import { a as E, b as D } from "./chunk-XTLZV3YN.js";
import { a as u, c as ze, d as Rt, e as A, f as w, g as re, h as he, i as y3, j as mt } from "./chunk-A74TA65P.js";
var il = ze((t, e) => {
    E();
    var n = u(function () {
      this._tweens = {}, this._tweensAddedDuringUpdate = {};
    }, "_Group");
    n.prototype = {
      getAll: function () {
        return Object.keys(this._tweens).map(function (t) {
          return this._tweens[t];
        }.bind(this));
      },
      removeAll: function () {
        this._tweens = {};
      },
      add: function (t) {
        this._tweens[t.getId()] = t, this._tweensAddedDuringUpdate[t.getId()] = t;
      },
      remove: function (t) {
        delete this._tweens[t.getId()], delete this._tweensAddedDuringUpdate[t.getId()];
      },
      update: function (t, e) {
        var n = Object.keys(this._tweens);
        if (0 === n.length) return !1;
        for (t = void 0 !== t ? t : r.now(); n.length > 0;) {
          this._tweensAddedDuringUpdate = {};
          for (var i = 0; i < n.length; i++) {
            var o = this._tweens[n[i]];
            o && !1 === o.update(t) && (o._isPlaying = !1, e || delete this._tweens[n[i]]);
          }
          n = Object.keys(this._tweensAddedDuringUpdate);
        }
        return !0;
      }
    };
    var i,
      r = new n();
    r.Group = n, r._nextId = 0, r.nextId = function () {
      return r._nextId++;
    }, "undefined" == typeof self && void 0 !== D && D.hrtime ? r.now = function () {
      var t = D.hrtime();
      return 1e3 * t[0] + t[1] / 1e6;
    } : "undefined" != typeof self && void 0 !== self.performance && void 0 !== self.performance.now ? r.now = self.performance.now.bind(self.performance) : void 0 !== Date.now ? r.now = Date.now : r.now = function () {
      return new Date().getTime();
    }, r.Tween = function (t, e) {
      this._object = t, this._valuesStart = {}, this._valuesEnd = {}, this._valuesStartRepeat = {}, this._duration = 1e3, this._repeat = 0, this._repeatDelayTime = void 0, this._yoyo = !1, this._isPlaying = !1, this._reversed = !1, this._delayTime = 0, this._startTime = null, this._easingFunction = r.Easing.Linear.None, this._interpolationFunction = r.Interpolation.Linear, this._chainedTweens = [], this._onStartCallback = null, this._onStartCallbackFired = !1, this._onUpdateCallback = null, this._onRepeatCallback = null, this._onCompleteCallback = null, this._onStopCallback = null, this._group = e || r, this._id = r.nextId();
    }, r.Tween.prototype = {
      getId: function () {
        return this._id;
      },
      isPlaying: function () {
        return this._isPlaying;
      },
      to: function (t, e) {
        return this._valuesEnd = t, void 0 !== e && (this._duration = e), this;
      },
      duration: u(function (t) {
        return this._duration = t, this;
      }, "duration"),
      start: function (t) {
        for (var e in this._group.add(this), this._isPlaying = !0, this._onStartCallbackFired = !1, this._startTime = void 0 !== t ? "string" == typeof t ? r.now() + parseFloat(t) : t : r.now(), this._startTime += this._delayTime, this._valuesEnd) {
          if (this._valuesEnd[e] instanceof Array) {
            if (0 === this._valuesEnd[e].length) continue;
            this._valuesEnd[e] = [this._object[e]].concat(this._valuesEnd[e]);
          }
          void 0 !== this._object[e] && (this._valuesStart[e] = this._object[e], this._valuesStart[e] instanceof Array || (this._valuesStart[e] *= 1), this._valuesStartRepeat[e] = this._valuesStart[e] || 0);
        }
        return this;
      },
      stop: function () {
        return this._isPlaying ? (this._group.remove(this), this._isPlaying = !1, null !== this._onStopCallback && this._onStopCallback(this._object), this.stopChainedTweens(), this) : this;
      },
      end: function () {
        return this.update(1 / 0), this;
      },
      stopChainedTweens: function () {
        for (var t = 0, e = this._chainedTweens.length; t < e; t++) this._chainedTweens[t].stop();
      },
      group: function (t) {
        return this._group = t, this;
      },
      delay: function (t) {
        return this._delayTime = t, this;
      },
      repeat: function (t) {
        return this._repeat = t, this;
      },
      repeatDelay: function (t) {
        return this._repeatDelayTime = t, this;
      },
      yoyo: function (t) {
        return this._yoyo = t, this;
      },
      easing: function (t) {
        return this._easingFunction = t, this;
      },
      interpolation: function (t) {
        return this._interpolationFunction = t, this;
      },
      chain: function () {
        return this._chainedTweens = arguments, this;
      },
      onStart: function (t) {
        return this._onStartCallback = t, this;
      },
      onUpdate: function (t) {
        return this._onUpdateCallback = t, this;
      },
      onRepeat: u(function (t) {
        return this._onRepeatCallback = t, this;
      }, "onRepeat"),
      onComplete: function (t) {
        return this._onCompleteCallback = t, this;
      },
      onStop: function (t) {
        return this._onStopCallback = t, this;
      },
      update: function (t) {
        var e, n, i;
        if (t < this._startTime) return !0;
        for (e in !1 === this._onStartCallbackFired && (null !== this._onStartCallback && this._onStartCallback(this._object), this._onStartCallbackFired = !0), n = (t - this._startTime) / this._duration, n = 0 === this._duration || n > 1 ? 1 : n, i = this._easingFunction(n), this._valuesEnd) if (void 0 !== this._valuesStart[e]) {
          var r = this._valuesStart[e] || 0,
            o = this._valuesEnd[e];
          o instanceof Array ? this._object[e] = this._interpolationFunction(o, i) : ("string" == typeof o && (o = "+" === o.charAt(0) || "-" === o.charAt(0) ? r + parseFloat(o) : parseFloat(o)), "number" == typeof o && (this._object[e] = r + (o - r) * i));
        }
        if (null !== this._onUpdateCallback && this._onUpdateCallback(this._object, n), 1 === n) {
          if (this._repeat > 0) {
            for (e in isFinite(this._repeat) && this._repeat--, this._valuesStartRepeat) {
              if ("string" == typeof this._valuesEnd[e] && (this._valuesStartRepeat[e] = this._valuesStartRepeat[e] + parseFloat(this._valuesEnd[e])), this._yoyo) {
                var s = this._valuesStartRepeat[e];
                this._valuesStartRepeat[e] = this._valuesEnd[e], this._valuesEnd[e] = s;
              }
              this._valuesStart[e] = this._valuesStartRepeat[e];
            }
            return this._yoyo && (this._reversed = !this._reversed), void 0 !== this._repeatDelayTime ? this._startTime = t + this._repeatDelayTime : this._startTime = t + this._delayTime, null !== this._onRepeatCallback && this._onRepeatCallback(this._object), !0;
          }
          null !== this._onCompleteCallback && this._onCompleteCallback(this._object);
          for (var a = 0, l = this._chainedTweens.length; a < l; a++) this._chainedTweens[a].start(this._startTime + this._duration);
          return !1;
        }
        return !0;
      }
    }, r.Easing = {
      Linear: {
        None: function (t) {
          return t;
        }
      },
      Quadratic: {
        In: function (t) {
          return t * t;
        },
        Out: function (t) {
          return t * (2 - t);
        },
        InOut: function (t) {
          return (t *= 2) < 1 ? .5 * t * t : -.5 * (--t * (t - 2) - 1);
        }
      },
      Cubic: {
        In: function (t) {
          return t * t * t;
        },
        Out: function (t) {
          return --t * t * t + 1;
        },
        InOut: function (t) {
          return (t *= 2) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2);
        }
      },
      Quartic: {
        In: function (t) {
          return t * t * t * t;
        },
        Out: function (t) {
          return 1 - --t * t * t * t;
        },
        InOut: function (t) {
          return (t *= 2) < 1 ? .5 * t * t * t * t : -.5 * ((t -= 2) * t * t * t - 2);
        }
      },
      Quintic: {
        In: function (t) {
          return t * t * t * t * t;
        },
        Out: function (t) {
          return --t * t * t * t * t + 1;
        },
        InOut: function (t) {
          return (t *= 2) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2);
        }
      },
      Sinusoidal: {
        In: function (t) {
          return 1 - Math.cos(t * Math.PI / 2);
        },
        Out: function (t) {
          return Math.sin(t * Math.PI / 2);
        },
        InOut: function (t) {
          return .5 * (1 - Math.cos(Math.PI * t));
        }
      },
      Exponential: {
        In: function (t) {
          return 0 === t ? 0 : Math.pow(1024, t - 1);
        },
        Out: function (t) {
          return 1 === t ? 1 : 1 - Math.pow(2, -10 * t);
        },
        InOut: function (t) {
          return 0 === t ? 0 : 1 === t ? 1 : (t *= 2) < 1 ? .5 * Math.pow(1024, t - 1) : .5 * (2 - Math.pow(2, -10 * (t - 1)));
        }
      },
      Circular: {
        In: function (t) {
          return 1 - Math.sqrt(1 - t * t);
        },
        Out: function (t) {
          return Math.sqrt(1 - --t * t);
        },
        InOut: function (t) {
          return (t *= 2) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        }
      },
      Elastic: {
        In: function (t) {
          return 0 === t ? 0 : 1 === t ? 1 : -Math.pow(2, 10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI);
        },
        Out: function (t) {
          return 0 === t ? 0 : 1 === t ? 1 : Math.pow(2, -10 * t) * Math.sin(5 * (t - .1) * Math.PI) + 1;
        },
        InOut: function (t) {
          return 0 === t ? 0 : 1 === t ? 1 : (t *= 2) < 1 ? -.5 * Math.pow(2, 10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI) : .5 * Math.pow(2, -10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI) + 1;
        }
      },
      Back: {
        In: function (t) {
          var e = 1.70158;
          return t * t * ((e + 1) * t - e);
        },
        Out: function (t) {
          var e = 1.70158;
          return --t * t * ((e + 1) * t + e) + 1;
        },
        InOut: function (t) {
          var e = 2.5949095;
          return (t *= 2) < 1 ? t * t * ((e + 1) * t - e) * .5 : .5 * ((t -= 2) * t * ((e + 1) * t + e) + 2);
        }
      },
      Bounce: {
        In: function (t) {
          return 1 - r.Easing.Bounce.Out(1 - t);
        },
        Out: function (t) {
          return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
        },
        InOut: function (t) {
          return t < .5 ? .5 * r.Easing.Bounce.In(2 * t) : .5 * r.Easing.Bounce.Out(2 * t - 1) + .5;
        }
      }
    }, r.Interpolation = {
      Linear: function (t, e) {
        var n = t.length - 1,
          i = n * e,
          o = Math.floor(i),
          s = r.Interpolation.Utils.Linear;
        return e < 0 ? s(t[0], t[1], i) : e > 1 ? s(t[n], t[n - 1], n - i) : s(t[o], t[o + 1 > n ? n : o + 1], i - o);
      },
      Bezier: function (t, e) {
        for (var n = 0, i = t.length - 1, o = Math.pow, s = r.Interpolation.Utils.Bernstein, a = 0; a <= i; a++) n += o(1 - e, i - a) * o(e, a) * t[a] * s(i, a);
        return n;
      },
      CatmullRom: function (t, e) {
        var n = t.length - 1,
          i = n * e,
          o = Math.floor(i),
          s = r.Interpolation.Utils.CatmullRom;
        return t[0] === t[n] ? (e < 0 && (o = Math.floor(i = n * (1 + e))), s(t[(o - 1 + n) % n], t[o], t[(o + 1) % n], t[(o + 2) % n], i - o)) : e < 0 ? t[0] - (s(t[0], t[0], t[1], t[1], -i) - t[0]) : e > 1 ? t[n] - (s(t[n], t[n], t[n - 1], t[n - 1], i - n) - t[n]) : s(t[o ? o - 1 : 0], t[o], t[n < o + 1 ? n : o + 1], t[n < o + 2 ? n : o + 2], i - o);
      },
      Utils: {
        Linear: function (t, e, n) {
          return (e - t) * n + t;
        },
        Bernstein: function (t, e) {
          var n = r.Interpolation.Utils.Factorial;
          return n(t) / n(e) / n(t - e);
        },
        Factorial: (i = [1], function (t) {
          var e = 1;
          if (i[t]) return i[t];
          for (var n = t; n > 1; n--) e *= n;
          return i[t] = e, e;
        }),
        CatmullRom: function (t, e, n, i, r) {
          var o = .5 * (n - t),
            s = .5 * (i - e),
            a = r * r;
          return (2 * e - 2 * n + o + s) * (r * a) + (-3 * e + 3 * n - 2 * o - s) * a + o * r + e;
        }
      }
    }, function (n) {
      "function" == typeof define && define.amd ? define([], function () {
        return r;
      }) : void 0 !== e && "object" == typeof t ? e.exports = r : void 0 !== n && (n.TWEEN = r);
    }(t);
  }),
  g7 = ze((t, e) => {
    E(), e.exports = t => encodeURIComponent(t).replace(/[!'()*]/g, t => `%${t.charCodeAt(0).toString(16).toUpperCase()}`);
  }),
  b7 = ze((t, e) => {
    E();
    var n = "%[a-f0-9]{2}",
      i = new RegExp("(" + n + ")|([^%]+?)", "gi"),
      r = new RegExp("(" + n + ")+", "gi");
    function o(t, e) {
      try {
        return [decodeURIComponent(t.join(""))];
      } catch (t) {}
      if (1 === t.length) return t;
      e = e || 1;
      var n = t.slice(0, e),
        i = t.slice(e);
      return Array.prototype.concat.call([], o(n), o(i));
    }
    function s(t) {
      try {
        return decodeURIComponent(t);
      } catch (r) {
        for (var e = t.match(i) || [], n = 1; n < e.length; n++) e = (t = o(e, n).join("")).match(i) || [];
        return t;
      }
    }
    function a(t) {
      for (var e = {
          "%FE%FF": "��",
          "%FF%FE": "��"
        }, n = r.exec(t); n;) {
        try {
          e[n[0]] = decodeURIComponent(n[0]);
        } catch (t) {
          var i = s(n[0]);
          i !== n[0] && (e[n[0]] = i);
        }
        n = r.exec(t);
      }
      e["%C2"] = "�";
      for (var o = Object.keys(e), a = 0; a < o.length; a++) {
        var l = o[a];
        t = t.replace(new RegExp(l, "g"), e[l]);
      }
      return t;
    }
    u(o, "decodeComponents"), u(s, "decode"), u(a, "customDecodeURIComponent"), e.exports = function (t) {
      if ("string" != typeof t) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof t + "`");
      try {
        return t = t.replace(/\+/g, " "), decodeURIComponent(t);
      } catch (e) {
        return a(t);
      }
    };
  }),
  E7 = ze((t, e) => {
    E(), e.exports = (t, e) => {
      if ("string" != typeof t || "string" != typeof e) throw new TypeError("Expected the arguments to be of type `string`");
      if ("" === e) return [t];
      let n = t.indexOf(e);
      return -1 === n ? [t] : [t.slice(0, n), t.slice(n + e.length)];
    };
  }),
  S7 = ze((t, e) => {
    E(), e.exports = function (t, e) {
      for (var n = {}, i = Object.keys(t), r = Array.isArray(e), o = 0; o < i.length; o++) {
        var s = i[o],
          a = t[s];
        (r ? -1 !== e.indexOf(s) : e(s, a, t)) && (n[s] = a);
      }
      return n;
    };
  }),
  R7 = ze(t => {
    E();
    var e = g7(),
      n = b7(),
      i = E7(),
      r = S7(),
      o = u(t => null == t, "isNullOrUndefined"),
      s = Symbol("encodeFragmentIdentifier");
    function a(t) {
      switch (t.arrayFormat) {
        case "index":
          return e => (n, i) => {
            let r = n.length;
            return void 0 === i || t.skipNull && null === i || t.skipEmptyString && "" === i ? n : null === i ? [...n, [c(e, t), "[", r, "]"].join("")] : [...n, [c(e, t), "[", c(r, t), "]=", c(i, t)].join("")];
          };
        case "bracket":
          return e => (n, i) => void 0 === i || t.skipNull && null === i || t.skipEmptyString && "" === i ? n : null === i ? [...n, [c(e, t), "[]"].join("")] : [...n, [c(e, t), "[]=", c(i, t)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator":
          {
            let e = "bracket-separator" === t.arrayFormat ? "[]=" : "=";
            return n => (i, r) => void 0 === r || t.skipNull && null === r || t.skipEmptyString && "" === r ? i : (r = null === r ? "" : r, 0 === i.length ? [[c(n, t), e, c(r, t)].join("")] : [[i, c(r, t)].join(t.arrayFormatSeparator)]);
          }
        default:
          return e => (n, i) => void 0 === i || t.skipNull && null === i || t.skipEmptyString && "" === i ? n : null === i ? [...n, c(e, t)] : [...n, [c(e, t), "=", c(i, t)].join("")];
      }
    }
    function l(t) {
      let e;
      switch (t.arrayFormat) {
        case "index":
          return (t, n, i) => {
            e = /\[(\d*)\]$/.exec(t), t = t.replace(/\[\d*\]$/, ""), e ? (void 0 === i[t] && (i[t] = {}), i[t][e[1]] = n) : i[t] = n;
          };
        case "bracket":
          return (t, n, i) => {
            e = /(\[\])$/.exec(t), t = t.replace(/\[\]$/, ""), e ? void 0 !== i[t] ? i[t] = [].concat(i[t], n) : i[t] = [n] : i[t] = n;
          };
        case "comma":
        case "separator":
          return (e, n, i) => {
            let r = "string" == typeof n && n.includes(t.arrayFormatSeparator),
              o = "string" == typeof n && !r && p(n, t).includes(t.arrayFormatSeparator);
            n = o ? p(n, t) : n;
            let s = r || o ? n.split(t.arrayFormatSeparator).map(e => p(e, t)) : null === n ? n : p(n, t);
            i[e] = s;
          };
        case "bracket-separator":
          return (e, n, i) => {
            let r = /(\[\])$/.test(e);
            if (e = e.replace(/\[\]$/, ""), !r) return void (i[e] = n && p(n, t));
            let o = null === n ? [] : n.split(t.arrayFormatSeparator).map(e => p(e, t));
            void 0 !== i[e] ? i[e] = [].concat(i[e], o) : i[e] = o;
          };
        default:
          return (t, e, n) => {
            void 0 !== n[t] ? n[t] = [].concat(n[t], e) : n[t] = e;
          };
      }
    }
    function h(t) {
      if ("string" != typeof t || 1 !== t.length) throw new TypeError("arrayFormatSeparator must be single character string");
    }
    function c(t, n) {
      return n.encode ? n.strict ? e(t) : encodeURIComponent(t) : t;
    }
    function p(t, e) {
      return e.decode ? n(t) : t;
    }
    function d(t) {
      return Array.isArray(t) ? t.sort() : "object" == typeof t ? d(Object.keys(t)).sort((t, e) => Number(t) - Number(e)).map(e => t[e]) : t;
    }
    function f(t) {
      let e = t.indexOf("#");
      return -1 !== e && (t = t.slice(0, e)), t;
    }
    function m(t) {
      let e = "",
        n = t.indexOf("#");
      return -1 !== n && (e = t.slice(n)), e;
    }
    function g(t) {
      let e = (t = f(t)).indexOf("?");
      return -1 === e ? "" : t.slice(e + 1);
    }
    function v(t, e) {
      return e.parseNumbers && !Number.isNaN(Number(t)) && "string" == typeof t && "" !== t.trim() ? t = Number(t) : e.parseBooleans && null !== t && ("true" === t.toLowerCase() || "false" === t.toLowerCase()) && (t = "true" === t.toLowerCase()), t;
    }
    function y(t, e) {
      h((e = Object.assign({
        decode: !0,
        sort: !0,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: !1,
        parseBooleans: !1
      }, e)).arrayFormatSeparator);
      let n = l(e),
        r = Object.create(null);
      if ("string" != typeof t || !(t = t.trim().replace(/^[?#&]/, ""))) return r;
      for (let o of t.split("&")) {
        if ("" === o) continue;
        let [t, s] = i(e.decode ? o.replace(/\+/g, " ") : o, "=");
        s = void 0 === s ? null : ["comma", "separator", "bracket-separator"].includes(e.arrayFormat) ? s : p(s, e), n(p(t, e), s, r);
      }
      for (let t of Object.keys(r)) {
        let n = r[t];
        if ("object" == typeof n && null !== n) for (let t of Object.keys(n)) n[t] = v(n[t], e);else r[t] = v(n, e);
      }
      return !1 === e.sort ? r : (!0 === e.sort ? Object.keys(r).sort() : Object.keys(r).sort(e.sort)).reduce((t, e) => {
        let n = r[e];
        return Boolean(n) && "object" == typeof n && !Array.isArray(n) ? t[e] = d(n) : t[e] = n, t;
      }, Object.create(null));
    }
    u(a, "encoderForArrayFormat"), u(l, "parserForArrayFormat"), u(h, "validateArrayFormatSeparator"), u(c, "encode"), u(p, "decode"), u(d, "keysSorter"), u(f, "removeHash"), u(m, "getHash"), u(g, "extract"), u(v, "parseValue"), u(y, "parse"), t.extract = g, t.parse = y, t.stringify = (t, e) => {
      if (!t) return "";
      h((e = Object.assign({
        encode: !0,
        strict: !0,
        arrayFormat: "none",
        arrayFormatSeparator: ","
      }, e)).arrayFormatSeparator);
      let n = u(n => e.skipNull && o(t[n]) || e.skipEmptyString && "" === t[n], "shouldFilter"),
        i = a(e),
        r = {};
      for (let e of Object.keys(t)) n(e) || (r[e] = t[e]);
      let s = Object.keys(r);
      return !1 !== e.sort && s.sort(e.sort), s.map(n => {
        let r = t[n];
        return void 0 === r ? "" : null === r ? c(n, e) : Array.isArray(r) ? 0 === r.length && "bracket-separator" === e.arrayFormat ? c(n, e) + "[]" : r.reduce(i(n), []).join("&") : c(n, e) + "=" + c(r, e);
      }).filter(t => t.length > 0).join("&");
    }, t.parseUrl = (t, e) => {
      e = Object.assign({
        decode: !0
      }, e);
      let [n, r] = i(t, "#");
      return Object.assign({
        url: n.split("?")[0] || "",
        query: y(g(t), e)
      }, e && e.parseFragmentIdentifier && r ? {
        fragmentIdentifier: p(r, e)
      } : {});
    }, t.stringifyUrl = (e, n) => {
      n = Object.assign({
        encode: !0,
        strict: !0,
        [s]: !0
      }, n);
      let i = f(e.url).split("?")[0] || "",
        r = t.extract(e.url),
        o = t.parse(r, {
          sort: !1
        }),
        a = Object.assign(o, e.query),
        l = t.stringify(a, n);
      l && (l = `?${l}`);
      let u = m(e.url);
      return e.fragmentIdentifier && (u = `#${n[s] ? c(e.fragmentIdentifier, n) : e.fragmentIdentifier}`), `${i}${l}${u}`;
    }, t.pick = (e, n, i) => {
      i = Object.assign({
        parseFragmentIdentifier: !0,
        [s]: !1
      }, i);
      let {
        url: o,
        query: a,
        fragmentIdentifier: l
      } = t.parseUrl(e, i);
      return t.stringifyUrl({
        url: o,
        query: r(a, n),
        fragmentIdentifier: l
      }, i);
    }, t.exclude = (e, n, i) => {
      let r = Array.isArray(n) ? t => !n.includes(t) : (t, e) => !n(t, e);
      return t.pick(e, r, i);
    };
  }),
  N7 = ze((t, e) => {
    E(), function (n) {
      var i = "object" == typeof t && t,
        r = "object" == typeof e && e && e.exports == i && e,
        o = "object" == typeof global && global;
      (o.global === o || o.window === o) && (n = o);
      var s = u(function (t) {
        this.message = t;
      }, "InvalidCharacterError");
      s.prototype = new Error(), s.prototype.name = "InvalidCharacterError";
      var a = u(function (t) {
          throw new s(t);
        }, "error"),
        l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
        h = /[\t\n\f\r ]/g,
        c = u(function (t) {
          var e = (t = String(t).replace(h, "")).length;
          e % 4 == 0 && (e = (t = t.replace(/==?$/, "")).length), (e % 4 == 1 || /[^+a-zA-Z0-9/]/.test(t)) && a("Invalid character: the string to be decoded is not correctly encoded.");
          for (var n, i, r = 0, o = "", s = -1; ++s < e;) i = l.indexOf(t.charAt(s)), n = r % 4 ? 64 * n + i : i, r++ % 4 && (o += String.fromCharCode(255 & n >> (-2 * r & 6)));
          return o;
        }, "decode"),
        p = {
          encode: u(function (t) {
            t = String(t), /[^\0-\xFF]/.test(t) && a("The string to be encoded contains characters outside of the Latin1 range.");
            for (var e, n, i, r, o = t.length % 3, s = "", u = -1, h = t.length - o; ++u < h;) e = t.charCodeAt(u) << 16, n = t.charCodeAt(++u) << 8, i = t.charCodeAt(++u), s += l.charAt((r = e + n + i) >> 18 & 63) + l.charAt(r >> 12 & 63) + l.charAt(r >> 6 & 63) + l.charAt(63 & r);
            return 2 == o ? (e = t.charCodeAt(u) << 8, n = t.charCodeAt(++u), s += l.charAt((r = e + n) >> 10) + l.charAt(r >> 4 & 63) + l.charAt(r << 2 & 63) + "=") : 1 == o && (r = t.charCodeAt(u), s += l.charAt(r >> 2) + l.charAt(r << 4 & 63) + "=="), s;
          }, "encode"),
          decode: c,
          version: "1.0.0"
        };
      if ("function" == typeof define && "object" == typeof define.amd && define.amd) define(function () {
        return p;
      });else if (i && !i.nodeType) {
        if (r) r.exports = p;else for (var d in p) p.hasOwnProperty(d) && (i[d] = p[d]);
      } else n.base64 = p;
    }(t);
  }),
  Co = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.areaConversion = t.timeConversion = t.distanceConversion = t.altitudeKeys = t.latitudeKeys = t.longitudeKeys = t.MAXLON = t.MINLON = t.MAXLAT = t.MINLAT = t.earthRadius = t.sexagesimalPattern = void 0;
    t.sexagesimalPattern = /^([0-9]{1,3})°\s*([0-9]{1,3}(?:\.(?:[0-9]{1,}))?)['′]\s*(([0-9]{1,3}(\.([0-9]{1,}))?)["″]\s*)?([NEOSW]?)$/;
    t.earthRadius = 6378137;
    t.MINLAT = -90;
    t.MAXLAT = 90;
    t.MINLON = -180;
    t.MAXLON = 180;
    t.longitudeKeys = ["lng", "lon", "longitude", 0];
    t.latitudeKeys = ["lat", "latitude", 1];
    t.altitudeKeys = ["alt", "altitude", "elevation", "elev", 2];
    t.distanceConversion = {
      m: 1,
      km: .001,
      cm: 100,
      mm: 1e3,
      mi: 1 / 1609.344,
      sm: 1 / 1852.216,
      ft: 100 / 30.48,
      in: 100 / 2.54,
      yd: 1 / .9144
    };
    t.timeConversion = {
      m: 60,
      h: 3600,
      d: 86400
    };
    var e = {
      m2: 1,
      km2: 1e-6,
      ha: 1e-4,
      a: .01,
      ft2: 10.763911,
      yd2: 1.19599,
      in2: 1550.0031
    };
    t.areaConversion = e, e.sqm = e.m2, e.sqkm = e.km2, e.sqft = e.ft2, e.sqyd = e.yd2, e.sqin = e.in2;
  }),
  i0 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = u(function (t, e) {
      return e.reduce(function (e, n) {
        if (null == t) throw new Error("'".concat(t, "' is no valid coordinate."));
        return Object.prototype.hasOwnProperty.call(t, n) && void 0 !== n && void 0 === e ? (e = n, n) : e;
      }, void 0);
    }, "getCoordinateKey");
    t.default = e;
  }),
  r0 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = u(function (t) {
      var e = t.toString().trim();
      return !isNaN(parseFloat(e)) && parseFloat(e) === Number(e);
    }, "isDecimal");
    t.default = e;
  }),
  o0 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Co(),
      n = u(function (t) {
        return e.sexagesimalPattern.test(t.toString().trim());
      }, "isSexagesimal");
    t.default = n;
  }),
  s0 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Co(),
      n = u(function (t) {
        var n = new RegExp(e.sexagesimalPattern).exec(t);
        if (null == n) throw new Error("Given value is not in sexagesimal format");
        var i = Number(n[2]) / 60 || 0,
          r = Number(n[4]) / 3600 || 0,
          o = parseFloat(n[1]) + i + r;
        return ["S", "W"].includes(n[7]) ? -o : o;
      }, "sexagesimalToDecimal");
    t.default = n;
  }),
  l2 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Co(),
      n = i(i0());
    function i(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function r(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        e && (i = i.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, i);
      }
      return n;
    }
    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? r(Object(n), !0).forEach(function (e) {
          s(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    function s(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    u(i, "_interopRequireDefault"), u(r, "ownKeys"), u(o, "_objectSpread"), u(s, "_defineProperty");
    var a = u(function (t) {
      var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          longitude: e.longitudeKeys,
          latitude: e.latitudeKeys,
          altitude: e.altitudeKeys
        },
        r = (0, n.default)(t, i.longitude),
        s = (0, n.default)(t, i.latitude),
        a = (0, n.default)(t, i.altitude);
      return o({
        latitude: s,
        longitude: r
      }, a ? {
        altitude: a
      } : {});
    }, "getCoordinateKeys");
    t.default = a;
  }),
  uT = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(r0()),
      n = o(o0()),
      i = o(s0()),
      r = Co();
    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(o, "_interopRequireDefault");
    var s = u(function t(o) {
      return (0, e.default)(o) ? !(parseFloat(o) > r.MAXLAT || o < r.MINLAT) : !!(0, n.default)(o) && t((0, i.default)(o));
    }, "isValidLatitude");
    t.default = s;
  }),
  hT = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(r0()),
      n = o(o0()),
      i = o(s0()),
      r = Co();
    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(o, "_interopRequireDefault");
    var s = u(function t(o) {
      return (0, e.default)(o) ? !(parseFloat(o) > r.MAXLON || o < r.MINLON) : !!(0, n.default)(o) && t((0, i.default)(o));
    }, "isValidLongitude");
    t.default = s;
  }),
  pT = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = r(l2()),
      n = r(uT()),
      i = r(hT());
    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(r, "_interopRequireDefault");
    var o = u(function (t) {
      var r = (0, e.default)(t),
        o = r.latitude,
        s = r.longitude;
      if (Array.isArray(t) && t.length >= 2) return (0, i.default)(t[0]) && (0, n.default)(t[1]);
      if (void 0 === o || void 0 === s) return !1;
      var a = t[s],
        l = t[o];
      return !(void 0 === l || void 0 === a || !1 === (0, n.default)(l) || !1 === (0, i.default)(a));
    }, "isValidCoordinate");
    t.default = o;
  }),
  p2 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = s(r0()),
      n = s(o0()),
      i = s(s0()),
      r = s(pT()),
      o = s(l2());
    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        e && (i = i.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, i);
      }
      return n;
    }
    function l(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? a(Object(n), !0).forEach(function (e) {
          h(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    function h(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    u(s, "_interopRequireDefault"), u(a, "ownKeys"), u(l, "_objectSpread"), u(h, "_defineProperty");
    var c = u(function t(s) {
      if ((0, e.default)(s)) return Number(s);
      if ((0, n.default)(s)) return (0, i.default)(s);
      if ((0, r.default)(s)) {
        var a = (0, o.default)(s);
        return Array.isArray(s) ? s.map(function (e, n) {
          return [0, 1].includes(n) ? t(e) : e;
        }) : l(l(l({}, s), a.latitude && h({}, a.latitude, t(s[a.latitude]))), a.longitude && h({}, a.longitude, t(s[a.longitude])));
      }
      return Array.isArray(s) ? s.map(function (e) {
        return (0, r.default)(e) ? t(e) : e;
      }) : s;
    }, "toDecimal");
    t.default = c;
  }),
  da = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Co(),
      n = r(i0()),
      i = r(p2());
    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(r, "_interopRequireDefault");
    var o = u(function (t, r) {
      var o = (0, n.default)(t, e.latitudeKeys);
      if (null != o) {
        var s = t[o];
        return !0 === r ? s : (0, i.default)(s);
      }
    }, "getLatitude");
    t.default = o;
  }),
  ma = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Co(),
      n = r(i0()),
      i = r(p2());
    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(r, "_interopRequireDefault");
    var o = u(function (t, r) {
      var o = (0, n.default)(t, e.longitudeKeys);
      if (null != o) {
        var s = t[o];
        return !0 === r ? s : (0, i.default)(s);
      }
    }, "getLongitude");
    t.default = o;
  }),
  Dl = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = u(function (t) {
      return t * Math.PI / 180;
    }, "toRad");
    t.default = e;
  }),
  xf = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = u(function (t) {
      return 180 * t / Math.PI;
    }, "toDeg");
    t.default = e;
  }),
  j7 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = s(da()),
      n = s(ma()),
      i = s(Dl()),
      r = s(xf()),
      o = Co();
    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(s, "_interopRequireDefault");
    var a = u(function (t, s, a) {
      var l = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 6371e3,
        u = (0, e.default)(t),
        h = (0, n.default)(t),
        c = s / l,
        p = (0, i.default)(a),
        d = (0, i.default)(u),
        f = (0, i.default)(h),
        m = Math.asin(Math.sin(d) * Math.cos(c) + Math.cos(d) * Math.sin(c) * Math.cos(p)),
        g = f + Math.atan2(Math.sin(p) * Math.sin(c) * Math.cos(d), Math.cos(c) - Math.sin(d) * Math.sin(m)),
        v = (0, r.default)(g);
      return (v < o.MINLON || v > o.MAXLON) && (g = (g + 3 * Math.PI) % (2 * Math.PI) - Math.PI, v = (0, r.default)(g)), {
        latitude: (0, r.default)(m),
        longitude: v
      };
    }, "computeDestinationPoint");
    t.default = a;
  }),
  W7 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Co(),
      n = u(function (t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "m",
          i = e.areaConversion[n];
        if (i) return t * i;
        throw new Error("Invalid unit used for area conversion.");
      }, "convertArea");
    t.default = n;
  }),
  X7 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Co(),
      n = u(function (t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "m",
          i = e.distanceConversion[n];
        if (i) return t * i;
        throw new Error("Invalid unit used for distance conversion.");
      }, "convertDistance");
    t.default = n;
  }),
  Y7 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Co(),
      n = u(function (t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "kmh";
        switch (n) {
          case "kmh":
            return t * e.timeConversion.h * e.distanceConversion.km;
          case "mph":
            return t * e.timeConversion.h * e.distanceConversion.mi;
          default:
            return t;
        }
      }, "convertSpeed");
    t.default = n;
  }),
  K7 = ze(t => {
    function e(t, e) {
      return s(t) || o(t, e) || i(t, e) || n();
    }
    function n() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function i(t, e) {
      if (t) {
        if ("string" == typeof t) return r(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        if ("Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return r(t, e);
      }
    }
    function r(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
      return i;
    }
    function o(t, e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
        var n = [],
          i = !0,
          r = !1,
          o = void 0;
        try {
          for (var s, a = t[Symbol.iterator](); !(i = (s = a.next()).done) && (n.push(s.value), !e || n.length !== e); i = !0);
        } catch (t) {
          r = !0, o = t;
        } finally {
          try {
            !i && null != a.return && a.return();
          } finally {
            if (r) throw o;
          }
        }
        return n;
      }
    }
    function s(t) {
      if (Array.isArray(t)) return t;
    }
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0, u(e, "_slicedToArray"), u(n, "_nonIterableRest"), u(i, "_unsupportedIterableToArray"), u(r, "_arrayLikeToArray"), u(o, "_iterableToArrayLimit"), u(s, "_arrayWithHoles");
    var a = u(function (t) {
        var e = Math.pow(10, 12);
        return Math.round(t * e) / e;
      }, "imprecise"),
      l = u(function (t) {
        var n = e(t.toString().split("."), 2),
          i = n[0],
          r = n[1],
          o = Math.abs(Number(i)),
          s = a(60 * Number("0." + (r || 0))),
          l = Math.floor(s),
          u = a(60 * (s % l || 0));
        return o + "° " + Number(l.toFixed(6)).toString().split(".").map(function (t, e) {
          return 0 === e ? t.padStart(2, "0") : t;
        }).join(".") + "' " + Number(u.toFixed(4)).toString().split(".").map(function (t, e) {
          return 0 === e ? t.padStart(2, "0") : t;
        }).join(".") + '"';
      }, "decimal2sexagesimal");
    t.default = l;
  }),
  yT = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = u(function (t) {
      return t > 1 ? 1 : t < -1 ? -1 : t;
    }, "robustAcos");
    t.default = e;
  }),
  rh = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = s(da()),
      n = s(ma()),
      i = s(Dl()),
      r = s(yT()),
      o = Co();
    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(s, "_interopRequireDefault");
    var a = u(function (t, s) {
      var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      a = void 0 === a || isNaN(a) ? 1 : a;
      var l = (0, e.default)(t),
        u = (0, n.default)(t),
        h = (0, e.default)(s),
        c = (0, n.default)(s),
        p = Math.acos((0, r.default)(Math.sin((0, i.default)(h)) * Math.sin((0, i.default)(l)) + Math.cos((0, i.default)(h)) * Math.cos((0, i.default)(l)) * Math.cos((0, i.default)(u) - (0, i.default)(c)))) * o.earthRadius;
      return Math.round(p / a) * a;
    }, "getDistance");
    t.default = a;
  }),
  _T = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(rh());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(n, "_interopRequireDefault");
    var i = u(function (t, n) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.default;
      return i = "function" == typeof i ? i : e.default, n.slice().sort(function (e, n) {
        return i(t, e) - i(t, n);
      });
    }, "orderByDistance");
    t.default = i;
  }),
  tL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(_T());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(n, "_interopRequireDefault");
    var i = u(function (t, n) {
      return (0, e.default)(t, n)[0];
    }, "findNearest");
    t.default = i;
  }),
  rL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(Dl()),
      n = o(da()),
      i = o(ma()),
      r = Co();
    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(o, "_interopRequireDefault");
    var s = u(function (t) {
      var o = 0;
      if (t.length > 2) {
        for (var s, a, l, u = 0; u < t.length; u++) {
          u === t.length - 2 ? (s = t.length - 2, a = t.length - 1, l = 0) : u === t.length - 1 ? (s = t.length - 1, a = 0, l = 1) : (s = u, a = u + 1, l = u + 2);
          var h = (0, i.default)(t[s]),
            c = (0, n.default)(t[a]),
            p = (0, i.default)(t[l]);
          o += ((0, e.default)(p) - (0, e.default)(h)) * Math.sin((0, e.default)(c));
        }
        o = o * r.earthRadius * r.earthRadius / 2;
      }
      return Math.abs(o);
    }, "getAreaOfPolygon");
    t.default = s;
  }),
  MT = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = i(da()),
      n = i(ma());
    function i(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(i, "_interopRequireDefault");
    var r = u(function (t) {
      if (!1 === Array.isArray(t) || 0 === t.length) throw new Error("No points were given.");
      return t.reduce(function (t, i) {
        var r = (0, e.default)(i),
          o = (0, n.default)(i);
        return {
          maxLat: Math.max(r, t.maxLat),
          minLat: Math.min(r, t.minLat),
          maxLng: Math.max(o, t.maxLng),
          minLng: Math.min(o, t.minLng)
        };
      }, {
        maxLat: -1 / 0,
        minLat: 1 / 0,
        maxLng: -1 / 0,
        minLng: 1 / 0
      });
    }, "getBounds");
    t.default = r;
  }),
  sL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = s(da()),
      n = s(ma()),
      i = s(Dl()),
      r = s(xf()),
      o = Co();
    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(s, "_interopRequireDefault");
    var a = u(function (t, s) {
      var a,
        l,
        u = (0, e.default)(t),
        h = (0, n.default)(t),
        c = (0, i.default)(u),
        p = (0, i.default)(h),
        d = s / o.earthRadius,
        f = c - d,
        m = c + d,
        g = (0, i.default)(o.MAXLAT),
        v = (0, i.default)(o.MINLAT),
        y = (0, i.default)(o.MAXLON),
        _ = (0, i.default)(o.MINLON);
      if (f > v && m < g) {
        var x = Math.asin(Math.sin(d) / Math.cos(c));
        (a = p - x) < _ && (a += 2 * Math.PI), (l = p + x) > y && (l -= 2 * Math.PI);
      } else f = Math.max(f, v), m = Math.min(m, g), a = _, l = y;
      return [{
        latitude: (0, r.default)(f),
        longitude: (0, r.default)(a)
      }, {
        latitude: (0, r.default)(m),
        longitude: (0, r.default)(l)
      }];
    }, "getBoundsOfDistance");
    t.default = a;
  }),
  uL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(da()),
      n = o(ma()),
      i = o(Dl()),
      r = o(xf());
    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(o, "_interopRequireDefault");
    var s = u(function (t) {
      if (!1 === Array.isArray(t) || 0 === t.length) return !1;
      var o = t.length,
        s = t.reduce(function (t, r) {
          var o = (0, i.default)((0, e.default)(r)),
            s = (0, i.default)((0, n.default)(r));
          return {
            X: t.X + Math.cos(o) * Math.cos(s),
            Y: t.Y + Math.cos(o) * Math.sin(s),
            Z: t.Z + Math.sin(o)
          };
        }, {
          X: 0,
          Y: 0,
          Z: 0
        }),
        a = s.X / o,
        l = s.Y / o,
        u = s.Z / o;
      return {
        longitude: (0, r.default)(Math.atan2(l, a)),
        latitude: (0, r.default)(Math.atan2(u, Math.sqrt(a * a + l * l)))
      };
    }, "getCenter");
    t.default = s;
  }),
  cL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(MT());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(n, "_interopRequireDefault");
    var i = u(function (t) {
      var n = (0, e.default)(t),
        i = n.minLat + (n.maxLat - n.minLat) / 2,
        r = n.minLng + (n.maxLng - n.minLng) / 2;
      return {
        latitude: parseFloat(i.toFixed(6)),
        longitude: parseFloat(r.toFixed(6))
      };
    }, "getCenterOfBounds");
    t.default = i;
  }),
  ET = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(da()),
      n = o(ma()),
      i = o(Dl()),
      r = o(xf());
    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(o, "_interopRequireDefault");
    var s = u(function (t, o) {
      var s = (0, i.default)((0, n.default)(o)) - (0, i.default)((0, n.default)(t)),
        a = Math.log(Math.tan((0, i.default)((0, e.default)(o)) / 2 + Math.PI / 4) / Math.tan((0, i.default)((0, e.default)(t)) / 2 + Math.PI / 4));
      return Math.abs(s) > Math.PI && (s = s > 0 ? -1 * (2 * Math.PI - s) : 2 * Math.PI + s), ((0, r.default)(Math.atan2(s, a)) + 360) % 360;
    }, "getRhumbLineBearing");
    t.default = s;
  }),
  dL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(ET());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(n, "_interopRequireDefault");
    var i = u(function (t, n) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.default,
        r = "function" == typeof i ? i(t, n) : (0, e.default)(t, n);
      if (isNaN(r)) throw new Error("Could not calculate bearing for given points. Check your bearing function");
      switch (Math.round(r / 22.5)) {
        case 1:
          return "NNE";
        case 2:
          return "NE";
        case 3:
          return "ENE";
        case 4:
          return "E";
        case 5:
          return "ESE";
        case 6:
          return "SE";
        case 7:
          return "SSE";
        case 8:
          return "S";
        case 9:
          return "SSW";
        case 10:
          return "SW";
        case 11:
          return "WSW";
        case 12:
          return "W";
        case 13:
          return "WNW";
        case 14:
          return "NW";
        case 15:
          return "NNW";
        default:
          return "N";
      }
    }, "getCompassDirection");
    t.default = i;
  }),
  ST = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = i(rh()),
      n = i(yT());
    function i(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(i, "_interopRequireDefault");
    var r = u(function (t, i, r) {
      var o = (0, e.default)(i, t),
        s = (0, e.default)(t, r),
        a = (0, e.default)(i, r),
        l = Math.acos((0, n.default)((o * o + a * a - s * s) / (2 * o * a))),
        u = Math.acos((0, n.default)((s * s + a * a - o * o) / (2 * s * a)));
      return l > Math.PI / 2 ? o : u > Math.PI / 2 ? s : Math.sin(l) * o;
    }, "getDistanceFromLine");
    t.default = r;
  }),
  _L = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(da()),
      n = o(ma()),
      i = o(Dl()),
      r = o(xf());
    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(o, "_interopRequireDefault");
    var s = u(function (t, o) {
      var s = (0, e.default)(o),
        a = (0, n.default)(o),
        l = (0, e.default)(t),
        u = (0, n.default)(t);
      return ((0, r.default)(Math.atan2(Math.sin((0, i.default)(a) - (0, i.default)(u)) * Math.cos((0, i.default)(s)), Math.cos((0, i.default)(l)) * Math.sin((0, i.default)(s)) - Math.sin((0, i.default)(l)) * Math.cos((0, i.default)(s)) * Math.cos((0, i.default)(a) - (0, i.default)(u)))) + 360) % 360;
    }, "getGreatCircleBearing");
    t.default = s;
  }),
  xL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(rh());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? u(function (t) {
        return typeof t;
      }, "_typeof") : u(function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, "_typeof"))(t);
    }
    u(n, "_interopRequireDefault"), u(i, "_typeof");
    var r = u(function (t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.default;
      return t.reduce(function (t, e) {
        return "object" === i(t) && null !== t.last && (t.distance += n(e, t.last)), t.last = e, t;
      }, {
        last: null,
        distance: 0
      }).distance;
    }, "getPathLength");
    t.default = r;
  }),
  wL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(da()),
      n = o(ma()),
      i = o(Dl()),
      r = Co();
    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(o, "_interopRequireDefault");
    var s = u(function (t, o) {
      var s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      s = void 0 === s || isNaN(s) ? 1 : s;
      var a,
        l,
        u,
        h,
        c,
        p,
        d,
        f = (0, e.default)(t),
        m = (0, n.default)(t),
        g = (0, e.default)(o),
        v = (0, n.default)(o),
        y = 6356752.314245,
        _ = 1 / 298.257223563,
        x = (0, i.default)(v - m),
        E = Math.atan((1 - _) * Math.tan((0, i.default)(parseFloat(f)))),
        b = Math.atan((1 - _) * Math.tan((0, i.default)(parseFloat(g)))),
        w = Math.sin(E),
        S = Math.cos(E),
        M = Math.sin(b),
        T = Math.cos(b),
        A = x,
        P = 100;
      do {
        var C = Math.sin(A),
          I = Math.cos(A);
        if (0 === (p = Math.sqrt(T * C * (T * C) + (S * M - w * T * I) * (S * M - w * T * I)))) return 0;
        a = w * M + S * T * I, l = Math.atan2(p, a), c = a - 2 * w * M / (h = 1 - (u = S * T * C / p) * u), isNaN(c) && (c = 0);
        var N = _ / 16 * h * (4 + _ * (4 - 3 * h));
        d = A, A = x + (1 - N) * _ * u * (l + N * p * (c + N * a * (2 * c * c - 1)));
      } while (Math.abs(A - d) > 1e-12 && --P > 0);
      if (0 === P) return NaN;
      var L = h * (r.earthRadius * r.earthRadius - y * y) / (y * y),
        R = 1 + L / 16384 * (4096 + L * (L * (320 - 175 * L) - 768)),
        O = L / 1024 * (256 + L * (L * (74 - 47 * L) - 128)),
        q = O * p * (c + O / 4 * (a * (2 * c * c - 1) - O / 6 * c * (4 * p * p - 3) * (4 * c * c - 3))),
        D = y * R * (l - q);
      return Math.round(D / s) * s;
    }, "getDistance");
    t.default = s;
  }),
  SL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = u(function (t) {
      return /^NNE|NE|NNW|N$/.test(t) ? "N" : /^ENE|E|ESE|SE$/.test(t) ? "E" : /^SSE|S|SSW|SW$/.test(t) ? "S" : /^WSW|W|WNW|NW$/.test(t) ? "W" : void 0;
    }, "getRoughCompassDirection");
    t.default = e;
  }),
  TL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(rh());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(n, "_interopRequireDefault");
    var i = u(function (t, n) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.default,
        r = i(t, n),
        o = Number(n.time) - Number(t.time),
        s = r / o * 1e3;
      return s;
    }, "getSpeed");
    t.default = i;
  }),
  PL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(rh());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(n, "_interopRequireDefault");
    var i = u(function (t, n, i) {
      return (0, e.default)(n, t) + (0, e.default)(t, i) === (0, e.default)(n, i);
    }, "isPointInLine");
    t.default = i;
  }),
  AL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = i(da()),
      n = i(ma());
    function i(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(i, "_interopRequireDefault");
    var r = u(function (t, i) {
      for (var r = !1, o = i.length, s = -1, a = o - 1; ++s < o; a = s) ((0, n.default)(i[s]) <= (0, n.default)(t) && (0, n.default)(t) < (0, n.default)(i[a]) || (0, n.default)(i[a]) <= (0, n.default)(t) && (0, n.default)(t) < (0, n.default)(i[s])) && (0, e.default)(t) < ((0, e.default)(i[a]) - (0, e.default)(i[s])) * ((0, n.default)(t) - (0, n.default)(i[s])) / ((0, n.default)(i[a]) - (0, n.default)(i[s])) + (0, e.default)(i[s]) && (r = !r);
      return r;
    }, "isPointInPolygon");
    t.default = r;
  }),
  IL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(ST());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(n, "_interopRequireDefault");
    var i = u(function (t, n, i, r) {
      return (0, e.default)(t, n, i) < r;
    }, "isPointNearLine");
    t.default = i;
  }),
  LL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(rh());
    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u(n, "_interopRequireDefault");
    var i = u(function (t, n, i) {
      return (0, e.default)(t, n) < i;
    }, "isPointWithinRadius");
    t.default = i;
  }),
  RL = ze(t => {
    function e(t, e) {
      return s(t) || o(t, e) || i(t, e) || n();
    }
    function n() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function i(t, e) {
      if (t) {
        if ("string" == typeof t) return r(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        if ("Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return r(t, e);
      }
    }
    function r(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
      return i;
    }
    function o(t, e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
        var n = [],
          i = !0,
          r = !1,
          o = void 0;
        try {
          for (var s, a = t[Symbol.iterator](); !(i = (s = a.next()).done) && (n.push(s.value), !e || n.length !== e); i = !0);
        } catch (t) {
          r = !0, o = t;
        } finally {
          try {
            !i && null != a.return && a.return();
          } finally {
            if (r) throw o;
          }
        }
        return n;
      }
    }
    function s(t) {
      if (Array.isArray(t)) return t;
    }
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0, u(e, "_slicedToArray"), u(n, "_nonIterableRest"), u(i, "_unsupportedIterableToArray"), u(r, "_arrayLikeToArray"), u(o, "_iterableToArrayLimit"), u(s, "_arrayWithHoles");
    var a = u(function (t) {
      if (!t.startsWith("POLYGON")) throw new Error("Invalid wkt.");
      return t.slice(t.indexOf("(") + 2, t.indexOf(")")).split(", ").map(function (t) {
        var n = e(t.split(" "), 2),
          i = n[0],
          r = n[1];
        return {
          longitude: parseFloat(i),
          latitude: parseFloat(r)
        };
      });
    }, "wktToPolygon");
    t.default = a;
  }),
  DL = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var e = {
      computeDestinationPoint: !0,
      convertArea: !0,
      convertDistance: !0,
      convertSpeed: !0,
      decimalToSexagesimal: !0,
      findNearest: !0,
      getAreaOfPolygon: !0,
      getBounds: !0,
      getBoundsOfDistance: !0,
      getCenter: !0,
      getCenterOfBounds: !0,
      getCompassDirection: !0,
      getCoordinateKey: !0,
      getCoordinateKeys: !0,
      getDistance: !0,
      getDistanceFromLine: !0,
      getGreatCircleBearing: !0,
      getLatitude: !0,
      getLongitude: !0,
      getPathLength: !0,
      getPreciseDistance: !0,
      getRhumbLineBearing: !0,
      getRoughCompassDirection: !0,
      getSpeed: !0,
      isDecimal: !0,
      isPointInLine: !0,
      isPointInPolygon: !0,
      isPointNearLine: !0,
      isPointWithinRadius: !0,
      isSexagesimal: !0,
      isValidCoordinate: !0,
      isValidLatitude: !0,
      isValidLongitude: !0,
      orderByDistance: !0,
      sexagesimalToDecimal: !0,
      toDecimal: !0,
      toRad: !0,
      toDeg: !0,
      wktToPolygon: !0
    };
    Object.defineProperty(t, "computeDestinationPoint", {
      enumerable: !0,
      get: u(function () {
        return n.default;
      }, "get")
    }), Object.defineProperty(t, "convertArea", {
      enumerable: !0,
      get: u(function () {
        return i.default;
      }, "get")
    }), Object.defineProperty(t, "convertDistance", {
      enumerable: !0,
      get: u(function () {
        return r.default;
      }, "get")
    }), Object.defineProperty(t, "convertSpeed", {
      enumerable: !0,
      get: u(function () {
        return o.default;
      }, "get")
    }), Object.defineProperty(t, "decimalToSexagesimal", {
      enumerable: !0,
      get: u(function () {
        return s.default;
      }, "get")
    }), Object.defineProperty(t, "findNearest", {
      enumerable: !0,
      get: u(function () {
        return a.default;
      }, "get")
    }), Object.defineProperty(t, "getAreaOfPolygon", {
      enumerable: !0,
      get: u(function () {
        return l.default;
      }, "get")
    }), Object.defineProperty(t, "getBounds", {
      enumerable: !0,
      get: u(function () {
        return h.default;
      }, "get")
    }), Object.defineProperty(t, "getBoundsOfDistance", {
      enumerable: !0,
      get: u(function () {
        return c.default;
      }, "get")
    }), Object.defineProperty(t, "getCenter", {
      enumerable: !0,
      get: u(function () {
        return p.default;
      }, "get")
    }), Object.defineProperty(t, "getCenterOfBounds", {
      enumerable: !0,
      get: u(function () {
        return d.default;
      }, "get")
    }), Object.defineProperty(t, "getCompassDirection", {
      enumerable: !0,
      get: u(function () {
        return f.default;
      }, "get")
    }), Object.defineProperty(t, "getCoordinateKey", {
      enumerable: !0,
      get: u(function () {
        return m.default;
      }, "get")
    }), Object.defineProperty(t, "getCoordinateKeys", {
      enumerable: !0,
      get: u(function () {
        return g.default;
      }, "get")
    }), Object.defineProperty(t, "getDistance", {
      enumerable: !0,
      get: u(function () {
        return v.default;
      }, "get")
    }), Object.defineProperty(t, "getDistanceFromLine", {
      enumerable: !0,
      get: u(function () {
        return y.default;
      }, "get")
    }), Object.defineProperty(t, "getGreatCircleBearing", {
      enumerable: !0,
      get: u(function () {
        return _.default;
      }, "get")
    }), Object.defineProperty(t, "getLatitude", {
      enumerable: !0,
      get: u(function () {
        return x.default;
      }, "get")
    }), Object.defineProperty(t, "getLongitude", {
      enumerable: !0,
      get: u(function () {
        return b.default;
      }, "get")
    }), Object.defineProperty(t, "getPathLength", {
      enumerable: !0,
      get: u(function () {
        return w.default;
      }, "get")
    }), Object.defineProperty(t, "getPreciseDistance", {
      enumerable: !0,
      get: u(function () {
        return S.default;
      }, "get")
    }), Object.defineProperty(t, "getRhumbLineBearing", {
      enumerable: !0,
      get: u(function () {
        return M.default;
      }, "get")
    }), Object.defineProperty(t, "getRoughCompassDirection", {
      enumerable: !0,
      get: u(function () {
        return T.default;
      }, "get")
    }), Object.defineProperty(t, "getSpeed", {
      enumerable: !0,
      get: u(function () {
        return A.default;
      }, "get")
    }), Object.defineProperty(t, "isDecimal", {
      enumerable: !0,
      get: u(function () {
        return P.default;
      }, "get")
    }), Object.defineProperty(t, "isPointInLine", {
      enumerable: !0,
      get: u(function () {
        return C.default;
      }, "get")
    }), Object.defineProperty(t, "isPointInPolygon", {
      enumerable: !0,
      get: u(function () {
        return I.default;
      }, "get")
    }), Object.defineProperty(t, "isPointNearLine", {
      enumerable: !0,
      get: u(function () {
        return N.default;
      }, "get")
    }), Object.defineProperty(t, "isPointWithinRadius", {
      enumerable: !0,
      get: u(function () {
        return L.default;
      }, "get")
    }), Object.defineProperty(t, "isSexagesimal", {
      enumerable: !0,
      get: u(function () {
        return R.default;
      }, "get")
    }), Object.defineProperty(t, "isValidCoordinate", {
      enumerable: !0,
      get: u(function () {
        return O.default;
      }, "get")
    }), Object.defineProperty(t, "isValidLatitude", {
      enumerable: !0,
      get: u(function () {
        return q.default;
      }, "get")
    }), Object.defineProperty(t, "isValidLongitude", {
      enumerable: !0,
      get: u(function () {
        return D.default;
      }, "get")
    }), Object.defineProperty(t, "orderByDistance", {
      enumerable: !0,
      get: u(function () {
        return k.default;
      }, "get")
    }), Object.defineProperty(t, "sexagesimalToDecimal", {
      enumerable: !0,
      get: u(function () {
        return F.default;
      }, "get")
    }), Object.defineProperty(t, "toDecimal", {
      enumerable: !0,
      get: u(function () {
        return U.default;
      }, "get")
    }), Object.defineProperty(t, "toRad", {
      enumerable: !0,
      get: u(function () {
        return B.default;
      }, "get")
    }), Object.defineProperty(t, "toDeg", {
      enumerable: !0,
      get: u(function () {
        return z.default;
      }, "get")
    }), Object.defineProperty(t, "wktToPolygon", {
      enumerable: !0,
      get: u(function () {
        return V.default;
      }, "get")
    });
    var n = G(j7()),
      i = G(W7()),
      r = G(X7()),
      o = G(Y7()),
      s = G(K7()),
      a = G(tL()),
      l = G(rL()),
      h = G(MT()),
      c = G(sL()),
      p = G(uL()),
      d = G(cL()),
      f = G(dL()),
      m = G(i0()),
      g = G(l2()),
      v = G(rh()),
      y = G(ST()),
      _ = G(_L()),
      x = G(da()),
      b = G(ma()),
      w = G(xL()),
      S = G(wL()),
      M = G(ET()),
      T = G(SL()),
      A = G(TL()),
      P = G(r0()),
      C = G(PL()),
      I = G(AL()),
      N = G(IL()),
      L = G(LL()),
      R = G(o0()),
      O = G(pT()),
      q = G(uT()),
      D = G(hT()),
      k = G(_T()),
      F = G(s0()),
      U = G(p2()),
      B = G(Dl()),
      z = G(xf()),
      V = G(RL()),
      j = Co();
    function G(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.keys(j).forEach(function (n) {
      "default" === n || "__esModule" === n || Object.prototype.hasOwnProperty.call(e, n) || Object.defineProperty(t, n, {
        enumerable: !0,
        get: u(function () {
          return j[n];
        }, "get")
      });
    }), u(G, "_interopRequireDefault");
  }),
  c9 = ze((t, e) => {
    var n, i, r, o, s, a, l, h, c, p, d, f, m, g, v, y, _, x, b, w, S, M, T, A, P;
    E(), function (t) {
      var n = "object" == typeof global ? global : "object" == typeof self ? self : "object" == typeof this ? this : {};
      function i(t, e) {
        return t !== n && ("function" == typeof Object.create ? Object.defineProperty(t, "__esModule", {
          value: !0
        }) : t.__esModule = !0), function (n, i) {
          return t[n] = e ? e(n, i) : i;
        };
      }
      "function" == typeof define && define.amd ? define("tslib", ["exports"], function (e) {
        t(i(n, i(e)));
      }) : "object" == typeof e && "object" == typeof e.exports ? t(i(n, i(e.exports))) : t(i(n)), u(i, "createExporter");
    }(function (t) {
      var e = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      };
      n = u(function (t, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
        function i() {
          this.constructor = t;
        }
        e(t, n), u(i, "__"), t.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
      }, "__extends"), i = Object.assign || function (t) {
        for (var e, n = 1, i = arguments.length; n < i; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t;
      }, r = u(function (t, e) {
        var n = {};
        for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var r = 0;
          for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) e.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (n[i[r]] = t[i[r]]);
        }
        return n;
      }, "__rest"), o = u(function (t, e, n, i) {
        var r,
          o = arguments.length,
          s = o < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, n, i);else for (var a = t.length - 1; a >= 0; a--) (r = t[a]) && (s = (o < 3 ? r(s) : o > 3 ? r(e, n, s) : r(e, n)) || s);
        return o > 3 && s && Object.defineProperty(e, n, s), s;
      }, "__decorate"), s = u(function (t, e) {
        return function (n, i) {
          e(n, i, t);
        };
      }, "__param"), a = u(function (t, e) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
      }, "__metadata"), l = u(function (t, e, n, i) {
        function r(t) {
          return t instanceof n ? t : new n(function (e) {
            e(t);
          });
        }
        return u(r, "adopt"), new (n || (n = Promise))(function (n, o) {
          function s(t) {
            try {
              l(i.next(t));
            } catch (t) {
              o(t);
            }
          }
          function a(t) {
            try {
              l(i.throw(t));
            } catch (t) {
              o(t);
            }
          }
          function l(t) {
            t.done ? n(t.value) : r(t.value).then(s, a);
          }
          u(s, "fulfilled"), u(a, "rejected"), u(l, "step"), l((i = i.apply(t, e || [])).next());
        });
      }, "__awaiter"), h = u(function (t, e) {
        var n,
          i,
          r,
          o,
          s = {
            label: 0,
            sent: function () {
              if (1 & r[0]) throw r[1];
              return r[1];
            },
            trys: [],
            ops: []
          };
        return o = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;
        function a(a) {
          return function (l) {
            return function (a) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; o && (o = 0, a[0] && (s = 0)), s;) try {
                if (n = 1, i && (r = 2 & a[0] ? i.return : a[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, a[1])).done) return r;
                switch (i = 0, r && (a = [2 & a[0], r.value]), a[0]) {
                  case 0:
                  case 1:
                    r = a;
                    break;
                  case 4:
                    return s.label++, {
                      value: a[1],
                      done: !1
                    };
                  case 5:
                    s.label++, i = a[1], a = [0];
                    continue;
                  case 7:
                    a = s.ops.pop(), s.trys.pop();
                    continue;
                  default:
                    if (!(r = (r = s.trys).length > 0 && r[r.length - 1]) && (6 === a[0] || 2 === a[0])) {
                      s = 0;
                      continue;
                    }
                    if (3 === a[0] && (!r || a[1] > r[0] && a[1] < r[3])) {
                      s.label = a[1];
                      break;
                    }
                    if (6 === a[0] && s.label < r[1]) {
                      s.label = r[1], r = a;
                      break;
                    }
                    if (r && s.label < r[2]) {
                      s.label = r[2], s.ops.push(a);
                      break;
                    }
                    r[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }
                a = e.call(t, s);
              } catch (t) {
                a = [6, t], i = 0;
              } finally {
                n = r = 0;
              }
              if (5 & a[0]) throw a[1];
              return {
                value: a[0] ? a[1] : void 0,
                done: !0
              };
            }([a, l]);
          };
        }
      }, "__generator"), c = u(function (t, e) {
        for (var n in t) "default" !== n && !Object.prototype.hasOwnProperty.call(e, n) && P(e, t, n);
      }, "__exportStar"), P = Object.create ? function (t, e, n, i) {
        void 0 === i && (i = n);
        var r = Object.getOwnPropertyDescriptor(e, n);
        (!r || ("get" in r ? !e.__esModule : r.writable || r.configurable)) && (r = {
          enumerable: !0,
          get: function () {
            return e[n];
          }
        }), Object.defineProperty(t, i, r);
      } : function (t, e, n, i) {
        void 0 === i && (i = n), t[i] = e[n];
      }, p = u(function (t) {
        var e = "function" == typeof Symbol && Symbol.iterator,
          n = e && t[e],
          i = 0;
        if (n) return n.call(t);
        if (t && "number" == typeof t.length) return {
          next: function () {
            return t && i >= t.length && (t = void 0), {
              value: t && t[i++],
              done: !t
            };
          }
        };
        throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, "__values"), d = u(function (t, e) {
        var n = "function" == typeof Symbol && t[Symbol.iterator];
        if (!n) return t;
        var i,
          r,
          o = n.call(t),
          s = [];
        try {
          for (; (void 0 === e || e-- > 0) && !(i = o.next()).done;) s.push(i.value);
        } catch (t) {
          r = {
            error: t
          };
        } finally {
          try {
            i && !i.done && (n = o.return) && n.call(o);
          } finally {
            if (r) throw r.error;
          }
        }
        return s;
      }, "__read"), f = u(function () {
        for (var t = [], e = 0; e < arguments.length; e++) t = t.concat(d(arguments[e]));
        return t;
      }, "__spread"), m = u(function () {
        for (var t = 0, e = 0, n = arguments.length; e < n; e++) t += arguments[e].length;
        var i = Array(t),
          r = 0;
        for (e = 0; e < n; e++) for (var o = arguments[e], s = 0, a = o.length; s < a; s++, r++) i[r] = o[s];
        return i;
      }, "__spreadArrays"), g = u(function (t, e, n) {
        if (n || 2 === arguments.length) for (var i, r = 0, o = e.length; r < o; r++) (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
        return t.concat(i || Array.prototype.slice.call(e));
      }, "__spreadArray"), v = u(function (t) {
        return this instanceof v ? (this.v = t, this) : new v(t);
      }, "__await"), y = u(function (t, e, n) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var i,
          r = n.apply(t, e || []),
          o = [];
        return i = {}, s("next"), s("throw"), s("return"), i[Symbol.asyncIterator] = function () {
          return this;
        }, i;
        function s(t) {
          r[t] && (i[t] = function (e) {
            return new Promise(function (n, i) {
              o.push([t, e, n, i]) > 1 || a(t, e);
            });
          });
        }
        function a(t, e) {
          try {
            !function (t) {
              t.value instanceof v ? Promise.resolve(t.value.v).then(l, u) : h(o[0][2], t);
            }(r[t](e));
          } catch (t) {
            h(o[0][3], t);
          }
        }
        function l(t) {
          a("next", t);
        }
        function u(t) {
          a("throw", t);
        }
        function h(t, e) {
          t(e), o.shift(), o.length && a(o[0][0], o[0][1]);
        }
      }, "__asyncGenerator"), _ = u(function (t) {
        var e, n;
        return e = {}, i("next"), i("throw", function (t) {
          throw t;
        }), i("return"), e[Symbol.iterator] = function () {
          return this;
        }, e;
        function i(i, r) {
          e[i] = t[i] ? function (e) {
            return (n = !n) ? {
              value: v(t[i](e)),
              done: "return" === i
            } : r ? r(e) : e;
          } : r;
        }
      }, "__asyncDelegator"), x = u(function (t) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var e,
          n = t[Symbol.asyncIterator];
        return n ? n.call(t) : (t = "function" == typeof p ? p(t) : t[Symbol.iterator](), e = {}, i("next"), i("throw"), i("return"), e[Symbol.asyncIterator] = function () {
          return this;
        }, e);
        function i(n) {
          e[n] = t[n] && function (e) {
            return new Promise(function (i, r) {
              (function (t, e, n, i) {
                Promise.resolve(i).then(function (e) {
                  t({
                    value: e,
                    done: n
                  });
                }, e);
              })(i, r, (e = t[n](e)).done, e.value);
            });
          };
        }
      }, "__asyncValues"), b = u(function (t, e) {
        return Object.defineProperty ? Object.defineProperty(t, "raw", {
          value: e
        }) : t.raw = e, t;
      }, "__makeTemplateObject");
      var E = Object.create ? function (t, e) {
        Object.defineProperty(t, "default", {
          enumerable: !0,
          value: e
        });
      } : function (t, e) {
        t.default = e;
      };
      w = u(function (t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var n in t) "default" !== n && Object.prototype.hasOwnProperty.call(t, n) && P(e, t, n);
        return E(e, t), e;
      }, "__importStar"), S = u(function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }, "__importDefault"), M = u(function (t, e, n, i) {
        if ("a" === n && !i) throw new TypeError("Private accessor was defined without a getter");
        if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return "m" === n ? i : "a" === n ? i.call(t) : i ? i.value : e.get(t);
      }, "__classPrivateFieldGet"), T = u(function (t, e, n, i, r) {
        if ("m" === i) throw new TypeError("Private method is not writable");
        if ("a" === i && !r) throw new TypeError("Private accessor was defined without a setter");
        if ("function" == typeof e ? t !== e || !r : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return "a" === i ? r.call(t, n) : r ? r.value = n : e.set(t, n), n;
      }, "__classPrivateFieldSet"), A = u(function (t, e) {
        if (null === e || "object" != typeof e && "function" != typeof e) throw new TypeError("Cannot use 'in' operator on non-object");
        return "function" == typeof t ? e === t : t.has(e);
      }, "__classPrivateFieldIn"), t("__extends", n), t("__assign", i), t("__rest", r), t("__decorate", o), t("__param", s), t("__metadata", a), t("__awaiter", l), t("__generator", h), t("__exportStar", c), t("__createBinding", P), t("__values", p), t("__read", d), t("__spread", f), t("__spreadArrays", m), t("__spreadArray", g), t("__await", v), t("__asyncGenerator", y), t("__asyncDelegator", _), t("__asyncValues", x), t("__makeTemplateObject", b), t("__importStar", w), t("__importDefault", S), t("__classPrivateFieldGet", M), t("__classPrivateFieldSet", T), t("__classPrivateFieldIn", A);
    });
  }),
  d4 = ze((t, e) => {
    E(), function (n, i) {
      "use strict";

      var r = "function",
        o = "undefined",
        s = "object",
        a = "string",
        l = "model",
        h = "name",
        c = "type",
        p = "vendor",
        d = "version",
        f = "architecture",
        m = "console",
        g = "mobile",
        v = "tablet",
        y = "smarttv",
        _ = "wearable",
        x = "embedded",
        E = "Amazon",
        b = "Apple",
        w = "ASUS",
        S = "BlackBerry",
        M = "Browser",
        T = "Chrome",
        A = "Firefox",
        P = "Google",
        C = "Huawei",
        I = "LG",
        N = "Microsoft",
        L = "Motorola",
        R = "Opera",
        O = "Samsung",
        q = "Sony",
        D = "Xiaomi",
        k = "Zebra",
        F = "Facebook",
        U = u(function (t, e) {
          var n = {};
          for (var i in t) e[i] && e[i].length % 2 == 0 ? n[i] = e[i].concat(t[i]) : n[i] = t[i];
          return n;
        }, "extend"),
        B = u(function (t) {
          for (var e = {}, n = 0; n < t.length; n++) e[t[n].toUpperCase()] = t[n];
          return e;
        }, "enumerize"),
        z = u(function (t, e) {
          return typeof t === a && -1 !== V(e).indexOf(V(t));
        }, "has"),
        V = u(function (t) {
          return t.toLowerCase();
        }, "lowerize"),
        j = u(function (t) {
          return typeof t === a ? t.replace(/[^\d\.]/g, "").split(".")[0] : i;
        }, "majorize"),
        G = u(function (t, e) {
          if (typeof t === a) return t = t.replace(/^\s\s*/, "").replace(/\s\s*$/, ""), typeof e === o ? t : t.substring(0, 275);
        }, "trim"),
        W = u(function (t, e) {
          for (var n, o, a, l, u, h, c = 0; c < e.length && !u;) {
            var p = e[c],
              d = e[c + 1];
            for (n = o = 0; n < p.length && !u;) if (u = p[n++].exec(t)) for (a = 0; a < d.length; a++) h = u[++o], typeof (l = d[a]) === s && l.length > 0 ? 2 === l.length ? typeof l[1] == r ? this[l[0]] = l[1].call(this, h) : this[l[0]] = l[1] : 3 === l.length ? typeof l[1] !== r || l[1].exec && l[1].test ? this[l[0]] = h ? h.replace(l[1], l[2]) : i : this[l[0]] = h ? l[1].call(this, h, l[2]) : i : 4 === l.length && (this[l[0]] = h ? l[3].call(this, h.replace(l[1], l[2])) : i) : this[l] = h || i;
            c += 2;
          }
        }, "rgxMapper"),
        H = u(function (t, e) {
          for (var n in e) if (typeof e[n] === s && e[n].length > 0) {
            for (var r = 0; r < e[n].length; r++) if (z(e[n][r], t)) return "?" === n ? i : n;
          } else if (z(e[n], t)) return "?" === n ? i : n;
          return t;
        }, "strMapper"),
        X = {
          ME: "4.90",
          "NT 3.11": "NT3.51",
          "NT 4.0": "NT4.0",
          2e3: "NT 5.0",
          XP: ["NT 5.1", "NT 5.2"],
          Vista: "NT 6.0",
          7: "NT 6.1",
          8: "NT 6.2",
          8.1: "NT 6.3",
          10: ["NT 6.4", "NT 10.0"],
          RT: "ARM"
        },
        Y = {
          browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [d, [h, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [d, [h, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [h, d], [/opios[\/ ]+([\w\.]+)/i], [d, [h, R + " Mini"]], [/\bopr\/([\w\.]+)/i], [d, [h, R]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, /(ba?idubrowser)[\/ ]?([\w\.]+)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i, /(weibo)__([\d\.]+)/i], [h, d], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [d, [h, "UC" + M]], [/\bqbcore\/([\w\.]+)/i], [d, [h, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [d, [h, "WeChat"]], [/konqueror\/([\w\.]+)/i], [d, [h, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [d, [h, "IE"]], [/yabrowser\/([\w\.]+)/i], [d, [h, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[h, /(.+)/, "$1 Secure " + M], d], [/\bfocus\/([\w\.]+)/i], [d, [h, A + " Focus"]], [/\bopt\/([\w\.]+)/i], [d, [h, R + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [d, [h, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [d, [h, "Dolphin"]], [/coast\/([\w\.]+)/i], [d, [h, R + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [d, [h, "MIUI " + M]], [/fxios\/([-\w\.]+)/i], [d, [h, A]], [/\bqihu|(qi?ho?o?|360)browser/i], [[h, "360 " + M]], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[h, /(.+)/, "$1 " + M], d], [/(comodo_dragon)\/([\w\.]+)/i], [[h, /_/g, " "], d], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i], [h, d], [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i], [h], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[h, F], d], [/safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/ ]([-\w\.]+)/i], [h, d], [/\bgsa\/([\w\.]+) .*safari\//i], [d, [h, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [d, [h, T + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[h, T + " WebView"], d], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [d, [h, "Android " + M]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [h, d], [/version\/([\w\.]+) .*mobile\/\w+ (safari)/i], [d, [h, "Mobile Safari"]], [/version\/([\w\.]+) .*(mobile ?safari|safari)/i], [d, h], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [h, [d, H, {
            "1.0": "/8",
            1.2: "/1",
            1.3: "/3",
            "2.0": "/412",
            "2.0.2": "/416",
            "2.0.3": "/417",
            "2.0.4": "/419",
            "?": "/"
          }]], [/(webkit|khtml)\/([\w\.]+)/i], [h, d], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[h, "Netscape"], d], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [d, [h, A + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i], [h, d]],
          cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[f, "amd64"]], [/(ia32(?=;))/i], [[f, V]], [/((?:i[346]|x)86)[;\)]/i], [[f, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[f, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[f, "armhf"]], [/windows (ce|mobile); ppc;/i], [[f, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[f, /ower/, "", V]], [/(sun4\w)[;\)]/i], [[f, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[f, V]]],
          device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [l, [p, O], [c, v]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [l, [p, O], [c, g]], [/((ipod|iphone)\d+,\d+)/i], [l, [p, b], [c, g]], [/(ipad\d+,\d+)/i], [l, [p, b], [c, v]], [/\((ip(?:hone|od)[\w ]*);/i], [l, [p, b], [c, g]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [l, [p, b], [c, v]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [l, [p, C], [c, v]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [l, [p, C], [c, g]], [/\b(poco[\w ]+)(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[l, /_/g, " "], [p, D], [c, g]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[l, /_/g, " "], [p, D], [c, v]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [l, [p, "OPPO"], [c, g]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [l, [p, "Vivo"], [c, g]], [/\b(rmx[12]\d{3})(?: bui|;|\))/i], [l, [p, "Realme"], [c, g]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [l, [p, L], [c, g]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [l, [p, L], [c, v]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [l, [p, I], [c, v]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [l, [p, I], [c, g]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [l, [p, "Lenovo"], [c, v]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[l, /_/g, " "], [p, "Nokia"], [c, g]], [/(pixel c)\b/i], [l, [p, P], [c, v]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [l, [p, P], [c, g]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [l, [p, q], [c, g]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[l, "Xperia Tablet"], [p, q], [c, v]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [l, [p, "OnePlus"], [c, g]], [/(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [l, [p, E], [c, v]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[l, /(.+)/g, "Fire Phone $1"], [p, E], [c, g]], [/(playbook);[-\w\),; ]+(rim)/i], [l, p, [c, v]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [l, [p, S], [c, g]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [l, [p, w], [c, v]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [l, [p, w], [c, g]], [/(nexus 9)/i], [l, [p, "HTC"], [c, v]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i], [p, [l, /_/g, " "], [c, g]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [l, [p, "Acer"], [c, v]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [l, [p, "Meizu"], [c, g]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [l, [p, "Sharp"], [c, g]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [p, l, [c, g]], [/(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [p, l, [c, v]], [/(surface duo)/i], [l, [p, N], [c, v]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [l, [p, "Fairphone"], [c, g]], [/(u304aa)/i], [l, [p, "AT&T"], [c, g]], [/\bsie-(\w*)/i], [l, [p, "Siemens"], [c, g]], [/\b(rct\w+) b/i], [l, [p, "RCA"], [c, v]], [/\b(venue[\d ]{2,7}) b/i], [l, [p, "Dell"], [c, v]], [/\b(q(?:mv|ta)\w+) b/i], [l, [p, "Verizon"], [c, v]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [l, [p, "Barnes & Noble"], [c, v]], [/\b(tm\d{3}\w+) b/i], [l, [p, "NuVision"], [c, v]], [/\b(k88) b/i], [l, [p, "ZTE"], [c, v]], [/\b(nx\d{3}j) b/i], [l, [p, "ZTE"], [c, g]], [/\b(gen\d{3}) b.+49h/i], [l, [p, "Swiss"], [c, g]], [/\b(zur\d{3}) b/i], [l, [p, "Swiss"], [c, v]], [/\b((zeki)?tb.*\b) b/i], [l, [p, "Zeki"], [c, v]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[p, "Dragon Touch"], l, [c, v]], [/\b(ns-?\w{0,9}) b/i], [l, [p, "Insignia"], [c, v]], [/\b((nxa|next)-?\w{0,9}) b/i], [l, [p, "NextBook"], [c, v]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[p, "Voice"], l, [c, g]], [/\b(lvtel\-)?(v1[12]) b/i], [[p, "LvTel"], l, [c, g]], [/\b(ph-1) /i], [l, [p, "Essential"], [c, g]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [l, [p, "Envizen"], [c, v]], [/\b(trio[-\w\. ]+) b/i], [l, [p, "MachSpeed"], [c, v]], [/\btu_(1491) b/i], [l, [p, "Rotor"], [c, v]], [/(shield[\w ]+) b/i], [l, [p, "Nvidia"], [c, v]], [/(sprint) (\w+)/i], [p, l, [c, g]], [/(kin\.[onetw]{3})/i], [[l, /\./g, " "], [p, N], [c, g]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [l, [p, k], [c, v]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [l, [p, k], [c, g]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [p, l, [c, m]], [/droid.+; (shield) bui/i], [l, [p, "Nvidia"], [c, m]], [/(playstation [345portablevi]+)/i], [l, [p, q], [c, m]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [l, [p, N], [c, m]], [/smart-tv.+(samsung)/i], [p, [c, y]], [/hbbtv.+maple;(\d+)/i], [[l, /^/, "SmartTV"], [p, O], [c, y]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[p, I], [c, y]], [/(apple) ?tv/i], [p, [l, b + " TV"], [c, y]], [/crkey/i], [[l, T + "cast"], [p, P], [c, y]], [/droid.+aft(\w)( bui|\))/i], [l, [p, E], [c, y]], [/\(dtv[\);].+(aquos)/i], [l, [p, "Sharp"], [c, y]], [/(bravia[\w- ]+) bui/i], [l, [p, q], [c, y]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i], [[p, G], [l, G], [c, y]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[c, y]], [/((pebble))app/i], [p, l, [c, _]], [/droid.+; (glass) \d/i], [l, [p, P], [c, _]], [/droid.+; (wt63?0{2,3})\)/i], [l, [p, k], [c, _]], [/(quest( 2)?)/i], [l, [p, F], [c, _]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [p, [c, x]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i], [l, [c, g]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [l, [c, v]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[c, v]], [/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i], [[c, g]], [/(android[-\w\. ]{0,9});.+buil/i], [l, [p, "Generic"]]],
          engine: [[/windows.+ edge\/([\w\.]+)/i], [d, [h, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [d, [h, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i], [h, d], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [d, h]],
          os: [[/microsoft (windows) (vista|xp)/i], [h, d], [/(windows) nt 6\.2; (arm)/i, /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [h, [d, H, X]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[h, "Windows"], [d, H, X]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /cfnetwork\/.+darwin/i], [[d, /_/g, "."], [h, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[h, "Mac OS"], [d, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86)/i], [d, h], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [h, d], [/\(bb(10);/i], [d, [h, S]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [d, [h, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [d, [h, A + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [d, [h, "webOS"]], [/crkey\/([\d\.]+)/i], [d, [h, T + "cast"]], [/(cros) [\w]+ ([\w\.]+\w)/i], [[h, "Chromium OS"], d], [/(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [h, d], [/(sunos) ?([\w\.\d]*)/i], [[h, "Solaris"], d], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, /(unix) ?([\w\.]*)/i], [h, d]]
        },
        Z = u(function (t, e) {
          if (typeof t === s && (e = t, t = i), !(this instanceof Z)) return new Z(t, e).getResult();
          var r = t || (typeof n !== o && n.navigator && n.navigator.userAgent ? n.navigator.userAgent : ""),
            u = e ? U(Y, e) : Y;
          return this.getBrowser = function () {
            var t = {};
            return t[h] = i, t[d] = i, W.call(t, r, u.browser), t.major = j(t.version), t;
          }, this.getCPU = function () {
            var t = {};
            return t[f] = i, W.call(t, r, u.cpu), t;
          }, this.getDevice = function () {
            var t = {};
            return t[p] = i, t[l] = i, t[c] = i, W.call(t, r, u.device), t;
          }, this.getEngine = function () {
            var t = {};
            return t[h] = i, t[d] = i, W.call(t, r, u.engine), t;
          }, this.getOS = function () {
            var t = {};
            return t[h] = i, t[d] = i, W.call(t, r, u.os), t;
          }, this.getResult = function () {
            return {
              ua: this.getUA(),
              browser: this.getBrowser(),
              engine: this.getEngine(),
              os: this.getOS(),
              device: this.getDevice(),
              cpu: this.getCPU()
            };
          }, this.getUA = function () {
            return r;
          }, this.setUA = function (t) {
            return r = typeof t === a && t.length > 275 ? G(t, 275) : t, this;
          }, this.setUA(r), this;
        }, "UAParser");
      Z.VERSION = "0.7.31", Z.BROWSER = B([h, d, "major"]), Z.CPU = B([f]), Z.DEVICE = B([l, p, c, m, g, y, v, _, x]), Z.ENGINE = Z.OS = B([h, d]), typeof t !== o ? (typeof e !== o && e.exports && (t = e.exports = Z), t.UAParser = Z) : typeof define === r && define.amd ? define(function () {
        return Z;
      }) : typeof n !== o && (n.UAParser = Z);
      var J = typeof n !== o && (n.jQuery || n.Zepto);
      if (J && !J.ua) {
        var K = new Z();
        J.ua = K.getResult(), J.ua.get = function () {
          return K.getUA();
        }, J.ua.set = function (t) {
          K.setUA(t);
          var e = K.getResult();
          for (var n in e) J.ua[n] = e[n];
        };
      }
    }("object" == typeof window ? window : t);
  }),
  OO = ze((t, e) => {
    E();
    var n = "__lodash_hash_undefined__",
      i = 9007199254740991,
      r = "[object Arguments]",
      o = "[object Array]",
      s = "[object Boolean]",
      a = "[object Date]",
      l = "[object Error]",
      h = "[object Function]",
      c = "[object Map]",
      p = "[object Number]",
      d = "[object Object]",
      f = "[object Promise]",
      m = "[object RegExp]",
      g = "[object Set]",
      v = "[object String]",
      y = "[object WeakMap]",
      _ = "[object ArrayBuffer]",
      x = "[object DataView]",
      b = /^\[object .+?Constructor\]$/,
      w = /^(?:0|[1-9]\d*)$/,
      S = {};
    S["[object Float32Array]"] = S["[object Float64Array]"] = S["[object Int8Array]"] = S["[object Int16Array]"] = S["[object Int32Array]"] = S["[object Uint8Array]"] = S["[object Uint8ClampedArray]"] = S["[object Uint16Array]"] = S["[object Uint32Array]"] = !0, S[r] = S[o] = S[_] = S[s] = S[x] = S[a] = S[l] = S[h] = S[c] = S[p] = S[d] = S[m] = S[g] = S[v] = S[y] = !1;
    var M = "object" == typeof global && global && global.Object === Object && global,
      T = "object" == typeof self && self && self.Object === Object && self,
      A = M || T || Function("return this")(),
      P = "object" == typeof t && t && !t.nodeType && t,
      C = P && "object" == typeof e && e && !e.nodeType && e,
      I = C && C.exports === P,
      N = I && M.process,
      L = function () {
        try {
          return N && N.binding && N.binding("util");
        } catch (t) {}
      }(),
      R = L && L.isTypedArray;
    function O(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, r = 0, o = []; ++n < i;) {
        var s = t[n];
        e(s, n, t) && (o[r++] = s);
      }
      return o;
    }
    function q(t, e) {
      for (var n = -1, i = e.length, r = t.length; ++n < i;) t[r + n] = e[n];
      return t;
    }
    function D(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i;) if (e(t[n], n, t)) return !0;
      return !1;
    }
    function k(t, e) {
      for (var n = -1, i = Array(t); ++n < t;) i[n] = e(n);
      return i;
    }
    function F(t) {
      return function (e) {
        return t(e);
      };
    }
    function U(t, e) {
      return t.has(e);
    }
    function B(t, e) {
      return null == t ? void 0 : t[e];
    }
    function z(t) {
      var e = -1,
        n = Array(t.size);
      return t.forEach(function (t, i) {
        n[++e] = [i, t];
      }), n;
    }
    function V(t, e) {
      return function (n) {
        return t(e(n));
      };
    }
    function j(t) {
      var e = -1,
        n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    }
    u(O, "arrayFilter"), u(q, "arrayPush"), u(D, "arraySome"), u(k, "baseTimes"), u(F, "baseUnary"), u(U, "cacheHas"), u(B, "getValue"), u(z, "mapToArray"), u(V, "overArg"), u(j, "setToArray");
    var G,
      W = Array.prototype,
      H = Function.prototype,
      X = Object.prototype,
      Y = A["__core-js_shared__"],
      Z = H.toString,
      J = X.hasOwnProperty,
      K = (G = /[^.]+$/.exec(Y && Y.keys && Y.keys.IE_PROTO || "")) ? "Symbol(src)_1." + G : "",
      Q = X.toString,
      $ = RegExp("^" + Z.call(J).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
      tt = I ? A.Buffer : void 0,
      et = A.Symbol,
      nt = A.Uint8Array,
      it = X.propertyIsEnumerable,
      rt = W.splice,
      ot = et ? et.toStringTag : void 0,
      st = Object.getOwnPropertySymbols,
      at = tt ? tt.isBuffer : void 0,
      lt = V(Object.keys, Object),
      ut = he(A, "DataView"),
      ht = he(A, "Map"),
      ct = he(A, "Promise"),
      pt = he(A, "Set"),
      dt = he(A, "WeakMap"),
      ft = he(Object, "create"),
      mt = _e(ut),
      gt = _e(ht),
      vt = _e(ct),
      yt = _e(pt),
      _t = _e(dt),
      xt = et ? et.prototype : void 0,
      Et = xt ? xt.valueOf : void 0;
    function bt(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function wt() {
      this.__data__ = ft ? ft(null) : {}, this.size = 0;
    }
    function St(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    }
    function Mt(t) {
      var e = this.__data__;
      if (ft) {
        var i = e[t];
        return i === n ? void 0 : i;
      }
      return J.call(e, t) ? e[t] : void 0;
    }
    function Tt(t) {
      var e = this.__data__;
      return ft ? void 0 !== e[t] : J.call(e, t);
    }
    function At(t, e) {
      var i = this.__data__;
      return this.size += this.has(t) ? 0 : 1, i[t] = ft && void 0 === e ? n : e, this;
    }
    function Pt(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function Ct() {
      this.__data__ = [], this.size = 0;
    }
    function It(t) {
      var e = this.__data__,
        n = Jt(e, t);
      return !(n < 0) && (n == e.length - 1 ? e.pop() : rt.call(e, n, 1), --this.size, !0);
    }
    function Nt(t) {
      var e = this.__data__,
        n = Jt(e, t);
      return n < 0 ? void 0 : e[n][1];
    }
    function Lt(t) {
      return Jt(this.__data__, t) > -1;
    }
    function Rt(t, e) {
      var n = this.__data__,
        i = Jt(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    }
    function Ot(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function qt() {
      this.size = 0, this.__data__ = {
        hash: new bt(),
        map: new (ht || Pt)(),
        string: new bt()
      };
    }
    function Dt(t) {
      var e = ue(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    }
    function kt(t) {
      return ue(this, t).get(t);
    }
    function Ft(t) {
      return ue(this, t).has(t);
    }
    function Ut(t, e) {
      var n = ue(this, t),
        i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    }
    function Bt(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.__data__ = new Ot(); ++e < n;) this.add(t[e]);
    }
    function zt(t) {
      return this.__data__.set(t, n), this;
    }
    function Vt(t) {
      return this.__data__.has(t);
    }
    function jt(t) {
      var e = this.__data__ = new Pt(t);
      this.size = e.size;
    }
    function Gt() {
      this.__data__ = new Pt(), this.size = 0;
    }
    function Wt(t) {
      var e = this.__data__,
        n = e.delete(t);
      return this.size = e.size, n;
    }
    function Ht(t) {
      return this.__data__.get(t);
    }
    function Xt(t) {
      return this.__data__.has(t);
    }
    function Yt(t, e) {
      var n = this.__data__;
      if (n instanceof Pt) {
        var i = n.__data__;
        if (!ht || i.length < 199) return i.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new Ot(i);
      }
      return n.set(t, e), this.size = n.size, this;
    }
    function Zt(t, e) {
      var n = be(t),
        i = !n && Ee(t),
        r = !n && !i && Se(t),
        o = !n && !i && !r && Ie(t),
        s = n || i || r || o,
        a = s ? k(t.length, String) : [],
        l = a.length;
      for (var u in t) (e || J.call(t, u)) && (!s || !("length" == u || r && ("offset" == u || "parent" == u) || o && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || fe(u, l))) && a.push(u);
      return a;
    }
    function Jt(t, e) {
      for (var n = t.length; n--;) if (xe(t[n][0], e)) return n;
      return -1;
    }
    function Kt(t, e, n) {
      var i = e(t);
      return be(t) ? i : q(i, n(t));
    }
    function Qt(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : ot && ot in Object(t) ? ce(t) : ye(t);
    }
    function $t(t) {
      return Ce(t) && Qt(t) == r;
    }
    function te(t, e, n, i, r) {
      return t === e || (null == t || null == e || !Ce(t) && !Ce(e) ? t != t && e != e : ee(t, e, n, i, te, r));
    }
    function ee(t, e, n, i, s, a) {
      var l = be(t),
        u = be(e),
        h = l ? o : de(t),
        c = u ? o : de(e),
        p = (h = h == r ? d : h) == d,
        f = (c = c == r ? d : c) == d,
        m = h == c;
      if (m && Se(t)) {
        if (!Se(e)) return !1;
        l = !0, p = !1;
      }
      if (m && !p) return a || (a = new jt()), l || Ie(t) ? oe(t, e, n, i, s, a) : se(t, e, h, n, i, s, a);
      if (!(1 & n)) {
        var g = p && J.call(t, "__wrapped__"),
          v = f && J.call(e, "__wrapped__");
        if (g || v) {
          var y = g ? t.value() : t,
            _ = v ? e.value() : e;
          return a || (a = new jt()), s(y, _, n, i, a);
        }
      }
      return !!m && (a || (a = new jt()), ae(t, e, n, i, s, a));
    }
    function ne(t) {
      return !(!Pe(t) || ge(t)) && (Te(t) ? $ : b).test(_e(t));
    }
    function ie(t) {
      return Ce(t) && Ae(t.length) && !!S[Qt(t)];
    }
    function re(t) {
      if (!ve(t)) return lt(t);
      var e = [];
      for (var n in Object(t)) J.call(t, n) && "constructor" != n && e.push(n);
      return e;
    }
    function oe(t, e, n, i, r, o) {
      var s = 1 & n,
        a = t.length,
        l = e.length;
      if (a != l && !(s && l > a)) return !1;
      var u = o.get(t);
      if (u && o.get(e)) return u == e;
      var h = -1,
        c = !0,
        p = 2 & n ? new Bt() : void 0;
      for (o.set(t, e), o.set(e, t); ++h < a;) {
        var d = t[h],
          f = e[h];
        if (i) var m = s ? i(f, d, h, e, t, o) : i(d, f, h, t, e, o);
        if (void 0 !== m) {
          if (m) continue;
          c = !1;
          break;
        }
        if (p) {
          if (!D(e, function (t, e) {
            if (!U(p, e) && (d === t || r(d, t, n, i, o))) return p.push(e);
          })) {
            c = !1;
            break;
          }
        } else if (d !== f && !r(d, f, n, i, o)) {
          c = !1;
          break;
        }
      }
      return o.delete(t), o.delete(e), c;
    }
    function se(t, e, n, i, r, o, u) {
      switch (n) {
        case x:
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;
        case _:
          return !(t.byteLength != e.byteLength || !o(new nt(t), new nt(e)));
        case s:
        case a:
        case p:
          return xe(+t, +e);
        case l:
          return t.name == e.name && t.message == e.message;
        case m:
        case v:
          return t == e + "";
        case c:
          var h = z;
        case g:
          var d = 1 & i;
          if (h || (h = j), t.size != e.size && !d) return !1;
          var f = u.get(t);
          if (f) return f == e;
          i |= 2, u.set(t, e);
          var y = oe(h(t), h(e), i, r, o, u);
          return u.delete(t), y;
        case "[object Symbol]":
          if (Et) return Et.call(t) == Et.call(e);
      }
      return !1;
    }
    function ae(t, e, n, i, r, o) {
      var s = 1 & n,
        a = le(t),
        l = a.length;
      if (l != le(e).length && !s) return !1;
      for (var u = l; u--;) {
        var h = a[u];
        if (!(s ? h in e : J.call(e, h))) return !1;
      }
      var c = o.get(t);
      if (c && o.get(e)) return c == e;
      var p = !0;
      o.set(t, e), o.set(e, t);
      for (var d = s; ++u < l;) {
        var f = t[h = a[u]],
          m = e[h];
        if (i) var g = s ? i(m, f, h, e, t, o) : i(f, m, h, t, e, o);
        if (!(void 0 === g ? f === m || r(f, m, n, i, o) : g)) {
          p = !1;
          break;
        }
        d || (d = "constructor" == h);
      }
      if (p && !d) {
        var v = t.constructor,
          y = e.constructor;
        v != y && "constructor" in t && "constructor" in e && !("function" == typeof v && v instanceof v && "function" == typeof y && y instanceof y) && (p = !1);
      }
      return o.delete(t), o.delete(e), p;
    }
    function le(t) {
      return Kt(t, Ne, pe);
    }
    function ue(t, e) {
      var n = t.__data__;
      return me(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    }
    function he(t, e) {
      var n = B(t, e);
      return ne(n) ? n : void 0;
    }
    function ce(t) {
      var e = J.call(t, ot),
        n = t[ot];
      try {
        t[ot] = void 0;
        var i = !0;
      } catch (t) {}
      var r = Q.call(t);
      return i && (e ? t[ot] = n : delete t[ot]), r;
    }
    u(bt, "Hash"), u(wt, "hashClear"), u(St, "hashDelete"), u(Mt, "hashGet"), u(Tt, "hashHas"), u(At, "hashSet"), bt.prototype.clear = wt, bt.prototype.delete = St, bt.prototype.get = Mt, bt.prototype.has = Tt, bt.prototype.set = At, u(Pt, "ListCache"), u(Ct, "listCacheClear"), u(It, "listCacheDelete"), u(Nt, "listCacheGet"), u(Lt, "listCacheHas"), u(Rt, "listCacheSet"), Pt.prototype.clear = Ct, Pt.prototype.delete = It, Pt.prototype.get = Nt, Pt.prototype.has = Lt, Pt.prototype.set = Rt, u(Ot, "MapCache"), u(qt, "mapCacheClear"), u(Dt, "mapCacheDelete"), u(kt, "mapCacheGet"), u(Ft, "mapCacheHas"), u(Ut, "mapCacheSet"), Ot.prototype.clear = qt, Ot.prototype.delete = Dt, Ot.prototype.get = kt, Ot.prototype.has = Ft, Ot.prototype.set = Ut, u(Bt, "SetCache"), u(zt, "setCacheAdd"), u(Vt, "setCacheHas"), Bt.prototype.add = Bt.prototype.push = zt, Bt.prototype.has = Vt, u(jt, "Stack"), u(Gt, "stackClear"), u(Wt, "stackDelete"), u(Ht, "stackGet"), u(Xt, "stackHas"), u(Yt, "stackSet"), jt.prototype.clear = Gt, jt.prototype.delete = Wt, jt.prototype.get = Ht, jt.prototype.has = Xt, jt.prototype.set = Yt, u(Zt, "arrayLikeKeys"), u(Jt, "assocIndexOf"), u(Kt, "baseGetAllKeys"), u(Qt, "baseGetTag"), u($t, "baseIsArguments"), u(te, "baseIsEqual"), u(ee, "baseIsEqualDeep"), u(ne, "baseIsNative"), u(ie, "baseIsTypedArray"), u(re, "baseKeys"), u(oe, "equalArrays"), u(se, "equalByTag"), u(ae, "equalObjects"), u(le, "getAllKeys"), u(ue, "getMapData"), u(he, "getNative"), u(ce, "getRawTag");
    var pe = st ? function (t) {
        return null == t ? [] : (t = Object(t), O(st(t), function (e) {
          return it.call(t, e);
        }));
      } : Le,
      de = Qt;
    function fe(t, e) {
      return !!(e = null == e ? i : e) && ("number" == typeof t || w.test(t)) && t > -1 && t % 1 == 0 && t < e;
    }
    function me(t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    }
    function ge(t) {
      return !!K && K in t;
    }
    function ve(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || X);
    }
    function ye(t) {
      return Q.call(t);
    }
    function _e(t) {
      if (null != t) {
        try {
          return Z.call(t);
        } catch (t) {}
        try {
          return t + "";
        } catch (t) {}
      }
      return "";
    }
    function xe(t, e) {
      return t === e || t != t && e != e;
    }
    (ut && de(new ut(new ArrayBuffer(1))) != x || ht && de(new ht()) != c || ct && de(ct.resolve()) != f || pt && de(new pt()) != g || dt && de(new dt()) != y) && (de = u(function (t) {
      var e = Qt(t),
        n = e == d ? t.constructor : void 0,
        i = n ? _e(n) : "";
      if (i) switch (i) {
        case mt:
          return x;
        case gt:
          return c;
        case vt:
          return f;
        case yt:
          return g;
        case _t:
          return y;
      }
      return e;
    }, "getTag")), u(fe, "isIndex"), u(me, "isKeyable"), u(ge, "isMasked"), u(ve, "isPrototype"), u(ye, "objectToString"), u(_e, "toSource"), u(xe, "eq");
    var Ee = $t(function () {
        return arguments;
      }()) ? $t : function (t) {
        return Ce(t) && J.call(t, "callee") && !it.call(t, "callee");
      },
      be = Array.isArray;
    function we(t) {
      return null != t && Ae(t.length) && !Te(t);
    }
    u(we, "isArrayLike");
    var Se = at || Re;
    function Me(t, e) {
      return te(t, e);
    }
    function Te(t) {
      if (!Pe(t)) return !1;
      var e = Qt(t);
      return e == h || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    }
    function Ae(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= i;
    }
    function Pe(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    }
    function Ce(t) {
      return null != t && "object" == typeof t;
    }
    u(Me, "isEqual"), u(Te, "isFunction"), u(Ae, "isLength"), u(Pe, "isObject"), u(Ce, "isObjectLike");
    var Ie = R ? F(R) : ie;
    function Ne(t) {
      return we(t) ? Zt(t) : re(t);
    }
    function Le() {
      return [];
    }
    function Re() {
      return !1;
    }
    u(Ne, "keys"), u(Le, "stubArray"), u(Re, "stubFalse"), e.exports = Me;
  }),
  Q4 = ze((t, e) => {
    E();
    var n = "__lodash_hash_undefined__",
      i = 9007199254740991,
      r = "[object Arguments]",
      o = "[object Function]",
      s = "[object Object]",
      a = /^\[object .+?Constructor\]$/,
      l = /^(?:0|[1-9]\d*)$/,
      h = {};
    h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = !0, h[r] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h[o] = h["[object Map]"] = h["[object Number]"] = h[s] = h["[object RegExp]"] = h["[object Set]"] = h["[object String]"] = h["[object WeakMap]"] = !1;
    var c = "object" == typeof global && global && global.Object === Object && global,
      p = "object" == typeof self && self && self.Object === Object && self,
      d = c || p || Function("return this")(),
      f = "object" == typeof t && t && !t.nodeType && t,
      m = f && "object" == typeof e && e && !e.nodeType && e,
      g = m && m.exports === f,
      v = g && c.process,
      y = function () {
        try {
          return m && m.require && m.require("util").types || v && v.binding && v.binding("util");
        } catch (t) {}
      }(),
      _ = y && y.isTypedArray;
    function x(t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);
        case 1:
          return t.call(e, n[0]);
        case 2:
          return t.call(e, n[0], n[1]);
        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }
      return t.apply(e, n);
    }
    function b(t, e) {
      for (var n = -1, i = Array(t); ++n < t;) i[n] = e(n);
      return i;
    }
    function w(t) {
      return function (e) {
        return t(e);
      };
    }
    function S(t, e) {
      return null == t ? void 0 : t[e];
    }
    function M(t, e) {
      return function (n) {
        return t(e(n));
      };
    }
    u(x, "apply"), u(b, "baseTimes"), u(w, "baseUnary"), u(S, "getValue"), u(M, "overArg");
    var T,
      A = Array.prototype,
      P = Function.prototype,
      C = Object.prototype,
      I = d["__core-js_shared__"],
      N = P.toString,
      L = C.hasOwnProperty,
      R = (T = /[^.]+$/.exec(I && I.keys && I.keys.IE_PROTO || "")) ? "Symbol(src)_1." + T : "",
      O = C.toString,
      q = N.call(Object),
      D = RegExp("^" + N.call(L).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
      k = g ? d.Buffer : void 0,
      F = d.Symbol,
      U = d.Uint8Array,
      B = k ? k.allocUnsafe : void 0,
      z = M(Object.getPrototypeOf, Object),
      V = Object.create,
      j = C.propertyIsEnumerable,
      G = A.splice,
      W = F ? F.toStringTag : void 0,
      H = function () {
        try {
          var t = Ht(Object, "defineProperty");
          return t({}, "", {}), t;
        } catch (t) {}
      }(),
      X = k ? k.isBuffer : void 0,
      Y = Math.max,
      Z = Date.now,
      J = Ht(d, "Map"),
      K = Ht(Object, "create"),
      Q = function () {
        function t() {}
        return u(t, "object"), function (e) {
          if (!me(e)) return {};
          if (V) return V(e);
          t.prototype = e;
          var n = new t();
          return t.prototype = void 0, n;
        };
      }();
    function $(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function tt() {
      this.__data__ = K ? K(null) : {}, this.size = 0;
    }
    function et(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    }
    function nt(t) {
      var e = this.__data__;
      if (K) {
        var i = e[t];
        return i === n ? void 0 : i;
      }
      return L.call(e, t) ? e[t] : void 0;
    }
    function it(t) {
      var e = this.__data__;
      return K ? void 0 !== e[t] : L.call(e, t);
    }
    function rt(t, e) {
      var i = this.__data__;
      return this.size += this.has(t) ? 0 : 1, i[t] = K && void 0 === e ? n : e, this;
    }
    function ot(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function st() {
      this.__data__ = [], this.size = 0;
    }
    function at(t) {
      var e = this.__data__,
        n = Tt(e, t);
      return !(n < 0) && (n == e.length - 1 ? e.pop() : G.call(e, n, 1), --this.size, !0);
    }
    function lt(t) {
      var e = this.__data__,
        n = Tt(e, t);
      return n < 0 ? void 0 : e[n][1];
    }
    function ut(t) {
      return Tt(this.__data__, t) > -1;
    }
    function ht(t, e) {
      var n = this.__data__,
        i = Tt(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    }
    function ct(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function pt() {
      this.size = 0, this.__data__ = {
        hash: new $(),
        map: new (J || ot)(),
        string: new $()
      };
    }
    function dt(t) {
      var e = Wt(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    }
    function ft(t) {
      return Wt(this, t).get(t);
    }
    function mt(t) {
      return Wt(this, t).has(t);
    }
    function gt(t, e) {
      var n = Wt(this, t),
        i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    }
    function vt(t) {
      var e = this.__data__ = new ot(t);
      this.size = e.size;
    }
    function yt() {
      this.__data__ = new ot(), this.size = 0;
    }
    function _t(t) {
      var e = this.__data__,
        n = e.delete(t);
      return this.size = e.size, n;
    }
    function xt(t) {
      return this.__data__.get(t);
    }
    function Et(t) {
      return this.__data__.has(t);
    }
    function bt(t, e) {
      var n = this.__data__;
      if (n instanceof ot) {
        var i = n.__data__;
        if (!J || i.length < 199) return i.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new ct(i);
      }
      return n.set(t, e), this.size = n.size, this;
    }
    function wt(t, e) {
      var n = ue(t),
        i = !n && le(t),
        r = !n && !i && pe(t),
        o = !n && !i && !r && ye(t),
        s = n || i || r || o,
        a = s ? b(t.length, String) : [],
        l = a.length;
      for (var u in t) (e || L.call(t, u)) && (!s || !("length" == u || r && ("offset" == u || "parent" == u) || o && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || Zt(u, l))) && a.push(u);
      return a;
    }
    function St(t, e, n) {
      (void 0 !== n && !ae(t[e], n) || void 0 === n && !(e in t)) && At(t, e, n);
    }
    function Mt(t, e, n) {
      var i = t[e];
      (!L.call(t, e) || !ae(i, n) || void 0 === n && !(e in t)) && At(t, e, n);
    }
    function Tt(t, e) {
      for (var n = t.length; n--;) if (ae(t[n][0], e)) return n;
      return -1;
    }
    function At(t, e, n) {
      "__proto__" == e && H ? H(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    }
    u($, "Hash"), u(tt, "hashClear"), u(et, "hashDelete"), u(nt, "hashGet"), u(it, "hashHas"), u(rt, "hashSet"), $.prototype.clear = tt, $.prototype.delete = et, $.prototype.get = nt, $.prototype.has = it, $.prototype.set = rt, u(ot, "ListCache"), u(st, "listCacheClear"), u(at, "listCacheDelete"), u(lt, "listCacheGet"), u(ut, "listCacheHas"), u(ht, "listCacheSet"), ot.prototype.clear = st, ot.prototype.delete = at, ot.prototype.get = lt, ot.prototype.has = ut, ot.prototype.set = ht, u(ct, "MapCache"), u(pt, "mapCacheClear"), u(dt, "mapCacheDelete"), u(ft, "mapCacheGet"), u(mt, "mapCacheHas"), u(gt, "mapCacheSet"), ct.prototype.clear = pt, ct.prototype.delete = dt, ct.prototype.get = ft, ct.prototype.has = mt, ct.prototype.set = gt, u(vt, "Stack"), u(yt, "stackClear"), u(_t, "stackDelete"), u(xt, "stackGet"), u(Et, "stackHas"), u(bt, "stackSet"), vt.prototype.clear = yt, vt.prototype.delete = _t, vt.prototype.get = xt, vt.prototype.has = Et, vt.prototype.set = bt, u(wt, "arrayLikeKeys"), u(St, "assignMergeValue"), u(Mt, "assignValue"), u(Tt, "assocIndexOf"), u(At, "baseAssignValue");
    var Pt = Gt();
    function Ct(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : W && W in Object(t) ? Xt(t) : ee(t);
    }
    function It(t) {
      return ge(t) && Ct(t) == r;
    }
    function Nt(t) {
      return !(!me(t) || Qt(t)) && (de(t) ? D : a).test(se(t));
    }
    function Lt(t) {
      return ge(t) && fe(t.length) && !!h[Ct(t)];
    }
    function Rt(t) {
      if (!me(t)) return te(t);
      var e = $t(t),
        n = [];
      for (var i in t) "constructor" == i && (e || !L.call(t, i)) || n.push(i);
      return n;
    }
    function Ot(t, e, n, i, r) {
      t !== e && Pt(e, function (o, s) {
        if (r || (r = new vt()), me(o)) qt(t, e, s, n, Ot, i, r);else {
          var a = i ? i(ie(t, s), o, s + "", t, e, r) : void 0;
          void 0 === a && (a = o), St(t, s, a);
        }
      }, xe);
    }
    function qt(t, e, n, i, r, o, s) {
      var a = ie(t, n),
        l = ie(e, n),
        u = s.get(l);
      if (u) St(t, n, u);else {
        var h = o ? o(a, l, n + "", t, e, s) : void 0,
          c = void 0 === h;
        if (c) {
          var p = ue(l),
            d = !p && pe(l),
            f = !p && !d && ye(l);
          h = l, p || d || f ? ue(a) ? h = a : ce(a) ? h = zt(a) : d ? (c = !1, h = Ft(l, !0)) : f ? (c = !1, h = Bt(l, !0)) : h = [] : ve(l) || le(l) ? (h = a, le(a) ? h = _e(a) : (!me(a) || de(a)) && (h = Yt(l))) : c = !1;
        }
        c && (s.set(l, h), r(h, l, i, o, s), s.delete(l)), St(t, n, h);
      }
    }
    function Dt(t, e) {
      return re(ne(t, e, we), t + "");
    }
    u(Ct, "baseGetTag"), u(It, "baseIsArguments"), u(Nt, "baseIsNative"), u(Lt, "baseIsTypedArray"), u(Rt, "baseKeysIn"), u(Ot, "baseMerge"), u(qt, "baseMergeDeep"), u(Dt, "baseRest");
    var kt = H ? function (t, e) {
      return H(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: be(e),
        writable: !0
      });
    } : we;
    function Ft(t, e) {
      if (e) return t.slice();
      var n = t.length,
        i = B ? B(n) : new t.constructor(n);
      return t.copy(i), i;
    }
    function Ut(t) {
      var e = new t.constructor(t.byteLength);
      return new U(e).set(new U(t)), e;
    }
    function Bt(t, e) {
      var n = e ? Ut(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    }
    function zt(t, e) {
      var n = -1,
        i = t.length;
      for (e || (e = Array(i)); ++n < i;) e[n] = t[n];
      return e;
    }
    function Vt(t, e, n, i) {
      var r = !n;
      n || (n = {});
      for (var o = -1, s = e.length; ++o < s;) {
        var a = e[o],
          l = i ? i(n[a], t[a], a, n, t) : void 0;
        void 0 === l && (l = t[a]), r ? At(n, a, l) : Mt(n, a, l);
      }
      return n;
    }
    function jt(t) {
      return Dt(function (e, n) {
        var i = -1,
          r = n.length,
          o = r > 1 ? n[r - 1] : void 0,
          s = r > 2 ? n[2] : void 0;
        for (o = t.length > 3 && "function" == typeof o ? (r--, o) : void 0, s && Jt(n[0], n[1], s) && (o = r < 3 ? void 0 : o, r = 1), e = Object(e); ++i < r;) {
          var a = n[i];
          a && t(e, a, i, o);
        }
        return e;
      });
    }
    function Gt(t) {
      return function (e, n, i) {
        for (var r = -1, o = Object(e), s = i(e), a = s.length; a--;) {
          var l = s[t ? a : ++r];
          if (!1 === n(o[l], l, o)) break;
        }
        return e;
      };
    }
    function Wt(t, e) {
      var n = t.__data__;
      return Kt(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    }
    function Ht(t, e) {
      var n = S(t, e);
      return Nt(n) ? n : void 0;
    }
    function Xt(t) {
      var e = L.call(t, W),
        n = t[W];
      try {
        t[W] = void 0;
        var i = !0;
      } catch (t) {}
      var r = O.call(t);
      return i && (e ? t[W] = n : delete t[W]), r;
    }
    function Yt(t) {
      return "function" != typeof t.constructor || $t(t) ? {} : Q(z(t));
    }
    function Zt(t, e) {
      var n = typeof t;
      return !!(e = null == e ? i : e) && ("number" == n || "symbol" != n && l.test(t)) && t > -1 && t % 1 == 0 && t < e;
    }
    function Jt(t, e, n) {
      if (!me(n)) return !1;
      var i = typeof e;
      return !!("number" == i ? he(n) && Zt(e, n.length) : "string" == i && e in n) && ae(n[e], t);
    }
    function Kt(t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    }
    function Qt(t) {
      return !!R && R in t;
    }
    function $t(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || C);
    }
    function te(t) {
      var e = [];
      if (null != t) for (var n in Object(t)) e.push(n);
      return e;
    }
    function ee(t) {
      return O.call(t);
    }
    function ne(t, e, n) {
      return e = Y(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var i = arguments, r = -1, o = Y(i.length - e, 0), s = Array(o); ++r < o;) s[r] = i[e + r];
        r = -1;
        for (var a = Array(e + 1); ++r < e;) a[r] = i[r];
        return a[e] = n(s), x(t, this, a);
      };
    }
    function ie(t, e) {
      if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
    }
    u(Ft, "cloneBuffer"), u(Ut, "cloneArrayBuffer"), u(Bt, "cloneTypedArray"), u(zt, "copyArray"), u(Vt, "copyObject"), u(jt, "createAssigner"), u(Gt, "createBaseFor"), u(Wt, "getMapData"), u(Ht, "getNative"), u(Xt, "getRawTag"), u(Yt, "initCloneObject"), u(Zt, "isIndex"), u(Jt, "isIterateeCall"), u(Kt, "isKeyable"), u(Qt, "isMasked"), u($t, "isPrototype"), u(te, "nativeKeysIn"), u(ee, "objectToString"), u(ne, "overRest"), u(ie, "safeGet");
    var re = oe(kt);
    function oe(t) {
      var e = 0,
        n = 0;
      return function () {
        var i = Z(),
          r = 16 - (i - n);
        if (n = i, r > 0) {
          if (++e >= 800) return arguments[0];
        } else e = 0;
        return t.apply(void 0, arguments);
      };
    }
    function se(t) {
      if (null != t) {
        try {
          return N.call(t);
        } catch (t) {}
        try {
          return t + "";
        } catch (t) {}
      }
      return "";
    }
    function ae(t, e) {
      return t === e || t != t && e != e;
    }
    u(oe, "shortOut"), u(se, "toSource"), u(ae, "eq");
    var le = It(function () {
        return arguments;
      }()) ? It : function (t) {
        return ge(t) && L.call(t, "callee") && !j.call(t, "callee");
      },
      ue = Array.isArray;
    function he(t) {
      return null != t && fe(t.length) && !de(t);
    }
    function ce(t) {
      return ge(t) && he(t);
    }
    u(he, "isArrayLike"), u(ce, "isArrayLikeObject");
    var pe = X || Se;
    function de(t) {
      if (!me(t)) return !1;
      var e = Ct(t);
      return e == o || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    }
    function fe(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= i;
    }
    function me(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    }
    function ge(t) {
      return null != t && "object" == typeof t;
    }
    function ve(t) {
      if (!ge(t) || Ct(t) != s) return !1;
      var e = z(t);
      if (null === e) return !0;
      var n = L.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && N.call(n) == q;
    }
    u(de, "isFunction"), u(fe, "isLength"), u(me, "isObject"), u(ge, "isObjectLike"), u(ve, "isPlainObject");
    var ye = _ ? w(_) : Lt;
    function _e(t) {
      return Vt(t, xe(t));
    }
    function xe(t) {
      return he(t) ? wt(t, !0) : Rt(t);
    }
    u(_e, "toPlainObject"), u(xe, "keysIn");
    var Ee = jt(function (t, e, n) {
      Ot(t, e, n);
    });
    function be(t) {
      return function () {
        return t;
      };
    }
    function we(t) {
      return t;
    }
    function Se() {
      return !1;
    }
    u(be, "constant"), u(we, "identity"), u(Se, "stubFalse"), e.exports = Ee;
  }),
  aR = ze((t, e) => {
    E(), function (n, i) {
      "use strict";

      var r = "function",
        o = "undefined",
        s = "object",
        a = "string",
        l = "model",
        h = "name",
        c = "type",
        p = "vendor",
        d = "version",
        f = "architecture",
        m = "console",
        g = "mobile",
        v = "tablet",
        y = "smarttv",
        _ = "wearable",
        x = "embedded",
        E = "Amazon",
        b = "Apple",
        w = "ASUS",
        S = "BlackBerry",
        M = "Browser",
        T = "Chrome",
        A = "Firefox",
        P = "Google",
        C = "Huawei",
        I = "LG",
        N = "Microsoft",
        L = "Motorola",
        R = "Opera",
        O = "Samsung",
        q = "Sharp",
        D = "Sony",
        k = "Xiaomi",
        F = "Zebra",
        U = "Facebook",
        B = u(function (t, e) {
          var n = {};
          for (var i in t) e[i] && e[i].length % 2 == 0 ? n[i] = e[i].concat(t[i]) : n[i] = t[i];
          return n;
        }, "extend"),
        z = u(function (t) {
          for (var e = {}, n = 0; n < t.length; n++) e[t[n].toUpperCase()] = t[n];
          return e;
        }, "enumerize"),
        V = u(function (t, e) {
          return typeof t === a && -1 !== j(e).indexOf(j(t));
        }, "has"),
        j = u(function (t) {
          return t.toLowerCase();
        }, "lowerize"),
        G = u(function (t) {
          return typeof t === a ? t.replace(/[^\d\.]/g, "").split(".")[0] : i;
        }, "majorize"),
        W = u(function (t, e) {
          if (typeof t === a) return t = t.replace(/^\s\s*/, ""), typeof e === o ? t : t.substring(0, 350);
        }, "trim"),
        H = u(function (t, e) {
          for (var n, o, a, l, u, h, c = 0; c < e.length && !u;) {
            var p = e[c],
              d = e[c + 1];
            for (n = o = 0; n < p.length && !u;) if (u = p[n++].exec(t)) for (a = 0; a < d.length; a++) h = u[++o], typeof (l = d[a]) === s && l.length > 0 ? 2 === l.length ? typeof l[1] == r ? this[l[0]] = l[1].call(this, h) : this[l[0]] = l[1] : 3 === l.length ? typeof l[1] !== r || l[1].exec && l[1].test ? this[l[0]] = h ? h.replace(l[1], l[2]) : i : this[l[0]] = h ? l[1].call(this, h, l[2]) : i : 4 === l.length && (this[l[0]] = h ? l[3].call(this, h.replace(l[1], l[2])) : i) : this[l] = h || i;
            c += 2;
          }
        }, "rgxMapper"),
        X = u(function (t, e) {
          for (var n in e) if (typeof e[n] === s && e[n].length > 0) {
            for (var r = 0; r < e[n].length; r++) if (V(e[n][r], t)) return "?" === n ? i : n;
          } else if (V(e[n], t)) return "?" === n ? i : n;
          return t;
        }, "strMapper"),
        Y = {
          ME: "4.90",
          "NT 3.11": "NT3.51",
          "NT 4.0": "NT4.0",
          2e3: "NT 5.0",
          XP: ["NT 5.1", "NT 5.2"],
          Vista: "NT 6.0",
          7: "NT 6.1",
          8: "NT 6.2",
          8.1: "NT 6.3",
          10: ["NT 6.4", "NT 10.0"],
          RT: "ARM"
        },
        Z = {
          browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [d, [h, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [d, [h, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [h, d], [/opios[\/ ]+([\w\.]+)/i], [d, [h, R + " Mini"]], [/\bopr\/([\w\.]+)/i], [d, [h, R]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, /(ba?idubrowser)[\/ ]?([\w\.]+)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(weibo)__([\d\.]+)/i], [h, d], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [d, [h, "UC" + M]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i], [d, [h, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [d, [h, "WeChat"]], [/konqueror\/([\w\.]+)/i], [d, [h, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [d, [h, "IE"]], [/yabrowser\/([\w\.]+)/i], [d, [h, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[h, /(.+)/, "$1 Secure " + M], d], [/\bfocus\/([\w\.]+)/i], [d, [h, A + " Focus"]], [/\bopt\/([\w\.]+)/i], [d, [h, R + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [d, [h, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [d, [h, "Dolphin"]], [/coast\/([\w\.]+)/i], [d, [h, R + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [d, [h, "MIUI " + M]], [/fxios\/([-\w\.]+)/i], [d, [h, A]], [/\bqihu|(qi?ho?o?|360)browser/i], [[h, "360 " + M]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[h, /(.+)/, "$1 " + M], d], [/(comodo_dragon)\/([\w\.]+)/i], [[h, /_/g, " "], d], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i], [h, d], [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i, /\[(linkedin)app\]/i], [h], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[h, U], d], [/safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/ ]([-\w\.]+)/i], [h, d], [/\bgsa\/([\w\.]+) .*safari\//i], [d, [h, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [d, [h, T + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[h, T + " WebView"], d], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [d, [h, "Android " + M]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [h, d], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [d, [h, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [d, h], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [h, [d, X, {
            "1.0": "/8",
            1.2: "/1",
            1.3: "/3",
            "2.0": "/412",
            "2.0.2": "/416",
            "2.0.3": "/417",
            "2.0.4": "/419",
            "?": "/"
          }]], [/(webkit|khtml)\/([\w\.]+)/i], [h, d], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[h, "Netscape"], d], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [d, [h, A + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i], [h, d], [/(cobalt)\/([\w\.]+)/i], [h, [d, /master.|lts./, ""]]],
          cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[f, "amd64"]], [/(ia32(?=;))/i], [[f, j]], [/((?:i[346]|x)86)[;\)]/i], [[f, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[f, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[f, "armhf"]], [/windows (ce|mobile); ppc;/i], [[f, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[f, /ower/, "", j]], [/(sun4\w)[;\)]/i], [[f, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[f, j]]],
          device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [l, [p, O], [c, v]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [l, [p, O], [c, g]], [/\((ip(?:hone|od)[\w ]*);/i], [l, [p, b], [c, g]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [l, [p, b], [c, v]], [/(macintosh);/i], [l, [p, b]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [l, [p, C], [c, v]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [l, [p, C], [c, g]], [/\b(poco[\w ]+)(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[l, /_/g, " "], [p, k], [c, g]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[l, /_/g, " "], [p, k], [c, v]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [l, [p, "OPPO"], [c, g]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [l, [p, "Vivo"], [c, g]], [/\b(rmx[12]\d{3})(?: bui|;|\))/i], [l, [p, "Realme"], [c, g]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [l, [p, L], [c, g]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [l, [p, L], [c, v]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [l, [p, I], [c, v]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [l, [p, I], [c, g]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [l, [p, "Lenovo"], [c, v]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[l, /_/g, " "], [p, "Nokia"], [c, g]], [/(pixel c)\b/i], [l, [p, P], [c, v]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [l, [p, P], [c, g]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [l, [p, D], [c, g]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[l, "Xperia Tablet"], [p, D], [c, v]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [l, [p, "OnePlus"], [c, g]], [/(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [l, [p, E], [c, v]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[l, /(.+)/g, "Fire Phone $1"], [p, E], [c, g]], [/(playbook);[-\w\),; ]+(rim)/i], [l, p, [c, v]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [l, [p, S], [c, g]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [l, [p, w], [c, v]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [l, [p, w], [c, g]], [/(nexus 9)/i], [l, [p, "HTC"], [c, v]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i], [p, [l, /_/g, " "], [c, g]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [l, [p, "Acer"], [c, v]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [l, [p, "Meizu"], [c, g]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [l, [p, q], [c, g]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [p, l, [c, g]], [/(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [p, l, [c, v]], [/(surface duo)/i], [l, [p, N], [c, v]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [l, [p, "Fairphone"], [c, g]], [/(u304aa)/i], [l, [p, "AT&T"], [c, g]], [/\bsie-(\w*)/i], [l, [p, "Siemens"], [c, g]], [/\b(rct\w+) b/i], [l, [p, "RCA"], [c, v]], [/\b(venue[\d ]{2,7}) b/i], [l, [p, "Dell"], [c, v]], [/\b(q(?:mv|ta)\w+) b/i], [l, [p, "Verizon"], [c, v]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [l, [p, "Barnes & Noble"], [c, v]], [/\b(tm\d{3}\w+) b/i], [l, [p, "NuVision"], [c, v]], [/\b(k88) b/i], [l, [p, "ZTE"], [c, v]], [/\b(nx\d{3}j) b/i], [l, [p, "ZTE"], [c, g]], [/\b(gen\d{3}) b.+49h/i], [l, [p, "Swiss"], [c, g]], [/\b(zur\d{3}) b/i], [l, [p, "Swiss"], [c, v]], [/\b((zeki)?tb.*\b) b/i], [l, [p, "Zeki"], [c, v]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[p, "Dragon Touch"], l, [c, v]], [/\b(ns-?\w{0,9}) b/i], [l, [p, "Insignia"], [c, v]], [/\b((nxa|next)-?\w{0,9}) b/i], [l, [p, "NextBook"], [c, v]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[p, "Voice"], l, [c, g]], [/\b(lvtel\-)?(v1[12]) b/i], [[p, "LvTel"], l, [c, g]], [/\b(ph-1) /i], [l, [p, "Essential"], [c, g]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [l, [p, "Envizen"], [c, v]], [/\b(trio[-\w\. ]+) b/i], [l, [p, "MachSpeed"], [c, v]], [/\btu_(1491) b/i], [l, [p, "Rotor"], [c, v]], [/(shield[\w ]+) b/i], [l, [p, "Nvidia"], [c, v]], [/(sprint) (\w+)/i], [p, l, [c, g]], [/(kin\.[onetw]{3})/i], [[l, /\./g, " "], [p, N], [c, g]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [l, [p, F], [c, v]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [l, [p, F], [c, g]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [p, l, [c, m]], [/droid.+; (shield) bui/i], [l, [p, "Nvidia"], [c, m]], [/(playstation [345portablevi]+)/i], [l, [p, D], [c, m]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [l, [p, N], [c, m]], [/smart-tv.+(samsung)/i], [p, [c, y]], [/hbbtv.+maple;(\d+)/i], [[l, /^/, "SmartTV"], [p, O], [c, y]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[p, I], [c, y]], [/(apple) ?tv/i], [p, [l, b + " TV"], [c, y]], [/crkey/i], [[l, T + "cast"], [p, P], [c, y]], [/droid.+aft(\w)( bui|\))/i], [l, [p, E], [c, y]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [l, [p, q], [c, y]], [/(bravia[\w ]+)( bui|\))/i], [l, [p, D], [c, y]], [/(mitv-\w{5}) bui/i], [l, [p, k], [c, y]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i], [[p, W], [l, W], [c, y]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[c, y]], [/((pebble))app/i], [p, l, [c, _]], [/droid.+; (glass) \d/i], [l, [p, P], [c, _]], [/droid.+; (wt63?0{2,3})\)/i], [l, [p, F], [c, _]], [/(quest( 2)?)/i], [l, [p, U], [c, _]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [p, [c, x]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i], [l, [c, g]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [l, [c, v]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[c, v]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[c, g]], [/(android[-\w\. ]{0,9});.+buil/i], [l, [p, "Generic"]]],
          engine: [[/windows.+ edge\/([\w\.]+)/i], [d, [h, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [d, [h, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i], [h, d], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [d, h]],
          os: [[/microsoft (windows) (vista|xp)/i], [h, d], [/(windows) nt 6\.2; (arm)/i, /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [h, [d, X, Y]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[h, "Windows"], [d, X, Y]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /cfnetwork\/.+darwin/i], [[d, /_/g, "."], [h, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[h, "Mac OS"], [d, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [d, h], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [h, d], [/\(bb(10);/i], [d, [h, S]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [d, [h, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [d, [h, A + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [d, [h, "webOS"]], [/crkey\/([\d\.]+)/i], [d, [h, T + "cast"]], [/(cros) [\w]+ ([\w\.]+\w)/i], [[h, "Chromium OS"], d], [/(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [h, d], [/(sunos) ?([\w\.\d]*)/i], [[h, "Solaris"], d], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, /(unix) ?([\w\.]*)/i], [h, d]]
        },
        J = u(function (t, e) {
          if (typeof t === s && (e = t, t = i), !(this instanceof J)) return new J(t, e).getResult();
          var r = t || (typeof n !== o && n.navigator && n.navigator.userAgent ? n.navigator.userAgent : ""),
            u = e ? B(Z, e) : Z;
          return this.getBrowser = function () {
            var t = {};
            return t[h] = i, t[d] = i, H.call(t, r, u.browser), t.major = G(t.version), t;
          }, this.getCPU = function () {
            var t = {};
            return t[f] = i, H.call(t, r, u.cpu), t;
          }, this.getDevice = function () {
            var t = {};
            return t[p] = i, t[l] = i, t[c] = i, H.call(t, r, u.device), t;
          }, this.getEngine = function () {
            var t = {};
            return t[h] = i, t[d] = i, H.call(t, r, u.engine), t;
          }, this.getOS = function () {
            var t = {};
            return t[h] = i, t[d] = i, H.call(t, r, u.os), t;
          }, this.getResult = function () {
            return {
              ua: this.getUA(),
              browser: this.getBrowser(),
              engine: this.getEngine(),
              os: this.getOS(),
              device: this.getDevice(),
              cpu: this.getCPU()
            };
          }, this.getUA = function () {
            return r;
          }, this.setUA = function (t) {
            return r = typeof t === a && t.length > 350 ? W(t, 350) : t, this;
          }, this.setUA(r), this;
        }, "UAParser");
      J.VERSION = "0.7.33", J.BROWSER = z([h, d, "major"]), J.CPU = z([f]), J.DEVICE = z([l, p, c, m, g, y, v, _, x]), J.ENGINE = J.OS = z([h, d]), typeof t !== o ? (typeof e !== o && e.exports && (t = e.exports = J), t.UAParser = J) : typeof define === r && define.amd ? define(function () {
        return J;
      }) : typeof n !== o && (n.UAParser = J);
      var K = typeof n !== o && (n.jQuery || n.Zepto);
      if (K && !K.ua) {
        var Q = new J();
        K.ua = Q.getResult(), K.ua.get = function () {
          return Q.getUA();
        }, K.ua.set = function (t) {
          Q.setUA(t);
          var e = Q.getResult();
          for (var n in e) K.ua[n] = e[n];
        };
      }
    }("object" == typeof window ? window : t);
  }),
  uM = ze((t, e) => {
    E();
    var n = Object.getOwnPropertySymbols,
      i = Object.prototype.hasOwnProperty,
      r = Object.prototype.propertyIsEnumerable;
    function o(t) {
      if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(t);
    }
    function s() {
      try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;
        for (var e = {}, n = 0; n < 10; n++) e["_" + String.fromCharCode(n)] = n;
        if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
          return e[t];
        }).join("")) return !1;
        var i = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (t) {
          i[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
      } catch (t) {
        return !1;
      }
    }
    u(o, "toObject"), u(s, "shouldUseNative"), e.exports = s() ? Object.assign : function (t, e) {
      for (var s, a, l = o(t), u = 1; u < arguments.length; u++) {
        for (var h in s = Object(arguments[u])) i.call(s, h) && (l[h] = s[h]);
        if (n) {
          a = n(s);
          for (var c = 0; c < a.length; c++) r.call(s, a[c]) && (l[a[c]] = s[a[c]]);
        }
      }
      return l;
    };
  }),
  TR = ze((t, e) => {
    var n, i;
    E(), n = t, i = function () {
      "use strict";

      function t(t, i, r, o, s) {
        u(function t(n, i, r, o, s) {
          for (; o > r;) {
            if (o - r > 600) {
              var a = o - r + 1,
                l = i - r + 1,
                u = Math.log(a),
                h = .5 * Math.exp(2 * u / 3),
                c = .5 * Math.sqrt(u * h * (a - h) / a) * (l - a / 2 < 0 ? -1 : 1);
              t(n, i, Math.max(r, Math.floor(i - l * h / a + c)), Math.min(o, Math.floor(i + (a - l) * h / a + c)), s);
            }
            var p = n[i],
              d = r,
              f = o;
            for (e(n, r, i), s(n[o], p) > 0 && e(n, r, o); d < f;) {
              for (e(n, d, f), d++, f--; s(n[d], p) < 0;) d++;
              for (; s(n[f], p) > 0;) f--;
            }
            0 === s(n[r], p) ? e(n, r, f) : e(n, ++f, o), f <= i && (r = f + 1), i <= f && (o = f - 1);
          }
        }, "t")(t, i, r || 0, o || t.length - 1, s || n);
      }
      function e(t, e, n) {
        var i = t[e];
        t[e] = t[n], t[n] = i;
      }
      function n(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
      }
      u(t, "t"), u(e, "i"), u(n, "n");
      var i = u(function (t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
      }, "r");
      function r(t, e, n) {
        if (!n) return e.indexOf(t);
        for (var i = 0; i < e.length; i++) if (n(t, e[i])) return i;
        return -1;
      }
      function o(t, e) {
        s(t, 0, t.children.length, e, t);
      }
      function s(t, e, n, i, r) {
        r || (r = m(null)), r.minX = 1 / 0, r.minY = 1 / 0, r.maxX = -1 / 0, r.maxY = -1 / 0;
        for (var o = e; o < n; o++) {
          var s = t.children[o];
          a(r, t.leaf ? i(s) : s);
        }
        return r;
      }
      function a(t, e) {
        return t.minX = Math.min(t.minX, e.minX), t.minY = Math.min(t.minY, e.minY), t.maxX = Math.max(t.maxX, e.maxX), t.maxY = Math.max(t.maxY, e.maxY), t;
      }
      function l(t, e) {
        return t.minX - e.minX;
      }
      function h(t, e) {
        return t.minY - e.minY;
      }
      function c(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
      }
      function p(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
      }
      function d(t, e) {
        return t.minX <= e.minX && t.minY <= e.minY && e.maxX <= t.maxX && e.maxY <= t.maxY;
      }
      function f(t, e) {
        return e.minX <= t.maxX && e.minY <= t.maxY && e.maxX >= t.minX && e.maxY >= t.minY;
      }
      function m(t) {
        return {
          children: t,
          height: 1,
          leaf: !0,
          minX: 1 / 0,
          minY: 1 / 0,
          maxX: -1 / 0,
          maxY: -1 / 0
        };
      }
      function g(e, n, i, r, o) {
        for (var s = [n, i]; s.length;) if (!((i = s.pop()) - (n = s.pop()) <= r)) {
          var a = n + Math.ceil((i - n) / r / 2) * r;
          t(e, a, n, i, o), s.push(n, a, a, i);
        }
      }
      return u(r, "e"), u(o, "a"), u(s, "h"), u(a, "o"), u(l, "s"), u(h, "l"), u(c, "f"), u(p, "u"), u(d, "m"), u(f, "c"), u(m, "p"), u(g, "d"), i.prototype.all = function () {
        return this._all(this.data, []);
      }, i.prototype.search = function (t) {
        var e = this.data,
          n = [];
        if (!f(t, e)) return n;
        for (var i = this.toBBox, r = []; e;) {
          for (var o = 0; o < e.children.length; o++) {
            var s = e.children[o],
              a = e.leaf ? i(s) : s;
            f(t, a) && (e.leaf ? n.push(s) : d(t, a) ? this._all(s, n) : r.push(s));
          }
          e = r.pop();
        }
        return n;
      }, i.prototype.collides = function (t) {
        var e = this.data;
        if (!f(t, e)) return !1;
        for (var n = []; e;) {
          for (var i = 0; i < e.children.length; i++) {
            var r = e.children[i],
              o = e.leaf ? this.toBBox(r) : r;
            if (f(t, o)) {
              if (e.leaf || d(t, o)) return !0;
              n.push(r);
            }
          }
          e = n.pop();
        }
        return !1;
      }, i.prototype.load = function (t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
          for (var e = 0; e < t.length; e++) this.insert(t[e]);
          return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
          if (this.data.height === n.height) this._splitRoot(this.data, n);else {
            if (this.data.height < n.height) {
              var i = this.data;
              this.data = n, n = i;
            }
            this._insert(n, this.data.height - n.height - 1, !0);
          }
        } else this.data = n;
        return this;
      }, i.prototype.insert = function (t) {
        return t && this._insert(t, this.data.height - 1), this;
      }, i.prototype.clear = function () {
        return this.data = m([]), this;
      }, i.prototype.remove = function (t, e) {
        if (!t) return this;
        for (var n, i, o, s = this.data, a = this.toBBox(t), l = [], u = []; s || l.length;) {
          if (s || (s = l.pop(), i = l[l.length - 1], n = u.pop(), o = !0), s.leaf) {
            var h = r(t, s.children, e);
            if (-1 !== h) return s.children.splice(h, 1), l.push(s), this._condense(l), this;
          }
          o || s.leaf || !d(s, a) ? i ? (n++, s = i.children[n], o = !1) : s = null : (l.push(s), u.push(n), n = 0, i = s, s = s.children[0]);
        }
        return this;
      }, i.prototype.toBBox = function (t) {
        return t;
      }, i.prototype.compareMinX = function (t, e) {
        return t.minX - e.minX;
      }, i.prototype.compareMinY = function (t, e) {
        return t.minY - e.minY;
      }, i.prototype.toJSON = function () {
        return this.data;
      }, i.prototype.fromJSON = function (t) {
        return this.data = t, this;
      }, i.prototype._all = function (t, e) {
        for (var n = []; t;) t.leaf ? e.push.apply(e, t.children) : n.push.apply(n, t.children), t = n.pop();
        return e;
      }, i.prototype._build = function (t, e, n, i) {
        var r,
          s = n - e + 1,
          a = this._maxEntries;
        if (s <= a) return o(r = m(t.slice(e, n + 1)), this.toBBox), r;
        i || (i = Math.ceil(Math.log(s) / Math.log(a)), a = Math.ceil(s / Math.pow(a, i - 1))), (r = m([])).leaf = !1, r.height = i;
        var l = Math.ceil(s / a),
          u = l * Math.ceil(Math.sqrt(a));
        g(t, e, n, u, this.compareMinX);
        for (var h = e; h <= n; h += u) {
          var c = Math.min(h + u - 1, n);
          g(t, h, c, l, this.compareMinY);
          for (var p = h; p <= c; p += l) {
            var d = Math.min(p + l - 1, c);
            r.children.push(this._build(t, p, d, i - 1));
          }
        }
        return o(r, this.toBBox), r;
      }, i.prototype._chooseSubtree = function (t, e, n, i) {
        for (; i.push(e), !e.leaf && i.length - 1 !== n;) {
          for (var r = 1 / 0, o = 1 / 0, s = void 0, a = 0; a < e.children.length; a++) {
            var l = e.children[a],
              u = c(l),
              h = (p = t, d = l, (Math.max(d.maxX, p.maxX) - Math.min(d.minX, p.minX)) * (Math.max(d.maxY, p.maxY) - Math.min(d.minY, p.minY)) - u);
            h < o ? (o = h, r = u < r ? u : r, s = l) : h === o && u < r && (r = u, s = l);
          }
          e = s || e.children[0];
        }
        var p, d;
        return e;
      }, i.prototype._insert = function (t, e, n) {
        var i = n ? t : this.toBBox(t),
          r = [],
          o = this._chooseSubtree(i, this.data, e, r);
        for (o.children.push(t), a(o, i); e >= 0 && r[e].children.length > this._maxEntries;) this._split(r, e), e--;
        this._adjustParentBBoxes(i, r, e);
      }, i.prototype._split = function (t, e) {
        var n = t[e],
          i = n.children.length,
          r = this._minEntries;
        this._chooseSplitAxis(n, r, i);
        var s = this._chooseSplitIndex(n, r, i),
          a = m(n.children.splice(s, n.children.length - s));
        a.height = n.height, a.leaf = n.leaf, o(n, this.toBBox), o(a, this.toBBox), e ? t[e - 1].children.push(a) : this._splitRoot(n, a);
      }, i.prototype._splitRoot = function (t, e) {
        this.data = m([t, e]), this.data.height = t.height + 1, this.data.leaf = !1, o(this.data, this.toBBox);
      }, i.prototype._chooseSplitIndex = function (t, e, n) {
        for (var i, r, o, a, l, u, h, p = 1 / 0, d = 1 / 0, f = e; f <= n - e; f++) {
          var m = s(t, 0, f, this.toBBox),
            g = s(t, f, n, this.toBBox),
            v = (r = m, o = g, a = Math.max(r.minX, o.minX), l = Math.max(r.minY, o.minY), u = Math.min(r.maxX, o.maxX), h = Math.min(r.maxY, o.maxY), Math.max(0, u - a) * Math.max(0, h - l)),
            y = c(m) + c(g);
          v < p ? (p = v, i = f, d = y < d ? y : d) : v === p && y < d && (d = y, i = f);
        }
        return i || n - e;
      }, i.prototype._chooseSplitAxis = function (t, e, n) {
        var i = t.leaf ? this.compareMinX : l,
          r = t.leaf ? this.compareMinY : h;
        this._allDistMargin(t, e, n, i) < this._allDistMargin(t, e, n, r) && t.children.sort(i);
      }, i.prototype._allDistMargin = function (t, e, n, i) {
        t.children.sort(i);
        for (var r = this.toBBox, o = s(t, 0, e, r), l = s(t, n - e, n, r), u = p(o) + p(l), h = e; h < n - e; h++) {
          var c = t.children[h];
          a(o, t.leaf ? r(c) : c), u += p(o);
        }
        for (var d = n - e - 1; d >= e; d--) {
          var f = t.children[d];
          a(l, t.leaf ? r(f) : f), u += p(l);
        }
        return u;
      }, i.prototype._adjustParentBBoxes = function (t, e, n) {
        for (var i = n; i >= 0; i--) a(e[i], t);
      }, i.prototype._condense = function (t) {
        for (var e = t.length - 1, n = void 0; e >= 0; e--) 0 === t[e].children.length ? e > 0 ? (n = t[e - 1].children).splice(n.indexOf(t[e]), 1) : this.clear() : o(t[e], this.toBBox);
      }, i;
    }, "object" == typeof t && void 0 !== e ? e.exports = i() : "function" == typeof define && define.amd ? define(i) : (n = n || self).RBush = i();
  }),
  PR = ze((t, e) => {
    var n, i;
    E(), n = t, i = function () {
      "use strict";

      var t = u(function (t, n) {
        if (void 0 === t && (t = []), void 0 === n && (n = e), this.data = t, this.length = this.data.length, this.compare = n, this.length > 0) for (var i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
      }, "TinyQueue");
      function e(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
      }
      return t.prototype.push = u(function (t) {
        this.data.push(t), this.length++, this._up(this.length - 1);
      }, "push"), t.prototype.pop = u(function () {
        if (0 !== this.length) {
          var t = this.data[0],
            e = this.data.pop();
          return this.length--, this.length > 0 && (this.data[0] = e, this._down(0)), t;
        }
      }, "pop"), t.prototype.peek = u(function () {
        return this.data[0];
      }, "peek"), t.prototype._up = u(function (t) {
        for (var e = this.data, n = this.compare, i = e[t]; t > 0;) {
          var r = t - 1 >> 1,
            o = e[r];
          if (n(i, o) >= 0) break;
          e[t] = o, t = r;
        }
        e[t] = i;
      }, "_up"), t.prototype._down = u(function (t) {
        for (var e = this.data, n = this.compare, i = this.length >> 1, r = e[t]; t < i;) {
          var o = 1 + (t << 1),
            s = e[o],
            a = o + 1;
          if (a < this.length && n(e[a], s) < 0 && (o = a, s = e[a]), n(s, r) >= 0) break;
          e[t] = s, t = o;
        }
        e[t] = r;
      }, "_down"), u(e, "defaultCompare"), t;
    }, "object" == typeof t && void 0 !== e ? e.exports = i() : "function" == typeof define && define.amd ? define(i) : (n = n || self).TinyQueue = i();
  }),
  AR = ze((t, e) => {
    E(), e.exports = u(function (t, e, n, i) {
      var r = t[0],
        o = t[1],
        s = !1;
      void 0 === n && (n = 0), void 0 === i && (i = e.length);
      for (var a = (i - n) / 2, l = 0, u = a - 1; l < a; u = l++) {
        var h = e[n + 2 * l + 0],
          c = e[n + 2 * l + 1],
          p = e[n + 2 * u + 0],
          d = e[n + 2 * u + 1];
        c > o != d > o && r < (p - h) * (o - c) / (d - c) + h && (s = !s);
      }
      return s;
    }, "pointInPolygonFlat");
  }),
  LR = ze((t, e) => {
    E(), e.exports = u(function (t, e, n, i) {
      var r = t[0],
        o = t[1],
        s = !1;
      void 0 === n && (n = 0), void 0 === i && (i = e.length);
      for (var a = i - n, l = 0, u = a - 1; l < a; u = l++) {
        var h = e[l + n][0],
          c = e[l + n][1],
          p = e[u + n][0],
          d = e[u + n][1];
        c > o != d > o && r < (p - h) * (o - c) / (d - c) + h && (s = !s);
      }
      return s;
    }, "pointInPolygonNested");
  }),
  NR = ze((t, e) => {
    E();
    var n = AR(),
      i = LR();
    e.exports = u(function (t, e, r, o) {
      return e.length > 0 && Array.isArray(e[0]) ? i(t, e, r, o) : n(t, e, r, o);
    }, "pointInPolygon"), e.exports.nested = i, e.exports.flat = n;
  }),
  qR = ze((t, e) => {
    var n, i;
    E(), n = t, i = function (t) {
      "use strict";

      let e = 134217729;
      function n(t, e, n, i, r) {
        let o,
          s,
          a,
          l,
          u = e[0],
          h = i[0],
          c = 0,
          p = 0;
        h > u == h > -u ? (o = u, u = e[++c]) : (o = h, h = i[++p]);
        let d = 0;
        if (c < t && p < n) for (h > u == h > -u ? (a = o - ((s = u + o) - u), u = e[++c]) : (a = o - ((s = h + o) - h), h = i[++p]), o = s, 0 !== a && (r[d++] = a); c < t && p < n;) h > u == h > -u ? (a = o - ((s = o + u) - (l = s - o)) + (u - l), u = e[++c]) : (a = o - ((s = o + h) - (l = s - o)) + (h - l), h = i[++p]), o = s, 0 !== a && (r[d++] = a);
        for (; c < t;) a = o - ((s = o + u) - (l = s - o)) + (u - l), u = e[++c], o = s, 0 !== a && (r[d++] = a);
        for (; p < n;) a = o - ((s = o + h) - (l = s - o)) + (h - l), h = i[++p], o = s, 0 !== a && (r[d++] = a);
        return 0 === o && 0 !== d || (r[d++] = o), d;
      }
      function i(t) {
        return new Float64Array(t);
      }
      u(n, "r"), u(i, "o");
      let r = i(4),
        o = i(8),
        s = i(12),
        a = i(16),
        l = i(4);
      t.orient2d = function (t, i, u, h, c, p) {
        let d = (i - p) * (u - c),
          f = (t - c) * (h - p),
          m = d - f;
        if (0 === d || 0 === f || d > 0 != f > 0) return m;
        let g = Math.abs(d + f);
        return Math.abs(m) >= 33306690738754716e-32 * g ? m : -function (t, i, u, h, c, p, d) {
          let f,
            m,
            g,
            v,
            y,
            _,
            x,
            E,
            b,
            w,
            S,
            M,
            T,
            A,
            P,
            C,
            I,
            N,
            L = t - c,
            R = u - c,
            O = i - p,
            q = h - p;
          y = (P = (E = L - (x = (_ = e * L) - (_ - L))) * (w = q - (b = (_ = e * q) - (_ - q))) - ((A = L * q) - x * b - E * b - x * w)) - (S = P - (I = (E = O - (x = (_ = e * O) - (_ - O))) * (w = R - (b = (_ = e * R) - (_ - R))) - ((C = O * R) - x * b - E * b - x * w))), r[0] = P - (S + y) + (y - I), y = (T = A - ((M = A + S) - (y = M - A)) + (S - y)) - (S = T - C), r[1] = T - (S + y) + (y - C), y = (N = M + S) - M, r[2] = M - (N - y) + (S - y), r[3] = N;
          let D = function (t, e) {
              let n = e[0];
              for (let t = 1; t < 4; t++) n += e[t];
              return n;
            }(0, r),
            k = 22204460492503146e-32 * d;
          if (D >= k || -D >= k || (f = t - (L + (y = t - L)) + (y - c), g = u - (R + (y = u - R)) + (y - c), m = i - (O + (y = i - O)) + (y - p), v = h - (q + (y = h - q)) + (y - p), 0 === f && 0 === m && 0 === g && 0 === v) || (k = 11093356479670487e-47 * d + 33306690738754706e-32 * Math.abs(D), (D += L * v + q * f - (O * g + R * m)) >= k || -D >= k)) return D;
          y = (P = (E = f - (x = (_ = e * f) - (_ - f))) * (w = q - (b = (_ = e * q) - (_ - q))) - ((A = f * q) - x * b - E * b - x * w)) - (S = P - (I = (E = m - (x = (_ = e * m) - (_ - m))) * (w = R - (b = (_ = e * R) - (_ - R))) - ((C = m * R) - x * b - E * b - x * w))), l[0] = P - (S + y) + (y - I), y = (T = A - ((M = A + S) - (y = M - A)) + (S - y)) - (S = T - C), l[1] = T - (S + y) + (y - C), y = (N = M + S) - M, l[2] = M - (N - y) + (S - y), l[3] = N;
          let F = n(4, r, 4, l, o);
          y = (P = (E = L - (x = (_ = e * L) - (_ - L))) * (w = v - (b = (_ = e * v) - (_ - v))) - ((A = L * v) - x * b - E * b - x * w)) - (S = P - (I = (E = O - (x = (_ = e * O) - (_ - O))) * (w = g - (b = (_ = e * g) - (_ - g))) - ((C = O * g) - x * b - E * b - x * w))), l[0] = P - (S + y) + (y - I), y = (T = A - ((M = A + S) - (y = M - A)) + (S - y)) - (S = T - C), l[1] = T - (S + y) + (y - C), y = (N = M + S) - M, l[2] = M - (N - y) + (S - y), l[3] = N;
          let U = n(F, o, 4, l, s);
          y = (P = (E = f - (x = (_ = e * f) - (_ - f))) * (w = v - (b = (_ = e * v) - (_ - v))) - ((A = f * v) - x * b - E * b - x * w)) - (S = P - (I = (E = m - (x = (_ = e * m) - (_ - m))) * (w = g - (b = (_ = e * g) - (_ - g))) - ((C = m * g) - x * b - E * b - x * w))), l[0] = P - (S + y) + (y - I), y = (T = A - ((M = A + S) - (y = M - A)) + (S - y)) - (S = T - C), l[1] = T - (S + y) + (y - C), y = (N = M + S) - M, l[2] = M - (N - y) + (S - y), l[3] = N;
          let B = n(U, s, 4, l, a);
          return a[B - 1];
        }(t, i, u, h, c, p, g);
      }, t.orient2dfast = function (t, e, n, i, r, o) {
        return (e - o) * (n - r) - (t - r) * (i - o);
      }, Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, "object" == typeof t && void 0 !== e ? i(t) : "function" == typeof define && define.amd ? define(["exports"], i) : i((n = n || self).predicates = {});
  }),
  VR = ze((t, e) => {
    E();
    var n = TR(),
      i = PR(),
      r = NR(),
      o = qR().orient2d;
    function s(t, e, i) {
      e = Math.max(0, void 0 === e ? 2 : e), i = i || 0;
      var r = g(t),
        o = new n(16);
      o.toBBox = function (t) {
        return {
          minX: t[0],
          minY: t[1],
          maxX: t[0],
          maxY: t[1]
        };
      }, o.compareMinX = function (t, e) {
        return t[0] - e[0];
      }, o.compareMinY = function (t, e) {
        return t[1] - e[1];
      }, o.load(t);
      for (var s, l = [], u = 0; u < r.length; u++) {
        var h = r[u];
        o.remove(h), s = v(h, s), l.push(s);
      }
      var c = new n(16);
      for (u = 0; u < l.length; u++) c.insert(m(l[u]));
      for (var p = e * e, d = i * i; l.length;) {
        var f = l.shift(),
          _ = f.p,
          x = f.next.p,
          E = y(_, x);
        if (!(E < d)) {
          var b = E / p;
          (h = a(o, f.prev.p, _, x, f.next.next.p, b, c)) && Math.min(y(h, _), y(h, x)) <= b && (l.push(f), l.push(v(h, f)), o.remove(h), c.remove(f), c.insert(m(f)), c.insert(m(f.next)));
        }
      }
      f = s;
      var w = [];
      do {
        w.push(f.p), f = f.next;
      } while (f !== s);
      return w.push(f.p), w;
    }
    function a(t, e, n, r, o, s, a) {
      for (var u = new i([], l), c = t.data; c;) {
        for (var d = 0; d < c.children.length; d++) {
          var f = c.children[d],
            m = c.leaf ? _(f, n, r) : h(n, r, f);
          m > s || u.push({
            node: f,
            dist: m
          });
        }
        for (; u.length && !u.peek().node.children;) {
          var g = u.pop(),
            v = g.node,
            y = _(v, e, n),
            x = _(v, r, o);
          if (g.dist < y && g.dist < x && p(n, v, a) && p(r, v, a)) return v;
        }
        (c = u.pop()) && (c = c.node);
      }
      return null;
    }
    function l(t, e) {
      return t.dist - e.dist;
    }
    function h(t, e, n) {
      if (c(t, n) || c(e, n)) return 0;
      var i = x(t[0], t[1], e[0], e[1], n.minX, n.minY, n.maxX, n.minY);
      if (0 === i) return 0;
      var r = x(t[0], t[1], e[0], e[1], n.minX, n.minY, n.minX, n.maxY);
      if (0 === r) return 0;
      var o = x(t[0], t[1], e[0], e[1], n.maxX, n.minY, n.maxX, n.maxY);
      if (0 === o) return 0;
      var s = x(t[0], t[1], e[0], e[1], n.minX, n.maxY, n.maxX, n.maxY);
      return 0 === s ? 0 : Math.min(i, r, o, s);
    }
    function c(t, e) {
      return t[0] >= e.minX && t[0] <= e.maxX && t[1] >= e.minY && t[1] <= e.maxY;
    }
    function p(t, e, n) {
      for (var i = Math.min(t[0], e[0]), r = Math.min(t[1], e[1]), o = Math.max(t[0], e[0]), s = Math.max(t[1], e[1]), a = n.search({
          minX: i,
          minY: r,
          maxX: o,
          maxY: s
        }), l = 0; l < a.length; l++) if (f(a[l].p, a[l].next.p, t, e)) return !1;
      return !0;
    }
    function d(t, e, n) {
      return o(t[0], t[1], e[0], e[1], n[0], n[1]);
    }
    function f(t, e, n, i) {
      return t !== i && e !== n && d(t, e, n) > 0 != d(t, e, i) > 0 && d(n, i, t) > 0 != d(n, i, e) > 0;
    }
    function m(t) {
      var e = t.p,
        n = t.next.p;
      return t.minX = Math.min(e[0], n[0]), t.minY = Math.min(e[1], n[1]), t.maxX = Math.max(e[0], n[0]), t.maxY = Math.max(e[1], n[1]), t;
    }
    function g(t) {
      for (var e = t[0], n = t[0], i = t[0], o = t[0], s = 0; s < t.length; s++) {
        var a = t[s];
        a[0] < e[0] && (e = a), a[0] > i[0] && (i = a), a[1] < n[1] && (n = a), a[1] > o[1] && (o = a);
      }
      var l = [e, n, i, o],
        u = l.slice();
      for (s = 0; s < t.length; s++) r(t[s], l) || u.push(t[s]);
      return w(u);
    }
    function v(t, e) {
      var n = {
        p: t,
        prev: null,
        next: null,
        minX: 0,
        minY: 0,
        maxX: 0,
        maxY: 0
      };
      return e ? (n.next = e.next, n.prev = e, e.next.prev = n, e.next = n) : (n.prev = n, n.next = n), n;
    }
    function y(t, e) {
      var n = t[0] - e[0],
        i = t[1] - e[1];
      return n * n + i * i;
    }
    function _(t, e, n) {
      var i = e[0],
        r = e[1],
        o = n[0] - i,
        s = n[1] - r;
      if (0 !== o || 0 !== s) {
        var a = ((t[0] - i) * o + (t[1] - r) * s) / (o * o + s * s);
        a > 1 ? (i = n[0], r = n[1]) : a > 0 && (i += o * a, r += s * a);
      }
      return (o = t[0] - i) * o + (s = t[1] - r) * s;
    }
    function x(t, e, n, i, r, o, s, a) {
      var l,
        u,
        h,
        c,
        p = n - t,
        d = i - e,
        f = s - r,
        m = a - o,
        g = t - r,
        v = e - o,
        y = p * p + d * d,
        _ = p * f + d * m,
        x = f * f + m * m,
        E = p * g + d * v,
        b = f * g + m * v,
        w = y * x - _ * _,
        S = w,
        M = w;
      0 === w ? (u = 0, S = 1, c = b, M = x) : (c = y * b - _ * E, (u = _ * b - x * E) < 0 ? (u = 0, c = b, M = x) : u > S && (u = S, c = b + _, M = x)), c < 0 ? (c = 0, -E < 0 ? u = 0 : -E > y ? u = S : (u = -E, S = y)) : c > M && (c = M, -E + _ < 0 ? u = 0 : -E + _ > y ? u = S : (u = -E + _, S = y));
      var T = (1 - (h = 0 === c ? 0 : c / M)) * r + h * s - ((1 - (l = 0 === u ? 0 : u / S)) * t + l * n),
        A = (1 - h) * o + h * a - ((1 - l) * e + l * i);
      return T * T + A * A;
    }
    function b(t, e) {
      return t[0] === e[0] ? t[1] - e[1] : t[0] - e[0];
    }
    function w(t) {
      t.sort(b);
      for (var e = [], n = 0; n < t.length; n++) {
        for (; e.length >= 2 && d(e[e.length - 2], e[e.length - 1], t[n]) <= 0;) e.pop();
        e.push(t[n]);
      }
      for (var i = [], r = t.length - 1; r >= 0; r--) {
        for (; i.length >= 2 && d(i[i.length - 2], i[i.length - 1], t[r]) <= 0;) i.pop();
        i.push(t[r]);
      }
      return i.pop(), e.pop(), e.concat(i);
    }
    i.default && (i = i.default), e.exports = s, e.exports.default = s, u(s, "concaveman"), u(a, "findCandidate"), u(l, "compareDist"), u(h, "sqSegBoxDist"), u(c, "inside"), u(p, "noIntersections"), u(d, "cross"), u(f, "intersects"), u(m, "updateBBox"), u(g, "fastConvexHull"), u(v, "insertNode"), u(y, "getSqDist"), u(_, "sqSegDist"), u(x, "sqSegSegDist"), u(b, "compareByX"), u(w, "convexHull");
  }),
  XR = ze((t, e) => {
    var n, i;
    E(), n = t, i = function () {
      "use strict";

      function t(t, n, r, o, s) {
        e(t, n, r || 0, o || t.length - 1, s || i);
      }
      function e(t, i, r, o, s) {
        for (; o > r;) {
          if (o - r > 600) {
            var a = o - r + 1,
              l = i - r + 1,
              u = Math.log(a),
              h = .5 * Math.exp(2 * u / 3),
              c = .5 * Math.sqrt(u * h * (a - h) / a) * (l - a / 2 < 0 ? -1 : 1);
            e(t, i, Math.max(r, Math.floor(i - l * h / a + c)), Math.min(o, Math.floor(i + (a - l) * h / a + c)), s);
          }
          var p = t[i],
            d = r,
            f = o;
          for (n(t, r, i), s(t[o], p) > 0 && n(t, r, o); d < f;) {
            for (n(t, d, f), d++, f--; s(t[d], p) < 0;) d++;
            for (; s(t[f], p) > 0;) f--;
          }
          0 === s(t[r], p) ? n(t, r, f) : n(t, ++f, o), f <= i && (r = f + 1), i <= f && (o = f - 1);
        }
      }
      function n(t, e, n) {
        var i = t[e];
        t[e] = t[n], t[n] = i;
      }
      function i(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
      }
      return u(t, "quickselect"), u(e, "quickselectStep"), u(n, "swap"), u(i, "defaultCompare"), t;
    }, "object" == typeof t && void 0 !== e ? e.exports = i() : "function" == typeof define && define.amd ? define(i) : n.quickselect = i();
  }),
  v5 = ze((t, e) => {
    E(), e.exports = i, e.exports.default = i;
    var n = XR();
    function i(t, e) {
      if (!(this instanceof i)) return new i(t, e);
      this._maxEntries = Math.max(4, t || 9), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), e && this._initFormat(e), this.clear();
    }
    function r(t, e, n) {
      if (!n) return e.indexOf(t);
      for (var i = 0; i < e.length; i++) if (n(t, e[i])) return i;
      return -1;
    }
    function o(t, e) {
      s(t, 0, t.children.length, e, t);
    }
    function s(t, e, n, i, r) {
      r || (r = v(null)), r.minX = 1 / 0, r.minY = 1 / 0, r.maxX = -1 / 0, r.maxY = -1 / 0;
      for (var o, s = e; s < n; s++) o = t.children[s], a(r, t.leaf ? i(o) : o);
      return r;
    }
    function a(t, e) {
      return t.minX = Math.min(t.minX, e.minX), t.minY = Math.min(t.minY, e.minY), t.maxX = Math.max(t.maxX, e.maxX), t.maxY = Math.max(t.maxY, e.maxY), t;
    }
    function l(t, e) {
      return t.minX - e.minX;
    }
    function h(t, e) {
      return t.minY - e.minY;
    }
    function c(t) {
      return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function p(t) {
      return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function d(t, e) {
      return (Math.max(e.maxX, t.maxX) - Math.min(e.minX, t.minX)) * (Math.max(e.maxY, t.maxY) - Math.min(e.minY, t.minY));
    }
    function f(t, e) {
      var n = Math.max(t.minX, e.minX),
        i = Math.max(t.minY, e.minY),
        r = Math.min(t.maxX, e.maxX),
        o = Math.min(t.maxY, e.maxY);
      return Math.max(0, r - n) * Math.max(0, o - i);
    }
    function m(t, e) {
      return t.minX <= e.minX && t.minY <= e.minY && e.maxX <= t.maxX && e.maxY <= t.maxY;
    }
    function g(t, e) {
      return e.minX <= t.maxX && e.minY <= t.maxY && e.maxX >= t.minX && e.maxY >= t.minY;
    }
    function v(t) {
      return {
        children: t,
        height: 1,
        leaf: !0,
        minX: 1 / 0,
        minY: 1 / 0,
        maxX: -1 / 0,
        maxY: -1 / 0
      };
    }
    function y(t, e, i, r, o) {
      for (var s, a = [e, i]; a.length;) !((i = a.pop()) - (e = a.pop()) <= r) && (s = e + Math.ceil((i - e) / r / 2) * r, n(t, s, e, i, o), a.push(e, s, s, i));
    }
    u(i, "rbush"), i.prototype = {
      all: function () {
        return this._all(this.data, []);
      },
      search: function (t) {
        var e = this.data,
          n = [],
          i = this.toBBox;
        if (!g(t, e)) return n;
        for (var r, o, s, a, l = []; e;) {
          for (r = 0, o = e.children.length; r < o; r++) s = e.children[r], g(t, a = e.leaf ? i(s) : s) && (e.leaf ? n.push(s) : m(t, a) ? this._all(s, n) : l.push(s));
          e = l.pop();
        }
        return n;
      },
      collides: function (t) {
        var e = this.data,
          n = this.toBBox;
        if (!g(t, e)) return !1;
        for (var i, r, o, s, a = []; e;) {
          for (i = 0, r = e.children.length; i < r; i++) if (o = e.children[i], g(t, s = e.leaf ? n(o) : o)) {
            if (e.leaf || m(t, s)) return !0;
            a.push(o);
          }
          e = a.pop();
        }
        return !1;
      },
      load: function (t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
          for (var e = 0, n = t.length; e < n; e++) this.insert(t[e]);
          return this;
        }
        var i = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
          if (this.data.height === i.height) this._splitRoot(this.data, i);else {
            if (this.data.height < i.height) {
              var r = this.data;
              this.data = i, i = r;
            }
            this._insert(i, this.data.height - i.height - 1, !0);
          }
        } else this.data = i;
        return this;
      },
      insert: function (t) {
        return t && this._insert(t, this.data.height - 1), this;
      },
      clear: function () {
        return this.data = v([]), this;
      },
      remove: function (t, e) {
        if (!t) return this;
        for (var n, i, o, s, a = this.data, l = this.toBBox(t), u = [], h = []; a || u.length;) {
          if (a || (a = u.pop(), i = u[u.length - 1], n = h.pop(), s = !0), a.leaf && -1 !== (o = r(t, a.children, e))) return a.children.splice(o, 1), u.push(a), this._condense(u), this;
          s || a.leaf || !m(a, l) ? i ? (n++, a = i.children[n], s = !1) : a = null : (u.push(a), h.push(n), n = 0, i = a, a = a.children[0]);
        }
        return this;
      },
      toBBox: function (t) {
        return t;
      },
      compareMinX: l,
      compareMinY: h,
      toJSON: function () {
        return this.data;
      },
      fromJSON: function (t) {
        return this.data = t, this;
      },
      _all: function (t, e) {
        for (var n = []; t;) t.leaf ? e.push.apply(e, t.children) : n.push.apply(n, t.children), t = n.pop();
        return e;
      },
      _build: function (t, e, n, i) {
        var r,
          s = n - e + 1,
          a = this._maxEntries;
        if (s <= a) return o(r = v(t.slice(e, n + 1)), this.toBBox), r;
        i || (i = Math.ceil(Math.log(s) / Math.log(a)), a = Math.ceil(s / Math.pow(a, i - 1))), (r = v([])).leaf = !1, r.height = i;
        var l,
          u,
          h,
          c,
          p = Math.ceil(s / a),
          d = p * Math.ceil(Math.sqrt(a));
        for (y(t, e, n, d, this.compareMinX), l = e; l <= n; l += d) for (y(t, l, h = Math.min(l + d - 1, n), p, this.compareMinY), u = l; u <= h; u += p) c = Math.min(u + p - 1, h), r.children.push(this._build(t, u, c, i - 1));
        return o(r, this.toBBox), r;
      },
      _chooseSubtree: function (t, e, n, i) {
        for (var r, o, s, a, l, u, h, p; i.push(e), !e.leaf && i.length - 1 !== n;) {
          for (h = p = 1 / 0, r = 0, o = e.children.length; r < o; r++) l = c(s = e.children[r]), (u = d(t, s) - l) < p ? (p = u, h = l < h ? l : h, a = s) : u === p && l < h && (h = l, a = s);
          e = a || e.children[0];
        }
        return e;
      },
      _insert: function (t, e, n) {
        var i = this.toBBox,
          r = n ? t : i(t),
          o = [],
          s = this._chooseSubtree(r, this.data, e, o);
        for (s.children.push(t), a(s, r); e >= 0 && o[e].children.length > this._maxEntries;) this._split(o, e), e--;
        this._adjustParentBBoxes(r, o, e);
      },
      _split: function (t, e) {
        var n = t[e],
          i = n.children.length,
          r = this._minEntries;
        this._chooseSplitAxis(n, r, i);
        var s = this._chooseSplitIndex(n, r, i),
          a = v(n.children.splice(s, n.children.length - s));
        a.height = n.height, a.leaf = n.leaf, o(n, this.toBBox), o(a, this.toBBox), e ? t[e - 1].children.push(a) : this._splitRoot(n, a);
      },
      _splitRoot: function (t, e) {
        this.data = v([t, e]), this.data.height = t.height + 1, this.data.leaf = !1, o(this.data, this.toBBox);
      },
      _chooseSplitIndex: function (t, e, n) {
        var i, r, o, a, l, u, h, p;
        for (u = h = 1 / 0, i = e; i <= n - e; i++) a = f(r = s(t, 0, i, this.toBBox), o = s(t, i, n, this.toBBox)), l = c(r) + c(o), a < u ? (u = a, p = i, h = l < h ? l : h) : a === u && l < h && (h = l, p = i);
        return p;
      },
      _chooseSplitAxis: function (t, e, n) {
        var i = t.leaf ? this.compareMinX : l,
          r = t.leaf ? this.compareMinY : h;
        this._allDistMargin(t, e, n, i) < this._allDistMargin(t, e, n, r) && t.children.sort(i);
      },
      _allDistMargin: function (t, e, n, i) {
        t.children.sort(i);
        var r,
          o,
          l = this.toBBox,
          u = s(t, 0, e, l),
          h = s(t, n - e, n, l),
          c = p(u) + p(h);
        for (r = e; r < n - e; r++) o = t.children[r], a(u, t.leaf ? l(o) : o), c += p(u);
        for (r = n - e - 1; r >= e; r--) o = t.children[r], a(h, t.leaf ? l(o) : o), c += p(h);
        return c;
      },
      _adjustParentBBoxes: function (t, e, n) {
        for (var i = n; i >= 0; i--) a(e[i], t);
      },
      _condense: function (t) {
        for (var e, n = t.length - 1; n >= 0; n--) 0 === t[n].children.length ? n > 0 ? (e = t[n - 1].children).splice(e.indexOf(t[n]), 1) : this.clear() : o(t[n], this.toBBox);
      },
      _initFormat: function (t) {
        var e = ["return a", " - b", ";"];
        this.compareMinX = new Function("a", "b", e.join(t[0])), this.compareMinY = new Function("a", "b", e.join(t[1])), this.toBBox = new Function("a", "return {minX: a" + t[0] + ", minY: a" + t[1] + ", maxX: a" + t[2] + ", maxY: a" + t[3] + "};");
      }
    }, u(r, "findItem"), u(o, "calcBBox"), u(s, "distBBox"), u(a, "extend"), u(l, "compareNodeMinX"), u(h, "compareNodeMinY"), u(c, "bboxArea"), u(p, "bboxMargin"), u(d, "enlargedArea"), u(f, "intersectionArea"), u(m, "contains"), u(g, "intersects"), u(v, "createNode"), u(y, "multiSelect");
  }),
  tN = ze((t, e) => {
    function n(t, e, n) {
      n = n || 2;
      var r,
        s,
        a,
        l,
        u,
        h,
        p,
        d = e && e.length,
        f = d ? e[0] * n : t.length,
        m = i(t, 0, f, n, !0),
        g = [];
      if (!m || m.next === m.prev) return g;
      if (d && (m = c(t, e, m, n)), t.length > 80 * n) {
        r = a = t[0], s = l = t[1];
        for (var v = n; v < f; v += n) (u = t[v]) < r && (r = u), (h = t[v + 1]) < s && (s = h), u > a && (a = u), h > l && (l = h);
        p = 0 !== (p = Math.max(a - r, l - s)) ? 32767 / p : 0;
      }
      return o(m, g, n, r, s, p, 0), g;
    }
    function i(t, e, n, i, r) {
      var o, s;
      if (r === q(t, e, n, i) > 0) for (o = e; o < n; o += i) s = L(o, t[o], t[o + 1], s);else for (o = n - i; o >= e; o -= i) s = L(o, t[o], t[o + 1], s);
      return s && S(s, s.next) && (R(s), s = s.next), s;
    }
    function r(t, e) {
      if (!t) return t;
      e || (e = t);
      var n,
        i = t;
      do {
        if (n = !1, i.steiner || !S(i, i.next) && 0 !== w(i.prev, i, i.next)) i = i.next;else {
          if (R(i), (i = e = i.prev) === i.next) break;
          n = !0;
        }
      } while (n || i !== e);
      return e;
    }
    function o(t, e, n, i, u, c, p) {
      if (t) {
        !p && c && g(t, i, u, c);
        for (var d, f, m = t; t.prev !== t.next;) if (d = t.prev, f = t.next, c ? a(t, i, u, c) : s(t)) e.push(d.i / n | 0), e.push(t.i / n | 0), e.push(f.i / n | 0), R(t), t = f.next, m = f.next;else if ((t = f) === m) {
          p ? 1 === p ? o(t = l(r(t), e, n), e, n, i, u, c, 2) : 2 === p && h(t, e, n, i, u, c) : o(r(t), e, n, i, u, c, 1);
          break;
        }
      }
    }
    function s(t) {
      var e = t.prev,
        n = t,
        i = t.next;
      if (w(e, n, i) >= 0) return !1;
      for (var r = e.x, o = n.x, s = i.x, a = e.y, l = n.y, u = i.y, h = r < o ? r < s ? r : s : o < s ? o : s, c = a < l ? a < u ? a : u : l < u ? l : u, p = r > o ? r > s ? r : s : o > s ? o : s, d = a > l ? a > u ? a : u : l > u ? l : u, f = i.next; f !== e;) {
        if (f.x >= h && f.x <= p && f.y >= c && f.y <= d && x(r, a, o, l, s, u, f.x, f.y) && w(f.prev, f, f.next) >= 0) return !1;
        f = f.next;
      }
      return !0;
    }
    function a(t, e, n, i) {
      var r = t.prev,
        o = t,
        s = t.next;
      if (w(r, o, s) >= 0) return !1;
      for (var a = r.x, l = o.x, u = s.x, h = r.y, c = o.y, p = s.y, d = a < l ? a < u ? a : u : l < u ? l : u, f = h < c ? h < p ? h : p : c < p ? c : p, m = a > l ? a > u ? a : u : l > u ? l : u, g = h > c ? h > p ? h : p : c > p ? c : p, v = y(d, f, e, n, i), _ = y(m, g, e, n, i), E = t.prevZ, b = t.nextZ; E && E.z >= v && b && b.z <= _;) {
        if (E.x >= d && E.x <= m && E.y >= f && E.y <= g && E !== r && E !== s && x(a, h, l, c, u, p, E.x, E.y) && w(E.prev, E, E.next) >= 0 || (E = E.prevZ, b.x >= d && b.x <= m && b.y >= f && b.y <= g && b !== r && b !== s && x(a, h, l, c, u, p, b.x, b.y) && w(b.prev, b, b.next) >= 0)) return !1;
        b = b.nextZ;
      }
      for (; E && E.z >= v;) {
        if (E.x >= d && E.x <= m && E.y >= f && E.y <= g && E !== r && E !== s && x(a, h, l, c, u, p, E.x, E.y) && w(E.prev, E, E.next) >= 0) return !1;
        E = E.prevZ;
      }
      for (; b && b.z <= _;) {
        if (b.x >= d && b.x <= m && b.y >= f && b.y <= g && b !== r && b !== s && x(a, h, l, c, u, p, b.x, b.y) && w(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
      }
      return !0;
    }
    function l(t, e, n) {
      var i = t;
      do {
        var o = i.prev,
          s = i.next.next;
        !S(o, s) && M(o, i, i.next, s) && C(o, s) && C(s, o) && (e.push(o.i / n | 0), e.push(i.i / n | 0), e.push(s.i / n | 0), R(i), R(i.next), i = t = s), i = i.next;
      } while (i !== t);
      return r(i);
    }
    function h(t, e, n, i, s, a) {
      var l = t;
      do {
        for (var u = l.next.next; u !== l.prev;) {
          if (l.i !== u.i && b(l, u)) {
            var h = N(l, u);
            return l = r(l, l.next), h = r(h, h.next), o(l, e, n, i, s, a, 0), void o(h, e, n, i, s, a, 0);
          }
          u = u.next;
        }
        l = l.next;
      } while (l !== t);
    }
    function c(t, e, n, r) {
      var o,
        s,
        a,
        l = [];
      for (o = 0, s = e.length; o < s; o++) (a = i(t, e[o] * r, o < s - 1 ? e[o + 1] * r : t.length, r, !1)) === a.next && (a.steiner = !0), l.push(_(a));
      for (l.sort(p), o = 0; o < l.length; o++) n = d(l[o], n);
      return n;
    }
    function p(t, e) {
      return t.x - e.x;
    }
    function d(t, e) {
      var n = f(t, e);
      if (!n) return e;
      var i = N(n, t);
      return r(i, i.next), r(n, n.next);
    }
    function f(t, e) {
      var n,
        i = e,
        r = t.x,
        o = t.y,
        s = -1 / 0;
      do {
        if (o <= i.y && o >= i.next.y && i.next.y !== i.y) {
          var a = i.x + (o - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
          if (a <= r && a > s && (s = a, n = i.x < i.next.x ? i : i.next, a === r)) return n;
        }
        i = i.next;
      } while (i !== e);
      if (!n) return null;
      var l,
        u = n,
        h = n.x,
        c = n.y,
        p = 1 / 0;
      i = n;
      do {
        r >= i.x && i.x >= h && r !== i.x && x(o < c ? r : s, o, h, c, o < c ? s : r, o, i.x, i.y) && (l = Math.abs(o - i.y) / (r - i.x), C(i, t) && (l < p || l === p && (i.x > n.x || i.x === n.x && m(n, i))) && (n = i, p = l)), i = i.next;
      } while (i !== u);
      return n;
    }
    function m(t, e) {
      return w(t.prev, t, e.prev) < 0 && w(e.next, t, t.next) < 0;
    }
    function g(t, e, n, i) {
      var r = t;
      do {
        0 === r.z && (r.z = y(r.x, r.y, e, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
      } while (r !== t);
      r.prevZ.nextZ = null, r.prevZ = null, v(r);
    }
    function v(t) {
      var e,
        n,
        i,
        r,
        o,
        s,
        a,
        l,
        u = 1;
      do {
        for (n = t, t = null, o = null, s = 0; n;) {
          for (s++, i = n, a = 0, e = 0; e < u && (a++, i = i.nextZ); e++);
          for (l = u; a > 0 || l > 0 && i;) 0 !== a && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, a--) : (r = i, i = i.nextZ, l--), o ? o.nextZ = r : t = r, r.prevZ = o, o = r;
          n = i;
        }
        o.nextZ = null, u *= 2;
      } while (s > 1);
      return t;
    }
    function y(t, e, n, i, r) {
      return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - n) * r | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - i) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
    }
    function _(t) {
      var e = t,
        n = t;
      do {
        (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
      } while (e !== t);
      return n;
    }
    function x(t, e, n, i, r, o, s, a) {
      return (r - s) * (e - a) >= (t - s) * (o - a) && (t - s) * (i - a) >= (n - s) * (e - a) && (n - s) * (o - a) >= (r - s) * (i - a);
    }
    function b(t, e) {
      return t.next.i !== e.i && t.prev.i !== e.i && !P(t, e) && (C(t, e) && C(e, t) && I(t, e) && (w(t.prev, t, e.prev) || w(t, e.prev, e)) || S(t, e) && w(t.prev, t, t.next) > 0 && w(e.prev, e, e.next) > 0);
    }
    function w(t, e, n) {
      return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
    }
    function S(t, e) {
      return t.x === e.x && t.y === e.y;
    }
    function M(t, e, n, i) {
      var r = A(w(t, e, n)),
        o = A(w(t, e, i)),
        s = A(w(n, i, t)),
        a = A(w(n, i, e));
      return !!(r !== o && s !== a || 0 === r && T(t, n, e) || 0 === o && T(t, i, e) || 0 === s && T(n, t, i) || 0 === a && T(n, e, i));
    }
    function T(t, e, n) {
      return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
    }
    function A(t) {
      return t > 0 ? 1 : t < 0 ? -1 : 0;
    }
    function P(t, e) {
      var n = t;
      do {
        if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && M(n, n.next, t, e)) return !0;
        n = n.next;
      } while (n !== t);
      return !1;
    }
    function C(t, e) {
      return w(t.prev, t, t.next) < 0 ? w(t, e, t.next) >= 0 && w(t, t.prev, e) >= 0 : w(t, e, t.prev) < 0 || w(t, t.next, e) < 0;
    }
    function I(t, e) {
      var n = t,
        i = !1,
        r = (t.x + e.x) / 2,
        o = (t.y + e.y) / 2;
      do {
        n.y > o != n.next.y > o && n.next.y !== n.y && r < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
      } while (n !== t);
      return i;
    }
    function N(t, e) {
      var n = new O(t.i, t.x, t.y),
        i = new O(e.i, e.x, e.y),
        r = t.next,
        o = e.prev;
      return t.next = e, e.prev = t, n.next = r, r.prev = n, i.next = n, n.prev = i, o.next = i, i.prev = o, i;
    }
    function L(t, e, n, i) {
      var r = new O(t, e, n);
      return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
    }
    function R(t) {
      t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
    }
    function O(t, e, n) {
      this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
    }
    function q(t, e, n, i) {
      for (var r = 0, o = e, s = n - i; o < n; o += i) r += (t[s] - t[o]) * (t[o + 1] + t[s + 1]), s = o;
      return r;
    }
    E(), e.exports = n, e.exports.default = n, u(n, "earcut"), u(i, "linkedList"), u(r, "filterPoints"), u(o, "earcutLinked"), u(s, "isEar"), u(a, "isEarHashed"), u(l, "cureLocalIntersections"), u(h, "splitEarcut"), u(c, "eliminateHoles"), u(p, "compareX"), u(d, "eliminateHole"), u(f, "findHoleBridge"), u(m, "sectorContainsSector"), u(g, "indexCurve"), u(v, "sortLinked"), u(y, "zOrder"), u(_, "getLeftmost"), u(x, "pointInTriangle"), u(b, "isValidDiagonal"), u(w, "area"), u(S, "equals"), u(M, "intersects"), u(T, "onSegment"), u(A, "sign"), u(P, "intersectsPolygon"), u(C, "locallyInside"), u(I, "middleInside"), u(N, "splitPolygon"), u(L, "insertNode"), u(R, "removeNode"), u(O, "Node"), n.deviation = function (t, e, n, i) {
      var r = e && e.length,
        o = r ? e[0] * n : t.length,
        s = Math.abs(q(t, 0, o, n));
      if (r) for (var a = 0, l = e.length; a < l; a++) {
        var u = e[a] * n,
          h = a < l - 1 ? e[a + 1] * n : t.length;
        s -= Math.abs(q(t, u, h, n));
      }
      var c = 0;
      for (a = 0; a < i.length; a += 3) {
        var p = i[a] * n,
          d = i[a + 1] * n,
          f = i[a + 2] * n;
        c += Math.abs((t[p] - t[f]) * (t[d + 1] - t[p + 1]) - (t[p] - t[d]) * (t[f + 1] - t[p + 1]));
      }
      return 0 === s && 0 === c ? 0 : Math.abs((c - s) / s);
    }, u(q, "signedArea"), n.flatten = function (t) {
      for (var e = t[0][0].length, n = {
          vertices: [],
          holes: [],
          dimensions: e
        }, i = 0, r = 0; r < t.length; r++) {
        for (var o = 0; o < t[r].length; o++) for (var s = 0; s < e; s++) n.vertices.push(t[r][o][s]);
        r > 0 && (i += t[r - 1].length, n.holes.push(i));
      }
      return n;
    };
  }),
  nN = ze((t, e) => {
    var n, i;
    E(), n = t, i = function () {
      "use strict";

      function t(t, i, r, o, s) {
        u(function t(n, i, r, o, s) {
          for (; o > r;) {
            if (o - r > 600) {
              var a = o - r + 1,
                l = i - r + 1,
                u = Math.log(a),
                h = .5 * Math.exp(2 * u / 3),
                c = .5 * Math.sqrt(u * h * (a - h) / a) * (l - a / 2 < 0 ? -1 : 1);
              t(n, i, Math.max(r, Math.floor(i - l * h / a + c)), Math.min(o, Math.floor(i + (a - l) * h / a + c)), s);
            }
            var p = n[i],
              d = r,
              f = o;
            for (e(n, r, i), s(n[o], p) > 0 && e(n, r, o); d < f;) {
              for (e(n, d, f), d++, f--; s(n[d], p) < 0;) d++;
              for (; s(n[f], p) > 0;) f--;
            }
            0 === s(n[r], p) ? e(n, r, f) : e(n, ++f, o), f <= i && (r = f + 1), i <= f && (o = f - 1);
          }
        }, "t")(t, i, r || 0, o || t.length - 1, s || n);
      }
      function e(t, e, n) {
        var i = t[e];
        t[e] = t[n], t[n] = i;
      }
      function n(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
      }
      u(t, "t"), u(e, "i"), u(n, "n");
      var i = u(function (t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
      }, "r");
      function r(t, e, n) {
        if (!n) return e.indexOf(t);
        for (var i = 0; i < e.length; i++) if (n(t, e[i])) return i;
        return -1;
      }
      function o(t, e) {
        s(t, 0, t.children.length, e, t);
      }
      function s(t, e, n, i, r) {
        r || (r = m(null)), r.minX = 1 / 0, r.minY = 1 / 0, r.maxX = -1 / 0, r.maxY = -1 / 0;
        for (var o = e; o < n; o++) {
          var s = t.children[o];
          a(r, t.leaf ? i(s) : s);
        }
        return r;
      }
      function a(t, e) {
        return t.minX = Math.min(t.minX, e.minX), t.minY = Math.min(t.minY, e.minY), t.maxX = Math.max(t.maxX, e.maxX), t.maxY = Math.max(t.maxY, e.maxY), t;
      }
      function l(t, e) {
        return t.minX - e.minX;
      }
      function h(t, e) {
        return t.minY - e.minY;
      }
      function c(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
      }
      function p(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
      }
      function d(t, e) {
        return t.minX <= e.minX && t.minY <= e.minY && e.maxX <= t.maxX && e.maxY <= t.maxY;
      }
      function f(t, e) {
        return e.minX <= t.maxX && e.minY <= t.maxY && e.maxX >= t.minX && e.maxY >= t.minY;
      }
      function m(t) {
        return {
          children: t,
          height: 1,
          leaf: !0,
          minX: 1 / 0,
          minY: 1 / 0,
          maxX: -1 / 0,
          maxY: -1 / 0
        };
      }
      function g(e, n, i, r, o) {
        for (var s = [n, i]; s.length;) if (!((i = s.pop()) - (n = s.pop()) <= r)) {
          var a = n + Math.ceil((i - n) / r / 2) * r;
          t(e, a, n, i, o), s.push(n, a, a, i);
        }
      }
      return u(r, "e"), u(o, "a"), u(s, "h"), u(a, "o"), u(l, "s"), u(h, "l"), u(c, "f"), u(p, "u"), u(d, "m"), u(f, "c"), u(m, "p"), u(g, "d"), i.prototype.all = function () {
        return this._all(this.data, []);
      }, i.prototype.search = function (t) {
        var e = this.data,
          n = [];
        if (!f(t, e)) return n;
        for (var i = this.toBBox, r = []; e;) {
          for (var o = 0; o < e.children.length; o++) {
            var s = e.children[o],
              a = e.leaf ? i(s) : s;
            f(t, a) && (e.leaf ? n.push(s) : d(t, a) ? this._all(s, n) : r.push(s));
          }
          e = r.pop();
        }
        return n;
      }, i.prototype.collides = function (t) {
        var e = this.data;
        if (!f(t, e)) return !1;
        for (var n = []; e;) {
          for (var i = 0; i < e.children.length; i++) {
            var r = e.children[i],
              o = e.leaf ? this.toBBox(r) : r;
            if (f(t, o)) {
              if (e.leaf || d(t, o)) return !0;
              n.push(r);
            }
          }
          e = n.pop();
        }
        return !1;
      }, i.prototype.load = function (t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
          for (var e = 0; e < t.length; e++) this.insert(t[e]);
          return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
          if (this.data.height === n.height) this._splitRoot(this.data, n);else {
            if (this.data.height < n.height) {
              var i = this.data;
              this.data = n, n = i;
            }
            this._insert(n, this.data.height - n.height - 1, !0);
          }
        } else this.data = n;
        return this;
      }, i.prototype.insert = function (t) {
        return t && this._insert(t, this.data.height - 1), this;
      }, i.prototype.clear = function () {
        return this.data = m([]), this;
      }, i.prototype.remove = function (t, e) {
        if (!t) return this;
        for (var n, i, o, s = this.data, a = this.toBBox(t), l = [], u = []; s || l.length;) {
          if (s || (s = l.pop(), i = l[l.length - 1], n = u.pop(), o = !0), s.leaf) {
            var h = r(t, s.children, e);
            if (-1 !== h) return s.children.splice(h, 1), l.push(s), this._condense(l), this;
          }
          o || s.leaf || !d(s, a) ? i ? (n++, s = i.children[n], o = !1) : s = null : (l.push(s), u.push(n), n = 0, i = s, s = s.children[0]);
        }
        return this;
      }, i.prototype.toBBox = function (t) {
        return t;
      }, i.prototype.compareMinX = function (t, e) {
        return t.minX - e.minX;
      }, i.prototype.compareMinY = function (t, e) {
        return t.minY - e.minY;
      }, i.prototype.toJSON = function () {
        return this.data;
      }, i.prototype.fromJSON = function (t) {
        return this.data = t, this;
      }, i.prototype._all = function (t, e) {
        for (var n = []; t;) t.leaf ? e.push.apply(e, t.children) : n.push.apply(n, t.children), t = n.pop();
        return e;
      }, i.prototype._build = function (t, e, n, i) {
        var r,
          s = n - e + 1,
          a = this._maxEntries;
        if (s <= a) return o(r = m(t.slice(e, n + 1)), this.toBBox), r;
        i || (i = Math.ceil(Math.log(s) / Math.log(a)), a = Math.ceil(s / Math.pow(a, i - 1))), (r = m([])).leaf = !1, r.height = i;
        var l = Math.ceil(s / a),
          u = l * Math.ceil(Math.sqrt(a));
        g(t, e, n, u, this.compareMinX);
        for (var h = e; h <= n; h += u) {
          var c = Math.min(h + u - 1, n);
          g(t, h, c, l, this.compareMinY);
          for (var p = h; p <= c; p += l) {
            var d = Math.min(p + l - 1, c);
            r.children.push(this._build(t, p, d, i - 1));
          }
        }
        return o(r, this.toBBox), r;
      }, i.prototype._chooseSubtree = function (t, e, n, i) {
        for (; i.push(e), !e.leaf && i.length - 1 !== n;) {
          for (var r = 1 / 0, o = 1 / 0, s = void 0, a = 0; a < e.children.length; a++) {
            var l = e.children[a],
              u = c(l),
              h = (p = t, d = l, (Math.max(d.maxX, p.maxX) - Math.min(d.minX, p.minX)) * (Math.max(d.maxY, p.maxY) - Math.min(d.minY, p.minY)) - u);
            h < o ? (o = h, r = u < r ? u : r, s = l) : h === o && u < r && (r = u, s = l);
          }
          e = s || e.children[0];
        }
        var p, d;
        return e;
      }, i.prototype._insert = function (t, e, n) {
        var i = n ? t : this.toBBox(t),
          r = [],
          o = this._chooseSubtree(i, this.data, e, r);
        for (o.children.push(t), a(o, i); e >= 0 && r[e].children.length > this._maxEntries;) this._split(r, e), e--;
        this._adjustParentBBoxes(i, r, e);
      }, i.prototype._split = function (t, e) {
        var n = t[e],
          i = n.children.length,
          r = this._minEntries;
        this._chooseSplitAxis(n, r, i);
        var s = this._chooseSplitIndex(n, r, i),
          a = m(n.children.splice(s, n.children.length - s));
        a.height = n.height, a.leaf = n.leaf, o(n, this.toBBox), o(a, this.toBBox), e ? t[e - 1].children.push(a) : this._splitRoot(n, a);
      }, i.prototype._splitRoot = function (t, e) {
        this.data = m([t, e]), this.data.height = t.height + 1, this.data.leaf = !1, o(this.data, this.toBBox);
      }, i.prototype._chooseSplitIndex = function (t, e, n) {
        for (var i, r, o, a, l, u, h, p = 1 / 0, d = 1 / 0, f = e; f <= n - e; f++) {
          var m = s(t, 0, f, this.toBBox),
            g = s(t, f, n, this.toBBox),
            v = (r = m, o = g, a = Math.max(r.minX, o.minX), l = Math.max(r.minY, o.minY), u = Math.min(r.maxX, o.maxX), h = Math.min(r.maxY, o.maxY), Math.max(0, u - a) * Math.max(0, h - l)),
            y = c(m) + c(g);
          v < p ? (p = v, i = f, d = y < d ? y : d) : v === p && y < d && (d = y, i = f);
        }
        return i || n - e;
      }, i.prototype._chooseSplitAxis = function (t, e, n) {
        var i = t.leaf ? this.compareMinX : l,
          r = t.leaf ? this.compareMinY : h;
        this._allDistMargin(t, e, n, i) < this._allDistMargin(t, e, n, r) && t.children.sort(i);
      }, i.prototype._allDistMargin = function (t, e, n, i) {
        t.children.sort(i);
        for (var r = this.toBBox, o = s(t, 0, e, r), l = s(t, n - e, n, r), u = p(o) + p(l), h = e; h < n - e; h++) {
          var c = t.children[h];
          a(o, t.leaf ? r(c) : c), u += p(o);
        }
        for (var d = n - e - 1; d >= e; d--) {
          var f = t.children[d];
          a(l, t.leaf ? r(f) : f), u += p(l);
        }
        return u;
      }, i.prototype._adjustParentBBoxes = function (t, e, n) {
        for (var i = n; i >= 0; i--) a(e[i], t);
      }, i.prototype._condense = function (t) {
        for (var e = t.length - 1, n = void 0; e >= 0; e--) 0 === t[e].children.length ? e > 0 ? (n = t[e - 1].children).splice(n.indexOf(t[e]), 1) : this.clear() : o(t[e], this.toBBox);
      }, i;
    }, "object" == typeof t && void 0 !== e ? e.exports = i() : "function" == typeof define && define.amd ? define(i) : (n = n || self).RBush = i();
  }),
  A5 = ze(t => {
    function e(t, e, n) {
      void 0 === n && (n = {});
      var i = {
        type: "Feature"
      };
      return (0 === n.id || n.id) && (i.id = n.id), n.bbox && (i.bbox = n.bbox), i.properties = e || {}, i.geometry = t, i;
    }
    function n(t, e, n) {
      switch (void 0 === n && (n = {}), t) {
        case "Point":
          return i(e).geometry;
        case "LineString":
          return a(e).geometry;
        case "Polygon":
          return o(e).geometry;
        case "MultiPoint":
          return p(e).geometry;
        case "MultiLineString":
          return c(e).geometry;
        case "MultiPolygon":
          return d(e).geometry;
        default:
          throw new Error(t + " is invalid");
      }
    }
    function i(t, n, i) {
      if (void 0 === i && (i = {}), !t) throw new Error("coordinates is required");
      if (!Array.isArray(t)) throw new Error("coordinates must be an Array");
      if (t.length < 2) throw new Error("coordinates must be at least 2 numbers long");
      if (!M(t[0]) || !M(t[1])) throw new Error("coordinates must contain numbers");
      return e({
        type: "Point",
        coordinates: t
      }, n, i);
    }
    function r(t, e, n) {
      return void 0 === n && (n = {}), h(t.map(function (t) {
        return i(t, e);
      }), n);
    }
    function o(t, n, i) {
      void 0 === i && (i = {});
      for (var r = 0, o = t; r < o.length; r++) {
        var s = o[r];
        if (s.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for (var a = 0; a < s[s.length - 1].length; a++) if (s[s.length - 1][a] !== s[0][a]) throw new Error("First and last Position are not equivalent.");
      }
      return e({
        type: "Polygon",
        coordinates: t
      }, n, i);
    }
    function s(t, e, n) {
      return void 0 === n && (n = {}), h(t.map(function (t) {
        return o(t, e);
      }), n);
    }
    function a(t, n, i) {
      if (void 0 === i && (i = {}), t.length < 2) throw new Error("coordinates must be an array of two or more positions");
      return e({
        type: "LineString",
        coordinates: t
      }, n, i);
    }
    function l(t, e, n) {
      return void 0 === n && (n = {}), h(t.map(function (t) {
        return a(t, e);
      }), n);
    }
    function h(t, e) {
      void 0 === e && (e = {});
      var n = {
        type: "FeatureCollection"
      };
      return e.id && (n.id = e.id), e.bbox && (n.bbox = e.bbox), n.features = t, n;
    }
    function c(t, n, i) {
      return void 0 === i && (i = {}), e({
        type: "MultiLineString",
        coordinates: t
      }, n, i);
    }
    function p(t, n, i) {
      return void 0 === i && (i = {}), e({
        type: "MultiPoint",
        coordinates: t
      }, n, i);
    }
    function d(t, n, i) {
      return void 0 === i && (i = {}), e({
        type: "MultiPolygon",
        coordinates: t
      }, n, i);
    }
    function f(t, n, i) {
      return void 0 === i && (i = {}), e({
        type: "GeometryCollection",
        geometries: t
      }, n, i);
    }
    function m(t, e) {
      if (void 0 === e && (e = 0), e && !(e >= 0)) throw new Error("precision must be a positive number");
      var n = Math.pow(10, e || 0);
      return Math.round(t * n) / n;
    }
    function g(e, n) {
      void 0 === n && (n = "kilometers");
      var i = t.factors[n];
      if (!i) throw new Error(n + " units is invalid");
      return e * i;
    }
    function v(e, n) {
      void 0 === n && (n = "kilometers");
      var i = t.factors[n];
      if (!i) throw new Error(n + " units is invalid");
      return e / i;
    }
    function y(t, e) {
      return x(v(t, e));
    }
    function _(t) {
      var e = t % 360;
      return e < 0 && (e += 360), e;
    }
    function x(t) {
      return 180 * (t % (2 * Math.PI)) / Math.PI;
    }
    function b(t) {
      return t % 360 * Math.PI / 180;
    }
    function w(t, e, n) {
      if (void 0 === e && (e = "kilometers"), void 0 === n && (n = "kilometers"), !(t >= 0)) throw new Error("length must be a positive number");
      return g(v(t, e), n);
    }
    function S(e, n, i) {
      if (void 0 === n && (n = "meters"), void 0 === i && (i = "kilometers"), !(e >= 0)) throw new Error("area must be a positive number");
      var r = t.areaFactors[n];
      if (!r) throw new Error("invalid original units");
      var o = t.areaFactors[i];
      if (!o) throw new Error("invalid final units");
      return e / r * o;
    }
    function M(t) {
      return !isNaN(t) && null !== t && !Array.isArray(t);
    }
    function T(t) {
      return !!t && t.constructor === Object;
    }
    function A(t) {
      if (!t) throw new Error("bbox is required");
      if (!Array.isArray(t)) throw new Error("bbox must be an Array");
      if (4 !== t.length && 6 !== t.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
      t.forEach(function (t) {
        if (!M(t)) throw new Error("bbox must only contain numbers");
      });
    }
    function P(t) {
      if (!t) throw new Error("id is required");
      if (-1 === ["string", "number"].indexOf(typeof t)) throw new Error("id must be a number or a string");
    }
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.earthRadius = 6371008.8, t.factors = {
      centimeters: 100 * t.earthRadius,
      centimetres: 100 * t.earthRadius,
      degrees: t.earthRadius / 111325,
      feet: 3.28084 * t.earthRadius,
      inches: 39.37 * t.earthRadius,
      kilometers: t.earthRadius / 1e3,
      kilometres: t.earthRadius / 1e3,
      meters: t.earthRadius,
      metres: t.earthRadius,
      miles: t.earthRadius / 1609.344,
      millimeters: 1e3 * t.earthRadius,
      millimetres: 1e3 * t.earthRadius,
      nauticalmiles: t.earthRadius / 1852,
      radians: 1,
      yards: 1.0936 * t.earthRadius
    }, t.unitsFactors = {
      centimeters: 100,
      centimetres: 100,
      degrees: 1 / 111325,
      feet: 3.28084,
      inches: 39.37,
      kilometers: .001,
      kilometres: .001,
      meters: 1,
      metres: 1,
      miles: 1 / 1609.344,
      millimeters: 1e3,
      millimetres: 1e3,
      nauticalmiles: 1 / 1852,
      radians: 1 / t.earthRadius,
      yards: 1.0936133
    }, t.areaFactors = {
      acres: 247105e-9,
      centimeters: 1e4,
      centimetres: 1e4,
      feet: 10.763910417,
      hectares: 1e-4,
      inches: 1550.003100006,
      kilometers: 1e-6,
      kilometres: 1e-6,
      meters: 1,
      metres: 1,
      miles: 386e-9,
      millimeters: 1e6,
      millimetres: 1e6,
      yards: 1.195990046
    }, u(e, "feature"), t.feature = e, u(n, "geometry"), t.geometry = n, u(i, "point"), t.point = i, u(r, "points"), t.points = r, u(o, "polygon"), t.polygon = o, u(s, "polygons"), t.polygons = s, u(a, "lineString"), t.lineString = a, u(l, "lineStrings"), t.lineStrings = l, u(h, "featureCollection"), t.featureCollection = h, u(c, "multiLineString"), t.multiLineString = c, u(p, "multiPoint"), t.multiPoint = p, u(d, "multiPolygon"), t.multiPolygon = d, u(f, "geometryCollection"), t.geometryCollection = f, u(m, "round"), t.round = m, u(g, "radiansToLength"), t.radiansToLength = g, u(v, "lengthToRadians"), t.lengthToRadians = v, u(y, "lengthToDegrees"), t.lengthToDegrees = y, u(_, "bearingToAzimuth"), t.bearingToAzimuth = _, u(x, "radiansToDegrees"), t.radiansToDegrees = x, u(b, "degreesToRadians"), t.degreesToRadians = b, u(w, "convertLength"), t.convertLength = w, u(S, "convertArea"), t.convertArea = S, u(M, "isNumber"), t.isNumber = M, u(T, "isObject"), t.isObject = T, u(A, "validateBBox"), t.validateBBox = A, u(P, "validateId"), t.validateId = P;
  }),
  L5 = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var e = A5();
    function n(t, e, i) {
      if (null !== t) for (var r, o, s, a, l, u, h, c, p = 0, d = 0, f = t.type, m = "FeatureCollection" === f, g = "Feature" === f, v = m ? t.features.length : 1, y = 0; y < v; y++) {
        l = (c = !!(h = m ? t.features[y].geometry : g ? t.geometry : t) && "GeometryCollection" === h.type) ? h.geometries.length : 1;
        for (var _ = 0; _ < l; _++) {
          var x = 0,
            E = 0;
          if (null !== (a = c ? h.geometries[_] : h)) {
            u = a.coordinates;
            var b = a.type;
            switch (p = !i || "Polygon" !== b && "MultiPolygon" !== b ? 0 : 1, b) {
              case null:
                break;
              case "Point":
                if (!1 === e(u, d, y, x, E)) return !1;
                d++, x++;
                break;
              case "LineString":
              case "MultiPoint":
                for (r = 0; r < u.length; r++) {
                  if (!1 === e(u[r], d, y, x, E)) return !1;
                  d++, "MultiPoint" === b && x++;
                }
                "LineString" === b && x++;
                break;
              case "Polygon":
              case "MultiLineString":
                for (r = 0; r < u.length; r++) {
                  for (o = 0; o < u[r].length - p; o++) {
                    if (!1 === e(u[r][o], d, y, x, E)) return !1;
                    d++;
                  }
                  "MultiLineString" === b && x++, "Polygon" === b && E++;
                }
                "Polygon" === b && x++;
                break;
              case "MultiPolygon":
                for (r = 0; r < u.length; r++) {
                  for (E = 0, o = 0; o < u[r].length; o++) {
                    for (s = 0; s < u[r][o].length - p; s++) {
                      if (!1 === e(u[r][o][s], d, y, x, E)) return !1;
                      d++;
                    }
                    E++;
                  }
                  x++;
                }
                break;
              case "GeometryCollection":
                for (r = 0; r < a.geometries.length; r++) if (!1 === n(a.geometries[r], e, i)) return !1;
                break;
              default:
                throw new Error("Unknown Geometry Type");
            }
          }
        }
      }
    }
    function i(t, e, i, r) {
      var o = i;
      return n(t, function (t, n, r, s, a) {
        o = 0 === n && void 0 === i ? t : e(o, t, n, r, s, a);
      }, r), o;
    }
    function r(t, e) {
      var n;
      switch (t.type) {
        case "FeatureCollection":
          for (n = 0; n < t.features.length && !1 !== e(t.features[n].properties, n); n++);
          break;
        case "Feature":
          e(t.properties, 0);
      }
    }
    function o(t, e, n) {
      var i = n;
      return r(t, function (t, r) {
        i = 0 === r && void 0 === n ? t : e(i, t, r);
      }), i;
    }
    function s(t, e) {
      if ("Feature" === t.type) e(t, 0);else if ("FeatureCollection" === t.type) for (var n = 0; n < t.features.length && !1 !== e(t.features[n], n); n++);
    }
    function a(t, e, n) {
      var i = n;
      return s(t, function (t, r) {
        i = 0 === r && void 0 === n ? t : e(i, t, r);
      }), i;
    }
    function l(t) {
      var e = [];
      return n(t, function (t) {
        e.push(t);
      }), e;
    }
    function h(t, e) {
      var n,
        i,
        r,
        o,
        s,
        a,
        l,
        u,
        h,
        c,
        p = 0,
        d = "FeatureCollection" === t.type,
        f = "Feature" === t.type,
        m = d ? t.features.length : 1;
      for (n = 0; n < m; n++) {
        for (a = d ? t.features[n].geometry : f ? t.geometry : t, u = d ? t.features[n].properties : f ? t.properties : {}, h = d ? t.features[n].bbox : f ? t.bbox : void 0, c = d ? t.features[n].id : f ? t.id : void 0, s = (l = !!a && "GeometryCollection" === a.type) ? a.geometries.length : 1, r = 0; r < s; r++) if (null !== (o = l ? a.geometries[r] : a)) switch (o.type) {
          case "Point":
          case "LineString":
          case "MultiPoint":
          case "Polygon":
          case "MultiLineString":
          case "MultiPolygon":
            if (!1 === e(o, p, u, h, c)) return !1;
            break;
          case "GeometryCollection":
            for (i = 0; i < o.geometries.length; i++) if (!1 === e(o.geometries[i], p, u, h, c)) return !1;
            break;
          default:
            throw new Error("Unknown Geometry Type");
        } else if (!1 === e(null, p, u, h, c)) return !1;
        p++;
      }
    }
    function c(t, e, n) {
      var i = n;
      return h(t, function (t, r, o, s, a) {
        i = 0 === r && void 0 === n ? t : e(i, t, r, o, s, a);
      }), i;
    }
    function p(t, n) {
      h(t, function (t, i, r, o, s) {
        var a,
          l = null === t ? null : t.type;
        switch (l) {
          case null:
          case "Point":
          case "LineString":
          case "Polygon":
            return !1 !== n(e.feature(t, r, {
              bbox: o,
              id: s
            }), i, 0) && void 0;
        }
        switch (l) {
          case "MultiPoint":
            a = "Point";
            break;
          case "MultiLineString":
            a = "LineString";
            break;
          case "MultiPolygon":
            a = "Polygon";
        }
        for (var u = 0; u < t.coordinates.length; u++) {
          var h = {
            type: a,
            coordinates: t.coordinates[u]
          };
          if (!1 === n(e.feature(h, r), i, u)) return !1;
        }
      });
    }
    function d(t, e, n) {
      var i = n;
      return p(t, function (t, r, o) {
        i = 0 === r && 0 === o && void 0 === n ? t : e(i, t, r, o);
      }), i;
    }
    function f(t, i) {
      p(t, function (t, r, o) {
        var s = 0;
        if (t.geometry) {
          var a = t.geometry.type;
          if ("Point" !== a && "MultiPoint" !== a) {
            var l,
              u = 0,
              h = 0,
              c = 0;
            if (!1 === n(t, function (n, a, p, d, f) {
              if (void 0 === l || r > u || d > h || f > c) return l = n, u = r, h = d, c = f, void (s = 0);
              var m = e.lineString([l, n], t.properties);
              if (!1 === i(m, r, o, f, s)) return !1;
              s++, l = n;
            })) return !1;
          }
        }
      });
    }
    function m(t, e, n) {
      var i = n,
        r = !1;
      return f(t, function (t, o, s, a, l) {
        i = !1 === r && void 0 === n ? t : e(i, t, o, s, a, l), r = !0;
      }), i;
    }
    function g(t, n) {
      if (!t) throw new Error("geojson is required");
      p(t, function (t, i, r) {
        if (null !== t.geometry) {
          var o = t.geometry.type,
            s = t.geometry.coordinates;
          switch (o) {
            case "LineString":
              if (!1 === n(t, i, r, 0, 0)) return !1;
              break;
            case "Polygon":
              for (var a = 0; a < s.length; a++) if (!1 === n(e.lineString(s[a], t.properties), i, r, a)) return !1;
          }
        }
      });
    }
    function v(t, e, n) {
      var i = n;
      return g(t, function (t, r, o, s) {
        i = 0 === r && void 0 === n ? t : e(i, t, r, o, s);
      }), i;
    }
    function y(t, n) {
      if (n = n || {}, !e.isObject(n)) throw new Error("options is invalid");
      var i,
        r = n.featureIndex || 0,
        o = n.multiFeatureIndex || 0,
        s = n.geometryIndex || 0,
        a = n.segmentIndex || 0,
        l = n.properties;
      switch (t.type) {
        case "FeatureCollection":
          r < 0 && (r = t.features.length + r), l = l || t.features[r].properties, i = t.features[r].geometry;
          break;
        case "Feature":
          l = l || t.properties, i = t.geometry;
          break;
        case "Point":
        case "MultiPoint":
          return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
          i = t;
          break;
        default:
          throw new Error("geojson is invalid");
      }
      if (null === i) return null;
      var u = i.coordinates;
      switch (i.type) {
        case "Point":
        case "MultiPoint":
          return null;
        case "LineString":
          return a < 0 && (a = u.length + a - 1), e.lineString([u[a], u[a + 1]], l, n);
        case "Polygon":
          return s < 0 && (s = u.length + s), a < 0 && (a = u[s].length + a - 1), e.lineString([u[s][a], u[s][a + 1]], l, n);
        case "MultiLineString":
          return o < 0 && (o = u.length + o), a < 0 && (a = u[o].length + a - 1), e.lineString([u[o][a], u[o][a + 1]], l, n);
        case "MultiPolygon":
          return o < 0 && (o = u.length + o), s < 0 && (s = u[o].length + s), a < 0 && (a = u[o][s].length - a - 1), e.lineString([u[o][s][a], u[o][s][a + 1]], l, n);
      }
      throw new Error("geojson is invalid");
    }
    function _(t, n) {
      if (n = n || {}, !e.isObject(n)) throw new Error("options is invalid");
      var i,
        r = n.featureIndex || 0,
        o = n.multiFeatureIndex || 0,
        s = n.geometryIndex || 0,
        a = n.coordIndex || 0,
        l = n.properties;
      switch (t.type) {
        case "FeatureCollection":
          r < 0 && (r = t.features.length + r), l = l || t.features[r].properties, i = t.features[r].geometry;
          break;
        case "Feature":
          l = l || t.properties, i = t.geometry;
          break;
        case "Point":
        case "MultiPoint":
          return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
          i = t;
          break;
        default:
          throw new Error("geojson is invalid");
      }
      if (null === i) return null;
      var u = i.coordinates;
      switch (i.type) {
        case "Point":
          return e.point(u, l, n);
        case "MultiPoint":
          return o < 0 && (o = u.length + o), e.point(u[o], l, n);
        case "LineString":
          return a < 0 && (a = u.length + a), e.point(u[a], l, n);
        case "Polygon":
          return s < 0 && (s = u.length + s), a < 0 && (a = u[s].length + a), e.point(u[s][a], l, n);
        case "MultiLineString":
          return o < 0 && (o = u.length + o), a < 0 && (a = u[o].length + a), e.point(u[o][a], l, n);
        case "MultiPolygon":
          return o < 0 && (o = u.length + o), s < 0 && (s = u[o].length + s), a < 0 && (a = u[o][s].length - a), e.point(u[o][s][a], l, n);
      }
      throw new Error("geojson is invalid");
    }
    u(n, "coordEach"), u(i, "coordReduce"), u(r, "propEach"), u(o, "propReduce"), u(s, "featureEach"), u(a, "featureReduce"), u(l, "coordAll"), u(h, "geomEach"), u(c, "geomReduce"), u(p, "flattenEach"), u(d, "flattenReduce"), u(f, "segmentEach"), u(m, "segmentReduce"), u(g, "lineEach"), u(v, "lineReduce"), u(y, "findSegment"), u(_, "findPoint"), t.coordAll = l, t.coordEach = n, t.coordReduce = i, t.featureEach = s, t.featureReduce = a, t.findPoint = _, t.findSegment = y, t.flattenEach = p, t.flattenReduce = d, t.geomEach = h, t.geomReduce = c, t.lineEach = g, t.lineReduce = v, t.propEach = r, t.propReduce = o, t.segmentEach = f, t.segmentReduce = m;
  }),
  fN = ze(t => {
    E(), Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var e = L5();
    function n(t) {
      var n = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
      return e.coordEach(t, function (t) {
        n[0] > t[0] && (n[0] = t[0]), n[1] > t[1] && (n[1] = t[1]), n[2] < t[0] && (n[2] = t[0]), n[3] < t[1] && (n[3] = t[1]);
      }), n;
    }
    u(n, "bbox"), n.default = n, t.default = n;
  }),
  SM = ze((t, e) => {
    E();
    var n = nN(),
      i = A5(),
      r = L5(),
      o = fN().default,
      s = r.featureEach,
      a = (r.coordEach, i.polygon, i.featureCollection);
    function l(t) {
      var e = new n(t);
      return e.insert = function (t) {
        if ("Feature" !== t.type) throw new Error("invalid feature");
        return t.bbox = t.bbox ? t.bbox : o(t), n.prototype.insert.call(this, t);
      }, e.load = function (t) {
        var e = [];
        return Array.isArray(t) ? t.forEach(function (t) {
          if ("Feature" !== t.type) throw new Error("invalid features");
          t.bbox = t.bbox ? t.bbox : o(t), e.push(t);
        }) : s(t, function (t) {
          if ("Feature" !== t.type) throw new Error("invalid features");
          t.bbox = t.bbox ? t.bbox : o(t), e.push(t);
        }), n.prototype.load.call(this, e);
      }, e.remove = function (t, e) {
        if ("Feature" !== t.type) throw new Error("invalid feature");
        return t.bbox = t.bbox ? t.bbox : o(t), n.prototype.remove.call(this, t, e);
      }, e.clear = function () {
        return n.prototype.clear.call(this);
      }, e.search = function (t) {
        var e = n.prototype.search.call(this, this.toBBox(t));
        return a(e);
      }, e.collides = function (t) {
        return n.prototype.collides.call(this, this.toBBox(t));
      }, e.all = function () {
        var t = n.prototype.all.call(this);
        return a(t);
      }, e.toJSON = function () {
        return n.prototype.toJSON.call(this);
      }, e.fromJSON = function (t) {
        return n.prototype.fromJSON.call(this, t);
      }, e.toBBox = function (t) {
        var e;
        if (t.bbox) e = t.bbox;else if (Array.isArray(t) && 4 === t.length) e = t;else if (Array.isArray(t) && 6 === t.length) e = [t[0], t[1], t[3], t[4]];else if ("Feature" === t.type) e = o(t);else {
          if ("FeatureCollection" !== t.type) throw new Error("invalid geojson");
          e = o(t);
        }
        return {
          minX: e[0],
          minY: e[1],
          maxX: e[2],
          maxY: e[3]
        };
      }, e;
    }
    u(l, "geojsonRbush"), e.exports = l, e.exports.default = l;
  }),
  B5 = ze((t, e) => {
    E();
    var n = Object.prototype.toString;
    e.exports = u(function (t) {
      var e = n.call(t),
        i = "[object Arguments]" === e;
      return i || (i = "[object Array]" !== e && null !== t && "object" == typeof t && "number" == typeof t.length && t.length >= 0 && "[object Function]" === n.call(t.callee)), i;
    }, "isArguments");
  }),
  DN = ze((t, e) => {
    var n, i, r, o, s, a, l, h, c, p, d, f;
    E(), Object.keys || (i = Object.prototype.hasOwnProperty, r = Object.prototype.toString, o = B5(), s = Object.prototype.propertyIsEnumerable, a = !s.call({
      toString: null
    }, "toString"), l = s.call(function () {}, "prototype"), h = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"], c = u(function (t) {
      var e = t.constructor;
      return e && e.prototype === t;
    }, "equalsConstructorPrototype"), p = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, d = function () {
      if ("undefined" == typeof window) return !1;
      for (var t in window) try {
        if (!p["$" + t] && i.call(window, t) && null !== window[t] && "object" == typeof window[t]) try {
          c(window[t]);
        } catch (t) {
          return !0;
        }
      } catch (t) {
        return !0;
      }
      return !1;
    }(), f = u(function (t) {
      if ("undefined" == typeof window || !d) return c(t);
      try {
        return c(t);
      } catch (t) {
        return !1;
      }
    }, "equalsConstructorPrototypeIfNotBuggy"), n = u(function (t) {
      var e = null !== t && "object" == typeof t,
        n = "[object Function]" === r.call(t),
        s = o(t),
        u = e && "[object String]" === r.call(t),
        c = [];
      if (!e && !n && !s) throw new TypeError("Object.keys called on a non-object");
      var p = l && n;
      if (u && t.length > 0 && !i.call(t, 0)) for (var d = 0; d < t.length; ++d) c.push(String(d));
      if (s && t.length > 0) for (var m = 0; m < t.length; ++m) c.push(String(m));else for (var g in t) (!p || "prototype" !== g) && i.call(t, g) && c.push(String(g));
      if (a) for (var v = f(t), y = 0; y < h.length; ++y) (!v || "constructor" !== h[y]) && i.call(t, h[y]) && c.push(h[y]);
      return c;
    }, "keys")), e.exports = n;
  }),
  IM = ze((t, e) => {
    E();
    var n = Array.prototype.slice,
      i = B5(),
      r = Object.keys,
      o = r ? u(function (t) {
        return r(t);
      }, "keys") : DN(),
      s = Object.keys;
    o.shim = u(function () {
      if (Object.keys) {
        var t = function () {
          var t = Object.keys(arguments);
          return t && t.length === arguments.length;
        }(1, 2);
        t || (Object.keys = u(function (t) {
          return i(t) ? s(n.call(t)) : s(t);
        }, "keys"));
      } else Object.keys = o;
      return Object.keys || o;
    }, "shimObjectKeys"), e.exports = o;
  }),
  UN = ze((t, e) => {
    E(), e.exports = u(function () {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" == typeof Symbol.iterator) return !0;
      var t = {},
        e = Symbol("test"),
        n = Object(e);
      if ("string" == typeof e || "[object Symbol]" !== Object.prototype.toString.call(e) || "[object Symbol]" !== Object.prototype.toString.call(n)) return !1;
      for (e in t[e] = 42, t) return !1;
      if ("function" == typeof Object.keys && 0 !== Object.keys(t).length || "function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
      var i = Object.getOwnPropertySymbols(t);
      if (1 !== i.length || i[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e)) return !1;
      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var r = Object.getOwnPropertyDescriptor(t, e);
        if (42 !== r.value || !0 !== r.enumerable) return !1;
      }
      return !0;
    }, "hasSymbols");
  }),
  V5 = ze((t, e) => {
    E();
    var n = UN();
    e.exports = u(function () {
      return n() && !!Symbol.toStringTag;
    }, "hasToStringTagShams");
  }),
  GN = ze((t, e) => {
    E(), e.exports = u(function () {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" == typeof Symbol.iterator) return !0;
      var t = {},
        e = Symbol("test"),
        n = Object(e);
      if ("string" == typeof e || "[object Symbol]" !== Object.prototype.toString.call(e) || "[object Symbol]" !== Object.prototype.toString.call(n)) return !1;
      for (e in t[e] = 42, t) return !1;
      if ("function" == typeof Object.keys && 0 !== Object.keys(t).length || "function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
      var i = Object.getOwnPropertySymbols(t);
      if (1 !== i.length || i[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e)) return !1;
      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var r = Object.getOwnPropertyDescriptor(t, e);
        if (42 !== r.value || !0 !== r.enumerable) return !1;
      }
      return !0;
    }, "hasSymbols");
  }),
  WN = ze((t, e) => {
    E();
    var n = "undefined" != typeof Symbol && Symbol,
      i = GN();
    e.exports = u(function () {
      return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && i();
    }, "hasNativeSymbols");
  }),
  YN = ze((t, e) => {
    E();
    var n = "Function.prototype.bind called on incompatible ",
      i = Array.prototype.slice,
      r = Object.prototype.toString,
      o = "[object Function]";
    e.exports = u(function (t) {
      var e = this;
      if ("function" != typeof e || r.call(e) !== o) throw new TypeError(n + e);
      for (var s, a = i.call(arguments, 1), l = u(function () {
          if (this instanceof s) {
            var n = e.apply(this, a.concat(i.call(arguments)));
            return Object(n) === n ? n : this;
          }
          return e.apply(t, a.concat(i.call(arguments)));
        }, "binder"), h = Math.max(0, e.length - a.length), c = [], p = 0; p < h; p++) c.push("$" + p);
      if (s = Function("binder", "return function (" + c.join(",") + "){ return binder.apply(this,arguments); }")(l), e.prototype) {
        var d = u(function () {}, "Empty");
        d.prototype = e.prototype, s.prototype = new d(), d.prototype = null;
      }
      return s;
    }, "bind");
  }),
  Fv = ze((t, e) => {
    E();
    var n = YN();
    e.exports = Function.prototype.bind || n;
  }),
  H5 = ze((t, e) => {
    E();
    var n = Fv();
    e.exports = n.call(Function.call, Object.prototype.hasOwnProperty);
  }),
  X5 = ze((t, e) => {
    E();
    var n,
      i = SyntaxError,
      r = Function,
      o = TypeError,
      s = u(function (t) {
        try {
          return r('"use strict"; return (' + t + ").constructor;")();
        } catch (t) {}
      }, "getEvalledConstructor"),
      a = Object.getOwnPropertyDescriptor;
    if (a) try {
      a({}, "");
    } catch (t) {
      a = null;
    }
    var l = u(function () {
        throw new o();
      }, "throwTypeError"),
      h = a ? function () {
        try {
          return l;
        } catch (t) {
          try {
            return a(arguments, "callee").get;
          } catch (t) {
            return l;
          }
        }
      }() : l,
      c = WN()(),
      p = Object.getPrototypeOf || function (t) {
        return t.__proto__;
      },
      d = {},
      f = "undefined" == typeof Uint8Array ? n : p(Uint8Array),
      m = {
        "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
        "%Array%": Array,
        "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
        "%ArrayIteratorPrototype%": c ? p([][Symbol.iterator]()) : n,
        "%AsyncFromSyncIteratorPrototype%": n,
        "%AsyncFunction%": d,
        "%AsyncGenerator%": d,
        "%AsyncGeneratorFunction%": d,
        "%AsyncIteratorPrototype%": d,
        "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
        "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
        "%Boolean%": Boolean,
        "%DataView%": "undefined" == typeof DataView ? n : DataView,
        "%Date%": Date,
        "%decodeURI%": decodeURI,
        "%decodeURIComponent%": decodeURIComponent,
        "%encodeURI%": encodeURI,
        "%encodeURIComponent%": encodeURIComponent,
        "%Error%": Error,
        "%eval%": eval,
        "%EvalError%": EvalError,
        "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
        "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
        "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
        "%Function%": r,
        "%GeneratorFunction%": d,
        "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
        "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
        "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
        "%isFinite%": isFinite,
        "%isNaN%": isNaN,
        "%IteratorPrototype%": c ? p(p([][Symbol.iterator]())) : n,
        "%JSON%": "object" == typeof JSON ? JSON : n,
        "%Map%": "undefined" == typeof Map ? n : Map,
        "%MapIteratorPrototype%": "undefined" != typeof Map && c ? p(new Map()[Symbol.iterator]()) : n,
        "%Math%": Math,
        "%Number%": Number,
        "%Object%": Object,
        "%parseFloat%": parseFloat,
        "%parseInt%": parseInt,
        "%Promise%": "undefined" == typeof Promise ? n : Promise,
        "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
        "%RangeError%": RangeError,
        "%ReferenceError%": ReferenceError,
        "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
        "%RegExp%": RegExp,
        "%Set%": "undefined" == typeof Set ? n : Set,
        "%SetIteratorPrototype%": "undefined" != typeof Set && c ? p(new Set()[Symbol.iterator]()) : n,
        "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
        "%String%": String,
        "%StringIteratorPrototype%": c ? p(""[Symbol.iterator]()) : n,
        "%Symbol%": c ? Symbol : n,
        "%SyntaxError%": i,
        "%ThrowTypeError%": h,
        "%TypedArray%": f,
        "%TypeError%": o,
        "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
        "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
        "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
        "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
        "%URIError%": URIError,
        "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
        "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
        "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet
      },
      g = u(function t(e) {
        var n;
        if ("%AsyncFunction%" === e) n = s("async function () {}");else if ("%GeneratorFunction%" === e) n = s("function* () {}");else if ("%AsyncGeneratorFunction%" === e) n = s("async function* () {}");else if ("%AsyncGenerator%" === e) {
          var i = t("%AsyncGeneratorFunction%");
          i && (n = i.prototype);
        } else if ("%AsyncIteratorPrototype%" === e) {
          var r = t("%AsyncGenerator%");
          r && (n = p(r.prototype));
        }
        return m[e] = n, n;
      }, "doEval"),
      v = {
        "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
        "%ArrayPrototype%": ["Array", "prototype"],
        "%ArrayProto_entries%": ["Array", "prototype", "entries"],
        "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
        "%ArrayProto_keys%": ["Array", "prototype", "keys"],
        "%ArrayProto_values%": ["Array", "prototype", "values"],
        "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
        "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
        "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
        "%BooleanPrototype%": ["Boolean", "prototype"],
        "%DataViewPrototype%": ["DataView", "prototype"],
        "%DatePrototype%": ["Date", "prototype"],
        "%ErrorPrototype%": ["Error", "prototype"],
        "%EvalErrorPrototype%": ["EvalError", "prototype"],
        "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
        "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
        "%FunctionPrototype%": ["Function", "prototype"],
        "%Generator%": ["GeneratorFunction", "prototype"],
        "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
        "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
        "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
        "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
        "%JSONParse%": ["JSON", "parse"],
        "%JSONStringify%": ["JSON", "stringify"],
        "%MapPrototype%": ["Map", "prototype"],
        "%NumberPrototype%": ["Number", "prototype"],
        "%ObjectPrototype%": ["Object", "prototype"],
        "%ObjProto_toString%": ["Object", "prototype", "toString"],
        "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
        "%PromisePrototype%": ["Promise", "prototype"],
        "%PromiseProto_then%": ["Promise", "prototype", "then"],
        "%Promise_all%": ["Promise", "all"],
        "%Promise_reject%": ["Promise", "reject"],
        "%Promise_resolve%": ["Promise", "resolve"],
        "%RangeErrorPrototype%": ["RangeError", "prototype"],
        "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
        "%RegExpPrototype%": ["RegExp", "prototype"],
        "%SetPrototype%": ["Set", "prototype"],
        "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
        "%StringPrototype%": ["String", "prototype"],
        "%SymbolPrototype%": ["Symbol", "prototype"],
        "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
        "%TypedArrayPrototype%": ["TypedArray", "prototype"],
        "%TypeErrorPrototype%": ["TypeError", "prototype"],
        "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
        "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
        "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
        "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
        "%URIErrorPrototype%": ["URIError", "prototype"],
        "%WeakMapPrototype%": ["WeakMap", "prototype"],
        "%WeakSetPrototype%": ["WeakSet", "prototype"]
      },
      y = Fv(),
      _ = H5(),
      x = y.call(Function.call, Array.prototype.concat),
      b = y.call(Function.apply, Array.prototype.splice),
      w = y.call(Function.call, String.prototype.replace),
      S = y.call(Function.call, String.prototype.slice),
      M = y.call(Function.call, RegExp.prototype.exec),
      T = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
      A = /\\(\\)?/g,
      P = u(function (t) {
        var e = S(t, 0, 1),
          n = S(t, -1);
        if ("%" === e && "%" !== n) throw new i("invalid intrinsic syntax, expected closing `%`");
        if ("%" === n && "%" !== e) throw new i("invalid intrinsic syntax, expected opening `%`");
        var r = [];
        return w(t, T, function (t, e, n, i) {
          r[r.length] = n ? w(i, A, "$1") : e || t;
        }), r;
      }, "stringToPath"),
      C = u(function (t, e) {
        var n,
          r = t;
        if (_(v, r) && (r = "%" + (n = v[r])[0] + "%"), _(m, r)) {
          var s = m[r];
          if (s === d && (s = g(r)), void 0 === s && !e) throw new o("intrinsic " + t + " exists, but is not available. Please file an issue!");
          return {
            alias: n,
            name: r,
            value: s
          };
        }
        throw new i("intrinsic " + t + " does not exist!");
      }, "getBaseIntrinsic");
    e.exports = u(function (t, e) {
      if ("string" != typeof t || 0 === t.length) throw new o("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" != typeof e) throw new o('"allowMissing" argument must be a boolean');
      if (null === M(/^%?[^%]*%?$/g, t)) throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      var n = P(t),
        r = n.length > 0 ? n[0] : "",
        s = C("%" + r + "%", e),
        l = s.name,
        u = s.value,
        h = !1,
        c = s.alias;
      c && (r = c[0], b(n, x([0, 1], c)));
      for (var p = 1, d = !0; p < n.length; p += 1) {
        var f = n[p],
          g = S(f, 0, 1),
          v = S(f, -1);
        if (('"' === g || "'" === g || "`" === g || '"' === v || "'" === v || "`" === v) && g !== v) throw new i("property names with quotes must have matching quotes");
        if (("constructor" === f || !d) && (h = !0), _(m, l = "%" + (r += "." + f) + "%")) u = m[l];else if (null != u) {
          if (!(f in u)) {
            if (!e) throw new o("base intrinsic for " + t + " exists, but the property is not available.");
            return;
          }
          if (a && p + 1 >= n.length) {
            var y = a(u, f);
            u = (d = !!y) && "get" in y && !("originalValue" in y.get) ? y.get : u[f];
          } else d = _(u, f), u = u[f];
          d && !h && (m[l] = u);
        }
      }
      return u;
    }, "GetIntrinsic");
  }),
  NM = ze((t, e) => {
    E();
    var n = Fv(),
      i = X5(),
      r = i("%Function.prototype.apply%"),
      o = i("%Function.prototype.call%"),
      s = i("%Reflect.apply%", !0) || n.call(o, r),
      a = i("%Object.getOwnPropertyDescriptor%", !0),
      l = i("%Object.defineProperty%", !0),
      h = i("%Math.max%");
    if (l) try {
      l({}, "a", {
        value: 1
      });
    } catch (t) {
      l = null;
    }
    e.exports = u(function (t) {
      var e = s(n, o, arguments);
      if (a && l) {
        var i = a(e, "length");
        i.configurable && l(e, "length", {
          value: 1 + h(0, t.length - (arguments.length - 1))
        });
      }
      return e;
    }, "callBind");
    var c = u(function () {
      return s(n, r, arguments);
    }, "applyBind");
    l ? l(e.exports, "apply", {
      value: c
    }) : e.exports.apply = c;
  }),
  Z5 = ze((t, e) => {
    E();
    var n = X5(),
      i = NM(),
      r = i(n("String.prototype.indexOf"));
    e.exports = u(function (t, e) {
      var o = n(t, !!e);
      return "function" == typeof o && r(t, ".prototype.") > -1 ? i(o) : o;
    }, "callBoundIntrinsic");
  }),
  hD = ze((t, e) => {
    E();
    var n = V5()(),
      i = Z5()("Object.prototype.toString"),
      r = u(function (t) {
        return !(n && t && "object" == typeof t && Symbol.toStringTag in t) && "[object Arguments]" === i(t);
      }, "isArguments"),
      o = u(function (t) {
        return !!r(t) || null !== t && "object" == typeof t && "number" == typeof t.length && t.length >= 0 && "[object Array]" !== i(t) && "[object Function]" === i(t.callee);
      }, "isArguments"),
      s = function () {
        return r(arguments);
      }();
    r.isLegacyArguments = o, e.exports = s ? r : o;
  }),
  Q5 = ze((t, e) => {
    E();
    var n = IM(),
      i = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
      r = Object.prototype.toString,
      o = Array.prototype.concat,
      s = Object.defineProperty,
      a = u(function (t) {
        return "function" == typeof t && "[object Function]" === r.call(t);
      }, "isFunction"),
      l = u(function () {
        var t = {};
        try {
          for (var e in s(t, "x", {
            enumerable: !1,
            value: t
          }), t) return !1;
          return t.x === t;
        } catch (t) {
          return !1;
        }
      }, "arePropertyDescriptorsSupported"),
      h = s && l(),
      c = u(function (t, e, n, i) {
        e in t && (!a(i) || !i()) || (h ? s(t, e, {
          configurable: !0,
          enumerable: !1,
          value: n,
          writable: !0
        }) : t[e] = n);
      }, "defineProperty"),
      p = u(function (t, e) {
        var r = arguments.length > 2 ? arguments[2] : {},
          s = n(e);
        i && (s = o.call(s, Object.getOwnPropertySymbols(e)));
        for (var a = 0; a < s.length; a += 1) c(t, s[a], e[s[a]], r[s[a]]);
      }, "defineProperties");
    p.supportsDescriptors = !!h, e.exports = p;
  }),
  $5 = ze((t, e) => {
    E();
    var n = u(function (t) {
      return t != t;
    }, "numberIsNaN");
    e.exports = u(function (t, e) {
      return 0 === t && 0 === e ? 1 / t == 1 / e : !!(t === e || n(t) && n(e));
    }, "is");
  }),
  eP = ze((t, e) => {
    E();
    var n = $5();
    e.exports = u(function () {
      return "function" == typeof Object.is ? Object.is : n;
    }, "getPolyfill");
  }),
  _D = ze((t, e) => {
    E();
    var n = eP(),
      i = Q5();
    e.exports = u(function () {
      var t = n();
      return i(Object, {
        is: t
      }, {
        is: u(function () {
          return Object.is !== t;
        }, "testObjectIs")
      }), t;
    }, "shimObjectIs");
  }),
  ED = ze((t, e) => {
    E();
    var n = Q5(),
      i = NM(),
      r = $5(),
      o = eP(),
      s = _D(),
      a = i(o(), Object);
    n(a, {
      getPolyfill: o,
      implementation: r,
      shim: s
    }), e.exports = a;
  }),
  CD = ze((t, e) => {
    E();
    var n,
      i,
      r,
      o,
      s = Z5(),
      a = V5()();
    a && (n = s("Object.prototype.hasOwnProperty"), i = s("RegExp.prototype.exec"), r = {}, l = u(function () {
      throw r;
    }, "throwRegexMarker"), o = {
      toString: l,
      valueOf: l
    }, "symbol" == typeof Symbol.toPrimitive && (o[Symbol.toPrimitive] = l));
    var l,
      h = s("Object.prototype.toString"),
      c = Object.getOwnPropertyDescriptor;
    e.exports = u(a ? function (t) {
      if (!t || "object" != typeof t) return !1;
      var e = c(t, "lastIndex");
      if (!(e && n(e, "value"))) return !1;
      try {
        i(t, o);
      } catch (t) {
        return t === r;
      }
    } : function (t) {
      return !(!t || "object" != typeof t && "function" != typeof t) && "[object RegExp]" === h(t);
    }, "isRegex");
  }),
  ID = ze((t, e) => {
    E(), e.exports = u(function () {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" == typeof Symbol.iterator) return !0;
      var t = {},
        e = Symbol("test"),
        n = Object(e);
      if ("string" == typeof e || "[object Symbol]" !== Object.prototype.toString.call(e) || "[object Symbol]" !== Object.prototype.toString.call(n)) return !1;
      for (e in t[e] = 42, t) return !1;
      if ("function" == typeof Object.keys && 0 !== Object.keys(t).length || "function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
      var i = Object.getOwnPropertySymbols(t);
      if (1 !== i.length || i[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e)) return !1;
      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var r = Object.getOwnPropertyDescriptor(t, e);
        if (42 !== r.value || !0 !== r.enumerable) return !1;
      }
      return !0;
    }, "hasSymbols");
  }),
  RD = ze((t, e) => {
    E();
    var n = "undefined" != typeof Symbol && Symbol,
      i = ID();
    e.exports = u(function () {
      return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && i();
    }, "hasNativeSymbols");
  }),
  FD = ze((t, e) => {
    E();
    var n,
      i = SyntaxError,
      r = Function,
      o = TypeError,
      s = u(function (t) {
        try {
          return r('"use strict"; return (' + t + ").constructor;")();
        } catch (t) {}
      }, "getEvalledConstructor"),
      a = Object.getOwnPropertyDescriptor;
    if (a) try {
      a({}, "");
    } catch (t) {
      a = null;
    }
    var l = u(function () {
        throw new o();
      }, "throwTypeError"),
      h = a ? function () {
        try {
          return l;
        } catch (t) {
          try {
            return a(arguments, "callee").get;
          } catch (t) {
            return l;
          }
        }
      }() : l,
      c = RD()(),
      p = Object.getPrototypeOf || function (t) {
        return t.__proto__;
      },
      d = {},
      f = "undefined" == typeof Uint8Array ? n : p(Uint8Array),
      m = {
        "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
        "%Array%": Array,
        "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
        "%ArrayIteratorPrototype%": c ? p([][Symbol.iterator]()) : n,
        "%AsyncFromSyncIteratorPrototype%": n,
        "%AsyncFunction%": d,
        "%AsyncGenerator%": d,
        "%AsyncGeneratorFunction%": d,
        "%AsyncIteratorPrototype%": d,
        "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
        "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
        "%Boolean%": Boolean,
        "%DataView%": "undefined" == typeof DataView ? n : DataView,
        "%Date%": Date,
        "%decodeURI%": decodeURI,
        "%decodeURIComponent%": decodeURIComponent,
        "%encodeURI%": encodeURI,
        "%encodeURIComponent%": encodeURIComponent,
        "%Error%": Error,
        "%eval%": eval,
        "%EvalError%": EvalError,
        "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
        "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
        "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
        "%Function%": r,
        "%GeneratorFunction%": d,
        "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
        "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
        "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
        "%isFinite%": isFinite,
        "%isNaN%": isNaN,
        "%IteratorPrototype%": c ? p(p([][Symbol.iterator]())) : n,
        "%JSON%": "object" == typeof JSON ? JSON : n,
        "%Map%": "undefined" == typeof Map ? n : Map,
        "%MapIteratorPrototype%": "undefined" != typeof Map && c ? p(new Map()[Symbol.iterator]()) : n,
        "%Math%": Math,
        "%Number%": Number,
        "%Object%": Object,
        "%parseFloat%": parseFloat,
        "%parseInt%": parseInt,
        "%Promise%": "undefined" == typeof Promise ? n : Promise,
        "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
        "%RangeError%": RangeError,
        "%ReferenceError%": ReferenceError,
        "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
        "%RegExp%": RegExp,
        "%Set%": "undefined" == typeof Set ? n : Set,
        "%SetIteratorPrototype%": "undefined" != typeof Set && c ? p(new Set()[Symbol.iterator]()) : n,
        "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
        "%String%": String,
        "%StringIteratorPrototype%": c ? p(""[Symbol.iterator]()) : n,
        "%Symbol%": c ? Symbol : n,
        "%SyntaxError%": i,
        "%ThrowTypeError%": h,
        "%TypedArray%": f,
        "%TypeError%": o,
        "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
        "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
        "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
        "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
        "%URIError%": URIError,
        "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
        "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
        "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet
      },
      g = u(function t(e) {
        var n;
        if ("%AsyncFunction%" === e) n = s("async function () {}");else if ("%GeneratorFunction%" === e) n = s("function* () {}");else if ("%AsyncGeneratorFunction%" === e) n = s("async function* () {}");else if ("%AsyncGenerator%" === e) {
          var i = t("%AsyncGeneratorFunction%");
          i && (n = i.prototype);
        } else if ("%AsyncIteratorPrototype%" === e) {
          var r = t("%AsyncGenerator%");
          r && (n = p(r.prototype));
        }
        return m[e] = n, n;
      }, "doEval"),
      v = {
        "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
        "%ArrayPrototype%": ["Array", "prototype"],
        "%ArrayProto_entries%": ["Array", "prototype", "entries"],
        "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
        "%ArrayProto_keys%": ["Array", "prototype", "keys"],
        "%ArrayProto_values%": ["Array", "prototype", "values"],
        "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
        "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
        "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
        "%BooleanPrototype%": ["Boolean", "prototype"],
        "%DataViewPrototype%": ["DataView", "prototype"],
        "%DatePrototype%": ["Date", "prototype"],
        "%ErrorPrototype%": ["Error", "prototype"],
        "%EvalErrorPrototype%": ["EvalError", "prototype"],
        "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
        "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
        "%FunctionPrototype%": ["Function", "prototype"],
        "%Generator%": ["GeneratorFunction", "prototype"],
        "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
        "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
        "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
        "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
        "%JSONParse%": ["JSON", "parse"],
        "%JSONStringify%": ["JSON", "stringify"],
        "%MapPrototype%": ["Map", "prototype"],
        "%NumberPrototype%": ["Number", "prototype"],
        "%ObjectPrototype%": ["Object", "prototype"],
        "%ObjProto_toString%": ["Object", "prototype", "toString"],
        "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
        "%PromisePrototype%": ["Promise", "prototype"],
        "%PromiseProto_then%": ["Promise", "prototype", "then"],
        "%Promise_all%": ["Promise", "all"],
        "%Promise_reject%": ["Promise", "reject"],
        "%Promise_resolve%": ["Promise", "resolve"],
        "%RangeErrorPrototype%": ["RangeError", "prototype"],
        "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
        "%RegExpPrototype%": ["RegExp", "prototype"],
        "%SetPrototype%": ["Set", "prototype"],
        "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
        "%StringPrototype%": ["String", "prototype"],
        "%SymbolPrototype%": ["Symbol", "prototype"],
        "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
        "%TypedArrayPrototype%": ["TypedArray", "prototype"],
        "%TypeErrorPrototype%": ["TypeError", "prototype"],
        "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
        "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
        "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
        "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
        "%URIErrorPrototype%": ["URIError", "prototype"],
        "%WeakMapPrototype%": ["WeakMap", "prototype"],
        "%WeakSetPrototype%": ["WeakSet", "prototype"]
      },
      y = Fv(),
      _ = H5(),
      x = y.call(Function.call, Array.prototype.concat),
      b = y.call(Function.apply, Array.prototype.splice),
      w = y.call(Function.call, String.prototype.replace),
      S = y.call(Function.call, String.prototype.slice),
      M = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
      T = /\\(\\)?/g,
      A = u(function (t) {
        var e = S(t, 0, 1),
          n = S(t, -1);
        if ("%" === e && "%" !== n) throw new i("invalid intrinsic syntax, expected closing `%`");
        if ("%" === n && "%" !== e) throw new i("invalid intrinsic syntax, expected opening `%`");
        var r = [];
        return w(t, M, function (t, e, n, i) {
          r[r.length] = n ? w(i, T, "$1") : e || t;
        }), r;
      }, "stringToPath"),
      P = u(function (t, e) {
        var n,
          r = t;
        if (_(v, r) && (r = "%" + (n = v[r])[0] + "%"), _(m, r)) {
          var s = m[r];
          if (s === d && (s = g(r)), void 0 === s && !e) throw new o("intrinsic " + t + " exists, but is not available. Please file an issue!");
          return {
            alias: n,
            name: r,
            value: s
          };
        }
        throw new i("intrinsic " + t + " does not exist!");
      }, "getBaseIntrinsic");
    e.exports = u(function (t, e) {
      if ("string" != typeof t || 0 === t.length) throw new o("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" != typeof e) throw new o('"allowMissing" argument must be a boolean');
      var n = A(t),
        r = n.length > 0 ? n[0] : "",
        s = P("%" + r + "%", e),
        l = s.name,
        u = s.value,
        h = !1,
        c = s.alias;
      c && (r = c[0], b(n, x([0, 1], c)));
      for (var p = 1, d = !0; p < n.length; p += 1) {
        var f = n[p],
          g = S(f, 0, 1),
          v = S(f, -1);
        if (('"' === g || "'" === g || "`" === g || '"' === v || "'" === v || "`" === v) && g !== v) throw new i("property names with quotes must have matching quotes");
        if (("constructor" === f || !d) && (h = !0), _(m, l = "%" + (r += "." + f) + "%")) u = m[l];else if (null != u) {
          if (!(f in u)) {
            if (!e) throw new o("base intrinsic for " + t + " exists, but the property is not available.");
            return;
          }
          if (a && p + 1 >= n.length) {
            var y = a(u, f);
            u = (d = !!y) && "get" in y && !("originalValue" in y.get) ? y.get : u[f];
          } else d = _(u, f), u = u[f];
          d && !h && (m[l] = u);
        }
      }
      return u;
    }, "GetIntrinsic");
  }),
  UD = ze((t, e) => {
    E();
    var n = FD()("%Object.defineProperty%", !0),
      i = u(function () {
        if (n) try {
          return n({}, "a", {
            value: 1
          }), !0;
        } catch (t) {
          return !1;
        }
        return !1;
      }, "hasPropertyDescriptors");
    i.hasArrayLengthDefineBug = u(function () {
      if (!i()) return null;
      try {
        return 1 !== n([], "length", {
          value: 1
        }).length;
      } catch (t) {
        return !0;
      }
    }, "hasArrayLengthDefineBug"), e.exports = i;
  }),
  UM = ze((t, e) => {
    E();
    var n = IM(),
      i = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
      r = Object.prototype.toString,
      o = Array.prototype.concat,
      s = Object.defineProperty,
      a = u(function (t) {
        return "function" == typeof t && "[object Function]" === r.call(t);
      }, "isFunction"),
      l = UD()(),
      h = s && l,
      c = u(function (t, e, n, i) {
        if (e in t) if (!0 === i) {
          if (t[e] === n) return;
        } else if (!a(i) || !i()) return;
        h ? s(t, e, {
          configurable: !0,
          enumerable: !1,
          value: n,
          writable: !0
        }) : t[e] = n;
      }, "defineProperty"),
      p = u(function (t, e) {
        var r = arguments.length > 2 ? arguments[2] : {},
          s = n(e);
        i && (s = o.call(s, Object.getOwnPropertySymbols(e)));
        for (var a = 0; a < s.length; a += 1) c(t, s[a], e[s[a]], r[s[a]]);
      }, "defineProperties");
    p.supportsDescriptors = !!h, e.exports = p;
  }),
  WD = ze((t, e) => {
    E();
    var n = u(function () {
        return "string" == typeof u(function () {}, "f").name;
      }, "functionsHaveNames"),
      i = Object.getOwnPropertyDescriptor;
    if (i) try {
      i([], "length");
    } catch (t) {
      i = null;
    }
    n.functionsHaveConfigurableNames = u(function () {
      if (!n() || !i) return !1;
      var t = i(function () {}, "name");
      return !!t && !!t.configurable;
    }, "functionsHaveConfigurableNames");
    var r = Function.prototype.bind;
    n.boundFunctionsHaveNames = u(function () {
      return n() && "function" == typeof r && "" !== u(function () {}, "f").bind().name;
    }, "boundFunctionsHaveNames"), e.exports = n;
  }),
  uP = ze((t, e) => {
    E();
    var n = WD().functionsHaveConfigurableNames(),
      i = Object,
      r = TypeError;
    e.exports = u(function () {
      if (null != this && this !== i(this)) throw new r("RegExp.prototype.flags getter called on non-object");
      var t = "";
      return this.hasIndices && (t += "d"), this.global && (t += "g"), this.ignoreCase && (t += "i"), this.multiline && (t += "m"), this.dotAll && (t += "s"), this.unicode && (t += "u"), this.unicodeSets && (t += "v"), this.sticky && (t += "y"), t;
    }, "flags"), n && Object.defineProperty && Object.defineProperty(e.exports, "name", {
      value: "get flags"
    });
  }),
  cP = ze((t, e) => {
    E();
    var n = uP(),
      i = UM().supportsDescriptors,
      r = Object.getOwnPropertyDescriptor;
    e.exports = u(function () {
      if (i && "gim" === /a/gim.flags) {
        var t = r(RegExp.prototype, "flags");
        if (t && "function" == typeof t.get && "boolean" == typeof RegExp.prototype.dotAll && "boolean" == typeof RegExp.prototype.hasIndices) {
          var e = "",
            o = {};
          if (Object.defineProperty(o, "hasIndices", {
            get: function () {
              e += "d";
            }
          }), Object.defineProperty(o, "sticky", {
            get: function () {
              e += "y";
            }
          }), "dy" === e) return t.get;
        }
      }
      return n;
    }, "getPolyfill");
  }),
  JD = ze((t, e) => {
    E();
    var n = UM().supportsDescriptors,
      i = cP(),
      r = Object.getOwnPropertyDescriptor,
      o = Object.defineProperty,
      s = TypeError,
      a = Object.getPrototypeOf,
      l = /a/;
    e.exports = u(function () {
      if (!n || !a) throw new s("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
      var t = i(),
        e = a(l),
        u = r(e, "flags");
      return (!u || u.get !== t) && o(e, "flags", {
        configurable: !0,
        enumerable: !1,
        get: t
      }), t;
    }, "shimFlags");
  }),
  eq = ze((t, e) => {
    E();
    var n = UM(),
      i = NM(),
      r = uP(),
      o = cP(),
      s = JD(),
      a = i(o());
    n(a, {
      getPolyfill: o,
      implementation: r,
      shim: s
    }), e.exports = a;
  }),
  nq = ze((t, e) => {
    E();
    var n = Date.prototype.getDay,
      i = u(function (t) {
        try {
          return n.call(t), !0;
        } catch (t) {
          return !1;
        }
      }, "tryDateGetDayCall"),
      r = Object.prototype.toString,
      o = "function" == typeof Symbol && !!Symbol.toStringTag;
    e.exports = u(function (t) {
      return "object" == typeof t && null !== t && (o ? i(t) : "[object Date]" === r.call(t));
    }, "isDateObject");
  }),
  hP = ze((t, e) => {
    E();
    var n = IM(),
      i = hD(),
      r = ED(),
      o = CD(),
      s = eq(),
      a = nq(),
      l = Date.prototype.getTime;
    function h(t, e, n) {
      var i = n || {};
      return !!(i.strict ? r(t, e) : t === e) || (!t || !e || "object" != typeof t && "object" != typeof e ? i.strict ? r(t, e) : t == e : d(t, e, i));
    }
    function c(t) {
      return null == t;
    }
    function p(t) {
      return !(!t || "object" != typeof t || "number" != typeof t.length || "function" != typeof t.copy || "function" != typeof t.slice || t.length > 0 && "number" != typeof t[0]);
    }
    function d(t, e, r) {
      var u, d;
      if (typeof t != typeof e || c(t) || c(e) || t.prototype !== e.prototype || i(t) !== i(e)) return !1;
      var f = o(t),
        m = o(e);
      if (f !== m) return !1;
      if (f || m) return t.source === e.source && s(t) === s(e);
      if (a(t) && a(e)) return l.call(t) === l.call(e);
      var g = p(t),
        v = p(e);
      if (g !== v) return !1;
      if (g || v) {
        if (t.length !== e.length) return !1;
        for (u = 0; u < t.length; u++) if (t[u] !== e[u]) return !1;
        return !0;
      }
      if (typeof t != typeof e) return !1;
      try {
        var y = n(t),
          _ = n(e);
      } catch (t) {
        return !1;
      }
      if (y.length !== _.length) return !1;
      for (y.sort(), _.sort(), u = y.length - 1; u >= 0; u--) if (y[u] != _[u]) return !1;
      for (u = y.length - 1; u >= 0; u--) if (!h(t[d = y[u]], e[d], r)) return !1;
      return !0;
    }
    u(h, "deepEqual"), u(c, "isUndefinedOrNull"), u(p, "isBuffer"), u(d, "objEquiv"), e.exports = h;
  }),
  EP = ze((t, e) => {
    E();
    var n = hP(),
      i = u(function (t) {
        this.precision = t && t.precision ? t.precision : 17, this.direction = !(!t || !t.direction) && t.direction, this.pseudoNode = !(!t || !t.pseudoNode) && t.pseudoNode, this.objectComparator = t && t.objectComparator ? t.objectComparator : s;
      }, "Equality");
    function r(t) {
      return t.coordinates.map(function (e) {
        return {
          type: t.type.replace("Multi", ""),
          coordinates: e
        };
      });
    }
    function o(t, e) {
      return t.hasOwnProperty("coordinates") ? t.coordinates.length === e.coordinates.length : t.length === e.length;
    }
    function s(t, e) {
      return n(t, e, {
        strict: !0
      });
    }
    i.prototype.compare = function (t, e) {
      if (t.type !== e.type || !o(t, e)) return !1;
      switch (t.type) {
        case "Point":
          return this.compareCoord(t.coordinates, e.coordinates);
        case "LineString":
          return this.compareLine(t.coordinates, e.coordinates, 0, !1);
        case "Polygon":
          return this.comparePolygon(t, e);
        case "Feature":
          return this.compareFeature(t, e);
        default:
          if (0 === t.type.indexOf("Multi")) {
            var n = this,
              i = r(t),
              s = r(e);
            return i.every(function (t) {
              return this.some(function (e) {
                return n.compare(t, e);
              });
            }, s);
          }
      }
      return !1;
    }, u(r, "explode"), u(o, "sameLength"), i.prototype.compareCoord = function (t, e) {
      if (t.length !== e.length) return !1;
      for (var n = 0; n < t.length; n++) if (t[n].toFixed(this.precision) !== e[n].toFixed(this.precision)) return !1;
      return !0;
    }, i.prototype.compareLine = function (t, e, n, i) {
      if (!o(t, e)) return !1;
      var r = this.pseudoNode ? t : this.removePseudo(t),
        s = this.pseudoNode ? e : this.removePseudo(e);
      if (!i || this.compareCoord(r[0], s[0]) || (s = this.fixStartIndex(s, r))) {
        var a = this.compareCoord(r[n], s[n]);
        return this.direction || a ? this.comparePath(r, s) : !!this.compareCoord(r[n], s[s.length - (1 + n)]) && this.comparePath(r.slice().reverse(), s);
      }
    }, i.prototype.fixStartIndex = function (t, e) {
      for (var n, i = -1, r = 0; r < t.length; r++) if (this.compareCoord(t[r], e[0])) {
        i = r;
        break;
      }
      return i >= 0 && (n = [].concat(t.slice(i, t.length), t.slice(1, i + 1))), n;
    }, i.prototype.comparePath = function (t, e) {
      var n = this;
      return t.every(function (t, e) {
        return n.compareCoord(t, this[e]);
      }, e);
    }, i.prototype.comparePolygon = function (t, e) {
      if (this.compareLine(t.coordinates[0], e.coordinates[0], 1, !0)) {
        var n = t.coordinates.slice(1, t.coordinates.length),
          i = e.coordinates.slice(1, e.coordinates.length),
          r = this;
        return n.every(function (t) {
          return this.some(function (e) {
            return r.compareLine(t, e, 1, !0);
          });
        }, i);
      }
      return !1;
    }, i.prototype.compareFeature = function (t, e) {
      return !(t.id !== e.id || !this.objectComparator(t.properties, e.properties) || !this.compareBBox(t, e)) && this.compare(t.geometry, e.geometry);
    }, i.prototype.compareBBox = function (t, e) {
      return !!(!t.bbox && !e.bbox || t.bbox && e.bbox && this.compareCoord(t.bbox, e.bbox));
    }, i.prototype.removePseudo = function (t) {
      return t;
    }, u(s, "objectComparator"), e.exports = i;
  }),
  bq = ze((t, e) => {
    function n(t, e, n, i) {
      this.dataset = [], this.epsilon = 1, this.minPts = 2, this.distance = this._euclideanDistance, this.clusters = [], this.noise = [], this._visited = [], this._assigned = [], this._datasetLength = 0, this._init(t, e, n, i);
    }
    E(), u(n, "DBSCAN"), n.prototype.run = function (t, e, n, i) {
      this._init(t, e, n, i);
      for (var r = 0; r < this._datasetLength; r++) if (1 !== this._visited[r]) {
        this._visited[r] = 1;
        var o = this._regionQuery(r);
        if (o.length < this.minPts) this.noise.push(r);else {
          var s = this.clusters.length;
          this.clusters.push([]), this._addToCluster(r, s), this._expandCluster(s, o);
        }
      }
      return this.clusters;
    }, n.prototype._init = function (t, e, n, i) {
      if (t) {
        if (!(t instanceof Array)) throw Error("Dataset must be of type array, " + typeof t + " given");
        this.dataset = t, this.clusters = [], this.noise = [], this._datasetLength = t.length, this._visited = new Array(this._datasetLength), this._assigned = new Array(this._datasetLength);
      }
      e && (this.epsilon = e), n && (this.minPts = n), i && (this.distance = i);
    }, n.prototype._expandCluster = function (t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        if (1 !== this._visited[i]) {
          this._visited[i] = 1;
          var r = this._regionQuery(i);
          r.length >= this.minPts && (e = this._mergeArrays(e, r));
        }
        1 !== this._assigned[i] && this._addToCluster(i, t);
      }
    }, n.prototype._addToCluster = function (t, e) {
      this.clusters[e].push(t), this._assigned[t] = 1;
    }, n.prototype._regionQuery = function (t) {
      for (var e = [], n = 0; n < this._datasetLength; n++) {
        this.distance(this.dataset[t], this.dataset[n]) < this.epsilon && e.push(n);
      }
      return e;
    }, n.prototype._mergeArrays = function (t, e) {
      for (var n = e.length, i = 0; i < n; i++) {
        var r = e[i];
        t.indexOf(r) < 0 && t.push(r);
      }
      return t;
    }, n.prototype._euclideanDistance = function (t, e) {
      for (var n = 0, i = Math.min(t.length, e.length); i--;) n += (t[i] - e[i]) * (t[i] - e[i]);
      return Math.sqrt(n);
    }, void 0 !== e && e.exports && (e.exports = n);
  }),
  Mq = ze((t, e) => {
    function n(t, e, n) {
      this.k = 3, this.dataset = [], this.assignments = [], this.centroids = [], this.init(t, e, n);
    }
    E(), u(n, "KMEANS"), n.prototype.init = function (t, e, n) {
      this.assignments = [], this.centroids = [], void 0 !== t && (this.dataset = t), void 0 !== e && (this.k = e), void 0 !== n && (this.distance = n);
    }, n.prototype.run = function (t, e) {
      this.init(t, e);
      for (var n = this.dataset.length, i = 0; i < this.k; i++) this.centroids[i] = this.randomCentroid();
      for (var r = !0; r;) {
        r = this.assign();
        for (var o = 0; o < this.k; o++) {
          for (var s = new Array(h), a = 0, l = 0; l < h; l++) s[l] = 0;
          for (var u = 0; u < n; u++) {
            var h = this.dataset[u].length;
            if (o === this.assignments[u]) {
              for (l = 0; l < h; l++) s[l] += this.dataset[u][l];
              a++;
            }
          }
          if (a > 0) {
            for (l = 0; l < h; l++) s[l] /= a;
            this.centroids[o] = s;
          } else this.centroids[o] = this.randomCentroid(), r = !0;
        }
      }
      return this.getClusters();
    }, n.prototype.randomCentroid = function () {
      var t,
        e,
        n = this.dataset.length - 1;
      do {
        e = Math.round(Math.random() * n), t = this.dataset[e];
      } while (this.centroids.indexOf(t) >= 0);
      return t;
    }, n.prototype.assign = function () {
      for (var t, e = !1, n = this.dataset.length, i = 0; i < n; i++) (t = this.argmin(this.dataset[i], this.centroids, this.distance)) != this.assignments[i] && (this.assignments[i] = t, e = !0);
      return e;
    }, n.prototype.getClusters = function () {
      for (var t, e = new Array(this.k), n = 0; n < this.assignments.length; n++) void 0 === e[t = this.assignments[n]] && (e[t] = []), e[t].push(n);
      return e;
    }, n.prototype.argmin = function (t, e, n) {
      for (var i, r = Number.MAX_VALUE, o = 0, s = e.length, a = 0; a < s; a++) (i = n(t, e[a])) < r && (r = i, o = a);
      return o;
    }, n.prototype.distance = function (t, e) {
      for (var n = 0, i = Math.min(t.length, e.length); i--;) {
        var r = t[i] - e[i];
        n += r * r;
      }
      return Math.sqrt(n);
    }, void 0 !== e && e.exports && (e.exports = n);
  }),
  wP = ze((t, e) => {
    function n(t, e, n) {
      this._queue = [], this._priorities = [], this._sorting = "desc", this._init(t, e, n);
    }
    E(), u(n, "PriorityQueue"), n.prototype.insert = function (t, e) {
      for (var n = this._queue.length, i = n; i--;) {
        var r = this._priorities[i];
        "desc" === this._sorting ? e > r && (n = i) : e < r && (n = i);
      }
      this._insertAt(t, e, n);
    }, n.prototype.remove = function (t) {
      for (var e = this._queue.length; e--;) {
        if (t === this._queue[e]) {
          this._queue.splice(e, 1), this._priorities.splice(e, 1);
          break;
        }
      }
    }, n.prototype.forEach = function (t) {
      this._queue.forEach(t);
    }, n.prototype.getElements = function () {
      return this._queue;
    }, n.prototype.getElementPriority = function (t) {
      return this._priorities[t];
    }, n.prototype.getPriorities = function () {
      return this._priorities;
    }, n.prototype.getElementsWithPriorities = function () {
      for (var t = [], e = 0, n = this._queue.length; e < n; e++) t.push([this._queue[e], this._priorities[e]]);
      return t;
    }, n.prototype._init = function (t, e, n) {
      if (t && e) {
        if (this._queue = [], this._priorities = [], t.length !== e.length) throw new Error("Arrays must have the same length");
        for (var i = 0; i < t.length; i++) this.insert(t[i], e[i]);
      }
      n && (this._sorting = n);
    }, n.prototype._insertAt = function (t, e, n) {
      this._queue.length === n ? (this._queue.push(t), this._priorities.push(e)) : (this._queue.splice(n, 0, t), this._priorities.splice(n, 0, e));
    }, void 0 !== e && e.exports && (e.exports = n);
  }),
  wq = ze((t, e) => {
    var n;
    function i(t, e, n, i) {
      this.epsilon = 1, this.minPts = 1, this.distance = this._euclideanDistance, this._reachability = [], this._processed = [], this._coreDistance = 0, this._orderedList = [], this._init(t, e, n, i);
    }
    E(), void 0 !== e && e.exports && (n = wP()), u(i, "OPTICS"), i.prototype.run = function (t, e, i, r) {
      this._init(t, e, i, r);
      for (var o = 0, s = this.dataset.length; o < s; o++) if (1 !== this._processed[o]) {
        this._processed[o] = 1, this.clusters.push([o]);
        var a = this.clusters.length - 1;
        this._orderedList.push(o);
        var l = new n(null, null, "asc"),
          u = this._regionQuery(o);
        void 0 !== this._distanceToCore(o) && (this._updateQueue(o, u, l), this._expandCluster(a, l));
      }
      return this.clusters;
    }, i.prototype.getReachabilityPlot = function () {
      for (var t = [], e = 0, n = this._orderedList.length; e < n; e++) {
        var i = this._orderedList[e],
          r = this._reachability[i];
        t.push([i, r]);
      }
      return t;
    }, i.prototype._init = function (t, e, n, i) {
      if (t) {
        if (!(t instanceof Array)) throw Error("Dataset must be of type array, " + typeof t + " given");
        this.dataset = t, this.clusters = [], this._reachability = new Array(this.dataset.length), this._processed = new Array(this.dataset.length), this._coreDistance = 0, this._orderedList = [];
      }
      e && (this.epsilon = e), n && (this.minPts = n), i && (this.distance = i);
    }, i.prototype._updateQueue = function (t, e, n) {
      var i = this;
      this._coreDistance = this._distanceToCore(t), e.forEach(function (e) {
        if (void 0 === i._processed[e]) {
          var r = i.distance(i.dataset[t], i.dataset[e]),
            o = Math.max(i._coreDistance, r);
          void 0 === i._reachability[e] ? (i._reachability[e] = o, n.insert(e, o)) : o < i._reachability[e] && (i._reachability[e] = o, n.remove(e), n.insert(e, o));
        }
      });
    }, i.prototype._expandCluster = function (t, e) {
      for (var n = e.getElements(), i = 0, r = n.length; i < r; i++) {
        var o = n[i];
        if (void 0 === this._processed[o]) {
          var s = this._regionQuery(o);
          this._processed[o] = 1, this.clusters[t].push(o), this._orderedList.push(o), void 0 !== this._distanceToCore(o) && (this._updateQueue(o, s, e), this._expandCluster(t, e));
        }
      }
    }, i.prototype._distanceToCore = function (t) {
      for (var e = this.epsilon, n = 0; n < e; n++) {
        if (this._regionQuery(t, n).length >= this.minPts) return n;
      }
    }, i.prototype._regionQuery = function (t, e) {
      e = e || this.epsilon;
      for (var n = [], i = 0, r = this.dataset.length; i < r; i++) this.distance(this.dataset[t], this.dataset[i]) < e && n.push(i);
      return n;
    }, i.prototype._euclideanDistance = function (t, e) {
      for (var n = 0, i = Math.min(t.length, e.length); i--;) n += (t[i] - e[i]) * (t[i] - e[i]);
      return Math.sqrt(n);
    }, void 0 !== e && e.exports && (e.exports = i);
  }),
  Sq = ze((t, e) => {
    E(), void 0 !== e && e.exports && (e.exports = {
      DBSCAN: bq(),
      KMEANS: Mq(),
      OPTICS: wq(),
      PriorityQueue: wP()
    });
  }),
  SP = ze((t, e) => {
    E(), e.exports = {
      eudist: u(function (t, e, n) {
        for (var i = t.length, r = 0, o = 0; o < i; o++) {
          var s = (t[o] || 0) - (e[o] || 0);
          r += s * s;
        }
        return n ? Math.sqrt(r) : r;
      }, "eudist"),
      mandist: u(function (t, e, n) {
        for (var i = t.length, r = 0, o = 0; o < i; o++) r += Math.abs((t[o] || 0) - (e[o] || 0));
        return n ? Math.sqrt(r) : r;
      }, "mandist"),
      dist: u(function (t, e, n) {
        var i = Math.abs(t - e);
        return n ? i : i * i;
      }, "dist")
    };
  }),
  Iq = ze((t, e) => {
    E();
    var n = SP(),
      i = n.eudist,
      r = n.dist;
    e.exports = {
      kmrand: u(function (t, e) {
        for (var n = {}, i = [], r = e << 2, o = t.length, s = t[0].length > 0; i.length < e && r-- > 0;) {
          var a = t[Math.floor(Math.random() * o)],
            l = s ? a.join("_") : "" + a;
          n[l] || (n[l] = !0, i.push(a));
        }
        if (i.length < e) throw new Error("Error initializating clusters");
        return i;
      }, "kmrand"),
      kmpp: u(function (t, e) {
        var n = t[0].length ? i : r,
          o = [],
          s = t.length,
          a = t[0].length > 0,
          l = t[Math.floor(Math.random() * s)];
        a && l.join("_");
        for (o.push(l); o.length < e;) {
          for (var u = [], h = o.length, c = 0, p = [], d = 0; d < s; d++) {
            for (var f = 1 / 0, m = 0; m < h; m++) {
              var g = n(t[d], o[m]);
              g <= f && (f = g);
            }
            u[d] = f;
          }
          for (var v = 0; v < s; v++) c += u[v];
          for (var y = 0; y < s; y++) p[y] = {
            i: y,
            v: t[y],
            pr: u[y] / c,
            cs: 0
          };
          p.sort(function (t, e) {
            return t.pr - e.pr;
          }), p[0].cs = p[0].pr;
          for (var _ = 1; _ < s; _++) p[_].cs = p[_ - 1].cs + p[_].pr;
          for (var x = Math.random(), E = 0; E < s - 1 && p[E++].cs < x;);
          o.push(p[E - 1].v);
        }
        return o;
      }, "kmpp")
    };
  }),
  Dq = ze((t, e) => {
    E();
    var n = SP(),
      i = Iq(),
      r = n.eudist,
      o = (n.mandist, n.dist, i.kmrand),
      s = i.kmpp;
    function a(t, e, n) {
      n = n || [];
      for (var i = 0; i < t; i++) n[i] = e;
      return n;
    }
    function l(t, e, n, i) {
      var l = [],
        u = [],
        h = [],
        c = [],
        p = !1,
        d = i || 1e4,
        f = t.length,
        m = t[0].length,
        g = m > 0,
        v = [];
      if (n) l = "kmrand" == n ? o(t, e) : "kmpp" == n ? s(t, e) : n;else for (var y = {}; l.length < e;) {
        var _ = Math.floor(Math.random() * f);
        y[_] || (y[_] = !0, l.push(t[_]));
      }
      do {
        a(e, 0, v);
        for (var x = 0; x < f; x++) {
          for (var E = 1 / 0, b = 0, w = 0; w < e; w++) {
            (c = g ? r(t[x], l[w]) : Math.abs(t[x] - l[w])) <= E && (E = c, b = w);
          }
          h[x] = b, v[b]++;
        }
        for (var S = [], M = (u = [], 0); M < e; M++) S[M] = g ? a(m, 0, S[M]) : 0, u[M] = l[M];
        if (g) {
          for (var T = 0; T < e; T++) l[T] = [];
          for (var A = 0; A < f; A++) for (var P = S[h[A]], C = t[A], I = 0; I < m; I++) P[I] += C[I];
          p = !0;
          for (var N = 0; N < e; N++) {
            for (var L = l[N], R = S[N], O = u[N], q = v[N], D = 0; D < m; D++) L[D] = R[D] / q || 0;
            if (p) for (var k = 0; k < m; k++) if (O[k] != L[k]) {
              p = !1;
              break;
            }
          }
        } else {
          for (var F = 0; F < f; F++) {
            S[h[F]] += t[F];
          }
          for (var U = 0; U < e; U++) l[U] = S[U] / v[U] || 0;
          p = !0;
          for (var B = 0; B < e; B++) if (u[B] != l[B]) {
            p = !1;
            break;
          }
        }
        p = p || --d <= 0;
      } while (!p);
      return {
        it: 1e4 - d,
        k: e,
        idxs: h,
        centroids: l
      };
    }
    u(a, "init"), u(l, "skmeans"), e.exports = l;
  }),
  vm = ze((t, e) => {
    var n, i;
    E(), n = t, i = function () {
      "use strict";

      function t(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      function e(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
        }
      }
      function n(t, n, i) {
        return n && e(t.prototype, n), i && e(t, i), t;
      }
      u(t, "_classCallCheck"), u(e, "_defineProperties"), u(n, "_createClass");
      var i = function () {
        function t(t, e) {
          this.next = null, this.key = t, this.data = e, this.left = null, this.right = null;
        }
        return u(t, "Node"), t;
      }();
      function r(t, e) {
        return t > e ? 1 : t < e ? -1 : 0;
      }
      function o(t, e, n) {
        for (var r = new i(null, null), o = r, s = r;;) {
          var a = n(t, e.key);
          if (a < 0) {
            if (null === e.left) break;
            if (n(t, e.left.key) < 0) {
              var l = e.left;
              if (e.left = l.right, l.right = e, null === (e = l).left) break;
            }
            s.left = e, s = e, e = e.left;
          } else {
            if (!(a > 0)) break;
            if (null === e.right) break;
            if (n(t, e.right.key) > 0 && (l = e.right, e.right = l.left, l.left = e, null === (e = l).right)) break;
            o.right = e, o = e, e = e.right;
          }
        }
        return o.right = e.left, s.left = e.right, e.left = r.right, e.right = r.left, e;
      }
      function s(t, e, n, r) {
        var s = new i(t, e);
        if (null === n) return s.left = s.right = null, s;
        var a = r(t, (n = o(t, n, r)).key);
        return a < 0 ? (s.left = n.left, s.right = n, n.left = null) : a >= 0 && (s.right = n.right, s.left = n, n.right = null), s;
      }
      function a(t, e, n) {
        var i = null,
          r = null;
        if (e) {
          var s = n((e = o(t, e, n)).key, t);
          0 === s ? (i = e.left, r = e.right) : s < 0 ? (r = e.right, e.right = null, i = e) : (i = e.left, e.left = null, r = e);
        }
        return {
          left: i,
          right: r
        };
      }
      function l(t, e, n) {
        return null === e ? t : (null === t || ((e = o(t.key, e, n)).left = t), e);
      }
      function h(t, e, n, i, r) {
        if (t) {
          i(e + (n ? "└── " : "├── ") + r(t) + "\n");
          var o = e + (n ? "    " : "│   ");
          t.left && h(t.left, o, !1, i, r), t.right && h(t.right, o, !0, i, r);
        }
      }
      u(r, "DEFAULT_COMPARE"), u(o, "splay"), u(s, "insert"), u(a, "split"), u(l, "merge"), u(h, "printRow");
      var c = function () {
        function t(t) {
          void 0 === t && (t = r), this._root = null, this._size = 0, this._comparator = t;
        }
        return u(t, "Tree"), t.prototype.insert = function (t, e) {
          return this._size++, this._root = s(t, e, this._root, this._comparator);
        }, t.prototype.add = function (t, e) {
          var n = new i(t, e);
          null === this._root && (n.left = n.right = null, this._size++, this._root = n);
          var r = this._comparator,
            s = o(t, this._root, r),
            a = r(t, s.key);
          return 0 === a ? this._root = s : (a < 0 ? (n.left = s.left, n.right = s, s.left = null) : a > 0 && (n.right = s.right, n.left = s, s.right = null), this._size++, this._root = n), this._root;
        }, t.prototype.remove = function (t) {
          this._root = this._remove(t, this._root, this._comparator);
        }, t.prototype._remove = function (t, e, n) {
          var i;
          return null === e ? null : 0 === n(t, (e = o(t, e, n)).key) ? (null === e.left ? i = e.right : (i = o(t, e.left, n)).right = e.right, this._size--, i) : e;
        }, t.prototype.pop = function () {
          var t = this._root;
          if (t) {
            for (; t.left;) t = t.left;
            return this._root = o(t.key, this._root, this._comparator), this._root = this._remove(t.key, this._root, this._comparator), {
              key: t.key,
              data: t.data
            };
          }
          return null;
        }, t.prototype.findStatic = function (t) {
          for (var e = this._root, n = this._comparator; e;) {
            var i = n(t, e.key);
            if (0 === i) return e;
            e = i < 0 ? e.left : e.right;
          }
          return null;
        }, t.prototype.find = function (t) {
          return this._root && (this._root = o(t, this._root, this._comparator), 0 !== this._comparator(t, this._root.key)) ? null : this._root;
        }, t.prototype.contains = function (t) {
          for (var e = this._root, n = this._comparator; e;) {
            var i = n(t, e.key);
            if (0 === i) return !0;
            e = i < 0 ? e.left : e.right;
          }
          return !1;
        }, t.prototype.forEach = function (t, e) {
          for (var n = this._root, i = [], r = !1; !r;) null !== n ? (i.push(n), n = n.left) : 0 !== i.length ? (n = i.pop(), t.call(e, n), n = n.right) : r = !0;
          return this;
        }, t.prototype.range = function (t, e, n, i) {
          for (var r = [], o = this._comparator, s = this._root; 0 !== r.length || s;) if (s) r.push(s), s = s.left;else {
            if (o((s = r.pop()).key, e) > 0) break;
            if (o(s.key, t) >= 0 && n.call(i, s)) return this;
            s = s.right;
          }
          return this;
        }, t.prototype.keys = function () {
          var t = [];
          return this.forEach(function (e) {
            var n = e.key;
            return t.push(n);
          }), t;
        }, t.prototype.values = function () {
          var t = [];
          return this.forEach(function (e) {
            var n = e.data;
            return t.push(n);
          }), t;
        }, t.prototype.min = function () {
          return this._root ? this.minNode(this._root).key : null;
        }, t.prototype.max = function () {
          return this._root ? this.maxNode(this._root).key : null;
        }, t.prototype.minNode = function (t) {
          if (void 0 === t && (t = this._root), t) for (; t.left;) t = t.left;
          return t;
        }, t.prototype.maxNode = function (t) {
          if (void 0 === t && (t = this._root), t) for (; t.right;) t = t.right;
          return t;
        }, t.prototype.at = function (t) {
          for (var e = this._root, n = !1, i = 0, r = []; !n;) if (e) r.push(e), e = e.left;else if (r.length > 0) {
            if (e = r.pop(), i === t) return e;
            i++, e = e.right;
          } else n = !0;
          return null;
        }, t.prototype.next = function (t) {
          var e = this._root,
            n = null;
          if (t.right) {
            for (n = t.right; n.left;) n = n.left;
            return n;
          }
          for (var i = this._comparator; e;) {
            var r = i(t.key, e.key);
            if (0 === r) break;
            r < 0 ? (n = e, e = e.left) : e = e.right;
          }
          return n;
        }, t.prototype.prev = function (t) {
          var e = this._root,
            n = null;
          if (null !== t.left) {
            for (n = t.left; n.right;) n = n.right;
            return n;
          }
          for (var i = this._comparator; e;) {
            var r = i(t.key, e.key);
            if (0 === r) break;
            r < 0 ? e = e.left : (n = e, e = e.right);
          }
          return n;
        }, t.prototype.clear = function () {
          return this._root = null, this._size = 0, this;
        }, t.prototype.toList = function () {
          return f(this._root);
        }, t.prototype.load = function (t, e, n) {
          void 0 === e && (e = []), void 0 === n && (n = !1);
          var i = t.length,
            r = this._comparator;
          if (n && v(t, e, 0, i - 1, r), null === this._root) this._root = p(t, e, 0, i), this._size = i;else {
            var o = g(this.toList(), d(t, e), r);
            i = this._size + i, this._root = m({
              head: o
            }, 0, i);
          }
          return this;
        }, t.prototype.isEmpty = function () {
          return null === this._root;
        }, Object.defineProperty(t.prototype, "size", {
          get: u(function () {
            return this._size;
          }, "get"),
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "root", {
          get: u(function () {
            return this._root;
          }, "get"),
          enumerable: !0,
          configurable: !0
        }), t.prototype.toString = function (t) {
          void 0 === t && (t = u(function (t) {
            return String(t.key);
          }, "printNode"));
          var e = [];
          return h(this._root, "", !0, function (t) {
            return e.push(t);
          }, t), e.join("");
        }, t.prototype.update = function (t, e, n) {
          var i = this._comparator,
            r = a(t, this._root, i),
            o = r.left,
            u = r.right;
          i(t, e) < 0 ? u = s(e, n, u, i) : o = s(e, n, o, i), this._root = l(o, u, i);
        }, t.prototype.split = function (t) {
          return a(t, this._root, this._comparator);
        }, t;
      }();
      function p(t, e, n, r) {
        var o = r - n;
        if (o > 0) {
          var s = n + Math.floor(o / 2),
            a = t[s],
            l = e[s],
            u = new i(a, l);
          return u.left = p(t, e, n, s), u.right = p(t, e, s + 1, r), u;
        }
        return null;
      }
      function d(t, e) {
        for (var n = new i(null, null), r = n, o = 0; o < t.length; o++) r = r.next = new i(t[o], e[o]);
        return r.next = null, n.next;
      }
      function f(t) {
        for (var e = t, n = [], r = !1, o = new i(null, null), s = o; !r;) e ? (n.push(e), e = e.left) : n.length > 0 ? e = (e = s = s.next = n.pop()).right : r = !0;
        return s.next = null, o.next;
      }
      function m(t, e, n) {
        var i = n - e;
        if (i > 0) {
          var r = e + Math.floor(i / 2),
            o = m(t, e, r),
            s = t.head;
          return s.left = o, t.head = t.head.next, s.right = m(t, r + 1, n), s;
        }
        return null;
      }
      function g(t, e, n) {
        for (var r = new i(null, null), o = r, s = t, a = e; null !== s && null !== a;) n(s.key, a.key) < 0 ? (o.next = s, s = s.next) : (o.next = a, a = a.next), o = o.next;
        return null !== s ? o.next = s : null !== a && (o.next = a), r.next;
      }
      function v(t, e, n, i, r) {
        if (!(n >= i)) {
          for (var o = t[n + i >> 1], s = n - 1, a = i + 1;;) {
            do {
              s++;
            } while (r(t[s], o) < 0);
            do {
              a--;
            } while (r(t[a], o) > 0);
            if (s >= a) break;
            var l = t[s];
            t[s] = t[a], t[a] = l, l = e[s], e[s] = e[a], e[a] = l;
          }
          v(t, e, n, a, r), v(t, e, a + 1, i, r);
        }
      }
      u(p, "loadRecursive"), u(d, "createList"), u(f, "toList"), u(m, "sortedListToBST"), u(g, "mergeLists"), u(v, "sort");
      var y = u(function (t, e) {
          return t.ll.x <= e.x && e.x <= t.ur.x && t.ll.y <= e.y && e.y <= t.ur.y;
        }, "isInBbox"),
        _ = u(function (t, e) {
          if (e.ur.x < t.ll.x || t.ur.x < e.ll.x || e.ur.y < t.ll.y || t.ur.y < e.ll.y) return null;
          var n = t.ll.x < e.ll.x ? e.ll.x : t.ll.x,
            i = t.ur.x < e.ur.x ? t.ur.x : e.ur.x;
          return {
            ll: {
              x: n,
              y: t.ll.y < e.ll.y ? e.ll.y : t.ll.y
            },
            ur: {
              x: i,
              y: t.ur.y < e.ur.y ? t.ur.y : e.ur.y
            }
          };
        }, "getBboxOverlap"),
        x = Number.EPSILON;
      void 0 === x && (x = Math.pow(2, -52));
      var E = x * x,
        b = u(function (t, e) {
          if (-x < t && t < x && -x < e && e < x) return 0;
          var n = t - e;
          return n * n < E * t * e ? 0 : t < e ? -1 : 1;
        }, "cmp"),
        w = function () {
          function e() {
            t(this, e), this.reset();
          }
          return u(e, "PtRounder"), n(e, [{
            key: "reset",
            value: u(function () {
              this.xRounder = new S(), this.yRounder = new S();
            }, "reset")
          }, {
            key: "round",
            value: u(function (t, e) {
              return {
                x: this.xRounder.round(t),
                y: this.yRounder.round(e)
              };
            }, "round")
          }]), e;
        }(),
        S = function () {
          function e() {
            t(this, e), this.tree = new c(), this.round(0);
          }
          return u(e, "CoordRounder"), n(e, [{
            key: "round",
            value: u(function (t) {
              var e = this.tree.add(t),
                n = this.tree.prev(e);
              if (null !== n && 0 === b(e.key, n.key)) return this.tree.remove(t), n.key;
              var i = this.tree.next(e);
              return null !== i && 0 === b(e.key, i.key) ? (this.tree.remove(t), i.key) : t;
            }, "round")
          }]), e;
        }(),
        M = new w(),
        T = u(function (t, e) {
          return t.x * e.y - t.y * e.x;
        }, "crossProduct"),
        A = u(function (t, e) {
          return t.x * e.x + t.y * e.y;
        }, "dotProduct"),
        P = u(function (t, e, n) {
          var i = {
              x: e.x - t.x,
              y: e.y - t.y
            },
            r = {
              x: n.x - t.x,
              y: n.y - t.y
            },
            o = T(i, r);
          return b(o, 0);
        }, "compareVectorAngles"),
        C = u(function (t) {
          return Math.sqrt(A(t, t));
        }, "length"),
        I = u(function (t, e, n) {
          var i = {
              x: e.x - t.x,
              y: e.y - t.y
            },
            r = {
              x: n.x - t.x,
              y: n.y - t.y
            };
          return T(r, i) / C(r) / C(i);
        }, "sineOfAngle"),
        N = u(function (t, e, n) {
          var i = {
              x: e.x - t.x,
              y: e.y - t.y
            },
            r = {
              x: n.x - t.x,
              y: n.y - t.y
            };
          return A(r, i) / C(r) / C(i);
        }, "cosineOfAngle"),
        L = u(function (t, e, n) {
          return 0 === e.y ? null : {
            x: t.x + e.x / e.y * (n - t.y),
            y: n
          };
        }, "horizontalIntersection"),
        R = u(function (t, e, n) {
          return 0 === e.x ? null : {
            x: n,
            y: t.y + e.y / e.x * (n - t.x)
          };
        }, "verticalIntersection"),
        O = u(function (t, e, n, i) {
          if (0 === e.x) return R(n, i, t.x);
          if (0 === i.x) return R(t, e, n.x);
          if (0 === e.y) return L(n, i, t.y);
          if (0 === i.y) return L(t, e, n.y);
          var r = T(e, i);
          if (0 == r) return null;
          var o = {
              x: n.x - t.x,
              y: n.y - t.y
            },
            s = T(o, e) / r,
            a = T(o, i) / r;
          return {
            x: (t.x + a * e.x + (n.x + s * i.x)) / 2,
            y: (t.y + a * e.y + (n.y + s * i.y)) / 2
          };
        }, "intersection"),
        q = function () {
          function e(n, i) {
            t(this, e), void 0 === n.events ? n.events = [this] : n.events.push(this), this.point = n, this.isLeft = i;
          }
          return n(e, null, [{
            key: "compare",
            value: u(function (t, n) {
              var i = e.comparePoints(t.point, n.point);
              return 0 !== i ? i : (t.point !== n.point && t.link(n), t.isLeft !== n.isLeft ? t.isLeft ? 1 : -1 : F.compare(t.segment, n.segment));
            }, "compare")
          }, {
            key: "comparePoints",
            value: u(function (t, e) {
              return t.x < e.x ? -1 : t.x > e.x ? 1 : t.y < e.y ? -1 : t.y > e.y ? 1 : 0;
            }, "comparePoints")
          }]), u(e, "SweepEvent"), n(e, [{
            key: "link",
            value: u(function (t) {
              if (t.point === this.point) throw new Error("Tried to link already linked events");
              for (var e = t.point.events, n = 0, i = e.length; n < i; n++) {
                var r = e[n];
                this.point.events.push(r), r.point = this.point;
              }
              this.checkForConsuming();
            }, "link")
          }, {
            key: "checkForConsuming",
            value: u(function () {
              for (var t = this.point.events.length, e = 0; e < t; e++) {
                var n = this.point.events[e];
                if (void 0 === n.segment.consumedBy) for (var i = e + 1; i < t; i++) {
                  var r = this.point.events[i];
                  void 0 === r.consumedBy && n.otherSE.point.events === r.otherSE.point.events && n.segment.consume(r.segment);
                }
              }
            }, "checkForConsuming")
          }, {
            key: "getAvailableLinkedEvents",
            value: u(function () {
              for (var t = [], e = 0, n = this.point.events.length; e < n; e++) {
                var i = this.point.events[e];
                i !== this && !i.segment.ringOut && i.segment.isInResult() && t.push(i);
              }
              return t;
            }, "getAvailableLinkedEvents")
          }, {
            key: "getLeftmostComparator",
            value: u(function (t) {
              var e = this,
                n = new Map(),
                i = u(function (i) {
                  var r = i.otherSE;
                  n.set(i, {
                    sine: I(e.point, t.point, r.point),
                    cosine: N(e.point, t.point, r.point)
                  });
                }, "fillCache");
              return function (t, e) {
                n.has(t) || i(t), n.has(e) || i(e);
                var r = n.get(t),
                  o = r.sine,
                  s = r.cosine,
                  a = n.get(e),
                  l = a.sine,
                  u = a.cosine;
                return o >= 0 && l >= 0 ? s < u ? 1 : s > u ? -1 : 0 : o < 0 && l < 0 ? s < u ? -1 : s > u ? 1 : 0 : l < o ? -1 : l > o ? 1 : 0;
              };
            }, "getLeftmostComparator")
          }]), e;
        }(),
        k = 0,
        F = function () {
          function e(n, i, r, o) {
            t(this, e), this.id = ++k, this.leftSE = n, n.segment = this, n.otherSE = i, this.rightSE = i, i.segment = this, i.otherSE = n, this.rings = r, this.windings = o;
          }
          return n(e, null, [{
            key: "compare",
            value: u(function (t, e) {
              var n = t.leftSE.point.x,
                i = e.leftSE.point.x,
                r = t.rightSE.point.x,
                o = e.rightSE.point.x;
              if (o < n) return 1;
              if (r < i) return -1;
              var s = t.leftSE.point.y,
                a = e.leftSE.point.y,
                l = t.rightSE.point.y,
                u = e.rightSE.point.y;
              if (n < i) {
                if (a < s && a < l) return 1;
                if (a > s && a > l) return -1;
                var h = t.comparePoint(e.leftSE.point);
                if (h < 0) return 1;
                if (h > 0) return -1;
                var c = e.comparePoint(t.rightSE.point);
                return 0 !== c ? c : -1;
              }
              if (n > i) {
                if (s < a && s < u) return -1;
                if (s > a && s > u) return 1;
                var p = e.comparePoint(t.leftSE.point);
                if (0 !== p) return p;
                var d = t.comparePoint(e.rightSE.point);
                return d < 0 ? 1 : d > 0 ? -1 : 1;
              }
              if (s < a) return -1;
              if (s > a) return 1;
              if (r < o) {
                var f = e.comparePoint(t.rightSE.point);
                if (0 !== f) return f;
              }
              if (r > o) {
                var m = t.comparePoint(e.rightSE.point);
                if (m < 0) return 1;
                if (m > 0) return -1;
              }
              if (r !== o) {
                var g = l - s,
                  v = r - n,
                  y = u - a,
                  _ = o - i;
                if (g > v && y < _) return 1;
                if (g < v && y > _) return -1;
              }
              return r > o ? 1 : r < o || l < u ? -1 : l > u ? 1 : t.id < e.id ? -1 : t.id > e.id ? 1 : 0;
            }, "compare")
          }]), u(e, "Segment"), n(e, [{
            key: "replaceRightSE",
            value: u(function (t) {
              this.rightSE = t, this.rightSE.segment = this, this.rightSE.otherSE = this.leftSE, this.leftSE.otherSE = this.rightSE;
            }, "replaceRightSE")
          }, {
            key: "bbox",
            value: u(function () {
              var t = this.leftSE.point.y,
                e = this.rightSE.point.y;
              return {
                ll: {
                  x: this.leftSE.point.x,
                  y: t < e ? t : e
                },
                ur: {
                  x: this.rightSE.point.x,
                  y: t > e ? t : e
                }
              };
            }, "bbox")
          }, {
            key: "vector",
            value: u(function () {
              return {
                x: this.rightSE.point.x - this.leftSE.point.x,
                y: this.rightSE.point.y - this.leftSE.point.y
              };
            }, "vector")
          }, {
            key: "isAnEndpoint",
            value: u(function (t) {
              return t.x === this.leftSE.point.x && t.y === this.leftSE.point.y || t.x === this.rightSE.point.x && t.y === this.rightSE.point.y;
            }, "isAnEndpoint")
          }, {
            key: "comparePoint",
            value: u(function (t) {
              if (this.isAnEndpoint(t)) return 0;
              var e = this.leftSE.point,
                n = this.rightSE.point,
                i = this.vector();
              if (e.x === n.x) return t.x === e.x ? 0 : t.x < e.x ? 1 : -1;
              var r = (t.y - e.y) / i.y,
                o = e.x + r * i.x;
              if (t.x === o) return 0;
              var s = (t.x - e.x) / i.x,
                a = e.y + s * i.y;
              return t.y === a ? 0 : t.y < a ? -1 : 1;
            }, "comparePoint")
          }, {
            key: "getIntersection",
            value: u(function (t) {
              var e = this.bbox(),
                n = t.bbox(),
                i = _(e, n);
              if (null === i) return null;
              var r = this.leftSE.point,
                o = this.rightSE.point,
                s = t.leftSE.point,
                a = t.rightSE.point,
                l = y(e, s) && 0 === this.comparePoint(s),
                u = y(n, r) && 0 === t.comparePoint(r),
                h = y(e, a) && 0 === this.comparePoint(a),
                c = y(n, o) && 0 === t.comparePoint(o);
              if (u && l) return c && !h ? o : !c && h ? a : null;
              if (u) return h && r.x === a.x && r.y === a.y ? null : r;
              if (l) return c && o.x === s.x && o.y === s.y ? null : s;
              if (c && h) return null;
              if (c) return o;
              if (h) return a;
              var p = O(r, this.vector(), s, t.vector());
              return null !== p && y(i, p) ? M.round(p.x, p.y) : null;
            }, "getIntersection")
          }, {
            key: "split",
            value: u(function (t) {
              var n = [],
                i = void 0 !== t.events,
                r = new q(t, !0),
                o = new q(t, !1),
                s = this.rightSE;
              this.replaceRightSE(o), n.push(o), n.push(r);
              var a = new e(r, s, this.rings.slice(), this.windings.slice());
              return q.comparePoints(a.leftSE.point, a.rightSE.point) > 0 && a.swapEvents(), q.comparePoints(this.leftSE.point, this.rightSE.point) > 0 && this.swapEvents(), i && (r.checkForConsuming(), o.checkForConsuming()), n;
            }, "split")
          }, {
            key: "swapEvents",
            value: u(function () {
              var t = this.rightSE;
              this.rightSE = this.leftSE, this.leftSE = t, this.leftSE.isLeft = !0, this.rightSE.isLeft = !1;
              for (var e = 0, n = this.windings.length; e < n; e++) this.windings[e] *= -1;
            }, "swapEvents")
          }, {
            key: "consume",
            value: u(function (t) {
              for (var n = this, i = t; n.consumedBy;) n = n.consumedBy;
              for (; i.consumedBy;) i = i.consumedBy;
              var r = e.compare(n, i);
              if (0 !== r) {
                if (r > 0) {
                  var o = n;
                  n = i, i = o;
                }
                if (n.prev === i) {
                  var s = n;
                  n = i, i = s;
                }
                for (var a = 0, l = i.rings.length; a < l; a++) {
                  var u = i.rings[a],
                    h = i.windings[a],
                    c = n.rings.indexOf(u);
                  -1 === c ? (n.rings.push(u), n.windings.push(h)) : n.windings[c] += h;
                }
                i.rings = null, i.windings = null, i.consumedBy = n, i.leftSE.consumedBy = n.leftSE, i.rightSE.consumedBy = n.rightSE;
              }
            }, "consume")
          }, {
            key: "prevInResult",
            value: u(function () {
              return void 0 !== this._prevInResult || (this.prev ? this.prev.isInResult() ? this._prevInResult = this.prev : this._prevInResult = this.prev.prevInResult() : this._prevInResult = null), this._prevInResult;
            }, "prevInResult")
          }, {
            key: "beforeState",
            value: u(function () {
              if (void 0 !== this._beforeState) return this._beforeState;
              if (this.prev) {
                var t = this.prev.consumedBy || this.prev;
                this._beforeState = t.afterState();
              } else this._beforeState = {
                rings: [],
                windings: [],
                multiPolys: []
              };
              return this._beforeState;
            }, "beforeState")
          }, {
            key: "afterState",
            value: u(function () {
              if (void 0 !== this._afterState) return this._afterState;
              var t = this.beforeState();
              this._afterState = {
                rings: t.rings.slice(0),
                windings: t.windings.slice(0),
                multiPolys: []
              };
              for (var e = this._afterState.rings, n = this._afterState.windings, i = this._afterState.multiPolys, r = 0, o = this.rings.length; r < o; r++) {
                var s = this.rings[r],
                  a = this.windings[r],
                  l = e.indexOf(s);
                -1 === l ? (e.push(s), n.push(a)) : n[l] += a;
              }
              for (var u = [], h = [], c = 0, p = e.length; c < p; c++) if (0 !== n[c]) {
                var d = e[c],
                  f = d.poly;
                if (-1 === h.indexOf(f)) if (d.isExterior) u.push(f);else {
                  -1 === h.indexOf(f) && h.push(f);
                  var m = u.indexOf(d.poly);
                  -1 !== m && u.splice(m, 1);
                }
              }
              for (var g = 0, v = u.length; g < v; g++) {
                var y = u[g].multiPoly;
                -1 === i.indexOf(y) && i.push(y);
              }
              return this._afterState;
            }, "afterState")
          }, {
            key: "isInResult",
            value: u(function () {
              if (this.consumedBy) return !1;
              if (void 0 !== this._isInResult) return this._isInResult;
              var t = this.beforeState().multiPolys,
                e = this.afterState().multiPolys;
              switch (Y.type) {
                case "union":
                  var n = 0 === t.length,
                    i = 0 === e.length;
                  this._isInResult = n !== i;
                  break;
                case "intersection":
                  var r, o;
                  t.length < e.length ? (r = t.length, o = e.length) : (r = e.length, o = t.length), this._isInResult = o === Y.numMultiPolys && r < o;
                  break;
                case "xor":
                  var s = Math.abs(t.length - e.length);
                  this._isInResult = s % 2 == 1;
                  break;
                case "difference":
                  var a = u(function (t) {
                    return 1 === t.length && t[0].isSubject;
                  }, "isJustSubject");
                  this._isInResult = a(t) !== a(e);
                  break;
                default:
                  throw new Error("Unrecognized operation type found ".concat(Y.type));
              }
              return this._isInResult;
            }, "isInResult")
          }], [{
            key: "fromRing",
            value: u(function (t, n, i) {
              var r,
                o,
                s,
                a = q.comparePoints(t, n);
              if (a < 0) r = t, o = n, s = 1;else {
                if (!(a > 0)) throw new Error("Tried to create degenerate segment at [".concat(t.x, ", ").concat(t.y, "]"));
                r = n, o = t, s = -1;
              }
              return new e(new q(r, !0), new q(o, !1), [i], [s]);
            }, "fromRing")
          }]), e;
        }(),
        U = function () {
          function e(n, i, r) {
            if (t(this, e), !Array.isArray(n) || 0 === n.length) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            if (this.poly = i, this.isExterior = r, this.segments = [], "number" != typeof n[0][0] || "number" != typeof n[0][1]) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            var o = M.round(n[0][0], n[0][1]);
            this.bbox = {
              ll: {
                x: o.x,
                y: o.y
              },
              ur: {
                x: o.x,
                y: o.y
              }
            };
            for (var s = o, a = 1, l = n.length; a < l; a++) {
              if ("number" != typeof n[a][0] || "number" != typeof n[a][1]) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
              var u = M.round(n[a][0], n[a][1]);
              u.x === s.x && u.y === s.y || (this.segments.push(F.fromRing(s, u, this)), u.x < this.bbox.ll.x && (this.bbox.ll.x = u.x), u.y < this.bbox.ll.y && (this.bbox.ll.y = u.y), u.x > this.bbox.ur.x && (this.bbox.ur.x = u.x), u.y > this.bbox.ur.y && (this.bbox.ur.y = u.y), s = u);
            }
            (o.x !== s.x || o.y !== s.y) && this.segments.push(F.fromRing(s, o, this));
          }
          return u(e, "RingIn"), n(e, [{
            key: "getSweepEvents",
            value: u(function () {
              for (var t = [], e = 0, n = this.segments.length; e < n; e++) {
                var i = this.segments[e];
                t.push(i.leftSE), t.push(i.rightSE);
              }
              return t;
            }, "getSweepEvents")
          }]), e;
        }(),
        B = function () {
          function e(n, i) {
            if (t(this, e), !Array.isArray(n)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.exteriorRing = new U(n[0], this, !0), this.bbox = {
              ll: {
                x: this.exteriorRing.bbox.ll.x,
                y: this.exteriorRing.bbox.ll.y
              },
              ur: {
                x: this.exteriorRing.bbox.ur.x,
                y: this.exteriorRing.bbox.ur.y
              }
            }, this.interiorRings = [];
            for (var r = 1, o = n.length; r < o; r++) {
              var s = new U(n[r], this, !1);
              s.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = s.bbox.ll.x), s.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = s.bbox.ll.y), s.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = s.bbox.ur.x), s.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = s.bbox.ur.y), this.interiorRings.push(s);
            }
            this.multiPoly = i;
          }
          return u(e, "PolyIn"), n(e, [{
            key: "getSweepEvents",
            value: u(function () {
              for (var t = this.exteriorRing.getSweepEvents(), e = 0, n = this.interiorRings.length; e < n; e++) for (var i = this.interiorRings[e].getSweepEvents(), r = 0, o = i.length; r < o; r++) t.push(i[r]);
              return t;
            }, "getSweepEvents")
          }]), e;
        }(),
        z = function () {
          function e(n, i) {
            if (t(this, e), !Array.isArray(n)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            try {
              "number" == typeof n[0][0][0] && (n = [n]);
            } catch (t) {}
            this.polys = [], this.bbox = {
              ll: {
                x: Number.POSITIVE_INFINITY,
                y: Number.POSITIVE_INFINITY
              },
              ur: {
                x: Number.NEGATIVE_INFINITY,
                y: Number.NEGATIVE_INFINITY
              }
            };
            for (var r = 0, o = n.length; r < o; r++) {
              var s = new B(n[r], this);
              s.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = s.bbox.ll.x), s.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = s.bbox.ll.y), s.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = s.bbox.ur.x), s.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = s.bbox.ur.y), this.polys.push(s);
            }
            this.isSubject = i;
          }
          return u(e, "MultiPolyIn"), n(e, [{
            key: "getSweepEvents",
            value: u(function () {
              for (var t = [], e = 0, n = this.polys.length; e < n; e++) for (var i = this.polys[e].getSweepEvents(), r = 0, o = i.length; r < o; r++) t.push(i[r]);
              return t;
            }, "getSweepEvents")
          }]), e;
        }(),
        V = function () {
          function e(n) {
            t(this, e), this.events = n;
            for (var i = 0, r = n.length; i < r; i++) n[i].segment.ringOut = this;
            this.poly = null;
          }
          return n(e, null, [{
            key: "factory",
            value: u(function (t) {
              for (var n = [], i = 0, r = t.length; i < r; i++) {
                var o = t[i];
                if (o.isInResult() && !o.ringOut) {
                  for (var s = null, a = o.leftSE, l = o.rightSE, u = [a], h = a.point, c = []; s = a, a = l, u.push(a), a.point !== h;) for (;;) {
                    var p = a.getAvailableLinkedEvents();
                    if (0 === p.length) {
                      var d = u[0].point,
                        f = u[u.length - 1].point;
                      throw new Error("Unable to complete output ring starting at [".concat(d.x, ",") + " ".concat(d.y, "]. Last matching segment found ends at") + " [".concat(f.x, ", ").concat(f.y, "]."));
                    }
                    if (1 === p.length) {
                      l = p[0].otherSE;
                      break;
                    }
                    for (var m = null, g = 0, v = c.length; g < v; g++) if (c[g].point === a.point) {
                      m = g;
                      break;
                    }
                    if (null === m) {
                      c.push({
                        index: u.length,
                        point: a.point
                      });
                      var y = a.getLeftmostComparator(s);
                      l = p.sort(y)[0].otherSE;
                      break;
                    }
                    var _ = c.splice(m)[0],
                      x = u.splice(_.index);
                    x.unshift(x[0].otherSE), n.push(new e(x.reverse()));
                  }
                  n.push(new e(u));
                }
              }
              return n;
            }, "factory")
          }]), u(e, "RingOut"), n(e, [{
            key: "getGeom",
            value: u(function () {
              for (var t = this.events[0].point, e = [t], n = 1, i = this.events.length - 1; n < i; n++) {
                var r = this.events[n].point,
                  o = this.events[n + 1].point;
                0 !== P(r, t, o) && (e.push(r), t = r);
              }
              if (1 === e.length) return null;
              var s = e[0],
                a = e[1];
              0 === P(s, t, a) && e.shift(), e.push(e[0]);
              for (var l = this.isExteriorRing() ? 1 : -1, u = this.isExteriorRing() ? 0 : e.length - 1, h = this.isExteriorRing() ? e.length : -1, c = [], p = u; p != h; p += l) c.push([e[p].x, e[p].y]);
              return c;
            }, "getGeom")
          }, {
            key: "isExteriorRing",
            value: u(function () {
              if (void 0 === this._isExteriorRing) {
                var t = this.enclosingRing();
                this._isExteriorRing = !t || !t.isExteriorRing();
              }
              return this._isExteriorRing;
            }, "isExteriorRing")
          }, {
            key: "enclosingRing",
            value: u(function () {
              return void 0 === this._enclosingRing && (this._enclosingRing = this._calcEnclosingRing()), this._enclosingRing;
            }, "enclosingRing")
          }, {
            key: "_calcEnclosingRing",
            value: u(function () {
              for (var t = this.events[0], e = 1, n = this.events.length; e < n; e++) {
                var i = this.events[e];
                q.compare(t, i) > 0 && (t = i);
              }
              for (var r = t.segment.prevInResult(), o = r ? r.prevInResult() : null;;) {
                if (!r) return null;
                if (!o) return r.ringOut;
                if (o.ringOut !== r.ringOut) return o.ringOut.enclosingRing() !== r.ringOut ? r.ringOut : r.ringOut.enclosingRing();
                r = o.prevInResult(), o = r ? r.prevInResult() : null;
              }
            }, "_calcEnclosingRing")
          }]), e;
        }(),
        j = function () {
          function e(n) {
            t(this, e), this.exteriorRing = n, n.poly = this, this.interiorRings = [];
          }
          return u(e, "PolyOut"), n(e, [{
            key: "addInterior",
            value: u(function (t) {
              this.interiorRings.push(t), t.poly = this;
            }, "addInterior")
          }, {
            key: "getGeom",
            value: u(function () {
              var t = [this.exteriorRing.getGeom()];
              if (null === t[0]) return null;
              for (var e = 0, n = this.interiorRings.length; e < n; e++) {
                var i = this.interiorRings[e].getGeom();
                null !== i && t.push(i);
              }
              return t;
            }, "getGeom")
          }]), e;
        }(),
        G = function () {
          function e(n) {
            t(this, e), this.rings = n, this.polys = this._composePolys(n);
          }
          return u(e, "MultiPolyOut"), n(e, [{
            key: "getGeom",
            value: u(function () {
              for (var t = [], e = 0, n = this.polys.length; e < n; e++) {
                var i = this.polys[e].getGeom();
                null !== i && t.push(i);
              }
              return t;
            }, "getGeom")
          }, {
            key: "_composePolys",
            value: u(function (t) {
              for (var e = [], n = 0, i = t.length; n < i; n++) {
                var r = t[n];
                if (!r.poly) if (r.isExteriorRing()) e.push(new j(r));else {
                  var o = r.enclosingRing();
                  o.poly || e.push(new j(o)), o.poly.addInterior(r);
                }
              }
              return e;
            }, "_composePolys")
          }]), e;
        }(),
        W = function () {
          function e(n) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : F.compare;
            t(this, e), this.queue = n, this.tree = new c(i), this.segments = [];
          }
          return u(e, "SweepLine"), n(e, [{
            key: "process",
            value: u(function (t) {
              var e = t.segment,
                n = [];
              if (t.consumedBy) return t.isLeft ? this.queue.remove(t.otherSE) : this.tree.remove(e), n;
              var i = t.isLeft ? this.tree.insert(e) : this.tree.find(e);
              if (!i) throw new Error("Unable to find segment #".concat(e.id, " ") + "[".concat(e.leftSE.point.x, ", ").concat(e.leftSE.point.y, "] -> ") + "[".concat(e.rightSE.point.x, ", ").concat(e.rightSE.point.y, "] ") + "in SweepLine tree. Please submit a bug report.");
              for (var r = i, o = i, s = void 0, a = void 0; void 0 === s;) null === (r = this.tree.prev(r)) ? s = null : void 0 === r.key.consumedBy && (s = r.key);
              for (; void 0 === a;) null === (o = this.tree.next(o)) ? a = null : void 0 === o.key.consumedBy && (a = o.key);
              if (t.isLeft) {
                var l = null;
                if (s) {
                  var u = s.getIntersection(e);
                  if (null !== u && (e.isAnEndpoint(u) || (l = u), !s.isAnEndpoint(u))) for (var h = this._splitSafely(s, u), c = 0, p = h.length; c < p; c++) n.push(h[c]);
                }
                var d = null;
                if (a) {
                  var f = a.getIntersection(e);
                  if (null !== f && (e.isAnEndpoint(f) || (d = f), !a.isAnEndpoint(f))) for (var m = this._splitSafely(a, f), g = 0, v = m.length; g < v; g++) n.push(m[g]);
                }
                if (null !== l || null !== d) {
                  var y = null;
                  y = null === l ? d : null === d || q.comparePoints(l, d) <= 0 ? l : d, this.queue.remove(e.rightSE), n.push(e.rightSE);
                  for (var _ = e.split(y), x = 0, E = _.length; x < E; x++) n.push(_[x]);
                }
                n.length > 0 ? (this.tree.remove(e), n.push(t)) : (this.segments.push(e), e.prev = s);
              } else {
                if (s && a) {
                  var b = s.getIntersection(a);
                  if (null !== b) {
                    if (!s.isAnEndpoint(b)) for (var w = this._splitSafely(s, b), S = 0, M = w.length; S < M; S++) n.push(w[S]);
                    if (!a.isAnEndpoint(b)) for (var T = this._splitSafely(a, b), A = 0, P = T.length; A < P; A++) n.push(T[A]);
                  }
                }
                this.tree.remove(e);
              }
              return n;
            }, "process")
          }, {
            key: "_splitSafely",
            value: u(function (t, e) {
              this.tree.remove(t);
              var n = t.rightSE;
              this.queue.remove(n);
              var i = t.split(e);
              return i.push(n), void 0 === t.consumedBy && this.tree.insert(t), i;
            }, "_splitSafely")
          }]), e;
        }(),
        H = void 0 !== D && D.env.POLYGON_CLIPPING_MAX_QUEUE_SIZE || 1e6,
        X = void 0 !== D && D.env.POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS || 1e6,
        Y = new (function () {
          function e() {
            t(this, e);
          }
          return u(e, "Operation"), n(e, [{
            key: "run",
            value: u(function (t, e, n) {
              Y.type = t, M.reset();
              for (var i = [new z(e, !0)], r = 0, o = n.length; r < o; r++) i.push(new z(n[r], !1));
              if (Y.numMultiPolys = i.length, "difference" === Y.type) for (var s = i[0], a = 1; a < i.length;) null !== _(i[a].bbox, s.bbox) ? a++ : i.splice(a, 1);
              if ("intersection" === Y.type) for (var l = 0, u = i.length; l < u; l++) for (var h = i[l], p = l + 1, d = i.length; p < d; p++) if (null === _(h.bbox, i[p].bbox)) return [];
              for (var f = new c(q.compare), m = 0, g = i.length; m < g; m++) for (var v = i[m].getSweepEvents(), y = 0, x = v.length; y < x; y++) if (f.insert(v[y]), f.size > H) throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big). Please file a bug report.");
              for (var E = new W(f), b = f.size, w = f.pop(); w;) {
                var S = w.key;
                if (f.size === b) {
                  var T = S.segment;
                  throw new Error("Unable to pop() ".concat(S.isLeft ? "left" : "right", " SweepEvent ") + "[".concat(S.point.x, ", ").concat(S.point.y, "] from segment #").concat(T.id, " ") + "[".concat(T.leftSE.point.x, ", ").concat(T.leftSE.point.y, "] -> ") + "[".concat(T.rightSE.point.x, ", ").concat(T.rightSE.point.y, "] from queue. ") + "Please file a bug report.");
                }
                if (f.size > H) throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big). Please file a bug report.");
                if (E.segments.length > X) throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments). Please file a bug report.");
                for (var A = E.process(S), P = 0, C = A.length; P < C; P++) {
                  var I = A[P];
                  void 0 === I.consumedBy && f.insert(I);
                }
                b = f.size, w = f.pop();
              }
              M.reset();
              var N = V.factory(E.segments);
              return new G(N).getGeom();
            }, "run")
          }]), e;
        }())(),
        Z = u(function (t) {
          for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) n[i - 1] = arguments[i];
          return Y.run("union", t, n);
        }, "union"),
        J = u(function (t) {
          for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) n[i - 1] = arguments[i];
          return Y.run("intersection", t, n);
        }, "intersection"),
        K = u(function (t) {
          for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) n[i - 1] = arguments[i];
          return Y.run("xor", t, n);
        }, "xor"),
        Q = u(function (t) {
          for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) n[i - 1] = arguments[i];
          return Y.run("difference", t, n);
        }, "difference");
      return {
        union: Z,
        intersection: J,
        xor: K,
        difference: Q
      };
    }, "object" == typeof t && void 0 !== e ? e.exports = i() : "function" == typeof define && define.amd ? define(i) : (n = "undefined" != typeof globalThis ? globalThis : n || self).polygonClipping = i();
  }),
  ek = ze((t, e) => {
    var n, i;
    E(), n = t, i = function (t) {
      "use strict";

      function e() {}
      function n(t) {
        this.message = t || "";
      }
      function i(t) {
        this.message = t || "";
      }
      function r(t) {
        this.message = t || "";
      }
      function o() {}
      function s(t) {
        return null === t ? qt : t.color;
      }
      function a(t) {
        return null === t ? null : t.parent;
      }
      function l(t, e) {
        null !== t && (t.color = e);
      }
      function h(t) {
        return null === t ? null : t.left;
      }
      function c(t) {
        return null === t ? null : t.right;
      }
      function p() {
        this.root_ = null, this.size_ = 0;
      }
      function d() {}
      function f() {
        this.array_ = [], arguments[0] instanceof Et && this.addAll(arguments[0]);
      }
      function m() {}
      function g(t) {
        this.message = t || "";
      }
      function v() {
        this.array_ = [];
      }
      u(e, "e"), u(n, "n"), u(i, "i"), u(r, "r"), u(o, "o"), u(s, "s"), u(a, "a"), u(l, "u"), u(h, "l"), u(c, "c"), u(p, "p"), u(d, "h"), u(f, "f"), u(m, "g"), u(g, "d"), u(v, "y"), "fill" in Array.prototype || Object.defineProperty(Array.prototype, "fill", {
        configurable: !0,
        value: function (t) {
          if (null == this) throw new TypeError(this + " is not an object");
          var e = Object(this),
            n = Math.max(Math.min(e.length, 9007199254740991), 0) || 0,
            i = 1 in arguments && parseInt(Number(arguments[1]), 10) || 0;
          i = i < 0 ? Math.max(n + i, 0) : Math.min(i, n);
          var r = 2 in arguments && void 0 !== arguments[2] ? parseInt(Number(arguments[2]), 10) || 0 : n;
          for (r = r < 0 ? Math.max(n + arguments[2], 0) : Math.min(r, n); i < r;) e[i] = t, ++i;
          return e;
        },
        writable: !0
      }), Number.isFinite = Number.isFinite || function (t) {
        return "number" == typeof t && isFinite(t);
      }, Number.isInteger = Number.isInteger || function (t) {
        return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
      }, Number.parseFloat = Number.parseFloat || parseFloat, Number.isNaN = Number.isNaN || function (t) {
        return t != t;
      }, Math.trunc = Math.trunc || function (t) {
        return t < 0 ? Math.ceil(t) : Math.floor(t);
      };
      var y = u(function () {}, "_");
      y.prototype.interfaces_ = function () {
        return [];
      }, y.prototype.getClass = function () {
        return y;
      }, y.prototype.equalsWithTolerance = function (t, e, n) {
        return Math.abs(t - e) <= n;
      };
      var _ = function (t) {
          function e(e) {
            t.call(this, e), this.name = "IllegalArgumentException", this.message = e, this.stack = new t().stack;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
        }(Error),
        x = u(function () {}, "v"),
        E = {
          MAX_VALUE: {
            configurable: !0
          }
        };
      x.isNaN = function (t) {
        return Number.isNaN(t);
      }, x.doubleToLongBits = function (t) {
        return t;
      }, x.longBitsToDouble = function (t) {
        return t;
      }, x.isInfinite = function (t) {
        return !Number.isFinite(t);
      }, E.MAX_VALUE.get = function () {
        return Number.MAX_VALUE;
      }, Object.defineProperties(x, E);
      var b = u(function () {}, "E"),
        w = u(function () {}, "x"),
        S = u(function () {}, "N"),
        M = u(function t() {
          if (this.x = null, this.y = null, this.z = null, 0 === arguments.length) this.x = 0, this.y = 0, this.z = t.NULL_ORDINATE;else if (1 === arguments.length) {
            var e = arguments[0];
            this.x = e.x, this.y = e.y, this.z = e.z;
          } else 2 === arguments.length ? (this.x = arguments[0], this.y = arguments[1], this.z = t.NULL_ORDINATE) : 3 === arguments.length && (this.x = arguments[0], this.y = arguments[1], this.z = arguments[2]);
        }, "t"),
        T = {
          DimensionalComparator: {
            configurable: !0
          },
          serialVersionUID: {
            configurable: !0
          },
          NULL_ORDINATE: {
            configurable: !0
          },
          X: {
            configurable: !0
          },
          Y: {
            configurable: !0
          },
          Z: {
            configurable: !0
          }
        };
      M.prototype.setOrdinate = function (t, e) {
        switch (t) {
          case M.X:
            this.x = e;
            break;
          case M.Y:
            this.y = e;
            break;
          case M.Z:
            this.z = e;
            break;
          default:
            throw new _("Invalid ordinate index: " + t);
        }
      }, M.prototype.equals2D = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return this.x === t.x && this.y === t.y;
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          return !!y.equalsWithTolerance(this.x, e.x, n) && !!y.equalsWithTolerance(this.y, e.y, n);
        }
      }, M.prototype.getOrdinate = function (t) {
        switch (t) {
          case M.X:
            return this.x;
          case M.Y:
            return this.y;
          case M.Z:
            return this.z;
        }
        throw new _("Invalid ordinate index: " + t);
      }, M.prototype.equals3D = function (t) {
        return this.x === t.x && this.y === t.y && (this.z === t.z || x.isNaN(this.z)) && x.isNaN(t.z);
      }, M.prototype.equals = function (t) {
        return t instanceof M && this.equals2D(t);
      }, M.prototype.equalInZ = function (t, e) {
        return y.equalsWithTolerance(this.z, t.z, e);
      }, M.prototype.compareTo = function (t) {
        var e = t;
        return this.x < e.x ? -1 : this.x > e.x ? 1 : this.y < e.y ? -1 : this.y > e.y ? 1 : 0;
      }, M.prototype.clone = function () {}, M.prototype.copy = function () {
        return new M(this);
      }, M.prototype.toString = function () {
        return "(" + this.x + ", " + this.y + ", " + this.z + ")";
      }, M.prototype.distance3D = function (t) {
        var e = this.x - t.x,
          n = this.y - t.y,
          i = this.z - t.z;
        return Math.sqrt(e * e + n * n + i * i);
      }, M.prototype.distance = function (t) {
        var e = this.x - t.x,
          n = this.y - t.y;
        return Math.sqrt(e * e + n * n);
      }, M.prototype.hashCode = function () {
        var t = 17;
        return 37 * (t = 37 * t + M.hashCode(this.x)) + M.hashCode(this.y);
      }, M.prototype.setCoordinate = function (t) {
        this.x = t.x, this.y = t.y, this.z = t.z;
      }, M.prototype.interfaces_ = function () {
        return [b, w, e];
      }, M.prototype.getClass = function () {
        return M;
      }, M.hashCode = function () {
        if (1 === arguments.length) {
          var t = arguments[0],
            e = x.doubleToLongBits(t);
          return Math.trunc((e ^ e) >>> 32);
        }
      }, T.DimensionalComparator.get = function () {
        return A;
      }, T.serialVersionUID.get = function () {
        return 0x5cbf2c235c7e5800;
      }, T.NULL_ORDINATE.get = function () {
        return x.NaN;
      }, T.X.get = function () {
        return 0;
      }, T.Y.get = function () {
        return 1;
      }, T.Z.get = function () {
        return 2;
      }, Object.defineProperties(M, T);
      var A = u(function (t) {
        if (this._dimensionsToTest = 2, 0 !== arguments.length && 1 === arguments.length) {
          var e = arguments[0];
          if (2 !== e && 3 !== e) throw new _("only 2 or 3 dimensions may be specified");
          this._dimensionsToTest = e;
        }
      }, "L");
      A.prototype.compare = function (t, e) {
        var n = t,
          i = e,
          r = A.compare(n.x, i.x);
        if (0 !== r) return r;
        var o = A.compare(n.y, i.y);
        return 0 !== o ? o : this._dimensionsToTest <= 2 ? 0 : A.compare(n.z, i.z);
      }, A.prototype.interfaces_ = function () {
        return [S];
      }, A.prototype.getClass = function () {
        return A;
      }, A.compare = function (t, e) {
        return t < e ? -1 : t > e ? 1 : x.isNaN(t) ? x.isNaN(e) ? 0 : -1 : x.isNaN(e) ? 1 : 0;
      };
      var P = u(function () {}, "b");
      P.prototype.create = function () {}, P.prototype.interfaces_ = function () {
        return [];
      }, P.prototype.getClass = function () {
        return P;
      };
      var C = u(function () {}, "w"),
        I = {
          INTERIOR: {
            configurable: !0
          },
          BOUNDARY: {
            configurable: !0
          },
          EXTERIOR: {
            configurable: !0
          },
          NONE: {
            configurable: !0
          }
        };
      C.prototype.interfaces_ = function () {
        return [];
      }, C.prototype.getClass = function () {
        return C;
      }, C.toLocationSymbol = function (t) {
        switch (t) {
          case C.EXTERIOR:
            return "e";
          case C.BOUNDARY:
            return "b";
          case C.INTERIOR:
            return "i";
          case C.NONE:
            return "-";
        }
        throw new _("Unknown location value: " + t);
      }, I.INTERIOR.get = function () {
        return 0;
      }, I.BOUNDARY.get = function () {
        return 1;
      }, I.EXTERIOR.get = function () {
        return 2;
      }, I.NONE.get = function () {
        return -1;
      }, Object.defineProperties(C, I);
      var N = u(function (t, e) {
          return t.interfaces_ && t.interfaces_().indexOf(e) > -1;
        }, "T"),
        L = u(function () {}, "R"),
        R = {
          LOG_10: {
            configurable: !0
          }
        };
      L.prototype.interfaces_ = function () {
        return [];
      }, L.prototype.getClass = function () {
        return L;
      }, L.log10 = function (t) {
        var e = Math.log(t);
        return x.isInfinite(e) || x.isNaN(e) ? e : e / L.LOG_10;
      }, L.min = function (t, e, n, i) {
        var r = t;
        return e < r && (r = e), n < r && (r = n), i < r && (r = i), r;
      }, L.clamp = function () {
        if ("number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
          var t = arguments[0],
            e = arguments[1],
            n = arguments[2];
          return t < e ? e : t > n ? n : t;
        }
        if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
          var i = arguments[0],
            r = arguments[1],
            o = arguments[2];
          return i < r ? r : i > o ? o : i;
        }
      }, L.wrap = function (t, e) {
        return t < 0 ? e - -t % e : t % e;
      }, L.max = function () {
        if (3 === arguments.length) {
          var t = arguments[0],
            e = arguments[1],
            n = arguments[2],
            i = t;
          return e > i && (i = e), n > i && (i = n), i;
        }
        if (4 === arguments.length) {
          var r = arguments[0],
            o = arguments[1],
            s = arguments[2],
            a = arguments[3],
            l = r;
          return o > l && (l = o), s > l && (l = s), a > l && (l = a), l;
        }
      }, L.average = function (t, e) {
        return (t + e) / 2;
      }, R.LOG_10.get = function () {
        return Math.log(10);
      }, Object.defineProperties(L, R);
      var O = u(function (t) {
        this.str = t;
      }, "D");
      O.prototype.append = function (t) {
        this.str += t;
      }, O.prototype.setCharAt = function (t, e) {
        this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
      }, O.prototype.toString = function (t) {
        return this.str;
      };
      var q = u(function (t) {
        this.value = t;
      }, "M");
      q.prototype.intValue = function () {
        return this.value;
      }, q.prototype.compareTo = function (t) {
        return this.value < t ? -1 : this.value > t ? 1 : 0;
      }, q.isNaN = function (t) {
        return Number.isNaN(t);
      };
      var D = u(function () {}, "A");
      D.isWhitespace = function (t) {
        return t <= 32 && t >= 0 || 127 === t;
      }, D.toUpperCase = function (t) {
        return t.toUpperCase();
      };
      var k = u(function t() {
          if (this._hi = 0, this._lo = 0, 0 === arguments.length) this.init(0);else if (1 === arguments.length) {
            if ("number" == typeof arguments[0]) {
              var e = arguments[0];
              this.init(e);
            } else if (arguments[0] instanceof t) {
              var n = arguments[0];
              this.init(n);
            } else if ("string" == typeof arguments[0]) {
              var i = arguments[0];
              t.call(this, t.parse(i));
            }
          } else if (2 === arguments.length) {
            var r = arguments[0],
              o = arguments[1];
            this.init(r, o);
          }
        }, "t"),
        F = {
          PI: {
            configurable: !0
          },
          TWO_PI: {
            configurable: !0
          },
          PI_2: {
            configurable: !0
          },
          E: {
            configurable: !0
          },
          NaN: {
            configurable: !0
          },
          EPS: {
            configurable: !0
          },
          SPLIT: {
            configurable: !0
          },
          MAX_PRINT_DIGITS: {
            configurable: !0
          },
          TEN: {
            configurable: !0
          },
          ONE: {
            configurable: !0
          },
          SCI_NOT_EXPONENT_CHAR: {
            configurable: !0
          },
          SCI_NOT_ZERO: {
            configurable: !0
          }
        };
      k.prototype.le = function (t) {
        return (this._hi < t._hi || this._hi === t._hi) && this._lo <= t._lo;
      }, k.prototype.extractSignificantDigits = function (t, e) {
        var n = this.abs(),
          i = k.magnitude(n._hi),
          r = k.TEN.pow(i);
        (n = n.divide(r)).gt(k.TEN) ? (n = n.divide(k.TEN), i += 1) : n.lt(k.ONE) && (n = n.multiply(k.TEN), i -= 1);
        for (var o = i + 1, s = new O(), a = k.MAX_PRINT_DIGITS - 1, l = 0; l <= a; l++) {
          t && l === o && s.append(".");
          var u = Math.trunc(n._hi);
          if (u < 0) break;
          var h = !1,
            c = 0;
          u > 9 ? (h = !0, c = "9") : c = "0" + u, s.append(c), n = n.subtract(k.valueOf(u)).multiply(k.TEN), h && n.selfAdd(k.TEN);
          var p = !0,
            d = k.magnitude(n._hi);
          if (d < 0 && Math.abs(d) >= a - l && (p = !1), !p) break;
        }
        return e[0] = i, s.toString();
      }, k.prototype.sqr = function () {
        return this.multiply(this);
      }, k.prototype.doubleValue = function () {
        return this._hi + this._lo;
      }, k.prototype.subtract = function () {
        if (arguments[0] instanceof k) {
          var t = arguments[0];
          return this.add(t.negate());
        }
        if ("number" == typeof arguments[0]) {
          var e = arguments[0];
          return this.add(-e);
        }
      }, k.prototype.equals = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return this._hi === t._hi && this._lo === t._lo;
        }
      }, k.prototype.isZero = function () {
        return 0 === this._hi && 0 === this._lo;
      }, k.prototype.selfSubtract = function () {
        if (arguments[0] instanceof k) {
          var t = arguments[0];
          return this.isNaN() ? this : this.selfAdd(-t._hi, -t._lo);
        }
        if ("number" == typeof arguments[0]) {
          var e = arguments[0];
          return this.isNaN() ? this : this.selfAdd(-e, 0);
        }
      }, k.prototype.getSpecialNumberString = function () {
        return this.isZero() ? "0.0" : this.isNaN() ? "NaN " : null;
      }, k.prototype.min = function (t) {
        return this.le(t) ? this : t;
      }, k.prototype.selfDivide = function () {
        if (1 === arguments.length) {
          if (arguments[0] instanceof k) {
            var t = arguments[0];
            return this.selfDivide(t._hi, t._lo);
          }
          if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return this.selfDivide(e, 0);
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = null,
            o = null,
            s = null,
            a = null,
            l = null,
            u = null,
            h = null,
            c = null;
          return l = this._hi / n, c = (r = (u = k.SPLIT * l) - (r = u - l)) * (s = (c = k.SPLIT * n) - (s = c - n)) - (h = l * n) + r * (a = n - s) + (o = l - r) * s + o * a, c = l + (u = (this._hi - h - c + this._lo - l * i) / n), this._hi = c, this._lo = l - c + u, this;
        }
      }, k.prototype.dump = function () {
        return "DD<" + this._hi + ", " + this._lo + ">";
      }, k.prototype.divide = function () {
        if (arguments[0] instanceof k) {
          var t = arguments[0],
            e = null,
            n = null,
            i = null,
            r = null,
            o = null,
            s = null,
            a = null,
            l = null;
          return n = (o = this._hi / t._hi) - (e = (s = k.SPLIT * o) - (e = s - o)), l = e * (i = (l = k.SPLIT * t._hi) - (i = l - t._hi)) - (a = o * t._hi) + e * (r = t._hi - i) + n * i + n * r, s = (this._hi - a - l + this._lo - o * t._lo) / t._hi, new k(l = o + s, o - l + s);
        }
        if ("number" == typeof arguments[0]) {
          var u = arguments[0];
          return x.isNaN(u) ? k.createNaN() : k.copy(this).selfDivide(u, 0);
        }
      }, k.prototype.ge = function (t) {
        return (this._hi > t._hi || this._hi === t._hi) && this._lo >= t._lo;
      }, k.prototype.pow = function (t) {
        if (0 === t) return k.valueOf(1);
        var e = new k(this),
          n = k.valueOf(1),
          i = Math.abs(t);
        if (i > 1) for (; i > 0;) i % 2 == 1 && n.selfMultiply(e), (i /= 2) > 0 && (e = e.sqr());else n = e;
        return t < 0 ? n.reciprocal() : n;
      }, k.prototype.ceil = function () {
        if (this.isNaN()) return k.NaN;
        var t = Math.ceil(this._hi),
          e = 0;
        return t === this._hi && (e = Math.ceil(this._lo)), new k(t, e);
      }, k.prototype.compareTo = function (t) {
        var e = t;
        return this._hi < e._hi ? -1 : this._hi > e._hi ? 1 : this._lo < e._lo ? -1 : this._lo > e._lo ? 1 : 0;
      }, k.prototype.rint = function () {
        return this.isNaN() ? this : this.add(.5).floor();
      }, k.prototype.setValue = function () {
        if (arguments[0] instanceof k) {
          var t = arguments[0];
          return this.init(t), this;
        }
        if ("number" == typeof arguments[0]) {
          var e = arguments[0];
          return this.init(e), this;
        }
      }, k.prototype.max = function (t) {
        return this.ge(t) ? this : t;
      }, k.prototype.sqrt = function () {
        if (this.isZero()) return k.valueOf(0);
        if (this.isNegative()) return k.NaN;
        var t = 1 / Math.sqrt(this._hi),
          e = this._hi * t,
          n = k.valueOf(e),
          i = this.subtract(n.sqr())._hi * (.5 * t);
        return n.add(i);
      }, k.prototype.selfAdd = function () {
        if (1 === arguments.length) {
          if (arguments[0] instanceof k) {
            var t = arguments[0];
            return this.selfAdd(t._hi, t._lo);
          }
          if ("number" == typeof arguments[0]) {
            var e = arguments[0],
              n = null,
              i = null,
              r = null,
              o = null,
              s = null,
              a = null;
            return o = (r = this._hi + e) - (s = r - this._hi), i = (a = (o = e - s + (this._hi - o)) + this._lo) + (r - (n = r + a)), this._hi = n + i, this._lo = i + (n - this._hi), this;
          }
        } else if (2 === arguments.length) {
          var l = arguments[0],
            u = arguments[1],
            h = null,
            c = null,
            p = null,
            d = null,
            f = null,
            m = null,
            g = null;
          d = this._hi + l, c = this._lo + u, f = d - (m = d - this._hi), p = c - (g = c - this._lo);
          var v = (h = d + (m = (f = l - m + (this._hi - f)) + c)) + (m = (p = u - g + (this._lo - p)) + (m + (d - h))),
            y = m + (h - v);
          return this._hi = v, this._lo = y, this;
        }
      }, k.prototype.selfMultiply = function () {
        if (1 === arguments.length) {
          if (arguments[0] instanceof k) {
            var t = arguments[0];
            return this.selfMultiply(t._hi, t._lo);
          }
          if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return this.selfMultiply(e, 0);
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = null,
            o = null,
            s = null,
            a = null,
            l = null,
            u = null;
          r = (l = k.SPLIT * this._hi) - this._hi, u = k.SPLIT * n, r = l - r, o = this._hi - r, s = u - n;
          var h = (l = this._hi * n) + (u = r * (s = u - s) - l + r * (a = n - s) + o * s + o * a + (this._hi * i + this._lo * n)),
            c = u + (r = l - h);
          return this._hi = h, this._lo = c, this;
        }
      }, k.prototype.selfSqr = function () {
        return this.selfMultiply(this);
      }, k.prototype.floor = function () {
        if (this.isNaN()) return k.NaN;
        var t = Math.floor(this._hi),
          e = 0;
        return t === this._hi && (e = Math.floor(this._lo)), new k(t, e);
      }, k.prototype.negate = function () {
        return this.isNaN() ? this : new k(-this._hi, -this._lo);
      }, k.prototype.clone = function () {}, k.prototype.multiply = function () {
        if (arguments[0] instanceof k) {
          var t = arguments[0];
          return t.isNaN() ? k.createNaN() : k.copy(this).selfMultiply(t);
        }
        if ("number" == typeof arguments[0]) {
          var e = arguments[0];
          return x.isNaN(e) ? k.createNaN() : k.copy(this).selfMultiply(e, 0);
        }
      }, k.prototype.isNaN = function () {
        return x.isNaN(this._hi);
      }, k.prototype.intValue = function () {
        return Math.trunc(this._hi);
      }, k.prototype.toString = function () {
        var t = k.magnitude(this._hi);
        return t >= -3 && t <= 20 ? this.toStandardNotation() : this.toSciNotation();
      }, k.prototype.toStandardNotation = function () {
        var t = this.getSpecialNumberString();
        if (null !== t) return t;
        var e = new Array(1).fill(null),
          n = this.extractSignificantDigits(!0, e),
          i = e[0] + 1,
          r = n;
        if ("." === n.charAt(0)) r = "0" + n;else if (i < 0) r = "0." + k.stringOfChar("0", -i) + n;else if (-1 === n.indexOf(".")) {
          var o = i - n.length;
          r = n + k.stringOfChar("0", o) + ".0";
        }
        return this.isNegative() ? "-" + r : r;
      }, k.prototype.reciprocal = function () {
        var t,
          e,
          n,
          i,
          r = null,
          o = null,
          s = null,
          a = null;
        t = (n = 1 / this._hi) - (r = (s = k.SPLIT * n) - (r = s - n)), o = (a = k.SPLIT * this._hi) - this._hi;
        var l = n + (s = (1 - (i = n * this._hi) - (a = r * (o = a - o) - i + r * (e = this._hi - o) + t * o + t * e) - n * this._lo) / this._hi);
        return new k(l, n - l + s);
      }, k.prototype.toSciNotation = function () {
        if (this.isZero()) return k.SCI_NOT_ZERO;
        var t = this.getSpecialNumberString();
        if (null !== t) return t;
        var e = new Array(1).fill(null),
          n = this.extractSignificantDigits(!1, e),
          i = k.SCI_NOT_EXPONENT_CHAR + e[0];
        if ("0" === n.charAt(0)) throw new Error("Found leading zero: " + n);
        var r = "";
        n.length > 1 && (r = n.substring(1));
        var o = n.charAt(0) + "." + r;
        return this.isNegative() ? "-" + o + i : o + i;
      }, k.prototype.abs = function () {
        return this.isNaN() ? k.NaN : this.isNegative() ? this.negate() : new k(this);
      }, k.prototype.isPositive = function () {
        return (this._hi > 0 || 0 === this._hi) && this._lo > 0;
      }, k.prototype.lt = function (t) {
        return (this._hi < t._hi || this._hi === t._hi) && this._lo < t._lo;
      }, k.prototype.add = function () {
        if (arguments[0] instanceof k) {
          var t = arguments[0];
          return k.copy(this).selfAdd(t);
        }
        if ("number" == typeof arguments[0]) {
          var e = arguments[0];
          return k.copy(this).selfAdd(e);
        }
      }, k.prototype.init = function () {
        if (1 === arguments.length) {
          if ("number" == typeof arguments[0]) {
            var t = arguments[0];
            this._hi = t, this._lo = 0;
          } else if (arguments[0] instanceof k) {
            var e = arguments[0];
            this._hi = e._hi, this._lo = e._lo;
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          this._hi = n, this._lo = i;
        }
      }, k.prototype.gt = function (t) {
        return (this._hi > t._hi || this._hi === t._hi) && this._lo > t._lo;
      }, k.prototype.isNegative = function () {
        return (this._hi < 0 || 0 === this._hi) && this._lo < 0;
      }, k.prototype.trunc = function () {
        return this.isNaN() ? k.NaN : this.isPositive() ? this.floor() : this.ceil();
      }, k.prototype.signum = function () {
        return this._hi > 0 ? 1 : this._hi < 0 ? -1 : this._lo > 0 ? 1 : this._lo < 0 ? -1 : 0;
      }, k.prototype.interfaces_ = function () {
        return [e, b, w];
      }, k.prototype.getClass = function () {
        return k;
      }, k.sqr = function (t) {
        return k.valueOf(t).selfMultiply(t);
      }, k.valueOf = function () {
        if ("string" == typeof arguments[0]) {
          var t = arguments[0];
          return k.parse(t);
        }
        if ("number" == typeof arguments[0]) {
          var e = arguments[0];
          return new k(e);
        }
      }, k.sqrt = function (t) {
        return k.valueOf(t).sqrt();
      }, k.parse = function (t) {
        for (var e = 0, n = t.length; D.isWhitespace(t.charAt(e));) e++;
        var i = !1;
        if (e < n) {
          var r = t.charAt(e);
          "-" !== r && "+" !== r || (e++, "-" === r && (i = !0));
        }
        for (var o = new k(), s = 0, a = 0, l = 0; !(e >= n);) {
          var u = t.charAt(e);
          if (e++, D.isDigit(u)) {
            var h = u - "0";
            o.selfMultiply(k.TEN), o.selfAdd(h), s++;
          } else {
            if ("." !== u) {
              if ("e" === u || "E" === u) {
                var c = t.substring(e);
                try {
                  l = q.parseInt(c);
                } catch (e) {
                  throw e instanceof Error ? new Error("Invalid exponent " + c + " in string " + t) : e;
                }
                break;
              }
              throw new Error("Unexpected character '" + u + "' at position " + e + " in string " + t);
            }
            a = s;
          }
        }
        var p = o,
          d = s - a - l;
        if (0 === d) p = o;else if (d > 0) {
          var f = k.TEN.pow(d);
          p = o.divide(f);
        } else if (d < 0) {
          var m = k.TEN.pow(-d);
          p = o.multiply(m);
        }
        return i ? p.negate() : p;
      }, k.createNaN = function () {
        return new k(x.NaN, x.NaN);
      }, k.copy = function (t) {
        return new k(t);
      }, k.magnitude = function (t) {
        var e = Math.abs(t),
          n = Math.log(e) / Math.log(10),
          i = Math.trunc(Math.floor(n));
        return 10 * Math.pow(10, i) <= e && (i += 1), i;
      }, k.stringOfChar = function (t, e) {
        for (var n = new O(), i = 0; i < e; i++) n.append(t);
        return n.toString();
      }, F.PI.get = function () {
        return new k(3.141592653589793, 12246467991473532e-32);
      }, F.TWO_PI.get = function () {
        return new k(6.283185307179586, 24492935982947064e-32);
      }, F.PI_2.get = function () {
        return new k(1.5707963267948966, 6123233995736766e-32);
      }, F.E.get = function () {
        return new k(2.718281828459045, 14456468917292502e-32);
      }, F.NaN.get = function () {
        return new k(x.NaN, x.NaN);
      }, F.EPS.get = function () {
        return 123259516440783e-46;
      }, F.SPLIT.get = function () {
        return 134217729;
      }, F.MAX_PRINT_DIGITS.get = function () {
        return 32;
      }, F.TEN.get = function () {
        return k.valueOf(10);
      }, F.ONE.get = function () {
        return k.valueOf(1);
      }, F.SCI_NOT_EXPONENT_CHAR.get = function () {
        return "E";
      }, F.SCI_NOT_ZERO.get = function () {
        return "0.0E0";
      }, Object.defineProperties(k, F);
      var U = u(function () {}, "q"),
        B = {
          DP_SAFE_EPSILON: {
            configurable: !0
          }
        };
      U.prototype.interfaces_ = function () {
        return [];
      }, U.prototype.getClass = function () {
        return U;
      }, U.orientationIndex = function (t, e, n) {
        var i = U.orientationIndexFilter(t, e, n);
        if (i <= 1) return i;
        var r = k.valueOf(e.x).selfAdd(-t.x),
          o = k.valueOf(e.y).selfAdd(-t.y),
          s = k.valueOf(n.x).selfAdd(-e.x),
          a = k.valueOf(n.y).selfAdd(-e.y);
        return r.selfMultiply(a).selfSubtract(o.selfMultiply(s)).signum();
      }, U.signOfDet2x2 = function (t, e, n, i) {
        return t.multiply(i).selfSubtract(e.multiply(n)).signum();
      }, U.intersection = function (t, e, n, i) {
        var r = k.valueOf(i.y).selfSubtract(n.y).selfMultiply(k.valueOf(e.x).selfSubtract(t.x)),
          o = k.valueOf(i.x).selfSubtract(n.x).selfMultiply(k.valueOf(e.y).selfSubtract(t.y)),
          s = r.subtract(o),
          a = k.valueOf(i.x).selfSubtract(n.x).selfMultiply(k.valueOf(t.y).selfSubtract(n.y)),
          l = k.valueOf(i.y).selfSubtract(n.y).selfMultiply(k.valueOf(t.x).selfSubtract(n.x)),
          u = a.subtract(l).selfDivide(s).doubleValue(),
          h = k.valueOf(t.x).selfAdd(k.valueOf(e.x).selfSubtract(t.x).selfMultiply(u)).doubleValue(),
          c = k.valueOf(e.x).selfSubtract(t.x).selfMultiply(k.valueOf(t.y).selfSubtract(n.y)),
          p = k.valueOf(e.y).selfSubtract(t.y).selfMultiply(k.valueOf(t.x).selfSubtract(n.x)),
          d = c.subtract(p).selfDivide(s).doubleValue(),
          f = k.valueOf(n.y).selfAdd(k.valueOf(i.y).selfSubtract(n.y).selfMultiply(d)).doubleValue();
        return new M(h, f);
      }, U.orientationIndexFilter = function (t, e, n) {
        var i = null,
          r = (t.x - n.x) * (e.y - n.y),
          o = (t.y - n.y) * (e.x - n.x),
          s = r - o;
        if (r > 0) {
          if (o <= 0) return U.signum(s);
          i = r + o;
        } else {
          if (!(r < 0) || o >= 0) return U.signum(s);
          i = -r - o;
        }
        var a = U.DP_SAFE_EPSILON * i;
        return s >= a || -s >= a ? U.signum(s) : 2;
      }, U.signum = function (t) {
        return t > 0 ? 1 : t < 0 ? -1 : 0;
      }, B.DP_SAFE_EPSILON.get = function () {
        return 1e-15;
      }, Object.defineProperties(U, B);
      var z = u(function () {}, "V"),
        V = {
          X: {
            configurable: !0
          },
          Y: {
            configurable: !0
          },
          Z: {
            configurable: !0
          },
          M: {
            configurable: !0
          }
        };
      V.X.get = function () {
        return 0;
      }, V.Y.get = function () {
        return 1;
      }, V.Z.get = function () {
        return 2;
      }, V.M.get = function () {
        return 3;
      }, z.prototype.setOrdinate = function (t, e, n) {}, z.prototype.size = function () {}, z.prototype.getOrdinate = function (t, e) {}, z.prototype.getCoordinate = function () {}, z.prototype.getCoordinateCopy = function (t) {}, z.prototype.getDimension = function () {}, z.prototype.getX = function (t) {}, z.prototype.clone = function () {}, z.prototype.expandEnvelope = function (t) {}, z.prototype.copy = function () {}, z.prototype.getY = function (t) {}, z.prototype.toCoordinateArray = function () {}, z.prototype.interfaces_ = function () {
        return [w];
      }, z.prototype.getClass = function () {
        return z;
      }, Object.defineProperties(z, V);
      var j = u(function () {}, "z"),
        G = function (t) {
          function e() {
            t.call(this, "Projective point not representable on the Cartesian plane.");
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(j),
        W = u(function () {}, "Y");
      W.arraycopy = function (t, e, n, i, r) {
        for (var o = 0, s = e; s < e + r; s++) n[i + o] = t[s], o++;
      }, W.getProperty = function (t) {
        return {
          "line.separator": "\n"
        }[t];
      };
      var H = u(function t() {
        if (this.x = null, this.y = null, this.w = null, 0 === arguments.length) this.x = 0, this.y = 0, this.w = 1;else if (1 === arguments.length) {
          var e = arguments[0];
          this.x = e.x, this.y = e.y, this.w = 1;
        } else if (2 === arguments.length) {
          if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
            var n = arguments[0],
              i = arguments[1];
            this.x = n, this.y = i, this.w = 1;
          } else if (arguments[0] instanceof t && arguments[1] instanceof t) {
            var r = arguments[0],
              o = arguments[1];
            this.x = r.y * o.w - o.y * r.w, this.y = o.x * r.w - r.x * o.w, this.w = r.x * o.y - o.x * r.y;
          } else if (arguments[0] instanceof M && arguments[1] instanceof M) {
            var s = arguments[0],
              a = arguments[1];
            this.x = s.y - a.y, this.y = a.x - s.x, this.w = s.x * a.y - a.x * s.y;
          }
        } else if (3 === arguments.length) {
          var l = arguments[0],
            u = arguments[1],
            h = arguments[2];
          this.x = l, this.y = u, this.w = h;
        } else if (4 === arguments.length) {
          var c = arguments[0],
            p = arguments[1],
            d = arguments[2],
            f = arguments[3],
            m = c.y - p.y,
            g = p.x - c.x,
            v = c.x * p.y - p.x * c.y,
            y = d.y - f.y,
            _ = f.x - d.x,
            x = d.x * f.y - f.x * d.y;
          this.x = g * x - _ * v, this.y = y * v - m * x, this.w = m * _ - y * g;
        }
      }, "t");
      H.prototype.getY = function () {
        var t = this.y / this.w;
        if (x.isNaN(t) || x.isInfinite(t)) throw new G();
        return t;
      }, H.prototype.getX = function () {
        var t = this.x / this.w;
        if (x.isNaN(t) || x.isInfinite(t)) throw new G();
        return t;
      }, H.prototype.getCoordinate = function () {
        var t = new M();
        return t.x = this.getX(), t.y = this.getY(), t;
      }, H.prototype.interfaces_ = function () {
        return [];
      }, H.prototype.getClass = function () {
        return H;
      }, H.intersection = function (t, e, n, i) {
        var r = t.y - e.y,
          o = e.x - t.x,
          s = t.x * e.y - e.x * t.y,
          a = n.y - i.y,
          l = i.x - n.x,
          u = n.x * i.y - i.x * n.y,
          h = r * l - a * o,
          c = (o * u - l * s) / h,
          p = (a * s - r * u) / h;
        if (x.isNaN(c) || x.isInfinite(c) || x.isNaN(p) || x.isInfinite(p)) throw new G();
        return new M(c, p);
      };
      var X = u(function t() {
          if (this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, 0 === arguments.length) this.init();else if (1 === arguments.length) {
            if (arguments[0] instanceof M) {
              var e = arguments[0];
              this.init(e.x, e.x, e.y, e.y);
            } else if (arguments[0] instanceof t) {
              var n = arguments[0];
              this.init(n);
            }
          } else if (2 === arguments.length) {
            var i = arguments[0],
              r = arguments[1];
            this.init(i.x, r.x, i.y, r.y);
          } else if (4 === arguments.length) {
            var o = arguments[0],
              s = arguments[1],
              a = arguments[2],
              l = arguments[3];
            this.init(o, s, a, l);
          }
        }, "t"),
        Y = {
          serialVersionUID: {
            configurable: !0
          }
        };
      X.prototype.getArea = function () {
        return this.getWidth() * this.getHeight();
      }, X.prototype.equals = function (t) {
        if (!(t instanceof X)) return !1;
        var e = t;
        return this.isNull() ? e.isNull() : this._maxx === e.getMaxX() && this._maxy === e.getMaxY() && this._minx === e.getMinX() && this._miny === e.getMinY();
      }, X.prototype.intersection = function (t) {
        if (this.isNull() || t.isNull() || !this.intersects(t)) return new X();
        var e = this._minx > t._minx ? this._minx : t._minx,
          n = this._miny > t._miny ? this._miny : t._miny,
          i = this._maxx < t._maxx ? this._maxx : t._maxx,
          r = this._maxy < t._maxy ? this._maxy : t._maxy;
        return new X(e, i, n, r);
      }, X.prototype.isNull = function () {
        return this._maxx < this._minx;
      }, X.prototype.getMaxX = function () {
        return this._maxx;
      }, X.prototype.covers = function () {
        if (1 === arguments.length) {
          if (arguments[0] instanceof M) {
            var t = arguments[0];
            return this.covers(t.x, t.y);
          }
          if (arguments[0] instanceof X) {
            var e = arguments[0];
            return !this.isNull() && !e.isNull() && e.getMinX() >= this._minx && e.getMaxX() <= this._maxx && e.getMinY() >= this._miny && e.getMaxY() <= this._maxy;
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          return !this.isNull() && n >= this._minx && n <= this._maxx && i >= this._miny && i <= this._maxy;
        }
      }, X.prototype.intersects = function () {
        if (1 === arguments.length) {
          if (arguments[0] instanceof X) {
            var t = arguments[0];
            return !this.isNull() && !t.isNull() && !(t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny);
          }
          if (arguments[0] instanceof M) {
            var e = arguments[0];
            return this.intersects(e.x, e.y);
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          return !this.isNull() && !(n > this._maxx || n < this._minx || i > this._maxy || i < this._miny);
        }
      }, X.prototype.getMinY = function () {
        return this._miny;
      }, X.prototype.getMinX = function () {
        return this._minx;
      }, X.prototype.expandToInclude = function () {
        if (1 === arguments.length) {
          if (arguments[0] instanceof M) {
            var t = arguments[0];
            this.expandToInclude(t.x, t.y);
          } else if (arguments[0] instanceof X) {
            var e = arguments[0];
            if (e.isNull()) return null;
            this.isNull() ? (this._minx = e.getMinX(), this._maxx = e.getMaxX(), this._miny = e.getMinY(), this._maxy = e.getMaxY()) : (e._minx < this._minx && (this._minx = e._minx), e._maxx > this._maxx && (this._maxx = e._maxx), e._miny < this._miny && (this._miny = e._miny), e._maxy > this._maxy && (this._maxy = e._maxy));
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          this.isNull() ? (this._minx = n, this._maxx = n, this._miny = i, this._maxy = i) : (n < this._minx && (this._minx = n), n > this._maxx && (this._maxx = n), i < this._miny && (this._miny = i), i > this._maxy && (this._maxy = i));
        }
      }, X.prototype.minExtent = function () {
        if (this.isNull()) return 0;
        var t = this.getWidth(),
          e = this.getHeight();
        return t < e ? t : e;
      }, X.prototype.getWidth = function () {
        return this.isNull() ? 0 : this._maxx - this._minx;
      }, X.prototype.compareTo = function (t) {
        var e = t;
        return this.isNull() ? e.isNull() ? 0 : -1 : e.isNull() ? 1 : this._minx < e._minx ? -1 : this._minx > e._minx ? 1 : this._miny < e._miny ? -1 : this._miny > e._miny ? 1 : this._maxx < e._maxx ? -1 : this._maxx > e._maxx ? 1 : this._maxy < e._maxy ? -1 : this._maxy > e._maxy ? 1 : 0;
      }, X.prototype.translate = function (t, e) {
        if (this.isNull()) return null;
        this.init(this.getMinX() + t, this.getMaxX() + t, this.getMinY() + e, this.getMaxY() + e);
      }, X.prototype.toString = function () {
        return "Env[" + this._minx + " : " + this._maxx + ", " + this._miny + " : " + this._maxy + "]";
      }, X.prototype.setToNull = function () {
        this._minx = 0, this._maxx = -1, this._miny = 0, this._maxy = -1;
      }, X.prototype.getHeight = function () {
        return this.isNull() ? 0 : this._maxy - this._miny;
      }, X.prototype.maxExtent = function () {
        if (this.isNull()) return 0;
        var t = this.getWidth(),
          e = this.getHeight();
        return t > e ? t : e;
      }, X.prototype.expandBy = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.expandBy(t, t);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          if (this.isNull()) return null;
          this._minx -= e, this._maxx += e, this._miny -= n, this._maxy += n, (this._minx > this._maxx || this._miny > this._maxy) && this.setToNull();
        }
      }, X.prototype.contains = function () {
        if (1 === arguments.length) {
          if (arguments[0] instanceof X) {
            var t = arguments[0];
            return this.covers(t);
          }
          if (arguments[0] instanceof M) {
            var e = arguments[0];
            return this.covers(e);
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          return this.covers(n, i);
        }
      }, X.prototype.centre = function () {
        return this.isNull() ? null : new M((this.getMinX() + this.getMaxX()) / 2, (this.getMinY() + this.getMaxY()) / 2);
      }, X.prototype.init = function () {
        if (0 === arguments.length) this.setToNull();else if (1 === arguments.length) {
          if (arguments[0] instanceof M) {
            var t = arguments[0];
            this.init(t.x, t.x, t.y, t.y);
          } else if (arguments[0] instanceof X) {
            var e = arguments[0];
            this._minx = e._minx, this._maxx = e._maxx, this._miny = e._miny, this._maxy = e._maxy;
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          this.init(n.x, i.x, n.y, i.y);
        } else if (4 === arguments.length) {
          var r = arguments[0],
            o = arguments[1],
            s = arguments[2],
            a = arguments[3];
          r < o ? (this._minx = r, this._maxx = o) : (this._minx = o, this._maxx = r), s < a ? (this._miny = s, this._maxy = a) : (this._miny = a, this._maxy = s);
        }
      }, X.prototype.getMaxY = function () {
        return this._maxy;
      }, X.prototype.distance = function (t) {
        if (this.intersects(t)) return 0;
        var e = 0;
        this._maxx < t._minx ? e = t._minx - this._maxx : this._minx > t._maxx && (e = this._minx - t._maxx);
        var n = 0;
        return this._maxy < t._miny ? n = t._miny - this._maxy : this._miny > t._maxy && (n = this._miny - t._maxy), 0 === e ? n : 0 === n ? e : Math.sqrt(e * e + n * n);
      }, X.prototype.hashCode = function () {
        var t = 17;
        return 37 * (t = 37 * (t = 37 * (t = 37 * t + M.hashCode(this._minx)) + M.hashCode(this._maxx)) + M.hashCode(this._miny)) + M.hashCode(this._maxy);
      }, X.prototype.interfaces_ = function () {
        return [b, e];
      }, X.prototype.getClass = function () {
        return X;
      }, X.intersects = function () {
        if (3 === arguments.length) {
          var t = arguments[0],
            e = arguments[1],
            n = arguments[2];
          return n.x >= (t.x < e.x ? t.x : e.x) && n.x <= (t.x > e.x ? t.x : e.x) && n.y >= (t.y < e.y ? t.y : e.y) && n.y <= (t.y > e.y ? t.y : e.y);
        }
        if (4 === arguments.length) {
          var i = arguments[0],
            r = arguments[1],
            o = arguments[2],
            s = arguments[3],
            a = Math.min(o.x, s.x),
            l = Math.max(o.x, s.x),
            u = Math.min(i.x, r.x),
            h = Math.max(i.x, r.x);
          return !(u > l || h < a || (a = Math.min(o.y, s.y), l = Math.max(o.y, s.y), u = Math.min(i.y, r.y), h = Math.max(i.y, r.y), u > l || h < a));
        }
      }, Y.serialVersionUID.get = function () {
        return 0x51845cd552189800;
      }, Object.defineProperties(X, Y);
      var Z = {
          typeStr: /^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,
          emptyTypeStr: /^\s*(\w+)\s*EMPTY\s*$/,
          spaces: /\s+/,
          parenComma: /\)\s*,\s*\(/,
          doubleParenComma: /\)\s*\)\s*,\s*\(\s*\(/,
          trimParens: /^\s*\(?(.*?)\)?\s*$/
        },
        J = u(function (t) {
          this.geometryFactory = t || new ye();
        }, "K");
      J.prototype.read = function (t) {
        var e, n, i;
        t = t.replace(/[\n\r]/g, " ");
        var r = Z.typeStr.exec(t);
        if (-1 !== t.search("EMPTY") && ((r = Z.emptyTypeStr.exec(t))[2] = void 0), r && (n = r[1].toLowerCase(), i = r[2], Q[n] && (e = Q[n].apply(this, [i]))), void 0 === e) throw new Error("Could not parse WKT " + t);
        return e;
      }, J.prototype.write = function (t) {
        return this.extractGeometry(t);
      }, J.prototype.extractGeometry = function (t) {
        var e = t.getGeometryType().toLowerCase();
        if (!K[e]) return null;
        var n = e.toUpperCase();
        return t.isEmpty() ? n + " EMPTY" : n + "(" + K[e].apply(this, [t]) + ")";
      };
      var K = {
          coordinate: function (t) {
            return t.x + " " + t.y;
          },
          point: function (t) {
            return K.coordinate.call(this, t._coordinates._coordinates[0]);
          },
          multipoint: function (t) {
            for (var e = [], n = 0, i = t._geometries.length; n < i; ++n) e.push("(" + K.point.apply(this, [t._geometries[n]]) + ")");
            return e.join(",");
          },
          linestring: function (t) {
            for (var e = [], n = 0, i = t._points._coordinates.length; n < i; ++n) e.push(K.coordinate.apply(this, [t._points._coordinates[n]]));
            return e.join(",");
          },
          linearring: function (t) {
            for (var e = [], n = 0, i = t._points._coordinates.length; n < i; ++n) e.push(K.coordinate.apply(this, [t._points._coordinates[n]]));
            return e.join(",");
          },
          multilinestring: function (t) {
            for (var e = [], n = 0, i = t._geometries.length; n < i; ++n) e.push("(" + K.linestring.apply(this, [t._geometries[n]]) + ")");
            return e.join(",");
          },
          polygon: function (t) {
            var e = [];
            e.push("(" + K.linestring.apply(this, [t._shell]) + ")");
            for (var n = 0, i = t._holes.length; n < i; ++n) e.push("(" + K.linestring.apply(this, [t._holes[n]]) + ")");
            return e.join(",");
          },
          multipolygon: function (t) {
            for (var e = [], n = 0, i = t._geometries.length; n < i; ++n) e.push("(" + K.polygon.apply(this, [t._geometries[n]]) + ")");
            return e.join(",");
          },
          geometrycollection: function (t) {
            for (var e = [], n = 0, i = t._geometries.length; n < i; ++n) e.push(this.extractGeometry(t._geometries[n]));
            return e.join(",");
          }
        },
        Q = {
          point: function (t) {
            if (void 0 === t) return this.geometryFactory.createPoint();
            var e = t.trim().split(Z.spaces);
            return this.geometryFactory.createPoint(new M(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
          },
          multipoint: function (t) {
            if (void 0 === t) return this.geometryFactory.createMultiPoint();
            for (var e, n = t.trim().split(","), i = [], r = 0, o = n.length; r < o; ++r) e = n[r].replace(Z.trimParens, "$1"), i.push(Q.point.apply(this, [e]));
            return this.geometryFactory.createMultiPoint(i);
          },
          linestring: function (t) {
            if (void 0 === t) return this.geometryFactory.createLineString();
            for (var e, n = t.trim().split(","), i = [], r = 0, o = n.length; r < o; ++r) e = n[r].trim().split(Z.spaces), i.push(new M(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
            return this.geometryFactory.createLineString(i);
          },
          linearring: function (t) {
            if (void 0 === t) return this.geometryFactory.createLinearRing();
            for (var e, n = t.trim().split(","), i = [], r = 0, o = n.length; r < o; ++r) e = n[r].trim().split(Z.spaces), i.push(new M(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
            return this.geometryFactory.createLinearRing(i);
          },
          multilinestring: function (t) {
            if (void 0 === t) return this.geometryFactory.createMultiLineString();
            for (var e, n = t.trim().split(Z.parenComma), i = [], r = 0, o = n.length; r < o; ++r) e = n[r].replace(Z.trimParens, "$1"), i.push(Q.linestring.apply(this, [e]));
            return this.geometryFactory.createMultiLineString(i);
          },
          polygon: function (t) {
            if (void 0 === t) return this.geometryFactory.createPolygon();
            for (var e, n, i, r, o = t.trim().split(Z.parenComma), s = [], a = 0, l = o.length; a < l; ++a) e = o[a].replace(Z.trimParens, "$1"), n = Q.linestring.apply(this, [e]), i = this.geometryFactory.createLinearRing(n._points), 0 === a ? r = i : s.push(i);
            return this.geometryFactory.createPolygon(r, s);
          },
          multipolygon: function (t) {
            if (void 0 === t) return this.geometryFactory.createMultiPolygon();
            for (var e, n = t.trim().split(Z.doubleParenComma), i = [], r = 0, o = n.length; r < o; ++r) e = n[r].replace(Z.trimParens, "$1"), i.push(Q.polygon.apply(this, [e]));
            return this.geometryFactory.createMultiPolygon(i);
          },
          geometrycollection: function (t) {
            if (void 0 === t) return this.geometryFactory.createGeometryCollection();
            for (var e = (t = t.replace(/,\s*([A-Za-z])/g, "|$1")).trim().split("|"), n = [], i = 0, r = e.length; i < r; ++i) n.push(this.read(e[i]));
            return this.geometryFactory.createGeometryCollection(n);
          }
        },
        $ = u(function (t) {
          this.parser = new J(t);
        }, "Z");
      $.prototype.write = function (t) {
        return this.parser.write(t);
      }, $.toLineString = function (t, e) {
        if (2 !== arguments.length) throw new Error("Not implemented");
        return "LINESTRING ( " + t.x + " " + t.y + ", " + e.x + " " + e.y + " )";
      };
      var tt = function (t) {
          function e(e) {
            t.call(this, e), this.name = "RuntimeException", this.message = e, this.stack = new t().stack;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
        }(Error),
        et = function (t) {
          function e() {
            if (t.call(this), 0 === arguments.length) t.call(this);else if (1 === arguments.length) {
              var e = arguments[0];
              t.call(this, e);
            }
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(tt),
        nt = u(function () {}, "et");
      nt.prototype.interfaces_ = function () {
        return [];
      }, nt.prototype.getClass = function () {
        return nt;
      }, nt.shouldNeverReachHere = function () {
        if (0 === arguments.length) nt.shouldNeverReachHere(null);else if (1 === arguments.length) {
          var t = arguments[0];
          throw new et("Should never reach here" + (null !== t ? ": " + t : ""));
        }
      }, nt.isTrue = function () {
        var t, e;
        if (1 === arguments.length) t = arguments[0], nt.isTrue(t, null);else if (2 === arguments.length && (e = arguments[1], !(t = arguments[0]))) throw null === e ? new et() : new et(e);
      }, nt.equals = function () {
        var t, e, n;
        if (2 === arguments.length) t = arguments[0], e = arguments[1], nt.equals(t, e, null);else if (3 === arguments.length && (t = arguments[0], n = arguments[2], !(e = arguments[1]).equals(t))) throw new et("Expected " + t + " but encountered " + e + (null !== n ? ": " + n : ""));
      };
      var it = u(function () {
          this._result = null, this._inputLines = Array(2).fill().map(function () {
            return Array(2);
          }), this._intPt = new Array(2).fill(null), this._intLineIndex = null, this._isProper = null, this._pa = null, this._pb = null, this._precisionModel = null, this._intPt[0] = new M(), this._intPt[1] = new M(), this._pa = this._intPt[0], this._pb = this._intPt[1], this._result = 0;
        }, "nt"),
        rt = {
          DONT_INTERSECT: {
            configurable: !0
          },
          DO_INTERSECT: {
            configurable: !0
          },
          COLLINEAR: {
            configurable: !0
          },
          NO_INTERSECTION: {
            configurable: !0
          },
          POINT_INTERSECTION: {
            configurable: !0
          },
          COLLINEAR_INTERSECTION: {
            configurable: !0
          }
        };
      it.prototype.getIndexAlongSegment = function (t, e) {
        return this.computeIntLineIndex(), this._intLineIndex[t][e];
      }, it.prototype.getTopologySummary = function () {
        var t = new O();
        return this.isEndPoint() && t.append(" endpoint"), this._isProper && t.append(" proper"), this.isCollinear() && t.append(" collinear"), t.toString();
      }, it.prototype.computeIntersection = function (t, e, n, i) {
        this._inputLines[0][0] = t, this._inputLines[0][1] = e, this._inputLines[1][0] = n, this._inputLines[1][1] = i, this._result = this.computeIntersect(t, e, n, i);
      }, it.prototype.getIntersectionNum = function () {
        return this._result;
      }, it.prototype.computeIntLineIndex = function () {
        if (0 === arguments.length) null === this._intLineIndex && (this._intLineIndex = Array(2).fill().map(function () {
          return Array(2);
        }), this.computeIntLineIndex(0), this.computeIntLineIndex(1));else if (1 === arguments.length) {
          var t = arguments[0];
          this.getEdgeDistance(t, 0) > this.getEdgeDistance(t, 1) ? (this._intLineIndex[t][0] = 0, this._intLineIndex[t][1] = 1) : (this._intLineIndex[t][0] = 1, this._intLineIndex[t][1] = 0);
        }
      }, it.prototype.isProper = function () {
        return this.hasIntersection() && this._isProper;
      }, it.prototype.setPrecisionModel = function (t) {
        this._precisionModel = t;
      }, it.prototype.isInteriorIntersection = function () {
        if (0 === arguments.length) return !!this.isInteriorIntersection(0) || !!this.isInteriorIntersection(1);
        if (1 === arguments.length) {
          for (var t = arguments[0], e = 0; e < this._result; e++) if (!this._intPt[e].equals2D(this._inputLines[t][0]) && !this._intPt[e].equals2D(this._inputLines[t][1])) return !0;
          return !1;
        }
      }, it.prototype.getIntersection = function (t) {
        return this._intPt[t];
      }, it.prototype.isEndPoint = function () {
        return this.hasIntersection() && !this._isProper;
      }, it.prototype.hasIntersection = function () {
        return this._result !== it.NO_INTERSECTION;
      }, it.prototype.getEdgeDistance = function (t, e) {
        return it.computeEdgeDistance(this._intPt[e], this._inputLines[t][0], this._inputLines[t][1]);
      }, it.prototype.isCollinear = function () {
        return this._result === it.COLLINEAR_INTERSECTION;
      }, it.prototype.toString = function () {
        return $.toLineString(this._inputLines[0][0], this._inputLines[0][1]) + " - " + $.toLineString(this._inputLines[1][0], this._inputLines[1][1]) + this.getTopologySummary();
      }, it.prototype.getEndpoint = function (t, e) {
        return this._inputLines[t][e];
      }, it.prototype.isIntersection = function (t) {
        for (var e = 0; e < this._result; e++) if (this._intPt[e].equals2D(t)) return !0;
        return !1;
      }, it.prototype.getIntersectionAlongSegment = function (t, e) {
        return this.computeIntLineIndex(), this._intPt[this._intLineIndex[t][e]];
      }, it.prototype.interfaces_ = function () {
        return [];
      }, it.prototype.getClass = function () {
        return it;
      }, it.computeEdgeDistance = function (t, e, n) {
        var i = Math.abs(n.x - e.x),
          r = Math.abs(n.y - e.y),
          o = -1;
        if (t.equals(e)) o = 0;else if (t.equals(n)) o = i > r ? i : r;else {
          var s = Math.abs(t.x - e.x),
            a = Math.abs(t.y - e.y);
          0 !== (o = i > r ? s : a) || t.equals(e) || (o = Math.max(s, a));
        }
        return nt.isTrue(!(0 === o && !t.equals(e)), "Bad distance calculation"), o;
      }, it.nonRobustComputeEdgeDistance = function (t, e, n) {
        var i = t.x - e.x,
          r = t.y - e.y,
          o = Math.sqrt(i * i + r * r);
        return nt.isTrue(!(0 === o && !t.equals(e)), "Invalid distance calculation"), o;
      }, rt.DONT_INTERSECT.get = function () {
        return 0;
      }, rt.DO_INTERSECT.get = function () {
        return 1;
      }, rt.COLLINEAR.get = function () {
        return 2;
      }, rt.NO_INTERSECTION.get = function () {
        return 0;
      }, rt.POINT_INTERSECTION.get = function () {
        return 1;
      }, rt.COLLINEAR_INTERSECTION.get = function () {
        return 2;
      }, Object.defineProperties(it, rt);
      var ot = function (t) {
          function e() {
            t.apply(this, arguments);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isInSegmentEnvelopes = function (t) {
            var e = new X(this._inputLines[0][0], this._inputLines[0][1]),
              n = new X(this._inputLines[1][0], this._inputLines[1][1]);
            return e.contains(t) && n.contains(t);
          }, e.prototype.computeIntersection = function () {
            if (3 !== arguments.length) return t.prototype.computeIntersection.apply(this, arguments);
            var e = arguments[0],
              n = arguments[1],
              i = arguments[2];
            if (this._isProper = !1, X.intersects(n, i, e) && 0 === lt.orientationIndex(n, i, e) && 0 === lt.orientationIndex(i, n, e)) return this._isProper = !0, (e.equals(n) || e.equals(i)) && (this._isProper = !1), this._result = t.POINT_INTERSECTION, null;
            this._result = t.NO_INTERSECTION;
          }, e.prototype.normalizeToMinimum = function (t, e, n, i, r) {
            r.x = this.smallestInAbsValue(t.x, e.x, n.x, i.x), r.y = this.smallestInAbsValue(t.y, e.y, n.y, i.y), t.x -= r.x, t.y -= r.y, e.x -= r.x, e.y -= r.y, n.x -= r.x, n.y -= r.y, i.x -= r.x, i.y -= r.y;
          }, e.prototype.safeHCoordinateIntersection = function (t, n, i, r) {
            var o = null;
            try {
              o = H.intersection(t, n, i, r);
            } catch (s) {
              if (!(s instanceof G)) throw s;
              o = e.nearestEndpoint(t, n, i, r);
            }
            return o;
          }, e.prototype.intersection = function (t, n, i, r) {
            var o = this.intersectionWithNormalization(t, n, i, r);
            return this.isInSegmentEnvelopes(o) || (o = new M(e.nearestEndpoint(t, n, i, r))), null !== this._precisionModel && this._precisionModel.makePrecise(o), o;
          }, e.prototype.smallestInAbsValue = function (t, e, n, i) {
            var r = t,
              o = Math.abs(r);
            return Math.abs(e) < o && (r = e, o = Math.abs(e)), Math.abs(n) < o && (r = n, o = Math.abs(n)), Math.abs(i) < o && (r = i), r;
          }, e.prototype.checkDD = function (t, e, n, i, r) {
            var o = U.intersection(t, e, n, i),
              s = this.isInSegmentEnvelopes(o);
            W.out.println("DD in env = " + s + "  --------------------- " + o), r.distance(o) > 1e-4 && W.out.println("Distance = " + r.distance(o));
          }, e.prototype.intersectionWithNormalization = function (t, e, n, i) {
            var r = new M(t),
              o = new M(e),
              s = new M(n),
              a = new M(i),
              l = new M();
            this.normalizeToEnvCentre(r, o, s, a, l);
            var u = this.safeHCoordinateIntersection(r, o, s, a);
            return u.x += l.x, u.y += l.y, u;
          }, e.prototype.computeCollinearIntersection = function (e, n, i, r) {
            var o = X.intersects(e, n, i),
              s = X.intersects(e, n, r),
              a = X.intersects(i, r, e),
              l = X.intersects(i, r, n);
            return o && s ? (this._intPt[0] = i, this._intPt[1] = r, t.COLLINEAR_INTERSECTION) : a && l ? (this._intPt[0] = e, this._intPt[1] = n, t.COLLINEAR_INTERSECTION) : o && a ? (this._intPt[0] = i, this._intPt[1] = e, !i.equals(e) || s || l ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : o && l ? (this._intPt[0] = i, this._intPt[1] = n, !i.equals(n) || s || a ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : s && a ? (this._intPt[0] = r, this._intPt[1] = e, !r.equals(e) || o || l ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : s && l ? (this._intPt[0] = r, this._intPt[1] = n, !r.equals(n) || o || a ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : t.NO_INTERSECTION;
          }, e.prototype.normalizeToEnvCentre = function (t, e, n, i, r) {
            var o = t.x < e.x ? t.x : e.x,
              s = t.y < e.y ? t.y : e.y,
              a = t.x > e.x ? t.x : e.x,
              l = t.y > e.y ? t.y : e.y,
              u = n.x < i.x ? n.x : i.x,
              h = n.y < i.y ? n.y : i.y,
              c = n.x > i.x ? n.x : i.x,
              p = n.y > i.y ? n.y : i.y,
              d = ((o > u ? o : u) + (a < c ? a : c)) / 2,
              f = ((s > h ? s : h) + (l < p ? l : p)) / 2;
            r.x = d, r.y = f, t.x -= r.x, t.y -= r.y, e.x -= r.x, e.y -= r.y, n.x -= r.x, n.y -= r.y, i.x -= r.x, i.y -= r.y;
          }, e.prototype.computeIntersect = function (e, n, i, r) {
            if (this._isProper = !1, !X.intersects(e, n, i, r)) return t.NO_INTERSECTION;
            var o = lt.orientationIndex(e, n, i),
              s = lt.orientationIndex(e, n, r);
            if (o > 0 && s > 0 || o < 0 && s < 0) return t.NO_INTERSECTION;
            var a = lt.orientationIndex(i, r, e),
              l = lt.orientationIndex(i, r, n);
            return a > 0 && l > 0 || a < 0 && l < 0 ? t.NO_INTERSECTION : 0 === o && 0 === s && 0 === a && 0 === l ? this.computeCollinearIntersection(e, n, i, r) : (0 === o || 0 === s || 0 === a || 0 === l ? (this._isProper = !1, e.equals2D(i) || e.equals2D(r) ? this._intPt[0] = e : n.equals2D(i) || n.equals2D(r) ? this._intPt[0] = n : 0 === o ? this._intPt[0] = new M(i) : 0 === s ? this._intPt[0] = new M(r) : 0 === a ? this._intPt[0] = new M(e) : 0 === l && (this._intPt[0] = new M(n))) : (this._isProper = !0, this._intPt[0] = this.intersection(e, n, i, r)), t.POINT_INTERSECTION);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e.nearestEndpoint = function (t, e, n, i) {
            var r = t,
              o = lt.distancePointLine(t, n, i),
              s = lt.distancePointLine(e, n, i);
            return s < o && (o = s, r = e), (s = lt.distancePointLine(n, t, e)) < o && (o = s, r = n), (s = lt.distancePointLine(i, t, e)) < o && (o = s, r = i), r;
          }, e;
        }(it),
        st = u(function () {}, "ot");
      st.prototype.interfaces_ = function () {
        return [];
      }, st.prototype.getClass = function () {
        return st;
      }, st.orientationIndex = function (t, e, n) {
        var i = e.x - t.x,
          r = e.y - t.y,
          o = n.x - e.x,
          s = n.y - e.y;
        return st.signOfDet2x2(i, r, o, s);
      }, st.signOfDet2x2 = function (t, e, n, i) {
        var r = null,
          o = null,
          s = null;
        if (r = 1, 0 === t || 0 === i) return 0 === e || 0 === n ? 0 : e > 0 ? n > 0 ? -r : r : n > 0 ? r : -r;
        if (0 === e || 0 === n) return i > 0 ? t > 0 ? r : -r : t > 0 ? -r : r;
        if (e > 0 ? i > 0 ? e <= i || (r = -r, o = t, t = n, n = o, o = e, e = i, i = o) : e <= -i ? (r = -r, n = -n, i = -i) : (o = t, t = -n, n = o, o = e, e = -i, i = o) : i > 0 ? -e <= i ? (r = -r, t = -t, e = -e) : (o = -t, t = n, n = o, o = -e, e = i, i = o) : e >= i ? (t = -t, e = -e, n = -n, i = -i) : (r = -r, o = -t, t = -n, n = o, o = -e, e = -i, i = o), t > 0) {
          if (!(n > 0 && t <= n)) return r;
        } else {
          if (n > 0 || !(t >= n)) return -r;
          r = -r, t = -t, n = -n;
        }
        for (;;) {
          if ((i -= (s = Math.floor(n / t)) * e) < 0) return -r;
          if (i > e) return r;
          if (t > (n -= s * t) + n) {
            if (e < i + i) return r;
          } else {
            if (e > i + i) return -r;
            n = t - n, i = e - i, r = -r;
          }
          if (0 === i) return 0 === n ? 0 : -r;
          if (0 === n || (t -= (s = Math.floor(t / n)) * n, (e -= s * i) < 0)) return r;
          if (e > i) return -r;
          if (n > t + t) {
            if (i < e + e) return -r;
          } else {
            if (i > e + e) return r;
            t = n - t, e = i - e, r = -r;
          }
          if (0 === e) return 0 === t ? 0 : r;
          if (0 === t) return -r;
        }
      };
      var at = u(function () {
        this._p = null, this._crossingCount = 0, this._isPointOnSegment = !1;
        var t = arguments[0];
        this._p = t;
      }, "st");
      at.prototype.countSegment = function (t, e) {
        if (t.x < this._p.x && e.x < this._p.x) return null;
        if (this._p.x === e.x && this._p.y === e.y) return this._isPointOnSegment = !0, null;
        if (t.y === this._p.y && e.y === this._p.y) {
          var n = t.x,
            i = e.x;
          return n > i && (n = e.x, i = t.x), this._p.x >= n && this._p.x <= i && (this._isPointOnSegment = !0), null;
        }
        if (t.y > this._p.y && e.y <= this._p.y || e.y > this._p.y && t.y <= this._p.y) {
          var r = t.x - this._p.x,
            o = t.y - this._p.y,
            s = e.x - this._p.x,
            a = e.y - this._p.y,
            l = st.signOfDet2x2(r, o, s, a);
          if (0 === l) return this._isPointOnSegment = !0, null;
          a < o && (l = -l), l > 0 && this._crossingCount++;
        }
      }, at.prototype.isPointInPolygon = function () {
        return this.getLocation() !== C.EXTERIOR;
      }, at.prototype.getLocation = function () {
        return this._isPointOnSegment ? C.BOUNDARY : this._crossingCount % 2 == 1 ? C.INTERIOR : C.EXTERIOR;
      }, at.prototype.isOnSegment = function () {
        return this._isPointOnSegment;
      }, at.prototype.interfaces_ = function () {
        return [];
      }, at.prototype.getClass = function () {
        return at;
      }, at.locatePointInRing = function () {
        if (arguments[0] instanceof M && N(arguments[1], z)) {
          for (var t = arguments[0], e = arguments[1], n = new at(t), i = new M(), r = new M(), o = 1; o < e.size(); o++) if (e.getCoordinate(o, i), e.getCoordinate(o - 1, r), n.countSegment(i, r), n.isOnSegment()) return n.getLocation();
          return n.getLocation();
        }
        if (arguments[0] instanceof M && arguments[1] instanceof Array) {
          for (var s = arguments[0], a = arguments[1], l = new at(s), u = 1; u < a.length; u++) {
            var h = a[u],
              c = a[u - 1];
            if (l.countSegment(h, c), l.isOnSegment()) return l.getLocation();
          }
          return l.getLocation();
        }
      };
      var lt = u(function () {}, "at"),
        ut = {
          CLOCKWISE: {
            configurable: !0
          },
          RIGHT: {
            configurable: !0
          },
          COUNTERCLOCKWISE: {
            configurable: !0
          },
          LEFT: {
            configurable: !0
          },
          COLLINEAR: {
            configurable: !0
          },
          STRAIGHT: {
            configurable: !0
          }
        };
      lt.prototype.interfaces_ = function () {
        return [];
      }, lt.prototype.getClass = function () {
        return lt;
      }, lt.orientationIndex = function (t, e, n) {
        return U.orientationIndex(t, e, n);
      }, lt.signedArea = function () {
        if (arguments[0] instanceof Array) {
          var t = arguments[0];
          if (t.length < 3) return 0;
          for (var e = 0, n = t[0].x, i = 1; i < t.length - 1; i++) {
            var r = t[i].x - n,
              o = t[i + 1].y;
            e += r * (t[i - 1].y - o);
          }
          return e / 2;
        }
        if (N(arguments[0], z)) {
          var s = arguments[0],
            a = s.size();
          if (a < 3) return 0;
          var l = new M(),
            u = new M(),
            h = new M();
          s.getCoordinate(0, u), s.getCoordinate(1, h);
          var c = u.x;
          h.x -= c;
          for (var p = 0, d = 1; d < a - 1; d++) l.y = u.y, u.x = h.x, u.y = h.y, s.getCoordinate(d + 1, h), h.x -= c, p += u.x * (l.y - h.y);
          return p / 2;
        }
      }, lt.distanceLineLine = function (t, e, n, i) {
        if (t.equals(e)) return lt.distancePointLine(t, n, i);
        if (n.equals(i)) return lt.distancePointLine(i, t, e);
        var r = !1;
        if (X.intersects(t, e, n, i)) {
          var o = (e.x - t.x) * (i.y - n.y) - (e.y - t.y) * (i.x - n.x);
          if (0 === o) r = !0;else {
            var s = (t.y - n.y) * (i.x - n.x) - (t.x - n.x) * (i.y - n.y),
              a = ((t.y - n.y) * (e.x - t.x) - (t.x - n.x) * (e.y - t.y)) / o,
              l = s / o;
            (l < 0 || l > 1 || a < 0 || a > 1) && (r = !0);
          }
        } else r = !0;
        return r ? L.min(lt.distancePointLine(t, n, i), lt.distancePointLine(e, n, i), lt.distancePointLine(n, t, e), lt.distancePointLine(i, t, e)) : 0;
      }, lt.isPointInRing = function (t, e) {
        return lt.locatePointInRing(t, e) !== C.EXTERIOR;
      }, lt.computeLength = function (t) {
        var e = t.size();
        if (e <= 1) return 0;
        var n = 0,
          i = new M();
        t.getCoordinate(0, i);
        for (var r = i.x, o = i.y, s = 1; s < e; s++) {
          t.getCoordinate(s, i);
          var a = i.x,
            l = i.y,
            u = a - r,
            h = l - o;
          n += Math.sqrt(u * u + h * h), r = a, o = l;
        }
        return n;
      }, lt.isCCW = function (t) {
        var e = t.length - 1;
        if (e < 3) throw new _("Ring has fewer than 4 points, so orientation cannot be determined");
        for (var n = t[0], i = 0, r = 1; r <= e; r++) {
          var o = t[r];
          o.y > n.y && (n = o, i = r);
        }
        var s = i;
        do {
          (s -= 1) < 0 && (s = e);
        } while (t[s].equals2D(n) && s !== i);
        var a = i;
        do {
          a = (a + 1) % e;
        } while (t[a].equals2D(n) && a !== i);
        var l = t[s],
          u = t[a];
        if (l.equals2D(n) || u.equals2D(n) || l.equals2D(u)) return !1;
        var h = lt.computeOrientation(l, n, u);
        return 0 === h ? l.x > u.x : h > 0;
      }, lt.locatePointInRing = function (t, e) {
        return at.locatePointInRing(t, e);
      }, lt.distancePointLinePerpendicular = function (t, e, n) {
        var i = (n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y),
          r = ((e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y)) / i;
        return Math.abs(r) * Math.sqrt(i);
      }, lt.computeOrientation = function (t, e, n) {
        return lt.orientationIndex(t, e, n);
      }, lt.distancePointLine = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          if (0 === e.length) throw new _("Line array must contain at least one vertex");
          for (var n = t.distance(e[0]), i = 0; i < e.length - 1; i++) {
            var r = lt.distancePointLine(t, e[i], e[i + 1]);
            r < n && (n = r);
          }
          return n;
        }
        if (3 === arguments.length) {
          var o = arguments[0],
            s = arguments[1],
            a = arguments[2];
          if (s.x === a.x && s.y === a.y) return o.distance(s);
          var l = (a.x - s.x) * (a.x - s.x) + (a.y - s.y) * (a.y - s.y),
            u = ((o.x - s.x) * (a.x - s.x) + (o.y - s.y) * (a.y - s.y)) / l;
          if (u <= 0) return o.distance(s);
          if (u >= 1) return o.distance(a);
          var h = ((s.y - o.y) * (a.x - s.x) - (s.x - o.x) * (a.y - s.y)) / l;
          return Math.abs(h) * Math.sqrt(l);
        }
      }, lt.isOnLine = function (t, e) {
        for (var n = new ot(), i = 1; i < e.length; i++) {
          var r = e[i - 1],
            o = e[i];
          if (n.computeIntersection(t, r, o), n.hasIntersection()) return !0;
        }
        return !1;
      }, ut.CLOCKWISE.get = function () {
        return -1;
      }, ut.RIGHT.get = function () {
        return lt.CLOCKWISE;
      }, ut.COUNTERCLOCKWISE.get = function () {
        return 1;
      }, ut.LEFT.get = function () {
        return lt.COUNTERCLOCKWISE;
      }, ut.COLLINEAR.get = function () {
        return 0;
      }, ut.STRAIGHT.get = function () {
        return lt.COLLINEAR;
      }, Object.defineProperties(lt, ut);
      var ht = u(function () {}, "lt");
      ht.prototype.filter = function (t) {}, ht.prototype.interfaces_ = function () {
        return [];
      }, ht.prototype.getClass = function () {
        return ht;
      };
      var ct = u(function () {
          var t = arguments[0];
          this._envelope = null, this._factory = null, this._SRID = null, this._userData = null, this._factory = t, this._SRID = t.getSRID();
        }, "ct"),
        pt = {
          serialVersionUID: {
            configurable: !0
          },
          SORTINDEX_POINT: {
            configurable: !0
          },
          SORTINDEX_MULTIPOINT: {
            configurable: !0
          },
          SORTINDEX_LINESTRING: {
            configurable: !0
          },
          SORTINDEX_LINEARRING: {
            configurable: !0
          },
          SORTINDEX_MULTILINESTRING: {
            configurable: !0
          },
          SORTINDEX_POLYGON: {
            configurable: !0
          },
          SORTINDEX_MULTIPOLYGON: {
            configurable: !0
          },
          SORTINDEX_GEOMETRYCOLLECTION: {
            configurable: !0
          },
          geometryChangedFilter: {
            configurable: !0
          }
        };
      ct.prototype.isGeometryCollection = function () {
        return this.getSortIndex() === ct.SORTINDEX_GEOMETRYCOLLECTION;
      }, ct.prototype.getFactory = function () {
        return this._factory;
      }, ct.prototype.getGeometryN = function (t) {
        return this;
      }, ct.prototype.getArea = function () {
        return 0;
      }, ct.prototype.isRectangle = function () {
        return !1;
      }, ct.prototype.equals = function () {
        if (arguments[0] instanceof ct) {
          var t = arguments[0];
          return null !== t && this.equalsTopo(t);
        }
        if (arguments[0] instanceof Object) {
          var e = arguments[0];
          if (!(e instanceof ct)) return !1;
          var n = e;
          return this.equalsExact(n);
        }
      }, ct.prototype.equalsExact = function (t) {
        return this === t || this.equalsExact(t, 0);
      }, ct.prototype.geometryChanged = function () {
        this.apply(ct.geometryChangedFilter);
      }, ct.prototype.geometryChangedAction = function () {
        this._envelope = null;
      }, ct.prototype.equalsNorm = function (t) {
        return null !== t && this.norm().equalsExact(t.norm());
      }, ct.prototype.getLength = function () {
        return 0;
      }, ct.prototype.getNumGeometries = function () {
        return 1;
      }, ct.prototype.compareTo = function () {
        if (1 === arguments.length) {
          var t = arguments[0],
            e = t;
          return this.getSortIndex() !== e.getSortIndex() ? this.getSortIndex() - e.getSortIndex() : this.isEmpty() && e.isEmpty() ? 0 : this.isEmpty() ? -1 : e.isEmpty() ? 1 : this.compareToSameClass(t);
        }
        if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          return this.getSortIndex() !== n.getSortIndex() ? this.getSortIndex() - n.getSortIndex() : this.isEmpty() && n.isEmpty() ? 0 : this.isEmpty() ? -1 : n.isEmpty() ? 1 : this.compareToSameClass(n, i);
        }
      }, ct.prototype.getUserData = function () {
        return this._userData;
      }, ct.prototype.getSRID = function () {
        return this._SRID;
      }, ct.prototype.getEnvelope = function () {
        return this.getFactory().toGeometry(this.getEnvelopeInternal());
      }, ct.prototype.checkNotGeometryCollection = function (t) {
        if (t.getSortIndex() === ct.SORTINDEX_GEOMETRYCOLLECTION) throw new _("This method does not support GeometryCollection arguments");
      }, ct.prototype.equal = function (t, e, n) {
        return 0 === n ? t.equals(e) : t.distance(e) <= n;
      }, ct.prototype.norm = function () {
        var t = this.copy();
        return t.normalize(), t;
      }, ct.prototype.getPrecisionModel = function () {
        return this._factory.getPrecisionModel();
      }, ct.prototype.getEnvelopeInternal = function () {
        return null === this._envelope && (this._envelope = this.computeEnvelopeInternal()), new X(this._envelope);
      }, ct.prototype.setSRID = function (t) {
        this._SRID = t;
      }, ct.prototype.setUserData = function (t) {
        this._userData = t;
      }, ct.prototype.compare = function (t, e) {
        for (var n = t.iterator(), i = e.iterator(); n.hasNext() && i.hasNext();) {
          var r = n.next(),
            o = i.next(),
            s = r.compareTo(o);
          if (0 !== s) return s;
        }
        return n.hasNext() ? 1 : i.hasNext() ? -1 : 0;
      }, ct.prototype.hashCode = function () {
        return this.getEnvelopeInternal().hashCode();
      }, ct.prototype.isGeometryCollectionOrDerived = function () {
        return this.getSortIndex() === ct.SORTINDEX_GEOMETRYCOLLECTION || this.getSortIndex() === ct.SORTINDEX_MULTIPOINT || this.getSortIndex() === ct.SORTINDEX_MULTILINESTRING || this.getSortIndex() === ct.SORTINDEX_MULTIPOLYGON;
      }, ct.prototype.interfaces_ = function () {
        return [w, b, e];
      }, ct.prototype.getClass = function () {
        return ct;
      }, ct.hasNonEmptyElements = function (t) {
        for (var e = 0; e < t.length; e++) if (!t[e].isEmpty()) return !0;
        return !1;
      }, ct.hasNullElements = function (t) {
        for (var e = 0; e < t.length; e++) if (null === t[e]) return !0;
        return !1;
      }, pt.serialVersionUID.get = function () {
        return 0x799ea46522854c00;
      }, pt.SORTINDEX_POINT.get = function () {
        return 0;
      }, pt.SORTINDEX_MULTIPOINT.get = function () {
        return 1;
      }, pt.SORTINDEX_LINESTRING.get = function () {
        return 2;
      }, pt.SORTINDEX_LINEARRING.get = function () {
        return 3;
      }, pt.SORTINDEX_MULTILINESTRING.get = function () {
        return 4;
      }, pt.SORTINDEX_POLYGON.get = function () {
        return 5;
      }, pt.SORTINDEX_MULTIPOLYGON.get = function () {
        return 6;
      }, pt.SORTINDEX_GEOMETRYCOLLECTION.get = function () {
        return 7;
      }, pt.geometryChangedFilter.get = function () {
        return dt;
      }, Object.defineProperties(ct, pt);
      var dt = u(function () {}, "ht");
      dt.interfaces_ = function () {
        return [ht];
      }, dt.filter = function (t) {
        t.geometryChangedAction();
      };
      var ft = u(function () {}, "ft");
      ft.prototype.filter = function (t) {}, ft.prototype.interfaces_ = function () {
        return [];
      }, ft.prototype.getClass = function () {
        return ft;
      };
      var mt = u(function () {}, "gt"),
        gt = {
          Mod2BoundaryNodeRule: {
            configurable: !0
          },
          EndPointBoundaryNodeRule: {
            configurable: !0
          },
          MultiValentEndPointBoundaryNodeRule: {
            configurable: !0
          },
          MonoValentEndPointBoundaryNodeRule: {
            configurable: !0
          },
          MOD2_BOUNDARY_RULE: {
            configurable: !0
          },
          ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
          },
          MULTIVALENT_ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
          },
          MONOVALENT_ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
          },
          OGC_SFS_BOUNDARY_RULE: {
            configurable: !0
          }
        };
      mt.prototype.isInBoundary = function (t) {}, mt.prototype.interfaces_ = function () {
        return [];
      }, mt.prototype.getClass = function () {
        return mt;
      }, gt.Mod2BoundaryNodeRule.get = function () {
        return vt;
      }, gt.EndPointBoundaryNodeRule.get = function () {
        return yt;
      }, gt.MultiValentEndPointBoundaryNodeRule.get = function () {
        return _t;
      }, gt.MonoValentEndPointBoundaryNodeRule.get = function () {
        return xt;
      }, gt.MOD2_BOUNDARY_RULE.get = function () {
        return new vt();
      }, gt.ENDPOINT_BOUNDARY_RULE.get = function () {
        return new yt();
      }, gt.MULTIVALENT_ENDPOINT_BOUNDARY_RULE.get = function () {
        return new _t();
      }, gt.MONOVALENT_ENDPOINT_BOUNDARY_RULE.get = function () {
        return new xt();
      }, gt.OGC_SFS_BOUNDARY_RULE.get = function () {
        return mt.MOD2_BOUNDARY_RULE;
      }, Object.defineProperties(mt, gt);
      var vt = u(function () {}, "yt");
      vt.prototype.isInBoundary = function (t) {
        return t % 2 == 1;
      }, vt.prototype.interfaces_ = function () {
        return [mt];
      }, vt.prototype.getClass = function () {
        return vt;
      };
      var yt = u(function () {}, "_t");
      yt.prototype.isInBoundary = function (t) {
        return t > 0;
      }, yt.prototype.interfaces_ = function () {
        return [mt];
      }, yt.prototype.getClass = function () {
        return yt;
      };
      var _t = u(function () {}, "mt");
      _t.prototype.isInBoundary = function (t) {
        return t > 1;
      }, _t.prototype.interfaces_ = function () {
        return [mt];
      }, _t.prototype.getClass = function () {
        return _t;
      };
      var xt = u(function () {}, "vt");
      xt.prototype.isInBoundary = function (t) {
        return 1 === t;
      }, xt.prototype.interfaces_ = function () {
        return [mt];
      }, xt.prototype.getClass = function () {
        return xt;
      };
      var Et = u(function () {}, "It");
      Et.prototype.add = function () {}, Et.prototype.addAll = function () {}, Et.prototype.isEmpty = function () {}, Et.prototype.iterator = function () {}, Et.prototype.size = function () {}, Et.prototype.toArray = function () {}, Et.prototype.remove = function () {}, (n.prototype = new Error()).name = "IndexOutOfBoundsException";
      var bt = u(function () {}, "Et");
      bt.prototype.hasNext = function () {}, bt.prototype.next = function () {}, bt.prototype.remove = function () {};
      var wt = function (t) {
        function e() {
          t.apply(this, arguments);
        }
        return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function () {}, e.prototype.set = function () {}, e.prototype.isEmpty = function () {}, e;
      }(Et);
      (i.prototype = new Error()).name = "NoSuchElementException";
      var St = function (t) {
          function e() {
            t.call(this), this.array_ = [], arguments[0] instanceof Et && this.addAll(arguments[0]);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.ensureCapacity = function () {}, e.prototype.interfaces_ = function () {
            return [t, Et];
          }, e.prototype.add = function (t) {
            return 1 === arguments.length ? this.array_.push(t) : this.array_.splice(arguments[0], arguments[1]), !0;
          }, e.prototype.clear = function () {
            this.array_ = [];
          }, e.prototype.addAll = function (t) {
            for (var e = t.iterator(); e.hasNext();) this.add(e.next());
            return !0;
          }, e.prototype.set = function (t, e) {
            var n = this.array_[t];
            return this.array_[t] = e, n;
          }, e.prototype.iterator = function () {
            return new Mt(this);
          }, e.prototype.get = function (t) {
            if (t < 0 || t >= this.size()) throw new n();
            return this.array_[t];
          }, e.prototype.isEmpty = function () {
            return 0 === this.array_.length;
          }, e.prototype.size = function () {
            return this.array_.length;
          }, e.prototype.toArray = function () {
            for (var t = [], e = 0, n = this.array_.length; e < n; e++) t.push(this.array_[e]);
            return t;
          }, e.prototype.remove = function (t) {
            for (var e = !1, n = 0, i = this.array_.length; n < i; n++) if (this.array_[n] === t) {
              this.array_.splice(n, 1), e = !0;
              break;
            }
            return e;
          }, e;
        }(wt),
        Mt = function (t) {
          function e(e) {
            t.call(this), this.arrayList_ = e, this.position_ = 0;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function () {
            if (this.position_ === this.arrayList_.size()) throw new i();
            return this.arrayList_.get(this.position_++);
          }, e.prototype.hasNext = function () {
            return this.position_ < this.arrayList_.size();
          }, e.prototype.set = function (t) {
            return this.arrayList_.set(this.position_ - 1, t);
          }, e.prototype.remove = function () {
            this.arrayList_.remove(this.arrayList_.get(this.position_));
          }, e;
        }(bt),
        Tt = function (t) {
          function e() {
            if (t.call(this), 0 !== arguments.length) if (1 === arguments.length) {
              var e = arguments[0];
              this.ensureCapacity(e.length), this.add(e, !0);
            } else if (2 === arguments.length) {
              var n = arguments[0],
                i = arguments[1];
              this.ensureCapacity(n.length), this.add(n, i);
            }
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            coordArrayType: {
              configurable: !0
            }
          };
          return n.coordArrayType.get = function () {
            return new Array(0).fill(null);
          }, e.prototype.getCoordinate = function (t) {
            return this.get(t);
          }, e.prototype.addAll = function () {
            if (2 === arguments.length) {
              for (var e = arguments[0], n = arguments[1], i = !1, r = e.iterator(); r.hasNext();) this.add(r.next(), n), i = !0;
              return i;
            }
            return t.prototype.addAll.apply(this, arguments);
          }, e.prototype.clone = function () {
            for (var e = t.prototype.clone.call(this), n = 0; n < this.size(); n++) e.add(n, this.get(n).copy());
            return e;
          }, e.prototype.toCoordinateArray = function () {
            return this.toArray(e.coordArrayType);
          }, e.prototype.add = function () {
            if (1 === arguments.length) {
              var e = arguments[0];
              t.prototype.add.call(this, e);
            } else if (2 === arguments.length) {
              if (arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                var n = arguments[0],
                  i = arguments[1];
                return this.add(n, i, !0), !0;
              }
              if (arguments[0] instanceof M && "boolean" == typeof arguments[1]) {
                var r = arguments[0];
                if (!arguments[1] && this.size() >= 1 && this.get(this.size() - 1).equals2D(r)) return null;
                t.prototype.add.call(this, r);
              } else if (arguments[0] instanceof Object && "boolean" == typeof arguments[1]) {
                var o = arguments[0],
                  s = arguments[1];
                return this.add(o, s), !0;
              }
            } else if (3 === arguments.length) {
              if ("boolean" == typeof arguments[2] && arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                var a = arguments[0],
                  l = arguments[1];
                if (arguments[2]) for (var u = 0; u < a.length; u++) this.add(a[u], l);else for (var h = a.length - 1; h >= 0; h--) this.add(a[h], l);
                return !0;
              }
              if ("boolean" == typeof arguments[2] && Number.isInteger(arguments[0]) && arguments[1] instanceof M) {
                var c = arguments[0],
                  p = arguments[1];
                if (!arguments[2]) {
                  var d = this.size();
                  if (d > 0 && (c > 0 && this.get(c - 1).equals2D(p) || c < d && this.get(c).equals2D(p))) return null;
                }
                t.prototype.add.call(this, c, p);
              }
            } else if (4 === arguments.length) {
              var f = arguments[0],
                m = arguments[1],
                g = arguments[2],
                v = arguments[3],
                y = 1;
              g > v && (y = -1);
              for (var _ = g; _ !== v; _ += y) this.add(f[_], m);
              return !0;
            }
          }, e.prototype.closeRing = function () {
            this.size() > 0 && this.add(new M(this.get(0)), !1);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, Object.defineProperties(e, n), e;
        }(St),
        At = u(function () {}, "Lt"),
        Pt = {
          ForwardComparator: {
            configurable: !0
          },
          BidirectionalComparator: {
            configurable: !0
          },
          coordArrayType: {
            configurable: !0
          }
        };
      Pt.ForwardComparator.get = function () {
        return Ct;
      }, Pt.BidirectionalComparator.get = function () {
        return It;
      }, Pt.coordArrayType.get = function () {
        return new Array(0).fill(null);
      }, At.prototype.interfaces_ = function () {
        return [];
      }, At.prototype.getClass = function () {
        return At;
      }, At.isRing = function (t) {
        return !(t.length < 4 || !t[0].equals2D(t[t.length - 1]));
      }, At.ptNotInList = function (t, e) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          if (At.indexOf(i, e) < 0) return i;
        }
        return null;
      }, At.scroll = function (t, e) {
        var n = At.indexOf(e, t);
        if (n < 0) return null;
        var i = new Array(t.length).fill(null);
        W.arraycopy(t, n, i, 0, t.length - n), W.arraycopy(t, 0, i, t.length - n, n), W.arraycopy(i, 0, t, 0, t.length);
      }, At.equals = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          if (t === e) return !0;
          if (null === t || null === e || t.length !== e.length) return !1;
          for (var n = 0; n < t.length; n++) if (!t[n].equals(e[n])) return !1;
          return !0;
        }
        if (3 === arguments.length) {
          var i = arguments[0],
            r = arguments[1],
            o = arguments[2];
          if (i === r) return !0;
          if (null === i || null === r || i.length !== r.length) return !1;
          for (var s = 0; s < i.length; s++) if (0 !== o.compare(i[s], r[s])) return !1;
          return !0;
        }
      }, At.intersection = function (t, e) {
        for (var n = new Tt(), i = 0; i < t.length; i++) e.intersects(t[i]) && n.add(t[i], !0);
        return n.toCoordinateArray();
      }, At.hasRepeatedPoints = function (t) {
        for (var e = 1; e < t.length; e++) if (t[e - 1].equals(t[e])) return !0;
        return !1;
      }, At.removeRepeatedPoints = function (t) {
        return At.hasRepeatedPoints(t) ? new Tt(t, !1).toCoordinateArray() : t;
      }, At.reverse = function (t) {
        for (var e = t.length - 1, n = Math.trunc(e / 2), i = 0; i <= n; i++) {
          var r = t[i];
          t[i] = t[e - i], t[e - i] = r;
        }
      }, At.removeNull = function (t) {
        for (var e = 0, n = 0; n < t.length; n++) null !== t[n] && e++;
        var i = new Array(e).fill(null);
        if (0 === e) return i;
        for (var r = 0, o = 0; o < t.length; o++) null !== t[o] && (i[r++] = t[o]);
        return i;
      }, At.copyDeep = function () {
        if (1 === arguments.length) {
          for (var t = arguments[0], e = new Array(t.length).fill(null), n = 0; n < t.length; n++) e[n] = new M(t[n]);
          return e;
        }
        if (5 === arguments.length) for (var i = arguments[0], r = arguments[1], o = arguments[2], s = arguments[3], a = arguments[4], l = 0; l < a; l++) o[s + l] = new M(i[r + l]);
      }, At.isEqualReversed = function (t, e) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n],
            r = e[t.length - n - 1];
          if (0 !== i.compareTo(r)) return !1;
        }
        return !0;
      }, At.envelope = function (t) {
        for (var e = new X(), n = 0; n < t.length; n++) e.expandToInclude(t[n]);
        return e;
      }, At.toCoordinateArray = function (t) {
        return t.toArray(At.coordArrayType);
      }, At.atLeastNCoordinatesOrNothing = function (t, e) {
        return e.length >= t ? e : [];
      }, At.indexOf = function (t, e) {
        for (var n = 0; n < e.length; n++) if (t.equals(e[n])) return n;
        return -1;
      }, At.increasingDirection = function (t) {
        for (var e = 0; e < Math.trunc(t.length / 2); e++) {
          var n = t.length - 1 - e,
            i = t[e].compareTo(t[n]);
          if (0 !== i) return i;
        }
        return 1;
      }, At.compare = function (t, e) {
        for (var n = 0; n < t.length && n < e.length;) {
          var i = t[n].compareTo(e[n]);
          if (0 !== i) return i;
          n++;
        }
        return n < e.length ? -1 : n < t.length ? 1 : 0;
      }, At.minCoordinate = function (t) {
        for (var e = null, n = 0; n < t.length; n++) (null === e || e.compareTo(t[n]) > 0) && (e = t[n]);
        return e;
      }, At.extract = function (t, e, n) {
        e = L.clamp(e, 0, t.length);
        var i = (n = L.clamp(n, -1, t.length)) - e + 1;
        n < 0 && (i = 0), e >= t.length && (i = 0), n < e && (i = 0);
        var r = new Array(i).fill(null);
        if (0 === i) return r;
        for (var o = 0, s = e; s <= n; s++) r[o++] = t[s];
        return r;
      }, Object.defineProperties(At, Pt);
      var Ct = u(function () {}, "wt");
      Ct.prototype.compare = function (t, e) {
        return At.compare(t, e);
      }, Ct.prototype.interfaces_ = function () {
        return [S];
      }, Ct.prototype.getClass = function () {
        return Ct;
      };
      var It = u(function () {}, "Ot");
      It.prototype.compare = function (t, e) {
        var n = t,
          i = e;
        if (n.length < i.length) return -1;
        if (n.length > i.length) return 1;
        if (0 === n.length) return 0;
        var r = At.compare(n, i);
        return At.isEqualReversed(n, i) ? 0 : r;
      }, It.prototype.OLDcompare = function (t, e) {
        var n = t,
          i = e;
        if (n.length < i.length) return -1;
        if (n.length > i.length) return 1;
        if (0 === n.length) return 0;
        for (var r = At.increasingDirection(n), o = At.increasingDirection(i), s = r > 0 ? 0 : n.length - 1, a = o > 0 ? 0 : n.length - 1, l = 0; l < n.length; l++) {
          var u = n[s].compareTo(i[a]);
          if (0 !== u) return u;
          s += r, a += o;
        }
        return 0;
      }, It.prototype.interfaces_ = function () {
        return [S];
      }, It.prototype.getClass = function () {
        return It;
      };
      var Nt = u(function () {}, "Tt");
      Nt.prototype.get = function () {}, Nt.prototype.put = function () {}, Nt.prototype.size = function () {}, Nt.prototype.values = function () {}, Nt.prototype.entrySet = function () {};
      var Lt = function (t) {
        function e() {
          t.apply(this, arguments);
        }
        return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
      }(Nt);
      (r.prototype = new Error()).name = "OperationNotSupported", (o.prototype = new Et()).contains = function () {};
      var Rt = function (t) {
          function e() {
            t.call(this), this.array_ = [], arguments[0] instanceof Et && this.addAll(arguments[0]);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.contains = function (t) {
            for (var e = 0, n = this.array_.length; e < n; e++) if (this.array_[e] === t) return !0;
            return !1;
          }, e.prototype.add = function (t) {
            return !this.contains(t) && (this.array_.push(t), !0);
          }, e.prototype.addAll = function (t) {
            for (var e = t.iterator(); e.hasNext();) this.add(e.next());
            return !0;
          }, e.prototype.remove = function (t) {
            throw new Error();
          }, e.prototype.size = function () {
            return this.array_.length;
          }, e.prototype.isEmpty = function () {
            return 0 === this.array_.length;
          }, e.prototype.toArray = function () {
            for (var t = [], e = 0, n = this.array_.length; e < n; e++) t.push(this.array_[e]);
            return t;
          }, e.prototype.iterator = function () {
            return new Ot(this);
          }, e;
        }(o),
        Ot = function (t) {
          function e(e) {
            t.call(this), this.hashSet_ = e, this.position_ = 0;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function () {
            if (this.position_ === this.hashSet_.size()) throw new i();
            return this.hashSet_.array_[this.position_++];
          }, e.prototype.hasNext = function () {
            return this.position_ < this.hashSet_.size();
          }, e.prototype.remove = function () {
            throw new r();
          }, e;
        }(bt),
        qt = 0;
      (p.prototype = new Lt()).get = function (t) {
        for (var e = this.root_; null !== e;) {
          var n = t.compareTo(e.key);
          if (n < 0) e = e.left;else {
            if (!(n > 0)) return e.value;
            e = e.right;
          }
        }
        return null;
      }, p.prototype.put = function (t, e) {
        if (null === this.root_) return this.root_ = {
          key: t,
          value: e,
          left: null,
          right: null,
          parent: null,
          color: qt,
          getValue: function () {
            return this.value;
          },
          getKey: function () {
            return this.key;
          }
        }, this.size_ = 1, null;
        var n,
          i,
          r = this.root_;
        do {
          if (n = r, (i = t.compareTo(r.key)) < 0) r = r.left;else {
            if (!(i > 0)) {
              var o = r.value;
              return r.value = e, o;
            }
            r = r.right;
          }
        } while (null !== r);
        var s = {
          key: t,
          left: null,
          right: null,
          value: e,
          parent: n,
          color: qt,
          getValue: function () {
            return this.value;
          },
          getKey: function () {
            return this.key;
          }
        };
        return i < 0 ? n.left = s : n.right = s, this.fixAfterInsertion(s), this.size_++, null;
      }, p.prototype.fixAfterInsertion = function (t) {
        for (t.color = 1; null != t && t !== this.root_ && 1 === t.parent.color;) if (a(t) === h(a(a(t)))) {
          var e = c(a(a(t)));
          1 === s(e) ? (l(a(t), qt), l(e, qt), l(a(a(t)), 1), t = a(a(t))) : (t === c(a(t)) && (t = a(t), this.rotateLeft(t)), l(a(t), qt), l(a(a(t)), 1), this.rotateRight(a(a(t))));
        } else {
          var n = h(a(a(t)));
          1 === s(n) ? (l(a(t), qt), l(n, qt), l(a(a(t)), 1), t = a(a(t))) : (t === h(a(t)) && (t = a(t), this.rotateRight(t)), l(a(t), qt), l(a(a(t)), 1), this.rotateLeft(a(a(t))));
        }
        this.root_.color = qt;
      }, p.prototype.values = function () {
        var t = new St(),
          e = this.getFirstEntry();
        if (null !== e) for (t.add(e.value); null !== (e = p.successor(e));) t.add(e.value);
        return t;
      }, p.prototype.entrySet = function () {
        var t = new Rt(),
          e = this.getFirstEntry();
        if (null !== e) for (t.add(e); null !== (e = p.successor(e));) t.add(e);
        return t;
      }, p.prototype.rotateLeft = function (t) {
        if (null != t) {
          var e = t.right;
          t.right = e.left, null != e.left && (e.left.parent = t), e.parent = t.parent, null === t.parent ? this.root_ = e : t.parent.left === t ? t.parent.left = e : t.parent.right = e, e.left = t, t.parent = e;
        }
      }, p.prototype.rotateRight = function (t) {
        if (null != t) {
          var e = t.left;
          t.left = e.right, null != e.right && (e.right.parent = t), e.parent = t.parent, null === t.parent ? this.root_ = e : t.parent.right === t ? t.parent.right = e : t.parent.left = e, e.right = t, t.parent = e;
        }
      }, p.prototype.getFirstEntry = function () {
        var t = this.root_;
        if (null != t) for (; null != t.left;) t = t.left;
        return t;
      }, p.successor = function (t) {
        if (null === t) return null;
        if (null !== t.right) {
          for (var e = t.right; null !== e.left;) e = e.left;
          return e;
        }
        for (var n = t.parent, i = t; null !== n && i === n.right;) i = n, n = n.parent;
        return n;
      }, p.prototype.size = function () {
        return this.size_;
      };
      var Dt = u(function () {}, "At");
      Dt.prototype.interfaces_ = function () {
        return [];
      }, Dt.prototype.getClass = function () {
        return Dt;
      }, d.prototype = new o(), (f.prototype = new d()).contains = function (t) {
        for (var e = 0, n = this.array_.length; e < n; e++) if (0 === this.array_[e].compareTo(t)) return !0;
        return !1;
      }, f.prototype.add = function (t) {
        if (this.contains(t)) return !1;
        for (var e = 0, n = this.array_.length; e < n; e++) if (1 === this.array_[e].compareTo(t)) return this.array_.splice(e, 0, t), !0;
        return this.array_.push(t), !0;
      }, f.prototype.addAll = function (t) {
        for (var e = t.iterator(); e.hasNext();) this.add(e.next());
        return !0;
      }, f.prototype.remove = function (t) {
        throw new r();
      }, f.prototype.size = function () {
        return this.array_.length;
      }, f.prototype.isEmpty = function () {
        return 0 === this.array_.length;
      }, f.prototype.toArray = function () {
        for (var t = [], e = 0, n = this.array_.length; e < n; e++) t.push(this.array_[e]);
        return t;
      }, f.prototype.iterator = function () {
        return new kt(this);
      };
      var kt = u(function (t) {
        this.treeSet_ = t, this.position_ = 0;
      }, "Ft");
      kt.prototype.next = function () {
        if (this.position_ === this.treeSet_.size()) throw new i();
        return this.treeSet_.array_[this.position_++];
      }, kt.prototype.hasNext = function () {
        return this.position_ < this.treeSet_.size();
      }, kt.prototype.remove = function () {
        throw new r();
      };
      var Ft = u(function () {}, "Gt");
      Ft.sort = function () {
        var t,
          e,
          n,
          i,
          r = arguments[0];
        if (1 === arguments.length) i = u(function (t, e) {
          return t.compareTo(e);
        }, "i"), r.sort(i);else if (2 === arguments.length) n = arguments[1], i = u(function (t, e) {
          return n.compare(t, e);
        }, "i"), r.sort(i);else if (3 === arguments.length) {
          (e = r.slice(arguments[1], arguments[2])).sort();
          var o = r.slice(0, arguments[1]).concat(e, r.slice(arguments[2], r.length));
          for (r.splice(0, r.length), t = 0; t < o.length; t++) r.push(o[t]);
        } else if (4 === arguments.length) for (e = r.slice(arguments[1], arguments[2]), n = arguments[3], i = u(function (t, e) {
          return n.compare(t, e);
        }, "i"), e.sort(i), o = r.slice(0, arguments[1]).concat(e, r.slice(arguments[2], r.length)), r.splice(0, r.length), t = 0; t < o.length; t++) r.push(o[t]);
      }, Ft.asList = function (t) {
        for (var e = new St(), n = 0, i = t.length; n < i; n++) e.add(t[n]);
        return e;
      };
      var Ut = u(function () {}, "qt"),
        Bt = {
          P: {
            configurable: !0
          },
          L: {
            configurable: !0
          },
          A: {
            configurable: !0
          },
          FALSE: {
            configurable: !0
          },
          TRUE: {
            configurable: !0
          },
          DONTCARE: {
            configurable: !0
          },
          SYM_FALSE: {
            configurable: !0
          },
          SYM_TRUE: {
            configurable: !0
          },
          SYM_DONTCARE: {
            configurable: !0
          },
          SYM_P: {
            configurable: !0
          },
          SYM_L: {
            configurable: !0
          },
          SYM_A: {
            configurable: !0
          }
        };
      Bt.P.get = function () {
        return 0;
      }, Bt.L.get = function () {
        return 1;
      }, Bt.A.get = function () {
        return 2;
      }, Bt.FALSE.get = function () {
        return -1;
      }, Bt.TRUE.get = function () {
        return -2;
      }, Bt.DONTCARE.get = function () {
        return -3;
      }, Bt.SYM_FALSE.get = function () {
        return "F";
      }, Bt.SYM_TRUE.get = function () {
        return "T";
      }, Bt.SYM_DONTCARE.get = function () {
        return "*";
      }, Bt.SYM_P.get = function () {
        return "0";
      }, Bt.SYM_L.get = function () {
        return "1";
      }, Bt.SYM_A.get = function () {
        return "2";
      }, Ut.prototype.interfaces_ = function () {
        return [];
      }, Ut.prototype.getClass = function () {
        return Ut;
      }, Ut.toDimensionSymbol = function (t) {
        switch (t) {
          case Ut.FALSE:
            return Ut.SYM_FALSE;
          case Ut.TRUE:
            return Ut.SYM_TRUE;
          case Ut.DONTCARE:
            return Ut.SYM_DONTCARE;
          case Ut.P:
            return Ut.SYM_P;
          case Ut.L:
            return Ut.SYM_L;
          case Ut.A:
            return Ut.SYM_A;
        }
        throw new _("Unknown dimension value: " + t);
      }, Ut.toDimensionValue = function (t) {
        switch (D.toUpperCase(t)) {
          case Ut.SYM_FALSE:
            return Ut.FALSE;
          case Ut.SYM_TRUE:
            return Ut.TRUE;
          case Ut.SYM_DONTCARE:
            return Ut.DONTCARE;
          case Ut.SYM_P:
            return Ut.P;
          case Ut.SYM_L:
            return Ut.L;
          case Ut.SYM_A:
            return Ut.A;
        }
        throw new _("Unknown dimension symbol: " + t);
      }, Object.defineProperties(Ut, Bt);
      var zt = u(function () {}, "Vt");
      zt.prototype.filter = function (t) {}, zt.prototype.interfaces_ = function () {
        return [];
      }, zt.prototype.getClass = function () {
        return zt;
      };
      var Vt = u(function () {}, "Ut");
      Vt.prototype.filter = function (t, e) {}, Vt.prototype.isDone = function () {}, Vt.prototype.isGeometryChanged = function () {}, Vt.prototype.interfaces_ = function () {
        return [];
      }, Vt.prototype.getClass = function () {
        return Vt;
      };
      var jt = function (t) {
          function e(e, n) {
            if (t.call(this, n), this._geometries = e || [], t.hasNullElements(this._geometries)) throw new _("geometries must not contain null elements");
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            serialVersionUID: {
              configurable: !0
            }
          };
          return e.prototype.computeEnvelopeInternal = function () {
            for (var t = new X(), e = 0; e < this._geometries.length; e++) t.expandToInclude(this._geometries[e].getEnvelopeInternal());
            return t;
          }, e.prototype.getGeometryN = function (t) {
            return this._geometries[t];
          }, e.prototype.getSortIndex = function () {
            return t.SORTINDEX_GEOMETRYCOLLECTION;
          }, e.prototype.getCoordinates = function () {
            for (var t = new Array(this.getNumPoints()).fill(null), e = -1, n = 0; n < this._geometries.length; n++) for (var i = this._geometries[n].getCoordinates(), r = 0; r < i.length; r++) t[++e] = i[r];
            return t;
          }, e.prototype.getArea = function () {
            for (var t = 0, e = 0; e < this._geometries.length; e++) t += this._geometries[e].getArea();
            return t;
          }, e.prototype.equalsExact = function () {
            if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              if (!this.isEquivalentClass(e)) return !1;
              var i = e;
              if (this._geometries.length !== i._geometries.length) return !1;
              for (var r = 0; r < this._geometries.length; r++) if (!this._geometries[r].equalsExact(i._geometries[r], n)) return !1;
              return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
          }, e.prototype.normalize = function () {
            for (var t = 0; t < this._geometries.length; t++) this._geometries[t].normalize();
            Ft.sort(this._geometries);
          }, e.prototype.getCoordinate = function () {
            return this.isEmpty() ? null : this._geometries[0].getCoordinate();
          }, e.prototype.getBoundaryDimension = function () {
            for (var t = Ut.FALSE, e = 0; e < this._geometries.length; e++) t = Math.max(t, this._geometries[e].getBoundaryDimension());
            return t;
          }, e.prototype.getDimension = function () {
            for (var t = Ut.FALSE, e = 0; e < this._geometries.length; e++) t = Math.max(t, this._geometries[e].getDimension());
            return t;
          }, e.prototype.getLength = function () {
            for (var t = 0, e = 0; e < this._geometries.length; e++) t += this._geometries[e].getLength();
            return t;
          }, e.prototype.getNumPoints = function () {
            for (var t = 0, e = 0; e < this._geometries.length; e++) t += this._geometries[e].getNumPoints();
            return t;
          }, e.prototype.getNumGeometries = function () {
            return this._geometries.length;
          }, e.prototype.reverse = function () {
            for (var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++) e[n] = this._geometries[n].reverse();
            return this.getFactory().createGeometryCollection(e);
          }, e.prototype.compareToSameClass = function () {
            if (1 === arguments.length) {
              var t = arguments[0],
                e = new f(Ft.asList(this._geometries)),
                n = new f(Ft.asList(t._geometries));
              return this.compare(e, n);
            }
            if (2 === arguments.length) {
              for (var i = arguments[0], r = arguments[1], o = i, s = this.getNumGeometries(), a = o.getNumGeometries(), l = 0; l < s && l < a;) {
                var u = this.getGeometryN(l),
                  h = o.getGeometryN(l),
                  c = u.compareToSameClass(h, r);
                if (0 !== c) return c;
                l++;
              }
              return l < s ? 1 : l < a ? -1 : 0;
            }
          }, e.prototype.apply = function () {
            if (N(arguments[0], ft)) for (var t = arguments[0], e = 0; e < this._geometries.length; e++) this._geometries[e].apply(t);else if (N(arguments[0], Vt)) {
              var n = arguments[0];
              if (0 === this._geometries.length) return null;
              for (var i = 0; i < this._geometries.length && (this._geometries[i].apply(n), !n.isDone()); i++);
              n.isGeometryChanged() && this.geometryChanged();
            } else if (N(arguments[0], zt)) {
              var r = arguments[0];
              r.filter(this);
              for (var o = 0; o < this._geometries.length; o++) this._geometries[o].apply(r);
            } else if (N(arguments[0], ht)) {
              var s = arguments[0];
              s.filter(this);
              for (var a = 0; a < this._geometries.length; a++) this._geometries[a].apply(s);
            }
          }, e.prototype.getBoundary = function () {
            return this.checkNotGeometryCollection(this), nt.shouldNeverReachHere(), null;
          }, e.prototype.clone = function () {
            var e = t.prototype.clone.call(this);
            e._geometries = new Array(this._geometries.length).fill(null);
            for (var n = 0; n < this._geometries.length; n++) e._geometries[n] = this._geometries[n].clone();
            return e;
          }, e.prototype.getGeometryType = function () {
            return "GeometryCollection";
          }, e.prototype.copy = function () {
            for (var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++) t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
          }, e.prototype.isEmpty = function () {
            for (var t = 0; t < this._geometries.length; t++) if (!this._geometries[t].isEmpty()) return !1;
            return !0;
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, n.serialVersionUID.get = function () {
            return -0x4f07bcb1f857d800;
          }, Object.defineProperties(e, n), e;
        }(ct),
        Gt = function (t) {
          function e() {
            t.apply(this, arguments);
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            serialVersionUID: {
              configurable: !0
            }
          };
          return e.prototype.getSortIndex = function () {
            return ct.SORTINDEX_MULTILINESTRING;
          }, e.prototype.equalsExact = function () {
            if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
          }, e.prototype.getBoundaryDimension = function () {
            return this.isClosed() ? Ut.FALSE : 0;
          }, e.prototype.isClosed = function () {
            if (this.isEmpty()) return !1;
            for (var t = 0; t < this._geometries.length; t++) if (!this._geometries[t].isClosed()) return !1;
            return !0;
          }, e.prototype.getDimension = function () {
            return 1;
          }, e.prototype.reverse = function () {
            for (var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++) e[t - 1 - n] = this._geometries[n].reverse();
            return this.getFactory().createMultiLineString(e);
          }, e.prototype.getBoundary = function () {
            return new Wt(this).getBoundary();
          }, e.prototype.getGeometryType = function () {
            return "MultiLineString";
          }, e.prototype.copy = function () {
            for (var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++) t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
          }, e.prototype.interfaces_ = function () {
            return [Dt];
          }, e.prototype.getClass = function () {
            return e;
          }, n.serialVersionUID.get = function () {
            return 0x7155d2ab4afa8000;
          }, Object.defineProperties(e, n), e;
        }(jt),
        Wt = u(function () {
          if (this._geom = null, this._geomFact = null, this._bnRule = null, this._endpointMap = null, 1 === arguments.length) {
            var t = arguments[0],
              e = mt.MOD2_BOUNDARY_RULE;
            this._geom = t, this._geomFact = t.getFactory(), this._bnRule = e;
          } else if (2 === arguments.length) {
            var n = arguments[0],
              i = arguments[1];
            this._geom = n, this._geomFact = n.getFactory(), this._bnRule = i;
          }
        }, "Yt");
      Wt.prototype.boundaryMultiLineString = function (t) {
        if (this._geom.isEmpty()) return this.getEmptyMultiPoint();
        var e = this.computeBoundaryCoordinates(t);
        return 1 === e.length ? this._geomFact.createPoint(e[0]) : this._geomFact.createMultiPointFromCoords(e);
      }, Wt.prototype.getBoundary = function () {
        return this._geom instanceof Jt ? this.boundaryLineString(this._geom) : this._geom instanceof Gt ? this.boundaryMultiLineString(this._geom) : this._geom.getBoundary();
      }, Wt.prototype.boundaryLineString = function (t) {
        return this._geom.isEmpty() ? this.getEmptyMultiPoint() : t.isClosed() ? this._bnRule.isInBoundary(2) ? t.getStartPoint() : this._geomFact.createMultiPoint() : this._geomFact.createMultiPoint([t.getStartPoint(), t.getEndPoint()]);
      }, Wt.prototype.getEmptyMultiPoint = function () {
        return this._geomFact.createMultiPoint();
      }, Wt.prototype.computeBoundaryCoordinates = function (t) {
        var e = new St();
        this._endpointMap = new p();
        for (var n = 0; n < t.getNumGeometries(); n++) {
          var i = t.getGeometryN(n);
          0 !== i.getNumPoints() && (this.addEndpoint(i.getCoordinateN(0)), this.addEndpoint(i.getCoordinateN(i.getNumPoints() - 1)));
        }
        for (var r = this._endpointMap.entrySet().iterator(); r.hasNext();) {
          var o = r.next(),
            s = o.getValue().count;
          this._bnRule.isInBoundary(s) && e.add(o.getKey());
        }
        return At.toCoordinateArray(e);
      }, Wt.prototype.addEndpoint = function (t) {
        var e = this._endpointMap.get(t);
        null === e && (e = new Ht(), this._endpointMap.put(t, e)), e.count++;
      }, Wt.prototype.interfaces_ = function () {
        return [];
      }, Wt.prototype.getClass = function () {
        return Wt;
      }, Wt.getBoundary = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return new Wt(t).getBoundary();
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          return new Wt(e, n).getBoundary();
        }
      };
      var Ht = u(function () {
        this.count = null;
      }, "kt");
      Ht.prototype.interfaces_ = function () {
        return [];
      }, Ht.prototype.getClass = function () {
        return Ht;
      };
      var Xt = u(function () {}, "jt"),
        Yt = {
          NEWLINE: {
            configurable: !0
          },
          SIMPLE_ORDINATE_FORMAT: {
            configurable: !0
          }
        };
      Xt.prototype.interfaces_ = function () {
        return [];
      }, Xt.prototype.getClass = function () {
        return Xt;
      }, Xt.chars = function (t, e) {
        for (var n = new Array(e).fill(null), i = 0; i < e; i++) n[i] = t;
        return String(n);
      }, Xt.getStackTrace = function () {
        if (1 === arguments.length) {
          var t = arguments[0],
            e = new function () {}(),
            n = new function () {}(e);
          return t.printStackTrace(n), e.toString();
        }
        if (2 === arguments.length) {
          for (var i = arguments[0], r = arguments[1], o = "", s = new function () {}(new function () {}(Xt.getStackTrace(i))), a = 0; a < r; a++) try {
            o += s.readLine() + Xt.NEWLINE;
          } catch (t) {
            if (!(t instanceof m)) throw t;
            nt.shouldNeverReachHere();
          }
          return o;
        }
      }, Xt.split = function (t, e) {
        for (var n = e.length, i = new St(), r = "" + t, o = r.indexOf(e); o >= 0;) {
          var s = r.substring(0, o);
          i.add(s), o = (r = r.substring(o + n)).indexOf(e);
        }
        r.length > 0 && i.add(r);
        for (var a = new Array(i.size()).fill(null), l = 0; l < a.length; l++) a[l] = i.get(l);
        return a;
      }, Xt.toString = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return Xt.SIMPLE_ORDINATE_FORMAT.format(t);
        }
      }, Xt.spaces = function (t) {
        return Xt.chars(" ", t);
      }, Yt.NEWLINE.get = function () {
        return W.getProperty("line.separator");
      }, Yt.SIMPLE_ORDINATE_FORMAT.get = function () {
        return new function () {}("0.#");
      }, Object.defineProperties(Xt, Yt);
      var Zt = u(function () {}, "Wt");
      Zt.prototype.interfaces_ = function () {
        return [];
      }, Zt.prototype.getClass = function () {
        return Zt;
      }, Zt.copyCoord = function (t, e, n, i) {
        for (var r = Math.min(t.getDimension(), n.getDimension()), o = 0; o < r; o++) n.setOrdinate(i, o, t.getOrdinate(e, o));
      }, Zt.isRing = function (t) {
        var e = t.size();
        return 0 === e || !(e <= 3) && t.getOrdinate(0, z.X) === t.getOrdinate(e - 1, z.X) && t.getOrdinate(0, z.Y) === t.getOrdinate(e - 1, z.Y);
      }, Zt.isEqual = function (t, e) {
        var n = t.size();
        if (n !== e.size()) return !1;
        for (var i = Math.min(t.getDimension(), e.getDimension()), r = 0; r < n; r++) for (var o = 0; o < i; o++) {
          var s = t.getOrdinate(r, o),
            a = e.getOrdinate(r, o);
          if (!(t.getOrdinate(r, o) === e.getOrdinate(r, o) || x.isNaN(s) && x.isNaN(a))) return !1;
        }
        return !0;
      }, Zt.extend = function (t, e, n) {
        var i = t.create(n, e.getDimension()),
          r = e.size();
        if (Zt.copy(e, 0, i, 0, r), r > 0) for (var o = r; o < n; o++) Zt.copy(e, r - 1, i, o, 1);
        return i;
      }, Zt.reverse = function (t) {
        for (var e = t.size() - 1, n = Math.trunc(e / 2), i = 0; i <= n; i++) Zt.swap(t, i, e - i);
      }, Zt.swap = function (t, e, n) {
        if (e === n) return null;
        for (var i = 0; i < t.getDimension(); i++) {
          var r = t.getOrdinate(e, i);
          t.setOrdinate(e, i, t.getOrdinate(n, i)), t.setOrdinate(n, i, r);
        }
      }, Zt.copy = function (t, e, n, i, r) {
        for (var o = 0; o < r; o++) Zt.copyCoord(t, e + o, n, i + o);
      }, Zt.toString = function () {
        if (1 === arguments.length) {
          var t = arguments[0],
            e = t.size();
          if (0 === e) return "()";
          var n = t.getDimension(),
            i = new O();
          i.append("(");
          for (var r = 0; r < e; r++) {
            r > 0 && i.append(" ");
            for (var o = 0; o < n; o++) o > 0 && i.append(","), i.append(Xt.toString(t.getOrdinate(r, o)));
          }
          return i.append(")"), i.toString();
        }
      }, Zt.ensureValidRing = function (t, e) {
        var n = e.size();
        return 0 === n ? e : n <= 3 ? Zt.createClosedRing(t, e, 4) : e.getOrdinate(0, z.X) === e.getOrdinate(n - 1, z.X) && e.getOrdinate(0, z.Y) === e.getOrdinate(n - 1, z.Y) ? e : Zt.createClosedRing(t, e, n + 1);
      }, Zt.createClosedRing = function (t, e, n) {
        var i = t.create(n, e.getDimension()),
          r = e.size();
        Zt.copy(e, 0, i, 0, r);
        for (var o = r; o < n; o++) Zt.copy(e, 0, i, o, 1);
        return i;
      };
      var Jt = function (t) {
          function e(e, n) {
            t.call(this, n), this._points = null, this.init(e);
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            serialVersionUID: {
              configurable: !0
            }
          };
          return e.prototype.computeEnvelopeInternal = function () {
            return this.isEmpty() ? new X() : this._points.expandEnvelope(new X());
          }, e.prototype.isRing = function () {
            return this.isClosed() && this.isSimple();
          }, e.prototype.getSortIndex = function () {
            return t.SORTINDEX_LINESTRING;
          }, e.prototype.getCoordinates = function () {
            return this._points.toCoordinateArray();
          }, e.prototype.equalsExact = function () {
            if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              if (!this.isEquivalentClass(e)) return !1;
              var i = e;
              if (this._points.size() !== i._points.size()) return !1;
              for (var r = 0; r < this._points.size(); r++) if (!this.equal(this._points.getCoordinate(r), i._points.getCoordinate(r), n)) return !1;
              return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
          }, e.prototype.normalize = function () {
            for (var t = 0; t < Math.trunc(this._points.size() / 2); t++) {
              var e = this._points.size() - 1 - t;
              if (!this._points.getCoordinate(t).equals(this._points.getCoordinate(e))) return this._points.getCoordinate(t).compareTo(this._points.getCoordinate(e)) > 0 && Zt.reverse(this._points), null;
            }
          }, e.prototype.getCoordinate = function () {
            return this.isEmpty() ? null : this._points.getCoordinate(0);
          }, e.prototype.getBoundaryDimension = function () {
            return this.isClosed() ? Ut.FALSE : 0;
          }, e.prototype.isClosed = function () {
            return !this.isEmpty() && this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
          }, e.prototype.getEndPoint = function () {
            return this.isEmpty() ? null : this.getPointN(this.getNumPoints() - 1);
          }, e.prototype.getDimension = function () {
            return 1;
          }, e.prototype.getLength = function () {
            return lt.computeLength(this._points);
          }, e.prototype.getNumPoints = function () {
            return this._points.size();
          }, e.prototype.reverse = function () {
            var t = this._points.copy();
            return Zt.reverse(t), this.getFactory().createLineString(t);
          }, e.prototype.compareToSameClass = function () {
            if (1 === arguments.length) {
              for (var t = arguments[0], e = 0, n = 0; e < this._points.size() && n < t._points.size();) {
                var i = this._points.getCoordinate(e).compareTo(t._points.getCoordinate(n));
                if (0 !== i) return i;
                e++, n++;
              }
              return e < this._points.size() ? 1 : n < t._points.size() ? -1 : 0;
            }
            if (2 === arguments.length) {
              var r = arguments[0];
              return arguments[1].compare(this._points, r._points);
            }
          }, e.prototype.apply = function () {
            if (N(arguments[0], ft)) for (var t = arguments[0], e = 0; e < this._points.size(); e++) t.filter(this._points.getCoordinate(e));else if (N(arguments[0], Vt)) {
              var n = arguments[0];
              if (0 === this._points.size()) return null;
              for (var i = 0; i < this._points.size() && (n.filter(this._points, i), !n.isDone()); i++);
              n.isGeometryChanged() && this.geometryChanged();
            } else (N(arguments[0], zt) || N(arguments[0], ht)) && arguments[0].filter(this);
          }, e.prototype.getBoundary = function () {
            return new Wt(this).getBoundary();
          }, e.prototype.isEquivalentClass = function (t) {
            return t instanceof e;
          }, e.prototype.clone = function () {
            var e = t.prototype.clone.call(this);
            return e._points = this._points.clone(), e;
          }, e.prototype.getCoordinateN = function (t) {
            return this._points.getCoordinate(t);
          }, e.prototype.getGeometryType = function () {
            return "LineString";
          }, e.prototype.copy = function () {
            return new e(this._points.copy(), this._factory);
          }, e.prototype.getCoordinateSequence = function () {
            return this._points;
          }, e.prototype.isEmpty = function () {
            return 0 === this._points.size();
          }, e.prototype.init = function (t) {
            if (null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), 1 === t.size()) throw new _("Invalid number of points in LineString (found " + t.size() + " - must be 0 or >= 2)");
            this._points = t;
          }, e.prototype.isCoordinate = function (t) {
            for (var e = 0; e < this._points.size(); e++) if (this._points.getCoordinate(e).equals(t)) return !0;
            return !1;
          }, e.prototype.getStartPoint = function () {
            return this.isEmpty() ? null : this.getPointN(0);
          }, e.prototype.getPointN = function (t) {
            return this.getFactory().createPoint(this._points.getCoordinate(t));
          }, e.prototype.interfaces_ = function () {
            return [Dt];
          }, e.prototype.getClass = function () {
            return e;
          }, n.serialVersionUID.get = function () {
            return 0x2b2b51ba435c8e00;
          }, Object.defineProperties(e, n), e;
        }(ct),
        Kt = u(function () {}, "Jt");
      Kt.prototype.interfaces_ = function () {
        return [];
      }, Kt.prototype.getClass = function () {
        return Kt;
      };
      var Qt = function (t) {
          function e(e, n) {
            t.call(this, n), this._coordinates = e || null, this.init(this._coordinates);
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            serialVersionUID: {
              configurable: !0
            }
          };
          return e.prototype.computeEnvelopeInternal = function () {
            if (this.isEmpty()) return new X();
            var t = new X();
            return t.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0)), t;
          }, e.prototype.getSortIndex = function () {
            return t.SORTINDEX_POINT;
          }, e.prototype.getCoordinates = function () {
            return this.isEmpty() ? [] : [this.getCoordinate()];
          }, e.prototype.equalsExact = function () {
            if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              return !!this.isEquivalentClass(e) && (!(!this.isEmpty() || !e.isEmpty()) || this.isEmpty() === e.isEmpty() && this.equal(e.getCoordinate(), this.getCoordinate(), n));
            }
            return t.prototype.equalsExact.apply(this, arguments);
          }, e.prototype.normalize = function () {}, e.prototype.getCoordinate = function () {
            return 0 !== this._coordinates.size() ? this._coordinates.getCoordinate(0) : null;
          }, e.prototype.getBoundaryDimension = function () {
            return Ut.FALSE;
          }, e.prototype.getDimension = function () {
            return 0;
          }, e.prototype.getNumPoints = function () {
            return this.isEmpty() ? 0 : 1;
          }, e.prototype.reverse = function () {
            return this.copy();
          }, e.prototype.getX = function () {
            if (null === this.getCoordinate()) throw new Error("getX called on empty Point");
            return this.getCoordinate().x;
          }, e.prototype.compareToSameClass = function () {
            if (1 === arguments.length) {
              var t = arguments[0];
              return this.getCoordinate().compareTo(t.getCoordinate());
            }
            if (2 === arguments.length) {
              var e = arguments[0];
              return arguments[1].compare(this._coordinates, e._coordinates);
            }
          }, e.prototype.apply = function () {
            if (N(arguments[0], ft)) {
              var t = arguments[0];
              if (this.isEmpty()) return null;
              t.filter(this.getCoordinate());
            } else if (N(arguments[0], Vt)) {
              var e = arguments[0];
              if (this.isEmpty()) return null;
              e.filter(this._coordinates, 0), e.isGeometryChanged() && this.geometryChanged();
            } else (N(arguments[0], zt) || N(arguments[0], ht)) && arguments[0].filter(this);
          }, e.prototype.getBoundary = function () {
            return this.getFactory().createGeometryCollection(null);
          }, e.prototype.clone = function () {
            var e = t.prototype.clone.call(this);
            return e._coordinates = this._coordinates.clone(), e;
          }, e.prototype.getGeometryType = function () {
            return "Point";
          }, e.prototype.copy = function () {
            return new e(this._coordinates.copy(), this._factory);
          }, e.prototype.getCoordinateSequence = function () {
            return this._coordinates;
          }, e.prototype.getY = function () {
            if (null === this.getCoordinate()) throw new Error("getY called on empty Point");
            return this.getCoordinate().y;
          }, e.prototype.isEmpty = function () {
            return 0 === this._coordinates.size();
          }, e.prototype.init = function (t) {
            null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), nt.isTrue(t.size() <= 1), this._coordinates = t;
          }, e.prototype.isSimple = function () {
            return !0;
          }, e.prototype.interfaces_ = function () {
            return [Kt];
          }, e.prototype.getClass = function () {
            return e;
          }, n.serialVersionUID.get = function () {
            return 0x44077bad161cbc00;
          }, Object.defineProperties(e, n), e;
        }(ct),
        $t = u(function () {}, "Zt");
      $t.prototype.interfaces_ = function () {
        return [];
      }, $t.prototype.getClass = function () {
        return $t;
      };
      var te = function (t) {
          function e(e, n, i) {
            if (t.call(this, i), this._shell = null, this._holes = null, null === e && (e = this.getFactory().createLinearRing()), null === n && (n = []), t.hasNullElements(n)) throw new _("holes must not contain null elements");
            if (e.isEmpty() && t.hasNonEmptyElements(n)) throw new _("shell is empty but holes are not");
            this._shell = e, this._holes = n;
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            serialVersionUID: {
              configurable: !0
            }
          };
          return e.prototype.computeEnvelopeInternal = function () {
            return this._shell.getEnvelopeInternal();
          }, e.prototype.getSortIndex = function () {
            return t.SORTINDEX_POLYGON;
          }, e.prototype.getCoordinates = function () {
            if (this.isEmpty()) return [];
            for (var t = new Array(this.getNumPoints()).fill(null), e = -1, n = this._shell.getCoordinates(), i = 0; i < n.length; i++) t[++e] = n[i];
            for (var r = 0; r < this._holes.length; r++) for (var o = this._holes[r].getCoordinates(), s = 0; s < o.length; s++) t[++e] = o[s];
            return t;
          }, e.prototype.getArea = function () {
            var t = 0;
            t += Math.abs(lt.signedArea(this._shell.getCoordinateSequence()));
            for (var e = 0; e < this._holes.length; e++) t -= Math.abs(lt.signedArea(this._holes[e].getCoordinateSequence()));
            return t;
          }, e.prototype.isRectangle = function () {
            if (0 !== this.getNumInteriorRing() || null === this._shell || 5 !== this._shell.getNumPoints()) return !1;
            for (var t = this._shell.getCoordinateSequence(), e = this.getEnvelopeInternal(), n = 0; n < 5; n++) {
              var i = t.getX(n);
              if (i !== e.getMinX() && i !== e.getMaxX()) return !1;
              var r = t.getY(n);
              if (r !== e.getMinY() && r !== e.getMaxY()) return !1;
            }
            for (var o = t.getX(0), s = t.getY(0), a = 1; a <= 4; a++) {
              var l = t.getX(a),
                u = t.getY(a);
              if (l !== o == (u !== s)) return !1;
              o = l, s = u;
            }
            return !0;
          }, e.prototype.equalsExact = function () {
            if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              if (!this.isEquivalentClass(e)) return !1;
              var i = e,
                r = this._shell,
                o = i._shell;
              if (!r.equalsExact(o, n) || this._holes.length !== i._holes.length) return !1;
              for (var s = 0; s < this._holes.length; s++) if (!this._holes[s].equalsExact(i._holes[s], n)) return !1;
              return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
          }, e.prototype.normalize = function () {
            if (0 === arguments.length) {
              this.normalize(this._shell, !0);
              for (var t = 0; t < this._holes.length; t++) this.normalize(this._holes[t], !1);
              Ft.sort(this._holes);
            } else if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              if (e.isEmpty()) return null;
              var i = new Array(e.getCoordinates().length - 1).fill(null);
              W.arraycopy(e.getCoordinates(), 0, i, 0, i.length);
              var r = At.minCoordinate(e.getCoordinates());
              At.scroll(i, r), W.arraycopy(i, 0, e.getCoordinates(), 0, i.length), e.getCoordinates()[i.length] = i[0], lt.isCCW(e.getCoordinates()) === n && At.reverse(e.getCoordinates());
            }
          }, e.prototype.getCoordinate = function () {
            return this._shell.getCoordinate();
          }, e.prototype.getNumInteriorRing = function () {
            return this._holes.length;
          }, e.prototype.getBoundaryDimension = function () {
            return 1;
          }, e.prototype.getDimension = function () {
            return 2;
          }, e.prototype.getLength = function () {
            var t = 0;
            t += this._shell.getLength();
            for (var e = 0; e < this._holes.length; e++) t += this._holes[e].getLength();
            return t;
          }, e.prototype.getNumPoints = function () {
            for (var t = this._shell.getNumPoints(), e = 0; e < this._holes.length; e++) t += this._holes[e].getNumPoints();
            return t;
          }, e.prototype.reverse = function () {
            var t = this.copy();
            t._shell = this._shell.copy().reverse(), t._holes = new Array(this._holes.length).fill(null);
            for (var e = 0; e < this._holes.length; e++) t._holes[e] = this._holes[e].copy().reverse();
            return t;
          }, e.prototype.convexHull = function () {
            return this.getExteriorRing().convexHull();
          }, e.prototype.compareToSameClass = function () {
            if (1 === arguments.length) {
              var t = arguments[0],
                e = this._shell,
                n = t._shell;
              return e.compareToSameClass(n);
            }
            if (2 === arguments.length) {
              var i = arguments[0],
                r = arguments[1],
                o = i,
                s = this._shell,
                a = o._shell,
                l = s.compareToSameClass(a, r);
              if (0 !== l) return l;
              for (var u = this.getNumInteriorRing(), h = o.getNumInteriorRing(), c = 0; c < u && c < h;) {
                var p = this.getInteriorRingN(c),
                  d = o.getInteriorRingN(c),
                  f = p.compareToSameClass(d, r);
                if (0 !== f) return f;
                c++;
              }
              return c < u ? 1 : c < h ? -1 : 0;
            }
          }, e.prototype.apply = function (t) {
            if (N(t, ft)) {
              this._shell.apply(t);
              for (var e = 0; e < this._holes.length; e++) this._holes[e].apply(t);
            } else if (N(t, Vt)) {
              if (this._shell.apply(t), !t.isDone()) for (var n = 0; n < this._holes.length && (this._holes[n].apply(t), !t.isDone()); n++);
              t.isGeometryChanged() && this.geometryChanged();
            } else if (N(t, zt)) t.filter(this);else if (N(t, ht)) {
              t.filter(this), this._shell.apply(t);
              for (var i = 0; i < this._holes.length; i++) this._holes[i].apply(t);
            }
          }, e.prototype.getBoundary = function () {
            if (this.isEmpty()) return this.getFactory().createMultiLineString();
            var t = new Array(this._holes.length + 1).fill(null);
            t[0] = this._shell;
            for (var e = 0; e < this._holes.length; e++) t[e + 1] = this._holes[e];
            return t.length <= 1 ? this.getFactory().createLinearRing(t[0].getCoordinateSequence()) : this.getFactory().createMultiLineString(t);
          }, e.prototype.clone = function () {
            var e = t.prototype.clone.call(this);
            e._shell = this._shell.clone(), e._holes = new Array(this._holes.length).fill(null);
            for (var n = 0; n < this._holes.length; n++) e._holes[n] = this._holes[n].clone();
            return e;
          }, e.prototype.getGeometryType = function () {
            return "Polygon";
          }, e.prototype.copy = function () {
            for (var t = this._shell.copy(), n = new Array(this._holes.length).fill(null), i = 0; i < n.length; i++) n[i] = this._holes[i].copy();
            return new e(t, n, this._factory);
          }, e.prototype.getExteriorRing = function () {
            return this._shell;
          }, e.prototype.isEmpty = function () {
            return this._shell.isEmpty();
          }, e.prototype.getInteriorRingN = function (t) {
            return this._holes[t];
          }, e.prototype.interfaces_ = function () {
            return [$t];
          }, e.prototype.getClass = function () {
            return e;
          }, n.serialVersionUID.get = function () {
            return -0x307ffefd8dc97200;
          }, Object.defineProperties(e, n), e;
        }(ct),
        ee = function (t) {
          function e() {
            t.apply(this, arguments);
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            serialVersionUID: {
              configurable: !0
            }
          };
          return e.prototype.getSortIndex = function () {
            return ct.SORTINDEX_MULTIPOINT;
          }, e.prototype.isValid = function () {
            return !0;
          }, e.prototype.equalsExact = function () {
            if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
          }, e.prototype.getCoordinate = function () {
            if (1 === arguments.length) {
              var e = arguments[0];
              return this._geometries[e].getCoordinate();
            }
            return t.prototype.getCoordinate.apply(this, arguments);
          }, e.prototype.getBoundaryDimension = function () {
            return Ut.FALSE;
          }, e.prototype.getDimension = function () {
            return 0;
          }, e.prototype.getBoundary = function () {
            return this.getFactory().createGeometryCollection(null);
          }, e.prototype.getGeometryType = function () {
            return "MultiPoint";
          }, e.prototype.copy = function () {
            for (var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++) t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
          }, e.prototype.interfaces_ = function () {
            return [Kt];
          }, e.prototype.getClass = function () {
            return e;
          }, n.serialVersionUID.get = function () {
            return -0x6fb1ed4162e0fc00;
          }, Object.defineProperties(e, n), e;
        }(jt),
        ne = function (t) {
          function e(e, n) {
            e instanceof M && n instanceof ye && (e = n.getCoordinateSequenceFactory().create(e)), t.call(this, e, n), this.validateConstruction();
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            MINIMUM_VALID_SIZE: {
              configurable: !0
            },
            serialVersionUID: {
              configurable: !0
            }
          };
          return e.prototype.getSortIndex = function () {
            return ct.SORTINDEX_LINEARRING;
          }, e.prototype.getBoundaryDimension = function () {
            return Ut.FALSE;
          }, e.prototype.isClosed = function () {
            return !!this.isEmpty() || t.prototype.isClosed.call(this);
          }, e.prototype.reverse = function () {
            var t = this._points.copy();
            return Zt.reverse(t), this.getFactory().createLinearRing(t);
          }, e.prototype.validateConstruction = function () {
            if (!this.isEmpty() && !t.prototype.isClosed.call(this)) throw new _("Points of LinearRing do not form a closed linestring");
            if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < e.MINIMUM_VALID_SIZE) throw new _("Invalid number of points in LinearRing (found " + this.getCoordinateSequence().size() + " - must be 0 or >= 4)");
          }, e.prototype.getGeometryType = function () {
            return "LinearRing";
          }, e.prototype.copy = function () {
            return new e(this._points.copy(), this._factory);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, n.MINIMUM_VALID_SIZE.get = function () {
            return 4;
          }, n.serialVersionUID.get = function () {
            return -0x3b229e262367a600;
          }, Object.defineProperties(e, n), e;
        }(Jt),
        ie = function (t) {
          function e() {
            t.apply(this, arguments);
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            serialVersionUID: {
              configurable: !0
            }
          };
          return e.prototype.getSortIndex = function () {
            return ct.SORTINDEX_MULTIPOLYGON;
          }, e.prototype.equalsExact = function () {
            if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
          }, e.prototype.getBoundaryDimension = function () {
            return 1;
          }, e.prototype.getDimension = function () {
            return 2;
          }, e.prototype.reverse = function () {
            for (var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++) e[n] = this._geometries[n].reverse();
            return this.getFactory().createMultiPolygon(e);
          }, e.prototype.getBoundary = function () {
            if (this.isEmpty()) return this.getFactory().createMultiLineString();
            for (var t = new St(), e = 0; e < this._geometries.length; e++) for (var n = this._geometries[e].getBoundary(), i = 0; i < n.getNumGeometries(); i++) t.add(n.getGeometryN(i));
            var r = new Array(t.size()).fill(null);
            return this.getFactory().createMultiLineString(t.toArray(r));
          }, e.prototype.getGeometryType = function () {
            return "MultiPolygon";
          }, e.prototype.copy = function () {
            for (var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++) t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
          }, e.prototype.interfaces_ = function () {
            return [$t];
          }, e.prototype.getClass = function () {
            return e;
          }, n.serialVersionUID.get = function () {
            return -0x7a5aa1369171980;
          }, Object.defineProperties(e, n), e;
        }(jt),
        re = u(function (t) {
          this._factory = t || null, this._isUserDataCopied = !1;
        }, "ie"),
        oe = {
          NoOpGeometryOperation: {
            configurable: !0
          },
          CoordinateOperation: {
            configurable: !0
          },
          CoordinateSequenceOperation: {
            configurable: !0
          }
        };
      re.prototype.setCopyUserData = function (t) {
        this._isUserDataCopied = t;
      }, re.prototype.edit = function (t, e) {
        if (null === t) return null;
        var n = this.editInternal(t, e);
        return this._isUserDataCopied && n.setUserData(t.getUserData()), n;
      }, re.prototype.editInternal = function (t, e) {
        return null === this._factory && (this._factory = t.getFactory()), t instanceof jt ? this.editGeometryCollection(t, e) : t instanceof te ? this.editPolygon(t, e) : t instanceof Qt || t instanceof Jt ? e.edit(t, this._factory) : (nt.shouldNeverReachHere("Unsupported Geometry class: " + t.getClass().getName()), null);
      }, re.prototype.editGeometryCollection = function (t, e) {
        for (var n = e.edit(t, this._factory), i = new St(), r = 0; r < n.getNumGeometries(); r++) {
          var o = this.edit(n.getGeometryN(r), e);
          null === o || o.isEmpty() || i.add(o);
        }
        return n.getClass() === ee ? this._factory.createMultiPoint(i.toArray([])) : n.getClass() === Gt ? this._factory.createMultiLineString(i.toArray([])) : n.getClass() === ie ? this._factory.createMultiPolygon(i.toArray([])) : this._factory.createGeometryCollection(i.toArray([]));
      }, re.prototype.editPolygon = function (t, e) {
        var n = e.edit(t, this._factory);
        if (null === n && (n = this._factory.createPolygon(null)), n.isEmpty()) return n;
        var i = this.edit(n.getExteriorRing(), e);
        if (null === i || i.isEmpty()) return this._factory.createPolygon();
        for (var r = new St(), o = 0; o < n.getNumInteriorRing(); o++) {
          var s = this.edit(n.getInteriorRingN(o), e);
          null === s || s.isEmpty() || r.add(s);
        }
        return this._factory.createPolygon(i, r.toArray([]));
      }, re.prototype.interfaces_ = function () {
        return [];
      }, re.prototype.getClass = function () {
        return re;
      }, re.GeometryEditorOperation = function () {}, oe.NoOpGeometryOperation.get = function () {
        return se;
      }, oe.CoordinateOperation.get = function () {
        return ae;
      }, oe.CoordinateSequenceOperation.get = function () {
        return le;
      }, Object.defineProperties(re, oe);
      var se = u(function () {}, "oe");
      se.prototype.edit = function (t, e) {
        return t;
      }, se.prototype.interfaces_ = function () {
        return [re.GeometryEditorOperation];
      }, se.prototype.getClass = function () {
        return se;
      };
      var ae = u(function () {}, "se");
      ae.prototype.edit = function (t, e) {
        var n = this.editCoordinates(t.getCoordinates(), t);
        return null === n ? t : t instanceof ne ? e.createLinearRing(n) : t instanceof Jt ? e.createLineString(n) : t instanceof Qt ? n.length > 0 ? e.createPoint(n[0]) : e.createPoint() : t;
      }, ae.prototype.interfaces_ = function () {
        return [re.GeometryEditorOperation];
      }, ae.prototype.getClass = function () {
        return ae;
      };
      var le = u(function () {}, "ae");
      le.prototype.edit = function (t, e) {
        return t instanceof ne ? e.createLinearRing(this.edit(t.getCoordinateSequence(), t)) : t instanceof Jt ? e.createLineString(this.edit(t.getCoordinateSequence(), t)) : t instanceof Qt ? e.createPoint(this.edit(t.getCoordinateSequence(), t)) : t;
      }, le.prototype.interfaces_ = function () {
        return [re.GeometryEditorOperation];
      }, le.prototype.getClass = function () {
        return le;
      };
      var ue = u(function () {
          if (this._dimension = 3, this._coordinates = null, 1 === arguments.length) {
            if (arguments[0] instanceof Array) this._coordinates = arguments[0], this._dimension = 3;else if (Number.isInteger(arguments[0])) {
              var t = arguments[0];
              this._coordinates = new Array(t).fill(null);
              for (var e = 0; e < t; e++) this._coordinates[e] = new M();
            } else if (N(arguments[0], z)) {
              var n = arguments[0];
              if (null === n) return this._coordinates = new Array(0).fill(null), null;
              this._dimension = n.getDimension(), this._coordinates = new Array(n.size()).fill(null);
              for (var i = 0; i < this._coordinates.length; i++) this._coordinates[i] = n.getCoordinateCopy(i);
            }
          } else if (2 === arguments.length) if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
            var r = arguments[0],
              o = arguments[1];
            this._coordinates = r, this._dimension = o, null === r && (this._coordinates = new Array(0).fill(null));
          } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
            var s = arguments[0],
              a = arguments[1];
            this._coordinates = new Array(s).fill(null), this._dimension = a;
            for (var l = 0; l < s; l++) this._coordinates[l] = new M();
          }
        }, "ue"),
        he = {
          serialVersionUID: {
            configurable: !0
          }
        };
      ue.prototype.setOrdinate = function (t, e, n) {
        switch (e) {
          case z.X:
            this._coordinates[t].x = n;
            break;
          case z.Y:
            this._coordinates[t].y = n;
            break;
          case z.Z:
            this._coordinates[t].z = n;
            break;
          default:
            throw new _("invalid ordinateIndex");
        }
      }, ue.prototype.size = function () {
        return this._coordinates.length;
      }, ue.prototype.getOrdinate = function (t, e) {
        switch (e) {
          case z.X:
            return this._coordinates[t].x;
          case z.Y:
            return this._coordinates[t].y;
          case z.Z:
            return this._coordinates[t].z;
        }
        return x.NaN;
      }, ue.prototype.getCoordinate = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return this._coordinates[t];
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          n.x = this._coordinates[e].x, n.y = this._coordinates[e].y, n.z = this._coordinates[e].z;
        }
      }, ue.prototype.getCoordinateCopy = function (t) {
        return new M(this._coordinates[t]);
      }, ue.prototype.getDimension = function () {
        return this._dimension;
      }, ue.prototype.getX = function (t) {
        return this._coordinates[t].x;
      }, ue.prototype.clone = function () {
        for (var t = new Array(this.size()).fill(null), e = 0; e < this._coordinates.length; e++) t[e] = this._coordinates[e].clone();
        return new ue(t, this._dimension);
      }, ue.prototype.expandEnvelope = function (t) {
        for (var e = 0; e < this._coordinates.length; e++) t.expandToInclude(this._coordinates[e]);
        return t;
      }, ue.prototype.copy = function () {
        for (var t = new Array(this.size()).fill(null), e = 0; e < this._coordinates.length; e++) t[e] = this._coordinates[e].copy();
        return new ue(t, this._dimension);
      }, ue.prototype.toString = function () {
        if (this._coordinates.length > 0) {
          var t = new O(17 * this._coordinates.length);
          t.append("("), t.append(this._coordinates[0]);
          for (var e = 1; e < this._coordinates.length; e++) t.append(", "), t.append(this._coordinates[e]);
          return t.append(")"), t.toString();
        }
        return "()";
      }, ue.prototype.getY = function (t) {
        return this._coordinates[t].y;
      }, ue.prototype.toCoordinateArray = function () {
        return this._coordinates;
      }, ue.prototype.interfaces_ = function () {
        return [z, e];
      }, ue.prototype.getClass = function () {
        return ue;
      }, he.serialVersionUID.get = function () {
        return -0xcb44a778db18e00;
      }, Object.defineProperties(ue, he);
      var ce = u(function () {}, "ce"),
        pe = {
          serialVersionUID: {
            configurable: !0
          },
          instanceObject: {
            configurable: !0
          }
        };
      ce.prototype.readResolve = function () {
        return ce.instance();
      }, ce.prototype.create = function () {
        if (1 === arguments.length) {
          if (arguments[0] instanceof Array) {
            var t = arguments[0];
            return new ue(t);
          }
          if (N(arguments[0], z)) {
            var e = arguments[0];
            return new ue(e);
          }
        } else if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          return i > 3 && (i = 3), i < 2 ? new ue(n) : new ue(n, i);
        }
      }, ce.prototype.interfaces_ = function () {
        return [P, e];
      }, ce.prototype.getClass = function () {
        return ce;
      }, ce.instance = function () {
        return ce.instanceObject;
      }, pe.serialVersionUID.get = function () {
        return -0x38e49fa6cf6f2e00;
      }, pe.instanceObject.get = function () {
        return new ce();
      }, Object.defineProperties(ce, pe);
      var de = function (t) {
          function e() {
            t.call(this), this.map_ = new Map();
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function (t) {
            return this.map_.get(t) || null;
          }, e.prototype.put = function (t, e) {
            return this.map_.set(t, e), e;
          }, e.prototype.values = function () {
            for (var t = new St(), e = this.map_.values(), n = e.next(); !n.done;) t.add(n.value), n = e.next();
            return t;
          }, e.prototype.entrySet = function () {
            var t = new Rt();
            return this.map_.entries().forEach(function (e) {
              return t.add(e);
            }), t;
          }, e.prototype.size = function () {
            return this.map_.size();
          }, e;
        }(Nt),
        fe = u(function t() {
          if (this._modelType = null, this._scale = null, 0 === arguments.length) this._modelType = t.FLOATING;else if (1 === arguments.length) if (arguments[0] instanceof ge) {
            var e = arguments[0];
            this._modelType = e, e === t.FIXED && this.setScale(1);
          } else if ("number" == typeof arguments[0]) {
            var n = arguments[0];
            this._modelType = t.FIXED, this.setScale(n);
          } else if (arguments[0] instanceof t) {
            var i = arguments[0];
            this._modelType = i._modelType, this._scale = i._scale;
          }
        }, "t"),
        me = {
          serialVersionUID: {
            configurable: !0
          },
          maximumPreciseValue: {
            configurable: !0
          }
        };
      fe.prototype.equals = function (t) {
        if (!(t instanceof fe)) return !1;
        var e = t;
        return this._modelType === e._modelType && this._scale === e._scale;
      }, fe.prototype.compareTo = function (t) {
        var e = t,
          n = this.getMaximumSignificantDigits(),
          i = e.getMaximumSignificantDigits();
        return new q(n).compareTo(new q(i));
      }, fe.prototype.getScale = function () {
        return this._scale;
      }, fe.prototype.isFloating = function () {
        return this._modelType === fe.FLOATING || this._modelType === fe.FLOATING_SINGLE;
      }, fe.prototype.getType = function () {
        return this._modelType;
      }, fe.prototype.toString = function () {
        var t = "UNKNOWN";
        return this._modelType === fe.FLOATING ? t = "Floating" : this._modelType === fe.FLOATING_SINGLE ? t = "Floating-Single" : this._modelType === fe.FIXED && (t = "Fixed (Scale=" + this.getScale() + ")"), t;
      }, fe.prototype.makePrecise = function () {
        if ("number" == typeof arguments[0]) {
          var t = arguments[0];
          return x.isNaN(t) || this._modelType === fe.FLOATING_SINGLE ? t : this._modelType === fe.FIXED ? Math.round(t * this._scale) / this._scale : t;
        }
        if (arguments[0] instanceof M) {
          var e = arguments[0];
          if (this._modelType === fe.FLOATING) return null;
          e.x = this.makePrecise(e.x), e.y = this.makePrecise(e.y);
        }
      }, fe.prototype.getMaximumSignificantDigits = function () {
        var t = 16;
        return this._modelType === fe.FLOATING ? t = 16 : this._modelType === fe.FLOATING_SINGLE ? t = 6 : this._modelType === fe.FIXED && (t = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)))), t;
      }, fe.prototype.setScale = function (t) {
        this._scale = Math.abs(t);
      }, fe.prototype.interfaces_ = function () {
        return [e, b];
      }, fe.prototype.getClass = function () {
        return fe;
      }, fe.mostPrecise = function (t, e) {
        return t.compareTo(e) >= 0 ? t : e;
      }, me.serialVersionUID.get = function () {
        return 0x6bee6404e9a25c00;
      }, me.maximumPreciseValue.get = function () {
        return 9007199254740992;
      }, Object.defineProperties(fe, me);
      var ge = u(function t(e) {
          this._name = e || null, t.nameToTypeMap.put(e, this);
        }, "t"),
        ve = {
          serialVersionUID: {
            configurable: !0
          },
          nameToTypeMap: {
            configurable: !0
          }
        };
      ge.prototype.readResolve = function () {
        return ge.nameToTypeMap.get(this._name);
      }, ge.prototype.toString = function () {
        return this._name;
      }, ge.prototype.interfaces_ = function () {
        return [e];
      }, ge.prototype.getClass = function () {
        return ge;
      }, ve.serialVersionUID.get = function () {
        return -552860263173159e4;
      }, ve.nameToTypeMap.get = function () {
        return new de();
      }, Object.defineProperties(ge, ve), fe.Type = ge, fe.FIXED = new ge("FIXED"), fe.FLOATING = new ge("FLOATING"), fe.FLOATING_SINGLE = new ge("FLOATING SINGLE");
      var ye = u(function t() {
          this._precisionModel = new fe(), this._SRID = 0, this._coordinateSequenceFactory = t.getDefaultCoordinateSequenceFactory(), 0 === arguments.length || (1 === arguments.length ? N(arguments[0], P) ? this._coordinateSequenceFactory = arguments[0] : arguments[0] instanceof fe && (this._precisionModel = arguments[0]) : 2 === arguments.length ? (this._precisionModel = arguments[0], this._SRID = arguments[1]) : 3 === arguments.length && (this._precisionModel = arguments[0], this._SRID = arguments[1], this._coordinateSequenceFactory = arguments[2]));
        }, "t"),
        _e = {
          serialVersionUID: {
            configurable: !0
          }
        };
      ye.prototype.toGeometry = function (t) {
        return t.isNull() ? this.createPoint(null) : t.getMinX() === t.getMaxX() && t.getMinY() === t.getMaxY() ? this.createPoint(new M(t.getMinX(), t.getMinY())) : t.getMinX() === t.getMaxX() || t.getMinY() === t.getMaxY() ? this.createLineString([new M(t.getMinX(), t.getMinY()), new M(t.getMaxX(), t.getMaxY())]) : this.createPolygon(this.createLinearRing([new M(t.getMinX(), t.getMinY()), new M(t.getMinX(), t.getMaxY()), new M(t.getMaxX(), t.getMaxY()), new M(t.getMaxX(), t.getMinY()), new M(t.getMinX(), t.getMinY())]), null);
      }, ye.prototype.createLineString = function (t) {
        return t ? t instanceof Array ? new Jt(this.getCoordinateSequenceFactory().create(t), this) : N(t, z) ? new Jt(t, this) : void 0 : new Jt(this.getCoordinateSequenceFactory().create([]), this);
      }, ye.prototype.createMultiLineString = function () {
        if (0 === arguments.length) return new Gt(null, this);
        if (1 === arguments.length) {
          var t = arguments[0];
          return new Gt(t, this);
        }
      }, ye.prototype.buildGeometry = function (t) {
        for (var e = null, n = !1, i = !1, r = t.iterator(); r.hasNext();) {
          var o = r.next(),
            s = o.getClass();
          null === e && (e = s), s !== e && (n = !0), o.isGeometryCollectionOrDerived() && (i = !0);
        }
        if (null === e) return this.createGeometryCollection();
        if (n || i) return this.createGeometryCollection(ye.toGeometryArray(t));
        var a = t.iterator().next();
        if (t.size() > 1) {
          if (a instanceof te) return this.createMultiPolygon(ye.toPolygonArray(t));
          if (a instanceof Jt) return this.createMultiLineString(ye.toLineStringArray(t));
          if (a instanceof Qt) return this.createMultiPoint(ye.toPointArray(t));
          nt.shouldNeverReachHere("Unhandled class: " + a.getClass().getName());
        }
        return a;
      }, ye.prototype.createMultiPointFromCoords = function (t) {
        return this.createMultiPoint(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
      }, ye.prototype.createPoint = function () {
        if (0 === arguments.length) return this.createPoint(this.getCoordinateSequenceFactory().create([]));
        if (1 === arguments.length) {
          if (arguments[0] instanceof M) {
            var t = arguments[0];
            return this.createPoint(null !== t ? this.getCoordinateSequenceFactory().create([t]) : null);
          }
          if (N(arguments[0], z)) {
            var e = arguments[0];
            return new Qt(e, this);
          }
        }
      }, ye.prototype.getCoordinateSequenceFactory = function () {
        return this._coordinateSequenceFactory;
      }, ye.prototype.createPolygon = function () {
        if (0 === arguments.length) return new te(null, null, this);
        if (1 === arguments.length) {
          if (N(arguments[0], z)) {
            var t = arguments[0];
            return this.createPolygon(this.createLinearRing(t));
          }
          if (arguments[0] instanceof Array) {
            var e = arguments[0];
            return this.createPolygon(this.createLinearRing(e));
          }
          if (arguments[0] instanceof ne) {
            var n = arguments[0];
            return this.createPolygon(n, null);
          }
        } else if (2 === arguments.length) {
          var i = arguments[0],
            r = arguments[1];
          return new te(i, r, this);
        }
      }, ye.prototype.getSRID = function () {
        return this._SRID;
      }, ye.prototype.createGeometryCollection = function () {
        if (0 === arguments.length) return new jt(null, this);
        if (1 === arguments.length) {
          var t = arguments[0];
          return new jt(t, this);
        }
      }, ye.prototype.createGeometry = function (t) {
        return new re(this).edit(t, {
          edit: function () {
            if (2 === arguments.length) {
              var t = arguments[0];
              return this._coordinateSequenceFactory.create(t);
            }
          }
        });
      }, ye.prototype.getPrecisionModel = function () {
        return this._precisionModel;
      }, ye.prototype.createLinearRing = function () {
        if (0 === arguments.length) return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
        if (1 === arguments.length) {
          if (arguments[0] instanceof Array) {
            var t = arguments[0];
            return this.createLinearRing(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
          }
          if (N(arguments[0], z)) {
            var e = arguments[0];
            return new ne(e, this);
          }
        }
      }, ye.prototype.createMultiPolygon = function () {
        if (0 === arguments.length) return new ie(null, this);
        if (1 === arguments.length) {
          var t = arguments[0];
          return new ie(t, this);
        }
      }, ye.prototype.createMultiPoint = function () {
        if (0 === arguments.length) return new ee(null, this);
        if (1 === arguments.length) {
          if (arguments[0] instanceof Array) {
            var t = arguments[0];
            return new ee(t, this);
          }
          if (arguments[0] instanceof Array) {
            var e = arguments[0];
            return this.createMultiPoint(null !== e ? this.getCoordinateSequenceFactory().create(e) : null);
          }
          if (N(arguments[0], z)) {
            var n = arguments[0];
            if (null === n) return this.createMultiPoint(new Array(0).fill(null));
            for (var i = new Array(n.size()).fill(null), r = 0; r < n.size(); r++) {
              var o = this.getCoordinateSequenceFactory().create(1, n.getDimension());
              Zt.copy(n, r, o, 0, 1), i[r] = this.createPoint(o);
            }
            return this.createMultiPoint(i);
          }
        }
      }, ye.prototype.interfaces_ = function () {
        return [e];
      }, ye.prototype.getClass = function () {
        return ye;
      }, ye.toMultiPolygonArray = function (t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
      }, ye.toGeometryArray = function (t) {
        if (null === t) return null;
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
      }, ye.getDefaultCoordinateSequenceFactory = function () {
        return ce.instance();
      }, ye.toMultiLineStringArray = function (t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
      }, ye.toLineStringArray = function (t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
      }, ye.toMultiPointArray = function (t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
      }, ye.toLinearRingArray = function (t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
      }, ye.toPointArray = function (t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
      }, ye.toPolygonArray = function (t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
      }, ye.createPointFromInternalCoord = function (t, e) {
        return e.getPrecisionModel().makePrecise(t), e.getFactory().createPoint(t);
      }, _e.serialVersionUID.get = function () {
        return -0x5ea75f2051eeb400;
      }, Object.defineProperties(ye, _e);
      var xe = ["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon"],
        Ee = u(function (t) {
          this.geometryFactory = t || new ye();
        }, "Ie");
      Ee.prototype.read = function (t) {
        var e,
          n = (e = "string" == typeof t ? JSON.parse(t) : t).type;
        if (!be[n]) throw new Error("Unknown GeoJSON type: " + e.type);
        return -1 !== xe.indexOf(n) ? be[n].apply(this, [e.coordinates]) : "GeometryCollection" === n ? be[n].apply(this, [e.geometries]) : be[n].apply(this, [e]);
      }, Ee.prototype.write = function (t) {
        var e = t.getGeometryType();
        if (!we[e]) throw new Error("Geometry is not supported");
        return we[e].apply(this, [t]);
      };
      var be = {
          Feature: function (t) {
            var e = {};
            for (var n in t) e[n] = t[n];
            if (t.geometry) {
              var i = t.geometry.type;
              if (!be[i]) throw new Error("Unknown GeoJSON type: " + t.type);
              e.geometry = this.read(t.geometry);
            }
            return t.bbox && (e.bbox = be.bbox.apply(this, [t.bbox])), e;
          },
          FeatureCollection: function (t) {
            var e = {};
            if (t.features) {
              e.features = [];
              for (var n = 0; n < t.features.length; ++n) e.features.push(this.read(t.features[n]));
            }
            return t.bbox && (e.bbox = this.parse.bbox.apply(this, [t.bbox])), e;
          },
          coordinates: function (t) {
            for (var e = [], n = 0; n < t.length; ++n) {
              var i = t[n];
              e.push(new M(i[0], i[1]));
            }
            return e;
          },
          bbox: function (t) {
            return this.geometryFactory.createLinearRing([new M(t[0], t[1]), new M(t[2], t[1]), new M(t[2], t[3]), new M(t[0], t[3]), new M(t[0], t[1])]);
          },
          Point: function (t) {
            var e = new M(t[0], t[1]);
            return this.geometryFactory.createPoint(e);
          },
          MultiPoint: function (t) {
            for (var e = [], n = 0; n < t.length; ++n) e.push(be.Point.apply(this, [t[n]]));
            return this.geometryFactory.createMultiPoint(e);
          },
          LineString: function (t) {
            var e = be.coordinates.apply(this, [t]);
            return this.geometryFactory.createLineString(e);
          },
          MultiLineString: function (t) {
            for (var e = [], n = 0; n < t.length; ++n) e.push(be.LineString.apply(this, [t[n]]));
            return this.geometryFactory.createMultiLineString(e);
          },
          Polygon: function (t) {
            for (var e = be.coordinates.apply(this, [t[0]]), n = this.geometryFactory.createLinearRing(e), i = [], r = 1; r < t.length; ++r) {
              var o = t[r],
                s = be.coordinates.apply(this, [o]),
                a = this.geometryFactory.createLinearRing(s);
              i.push(a);
            }
            return this.geometryFactory.createPolygon(n, i);
          },
          MultiPolygon: function (t) {
            for (var e = [], n = 0; n < t.length; ++n) {
              var i = t[n];
              e.push(be.Polygon.apply(this, [i]));
            }
            return this.geometryFactory.createMultiPolygon(e);
          },
          GeometryCollection: function (t) {
            for (var e = [], n = 0; n < t.length; ++n) {
              var i = t[n];
              e.push(this.read(i));
            }
            return this.geometryFactory.createGeometryCollection(e);
          }
        },
        we = {
          coordinate: function (t) {
            return [t.x, t.y];
          },
          Point: function (t) {
            return {
              type: "Point",
              coordinates: we.coordinate.apply(this, [t.getCoordinate()])
            };
          },
          MultiPoint: function (t) {
            for (var e = [], n = 0; n < t._geometries.length; ++n) {
              var i = t._geometries[n],
                r = we.Point.apply(this, [i]);
              e.push(r.coordinates);
            }
            return {
              type: "MultiPoint",
              coordinates: e
            };
          },
          LineString: function (t) {
            for (var e = [], n = t.getCoordinates(), i = 0; i < n.length; ++i) {
              var r = n[i];
              e.push(we.coordinate.apply(this, [r]));
            }
            return {
              type: "LineString",
              coordinates: e
            };
          },
          MultiLineString: function (t) {
            for (var e = [], n = 0; n < t._geometries.length; ++n) {
              var i = t._geometries[n],
                r = we.LineString.apply(this, [i]);
              e.push(r.coordinates);
            }
            return {
              type: "MultiLineString",
              coordinates: e
            };
          },
          Polygon: function (t) {
            var e = [],
              n = we.LineString.apply(this, [t._shell]);
            e.push(n.coordinates);
            for (var i = 0; i < t._holes.length; ++i) {
              var r = t._holes[i],
                o = we.LineString.apply(this, [r]);
              e.push(o.coordinates);
            }
            return {
              type: "Polygon",
              coordinates: e
            };
          },
          MultiPolygon: function (t) {
            for (var e = [], n = 0; n < t._geometries.length; ++n) {
              var i = t._geometries[n],
                r = we.Polygon.apply(this, [i]);
              e.push(r.coordinates);
            }
            return {
              type: "MultiPolygon",
              coordinates: e
            };
          },
          GeometryCollection: function (t) {
            for (var e = [], n = 0; n < t._geometries.length; ++n) {
              var i = t._geometries[n],
                r = i.getGeometryType();
              e.push(we[r].apply(this, [i]));
            }
            return {
              type: "GeometryCollection",
              geometries: e
            };
          }
        },
        Se = u(function (t) {
          this.geometryFactory = t || new ye(), this.precisionModel = this.geometryFactory.getPrecisionModel(), this.parser = new Ee(this.geometryFactory);
        }, "Ne");
      Se.prototype.read = function (t) {
        var e = this.parser.read(t);
        return this.precisionModel.getType() === fe.FIXED && this.reducePrecision(e), e;
      }, Se.prototype.reducePrecision = function (t) {
        var e, n;
        if (t.coordinate) this.precisionModel.makePrecise(t.coordinate);else if (t.points) for (e = 0, n = t.points.length; e < n; e++) this.precisionModel.makePrecise(t.points[e]);else if (t.geometries) for (e = 0, n = t.geometries.length; e < n; e++) this.reducePrecision(t.geometries[e]);
      };
      var Me = u(function () {
        this.parser = new Ee(this.geometryFactory);
      }, "Ce");
      Me.prototype.write = function (t) {
        return this.parser.write(t);
      };
      var Te = u(function () {}, "Se"),
        Ae = {
          ON: {
            configurable: !0
          },
          LEFT: {
            configurable: !0
          },
          RIGHT: {
            configurable: !0
          }
        };
      Te.prototype.interfaces_ = function () {
        return [];
      }, Te.prototype.getClass = function () {
        return Te;
      }, Te.opposite = function (t) {
        return t === Te.LEFT ? Te.RIGHT : t === Te.RIGHT ? Te.LEFT : t;
      }, Ae.ON.get = function () {
        return 0;
      }, Ae.LEFT.get = function () {
        return 1;
      }, Ae.RIGHT.get = function () {
        return 2;
      }, Object.defineProperties(Te, Ae), (g.prototype = new Error()).name = "EmptyStackException", (v.prototype = new wt()).add = function (t) {
        return this.array_.push(t), !0;
      }, v.prototype.get = function (t) {
        if (t < 0 || t >= this.size()) throw new Error();
        return this.array_[t];
      }, v.prototype.push = function (t) {
        return this.array_.push(t), t;
      }, v.prototype.pop = function (t) {
        if (0 === this.array_.length) throw new g();
        return this.array_.pop();
      }, v.prototype.peek = function () {
        if (0 === this.array_.length) throw new g();
        return this.array_[this.array_.length - 1];
      }, v.prototype.empty = function () {
        return 0 === this.array_.length;
      }, v.prototype.isEmpty = function () {
        return this.empty();
      }, v.prototype.search = function (t) {
        return this.array_.indexOf(t);
      }, v.prototype.size = function () {
        return this.array_.length;
      }, v.prototype.toArray = function () {
        for (var t = [], e = 0, n = this.array_.length; e < n; e++) t.push(this.array_[e]);
        return t;
      };
      var Pe = u(function () {
        this._minIndex = -1, this._minCoord = null, this._minDe = null, this._orientedDe = null;
      }, "be");
      Pe.prototype.getCoordinate = function () {
        return this._minCoord;
      }, Pe.prototype.getRightmostSide = function (t, e) {
        var n = this.getRightmostSideOfSegment(t, e);
        return n < 0 && (n = this.getRightmostSideOfSegment(t, e - 1)), n < 0 && (this._minCoord = null, this.checkForRightmostCoordinate(t)), n;
      }, Pe.prototype.findRightmostEdgeAtVertex = function () {
        var t = this._minDe.getEdge().getCoordinates();
        nt.isTrue(this._minIndex > 0 && this._minIndex < t.length, "rightmost point expected to be interior vertex of edge");
        var e = t[this._minIndex - 1],
          n = t[this._minIndex + 1],
          i = lt.computeOrientation(this._minCoord, n, e),
          r = !1;
        (e.y < this._minCoord.y && n.y < this._minCoord.y && i === lt.COUNTERCLOCKWISE || e.y > this._minCoord.y && n.y > this._minCoord.y && i === lt.CLOCKWISE) && (r = !0), r && (this._minIndex = this._minIndex - 1);
      }, Pe.prototype.getRightmostSideOfSegment = function (t, e) {
        var n = t.getEdge().getCoordinates();
        if (e < 0 || e + 1 >= n.length || n[e].y === n[e + 1].y) return -1;
        var i = Te.LEFT;
        return n[e].y < n[e + 1].y && (i = Te.RIGHT), i;
      }, Pe.prototype.getEdge = function () {
        return this._orientedDe;
      }, Pe.prototype.checkForRightmostCoordinate = function (t) {
        for (var e = t.getEdge().getCoordinates(), n = 0; n < e.length - 1; n++) (null === this._minCoord || e[n].x > this._minCoord.x) && (this._minDe = t, this._minIndex = n, this._minCoord = e[n]);
      }, Pe.prototype.findRightmostEdgeAtNode = function () {
        var t = this._minDe.getNode().getEdges();
        this._minDe = t.getRightmostEdge(), this._minDe.isForward() || (this._minDe = this._minDe.getSym(), this._minIndex = this._minDe.getEdge().getCoordinates().length - 1);
      }, Pe.prototype.findEdge = function (t) {
        for (var e = t.iterator(); e.hasNext();) {
          var n = e.next();
          n.isForward() && this.checkForRightmostCoordinate(n);
        }
        nt.isTrue(0 !== this._minIndex || this._minCoord.equals(this._minDe.getCoordinate()), "inconsistency in rightmost processing"), 0 === this._minIndex ? this.findRightmostEdgeAtNode() : this.findRightmostEdgeAtVertex(), this._orientedDe = this._minDe, this.getRightmostSide(this._minDe, this._minIndex) === Te.LEFT && (this._orientedDe = this._minDe.getSym());
      }, Pe.prototype.interfaces_ = function () {
        return [];
      }, Pe.prototype.getClass = function () {
        return Pe;
      };
      var Ce = function (t) {
          function e(n, i) {
            t.call(this, e.msgWithCoord(n, i)), this.pt = i ? new M(i) : null, this.name = "TopologyException";
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getCoordinate = function () {
            return this.pt;
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e.msgWithCoord = function (t, e) {
            return e ? t : t + " [ " + e + " ]";
          }, e;
        }(tt),
        Ie = u(function () {
          this.array_ = [];
        }, "Oe");
      Ie.prototype.addLast = function (t) {
        this.array_.push(t);
      }, Ie.prototype.removeFirst = function () {
        return this.array_.shift();
      }, Ie.prototype.isEmpty = function () {
        return 0 === this.array_.length;
      };
      var Ne = u(function () {
        this._finder = null, this._dirEdgeList = new St(), this._nodes = new St(), this._rightMostCoord = null, this._env = null, this._finder = new Pe();
      }, "Te");
      Ne.prototype.clearVisitedEdges = function () {
        for (var t = this._dirEdgeList.iterator(); t.hasNext();) t.next().setVisited(!1);
      }, Ne.prototype.getRightmostCoordinate = function () {
        return this._rightMostCoord;
      }, Ne.prototype.computeNodeDepth = function (t) {
        for (var e = null, n = t.getEdges().iterator(); n.hasNext();) {
          var i = n.next();
          if (i.isVisited() || i.getSym().isVisited()) {
            e = i;
            break;
          }
        }
        if (null === e) throw new Ce("unable to find edge to compute depths at " + t.getCoordinate());
        t.getEdges().computeDepths(e);
        for (var r = t.getEdges().iterator(); r.hasNext();) {
          var o = r.next();
          o.setVisited(!0), this.copySymDepths(o);
        }
      }, Ne.prototype.computeDepth = function (t) {
        this.clearVisitedEdges();
        var e = this._finder.getEdge();
        e.setEdgeDepths(Te.RIGHT, t), this.copySymDepths(e), this.computeDepths(e);
      }, Ne.prototype.create = function (t) {
        this.addReachable(t), this._finder.findEdge(this._dirEdgeList), this._rightMostCoord = this._finder.getCoordinate();
      }, Ne.prototype.findResultEdges = function () {
        for (var t = this._dirEdgeList.iterator(); t.hasNext();) {
          var e = t.next();
          e.getDepth(Te.RIGHT) >= 1 && e.getDepth(Te.LEFT) <= 0 && !e.isInteriorAreaEdge() && e.setInResult(!0);
        }
      }, Ne.prototype.computeDepths = function (t) {
        var e = new Rt(),
          n = new Ie(),
          i = t.getNode();
        for (n.addLast(i), e.add(i), t.setVisited(!0); !n.isEmpty();) {
          var r = n.removeFirst();
          e.add(r), this.computeNodeDepth(r);
          for (var o = r.getEdges().iterator(); o.hasNext();) {
            var s = o.next().getSym();
            if (!s.isVisited()) {
              var a = s.getNode();
              e.contains(a) || (n.addLast(a), e.add(a));
            }
          }
        }
      }, Ne.prototype.compareTo = function (t) {
        var e = t;
        return this._rightMostCoord.x < e._rightMostCoord.x ? -1 : this._rightMostCoord.x > e._rightMostCoord.x ? 1 : 0;
      }, Ne.prototype.getEnvelope = function () {
        if (null === this._env) {
          for (var t = new X(), e = this._dirEdgeList.iterator(); e.hasNext();) for (var n = e.next().getEdge().getCoordinates(), i = 0; i < n.length - 1; i++) t.expandToInclude(n[i]);
          this._env = t;
        }
        return this._env;
      }, Ne.prototype.addReachable = function (t) {
        var e = new v();
        for (e.add(t); !e.empty();) {
          var n = e.pop();
          this.add(n, e);
        }
      }, Ne.prototype.copySymDepths = function (t) {
        var e = t.getSym();
        e.setDepth(Te.LEFT, t.getDepth(Te.RIGHT)), e.setDepth(Te.RIGHT, t.getDepth(Te.LEFT));
      }, Ne.prototype.add = function (t, e) {
        t.setVisited(!0), this._nodes.add(t);
        for (var n = t.getEdges().iterator(); n.hasNext();) {
          var i = n.next();
          this._dirEdgeList.add(i);
          var r = i.getSym().getNode();
          r.isVisited() || e.push(r);
        }
      }, Ne.prototype.getNodes = function () {
        return this._nodes;
      }, Ne.prototype.getDirectedEdges = function () {
        return this._dirEdgeList;
      }, Ne.prototype.interfaces_ = function () {
        return [b];
      }, Ne.prototype.getClass = function () {
        return Ne;
      };
      var Le = u(function t() {
        if (this.location = null, 1 === arguments.length) {
          if (arguments[0] instanceof Array) {
            var e = arguments[0];
            this.init(e.length);
          } else if (Number.isInteger(arguments[0])) {
            var n = arguments[0];
            this.init(1), this.location[Te.ON] = n;
          } else if (arguments[0] instanceof t) {
            var i = arguments[0];
            if (this.init(i.location.length), null !== i) for (var r = 0; r < this.location.length; r++) this.location[r] = i.location[r];
          }
        } else if (3 === arguments.length) {
          var o = arguments[0],
            s = arguments[1],
            a = arguments[2];
          this.init(3), this.location[Te.ON] = o, this.location[Te.LEFT] = s, this.location[Te.RIGHT] = a;
        }
      }, "t");
      Le.prototype.setAllLocations = function (t) {
        for (var e = 0; e < this.location.length; e++) this.location[e] = t;
      }, Le.prototype.isNull = function () {
        for (var t = 0; t < this.location.length; t++) if (this.location[t] !== C.NONE) return !1;
        return !0;
      }, Le.prototype.setAllLocationsIfNull = function (t) {
        for (var e = 0; e < this.location.length; e++) this.location[e] === C.NONE && (this.location[e] = t);
      }, Le.prototype.isLine = function () {
        return 1 === this.location.length;
      }, Le.prototype.merge = function (t) {
        if (t.location.length > this.location.length) {
          var e = new Array(3).fill(null);
          e[Te.ON] = this.location[Te.ON], e[Te.LEFT] = C.NONE, e[Te.RIGHT] = C.NONE, this.location = e;
        }
        for (var n = 0; n < this.location.length; n++) this.location[n] === C.NONE && n < t.location.length && (this.location[n] = t.location[n]);
      }, Le.prototype.getLocations = function () {
        return this.location;
      }, Le.prototype.flip = function () {
        if (this.location.length <= 1) return null;
        var t = this.location[Te.LEFT];
        this.location[Te.LEFT] = this.location[Te.RIGHT], this.location[Te.RIGHT] = t;
      }, Le.prototype.toString = function () {
        var t = new O();
        return this.location.length > 1 && t.append(C.toLocationSymbol(this.location[Te.LEFT])), t.append(C.toLocationSymbol(this.location[Te.ON])), this.location.length > 1 && t.append(C.toLocationSymbol(this.location[Te.RIGHT])), t.toString();
      }, Le.prototype.setLocations = function (t, e, n) {
        this.location[Te.ON] = t, this.location[Te.LEFT] = e, this.location[Te.RIGHT] = n;
      }, Le.prototype.get = function (t) {
        return t < this.location.length ? this.location[t] : C.NONE;
      }, Le.prototype.isArea = function () {
        return this.location.length > 1;
      }, Le.prototype.isAnyNull = function () {
        for (var t = 0; t < this.location.length; t++) if (this.location[t] === C.NONE) return !0;
        return !1;
      }, Le.prototype.setLocation = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.setLocation(Te.ON, t);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          this.location[e] = n;
        }
      }, Le.prototype.init = function (t) {
        this.location = new Array(t).fill(null), this.setAllLocations(C.NONE);
      }, Le.prototype.isEqualOnSide = function (t, e) {
        return this.location[e] === t.location[e];
      }, Le.prototype.allPositionsEqual = function (t) {
        for (var e = 0; e < this.location.length; e++) if (this.location[e] !== t) return !1;
        return !0;
      }, Le.prototype.interfaces_ = function () {
        return [];
      }, Le.prototype.getClass = function () {
        return Le;
      };
      var Re = u(function t() {
        if (this.elt = new Array(2).fill(null), 1 === arguments.length) {
          if (Number.isInteger(arguments[0])) {
            var e = arguments[0];
            this.elt[0] = new Le(e), this.elt[1] = new Le(e);
          } else if (arguments[0] instanceof t) {
            var n = arguments[0];
            this.elt[0] = new Le(n.elt[0]), this.elt[1] = new Le(n.elt[1]);
          }
        } else if (2 === arguments.length) {
          var i = arguments[0],
            r = arguments[1];
          this.elt[0] = new Le(C.NONE), this.elt[1] = new Le(C.NONE), this.elt[i].setLocation(r);
        } else if (3 === arguments.length) {
          var o = arguments[0],
            s = arguments[1],
            a = arguments[2];
          this.elt[0] = new Le(o, s, a), this.elt[1] = new Le(o, s, a);
        } else if (4 === arguments.length) {
          var l = arguments[0],
            u = arguments[1],
            h = arguments[2],
            c = arguments[3];
          this.elt[0] = new Le(C.NONE, C.NONE, C.NONE), this.elt[1] = new Le(C.NONE, C.NONE, C.NONE), this.elt[l].setLocations(u, h, c);
        }
      }, "t");
      Re.prototype.getGeometryCount = function () {
        var t = 0;
        return this.elt[0].isNull() || t++, this.elt[1].isNull() || t++, t;
      }, Re.prototype.setAllLocations = function (t, e) {
        this.elt[t].setAllLocations(e);
      }, Re.prototype.isNull = function (t) {
        return this.elt[t].isNull();
      }, Re.prototype.setAllLocationsIfNull = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.setAllLocationsIfNull(0, t), this.setAllLocationsIfNull(1, t);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          this.elt[e].setAllLocationsIfNull(n);
        }
      }, Re.prototype.isLine = function (t) {
        return this.elt[t].isLine();
      }, Re.prototype.merge = function (t) {
        for (var e = 0; e < 2; e++) null === this.elt[e] && null !== t.elt[e] ? this.elt[e] = new Le(t.elt[e]) : this.elt[e].merge(t.elt[e]);
      }, Re.prototype.flip = function () {
        this.elt[0].flip(), this.elt[1].flip();
      }, Re.prototype.getLocation = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return this.elt[t].get(Te.ON);
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          return this.elt[e].get(n);
        }
      }, Re.prototype.toString = function () {
        var t = new O();
        return null !== this.elt[0] && (t.append("A:"), t.append(this.elt[0].toString())), null !== this.elt[1] && (t.append(" B:"), t.append(this.elt[1].toString())), t.toString();
      }, Re.prototype.isArea = function () {
        if (0 === arguments.length) return this.elt[0].isArea() || this.elt[1].isArea();
        if (1 === arguments.length) {
          var t = arguments[0];
          return this.elt[t].isArea();
        }
      }, Re.prototype.isAnyNull = function (t) {
        return this.elt[t].isAnyNull();
      }, Re.prototype.setLocation = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          this.elt[t].setLocation(Te.ON, e);
        } else if (3 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[2];
          this.elt[n].setLocation(i, r);
        }
      }, Re.prototype.isEqualOnSide = function (t, e) {
        return this.elt[0].isEqualOnSide(t.elt[0], e) && this.elt[1].isEqualOnSide(t.elt[1], e);
      }, Re.prototype.allPositionsEqual = function (t, e) {
        return this.elt[t].allPositionsEqual(e);
      }, Re.prototype.toLine = function (t) {
        this.elt[t].isArea() && (this.elt[t] = new Le(this.elt[t].location[0]));
      }, Re.prototype.interfaces_ = function () {
        return [];
      }, Re.prototype.getClass = function () {
        return Re;
      }, Re.toLineLabel = function (t) {
        for (var e = new Re(C.NONE), n = 0; n < 2; n++) e.setLocation(n, t.getLocation(n));
        return e;
      };
      var Oe = u(function () {
        this._startDe = null, this._maxNodeDegree = -1, this._edges = new St(), this._pts = new St(), this._label = new Re(C.NONE), this._ring = null, this._isHole = null, this._shell = null, this._holes = new St(), this._geometryFactory = null;
        var t = arguments[0],
          e = arguments[1];
        this._geometryFactory = e, this.computePoints(t), this.computeRing();
      }, "De");
      Oe.prototype.computeRing = function () {
        if (null !== this._ring) return null;
        for (var t = new Array(this._pts.size()).fill(null), e = 0; e < this._pts.size(); e++) t[e] = this._pts.get(e);
        this._ring = this._geometryFactory.createLinearRing(t), this._isHole = lt.isCCW(this._ring.getCoordinates());
      }, Oe.prototype.isIsolated = function () {
        return 1 === this._label.getGeometryCount();
      }, Oe.prototype.computePoints = function (t) {
        this._startDe = t;
        var e = t,
          n = !0;
        do {
          if (null === e) throw new Ce("Found null DirectedEdge");
          if (e.getEdgeRing() === this) throw new Ce("Directed Edge visited twice during ring-building at " + e.getCoordinate());
          this._edges.add(e);
          var i = e.getLabel();
          nt.isTrue(i.isArea()), this.mergeLabel(i), this.addPoints(e.getEdge(), e.isForward(), n), n = !1, this.setEdgeRing(e, this), e = this.getNext(e);
        } while (e !== this._startDe);
      }, Oe.prototype.getLinearRing = function () {
        return this._ring;
      }, Oe.prototype.getCoordinate = function (t) {
        return this._pts.get(t);
      }, Oe.prototype.computeMaxNodeDegree = function () {
        this._maxNodeDegree = 0;
        var t = this._startDe;
        do {
          var e = t.getNode().getEdges().getOutgoingDegree(this);
          e > this._maxNodeDegree && (this._maxNodeDegree = e), t = this.getNext(t);
        } while (t !== this._startDe);
        this._maxNodeDegree *= 2;
      }, Oe.prototype.addPoints = function (t, e, n) {
        var i = t.getCoordinates();
        if (e) {
          var r = 1;
          n && (r = 0);
          for (var o = r; o < i.length; o++) this._pts.add(i[o]);
        } else {
          var s = i.length - 2;
          n && (s = i.length - 1);
          for (var a = s; a >= 0; a--) this._pts.add(i[a]);
        }
      }, Oe.prototype.isHole = function () {
        return this._isHole;
      }, Oe.prototype.setInResult = function () {
        var t = this._startDe;
        do {
          t.getEdge().setInResult(!0), t = t.getNext();
        } while (t !== this._startDe);
      }, Oe.prototype.containsPoint = function (t) {
        var e = this.getLinearRing();
        if (!e.getEnvelopeInternal().contains(t) || !lt.isPointInRing(t, e.getCoordinates())) return !1;
        for (var n = this._holes.iterator(); n.hasNext();) if (n.next().containsPoint(t)) return !1;
        return !0;
      }, Oe.prototype.addHole = function (t) {
        this._holes.add(t);
      }, Oe.prototype.isShell = function () {
        return null === this._shell;
      }, Oe.prototype.getLabel = function () {
        return this._label;
      }, Oe.prototype.getEdges = function () {
        return this._edges;
      }, Oe.prototype.getMaxNodeDegree = function () {
        return this._maxNodeDegree < 0 && this.computeMaxNodeDegree(), this._maxNodeDegree;
      }, Oe.prototype.getShell = function () {
        return this._shell;
      }, Oe.prototype.mergeLabel = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.mergeLabel(t, 0), this.mergeLabel(t, 1);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1],
            i = e.getLocation(n, Te.RIGHT);
          if (i === C.NONE) return null;
          if (this._label.getLocation(n) === C.NONE) return this._label.setLocation(n, i), null;
        }
      }, Oe.prototype.setShell = function (t) {
        this._shell = t, null !== t && t.addHole(this);
      }, Oe.prototype.toPolygon = function (t) {
        for (var e = new Array(this._holes.size()).fill(null), n = 0; n < this._holes.size(); n++) e[n] = this._holes.get(n).getLinearRing();
        return t.createPolygon(this.getLinearRing(), e);
      }, Oe.prototype.interfaces_ = function () {
        return [];
      }, Oe.prototype.getClass = function () {
        return Oe;
      };
      var qe = function (t) {
          function e() {
            var e = arguments[0],
              n = arguments[1];
            t.call(this, e, n);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setEdgeRing = function (t, e) {
            t.setMinEdgeRing(e);
          }, e.prototype.getNext = function (t) {
            return t.getNextMin();
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(Oe),
        De = function (t) {
          function e() {
            var e = arguments[0],
              n = arguments[1];
            t.call(this, e, n);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.buildMinimalRings = function () {
            var t = new St(),
              e = this._startDe;
            do {
              if (null === e.getMinEdgeRing()) {
                var n = new qe(e, this._geometryFactory);
                t.add(n);
              }
              e = e.getNext();
            } while (e !== this._startDe);
            return t;
          }, e.prototype.setEdgeRing = function (t, e) {
            t.setEdgeRing(e);
          }, e.prototype.linkDirectedEdgesForMinimalEdgeRings = function () {
            var t = this._startDe;
            do {
              t.getNode().getEdges().linkMinimalDirectedEdges(this), t = t.getNext();
            } while (t !== this._startDe);
          }, e.prototype.getNext = function (t) {
            return t.getNext();
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(Oe),
        ke = u(function () {
          if (this._label = null, this._isInResult = !1, this._isCovered = !1, this._isCoveredSet = !1, this._isVisited = !1, 0 !== arguments.length && 1 === arguments.length) {
            var t = arguments[0];
            this._label = t;
          }
        }, "Fe");
      ke.prototype.setVisited = function (t) {
        this._isVisited = t;
      }, ke.prototype.setInResult = function (t) {
        this._isInResult = t;
      }, ke.prototype.isCovered = function () {
        return this._isCovered;
      }, ke.prototype.isCoveredSet = function () {
        return this._isCoveredSet;
      }, ke.prototype.setLabel = function (t) {
        this._label = t;
      }, ke.prototype.getLabel = function () {
        return this._label;
      }, ke.prototype.setCovered = function (t) {
        this._isCovered = t, this._isCoveredSet = !0;
      }, ke.prototype.updateIM = function (t) {
        nt.isTrue(this._label.getGeometryCount() >= 2, "found partial label"), this.computeIM(t);
      }, ke.prototype.isInResult = function () {
        return this._isInResult;
      }, ke.prototype.isVisited = function () {
        return this._isVisited;
      }, ke.prototype.interfaces_ = function () {
        return [];
      }, ke.prototype.getClass = function () {
        return ke;
      };
      var Fe = function (t) {
          function e() {
            t.call(this), this._coord = null, this._edges = null;
            var e = arguments[0],
              n = arguments[1];
            this._coord = e, this._edges = n, this._label = new Re(0, C.NONE);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isIncidentEdgeInResult = function () {
            for (var t = this.getEdges().getEdges().iterator(); t.hasNext();) if (t.next().getEdge().isInResult()) return !0;
            return !1;
          }, e.prototype.isIsolated = function () {
            return 1 === this._label.getGeometryCount();
          }, e.prototype.getCoordinate = function () {
            return this._coord;
          }, e.prototype.print = function (t) {
            t.println("node " + this._coord + " lbl: " + this._label);
          }, e.prototype.computeIM = function (t) {}, e.prototype.computeMergedLocation = function (t, e) {
            var n = C.NONE;
            if (n = this._label.getLocation(e), !t.isNull(e)) {
              var i = t.getLocation(e);
              n !== C.BOUNDARY && (n = i);
            }
            return n;
          }, e.prototype.setLabel = function () {
            if (2 !== arguments.length) return t.prototype.setLabel.apply(this, arguments);
            var e = arguments[0],
              n = arguments[1];
            null === this._label ? this._label = new Re(e, n) : this._label.setLocation(e, n);
          }, e.prototype.getEdges = function () {
            return this._edges;
          }, e.prototype.mergeLabel = function () {
            if (arguments[0] instanceof e) {
              var t = arguments[0];
              this.mergeLabel(t._label);
            } else if (arguments[0] instanceof Re) for (var n = arguments[0], i = 0; i < 2; i++) {
              var r = this.computeMergedLocation(n, i);
              this._label.getLocation(i) === C.NONE && this._label.setLocation(i, r);
            }
          }, e.prototype.add = function (t) {
            this._edges.insert(t), t.setNode(this);
          }, e.prototype.setLabelBoundary = function (t) {
            if (null === this._label) return null;
            var e = C.NONE;
            null !== this._label && (e = this._label.getLocation(t));
            var n = null;
            switch (e) {
              case C.BOUNDARY:
                n = C.INTERIOR;
                break;
              case C.INTERIOR:
              default:
                n = C.BOUNDARY;
            }
            this._label.setLocation(t, n);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(ke),
        Ue = u(function () {
          this.nodeMap = new p(), this.nodeFact = null;
          var t = arguments[0];
          this.nodeFact = t;
        }, "qe");
      Ue.prototype.find = function (t) {
        return this.nodeMap.get(t);
      }, Ue.prototype.addNode = function () {
        if (arguments[0] instanceof M) {
          var t = arguments[0],
            e = this.nodeMap.get(t);
          return null === e && (e = this.nodeFact.createNode(t), this.nodeMap.put(t, e)), e;
        }
        if (arguments[0] instanceof Fe) {
          var n = arguments[0],
            i = this.nodeMap.get(n.getCoordinate());
          return null === i ? (this.nodeMap.put(n.getCoordinate(), n), n) : (i.mergeLabel(n), i);
        }
      }, Ue.prototype.print = function (t) {
        for (var e = this.iterator(); e.hasNext();) e.next().print(t);
      }, Ue.prototype.iterator = function () {
        return this.nodeMap.values().iterator();
      }, Ue.prototype.values = function () {
        return this.nodeMap.values();
      }, Ue.prototype.getBoundaryNodes = function (t) {
        for (var e = new St(), n = this.iterator(); n.hasNext();) {
          var i = n.next();
          i.getLabel().getLocation(t) === C.BOUNDARY && e.add(i);
        }
        return e;
      }, Ue.prototype.add = function (t) {
        var e = t.getCoordinate();
        this.addNode(e).add(t);
      }, Ue.prototype.interfaces_ = function () {
        return [];
      }, Ue.prototype.getClass = function () {
        return Ue;
      };
      var Be = u(function () {}, "Be"),
        ze = {
          NE: {
            configurable: !0
          },
          NW: {
            configurable: !0
          },
          SW: {
            configurable: !0
          },
          SE: {
            configurable: !0
          }
        };
      Be.prototype.interfaces_ = function () {
        return [];
      }, Be.prototype.getClass = function () {
        return Be;
      }, Be.isNorthern = function (t) {
        return t === Be.NE || t === Be.NW;
      }, Be.isOpposite = function (t, e) {
        return t !== e && (t - e + 4) % 4 == 2;
      }, Be.commonHalfPlane = function (t, e) {
        if (t === e) return t;
        if ((t - e + 4) % 4 == 2) return -1;
        var n = t < e ? t : e;
        return 0 === n && 3 === (t > e ? t : e) ? 3 : n;
      }, Be.isInHalfPlane = function (t, e) {
        return e === Be.SE ? t === Be.SE || t === Be.SW : t === e || t === e + 1;
      }, Be.quadrant = function () {
        if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
          var t = arguments[0],
            e = arguments[1];
          if (0 === t && 0 === e) throw new _("Cannot compute the quadrant for point ( " + t + ", " + e + " )");
          return t >= 0 ? e >= 0 ? Be.NE : Be.SE : e >= 0 ? Be.NW : Be.SW;
        }
        if (arguments[0] instanceof M && arguments[1] instanceof M) {
          var n = arguments[0],
            i = arguments[1];
          if (i.x === n.x && i.y === n.y) throw new _("Cannot compute the quadrant for two identical points " + n);
          return i.x >= n.x ? i.y >= n.y ? Be.NE : Be.SE : i.y >= n.y ? Be.NW : Be.SW;
        }
      }, ze.NE.get = function () {
        return 0;
      }, ze.NW.get = function () {
        return 1;
      }, ze.SW.get = function () {
        return 2;
      }, ze.SE.get = function () {
        return 3;
      }, Object.defineProperties(Be, ze);
      var Ve = u(function () {
        if (this._edge = null, this._label = null, this._node = null, this._p0 = null, this._p1 = null, this._dx = null, this._dy = null, this._quadrant = null, 1 === arguments.length) {
          var t = arguments[0];
          this._edge = t;
        } else if (3 === arguments.length) {
          var e = arguments[0],
            n = arguments[1],
            i = arguments[2];
          this._edge = e, this.init(n, i), this._label = null;
        } else if (4 === arguments.length) {
          var r = arguments[0],
            o = arguments[1],
            s = arguments[2],
            a = arguments[3];
          this._edge = r, this.init(o, s), this._label = a;
        }
      }, "Ue");
      Ve.prototype.compareDirection = function (t) {
        return this._dx === t._dx && this._dy === t._dy ? 0 : this._quadrant > t._quadrant ? 1 : this._quadrant < t._quadrant ? -1 : lt.computeOrientation(t._p0, t._p1, this._p1);
      }, Ve.prototype.getDy = function () {
        return this._dy;
      }, Ve.prototype.getCoordinate = function () {
        return this._p0;
      }, Ve.prototype.setNode = function (t) {
        this._node = t;
      }, Ve.prototype.print = function (t) {
        var e = Math.atan2(this._dy, this._dx),
          n = this.getClass().getName(),
          i = n.lastIndexOf("."),
          r = n.substring(i + 1);
        t.print("  " + r + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + e + "   " + this._label);
      }, Ve.prototype.compareTo = function (t) {
        var e = t;
        return this.compareDirection(e);
      }, Ve.prototype.getDirectedCoordinate = function () {
        return this._p1;
      }, Ve.prototype.getDx = function () {
        return this._dx;
      }, Ve.prototype.getLabel = function () {
        return this._label;
      }, Ve.prototype.getEdge = function () {
        return this._edge;
      }, Ve.prototype.getQuadrant = function () {
        return this._quadrant;
      }, Ve.prototype.getNode = function () {
        return this._node;
      }, Ve.prototype.toString = function () {
        var t = Math.atan2(this._dy, this._dx),
          e = this.getClass().getName(),
          n = e.lastIndexOf(".");
        return "  " + e.substring(n + 1) + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + t + "   " + this._label;
      }, Ve.prototype.computeLabel = function (t) {}, Ve.prototype.init = function (t, e) {
        this._p0 = t, this._p1 = e, this._dx = e.x - t.x, this._dy = e.y - t.y, this._quadrant = Be.quadrant(this._dx, this._dy), nt.isTrue(!(0 === this._dx && 0 === this._dy), "EdgeEnd with identical endpoints found");
      }, Ve.prototype.interfaces_ = function () {
        return [b];
      }, Ve.prototype.getClass = function () {
        return Ve;
      };
      var je = function (t) {
          function e() {
            var e = arguments[0],
              n = arguments[1];
            if (t.call(this, e), this._isForward = null, this._isInResult = !1, this._isVisited = !1, this._sym = null, this._next = null, this._nextMin = null, this._edgeRing = null, this._minEdgeRing = null, this._depth = [0, -999, -999], this._isForward = n, n) this.init(e.getCoordinate(0), e.getCoordinate(1));else {
              var i = e.getNumPoints() - 1;
              this.init(e.getCoordinate(i), e.getCoordinate(i - 1));
            }
            this.computeDirectedLabel();
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getNextMin = function () {
            return this._nextMin;
          }, e.prototype.getDepth = function (t) {
            return this._depth[t];
          }, e.prototype.setVisited = function (t) {
            this._isVisited = t;
          }, e.prototype.computeDirectedLabel = function () {
            this._label = new Re(this._edge.getLabel()), this._isForward || this._label.flip();
          }, e.prototype.getNext = function () {
            return this._next;
          }, e.prototype.setDepth = function (t, e) {
            if (-999 !== this._depth[t] && this._depth[t] !== e) throw new Ce("assigned depths do not match", this.getCoordinate());
            this._depth[t] = e;
          }, e.prototype.isInteriorAreaEdge = function () {
            for (var t = !0, e = 0; e < 2; e++) this._label.isArea(e) && this._label.getLocation(e, Te.LEFT) === C.INTERIOR && this._label.getLocation(e, Te.RIGHT) === C.INTERIOR || (t = !1);
            return t;
          }, e.prototype.setNextMin = function (t) {
            this._nextMin = t;
          }, e.prototype.print = function (e) {
            t.prototype.print.call(this, e), e.print(" " + this._depth[Te.LEFT] + "/" + this._depth[Te.RIGHT]), e.print(" (" + this.getDepthDelta() + ")"), this._isInResult && e.print(" inResult");
          }, e.prototype.setMinEdgeRing = function (t) {
            this._minEdgeRing = t;
          }, e.prototype.isLineEdge = function () {
            var t = this._label.isLine(0) || this._label.isLine(1),
              e = !this._label.isArea(0) || this._label.allPositionsEqual(0, C.EXTERIOR),
              n = !this._label.isArea(1) || this._label.allPositionsEqual(1, C.EXTERIOR);
            return t && e && n;
          }, e.prototype.setEdgeRing = function (t) {
            this._edgeRing = t;
          }, e.prototype.getMinEdgeRing = function () {
            return this._minEdgeRing;
          }, e.prototype.getDepthDelta = function () {
            var t = this._edge.getDepthDelta();
            return this._isForward || (t = -t), t;
          }, e.prototype.setInResult = function (t) {
            this._isInResult = t;
          }, e.prototype.getSym = function () {
            return this._sym;
          }, e.prototype.isForward = function () {
            return this._isForward;
          }, e.prototype.getEdge = function () {
            return this._edge;
          }, e.prototype.printEdge = function (t) {
            this.print(t), t.print(" "), this._isForward ? this._edge.print(t) : this._edge.printReverse(t);
          }, e.prototype.setSym = function (t) {
            this._sym = t;
          }, e.prototype.setVisitedEdge = function (t) {
            this.setVisited(t), this._sym.setVisited(t);
          }, e.prototype.setEdgeDepths = function (t, e) {
            var n = this.getEdge().getDepthDelta();
            this._isForward || (n = -n);
            var i = 1;
            t === Te.LEFT && (i = -1);
            var r = Te.opposite(t),
              o = e + n * i;
            this.setDepth(t, e), this.setDepth(r, o);
          }, e.prototype.getEdgeRing = function () {
            return this._edgeRing;
          }, e.prototype.isInResult = function () {
            return this._isInResult;
          }, e.prototype.setNext = function (t) {
            this._next = t;
          }, e.prototype.isVisited = function () {
            return this._isVisited;
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e.depthFactor = function (t, e) {
            return t === C.EXTERIOR && e === C.INTERIOR ? 1 : t === C.INTERIOR && e === C.EXTERIOR ? -1 : 0;
          }, e;
        }(Ve),
        Ge = u(function () {}, "Xe");
      Ge.prototype.createNode = function (t) {
        return new Fe(t, null);
      }, Ge.prototype.interfaces_ = function () {
        return [];
      }, Ge.prototype.getClass = function () {
        return Ge;
      };
      var We = u(function () {
        if (this._edges = new St(), this._nodes = null, this._edgeEndList = new St(), 0 === arguments.length) this._nodes = new Ue(new Ge());else if (1 === arguments.length) {
          var t = arguments[0];
          this._nodes = new Ue(t);
        }
      }, "Ye");
      We.prototype.printEdges = function (t) {
        t.println("Edges:");
        for (var e = 0; e < this._edges.size(); e++) {
          t.println("edge " + e + ":");
          var n = this._edges.get(e);
          n.print(t), n.eiList.print(t);
        }
      }, We.prototype.find = function (t) {
        return this._nodes.find(t);
      }, We.prototype.addNode = function () {
        if (arguments[0] instanceof Fe) {
          var t = arguments[0];
          return this._nodes.addNode(t);
        }
        if (arguments[0] instanceof M) {
          var e = arguments[0];
          return this._nodes.addNode(e);
        }
      }, We.prototype.getNodeIterator = function () {
        return this._nodes.iterator();
      }, We.prototype.linkResultDirectedEdges = function () {
        for (var t = this._nodes.iterator(); t.hasNext();) t.next().getEdges().linkResultDirectedEdges();
      }, We.prototype.debugPrintln = function (t) {
        W.out.println(t);
      }, We.prototype.isBoundaryNode = function (t, e) {
        var n = this._nodes.find(e);
        if (null === n) return !1;
        var i = n.getLabel();
        return null !== i && i.getLocation(t) === C.BOUNDARY;
      }, We.prototype.linkAllDirectedEdges = function () {
        for (var t = this._nodes.iterator(); t.hasNext();) t.next().getEdges().linkAllDirectedEdges();
      }, We.prototype.matchInSameDirection = function (t, e, n, i) {
        return !!t.equals(n) && lt.computeOrientation(t, e, i) === lt.COLLINEAR && Be.quadrant(t, e) === Be.quadrant(n, i);
      }, We.prototype.getEdgeEnds = function () {
        return this._edgeEndList;
      }, We.prototype.debugPrint = function (t) {
        W.out.print(t);
      }, We.prototype.getEdgeIterator = function () {
        return this._edges.iterator();
      }, We.prototype.findEdgeInSameDirection = function (t, e) {
        for (var n = 0; n < this._edges.size(); n++) {
          var i = this._edges.get(n),
            r = i.getCoordinates();
          if (this.matchInSameDirection(t, e, r[0], r[1]) || this.matchInSameDirection(t, e, r[r.length - 1], r[r.length - 2])) return i;
        }
        return null;
      }, We.prototype.insertEdge = function (t) {
        this._edges.add(t);
      }, We.prototype.findEdgeEnd = function (t) {
        for (var e = this.getEdgeEnds().iterator(); e.hasNext();) {
          var n = e.next();
          if (n.getEdge() === t) return n;
        }
        return null;
      }, We.prototype.addEdges = function (t) {
        for (var e = t.iterator(); e.hasNext();) {
          var n = e.next();
          this._edges.add(n);
          var i = new je(n, !0),
            r = new je(n, !1);
          i.setSym(r), r.setSym(i), this.add(i), this.add(r);
        }
      }, We.prototype.add = function (t) {
        this._nodes.add(t), this._edgeEndList.add(t);
      }, We.prototype.getNodes = function () {
        return this._nodes.values();
      }, We.prototype.findEdge = function (t, e) {
        for (var n = 0; n < this._edges.size(); n++) {
          var i = this._edges.get(n),
            r = i.getCoordinates();
          if (t.equals(r[0]) && e.equals(r[1])) return i;
        }
        return null;
      }, We.prototype.interfaces_ = function () {
        return [];
      }, We.prototype.getClass = function () {
        return We;
      }, We.linkResultDirectedEdges = function (t) {
        for (var e = t.iterator(); e.hasNext();) e.next().getEdges().linkResultDirectedEdges();
      };
      var He = u(function () {
        this._geometryFactory = null, this._shellList = new St();
        var t = arguments[0];
        this._geometryFactory = t;
      }, "ke");
      He.prototype.sortShellsAndHoles = function (t, e, n) {
        for (var i = t.iterator(); i.hasNext();) {
          var r = i.next();
          r.isHole() ? n.add(r) : e.add(r);
        }
      }, He.prototype.computePolygons = function (t) {
        for (var e = new St(), n = t.iterator(); n.hasNext();) {
          var i = n.next().toPolygon(this._geometryFactory);
          e.add(i);
        }
        return e;
      }, He.prototype.placeFreeHoles = function (t, e) {
        for (var n = e.iterator(); n.hasNext();) {
          var i = n.next();
          if (null === i.getShell()) {
            var r = this.findEdgeRingContaining(i, t);
            if (null === r) throw new Ce("unable to assign hole to a shell", i.getCoordinate(0));
            i.setShell(r);
          }
        }
      }, He.prototype.buildMinimalEdgeRings = function (t, e, n) {
        for (var i = new St(), r = t.iterator(); r.hasNext();) {
          var o = r.next();
          if (o.getMaxNodeDegree() > 2) {
            o.linkDirectedEdgesForMinimalEdgeRings();
            var s = o.buildMinimalRings(),
              a = this.findShell(s);
            null !== a ? (this.placePolygonHoles(a, s), e.add(a)) : n.addAll(s);
          } else i.add(o);
        }
        return i;
      }, He.prototype.containsPoint = function (t) {
        for (var e = this._shellList.iterator(); e.hasNext();) if (e.next().containsPoint(t)) return !0;
        return !1;
      }, He.prototype.buildMaximalEdgeRings = function (t) {
        for (var e = new St(), n = t.iterator(); n.hasNext();) {
          var i = n.next();
          if (i.isInResult() && i.getLabel().isArea() && null === i.getEdgeRing()) {
            var r = new De(i, this._geometryFactory);
            e.add(r), r.setInResult();
          }
        }
        return e;
      }, He.prototype.placePolygonHoles = function (t, e) {
        for (var n = e.iterator(); n.hasNext();) {
          var i = n.next();
          i.isHole() && i.setShell(t);
        }
      }, He.prototype.getPolygons = function () {
        return this.computePolygons(this._shellList);
      }, He.prototype.findEdgeRingContaining = function (t, e) {
        for (var n = t.getLinearRing(), i = n.getEnvelopeInternal(), r = n.getCoordinateN(0), o = null, s = null, a = e.iterator(); a.hasNext();) {
          var l = a.next(),
            u = l.getLinearRing(),
            h = u.getEnvelopeInternal();
          null !== o && (s = o.getLinearRing().getEnvelopeInternal());
          var c = !1;
          h.contains(i) && lt.isPointInRing(r, u.getCoordinates()) && (c = !0), c && (null === o || s.contains(h)) && (o = l);
        }
        return o;
      }, He.prototype.findShell = function (t) {
        for (var e = 0, n = null, i = t.iterator(); i.hasNext();) {
          var r = i.next();
          r.isHole() || (n = r, e++);
        }
        return nt.isTrue(e <= 1, "found two shells in MinimalEdgeRing list"), n;
      }, He.prototype.add = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.add(t.getEdgeEnds(), t.getNodes());
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          We.linkResultDirectedEdges(n);
          var i = this.buildMaximalEdgeRings(e),
            r = new St(),
            o = this.buildMinimalEdgeRings(i, this._shellList, r);
          this.sortShellsAndHoles(o, this._shellList, r), this.placeFreeHoles(this._shellList, r);
        }
      }, He.prototype.interfaces_ = function () {
        return [];
      }, He.prototype.getClass = function () {
        return He;
      };
      var Xe = u(function () {}, "je");
      Xe.prototype.getBounds = function () {}, Xe.prototype.interfaces_ = function () {
        return [];
      }, Xe.prototype.getClass = function () {
        return Xe;
      };
      var Ye = u(function () {
        this._bounds = null, this._item = null;
        var t = arguments[0],
          e = arguments[1];
        this._bounds = t, this._item = e;
      }, "He");
      Ye.prototype.getItem = function () {
        return this._item;
      }, Ye.prototype.getBounds = function () {
        return this._bounds;
      }, Ye.prototype.interfaces_ = function () {
        return [Xe, e];
      }, Ye.prototype.getClass = function () {
        return Ye;
      };
      var Ze = u(function () {
        this._size = null, this._items = null, this._size = 0, this._items = new St(), this._items.add(null);
      }, "We");
      Ze.prototype.poll = function () {
        if (this.isEmpty()) return null;
        var t = this._items.get(1);
        return this._items.set(1, this._items.get(this._size)), this._size -= 1, this.reorder(1), t;
      }, Ze.prototype.size = function () {
        return this._size;
      }, Ze.prototype.reorder = function (t) {
        for (var e = null, n = this._items.get(t); 2 * t <= this._size && ((e = 2 * t) !== this._size && this._items.get(e + 1).compareTo(this._items.get(e)) < 0 && e++, this._items.get(e).compareTo(n) < 0); t = e) this._items.set(t, this._items.get(e));
        this._items.set(t, n);
      }, Ze.prototype.clear = function () {
        this._size = 0, this._items.clear();
      }, Ze.prototype.isEmpty = function () {
        return 0 === this._size;
      }, Ze.prototype.add = function (t) {
        this._items.add(null), this._size += 1;
        var e = this._size;
        for (this._items.set(0, t); t.compareTo(this._items.get(Math.trunc(e / 2))) < 0; e /= 2) this._items.set(e, this._items.get(Math.trunc(e / 2)));
        this._items.set(e, t);
      }, Ze.prototype.interfaces_ = function () {
        return [];
      }, Ze.prototype.getClass = function () {
        return Ze;
      };
      var Je = u(function () {}, "Ke");
      Je.prototype.visitItem = function (t) {}, Je.prototype.interfaces_ = function () {
        return [];
      }, Je.prototype.getClass = function () {
        return Je;
      };
      var Ke = u(function () {}, "Je");
      Ke.prototype.insert = function (t, e) {}, Ke.prototype.remove = function (t, e) {}, Ke.prototype.query = function () {}, Ke.prototype.interfaces_ = function () {
        return [];
      }, Ke.prototype.getClass = function () {
        return Ke;
      };
      var Qe = u(function () {
          if (this._childBoundables = new St(), this._bounds = null, this._level = null, 0 !== arguments.length && 1 === arguments.length) {
            var t = arguments[0];
            this._level = t;
          }
        }, "Qe"),
        $e = {
          serialVersionUID: {
            configurable: !0
          }
        };
      Qe.prototype.getLevel = function () {
        return this._level;
      }, Qe.prototype.size = function () {
        return this._childBoundables.size();
      }, Qe.prototype.getChildBoundables = function () {
        return this._childBoundables;
      }, Qe.prototype.addChildBoundable = function (t) {
        nt.isTrue(null === this._bounds), this._childBoundables.add(t);
      }, Qe.prototype.isEmpty = function () {
        return this._childBoundables.isEmpty();
      }, Qe.prototype.getBounds = function () {
        return null === this._bounds && (this._bounds = this.computeBounds()), this._bounds;
      }, Qe.prototype.interfaces_ = function () {
        return [Xe, e];
      }, Qe.prototype.getClass = function () {
        return Qe;
      }, $e.serialVersionUID.get = function () {
        return 0x5a1e55ec41369800;
      }, Object.defineProperties(Qe, $e);
      var tn = u(function () {}, "$e");
      tn.reverseOrder = function () {
        return {
          compare: function (t, e) {
            return e.compareTo(t);
          }
        };
      }, tn.min = function (t) {
        return tn.sort(t), t.get(0);
      }, tn.sort = function (t, e) {
        var n = t.toArray();
        e ? Ft.sort(n, e) : Ft.sort(n);
        for (var i = t.iterator(), r = 0, o = n.length; r < o; r++) i.next(), i.set(n[r]);
      }, tn.singletonList = function (t) {
        var e = new St();
        return e.add(t), e;
      };
      var en = u(function () {
        this._boundable1 = null, this._boundable2 = null, this._distance = null, this._itemDistance = null;
        var t = arguments[0],
          e = arguments[1],
          n = arguments[2];
        this._boundable1 = t, this._boundable2 = e, this._itemDistance = n, this._distance = this.distance();
      }, "tn");
      en.prototype.expandToQueue = function (t, e) {
        var n = en.isComposite(this._boundable1),
          i = en.isComposite(this._boundable2);
        if (n && i) return en.area(this._boundable1) > en.area(this._boundable2) ? (this.expand(this._boundable1, this._boundable2, t, e), null) : (this.expand(this._boundable2, this._boundable1, t, e), null);
        if (n) return this.expand(this._boundable1, this._boundable2, t, e), null;
        if (i) return this.expand(this._boundable2, this._boundable1, t, e), null;
        throw new _("neither boundable is composite");
      }, en.prototype.isLeaves = function () {
        return !(en.isComposite(this._boundable1) || en.isComposite(this._boundable2));
      }, en.prototype.compareTo = function (t) {
        var e = t;
        return this._distance < e._distance ? -1 : this._distance > e._distance ? 1 : 0;
      }, en.prototype.expand = function (t, e, n, i) {
        for (var r = t.getChildBoundables().iterator(); r.hasNext();) {
          var o = r.next(),
            s = new en(o, e, this._itemDistance);
          s.getDistance() < i && n.add(s);
        }
      }, en.prototype.getBoundable = function (t) {
        return 0 === t ? this._boundable1 : this._boundable2;
      }, en.prototype.getDistance = function () {
        return this._distance;
      }, en.prototype.distance = function () {
        return this.isLeaves() ? this._itemDistance.distance(this._boundable1, this._boundable2) : this._boundable1.getBounds().distance(this._boundable2.getBounds());
      }, en.prototype.interfaces_ = function () {
        return [b];
      }, en.prototype.getClass = function () {
        return en;
      }, en.area = function (t) {
        return t.getBounds().getArea();
      }, en.isComposite = function (t) {
        return t instanceof Qe;
      };
      var nn = u(function t() {
          if (this._root = null, this._built = !1, this._itemBoundables = new St(), this._nodeCapacity = null, 0 === arguments.length) {
            var e = t.DEFAULT_NODE_CAPACITY;
            this._nodeCapacity = e;
          } else if (1 === arguments.length) {
            var n = arguments[0];
            nt.isTrue(n > 1, "Node capacity must be greater than 1"), this._nodeCapacity = n;
          }
        }, "t"),
        rn = {
          IntersectsOp: {
            configurable: !0
          },
          serialVersionUID: {
            configurable: !0
          },
          DEFAULT_NODE_CAPACITY: {
            configurable: !0
          }
        };
      nn.prototype.getNodeCapacity = function () {
        return this._nodeCapacity;
      }, nn.prototype.lastNode = function (t) {
        return t.get(t.size() - 1);
      }, nn.prototype.size = function () {
        if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.size(this._root));
        if (1 === arguments.length) {
          for (var t = 0, e = arguments[0].getChildBoundables().iterator(); e.hasNext();) {
            var n = e.next();
            n instanceof Qe ? t += this.size(n) : n instanceof Ye && (t += 1);
          }
          return t;
        }
      }, nn.prototype.removeItem = function (t, e) {
        for (var n = null, i = t.getChildBoundables().iterator(); i.hasNext();) {
          var r = i.next();
          r instanceof Ye && r.getItem() === e && (n = r);
        }
        return null !== n && (t.getChildBoundables().remove(n), !0);
      }, nn.prototype.itemsTree = function () {
        if (0 === arguments.length) {
          this.build();
          var t = this.itemsTree(this._root);
          return null === t ? new St() : t;
        }
        if (1 === arguments.length) {
          for (var e = arguments[0], n = new St(), i = e.getChildBoundables().iterator(); i.hasNext();) {
            var r = i.next();
            if (r instanceof Qe) {
              var o = this.itemsTree(r);
              null !== o && n.add(o);
            } else r instanceof Ye ? n.add(r.getItem()) : nt.shouldNeverReachHere();
          }
          return n.size() <= 0 ? null : n;
        }
      }, nn.prototype.insert = function (t, e) {
        nt.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built."), this._itemBoundables.add(new Ye(t, e));
      }, nn.prototype.boundablesAtLevel = function () {
        if (1 === arguments.length) {
          var t = arguments[0],
            e = new St();
          return this.boundablesAtLevel(t, this._root, e), e;
        }
        if (3 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[2];
          if (nt.isTrue(n > -2), i.getLevel() === n) return r.add(i), null;
          for (var o = i.getChildBoundables().iterator(); o.hasNext();) {
            var s = o.next();
            s instanceof Qe ? this.boundablesAtLevel(n, s, r) : (nt.isTrue(s instanceof Ye), -1 === n && r.add(s));
          }
          return null;
        }
      }, nn.prototype.query = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.build();
          var e = new St();
          return this.isEmpty() || this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.query(t, this._root, e), e;
        }
        if (2 === arguments.length) {
          var n = arguments[0],
            i = arguments[1];
          if (this.build(), this.isEmpty()) return null;
          this.getIntersectsOp().intersects(this._root.getBounds(), n) && this.query(n, this._root, i);
        } else if (3 === arguments.length) if (N(arguments[2], Je) && arguments[0] instanceof Object && arguments[1] instanceof Qe) for (var r = arguments[0], o = arguments[1], s = arguments[2], a = o.getChildBoundables(), l = 0; l < a.size(); l++) {
          var u = a.get(l);
          this.getIntersectsOp().intersects(u.getBounds(), r) && (u instanceof Qe ? this.query(r, u, s) : u instanceof Ye ? s.visitItem(u.getItem()) : nt.shouldNeverReachHere());
        } else if (N(arguments[2], wt) && arguments[0] instanceof Object && arguments[1] instanceof Qe) for (var h = arguments[0], c = arguments[1], p = arguments[2], d = c.getChildBoundables(), f = 0; f < d.size(); f++) {
          var m = d.get(f);
          this.getIntersectsOp().intersects(m.getBounds(), h) && (m instanceof Qe ? this.query(h, m, p) : m instanceof Ye ? p.add(m.getItem()) : nt.shouldNeverReachHere());
        }
      }, nn.prototype.build = function () {
        if (this._built) return null;
        this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1), this._itemBoundables = null, this._built = !0;
      }, nn.prototype.getRoot = function () {
        return this.build(), this._root;
      }, nn.prototype.remove = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          return this.build(), !!this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.remove(t, this._root, e);
        }
        if (3 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[2],
            o = this.removeItem(i, r);
          if (o) return !0;
          for (var s = null, a = i.getChildBoundables().iterator(); a.hasNext();) {
            var l = a.next();
            if (this.getIntersectsOp().intersects(l.getBounds(), n) && l instanceof Qe && (o = this.remove(n, l, r))) {
              s = l;
              break;
            }
          }
          return null !== s && s.getChildBoundables().isEmpty() && i.getChildBoundables().remove(s), o;
        }
      }, nn.prototype.createHigherLevels = function (t, e) {
        nt.isTrue(!t.isEmpty());
        var n = this.createParentBoundables(t, e + 1);
        return 1 === n.size() ? n.get(0) : this.createHigherLevels(n, e + 1);
      }, nn.prototype.depth = function () {
        if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.depth(this._root));
        if (1 === arguments.length) {
          for (var t = 0, e = arguments[0].getChildBoundables().iterator(); e.hasNext();) {
            var n = e.next();
            if (n instanceof Qe) {
              var i = this.depth(n);
              i > t && (t = i);
            }
          }
          return t + 1;
        }
      }, nn.prototype.createParentBoundables = function (t, e) {
        nt.isTrue(!t.isEmpty());
        var n = new St();
        n.add(this.createNode(e));
        var i = new St(t);
        tn.sort(i, this.getComparator());
        for (var r = i.iterator(); r.hasNext();) {
          var o = r.next();
          this.lastNode(n).getChildBoundables().size() === this.getNodeCapacity() && n.add(this.createNode(e)), this.lastNode(n).addChildBoundable(o);
        }
        return n;
      }, nn.prototype.isEmpty = function () {
        return this._built ? this._root.isEmpty() : this._itemBoundables.isEmpty();
      }, nn.prototype.interfaces_ = function () {
        return [e];
      }, nn.prototype.getClass = function () {
        return nn;
      }, nn.compareDoubles = function (t, e) {
        return t > e ? 1 : t < e ? -1 : 0;
      }, rn.IntersectsOp.get = function () {
        return on;
      }, rn.serialVersionUID.get = function () {
        return -0x35ef64c82d4c5400;
      }, rn.DEFAULT_NODE_CAPACITY.get = function () {
        return 10;
      }, Object.defineProperties(nn, rn);
      var on = u(function () {}, "rn"),
        sn = u(function () {}, "on");
      sn.prototype.distance = function (t, e) {}, sn.prototype.interfaces_ = function () {
        return [];
      }, sn.prototype.getClass = function () {
        return sn;
      };
      var an = function (t) {
          function n(e) {
            e = e || n.DEFAULT_NODE_CAPACITY, t.call(this, e);
          }
          u(n, "n"), t && (n.__proto__ = t), (n.prototype = Object.create(t && t.prototype)).constructor = n;
          var i = {
            STRtreeNode: {
              configurable: !0
            },
            serialVersionUID: {
              configurable: !0
            },
            xComparator: {
              configurable: !0
            },
            yComparator: {
              configurable: !0
            },
            intersectsOp: {
              configurable: !0
            },
            DEFAULT_NODE_CAPACITY: {
              configurable: !0
            }
          };
          return n.prototype.createParentBoundablesFromVerticalSlices = function (t, e) {
            nt.isTrue(t.length > 0);
            for (var n = new St(), i = 0; i < t.length; i++) n.addAll(this.createParentBoundablesFromVerticalSlice(t[i], e));
            return n;
          }, n.prototype.createNode = function (t) {
            return new ln(t);
          }, n.prototype.size = function () {
            return 0 === arguments.length ? t.prototype.size.call(this) : t.prototype.size.apply(this, arguments);
          }, n.prototype.insert = function () {
            if (2 !== arguments.length) return t.prototype.insert.apply(this, arguments);
            var e = arguments[0],
              n = arguments[1];
            if (e.isNull()) return null;
            t.prototype.insert.call(this, e, n);
          }, n.prototype.getIntersectsOp = function () {
            return n.intersectsOp;
          }, n.prototype.verticalSlices = function (t, e) {
            for (var n = Math.trunc(Math.ceil(t.size() / e)), i = new Array(e).fill(null), r = t.iterator(), o = 0; o < e; o++) {
              i[o] = new St();
              for (var s = 0; r.hasNext() && s < n;) {
                var a = r.next();
                i[o].add(a), s++;
              }
            }
            return i;
          }, n.prototype.query = function () {
            if (1 === arguments.length) {
              var e = arguments[0];
              return t.prototype.query.call(this, e);
            }
            if (2 === arguments.length) {
              var n = arguments[0],
                i = arguments[1];
              t.prototype.query.call(this, n, i);
            } else if (3 === arguments.length) if (N(arguments[2], Je) && arguments[0] instanceof Object && arguments[1] instanceof Qe) {
              var r = arguments[0],
                o = arguments[1],
                s = arguments[2];
              t.prototype.query.call(this, r, o, s);
            } else if (N(arguments[2], wt) && arguments[0] instanceof Object && arguments[1] instanceof Qe) {
              var a = arguments[0],
                l = arguments[1],
                u = arguments[2];
              t.prototype.query.call(this, a, l, u);
            }
          }, n.prototype.getComparator = function () {
            return n.yComparator;
          }, n.prototype.createParentBoundablesFromVerticalSlice = function (e, n) {
            return t.prototype.createParentBoundables.call(this, e, n);
          }, n.prototype.remove = function () {
            if (2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1];
              return t.prototype.remove.call(this, e, n);
            }
            return t.prototype.remove.apply(this, arguments);
          }, n.prototype.depth = function () {
            return 0 === arguments.length ? t.prototype.depth.call(this) : t.prototype.depth.apply(this, arguments);
          }, n.prototype.createParentBoundables = function (t, e) {
            nt.isTrue(!t.isEmpty());
            var i = Math.trunc(Math.ceil(t.size() / this.getNodeCapacity())),
              r = new St(t);
            tn.sort(r, n.xComparator);
            var o = this.verticalSlices(r, Math.trunc(Math.ceil(Math.sqrt(i))));
            return this.createParentBoundablesFromVerticalSlices(o, e);
          }, n.prototype.nearestNeighbour = function () {
            if (1 === arguments.length) {
              if (N(arguments[0], sn)) {
                var t = arguments[0],
                  e = new en(this.getRoot(), this.getRoot(), t);
                return this.nearestNeighbour(e);
              }
              if (arguments[0] instanceof en) {
                var i = arguments[0];
                return this.nearestNeighbour(i, x.POSITIVE_INFINITY);
              }
            } else if (2 === arguments.length) {
              if (arguments[0] instanceof n && N(arguments[1], sn)) {
                var r = arguments[0],
                  o = arguments[1],
                  s = new en(this.getRoot(), r.getRoot(), o);
                return this.nearestNeighbour(s);
              }
              if (arguments[0] instanceof en && "number" == typeof arguments[1]) {
                var a = arguments[0],
                  l = arguments[1],
                  u = null,
                  h = new Ze();
                for (h.add(a); !h.isEmpty() && l > 0;) {
                  var c = h.poll(),
                    p = c.getDistance();
                  if (p >= l) break;
                  c.isLeaves() ? (l = p, u = c) : c.expandToQueue(h, l);
                }
                return [u.getBoundable(0).getItem(), u.getBoundable(1).getItem()];
              }
            } else if (3 === arguments.length) {
              var d = arguments[0],
                f = arguments[1],
                m = arguments[2],
                g = new Ye(d, f),
                v = new en(this.getRoot(), g, m);
              return this.nearestNeighbour(v)[0];
            }
          }, n.prototype.interfaces_ = function () {
            return [Ke, e];
          }, n.prototype.getClass = function () {
            return n;
          }, n.centreX = function (t) {
            return n.avg(t.getMinX(), t.getMaxX());
          }, n.avg = function (t, e) {
            return (t + e) / 2;
          }, n.centreY = function (t) {
            return n.avg(t.getMinY(), t.getMaxY());
          }, i.STRtreeNode.get = function () {
            return ln;
          }, i.serialVersionUID.get = function () {
            return 0x39920f7d5f261e0;
          }, i.xComparator.get = function () {
            return {
              interfaces_: function () {
                return [S];
              },
              compare: function (e, i) {
                return t.compareDoubles(n.centreX(e.getBounds()), n.centreX(i.getBounds()));
              }
            };
          }, i.yComparator.get = function () {
            return {
              interfaces_: function () {
                return [S];
              },
              compare: function (e, i) {
                return t.compareDoubles(n.centreY(e.getBounds()), n.centreY(i.getBounds()));
              }
            };
          }, i.intersectsOp.get = function () {
            return {
              interfaces_: function () {
                return [t.IntersectsOp];
              },
              intersects: function (t, e) {
                return t.intersects(e);
              }
            };
          }, i.DEFAULT_NODE_CAPACITY.get = function () {
            return 10;
          }, Object.defineProperties(n, i), n;
        }(nn),
        ln = function (t) {
          function e() {
            var e = arguments[0];
            t.call(this, e);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.computeBounds = function () {
            for (var t = null, e = this.getChildBoundables().iterator(); e.hasNext();) {
              var n = e.next();
              null === t ? t = new X(n.getBounds()) : t.expandToInclude(n.getBounds());
            }
            return t;
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(Qe),
        un = u(function () {}, "un");
      un.prototype.interfaces_ = function () {
        return [];
      }, un.prototype.getClass = function () {
        return un;
      }, un.relativeSign = function (t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
      }, un.compare = function (t, e, n) {
        if (e.equals2D(n)) return 0;
        var i = un.relativeSign(e.x, n.x),
          r = un.relativeSign(e.y, n.y);
        switch (t) {
          case 0:
            return un.compareValue(i, r);
          case 1:
            return un.compareValue(r, i);
          case 2:
            return un.compareValue(r, -i);
          case 3:
            return un.compareValue(-i, r);
          case 4:
            return un.compareValue(-i, -r);
          case 5:
            return un.compareValue(-r, -i);
          case 6:
            return un.compareValue(-r, i);
          case 7:
            return un.compareValue(i, -r);
        }
        return nt.shouldNeverReachHere("invalid octant value"), 0;
      }, un.compareValue = function (t, e) {
        return t < 0 ? -1 : t > 0 ? 1 : e < 0 ? -1 : e > 0 ? 1 : 0;
      };
      var hn = u(function () {
        this._segString = null, this.coord = null, this.segmentIndex = null, this._segmentOctant = null, this._isInterior = null;
        var t = arguments[0],
          e = arguments[1],
          n = arguments[2],
          i = arguments[3];
        this._segString = t, this.coord = new M(e), this.segmentIndex = n, this._segmentOctant = i, this._isInterior = !e.equals2D(t.getCoordinate(n));
      }, "ln");
      hn.prototype.getCoordinate = function () {
        return this.coord;
      }, hn.prototype.print = function (t) {
        t.print(this.coord), t.print(" seg # = " + this.segmentIndex);
      }, hn.prototype.compareTo = function (t) {
        var e = t;
        return this.segmentIndex < e.segmentIndex ? -1 : this.segmentIndex > e.segmentIndex ? 1 : this.coord.equals2D(e.coord) ? 0 : un.compare(this._segmentOctant, this.coord, e.coord);
      }, hn.prototype.isEndPoint = function (t) {
        return 0 === this.segmentIndex && !this._isInterior || this.segmentIndex === t;
      }, hn.prototype.isInterior = function () {
        return this._isInterior;
      }, hn.prototype.interfaces_ = function () {
        return [b];
      }, hn.prototype.getClass = function () {
        return hn;
      };
      var cn = u(function () {
        this._nodeMap = new p(), this._edge = null;
        var t = arguments[0];
        this._edge = t;
      }, "cn");
      cn.prototype.getSplitCoordinates = function () {
        var t = new Tt();
        this.addEndpoints();
        for (var e = this.iterator(), n = e.next(); e.hasNext();) {
          var i = e.next();
          this.addEdgeCoordinates(n, i, t), n = i;
        }
        return t.toCoordinateArray();
      }, cn.prototype.addCollapsedNodes = function () {
        var t = new St();
        this.findCollapsesFromInsertedNodes(t), this.findCollapsesFromExistingVertices(t);
        for (var e = t.iterator(); e.hasNext();) {
          var n = e.next().intValue();
          this.add(this._edge.getCoordinate(n), n);
        }
      }, cn.prototype.print = function (t) {
        t.println("Intersections:");
        for (var e = this.iterator(); e.hasNext();) e.next().print(t);
      }, cn.prototype.findCollapsesFromExistingVertices = function (t) {
        for (var e = 0; e < this._edge.size() - 2; e++) {
          var n = this._edge.getCoordinate(e),
            i = this._edge.getCoordinate(e + 2);
          n.equals2D(i) && t.add(new q(e + 1));
        }
      }, cn.prototype.addEdgeCoordinates = function (t, e, n) {
        var i = this._edge.getCoordinate(e.segmentIndex),
          r = e.isInterior() || !e.coord.equals2D(i);
        n.add(new M(t.coord), !1);
        for (var o = t.segmentIndex + 1; o <= e.segmentIndex; o++) n.add(this._edge.getCoordinate(o));
        r && n.add(new M(e.coord));
      }, cn.prototype.iterator = function () {
        return this._nodeMap.values().iterator();
      }, cn.prototype.addSplitEdges = function (t) {
        this.addEndpoints(), this.addCollapsedNodes();
        for (var e = this.iterator(), n = e.next(); e.hasNext();) {
          var i = e.next(),
            r = this.createSplitEdge(n, i);
          t.add(r), n = i;
        }
      }, cn.prototype.findCollapseIndex = function (t, e, n) {
        if (!t.coord.equals2D(e.coord)) return !1;
        var i = e.segmentIndex - t.segmentIndex;
        return e.isInterior() || i--, 1 === i && (n[0] = t.segmentIndex + 1, !0);
      }, cn.prototype.findCollapsesFromInsertedNodes = function (t) {
        for (var e = new Array(1).fill(null), n = this.iterator(), i = n.next(); n.hasNext();) {
          var r = n.next();
          this.findCollapseIndex(i, r, e) && t.add(new q(e[0])), i = r;
        }
      }, cn.prototype.getEdge = function () {
        return this._edge;
      }, cn.prototype.addEndpoints = function () {
        var t = this._edge.size() - 1;
        this.add(this._edge.getCoordinate(0), 0), this.add(this._edge.getCoordinate(t), t);
      }, cn.prototype.createSplitEdge = function (t, e) {
        var n = e.segmentIndex - t.segmentIndex + 2,
          i = this._edge.getCoordinate(e.segmentIndex),
          r = e.isInterior() || !e.coord.equals2D(i);
        r || n--;
        var o = new Array(n).fill(null),
          s = 0;
        o[s++] = new M(t.coord);
        for (var a = t.segmentIndex + 1; a <= e.segmentIndex; a++) o[s++] = this._edge.getCoordinate(a);
        return r && (o[s] = new M(e.coord)), new mn(o, this._edge.getData());
      }, cn.prototype.add = function (t, e) {
        var n = new hn(this._edge, t, e, this._edge.getSegmentOctant(e)),
          i = this._nodeMap.get(n);
        return null !== i ? (nt.isTrue(i.coord.equals2D(t), "Found equal nodes with different coordinates"), i) : (this._nodeMap.put(n, n), n);
      }, cn.prototype.checkSplitEdgesCorrectness = function (t) {
        var e = this._edge.getCoordinates(),
          n = t.get(0).getCoordinate(0);
        if (!n.equals2D(e[0])) throw new tt("bad split edge start point at " + n);
        var i = t.get(t.size() - 1).getCoordinates(),
          r = i[i.length - 1];
        if (!r.equals2D(e[e.length - 1])) throw new tt("bad split edge end point at " + r);
      }, cn.prototype.interfaces_ = function () {
        return [];
      }, cn.prototype.getClass = function () {
        return cn;
      };
      var pn = u(function () {}, "pn");
      pn.prototype.interfaces_ = function () {
        return [];
      }, pn.prototype.getClass = function () {
        return pn;
      }, pn.octant = function () {
        if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
          var t = arguments[0],
            e = arguments[1];
          if (0 === t && 0 === e) throw new _("Cannot compute the octant for point ( " + t + ", " + e + " )");
          var n = Math.abs(t),
            i = Math.abs(e);
          return t >= 0 ? e >= 0 ? n >= i ? 0 : 1 : n >= i ? 7 : 6 : e >= 0 ? n >= i ? 3 : 2 : n >= i ? 4 : 5;
        }
        if (arguments[0] instanceof M && arguments[1] instanceof M) {
          var r = arguments[0],
            o = arguments[1],
            s = o.x - r.x,
            a = o.y - r.y;
          if (0 === s && 0 === a) throw new _("Cannot compute the octant for two identical points " + r);
          return pn.octant(s, a);
        }
      };
      var dn = u(function () {}, "hn");
      dn.prototype.getCoordinates = function () {}, dn.prototype.size = function () {}, dn.prototype.getCoordinate = function (t) {}, dn.prototype.isClosed = function () {}, dn.prototype.setData = function (t) {}, dn.prototype.getData = function () {}, dn.prototype.interfaces_ = function () {
        return [];
      }, dn.prototype.getClass = function () {
        return dn;
      };
      var fn = u(function () {}, "fn");
      fn.prototype.addIntersection = function (t, e) {}, fn.prototype.interfaces_ = function () {
        return [dn];
      }, fn.prototype.getClass = function () {
        return fn;
      };
      var mn = u(function () {
        this._nodeList = new cn(this), this._pts = null, this._data = null;
        var t = arguments[0],
          e = arguments[1];
        this._pts = t, this._data = e;
      }, "gn");
      mn.prototype.getCoordinates = function () {
        return this._pts;
      }, mn.prototype.size = function () {
        return this._pts.length;
      }, mn.prototype.getCoordinate = function (t) {
        return this._pts[t];
      }, mn.prototype.isClosed = function () {
        return this._pts[0].equals(this._pts[this._pts.length - 1]);
      }, mn.prototype.getSegmentOctant = function (t) {
        return t === this._pts.length - 1 ? -1 : this.safeOctant(this.getCoordinate(t), this.getCoordinate(t + 1));
      }, mn.prototype.setData = function (t) {
        this._data = t;
      }, mn.prototype.safeOctant = function (t, e) {
        return t.equals2D(e) ? 0 : pn.octant(t, e);
      }, mn.prototype.getData = function () {
        return this._data;
      }, mn.prototype.addIntersection = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          this.addIntersectionNode(t, e);
        } else if (4 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[3],
            o = new M(n.getIntersection(r));
          this.addIntersection(o, i);
        }
      }, mn.prototype.toString = function () {
        return $.toLineString(new ue(this._pts));
      }, mn.prototype.getNodeList = function () {
        return this._nodeList;
      }, mn.prototype.addIntersectionNode = function (t, e) {
        var n = e,
          i = n + 1;
        if (i < this._pts.length) {
          var r = this._pts[i];
          t.equals2D(r) && (n = i);
        }
        return this._nodeList.add(t, n);
      }, mn.prototype.addIntersections = function (t, e, n) {
        for (var i = 0; i < t.getIntersectionNum(); i++) this.addIntersection(t, e, n, i);
      }, mn.prototype.interfaces_ = function () {
        return [fn];
      }, mn.prototype.getClass = function () {
        return mn;
      }, mn.getNodedSubstrings = function () {
        if (1 === arguments.length) {
          var t = arguments[0],
            e = new St();
          return mn.getNodedSubstrings(t, e), e;
        }
        if (2 === arguments.length) for (var n = arguments[0], i = arguments[1], r = n.iterator(); r.hasNext();) r.next().getNodeList().addSplitEdges(i);
      };
      var gn = u(function () {
          if (this.p0 = null, this.p1 = null, 0 === arguments.length) this.p0 = new M(), this.p1 = new M();else if (1 === arguments.length) {
            var t = arguments[0];
            this.p0 = new M(t.p0), this.p1 = new M(t.p1);
          } else if (2 === arguments.length) this.p0 = arguments[0], this.p1 = arguments[1];else if (4 === arguments.length) {
            var e = arguments[0],
              n = arguments[1],
              i = arguments[2],
              r = arguments[3];
            this.p0 = new M(e, n), this.p1 = new M(i, r);
          }
        }, "dn"),
        vn = {
          serialVersionUID: {
            configurable: !0
          }
        };
      gn.prototype.minX = function () {
        return Math.min(this.p0.x, this.p1.x);
      }, gn.prototype.orientationIndex = function () {
        if (arguments[0] instanceof gn) {
          var t = arguments[0],
            e = lt.orientationIndex(this.p0, this.p1, t.p0),
            n = lt.orientationIndex(this.p0, this.p1, t.p1);
          return e >= 0 && n >= 0 || e <= 0 && n <= 0 ? Math.max(e, n) : 0;
        }
        if (arguments[0] instanceof M) {
          var i = arguments[0];
          return lt.orientationIndex(this.p0, this.p1, i);
        }
      }, gn.prototype.toGeometry = function (t) {
        return t.createLineString([this.p0, this.p1]);
      }, gn.prototype.isVertical = function () {
        return this.p0.x === this.p1.x;
      }, gn.prototype.equals = function (t) {
        if (!(t instanceof gn)) return !1;
        var e = t;
        return this.p0.equals(e.p0) && this.p1.equals(e.p1);
      }, gn.prototype.intersection = function (t) {
        var e = new ot();
        return e.computeIntersection(this.p0, this.p1, t.p0, t.p1), e.hasIntersection() ? e.getIntersection(0) : null;
      }, gn.prototype.project = function () {
        if (arguments[0] instanceof M) {
          var t = arguments[0];
          if (t.equals(this.p0) || t.equals(this.p1)) return new M(t);
          var e = this.projectionFactor(t),
            n = new M();
          return n.x = this.p0.x + e * (this.p1.x - this.p0.x), n.y = this.p0.y + e * (this.p1.y - this.p0.y), n;
        }
        if (arguments[0] instanceof gn) {
          var i = arguments[0],
            r = this.projectionFactor(i.p0),
            o = this.projectionFactor(i.p1);
          if (r >= 1 && o >= 1 || r <= 0 && o <= 0) return null;
          var s = this.project(i.p0);
          r < 0 && (s = this.p0), r > 1 && (s = this.p1);
          var a = this.project(i.p1);
          return o < 0 && (a = this.p0), o > 1 && (a = this.p1), new gn(s, a);
        }
      }, gn.prototype.normalize = function () {
        this.p1.compareTo(this.p0) < 0 && this.reverse();
      }, gn.prototype.angle = function () {
        return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
      }, gn.prototype.getCoordinate = function (t) {
        return 0 === t ? this.p0 : this.p1;
      }, gn.prototype.distancePerpendicular = function (t) {
        return lt.distancePointLinePerpendicular(t, this.p0, this.p1);
      }, gn.prototype.minY = function () {
        return Math.min(this.p0.y, this.p1.y);
      }, gn.prototype.midPoint = function () {
        return gn.midPoint(this.p0, this.p1);
      }, gn.prototype.projectionFactor = function (t) {
        if (t.equals(this.p0)) return 0;
        if (t.equals(this.p1)) return 1;
        var e = this.p1.x - this.p0.x,
          n = this.p1.y - this.p0.y,
          i = e * e + n * n;
        return i <= 0 ? x.NaN : ((t.x - this.p0.x) * e + (t.y - this.p0.y) * n) / i;
      }, gn.prototype.closestPoints = function (t) {
        var e = this.intersection(t);
        if (null !== e) return [e, e];
        var n = new Array(2).fill(null),
          i = x.MAX_VALUE,
          r = null,
          o = this.closestPoint(t.p0);
        i = o.distance(t.p0), n[0] = o, n[1] = t.p0;
        var s = this.closestPoint(t.p1);
        (r = s.distance(t.p1)) < i && (i = r, n[0] = s, n[1] = t.p1);
        var a = t.closestPoint(this.p0);
        (r = a.distance(this.p0)) < i && (i = r, n[0] = this.p0, n[1] = a);
        var l = t.closestPoint(this.p1);
        return (r = l.distance(this.p1)) < i && (i = r, n[0] = this.p1, n[1] = l), n;
      }, gn.prototype.closestPoint = function (t) {
        var e = this.projectionFactor(t);
        return e > 0 && e < 1 ? this.project(t) : this.p0.distance(t) < this.p1.distance(t) ? this.p0 : this.p1;
      }, gn.prototype.maxX = function () {
        return Math.max(this.p0.x, this.p1.x);
      }, gn.prototype.getLength = function () {
        return this.p0.distance(this.p1);
      }, gn.prototype.compareTo = function (t) {
        var e = t,
          n = this.p0.compareTo(e.p0);
        return 0 !== n ? n : this.p1.compareTo(e.p1);
      }, gn.prototype.reverse = function () {
        var t = this.p0;
        this.p0 = this.p1, this.p1 = t;
      }, gn.prototype.equalsTopo = function (t) {
        return this.p0.equals(t.p0) && (this.p1.equals(t.p1) || this.p0.equals(t.p1)) && this.p1.equals(t.p0);
      }, gn.prototype.lineIntersection = function (t) {
        try {
          return H.intersection(this.p0, this.p1, t.p0, t.p1);
        } catch (t) {
          if (!(t instanceof G)) throw t;
        }
        return null;
      }, gn.prototype.maxY = function () {
        return Math.max(this.p0.y, this.p1.y);
      }, gn.prototype.pointAlongOffset = function (t, e) {
        var n = this.p0.x + t * (this.p1.x - this.p0.x),
          i = this.p0.y + t * (this.p1.y - this.p0.y),
          r = this.p1.x - this.p0.x,
          o = this.p1.y - this.p0.y,
          s = Math.sqrt(r * r + o * o),
          a = 0,
          l = 0;
        if (0 !== e) {
          if (s <= 0) throw new Error("Cannot compute offset from zero-length line segment");
          a = e * r / s, l = e * o / s;
        }
        return new M(n - l, i + a);
      }, gn.prototype.setCoordinates = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.setCoordinates(t.p0, t.p1);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          this.p0.x = e.x, this.p0.y = e.y, this.p1.x = n.x, this.p1.y = n.y;
        }
      }, gn.prototype.segmentFraction = function (t) {
        var e = this.projectionFactor(t);
        return e < 0 ? e = 0 : (e > 1 || x.isNaN(e)) && (e = 1), e;
      }, gn.prototype.toString = function () {
        return "LINESTRING( " + this.p0.x + " " + this.p0.y + ", " + this.p1.x + " " + this.p1.y + ")";
      }, gn.prototype.isHorizontal = function () {
        return this.p0.y === this.p1.y;
      }, gn.prototype.distance = function () {
        if (arguments[0] instanceof gn) {
          var t = arguments[0];
          return lt.distanceLineLine(this.p0, this.p1, t.p0, t.p1);
        }
        if (arguments[0] instanceof M) {
          var e = arguments[0];
          return lt.distancePointLine(e, this.p0, this.p1);
        }
      }, gn.prototype.pointAlong = function (t) {
        var e = new M();
        return e.x = this.p0.x + t * (this.p1.x - this.p0.x), e.y = this.p0.y + t * (this.p1.y - this.p0.y), e;
      }, gn.prototype.hashCode = function () {
        var t = x.doubleToLongBits(this.p0.x);
        t ^= 31 * x.doubleToLongBits(this.p0.y);
        var e = Math.trunc(t) ^ Math.trunc(t >> 32),
          n = x.doubleToLongBits(this.p1.x);
        return n ^= 31 * x.doubleToLongBits(this.p1.y), e ^ Math.trunc(n) ^ Math.trunc(n >> 32);
      }, gn.prototype.interfaces_ = function () {
        return [b, e];
      }, gn.prototype.getClass = function () {
        return gn;
      }, gn.midPoint = function (t, e) {
        return new M((t.x + e.x) / 2, (t.y + e.y) / 2);
      }, vn.serialVersionUID.get = function () {
        return 0x2d2172135f411c00;
      }, Object.defineProperties(gn, vn);
      var yn = u(function () {
        this.tempEnv1 = new X(), this.tempEnv2 = new X(), this._overlapSeg1 = new gn(), this._overlapSeg2 = new gn();
      }, "_n");
      yn.prototype.overlap = function () {
        if (2 !== arguments.length && 4 === arguments.length) {
          var t = arguments[0],
            e = arguments[1],
            n = arguments[2],
            i = arguments[3];
          t.getLineSegment(e, this._overlapSeg1), n.getLineSegment(i, this._overlapSeg2), this.overlap(this._overlapSeg1, this._overlapSeg2);
        }
      }, yn.prototype.interfaces_ = function () {
        return [];
      }, yn.prototype.getClass = function () {
        return yn;
      };
      var _n = u(function () {
        this._pts = null, this._start = null, this._end = null, this._env = null, this._context = null, this._id = null;
        var t = arguments[0],
          e = arguments[1],
          n = arguments[2],
          i = arguments[3];
        this._pts = t, this._start = e, this._end = n, this._context = i;
      }, "mn");
      _n.prototype.getLineSegment = function (t, e) {
        e.p0 = this._pts[t], e.p1 = this._pts[t + 1];
      }, _n.prototype.computeSelect = function (t, e, n, i) {
        var r = this._pts[e],
          o = this._pts[n];
        if (i.tempEnv1.init(r, o), n - e == 1) return i.select(this, e), null;
        if (!t.intersects(i.tempEnv1)) return null;
        var s = Math.trunc((e + n) / 2);
        e < s && this.computeSelect(t, e, s, i), s < n && this.computeSelect(t, s, n, i);
      }, _n.prototype.getCoordinates = function () {
        for (var t = new Array(this._end - this._start + 1).fill(null), e = 0, n = this._start; n <= this._end; n++) t[e++] = this._pts[n];
        return t;
      }, _n.prototype.computeOverlaps = function (t, e) {
        this.computeOverlapsInternal(this._start, this._end, t, t._start, t._end, e);
      }, _n.prototype.setId = function (t) {
        this._id = t;
      }, _n.prototype.select = function (t, e) {
        this.computeSelect(t, this._start, this._end, e);
      }, _n.prototype.getEnvelope = function () {
        if (null === this._env) {
          var t = this._pts[this._start],
            e = this._pts[this._end];
          this._env = new X(t, e);
        }
        return this._env;
      }, _n.prototype.getEndIndex = function () {
        return this._end;
      }, _n.prototype.getStartIndex = function () {
        return this._start;
      }, _n.prototype.getContext = function () {
        return this._context;
      }, _n.prototype.getId = function () {
        return this._id;
      }, _n.prototype.computeOverlapsInternal = function (t, e, n, i, r, o) {
        var s = this._pts[t],
          a = this._pts[e],
          l = n._pts[i],
          u = n._pts[r];
        if (e - t == 1 && r - i == 1) return o.overlap(this, t, n, i), null;
        if (o.tempEnv1.init(s, a), o.tempEnv2.init(l, u), !o.tempEnv1.intersects(o.tempEnv2)) return null;
        var h = Math.trunc((t + e) / 2),
          c = Math.trunc((i + r) / 2);
        t < h && (i < c && this.computeOverlapsInternal(t, h, n, i, c, o), c < r && this.computeOverlapsInternal(t, h, n, c, r, o)), h < e && (i < c && this.computeOverlapsInternal(h, e, n, i, c, o), c < r && this.computeOverlapsInternal(h, e, n, c, r, o));
      }, _n.prototype.interfaces_ = function () {
        return [];
      }, _n.prototype.getClass = function () {
        return _n;
      };
      var xn = u(function () {}, "vn");
      xn.prototype.interfaces_ = function () {
        return [];
      }, xn.prototype.getClass = function () {
        return xn;
      }, xn.getChainStartIndices = function (t) {
        var e = 0,
          n = new St();
        n.add(new q(e));
        do {
          var i = xn.findChainEnd(t, e);
          n.add(new q(i)), e = i;
        } while (e < t.length - 1);
        return xn.toIntArray(n);
      }, xn.findChainEnd = function (t, e) {
        for (var n = e; n < t.length - 1 && t[n].equals2D(t[n + 1]);) n++;
        if (n >= t.length - 1) return t.length - 1;
        for (var i = Be.quadrant(t[n], t[n + 1]), r = e + 1; r < t.length && (t[r - 1].equals2D(t[r]) || Be.quadrant(t[r - 1], t[r]) === i);) r++;
        return r - 1;
      }, xn.getChains = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return xn.getChains(t, null);
        }
        if (2 === arguments.length) {
          for (var e = arguments[0], n = arguments[1], i = new St(), r = xn.getChainStartIndices(e), o = 0; o < r.length - 1; o++) {
            var s = new _n(e, r[o], r[o + 1], n);
            i.add(s);
          }
          return i;
        }
      }, xn.toIntArray = function (t) {
        for (var e = new Array(t.size()).fill(null), n = 0; n < e.length; n++) e[n] = t.get(n).intValue();
        return e;
      };
      var En = u(function () {}, "In");
      En.prototype.computeNodes = function (t) {}, En.prototype.getNodedSubstrings = function () {}, En.prototype.interfaces_ = function () {
        return [];
      }, En.prototype.getClass = function () {
        return En;
      };
      var bn = u(function () {
        if (this._segInt = null, 0 !== arguments.length && 1 === arguments.length) {
          var t = arguments[0];
          this.setSegmentIntersector(t);
        }
      }, "En");
      bn.prototype.setSegmentIntersector = function (t) {
        this._segInt = t;
      }, bn.prototype.interfaces_ = function () {
        return [En];
      }, bn.prototype.getClass = function () {
        return bn;
      };
      var wn = function (t) {
          function e(e) {
            e ? t.call(this, e) : t.call(this), this._monoChains = new St(), this._index = new an(), this._idCounter = 0, this._nodedSegStrings = null, this._nOverlaps = 0;
          }
          u(e, "e"), t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
          var n = {
            SegmentOverlapAction: {
              configurable: !0
            }
          };
          return e.prototype.getMonotoneChains = function () {
            return this._monoChains;
          }, e.prototype.getNodedSubstrings = function () {
            return mn.getNodedSubstrings(this._nodedSegStrings);
          }, e.prototype.getIndex = function () {
            return this._index;
          }, e.prototype.add = function (t) {
            for (var e = xn.getChains(t.getCoordinates(), t).iterator(); e.hasNext();) {
              var n = e.next();
              n.setId(this._idCounter++), this._index.insert(n.getEnvelope(), n), this._monoChains.add(n);
            }
          }, e.prototype.computeNodes = function (t) {
            this._nodedSegStrings = t;
            for (var e = t.iterator(); e.hasNext();) this.add(e.next());
            this.intersectChains();
          }, e.prototype.intersectChains = function () {
            for (var t = new Sn(this._segInt), e = this._monoChains.iterator(); e.hasNext();) for (var n = e.next(), i = this._index.query(n.getEnvelope()).iterator(); i.hasNext();) {
              var r = i.next();
              if (r.getId() > n.getId() && (n.computeOverlaps(r, t), this._nOverlaps++), this._segInt.isDone()) return null;
            }
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, n.SegmentOverlapAction.get = function () {
            return Sn;
          }, Object.defineProperties(e, n), e;
        }(bn),
        Sn = function (t) {
          function e() {
            t.call(this), this._si = null;
            var e = arguments[0];
            this._si = e;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.overlap = function () {
            if (4 !== arguments.length) return t.prototype.overlap.apply(this, arguments);
            var e = arguments[0],
              n = arguments[1],
              i = arguments[2],
              r = arguments[3],
              o = e.getContext(),
              s = i.getContext();
            this._si.processIntersections(o, n, s, r);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(yn),
        Mn = u(function t() {
          if (this._quadrantSegments = t.DEFAULT_QUADRANT_SEGMENTS, this._endCapStyle = t.CAP_ROUND, this._joinStyle = t.JOIN_ROUND, this._mitreLimit = t.DEFAULT_MITRE_LIMIT, this._isSingleSided = !1, this._simplifyFactor = t.DEFAULT_SIMPLIFY_FACTOR, 0 !== arguments.length) if (1 === arguments.length) {
            var e = arguments[0];
            this.setQuadrantSegments(e);
          } else if (2 === arguments.length) {
            var n = arguments[0],
              i = arguments[1];
            this.setQuadrantSegments(n), this.setEndCapStyle(i);
          } else if (4 === arguments.length) {
            var r = arguments[0],
              o = arguments[1],
              s = arguments[2],
              a = arguments[3];
            this.setQuadrantSegments(r), this.setEndCapStyle(o), this.setJoinStyle(s), this.setMitreLimit(a);
          }
        }, "t"),
        Tn = {
          CAP_ROUND: {
            configurable: !0
          },
          CAP_FLAT: {
            configurable: !0
          },
          CAP_SQUARE: {
            configurable: !0
          },
          JOIN_ROUND: {
            configurable: !0
          },
          JOIN_MITRE: {
            configurable: !0
          },
          JOIN_BEVEL: {
            configurable: !0
          },
          DEFAULT_QUADRANT_SEGMENTS: {
            configurable: !0
          },
          DEFAULT_MITRE_LIMIT: {
            configurable: !0
          },
          DEFAULT_SIMPLIFY_FACTOR: {
            configurable: !0
          }
        };
      Mn.prototype.getEndCapStyle = function () {
        return this._endCapStyle;
      }, Mn.prototype.isSingleSided = function () {
        return this._isSingleSided;
      }, Mn.prototype.setQuadrantSegments = function (t) {
        this._quadrantSegments = t, 0 === this._quadrantSegments && (this._joinStyle = Mn.JOIN_BEVEL), this._quadrantSegments < 0 && (this._joinStyle = Mn.JOIN_MITRE, this._mitreLimit = Math.abs(this._quadrantSegments)), t <= 0 && (this._quadrantSegments = 1), this._joinStyle !== Mn.JOIN_ROUND && (this._quadrantSegments = Mn.DEFAULT_QUADRANT_SEGMENTS);
      }, Mn.prototype.getJoinStyle = function () {
        return this._joinStyle;
      }, Mn.prototype.setJoinStyle = function (t) {
        this._joinStyle = t;
      }, Mn.prototype.setSimplifyFactor = function (t) {
        this._simplifyFactor = t < 0 ? 0 : t;
      }, Mn.prototype.getSimplifyFactor = function () {
        return this._simplifyFactor;
      }, Mn.prototype.getQuadrantSegments = function () {
        return this._quadrantSegments;
      }, Mn.prototype.setEndCapStyle = function (t) {
        this._endCapStyle = t;
      }, Mn.prototype.getMitreLimit = function () {
        return this._mitreLimit;
      }, Mn.prototype.setMitreLimit = function (t) {
        this._mitreLimit = t;
      }, Mn.prototype.setSingleSided = function (t) {
        this._isSingleSided = t;
      }, Mn.prototype.interfaces_ = function () {
        return [];
      }, Mn.prototype.getClass = function () {
        return Mn;
      }, Mn.bufferDistanceError = function (t) {
        var e = Math.PI / 2 / t;
        return 1 - Math.cos(e / 2);
      }, Tn.CAP_ROUND.get = function () {
        return 1;
      }, Tn.CAP_FLAT.get = function () {
        return 2;
      }, Tn.CAP_SQUARE.get = function () {
        return 3;
      }, Tn.JOIN_ROUND.get = function () {
        return 1;
      }, Tn.JOIN_MITRE.get = function () {
        return 2;
      }, Tn.JOIN_BEVEL.get = function () {
        return 3;
      }, Tn.DEFAULT_QUADRANT_SEGMENTS.get = function () {
        return 8;
      }, Tn.DEFAULT_MITRE_LIMIT.get = function () {
        return 5;
      }, Tn.DEFAULT_SIMPLIFY_FACTOR.get = function () {
        return .01;
      }, Object.defineProperties(Mn, Tn);
      var An = u(function (t) {
          this._distanceTol = null, this._isDeleted = null, this._angleOrientation = lt.COUNTERCLOCKWISE, this._inputLine = t || null;
        }, "Ln"),
        Pn = {
          INIT: {
            configurable: !0
          },
          DELETE: {
            configurable: !0
          },
          KEEP: {
            configurable: !0
          },
          NUM_PTS_TO_CHECK: {
            configurable: !0
          }
        };
      An.prototype.isDeletable = function (t, e, n, i) {
        var r = this._inputLine[t],
          o = this._inputLine[e],
          s = this._inputLine[n];
        return !!this.isConcave(r, o, s) && !!this.isShallow(r, o, s, i) && this.isShallowSampled(r, o, t, n, i);
      }, An.prototype.deleteShallowConcavities = function () {
        for (var t = 1, e = this.findNextNonDeletedIndex(t), n = this.findNextNonDeletedIndex(e), i = !1; n < this._inputLine.length;) {
          var r = !1;
          this.isDeletable(t, e, n, this._distanceTol) && (this._isDeleted[e] = An.DELETE, r = !0, i = !0), t = r ? n : e, e = this.findNextNonDeletedIndex(t), n = this.findNextNonDeletedIndex(e);
        }
        return i;
      }, An.prototype.isShallowConcavity = function (t, e, n, i) {
        return lt.computeOrientation(t, e, n) === this._angleOrientation && lt.distancePointLine(e, t, n) < i;
      }, An.prototype.isShallowSampled = function (t, e, n, i, r) {
        var o = Math.trunc((i - n) / An.NUM_PTS_TO_CHECK);
        o <= 0 && (o = 1);
        for (var s = n; s < i; s += o) if (!this.isShallow(t, e, this._inputLine[s], r)) return !1;
        return !0;
      }, An.prototype.isConcave = function (t, e, n) {
        return lt.computeOrientation(t, e, n) === this._angleOrientation;
      }, An.prototype.simplify = function (t) {
        this._distanceTol = Math.abs(t), t < 0 && (this._angleOrientation = lt.CLOCKWISE), this._isDeleted = new Array(this._inputLine.length).fill(null);
        var e = !1;
        do {
          e = this.deleteShallowConcavities();
        } while (e);
        return this.collapseLine();
      }, An.prototype.findNextNonDeletedIndex = function (t) {
        for (var e = t + 1; e < this._inputLine.length && this._isDeleted[e] === An.DELETE;) e++;
        return e;
      }, An.prototype.isShallow = function (t, e, n, i) {
        return lt.distancePointLine(e, t, n) < i;
      }, An.prototype.collapseLine = function () {
        for (var t = new Tt(), e = 0; e < this._inputLine.length; e++) this._isDeleted[e] !== An.DELETE && t.add(this._inputLine[e]);
        return t.toCoordinateArray();
      }, An.prototype.interfaces_ = function () {
        return [];
      }, An.prototype.getClass = function () {
        return An;
      }, An.simplify = function (t, e) {
        return new An(t).simplify(e);
      }, Pn.INIT.get = function () {
        return 0;
      }, Pn.DELETE.get = function () {
        return 1;
      }, Pn.KEEP.get = function () {
        return 1;
      }, Pn.NUM_PTS_TO_CHECK.get = function () {
        return 10;
      }, Object.defineProperties(An, Pn);
      var Cn = u(function () {
          this._ptList = null, this._precisionModel = null, this._minimimVertexDistance = 0, this._ptList = new St();
        }, "wn"),
        In = {
          COORDINATE_ARRAY_TYPE: {
            configurable: !0
          }
        };
      Cn.prototype.getCoordinates = function () {
        return this._ptList.toArray(Cn.COORDINATE_ARRAY_TYPE);
      }, Cn.prototype.setPrecisionModel = function (t) {
        this._precisionModel = t;
      }, Cn.prototype.addPt = function (t) {
        var e = new M(t);
        if (this._precisionModel.makePrecise(e), this.isRedundant(e)) return null;
        this._ptList.add(e);
      }, Cn.prototype.revere = function () {}, Cn.prototype.addPts = function (t, e) {
        if (e) for (var n = 0; n < t.length; n++) this.addPt(t[n]);else for (var i = t.length - 1; i >= 0; i--) this.addPt(t[i]);
      }, Cn.prototype.isRedundant = function (t) {
        if (this._ptList.size() < 1) return !1;
        var e = this._ptList.get(this._ptList.size() - 1);
        return t.distance(e) < this._minimimVertexDistance;
      }, Cn.prototype.toString = function () {
        return new ye().createLineString(this.getCoordinates()).toString();
      }, Cn.prototype.closeRing = function () {
        if (this._ptList.size() < 1) return null;
        var t = new M(this._ptList.get(0)),
          e = this._ptList.get(this._ptList.size() - 1);
        if (t.equals(e)) return null;
        this._ptList.add(t);
      }, Cn.prototype.setMinimumVertexDistance = function (t) {
        this._minimimVertexDistance = t;
      }, Cn.prototype.interfaces_ = function () {
        return [];
      }, Cn.prototype.getClass = function () {
        return Cn;
      }, In.COORDINATE_ARRAY_TYPE.get = function () {
        return new Array(0).fill(null);
      }, Object.defineProperties(Cn, In);
      var Nn = u(function () {}, "Tn"),
        Ln = {
          PI_TIMES_2: {
            configurable: !0
          },
          PI_OVER_2: {
            configurable: !0
          },
          PI_OVER_4: {
            configurable: !0
          },
          COUNTERCLOCKWISE: {
            configurable: !0
          },
          CLOCKWISE: {
            configurable: !0
          },
          NONE: {
            configurable: !0
          }
        };
      Nn.prototype.interfaces_ = function () {
        return [];
      }, Nn.prototype.getClass = function () {
        return Nn;
      }, Nn.toDegrees = function (t) {
        return 180 * t / Math.PI;
      }, Nn.normalize = function (t) {
        for (; t > Math.PI;) t -= Nn.PI_TIMES_2;
        for (; t <= -Math.PI;) t += Nn.PI_TIMES_2;
        return t;
      }, Nn.angle = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return Math.atan2(t.y, t.x);
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1],
            i = n.x - e.x,
            r = n.y - e.y;
          return Math.atan2(r, i);
        }
      }, Nn.isAcute = function (t, e, n) {
        var i = t.x - e.x,
          r = t.y - e.y;
        return i * (n.x - e.x) + r * (n.y - e.y) > 0;
      }, Nn.isObtuse = function (t, e, n) {
        var i = t.x - e.x,
          r = t.y - e.y;
        return i * (n.x - e.x) + r * (n.y - e.y) < 0;
      }, Nn.interiorAngle = function (t, e, n) {
        var i = Nn.angle(e, t),
          r = Nn.angle(e, n);
        return Math.abs(r - i);
      }, Nn.normalizePositive = function (t) {
        if (t < 0) {
          for (; t < 0;) t += Nn.PI_TIMES_2;
          t >= Nn.PI_TIMES_2 && (t = 0);
        } else {
          for (; t >= Nn.PI_TIMES_2;) t -= Nn.PI_TIMES_2;
          t < 0 && (t = 0);
        }
        return t;
      }, Nn.angleBetween = function (t, e, n) {
        var i = Nn.angle(e, t),
          r = Nn.angle(e, n);
        return Nn.diff(i, r);
      }, Nn.diff = function (t, e) {
        var n = null;
        return (n = t < e ? e - t : t - e) > Math.PI && (n = 2 * Math.PI - n), n;
      }, Nn.toRadians = function (t) {
        return t * Math.PI / 180;
      }, Nn.getTurn = function (t, e) {
        var n = Math.sin(e - t);
        return n > 0 ? Nn.COUNTERCLOCKWISE : n < 0 ? Nn.CLOCKWISE : Nn.NONE;
      }, Nn.angleBetweenOriented = function (t, e, n) {
        var i = Nn.angle(e, t),
          r = Nn.angle(e, n) - i;
        return r <= -Math.PI ? r + Nn.PI_TIMES_2 : r > Math.PI ? r - Nn.PI_TIMES_2 : r;
      }, Ln.PI_TIMES_2.get = function () {
        return 2 * Math.PI;
      }, Ln.PI_OVER_2.get = function () {
        return Math.PI / 2;
      }, Ln.PI_OVER_4.get = function () {
        return Math.PI / 4;
      }, Ln.COUNTERCLOCKWISE.get = function () {
        return lt.COUNTERCLOCKWISE;
      }, Ln.CLOCKWISE.get = function () {
        return lt.CLOCKWISE;
      }, Ln.NONE.get = function () {
        return lt.COLLINEAR;
      }, Object.defineProperties(Nn, Ln);
      var Rn = u(function t() {
          this._maxCurveSegmentError = 0, this._filletAngleQuantum = null, this._closingSegLengthFactor = 1, this._segList = null, this._distance = 0, this._precisionModel = null, this._bufParams = null, this._li = null, this._s0 = null, this._s1 = null, this._s2 = null, this._seg0 = new gn(), this._seg1 = new gn(), this._offset0 = new gn(), this._offset1 = new gn(), this._side = 0, this._hasNarrowConcaveAngle = !1;
          var e = arguments[0],
            n = arguments[1],
            i = arguments[2];
          this._precisionModel = e, this._bufParams = n, this._li = new ot(), this._filletAngleQuantum = Math.PI / 2 / n.getQuadrantSegments(), n.getQuadrantSegments() >= 8 && n.getJoinStyle() === Mn.JOIN_ROUND && (this._closingSegLengthFactor = t.MAX_CLOSING_SEG_LEN_FACTOR), this.init(i);
        }, "t"),
        On = {
          OFFSET_SEGMENT_SEPARATION_FACTOR: {
            configurable: !0
          },
          INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR: {
            configurable: !0
          },
          CURVE_VERTEX_SNAP_DISTANCE_FACTOR: {
            configurable: !0
          },
          MAX_CLOSING_SEG_LEN_FACTOR: {
            configurable: !0
          }
        };
      Rn.prototype.addNextSegment = function (t, e) {
        if (this._s0 = this._s1, this._s1 = this._s2, this._s2 = t, this._seg0.setCoordinates(this._s0, this._s1), this.computeOffsetSegment(this._seg0, this._side, this._distance, this._offset0), this._seg1.setCoordinates(this._s1, this._s2), this.computeOffsetSegment(this._seg1, this._side, this._distance, this._offset1), this._s1.equals(this._s2)) return null;
        var n = lt.computeOrientation(this._s0, this._s1, this._s2),
          i = n === lt.CLOCKWISE && this._side === Te.LEFT || n === lt.COUNTERCLOCKWISE && this._side === Te.RIGHT;
        0 === n ? this.addCollinear(e) : i ? this.addOutsideTurn(n, e) : this.addInsideTurn(n, e);
      }, Rn.prototype.addLineEndCap = function (t, e) {
        var n = new gn(t, e),
          i = new gn();
        this.computeOffsetSegment(n, Te.LEFT, this._distance, i);
        var r = new gn();
        this.computeOffsetSegment(n, Te.RIGHT, this._distance, r);
        var o = e.x - t.x,
          s = e.y - t.y,
          a = Math.atan2(s, o);
        switch (this._bufParams.getEndCapStyle()) {
          case Mn.CAP_ROUND:
            this._segList.addPt(i.p1), this.addFilletArc(e, a + Math.PI / 2, a - Math.PI / 2, lt.CLOCKWISE, this._distance), this._segList.addPt(r.p1);
            break;
          case Mn.CAP_FLAT:
            this._segList.addPt(i.p1), this._segList.addPt(r.p1);
            break;
          case Mn.CAP_SQUARE:
            var l = new M();
            l.x = Math.abs(this._distance) * Math.cos(a), l.y = Math.abs(this._distance) * Math.sin(a);
            var u = new M(i.p1.x + l.x, i.p1.y + l.y),
              h = new M(r.p1.x + l.x, r.p1.y + l.y);
            this._segList.addPt(u), this._segList.addPt(h);
        }
      }, Rn.prototype.getCoordinates = function () {
        return this._segList.getCoordinates();
      }, Rn.prototype.addMitreJoin = function (t, e, n, i) {
        var r = !0,
          o = null;
        try {
          o = H.intersection(e.p0, e.p1, n.p0, n.p1), (i <= 0 ? 1 : o.distance(t) / Math.abs(i)) > this._bufParams.getMitreLimit() && (r = !1);
        } catch (t) {
          if (!(t instanceof G)) throw t;
          o = new M(0, 0), r = !1;
        }
        r ? this._segList.addPt(o) : this.addLimitedMitreJoin(e, n, i, this._bufParams.getMitreLimit());
      }, Rn.prototype.addFilletCorner = function (t, e, n, i, r) {
        var o = e.x - t.x,
          s = e.y - t.y,
          a = Math.atan2(s, o),
          l = n.x - t.x,
          u = n.y - t.y,
          h = Math.atan2(u, l);
        i === lt.CLOCKWISE ? a <= h && (a += 2 * Math.PI) : a >= h && (a -= 2 * Math.PI), this._segList.addPt(e), this.addFilletArc(t, a, h, i, r), this._segList.addPt(n);
      }, Rn.prototype.addOutsideTurn = function (t, e) {
        if (this._offset0.p1.distance(this._offset1.p0) < this._distance * Rn.OFFSET_SEGMENT_SEPARATION_FACTOR) return this._segList.addPt(this._offset0.p1), null;
        this._bufParams.getJoinStyle() === Mn.JOIN_MITRE ? this.addMitreJoin(this._s1, this._offset0, this._offset1, this._distance) : this._bufParams.getJoinStyle() === Mn.JOIN_BEVEL ? this.addBevelJoin(this._offset0, this._offset1) : (e && this._segList.addPt(this._offset0.p1), this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, t, this._distance), this._segList.addPt(this._offset1.p0));
      }, Rn.prototype.createSquare = function (t) {
        this._segList.addPt(new M(t.x + this._distance, t.y + this._distance)), this._segList.addPt(new M(t.x + this._distance, t.y - this._distance)), this._segList.addPt(new M(t.x - this._distance, t.y - this._distance)), this._segList.addPt(new M(t.x - this._distance, t.y + this._distance)), this._segList.closeRing();
      }, Rn.prototype.addSegments = function (t, e) {
        this._segList.addPts(t, e);
      }, Rn.prototype.addFirstSegment = function () {
        this._segList.addPt(this._offset1.p0);
      }, Rn.prototype.addLastSegment = function () {
        this._segList.addPt(this._offset1.p1);
      }, Rn.prototype.initSideSegments = function (t, e, n) {
        this._s1 = t, this._s2 = e, this._side = n, this._seg1.setCoordinates(t, e), this.computeOffsetSegment(this._seg1, n, this._distance, this._offset1);
      }, Rn.prototype.addLimitedMitreJoin = function (t, e, n, i) {
        var r = this._seg0.p1,
          o = Nn.angle(r, this._seg0.p0),
          s = Nn.angleBetweenOriented(this._seg0.p0, r, this._seg1.p1) / 2,
          a = Nn.normalize(o + s),
          l = Nn.normalize(a + Math.PI),
          u = i * n,
          h = n - u * Math.abs(Math.sin(s)),
          c = r.x + u * Math.cos(l),
          p = r.y + u * Math.sin(l),
          d = new M(c, p),
          f = new gn(r, d),
          m = f.pointAlongOffset(1, h),
          g = f.pointAlongOffset(1, -h);
        this._side === Te.LEFT ? (this._segList.addPt(m), this._segList.addPt(g)) : (this._segList.addPt(g), this._segList.addPt(m));
      }, Rn.prototype.computeOffsetSegment = function (t, e, n, i) {
        var r = e === Te.LEFT ? 1 : -1,
          o = t.p1.x - t.p0.x,
          s = t.p1.y - t.p0.y,
          a = Math.sqrt(o * o + s * s),
          l = r * n * o / a,
          u = r * n * s / a;
        i.p0.x = t.p0.x - u, i.p0.y = t.p0.y + l, i.p1.x = t.p1.x - u, i.p1.y = t.p1.y + l;
      }, Rn.prototype.addFilletArc = function (t, e, n, i, r) {
        var o = i === lt.CLOCKWISE ? -1 : 1,
          s = Math.abs(e - n),
          a = Math.trunc(s / this._filletAngleQuantum + .5);
        if (a < 1) return null;
        for (var l = s / a, u = 0, h = new M(); u < s;) {
          var c = e + o * u;
          h.x = t.x + r * Math.cos(c), h.y = t.y + r * Math.sin(c), this._segList.addPt(h), u += l;
        }
      }, Rn.prototype.addInsideTurn = function (t, e) {
        if (this._li.computeIntersection(this._offset0.p0, this._offset0.p1, this._offset1.p0, this._offset1.p1), this._li.hasIntersection()) this._segList.addPt(this._li.getIntersection(0));else if (this._hasNarrowConcaveAngle = !0, this._offset0.p1.distance(this._offset1.p0) < this._distance * Rn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR) this._segList.addPt(this._offset0.p1);else {
          if (this._segList.addPt(this._offset0.p1), this._closingSegLengthFactor > 0) {
            var n = new M((this._closingSegLengthFactor * this._offset0.p1.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset0.p1.y + this._s1.y) / (this._closingSegLengthFactor + 1));
            this._segList.addPt(n);
            var i = new M((this._closingSegLengthFactor * this._offset1.p0.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset1.p0.y + this._s1.y) / (this._closingSegLengthFactor + 1));
            this._segList.addPt(i);
          } else this._segList.addPt(this._s1);
          this._segList.addPt(this._offset1.p0);
        }
      }, Rn.prototype.createCircle = function (t) {
        var e = new M(t.x + this._distance, t.y);
        this._segList.addPt(e), this.addFilletArc(t, 0, 2 * Math.PI, -1, this._distance), this._segList.closeRing();
      }, Rn.prototype.addBevelJoin = function (t, e) {
        this._segList.addPt(t.p1), this._segList.addPt(e.p0);
      }, Rn.prototype.init = function (t) {
        this._distance = t, this._maxCurveSegmentError = t * (1 - Math.cos(this._filletAngleQuantum / 2)), this._segList = new Cn(), this._segList.setPrecisionModel(this._precisionModel), this._segList.setMinimumVertexDistance(t * Rn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR);
      }, Rn.prototype.addCollinear = function (t) {
        this._li.computeIntersection(this._s0, this._s1, this._s1, this._s2), this._li.getIntersectionNum() >= 2 && (this._bufParams.getJoinStyle() === Mn.JOIN_BEVEL || this._bufParams.getJoinStyle() === Mn.JOIN_MITRE ? (t && this._segList.addPt(this._offset0.p1), this._segList.addPt(this._offset1.p0)) : this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, lt.CLOCKWISE, this._distance));
      }, Rn.prototype.closeRing = function () {
        this._segList.closeRing();
      }, Rn.prototype.hasNarrowConcaveAngle = function () {
        return this._hasNarrowConcaveAngle;
      }, Rn.prototype.interfaces_ = function () {
        return [];
      }, Rn.prototype.getClass = function () {
        return Rn;
      }, On.OFFSET_SEGMENT_SEPARATION_FACTOR.get = function () {
        return .001;
      }, On.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR.get = function () {
        return .001;
      }, On.CURVE_VERTEX_SNAP_DISTANCE_FACTOR.get = function () {
        return 1e-6;
      }, On.MAX_CLOSING_SEG_LEN_FACTOR.get = function () {
        return 80;
      }, Object.defineProperties(Rn, On);
      var qn = u(function () {
        this._distance = 0, this._precisionModel = null, this._bufParams = null;
        var t = arguments[0],
          e = arguments[1];
        this._precisionModel = t, this._bufParams = e;
      }, "Mn");
      qn.prototype.getOffsetCurve = function (t, e) {
        if (this._distance = e, 0 === e) return null;
        var n = e < 0,
          i = Math.abs(e),
          r = this.getSegGen(i);
        t.length <= 1 ? this.computePointCurve(t[0], r) : this.computeOffsetCurve(t, n, r);
        var o = r.getCoordinates();
        return n && At.reverse(o), o;
      }, qn.prototype.computeSingleSidedBufferCurve = function (t, e, n) {
        var i = this.simplifyTolerance(this._distance);
        if (e) {
          n.addSegments(t, !0);
          var r = An.simplify(t, -i),
            o = r.length - 1;
          n.initSideSegments(r[o], r[o - 1], Te.LEFT), n.addFirstSegment();
          for (var s = o - 2; s >= 0; s--) n.addNextSegment(r[s], !0);
        } else {
          n.addSegments(t, !1);
          var a = An.simplify(t, i),
            l = a.length - 1;
          n.initSideSegments(a[0], a[1], Te.LEFT), n.addFirstSegment();
          for (var u = 2; u <= l; u++) n.addNextSegment(a[u], !0);
        }
        n.addLastSegment(), n.closeRing();
      }, qn.prototype.computeRingBufferCurve = function (t, e, n) {
        var i = this.simplifyTolerance(this._distance);
        e === Te.RIGHT && (i = -i);
        var r = An.simplify(t, i),
          o = r.length - 1;
        n.initSideSegments(r[o - 1], r[0], e);
        for (var s = 1; s <= o; s++) {
          var a = 1 !== s;
          n.addNextSegment(r[s], a);
        }
        n.closeRing();
      }, qn.prototype.computeLineBufferCurve = function (t, e) {
        var n = this.simplifyTolerance(this._distance),
          i = An.simplify(t, n),
          r = i.length - 1;
        e.initSideSegments(i[0], i[1], Te.LEFT);
        for (var o = 2; o <= r; o++) e.addNextSegment(i[o], !0);
        e.addLastSegment(), e.addLineEndCap(i[r - 1], i[r]);
        var s = An.simplify(t, -n),
          a = s.length - 1;
        e.initSideSegments(s[a], s[a - 1], Te.LEFT);
        for (var l = a - 2; l >= 0; l--) e.addNextSegment(s[l], !0);
        e.addLastSegment(), e.addLineEndCap(s[1], s[0]), e.closeRing();
      }, qn.prototype.computePointCurve = function (t, e) {
        switch (this._bufParams.getEndCapStyle()) {
          case Mn.CAP_ROUND:
            e.createCircle(t);
            break;
          case Mn.CAP_SQUARE:
            e.createSquare(t);
        }
      }, qn.prototype.getLineCurve = function (t, e) {
        if (this._distance = e, e < 0 && !this._bufParams.isSingleSided() || 0 === e) return null;
        var n = Math.abs(e),
          i = this.getSegGen(n);
        if (t.length <= 1) this.computePointCurve(t[0], i);else if (this._bufParams.isSingleSided()) {
          var r = e < 0;
          this.computeSingleSidedBufferCurve(t, r, i);
        } else this.computeLineBufferCurve(t, i);
        return i.getCoordinates();
      }, qn.prototype.getBufferParameters = function () {
        return this._bufParams;
      }, qn.prototype.simplifyTolerance = function (t) {
        return t * this._bufParams.getSimplifyFactor();
      }, qn.prototype.getRingCurve = function (t, e, n) {
        if (this._distance = n, t.length <= 2) return this.getLineCurve(t, n);
        if (0 === n) return qn.copyCoordinates(t);
        var i = this.getSegGen(n);
        return this.computeRingBufferCurve(t, e, i), i.getCoordinates();
      }, qn.prototype.computeOffsetCurve = function (t, e, n) {
        var i = this.simplifyTolerance(this._distance);
        if (e) {
          var r = An.simplify(t, -i),
            o = r.length - 1;
          n.initSideSegments(r[o], r[o - 1], Te.LEFT), n.addFirstSegment();
          for (var s = o - 2; s >= 0; s--) n.addNextSegment(r[s], !0);
        } else {
          var a = An.simplify(t, i),
            l = a.length - 1;
          n.initSideSegments(a[0], a[1], Te.LEFT), n.addFirstSegment();
          for (var u = 2; u <= l; u++) n.addNextSegment(a[u], !0);
        }
        n.addLastSegment();
      }, qn.prototype.getSegGen = function (t) {
        return new Rn(this._precisionModel, this._bufParams, t);
      }, qn.prototype.interfaces_ = function () {
        return [];
      }, qn.prototype.getClass = function () {
        return qn;
      }, qn.copyCoordinates = function (t) {
        for (var e = new Array(t.length).fill(null), n = 0; n < e.length; n++) e[n] = new M(t[n]);
        return e;
      };
      var Dn = u(function () {
          this._subgraphs = null, this._seg = new gn(), this._cga = new lt();
          var t = arguments[0];
          this._subgraphs = t;
        }, "An"),
        kn = {
          DepthSegment: {
            configurable: !0
          }
        };
      Dn.prototype.findStabbedSegments = function () {
        if (1 === arguments.length) {
          for (var t = arguments[0], e = new St(), n = this._subgraphs.iterator(); n.hasNext();) {
            var i = n.next(),
              r = i.getEnvelope();
            t.y < r.getMinY() || t.y > r.getMaxY() || this.findStabbedSegments(t, i.getDirectedEdges(), e);
          }
          return e;
        }
        if (3 === arguments.length) if (N(arguments[2], wt) && arguments[0] instanceof M && arguments[1] instanceof je) {
          for (var o = arguments[0], s = arguments[1], a = arguments[2], l = s.getEdge().getCoordinates(), u = 0; u < l.length - 1; u++) if (this._seg.p0 = l[u], this._seg.p1 = l[u + 1], this._seg.p0.y > this._seg.p1.y && this._seg.reverse(), !(Math.max(this._seg.p0.x, this._seg.p1.x) < o.x || this._seg.isHorizontal() || o.y < this._seg.p0.y || o.y > this._seg.p1.y || lt.computeOrientation(this._seg.p0, this._seg.p1, o) === lt.RIGHT)) {
            var h = s.getDepth(Te.LEFT);
            this._seg.p0.equals(l[u]) || (h = s.getDepth(Te.RIGHT));
            var c = new Fn(this._seg, h);
            a.add(c);
          }
        } else if (N(arguments[2], wt) && arguments[0] instanceof M && N(arguments[1], wt)) for (var p = arguments[0], d = arguments[1], f = arguments[2], m = d.iterator(); m.hasNext();) {
          var g = m.next();
          g.isForward() && this.findStabbedSegments(p, g, f);
        }
      }, Dn.prototype.getDepth = function (t) {
        var e = this.findStabbedSegments(t);
        return 0 === e.size() ? 0 : tn.min(e)._leftDepth;
      }, Dn.prototype.interfaces_ = function () {
        return [];
      }, Dn.prototype.getClass = function () {
        return Dn;
      }, kn.DepthSegment.get = function () {
        return Fn;
      }, Object.defineProperties(Dn, kn);
      var Fn = u(function () {
        this._upwardSeg = null, this._leftDepth = null;
        var t = arguments[0],
          e = arguments[1];
        this._upwardSeg = new gn(t), this._leftDepth = e;
      }, "Gn");
      Fn.prototype.compareTo = function (t) {
        var e = t;
        if (this._upwardSeg.minX() >= e._upwardSeg.maxX()) return 1;
        if (this._upwardSeg.maxX() <= e._upwardSeg.minX()) return -1;
        var n = this._upwardSeg.orientationIndex(e._upwardSeg);
        return 0 !== n || 0 != (n = -1 * e._upwardSeg.orientationIndex(this._upwardSeg)) ? n : this._upwardSeg.compareTo(e._upwardSeg);
      }, Fn.prototype.compareX = function (t, e) {
        var n = t.p0.compareTo(e.p0);
        return 0 !== n ? n : t.p1.compareTo(e.p1);
      }, Fn.prototype.toString = function () {
        return this._upwardSeg.toString();
      }, Fn.prototype.interfaces_ = function () {
        return [b];
      }, Fn.prototype.getClass = function () {
        return Fn;
      };
      var Un = u(function (t, e, n) {
        this.p0 = t || null, this.p1 = e || null, this.p2 = n || null;
      }, "qn");
      Un.prototype.area = function () {
        return Un.area(this.p0, this.p1, this.p2);
      }, Un.prototype.signedArea = function () {
        return Un.signedArea(this.p0, this.p1, this.p2);
      }, Un.prototype.interpolateZ = function (t) {
        if (null === t) throw new _("Supplied point is null.");
        return Un.interpolateZ(t, this.p0, this.p1, this.p2);
      }, Un.prototype.longestSideLength = function () {
        return Un.longestSideLength(this.p0, this.p1, this.p2);
      }, Un.prototype.isAcute = function () {
        return Un.isAcute(this.p0, this.p1, this.p2);
      }, Un.prototype.circumcentre = function () {
        return Un.circumcentre(this.p0, this.p1, this.p2);
      }, Un.prototype.area3D = function () {
        return Un.area3D(this.p0, this.p1, this.p2);
      }, Un.prototype.centroid = function () {
        return Un.centroid(this.p0, this.p1, this.p2);
      }, Un.prototype.inCentre = function () {
        return Un.inCentre(this.p0, this.p1, this.p2);
      }, Un.prototype.interfaces_ = function () {
        return [];
      }, Un.prototype.getClass = function () {
        return Un;
      }, Un.area = function (t, e, n) {
        return Math.abs(((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2);
      }, Un.signedArea = function (t, e, n) {
        return ((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2;
      }, Un.det = function (t, e, n, i) {
        return t * i - e * n;
      }, Un.interpolateZ = function (t, e, n, i) {
        var r = e.x,
          o = e.y,
          s = n.x - r,
          a = i.x - r,
          l = n.y - o,
          u = i.y - o,
          h = s * u - a * l,
          c = t.x - r,
          p = t.y - o,
          d = (u * c - a * p) / h,
          f = (-l * c + s * p) / h;
        return e.z + d * (n.z - e.z) + f * (i.z - e.z);
      }, Un.longestSideLength = function (t, e, n) {
        var i = t.distance(e),
          r = e.distance(n),
          o = n.distance(t),
          s = i;
        return r > s && (s = r), o > s && (s = o), s;
      }, Un.isAcute = function (t, e, n) {
        return !!Nn.isAcute(t, e, n) && !!Nn.isAcute(e, n, t) && !!Nn.isAcute(n, t, e);
      }, Un.circumcentre = function (t, e, n) {
        var i = n.x,
          r = n.y,
          o = t.x - i,
          s = t.y - r,
          a = e.x - i,
          l = e.y - r,
          u = 2 * Un.det(o, s, a, l),
          h = Un.det(s, o * o + s * s, l, a * a + l * l),
          c = Un.det(o, o * o + s * s, a, a * a + l * l);
        return new M(i - h / u, r + c / u);
      }, Un.perpendicularBisector = function (t, e) {
        var n = e.x - t.x,
          i = e.y - t.y,
          r = new H(t.x + n / 2, t.y + i / 2, 1),
          o = new H(t.x - i + n / 2, t.y + n + i / 2, 1);
        return new H(r, o);
      }, Un.angleBisector = function (t, e, n) {
        var i = e.distance(t),
          r = i / (i + e.distance(n)),
          o = n.x - t.x,
          s = n.y - t.y;
        return new M(t.x + r * o, t.y + r * s);
      }, Un.area3D = function (t, e, n) {
        var i = e.x - t.x,
          r = e.y - t.y,
          o = e.z - t.z,
          s = n.x - t.x,
          a = n.y - t.y,
          l = n.z - t.z,
          u = r * l - o * a,
          h = o * s - i * l,
          c = i * a - r * s,
          p = u * u + h * h + c * c;
        return Math.sqrt(p) / 2;
      }, Un.centroid = function (t, e, n) {
        var i = (t.x + e.x + n.x) / 3,
          r = (t.y + e.y + n.y) / 3;
        return new M(i, r);
      }, Un.inCentre = function (t, e, n) {
        var i = e.distance(n),
          r = t.distance(n),
          o = t.distance(e),
          s = i + r + o,
          a = (i * t.x + r * e.x + o * n.x) / s,
          l = (i * t.y + r * e.y + o * n.y) / s;
        return new M(a, l);
      };
      var Bn = u(function () {
        this._inputGeom = null, this._distance = null, this._curveBuilder = null, this._curveList = new St();
        var t = arguments[0],
          e = arguments[1],
          n = arguments[2];
        this._inputGeom = t, this._distance = e, this._curveBuilder = n;
      }, "Bn");
      Bn.prototype.addPoint = function (t) {
        if (this._distance <= 0) return null;
        var e = t.getCoordinates(),
          n = this._curveBuilder.getLineCurve(e, this._distance);
        this.addCurve(n, C.EXTERIOR, C.INTERIOR);
      }, Bn.prototype.addPolygon = function (t) {
        var e = this._distance,
          n = Te.LEFT;
        this._distance < 0 && (e = -this._distance, n = Te.RIGHT);
        var i = t.getExteriorRing(),
          r = At.removeRepeatedPoints(i.getCoordinates());
        if (this._distance < 0 && this.isErodedCompletely(i, this._distance) || this._distance <= 0 && r.length < 3) return null;
        this.addPolygonRing(r, e, n, C.EXTERIOR, C.INTERIOR);
        for (var o = 0; o < t.getNumInteriorRing(); o++) {
          var s = t.getInteriorRingN(o),
            a = At.removeRepeatedPoints(s.getCoordinates());
          this._distance > 0 && this.isErodedCompletely(s, -this._distance) || this.addPolygonRing(a, e, Te.opposite(n), C.INTERIOR, C.EXTERIOR);
        }
      }, Bn.prototype.isTriangleErodedCompletely = function (t, e) {
        var n = new Un(t[0], t[1], t[2]),
          i = n.inCentre();
        return lt.distancePointLine(i, n.p0, n.p1) < Math.abs(e);
      }, Bn.prototype.addLineString = function (t) {
        if (this._distance <= 0 && !this._curveBuilder.getBufferParameters().isSingleSided()) return null;
        var e = At.removeRepeatedPoints(t.getCoordinates()),
          n = this._curveBuilder.getLineCurve(e, this._distance);
        this.addCurve(n, C.EXTERIOR, C.INTERIOR);
      }, Bn.prototype.addCurve = function (t, e, n) {
        if (null === t || t.length < 2) return null;
        var i = new mn(t, new Re(0, C.BOUNDARY, e, n));
        this._curveList.add(i);
      }, Bn.prototype.getCurves = function () {
        return this.add(this._inputGeom), this._curveList;
      }, Bn.prototype.addPolygonRing = function (t, e, n, i, r) {
        if (0 === e && t.length < ne.MINIMUM_VALID_SIZE) return null;
        var o = i,
          s = r;
        t.length >= ne.MINIMUM_VALID_SIZE && lt.isCCW(t) && (o = r, s = i, n = Te.opposite(n));
        var a = this._curveBuilder.getRingCurve(t, n, e);
        this.addCurve(a, o, s);
      }, Bn.prototype.add = function (t) {
        if (t.isEmpty()) return null;
        t instanceof te ? this.addPolygon(t) : t instanceof Jt ? this.addLineString(t) : t instanceof Qt ? this.addPoint(t) : (t instanceof ee || t instanceof Gt || t instanceof ie || t instanceof jt) && this.addCollection(t);
      }, Bn.prototype.isErodedCompletely = function (t, e) {
        var n = t.getCoordinates();
        if (n.length < 4) return e < 0;
        if (4 === n.length) return this.isTriangleErodedCompletely(n, e);
        var i = t.getEnvelopeInternal(),
          r = Math.min(i.getHeight(), i.getWidth());
        return e < 0 && 2 * Math.abs(e) > r;
      }, Bn.prototype.addCollection = function (t) {
        for (var e = 0; e < t.getNumGeometries(); e++) {
          var n = t.getGeometryN(e);
          this.add(n);
        }
      }, Bn.prototype.interfaces_ = function () {
        return [];
      }, Bn.prototype.getClass = function () {
        return Bn;
      };
      var zn = u(function () {}, "Vn");
      zn.prototype.locate = function (t) {}, zn.prototype.interfaces_ = function () {
        return [];
      }, zn.prototype.getClass = function () {
        return zn;
      };
      var Vn = u(function () {
        this._parent = null, this._atStart = null, this._max = null, this._index = null, this._subcollectionIterator = null;
        var t = arguments[0];
        this._parent = t, this._atStart = !0, this._index = 0, this._max = t.getNumGeometries();
      }, "Un");
      Vn.prototype.next = function () {
        if (this._atStart) return this._atStart = !1, Vn.isAtomic(this._parent) && this._index++, this._parent;
        if (null !== this._subcollectionIterator) {
          if (this._subcollectionIterator.hasNext()) return this._subcollectionIterator.next();
          this._subcollectionIterator = null;
        }
        if (this._index >= this._max) throw new i();
        var t = this._parent.getGeometryN(this._index++);
        return t instanceof jt ? (this._subcollectionIterator = new Vn(t), this._subcollectionIterator.next()) : t;
      }, Vn.prototype.remove = function () {
        throw new Error(this.getClass().getName());
      }, Vn.prototype.hasNext = function () {
        if (this._atStart) return !0;
        if (null !== this._subcollectionIterator) {
          if (this._subcollectionIterator.hasNext()) return !0;
          this._subcollectionIterator = null;
        }
        return !(this._index >= this._max);
      }, Vn.prototype.interfaces_ = function () {
        return [bt];
      }, Vn.prototype.getClass = function () {
        return Vn;
      }, Vn.isAtomic = function (t) {
        return !(t instanceof jt);
      };
      var jn = u(function () {
        this._geom = null;
        var t = arguments[0];
        this._geom = t;
      }, "zn");
      jn.prototype.locate = function (t) {
        return jn.locate(t, this._geom);
      }, jn.prototype.interfaces_ = function () {
        return [zn];
      }, jn.prototype.getClass = function () {
        return jn;
      }, jn.isPointInRing = function (t, e) {
        return !!e.getEnvelopeInternal().intersects(t) && lt.isPointInRing(t, e.getCoordinates());
      }, jn.containsPointInPolygon = function (t, e) {
        if (e.isEmpty()) return !1;
        var n = e.getExteriorRing();
        if (!jn.isPointInRing(t, n)) return !1;
        for (var i = 0; i < e.getNumInteriorRing(); i++) {
          var r = e.getInteriorRingN(i);
          if (jn.isPointInRing(t, r)) return !1;
        }
        return !0;
      }, jn.containsPoint = function (t, e) {
        if (e instanceof te) return jn.containsPointInPolygon(t, e);
        if (e instanceof jt) for (var n = new Vn(e); n.hasNext();) {
          var i = n.next();
          if (i !== e && jn.containsPoint(t, i)) return !0;
        }
        return !1;
      }, jn.locate = function (t, e) {
        return e.isEmpty() ? C.EXTERIOR : jn.containsPoint(t, e) ? C.INTERIOR : C.EXTERIOR;
      };
      var Gn = u(function () {
        this._edgeMap = new p(), this._edgeList = null, this._ptInAreaLocation = [C.NONE, C.NONE];
      }, "Xn");
      Gn.prototype.getNextCW = function (t) {
        this.getEdges();
        var e = this._edgeList.indexOf(t),
          n = e - 1;
        return 0 === e && (n = this._edgeList.size() - 1), this._edgeList.get(n);
      }, Gn.prototype.propagateSideLabels = function (t) {
        for (var e = C.NONE, n = this.iterator(); n.hasNext();) {
          var i = n.next().getLabel();
          i.isArea(t) && i.getLocation(t, Te.LEFT) !== C.NONE && (e = i.getLocation(t, Te.LEFT));
        }
        if (e === C.NONE) return null;
        for (var r = e, o = this.iterator(); o.hasNext();) {
          var s = o.next(),
            a = s.getLabel();
          if (a.getLocation(t, Te.ON) === C.NONE && a.setLocation(t, Te.ON, r), a.isArea(t)) {
            var l = a.getLocation(t, Te.LEFT),
              u = a.getLocation(t, Te.RIGHT);
            if (u !== C.NONE) {
              if (u !== r) throw new Ce("side location conflict", s.getCoordinate());
              l === C.NONE && nt.shouldNeverReachHere("found single null side (at " + s.getCoordinate() + ")"), r = l;
            } else nt.isTrue(a.getLocation(t, Te.LEFT) === C.NONE, "found single null side"), a.setLocation(t, Te.RIGHT, r), a.setLocation(t, Te.LEFT, r);
          }
        }
      }, Gn.prototype.getCoordinate = function () {
        var t = this.iterator();
        return t.hasNext() ? t.next().getCoordinate() : null;
      }, Gn.prototype.print = function (t) {
        W.out.println("EdgeEndStar:   " + this.getCoordinate());
        for (var e = this.iterator(); e.hasNext();) e.next().print(t);
      }, Gn.prototype.isAreaLabelsConsistent = function (t) {
        return this.computeEdgeEndLabels(t.getBoundaryNodeRule()), this.checkAreaLabelsConsistent(0);
      }, Gn.prototype.checkAreaLabelsConsistent = function (t) {
        var e = this.getEdges();
        if (e.size() <= 0) return !0;
        var n = e.size() - 1,
          i = e.get(n).getLabel().getLocation(t, Te.LEFT);
        nt.isTrue(i !== C.NONE, "Found unlabelled area edge");
        for (var r = i, o = this.iterator(); o.hasNext();) {
          var s = o.next().getLabel();
          nt.isTrue(s.isArea(t), "Found non-area edge");
          var a = s.getLocation(t, Te.LEFT),
            l = s.getLocation(t, Te.RIGHT);
          if (a === l || l !== r) return !1;
          r = a;
        }
        return !0;
      }, Gn.prototype.findIndex = function (t) {
        this.iterator();
        for (var e = 0; e < this._edgeList.size(); e++) if (this._edgeList.get(e) === t) return e;
        return -1;
      }, Gn.prototype.iterator = function () {
        return this.getEdges().iterator();
      }, Gn.prototype.getEdges = function () {
        return null === this._edgeList && (this._edgeList = new St(this._edgeMap.values())), this._edgeList;
      }, Gn.prototype.getLocation = function (t, e, n) {
        return this._ptInAreaLocation[t] === C.NONE && (this._ptInAreaLocation[t] = jn.locate(e, n[t].getGeometry())), this._ptInAreaLocation[t];
      }, Gn.prototype.toString = function () {
        var t = new O();
        t.append("EdgeEndStar:   " + this.getCoordinate()), t.append("\n");
        for (var e = this.iterator(); e.hasNext();) {
          var n = e.next();
          t.append(n), t.append("\n");
        }
        return t.toString();
      }, Gn.prototype.computeEdgeEndLabels = function (t) {
        for (var e = this.iterator(); e.hasNext();) e.next().computeLabel(t);
      }, Gn.prototype.computeLabelling = function (t) {
        this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()), this.propagateSideLabels(0), this.propagateSideLabels(1);
        for (var e = [!1, !1], n = this.iterator(); n.hasNext();) for (var i = n.next().getLabel(), r = 0; r < 2; r++) i.isLine(r) && i.getLocation(r) === C.BOUNDARY && (e[r] = !0);
        for (var o = this.iterator(); o.hasNext();) for (var s = o.next(), a = s.getLabel(), l = 0; l < 2; l++) if (a.isAnyNull(l)) {
          var u = C.NONE;
          if (e[l]) u = C.EXTERIOR;else {
            var h = s.getCoordinate();
            u = this.getLocation(l, h, t);
          }
          a.setAllLocationsIfNull(l, u);
        }
      }, Gn.prototype.getDegree = function () {
        return this._edgeMap.size();
      }, Gn.prototype.insertEdgeEnd = function (t, e) {
        this._edgeMap.put(t, e), this._edgeList = null;
      }, Gn.prototype.interfaces_ = function () {
        return [];
      }, Gn.prototype.getClass = function () {
        return Gn;
      };
      var Wn = function (t) {
          function e() {
            t.call(this), this._resultAreaEdgeList = null, this._label = null, this._SCANNING_FOR_INCOMING = 1, this._LINKING_TO_OUTGOING = 2;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.linkResultDirectedEdges = function () {
            this.getResultAreaEdges();
            for (var t = null, e = null, n = this._SCANNING_FOR_INCOMING, i = 0; i < this._resultAreaEdgeList.size(); i++) {
              var r = this._resultAreaEdgeList.get(i),
                o = r.getSym();
              if (r.getLabel().isArea()) switch (null === t && r.isInResult() && (t = r), n) {
                case this._SCANNING_FOR_INCOMING:
                  if (!o.isInResult()) continue;
                  e = o, n = this._LINKING_TO_OUTGOING;
                  break;
                case this._LINKING_TO_OUTGOING:
                  if (!r.isInResult()) continue;
                  e.setNext(r), n = this._SCANNING_FOR_INCOMING;
              }
            }
            if (n === this._LINKING_TO_OUTGOING) {
              if (null === t) throw new Ce("no outgoing dirEdge found", this.getCoordinate());
              nt.isTrue(t.isInResult(), "unable to link last incoming dirEdge"), e.setNext(t);
            }
          }, e.prototype.insert = function (t) {
            var e = t;
            this.insertEdgeEnd(e, e);
          }, e.prototype.getRightmostEdge = function () {
            var t = this.getEdges(),
              e = t.size();
            if (e < 1) return null;
            var n = t.get(0);
            if (1 === e) return n;
            var i = t.get(e - 1),
              r = n.getQuadrant(),
              o = i.getQuadrant();
            return Be.isNorthern(r) && Be.isNorthern(o) ? n : Be.isNorthern(r) || Be.isNorthern(o) ? 0 !== n.getDy() ? n : 0 !== i.getDy() ? i : (nt.shouldNeverReachHere("found two horizontal edges incident on node"), null) : i;
          }, e.prototype.print = function (t) {
            W.out.println("DirectedEdgeStar: " + this.getCoordinate());
            for (var e = this.iterator(); e.hasNext();) {
              var n = e.next();
              t.print("out "), n.print(t), t.println(), t.print("in "), n.getSym().print(t), t.println();
            }
          }, e.prototype.getResultAreaEdges = function () {
            if (null !== this._resultAreaEdgeList) return this._resultAreaEdgeList;
            this._resultAreaEdgeList = new St();
            for (var t = this.iterator(); t.hasNext();) {
              var e = t.next();
              (e.isInResult() || e.getSym().isInResult()) && this._resultAreaEdgeList.add(e);
            }
            return this._resultAreaEdgeList;
          }, e.prototype.updateLabelling = function (t) {
            for (var e = this.iterator(); e.hasNext();) {
              var n = e.next().getLabel();
              n.setAllLocationsIfNull(0, t.getLocation(0)), n.setAllLocationsIfNull(1, t.getLocation(1));
            }
          }, e.prototype.linkAllDirectedEdges = function () {
            this.getEdges();
            for (var t = null, e = null, n = this._edgeList.size() - 1; n >= 0; n--) {
              var i = this._edgeList.get(n),
                r = i.getSym();
              null === e && (e = r), null !== t && r.setNext(t), t = i;
            }
            e.setNext(t);
          }, e.prototype.computeDepths = function () {
            if (1 === arguments.length) {
              var t = arguments[0],
                e = this.findIndex(t),
                n = t.getDepth(Te.LEFT),
                i = t.getDepth(Te.RIGHT),
                r = this.computeDepths(e + 1, this._edgeList.size(), n);
              if (this.computeDepths(0, e, r) !== i) throw new Ce("depth mismatch at " + t.getCoordinate());
            } else if (3 === arguments.length) {
              for (var o = arguments[0], s = arguments[1], a = arguments[2], l = o; l < s; l++) {
                var u = this._edgeList.get(l);
                u.setEdgeDepths(Te.RIGHT, a), a = u.getDepth(Te.LEFT);
              }
              return a;
            }
          }, e.prototype.mergeSymLabels = function () {
            for (var t = this.iterator(); t.hasNext();) {
              var e = t.next();
              e.getLabel().merge(e.getSym().getLabel());
            }
          }, e.prototype.linkMinimalDirectedEdges = function (t) {
            for (var e = null, n = null, i = this._SCANNING_FOR_INCOMING, r = this._resultAreaEdgeList.size() - 1; r >= 0; r--) {
              var o = this._resultAreaEdgeList.get(r),
                s = o.getSym();
              switch (null === e && o.getEdgeRing() === t && (e = o), i) {
                case this._SCANNING_FOR_INCOMING:
                  if (s.getEdgeRing() !== t) continue;
                  n = s, i = this._LINKING_TO_OUTGOING;
                  break;
                case this._LINKING_TO_OUTGOING:
                  if (o.getEdgeRing() !== t) continue;
                  n.setNextMin(o), i = this._SCANNING_FOR_INCOMING;
              }
            }
            i === this._LINKING_TO_OUTGOING && (nt.isTrue(null !== e, "found null for first outgoing dirEdge"), nt.isTrue(e.getEdgeRing() === t, "unable to link last incoming dirEdge"), n.setNextMin(e));
          }, e.prototype.getOutgoingDegree = function () {
            if (0 === arguments.length) {
              for (var t = 0, e = this.iterator(); e.hasNext();) e.next().isInResult() && t++;
              return t;
            }
            if (1 === arguments.length) {
              for (var n = arguments[0], i = 0, r = this.iterator(); r.hasNext();) r.next().getEdgeRing() === n && i++;
              return i;
            }
          }, e.prototype.getLabel = function () {
            return this._label;
          }, e.prototype.findCoveredLineEdges = function () {
            for (var t = C.NONE, e = this.iterator(); e.hasNext();) {
              var n = e.next(),
                i = n.getSym();
              if (!n.isLineEdge()) {
                if (n.isInResult()) {
                  t = C.INTERIOR;
                  break;
                }
                if (i.isInResult()) {
                  t = C.EXTERIOR;
                  break;
                }
              }
            }
            if (t === C.NONE) return null;
            for (var r = t, o = this.iterator(); o.hasNext();) {
              var s = o.next(),
                a = s.getSym();
              s.isLineEdge() ? s.getEdge().setCovered(r === C.INTERIOR) : (s.isInResult() && (r = C.EXTERIOR), a.isInResult() && (r = C.INTERIOR));
            }
          }, e.prototype.computeLabelling = function (e) {
            t.prototype.computeLabelling.call(this, e), this._label = new Re(C.NONE);
            for (var n = this.iterator(); n.hasNext();) for (var i = n.next().getEdge().getLabel(), r = 0; r < 2; r++) {
              var o = i.getLocation(r);
              o !== C.INTERIOR && o !== C.BOUNDARY || this._label.setLocation(r, C.INTERIOR);
            }
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(Gn),
        Hn = function (t) {
          function e() {
            t.apply(this, arguments);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.createNode = function (t) {
            return new Fe(t, new Wn());
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(Ge),
        Xn = u(function t() {
          this._pts = null, this._orientation = null;
          var e = arguments[0];
          this._pts = e, this._orientation = t.orientation(e);
        }, "t");
      Xn.prototype.compareTo = function (t) {
        var e = t;
        return Xn.compareOriented(this._pts, this._orientation, e._pts, e._orientation);
      }, Xn.prototype.interfaces_ = function () {
        return [b];
      }, Xn.prototype.getClass = function () {
        return Xn;
      }, Xn.orientation = function (t) {
        return 1 === At.increasingDirection(t);
      }, Xn.compareOriented = function (t, e, n, i) {
        for (var r = e ? 1 : -1, o = i ? 1 : -1, s = e ? t.length : -1, a = i ? n.length : -1, l = e ? 0 : t.length - 1, u = i ? 0 : n.length - 1;;) {
          var h = t[l].compareTo(n[u]);
          if (0 !== h) return h;
          var c = (l += r) === s,
            p = (u += o) === a;
          if (c && !p) return -1;
          if (!c && p) return 1;
          if (c && p) return 0;
        }
      };
      var Yn = u(function () {
        this._edges = new St(), this._ocaMap = new p();
      }, "Hn");
      Yn.prototype.print = function (t) {
        t.print("MULTILINESTRING ( ");
        for (var e = 0; e < this._edges.size(); e++) {
          var n = this._edges.get(e);
          e > 0 && t.print(","), t.print("(");
          for (var i = n.getCoordinates(), r = 0; r < i.length; r++) r > 0 && t.print(","), t.print(i[r].x + " " + i[r].y);
          t.println(")");
        }
        t.print(")  ");
      }, Yn.prototype.addAll = function (t) {
        for (var e = t.iterator(); e.hasNext();) this.add(e.next());
      }, Yn.prototype.findEdgeIndex = function (t) {
        for (var e = 0; e < this._edges.size(); e++) if (this._edges.get(e).equals(t)) return e;
        return -1;
      }, Yn.prototype.iterator = function () {
        return this._edges.iterator();
      }, Yn.prototype.getEdges = function () {
        return this._edges;
      }, Yn.prototype.get = function (t) {
        return this._edges.get(t);
      }, Yn.prototype.findEqualEdge = function (t) {
        var e = new Xn(t.getCoordinates());
        return this._ocaMap.get(e);
      }, Yn.prototype.add = function (t) {
        this._edges.add(t);
        var e = new Xn(t.getCoordinates());
        this._ocaMap.put(e, t);
      }, Yn.prototype.interfaces_ = function () {
        return [];
      }, Yn.prototype.getClass = function () {
        return Yn;
      };
      var Zn = u(function () {}, "Wn");
      Zn.prototype.processIntersections = function (t, e, n, i) {}, Zn.prototype.isDone = function () {}, Zn.prototype.interfaces_ = function () {
        return [];
      }, Zn.prototype.getClass = function () {
        return Zn;
      };
      var Jn = u(function () {
        this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._hasInterior = !1, this._properIntersectionPoint = null, this._li = null, this._isSelfIntersection = null, this.numIntersections = 0, this.numInteriorIntersections = 0, this.numProperIntersections = 0, this.numTests = 0;
        var t = arguments[0];
        this._li = t;
      }, "Kn");
      Jn.prototype.isTrivialIntersection = function (t, e, n, i) {
        if (t === n && 1 === this._li.getIntersectionNum()) {
          if (Jn.isAdjacentSegments(e, i)) return !0;
          if (t.isClosed()) {
            var r = t.size() - 1;
            if (0 === e && i === r || 0 === i && e === r) return !0;
          }
        }
        return !1;
      }, Jn.prototype.getProperIntersectionPoint = function () {
        return this._properIntersectionPoint;
      }, Jn.prototype.hasProperInteriorIntersection = function () {
        return this._hasProperInterior;
      }, Jn.prototype.getLineIntersector = function () {
        return this._li;
      }, Jn.prototype.hasProperIntersection = function () {
        return this._hasProper;
      }, Jn.prototype.processIntersections = function (t, e, n, i) {
        if (t === n && e === i) return null;
        this.numTests++;
        var r = t.getCoordinates()[e],
          o = t.getCoordinates()[e + 1],
          s = n.getCoordinates()[i],
          a = n.getCoordinates()[i + 1];
        this._li.computeIntersection(r, o, s, a), this._li.hasIntersection() && (this.numIntersections++, this._li.isInteriorIntersection() && (this.numInteriorIntersections++, this._hasInterior = !0), this.isTrivialIntersection(t, e, n, i) || (this._hasIntersection = !0, t.addIntersections(this._li, e, 0), n.addIntersections(this._li, i, 1), this._li.isProper() && (this.numProperIntersections++, this._hasProper = !0, this._hasProperInterior = !0)));
      }, Jn.prototype.hasIntersection = function () {
        return this._hasIntersection;
      }, Jn.prototype.isDone = function () {
        return !1;
      }, Jn.prototype.hasInteriorIntersection = function () {
        return this._hasInterior;
      }, Jn.prototype.interfaces_ = function () {
        return [Zn];
      }, Jn.prototype.getClass = function () {
        return Jn;
      }, Jn.isAdjacentSegments = function (t, e) {
        return 1 === Math.abs(t - e);
      };
      var Kn = u(function () {
        this.coord = null, this.segmentIndex = null, this.dist = null;
        var t = arguments[0],
          e = arguments[1],
          n = arguments[2];
        this.coord = new M(t), this.segmentIndex = e, this.dist = n;
      }, "Jn");
      Kn.prototype.getSegmentIndex = function () {
        return this.segmentIndex;
      }, Kn.prototype.getCoordinate = function () {
        return this.coord;
      }, Kn.prototype.print = function (t) {
        t.print(this.coord), t.print(" seg # = " + this.segmentIndex), t.println(" dist = " + this.dist);
      }, Kn.prototype.compareTo = function (t) {
        var e = t;
        return this.compare(e.segmentIndex, e.dist);
      }, Kn.prototype.isEndPoint = function (t) {
        return 0 === this.segmentIndex && 0 === this.dist || this.segmentIndex === t;
      }, Kn.prototype.toString = function () {
        return this.coord + " seg # = " + this.segmentIndex + " dist = " + this.dist;
      }, Kn.prototype.getDistance = function () {
        return this.dist;
      }, Kn.prototype.compare = function (t, e) {
        return this.segmentIndex < t ? -1 : this.segmentIndex > t ? 1 : this.dist < e ? -1 : this.dist > e ? 1 : 0;
      }, Kn.prototype.interfaces_ = function () {
        return [b];
      }, Kn.prototype.getClass = function () {
        return Kn;
      };
      var Qn = u(function () {
        this._nodeMap = new p(), this.edge = null;
        var t = arguments[0];
        this.edge = t;
      }, "Qn");
      Qn.prototype.print = function (t) {
        t.println("Intersections:");
        for (var e = this.iterator(); e.hasNext();) e.next().print(t);
      }, Qn.prototype.iterator = function () {
        return this._nodeMap.values().iterator();
      }, Qn.prototype.addSplitEdges = function (t) {
        this.addEndpoints();
        for (var e = this.iterator(), n = e.next(); e.hasNext();) {
          var i = e.next(),
            r = this.createSplitEdge(n, i);
          t.add(r), n = i;
        }
      }, Qn.prototype.addEndpoints = function () {
        var t = this.edge.pts.length - 1;
        this.add(this.edge.pts[0], 0, 0), this.add(this.edge.pts[t], t, 0);
      }, Qn.prototype.createSplitEdge = function (t, e) {
        var n = e.segmentIndex - t.segmentIndex + 2,
          i = this.edge.pts[e.segmentIndex],
          r = e.dist > 0 || !e.coord.equals2D(i);
        r || n--;
        var o = new Array(n).fill(null),
          s = 0;
        o[s++] = new M(t.coord);
        for (var a = t.segmentIndex + 1; a <= e.segmentIndex; a++) o[s++] = this.edge.pts[a];
        return r && (o[s] = e.coord), new ii(o, new Re(this.edge._label));
      }, Qn.prototype.add = function (t, e, n) {
        var i = new Kn(t, e, n),
          r = this._nodeMap.get(i);
        return null !== r ? r : (this._nodeMap.put(i, i), i);
      }, Qn.prototype.isIntersection = function (t) {
        for (var e = this.iterator(); e.hasNext();) if (e.next().coord.equals(t)) return !0;
        return !1;
      }, Qn.prototype.interfaces_ = function () {
        return [];
      }, Qn.prototype.getClass = function () {
        return Qn;
      };
      var $n = u(function () {}, "Zn");
      $n.prototype.getChainStartIndices = function (t) {
        var e = 0,
          n = new St();
        n.add(new q(e));
        do {
          var i = this.findChainEnd(t, e);
          n.add(new q(i)), e = i;
        } while (e < t.length - 1);
        return $n.toIntArray(n);
      }, $n.prototype.findChainEnd = function (t, e) {
        for (var n = Be.quadrant(t[e], t[e + 1]), i = e + 1; i < t.length && Be.quadrant(t[i - 1], t[i]) === n;) i++;
        return i - 1;
      }, $n.prototype.interfaces_ = function () {
        return [];
      }, $n.prototype.getClass = function () {
        return $n;
      }, $n.toIntArray = function (t) {
        for (var e = new Array(t.size()).fill(null), n = 0; n < e.length; n++) e[n] = t.get(n).intValue();
        return e;
      };
      var ti = u(function () {
        this.e = null, this.pts = null, this.startIndex = null, this.env1 = new X(), this.env2 = new X();
        var t = arguments[0];
        this.e = t, this.pts = t.getCoordinates();
        var e = new $n();
        this.startIndex = e.getChainStartIndices(this.pts);
      }, "$n");
      ti.prototype.getCoordinates = function () {
        return this.pts;
      }, ti.prototype.getMaxX = function (t) {
        var e = this.pts[this.startIndex[t]].x,
          n = this.pts[this.startIndex[t + 1]].x;
        return e > n ? e : n;
      }, ti.prototype.getMinX = function (t) {
        var e = this.pts[this.startIndex[t]].x,
          n = this.pts[this.startIndex[t + 1]].x;
        return e < n ? e : n;
      }, ti.prototype.computeIntersectsForChain = function () {
        if (4 === arguments.length) {
          var t = arguments[0],
            e = arguments[1],
            n = arguments[2],
            i = arguments[3];
          this.computeIntersectsForChain(this.startIndex[t], this.startIndex[t + 1], e, e.startIndex[n], e.startIndex[n + 1], i);
        } else if (6 === arguments.length) {
          var r = arguments[0],
            o = arguments[1],
            s = arguments[2],
            a = arguments[3],
            l = arguments[4],
            u = arguments[5],
            h = this.pts[r],
            c = this.pts[o],
            p = s.pts[a],
            d = s.pts[l];
          if (o - r == 1 && l - a == 1) return u.addIntersections(this.e, r, s.e, a), null;
          if (this.env1.init(h, c), this.env2.init(p, d), !this.env1.intersects(this.env2)) return null;
          var f = Math.trunc((r + o) / 2),
            m = Math.trunc((a + l) / 2);
          r < f && (a < m && this.computeIntersectsForChain(r, f, s, a, m, u), m < l && this.computeIntersectsForChain(r, f, s, m, l, u)), f < o && (a < m && this.computeIntersectsForChain(f, o, s, a, m, u), m < l && this.computeIntersectsForChain(f, o, s, m, l, u));
        }
      }, ti.prototype.getStartIndexes = function () {
        return this.startIndex;
      }, ti.prototype.computeIntersects = function (t, e) {
        for (var n = 0; n < this.startIndex.length - 1; n++) for (var i = 0; i < t.startIndex.length - 1; i++) this.computeIntersectsForChain(n, t, i, e);
      }, ti.prototype.interfaces_ = function () {
        return [];
      }, ti.prototype.getClass = function () {
        return ti;
      };
      var ei = u(function t() {
          this._depth = Array(2).fill().map(function () {
            return Array(3);
          });
          for (var e = 0; e < 2; e++) for (var n = 0; n < 3; n++) this._depth[e][n] = t.NULL_VALUE;
        }, "t"),
        ni = {
          NULL_VALUE: {
            configurable: !0
          }
        };
      ei.prototype.getDepth = function (t, e) {
        return this._depth[t][e];
      }, ei.prototype.setDepth = function (t, e, n) {
        this._depth[t][e] = n;
      }, ei.prototype.isNull = function () {
        if (0 === arguments.length) {
          for (var t = 0; t < 2; t++) for (var e = 0; e < 3; e++) if (this._depth[t][e] !== ei.NULL_VALUE) return !1;
          return !0;
        }
        if (1 === arguments.length) {
          var n = arguments[0];
          return this._depth[n][1] === ei.NULL_VALUE;
        }
        if (2 === arguments.length) {
          var i = arguments[0],
            r = arguments[1];
          return this._depth[i][r] === ei.NULL_VALUE;
        }
      }, ei.prototype.normalize = function () {
        for (var t = 0; t < 2; t++) if (!this.isNull(t)) {
          var e = this._depth[t][1];
          this._depth[t][2] < e && (e = this._depth[t][2]), e < 0 && (e = 0);
          for (var n = 1; n < 3; n++) {
            var i = 0;
            this._depth[t][n] > e && (i = 1), this._depth[t][n] = i;
          }
        }
      }, ei.prototype.getDelta = function (t) {
        return this._depth[t][Te.RIGHT] - this._depth[t][Te.LEFT];
      }, ei.prototype.getLocation = function (t, e) {
        return this._depth[t][e] <= 0 ? C.EXTERIOR : C.INTERIOR;
      }, ei.prototype.toString = function () {
        return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
      }, ei.prototype.add = function () {
        if (1 === arguments.length) for (var t = arguments[0], e = 0; e < 2; e++) for (var n = 1; n < 3; n++) {
          var i = t.getLocation(e, n);
          i !== C.EXTERIOR && i !== C.INTERIOR || (this.isNull(e, n) ? this._depth[e][n] = ei.depthAtLocation(i) : this._depth[e][n] += ei.depthAtLocation(i));
        } else if (3 === arguments.length) {
          var r = arguments[0],
            o = arguments[1];
          arguments[2] === C.INTERIOR && this._depth[r][o]++;
        }
      }, ei.prototype.interfaces_ = function () {
        return [];
      }, ei.prototype.getClass = function () {
        return ei;
      }, ei.depthAtLocation = function (t) {
        return t === C.EXTERIOR ? 0 : t === C.INTERIOR ? 1 : ei.NULL_VALUE;
      }, ni.NULL_VALUE.get = function () {
        return -1;
      }, Object.defineProperties(ei, ni);
      var ii = function (t) {
          function e() {
            if (t.call(this), this.pts = null, this._env = null, this.eiList = new Qn(this), this._name = null, this._mce = null, this._isIsolated = !0, this._depth = new ei(), this._depthDelta = 0, 1 === arguments.length) {
              var n = arguments[0];
              e.call(this, n, null);
            } else if (2 === arguments.length) {
              var i = arguments[0],
                r = arguments[1];
              this.pts = i, this._label = r;
            }
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDepth = function () {
            return this._depth;
          }, e.prototype.getCollapsedEdge = function () {
            var t = new Array(2).fill(null);
            return t[0] = this.pts[0], t[1] = this.pts[1], new e(t, Re.toLineLabel(this._label));
          }, e.prototype.isIsolated = function () {
            return this._isIsolated;
          }, e.prototype.getCoordinates = function () {
            return this.pts;
          }, e.prototype.setIsolated = function (t) {
            this._isIsolated = t;
          }, e.prototype.setName = function (t) {
            this._name = t;
          }, e.prototype.equals = function (t) {
            if (!(t instanceof e)) return !1;
            var n = t;
            if (this.pts.length !== n.pts.length) return !1;
            for (var i = !0, r = !0, o = this.pts.length, s = 0; s < this.pts.length; s++) if (this.pts[s].equals2D(n.pts[s]) || (i = !1), this.pts[s].equals2D(n.pts[--o]) || (r = !1), !i && !r) return !1;
            return !0;
          }, e.prototype.getCoordinate = function () {
            if (0 === arguments.length) return this.pts.length > 0 ? this.pts[0] : null;
            if (1 === arguments.length) {
              var t = arguments[0];
              return this.pts[t];
            }
          }, e.prototype.print = function (t) {
            t.print("edge " + this._name + ": "), t.print("LINESTRING (");
            for (var e = 0; e < this.pts.length; e++) e > 0 && t.print(","), t.print(this.pts[e].x + " " + this.pts[e].y);
            t.print(")  " + this._label + " " + this._depthDelta);
          }, e.prototype.computeIM = function (t) {
            e.updateIM(this._label, t);
          }, e.prototype.isCollapsed = function () {
            return !!this._label.isArea() && 3 === this.pts.length && !!this.pts[0].equals(this.pts[2]);
          }, e.prototype.isClosed = function () {
            return this.pts[0].equals(this.pts[this.pts.length - 1]);
          }, e.prototype.getMaximumSegmentIndex = function () {
            return this.pts.length - 1;
          }, e.prototype.getDepthDelta = function () {
            return this._depthDelta;
          }, e.prototype.getNumPoints = function () {
            return this.pts.length;
          }, e.prototype.printReverse = function (t) {
            t.print("edge " + this._name + ": ");
            for (var e = this.pts.length - 1; e >= 0; e--) t.print(this.pts[e] + " ");
            t.println("");
          }, e.prototype.getMonotoneChainEdge = function () {
            return null === this._mce && (this._mce = new ti(this)), this._mce;
          }, e.prototype.getEnvelope = function () {
            if (null === this._env) {
              this._env = new X();
              for (var t = 0; t < this.pts.length; t++) this._env.expandToInclude(this.pts[t]);
            }
            return this._env;
          }, e.prototype.addIntersection = function (t, e, n, i) {
            var r = new M(t.getIntersection(i)),
              o = e,
              s = t.getEdgeDistance(n, i),
              a = o + 1;
            if (a < this.pts.length) {
              var l = this.pts[a];
              r.equals2D(l) && (o = a, s = 0);
            }
            this.eiList.add(r, o, s);
          }, e.prototype.toString = function () {
            var t = new O();
            t.append("edge " + this._name + ": "), t.append("LINESTRING (");
            for (var e = 0; e < this.pts.length; e++) e > 0 && t.append(","), t.append(this.pts[e].x + " " + this.pts[e].y);
            return t.append(")  " + this._label + " " + this._depthDelta), t.toString();
          }, e.prototype.isPointwiseEqual = function (t) {
            if (this.pts.length !== t.pts.length) return !1;
            for (var e = 0; e < this.pts.length; e++) if (!this.pts[e].equals2D(t.pts[e])) return !1;
            return !0;
          }, e.prototype.setDepthDelta = function (t) {
            this._depthDelta = t;
          }, e.prototype.getEdgeIntersectionList = function () {
            return this.eiList;
          }, e.prototype.addIntersections = function (t, e, n) {
            for (var i = 0; i < t.getIntersectionNum(); i++) this.addIntersection(t, e, n, i);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e.updateIM = function () {
            if (2 !== arguments.length) return t.prototype.updateIM.apply(this, arguments);
            var e = arguments[0],
              n = arguments[1];
            n.setAtLeastIfValid(e.getLocation(0, Te.ON), e.getLocation(1, Te.ON), 1), e.isArea() && (n.setAtLeastIfValid(e.getLocation(0, Te.LEFT), e.getLocation(1, Te.LEFT), 2), n.setAtLeastIfValid(e.getLocation(0, Te.RIGHT), e.getLocation(1, Te.RIGHT), 2));
          }, e;
        }(ke),
        ri = u(function (t) {
          this._workingPrecisionModel = null, this._workingNoder = null, this._geomFact = null, this._graph = null, this._edgeList = new Yn(), this._bufParams = t || null;
        }, "ii");
      ri.prototype.setWorkingPrecisionModel = function (t) {
        this._workingPrecisionModel = t;
      }, ri.prototype.insertUniqueEdge = function (t) {
        var e = this._edgeList.findEqualEdge(t);
        if (null !== e) {
          var n = e.getLabel(),
            i = t.getLabel();
          e.isPointwiseEqual(t) || (i = new Re(t.getLabel())).flip(), n.merge(i);
          var r = ri.depthDelta(i),
            o = e.getDepthDelta() + r;
          e.setDepthDelta(o);
        } else this._edgeList.add(t), t.setDepthDelta(ri.depthDelta(t.getLabel()));
      }, ri.prototype.buildSubgraphs = function (t, e) {
        for (var n = new St(), i = t.iterator(); i.hasNext();) {
          var r = i.next(),
            o = r.getRightmostCoordinate(),
            s = new Dn(n).getDepth(o);
          r.computeDepth(s), r.findResultEdges(), n.add(r), e.add(r.getDirectedEdges(), r.getNodes());
        }
      }, ri.prototype.createSubgraphs = function (t) {
        for (var e = new St(), n = t.getNodes().iterator(); n.hasNext();) {
          var i = n.next();
          if (!i.isVisited()) {
            var r = new Ne();
            r.create(i), e.add(r);
          }
        }
        return tn.sort(e, tn.reverseOrder()), e;
      }, ri.prototype.createEmptyResultGeometry = function () {
        return this._geomFact.createPolygon();
      }, ri.prototype.getNoder = function (t) {
        if (null !== this._workingNoder) return this._workingNoder;
        var e = new wn(),
          n = new ot();
        return n.setPrecisionModel(t), e.setSegmentIntersector(new Jn(n)), e;
      }, ri.prototype.buffer = function (t, e) {
        var n = this._workingPrecisionModel;
        null === n && (n = t.getPrecisionModel()), this._geomFact = t.getFactory();
        var i = new qn(n, this._bufParams),
          r = new Bn(t, e, i).getCurves();
        if (r.size() <= 0) return this.createEmptyResultGeometry();
        this.computeNodedEdges(r, n), this._graph = new We(new Hn()), this._graph.addEdges(this._edgeList.getEdges());
        var o = this.createSubgraphs(this._graph),
          s = new He(this._geomFact);
        this.buildSubgraphs(o, s);
        var a = s.getPolygons();
        return a.size() <= 0 ? this.createEmptyResultGeometry() : this._geomFact.buildGeometry(a);
      }, ri.prototype.computeNodedEdges = function (t, e) {
        var n = this.getNoder(e);
        n.computeNodes(t);
        for (var i = n.getNodedSubstrings().iterator(); i.hasNext();) {
          var r = i.next(),
            o = r.getCoordinates();
          if (2 !== o.length || !o[0].equals2D(o[1])) {
            var s = r.getData(),
              a = new ii(r.getCoordinates(), new Re(s));
            this.insertUniqueEdge(a);
          }
        }
      }, ri.prototype.setNoder = function (t) {
        this._workingNoder = t;
      }, ri.prototype.interfaces_ = function () {
        return [];
      }, ri.prototype.getClass = function () {
        return ri;
      }, ri.depthDelta = function (t) {
        var e = t.getLocation(0, Te.LEFT),
          n = t.getLocation(0, Te.RIGHT);
        return e === C.INTERIOR && n === C.EXTERIOR ? 1 : e === C.EXTERIOR && n === C.INTERIOR ? -1 : 0;
      }, ri.convertSegStrings = function (t) {
        for (var e = new ye(), n = new St(); t.hasNext();) {
          var i = t.next(),
            r = e.createLineString(i.getCoordinates());
          n.add(r);
        }
        return e.buildGeometry(n);
      };
      var oi = u(function () {
        if (this._noder = null, this._scaleFactor = null, this._offsetX = null, this._offsetY = null, this._isScaled = !1, 2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          this._noder = t, this._scaleFactor = e, this._offsetX = 0, this._offsetY = 0, this._isScaled = !this.isIntegerPrecision();
        } else if (4 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[2],
            o = arguments[3];
          this._noder = n, this._scaleFactor = i, this._offsetX = r, this._offsetY = o, this._isScaled = !this.isIntegerPrecision();
        }
      }, "ri");
      oi.prototype.rescale = function () {
        if (N(arguments[0], Et)) for (var t = arguments[0].iterator(); t.hasNext();) {
          var e = t.next();
          this.rescale(e.getCoordinates());
        } else if (arguments[0] instanceof Array) {
          for (var n = arguments[0], i = 0; i < n.length; i++) n[i].x = n[i].x / this._scaleFactor + this._offsetX, n[i].y = n[i].y / this._scaleFactor + this._offsetY;
          2 === n.length && n[0].equals2D(n[1]) && W.out.println(n);
        }
      }, oi.prototype.scale = function () {
        if (N(arguments[0], Et)) {
          for (var t = arguments[0], e = new St(), n = t.iterator(); n.hasNext();) {
            var i = n.next();
            e.add(new mn(this.scale(i.getCoordinates()), i.getData()));
          }
          return e;
        }
        if (arguments[0] instanceof Array) {
          for (var r = arguments[0], o = new Array(r.length).fill(null), s = 0; s < r.length; s++) o[s] = new M(Math.round((r[s].x - this._offsetX) * this._scaleFactor), Math.round((r[s].y - this._offsetY) * this._scaleFactor), r[s].z);
          return At.removeRepeatedPoints(o);
        }
      }, oi.prototype.isIntegerPrecision = function () {
        return 1 === this._scaleFactor;
      }, oi.prototype.getNodedSubstrings = function () {
        var t = this._noder.getNodedSubstrings();
        return this._isScaled && this.rescale(t), t;
      }, oi.prototype.computeNodes = function (t) {
        var e = t;
        this._isScaled && (e = this.scale(t)), this._noder.computeNodes(e);
      }, oi.prototype.interfaces_ = function () {
        return [En];
      }, oi.prototype.getClass = function () {
        return oi;
      };
      var si = u(function () {
          this._li = new ot(), this._segStrings = null;
          var t = arguments[0];
          this._segStrings = t;
        }, "oi"),
        ai = {
          fact: {
            configurable: !0
          }
        };
      si.prototype.checkEndPtVertexIntersections = function () {
        if (0 === arguments.length) for (var t = this._segStrings.iterator(); t.hasNext();) {
          var e = t.next().getCoordinates();
          this.checkEndPtVertexIntersections(e[0], this._segStrings), this.checkEndPtVertexIntersections(e[e.length - 1], this._segStrings);
        } else if (2 === arguments.length) for (var n = arguments[0], i = arguments[1].iterator(); i.hasNext();) for (var r = i.next().getCoordinates(), o = 1; o < r.length - 1; o++) if (r[o].equals(n)) throw new tt("found endpt/interior pt intersection at index " + o + " :pt " + n);
      }, si.prototype.checkInteriorIntersections = function () {
        if (0 === arguments.length) for (var t = this._segStrings.iterator(); t.hasNext();) for (var e = t.next(), n = this._segStrings.iterator(); n.hasNext();) {
          var i = n.next();
          this.checkInteriorIntersections(e, i);
        } else if (2 === arguments.length) for (var r = arguments[0], o = arguments[1], s = r.getCoordinates(), a = o.getCoordinates(), l = 0; l < s.length - 1; l++) for (var u = 0; u < a.length - 1; u++) this.checkInteriorIntersections(r, l, o, u);else if (4 === arguments.length) {
          var h = arguments[0],
            c = arguments[1],
            p = arguments[2],
            d = arguments[3];
          if (h === p && c === d) return null;
          var f = h.getCoordinates()[c],
            m = h.getCoordinates()[c + 1],
            g = p.getCoordinates()[d],
            v = p.getCoordinates()[d + 1];
          if (this._li.computeIntersection(f, m, g, v), this._li.hasIntersection() && (this._li.isProper() || this.hasInteriorIntersection(this._li, f, m) || this.hasInteriorIntersection(this._li, g, v))) throw new tt("found non-noded intersection at " + f + "-" + m + " and " + g + "-" + v);
        }
      }, si.prototype.checkValid = function () {
        this.checkEndPtVertexIntersections(), this.checkInteriorIntersections(), this.checkCollapses();
      }, si.prototype.checkCollapses = function () {
        if (0 === arguments.length) for (var t = this._segStrings.iterator(); t.hasNext();) {
          var e = t.next();
          this.checkCollapses(e);
        } else if (1 === arguments.length) for (var n = arguments[0].getCoordinates(), i = 0; i < n.length - 2; i++) this.checkCollapse(n[i], n[i + 1], n[i + 2]);
      }, si.prototype.hasInteriorIntersection = function (t, e, n) {
        for (var i = 0; i < t.getIntersectionNum(); i++) {
          var r = t.getIntersection(i);
          if (!r.equals(e) && !r.equals(n)) return !0;
        }
        return !1;
      }, si.prototype.checkCollapse = function (t, e, n) {
        if (t.equals(n)) throw new tt("found non-noded collapse at " + si.fact.createLineString([t, e, n]));
      }, si.prototype.interfaces_ = function () {
        return [];
      }, si.prototype.getClass = function () {
        return si;
      }, ai.fact.get = function () {
        return new ye();
      }, Object.defineProperties(si, ai);
      var li = u(function () {
          this._li = null, this._pt = null, this._originalPt = null, this._ptScaled = null, this._p0Scaled = null, this._p1Scaled = null, this._scaleFactor = null, this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, this._corner = new Array(4).fill(null), this._safeEnv = null;
          var t = arguments[0],
            e = arguments[1],
            n = arguments[2];
          if (this._originalPt = t, this._pt = t, this._scaleFactor = e, this._li = n, e <= 0) throw new _("Scale factor must be non-zero");
          1 !== e && (this._pt = new M(this.scale(t.x), this.scale(t.y)), this._p0Scaled = new M(), this._p1Scaled = new M()), this.initCorners(this._pt);
        }, "ai"),
        ui = {
          SAFE_ENV_EXPANSION_FACTOR: {
            configurable: !0
          }
        };
      li.prototype.intersectsScaled = function (t, e) {
        var n = Math.min(t.x, e.x),
          i = Math.max(t.x, e.x),
          r = Math.min(t.y, e.y),
          o = Math.max(t.y, e.y),
          s = this._maxx < n || this._minx > i || this._maxy < r || this._miny > o;
        if (s) return !1;
        var a = this.intersectsToleranceSquare(t, e);
        return nt.isTrue(!(s && a), "Found bad envelope test"), a;
      }, li.prototype.initCorners = function (t) {
        this._minx = t.x - .5, this._maxx = t.x + .5, this._miny = t.y - .5, this._maxy = t.y + .5, this._corner[0] = new M(this._maxx, this._maxy), this._corner[1] = new M(this._minx, this._maxy), this._corner[2] = new M(this._minx, this._miny), this._corner[3] = new M(this._maxx, this._miny);
      }, li.prototype.intersects = function (t, e) {
        return 1 === this._scaleFactor ? this.intersectsScaled(t, e) : (this.copyScaled(t, this._p0Scaled), this.copyScaled(e, this._p1Scaled), this.intersectsScaled(this._p0Scaled, this._p1Scaled));
      }, li.prototype.scale = function (t) {
        return Math.round(t * this._scaleFactor);
      }, li.prototype.getCoordinate = function () {
        return this._originalPt;
      }, li.prototype.copyScaled = function (t, e) {
        e.x = this.scale(t.x), e.y = this.scale(t.y);
      }, li.prototype.getSafeEnvelope = function () {
        if (null === this._safeEnv) {
          var t = li.SAFE_ENV_EXPANSION_FACTOR / this._scaleFactor;
          this._safeEnv = new X(this._originalPt.x - t, this._originalPt.x + t, this._originalPt.y - t, this._originalPt.y + t);
        }
        return this._safeEnv;
      }, li.prototype.intersectsPixelClosure = function (t, e) {
        return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!(this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), this._li.hasIntersection()))));
      }, li.prototype.intersectsToleranceSquare = function (t, e) {
        var n = !1,
          i = !1;
        return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!(this._li.isProper() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), this._li.isProper() || (this._li.hasIntersection() && (n = !0), this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), this._li.isProper() || (this._li.hasIntersection() && (i = !0), this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), this._li.isProper() || n && i || t.equals(this._pt) || e.equals(this._pt)))));
      }, li.prototype.addSnappedNode = function (t, e) {
        var n = t.getCoordinate(e),
          i = t.getCoordinate(e + 1);
        return !!this.intersects(n, i) && (t.addIntersection(this.getCoordinate(), e), !0);
      }, li.prototype.interfaces_ = function () {
        return [];
      }, li.prototype.getClass = function () {
        return li;
      }, ui.SAFE_ENV_EXPANSION_FACTOR.get = function () {
        return .75;
      }, Object.defineProperties(li, ui);
      var hi = u(function () {
        this.tempEnv1 = new X(), this.selectedSegment = new gn();
      }, "li");
      hi.prototype.select = function () {
        if (1 !== arguments.length && 2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          t.getLineSegment(e, this.selectedSegment), this.select(this.selectedSegment);
        }
      }, hi.prototype.interfaces_ = function () {
        return [];
      }, hi.prototype.getClass = function () {
        return hi;
      };
      var ci = u(function () {
          this._index = null;
          var t = arguments[0];
          this._index = t;
        }, "ci"),
        pi = {
          HotPixelSnapAction: {
            configurable: !0
          }
        };
      ci.prototype.snap = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return this.snap(t, null, -1);
        }
        if (3 === arguments.length) {
          var e = arguments[0],
            n = arguments[1],
            i = arguments[2],
            r = e.getSafeEnvelope(),
            o = new di(e, n, i);
          return this._index.query(r, {
            interfaces_: function () {
              return [Je];
            },
            visitItem: function (t) {
              t.select(r, o);
            }
          }), o.isNodeAdded();
        }
      }, ci.prototype.interfaces_ = function () {
        return [];
      }, ci.prototype.getClass = function () {
        return ci;
      }, pi.HotPixelSnapAction.get = function () {
        return di;
      }, Object.defineProperties(ci, pi);
      var di = function (t) {
          function e() {
            t.call(this), this._hotPixel = null, this._parentEdge = null, this._hotPixelVertexIndex = null, this._isNodeAdded = !1;
            var e = arguments[0],
              n = arguments[1],
              i = arguments[2];
            this._hotPixel = e, this._parentEdge = n, this._hotPixelVertexIndex = i;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isNodeAdded = function () {
            return this._isNodeAdded;
          }, e.prototype.select = function () {
            if (2 !== arguments.length) return t.prototype.select.apply(this, arguments);
            var e = arguments[0],
              n = arguments[1],
              i = e.getContext();
            if (null !== this._parentEdge && i === this._parentEdge && n === this._hotPixelVertexIndex) return null;
            this._isNodeAdded = this._hotPixel.addSnappedNode(i, n);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(hi),
        fi = u(function () {
          this._li = null, this._interiorIntersections = null;
          var t = arguments[0];
          this._li = t, this._interiorIntersections = new St();
        }, "fi");
      fi.prototype.processIntersections = function (t, e, n, i) {
        if (t === n && e === i) return null;
        var r = t.getCoordinates()[e],
          o = t.getCoordinates()[e + 1],
          s = n.getCoordinates()[i],
          a = n.getCoordinates()[i + 1];
        if (this._li.computeIntersection(r, o, s, a), this._li.hasIntersection() && this._li.isInteriorIntersection()) {
          for (var l = 0; l < this._li.getIntersectionNum(); l++) this._interiorIntersections.add(this._li.getIntersection(l));
          t.addIntersections(this._li, e, 0), n.addIntersections(this._li, i, 1);
        }
      }, fi.prototype.isDone = function () {
        return !1;
      }, fi.prototype.getInteriorIntersections = function () {
        return this._interiorIntersections;
      }, fi.prototype.interfaces_ = function () {
        return [Zn];
      }, fi.prototype.getClass = function () {
        return fi;
      };
      var mi = u(function () {
        this._pm = null, this._li = null, this._scaleFactor = null, this._noder = null, this._pointSnapper = null, this._nodedSegStrings = null;
        var t = arguments[0];
        this._pm = t, this._li = new ot(), this._li.setPrecisionModel(t), this._scaleFactor = t.getScale();
      }, "gi");
      mi.prototype.checkCorrectness = function (t) {
        var e = mn.getNodedSubstrings(t),
          n = new si(e);
        try {
          n.checkValid();
        } catch (t) {
          if (!(t instanceof j)) throw t;
          t.printStackTrace();
        }
      }, mi.prototype.getNodedSubstrings = function () {
        return mn.getNodedSubstrings(this._nodedSegStrings);
      }, mi.prototype.snapRound = function (t, e) {
        var n = this.findInteriorIntersections(t, e);
        this.computeIntersectionSnaps(n), this.computeVertexSnaps(t);
      }, mi.prototype.findInteriorIntersections = function (t, e) {
        var n = new fi(e);
        return this._noder.setSegmentIntersector(n), this._noder.computeNodes(t), n.getInteriorIntersections();
      }, mi.prototype.computeVertexSnaps = function () {
        if (N(arguments[0], Et)) for (var t = arguments[0].iterator(); t.hasNext();) {
          var e = t.next();
          this.computeVertexSnaps(e);
        } else if (arguments[0] instanceof mn) for (var n = arguments[0], i = n.getCoordinates(), r = 0; r < i.length; r++) {
          var o = new li(i[r], this._scaleFactor, this._li);
          this._pointSnapper.snap(o, n, r) && n.addIntersection(i[r], r);
        }
      }, mi.prototype.computeNodes = function (t) {
        this._nodedSegStrings = t, this._noder = new wn(), this._pointSnapper = new ci(this._noder.getIndex()), this.snapRound(t, this._li);
      }, mi.prototype.computeIntersectionSnaps = function (t) {
        for (var e = t.iterator(); e.hasNext();) {
          var n = e.next(),
            i = new li(n, this._scaleFactor, this._li);
          this._pointSnapper.snap(i);
        }
      }, mi.prototype.interfaces_ = function () {
        return [En];
      }, mi.prototype.getClass = function () {
        return mi;
      };
      var gi = u(function () {
          if (this._argGeom = null, this._distance = null, this._bufParams = new Mn(), this._resultGeometry = null, this._saveException = null, 1 === arguments.length) {
            var t = arguments[0];
            this._argGeom = t;
          } else if (2 === arguments.length) {
            var e = arguments[0],
              n = arguments[1];
            this._argGeom = e, this._bufParams = n;
          }
        }, "di"),
        vi = {
          CAP_ROUND: {
            configurable: !0
          },
          CAP_BUTT: {
            configurable: !0
          },
          CAP_FLAT: {
            configurable: !0
          },
          CAP_SQUARE: {
            configurable: !0
          },
          MAX_PRECISION_DIGITS: {
            configurable: !0
          }
        };
      gi.prototype.bufferFixedPrecision = function (t) {
        var e = new oi(new mi(new fe(1)), t.getScale()),
          n = new ri(this._bufParams);
        n.setWorkingPrecisionModel(t), n.setNoder(e), this._resultGeometry = n.buffer(this._argGeom, this._distance);
      }, gi.prototype.bufferReducedPrecision = function () {
        var t = this;
        if (0 === arguments.length) {
          for (var e = gi.MAX_PRECISION_DIGITS; e >= 0; e--) {
            try {
              t.bufferReducedPrecision(e);
            } catch (e) {
              if (!(e instanceof Ce)) throw e;
              t._saveException = e;
            }
            if (null !== t._resultGeometry) return null;
          }
          throw this._saveException;
        }
        if (1 === arguments.length) {
          var n = arguments[0],
            i = gi.precisionScaleFactor(this._argGeom, this._distance, n),
            r = new fe(i);
          this.bufferFixedPrecision(r);
        }
      }, gi.prototype.computeGeometry = function () {
        if (this.bufferOriginalPrecision(), null !== this._resultGeometry) return null;
        var t = this._argGeom.getFactory().getPrecisionModel();
        t.getType() === fe.FIXED ? this.bufferFixedPrecision(t) : this.bufferReducedPrecision();
      }, gi.prototype.setQuadrantSegments = function (t) {
        this._bufParams.setQuadrantSegments(t);
      }, gi.prototype.bufferOriginalPrecision = function () {
        try {
          var t = new ri(this._bufParams);
          this._resultGeometry = t.buffer(this._argGeom, this._distance);
        } catch (t) {
          if (!(t instanceof tt)) throw t;
          this._saveException = t;
        }
      }, gi.prototype.getResultGeometry = function (t) {
        return this._distance = t, this.computeGeometry(), this._resultGeometry;
      }, gi.prototype.setEndCapStyle = function (t) {
        this._bufParams.setEndCapStyle(t);
      }, gi.prototype.interfaces_ = function () {
        return [];
      }, gi.prototype.getClass = function () {
        return gi;
      }, gi.bufferOp = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          return new gi(t).getResultGeometry(e);
        }
        if (3 === arguments.length) {
          if (Number.isInteger(arguments[2]) && arguments[0] instanceof ct && "number" == typeof arguments[1]) {
            var n = arguments[0],
              i = arguments[1],
              r = arguments[2],
              o = new gi(n);
            return o.setQuadrantSegments(r), o.getResultGeometry(i);
          }
          if (arguments[2] instanceof Mn && arguments[0] instanceof ct && "number" == typeof arguments[1]) {
            var s = arguments[0],
              a = arguments[1],
              l = arguments[2];
            return new gi(s, l).getResultGeometry(a);
          }
        } else if (4 === arguments.length) {
          var u = arguments[0],
            h = arguments[1],
            c = arguments[2],
            p = arguments[3],
            d = new gi(u);
          return d.setQuadrantSegments(c), d.setEndCapStyle(p), d.getResultGeometry(h);
        }
      }, gi.precisionScaleFactor = function (t, e, n) {
        var i = t.getEnvelopeInternal(),
          r = L.max(Math.abs(i.getMaxX()), Math.abs(i.getMaxY()), Math.abs(i.getMinX()), Math.abs(i.getMinY())) + 2 * (e > 0 ? e : 0),
          o = n - Math.trunc(Math.log(r) / Math.log(10) + 1);
        return Math.pow(10, o);
      }, vi.CAP_ROUND.get = function () {
        return Mn.CAP_ROUND;
      }, vi.CAP_BUTT.get = function () {
        return Mn.CAP_FLAT;
      }, vi.CAP_FLAT.get = function () {
        return Mn.CAP_FLAT;
      }, vi.CAP_SQUARE.get = function () {
        return Mn.CAP_SQUARE;
      }, vi.MAX_PRECISION_DIGITS.get = function () {
        return 12;
      }, Object.defineProperties(gi, vi);
      var yi = u(function () {
        this._pt = [new M(), new M()], this._distance = x.NaN, this._isNull = !0;
      }, "_i");
      yi.prototype.getCoordinates = function () {
        return this._pt;
      }, yi.prototype.getCoordinate = function (t) {
        return this._pt[t];
      }, yi.prototype.setMinimum = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.setMinimum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          if (this._isNull) return this.initialize(e, n), null;
          var i = e.distance(n);
          i < this._distance && this.initialize(e, n, i);
        }
      }, yi.prototype.initialize = function () {
        if (0 === arguments.length) this._isNull = !0;else if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          this._pt[0].setCoordinate(t), this._pt[1].setCoordinate(e), this._distance = t.distance(e), this._isNull = !1;
        } else if (3 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[2];
          this._pt[0].setCoordinate(n), this._pt[1].setCoordinate(i), this._distance = r, this._isNull = !1;
        }
      }, yi.prototype.getDistance = function () {
        return this._distance;
      }, yi.prototype.setMaximum = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.setMaximum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          if (this._isNull) return this.initialize(e, n), null;
          var i = e.distance(n);
          i > this._distance && this.initialize(e, n, i);
        }
      }, yi.prototype.interfaces_ = function () {
        return [];
      }, yi.prototype.getClass = function () {
        return yi;
      };
      var _i = u(function () {}, "mi");
      _i.prototype.interfaces_ = function () {
        return [];
      }, _i.prototype.getClass = function () {
        return _i;
      }, _i.computeDistance = function () {
        if (arguments[2] instanceof yi && arguments[0] instanceof Jt && arguments[1] instanceof M) for (var t = arguments[0], e = arguments[1], n = arguments[2], i = t.getCoordinates(), r = new gn(), o = 0; o < i.length - 1; o++) {
          r.setCoordinates(i[o], i[o + 1]);
          var s = r.closestPoint(e);
          n.setMinimum(s, e);
        } else if (arguments[2] instanceof yi && arguments[0] instanceof te && arguments[1] instanceof M) {
          var a = arguments[0],
            l = arguments[1],
            u = arguments[2];
          _i.computeDistance(a.getExteriorRing(), l, u);
          for (var h = 0; h < a.getNumInteriorRing(); h++) _i.computeDistance(a.getInteriorRingN(h), l, u);
        } else if (arguments[2] instanceof yi && arguments[0] instanceof ct && arguments[1] instanceof M) {
          var c = arguments[0],
            p = arguments[1],
            d = arguments[2];
          if (c instanceof Jt) _i.computeDistance(c, p, d);else if (c instanceof te) _i.computeDistance(c, p, d);else if (c instanceof jt) for (var f = c, m = 0; m < f.getNumGeometries(); m++) {
            var g = f.getGeometryN(m);
            _i.computeDistance(g, p, d);
          } else d.setMinimum(c.getCoordinate(), p);
        } else if (arguments[2] instanceof yi && arguments[0] instanceof gn && arguments[1] instanceof M) {
          var v = arguments[0],
            y = arguments[1],
            _ = arguments[2],
            x = v.closestPoint(y);
          _.setMinimum(x, y);
        }
      };
      var xi = u(function (t) {
          this._maxPtDist = new yi(), this._inputGeom = t || null;
        }, "vi"),
        Ei = {
          MaxPointDistanceFilter: {
            configurable: !0
          },
          MaxMidpointDistanceFilter: {
            configurable: !0
          }
        };
      xi.prototype.computeMaxMidpointDistance = function (t) {
        var e = new wi(this._inputGeom);
        t.apply(e), this._maxPtDist.setMaximum(e.getMaxPointDistance());
      }, xi.prototype.computeMaxVertexDistance = function (t) {
        var e = new bi(this._inputGeom);
        t.apply(e), this._maxPtDist.setMaximum(e.getMaxPointDistance());
      }, xi.prototype.findDistance = function (t) {
        return this.computeMaxVertexDistance(t), this.computeMaxMidpointDistance(t), this._maxPtDist.getDistance();
      }, xi.prototype.getDistancePoints = function () {
        return this._maxPtDist;
      }, xi.prototype.interfaces_ = function () {
        return [];
      }, xi.prototype.getClass = function () {
        return xi;
      }, Ei.MaxPointDistanceFilter.get = function () {
        return bi;
      }, Ei.MaxMidpointDistanceFilter.get = function () {
        return wi;
      }, Object.defineProperties(xi, Ei);
      var bi = u(function (t) {
        this._maxPtDist = new yi(), this._minPtDist = new yi(), this._geom = t || null;
      }, "Ei");
      bi.prototype.filter = function (t) {
        this._minPtDist.initialize(), _i.computeDistance(this._geom, t, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
      }, bi.prototype.getMaxPointDistance = function () {
        return this._maxPtDist;
      }, bi.prototype.interfaces_ = function () {
        return [ft];
      }, bi.prototype.getClass = function () {
        return bi;
      };
      var wi = u(function (t) {
        this._maxPtDist = new yi(), this._minPtDist = new yi(), this._geom = t || null;
      }, "xi");
      wi.prototype.filter = function (t, e) {
        if (0 === e) return null;
        var n = t.getCoordinate(e - 1),
          i = t.getCoordinate(e),
          r = new M((n.x + i.x) / 2, (n.y + i.y) / 2);
        this._minPtDist.initialize(), _i.computeDistance(this._geom, r, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
      }, wi.prototype.isDone = function () {
        return !1;
      }, wi.prototype.isGeometryChanged = function () {
        return !1;
      }, wi.prototype.getMaxPointDistance = function () {
        return this._maxPtDist;
      }, wi.prototype.interfaces_ = function () {
        return [Vt];
      }, wi.prototype.getClass = function () {
        return wi;
      };
      var Si = u(function (t) {
        this._comps = t || null;
      }, "Ni");
      Si.prototype.filter = function (t) {
        t instanceof te && this._comps.add(t);
      }, Si.prototype.interfaces_ = function () {
        return [zt];
      }, Si.prototype.getClass = function () {
        return Si;
      }, Si.getPolygons = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return Si.getPolygons(t, new St());
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          return e instanceof te ? n.add(e) : e instanceof jt && e.apply(new Si(n)), n;
        }
      };
      var Mi = u(function () {
        if (this._lines = null, this._isForcedToLineString = !1, 1 === arguments.length) {
          var t = arguments[0];
          this._lines = t;
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          this._lines = e, this._isForcedToLineString = n;
        }
      }, "Ci");
      Mi.prototype.filter = function (t) {
        if (this._isForcedToLineString && t instanceof ne) {
          var e = t.getFactory().createLineString(t.getCoordinateSequence());
          return this._lines.add(e), null;
        }
        t instanceof Jt && this._lines.add(t);
      }, Mi.prototype.setForceToLineString = function (t) {
        this._isForcedToLineString = t;
      }, Mi.prototype.interfaces_ = function () {
        return [ht];
      }, Mi.prototype.getClass = function () {
        return Mi;
      }, Mi.getGeometry = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return t.getFactory().buildGeometry(Mi.getLines(t));
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          return e.getFactory().buildGeometry(Mi.getLines(e, n));
        }
      }, Mi.getLines = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return Mi.getLines(t, !1);
        }
        if (2 === arguments.length) {
          if (N(arguments[0], Et) && N(arguments[1], Et)) {
            for (var e = arguments[0], n = arguments[1], i = e.iterator(); i.hasNext();) {
              var r = i.next();
              Mi.getLines(r, n);
            }
            return n;
          }
          if (arguments[0] instanceof ct && "boolean" == typeof arguments[1]) {
            var o = arguments[0],
              s = arguments[1],
              a = new St();
            return o.apply(new Mi(a, s)), a;
          }
          if (arguments[0] instanceof ct && N(arguments[1], Et)) {
            var l = arguments[0],
              u = arguments[1];
            return l instanceof Jt ? u.add(l) : l.apply(new Mi(u)), u;
          }
        } else if (3 === arguments.length) {
          if ("boolean" == typeof arguments[2] && N(arguments[0], Et) && N(arguments[1], Et)) {
            for (var h = arguments[0], c = arguments[1], p = arguments[2], d = h.iterator(); d.hasNext();) {
              var f = d.next();
              Mi.getLines(f, c, p);
            }
            return c;
          }
          if ("boolean" == typeof arguments[2] && arguments[0] instanceof ct && N(arguments[1], Et)) {
            var m = arguments[0],
              g = arguments[1],
              v = arguments[2];
            return m.apply(new Mi(g, v)), g;
          }
        }
      };
      var Ti = u(function () {
        if (this._boundaryRule = mt.OGC_SFS_BOUNDARY_RULE, this._isIn = null, this._numBoundaries = null, 0 !== arguments.length && 1 === arguments.length) {
          var t = arguments[0];
          if (null === t) throw new _("Rule must be non-null");
          this._boundaryRule = t;
        }
      }, "Si");
      Ti.prototype.locateInternal = function () {
        if (arguments[0] instanceof M && arguments[1] instanceof te) {
          var t = arguments[0],
            e = arguments[1];
          if (e.isEmpty()) return C.EXTERIOR;
          var n = e.getExteriorRing(),
            i = this.locateInPolygonRing(t, n);
          if (i === C.EXTERIOR) return C.EXTERIOR;
          if (i === C.BOUNDARY) return C.BOUNDARY;
          for (var r = 0; r < e.getNumInteriorRing(); r++) {
            var o = e.getInteriorRingN(r),
              s = this.locateInPolygonRing(t, o);
            if (s === C.INTERIOR) return C.EXTERIOR;
            if (s === C.BOUNDARY) return C.BOUNDARY;
          }
          return C.INTERIOR;
        }
        if (arguments[0] instanceof M && arguments[1] instanceof Jt) {
          var a = arguments[0],
            l = arguments[1];
          if (!l.getEnvelopeInternal().intersects(a)) return C.EXTERIOR;
          var u = l.getCoordinates();
          return l.isClosed() || !a.equals(u[0]) && !a.equals(u[u.length - 1]) ? lt.isOnLine(a, u) ? C.INTERIOR : C.EXTERIOR : C.BOUNDARY;
        }
        if (arguments[0] instanceof M && arguments[1] instanceof Qt) {
          var h = arguments[0];
          return arguments[1].getCoordinate().equals2D(h) ? C.INTERIOR : C.EXTERIOR;
        }
      }, Ti.prototype.locateInPolygonRing = function (t, e) {
        return e.getEnvelopeInternal().intersects(t) ? lt.locatePointInRing(t, e.getCoordinates()) : C.EXTERIOR;
      }, Ti.prototype.intersects = function (t, e) {
        return this.locate(t, e) !== C.EXTERIOR;
      }, Ti.prototype.updateLocationInfo = function (t) {
        t === C.INTERIOR && (this._isIn = !0), t === C.BOUNDARY && this._numBoundaries++;
      }, Ti.prototype.computeLocation = function (t, e) {
        if (e instanceof Qt && this.updateLocationInfo(this.locateInternal(t, e)), e instanceof Jt) this.updateLocationInfo(this.locateInternal(t, e));else if (e instanceof te) this.updateLocationInfo(this.locateInternal(t, e));else if (e instanceof Gt) for (var n = e, i = 0; i < n.getNumGeometries(); i++) {
          var r = n.getGeometryN(i);
          this.updateLocationInfo(this.locateInternal(t, r));
        } else if (e instanceof ie) for (var o = e, s = 0; s < o.getNumGeometries(); s++) {
          var a = o.getGeometryN(s);
          this.updateLocationInfo(this.locateInternal(t, a));
        } else if (e instanceof jt) for (var l = new Vn(e); l.hasNext();) {
          var u = l.next();
          u !== e && this.computeLocation(t, u);
        }
      }, Ti.prototype.locate = function (t, e) {
        return e.isEmpty() ? C.EXTERIOR : e instanceof Jt || e instanceof te ? this.locateInternal(t, e) : (this._isIn = !1, this._numBoundaries = 0, this.computeLocation(t, e), this._boundaryRule.isInBoundary(this._numBoundaries) ? C.BOUNDARY : this._numBoundaries > 0 || this._isIn ? C.INTERIOR : C.EXTERIOR);
      }, Ti.prototype.interfaces_ = function () {
        return [];
      }, Ti.prototype.getClass = function () {
        return Ti;
      };
      var Ai = u(function t() {
          if (this._component = null, this._segIndex = null, this._pt = null, 2 === arguments.length) {
            var e = arguments[0],
              n = arguments[1];
            t.call(this, e, t.INSIDE_AREA, n);
          } else if (3 === arguments.length) {
            var i = arguments[0],
              r = arguments[1],
              o = arguments[2];
            this._component = i, this._segIndex = r, this._pt = o;
          }
        }, "t"),
        Pi = {
          INSIDE_AREA: {
            configurable: !0
          }
        };
      Ai.prototype.isInsideArea = function () {
        return this._segIndex === Ai.INSIDE_AREA;
      }, Ai.prototype.getCoordinate = function () {
        return this._pt;
      }, Ai.prototype.getGeometryComponent = function () {
        return this._component;
      }, Ai.prototype.getSegmentIndex = function () {
        return this._segIndex;
      }, Ai.prototype.interfaces_ = function () {
        return [];
      }, Ai.prototype.getClass = function () {
        return Ai;
      }, Pi.INSIDE_AREA.get = function () {
        return -1;
      }, Object.defineProperties(Ai, Pi);
      var Ci = u(function (t) {
        this._pts = t || null;
      }, "wi");
      Ci.prototype.filter = function (t) {
        t instanceof Qt && this._pts.add(t);
      }, Ci.prototype.interfaces_ = function () {
        return [zt];
      }, Ci.prototype.getClass = function () {
        return Ci;
      }, Ci.getPoints = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return t instanceof Qt ? tn.singletonList(t) : Ci.getPoints(t, new St());
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          return e instanceof Qt ? n.add(e) : e instanceof jt && e.apply(new Ci(n)), n;
        }
      };
      var Ii = u(function () {
        this._locations = null;
        var t = arguments[0];
        this._locations = t;
      }, "Oi");
      Ii.prototype.filter = function (t) {
        (t instanceof Qt || t instanceof Jt || t instanceof te) && this._locations.add(new Ai(t, 0, t.getCoordinate()));
      }, Ii.prototype.interfaces_ = function () {
        return [zt];
      }, Ii.prototype.getClass = function () {
        return Ii;
      }, Ii.getLocations = function (t) {
        var e = new St();
        return t.apply(new Ii(e)), e;
      };
      var Ni = u(function () {
        if (this._geom = null, this._terminateDistance = 0, this._ptLocator = new Ti(), this._minDistanceLocation = null, this._minDistance = x.MAX_VALUE, 2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          this._geom = [t, e], this._terminateDistance = 0;
        } else if (3 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[2];
          this._geom = new Array(2).fill(null), this._geom[0] = n, this._geom[1] = i, this._terminateDistance = r;
        }
      }, "Ti");
      Ni.prototype.computeContainmentDistance = function () {
        if (0 === arguments.length) {
          var t = new Array(2).fill(null);
          if (this.computeContainmentDistance(0, t), this._minDistance <= this._terminateDistance) return null;
          this.computeContainmentDistance(1, t);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1],
            i = 1 - e,
            r = Si.getPolygons(this._geom[e]);
          if (r.size() > 0) {
            var o = Ii.getLocations(this._geom[i]);
            if (this.computeContainmentDistance(o, r, n), this._minDistance <= this._terminateDistance) return this._minDistanceLocation[i] = n[0], this._minDistanceLocation[e] = n[1], null;
          }
        } else if (3 === arguments.length) if (arguments[2] instanceof Array && N(arguments[0], wt) && N(arguments[1], wt)) {
          for (var s = arguments[0], a = arguments[1], l = arguments[2], u = 0; u < s.size(); u++) for (var h = s.get(u), c = 0; c < a.size(); c++) if (this.computeContainmentDistance(h, a.get(c), l), this._minDistance <= this._terminateDistance) return null;
        } else if (arguments[2] instanceof Array && arguments[0] instanceof Ai && arguments[1] instanceof te) {
          var p = arguments[0],
            d = arguments[1],
            f = arguments[2],
            m = p.getCoordinate();
          if (C.EXTERIOR !== this._ptLocator.locate(m, d)) return this._minDistance = 0, f[0] = p, f[1] = new Ai(d, m), null;
        }
      }, Ni.prototype.computeMinDistanceLinesPoints = function (t, e, n) {
        for (var i = 0; i < t.size(); i++) for (var r = t.get(i), o = 0; o < e.size(); o++) {
          var s = e.get(o);
          if (this.computeMinDistance(r, s, n), this._minDistance <= this._terminateDistance) return null;
        }
      }, Ni.prototype.computeFacetDistance = function () {
        var t = new Array(2).fill(null),
          e = Mi.getLines(this._geom[0]),
          n = Mi.getLines(this._geom[1]),
          i = Ci.getPoints(this._geom[0]),
          r = Ci.getPoints(this._geom[1]);
        return this.computeMinDistanceLines(e, n, t), this.updateMinDistance(t, !1), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistanceLinesPoints(e, r, t), this.updateMinDistance(t, !1), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistanceLinesPoints(n, i, t), this.updateMinDistance(t, !0), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistancePoints(i, r, t), void this.updateMinDistance(t, !1))));
      }, Ni.prototype.nearestLocations = function () {
        return this.computeMinDistance(), this._minDistanceLocation;
      }, Ni.prototype.updateMinDistance = function (t, e) {
        if (null === t[0]) return null;
        e ? (this._minDistanceLocation[0] = t[1], this._minDistanceLocation[1] = t[0]) : (this._minDistanceLocation[0] = t[0], this._minDistanceLocation[1] = t[1]);
      }, Ni.prototype.nearestPoints = function () {
        return this.computeMinDistance(), [this._minDistanceLocation[0].getCoordinate(), this._minDistanceLocation[1].getCoordinate()];
      }, Ni.prototype.computeMinDistance = function () {
        if (0 === arguments.length) {
          if (null !== this._minDistanceLocation || (this._minDistanceLocation = new Array(2).fill(null), this.computeContainmentDistance(), this._minDistance <= this._terminateDistance)) return null;
          this.computeFacetDistance();
        } else if (3 === arguments.length) if (arguments[2] instanceof Array && arguments[0] instanceof Jt && arguments[1] instanceof Qt) {
          var t = arguments[0],
            e = arguments[1],
            n = arguments[2];
          if (t.getEnvelopeInternal().distance(e.getEnvelopeInternal()) > this._minDistance) return null;
          for (var i = t.getCoordinates(), r = e.getCoordinate(), o = 0; o < i.length - 1; o++) {
            var s = lt.distancePointLine(r, i[o], i[o + 1]);
            if (s < this._minDistance) {
              this._minDistance = s;
              var a = new gn(i[o], i[o + 1]).closestPoint(r);
              n[0] = new Ai(t, o, a), n[1] = new Ai(e, 0, r);
            }
            if (this._minDistance <= this._terminateDistance) return null;
          }
        } else if (arguments[2] instanceof Array && arguments[0] instanceof Jt && arguments[1] instanceof Jt) {
          var l = arguments[0],
            u = arguments[1],
            h = arguments[2];
          if (l.getEnvelopeInternal().distance(u.getEnvelopeInternal()) > this._minDistance) return null;
          for (var c = l.getCoordinates(), p = u.getCoordinates(), d = 0; d < c.length - 1; d++) for (var f = 0; f < p.length - 1; f++) {
            var m = lt.distanceLineLine(c[d], c[d + 1], p[f], p[f + 1]);
            if (m < this._minDistance) {
              this._minDistance = m;
              var g = new gn(c[d], c[d + 1]),
                v = new gn(p[f], p[f + 1]),
                y = g.closestPoints(v);
              h[0] = new Ai(l, d, y[0]), h[1] = new Ai(u, f, y[1]);
            }
            if (this._minDistance <= this._terminateDistance) return null;
          }
        }
      }, Ni.prototype.computeMinDistancePoints = function (t, e, n) {
        for (var i = 0; i < t.size(); i++) for (var r = t.get(i), o = 0; o < e.size(); o++) {
          var s = e.get(o),
            a = r.getCoordinate().distance(s.getCoordinate());
          if (a < this._minDistance && (this._minDistance = a, n[0] = new Ai(r, 0, r.getCoordinate()), n[1] = new Ai(s, 0, s.getCoordinate())), this._minDistance <= this._terminateDistance) return null;
        }
      }, Ni.prototype.distance = function () {
        if (null === this._geom[0] || null === this._geom[1]) throw new _("null geometries are not supported");
        return this._geom[0].isEmpty() || this._geom[1].isEmpty() ? 0 : (this.computeMinDistance(), this._minDistance);
      }, Ni.prototype.computeMinDistanceLines = function (t, e, n) {
        for (var i = 0; i < t.size(); i++) for (var r = t.get(i), o = 0; o < e.size(); o++) {
          var s = e.get(o);
          if (this.computeMinDistance(r, s, n), this._minDistance <= this._terminateDistance) return null;
        }
      }, Ni.prototype.interfaces_ = function () {
        return [];
      }, Ni.prototype.getClass = function () {
        return Ni;
      }, Ni.distance = function (t, e) {
        return new Ni(t, e).distance();
      }, Ni.isWithinDistance = function (t, e, n) {
        return new Ni(t, e, n).distance() <= n;
      }, Ni.nearestPoints = function (t, e) {
        return new Ni(t, e).nearestPoints();
      };
      var Li = u(function () {
        this._pt = [new M(), new M()], this._distance = x.NaN, this._isNull = !0;
      }, "Ri");
      Li.prototype.getCoordinates = function () {
        return this._pt;
      }, Li.prototype.getCoordinate = function (t) {
        return this._pt[t];
      }, Li.prototype.setMinimum = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.setMinimum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          if (this._isNull) return this.initialize(e, n), null;
          var i = e.distance(n);
          i < this._distance && this.initialize(e, n, i);
        }
      }, Li.prototype.initialize = function () {
        if (0 === arguments.length) this._isNull = !0;else if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          this._pt[0].setCoordinate(t), this._pt[1].setCoordinate(e), this._distance = t.distance(e), this._isNull = !1;
        } else if (3 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[2];
          this._pt[0].setCoordinate(n), this._pt[1].setCoordinate(i), this._distance = r, this._isNull = !1;
        }
      }, Li.prototype.toString = function () {
        return $.toLineString(this._pt[0], this._pt[1]);
      }, Li.prototype.getDistance = function () {
        return this._distance;
      }, Li.prototype.setMaximum = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          this.setMaximum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          if (this._isNull) return this.initialize(e, n), null;
          var i = e.distance(n);
          i > this._distance && this.initialize(e, n, i);
        }
      }, Li.prototype.interfaces_ = function () {
        return [];
      }, Li.prototype.getClass = function () {
        return Li;
      };
      var Ri = u(function () {}, "Pi");
      Ri.prototype.interfaces_ = function () {
        return [];
      }, Ri.prototype.getClass = function () {
        return Ri;
      }, Ri.computeDistance = function () {
        if (arguments[2] instanceof Li && arguments[0] instanceof Jt && arguments[1] instanceof M) for (var t = arguments[0], e = arguments[1], n = arguments[2], i = new gn(), r = t.getCoordinates(), o = 0; o < r.length - 1; o++) {
          i.setCoordinates(r[o], r[o + 1]);
          var s = i.closestPoint(e);
          n.setMinimum(s, e);
        } else if (arguments[2] instanceof Li && arguments[0] instanceof te && arguments[1] instanceof M) {
          var a = arguments[0],
            l = arguments[1],
            u = arguments[2];
          Ri.computeDistance(a.getExteriorRing(), l, u);
          for (var h = 0; h < a.getNumInteriorRing(); h++) Ri.computeDistance(a.getInteriorRingN(h), l, u);
        } else if (arguments[2] instanceof Li && arguments[0] instanceof ct && arguments[1] instanceof M) {
          var c = arguments[0],
            p = arguments[1],
            d = arguments[2];
          if (c instanceof Jt) Ri.computeDistance(c, p, d);else if (c instanceof te) Ri.computeDistance(c, p, d);else if (c instanceof jt) for (var f = c, m = 0; m < f.getNumGeometries(); m++) {
            var g = f.getGeometryN(m);
            Ri.computeDistance(g, p, d);
          } else d.setMinimum(c.getCoordinate(), p);
        } else if (arguments[2] instanceof Li && arguments[0] instanceof gn && arguments[1] instanceof M) {
          var v = arguments[0],
            y = arguments[1],
            _ = arguments[2],
            x = v.closestPoint(y);
          _.setMinimum(x, y);
        }
      };
      var Oi = u(function () {
          this._g0 = null, this._g1 = null, this._ptDist = new Li(), this._densifyFrac = 0;
          var t = arguments[0],
            e = arguments[1];
          this._g0 = t, this._g1 = e;
        }, "Di"),
        qi = {
          MaxPointDistanceFilter: {
            configurable: !0
          },
          MaxDensifiedByFractionDistanceFilter: {
            configurable: !0
          }
        };
      Oi.prototype.getCoordinates = function () {
        return this._ptDist.getCoordinates();
      }, Oi.prototype.setDensifyFraction = function (t) {
        if (t > 1 || t <= 0) throw new _("Fraction is not in range (0.0 - 1.0]");
        this._densifyFrac = t;
      }, Oi.prototype.compute = function (t, e) {
        this.computeOrientedDistance(t, e, this._ptDist), this.computeOrientedDistance(e, t, this._ptDist);
      }, Oi.prototype.distance = function () {
        return this.compute(this._g0, this._g1), this._ptDist.getDistance();
      }, Oi.prototype.computeOrientedDistance = function (t, e, n) {
        var i = new Di(e);
        if (t.apply(i), n.setMaximum(i.getMaxPointDistance()), this._densifyFrac > 0) {
          var r = new ki(e, this._densifyFrac);
          t.apply(r), n.setMaximum(r.getMaxPointDistance());
        }
      }, Oi.prototype.orientedDistance = function () {
        return this.computeOrientedDistance(this._g0, this._g1, this._ptDist), this._ptDist.getDistance();
      }, Oi.prototype.interfaces_ = function () {
        return [];
      }, Oi.prototype.getClass = function () {
        return Oi;
      }, Oi.distance = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1];
          return new Oi(t, e).distance();
        }
        if (3 === arguments.length) {
          var n = arguments[0],
            i = arguments[1],
            r = arguments[2],
            o = new Oi(n, i);
          return o.setDensifyFraction(r), o.distance();
        }
      }, qi.MaxPointDistanceFilter.get = function () {
        return Di;
      }, qi.MaxDensifiedByFractionDistanceFilter.get = function () {
        return ki;
      }, Object.defineProperties(Oi, qi);
      var Di = u(function () {
        this._maxPtDist = new Li(), this._minPtDist = new Li(), this._euclideanDist = new Ri(), this._geom = null;
        var t = arguments[0];
        this._geom = t;
      }, "Ai");
      Di.prototype.filter = function (t) {
        this._minPtDist.initialize(), Ri.computeDistance(this._geom, t, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
      }, Di.prototype.getMaxPointDistance = function () {
        return this._maxPtDist;
      }, Di.prototype.interfaces_ = function () {
        return [ft];
      }, Di.prototype.getClass = function () {
        return Di;
      };
      var ki = u(function () {
        this._maxPtDist = new Li(), this._minPtDist = new Li(), this._geom = null, this._numSubSegs = 0;
        var t = arguments[0],
          e = arguments[1];
        this._geom = t, this._numSubSegs = Math.trunc(Math.round(1 / e));
      }, "Fi");
      ki.prototype.filter = function (t, e) {
        if (0 === e) return null;
        for (var n = t.getCoordinate(e - 1), i = t.getCoordinate(e), r = (i.x - n.x) / this._numSubSegs, o = (i.y - n.y) / this._numSubSegs, s = 0; s < this._numSubSegs; s++) {
          var a = n.x + s * r,
            l = n.y + s * o,
            u = new M(a, l);
          this._minPtDist.initialize(), Ri.computeDistance(this._geom, u, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
        }
      }, ki.prototype.isDone = function () {
        return !1;
      }, ki.prototype.isGeometryChanged = function () {
        return !1;
      }, ki.prototype.getMaxPointDistance = function () {
        return this._maxPtDist;
      }, ki.prototype.interfaces_ = function () {
        return [Vt];
      }, ki.prototype.getClass = function () {
        return ki;
      };
      var Fi = u(function (t, e, n) {
          this._minValidDistance = null, this._maxValidDistance = null, this._minDistanceFound = null, this._maxDistanceFound = null, this._isValid = !0, this._errMsg = null, this._errorLocation = null, this._errorIndicator = null, this._input = t || null, this._bufDistance = e || null, this._result = n || null;
        }, "Gi"),
        Ui = {
          VERBOSE: {
            configurable: !0
          },
          MAX_DISTANCE_DIFF_FRAC: {
            configurable: !0
          }
        };
      Fi.prototype.checkMaximumDistance = function (t, e, n) {
        var i = new Oi(e, t);
        if (i.setDensifyFraction(.25), this._maxDistanceFound = i.orientedDistance(), this._maxDistanceFound > n) {
          this._isValid = !1;
          var r = i.getCoordinates();
          this._errorLocation = r[1], this._errorIndicator = t.getFactory().createLineString(r), this._errMsg = "Distance between buffer curve and input is too large (" + this._maxDistanceFound + " at " + $.toLineString(r[0], r[1]) + ")";
        }
      }, Fi.prototype.isValid = function () {
        var t = Math.abs(this._bufDistance),
          e = Fi.MAX_DISTANCE_DIFF_FRAC * t;
        return this._minValidDistance = t - e, this._maxValidDistance = t + e, !(!this._input.isEmpty() && !this._result.isEmpty()) || (this._bufDistance > 0 ? this.checkPositiveValid() : this.checkNegativeValid(), Fi.VERBOSE && W.out.println("Min Dist= " + this._minDistanceFound + "  err= " + (1 - this._minDistanceFound / this._bufDistance) + "  Max Dist= " + this._maxDistanceFound + "  err= " + (this._maxDistanceFound / this._bufDistance - 1)), this._isValid);
      }, Fi.prototype.checkNegativeValid = function () {
        if (!(this._input instanceof te || this._input instanceof ie || this._input instanceof jt)) return null;
        var t = this.getPolygonLines(this._input);
        if (this.checkMinimumDistance(t, this._result, this._minValidDistance), !this._isValid) return null;
        this.checkMaximumDistance(t, this._result, this._maxValidDistance);
      }, Fi.prototype.getErrorIndicator = function () {
        return this._errorIndicator;
      }, Fi.prototype.checkMinimumDistance = function (t, e, n) {
        var i = new Ni(t, e, n);
        if (this._minDistanceFound = i.distance(), this._minDistanceFound < n) {
          this._isValid = !1;
          var r = i.nearestPoints();
          this._errorLocation = i.nearestPoints()[1], this._errorIndicator = t.getFactory().createLineString(r), this._errMsg = "Distance between buffer curve and input is too small (" + this._minDistanceFound + " at " + $.toLineString(r[0], r[1]) + " )";
        }
      }, Fi.prototype.checkPositiveValid = function () {
        var t = this._result.getBoundary();
        if (this.checkMinimumDistance(this._input, t, this._minValidDistance), !this._isValid) return null;
        this.checkMaximumDistance(this._input, t, this._maxValidDistance);
      }, Fi.prototype.getErrorLocation = function () {
        return this._errorLocation;
      }, Fi.prototype.getPolygonLines = function (t) {
        for (var e = new St(), n = new Mi(e), i = Si.getPolygons(t).iterator(); i.hasNext();) i.next().apply(n);
        return t.getFactory().buildGeometry(e);
      }, Fi.prototype.getErrorMessage = function () {
        return this._errMsg;
      }, Fi.prototype.interfaces_ = function () {
        return [];
      }, Fi.prototype.getClass = function () {
        return Fi;
      }, Ui.VERBOSE.get = function () {
        return !1;
      }, Ui.MAX_DISTANCE_DIFF_FRAC.get = function () {
        return .012;
      }, Object.defineProperties(Fi, Ui);
      var Bi = u(function (t, e, n) {
          this._isValid = !0, this._errorMsg = null, this._errorLocation = null, this._errorIndicator = null, this._input = t || null, this._distance = e || null, this._result = n || null;
        }, "Bi"),
        zi = {
          VERBOSE: {
            configurable: !0
          },
          MAX_ENV_DIFF_FRAC: {
            configurable: !0
          }
        };
      Bi.prototype.isValid = function () {
        return this.checkPolygonal(), this._isValid ? (this.checkExpectedEmpty(), this._isValid ? (this.checkEnvelope(), this._isValid ? (this.checkArea(), this._isValid ? (this.checkDistance(), this._isValid) : this._isValid) : this._isValid) : this._isValid) : this._isValid;
      }, Bi.prototype.checkEnvelope = function () {
        if (this._distance < 0) return null;
        var t = this._distance * Bi.MAX_ENV_DIFF_FRAC;
        0 === t && (t = .001);
        var e = new X(this._input.getEnvelopeInternal());
        e.expandBy(this._distance);
        var n = new X(this._result.getEnvelopeInternal());
        n.expandBy(t), n.contains(e) || (this._isValid = !1, this._errorMsg = "Buffer envelope is incorrect", this._errorIndicator = this._input.getFactory().toGeometry(n)), this.report("Envelope");
      }, Bi.prototype.checkDistance = function () {
        var t = new Fi(this._input, this._distance, this._result);
        t.isValid() || (this._isValid = !1, this._errorMsg = t.getErrorMessage(), this._errorLocation = t.getErrorLocation(), this._errorIndicator = t.getErrorIndicator()), this.report("Distance");
      }, Bi.prototype.checkArea = function () {
        var t = this._input.getArea(),
          e = this._result.getArea();
        this._distance > 0 && t > e && (this._isValid = !1, this._errorMsg = "Area of positive buffer is smaller than input", this._errorIndicator = this._result), this._distance < 0 && t < e && (this._isValid = !1, this._errorMsg = "Area of negative buffer is larger than input", this._errorIndicator = this._result), this.report("Area");
      }, Bi.prototype.checkPolygonal = function () {
        this._result instanceof te || this._result instanceof ie || (this._isValid = !1), this._errorMsg = "Result is not polygonal", this._errorIndicator = this._result, this.report("Polygonal");
      }, Bi.prototype.getErrorIndicator = function () {
        return this._errorIndicator;
      }, Bi.prototype.getErrorLocation = function () {
        return this._errorLocation;
      }, Bi.prototype.checkExpectedEmpty = function () {
        return this._input.getDimension() >= 2 || this._distance > 0 ? null : (this._result.isEmpty() || (this._isValid = !1, this._errorMsg = "Result is non-empty", this._errorIndicator = this._result), void this.report("ExpectedEmpty"));
      }, Bi.prototype.report = function (t) {
        if (!Bi.VERBOSE) return null;
        W.out.println("Check " + t + ": " + (this._isValid ? "passed" : "FAILED"));
      }, Bi.prototype.getErrorMessage = function () {
        return this._errorMsg;
      }, Bi.prototype.interfaces_ = function () {
        return [];
      }, Bi.prototype.getClass = function () {
        return Bi;
      }, Bi.isValidMsg = function (t, e, n) {
        var i = new Bi(t, e, n);
        return i.isValid() ? null : i.getErrorMessage();
      }, Bi.isValid = function (t, e, n) {
        return !!new Bi(t, e, n).isValid();
      }, zi.VERBOSE.get = function () {
        return !1;
      }, zi.MAX_ENV_DIFF_FRAC.get = function () {
        return .012;
      }, Object.defineProperties(Bi, zi);
      var Vi = u(function () {
        this._pts = null, this._data = null;
        var t = arguments[0],
          e = arguments[1];
        this._pts = t, this._data = e;
      }, "Ui");
      Vi.prototype.getCoordinates = function () {
        return this._pts;
      }, Vi.prototype.size = function () {
        return this._pts.length;
      }, Vi.prototype.getCoordinate = function (t) {
        return this._pts[t];
      }, Vi.prototype.isClosed = function () {
        return this._pts[0].equals(this._pts[this._pts.length - 1]);
      }, Vi.prototype.getSegmentOctant = function (t) {
        return t === this._pts.length - 1 ? -1 : pn.octant(this.getCoordinate(t), this.getCoordinate(t + 1));
      }, Vi.prototype.setData = function (t) {
        this._data = t;
      }, Vi.prototype.getData = function () {
        return this._data;
      }, Vi.prototype.toString = function () {
        return $.toLineString(new ue(this._pts));
      }, Vi.prototype.interfaces_ = function () {
        return [dn];
      }, Vi.prototype.getClass = function () {
        return Vi;
      };
      var ji = u(function () {
        this._findAllIntersections = !1, this._isCheckEndSegmentsOnly = !1, this._li = null, this._interiorIntersection = null, this._intSegments = null, this._intersections = new St(), this._intersectionCount = 0, this._keepIntersections = !0;
        var t = arguments[0];
        this._li = t, this._interiorIntersection = null;
      }, "zi");
      ji.prototype.getInteriorIntersection = function () {
        return this._interiorIntersection;
      }, ji.prototype.setCheckEndSegmentsOnly = function (t) {
        this._isCheckEndSegmentsOnly = t;
      }, ji.prototype.getIntersectionSegments = function () {
        return this._intSegments;
      }, ji.prototype.count = function () {
        return this._intersectionCount;
      }, ji.prototype.getIntersections = function () {
        return this._intersections;
      }, ji.prototype.setFindAllIntersections = function (t) {
        this._findAllIntersections = t;
      }, ji.prototype.setKeepIntersections = function (t) {
        this._keepIntersections = t;
      }, ji.prototype.processIntersections = function (t, e, n, i) {
        if (!this._findAllIntersections && this.hasIntersection() || t === n && e === i || this._isCheckEndSegmentsOnly && !this.isEndSegment(t, e) && !this.isEndSegment(n, i)) return null;
        var r = t.getCoordinates()[e],
          o = t.getCoordinates()[e + 1],
          s = n.getCoordinates()[i],
          a = n.getCoordinates()[i + 1];
        this._li.computeIntersection(r, o, s, a), this._li.hasIntersection() && this._li.isInteriorIntersection() && (this._intSegments = new Array(4).fill(null), this._intSegments[0] = r, this._intSegments[1] = o, this._intSegments[2] = s, this._intSegments[3] = a, this._interiorIntersection = this._li.getIntersection(0), this._keepIntersections && this._intersections.add(this._interiorIntersection), this._intersectionCount++);
      }, ji.prototype.isEndSegment = function (t, e) {
        return 0 === e || e >= t.size() - 2;
      }, ji.prototype.hasIntersection = function () {
        return null !== this._interiorIntersection;
      }, ji.prototype.isDone = function () {
        return !this._findAllIntersections && null !== this._interiorIntersection;
      }, ji.prototype.interfaces_ = function () {
        return [Zn];
      }, ji.prototype.getClass = function () {
        return ji;
      }, ji.createAllIntersectionsFinder = function (t) {
        var e = new ji(t);
        return e.setFindAllIntersections(!0), e;
      }, ji.createAnyIntersectionFinder = function (t) {
        return new ji(t);
      }, ji.createIntersectionCounter = function (t) {
        var e = new ji(t);
        return e.setFindAllIntersections(!0), e.setKeepIntersections(!1), e;
      };
      var Gi = u(function () {
        this._li = new ot(), this._segStrings = null, this._findAllIntersections = !1, this._segInt = null, this._isValid = !0;
        var t = arguments[0];
        this._segStrings = t;
      }, "Xi");
      Gi.prototype.execute = function () {
        if (null !== this._segInt) return null;
        this.checkInteriorIntersections();
      }, Gi.prototype.getIntersections = function () {
        return this._segInt.getIntersections();
      }, Gi.prototype.isValid = function () {
        return this.execute(), this._isValid;
      }, Gi.prototype.setFindAllIntersections = function (t) {
        this._findAllIntersections = t;
      }, Gi.prototype.checkInteriorIntersections = function () {
        this._isValid = !0, this._segInt = new ji(this._li), this._segInt.setFindAllIntersections(this._findAllIntersections);
        var t = new wn();
        if (t.setSegmentIntersector(this._segInt), t.computeNodes(this._segStrings), this._segInt.hasIntersection()) return this._isValid = !1, null;
      }, Gi.prototype.checkValid = function () {
        if (this.execute(), !this._isValid) throw new Ce(this.getErrorMessage(), this._segInt.getInteriorIntersection());
      }, Gi.prototype.getErrorMessage = function () {
        if (this._isValid) return "no intersections found";
        var t = this._segInt.getIntersectionSegments();
        return "found non-noded intersection between " + $.toLineString(t[0], t[1]) + " and " + $.toLineString(t[2], t[3]);
      }, Gi.prototype.interfaces_ = function () {
        return [];
      }, Gi.prototype.getClass = function () {
        return Gi;
      }, Gi.computeIntersections = function (t) {
        var e = new Gi(t);
        return e.setFindAllIntersections(!0), e.isValid(), e.getIntersections();
      };
      var Wi = u(function t() {
        this._nv = null;
        var e = arguments[0];
        this._nv = new Gi(t.toSegmentStrings(e));
      }, "t");
      Wi.prototype.checkValid = function () {
        this._nv.checkValid();
      }, Wi.prototype.interfaces_ = function () {
        return [];
      }, Wi.prototype.getClass = function () {
        return Wi;
      }, Wi.toSegmentStrings = function (t) {
        for (var e = new St(), n = t.iterator(); n.hasNext();) {
          var i = n.next();
          e.add(new Vi(i.getCoordinates(), i));
        }
        return e;
      }, Wi.checkValid = function (t) {
        new Wi(t).checkValid();
      };
      var Hi = u(function (t) {
        this._mapOp = t;
      }, "ki");
      Hi.prototype.map = function (t) {
        for (var e = new St(), n = 0; n < t.getNumGeometries(); n++) {
          var i = this._mapOp.map(t.getGeometryN(n));
          i.isEmpty() || e.add(i);
        }
        return t.getFactory().createGeometryCollection(ye.toGeometryArray(e));
      }, Hi.prototype.interfaces_ = function () {
        return [];
      }, Hi.prototype.getClass = function () {
        return Hi;
      }, Hi.map = function (t, e) {
        return new Hi(e).map(t);
      };
      var Xi = u(function () {
        this._op = null, this._geometryFactory = null, this._ptLocator = null, this._lineEdgesList = new St(), this._resultLineList = new St();
        var t = arguments[0],
          e = arguments[1],
          n = arguments[2];
        this._op = t, this._geometryFactory = e, this._ptLocator = n;
      }, "ji");
      Xi.prototype.collectLines = function (t) {
        for (var e = this._op.getGraph().getEdgeEnds().iterator(); e.hasNext();) {
          var n = e.next();
          this.collectLineEdge(n, t, this._lineEdgesList), this.collectBoundaryTouchEdge(n, t, this._lineEdgesList);
        }
      }, Xi.prototype.labelIsolatedLine = function (t, e) {
        var n = this._ptLocator.locate(t.getCoordinate(), this._op.getArgGeometry(e));
        t.getLabel().setLocation(e, n);
      }, Xi.prototype.build = function (t) {
        return this.findCoveredLineEdges(), this.collectLines(t), this.buildLines(t), this._resultLineList;
      }, Xi.prototype.collectLineEdge = function (t, e, n) {
        var i = t.getLabel(),
          r = t.getEdge();
        t.isLineEdge() && (t.isVisited() || !Ar.isResultOfOp(i, e) || r.isCovered() || (n.add(r), t.setVisitedEdge(!0)));
      }, Xi.prototype.findCoveredLineEdges = function () {
        for (var t = this._op.getGraph().getNodes().iterator(); t.hasNext();) t.next().getEdges().findCoveredLineEdges();
        for (var e = this._op.getGraph().getEdgeEnds().iterator(); e.hasNext();) {
          var n = e.next(),
            i = n.getEdge();
          if (n.isLineEdge() && !i.isCoveredSet()) {
            var r = this._op.isCoveredByA(n.getCoordinate());
            i.setCovered(r);
          }
        }
      }, Xi.prototype.labelIsolatedLines = function (t) {
        for (var e = t.iterator(); e.hasNext();) {
          var n = e.next(),
            i = n.getLabel();
          n.isIsolated() && (i.isNull(0) ? this.labelIsolatedLine(n, 0) : this.labelIsolatedLine(n, 1));
        }
      }, Xi.prototype.buildLines = function (t) {
        for (var e = this._lineEdgesList.iterator(); e.hasNext();) {
          var n = e.next(),
            i = this._geometryFactory.createLineString(n.getCoordinates());
          this._resultLineList.add(i), n.setInResult(!0);
        }
      }, Xi.prototype.collectBoundaryTouchEdge = function (t, e, n) {
        var i = t.getLabel();
        return t.isLineEdge() || t.isVisited() || t.isInteriorAreaEdge() || t.getEdge().isInResult() ? null : (nt.isTrue(!(t.isInResult() || t.getSym().isInResult()) || !t.getEdge().isInResult()), void (Ar.isResultOfOp(i, e) && e === Ar.INTERSECTION && (n.add(t.getEdge()), t.setVisitedEdge(!0))));
      }, Xi.prototype.interfaces_ = function () {
        return [];
      }, Xi.prototype.getClass = function () {
        return Xi;
      };
      var Yi = u(function () {
        this._op = null, this._geometryFactory = null, this._resultPointList = new St();
        var t = arguments[0],
          e = arguments[1];
        this._op = t, this._geometryFactory = e;
      }, "Hi");
      Yi.prototype.filterCoveredNodeToPoint = function (t) {
        var e = t.getCoordinate();
        if (!this._op.isCoveredByLA(e)) {
          var n = this._geometryFactory.createPoint(e);
          this._resultPointList.add(n);
        }
      }, Yi.prototype.extractNonCoveredResultNodes = function (t) {
        for (var e = this._op.getGraph().getNodes().iterator(); e.hasNext();) {
          var n = e.next();
          if (!(n.isInResult() || n.isIncidentEdgeInResult() || 0 !== n.getEdges().getDegree() && t !== Ar.INTERSECTION)) {
            var i = n.getLabel();
            Ar.isResultOfOp(i, t) && this.filterCoveredNodeToPoint(n);
          }
        }
      }, Yi.prototype.build = function (t) {
        return this.extractNonCoveredResultNodes(t), this._resultPointList;
      }, Yi.prototype.interfaces_ = function () {
        return [];
      }, Yi.prototype.getClass = function () {
        return Yi;
      };
      var Zi = u(function () {
        this._inputGeom = null, this._factory = null, this._pruneEmptyGeometry = !0, this._preserveGeometryCollectionType = !0, this._preserveCollections = !1, this._preserveType = !1;
      }, "Wi");
      Zi.prototype.transformPoint = function (t, e) {
        return this._factory.createPoint(this.transformCoordinates(t.getCoordinateSequence(), t));
      }, Zi.prototype.transformPolygon = function (t, e) {
        var n = !0,
          i = this.transformLinearRing(t.getExteriorRing(), t);
        null !== i && i instanceof ne && !i.isEmpty() || (n = !1);
        for (var r = new St(), o = 0; o < t.getNumInteriorRing(); o++) {
          var s = this.transformLinearRing(t.getInteriorRingN(o), t);
          null === s || s.isEmpty() || (s instanceof ne || (n = !1), r.add(s));
        }
        if (n) return this._factory.createPolygon(i, r.toArray([]));
        var a = new St();
        return null !== i && a.add(i), a.addAll(r), this._factory.buildGeometry(a);
      }, Zi.prototype.createCoordinateSequence = function (t) {
        return this._factory.getCoordinateSequenceFactory().create(t);
      }, Zi.prototype.getInputGeometry = function () {
        return this._inputGeom;
      }, Zi.prototype.transformMultiLineString = function (t, e) {
        for (var n = new St(), i = 0; i < t.getNumGeometries(); i++) {
          var r = this.transformLineString(t.getGeometryN(i), t);
          null !== r && (r.isEmpty() || n.add(r));
        }
        return this._factory.buildGeometry(n);
      }, Zi.prototype.transformCoordinates = function (t, e) {
        return this.copy(t);
      }, Zi.prototype.transformLineString = function (t, e) {
        return this._factory.createLineString(this.transformCoordinates(t.getCoordinateSequence(), t));
      }, Zi.prototype.transformMultiPoint = function (t, e) {
        for (var n = new St(), i = 0; i < t.getNumGeometries(); i++) {
          var r = this.transformPoint(t.getGeometryN(i), t);
          null !== r && (r.isEmpty() || n.add(r));
        }
        return this._factory.buildGeometry(n);
      }, Zi.prototype.transformMultiPolygon = function (t, e) {
        for (var n = new St(), i = 0; i < t.getNumGeometries(); i++) {
          var r = this.transformPolygon(t.getGeometryN(i), t);
          null !== r && (r.isEmpty() || n.add(r));
        }
        return this._factory.buildGeometry(n);
      }, Zi.prototype.copy = function (t) {
        return t.copy();
      }, Zi.prototype.transformGeometryCollection = function (t, e) {
        for (var n = new St(), i = 0; i < t.getNumGeometries(); i++) {
          var r = this.transform(t.getGeometryN(i));
          null !== r && (this._pruneEmptyGeometry && r.isEmpty() || n.add(r));
        }
        return this._preserveGeometryCollectionType ? this._factory.createGeometryCollection(ye.toGeometryArray(n)) : this._factory.buildGeometry(n);
      }, Zi.prototype.transform = function (t) {
        if (this._inputGeom = t, this._factory = t.getFactory(), t instanceof Qt) return this.transformPoint(t, null);
        if (t instanceof ee) return this.transformMultiPoint(t, null);
        if (t instanceof ne) return this.transformLinearRing(t, null);
        if (t instanceof Jt) return this.transformLineString(t, null);
        if (t instanceof Gt) return this.transformMultiLineString(t, null);
        if (t instanceof te) return this.transformPolygon(t, null);
        if (t instanceof ie) return this.transformMultiPolygon(t, null);
        if (t instanceof jt) return this.transformGeometryCollection(t, null);
        throw new _("Unknown Geometry subtype: " + t.getClass().getName());
      }, Zi.prototype.transformLinearRing = function (t, e) {
        var n = this.transformCoordinates(t.getCoordinateSequence(), t);
        if (null === n) return this._factory.createLinearRing(null);
        var i = n.size();
        return i > 0 && i < 4 && !this._preserveType ? this._factory.createLineString(n) : this._factory.createLinearRing(n);
      }, Zi.prototype.interfaces_ = function () {
        return [];
      }, Zi.prototype.getClass = function () {
        return Zi;
      };
      var Ji = u(function t() {
        if (this._snapTolerance = 0, this._srcPts = null, this._seg = new gn(), this._allowSnappingToSourceVertices = !1, this._isClosed = !1, arguments[0] instanceof Jt && "number" == typeof arguments[1]) {
          var e = arguments[0],
            n = arguments[1];
          t.call(this, e.getCoordinates(), n);
        } else if (arguments[0] instanceof Array && "number" == typeof arguments[1]) {
          var i = arguments[0],
            r = arguments[1];
          this._srcPts = i, this._isClosed = t.isClosed(i), this._snapTolerance = r;
        }
      }, "t");
      Ji.prototype.snapVertices = function (t, e) {
        for (var n = this._isClosed ? t.size() - 1 : t.size(), i = 0; i < n; i++) {
          var r = t.get(i),
            o = this.findSnapForVertex(r, e);
          null !== o && (t.set(i, new M(o)), 0 === i && this._isClosed && t.set(t.size() - 1, new M(o)));
        }
      }, Ji.prototype.findSnapForVertex = function (t, e) {
        for (var n = 0; n < e.length; n++) {
          if (t.equals2D(e[n])) return null;
          if (t.distance(e[n]) < this._snapTolerance) return e[n];
        }
        return null;
      }, Ji.prototype.snapTo = function (t) {
        var e = new Tt(this._srcPts);
        return this.snapVertices(e, t), this.snapSegments(e, t), e.toCoordinateArray();
      }, Ji.prototype.snapSegments = function (t, e) {
        if (0 === e.length) return null;
        var n = e.length;
        e[0].equals2D(e[e.length - 1]) && (n = e.length - 1);
        for (var i = 0; i < n; i++) {
          var r = e[i],
            o = this.findSegmentIndexToSnap(r, t);
          o >= 0 && t.add(o + 1, new M(r), !1);
        }
      }, Ji.prototype.findSegmentIndexToSnap = function (t, e) {
        for (var n = x.MAX_VALUE, i = -1, r = 0; r < e.size() - 1; r++) {
          if (this._seg.p0 = e.get(r), this._seg.p1 = e.get(r + 1), this._seg.p0.equals2D(t) || this._seg.p1.equals2D(t)) {
            if (this._allowSnappingToSourceVertices) continue;
            return -1;
          }
          var o = this._seg.distance(t);
          o < this._snapTolerance && o < n && (n = o, i = r);
        }
        return i;
      }, Ji.prototype.setAllowSnappingToSourceVertices = function (t) {
        this._allowSnappingToSourceVertices = t;
      }, Ji.prototype.interfaces_ = function () {
        return [];
      }, Ji.prototype.getClass = function () {
        return Ji;
      }, Ji.isClosed = function (t) {
        return !(t.length <= 1) && t[0].equals2D(t[t.length - 1]);
      };
      var Ki = u(function (t) {
          this._srcGeom = t || null;
        }, "Ji"),
        Qi = {
          SNAP_PRECISION_FACTOR: {
            configurable: !0
          }
        };
      Ki.prototype.snapTo = function (t, e) {
        var n = this.extractTargetCoordinates(t);
        return new $i(e, n).transform(this._srcGeom);
      }, Ki.prototype.snapToSelf = function (t, e) {
        var n = this.extractTargetCoordinates(this._srcGeom),
          i = new $i(t, n, !0).transform(this._srcGeom),
          r = i;
        return e && N(r, $t) && (r = i.buffer(0)), r;
      }, Ki.prototype.computeSnapTolerance = function (t) {
        return this.computeMinimumSegmentLength(t) / 10;
      }, Ki.prototype.extractTargetCoordinates = function (t) {
        for (var e = new f(), n = t.getCoordinates(), i = 0; i < n.length; i++) e.add(n[i]);
        return e.toArray(new Array(0).fill(null));
      }, Ki.prototype.computeMinimumSegmentLength = function (t) {
        for (var e = x.MAX_VALUE, n = 0; n < t.length - 1; n++) {
          var i = t[n].distance(t[n + 1]);
          i < e && (e = i);
        }
        return e;
      }, Ki.prototype.interfaces_ = function () {
        return [];
      }, Ki.prototype.getClass = function () {
        return Ki;
      }, Ki.snap = function (t, e, n) {
        var i = new Array(2).fill(null),
          r = new Ki(t);
        i[0] = r.snapTo(e, n);
        var o = new Ki(e);
        return i[1] = o.snapTo(i[0], n), i;
      }, Ki.computeOverlaySnapTolerance = function () {
        if (1 === arguments.length) {
          var t = arguments[0],
            e = Ki.computeSizeBasedSnapTolerance(t),
            n = t.getPrecisionModel();
          if (n.getType() === fe.FIXED) {
            var i = 1 / n.getScale() * 2 / 1.415;
            i > e && (e = i);
          }
          return e;
        }
        if (2 === arguments.length) {
          var r = arguments[0],
            o = arguments[1];
          return Math.min(Ki.computeOverlaySnapTolerance(r), Ki.computeOverlaySnapTolerance(o));
        }
      }, Ki.computeSizeBasedSnapTolerance = function (t) {
        var e = t.getEnvelopeInternal();
        return Math.min(e.getHeight(), e.getWidth()) * Ki.SNAP_PRECISION_FACTOR;
      }, Ki.snapToSelf = function (t, e, n) {
        return new Ki(t).snapToSelf(e, n);
      }, Qi.SNAP_PRECISION_FACTOR.get = function () {
        return 1e-9;
      }, Object.defineProperties(Ki, Qi);
      var $i = function (t) {
          function e(e, n, i) {
            t.call(this), this._snapTolerance = e || null, this._snapPts = n || null, this._isSelfSnap = void 0 !== i && i;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.snapLine = function (t, e) {
            var n = new Ji(t, this._snapTolerance);
            return n.setAllowSnappingToSourceVertices(this._isSelfSnap), n.snapTo(e);
          }, e.prototype.transformCoordinates = function (t, e) {
            var n = t.toCoordinateArray(),
              i = this.snapLine(n, this._snapPts);
            return this._factory.getCoordinateSequenceFactory().create(i);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(Zi),
        tr = u(function () {
          this._isFirst = !0, this._commonMantissaBitsCount = 53, this._commonBits = 0, this._commonSignExp = null;
        }, "$i");
      tr.prototype.getCommon = function () {
        return x.longBitsToDouble(this._commonBits);
      }, tr.prototype.add = function (t) {
        var e = x.doubleToLongBits(t);
        return this._isFirst ? (this._commonBits = e, this._commonSignExp = tr.signExpBits(this._commonBits), this._isFirst = !1, null) : tr.signExpBits(e) !== this._commonSignExp ? (this._commonBits = 0, null) : (this._commonMantissaBitsCount = tr.numCommonMostSigMantissaBits(this._commonBits, e), void (this._commonBits = tr.zeroLowerBits(this._commonBits, 64 - (12 + this._commonMantissaBitsCount))));
      }, tr.prototype.toString = function () {
        if (1 === arguments.length) {
          var t = arguments[0],
            e = x.longBitsToDouble(t),
            n = "0000000000000000000000000000000000000000000000000000000000000000" + x.toBinaryString(t),
            i = n.substring(n.length - 64);
          return i.substring(0, 1) + "  " + i.substring(1, 12) + "(exp) " + i.substring(12) + " [ " + e + " ]";
        }
      }, tr.prototype.interfaces_ = function () {
        return [];
      }, tr.prototype.getClass = function () {
        return tr;
      }, tr.getBit = function (t, e) {
        return 0 != (t & 1 << e) ? 1 : 0;
      }, tr.signExpBits = function (t) {
        return t >> 52;
      }, tr.zeroLowerBits = function (t, e) {
        return t & ~((1 << e) - 1);
      }, tr.numCommonMostSigMantissaBits = function (t, e) {
        for (var n = 0, i = 52; i >= 0; i--) {
          if (tr.getBit(t, i) !== tr.getBit(e, i)) return n;
          n++;
        }
        return 52;
      };
      var er = u(function () {
          this._commonCoord = null, this._ccFilter = new ir();
        }, "tr"),
        nr = {
          CommonCoordinateFilter: {
            configurable: !0
          },
          Translater: {
            configurable: !0
          }
        };
      er.prototype.addCommonBits = function (t) {
        var e = new rr(this._commonCoord);
        t.apply(e), t.geometryChanged();
      }, er.prototype.removeCommonBits = function (t) {
        if (0 === this._commonCoord.x && 0 === this._commonCoord.y) return t;
        var e = new M(this._commonCoord);
        e.x = -e.x, e.y = -e.y;
        var n = new rr(e);
        return t.apply(n), t.geometryChanged(), t;
      }, er.prototype.getCommonCoordinate = function () {
        return this._commonCoord;
      }, er.prototype.add = function (t) {
        t.apply(this._ccFilter), this._commonCoord = this._ccFilter.getCommonCoordinate();
      }, er.prototype.interfaces_ = function () {
        return [];
      }, er.prototype.getClass = function () {
        return er;
      }, nr.CommonCoordinateFilter.get = function () {
        return ir;
      }, nr.Translater.get = function () {
        return rr;
      }, Object.defineProperties(er, nr);
      var ir = u(function () {
        this._commonBitsX = new tr(), this._commonBitsY = new tr();
      }, "nr");
      ir.prototype.filter = function (t) {
        this._commonBitsX.add(t.x), this._commonBitsY.add(t.y);
      }, ir.prototype.getCommonCoordinate = function () {
        return new M(this._commonBitsX.getCommon(), this._commonBitsY.getCommon());
      }, ir.prototype.interfaces_ = function () {
        return [ft];
      }, ir.prototype.getClass = function () {
        return ir;
      };
      var rr = u(function () {
        this.trans = null;
        var t = arguments[0];
        this.trans = t;
      }, "ir");
      rr.prototype.filter = function (t, e) {
        var n = t.getOrdinate(e, 0) + this.trans.x,
          i = t.getOrdinate(e, 1) + this.trans.y;
        t.setOrdinate(e, 0, n), t.setOrdinate(e, 1, i);
      }, rr.prototype.isDone = function () {
        return !1;
      }, rr.prototype.isGeometryChanged = function () {
        return !0;
      }, rr.prototype.interfaces_ = function () {
        return [Vt];
      }, rr.prototype.getClass = function () {
        return rr;
      };
      var or = u(function (t, e) {
        this._geom = new Array(2).fill(null), this._snapTolerance = null, this._cbr = null, this._geom[0] = t, this._geom[1] = e, this.computeSnapTolerance();
      }, "rr");
      or.prototype.selfSnap = function (t) {
        return new Ki(t).snapTo(t, this._snapTolerance);
      }, or.prototype.removeCommonBits = function (t) {
        this._cbr = new er(), this._cbr.add(t[0]), this._cbr.add(t[1]);
        var e = new Array(2).fill(null);
        return e[0] = this._cbr.removeCommonBits(t[0].copy()), e[1] = this._cbr.removeCommonBits(t[1].copy()), e;
      }, or.prototype.prepareResult = function (t) {
        return this._cbr.addCommonBits(t), t;
      }, or.prototype.getResultGeometry = function (t) {
        var e = this.snap(this._geom),
          n = Ar.overlayOp(e[0], e[1], t);
        return this.prepareResult(n);
      }, or.prototype.checkValid = function (t) {
        t.isValid() || W.out.println("Snapped geometry is invalid");
      }, or.prototype.computeSnapTolerance = function () {
        this._snapTolerance = Ki.computeOverlaySnapTolerance(this._geom[0], this._geom[1]);
      }, or.prototype.snap = function (t) {
        var e = this.removeCommonBits(t);
        return Ki.snap(e[0], e[1], this._snapTolerance);
      }, or.prototype.interfaces_ = function () {
        return [];
      }, or.prototype.getClass = function () {
        return or;
      }, or.overlayOp = function (t, e, n) {
        return new or(t, e).getResultGeometry(n);
      }, or.union = function (t, e) {
        return or.overlayOp(t, e, Ar.UNION);
      }, or.intersection = function (t, e) {
        return or.overlayOp(t, e, Ar.INTERSECTION);
      }, or.symDifference = function (t, e) {
        return or.overlayOp(t, e, Ar.SYMDIFFERENCE);
      }, or.difference = function (t, e) {
        return or.overlayOp(t, e, Ar.DIFFERENCE);
      };
      var sr = u(function (t, e) {
        this._geom = new Array(2).fill(null), this._geom[0] = t, this._geom[1] = e;
      }, "or");
      sr.prototype.getResultGeometry = function (t) {
        var e = null,
          n = !1,
          i = null;
        try {
          e = Ar.overlayOp(this._geom[0], this._geom[1], t), n = !0;
        } catch (t) {
          if (!(t instanceof tt)) throw t;
          i = t;
        }
        if (!n) try {
          e = or.overlayOp(this._geom[0], this._geom[1], t);
        } catch (t) {
          throw t instanceof tt ? i : t;
        }
        return e;
      }, sr.prototype.interfaces_ = function () {
        return [];
      }, sr.prototype.getClass = function () {
        return sr;
      }, sr.overlayOp = function (t, e, n) {
        return new sr(t, e).getResultGeometry(n);
      }, sr.union = function (t, e) {
        return sr.overlayOp(t, e, Ar.UNION);
      }, sr.intersection = function (t, e) {
        return sr.overlayOp(t, e, Ar.INTERSECTION);
      }, sr.symDifference = function (t, e) {
        return sr.overlayOp(t, e, Ar.SYMDIFFERENCE);
      }, sr.difference = function (t, e) {
        return sr.overlayOp(t, e, Ar.DIFFERENCE);
      };
      var ar = u(function () {
        this.mce = null, this.chainIndex = null;
        var t = arguments[0],
          e = arguments[1];
        this.mce = t, this.chainIndex = e;
      }, "sr");
      ar.prototype.computeIntersections = function (t, e) {
        this.mce.computeIntersectsForChain(this.chainIndex, t.mce, t.chainIndex, e);
      }, ar.prototype.interfaces_ = function () {
        return [];
      }, ar.prototype.getClass = function () {
        return ar;
      };
      var lr = u(function t() {
          if (this._label = null, this._xValue = null, this._eventType = null, this._insertEvent = null, this._deleteEventIndex = null, this._obj = null, 2 === arguments.length) {
            var e = arguments[0],
              n = arguments[1];
            this._eventType = t.DELETE, this._xValue = e, this._insertEvent = n;
          } else if (3 === arguments.length) {
            var i = arguments[0],
              r = arguments[1],
              o = arguments[2];
            this._eventType = t.INSERT, this._label = i, this._xValue = r, this._obj = o;
          }
        }, "t"),
        ur = {
          INSERT: {
            configurable: !0
          },
          DELETE: {
            configurable: !0
          }
        };
      lr.prototype.isDelete = function () {
        return this._eventType === lr.DELETE;
      }, lr.prototype.setDeleteEventIndex = function (t) {
        this._deleteEventIndex = t;
      }, lr.prototype.getObject = function () {
        return this._obj;
      }, lr.prototype.compareTo = function (t) {
        var e = t;
        return this._xValue < e._xValue ? -1 : this._xValue > e._xValue ? 1 : this._eventType < e._eventType ? -1 : this._eventType > e._eventType ? 1 : 0;
      }, lr.prototype.getInsertEvent = function () {
        return this._insertEvent;
      }, lr.prototype.isInsert = function () {
        return this._eventType === lr.INSERT;
      }, lr.prototype.isSameLabel = function (t) {
        return null !== this._label && this._label === t._label;
      }, lr.prototype.getDeleteEventIndex = function () {
        return this._deleteEventIndex;
      }, lr.prototype.interfaces_ = function () {
        return [b];
      }, lr.prototype.getClass = function () {
        return lr;
      }, ur.INSERT.get = function () {
        return 1;
      }, ur.DELETE.get = function () {
        return 2;
      }, Object.defineProperties(lr, ur);
      var hr = u(function () {}, "lr");
      hr.prototype.interfaces_ = function () {
        return [];
      }, hr.prototype.getClass = function () {
        return hr;
      };
      var cr = u(function () {
        this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._properIntersectionPoint = null, this._li = null, this._includeProper = null, this._recordIsolated = null, this._isSelfIntersection = null, this._numIntersections = 0, this.numTests = 0, this._bdyNodes = null, this._isDone = !1, this._isDoneWhenProperInt = !1;
        var t = arguments[0],
          e = arguments[1],
          n = arguments[2];
        this._li = t, this._includeProper = e, this._recordIsolated = n;
      }, "cr");
      cr.prototype.isTrivialIntersection = function (t, e, n, i) {
        if (t === n && 1 === this._li.getIntersectionNum()) {
          if (cr.isAdjacentSegments(e, i)) return !0;
          if (t.isClosed()) {
            var r = t.getNumPoints() - 1;
            if (0 === e && i === r || 0 === i && e === r) return !0;
          }
        }
        return !1;
      }, cr.prototype.getProperIntersectionPoint = function () {
        return this._properIntersectionPoint;
      }, cr.prototype.setIsDoneIfProperInt = function (t) {
        this._isDoneWhenProperInt = t;
      }, cr.prototype.hasProperInteriorIntersection = function () {
        return this._hasProperInterior;
      }, cr.prototype.isBoundaryPointInternal = function (t, e) {
        for (var n = e.iterator(); n.hasNext();) {
          var i = n.next().getCoordinate();
          if (t.isIntersection(i)) return !0;
        }
        return !1;
      }, cr.prototype.hasProperIntersection = function () {
        return this._hasProper;
      }, cr.prototype.hasIntersection = function () {
        return this._hasIntersection;
      }, cr.prototype.isDone = function () {
        return this._isDone;
      }, cr.prototype.isBoundaryPoint = function (t, e) {
        return !(null === e || !this.isBoundaryPointInternal(t, e[0]) && !this.isBoundaryPointInternal(t, e[1]));
      }, cr.prototype.setBoundaryNodes = function (t, e) {
        this._bdyNodes = new Array(2).fill(null), this._bdyNodes[0] = t, this._bdyNodes[1] = e;
      }, cr.prototype.addIntersections = function (t, e, n, i) {
        if (t === n && e === i) return null;
        this.numTests++;
        var r = t.getCoordinates()[e],
          o = t.getCoordinates()[e + 1],
          s = n.getCoordinates()[i],
          a = n.getCoordinates()[i + 1];
        this._li.computeIntersection(r, o, s, a), this._li.hasIntersection() && (this._recordIsolated && (t.setIsolated(!1), n.setIsolated(!1)), this._numIntersections++, this.isTrivialIntersection(t, e, n, i) || (this._hasIntersection = !0, !this._includeProper && this._li.isProper() || (t.addIntersections(this._li, e, 0), n.addIntersections(this._li, i, 1)), this._li.isProper() && (this._properIntersectionPoint = this._li.getIntersection(0).copy(), this._hasProper = !0, this._isDoneWhenProperInt && (this._isDone = !0), this.isBoundaryPoint(this._li, this._bdyNodes) || (this._hasProperInterior = !0))));
      }, cr.prototype.interfaces_ = function () {
        return [];
      }, cr.prototype.getClass = function () {
        return cr;
      }, cr.isAdjacentSegments = function (t, e) {
        return 1 === Math.abs(t - e);
      };
      var pr = function (t) {
          function e() {
            t.call(this), this.events = new St(), this.nOverlaps = null;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.prepareEvents = function () {
            tn.sort(this.events);
            for (var t = 0; t < this.events.size(); t++) {
              var e = this.events.get(t);
              e.isDelete() && e.getInsertEvent().setDeleteEventIndex(t);
            }
          }, e.prototype.computeIntersections = function () {
            if (1 === arguments.length) {
              var t = arguments[0];
              this.nOverlaps = 0, this.prepareEvents();
              for (var e = 0; e < this.events.size(); e++) {
                var n = this.events.get(e);
                if (n.isInsert() && this.processOverlaps(e, n.getDeleteEventIndex(), n, t), t.isDone()) break;
              }
            } else if (3 === arguments.length) if (arguments[2] instanceof cr && N(arguments[0], wt) && N(arguments[1], wt)) {
              var i = arguments[0],
                r = arguments[1],
                o = arguments[2];
              this.addEdges(i, i), this.addEdges(r, r), this.computeIntersections(o);
            } else if ("boolean" == typeof arguments[2] && N(arguments[0], wt) && arguments[1] instanceof cr) {
              var s = arguments[0],
                a = arguments[1];
              arguments[2] ? this.addEdges(s, null) : this.addEdges(s), this.computeIntersections(a);
            }
          }, e.prototype.addEdge = function (t, e) {
            for (var n = t.getMonotoneChainEdge(), i = n.getStartIndexes(), r = 0; r < i.length - 1; r++) {
              var o = new ar(n, r),
                s = new lr(e, n.getMinX(r), o);
              this.events.add(s), this.events.add(new lr(n.getMaxX(r), s));
            }
          }, e.prototype.processOverlaps = function (t, e, n, i) {
            for (var r = n.getObject(), o = t; o < e; o++) {
              var s = this.events.get(o);
              if (s.isInsert()) {
                var a = s.getObject();
                n.isSameLabel(s) || (r.computeIntersections(a, i), this.nOverlaps++);
              }
            }
          }, e.prototype.addEdges = function () {
            if (1 === arguments.length) for (var t = arguments[0].iterator(); t.hasNext();) {
              var e = t.next();
              this.addEdge(e, e);
            } else if (2 === arguments.length) for (var n = arguments[0], i = arguments[1], r = n.iterator(); r.hasNext();) {
              var o = r.next();
              this.addEdge(o, i);
            }
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(hr),
        dr = u(function () {
          this._min = x.POSITIVE_INFINITY, this._max = x.NEGATIVE_INFINITY;
        }, "hr"),
        fr = {
          NodeComparator: {
            configurable: !0
          }
        };
      dr.prototype.getMin = function () {
        return this._min;
      }, dr.prototype.intersects = function (t, e) {
        return !(this._min > e || this._max < t);
      }, dr.prototype.getMax = function () {
        return this._max;
      }, dr.prototype.toString = function () {
        return $.toLineString(new M(this._min, 0), new M(this._max, 0));
      }, dr.prototype.interfaces_ = function () {
        return [];
      }, dr.prototype.getClass = function () {
        return dr;
      }, fr.NodeComparator.get = function () {
        return mr;
      }, Object.defineProperties(dr, fr);
      var mr = u(function () {}, "gr");
      mr.prototype.compare = function (t, e) {
        var n = t,
          i = e,
          r = (n._min + n._max) / 2,
          o = (i._min + i._max) / 2;
        return r < o ? -1 : r > o ? 1 : 0;
      }, mr.prototype.interfaces_ = function () {
        return [S];
      }, mr.prototype.getClass = function () {
        return mr;
      };
      var gr = function (t) {
          function e() {
            t.call(this), this._item = null;
            var e = arguments[0],
              n = arguments[1],
              i = arguments[2];
            this._min = e, this._max = n, this._item = i;
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.query = function (t, e, n) {
            if (!this.intersects(t, e)) return null;
            n.visitItem(this._item);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(dr),
        vr = function (t) {
          function e() {
            t.call(this), this._node1 = null, this._node2 = null;
            var e = arguments[0],
              n = arguments[1];
            this._node1 = e, this._node2 = n, this.buildExtent(this._node1, this._node2);
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.buildExtent = function (t, e) {
            this._min = Math.min(t._min, e._min), this._max = Math.max(t._max, e._max);
          }, e.prototype.query = function (t, e, n) {
            if (!this.intersects(t, e)) return null;
            null !== this._node1 && this._node1.query(t, e, n), null !== this._node2 && this._node2.query(t, e, n);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e;
        }(dr),
        yr = u(function () {
          this._leaves = new St(), this._root = null, this._level = 0;
        }, "_r");
      yr.prototype.buildTree = function () {
        tn.sort(this._leaves, new dr.NodeComparator());
        for (var t = this._leaves, e = null, n = new St();;) {
          if (this.buildLevel(t, n), 1 === n.size()) return n.get(0);
          e = t, t = n, n = e;
        }
      }, yr.prototype.insert = function (t, e, n) {
        if (null !== this._root) throw new Error("Index cannot be added to once it has been queried");
        this._leaves.add(new gr(t, e, n));
      }, yr.prototype.query = function (t, e, n) {
        this.init(), this._root.query(t, e, n);
      }, yr.prototype.buildRoot = function () {
        if (null !== this._root) return null;
        this._root = this.buildTree();
      }, yr.prototype.printNode = function (t) {
        W.out.println($.toLineString(new M(t._min, this._level), new M(t._max, this._level)));
      }, yr.prototype.init = function () {
        if (null !== this._root) return null;
        this.buildRoot();
      }, yr.prototype.buildLevel = function (t, e) {
        this._level++, e.clear();
        for (var n = 0; n < t.size(); n += 2) {
          var i = t.get(n);
          if (null === (n + 1 < t.size() ? t.get(n) : null)) e.add(i);else {
            var r = new vr(t.get(n), t.get(n + 1));
            e.add(r);
          }
        }
      }, yr.prototype.interfaces_ = function () {
        return [];
      }, yr.prototype.getClass = function () {
        return yr;
      };
      var _r = u(function () {
        this._items = new St();
      }, "mr");
      _r.prototype.visitItem = function (t) {
        this._items.add(t);
      }, _r.prototype.getItems = function () {
        return this._items;
      }, _r.prototype.interfaces_ = function () {
        return [Je];
      }, _r.prototype.getClass = function () {
        return _r;
      };
      var xr = u(function () {
          this._index = null;
          var t = arguments[0];
          if (!N(t, $t)) throw new _("Argument must be Polygonal");
          this._index = new wr(t);
        }, "vr"),
        Er = {
          SegmentVisitor: {
            configurable: !0
          },
          IntervalIndexedGeometry: {
            configurable: !0
          }
        };
      xr.prototype.locate = function (t) {
        var e = new at(t),
          n = new br(e);
        return this._index.query(t.y, t.y, n), e.getLocation();
      }, xr.prototype.interfaces_ = function () {
        return [zn];
      }, xr.prototype.getClass = function () {
        return xr;
      }, Er.SegmentVisitor.get = function () {
        return br;
      }, Er.IntervalIndexedGeometry.get = function () {
        return wr;
      }, Object.defineProperties(xr, Er);
      var br = u(function () {
        this._counter = null;
        var t = arguments[0];
        this._counter = t;
      }, "Er");
      br.prototype.visitItem = function (t) {
        var e = t;
        this._counter.countSegment(e.getCoordinate(0), e.getCoordinate(1));
      }, br.prototype.interfaces_ = function () {
        return [Je];
      }, br.prototype.getClass = function () {
        return br;
      };
      var wr = u(function () {
        this._index = new yr();
        var t = arguments[0];
        this.init(t);
      }, "xr");
      wr.prototype.init = function (t) {
        for (var e = Mi.getLines(t).iterator(); e.hasNext();) {
          var n = e.next().getCoordinates();
          this.addLine(n);
        }
      }, wr.prototype.addLine = function (t) {
        for (var e = 1; e < t.length; e++) {
          var n = new gn(t[e - 1], t[e]),
            i = Math.min(n.p0.y, n.p1.y),
            r = Math.max(n.p0.y, n.p1.y);
          this._index.insert(i, r, n);
        }
      }, wr.prototype.query = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1],
            n = new _r();
          return this._index.query(t, e, n), n.getItems();
        }
        if (3 === arguments.length) {
          var i = arguments[0],
            r = arguments[1],
            o = arguments[2];
          this._index.query(i, r, o);
        }
      }, wr.prototype.interfaces_ = function () {
        return [];
      }, wr.prototype.getClass = function () {
        return wr;
      };
      var Sr = function (t) {
          function e() {
            if (t.call(this), this._parentGeom = null, this._lineEdgeMap = new de(), this._boundaryNodeRule = null, this._useBoundaryDeterminationRule = !0, this._argIndex = null, this._boundaryNodes = null, this._hasTooFewPoints = !1, this._invalidPoint = null, this._areaPtLocator = null, this._ptLocator = new Ti(), 2 === arguments.length) {
              var e = arguments[0],
                n = arguments[1],
                i = mt.OGC_SFS_BOUNDARY_RULE;
              this._argIndex = e, this._parentGeom = n, this._boundaryNodeRule = i, null !== n && this.add(n);
            } else if (3 === arguments.length) {
              var r = arguments[0],
                o = arguments[1],
                s = arguments[2];
              this._argIndex = r, this._parentGeom = o, this._boundaryNodeRule = s, null !== o && this.add(o);
            }
          }
          return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.insertBoundaryPoint = function (t, n) {
            var i = this._nodes.addNode(n).getLabel(),
              r = 1;
            C.NONE, i.getLocation(t, Te.ON) === C.BOUNDARY && r++;
            var o = e.determineBoundary(this._boundaryNodeRule, r);
            i.setLocation(t, o);
          }, e.prototype.computeSelfNodes = function () {
            if (2 === arguments.length) {
              var t = arguments[0],
                e = arguments[1];
              return this.computeSelfNodes(t, e, !1);
            }
            if (3 === arguments.length) {
              var n = arguments[0],
                i = arguments[1],
                r = arguments[2],
                o = new cr(n, !0, !1);
              o.setIsDoneIfProperInt(r);
              var s = this.createEdgeSetIntersector(),
                a = this._parentGeom instanceof ne || this._parentGeom instanceof te || this._parentGeom instanceof ie,
                l = i || !a;
              return s.computeIntersections(this._edges, o, l), this.addSelfIntersectionNodes(this._argIndex), o;
            }
          }, e.prototype.computeSplitEdges = function (t) {
            for (var e = this._edges.iterator(); e.hasNext();) e.next().eiList.addSplitEdges(t);
          }, e.prototype.computeEdgeIntersections = function (t, e, n) {
            var i = new cr(e, n, !0);
            return i.setBoundaryNodes(this.getBoundaryNodes(), t.getBoundaryNodes()), this.createEdgeSetIntersector().computeIntersections(this._edges, t._edges, i), i;
          }, e.prototype.getGeometry = function () {
            return this._parentGeom;
          }, e.prototype.getBoundaryNodeRule = function () {
            return this._boundaryNodeRule;
          }, e.prototype.hasTooFewPoints = function () {
            return this._hasTooFewPoints;
          }, e.prototype.addPoint = function () {
            if (arguments[0] instanceof Qt) {
              var t = arguments[0].getCoordinate();
              this.insertPoint(this._argIndex, t, C.INTERIOR);
            } else if (arguments[0] instanceof M) {
              var e = arguments[0];
              this.insertPoint(this._argIndex, e, C.INTERIOR);
            }
          }, e.prototype.addPolygon = function (t) {
            this.addPolygonRing(t.getExteriorRing(), C.EXTERIOR, C.INTERIOR);
            for (var e = 0; e < t.getNumInteriorRing(); e++) {
              var n = t.getInteriorRingN(e);
              this.addPolygonRing(n, C.INTERIOR, C.EXTERIOR);
            }
          }, e.prototype.addEdge = function (t) {
            this.insertEdge(t);
            var e = t.getCoordinates();
            this.insertPoint(this._argIndex, e[0], C.BOUNDARY), this.insertPoint(this._argIndex, e[e.length - 1], C.BOUNDARY);
          }, e.prototype.addLineString = function (t) {
            var e = At.removeRepeatedPoints(t.getCoordinates());
            if (e.length < 2) return this._hasTooFewPoints = !0, this._invalidPoint = e[0], null;
            var n = new ii(e, new Re(this._argIndex, C.INTERIOR));
            this._lineEdgeMap.put(t, n), this.insertEdge(n), nt.isTrue(e.length >= 2, "found LineString with single point"), this.insertBoundaryPoint(this._argIndex, e[0]), this.insertBoundaryPoint(this._argIndex, e[e.length - 1]);
          }, e.prototype.getInvalidPoint = function () {
            return this._invalidPoint;
          }, e.prototype.getBoundaryPoints = function () {
            for (var t = this.getBoundaryNodes(), e = new Array(t.size()).fill(null), n = 0, i = t.iterator(); i.hasNext();) {
              var r = i.next();
              e[n++] = r.getCoordinate().copy();
            }
            return e;
          }, e.prototype.getBoundaryNodes = function () {
            return null === this._boundaryNodes && (this._boundaryNodes = this._nodes.getBoundaryNodes(this._argIndex)), this._boundaryNodes;
          }, e.prototype.addSelfIntersectionNode = function (t, e, n) {
            if (this.isBoundaryNode(t, e)) return null;
            n === C.BOUNDARY && this._useBoundaryDeterminationRule ? this.insertBoundaryPoint(t, e) : this.insertPoint(t, e, n);
          }, e.prototype.addPolygonRing = function (t, e, n) {
            if (t.isEmpty()) return null;
            var i = At.removeRepeatedPoints(t.getCoordinates());
            if (i.length < 4) return this._hasTooFewPoints = !0, this._invalidPoint = i[0], null;
            var r = e,
              o = n;
            lt.isCCW(i) && (r = n, o = e);
            var s = new ii(i, new Re(this._argIndex, C.BOUNDARY, r, o));
            this._lineEdgeMap.put(t, s), this.insertEdge(s), this.insertPoint(this._argIndex, i[0], C.BOUNDARY);
          }, e.prototype.insertPoint = function (t, e, n) {
            var i = this._nodes.addNode(e),
              r = i.getLabel();
            null === r ? i._label = new Re(t, n) : r.setLocation(t, n);
          }, e.prototype.createEdgeSetIntersector = function () {
            return new pr();
          }, e.prototype.addSelfIntersectionNodes = function (t) {
            for (var e = this._edges.iterator(); e.hasNext();) for (var n = e.next(), i = n.getLabel().getLocation(t), r = n.eiList.iterator(); r.hasNext();) {
              var o = r.next();
              this.addSelfIntersectionNode(t, o.coord, i);
            }
          }, e.prototype.add = function () {
            if (1 !== arguments.length) return t.prototype.add.apply(this, arguments);
            var e = arguments[0];
            if (e.isEmpty()) return null;
            if (e instanceof ie && (this._useBoundaryDeterminationRule = !1), e instanceof te) this.addPolygon(e);else if (e instanceof Jt) this.addLineString(e);else if (e instanceof Qt) this.addPoint(e);else if (e instanceof ee) this.addCollection(e);else if (e instanceof Gt) this.addCollection(e);else if (e instanceof ie) this.addCollection(e);else {
              if (!(e instanceof jt)) throw new Error(e.getClass().getName());
              this.addCollection(e);
            }
          }, e.prototype.addCollection = function (t) {
            for (var e = 0; e < t.getNumGeometries(); e++) {
              var n = t.getGeometryN(e);
              this.add(n);
            }
          }, e.prototype.locate = function (t) {
            return N(this._parentGeom, $t) && this._parentGeom.getNumGeometries() > 50 ? (null === this._areaPtLocator && (this._areaPtLocator = new xr(this._parentGeom)), this._areaPtLocator.locate(t)) : this._ptLocator.locate(t, this._parentGeom);
          }, e.prototype.findEdge = function () {
            if (1 === arguments.length) {
              var e = arguments[0];
              return this._lineEdgeMap.get(e);
            }
            return t.prototype.findEdge.apply(this, arguments);
          }, e.prototype.interfaces_ = function () {
            return [];
          }, e.prototype.getClass = function () {
            return e;
          }, e.determineBoundary = function (t, e) {
            return t.isInBoundary(e) ? C.BOUNDARY : C.INTERIOR;
          }, e;
        }(We),
        Mr = u(function () {
          if (this._li = new ot(), this._resultPrecisionModel = null, this._arg = null, 1 === arguments.length) {
            var t = arguments[0];
            this.setComputationPrecision(t.getPrecisionModel()), this._arg = new Array(1).fill(null), this._arg[0] = new Sr(0, t);
          } else if (2 === arguments.length) {
            var e = arguments[0],
              n = arguments[1],
              i = mt.OGC_SFS_BOUNDARY_RULE;
            e.getPrecisionModel().compareTo(n.getPrecisionModel()) >= 0 ? this.setComputationPrecision(e.getPrecisionModel()) : this.setComputationPrecision(n.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new Sr(0, e, i), this._arg[1] = new Sr(1, n, i);
          } else if (3 === arguments.length) {
            var r = arguments[0],
              o = arguments[1],
              s = arguments[2];
            r.getPrecisionModel().compareTo(o.getPrecisionModel()) >= 0 ? this.setComputationPrecision(r.getPrecisionModel()) : this.setComputationPrecision(o.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new Sr(0, r, s), this._arg[1] = new Sr(1, o, s);
          }
        }, "Cr");
      Mr.prototype.getArgGeometry = function (t) {
        return this._arg[t].getGeometry();
      }, Mr.prototype.setComputationPrecision = function (t) {
        this._resultPrecisionModel = t, this._li.setPrecisionModel(this._resultPrecisionModel);
      }, Mr.prototype.interfaces_ = function () {
        return [];
      }, Mr.prototype.getClass = function () {
        return Mr;
      };
      var Tr = u(function () {}, "Sr");
      Tr.prototype.interfaces_ = function () {
        return [];
      }, Tr.prototype.getClass = function () {
        return Tr;
      }, Tr.map = function () {
        if (arguments[0] instanceof ct && N(arguments[1], Tr.MapOp)) {
          for (var t = arguments[0], e = arguments[1], n = new St(), i = 0; i < t.getNumGeometries(); i++) {
            var r = e.map(t.getGeometryN(i));
            null !== r && n.add(r);
          }
          return t.getFactory().buildGeometry(n);
        }
        if (N(arguments[0], Et) && N(arguments[1], Tr.MapOp)) {
          for (var o = arguments[0], s = arguments[1], a = new St(), l = o.iterator(); l.hasNext();) {
            var u = l.next(),
              h = s.map(u);
            null !== h && a.add(h);
          }
          return a;
        }
      }, Tr.MapOp = function () {};
      var Ar = function (t) {
        function e() {
          var e = arguments[0],
            n = arguments[1];
          t.call(this, e, n), this._ptLocator = new Ti(), this._geomFact = null, this._resultGeom = null, this._graph = null, this._edgeList = new Yn(), this._resultPolyList = new St(), this._resultLineList = new St(), this._resultPointList = new St(), this._graph = new We(new Hn()), this._geomFact = e.getFactory();
        }
        return u(e, "e"), t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.insertUniqueEdge = function (t) {
          var e = this._edgeList.findEqualEdge(t);
          if (null !== e) {
            var n = e.getLabel(),
              i = t.getLabel();
            e.isPointwiseEqual(t) || (i = new Re(t.getLabel())).flip();
            var r = e.getDepth();
            r.isNull() && r.add(n), r.add(i), n.merge(i);
          } else this._edgeList.add(t);
        }, e.prototype.getGraph = function () {
          return this._graph;
        }, e.prototype.cancelDuplicateResultEdges = function () {
          for (var t = this._graph.getEdgeEnds().iterator(); t.hasNext();) {
            var e = t.next(),
              n = e.getSym();
            e.isInResult() && n.isInResult() && (e.setInResult(!1), n.setInResult(!1));
          }
        }, e.prototype.isCoveredByLA = function (t) {
          return !!this.isCovered(t, this._resultLineList) || !!this.isCovered(t, this._resultPolyList);
        }, e.prototype.computeGeometry = function (t, n, i, r) {
          var o = new St();
          return o.addAll(t), o.addAll(n), o.addAll(i), o.isEmpty() ? e.createEmptyResult(r, this._arg[0].getGeometry(), this._arg[1].getGeometry(), this._geomFact) : this._geomFact.buildGeometry(o);
        }, e.prototype.mergeSymLabels = function () {
          for (var t = this._graph.getNodes().iterator(); t.hasNext();) t.next().getEdges().mergeSymLabels();
        }, e.prototype.isCovered = function (t, e) {
          for (var n = e.iterator(); n.hasNext();) {
            var i = n.next();
            if (this._ptLocator.locate(t, i) !== C.EXTERIOR) return !0;
          }
          return !1;
        }, e.prototype.replaceCollapsedEdges = function () {
          for (var t = new St(), e = this._edgeList.iterator(); e.hasNext();) {
            var n = e.next();
            n.isCollapsed() && (e.remove(), t.add(n.getCollapsedEdge()));
          }
          this._edgeList.addAll(t);
        }, e.prototype.updateNodeLabelling = function () {
          for (var t = this._graph.getNodes().iterator(); t.hasNext();) {
            var e = t.next(),
              n = e.getEdges().getLabel();
            e.getLabel().merge(n);
          }
        }, e.prototype.getResultGeometry = function (t) {
          return this.computeOverlay(t), this._resultGeom;
        }, e.prototype.insertUniqueEdges = function (t) {
          for (var e = t.iterator(); e.hasNext();) {
            var n = e.next();
            this.insertUniqueEdge(n);
          }
        }, e.prototype.computeOverlay = function (t) {
          this.copyPoints(0), this.copyPoints(1), this._arg[0].computeSelfNodes(this._li, !1), this._arg[1].computeSelfNodes(this._li, !1), this._arg[0].computeEdgeIntersections(this._arg[1], this._li, !0);
          var e = new St();
          this._arg[0].computeSplitEdges(e), this._arg[1].computeSplitEdges(e), this.insertUniqueEdges(e), this.computeLabelsFromDepths(), this.replaceCollapsedEdges(), Wi.checkValid(this._edgeList.getEdges()), this._graph.addEdges(this._edgeList.getEdges()), this.computeLabelling(), this.labelIncompleteNodes(), this.findResultAreaEdges(t), this.cancelDuplicateResultEdges();
          var n = new He(this._geomFact);
          n.add(this._graph), this._resultPolyList = n.getPolygons();
          var i = new Xi(this, this._geomFact, this._ptLocator);
          this._resultLineList = i.build(t);
          var r = new Yi(this, this._geomFact, this._ptLocator);
          this._resultPointList = r.build(t), this._resultGeom = this.computeGeometry(this._resultPointList, this._resultLineList, this._resultPolyList, t);
        }, e.prototype.labelIncompleteNode = function (t, e) {
          var n = this._ptLocator.locate(t.getCoordinate(), this._arg[e].getGeometry());
          t.getLabel().setLocation(e, n);
        }, e.prototype.copyPoints = function (t) {
          for (var e = this._arg[t].getNodeIterator(); e.hasNext();) {
            var n = e.next();
            this._graph.addNode(n.getCoordinate()).setLabel(t, n.getLabel().getLocation(t));
          }
        }, e.prototype.findResultAreaEdges = function (t) {
          for (var n = this._graph.getEdgeEnds().iterator(); n.hasNext();) {
            var i = n.next(),
              r = i.getLabel();
            r.isArea() && !i.isInteriorAreaEdge() && e.isResultOfOp(r.getLocation(0, Te.RIGHT), r.getLocation(1, Te.RIGHT), t) && i.setInResult(!0);
          }
        }, e.prototype.computeLabelsFromDepths = function () {
          for (var t = this._edgeList.iterator(); t.hasNext();) {
            var e = t.next(),
              n = e.getLabel(),
              i = e.getDepth();
            if (!i.isNull()) {
              i.normalize();
              for (var r = 0; r < 2; r++) n.isNull(r) || !n.isArea() || i.isNull(r) || (0 === i.getDelta(r) ? n.toLine(r) : (nt.isTrue(!i.isNull(r, Te.LEFT), "depth of LEFT side has not been initialized"), n.setLocation(r, Te.LEFT, i.getLocation(r, Te.LEFT)), nt.isTrue(!i.isNull(r, Te.RIGHT), "depth of RIGHT side has not been initialized"), n.setLocation(r, Te.RIGHT, i.getLocation(r, Te.RIGHT))));
            }
          }
        }, e.prototype.computeLabelling = function () {
          for (var t = this._graph.getNodes().iterator(); t.hasNext();) t.next().getEdges().computeLabelling(this._arg);
          this.mergeSymLabels(), this.updateNodeLabelling();
        }, e.prototype.labelIncompleteNodes = function () {
          for (var t = this._graph.getNodes().iterator(); t.hasNext();) {
            var e = t.next(),
              n = e.getLabel();
            e.isIsolated() && (n.isNull(0) ? this.labelIncompleteNode(e, 0) : this.labelIncompleteNode(e, 1)), e.getEdges().updateLabelling(n);
          }
        }, e.prototype.isCoveredByA = function (t) {
          return !!this.isCovered(t, this._resultPolyList);
        }, e.prototype.interfaces_ = function () {
          return [];
        }, e.prototype.getClass = function () {
          return e;
        }, e;
      }(Mr);
      Ar.overlayOp = function (t, e, n) {
        return new Ar(t, e).getResultGeometry(n);
      }, Ar.intersection = function (t, e) {
        if (t.isEmpty() || e.isEmpty()) return Ar.createEmptyResult(Ar.INTERSECTION, t, e, t.getFactory());
        if (t.isGeometryCollection()) {
          var n = e;
          return Hi.map(t, {
            interfaces_: function () {
              return [Tr.MapOp];
            },
            map: function (t) {
              return t.intersection(n);
            }
          });
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), sr.overlayOp(t, e, Ar.INTERSECTION);
      }, Ar.symDifference = function (t, e) {
        if (t.isEmpty() || e.isEmpty()) {
          if (t.isEmpty() && e.isEmpty()) return Ar.createEmptyResult(Ar.SYMDIFFERENCE, t, e, t.getFactory());
          if (t.isEmpty()) return e.copy();
          if (e.isEmpty()) return t.copy();
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), sr.overlayOp(t, e, Ar.SYMDIFFERENCE);
      }, Ar.resultDimension = function (t, e, n) {
        var i = e.getDimension(),
          r = n.getDimension(),
          o = -1;
        switch (t) {
          case Ar.INTERSECTION:
            o = Math.min(i, r);
            break;
          case Ar.UNION:
            o = Math.max(i, r);
            break;
          case Ar.DIFFERENCE:
            o = i;
            break;
          case Ar.SYMDIFFERENCE:
            o = Math.max(i, r);
        }
        return o;
      }, Ar.createEmptyResult = function (t, e, n, i) {
        var r = null;
        switch (Ar.resultDimension(t, e, n)) {
          case -1:
            r = i.createGeometryCollection(new Array(0).fill(null));
            break;
          case 0:
            r = i.createPoint();
            break;
          case 1:
            r = i.createLineString();
            break;
          case 2:
            r = i.createPolygon();
        }
        return r;
      }, Ar.difference = function (t, e) {
        return t.isEmpty() ? Ar.createEmptyResult(Ar.DIFFERENCE, t, e, t.getFactory()) : e.isEmpty() ? t.copy() : (t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), sr.overlayOp(t, e, Ar.DIFFERENCE));
      }, Ar.isResultOfOp = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1],
            n = t.getLocation(0),
            i = t.getLocation(1);
          return Ar.isResultOfOp(n, i, e);
        }
        if (3 === arguments.length) {
          var r = arguments[0],
            o = arguments[1],
            s = arguments[2];
          switch (r === C.BOUNDARY && (r = C.INTERIOR), o === C.BOUNDARY && (o = C.INTERIOR), s) {
            case Ar.INTERSECTION:
              return r === C.INTERIOR && o === C.INTERIOR;
            case Ar.UNION:
              return r === C.INTERIOR || o === C.INTERIOR;
            case Ar.DIFFERENCE:
              return r === C.INTERIOR && o !== C.INTERIOR;
            case Ar.SYMDIFFERENCE:
              return r === C.INTERIOR && o !== C.INTERIOR || r !== C.INTERIOR && o === C.INTERIOR;
          }
          return !1;
        }
      }, Ar.INTERSECTION = 1, Ar.UNION = 2, Ar.DIFFERENCE = 3, Ar.SYMDIFFERENCE = 4;
      var Pr = u(function () {
        this._g = null, this._boundaryDistanceTolerance = null, this._linework = null, this._ptLocator = new Ti(), this._seg = new gn();
        var t = arguments[0],
          e = arguments[1];
        this._g = t, this._boundaryDistanceTolerance = e, this._linework = this.extractLinework(t);
      }, "br");
      Pr.prototype.isWithinToleranceOfBoundary = function (t) {
        for (var e = 0; e < this._linework.getNumGeometries(); e++) for (var n = this._linework.getGeometryN(e).getCoordinateSequence(), i = 0; i < n.size() - 1; i++) if (n.getCoordinate(i, this._seg.p0), n.getCoordinate(i + 1, this._seg.p1), this._seg.distance(t) <= this._boundaryDistanceTolerance) return !0;
        return !1;
      }, Pr.prototype.getLocation = function (t) {
        return this.isWithinToleranceOfBoundary(t) ? C.BOUNDARY : this._ptLocator.locate(t, this._g);
      }, Pr.prototype.extractLinework = function (t) {
        var e = new Cr();
        t.apply(e);
        var n = e.getLinework(),
          i = ye.toLineStringArray(n);
        return t.getFactory().createMultiLineString(i);
      }, Pr.prototype.interfaces_ = function () {
        return [];
      }, Pr.prototype.getClass = function () {
        return Pr;
      };
      var Cr = u(function () {
        this._linework = null, this._linework = new St();
      }, "wr");
      Cr.prototype.getLinework = function () {
        return this._linework;
      }, Cr.prototype.filter = function (t) {
        if (t instanceof te) {
          var e = t;
          this._linework.add(e.getExteriorRing());
          for (var n = 0; n < e.getNumInteriorRing(); n++) this._linework.add(e.getInteriorRingN(n));
        }
      }, Cr.prototype.interfaces_ = function () {
        return [zt];
      }, Cr.prototype.getClass = function () {
        return Cr;
      };
      var Ir = u(function () {
        this._g = null, this._doLeft = !0, this._doRight = !0;
        var t = arguments[0];
        this._g = t;
      }, "Or");
      Ir.prototype.extractPoints = function (t, e, n) {
        for (var i = t.getCoordinates(), r = 0; r < i.length - 1; r++) this.computeOffsetPoints(i[r], i[r + 1], e, n);
      }, Ir.prototype.setSidesToGenerate = function (t, e) {
        this._doLeft = t, this._doRight = e;
      }, Ir.prototype.getPoints = function (t) {
        for (var e = new St(), n = Mi.getLines(this._g).iterator(); n.hasNext();) {
          var i = n.next();
          this.extractPoints(i, t, e);
        }
        return e;
      }, Ir.prototype.computeOffsetPoints = function (t, e, n, i) {
        var r = e.x - t.x,
          o = e.y - t.y,
          s = Math.sqrt(r * r + o * o),
          a = n * r / s,
          l = n * o / s,
          u = (e.x + t.x) / 2,
          h = (e.y + t.y) / 2;
        if (this._doLeft) {
          var c = new M(u - l, h + a);
          i.add(c);
        }
        if (this._doRight) {
          var p = new M(u + l, h - a);
          i.add(p);
        }
      }, Ir.prototype.interfaces_ = function () {
        return [];
      }, Ir.prototype.getClass = function () {
        return Ir;
      };
      var Nr = u(function t() {
          this._geom = null, this._locFinder = null, this._location = new Array(3).fill(null), this._invalidLocation = null, this._boundaryDistanceTolerance = t.TOLERANCE, this._testCoords = new St();
          var e = arguments[0],
            n = arguments[1],
            i = arguments[2];
          this._boundaryDistanceTolerance = t.computeBoundaryDistanceTolerance(e, n), this._geom = [e, n, i], this._locFinder = [new Pr(this._geom[0], this._boundaryDistanceTolerance), new Pr(this._geom[1], this._boundaryDistanceTolerance), new Pr(this._geom[2], this._boundaryDistanceTolerance)];
        }, "t"),
        Lr = {
          TOLERANCE: {
            configurable: !0
          }
        };
      Nr.prototype.reportResult = function (t, e, n) {
        W.out.println("Overlay result invalid - A:" + C.toLocationSymbol(e[0]) + " B:" + C.toLocationSymbol(e[1]) + " expected:" + (n ? "i" : "e") + " actual:" + C.toLocationSymbol(e[2]));
      }, Nr.prototype.isValid = function (t) {
        return this.addTestPts(this._geom[0]), this.addTestPts(this._geom[1]), this.checkValid(t);
      }, Nr.prototype.checkValid = function () {
        if (1 === arguments.length) {
          for (var t = arguments[0], e = 0; e < this._testCoords.size(); e++) {
            var n = this._testCoords.get(e);
            if (!this.checkValid(t, n)) return this._invalidLocation = n, !1;
          }
          return !0;
        }
        if (2 === arguments.length) {
          var i = arguments[0],
            r = arguments[1];
          return this._location[0] = this._locFinder[0].getLocation(r), this._location[1] = this._locFinder[1].getLocation(r), this._location[2] = this._locFinder[2].getLocation(r), !!Nr.hasLocation(this._location, C.BOUNDARY) || this.isValidResult(i, this._location);
        }
      }, Nr.prototype.addTestPts = function (t) {
        var e = new Ir(t);
        this._testCoords.addAll(e.getPoints(5 * this._boundaryDistanceTolerance));
      }, Nr.prototype.isValidResult = function (t, e) {
        var n = Ar.isResultOfOp(e[0], e[1], t),
          i = !(n ^ e[2] === C.INTERIOR);
        return i || this.reportResult(t, e, n), i;
      }, Nr.prototype.getInvalidLocation = function () {
        return this._invalidLocation;
      }, Nr.prototype.interfaces_ = function () {
        return [];
      }, Nr.prototype.getClass = function () {
        return Nr;
      }, Nr.hasLocation = function (t, e) {
        for (var n = 0; n < 3; n++) if (t[n] === e) return !0;
        return !1;
      }, Nr.computeBoundaryDistanceTolerance = function (t, e) {
        return Math.min(Ki.computeSizeBasedSnapTolerance(t), Ki.computeSizeBasedSnapTolerance(e));
      }, Nr.isValid = function (t, e, n, i) {
        return new Nr(t, e, i).isValid(n);
      }, Lr.TOLERANCE.get = function () {
        return 1e-6;
      }, Object.defineProperties(Nr, Lr);
      var Rr = u(function t(e) {
        this._geomFactory = null, this._skipEmpty = !1, this._inputGeoms = null, this._geomFactory = t.extractFactory(e), this._inputGeoms = e;
      }, "t");
      Rr.prototype.extractElements = function (t, e) {
        if (null === t) return null;
        for (var n = 0; n < t.getNumGeometries(); n++) {
          var i = t.getGeometryN(n);
          this._skipEmpty && i.isEmpty() || e.add(i);
        }
      }, Rr.prototype.combine = function () {
        for (var t = new St(), e = this._inputGeoms.iterator(); e.hasNext();) {
          var n = e.next();
          this.extractElements(n, t);
        }
        return 0 === t.size() ? null !== this._geomFactory ? this._geomFactory.createGeometryCollection(null) : null : this._geomFactory.buildGeometry(t);
      }, Rr.prototype.interfaces_ = function () {
        return [];
      }, Rr.prototype.getClass = function () {
        return Rr;
      }, Rr.combine = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return new Rr(t).combine();
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          return new Rr(Rr.createList(e, n)).combine();
        }
        if (3 === arguments.length) {
          var i = arguments[0],
            r = arguments[1],
            o = arguments[2];
          return new Rr(Rr.createList(i, r, o)).combine();
        }
      }, Rr.extractFactory = function (t) {
        return t.isEmpty() ? null : t.iterator().next().getFactory();
      }, Rr.createList = function () {
        if (2 === arguments.length) {
          var t = arguments[0],
            e = arguments[1],
            n = new St();
          return n.add(t), n.add(e), n;
        }
        if (3 === arguments.length) {
          var i = arguments[0],
            r = arguments[1],
            o = arguments[2],
            s = new St();
          return s.add(i), s.add(r), s.add(o), s;
        }
      };
      var Or = u(function () {
          this._inputPolys = null, this._geomFactory = null;
          var t = arguments[0];
          this._inputPolys = t, null === this._inputPolys && (this._inputPolys = new St());
        }, "Dr"),
        qr = {
          STRTREE_NODE_CAPACITY: {
            configurable: !0
          }
        };
      Or.prototype.reduceToGeometries = function (t) {
        for (var e = new St(), n = t.iterator(); n.hasNext();) {
          var i = n.next(),
            r = null;
          N(i, wt) ? r = this.unionTree(i) : i instanceof ct && (r = i), e.add(r);
        }
        return e;
      }, Or.prototype.extractByEnvelope = function (t, e, n) {
        for (var i = new St(), r = 0; r < e.getNumGeometries(); r++) {
          var o = e.getGeometryN(r);
          o.getEnvelopeInternal().intersects(t) ? i.add(o) : n.add(o);
        }
        return this._geomFactory.buildGeometry(i);
      }, Or.prototype.unionOptimized = function (t, e) {
        var n = t.getEnvelopeInternal(),
          i = e.getEnvelopeInternal();
        if (!n.intersects(i)) return Rr.combine(t, e);
        if (t.getNumGeometries() <= 1 && e.getNumGeometries() <= 1) return this.unionActual(t, e);
        var r = n.intersection(i);
        return this.unionUsingEnvelopeIntersection(t, e, r);
      }, Or.prototype.union = function () {
        if (null === this._inputPolys) throw new Error("union() method cannot be called twice");
        if (this._inputPolys.isEmpty()) return null;
        this._geomFactory = this._inputPolys.iterator().next().getFactory();
        for (var t = new an(Or.STRTREE_NODE_CAPACITY), e = this._inputPolys.iterator(); e.hasNext();) {
          var n = e.next();
          t.insert(n.getEnvelopeInternal(), n);
        }
        this._inputPolys = null;
        var i = t.itemsTree();
        return this.unionTree(i);
      }, Or.prototype.binaryUnion = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return this.binaryUnion(t, 0, t.size());
        }
        if (3 === arguments.length) {
          var e = arguments[0],
            n = arguments[1],
            i = arguments[2];
          if (i - n <= 1) {
            var r = Or.getGeometry(e, n);
            return this.unionSafe(r, null);
          }
          if (i - n == 2) return this.unionSafe(Or.getGeometry(e, n), Or.getGeometry(e, n + 1));
          var o = Math.trunc((i + n) / 2),
            s = this.binaryUnion(e, n, o),
            a = this.binaryUnion(e, o, i);
          return this.unionSafe(s, a);
        }
      }, Or.prototype.repeatedUnion = function (t) {
        for (var e = null, n = t.iterator(); n.hasNext();) {
          var i = n.next();
          e = null === e ? i.copy() : e.union(i);
        }
        return e;
      }, Or.prototype.unionSafe = function (t, e) {
        return null === t && null === e ? null : null === t ? e.copy() : null === e ? t.copy() : this.unionOptimized(t, e);
      }, Or.prototype.unionActual = function (t, e) {
        return Or.restrictToPolygons(t.union(e));
      }, Or.prototype.unionTree = function (t) {
        var e = this.reduceToGeometries(t);
        return this.binaryUnion(e);
      }, Or.prototype.unionUsingEnvelopeIntersection = function (t, e, n) {
        var i = new St(),
          r = this.extractByEnvelope(n, t, i),
          o = this.extractByEnvelope(n, e, i),
          s = this.unionActual(r, o);
        return i.add(s), Rr.combine(i);
      }, Or.prototype.bufferUnion = function () {
        if (1 === arguments.length) {
          var t = arguments[0];
          return t.get(0).getFactory().buildGeometry(t).buffer(0);
        }
        if (2 === arguments.length) {
          var e = arguments[0],
            n = arguments[1];
          return e.getFactory().createGeometryCollection([e, n]).buffer(0);
        }
      }, Or.prototype.interfaces_ = function () {
        return [];
      }, Or.prototype.getClass = function () {
        return Or;
      }, Or.restrictToPolygons = function (t) {
        if (N(t, $t)) return t;
        var e = Si.getPolygons(t);
        return 1 === e.size() ? e.get(0) : t.getFactory().createMultiPolygon(ye.toPolygonArray(e));
      }, Or.getGeometry = function (t, e) {
        return e >= t.size() ? null : t.get(e);
      }, Or.union = function (t) {
        return new Or(t).union();
      }, qr.STRTREE_NODE_CAPACITY.get = function () {
        return 4;
      }, Object.defineProperties(Or, qr);
      var Dr = u(function () {}, "Ar");
      Dr.prototype.interfaces_ = function () {
        return [];
      }, Dr.prototype.getClass = function () {
        return Dr;
      }, Dr.union = function (t, e) {
        if (t.isEmpty() || e.isEmpty()) {
          if (t.isEmpty() && e.isEmpty()) return Ar.createEmptyResult(Ar.UNION, t, e, t.getFactory());
          if (t.isEmpty()) return e.copy();
          if (e.isEmpty()) return t.copy();
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), sr.overlayOp(t, e, Ar.UNION);
      }, t.GeoJSONReader = Se, t.GeoJSONWriter = Me, t.OverlayOp = Ar, t.UnionOp = Dr, t.BufferOp = gi, Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, "object" == typeof t && void 0 !== e ? i(t) : "function" == typeof define && define.amd ? define(["exports"], i) : i(n.jsts = {});
  }),
  GF = ze((t, e) => {
    E();
    var n = 9007199254740991,
      i = /^(?:0|[1-9]\d*)$/;
    function r(t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);
        case 1:
          return t.call(e, n[0]);
        case 2:
          return t.call(e, n[0], n[1]);
        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }
      return t.apply(e, n);
    }
    function o(t, e) {
      for (var n = -1, i = Array(t); ++n < t;) i[n] = e(n);
      return i;
    }
    u(r, "apply"), u(o, "baseTimes");
    var s = Object.prototype,
      a = s.hasOwnProperty,
      l = s.toString,
      h = s.propertyIsEnumerable,
      c = Math.max;
    function p(t, e) {
      var n = T(t) || M(t) ? o(t.length, String) : [],
        i = n.length,
        r = !!i;
      for (var s in t) (e || a.call(t, s)) && (!r || "length" != s && !_(s, i)) && n.push(s);
      return n;
    }
    function d(t, e, n, i) {
      return void 0 === t || S(t, s[n]) && !a.call(i, n) ? e : t;
    }
    function f(t, e, n) {
      var i = t[e];
      (!a.call(t, e) || !S(i, n) || void 0 === n && !(e in t)) && (t[e] = n);
    }
    function m(t) {
      if (!N(t)) return w(t);
      var e = b(t),
        n = [];
      for (var i in t) "constructor" == i && (e || !a.call(t, i)) || n.push(i);
      return n;
    }
    function g(t, e) {
      return e = c(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var n = arguments, i = -1, o = c(n.length - e, 0), s = Array(o); ++i < o;) s[i] = n[e + i];
        i = -1;
        for (var a = Array(e + 1); ++i < e;) a[i] = n[i];
        return a[e] = s, r(t, this, a);
      };
    }
    function v(t, e, n, i) {
      n || (n = {});
      for (var r = -1, o = e.length; ++r < o;) {
        var s = e[r],
          a = i ? i(n[s], t[s], s, n, t) : void 0;
        f(n, s, void 0 === a ? t[s] : a);
      }
      return n;
    }
    function y(t) {
      return g(function (e, n) {
        var i = -1,
          r = n.length,
          o = r > 1 ? n[r - 1] : void 0,
          s = r > 2 ? n[2] : void 0;
        for (o = t.length > 3 && "function" == typeof o ? (r--, o) : void 0, s && x(n[0], n[1], s) && (o = r < 3 ? void 0 : o, r = 1), e = Object(e); ++i < r;) {
          var a = n[i];
          a && t(e, a, i, o);
        }
        return e;
      });
    }
    function _(t, e) {
      return !!(e = null == e ? n : e) && ("number" == typeof t || i.test(t)) && t > -1 && t % 1 == 0 && t < e;
    }
    function x(t, e, n) {
      if (!N(n)) return !1;
      var i = typeof e;
      return !!("number" == i ? A(n) && _(e, n.length) : "string" == i && e in n) && S(n[e], t);
    }
    function b(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || s);
    }
    function w(t) {
      var e = [];
      if (null != t) for (var n in Object(t)) e.push(n);
      return e;
    }
    function S(t, e) {
      return t === e || t != t && e != e;
    }
    function M(t) {
      return P(t) && a.call(t, "callee") && (!h.call(t, "callee") || "[object Arguments]" == l.call(t));
    }
    u(p, "arrayLikeKeys"), u(d, "assignInDefaults"), u(f, "assignValue"), u(m, "baseKeysIn"), u(g, "baseRest"), u(v, "copyObject"), u(y, "createAssigner"), u(_, "isIndex"), u(x, "isIterateeCall"), u(b, "isPrototype"), u(w, "nativeKeysIn"), u(S, "eq"), u(M, "isArguments");
    var T = Array.isArray;
    function A(t) {
      return null != t && I(t.length) && !C(t);
    }
    function P(t) {
      return L(t) && A(t);
    }
    function C(t) {
      var e = N(t) ? l.call(t) : "";
      return "[object Function]" == e || "[object GeneratorFunction]" == e;
    }
    function I(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
    }
    function N(t) {
      var e = typeof t;
      return !!t && ("object" == e || "function" == e);
    }
    function L(t) {
      return !!t && "object" == typeof t;
    }
    u(A, "isArrayLike"), u(P, "isArrayLikeObject"), u(C, "isFunction"), u(I, "isLength"), u(N, "isObject"), u(L, "isObjectLike");
    var R = y(function (t, e, n, i) {
        v(e, q(e), t, i);
      }),
      O = g(function (t) {
        return t.push(void 0, d), r(R, void 0, t);
      });
    function q(t) {
      return A(t) ? p(t, !0) : m(t);
    }
    u(q, "keysIn"), e.exports = O;
  }),
  $F = ze((t, e) => {
    E();
    var n,
      i = {},
      r = !1;
    void 0 !== e && e.exports ? (e.exports = i, r = !0) : "undefined" != typeof document ? window.ClipperLib = i : self.ClipperLib = i, r ? (o = "chrome", n = "Netscape") : (o = navigator.userAgent.toString().toLowerCase(), n = navigator.appName);
    var o,
      s = {};
    -1 != o.indexOf("chrome") && -1 == o.indexOf("chromium") ? s.chrome = 1 : s.chrome = 0, -1 != o.indexOf("chromium") ? s.chromium = 1 : s.chromium = 0, -1 != o.indexOf("safari") && -1 == o.indexOf("chrome") && -1 == o.indexOf("chromium") ? s.safari = 1 : s.safari = 0, -1 != o.indexOf("firefox") ? s.firefox = 1 : s.firefox = 0, -1 != o.indexOf("firefox/17") ? s.firefox17 = 1 : s.firefox17 = 0, -1 != o.indexOf("firefox/15") ? s.firefox15 = 1 : s.firefox15 = 0, -1 != o.indexOf("firefox/3") ? s.firefox3 = 1 : s.firefox3 = 0, -1 != o.indexOf("opera") ? s.opera = 1 : s.opera = 0, -1 != o.indexOf("msie 10") ? s.msie10 = 1 : s.msie10 = 0, -1 != o.indexOf("msie 9") ? s.msie9 = 1 : s.msie9 = 0, -1 != o.indexOf("msie 8") ? s.msie8 = 1 : s.msie8 = 0, -1 != o.indexOf("msie 7") ? s.msie7 = 1 : s.msie7 = 0, -1 != o.indexOf("msie ") ? s.msie = 1 : s.msie = 0, i.biginteger_used = null;
    var a;
    function l(t, e, n) {
      i.biginteger_used = 1, null != t && ("number" == typeof t && void 0 === e ? this.fromInt(t) : "number" == typeof t ? this.fromNumber(t, e, n) : null == e && "string" != typeof t ? this.fromString(t, 256) : this.fromString(t, e));
    }
    function h() {
      return new l(null);
    }
    function c(t, e, n, i, r, o) {
      for (; --o >= 0;) {
        var s = e * this[t++] + n[i] + r;
        r = Math.floor(s / 67108864), n[i++] = 67108863 & s;
      }
      return r;
    }
    function p(t, e, n, i, r, o) {
      for (var s = 32767 & e, a = e >> 15; --o >= 0;) {
        var l = 32767 & this[t],
          u = this[t++] >> 15,
          h = a * l + u * s;
        r = ((l = s * l + ((32767 & h) << 15) + n[i] + (1073741823 & r)) >>> 30) + (h >>> 15) + a * u + (r >>> 30), n[i++] = 1073741823 & l;
      }
      return r;
    }
    function d(t, e, n, i, r, o) {
      for (var s = 16383 & e, a = e >> 14; --o >= 0;) {
        var l = 16383 & this[t],
          u = this[t++] >> 14,
          h = a * l + u * s;
        r = ((l = s * l + ((16383 & h) << 14) + n[i] + r) >> 28) + (h >> 14) + a * u, n[i++] = 268435455 & l;
      }
      return r;
    }
    u(l, "BigInteger"), u(h, "nbi"), u(c, "am1"), u(p, "am2"), u(d, "am3"), "Microsoft Internet Explorer" == n ? (l.prototype.am = p, a = 30) : "Netscape" != n ? (l.prototype.am = c, a = 26) : (l.prototype.am = d, a = 28), l.prototype.DB = a, l.prototype.DM = (1 << a) - 1, l.prototype.DV = 1 << a;
    l.prototype.FV = Math.pow(2, 52), l.prototype.F1 = 52 - a, l.prototype.F2 = 2 * a - 52;
    var f,
      m,
      g = new Array();
    for (f = "0".charCodeAt(0), m = 0; m <= 9; ++m) g[f++] = m;
    for (f = "a".charCodeAt(0), m = 10; m < 36; ++m) g[f++] = m;
    for (f = "A".charCodeAt(0), m = 10; m < 36; ++m) g[f++] = m;
    function v(t) {
      return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t);
    }
    function y(t, e) {
      var n = g[t.charCodeAt(e)];
      return null == n ? -1 : n;
    }
    function _(t) {
      for (var e = this.t - 1; e >= 0; --e) t[e] = this[e];
      t.t = this.t, t.s = this.s;
    }
    function x(t) {
      this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this[0] = t : t < -1 ? this[0] = t + this.DV : this.t = 0;
    }
    function b(t) {
      var e = h();
      return e.fromInt(t), e;
    }
    function w(t, e) {
      var n;
      if (16 == e) n = 4;else if (8 == e) n = 3;else if (256 == e) n = 8;else if (2 == e) n = 1;else if (32 == e) n = 5;else {
        if (4 != e) return void this.fromRadix(t, e);
        n = 2;
      }
      this.t = 0, this.s = 0;
      for (var i = t.length, r = !1, o = 0; --i >= 0;) {
        var s = 8 == n ? 255 & t[i] : y(t, i);
        s < 0 ? "-" == t.charAt(i) && (r = !0) : (r = !1, 0 == o ? this[this.t++] = s : o + n > this.DB ? (this[this.t - 1] |= (s & (1 << this.DB - o) - 1) << o, this[this.t++] = s >> this.DB - o) : this[this.t - 1] |= s << o, (o += n) >= this.DB && (o -= this.DB));
      }
      8 == n && 0 != (128 & t[0]) && (this.s = -1, o > 0 && (this[this.t - 1] |= (1 << this.DB - o) - 1 << o)), this.clamp(), r && l.ZERO.subTo(this, this);
    }
    function S() {
      for (var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t;) --this.t;
    }
    function M(t) {
      if (this.s < 0) return "-" + this.negate().toString(t);
      var e;
      if (16 == t) e = 4;else if (8 == t) e = 3;else if (2 == t) e = 1;else if (32 == t) e = 5;else {
        if (4 != t) return this.toRadix(t);
        e = 2;
      }
      var n,
        i = (1 << e) - 1,
        r = !1,
        o = "",
        s = this.t,
        a = this.DB - s * this.DB % e;
      if (s-- > 0) for (a < this.DB && (n = this[s] >> a) > 0 && (r = !0, o = v(n)); s >= 0;) a < e ? (n = (this[s] & (1 << a) - 1) << e - a, n |= this[--s] >> (a += this.DB - e)) : (n = this[s] >> (a -= e) & i, a <= 0 && (a += this.DB, --s)), n > 0 && (r = !0), r && (o += v(n));
      return r ? o : "0";
    }
    function T() {
      var t = h();
      return l.ZERO.subTo(this, t), t;
    }
    function A() {
      return this.s < 0 ? this.negate() : this;
    }
    function P(t) {
      var e = this.s - t.s;
      if (0 != e) return e;
      var n = this.t;
      if (0 != (e = n - t.t)) return this.s < 0 ? -e : e;
      for (; --n >= 0;) if (0 != (e = this[n] - t[n])) return e;
      return 0;
    }
    function C(t) {
      var e,
        n = 1;
      return 0 != (e = t >>> 16) && (t = e, n += 16), 0 != (e = t >> 8) && (t = e, n += 8), 0 != (e = t >> 4) && (t = e, n += 4), 0 != (e = t >> 2) && (t = e, n += 2), 0 != (e = t >> 1) && (t = e, n += 1), n;
    }
    function I() {
      return this.t <= 0 ? 0 : this.DB * (this.t - 1) + C(this[this.t - 1] ^ this.s & this.DM);
    }
    function N(t, e) {
      var n;
      for (n = this.t - 1; n >= 0; --n) e[n + t] = this[n];
      for (n = t - 1; n >= 0; --n) e[n] = 0;
      e.t = this.t + t, e.s = this.s;
    }
    function L(t, e) {
      for (var n = t; n < this.t; ++n) e[n - t] = this[n];
      e.t = Math.max(this.t - t, 0), e.s = this.s;
    }
    function R(t, e) {
      var n,
        i = t % this.DB,
        r = this.DB - i,
        o = (1 << r) - 1,
        s = Math.floor(t / this.DB),
        a = this.s << i & this.DM;
      for (n = this.t - 1; n >= 0; --n) e[n + s + 1] = this[n] >> r | a, a = (this[n] & o) << i;
      for (n = s - 1; n >= 0; --n) e[n] = 0;
      e[s] = a, e.t = this.t + s + 1, e.s = this.s, e.clamp();
    }
    function O(t, e) {
      e.s = this.s;
      var n = Math.floor(t / this.DB);
      if (n >= this.t) e.t = 0;else {
        var i = t % this.DB,
          r = this.DB - i,
          o = (1 << i) - 1;
        e[0] = this[n] >> i;
        for (var s = n + 1; s < this.t; ++s) e[s - n - 1] |= (this[s] & o) << r, e[s - n] = this[s] >> i;
        i > 0 && (e[this.t - n - 1] |= (this.s & o) << r), e.t = this.t - n, e.clamp();
      }
    }
    function q(t, e) {
      for (var n = 0, i = 0, r = Math.min(t.t, this.t); n < r;) i += this[n] - t[n], e[n++] = i & this.DM, i >>= this.DB;
      if (t.t < this.t) {
        for (i -= t.s; n < this.t;) i += this[n], e[n++] = i & this.DM, i >>= this.DB;
        i += this.s;
      } else {
        for (i += this.s; n < t.t;) i -= t[n], e[n++] = i & this.DM, i >>= this.DB;
        i -= t.s;
      }
      e.s = i < 0 ? -1 : 0, i < -1 ? e[n++] = this.DV + i : i > 0 && (e[n++] = i), e.t = n, e.clamp();
    }
    function D(t, e) {
      var n = this.abs(),
        i = t.abs(),
        r = n.t;
      for (e.t = r + i.t; --r >= 0;) e[r] = 0;
      for (r = 0; r < i.t; ++r) e[r + n.t] = n.am(0, i[r], e, r, 0, n.t);
      e.s = 0, e.clamp(), this.s != t.s && l.ZERO.subTo(e, e);
    }
    function k(t) {
      for (var e = this.abs(), n = t.t = 2 * e.t; --n >= 0;) t[n] = 0;
      for (n = 0; n < e.t - 1; ++n) {
        var i = e.am(n, e[n], t, 2 * n, 0, 1);
        (t[n + e.t] += e.am(n + 1, 2 * e[n], t, 2 * n + 1, i, e.t - n - 1)) >= e.DV && (t[n + e.t] -= e.DV, t[n + e.t + 1] = 1);
      }
      t.t > 0 && (t[t.t - 1] += e.am(n, e[n], t, 2 * n, 0, 1)), t.s = 0, t.clamp();
    }
    function F(t, e, n) {
      var i = t.abs();
      if (!(i.t <= 0)) {
        var r = this.abs();
        if (r.t < i.t) return null != e && e.fromInt(0), void (null != n && this.copyTo(n));
        null == n && (n = h());
        var o = h(),
          s = this.s,
          a = t.s,
          u = this.DB - C(i[i.t - 1]);
        u > 0 ? (i.lShiftTo(u, o), r.lShiftTo(u, n)) : (i.copyTo(o), r.copyTo(n));
        var c = o.t,
          p = o[c - 1];
        if (0 != p) {
          var d = p * (1 << this.F1) + (c > 1 ? o[c - 2] >> this.F2 : 0),
            f = this.FV / d,
            m = (1 << this.F1) / d,
            g = 1 << this.F2,
            v = n.t,
            y = v - c,
            _ = null == e ? h() : e;
          for (o.dlShiftTo(y, _), n.compareTo(_) >= 0 && (n[n.t++] = 1, n.subTo(_, n)), l.ONE.dlShiftTo(c, _), _.subTo(o, o); o.t < c;) o[o.t++] = 0;
          for (; --y >= 0;) {
            var x = n[--v] == p ? this.DM : Math.floor(n[v] * f + (n[v - 1] + g) * m);
            if ((n[v] += o.am(0, x, n, y, 0, c)) < x) for (o.dlShiftTo(y, _), n.subTo(_, n); n[v] < --x;) n.subTo(_, n);
          }
          null != e && (n.drShiftTo(c, e), s != a && l.ZERO.subTo(e, e)), n.t = c, n.clamp(), u > 0 && n.rShiftTo(u, n), s < 0 && l.ZERO.subTo(n, n);
        }
      }
    }
    function U(t) {
      var e = h();
      return this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(l.ZERO) > 0 && t.subTo(e, e), e;
    }
    function B(t) {
      this.m = t;
    }
    function z(t) {
      return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t;
    }
    function V(t) {
      return t;
    }
    function j(t) {
      t.divRemTo(this.m, null, t);
    }
    function G(t, e, n) {
      t.multiplyTo(e, n), this.reduce(n);
    }
    function W(t, e) {
      t.squareTo(e), this.reduce(e);
    }
    function H() {
      if (this.t < 1) return 0;
      var t = this[0];
      if (0 == (1 & t)) return 0;
      var e = 3 & t;
      return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e;
    }
    function X(t) {
      this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t;
    }
    function Y(t) {
      var e = h();
      return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(l.ZERO) > 0 && this.m.subTo(e, e), e;
    }
    function Z(t) {
      var e = h();
      return t.copyTo(e), this.reduce(e), e;
    }
    function J(t) {
      for (; t.t <= this.mt2;) t[t.t++] = 0;
      for (var e = 0; e < this.m.t; ++e) {
        var n = 32767 & t[e],
          i = n * this.mpl + ((n * this.mph + (t[e] >> 15) * this.mpl & this.um) << 15) & t.DM;
        for (t[n = e + this.m.t] += this.m.am(0, i, t, e, 0, this.m.t); t[n] >= t.DV;) t[n] -= t.DV, t[++n]++;
      }
      t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t);
    }
    function K(t, e) {
      t.squareTo(e), this.reduce(e);
    }
    function Q(t, e, n) {
      t.multiplyTo(e, n), this.reduce(n);
    }
    function $() {
      return 0 == (this.t > 0 ? 1 & this[0] : this.s);
    }
    function tt(t, e) {
      if (t > 4294967295 || t < 1) return l.ONE;
      var n = h(),
        i = h(),
        r = e.convert(this),
        o = C(t) - 1;
      for (r.copyTo(n); --o >= 0;) if (e.sqrTo(n, i), (t & 1 << o) > 0) e.mulTo(i, r, n);else {
        var s = n;
        n = i, i = s;
      }
      return e.revert(n);
    }
    function et(t, e) {
      var n;
      return n = t < 256 || e.isEven() ? new B(e) : new X(e), this.exp(t, n);
    }
    function nt() {
      var t = h();
      return this.copyTo(t), t;
    }
    function it() {
      if (this.s < 0) {
        if (1 == this.t) return this[0] - this.DV;
        if (0 == this.t) return -1;
      } else {
        if (1 == this.t) return this[0];
        if (0 == this.t) return 0;
      }
      return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    }
    function rt() {
      return 0 == this.t ? this.s : this[0] << 24 >> 24;
    }
    function ot() {
      return 0 == this.t ? this.s : this[0] << 16 >> 16;
    }
    function st(t) {
      return Math.floor(Math.LN2 * this.DB / Math.log(t));
    }
    function at() {
      return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
    }
    function lt(t) {
      if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36) return "0";
      var e = this.chunkSize(t),
        n = Math.pow(t, e),
        i = b(n),
        r = h(),
        o = h(),
        s = "";
      for (this.divRemTo(i, r, o); r.signum() > 0;) s = (n + o.intValue()).toString(t).substr(1) + s, r.divRemTo(i, r, o);
      return o.intValue().toString(t) + s;
    }
    function ut(t, e) {
      this.fromInt(0), null == e && (e = 10);
      for (var n = this.chunkSize(e), i = Math.pow(e, n), r = !1, o = 0, s = 0, a = 0; a < t.length; ++a) {
        var u = y(t, a);
        u < 0 ? "-" == t.charAt(a) && 0 == this.signum() && (r = !0) : (s = e * s + u, ++o >= n && (this.dMultiply(i), this.dAddOffset(s, 0), o = 0, s = 0));
      }
      o > 0 && (this.dMultiply(Math.pow(e, o)), this.dAddOffset(s, 0)), r && l.ZERO.subTo(this, this);
    }
    function ht(t, e, n) {
      if ("number" == typeof e) {
        if (t < 2) this.fromInt(1);else for (this.fromNumber(t, n), this.testBit(t - 1) || this.bitwiseTo(l.ONE.shiftLeft(t - 1), yt, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);) this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(l.ONE.shiftLeft(t - 1), this);
      } else {
        var i = new Array(),
          r = 7 & t;
        i.length = 1 + (t >> 3), e.nextBytes(i), r > 0 ? i[0] &= (1 << r) - 1 : i[0] = 0, this.fromString(i, 256);
      }
    }
    function ct() {
      var t = this.t,
        e = new Array();
      e[0] = this.s;
      var n,
        i = this.DB - t * this.DB % 8,
        r = 0;
      if (t-- > 0) for (i < this.DB && (n = this[t] >> i) != (this.s & this.DM) >> i && (e[r++] = n | this.s << this.DB - i); t >= 0;) i < 8 ? (n = (this[t] & (1 << i) - 1) << 8 - i, n |= this[--t] >> (i += this.DB - 8)) : (n = this[t] >> (i -= 8) & 255, i <= 0 && (i += this.DB, --t)), 0 != (128 & n) && (n |= -256), 0 == r && (128 & this.s) != (128 & n) && ++r, (r > 0 || n != this.s) && (e[r++] = n);
      return e;
    }
    function pt(t) {
      return 0 == this.compareTo(t);
    }
    function dt(t) {
      return this.compareTo(t) < 0 ? this : t;
    }
    function ft(t) {
      return this.compareTo(t) > 0 ? this : t;
    }
    function mt(t, e, n) {
      var i,
        r,
        o = Math.min(t.t, this.t);
      for (i = 0; i < o; ++i) n[i] = e(this[i], t[i]);
      if (t.t < this.t) {
        for (r = t.s & this.DM, i = o; i < this.t; ++i) n[i] = e(this[i], r);
        n.t = this.t;
      } else {
        for (r = this.s & this.DM, i = o; i < t.t; ++i) n[i] = e(r, t[i]);
        n.t = t.t;
      }
      n.s = e(this.s, t.s), n.clamp();
    }
    function gt(t, e) {
      return t & e;
    }
    function vt(t) {
      var e = h();
      return this.bitwiseTo(t, gt, e), e;
    }
    function yt(t, e) {
      return t | e;
    }
    function _t(t) {
      var e = h();
      return this.bitwiseTo(t, yt, e), e;
    }
    function xt(t, e) {
      return t ^ e;
    }
    function Et(t) {
      var e = h();
      return this.bitwiseTo(t, xt, e), e;
    }
    function bt(t, e) {
      return t & ~e;
    }
    function wt(t) {
      var e = h();
      return this.bitwiseTo(t, bt, e), e;
    }
    function St() {
      for (var t = h(), e = 0; e < this.t; ++e) t[e] = this.DM & ~this[e];
      return t.t = this.t, t.s = ~this.s, t;
    }
    function Mt(t) {
      var e = h();
      return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e;
    }
    function Tt(t) {
      var e = h();
      return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e;
    }
    function At(t) {
      if (0 == t) return -1;
      var e = 0;
      return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e;
    }
    function Pt() {
      for (var t = 0; t < this.t; ++t) if (0 != this[t]) return t * this.DB + At(this[t]);
      return this.s < 0 ? this.t * this.DB : -1;
    }
    function Ct(t) {
      for (var e = 0; 0 != t;) t &= t - 1, ++e;
      return e;
    }
    function It() {
      for (var t = 0, e = this.s & this.DM, n = 0; n < this.t; ++n) t += Ct(this[n] ^ e);
      return t;
    }
    function Nt(t) {
      var e = Math.floor(t / this.DB);
      return e >= this.t ? 0 != this.s : 0 != (this[e] & 1 << t % this.DB);
    }
    function Lt(t, e) {
      var n = l.ONE.shiftLeft(t);
      return this.bitwiseTo(n, e, n), n;
    }
    function Rt(t) {
      return this.changeBit(t, yt);
    }
    function Ot(t) {
      return this.changeBit(t, bt);
    }
    function qt(t) {
      return this.changeBit(t, xt);
    }
    function Dt(t, e) {
      for (var n = 0, i = 0, r = Math.min(t.t, this.t); n < r;) i += this[n] + t[n], e[n++] = i & this.DM, i >>= this.DB;
      if (t.t < this.t) {
        for (i += t.s; n < this.t;) i += this[n], e[n++] = i & this.DM, i >>= this.DB;
        i += this.s;
      } else {
        for (i += this.s; n < t.t;) i += t[n], e[n++] = i & this.DM, i >>= this.DB;
        i += t.s;
      }
      e.s = i < 0 ? -1 : 0, i > 0 ? e[n++] = i : i < -1 && (e[n++] = this.DV + i), e.t = n, e.clamp();
    }
    function kt(t) {
      var e = h();
      return this.addTo(t, e), e;
    }
    function Ft(t) {
      var e = h();
      return this.subTo(t, e), e;
    }
    function Ut(t) {
      var e = h();
      return this.multiplyTo(t, e), e;
    }
    function Bt() {
      var t = h();
      return this.squareTo(t), t;
    }
    function zt(t) {
      var e = h();
      return this.divRemTo(t, e, null), e;
    }
    function Vt(t) {
      var e = h();
      return this.divRemTo(t, null, e), e;
    }
    function jt(t) {
      var e = h(),
        n = h();
      return this.divRemTo(t, e, n), new Array(e, n);
    }
    function Gt(t) {
      this[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp();
    }
    function Wt(t, e) {
      if (0 != t) {
        for (; this.t <= e;) this[this.t++] = 0;
        for (this[e] += t; this[e] >= this.DV;) this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e];
      }
    }
    function Ht() {}
    function Xt(t) {
      return t;
    }
    function Yt(t, e, n) {
      t.multiplyTo(e, n);
    }
    function Zt(t, e) {
      t.squareTo(e);
    }
    function Jt(t) {
      return this.exp(t, new Ht());
    }
    function Kt(t, e, n) {
      var i,
        r = Math.min(this.t + t.t, e);
      for (n.s = 0, n.t = r; r > 0;) n[--r] = 0;
      for (i = n.t - this.t; r < i; ++r) n[r + this.t] = this.am(0, t[r], n, r, 0, this.t);
      for (i = Math.min(t.t, e); r < i; ++r) this.am(0, t[r], n, r, 0, e - r);
      n.clamp();
    }
    function Qt(t, e, n) {
      --e;
      var i = n.t = this.t + t.t - e;
      for (n.s = 0; --i >= 0;) n[i] = 0;
      for (i = Math.max(e - this.t, 0); i < t.t; ++i) n[this.t + i - e] = this.am(e - i, t[i], n, 0, 0, this.t + i - e);
      n.clamp(), n.drShiftTo(1, n);
    }
    function $t(t) {
      this.r2 = h(), this.q3 = h(), l.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t;
    }
    function te(t) {
      if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
      if (t.compareTo(this.m) < 0) return t;
      var e = h();
      return t.copyTo(e), this.reduce(e), e;
    }
    function ee(t) {
      return t;
    }
    function ne(t) {
      for (t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;) t.dAddOffset(1, this.m.t + 1);
      for (t.subTo(this.r2, t); t.compareTo(this.m) >= 0;) t.subTo(this.m, t);
    }
    function ie(t, e) {
      t.squareTo(e), this.reduce(e);
    }
    function re(t, e, n) {
      t.multiplyTo(e, n), this.reduce(n);
    }
    function oe(t, e) {
      var n,
        i,
        r = t.bitLength(),
        o = b(1);
      if (r <= 0) return o;
      n = r < 18 ? 1 : r < 48 ? 3 : r < 144 ? 4 : r < 768 ? 5 : 6, i = r < 8 ? new B(e) : e.isEven() ? new $t(e) : new X(e);
      var s = new Array(),
        a = 3,
        l = n - 1,
        u = (1 << n) - 1;
      if (s[1] = i.convert(this), n > 1) {
        var c = h();
        for (i.sqrTo(s[1], c); a <= u;) s[a] = h(), i.mulTo(c, s[a - 2], s[a]), a += 2;
      }
      var p,
        d,
        f = t.t - 1,
        m = !0,
        g = h();
      for (r = C(t[f]) - 1; f >= 0;) {
        for (r >= l ? p = t[f] >> r - l & u : (p = (t[f] & (1 << r + 1) - 1) << l - r, f > 0 && (p |= t[f - 1] >> this.DB + r - l)), a = n; 0 == (1 & p);) p >>= 1, --a;
        if ((r -= a) < 0 && (r += this.DB, --f), m) s[p].copyTo(o), m = !1;else {
          for (; a > 1;) i.sqrTo(o, g), i.sqrTo(g, o), a -= 2;
          a > 0 ? i.sqrTo(o, g) : (d = o, o = g, g = d), i.mulTo(g, s[p], o);
        }
        for (; f >= 0 && 0 == (t[f] & 1 << r);) i.sqrTo(o, g), d = o, o = g, g = d, --r < 0 && (r = this.DB - 1, --f);
      }
      return i.revert(o);
    }
    function se(t) {
      var e = this.s < 0 ? this.negate() : this.clone(),
        n = t.s < 0 ? t.negate() : t.clone();
      if (e.compareTo(n) < 0) {
        var i = e;
        e = n, n = i;
      }
      var r = e.getLowestSetBit(),
        o = n.getLowestSetBit();
      if (o < 0) return e;
      for (r < o && (o = r), o > 0 && (e.rShiftTo(o, e), n.rShiftTo(o, n)); e.signum() > 0;) (r = e.getLowestSetBit()) > 0 && e.rShiftTo(r, e), (r = n.getLowestSetBit()) > 0 && n.rShiftTo(r, n), e.compareTo(n) >= 0 ? (e.subTo(n, e), e.rShiftTo(1, e)) : (n.subTo(e, n), n.rShiftTo(1, n));
      return o > 0 && n.lShiftTo(o, n), n;
    }
    function ae(t) {
      if (t <= 0) return 0;
      var e = this.DV % t,
        n = this.s < 0 ? t - 1 : 0;
      if (this.t > 0) if (0 == e) n = this[0] % t;else for (var i = this.t - 1; i >= 0; --i) n = (e * n + this[i]) % t;
      return n;
    }
    function le(t) {
      var e = t.isEven();
      if (this.isEven() && e || 0 == t.signum()) return l.ZERO;
      for (var n = t.clone(), i = this.clone(), r = b(1), o = b(0), s = b(0), a = b(1); 0 != n.signum();) {
        for (; n.isEven();) n.rShiftTo(1, n), e ? ((!r.isEven() || !o.isEven()) && (r.addTo(this, r), o.subTo(t, o)), r.rShiftTo(1, r)) : o.isEven() || o.subTo(t, o), o.rShiftTo(1, o);
        for (; i.isEven();) i.rShiftTo(1, i), e ? ((!s.isEven() || !a.isEven()) && (s.addTo(this, s), a.subTo(t, a)), s.rShiftTo(1, s)) : a.isEven() || a.subTo(t, a), a.rShiftTo(1, a);
        n.compareTo(i) >= 0 ? (n.subTo(i, n), e && r.subTo(s, r), o.subTo(a, o)) : (i.subTo(n, i), e && s.subTo(r, s), a.subTo(o, a));
      }
      return 0 != i.compareTo(l.ONE) ? l.ZERO : a.compareTo(t) >= 0 ? a.subtract(t) : a.signum() < 0 ? (a.addTo(t, a), a.signum() < 0 ? a.add(t) : a) : a;
    }
    u(v, "int2char"), u(y, "intAt"), u(_, "bnpCopyTo"), u(x, "bnpFromInt"), u(b, "nbv"), u(w, "bnpFromString"), u(S, "bnpClamp"), u(M, "bnToString"), u(T, "bnNegate"), u(A, "bnAbs"), u(P, "bnCompareTo"), u(C, "nbits"), u(I, "bnBitLength"), u(N, "bnpDLShiftTo"), u(L, "bnpDRShiftTo"), u(R, "bnpLShiftTo"), u(O, "bnpRShiftTo"), u(q, "bnpSubTo"), u(D, "bnpMultiplyTo"), u(k, "bnpSquareTo"), u(F, "bnpDivRemTo"), u(U, "bnMod"), u(B, "Classic"), u(z, "cConvert"), u(V, "cRevert"), u(j, "cReduce"), u(G, "cMulTo"), u(W, "cSqrTo"), B.prototype.convert = z, B.prototype.revert = V, B.prototype.reduce = j, B.prototype.mulTo = G, B.prototype.sqrTo = W, u(H, "bnpInvDigit"), u(X, "Montgomery"), u(Y, "montConvert"), u(Z, "montRevert"), u(J, "montReduce"), u(K, "montSqrTo"), u(Q, "montMulTo"), X.prototype.convert = Y, X.prototype.revert = Z, X.prototype.reduce = J, X.prototype.mulTo = Q, X.prototype.sqrTo = K, u($, "bnpIsEven"), u(tt, "bnpExp"), u(et, "bnModPowInt"), l.prototype.copyTo = _, l.prototype.fromInt = x, l.prototype.fromString = w, l.prototype.clamp = S, l.prototype.dlShiftTo = N, l.prototype.drShiftTo = L, l.prototype.lShiftTo = R, l.prototype.rShiftTo = O, l.prototype.subTo = q, l.prototype.multiplyTo = D, l.prototype.squareTo = k, l.prototype.divRemTo = F, l.prototype.invDigit = H, l.prototype.isEven = $, l.prototype.exp = tt, l.prototype.toString = M, l.prototype.negate = T, l.prototype.abs = A, l.prototype.compareTo = P, l.prototype.bitLength = I, l.prototype.mod = U, l.prototype.modPowInt = et, l.ZERO = b(0), l.ONE = b(1), u(nt, "bnClone"), u(it, "bnIntValue"), u(rt, "bnByteValue"), u(ot, "bnShortValue"), u(st, "bnpChunkSize"), u(at, "bnSigNum"), u(lt, "bnpToRadix"), u(ut, "bnpFromRadix"), u(ht, "bnpFromNumber"), u(ct, "bnToByteArray"), u(pt, "bnEquals"), u(dt, "bnMin"), u(ft, "bnMax"), u(mt, "bnpBitwiseTo"), u(gt, "op_and"), u(vt, "bnAnd"), u(yt, "op_or"), u(_t, "bnOr"), u(xt, "op_xor"), u(Et, "bnXor"), u(bt, "op_andnot"), u(wt, "bnAndNot"), u(St, "bnNot"), u(Mt, "bnShiftLeft"), u(Tt, "bnShiftRight"), u(At, "lbit"), u(Pt, "bnGetLowestSetBit"), u(Ct, "cbit"), u(It, "bnBitCount"), u(Nt, "bnTestBit"), u(Lt, "bnpChangeBit"), u(Rt, "bnSetBit"), u(Ot, "bnClearBit"), u(qt, "bnFlipBit"), u(Dt, "bnpAddTo"), u(kt, "bnAdd"), u(Ft, "bnSubtract"), u(Ut, "bnMultiply"), u(Bt, "bnSquare"), u(zt, "bnDivide"), u(Vt, "bnRemainder"), u(jt, "bnDivideAndRemainder"), u(Gt, "bnpDMultiply"), u(Wt, "bnpDAddOffset"), u(Ht, "NullExp"), u(Xt, "nNop"), u(Yt, "nMulTo"), u(Zt, "nSqrTo"), Ht.prototype.convert = Xt, Ht.prototype.revert = Xt, Ht.prototype.mulTo = Yt, Ht.prototype.sqrTo = Zt, u(Jt, "bnPow"), u(Kt, "bnpMultiplyLowerTo"), u(Qt, "bnpMultiplyUpperTo"), u($t, "Barrett"), u(te, "barrettConvert"), u(ee, "barrettRevert"), u(ne, "barrettReduce"), u(ie, "barrettSqrTo"), u(re, "barrettMulTo"), $t.prototype.convert = te, $t.prototype.revert = ee, $t.prototype.reduce = ne, $t.prototype.mulTo = re, $t.prototype.sqrTo = ie, u(oe, "bnModPow"), u(se, "bnGCD"), u(ae, "bnpModInt"), u(le, "bnModInverse");
    var ue = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997],
      he = (1 << 26) / ue[ue.length - 1];
    function ce(t) {
      var e,
        n = this.abs();
      if (1 == n.t && n[0] <= ue[ue.length - 1]) {
        for (e = 0; e < ue.length; ++e) if (n[0] == ue[e]) return !0;
        return !1;
      }
      if (n.isEven()) return !1;
      for (e = 1; e < ue.length;) {
        for (var i = ue[e], r = e + 1; r < ue.length && i < he;) i *= ue[r++];
        for (i = n.modInt(i); e < r;) if (i % ue[e++] == 0) return !1;
      }
      return n.millerRabin(t);
    }
    function pe(t) {
      var e = this.subtract(l.ONE),
        n = e.getLowestSetBit();
      if (n <= 0) return !1;
      var i = e.shiftRight(n);
      (t = t + 1 >> 1) > ue.length && (t = ue.length);
      for (var r = h(), o = 0; o < t; ++o) {
        r.fromInt(ue[Math.floor(Math.random() * ue.length)]);
        var s = r.modPow(i, this);
        if (0 != s.compareTo(l.ONE) && 0 != s.compareTo(e)) {
          for (var a = 1; a++ < n && 0 != s.compareTo(e);) if (0 == (s = s.modPowInt(2, this)).compareTo(l.ONE)) return !1;
          if (0 != s.compareTo(e)) return !1;
        }
      }
      return !0;
    }
    u(ce, "bnIsProbablePrime"), u(pe, "bnpMillerRabin"), l.prototype.chunkSize = st, l.prototype.toRadix = lt, l.prototype.fromRadix = ut, l.prototype.fromNumber = ht, l.prototype.bitwiseTo = mt, l.prototype.changeBit = Lt, l.prototype.addTo = Dt, l.prototype.dMultiply = Gt, l.prototype.dAddOffset = Wt, l.prototype.multiplyLowerTo = Kt, l.prototype.multiplyUpperTo = Qt, l.prototype.modInt = ae, l.prototype.millerRabin = pe, l.prototype.clone = nt, l.prototype.intValue = it, l.prototype.byteValue = rt, l.prototype.shortValue = ot, l.prototype.signum = at, l.prototype.toByteArray = ct, l.prototype.equals = pt, l.prototype.min = dt, l.prototype.max = ft, l.prototype.and = vt, l.prototype.or = _t, l.prototype.xor = Et, l.prototype.andNot = wt, l.prototype.not = St, l.prototype.shiftLeft = Mt, l.prototype.shiftRight = Tt, l.prototype.getLowestSetBit = Pt, l.prototype.bitCount = It, l.prototype.testBit = Nt, l.prototype.setBit = Rt, l.prototype.clearBit = Ot, l.prototype.flipBit = qt, l.prototype.add = kt, l.prototype.subtract = Ft, l.prototype.multiply = Ut, l.prototype.divide = zt, l.prototype.remainder = Vt, l.prototype.divideAndRemainder = jt, l.prototype.modPow = oe, l.prototype.modInverse = le, l.prototype.pow = Jt, l.prototype.gcd = se, l.prototype.isProbablePrime = ce, l.prototype.square = Bt;
    var de,
      fe = l;
    fe.prototype.IsNegative = function () {
      return -1 == this.compareTo(fe.ZERO);
    }, fe.op_Equality = function (t, e) {
      return 0 == t.compareTo(e);
    }, fe.op_Inequality = function (t, e) {
      return 0 != t.compareTo(e);
    }, fe.op_GreaterThan = function (t, e) {
      return t.compareTo(e) > 0;
    }, fe.op_LessThan = function (t, e) {
      return t.compareTo(e) < 0;
    }, fe.op_Addition = function (t, e) {
      return new fe(t).add(new fe(e));
    }, fe.op_Subtraction = function (t, e) {
      return new fe(t).subtract(new fe(e));
    }, fe.Int128Mul = function (t, e) {
      return new fe(t).multiply(new fe(e));
    }, fe.op_Division = function (t, e) {
      return t.divide(e);
    }, fe.prototype.ToDouble = function () {
      return parseFloat(this.toString());
    }, void 0 === de && (de = u(function (t, e) {
      var n;
      if (void 0 === Object.getOwnPropertyNames) {
        for (n in e.prototype) (void 0 === t.prototype[n] || t.prototype[n] == Object.prototype[n]) && (t.prototype[n] = e.prototype[n]);
        for (n in e) void 0 === t[n] && (t[n] = e[n]);
        t.$baseCtor = e;
      } else {
        for (var i = Object.getOwnPropertyNames(e.prototype), r = 0; r < i.length; r++) void 0 === Object.getOwnPropertyDescriptor(t.prototype, i[r]) && Object.defineProperty(t.prototype, i[r], Object.getOwnPropertyDescriptor(e.prototype, i[r]));
        for (n in e) void 0 === t[n] && (t[n] = e[n]);
        t.$baseCtor = e;
      }
    }, "Inherit")), i.Path = function () {
      return [];
    }, i.Paths = function () {
      return [];
    }, i.DoublePoint = function () {
      var t = arguments;
      this.X = 0, this.Y = 0, 1 == t.length ? (this.X = t[0].X, this.Y = t[0].Y) : 2 == t.length && (this.X = t[0], this.Y = t[1]);
    }, i.DoublePoint0 = function () {
      this.X = 0, this.Y = 0;
    }, i.DoublePoint1 = function (t) {
      this.X = t.X, this.Y = t.Y;
    }, i.DoublePoint2 = function (t, e) {
      this.X = t, this.Y = e;
    }, i.PolyNode = function () {
      this.m_Parent = null, this.m_polygon = new i.Path(), this.m_Index = 0, this.m_jointype = 0, this.m_endtype = 0, this.m_Childs = [], this.IsOpen = !1;
    }, i.PolyNode.prototype.IsHoleNode = function () {
      for (var t = !0, e = this.m_Parent; null !== e;) t = !t, e = e.m_Parent;
      return t;
    }, i.PolyNode.prototype.ChildCount = function () {
      return this.m_Childs.length;
    }, i.PolyNode.prototype.Contour = function () {
      return this.m_polygon;
    }, i.PolyNode.prototype.AddChild = function (t) {
      var e = this.m_Childs.length;
      this.m_Childs.push(t), t.m_Parent = this, t.m_Index = e;
    }, i.PolyNode.prototype.GetNext = function () {
      return this.m_Childs.length > 0 ? this.m_Childs[0] : this.GetNextSiblingUp();
    }, i.PolyNode.prototype.GetNextSiblingUp = function () {
      return null === this.m_Parent ? null : this.m_Index == this.m_Parent.m_Childs.length - 1 ? this.m_Parent.GetNextSiblingUp() : this.m_Parent.m_Childs[this.m_Index + 1];
    }, i.PolyNode.prototype.Childs = function () {
      return this.m_Childs;
    }, i.PolyNode.prototype.Parent = function () {
      return this.m_Parent;
    }, i.PolyNode.prototype.IsHole = function () {
      return this.IsHoleNode();
    }, i.PolyTree = function () {
      this.m_AllPolys = [], i.PolyNode.call(this);
    }, i.PolyTree.prototype.Clear = function () {
      for (var t = 0, e = this.m_AllPolys.length; t < e; t++) this.m_AllPolys[t] = null;
      this.m_AllPolys.length = 0, this.m_Childs.length = 0;
    }, i.PolyTree.prototype.GetFirst = function () {
      return this.m_Childs.length > 0 ? this.m_Childs[0] : null;
    }, i.PolyTree.prototype.Total = function () {
      return this.m_AllPolys.length;
    }, de(i.PolyTree, i.PolyNode), i.Math_Abs_Int64 = i.Math_Abs_Int32 = i.Math_Abs_Double = function (t) {
      return Math.abs(t);
    }, i.Math_Max_Int32_Int32 = function (t, e) {
      return Math.max(t, e);
    }, s.msie || s.opera || s.safari ? i.Cast_Int32 = function (t) {
      return 0 | t;
    } : i.Cast_Int32 = function (t) {
      return ~~t;
    }, s.chrome ? i.Cast_Int64 = function (t) {
      return t < -2147483648 || t > 2147483647 ? t < 0 ? Math.ceil(t) : Math.floor(t) : ~~t;
    } : s.firefox && "function" == typeof Number.toInteger ? i.Cast_Int64 = function (t) {
      return Number.toInteger(t);
    } : s.msie7 || s.msie8 ? i.Cast_Int64 = function (t) {
      return parseInt(t, 10);
    } : s.msie ? i.Cast_Int64 = function (t) {
      return t < -2147483648 || t > 2147483647 ? t < 0 ? Math.ceil(t) : Math.floor(t) : 0 | t;
    } : i.Cast_Int64 = function (t) {
      return t < 0 ? Math.ceil(t) : Math.floor(t);
    }, i.Clear = function (t) {
      t.length = 0;
    }, i.PI = 3.141592653589793, i.PI2 = 6.283185307179586, i.IntPoint = function () {
      var t = arguments,
        e = t.length;
      if (this.X = 0, this.Y = 0, 2 == e) this.X = t[0], this.Y = t[1];else if (1 == e) {
        if (t[0] instanceof i.DoublePoint) {
          var n = t[0];
          this.X = i.Clipper.Round(n.X), this.Y = i.Clipper.Round(n.Y);
        } else {
          var r = t[0];
          this.X = r.X, this.Y = r.Y;
        }
      } else this.X = 0, this.Y = 0;
    }, i.IntPoint.op_Equality = function (t, e) {
      return t.X == e.X && t.Y == e.Y;
    }, i.IntPoint.op_Inequality = function (t, e) {
      return t.X != e.X || t.Y != e.Y;
    }, i.IntPoint0 = function () {
      this.X = 0, this.Y = 0;
    }, i.IntPoint1 = function (t) {
      this.X = t.X, this.Y = t.Y;
    }, i.IntPoint1dp = function (t) {
      this.X = i.Clipper.Round(t.X), this.Y = i.Clipper.Round(t.Y);
    }, i.IntPoint2 = function (t, e) {
      this.X = t, this.Y = e;
    }, i.IntRect = function () {
      var t = arguments,
        e = t.length;
      4 == e ? (this.left = t[0], this.top = t[1], this.right = t[2], this.bottom = t[3]) : 1 == e ? (this.left = ir.left, this.top = ir.top, this.right = ir.right, this.bottom = ir.bottom) : (this.left = 0, this.top = 0, this.right = 0, this.bottom = 0);
    }, i.IntRect0 = function () {
      this.left = 0, this.top = 0, this.right = 0, this.bottom = 0;
    }, i.IntRect1 = function (t) {
      this.left = t.left, this.top = t.top, this.right = t.right, this.bottom = t.bottom;
    }, i.IntRect4 = function (t, e, n, i) {
      this.left = t, this.top = e, this.right = n, this.bottom = i;
    }, i.ClipType = {
      ctIntersection: 0,
      ctUnion: 1,
      ctDifference: 2,
      ctXor: 3
    }, i.PolyType = {
      ptSubject: 0,
      ptClip: 1
    }, i.PolyFillType = {
      pftEvenOdd: 0,
      pftNonZero: 1,
      pftPositive: 2,
      pftNegative: 3
    }, i.JoinType = {
      jtSquare: 0,
      jtRound: 1,
      jtMiter: 2
    }, i.EndType = {
      etOpenSquare: 0,
      etOpenRound: 1,
      etOpenButt: 2,
      etClosedLine: 3,
      etClosedPolygon: 4
    }, i.EdgeSide = {
      esLeft: 0,
      esRight: 1
    }, i.Direction = {
      dRightToLeft: 0,
      dLeftToRight: 1
    }, i.TEdge = function () {
      this.Bot = new i.IntPoint(), this.Curr = new i.IntPoint(), this.Top = new i.IntPoint(), this.Delta = new i.IntPoint(), this.Dx = 0, this.PolyTyp = i.PolyType.ptSubject, this.Side = i.EdgeSide.esLeft, this.WindDelta = 0, this.WindCnt = 0, this.WindCnt2 = 0, this.OutIdx = 0, this.Next = null, this.Prev = null, this.NextInLML = null, this.NextInAEL = null, this.PrevInAEL = null, this.NextInSEL = null, this.PrevInSEL = null;
    }, i.IntersectNode = function () {
      this.Edge1 = null, this.Edge2 = null, this.Pt = new i.IntPoint();
    }, i.MyIntersectNodeSort = function () {}, i.MyIntersectNodeSort.Compare = function (t, e) {
      return e.Pt.Y - t.Pt.Y;
    }, i.LocalMinima = function () {
      this.Y = 0, this.LeftBound = null, this.RightBound = null, this.Next = null;
    }, i.Scanbeam = function () {
      this.Y = 0, this.Next = null;
    }, i.OutRec = function () {
      this.Idx = 0, this.IsHole = !1, this.IsOpen = !1, this.FirstLeft = null, this.Pts = null, this.BottomPt = null, this.PolyNode = null;
    }, i.OutPt = function () {
      this.Idx = 0, this.Pt = new i.IntPoint(), this.Next = null, this.Prev = null;
    }, i.Join = function () {
      this.OutPt1 = null, this.OutPt2 = null, this.OffPt = new i.IntPoint();
    }, i.ClipperBase = function () {
      this.m_MinimaList = null, this.m_CurrentLM = null, this.m_edges = new Array(), this.m_UseFullRange = !1, this.m_HasOpenPaths = !1, this.PreserveCollinear = !1, this.m_MinimaList = null, this.m_CurrentLM = null, this.m_UseFullRange = !1, this.m_HasOpenPaths = !1;
    }, i.ClipperBase.horizontal = -9007199254740992, i.ClipperBase.Skip = -2, i.ClipperBase.Unassigned = -1, i.ClipperBase.tolerance = 1e-20, i.ClipperBase.loRange = 47453132, i.ClipperBase.hiRange = 0xfffffffffffff, i.ClipperBase.near_zero = function (t) {
      return t > -i.ClipperBase.tolerance && t < i.ClipperBase.tolerance;
    }, i.ClipperBase.IsHorizontal = function (t) {
      return 0 === t.Delta.Y;
    }, i.ClipperBase.prototype.PointIsVertex = function (t, e) {
      var n = e;
      do {
        if (i.IntPoint.op_Equality(n.Pt, t)) return !0;
        n = n.Next;
      } while (n != e);
      return !1;
    }, i.ClipperBase.prototype.PointOnLineSegment = function (t, e, n, i) {
      return i ? t.X == e.X && t.Y == e.Y || t.X == n.X && t.Y == n.Y || t.X > e.X == t.X < n.X && t.Y > e.Y == t.Y < n.Y && fe.op_Equality(fe.Int128Mul(t.X - e.X, n.Y - e.Y), fe.Int128Mul(n.X - e.X, t.Y - e.Y)) : t.X == e.X && t.Y == e.Y || t.X == n.X && t.Y == n.Y || t.X > e.X == t.X < n.X && t.Y > e.Y == t.Y < n.Y && (t.X - e.X) * (n.Y - e.Y) == (n.X - e.X) * (t.Y - e.Y);
    }, i.ClipperBase.prototype.PointOnPolygon = function (t, e, n) {
      for (var i = e;;) {
        if (this.PointOnLineSegment(t, i.Pt, i.Next.Pt, n)) return !0;
        if ((i = i.Next) == e) break;
      }
      return !1;
    }, i.ClipperBase.prototype.SlopesEqual = i.ClipperBase.SlopesEqual = function () {
      var t,
        e,
        n,
        r,
        o,
        s,
        a = arguments,
        l = a.length;
      return 3 == l ? (t = a[0], e = a[1], a[2] ? fe.op_Equality(fe.Int128Mul(t.Delta.Y, e.Delta.X), fe.Int128Mul(t.Delta.X, e.Delta.Y)) : i.Cast_Int64(t.Delta.Y * e.Delta.X) == i.Cast_Int64(t.Delta.X * e.Delta.Y)) : 4 == l ? (n = a[0], r = a[1], o = a[2], a[3] ? fe.op_Equality(fe.Int128Mul(n.Y - r.Y, r.X - o.X), fe.Int128Mul(n.X - r.X, r.Y - o.Y)) : i.Cast_Int64((n.Y - r.Y) * (r.X - o.X)) - i.Cast_Int64((n.X - r.X) * (r.Y - o.Y)) == 0) : (n = a[0], r = a[1], o = a[2], s = a[3], a[4] ? fe.op_Equality(fe.Int128Mul(n.Y - r.Y, o.X - s.X), fe.Int128Mul(n.X - r.X, o.Y - s.Y)) : i.Cast_Int64((n.Y - r.Y) * (o.X - s.X)) - i.Cast_Int64((n.X - r.X) * (o.Y - s.Y)) == 0);
    }, i.ClipperBase.SlopesEqual3 = function (t, e, n) {
      return n ? fe.op_Equality(fe.Int128Mul(t.Delta.Y, e.Delta.X), fe.Int128Mul(t.Delta.X, e.Delta.Y)) : i.Cast_Int64(t.Delta.Y * e.Delta.X) == i.Cast_Int64(t.Delta.X * e.Delta.Y);
    }, i.ClipperBase.SlopesEqual4 = function (t, e, n, r) {
      return r ? fe.op_Equality(fe.Int128Mul(t.Y - e.Y, e.X - n.X), fe.Int128Mul(t.X - e.X, e.Y - n.Y)) : i.Cast_Int64((t.Y - e.Y) * (e.X - n.X)) - i.Cast_Int64((t.X - e.X) * (e.Y - n.Y)) == 0;
    }, i.ClipperBase.SlopesEqual5 = function (t, e, n, r, o) {
      return o ? fe.op_Equality(fe.Int128Mul(t.Y - e.Y, n.X - r.X), fe.Int128Mul(t.X - e.X, n.Y - r.Y)) : i.Cast_Int64((t.Y - e.Y) * (n.X - r.X)) - i.Cast_Int64((t.X - e.X) * (n.Y - r.Y)) == 0;
    }, i.ClipperBase.prototype.Clear = function () {
      this.DisposeLocalMinimaList();
      for (var t = 0, e = this.m_edges.length; t < e; ++t) {
        for (var n = 0, r = this.m_edges[t].length; n < r; ++n) this.m_edges[t][n] = null;
        i.Clear(this.m_edges[t]);
      }
      i.Clear(this.m_edges), this.m_UseFullRange = !1, this.m_HasOpenPaths = !1;
    }, i.ClipperBase.prototype.DisposeLocalMinimaList = function () {
      for (; null !== this.m_MinimaList;) {
        var t = this.m_MinimaList.Next;
        this.m_MinimaList = null, this.m_MinimaList = t;
      }
      this.m_CurrentLM = null;
    }, i.ClipperBase.prototype.RangeTest = function (t, e) {
      e.Value ? (t.X > i.ClipperBase.hiRange || t.Y > i.ClipperBase.hiRange || -t.X > i.ClipperBase.hiRange || -t.Y > i.ClipperBase.hiRange) && i.Error("Coordinate outside allowed range in RangeTest().") : (t.X > i.ClipperBase.loRange || t.Y > i.ClipperBase.loRange || -t.X > i.ClipperBase.loRange || -t.Y > i.ClipperBase.loRange) && (e.Value = !0, this.RangeTest(t, e));
    }, i.ClipperBase.prototype.InitEdge = function (t, e, n, i) {
      t.Next = e, t.Prev = n, t.Curr.X = i.X, t.Curr.Y = i.Y, t.OutIdx = -1;
    }, i.ClipperBase.prototype.InitEdge2 = function (t, e) {
      t.Curr.Y >= t.Next.Curr.Y ? (t.Bot.X = t.Curr.X, t.Bot.Y = t.Curr.Y, t.Top.X = t.Next.Curr.X, t.Top.Y = t.Next.Curr.Y) : (t.Top.X = t.Curr.X, t.Top.Y = t.Curr.Y, t.Bot.X = t.Next.Curr.X, t.Bot.Y = t.Next.Curr.Y), this.SetDx(t), t.PolyTyp = e;
    }, i.ClipperBase.prototype.FindNextLocMin = function (t) {
      for (var e;;) {
        for (; i.IntPoint.op_Inequality(t.Bot, t.Prev.Bot) || i.IntPoint.op_Equality(t.Curr, t.Top);) t = t.Next;
        if (t.Dx != i.ClipperBase.horizontal && t.Prev.Dx != i.ClipperBase.horizontal) break;
        for (; t.Prev.Dx == i.ClipperBase.horizontal;) t = t.Prev;
        for (e = t; t.Dx == i.ClipperBase.horizontal;) t = t.Next;
        if (t.Top.Y != t.Prev.Bot.Y) {
          e.Prev.Bot.X < t.Bot.X && (t = e);
          break;
        }
      }
      return t;
    }, i.ClipperBase.prototype.ProcessBound = function (t, e) {
      var n,
        r,
        o = t,
        s = t;
      if (t.Dx == i.ClipperBase.horizontal && (r = e ? t.Prev.Bot.X : t.Next.Bot.X, t.Bot.X != r && this.ReverseHorizontal(t)), s.OutIdx != i.ClipperBase.Skip) if (e) {
        for (; s.Top.Y == s.Next.Bot.Y && s.Next.OutIdx != i.ClipperBase.Skip;) s = s.Next;
        if (s.Dx == i.ClipperBase.horizontal && s.Next.OutIdx != i.ClipperBase.Skip) {
          for (n = s; n.Prev.Dx == i.ClipperBase.horizontal;) n = n.Prev;
          n.Prev.Top.X == s.Next.Top.X ? e || (s = n.Prev) : n.Prev.Top.X > s.Next.Top.X && (s = n.Prev);
        }
        for (; t != s;) t.NextInLML = t.Next, t.Dx == i.ClipperBase.horizontal && t != o && t.Bot.X != t.Prev.Top.X && this.ReverseHorizontal(t), t = t.Next;
        t.Dx == i.ClipperBase.horizontal && t != o && t.Bot.X != t.Prev.Top.X && this.ReverseHorizontal(t), s = s.Next;
      } else {
        for (; s.Top.Y == s.Prev.Bot.Y && s.Prev.OutIdx != i.ClipperBase.Skip;) s = s.Prev;
        if (s.Dx == i.ClipperBase.horizontal && s.Prev.OutIdx != i.ClipperBase.Skip) {
          for (n = s; n.Next.Dx == i.ClipperBase.horizontal;) n = n.Next;
          n.Next.Top.X == s.Prev.Top.X ? e || (s = n.Next) : n.Next.Top.X > s.Prev.Top.X && (s = n.Next);
        }
        for (; t != s;) t.NextInLML = t.Prev, t.Dx == i.ClipperBase.horizontal && t != o && t.Bot.X != t.Next.Top.X && this.ReverseHorizontal(t), t = t.Prev;
        t.Dx == i.ClipperBase.horizontal && t != o && t.Bot.X != t.Next.Top.X && this.ReverseHorizontal(t), s = s.Prev;
      }
      if (s.OutIdx == i.ClipperBase.Skip) {
        if (t = s, e) {
          for (; t.Top.Y == t.Next.Bot.Y;) t = t.Next;
          for (; t != s && t.Dx == i.ClipperBase.horizontal;) t = t.Prev;
        } else {
          for (; t.Top.Y == t.Prev.Bot.Y;) t = t.Prev;
          for (; t != s && t.Dx == i.ClipperBase.horizontal;) t = t.Next;
        }
        if (t == s) s = e ? t.Next : t.Prev;else {
          t = e ? s.Next : s.Prev;
          var a = new i.LocalMinima();
          a.Next = null, a.Y = t.Bot.Y, a.LeftBound = null, a.RightBound = t, a.RightBound.WindDelta = 0, s = this.ProcessBound(a.RightBound, e), this.InsertLocalMinima(a);
        }
      }
      return s;
    }, i.ClipperBase.prototype.AddPath = function (t, e, n) {
      !n && e == i.PolyType.ptClip && i.Error("AddPath: Open paths must be subject.");
      var r = t.length - 1;
      if (n) for (; r > 0 && i.IntPoint.op_Equality(t[r], t[0]);) --r;
      for (; r > 0 && i.IntPoint.op_Equality(t[r], t[r - 1]);) --r;
      if (n && r < 2 || !n && r < 1) return !1;
      for (var o = new Array(), s = 0; s <= r; s++) o.push(new i.TEdge());
      var a = !0;
      o[1].Curr.X = t[1].X, o[1].Curr.Y = t[1].Y;
      var l = {
        Value: this.m_UseFullRange
      };
      this.RangeTest(t[0], l), this.m_UseFullRange = l.Value, l.Value = this.m_UseFullRange, this.RangeTest(t[r], l), this.m_UseFullRange = l.Value, this.InitEdge(o[0], o[1], o[r], t[0]), this.InitEdge(o[r], o[0], o[r - 1], t[r]);
      for (s = r - 1; s >= 1; --s) l.Value = this.m_UseFullRange, this.RangeTest(t[s], l), this.m_UseFullRange = l.Value, this.InitEdge(o[s], o[s + 1], o[s - 1], t[s]);
      for (var u = o[0], h = u, c = u;;) if (i.IntPoint.op_Equality(h.Curr, h.Next.Curr)) {
        if (h == h.Next) break;
        h == u && (u = h.Next), c = h = this.RemoveEdge(h);
      } else {
        if (h.Prev == h.Next) break;
        if (!n || !i.ClipperBase.SlopesEqual(h.Prev.Curr, h.Curr, h.Next.Curr, this.m_UseFullRange) || this.PreserveCollinear && this.Pt2IsBetweenPt1AndPt3(h.Prev.Curr, h.Curr, h.Next.Curr)) {
          if ((h = h.Next) == c) break;
        } else h == u && (u = h.Next), c = h = (h = this.RemoveEdge(h)).Prev;
      }
      if (!n && h == h.Next || n && h.Prev == h.Next) return !1;
      n || (this.m_HasOpenPaths = !0, u.Prev.OutIdx = i.ClipperBase.Skip);
      h = u;
      do {
        this.InitEdge2(h, e), h = h.Next, a && h.Curr.Y != u.Curr.Y && (a = !1);
      } while (h != u);
      if (a) {
        if (n) return !1;
        for (h.Prev.OutIdx = i.ClipperBase.Skip, h.Prev.Bot.X < h.Prev.Top.X && this.ReverseHorizontal(h.Prev), (f = new i.LocalMinima()).Next = null, f.Y = h.Bot.Y, f.LeftBound = null, f.RightBound = h, f.RightBound.Side = i.EdgeSide.esRight, f.RightBound.WindDelta = 0; h.Next.OutIdx != i.ClipperBase.Skip;) h.NextInLML = h.Next, h.Bot.X != h.Prev.Top.X && this.ReverseHorizontal(h), h = h.Next;
        return this.InsertLocalMinima(f), this.m_edges.push(o), !0;
      }
      this.m_edges.push(o);
      for (var p, d = null; (h = this.FindNextLocMin(h)) != d;) {
        var f;
        null == d && (d = h), (f = new i.LocalMinima()).Next = null, f.Y = h.Bot.Y, h.Dx < h.Prev.Dx ? (f.LeftBound = h.Prev, f.RightBound = h, p = !1) : (f.LeftBound = h, f.RightBound = h.Prev, p = !0), f.LeftBound.Side = i.EdgeSide.esLeft, f.RightBound.Side = i.EdgeSide.esRight, n ? f.LeftBound.Next == f.RightBound ? f.LeftBound.WindDelta = -1 : f.LeftBound.WindDelta = 1 : f.LeftBound.WindDelta = 0, f.RightBound.WindDelta = -f.LeftBound.WindDelta, h = this.ProcessBound(f.LeftBound, p);
        var m = this.ProcessBound(f.RightBound, !p);
        f.LeftBound.OutIdx == i.ClipperBase.Skip ? f.LeftBound = null : f.RightBound.OutIdx == i.ClipperBase.Skip && (f.RightBound = null), this.InsertLocalMinima(f), p || (h = m);
      }
      return !0;
    }, i.ClipperBase.prototype.AddPaths = function (t, e, n) {
      for (var i = !1, r = 0, o = t.length; r < o; ++r) this.AddPath(t[r], e, n) && (i = !0);
      return i;
    }, i.ClipperBase.prototype.Pt2IsBetweenPt1AndPt3 = function (t, e, n) {
      return !(i.IntPoint.op_Equality(t, n) || i.IntPoint.op_Equality(t, e) || i.IntPoint.op_Equality(n, e)) && (t.X != n.X ? e.X > t.X == e.X < n.X : e.Y > t.Y == e.Y < n.Y);
    }, i.ClipperBase.prototype.RemoveEdge = function (t) {
      t.Prev.Next = t.Next, t.Next.Prev = t.Prev;
      var e = t.Next;
      return t.Prev = null, e;
    }, i.ClipperBase.prototype.SetDx = function (t) {
      t.Delta.X = t.Top.X - t.Bot.X, t.Delta.Y = t.Top.Y - t.Bot.Y, 0 === t.Delta.Y ? t.Dx = i.ClipperBase.horizontal : t.Dx = t.Delta.X / t.Delta.Y;
    }, i.ClipperBase.prototype.InsertLocalMinima = function (t) {
      if (null === this.m_MinimaList) this.m_MinimaList = t;else if (t.Y >= this.m_MinimaList.Y) t.Next = this.m_MinimaList, this.m_MinimaList = t;else {
        for (var e = this.m_MinimaList; null !== e.Next && t.Y < e.Next.Y;) e = e.Next;
        t.Next = e.Next, e.Next = t;
      }
    }, i.ClipperBase.prototype.PopLocalMinima = function () {
      null !== this.m_CurrentLM && (this.m_CurrentLM = this.m_CurrentLM.Next);
    }, i.ClipperBase.prototype.ReverseHorizontal = function (t) {
      var e = t.Top.X;
      t.Top.X = t.Bot.X, t.Bot.X = e;
    }, i.ClipperBase.prototype.Reset = function () {
      if (this.m_CurrentLM = this.m_MinimaList, null != this.m_CurrentLM) for (var t = this.m_MinimaList; null != t;) {
        var e = t.LeftBound;
        null != e && (e.Curr.X = e.Bot.X, e.Curr.Y = e.Bot.Y, e.Side = i.EdgeSide.esLeft, e.OutIdx = i.ClipperBase.Unassigned), null != (e = t.RightBound) && (e.Curr.X = e.Bot.X, e.Curr.Y = e.Bot.Y, e.Side = i.EdgeSide.esRight, e.OutIdx = i.ClipperBase.Unassigned), t = t.Next;
      }
    }, i.Clipper = function (t) {
      void 0 === t && (t = 0), this.m_PolyOuts = null, this.m_ClipType = i.ClipType.ctIntersection, this.m_Scanbeam = null, this.m_ActiveEdges = null, this.m_SortedEdges = null, this.m_IntersectList = null, this.m_IntersectNodeComparer = null, this.m_ExecuteLocked = !1, this.m_ClipFillType = i.PolyFillType.pftEvenOdd, this.m_SubjFillType = i.PolyFillType.pftEvenOdd, this.m_Joins = null, this.m_GhostJoins = null, this.m_UsingPolyTree = !1, this.ReverseSolution = !1, this.StrictlySimple = !1, i.ClipperBase.call(this), this.m_Scanbeam = null, this.m_ActiveEdges = null, this.m_SortedEdges = null, this.m_IntersectList = new Array(), this.m_IntersectNodeComparer = i.MyIntersectNodeSort.Compare, this.m_ExecuteLocked = !1, this.m_UsingPolyTree = !1, this.m_PolyOuts = new Array(), this.m_Joins = new Array(), this.m_GhostJoins = new Array(), this.ReverseSolution = 0 != (1 & t), this.StrictlySimple = 0 != (2 & t), this.PreserveCollinear = 0 != (4 & t);
    }, i.Clipper.ioReverseSolution = 1, i.Clipper.ioStrictlySimple = 2, i.Clipper.ioPreserveCollinear = 4, i.Clipper.prototype.Clear = function () {
      0 !== this.m_edges.length && (this.DisposeAllPolyPts(), i.ClipperBase.prototype.Clear.call(this));
    }, i.Clipper.prototype.DisposeScanbeamList = function () {
      for (; null !== this.m_Scanbeam;) {
        var t = this.m_Scanbeam.Next;
        this.m_Scanbeam = null, this.m_Scanbeam = t;
      }
    }, i.Clipper.prototype.Reset = function () {
      i.ClipperBase.prototype.Reset.call(this), this.m_Scanbeam = null, this.m_ActiveEdges = null, this.m_SortedEdges = null;
      for (var t = this.m_MinimaList; null !== t;) this.InsertScanbeam(t.Y), t = t.Next;
    }, i.Clipper.prototype.InsertScanbeam = function (t) {
      if (null === this.m_Scanbeam) this.m_Scanbeam = new i.Scanbeam(), this.m_Scanbeam.Next = null, this.m_Scanbeam.Y = t;else if (t > this.m_Scanbeam.Y) {
        (n = new i.Scanbeam()).Y = t, n.Next = this.m_Scanbeam, this.m_Scanbeam = n;
      } else {
        for (var e = this.m_Scanbeam; null !== e.Next && t <= e.Next.Y;) e = e.Next;
        if (t == e.Y) return;
        var n;
        (n = new i.Scanbeam()).Y = t, n.Next = e.Next, e.Next = n;
      }
    }, i.Clipper.prototype.Execute = function () {
      var t = arguments,
        e = t.length,
        n = t[1] instanceof i.PolyTree;
      if (4 == e && !n) {
        var r = t[0],
          o = t[1],
          s = t[2],
          a = t[3];
        if (this.m_ExecuteLocked) return !1;
        this.m_HasOpenPaths && i.Error("Error: PolyTree struct is need for open path clipping."), this.m_ExecuteLocked = !0, i.Clear(o), this.m_SubjFillType = s, this.m_ClipFillType = a, this.m_ClipType = r, this.m_UsingPolyTree = !1;
        try {
          (u = this.ExecuteInternal()) && this.BuildResult(o);
        } finally {
          this.DisposeAllPolyPts(), this.m_ExecuteLocked = !1;
        }
        return u;
      }
      if (4 == e && n) {
        r = t[0];
        var l = t[1];
        s = t[2], a = t[3];
        if (this.m_ExecuteLocked) return !1;
        this.m_ExecuteLocked = !0, this.m_SubjFillType = s, this.m_ClipFillType = a, this.m_ClipType = r, this.m_UsingPolyTree = !0;
        try {
          var u;
          (u = this.ExecuteInternal()) && this.BuildResult2(l);
        } finally {
          this.DisposeAllPolyPts(), this.m_ExecuteLocked = !1;
        }
        return u;
      }
      if (2 == e && !n) {
        r = t[0], o = t[1];
        return this.Execute(r, o, i.PolyFillType.pftEvenOdd, i.PolyFillType.pftEvenOdd);
      }
      if (2 == e && n) {
        r = t[0], l = t[1];
        return this.Execute(r, l, i.PolyFillType.pftEvenOdd, i.PolyFillType.pftEvenOdd);
      }
    }, i.Clipper.prototype.FixHoleLinkage = function (t) {
      if (null !== t.FirstLeft && (t.IsHole == t.FirstLeft.IsHole || null === t.FirstLeft.Pts)) {
        for (var e = t.FirstLeft; null !== e && (e.IsHole == t.IsHole || null === e.Pts);) e = e.FirstLeft;
        t.FirstLeft = e;
      }
    }, i.Clipper.prototype.ExecuteInternal = function () {
      try {
        if (this.Reset(), null === this.m_CurrentLM) return !1;
        var t = this.PopScanbeam();
        do {
          if (this.InsertLocalMinimaIntoAEL(t), i.Clear(this.m_GhostJoins), this.ProcessHorizontals(!1), null === this.m_Scanbeam) break;
          var e = this.PopScanbeam();
          if (!this.ProcessIntersections(t, e)) return !1;
          this.ProcessEdgesAtTopOfScanbeam(e), t = e;
        } while (null !== this.m_Scanbeam || null !== this.m_CurrentLM);
        for (var n = 0, r = this.m_PolyOuts.length; n < r; n++) {
          null === (o = this.m_PolyOuts[n]).Pts || o.IsOpen || (o.IsHole ^ this.ReverseSolution) == this.Area(o) > 0 && this.ReversePolyPtLinks(o.Pts);
        }
        this.JoinCommonEdges();
        for (n = 0, r = this.m_PolyOuts.length; n < r; n++) {
          var o;
          null !== (o = this.m_PolyOuts[n]).Pts && !o.IsOpen && this.FixupOutPolygon(o);
        }
        return this.StrictlySimple && this.DoSimplePolygons(), !0;
      } finally {
        i.Clear(this.m_Joins), i.Clear(this.m_GhostJoins);
      }
    }, i.Clipper.prototype.PopScanbeam = function () {
      var t = this.m_Scanbeam.Y;
      this.m_Scanbeam;
      return this.m_Scanbeam = this.m_Scanbeam.Next, null, t;
    }, i.Clipper.prototype.DisposeAllPolyPts = function () {
      for (var t = 0, e = this.m_PolyOuts.length; t < e; ++t) this.DisposeOutRec(t);
      i.Clear(this.m_PolyOuts);
    }, i.Clipper.prototype.DisposeOutRec = function (t) {
      var e = this.m_PolyOuts[t];
      null !== e.Pts && this.DisposeOutPts(e.Pts), e = null, this.m_PolyOuts[t] = null;
    }, i.Clipper.prototype.DisposeOutPts = function (t) {
      if (null !== t) {
        for (t.Prev.Next = null; null !== t;) t, t = t.Next, null;
      }
    }, i.Clipper.prototype.AddJoin = function (t, e, n) {
      var r = new i.Join();
      r.OutPt1 = t, r.OutPt2 = e, r.OffPt.X = n.X, r.OffPt.Y = n.Y, this.m_Joins.push(r);
    }, i.Clipper.prototype.AddGhostJoin = function (t, e) {
      var n = new i.Join();
      n.OutPt1 = t, n.OffPt.X = e.X, n.OffPt.Y = e.Y, this.m_GhostJoins.push(n);
    }, i.Clipper.prototype.InsertLocalMinimaIntoAEL = function (t) {
      for (; null !== this.m_CurrentLM && this.m_CurrentLM.Y == t;) {
        var e = this.m_CurrentLM.LeftBound,
          n = this.m_CurrentLM.RightBound;
        this.PopLocalMinima();
        var r = null;
        if (null === e ? (this.InsertEdgeIntoAEL(n, null), this.SetWindingCount(n), this.IsContributing(n) && (r = this.AddOutPt(n, n.Bot))) : null == n ? (this.InsertEdgeIntoAEL(e, null), this.SetWindingCount(e), this.IsContributing(e) && (r = this.AddOutPt(e, e.Bot)), this.InsertScanbeam(e.Top.Y)) : (this.InsertEdgeIntoAEL(e, null), this.InsertEdgeIntoAEL(n, e), this.SetWindingCount(e), n.WindCnt = e.WindCnt, n.WindCnt2 = e.WindCnt2, this.IsContributing(e) && (r = this.AddLocalMinPoly(e, n, e.Bot)), this.InsertScanbeam(e.Top.Y)), null != n && (i.ClipperBase.IsHorizontal(n) ? this.AddEdgeToSEL(n) : this.InsertScanbeam(n.Top.Y)), null != e && null != n) {
          if (null !== r && i.ClipperBase.IsHorizontal(n) && this.m_GhostJoins.length > 0 && 0 !== n.WindDelta) for (var o = 0, s = this.m_GhostJoins.length; o < s; o++) {
            var a = this.m_GhostJoins[o];
            this.HorzSegmentsOverlap(a.OutPt1.Pt, a.OffPt, n.Bot, n.Top) && this.AddJoin(a.OutPt1, r, a.OffPt);
          }
          if (e.OutIdx >= 0 && null !== e.PrevInAEL && e.PrevInAEL.Curr.X == e.Bot.X && e.PrevInAEL.OutIdx >= 0 && i.ClipperBase.SlopesEqual(e.PrevInAEL, e, this.m_UseFullRange) && 0 !== e.WindDelta && 0 !== e.PrevInAEL.WindDelta) {
            var l = this.AddOutPt(e.PrevInAEL, e.Bot);
            this.AddJoin(r, l, e.Top);
          }
          if (e.NextInAEL != n) {
            if (n.OutIdx >= 0 && n.PrevInAEL.OutIdx >= 0 && i.ClipperBase.SlopesEqual(n.PrevInAEL, n, this.m_UseFullRange) && 0 !== n.WindDelta && 0 !== n.PrevInAEL.WindDelta) {
              l = this.AddOutPt(n.PrevInAEL, n.Bot);
              this.AddJoin(r, l, n.Top);
            }
            var u = e.NextInAEL;
            if (null !== u) for (; u != n;) this.IntersectEdges(n, u, e.Curr, !1), u = u.NextInAEL;
          }
        }
      }
    }, i.Clipper.prototype.InsertEdgeIntoAEL = function (t, e) {
      if (null === this.m_ActiveEdges) t.PrevInAEL = null, t.NextInAEL = null, this.m_ActiveEdges = t;else if (null === e && this.E2InsertsBeforeE1(this.m_ActiveEdges, t)) t.PrevInAEL = null, t.NextInAEL = this.m_ActiveEdges, this.m_ActiveEdges.PrevInAEL = t, this.m_ActiveEdges = t;else {
        for (null === e && (e = this.m_ActiveEdges); null !== e.NextInAEL && !this.E2InsertsBeforeE1(e.NextInAEL, t);) e = e.NextInAEL;
        t.NextInAEL = e.NextInAEL, null !== e.NextInAEL && (e.NextInAEL.PrevInAEL = t), t.PrevInAEL = e, e.NextInAEL = t;
      }
    }, i.Clipper.prototype.E2InsertsBeforeE1 = function (t, e) {
      return e.Curr.X == t.Curr.X ? e.Top.Y > t.Top.Y ? e.Top.X < i.Clipper.TopX(t, e.Top.Y) : t.Top.X > i.Clipper.TopX(e, t.Top.Y) : e.Curr.X < t.Curr.X;
    }, i.Clipper.prototype.IsEvenOddFillType = function (t) {
      return t.PolyTyp == i.PolyType.ptSubject ? this.m_SubjFillType == i.PolyFillType.pftEvenOdd : this.m_ClipFillType == i.PolyFillType.pftEvenOdd;
    }, i.Clipper.prototype.IsEvenOddAltFillType = function (t) {
      return t.PolyTyp == i.PolyType.ptSubject ? this.m_ClipFillType == i.PolyFillType.pftEvenOdd : this.m_SubjFillType == i.PolyFillType.pftEvenOdd;
    }, i.Clipper.prototype.IsContributing = function (t) {
      var e, n;
      switch (t.PolyTyp == i.PolyType.ptSubject ? (e = this.m_SubjFillType, n = this.m_ClipFillType) : (e = this.m_ClipFillType, n = this.m_SubjFillType), e) {
        case i.PolyFillType.pftEvenOdd:
          if (0 === t.WindDelta && 1 != t.WindCnt) return !1;
          break;
        case i.PolyFillType.pftNonZero:
          if (1 != Math.abs(t.WindCnt)) return !1;
          break;
        case i.PolyFillType.pftPositive:
          if (1 != t.WindCnt) return !1;
          break;
        default:
          if (-1 != t.WindCnt) return !1;
      }
      switch (this.m_ClipType) {
        case i.ClipType.ctIntersection:
          switch (n) {
            case i.PolyFillType.pftEvenOdd:
            case i.PolyFillType.pftNonZero:
              return 0 !== t.WindCnt2;
            case i.PolyFillType.pftPositive:
              return t.WindCnt2 > 0;
            default:
              return t.WindCnt2 < 0;
          }
        case i.ClipType.ctUnion:
          switch (n) {
            case i.PolyFillType.pftEvenOdd:
            case i.PolyFillType.pftNonZero:
              return 0 === t.WindCnt2;
            case i.PolyFillType.pftPositive:
              return t.WindCnt2 <= 0;
            default:
              return t.WindCnt2 >= 0;
          }
        case i.ClipType.ctDifference:
          if (t.PolyTyp == i.PolyType.ptSubject) switch (n) {
            case i.PolyFillType.pftEvenOdd:
            case i.PolyFillType.pftNonZero:
              return 0 === t.WindCnt2;
            case i.PolyFillType.pftPositive:
              return t.WindCnt2 <= 0;
            default:
              return t.WindCnt2 >= 0;
          } else switch (n) {
            case i.PolyFillType.pftEvenOdd:
            case i.PolyFillType.pftNonZero:
              return 0 !== t.WindCnt2;
            case i.PolyFillType.pftPositive:
              return t.WindCnt2 > 0;
            default:
              return t.WindCnt2 < 0;
          }
        case i.ClipType.ctXor:
          if (0 !== t.WindDelta) return !0;
          switch (n) {
            case i.PolyFillType.pftEvenOdd:
            case i.PolyFillType.pftNonZero:
              return 0 === t.WindCnt2;
            case i.PolyFillType.pftPositive:
              return t.WindCnt2 <= 0;
            default:
              return t.WindCnt2 >= 0;
          }
      }
      return !0;
    }, i.Clipper.prototype.SetWindingCount = function (t) {
      for (var e = t.PrevInAEL; null !== e && (e.PolyTyp != t.PolyTyp || 0 === e.WindDelta);) e = e.PrevInAEL;
      if (null === e) t.WindCnt = 0 === t.WindDelta ? 1 : t.WindDelta, t.WindCnt2 = 0, e = this.m_ActiveEdges;else if (0 === t.WindDelta && this.m_ClipType != i.ClipType.ctUnion) t.WindCnt = 1, t.WindCnt2 = e.WindCnt2, e = e.NextInAEL;else if (this.IsEvenOddFillType(t)) {
        if (0 === t.WindDelta) {
          for (var n = !0, r = e.PrevInAEL; null !== r;) r.PolyTyp == e.PolyTyp && 0 !== r.WindDelta && (n = !n), r = r.PrevInAEL;
          t.WindCnt = n ? 0 : 1;
        } else t.WindCnt = t.WindDelta;
        t.WindCnt2 = e.WindCnt2, e = e.NextInAEL;
      } else e.WindCnt * e.WindDelta < 0 ? Math.abs(e.WindCnt) > 1 ? e.WindDelta * t.WindDelta < 0 ? t.WindCnt = e.WindCnt : t.WindCnt = e.WindCnt + t.WindDelta : t.WindCnt = 0 === t.WindDelta ? 1 : t.WindDelta : 0 === t.WindDelta ? t.WindCnt = e.WindCnt < 0 ? e.WindCnt - 1 : e.WindCnt + 1 : e.WindDelta * t.WindDelta < 0 ? t.WindCnt = e.WindCnt : t.WindCnt = e.WindCnt + t.WindDelta, t.WindCnt2 = e.WindCnt2, e = e.NextInAEL;
      if (this.IsEvenOddAltFillType(t)) for (; e != t;) 0 !== e.WindDelta && (t.WindCnt2 = 0 === t.WindCnt2 ? 1 : 0), e = e.NextInAEL;else for (; e != t;) t.WindCnt2 += e.WindDelta, e = e.NextInAEL;
    }, i.Clipper.prototype.AddEdgeToSEL = function (t) {
      null === this.m_SortedEdges ? (this.m_SortedEdges = t, t.PrevInSEL = null, t.NextInSEL = null) : (t.NextInSEL = this.m_SortedEdges, t.PrevInSEL = null, this.m_SortedEdges.PrevInSEL = t, this.m_SortedEdges = t);
    }, i.Clipper.prototype.CopyAELToSEL = function () {
      var t = this.m_ActiveEdges;
      for (this.m_SortedEdges = t; null !== t;) t.PrevInSEL = t.PrevInAEL, t.NextInSEL = t.NextInAEL, t = t.NextInAEL;
    }, i.Clipper.prototype.SwapPositionsInAEL = function (t, e) {
      if (t.NextInAEL != t.PrevInAEL && e.NextInAEL != e.PrevInAEL) {
        if (t.NextInAEL == e) null !== (n = e.NextInAEL) && (n.PrevInAEL = t), null !== (i = t.PrevInAEL) && (i.NextInAEL = e), e.PrevInAEL = i, e.NextInAEL = t, t.PrevInAEL = e, t.NextInAEL = n;else if (e.NextInAEL == t) {
          null !== (n = t.NextInAEL) && (n.PrevInAEL = e), null !== (i = e.PrevInAEL) && (i.NextInAEL = t), t.PrevInAEL = i, t.NextInAEL = e, e.PrevInAEL = t, e.NextInAEL = n;
        } else {
          var n = t.NextInAEL,
            i = t.PrevInAEL;
          t.NextInAEL = e.NextInAEL, null !== t.NextInAEL && (t.NextInAEL.PrevInAEL = t), t.PrevInAEL = e.PrevInAEL, null !== t.PrevInAEL && (t.PrevInAEL.NextInAEL = t), e.NextInAEL = n, null !== e.NextInAEL && (e.NextInAEL.PrevInAEL = e), e.PrevInAEL = i, null !== e.PrevInAEL && (e.PrevInAEL.NextInAEL = e);
        }
        null === t.PrevInAEL ? this.m_ActiveEdges = t : null === e.PrevInAEL && (this.m_ActiveEdges = e);
      }
    }, i.Clipper.prototype.SwapPositionsInSEL = function (t, e) {
      if (!(null === t.NextInSEL && null === t.PrevInSEL || null === e.NextInSEL && null === e.PrevInSEL)) {
        if (t.NextInSEL == e) null !== (n = e.NextInSEL) && (n.PrevInSEL = t), null !== (i = t.PrevInSEL) && (i.NextInSEL = e), e.PrevInSEL = i, e.NextInSEL = t, t.PrevInSEL = e, t.NextInSEL = n;else if (e.NextInSEL == t) {
          null !== (n = t.NextInSEL) && (n.PrevInSEL = e), null !== (i = e.PrevInSEL) && (i.NextInSEL = t), t.PrevInSEL = i, t.NextInSEL = e, e.PrevInSEL = t, e.NextInSEL = n;
        } else {
          var n = t.NextInSEL,
            i = t.PrevInSEL;
          t.NextInSEL = e.NextInSEL, null !== t.NextInSEL && (t.NextInSEL.PrevInSEL = t), t.PrevInSEL = e.PrevInSEL, null !== t.PrevInSEL && (t.PrevInSEL.NextInSEL = t), e.NextInSEL = n, null !== e.NextInSEL && (e.NextInSEL.PrevInSEL = e), e.PrevInSEL = i, null !== e.PrevInSEL && (e.PrevInSEL.NextInSEL = e);
        }
        null === t.PrevInSEL ? this.m_SortedEdges = t : null === e.PrevInSEL && (this.m_SortedEdges = e);
      }
    }, i.Clipper.prototype.AddLocalMaxPoly = function (t, e, n) {
      this.AddOutPt(t, n), 0 == e.WindDelta && this.AddOutPt(e, n), t.OutIdx == e.OutIdx ? (t.OutIdx = -1, e.OutIdx = -1) : t.OutIdx < e.OutIdx ? this.AppendPolygon(t, e) : this.AppendPolygon(e, t);
    }, i.Clipper.prototype.AddLocalMinPoly = function (t, e, n) {
      var r, o, s;
      if (i.ClipperBase.IsHorizontal(e) || t.Dx > e.Dx ? (r = this.AddOutPt(t, n), e.OutIdx = t.OutIdx, t.Side = i.EdgeSide.esLeft, e.Side = i.EdgeSide.esRight, s = (o = t).PrevInAEL == e ? e.PrevInAEL : o.PrevInAEL) : (r = this.AddOutPt(e, n), t.OutIdx = e.OutIdx, t.Side = i.EdgeSide.esRight, e.Side = i.EdgeSide.esLeft, s = (o = e).PrevInAEL == t ? t.PrevInAEL : o.PrevInAEL), null !== s && s.OutIdx >= 0 && i.Clipper.TopX(s, n.Y) == i.Clipper.TopX(o, n.Y) && i.ClipperBase.SlopesEqual(o, s, this.m_UseFullRange) && 0 !== o.WindDelta && 0 !== s.WindDelta) {
        var a = this.AddOutPt(s, n);
        this.AddJoin(r, a, o.Top);
      }
      return r;
    }, i.Clipper.prototype.CreateOutRec = function () {
      var t = new i.OutRec();
      return t.Idx = -1, t.IsHole = !1, t.IsOpen = !1, t.FirstLeft = null, t.Pts = null, t.BottomPt = null, t.PolyNode = null, this.m_PolyOuts.push(t), t.Idx = this.m_PolyOuts.length - 1, t;
    }, i.Clipper.prototype.AddOutPt = function (t, e) {
      var n = t.Side == i.EdgeSide.esLeft;
      if (t.OutIdx < 0) {
        (o = this.CreateOutRec()).IsOpen = 0 === t.WindDelta;
        var r = new i.OutPt();
        return o.Pts = r, r.Idx = o.Idx, r.Pt.X = e.X, r.Pt.Y = e.Y, r.Next = r, r.Prev = r, o.IsOpen || this.SetHoleState(t, o), t.OutIdx = o.Idx, r;
      }
      var o,
        s = (o = this.m_PolyOuts[t.OutIdx]).Pts;
      return n && i.IntPoint.op_Equality(e, s.Pt) ? s : !n && i.IntPoint.op_Equality(e, s.Prev.Pt) ? s.Prev : ((r = new i.OutPt()).Idx = o.Idx, r.Pt.X = e.X, r.Pt.Y = e.Y, r.Next = s, r.Prev = s.Prev, r.Prev.Next = r, s.Prev = r, n && (o.Pts = r), r);
    }, i.Clipper.prototype.SwapPoints = function (t, e) {
      var n = new i.IntPoint(t.Value);
      t.Value.X = e.Value.X, t.Value.Y = e.Value.Y, e.Value.X = n.X, e.Value.Y = n.Y;
    }, i.Clipper.prototype.HorzSegmentsOverlap = function (t, e, n, i) {
      return t.X > n.X == t.X < i.X || e.X > n.X == e.X < i.X || n.X > t.X == n.X < e.X || i.X > t.X == i.X < e.X || t.X == n.X && e.X == i.X || t.X == i.X && e.X == n.X;
    }, i.Clipper.prototype.InsertPolyPtBetween = function (t, e, n) {
      var r = new i.OutPt();
      return r.Pt.X = n.X, r.Pt.Y = n.Y, e == t.Next ? (t.Next = r, e.Prev = r, r.Next = e, r.Prev = t) : (e.Next = r, t.Prev = r, r.Next = t, r.Prev = e), r;
    }, i.Clipper.prototype.SetHoleState = function (t, e) {
      for (var n = !1, i = t.PrevInAEL; null !== i;) i.OutIdx >= 0 && 0 != i.WindDelta && (n = !n, null === e.FirstLeft && (e.FirstLeft = this.m_PolyOuts[i.OutIdx])), i = i.PrevInAEL;
      n && (e.IsHole = !0);
    }, i.Clipper.prototype.GetDx = function (t, e) {
      return t.Y == e.Y ? i.ClipperBase.horizontal : (e.X - t.X) / (e.Y - t.Y);
    }, i.Clipper.prototype.FirstIsBottomPt = function (t, e) {
      for (var n = t.Prev; i.IntPoint.op_Equality(n.Pt, t.Pt) && n != t;) n = n.Prev;
      var r = Math.abs(this.GetDx(t.Pt, n.Pt));
      for (n = t.Next; i.IntPoint.op_Equality(n.Pt, t.Pt) && n != t;) n = n.Next;
      var o = Math.abs(this.GetDx(t.Pt, n.Pt));
      for (n = e.Prev; i.IntPoint.op_Equality(n.Pt, e.Pt) && n != e;) n = n.Prev;
      var s = Math.abs(this.GetDx(e.Pt, n.Pt));
      for (n = e.Next; i.IntPoint.op_Equality(n.Pt, e.Pt) && n != e;) n = n.Next;
      var a = Math.abs(this.GetDx(e.Pt, n.Pt));
      return r >= s && r >= a || o >= s && o >= a;
    }, i.Clipper.prototype.GetBottomPt = function (t) {
      for (var e = null, n = t.Next; n != t;) n.Pt.Y > t.Pt.Y ? (t = n, e = null) : n.Pt.Y == t.Pt.Y && n.Pt.X <= t.Pt.X && (n.Pt.X < t.Pt.X ? (e = null, t = n) : n.Next != t && n.Prev != t && (e = n)), n = n.Next;
      if (null !== e) for (; e != n;) for (this.FirstIsBottomPt(n, e) || (t = e), e = e.Next; i.IntPoint.op_Inequality(e.Pt, t.Pt);) e = e.Next;
      return t;
    }, i.Clipper.prototype.GetLowermostRec = function (t, e) {
      null === t.BottomPt && (t.BottomPt = this.GetBottomPt(t.Pts)), null === e.BottomPt && (e.BottomPt = this.GetBottomPt(e.Pts));
      var n = t.BottomPt,
        i = e.BottomPt;
      return n.Pt.Y > i.Pt.Y ? t : n.Pt.Y < i.Pt.Y ? e : n.Pt.X < i.Pt.X ? t : n.Pt.X > i.Pt.X || n.Next == n ? e : i.Next == i || this.FirstIsBottomPt(n, i) ? t : e;
    }, i.Clipper.prototype.Param1RightOfParam2 = function (t, e) {
      do {
        if ((t = t.FirstLeft) == e) return !0;
      } while (null !== t);
      return !1;
    }, i.Clipper.prototype.GetOutRec = function (t) {
      for (var e = this.m_PolyOuts[t]; e != this.m_PolyOuts[e.Idx];) e = this.m_PolyOuts[e.Idx];
      return e;
    }, i.Clipper.prototype.AppendPolygon = function (t, e) {
      var n,
        r = this.m_PolyOuts[t.OutIdx],
        o = this.m_PolyOuts[e.OutIdx];
      n = this.Param1RightOfParam2(r, o) ? o : this.Param1RightOfParam2(o, r) ? r : this.GetLowermostRec(r, o);
      var s,
        a = r.Pts,
        l = a.Prev,
        u = o.Pts,
        h = u.Prev;
      t.Side == i.EdgeSide.esLeft ? (e.Side == i.EdgeSide.esLeft ? (this.ReversePolyPtLinks(u), u.Next = a, a.Prev = u, l.Next = h, h.Prev = l, r.Pts = h) : (h.Next = a, a.Prev = h, u.Prev = l, l.Next = u, r.Pts = u), s = i.EdgeSide.esLeft) : (e.Side == i.EdgeSide.esRight ? (this.ReversePolyPtLinks(u), l.Next = h, h.Prev = l, u.Next = a, a.Prev = u) : (l.Next = u, u.Prev = l, a.Prev = h, h.Next = a), s = i.EdgeSide.esRight), r.BottomPt = null, n == o && (o.FirstLeft != r && (r.FirstLeft = o.FirstLeft), r.IsHole = o.IsHole), o.Pts = null, o.BottomPt = null, o.FirstLeft = r;
      var c = t.OutIdx,
        p = e.OutIdx;
      t.OutIdx = -1, e.OutIdx = -1;
      for (var d = this.m_ActiveEdges; null !== d;) {
        if (d.OutIdx == p) {
          d.OutIdx = c, d.Side = s;
          break;
        }
        d = d.NextInAEL;
      }
      o.Idx = r.Idx;
    }, i.Clipper.prototype.ReversePolyPtLinks = function (t) {
      if (null !== t) {
        var e, n;
        e = t;
        do {
          n = e.Next, e.Next = e.Prev, e.Prev = n, e = n;
        } while (e != t);
      }
    }, i.Clipper.SwapSides = function (t, e) {
      var n = t.Side;
      t.Side = e.Side, e.Side = n;
    }, i.Clipper.SwapPolyIndexes = function (t, e) {
      var n = t.OutIdx;
      t.OutIdx = e.OutIdx, e.OutIdx = n;
    }, i.Clipper.prototype.IntersectEdges = function (t, e, n, r) {
      var o,
        s,
        a,
        l,
        u,
        h,
        c = !r && null === t.NextInLML && t.Top.X == n.X && t.Top.Y == n.Y,
        p = !r && null === e.NextInLML && e.Top.X == n.X && e.Top.Y == n.Y,
        d = t.OutIdx >= 0,
        f = e.OutIdx >= 0;
      if (0 === t.WindDelta || 0 === e.WindDelta) return 0 === t.WindDelta && 0 === e.WindDelta ? (c || p) && d && f && this.AddLocalMaxPoly(t, e, n) : t.PolyTyp == e.PolyTyp && t.WindDelta != e.WindDelta && this.m_ClipType == i.ClipType.ctUnion ? 0 === t.WindDelta ? f && (this.AddOutPt(t, n), d && (t.OutIdx = -1)) : d && (this.AddOutPt(e, n), f && (e.OutIdx = -1)) : t.PolyTyp != e.PolyTyp && (0 !== t.WindDelta || 1 != Math.abs(e.WindCnt) || this.m_ClipType == i.ClipType.ctUnion && 0 !== e.WindCnt2 ? 0 === e.WindDelta && 1 == Math.abs(t.WindCnt) && (this.m_ClipType != i.ClipType.ctUnion || 0 === t.WindCnt2) && (this.AddOutPt(e, n), f && (e.OutIdx = -1)) : (this.AddOutPt(t, n), d && (t.OutIdx = -1))), c && (t.OutIdx < 0 ? this.DeleteFromAEL(t) : i.Error("Error intersecting polylines")), void (p && (e.OutIdx < 0 ? this.DeleteFromAEL(e) : i.Error("Error intersecting polylines")));
      if (t.PolyTyp == e.PolyTyp) {
        if (this.IsEvenOddFillType(t)) {
          var m = t.WindCnt;
          t.WindCnt = e.WindCnt, e.WindCnt = m;
        } else t.WindCnt + e.WindDelta === 0 ? t.WindCnt = -t.WindCnt : t.WindCnt += e.WindDelta, e.WindCnt - t.WindDelta == 0 ? e.WindCnt = -e.WindCnt : e.WindCnt -= t.WindDelta;
      } else this.IsEvenOddFillType(e) ? t.WindCnt2 = 0 === t.WindCnt2 ? 1 : 0 : t.WindCnt2 += e.WindDelta, this.IsEvenOddFillType(t) ? e.WindCnt2 = 0 === e.WindCnt2 ? 1 : 0 : e.WindCnt2 -= t.WindDelta;
      switch (t.PolyTyp == i.PolyType.ptSubject ? (o = this.m_SubjFillType, a = this.m_ClipFillType) : (o = this.m_ClipFillType, a = this.m_SubjFillType), e.PolyTyp == i.PolyType.ptSubject ? (s = this.m_SubjFillType, l = this.m_ClipFillType) : (s = this.m_ClipFillType, l = this.m_SubjFillType), o) {
        case i.PolyFillType.pftPositive:
          u = t.WindCnt;
          break;
        case i.PolyFillType.pftNegative:
          u = -t.WindCnt;
          break;
        default:
          u = Math.abs(t.WindCnt);
      }
      switch (s) {
        case i.PolyFillType.pftPositive:
          h = e.WindCnt;
          break;
        case i.PolyFillType.pftNegative:
          h = -e.WindCnt;
          break;
        default:
          h = Math.abs(e.WindCnt);
      }
      if (d && f) c || p || 0 !== u && 1 != u || 0 !== h && 1 != h || t.PolyTyp != e.PolyTyp && this.m_ClipType != i.ClipType.ctXor ? this.AddLocalMaxPoly(t, e, n) : (this.AddOutPt(t, n), this.AddOutPt(e, n), i.Clipper.SwapSides(t, e), i.Clipper.SwapPolyIndexes(t, e));else if (d) (0 === h || 1 == h) && (this.AddOutPt(t, n), i.Clipper.SwapSides(t, e), i.Clipper.SwapPolyIndexes(t, e));else if (f) (0 === u || 1 == u) && (this.AddOutPt(e, n), i.Clipper.SwapSides(t, e), i.Clipper.SwapPolyIndexes(t, e));else if (!(0 !== u && 1 != u || 0 !== h && 1 != h || c || p)) {
        var g, v;
        switch (a) {
          case i.PolyFillType.pftPositive:
            g = t.WindCnt2;
            break;
          case i.PolyFillType.pftNegative:
            g = -t.WindCnt2;
            break;
          default:
            g = Math.abs(t.WindCnt2);
        }
        switch (l) {
          case i.PolyFillType.pftPositive:
            v = e.WindCnt2;
            break;
          case i.PolyFillType.pftNegative:
            v = -e.WindCnt2;
            break;
          default:
            v = Math.abs(e.WindCnt2);
        }
        if (t.PolyTyp != e.PolyTyp) this.AddLocalMinPoly(t, e, n);else if (1 == u && 1 == h) switch (this.m_ClipType) {
          case i.ClipType.ctIntersection:
            g > 0 && v > 0 && this.AddLocalMinPoly(t, e, n);
            break;
          case i.ClipType.ctUnion:
            g <= 0 && v <= 0 && this.AddLocalMinPoly(t, e, n);
            break;
          case i.ClipType.ctDifference:
            (t.PolyTyp == i.PolyType.ptClip && g > 0 && v > 0 || t.PolyTyp == i.PolyType.ptSubject && g <= 0 && v <= 0) && this.AddLocalMinPoly(t, e, n);
            break;
          case i.ClipType.ctXor:
            this.AddLocalMinPoly(t, e, n);
        } else i.Clipper.SwapSides(t, e);
      }
      c != p && (c && t.OutIdx >= 0 || p && e.OutIdx >= 0) && (i.Clipper.SwapSides(t, e), i.Clipper.SwapPolyIndexes(t, e)), c && this.DeleteFromAEL(t), p && this.DeleteFromAEL(e);
    }, i.Clipper.prototype.DeleteFromAEL = function (t) {
      var e = t.PrevInAEL,
        n = t.NextInAEL;
      null === e && null === n && t != this.m_ActiveEdges || (null !== e ? e.NextInAEL = n : this.m_ActiveEdges = n, null !== n && (n.PrevInAEL = e), t.NextInAEL = null, t.PrevInAEL = null);
    }, i.Clipper.prototype.DeleteFromSEL = function (t) {
      var e = t.PrevInSEL,
        n = t.NextInSEL;
      null === e && null === n && t != this.m_SortedEdges || (null !== e ? e.NextInSEL = n : this.m_SortedEdges = n, null !== n && (n.PrevInSEL = e), t.NextInSEL = null, t.PrevInSEL = null);
    }, i.Clipper.prototype.UpdateEdgeIntoAEL = function (t) {
      null === t.NextInLML && i.Error("UpdateEdgeIntoAEL: invalid call");
      var e = t.PrevInAEL,
        n = t.NextInAEL;
      return t.NextInLML.OutIdx = t.OutIdx, null !== e ? e.NextInAEL = t.NextInLML : this.m_ActiveEdges = t.NextInLML, null !== n && (n.PrevInAEL = t.NextInLML), t.NextInLML.Side = t.Side, t.NextInLML.WindDelta = t.WindDelta, t.NextInLML.WindCnt = t.WindCnt, t.NextInLML.WindCnt2 = t.WindCnt2, (t = t.NextInLML).Curr.X = t.Bot.X, t.Curr.Y = t.Bot.Y, t.PrevInAEL = e, t.NextInAEL = n, i.ClipperBase.IsHorizontal(t) || this.InsertScanbeam(t.Top.Y), t;
    }, i.Clipper.prototype.ProcessHorizontals = function (t) {
      for (var e = this.m_SortedEdges; null !== e;) this.DeleteFromSEL(e), this.ProcessHorizontal(e, t), e = this.m_SortedEdges;
    }, i.Clipper.prototype.GetHorzDirection = function (t, e) {
      t.Bot.X < t.Top.X ? (e.Left = t.Bot.X, e.Right = t.Top.X, e.Dir = i.Direction.dLeftToRight) : (e.Left = t.Top.X, e.Right = t.Bot.X, e.Dir = i.Direction.dRightToLeft);
    }, i.Clipper.prototype.PrepareHorzJoins = function (t, e) {
      var n = this.m_PolyOuts[t.OutIdx].Pts;
      t.Side != i.EdgeSide.esLeft && (n = n.Prev), e && (i.IntPoint.op_Equality(n.Pt, t.Top) ? this.AddGhostJoin(n, t.Bot) : this.AddGhostJoin(n, t.Top));
    }, i.Clipper.prototype.ProcessHorizontal = function (t, e) {
      var n = {
        Dir: null,
        Left: null,
        Right: null
      };
      this.GetHorzDirection(t, n);
      for (var r = n.Dir, o = n.Left, s = n.Right, a = t, l = null; null !== a.NextInLML && i.ClipperBase.IsHorizontal(a.NextInLML);) a = a.NextInLML;
      for (null === a.NextInLML && (l = this.GetMaximaPair(a));;) {
        for (var u = t == a, h = this.GetNextInAEL(t, r); null !== h && !(h.Curr.X == t.Top.X && null !== t.NextInLML && h.Dx < t.NextInLML.Dx);) {
          var c = this.GetNextInAEL(h, r);
          if (r == i.Direction.dLeftToRight && h.Curr.X <= s || r == i.Direction.dRightToLeft && h.Curr.X >= o) {
            if (t.OutIdx >= 0 && 0 != t.WindDelta && this.PrepareHorzJoins(t, e), h == l && u) return r == i.Direction.dLeftToRight ? this.IntersectEdges(t, h, h.Top, !1) : this.IntersectEdges(h, t, h.Top, !1), void (l.OutIdx >= 0 && i.Error("ProcessHorizontal error"));
            if (r == i.Direction.dLeftToRight) {
              var p = new i.IntPoint(h.Curr.X, t.Curr.Y);
              this.IntersectEdges(t, h, p, !0);
            } else {
              p = new i.IntPoint(h.Curr.X, t.Curr.Y);
              this.IntersectEdges(h, t, p, !0);
            }
            this.SwapPositionsInAEL(t, h);
          } else if (r == i.Direction.dLeftToRight && h.Curr.X >= s || r == i.Direction.dRightToLeft && h.Curr.X <= o) break;
          h = c;
        }
        if (t.OutIdx >= 0 && 0 !== t.WindDelta && this.PrepareHorzJoins(t, e), null === t.NextInLML || !i.ClipperBase.IsHorizontal(t.NextInLML)) break;
        (t = this.UpdateEdgeIntoAEL(t)).OutIdx >= 0 && this.AddOutPt(t, t.Bot);
        n = {
          Dir: r,
          Left: o,
          Right: s
        };
        this.GetHorzDirection(t, n), r = n.Dir, o = n.Left, s = n.Right;
      }
      if (null !== t.NextInLML) {
        if (t.OutIdx >= 0) {
          var d = this.AddOutPt(t, t.Top);
          if (0 === (t = this.UpdateEdgeIntoAEL(t)).WindDelta) return;
          var f = t.PrevInAEL;
          c = t.NextInAEL;
          if (null !== f && f.Curr.X == t.Bot.X && f.Curr.Y == t.Bot.Y && 0 !== f.WindDelta && f.OutIdx >= 0 && f.Curr.Y > f.Top.Y && i.ClipperBase.SlopesEqual(t, f, this.m_UseFullRange)) {
            var m = this.AddOutPt(f, t.Bot);
            this.AddJoin(d, m, t.Top);
          } else if (null !== c && c.Curr.X == t.Bot.X && c.Curr.Y == t.Bot.Y && 0 !== c.WindDelta && c.OutIdx >= 0 && c.Curr.Y > c.Top.Y && i.ClipperBase.SlopesEqual(t, c, this.m_UseFullRange)) {
            m = this.AddOutPt(c, t.Bot);
            this.AddJoin(d, m, t.Top);
          }
        } else t = this.UpdateEdgeIntoAEL(t);
      } else null !== l ? l.OutIdx >= 0 ? (r == i.Direction.dLeftToRight ? this.IntersectEdges(t, l, t.Top, !1) : this.IntersectEdges(l, t, t.Top, !1), l.OutIdx >= 0 && i.Error("ProcessHorizontal error")) : (this.DeleteFromAEL(t), this.DeleteFromAEL(l)) : (t.OutIdx >= 0 && this.AddOutPt(t, t.Top), this.DeleteFromAEL(t));
    }, i.Clipper.prototype.GetNextInAEL = function (t, e) {
      return e == i.Direction.dLeftToRight ? t.NextInAEL : t.PrevInAEL;
    }, i.Clipper.prototype.IsMinima = function (t) {
      return null !== t && t.Prev.NextInLML != t && t.Next.NextInLML != t;
    }, i.Clipper.prototype.IsMaxima = function (t, e) {
      return null !== t && t.Top.Y == e && null === t.NextInLML;
    }, i.Clipper.prototype.IsIntermediate = function (t, e) {
      return t.Top.Y == e && null !== t.NextInLML;
    }, i.Clipper.prototype.GetMaximaPair = function (t) {
      var e = null;
      return i.IntPoint.op_Equality(t.Next.Top, t.Top) && null === t.Next.NextInLML ? e = t.Next : i.IntPoint.op_Equality(t.Prev.Top, t.Top) && null === t.Prev.NextInLML && (e = t.Prev), null === e || -2 != e.OutIdx && (e.NextInAEL != e.PrevInAEL || i.ClipperBase.IsHorizontal(e)) ? e : null;
    }, i.Clipper.prototype.ProcessIntersections = function (t, e) {
      if (null == this.m_ActiveEdges) return !0;
      try {
        if (this.BuildIntersectList(t, e), 0 == this.m_IntersectList.length) return !0;
        if (1 != this.m_IntersectList.length && !this.FixupIntersectionOrder()) return !1;
        this.ProcessIntersectList();
      } catch (t) {
        this.m_SortedEdges = null, this.m_IntersectList.length = 0, i.Error("ProcessIntersections error");
      }
      return this.m_SortedEdges = null, !0;
    }, i.Clipper.prototype.BuildIntersectList = function (t, e) {
      if (null !== this.m_ActiveEdges) {
        var n = this.m_ActiveEdges;
        for (this.m_SortedEdges = n; null !== n;) n.PrevInSEL = n.PrevInAEL, n.NextInSEL = n.NextInAEL, n.Curr.X = i.Clipper.TopX(n, e), n = n.NextInAEL;
        for (var r = !0; r && null !== this.m_SortedEdges;) {
          for (r = !1, n = this.m_SortedEdges; null !== n.NextInSEL;) {
            var o = n.NextInSEL,
              s = new i.IntPoint();
            if (n.Curr.X > o.Curr.X) {
              !this.IntersectPoint(n, o, s) && n.Curr.X > o.Curr.X + 1 && i.Error("Intersection error"), s.Y > t && (s.Y = t, Math.abs(n.Dx) > Math.abs(o.Dx) ? s.X = i.Clipper.TopX(o, t) : s.X = i.Clipper.TopX(n, t));
              var a = new i.IntersectNode();
              a.Edge1 = n, a.Edge2 = o, a.Pt.X = s.X, a.Pt.Y = s.Y, this.m_IntersectList.push(a), this.SwapPositionsInSEL(n, o), r = !0;
            } else n = o;
          }
          if (null === n.PrevInSEL) break;
          n.PrevInSEL.NextInSEL = null;
        }
        this.m_SortedEdges = null;
      }
    }, i.Clipper.prototype.EdgesAdjacent = function (t) {
      return t.Edge1.NextInSEL == t.Edge2 || t.Edge1.PrevInSEL == t.Edge2;
    }, i.Clipper.IntersectNodeSort = function (t, e) {
      return e.Pt.Y - t.Pt.Y;
    }, i.Clipper.prototype.FixupIntersectionOrder = function () {
      this.m_IntersectList.sort(this.m_IntersectNodeComparer), this.CopyAELToSEL();
      for (var t = this.m_IntersectList.length, e = 0; e < t; e++) {
        if (!this.EdgesAdjacent(this.m_IntersectList[e])) {
          for (var n = e + 1; n < t && !this.EdgesAdjacent(this.m_IntersectList[n]);) n++;
          if (n == t) return !1;
          var i = this.m_IntersectList[e];
          this.m_IntersectList[e] = this.m_IntersectList[n], this.m_IntersectList[n] = i;
        }
        this.SwapPositionsInSEL(this.m_IntersectList[e].Edge1, this.m_IntersectList[e].Edge2);
      }
      return !0;
    }, i.Clipper.prototype.ProcessIntersectList = function () {
      for (var t = 0, e = this.m_IntersectList.length; t < e; t++) {
        var n = this.m_IntersectList[t];
        this.IntersectEdges(n.Edge1, n.Edge2, n.Pt, !0), this.SwapPositionsInAEL(n.Edge1, n.Edge2);
      }
      this.m_IntersectList.length = 0;
    };
    var me = u(function (t) {
        return t < 0 ? Math.ceil(t - .5) : Math.round(t);
      }, "R1"),
      ge = u(function (t) {
        return t < 0 ? Math.ceil(t - .5) : Math.floor(t + .5);
      }, "R2"),
      ve = u(function (t) {
        return t < 0 ? -Math.round(Math.abs(t)) : Math.round(t);
      }, "R3"),
      ye = u(function (t) {
        return t < 0 ? (t -= .5) < -2147483648 ? Math.ceil(t) : 0 | t : (t += .5) > 2147483647 ? Math.floor(t) : 0 | t;
      }, "R4");
    s.msie ? i.Clipper.Round = me : s.chromium ? i.Clipper.Round = ve : s.safari ? i.Clipper.Round = ye : i.Clipper.Round = ge, i.Clipper.TopX = function (t, e) {
      return e == t.Top.Y ? t.Top.X : t.Bot.X + i.Clipper.Round(t.Dx * (e - t.Bot.Y));
    }, i.Clipper.prototype.IntersectPoint = function (t, e, n) {
      var r, o;
      if (n.X = 0, n.Y = 0, i.ClipperBase.SlopesEqual(t, e, this.m_UseFullRange) || t.Dx == e.Dx) return e.Bot.Y > t.Bot.Y ? (n.X = e.Bot.X, n.Y = e.Bot.Y) : (n.X = t.Bot.X, n.Y = t.Bot.Y), !1;
      if (0 === t.Delta.X) n.X = t.Bot.X, i.ClipperBase.IsHorizontal(e) ? n.Y = e.Bot.Y : (o = e.Bot.Y - e.Bot.X / e.Dx, n.Y = i.Clipper.Round(n.X / e.Dx + o));else if (0 === e.Delta.X) n.X = e.Bot.X, i.ClipperBase.IsHorizontal(t) ? n.Y = t.Bot.Y : (r = t.Bot.Y - t.Bot.X / t.Dx, n.Y = i.Clipper.Round(n.X / t.Dx + r));else {
        r = t.Bot.X - t.Bot.Y * t.Dx;
        var s = ((o = e.Bot.X - e.Bot.Y * e.Dx) - r) / (t.Dx - e.Dx);
        n.Y = i.Clipper.Round(s), Math.abs(t.Dx) < Math.abs(e.Dx) ? n.X = i.Clipper.Round(t.Dx * s + r) : n.X = i.Clipper.Round(e.Dx * s + o);
      }
      if (n.Y < t.Top.Y || n.Y < e.Top.Y) {
        if (t.Top.Y > e.Top.Y) return n.Y = t.Top.Y, n.X = i.Clipper.TopX(e, t.Top.Y), n.X < t.Top.X;
        n.Y = e.Top.Y, Math.abs(t.Dx) < Math.abs(e.Dx) ? n.X = i.Clipper.TopX(t, n.Y) : n.X = i.Clipper.TopX(e, n.Y);
      }
      return !0;
    }, i.Clipper.prototype.ProcessEdgesAtTopOfScanbeam = function (t) {
      for (var e = this.m_ActiveEdges; null !== e;) {
        var n = this.IsMaxima(e, t);
        if (n) {
          var r = this.GetMaximaPair(e);
          n = null === r || !i.ClipperBase.IsHorizontal(r);
        }
        if (n) {
          var o = e.PrevInAEL;
          this.DoMaxima(e), e = null === o ? this.m_ActiveEdges : o.NextInAEL;
        } else {
          if (this.IsIntermediate(e, t) && i.ClipperBase.IsHorizontal(e.NextInLML) ? ((e = this.UpdateEdgeIntoAEL(e)).OutIdx >= 0 && this.AddOutPt(e, e.Bot), this.AddEdgeToSEL(e)) : (e.Curr.X = i.Clipper.TopX(e, t), e.Curr.Y = t), this.StrictlySimple) {
            o = e.PrevInAEL;
            if (e.OutIdx >= 0 && 0 !== e.WindDelta && null !== o && o.OutIdx >= 0 && o.Curr.X == e.Curr.X && 0 !== o.WindDelta) {
              var s = this.AddOutPt(o, e.Curr),
                a = this.AddOutPt(e, e.Curr);
              this.AddJoin(s, a, e.Curr);
            }
          }
          e = e.NextInAEL;
        }
      }
      for (this.ProcessHorizontals(!0), e = this.m_ActiveEdges; null !== e;) {
        if (this.IsIntermediate(e, t)) {
          s = null;
          e.OutIdx >= 0 && (s = this.AddOutPt(e, e.Top));
          o = (e = this.UpdateEdgeIntoAEL(e)).PrevInAEL;
          var l = e.NextInAEL;
          if (null !== o && o.Curr.X == e.Bot.X && o.Curr.Y == e.Bot.Y && null !== s && o.OutIdx >= 0 && o.Curr.Y > o.Top.Y && i.ClipperBase.SlopesEqual(e, o, this.m_UseFullRange) && 0 !== e.WindDelta && 0 !== o.WindDelta) {
            a = this.AddOutPt(o, e.Bot);
            this.AddJoin(s, a, e.Top);
          } else if (null !== l && l.Curr.X == e.Bot.X && l.Curr.Y == e.Bot.Y && null !== s && l.OutIdx >= 0 && l.Curr.Y > l.Top.Y && i.ClipperBase.SlopesEqual(e, l, this.m_UseFullRange) && 0 !== e.WindDelta && 0 !== l.WindDelta) {
            a = this.AddOutPt(l, e.Bot);
            this.AddJoin(s, a, e.Top);
          }
        }
        e = e.NextInAEL;
      }
    }, i.Clipper.prototype.DoMaxima = function (t) {
      var e = this.GetMaximaPair(t);
      if (null === e) return t.OutIdx >= 0 && this.AddOutPt(t, t.Top), void this.DeleteFromAEL(t);
      for (var n = t.NextInAEL; null !== n && n != e;) this.IntersectEdges(t, n, t.Top, !0), this.SwapPositionsInAEL(t, n), n = t.NextInAEL;
      -1 == t.OutIdx && -1 == e.OutIdx ? (this.DeleteFromAEL(t), this.DeleteFromAEL(e)) : t.OutIdx >= 0 && e.OutIdx >= 0 ? this.IntersectEdges(t, e, t.Top, !1) : 0 === t.WindDelta ? (t.OutIdx >= 0 && (this.AddOutPt(t, t.Top), t.OutIdx = -1), this.DeleteFromAEL(t), e.OutIdx >= 0 && (this.AddOutPt(e, t.Top), e.OutIdx = -1), this.DeleteFromAEL(e)) : i.Error("DoMaxima error");
    }, i.Clipper.ReversePaths = function (t) {
      for (var e = 0, n = t.length; e < n; e++) t[e].reverse();
    }, i.Clipper.Orientation = function (t) {
      return i.Clipper.Area(t) >= 0;
    }, i.Clipper.prototype.PointCount = function (t) {
      if (null === t) return 0;
      var e = 0,
        n = t;
      do {
        e++, n = n.Next;
      } while (n != t);
      return e;
    }, i.Clipper.prototype.BuildResult = function (t) {
      i.Clear(t);
      for (var e = 0, n = this.m_PolyOuts.length; e < n; e++) {
        var r = this.m_PolyOuts[e];
        if (null !== r.Pts) {
          var o = r.Pts.Prev,
            s = this.PointCount(o);
          if (!(s < 2)) {
            for (var a = new Array(s), l = 0; l < s; l++) a[l] = o.Pt, o = o.Prev;
            t.push(a);
          }
        }
      }
    }, i.Clipper.prototype.BuildResult2 = function (t) {
      t.Clear();
      for (var e = 0, n = this.m_PolyOuts.length; e < n; e++) {
        var r = this.m_PolyOuts[e],
          o = this.PointCount(r.Pts);
        if (!(r.IsOpen && o < 2 || !r.IsOpen && o < 3)) {
          this.FixHoleLinkage(r);
          var s = new i.PolyNode();
          t.m_AllPolys.push(s), r.PolyNode = s, s.m_polygon.length = o;
          for (var a = r.Pts.Prev, l = 0; l < o; l++) s.m_polygon[l] = a.Pt, a = a.Prev;
        }
      }
      for (e = 0, n = this.m_PolyOuts.length; e < n; e++) {
        null !== (r = this.m_PolyOuts[e]).PolyNode && (r.IsOpen ? (r.PolyNode.IsOpen = !0, t.AddChild(r.PolyNode)) : null !== r.FirstLeft && null != r.FirstLeft.PolyNode ? r.FirstLeft.PolyNode.AddChild(r.PolyNode) : t.AddChild(r.PolyNode));
      }
    }, i.Clipper.prototype.FixupOutPolygon = function (t) {
      var e = null;
      t.BottomPt = null;
      for (var n = t.Pts;;) {
        if (n.Prev == n || n.Prev == n.Next) return this.DisposeOutPts(n), void (t.Pts = null);
        if (i.IntPoint.op_Equality(n.Pt, n.Next.Pt) || i.IntPoint.op_Equality(n.Pt, n.Prev.Pt) || i.ClipperBase.SlopesEqual(n.Prev.Pt, n.Pt, n.Next.Pt, this.m_UseFullRange) && (!this.PreserveCollinear || !this.Pt2IsBetweenPt1AndPt3(n.Prev.Pt, n.Pt, n.Next.Pt))) {
          e = null;
          n.Prev.Next = n.Next, n.Next.Prev = n.Prev, n = n.Prev, null;
        } else {
          if (n == e) break;
          null === e && (e = n), n = n.Next;
        }
      }
      t.Pts = n;
    }, i.Clipper.prototype.DupOutPt = function (t, e) {
      var n = new i.OutPt();
      return n.Pt.X = t.Pt.X, n.Pt.Y = t.Pt.Y, n.Idx = t.Idx, e ? (n.Next = t.Next, n.Prev = t, t.Next.Prev = n, t.Next = n) : (n.Prev = t.Prev, n.Next = t, t.Prev.Next = n, t.Prev = n), n;
    }, i.Clipper.prototype.GetOverlap = function (t, e, n, i, r) {
      return t < e ? n < i ? (r.Left = Math.max(t, n), r.Right = Math.min(e, i)) : (r.Left = Math.max(t, i), r.Right = Math.min(e, n)) : n < i ? (r.Left = Math.max(e, n), r.Right = Math.min(t, i)) : (r.Left = Math.max(e, i), r.Right = Math.min(t, n)), r.Left < r.Right;
    }, i.Clipper.prototype.JoinHorz = function (t, e, n, r, o, s) {
      var a = t.Pt.X > e.Pt.X ? i.Direction.dRightToLeft : i.Direction.dLeftToRight,
        l = n.Pt.X > r.Pt.X ? i.Direction.dRightToLeft : i.Direction.dLeftToRight;
      if (a == l) return !1;
      if (a == i.Direction.dLeftToRight) {
        for (; t.Next.Pt.X <= o.X && t.Next.Pt.X >= t.Pt.X && t.Next.Pt.Y == o.Y;) t = t.Next;
        s && t.Pt.X != o.X && (t = t.Next), e = this.DupOutPt(t, !s), i.IntPoint.op_Inequality(e.Pt, o) && ((t = e).Pt.X = o.X, t.Pt.Y = o.Y, e = this.DupOutPt(t, !s));
      } else {
        for (; t.Next.Pt.X >= o.X && t.Next.Pt.X <= t.Pt.X && t.Next.Pt.Y == o.Y;) t = t.Next;
        !s && t.Pt.X != o.X && (t = t.Next), e = this.DupOutPt(t, s), i.IntPoint.op_Inequality(e.Pt, o) && ((t = e).Pt.X = o.X, t.Pt.Y = o.Y, e = this.DupOutPt(t, s));
      }
      if (l == i.Direction.dLeftToRight) {
        for (; n.Next.Pt.X <= o.X && n.Next.Pt.X >= n.Pt.X && n.Next.Pt.Y == o.Y;) n = n.Next;
        s && n.Pt.X != o.X && (n = n.Next), r = this.DupOutPt(n, !s), i.IntPoint.op_Inequality(r.Pt, o) && ((n = r).Pt.X = o.X, n.Pt.Y = o.Y, r = this.DupOutPt(n, !s));
      } else {
        for (; n.Next.Pt.X >= o.X && n.Next.Pt.X <= n.Pt.X && n.Next.Pt.Y == o.Y;) n = n.Next;
        !s && n.Pt.X != o.X && (n = n.Next), r = this.DupOutPt(n, s), i.IntPoint.op_Inequality(r.Pt, o) && ((n = r).Pt.X = o.X, n.Pt.Y = o.Y, r = this.DupOutPt(n, s));
      }
      return a == i.Direction.dLeftToRight == s ? (t.Prev = n, n.Next = t, e.Next = r, r.Prev = e) : (t.Next = n, n.Prev = t, e.Prev = r, r.Next = e), !0;
    }, i.Clipper.prototype.JoinPoints = function (t, e, n) {
      var r = t.OutPt1,
        o = new i.OutPt(),
        s = t.OutPt2,
        a = new i.OutPt(),
        l = t.OutPt1.Pt.Y == t.OffPt.Y;
      if (l && i.IntPoint.op_Equality(t.OffPt, t.OutPt1.Pt) && i.IntPoint.op_Equality(t.OffPt, t.OutPt2.Pt)) {
        for (o = t.OutPt1.Next; o != r && i.IntPoint.op_Equality(o.Pt, t.OffPt);) o = o.Next;
        var u = o.Pt.Y > t.OffPt.Y;
        for (a = t.OutPt2.Next; a != s && i.IntPoint.op_Equality(a.Pt, t.OffPt);) a = a.Next;
        return u != a.Pt.Y > t.OffPt.Y && (u ? (o = this.DupOutPt(r, !1), a = this.DupOutPt(s, !0), r.Prev = s, s.Next = r, o.Next = a, a.Prev = o, t.OutPt1 = r, t.OutPt2 = o, !0) : (o = this.DupOutPt(r, !0), a = this.DupOutPt(s, !1), r.Next = s, s.Prev = r, o.Prev = a, a.Next = o, t.OutPt1 = r, t.OutPt2 = o, !0));
      }
      if (l) {
        for (o = r; r.Prev.Pt.Y == r.Pt.Y && r.Prev != o && r.Prev != s;) r = r.Prev;
        for (; o.Next.Pt.Y == o.Pt.Y && o.Next != r && o.Next != s;) o = o.Next;
        if (o.Next == r || o.Next == s) return !1;
        for (a = s; s.Prev.Pt.Y == s.Pt.Y && s.Prev != a && s.Prev != o;) s = s.Prev;
        for (; a.Next.Pt.Y == a.Pt.Y && a.Next != s && a.Next != r;) a = a.Next;
        if (a.Next == s || a.Next == r) return !1;
        var h = {
          Left: null,
          Right: null
        };
        if (!this.GetOverlap(r.Pt.X, o.Pt.X, s.Pt.X, a.Pt.X, h)) return !1;
        var c,
          p = h.Left,
          d = h.Right,
          f = new i.IntPoint();
        return r.Pt.X >= p && r.Pt.X <= d ? (f.X = r.Pt.X, f.Y = r.Pt.Y, c = r.Pt.X > o.Pt.X) : s.Pt.X >= p && s.Pt.X <= d ? (f.X = s.Pt.X, f.Y = s.Pt.Y, c = s.Pt.X > a.Pt.X) : o.Pt.X >= p && o.Pt.X <= d ? (f.X = o.Pt.X, f.Y = o.Pt.Y, c = o.Pt.X > r.Pt.X) : (f.X = a.Pt.X, f.Y = a.Pt.Y, c = a.Pt.X > s.Pt.X), t.OutPt1 = r, t.OutPt2 = s, this.JoinHorz(r, o, s, a, f, c);
      }
      for (o = r.Next; i.IntPoint.op_Equality(o.Pt, r.Pt) && o != r;) o = o.Next;
      var m = o.Pt.Y > r.Pt.Y || !i.ClipperBase.SlopesEqual(r.Pt, o.Pt, t.OffPt, this.m_UseFullRange);
      if (m) {
        for (o = r.Prev; i.IntPoint.op_Equality(o.Pt, r.Pt) && o != r;) o = o.Prev;
        if (o.Pt.Y > r.Pt.Y || !i.ClipperBase.SlopesEqual(r.Pt, o.Pt, t.OffPt, this.m_UseFullRange)) return !1;
      }
      for (a = s.Next; i.IntPoint.op_Equality(a.Pt, s.Pt) && a != s;) a = a.Next;
      var g = a.Pt.Y > s.Pt.Y || !i.ClipperBase.SlopesEqual(s.Pt, a.Pt, t.OffPt, this.m_UseFullRange);
      if (g) {
        for (a = s.Prev; i.IntPoint.op_Equality(a.Pt, s.Pt) && a != s;) a = a.Prev;
        if (a.Pt.Y > s.Pt.Y || !i.ClipperBase.SlopesEqual(s.Pt, a.Pt, t.OffPt, this.m_UseFullRange)) return !1;
      }
      return o != r && a != s && o != a && (e != n || m != g) && (m ? (o = this.DupOutPt(r, !1), a = this.DupOutPt(s, !0), r.Prev = s, s.Next = r, o.Next = a, a.Prev = o, t.OutPt1 = r, t.OutPt2 = o, !0) : (o = this.DupOutPt(r, !0), a = this.DupOutPt(s, !1), r.Next = s, s.Prev = r, o.Prev = a, a.Next = o, t.OutPt1 = r, t.OutPt2 = o, !0));
    }, i.Clipper.GetBounds = function (t) {
      for (var e = 0, n = t.length; e < n && 0 == t[e].length;) e++;
      if (e == n) return new i.IntRect(0, 0, 0, 0);
      var r = new i.IntRect();
      for (r.left = t[e][0].X, r.right = r.left, r.top = t[e][0].Y, r.bottom = r.top; e < n; e++) for (var o = 0, s = t[e].length; o < s; o++) t[e][o].X < r.left ? r.left = t[e][o].X : t[e][o].X > r.right && (r.right = t[e][o].X), t[e][o].Y < r.top ? r.top = t[e][o].Y : t[e][o].Y > r.bottom && (r.bottom = t[e][o].Y);
      return r;
    }, i.Clipper.prototype.GetBounds2 = function (t) {
      var e = t,
        n = new i.IntRect();
      for (n.left = t.Pt.X, n.right = t.Pt.X, n.top = t.Pt.Y, n.bottom = t.Pt.Y, t = t.Next; t != e;) t.Pt.X < n.left && (n.left = t.Pt.X), t.Pt.X > n.right && (n.right = t.Pt.X), t.Pt.Y < n.top && (n.top = t.Pt.Y), t.Pt.Y > n.bottom && (n.bottom = t.Pt.Y), t = t.Next;
      return n;
    }, i.Clipper.PointInPolygon = function (t, e) {
      var n = 0,
        i = e.length;
      if (i < 3) return 0;
      for (var r = e[0], o = 1; o <= i; ++o) {
        var s = o == i ? e[0] : e[o];
        if (s.Y == t.Y && (s.X == t.X || r.Y == t.Y && s.X > t.X == r.X < t.X)) return -1;
        if (r.Y < t.Y != s.Y < t.Y) if (r.X >= t.X) {
          if (s.X > t.X) n = 1 - n;else {
            if (0 == (a = (r.X - t.X) * (s.Y - t.Y) - (s.X - t.X) * (r.Y - t.Y))) return -1;
            a > 0 == s.Y > r.Y && (n = 1 - n);
          }
        } else if (s.X > t.X) {
          var a;
          if (0 == (a = (r.X - t.X) * (s.Y - t.Y) - (s.X - t.X) * (r.Y - t.Y))) return -1;
          a > 0 == s.Y > r.Y && (n = 1 - n);
        }
        r = s;
      }
      return n;
    }, i.Clipper.prototype.PointInPolygon = function (t, e) {
      for (var n = 0, i = e;;) {
        var r = e.Pt.X,
          o = e.Pt.Y,
          s = e.Next.Pt.X,
          a = e.Next.Pt.Y;
        if (a == t.Y && (s == t.X || o == t.Y && s > t.X == r < t.X)) return -1;
        if (o < t.Y != a < t.Y) if (r >= t.X) {
          if (s > t.X) n = 1 - n;else {
            if (0 == (l = (r - t.X) * (a - t.Y) - (s - t.X) * (o - t.Y))) return -1;
            l > 0 == a > o && (n = 1 - n);
          }
        } else if (s > t.X) {
          var l;
          if (0 == (l = (r - t.X) * (a - t.Y) - (s - t.X) * (o - t.Y))) return -1;
          l > 0 == a > o && (n = 1 - n);
        }
        if (i == (e = e.Next)) break;
      }
      return n;
    }, i.Clipper.prototype.Poly2ContainsPoly1 = function (t, e) {
      var n = t;
      do {
        var i = this.PointInPolygon(n.Pt, e);
        if (i >= 0) return 0 != i;
        n = n.Next;
      } while (n != t);
      return !0;
    }, i.Clipper.prototype.FixupFirstLefts1 = function (t, e) {
      for (var n = 0, i = this.m_PolyOuts.length; n < i; n++) {
        var r = this.m_PolyOuts[n];
        null !== r.Pts && r.FirstLeft == t && this.Poly2ContainsPoly1(r.Pts, e.Pts) && (r.FirstLeft = e);
      }
    }, i.Clipper.prototype.FixupFirstLefts2 = function (t, e) {
      for (var n = 0, i = this.m_PolyOuts, r = i.length, o = i[n]; n < r; o = i[++n]) o.FirstLeft == t && (o.FirstLeft = e);
    }, i.Clipper.ParseFirstLeft = function (t) {
      for (; null != t && null == t.Pts;) t = t.FirstLeft;
      return t;
    }, i.Clipper.prototype.JoinCommonEdges = function () {
      for (var t = 0, e = this.m_Joins.length; t < e; t++) {
        var n,
          r = this.m_Joins[t],
          o = this.GetOutRec(r.OutPt1.Idx),
          s = this.GetOutRec(r.OutPt2.Idx);
        if (null != o.Pts && null != s.Pts) if (n = o == s ? o : this.Param1RightOfParam2(o, s) ? s : this.Param1RightOfParam2(s, o) ? o : this.GetLowermostRec(o, s), this.JoinPoints(r, o, s)) if (o == s) {
          if (o.Pts = r.OutPt1, o.BottomPt = null, (s = this.CreateOutRec()).Pts = r.OutPt2, this.UpdateOutPtIdxs(s), this.m_UsingPolyTree) for (var a = 0, l = this.m_PolyOuts.length; a < l - 1; a++) {
            var u = this.m_PolyOuts[a];
            null == u.Pts || i.Clipper.ParseFirstLeft(u.FirstLeft) != o || u.IsHole == o.IsHole || this.Poly2ContainsPoly1(u.Pts, r.OutPt2) && (u.FirstLeft = s);
          }
          this.Poly2ContainsPoly1(s.Pts, o.Pts) ? (s.IsHole = !o.IsHole, s.FirstLeft = o, this.m_UsingPolyTree && this.FixupFirstLefts2(s, o), (s.IsHole ^ this.ReverseSolution) == this.Area(s) > 0 && this.ReversePolyPtLinks(s.Pts)) : this.Poly2ContainsPoly1(o.Pts, s.Pts) ? (s.IsHole = o.IsHole, o.IsHole = !s.IsHole, s.FirstLeft = o.FirstLeft, o.FirstLeft = s, this.m_UsingPolyTree && this.FixupFirstLefts2(o, s), (o.IsHole ^ this.ReverseSolution) == this.Area(o) > 0 && this.ReversePolyPtLinks(o.Pts)) : (s.IsHole = o.IsHole, s.FirstLeft = o.FirstLeft, this.m_UsingPolyTree && this.FixupFirstLefts1(o, s));
        } else s.Pts = null, s.BottomPt = null, s.Idx = o.Idx, o.IsHole = n.IsHole, n == s && (o.FirstLeft = s.FirstLeft), s.FirstLeft = o, this.m_UsingPolyTree && this.FixupFirstLefts2(s, o);
      }
    }, i.Clipper.prototype.UpdateOutPtIdxs = function (t) {
      var e = t.Pts;
      do {
        e.Idx = t.Idx, e = e.Prev;
      } while (e != t.Pts);
    }, i.Clipper.prototype.DoSimplePolygons = function () {
      for (var t = 0; t < this.m_PolyOuts.length;) {
        var e = this.m_PolyOuts[t++],
          n = e.Pts;
        if (null !== n) do {
          for (var r = n.Next; r != e.Pts;) {
            if (i.IntPoint.op_Equality(n.Pt, r.Pt) && r.Next != n && r.Prev != n) {
              var o = n.Prev,
                s = r.Prev;
              n.Prev = s, s.Next = n, r.Prev = o, o.Next = r, e.Pts = n;
              var a = this.CreateOutRec();
              a.Pts = r, this.UpdateOutPtIdxs(a), this.Poly2ContainsPoly1(a.Pts, e.Pts) ? (a.IsHole = !e.IsHole, a.FirstLeft = e) : this.Poly2ContainsPoly1(e.Pts, a.Pts) ? (a.IsHole = e.IsHole, e.IsHole = !a.IsHole, a.FirstLeft = e.FirstLeft, e.FirstLeft = a) : (a.IsHole = e.IsHole, a.FirstLeft = e.FirstLeft), r = n;
            }
            r = r.Next;
          }
          n = n.Next;
        } while (n != e.Pts);
      }
    }, i.Clipper.Area = function (t) {
      var e = t.length;
      if (e < 3) return 0;
      for (var n = 0, i = 0, r = e - 1; i < e; ++i) n += (t[r].X + t[i].X) * (t[r].Y - t[i].Y), r = i;
      return .5 * -n;
    }, i.Clipper.prototype.Area = function (t) {
      var e = t.Pts;
      if (null == e) return 0;
      var n = 0;
      do {
        n += (e.Prev.Pt.X + e.Pt.X) * (e.Prev.Pt.Y - e.Pt.Y), e = e.Next;
      } while (e != t.Pts);
      return .5 * n;
    }, i.Clipper.SimplifyPolygon = function (t, e) {
      var n = new Array(),
        r = new i.Clipper(0);
      return r.StrictlySimple = !0, r.AddPath(t, i.PolyType.ptSubject, !0), r.Execute(i.ClipType.ctUnion, n, e, e), n;
    }, i.Clipper.SimplifyPolygons = function (t, e) {
      void 0 === e && (e = i.PolyFillType.pftEvenOdd);
      var n = new Array(),
        r = new i.Clipper(0);
      return r.StrictlySimple = !0, r.AddPaths(t, i.PolyType.ptSubject, !0), r.Execute(i.ClipType.ctUnion, n, e, e), n;
    }, i.Clipper.DistanceSqrd = function (t, e) {
      var n = t.X - e.X,
        i = t.Y - e.Y;
      return n * n + i * i;
    }, i.Clipper.DistanceFromLineSqrd = function (t, e, n) {
      var i = e.Y - n.Y,
        r = n.X - e.X,
        o = i * e.X + r * e.Y;
      return (o = i * t.X + r * t.Y - o) * o / (i * i + r * r);
    }, i.Clipper.SlopesNearCollinear = function (t, e, n, r) {
      return i.Clipper.DistanceFromLineSqrd(e, t, n) < r;
    }, i.Clipper.PointsAreClose = function (t, e, n) {
      var i = t.X - e.X,
        r = t.Y - e.Y;
      return i * i + r * r <= n;
    }, i.Clipper.ExcludeOp = function (t) {
      var e = t.Prev;
      return e.Next = t.Next, t.Next.Prev = e, e.Idx = 0, e;
    }, i.Clipper.CleanPolygon = function (t, e) {
      void 0 === e && (e = 1.415);
      var n = t.length;
      if (0 == n) return new Array();
      for (var r = new Array(n), o = 0; o < n; ++o) r[o] = new i.OutPt();
      for (o = 0; o < n; ++o) r[o].Pt = t[o], r[o].Next = r[(o + 1) % n], r[o].Next.Prev = r[o], r[o].Idx = 0;
      for (var s = e * e, a = r[0]; 0 == a.Idx && a.Next != a.Prev;) i.Clipper.PointsAreClose(a.Pt, a.Prev.Pt, s) ? (a = i.Clipper.ExcludeOp(a), n--) : i.Clipper.PointsAreClose(a.Prev.Pt, a.Next.Pt, s) ? (i.Clipper.ExcludeOp(a.Next), a = i.Clipper.ExcludeOp(a), n -= 2) : i.Clipper.SlopesNearCollinear(a.Prev.Pt, a.Pt, a.Next.Pt, s) ? (a = i.Clipper.ExcludeOp(a), n--) : (a.Idx = 1, a = a.Next);
      n < 3 && (n = 0);
      var l = new Array(n);
      for (o = 0; o < n; ++o) l[o] = new i.IntPoint(a.Pt), a = a.Next;
      return r = null, l;
    }, i.Clipper.CleanPolygons = function (t, e) {
      for (var n = new Array(t.length), r = 0, o = t.length; r < o; r++) n[r] = i.Clipper.CleanPolygon(t[r], e);
      return n;
    }, i.Clipper.Minkowski = function (t, e, n, r) {
      var o = r ? 1 : 0,
        s = t.length,
        a = e.length,
        l = new Array();
      if (n) for (var u = 0; u < a; u++) {
        for (var h = new Array(s), c = 0, p = t.length, d = t[c]; c < p; d = t[++c]) h[c] = new i.IntPoint(e[u].X + d.X, e[u].Y + d.Y);
        l.push(h);
      } else for (u = 0; u < a; u++) {
        for (h = new Array(s), c = 0, p = t.length, d = t[c]; c < p; d = t[++c]) h[c] = new i.IntPoint(e[u].X - d.X, e[u].Y - d.Y);
        l.push(h);
      }
      var f = new Array();
      for (u = 0; u < a - 1 + o; u++) for (c = 0; c < s; c++) {
        var m = new Array();
        m.push(l[u % a][c % s]), m.push(l[(u + 1) % a][c % s]), m.push(l[(u + 1) % a][(c + 1) % s]), m.push(l[u % a][(c + 1) % s]), i.Clipper.Orientation(m) || m.reverse(), f.push(m);
      }
      var g = new i.Clipper(0);
      return g.AddPaths(f, i.PolyType.ptSubject, !0), g.Execute(i.ClipType.ctUnion, l, i.PolyFillType.pftNonZero, i.PolyFillType.pftNonZero), l;
    }, i.Clipper.MinkowskiSum = function () {
      var t = arguments,
        e = t.length;
      if (3 == e) {
        var n = t[0],
          r = t[1],
          o = t[2];
        return i.Clipper.Minkowski(n, r, !0, o);
      }
      if (4 == e) {
        n = t[0];
        for (var s = t[1], a = t[2], l = (o = t[3], new i.Clipper()), u = 0, h = s.length; u < h; ++u) {
          var c = i.Clipper.Minkowski(n, s[u], !0, o);
          l.AddPaths(c, i.PolyType.ptSubject, !0);
        }
        o && l.AddPaths(s, i.PolyType.ptClip, !0);
        var p = new i.Paths();
        return l.Execute(i.ClipType.ctUnion, p, a, a), p;
      }
    }, i.Clipper.MinkowskiDiff = function (t, e, n) {
      return i.Clipper.Minkowski(t, e, !1, n);
    }, i.Clipper.PolyTreeToPaths = function (t) {
      var e = new Array();
      return i.Clipper.AddPolyNodeToPaths(t, i.Clipper.NodeType.ntAny, e), e;
    }, i.Clipper.AddPolyNodeToPaths = function (t, e, n) {
      var r = !0;
      switch (e) {
        case i.Clipper.NodeType.ntOpen:
          return;
        case i.Clipper.NodeType.ntClosed:
          r = !t.IsOpen;
      }
      t.m_polygon.length > 0 && r && n.push(t.m_polygon);
      for (var o = 0, s = t.Childs(), a = s.length, l = s[o]; o < a; l = s[++o]) i.Clipper.AddPolyNodeToPaths(l, e, n);
    }, i.Clipper.OpenPathsFromPolyTree = function (t) {
      for (var e = new i.Paths(), n = 0, r = t.ChildCount(); n < r; n++) t.Childs()[n].IsOpen && e.push(t.Childs()[n].m_polygon);
      return e;
    }, i.Clipper.ClosedPathsFromPolyTree = function (t) {
      var e = new i.Paths();
      return i.Clipper.AddPolyNodeToPaths(t, i.Clipper.NodeType.ntClosed, e), e;
    }, de(i.Clipper, i.ClipperBase), i.Clipper.NodeType = {
      ntAny: 0,
      ntOpen: 1,
      ntClosed: 2
    }, i.ClipperOffset = function (t, e) {
      void 0 === t && (t = 2), void 0 === e && (e = i.ClipperOffset.def_arc_tolerance), this.m_destPolys = new i.Paths(), this.m_srcPoly = new i.Path(), this.m_destPoly = new i.Path(), this.m_normals = new Array(), this.m_delta = 0, this.m_sinA = 0, this.m_sin = 0, this.m_cos = 0, this.m_miterLim = 0, this.m_StepsPerRad = 0, this.m_lowest = new i.IntPoint(), this.m_polyNodes = new i.PolyNode(), this.MiterLimit = t, this.ArcTolerance = e, this.m_lowest.X = -1;
    }, i.ClipperOffset.two_pi = 6.28318530717959, i.ClipperOffset.def_arc_tolerance = .25, i.ClipperOffset.prototype.Clear = function () {
      i.Clear(this.m_polyNodes.Childs()), this.m_lowest.X = -1;
    }, i.ClipperOffset.Round = i.Clipper.Round, i.ClipperOffset.prototype.AddPath = function (t, e, n) {
      var r = t.length - 1;
      if (!(r < 0)) {
        var o = new i.PolyNode();
        if (o.m_jointype = e, o.m_endtype = n, n == i.EndType.etClosedLine || n == i.EndType.etClosedPolygon) for (; r > 0 && i.IntPoint.op_Equality(t[0], t[r]);) r--;
        o.m_polygon.push(t[0]);
        for (var s = 0, a = 0, l = 1; l <= r; l++) i.IntPoint.op_Inequality(o.m_polygon[s], t[l]) && (s++, o.m_polygon.push(t[l]), (t[l].Y > o.m_polygon[a].Y || t[l].Y == o.m_polygon[a].Y && t[l].X < o.m_polygon[a].X) && (a = s));
        if (!(n == i.EndType.etClosedPolygon && s < 2 || n != i.EndType.etClosedPolygon && s < 0) && (this.m_polyNodes.AddChild(o), n == i.EndType.etClosedPolygon)) if (this.m_lowest.X < 0) this.m_lowest = new i.IntPoint(0, a);else {
          var u = this.m_polyNodes.Childs()[this.m_lowest.X].m_polygon[this.m_lowest.Y];
          (o.m_polygon[a].Y > u.Y || o.m_polygon[a].Y == u.Y && o.m_polygon[a].X < u.X) && (this.m_lowest = new i.IntPoint(this.m_polyNodes.ChildCount() - 1, a));
        }
      }
    }, i.ClipperOffset.prototype.AddPaths = function (t, e, n) {
      for (var i = 0, r = t.length; i < r; i++) this.AddPath(t[i], e, n);
    }, i.ClipperOffset.prototype.FixOrientations = function () {
      if (this.m_lowest.X >= 0 && !i.Clipper.Orientation(this.m_polyNodes.Childs()[this.m_lowest.X].m_polygon)) for (var t = 0; t < this.m_polyNodes.ChildCount(); t++) {
        ((e = this.m_polyNodes.Childs()[t]).m_endtype == i.EndType.etClosedPolygon || e.m_endtype == i.EndType.etClosedLine && i.Clipper.Orientation(e.m_polygon)) && e.m_polygon.reverse();
      } else for (t = 0; t < this.m_polyNodes.ChildCount(); t++) {
        var e;
        (e = this.m_polyNodes.Childs()[t]).m_endtype == i.EndType.etClosedLine && !i.Clipper.Orientation(e.m_polygon) && e.m_polygon.reverse();
      }
    }, i.ClipperOffset.GetUnitNormal = function (t, e) {
      var n = e.X - t.X,
        r = e.Y - t.Y;
      if (0 == n && 0 == r) return new i.DoublePoint(0, 0);
      var o = 1 / Math.sqrt(n * n + r * r);
      return n *= o, r *= o, new i.DoublePoint(r, -n);
    }, i.ClipperOffset.prototype.DoOffset = function (t) {
      if (this.m_destPolys = new Array(), this.m_delta = t, i.ClipperBase.near_zero(t)) for (var e = 0; e < this.m_polyNodes.ChildCount(); e++) {
        (o = this.m_polyNodes.Childs()[e]).m_endtype == i.EndType.etClosedPolygon && this.m_destPolys.push(o.m_polygon);
      } else {
        var n;
        this.MiterLimit > 2 ? this.m_miterLim = 2 / (this.MiterLimit * this.MiterLimit) : this.m_miterLim = .5, n = this.ArcTolerance <= 0 ? i.ClipperOffset.def_arc_tolerance : this.ArcTolerance > Math.abs(t) * i.ClipperOffset.def_arc_tolerance ? Math.abs(t) * i.ClipperOffset.def_arc_tolerance : this.ArcTolerance;
        var r = 3.14159265358979 / Math.acos(1 - n / Math.abs(t));
        this.m_sin = Math.sin(i.ClipperOffset.two_pi / r), this.m_cos = Math.cos(i.ClipperOffset.two_pi / r), this.m_StepsPerRad = r / i.ClipperOffset.two_pi, t < 0 && (this.m_sin = -this.m_sin);
        for (e = 0; e < this.m_polyNodes.ChildCount(); e++) {
          var o = this.m_polyNodes.Childs()[e];
          this.m_srcPoly = o.m_polygon;
          var s = this.m_srcPoly.length;
          if (!(0 == s || t <= 0 && (s < 3 || o.m_endtype != i.EndType.etClosedPolygon))) {
            if (this.m_destPoly = new Array(), 1 == s) {
              if (o.m_jointype == i.JoinType.jtRound) for (var a = 1, l = 0, u = 1; u <= r; u++) {
                this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[0].X + a * t), i.ClipperOffset.Round(this.m_srcPoly[0].Y + l * t)));
                var h = a;
                a = a * this.m_cos - this.m_sin * l, l = h * this.m_sin + l * this.m_cos;
              } else for (a = -1, l = -1, u = 0; u < 4; ++u) this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[0].X + a * t), i.ClipperOffset.Round(this.m_srcPoly[0].Y + l * t))), a < 0 ? a = 1 : l < 0 ? l = 1 : a = -1;
              this.m_destPolys.push(this.m_destPoly);
              continue;
            }
            this.m_normals.length = 0;
            for (u = 0; u < s - 1; u++) this.m_normals.push(i.ClipperOffset.GetUnitNormal(this.m_srcPoly[u], this.m_srcPoly[u + 1]));
            if (o.m_endtype == i.EndType.etClosedLine || o.m_endtype == i.EndType.etClosedPolygon ? this.m_normals.push(i.ClipperOffset.GetUnitNormal(this.m_srcPoly[s - 1], this.m_srcPoly[0])) : this.m_normals.push(new i.DoublePoint(this.m_normals[s - 2])), o.m_endtype == i.EndType.etClosedPolygon) {
              var c = s - 1;
              for (u = 0; u < s; u++) c = this.OffsetPoint(u, c, o.m_jointype);
              this.m_destPolys.push(this.m_destPoly);
            } else if (o.m_endtype == i.EndType.etClosedLine) {
              for (c = s - 1, u = 0; u < s; u++) c = this.OffsetPoint(u, c, o.m_jointype);
              this.m_destPolys.push(this.m_destPoly), this.m_destPoly = new Array();
              var p = this.m_normals[s - 1];
              for (u = s - 1; u > 0; u--) this.m_normals[u] = new i.DoublePoint(-this.m_normals[u - 1].X, -this.m_normals[u - 1].Y);
              this.m_normals[0] = new i.DoublePoint(-p.X, -p.Y), c = 0;
              for (u = s - 1; u >= 0; u--) c = this.OffsetPoint(u, c, o.m_jointype);
              this.m_destPolys.push(this.m_destPoly);
            } else {
              for (c = 0, u = 1; u < s - 1; ++u) c = this.OffsetPoint(u, c, o.m_jointype);
              var d;
              if (o.m_endtype == i.EndType.etOpenButt) {
                u = s - 1;
                d = new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[u].X + this.m_normals[u].X * t), i.ClipperOffset.Round(this.m_srcPoly[u].Y + this.m_normals[u].Y * t)), this.m_destPoly.push(d), d = new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[u].X - this.m_normals[u].X * t), i.ClipperOffset.Round(this.m_srcPoly[u].Y - this.m_normals[u].Y * t)), this.m_destPoly.push(d);
              } else {
                u = s - 1;
                c = s - 2, this.m_sinA = 0, this.m_normals[u] = new i.DoublePoint(-this.m_normals[u].X, -this.m_normals[u].Y), o.m_endtype == i.EndType.etOpenSquare ? this.DoSquare(u, c) : this.DoRound(u, c);
              }
              for (u = s - 1; u > 0; u--) this.m_normals[u] = new i.DoublePoint(-this.m_normals[u - 1].X, -this.m_normals[u - 1].Y);
              this.m_normals[0] = new i.DoublePoint(-this.m_normals[1].X, -this.m_normals[1].Y);
              for (u = (c = s - 1) - 1; u > 0; --u) c = this.OffsetPoint(u, c, o.m_jointype);
              o.m_endtype == i.EndType.etOpenButt ? (d = new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[0].X - this.m_normals[0].X * t), i.ClipperOffset.Round(this.m_srcPoly[0].Y - this.m_normals[0].Y * t)), this.m_destPoly.push(d), d = new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[0].X + this.m_normals[0].X * t), i.ClipperOffset.Round(this.m_srcPoly[0].Y + this.m_normals[0].Y * t)), this.m_destPoly.push(d)) : (c = 1, this.m_sinA = 0, o.m_endtype == i.EndType.etOpenSquare ? this.DoSquare(0, 1) : this.DoRound(0, 1)), this.m_destPolys.push(this.m_destPoly);
            }
          }
        }
      }
    }, i.ClipperOffset.prototype.Execute = function () {
      var t = arguments,
        e = t[0] instanceof i.PolyTree;
      if (e) {
        var n = t[0],
          r = t[1];
        if (n.Clear(), this.FixOrientations(), this.DoOffset(r), (l = new i.Clipper(0)).AddPaths(this.m_destPolys, i.PolyType.ptSubject, !0), r > 0) l.Execute(i.ClipType.ctUnion, n, i.PolyFillType.pftPositive, i.PolyFillType.pftPositive);else {
          var o = i.Clipper.GetBounds(this.m_destPolys);
          if ((u = new i.Path()).push(new i.IntPoint(o.left - 10, o.bottom + 10)), u.push(new i.IntPoint(o.right + 10, o.bottom + 10)), u.push(new i.IntPoint(o.right + 10, o.top - 10)), u.push(new i.IntPoint(o.left - 10, o.top - 10)), l.AddPath(u, i.PolyType.ptSubject, !0), l.ReverseSolution = !0, l.Execute(i.ClipType.ctUnion, n, i.PolyFillType.pftNegative, i.PolyFillType.pftNegative), 1 == n.ChildCount() && n.Childs()[0].ChildCount() > 0) {
            var s = n.Childs()[0];
            n.Childs()[0] = s.Childs()[0];
            for (var a = 1; a < s.ChildCount(); a++) n.AddChild(s.Childs()[a]);
          } else n.Clear();
        }
      } else {
        var l;
        n = t[0], r = t[1];
        if (i.Clear(n), this.FixOrientations(), this.DoOffset(r), (l = new i.Clipper(0)).AddPaths(this.m_destPolys, i.PolyType.ptSubject, !0), r > 0) l.Execute(i.ClipType.ctUnion, n, i.PolyFillType.pftPositive, i.PolyFillType.pftPositive);else {
          var u;
          o = i.Clipper.GetBounds(this.m_destPolys);
          (u = new i.Path()).push(new i.IntPoint(o.left - 10, o.bottom + 10)), u.push(new i.IntPoint(o.right + 10, o.bottom + 10)), u.push(new i.IntPoint(o.right + 10, o.top - 10)), u.push(new i.IntPoint(o.left - 10, o.top - 10)), l.AddPath(u, i.PolyType.ptSubject, !0), l.ReverseSolution = !0, l.Execute(i.ClipType.ctUnion, n, i.PolyFillType.pftNegative, i.PolyFillType.pftNegative), n.length > 0 && n.splice(0, 1);
        }
      }
    }, i.ClipperOffset.prototype.OffsetPoint = function (t, e, n) {
      if (this.m_sinA = this.m_normals[e].X * this.m_normals[t].Y - this.m_normals[t].X * this.m_normals[e].Y, this.m_sinA < 5e-5 && this.m_sinA > -5e-5) return e;
      if (this.m_sinA > 1 ? this.m_sinA = 1 : this.m_sinA < -1 && (this.m_sinA = -1), this.m_sinA * this.m_delta < 0) this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[t].X + this.m_normals[e].X * this.m_delta), i.ClipperOffset.Round(this.m_srcPoly[t].Y + this.m_normals[e].Y * this.m_delta))), this.m_destPoly.push(new i.IntPoint(this.m_srcPoly[t])), this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[t].X + this.m_normals[t].X * this.m_delta), i.ClipperOffset.Round(this.m_srcPoly[t].Y + this.m_normals[t].Y * this.m_delta)));else switch (n) {
        case i.JoinType.jtMiter:
          var r = this.m_normals[t].X * this.m_normals[e].X + this.m_normals[t].Y * this.m_normals[e].Y + 1;
          r >= this.m_miterLim ? this.DoMiter(t, e, r) : this.DoSquare(t, e);
          break;
        case i.JoinType.jtSquare:
          this.DoSquare(t, e);
          break;
        case i.JoinType.jtRound:
          this.DoRound(t, e);
      }
      return e = t;
    }, i.ClipperOffset.prototype.DoSquare = function (t, e) {
      var n = Math.tan(Math.atan2(this.m_sinA, this.m_normals[e].X * this.m_normals[t].X + this.m_normals[e].Y * this.m_normals[t].Y) / 4);
      this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[t].X + this.m_delta * (this.m_normals[e].X - this.m_normals[e].Y * n)), i.ClipperOffset.Round(this.m_srcPoly[t].Y + this.m_delta * (this.m_normals[e].Y + this.m_normals[e].X * n)))), this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[t].X + this.m_delta * (this.m_normals[t].X + this.m_normals[t].Y * n)), i.ClipperOffset.Round(this.m_srcPoly[t].Y + this.m_delta * (this.m_normals[t].Y - this.m_normals[t].X * n))));
    }, i.ClipperOffset.prototype.DoMiter = function (t, e, n) {
      var r = this.m_delta / n;
      this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[t].X + (this.m_normals[e].X + this.m_normals[t].X) * r), i.ClipperOffset.Round(this.m_srcPoly[t].Y + (this.m_normals[e].Y + this.m_normals[t].Y) * r)));
    }, i.ClipperOffset.prototype.DoRound = function (t, e) {
      for (var n, r = Math.atan2(this.m_sinA, this.m_normals[e].X * this.m_normals[t].X + this.m_normals[e].Y * this.m_normals[t].Y), o = i.Cast_Int32(i.ClipperOffset.Round(this.m_StepsPerRad * Math.abs(r))), s = this.m_normals[e].X, a = this.m_normals[e].Y, l = 0; l < o; ++l) this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[t].X + s * this.m_delta), i.ClipperOffset.Round(this.m_srcPoly[t].Y + a * this.m_delta))), n = s, s = s * this.m_cos - this.m_sin * a, a = n * this.m_sin + a * this.m_cos;
      this.m_destPoly.push(new i.IntPoint(i.ClipperOffset.Round(this.m_srcPoly[t].X + this.m_normals[t].X * this.m_delta), i.ClipperOffset.Round(this.m_srcPoly[t].Y + this.m_normals[t].Y * this.m_delta)));
    }, i.Error = function (t) {
      try {
        throw new Error(t);
      } catch (t) {
        alert(t.message);
      }
    }, i.JS = {}, i.JS.AreaOfPolygon = function (t, e) {
      return e || (e = 1), i.Clipper.Area(t) / (e * e);
    }, i.JS.AreaOfPolygons = function (t, e) {
      e || (e = 1);
      for (var n = 0, r = 0; r < t.length; r++) n += i.Clipper.Area(t[r]);
      return n / (e * e);
    }, i.JS.BoundsOfPath = function (t, e) {
      return i.JS.BoundsOfPaths([t], e);
    }, i.JS.BoundsOfPaths = function (t, e) {
      e || (e = 1);
      var n = i.Clipper.GetBounds(t);
      return n.left /= e, n.bottom /= e, n.right /= e, n.top /= e, n;
    }, i.JS.Clean = function (t, e) {
      if (!(t instanceof Array)) return [];
      var n = t[0] instanceof Array;
      t = i.JS.Clone(t);
      if ("number" != typeof e || null === e) return i.Error("Delta is not a number in Clean()."), t;
      if (0 === t.length || 1 == t.length && 0 === t[0].length || e < 0) return t;
      n || (t = [t]);
      for (var r, o, s, a, l, u, h, c = t.length, p = [], d = 0; d < c; d++) if (0 !== (r = (o = t[d]).length)) {
        if (r < 3) {
          s = o, p.push(s);
          continue;
        }
        for (s = o, a = e * e, l = o[0], u = 1, h = 1; h < r; h++) (o[h].X - l.X) * (o[h].X - l.X) + (o[h].Y - l.Y) * (o[h].Y - l.Y) <= a || (s[u] = o[h], l = o[h], u++);
        l = o[u - 1], (o[0].X - l.X) * (o[0].X - l.X) + (o[0].Y - l.Y) * (o[0].Y - l.Y) <= a && u--, u < r && s.splice(u, r - u), s.length && p.push(s);
      }
      return !n && p.length ? p = p[0] : n || 0 !== p.length ? n && 0 === p.length && (p = [[]]) : p = [], p;
    }, i.JS.Clone = function (t) {
      if (!(t instanceof Array)) return [];
      if (0 === t.length) return [];
      if (1 == t.length && 0 === t[0].length) return [[]];
      var e = t[0] instanceof Array;
      e || (t = [t]);
      var n,
        i,
        r,
        o,
        s = t.length,
        a = new Array(s);
      for (i = 0; i < s; i++) {
        for (n = t[i].length, o = new Array(n), r = 0; r < n; r++) o[r] = {
          X: t[i][r].X,
          Y: t[i][r].Y
        };
        a[i] = o;
      }
      return e || (a = a[0]), a;
    }, i.JS.Lighten = function (t, e) {
      if (!(t instanceof Array)) return [];
      if ("number" != typeof e || null === e) return i.Error("Tolerance is not a number in Lighten()."), i.JS.Clone(t);
      if (0 === t.length || 1 == t.length && 0 === t[0].length || e < 0) return i.JS.Clone(t);
      t[0] instanceof Array || (t = [t]);
      var n,
        r,
        o,
        s,
        a,
        l,
        u,
        h,
        c,
        p,
        d,
        f,
        m,
        g,
        v,
        y,
        _ = t.length,
        x = e * e,
        E = [];
      for (n = 0; n < _; n++) if (0 != (l = (o = t[n]).length)) {
        for (s = 0; s < 1e6; s++) {
          for (a = [], o[(l = o.length) - 1].X != o[0].X || o[l - 1].Y != o[0].Y ? (d = 1, o.push({
            X: o[0].X,
            Y: o[0].Y
          }), l = o.length) : d = 0, p = [], r = 0; r < l - 2; r++) u = o[r], c = o[r + 1], h = o[r + 2], v = u.X, y = u.Y, f = h.X - v, m = h.Y - y, (0 !== f || 0 !== m) && ((g = ((c.X - v) * f + (c.Y - y) * m) / (f * f + m * m)) > 1 ? (v = h.X, y = h.Y) : g > 0 && (v += f * g, y += m * g)), (f = c.X - v) * f + (m = c.Y - y) * m <= x && (p[r + 1] = 1, r++);
          for (a.push({
            X: o[0].X,
            Y: o[0].Y
          }), r = 1; r < l - 1; r++) p[r] || a.push({
            X: o[r].X,
            Y: o[r].Y
          });
          if (a.push({
            X: o[l - 1].X,
            Y: o[l - 1].Y
          }), d && o.pop(), !p.length) break;
          o = a;
        }
        a[(l = a.length) - 1].X == a[0].X && a[l - 1].Y == a[0].Y && a.pop(), a.length > 2 && E.push(a);
      }
      return !t[0] instanceof Array && (E = E[0]), void 0 === E && (E = [[]]), E;
    }, i.JS.PerimeterOfPath = function (t, e, n) {
      if (void 0 === t) return 0;
      var i,
        r,
        o = Math.sqrt,
        s = 0,
        a = 0,
        l = 0,
        u = 0,
        h = 0,
        c = t.length;
      if (c < 2) return 0;
      for (e && (t[c] = t[0], c++); --c;) a = (i = t[c]).X, l = i.Y, s += o((a - (u = (r = t[c - 1]).X)) * (a - u) + (l - (h = r.Y)) * (l - h));
      return e && t.pop(), s / n;
    }, i.JS.PerimeterOfPaths = function (t, e, n) {
      n || (n = 1);
      for (var r = 0, o = 0; o < t.length; o++) r += i.JS.PerimeterOfPath(t[o], e, n);
      return r;
    }, i.JS.ScaleDownPath = function (t, e) {
      var n, i;
      for (e || (e = 1), n = t.length; n--;) (i = t[n]).X = i.X / e, i.Y = i.Y / e;
    }, i.JS.ScaleDownPaths = function (t, e) {
      var n, i, r;
      Math.round;
      for (e || (e = 1), n = t.length; n--;) for (i = t[n].length; i--;) (r = t[n][i]).X = r.X / e, r.Y = r.Y / e;
    }, i.JS.ScaleUpPath = function (t, e) {
      var n,
        i,
        r = Math.round;
      for (e || (e = 1), n = t.length; n--;) (i = t[n]).X = r(i.X * e), i.Y = r(i.Y * e);
    }, i.JS.ScaleUpPaths = function (t, e) {
      var n,
        i,
        r,
        o = Math.round;
      for (e || (e = 1), n = t.length; n--;) for (i = t[n].length; i--;) (r = t[n][i]).X = o(r.X * e), r.Y = o(r.Y * e);
    }, i.ExPolygons = function () {
      return [];
    }, i.ExPolygon = function () {
      this.outer = null, this.holes = null;
    }, i.JS.AddOuterPolyNodeToExPolygons = function (t, e) {
      var n = new i.ExPolygon();
      n.outer = t.Contour();
      var r,
        o,
        s,
        a,
        l,
        u,
        h = t.Childs(),
        c = h.length;
      for (n.holes = new Array(c), s = 0; s < c; s++) for (r = h[s], n.holes[s] = r.Contour(), a = 0, u = (l = r.Childs()).length; a < u; a++) o = l[a], i.JS.AddOuterPolyNodeToExPolygons(o, e);
      e.push(n);
    }, i.JS.ExPolygonsToPaths = function (t) {
      var e,
        n,
        r,
        o,
        s = new i.Paths();
      for (e = 0, r = t.length; e < r; e++) for (s.push(t[e].outer), n = 0, o = t[e].holes.length; n < o; n++) s.push(t[e].holes[n]);
      return s;
    }, i.JS.PolyTreeToExPolygons = function (t) {
      var e,
        n,
        r,
        o,
        s = new i.ExPolygons();
      for (n = 0, o = (r = t.Childs()).length; n < o; n++) e = r[n], i.JS.AddOuterPolyNodeToExPolygons(e, s);
      return s;
    }, e.exports = i;
  }),
  mB = ze((t, e) => {
    E(), function (t) {
      var n = /^\s+/,
        i = /\s+$/,
        r = 0,
        o = t.round,
        s = t.min,
        a = t.max,
        l = t.random;
      function h(t, e) {
        if (e = e || {}, (t = t || "") instanceof h) return t;
        if (!(this instanceof h)) return new h(t, e);
        var n = c(t);
        this._originalInput = t, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = o(100 * this._a) / 100, this._format = e.format || n.format, this._gradientType = e.gradientType, this._r < 1 && (this._r = o(this._r)), this._g < 1 && (this._g = o(this._g)), this._b < 1 && (this._b = o(this._b)), this._ok = n.ok, this._tc_id = r++;
      }
      function c(t) {
        var e = {
            r: 0,
            g: 0,
            b: 0
          },
          n = 1,
          i = null,
          r = null,
          o = null,
          l = !1,
          u = !1;
        return "string" == typeof t && (t = K(t)), "object" == typeof t && (J(t.r) && J(t.g) && J(t.b) ? (e = p(t.r, t.g, t.b), l = !0, u = "%" === String(t.r).substr(-1) ? "prgb" : "rgb") : J(t.h) && J(t.s) && J(t.v) ? (i = j(t.s), r = j(t.v), e = g(t.h, i, r), l = !0, u = "hsv") : J(t.h) && J(t.s) && J(t.l) && (i = j(t.s), o = j(t.l), e = f(t.h, i, o), l = !0, u = "hsl"), t.hasOwnProperty("a") && (n = t.a)), n = D(n), {
          ok: l,
          format: t.format || u,
          r: s(255, a(e.r, 0)),
          g: s(255, a(e.g, 0)),
          b: s(255, a(e.b, 0)),
          a: n
        };
      }
      function p(t, e, n) {
        return {
          r: 255 * k(t, 255),
          g: 255 * k(e, 255),
          b: 255 * k(n, 255)
        };
      }
      function d(t, e, n) {
        t = k(t, 255), e = k(e, 255), n = k(n, 255);
        var i,
          r,
          o = a(t, e, n),
          l = s(t, e, n),
          u = (o + l) / 2;
        if (o == l) i = r = 0;else {
          var h = o - l;
          switch (r = u > .5 ? h / (2 - o - l) : h / (o + l), o) {
            case t:
              i = (e - n) / h + (e < n ? 6 : 0);
              break;
            case e:
              i = (n - t) / h + 2;
              break;
            case n:
              i = (t - e) / h + 4;
          }
          i /= 6;
        }
        return {
          h: i,
          s: r,
          l: u
        };
      }
      function f(t, e, n) {
        var i, r, o;
        function s(t, e, n) {
          return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
        }
        if (t = k(t, 360), e = k(e, 100), n = k(n, 100), u(s, "hue2rgb"), 0 === e) i = r = o = n;else {
          var a = n < .5 ? n * (1 + e) : n + e - n * e,
            l = 2 * n - a;
          i = s(l, a, t + 1 / 3), r = s(l, a, t), o = s(l, a, t - 1 / 3);
        }
        return {
          r: 255 * i,
          g: 255 * r,
          b: 255 * o
        };
      }
      function m(t, e, n) {
        t = k(t, 255), e = k(e, 255), n = k(n, 255);
        var i,
          r,
          o = a(t, e, n),
          l = s(t, e, n),
          u = o,
          h = o - l;
        if (r = 0 === o ? 0 : h / o, o == l) i = 0;else {
          switch (o) {
            case t:
              i = (e - n) / h + (e < n ? 6 : 0);
              break;
            case e:
              i = (n - t) / h + 2;
              break;
            case n:
              i = (t - e) / h + 4;
          }
          i /= 6;
        }
        return {
          h: i,
          s: r,
          v: u
        };
      }
      function g(e, n, i) {
        e = 6 * k(e, 360), n = k(n, 100), i = k(i, 100);
        var r = t.floor(e),
          o = e - r,
          s = i * (1 - n),
          a = i * (1 - o * n),
          l = i * (1 - (1 - o) * n),
          u = r % 6;
        return {
          r: 255 * [i, a, s, s, l, i][u],
          g: 255 * [l, i, i, a, s, s][u],
          b: 255 * [s, s, l, i, i, a][u]
        };
      }
      function v(t, e, n, i) {
        var r = [V(o(t).toString(16)), V(o(e).toString(16)), V(o(n).toString(16))];
        return i && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) : r.join("");
      }
      function y(t, e, n, i, r) {
        var s = [V(o(t).toString(16)), V(o(e).toString(16)), V(o(n).toString(16)), V(G(i))];
        return r && s[0].charAt(0) == s[0].charAt(1) && s[1].charAt(0) == s[1].charAt(1) && s[2].charAt(0) == s[2].charAt(1) && s[3].charAt(0) == s[3].charAt(1) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) + s[3].charAt(0) : s.join("");
      }
      function _(t, e, n, i) {
        return [V(G(i)), V(o(t).toString(16)), V(o(e).toString(16)), V(o(n).toString(16))].join("");
      }
      function x(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = h(t).toHsl();
        return n.s -= e / 100, n.s = F(n.s), h(n);
      }
      function E(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = h(t).toHsl();
        return n.s += e / 100, n.s = F(n.s), h(n);
      }
      function b(t) {
        return h(t).desaturate(100);
      }
      function w(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = h(t).toHsl();
        return n.l += e / 100, n.l = F(n.l), h(n);
      }
      function S(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = h(t).toRgb();
        return n.r = a(0, s(255, n.r - o(-e / 100 * 255))), n.g = a(0, s(255, n.g - o(-e / 100 * 255))), n.b = a(0, s(255, n.b - o(-e / 100 * 255))), h(n);
      }
      function M(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = h(t).toHsl();
        return n.l -= e / 100, n.l = F(n.l), h(n);
      }
      function T(t, e) {
        var n = h(t).toHsl(),
          i = (n.h + e) % 360;
        return n.h = i < 0 ? 360 + i : i, h(n);
      }
      function A(t) {
        var e = h(t).toHsl();
        return e.h = (e.h + 180) % 360, h(e);
      }
      function P(t) {
        var e = h(t).toHsl(),
          n = e.h;
        return [h(t), h({
          h: (n + 120) % 360,
          s: e.s,
          l: e.l
        }), h({
          h: (n + 240) % 360,
          s: e.s,
          l: e.l
        })];
      }
      function C(t) {
        var e = h(t).toHsl(),
          n = e.h;
        return [h(t), h({
          h: (n + 90) % 360,
          s: e.s,
          l: e.l
        }), h({
          h: (n + 180) % 360,
          s: e.s,
          l: e.l
        }), h({
          h: (n + 270) % 360,
          s: e.s,
          l: e.l
        })];
      }
      function I(t) {
        var e = h(t).toHsl(),
          n = e.h;
        return [h(t), h({
          h: (n + 72) % 360,
          s: e.s,
          l: e.l
        }), h({
          h: (n + 216) % 360,
          s: e.s,
          l: e.l
        })];
      }
      function N(t, e, n) {
        e = e || 6, n = n || 30;
        var i = h(t).toHsl(),
          r = 360 / n,
          o = [h(t)];
        for (i.h = (i.h - (r * e >> 1) + 720) % 360; --e;) i.h = (i.h + r) % 360, o.push(h(i));
        return o;
      }
      function L(t, e) {
        e = e || 6;
        for (var n = h(t).toHsv(), i = n.h, r = n.s, o = n.v, s = [], a = 1 / e; e--;) s.push(h({
          h: i,
          s: r,
          v: o
        })), o = (o + a) % 1;
        return s;
      }
      u(h, "tinycolor"), h.prototype = {
        isDark: function () {
          return this.getBrightness() < 128;
        },
        isLight: function () {
          return !this.isDark();
        },
        isValid: function () {
          return this._ok;
        },
        getOriginalInput: function () {
          return this._originalInput;
        },
        getFormat: function () {
          return this._format;
        },
        getAlpha: function () {
          return this._a;
        },
        getBrightness: function () {
          var t = this.toRgb();
          return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3;
        },
        getLuminance: function () {
          var e,
            n,
            i,
            r = this.toRgb();
          return e = r.r / 255, n = r.g / 255, i = r.b / 255, .2126 * (e <= .03928 ? e / 12.92 : t.pow((e + .055) / 1.055, 2.4)) + .7152 * (n <= .03928 ? n / 12.92 : t.pow((n + .055) / 1.055, 2.4)) + .0722 * (i <= .03928 ? i / 12.92 : t.pow((i + .055) / 1.055, 2.4));
        },
        setAlpha: function (t) {
          return this._a = D(t), this._roundA = o(100 * this._a) / 100, this;
        },
        toHsv: function () {
          var t = m(this._r, this._g, this._b);
          return {
            h: 360 * t.h,
            s: t.s,
            v: t.v,
            a: this._a
          };
        },
        toHsvString: function () {
          var t = m(this._r, this._g, this._b),
            e = o(360 * t.h),
            n = o(100 * t.s),
            i = o(100 * t.v);
          return 1 == this._a ? "hsv(" + e + ", " + n + "%, " + i + "%)" : "hsva(" + e + ", " + n + "%, " + i + "%, " + this._roundA + ")";
        },
        toHsl: function () {
          var t = d(this._r, this._g, this._b);
          return {
            h: 360 * t.h,
            s: t.s,
            l: t.l,
            a: this._a
          };
        },
        toHslString: function () {
          var t = d(this._r, this._g, this._b),
            e = o(360 * t.h),
            n = o(100 * t.s),
            i = o(100 * t.l);
          return 1 == this._a ? "hsl(" + e + ", " + n + "%, " + i + "%)" : "hsla(" + e + ", " + n + "%, " + i + "%, " + this._roundA + ")";
        },
        toHex: function (t) {
          return v(this._r, this._g, this._b, t);
        },
        toHexString: function (t) {
          return "#" + this.toHex(t);
        },
        toHex8: function (t) {
          return y(this._r, this._g, this._b, this._a, t);
        },
        toHex8String: function (t) {
          return "#" + this.toHex8(t);
        },
        toRgb: function () {
          return {
            r: o(this._r),
            g: o(this._g),
            b: o(this._b),
            a: this._a
          };
        },
        toRgbString: function () {
          return 1 == this._a ? "rgb(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ")" : "rgba(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function () {
          return {
            r: o(100 * k(this._r, 255)) + "%",
            g: o(100 * k(this._g, 255)) + "%",
            b: o(100 * k(this._b, 255)) + "%",
            a: this._a
          };
        },
        toPercentageRgbString: function () {
          return 1 == this._a ? "rgb(" + o(100 * k(this._r, 255)) + "%, " + o(100 * k(this._g, 255)) + "%, " + o(100 * k(this._b, 255)) + "%)" : "rgba(" + o(100 * k(this._r, 255)) + "%, " + o(100 * k(this._g, 255)) + "%, " + o(100 * k(this._b, 255)) + "%, " + this._roundA + ")";
        },
        toName: function () {
          return 0 === this._a ? "transparent" : !(this._a < 1) && (O[v(this._r, this._g, this._b, !0)] || !1);
        },
        toFilter: function (t) {
          var e = "#" + _(this._r, this._g, this._b, this._a),
            n = e,
            i = this._gradientType ? "GradientType = 1, " : "";
          if (t) {
            var r = h(t);
            n = "#" + _(r._r, r._g, r._b, r._a);
          }
          return "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + e + ",endColorstr=" + n + ")";
        },
        toString: function (t) {
          var e = !!t;
          t = t || this._format;
          var n = !1,
            i = this._a < 1 && this._a >= 0;
          return !e && i && ("hex" === t || "hex6" === t || "hex3" === t || "hex4" === t || "hex8" === t || "name" === t) ? "name" === t && 0 === this._a ? this.toName() : this.toRgbString() : ("rgb" === t && (n = this.toRgbString()), "prgb" === t && (n = this.toPercentageRgbString()), ("hex" === t || "hex6" === t) && (n = this.toHexString()), "hex3" === t && (n = this.toHexString(!0)), "hex4" === t && (n = this.toHex8String(!0)), "hex8" === t && (n = this.toHex8String()), "name" === t && (n = this.toName()), "hsl" === t && (n = this.toHslString()), "hsv" === t && (n = this.toHsvString()), n || this.toHexString());
        },
        clone: function () {
          return h(this.toString());
        },
        _applyModification: function (t, e) {
          var n = t.apply(null, [this].concat([].slice.call(e)));
          return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
        },
        lighten: function () {
          return this._applyModification(w, arguments);
        },
        brighten: function () {
          return this._applyModification(S, arguments);
        },
        darken: function () {
          return this._applyModification(M, arguments);
        },
        desaturate: function () {
          return this._applyModification(x, arguments);
        },
        saturate: function () {
          return this._applyModification(E, arguments);
        },
        greyscale: function () {
          return this._applyModification(b, arguments);
        },
        spin: function () {
          return this._applyModification(T, arguments);
        },
        _applyCombination: function (t, e) {
          return t.apply(null, [this].concat([].slice.call(e)));
        },
        analogous: function () {
          return this._applyCombination(N, arguments);
        },
        complement: function () {
          return this._applyCombination(A, arguments);
        },
        monochromatic: function () {
          return this._applyCombination(L, arguments);
        },
        splitcomplement: function () {
          return this._applyCombination(I, arguments);
        },
        triad: function () {
          return this._applyCombination(P, arguments);
        },
        tetrad: function () {
          return this._applyCombination(C, arguments);
        }
      }, h.fromRatio = function (t, e) {
        if ("object" == typeof t) {
          var n = {};
          for (var i in t) t.hasOwnProperty(i) && (n[i] = "a" === i ? t[i] : j(t[i]));
          t = n;
        }
        return h(t, e);
      }, u(c, "inputToRGB"), u(p, "rgbToRgb"), u(d, "rgbToHsl"), u(f, "hslToRgb"), u(m, "rgbToHsv"), u(g, "hsvToRgb"), u(v, "rgbToHex"), u(y, "rgbaToHex"), u(_, "rgbaToArgbHex"), h.equals = function (t, e) {
        return !(!t || !e) && h(t).toRgbString() == h(e).toRgbString();
      }, h.random = function () {
        return h.fromRatio({
          r: l(),
          g: l(),
          b: l()
        });
      }, u(x, "desaturate"), u(E, "saturate"), u(b, "greyscale"), u(w, "lighten"), u(S, "brighten"), u(M, "darken"), u(T, "spin"), u(A, "complement"), u(P, "triad"), u(C, "tetrad"), u(I, "splitcomplement"), u(N, "analogous"), u(L, "monochromatic"), h.mix = function (t, e, n) {
        n = 0 === n ? 0 : n || 50;
        var i = h(t).toRgb(),
          r = h(e).toRgb(),
          o = n / 100;
        return h({
          r: (r.r - i.r) * o + i.r,
          g: (r.g - i.g) * o + i.g,
          b: (r.b - i.b) * o + i.b,
          a: (r.a - i.a) * o + i.a
        });
      }, h.readability = function (e, n) {
        var i = h(e),
          r = h(n);
        return (t.max(i.getLuminance(), r.getLuminance()) + .05) / (t.min(i.getLuminance(), r.getLuminance()) + .05);
      }, h.isReadable = function (t, e, n) {
        var i,
          r,
          o = h.readability(t, e);
        switch (r = !1, (i = Q(n)).level + i.size) {
          case "AAsmall":
          case "AAAlarge":
            r = o >= 4.5;
            break;
          case "AAlarge":
            r = o >= 3;
            break;
          case "AAAsmall":
            r = o >= 7;
        }
        return r;
      }, h.mostReadable = function (t, e, n) {
        var i,
          r,
          o,
          s,
          a = null,
          l = 0;
        r = (n = n || {}).includeFallbackColors, o = n.level, s = n.size;
        for (var u = 0; u < e.length; u++) (i = h.readability(t, e[u])) > l && (l = i, a = h(e[u]));
        return h.isReadable(t, a, {
          level: o,
          size: s
        }) || !r ? a : (n.includeFallbackColors = !1, h.mostReadable(t, ["#fff", "#000"], n));
      };
      var R = h.names = {
          aliceblue: "f0f8ff",
          antiquewhite: "faebd7",
          aqua: "0ff",
          aquamarine: "7fffd4",
          azure: "f0ffff",
          beige: "f5f5dc",
          bisque: "ffe4c4",
          black: "000",
          blanchedalmond: "ffebcd",
          blue: "00f",
          blueviolet: "8a2be2",
          brown: "a52a2a",
          burlywood: "deb887",
          burntsienna: "ea7e5d",
          cadetblue: "5f9ea0",
          chartreuse: "7fff00",
          chocolate: "d2691e",
          coral: "ff7f50",
          cornflowerblue: "6495ed",
          cornsilk: "fff8dc",
          crimson: "dc143c",
          cyan: "0ff",
          darkblue: "00008b",
          darkcyan: "008b8b",
          darkgoldenrod: "b8860b",
          darkgray: "a9a9a9",
          darkgreen: "006400",
          darkgrey: "a9a9a9",
          darkkhaki: "bdb76b",
          darkmagenta: "8b008b",
          darkolivegreen: "556b2f",
          darkorange: "ff8c00",
          darkorchid: "9932cc",
          darkred: "8b0000",
          darksalmon: "e9967a",
          darkseagreen: "8fbc8f",
          darkslateblue: "483d8b",
          darkslategray: "2f4f4f",
          darkslategrey: "2f4f4f",
          darkturquoise: "00ced1",
          darkviolet: "9400d3",
          deeppink: "ff1493",
          deepskyblue: "00bfff",
          dimgray: "696969",
          dimgrey: "696969",
          dodgerblue: "1e90ff",
          firebrick: "b22222",
          floralwhite: "fffaf0",
          forestgreen: "228b22",
          fuchsia: "f0f",
          gainsboro: "dcdcdc",
          ghostwhite: "f8f8ff",
          gold: "ffd700",
          goldenrod: "daa520",
          gray: "808080",
          green: "008000",
          greenyellow: "adff2f",
          grey: "808080",
          honeydew: "f0fff0",
          hotpink: "ff69b4",
          indianred: "cd5c5c",
          indigo: "4b0082",
          ivory: "fffff0",
          khaki: "f0e68c",
          lavender: "e6e6fa",
          lavenderblush: "fff0f5",
          lawngreen: "7cfc00",
          lemonchiffon: "fffacd",
          lightblue: "add8e6",
          lightcoral: "f08080",
          lightcyan: "e0ffff",
          lightgoldenrodyellow: "fafad2",
          lightgray: "d3d3d3",
          lightgreen: "90ee90",
          lightgrey: "d3d3d3",
          lightpink: "ffb6c1",
          lightsalmon: "ffa07a",
          lightseagreen: "20b2aa",
          lightskyblue: "87cefa",
          lightslategray: "789",
          lightslategrey: "789",
          lightsteelblue: "b0c4de",
          lightyellow: "ffffe0",
          lime: "0f0",
          limegreen: "32cd32",
          linen: "faf0e6",
          magenta: "f0f",
          maroon: "800000",
          mediumaquamarine: "66cdaa",
          mediumblue: "0000cd",
          mediumorchid: "ba55d3",
          mediumpurple: "9370db",
          mediumseagreen: "3cb371",
          mediumslateblue: "7b68ee",
          mediumspringgreen: "00fa9a",
          mediumturquoise: "48d1cc",
          mediumvioletred: "c71585",
          midnightblue: "191970",
          mintcream: "f5fffa",
          mistyrose: "ffe4e1",
          moccasin: "ffe4b5",
          navajowhite: "ffdead",
          navy: "000080",
          oldlace: "fdf5e6",
          olive: "808000",
          olivedrab: "6b8e23",
          orange: "ffa500",
          orangered: "ff4500",
          orchid: "da70d6",
          palegoldenrod: "eee8aa",
          palegreen: "98fb98",
          paleturquoise: "afeeee",
          palevioletred: "db7093",
          papayawhip: "ffefd5",
          peachpuff: "ffdab9",
          peru: "cd853f",
          pink: "ffc0cb",
          plum: "dda0dd",
          powderblue: "b0e0e6",
          purple: "800080",
          rebeccapurple: "663399",
          red: "f00",
          rosybrown: "bc8f8f",
          royalblue: "4169e1",
          saddlebrown: "8b4513",
          salmon: "fa8072",
          sandybrown: "f4a460",
          seagreen: "2e8b57",
          seashell: "fff5ee",
          sienna: "a0522d",
          silver: "c0c0c0",
          skyblue: "87ceeb",
          slateblue: "6a5acd",
          slategray: "708090",
          slategrey: "708090",
          snow: "fffafa",
          springgreen: "00ff7f",
          steelblue: "4682b4",
          tan: "d2b48c",
          teal: "008080",
          thistle: "d8bfd8",
          tomato: "ff6347",
          turquoise: "40e0d0",
          violet: "ee82ee",
          wheat: "f5deb3",
          white: "fff",
          whitesmoke: "f5f5f5",
          yellow: "ff0",
          yellowgreen: "9acd32"
        },
        O = h.hexNames = q(R);
      function q(t) {
        var e = {};
        for (var n in t) t.hasOwnProperty(n) && (e[t[n]] = n);
        return e;
      }
      function D(t) {
        return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
      }
      function k(e, n) {
        B(e) && (e = "100%");
        var i = z(e);
        return e = s(n, a(0, parseFloat(e))), i && (e = parseInt(e * n, 10) / 100), t.abs(e - n) < 1e-6 ? 1 : e % n / parseFloat(n);
      }
      function F(t) {
        return s(1, a(0, t));
      }
      function U(t) {
        return parseInt(t, 16);
      }
      function B(t) {
        return "string" == typeof t && -1 != t.indexOf(".") && 1 === parseFloat(t);
      }
      function z(t) {
        return "string" == typeof t && -1 != t.indexOf("%");
      }
      function V(t) {
        return 1 == t.length ? "0" + t : "" + t;
      }
      function j(t) {
        return t <= 1 && (t = 100 * t + "%"), t;
      }
      function G(e) {
        return t.round(255 * parseFloat(e)).toString(16);
      }
      function W(t) {
        return U(t) / 255;
      }
      u(q, "flip"), u(D, "boundAlpha"), u(k, "bound01"), u(F, "clamp01"), u(U, "parseIntFromHex"), u(B, "isOnePointZero"), u(z, "isPercentage"), u(V, "pad2"), u(j, "convertToPercentage"), u(G, "convertDecimalToHex"), u(W, "convertHexToDecimal");
      var H,
        X,
        Y,
        Z = (X = "[\\s|\\(]+(" + (H = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + H + ")[,|\\s]+(" + H + ")\\s*\\)?", Y = "[\\s|\\(]+(" + H + ")[,|\\s]+(" + H + ")[,|\\s]+(" + H + ")[,|\\s]+(" + H + ")\\s*\\)?", {
          CSS_UNIT: new RegExp(H),
          rgb: new RegExp("rgb" + X),
          rgba: new RegExp("rgba" + Y),
          hsl: new RegExp("hsl" + X),
          hsla: new RegExp("hsla" + Y),
          hsv: new RegExp("hsv" + X),
          hsva: new RegExp("hsva" + Y),
          hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        });
      function J(t) {
        return !!Z.CSS_UNIT.exec(t);
      }
      function K(t) {
        t = t.replace(n, "").replace(i, "").toLowerCase();
        var e,
          r = !1;
        if (R[t]) t = R[t], r = !0;else if ("transparent" == t) return {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
          format: "name"
        };
        return (e = Z.rgb.exec(t)) ? {
          r: e[1],
          g: e[2],
          b: e[3]
        } : (e = Z.rgba.exec(t)) ? {
          r: e[1],
          g: e[2],
          b: e[3],
          a: e[4]
        } : (e = Z.hsl.exec(t)) ? {
          h: e[1],
          s: e[2],
          l: e[3]
        } : (e = Z.hsla.exec(t)) ? {
          h: e[1],
          s: e[2],
          l: e[3],
          a: e[4]
        } : (e = Z.hsv.exec(t)) ? {
          h: e[1],
          s: e[2],
          v: e[3]
        } : (e = Z.hsva.exec(t)) ? {
          h: e[1],
          s: e[2],
          v: e[3],
          a: e[4]
        } : (e = Z.hex8.exec(t)) ? {
          r: U(e[1]),
          g: U(e[2]),
          b: U(e[3]),
          a: W(e[4]),
          format: r ? "name" : "hex8"
        } : (e = Z.hex6.exec(t)) ? {
          r: U(e[1]),
          g: U(e[2]),
          b: U(e[3]),
          format: r ? "name" : "hex"
        } : (e = Z.hex4.exec(t)) ? {
          r: U(e[1] + "" + e[1]),
          g: U(e[2] + "" + e[2]),
          b: U(e[3] + "" + e[3]),
          a: W(e[4] + "" + e[4]),
          format: r ? "name" : "hex8"
        } : !!(e = Z.hex3.exec(t)) && {
          r: U(e[1] + "" + e[1]),
          g: U(e[2] + "" + e[2]),
          b: U(e[3] + "" + e[3]),
          format: r ? "name" : "hex"
        };
      }
      function Q(t) {
        var e, n;
        return "AA" !== (e = ((t = t || {
          level: "AA",
          size: "small"
        }).level || "AA").toUpperCase()) && "AAA" !== e && (e = "AA"), "small" !== (n = (t.size || "small").toLowerCase()) && "large" !== n && (n = "small"), {
          level: e,
          size: n
        };
      }
      u(J, "isValidCSSUnit"), u(K, "stringInputToObject"), u(Q, "validateWCAG2Parms"), void 0 !== e && e.exports ? e.exports = h : "function" == typeof define && define.amd ? define(function () {
        return h;
      }) : window.tinycolor = h;
    }(Math);
  }),
  Ny = ze((t, e) => {
    E();
    var n = "__lodash_hash_undefined__",
      i = 9007199254740991,
      r = "[object Arguments]",
      o = "[object Function]",
      s = "[object Object]",
      a = /^\[object .+?Constructor\]$/,
      l = /^(?:0|[1-9]\d*)$/,
      h = {};
    h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = !0, h[r] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h[o] = h["[object Map]"] = h["[object Number]"] = h[s] = h["[object RegExp]"] = h["[object Set]"] = h["[object String]"] = h["[object WeakMap]"] = !1;
    var c = "object" == typeof global && global && global.Object === Object && global,
      p = "object" == typeof self && self && self.Object === Object && self,
      d = c || p || Function("return this")(),
      f = "object" == typeof t && t && !t.nodeType && t,
      m = f && "object" == typeof e && e && !e.nodeType && e,
      g = m && m.exports === f,
      v = g && c.process,
      y = function () {
        try {
          return m && m.require && m.require("util").types || v && v.binding && v.binding("util");
        } catch (t) {}
      }(),
      _ = y && y.isTypedArray;
    function x(t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);
        case 1:
          return t.call(e, n[0]);
        case 2:
          return t.call(e, n[0], n[1]);
        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }
      return t.apply(e, n);
    }
    function b(t, e) {
      for (var n = -1, i = Array(t); ++n < t;) i[n] = e(n);
      return i;
    }
    function w(t) {
      return function (e) {
        return t(e);
      };
    }
    function S(t, e) {
      return null == t ? void 0 : t[e];
    }
    function M(t, e) {
      return function (n) {
        return t(e(n));
      };
    }
    u(x, "apply"), u(b, "baseTimes"), u(w, "baseUnary"), u(S, "getValue"), u(M, "overArg");
    var T,
      A = Array.prototype,
      P = Function.prototype,
      C = Object.prototype,
      I = d["__core-js_shared__"],
      N = P.toString,
      L = C.hasOwnProperty,
      R = (T = /[^.]+$/.exec(I && I.keys && I.keys.IE_PROTO || "")) ? "Symbol(src)_1." + T : "",
      O = C.toString,
      q = N.call(Object),
      D = RegExp("^" + N.call(L).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
      k = g ? d.Buffer : void 0,
      F = d.Symbol,
      U = d.Uint8Array,
      B = k ? k.allocUnsafe : void 0,
      z = M(Object.getPrototypeOf, Object),
      V = Object.create,
      j = C.propertyIsEnumerable,
      G = A.splice,
      W = F ? F.toStringTag : void 0,
      H = function () {
        try {
          var t = Xt(Object, "defineProperty");
          return t({}, "", {}), t;
        } catch (t) {}
      }(),
      X = k ? k.isBuffer : void 0,
      Y = Math.max,
      Z = Date.now,
      J = Xt(d, "Map"),
      K = Xt(Object, "create"),
      Q = function () {
        function t() {}
        return u(t, "object"), function (e) {
          if (!ge(e)) return {};
          if (V) return V(e);
          t.prototype = e;
          var n = new t();
          return t.prototype = void 0, n;
        };
      }();
    function $(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function tt() {
      this.__data__ = K ? K(null) : {}, this.size = 0;
    }
    function et(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    }
    function nt(t) {
      var e = this.__data__;
      if (K) {
        var i = e[t];
        return i === n ? void 0 : i;
      }
      return L.call(e, t) ? e[t] : void 0;
    }
    function it(t) {
      var e = this.__data__;
      return K ? void 0 !== e[t] : L.call(e, t);
    }
    function rt(t, e) {
      var i = this.__data__;
      return this.size += this.has(t) ? 0 : 1, i[t] = K && void 0 === e ? n : e, this;
    }
    function ot(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function st() {
      this.__data__ = [], this.size = 0;
    }
    function at(t) {
      var e = this.__data__,
        n = Tt(e, t);
      return !(n < 0) && (n == e.length - 1 ? e.pop() : G.call(e, n, 1), --this.size, !0);
    }
    function lt(t) {
      var e = this.__data__,
        n = Tt(e, t);
      return n < 0 ? void 0 : e[n][1];
    }
    function ut(t) {
      return Tt(this.__data__, t) > -1;
    }
    function ht(t, e) {
      var n = this.__data__,
        i = Tt(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    }
    function ct(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    function pt() {
      this.size = 0, this.__data__ = {
        hash: new $(),
        map: new (J || ot)(),
        string: new $()
      };
    }
    function dt(t) {
      var e = Ht(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    }
    function ft(t) {
      return Ht(this, t).get(t);
    }
    function mt(t) {
      return Ht(this, t).has(t);
    }
    function gt(t, e) {
      var n = Ht(this, t),
        i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    }
    function vt(t) {
      var e = this.__data__ = new ot(t);
      this.size = e.size;
    }
    function yt() {
      this.__data__ = new ot(), this.size = 0;
    }
    function _t(t) {
      var e = this.__data__,
        n = e.delete(t);
      return this.size = e.size, n;
    }
    function xt(t) {
      return this.__data__.get(t);
    }
    function Et(t) {
      return this.__data__.has(t);
    }
    function bt(t, e) {
      var n = this.__data__;
      if (n instanceof ot) {
        var i = n.__data__;
        if (!J || i.length < 199) return i.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new ct(i);
      }
      return n.set(t, e), this.size = n.size, this;
    }
    function wt(t, e) {
      var n = he(t),
        i = !n && ue(t),
        r = !n && !i && de(t),
        o = !n && !i && !r && _e(t),
        s = n || i || r || o,
        a = s ? b(t.length, String) : [],
        l = a.length;
      for (var u in t) (e || L.call(t, u)) && (!s || !("length" == u || r && ("offset" == u || "parent" == u) || o && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || Jt(u, l))) && a.push(u);
      return a;
    }
    function St(t, e, n) {
      (void 0 !== n && !le(t[e], n) || void 0 === n && !(e in t)) && At(t, e, n);
    }
    function Mt(t, e, n) {
      var i = t[e];
      (!L.call(t, e) || !le(i, n) || void 0 === n && !(e in t)) && At(t, e, n);
    }
    function Tt(t, e) {
      for (var n = t.length; n--;) if (le(t[n][0], e)) return n;
      return -1;
    }
    function At(t, e, n) {
      "__proto__" == e && H ? H(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    }
    u($, "Hash"), u(tt, "hashClear"), u(et, "hashDelete"), u(nt, "hashGet"), u(it, "hashHas"), u(rt, "hashSet"), $.prototype.clear = tt, $.prototype.delete = et, $.prototype.get = nt, $.prototype.has = it, $.prototype.set = rt, u(ot, "ListCache"), u(st, "listCacheClear"), u(at, "listCacheDelete"), u(lt, "listCacheGet"), u(ut, "listCacheHas"), u(ht, "listCacheSet"), ot.prototype.clear = st, ot.prototype.delete = at, ot.prototype.get = lt, ot.prototype.has = ut, ot.prototype.set = ht, u(ct, "MapCache"), u(pt, "mapCacheClear"), u(dt, "mapCacheDelete"), u(ft, "mapCacheGet"), u(mt, "mapCacheHas"), u(gt, "mapCacheSet"), ct.prototype.clear = pt, ct.prototype.delete = dt, ct.prototype.get = ft, ct.prototype.has = mt, ct.prototype.set = gt, u(vt, "Stack"), u(yt, "stackClear"), u(_t, "stackDelete"), u(xt, "stackGet"), u(Et, "stackHas"), u(bt, "stackSet"), vt.prototype.clear = yt, vt.prototype.delete = _t, vt.prototype.get = xt, vt.prototype.has = Et, vt.prototype.set = bt, u(wt, "arrayLikeKeys"), u(St, "assignMergeValue"), u(Mt, "assignValue"), u(Tt, "assocIndexOf"), u(At, "baseAssignValue");
    var Pt = Gt();
    function Ct(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : W && W in Object(t) ? Yt(t) : ne(t);
    }
    function It(t) {
      return ve(t) && Ct(t) == r;
    }
    function Nt(t) {
      return !(!ge(t) || $t(t)) && (fe(t) ? D : a).test(ae(t));
    }
    function Lt(t) {
      return ve(t) && me(t.length) && !!h[Ct(t)];
    }
    function Rt(t) {
      if (!ge(t)) return ee(t);
      var e = te(t),
        n = [];
      for (var i in t) "constructor" == i && (e || !L.call(t, i)) || n.push(i);
      return n;
    }
    function Ot(t, e, n, i, r) {
      t !== e && Pt(e, function (o, s) {
        if (r || (r = new vt()), ge(o)) qt(t, e, s, n, Ot, i, r);else {
          var a = i ? i(re(t, s), o, s + "", t, e, r) : void 0;
          void 0 === a && (a = o), St(t, s, a);
        }
      }, be);
    }
    function qt(t, e, n, i, r, o, s) {
      var a = re(t, n),
        l = re(e, n),
        u = s.get(l);
      if (u) St(t, n, u);else {
        var h = o ? o(a, l, n + "", t, e, s) : void 0,
          c = void 0 === h;
        if (c) {
          var p = he(l),
            d = !p && de(l),
            f = !p && !d && _e(l);
          h = l, p || d || f ? he(a) ? h = a : pe(a) ? h = zt(a) : d ? (c = !1, h = Ft(l, !0)) : f ? (c = !1, h = Bt(l, !0)) : h = [] : ye(l) || ue(l) ? (h = a, ue(a) ? h = xe(a) : (!ge(a) || fe(a)) && (h = Zt(l))) : c = !1;
        }
        c && (s.set(l, h), r(h, l, i, o, s), s.delete(l)), St(t, n, h);
      }
    }
    function Dt(t, e) {
      return oe(ie(t, e, Me), t + "");
    }
    u(Ct, "baseGetTag"), u(It, "baseIsArguments"), u(Nt, "baseIsNative"), u(Lt, "baseIsTypedArray"), u(Rt, "baseKeysIn"), u(Ot, "baseMerge"), u(qt, "baseMergeDeep"), u(Dt, "baseRest");
    var kt = H ? function (t, e) {
      return H(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Se(e),
        writable: !0
      });
    } : Me;
    function Ft(t, e) {
      if (e) return t.slice();
      var n = t.length,
        i = B ? B(n) : new t.constructor(n);
      return t.copy(i), i;
    }
    function Ut(t) {
      var e = new t.constructor(t.byteLength);
      return new U(e).set(new U(t)), e;
    }
    function Bt(t, e) {
      var n = e ? Ut(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    }
    function zt(t, e) {
      var n = -1,
        i = t.length;
      for (e || (e = Array(i)); ++n < i;) e[n] = t[n];
      return e;
    }
    function Vt(t, e, n, i) {
      var r = !n;
      n || (n = {});
      for (var o = -1, s = e.length; ++o < s;) {
        var a = e[o],
          l = i ? i(n[a], t[a], a, n, t) : void 0;
        void 0 === l && (l = t[a]), r ? At(n, a, l) : Mt(n, a, l);
      }
      return n;
    }
    function jt(t) {
      return Dt(function (e, n) {
        var i = -1,
          r = n.length,
          o = r > 1 ? n[r - 1] : void 0,
          s = r > 2 ? n[2] : void 0;
        for (o = t.length > 3 && "function" == typeof o ? (r--, o) : void 0, s && Kt(n[0], n[1], s) && (o = r < 3 ? void 0 : o, r = 1), e = Object(e); ++i < r;) {
          var a = n[i];
          a && t(e, a, i, o);
        }
        return e;
      });
    }
    function Gt(t) {
      return function (e, n, i) {
        for (var r = -1, o = Object(e), s = i(e), a = s.length; a--;) {
          var l = s[t ? a : ++r];
          if (!1 === n(o[l], l, o)) break;
        }
        return e;
      };
    }
    function Wt(t, e, n, i, r, o) {
      return ge(t) && ge(e) && (o.set(e, t), Ot(t, e, void 0, Wt, o), o.delete(e)), t;
    }
    function Ht(t, e) {
      var n = t.__data__;
      return Qt(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    }
    function Xt(t, e) {
      var n = S(t, e);
      return Nt(n) ? n : void 0;
    }
    function Yt(t) {
      var e = L.call(t, W),
        n = t[W];
      try {
        t[W] = void 0;
        var i = !0;
      } catch (t) {}
      var r = O.call(t);
      return i && (e ? t[W] = n : delete t[W]), r;
    }
    function Zt(t) {
      return "function" != typeof t.constructor || te(t) ? {} : Q(z(t));
    }
    function Jt(t, e) {
      var n = typeof t;
      return !!(e = null == e ? i : e) && ("number" == n || "symbol" != n && l.test(t)) && t > -1 && t % 1 == 0 && t < e;
    }
    function Kt(t, e, n) {
      if (!ge(n)) return !1;
      var i = typeof e;
      return !!("number" == i ? ce(n) && Jt(e, n.length) : "string" == i && e in n) && le(n[e], t);
    }
    function Qt(t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    }
    function $t(t) {
      return !!R && R in t;
    }
    function te(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || C);
    }
    function ee(t) {
      var e = [];
      if (null != t) for (var n in Object(t)) e.push(n);
      return e;
    }
    function ne(t) {
      return O.call(t);
    }
    function ie(t, e, n) {
      return e = Y(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var i = arguments, r = -1, o = Y(i.length - e, 0), s = Array(o); ++r < o;) s[r] = i[e + r];
        r = -1;
        for (var a = Array(e + 1); ++r < e;) a[r] = i[r];
        return a[e] = n(s), x(t, this, a);
      };
    }
    function re(t, e) {
      if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
    }
    u(Ft, "cloneBuffer"), u(Ut, "cloneArrayBuffer"), u(Bt, "cloneTypedArray"), u(zt, "copyArray"), u(Vt, "copyObject"), u(jt, "createAssigner"), u(Gt, "createBaseFor"), u(Wt, "customDefaultsMerge"), u(Ht, "getMapData"), u(Xt, "getNative"), u(Yt, "getRawTag"), u(Zt, "initCloneObject"), u(Jt, "isIndex"), u(Kt, "isIterateeCall"), u(Qt, "isKeyable"), u($t, "isMasked"), u(te, "isPrototype"), u(ee, "nativeKeysIn"), u(ne, "objectToString"), u(ie, "overRest"), u(re, "safeGet");
    var oe = se(kt);
    function se(t) {
      var e = 0,
        n = 0;
      return function () {
        var i = Z(),
          r = 16 - (i - n);
        if (n = i, r > 0) {
          if (++e >= 800) return arguments[0];
        } else e = 0;
        return t.apply(void 0, arguments);
      };
    }
    function ae(t) {
      if (null != t) {
        try {
          return N.call(t);
        } catch (t) {}
        try {
          return t + "";
        } catch (t) {}
      }
      return "";
    }
    function le(t, e) {
      return t === e || t != t && e != e;
    }
    u(se, "shortOut"), u(ae, "toSource"), u(le, "eq");
    var ue = It(function () {
        return arguments;
      }()) ? It : function (t) {
        return ve(t) && L.call(t, "callee") && !j.call(t, "callee");
      },
      he = Array.isArray;
    function ce(t) {
      return null != t && me(t.length) && !fe(t);
    }
    function pe(t) {
      return ve(t) && ce(t);
    }
    u(ce, "isArrayLike"), u(pe, "isArrayLikeObject");
    var de = X || Te;
    function fe(t) {
      if (!ge(t)) return !1;
      var e = Ct(t);
      return e == o || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    }
    function me(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= i;
    }
    function ge(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    }
    function ve(t) {
      return null != t && "object" == typeof t;
    }
    function ye(t) {
      if (!ve(t) || Ct(t) != s) return !1;
      var e = z(t);
      if (null === e) return !0;
      var n = L.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && N.call(n) == q;
    }
    u(fe, "isFunction"), u(me, "isLength"), u(ge, "isObject"), u(ve, "isObjectLike"), u(ye, "isPlainObject");
    var _e = _ ? w(_) : Lt;
    function xe(t) {
      return Vt(t, be(t));
    }
    u(xe, "toPlainObject");
    var Ee = Dt(function (t) {
      return t.push(void 0, Wt), x(we, void 0, t);
    });
    function be(t) {
      return ce(t) ? wt(t, !0) : Rt(t);
    }
    u(be, "keysIn");
    var we = jt(function (t, e, n, i) {
      Ot(t, e, n, i);
    });
    function Se(t) {
      return function () {
        return t;
      };
    }
    function Me(t) {
      return t;
    }
    function Te() {
      return !1;
    }
    u(Se, "constant"), u(Me, "identity"), u(Te, "stubFalse"), e.exports = Ee;
  }),
  IU = ze((t, e) => {
    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    function r(t, e, n) {
      return e && i(t.prototype, e), n && i(t, n), t;
    }
    E(), u(n, "_classCallCheck"), u(i, "_defineProperties"), u(r, "_createClass");
    var o = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          i = e.R,
          r = void 0 === i ? 1 : i,
          o = e.Q,
          s = void 0 === o ? 1 : o,
          a = e.A,
          l = void 0 === a ? 1 : a,
          u = e.B,
          h = void 0 === u ? 0 : u,
          c = e.C,
          p = void 0 === c ? 1 : c;
        n(this, t), this.R = r, this.Q = s, this.A = l, this.C = p, this.B = h, this.cov = NaN, this.x = NaN;
      }
      return u(t, "KalmanFilter"), r(t, [{
        key: "filter",
        value: u(function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          if (isNaN(this.x)) this.x = 1 / this.C * t, this.cov = 1 / this.C * this.Q * (1 / this.C);else {
            var n = this.predict(e),
              i = this.uncertainty(),
              r = i * this.C * (1 / (this.C * i * this.C + this.Q));
            this.x = n + r * (t - this.C * n), this.cov = i - r * this.C * i;
          }
          return this.x;
        }, "filter")
      }, {
        key: "predict",
        value: u(function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
          return this.A * this.x + this.B * t;
        }, "predict")
      }, {
        key: "uncertainty",
        value: u(function () {
          return this.A * this.cov * this.A + this.R;
        }, "uncertainty")
      }, {
        key: "lastMeasurement",
        value: u(function () {
          return this.x;
        }, "lastMeasurement")
      }, {
        key: "setMeasurementNoise",
        value: u(function (t) {
          this.Q = t;
        }, "setMeasurementNoise")
      }, {
        key: "setProcessNoise",
        value: u(function (t) {
          this.R = t;
        }, "setProcessNoise")
      }]), t;
    }();
    e.exports = o;
  }),
  zU = ze((t, e) => {
    E(), e.exports = u(function (t) {
      if (!Array.isArray(t)) throw new TypeError("array-unique expects an array.");
      for (var e = t.length, n = -1; n++ < e;) for (var i = n + 1; i < t.length; ++i) t[n] === t[i] && t.splice(i--, 1);
      return t;
    }, "unique"), e.exports.immutable = u(function (t) {
      if (!Array.isArray(t)) throw new TypeError("array-unique expects an array.");
      for (var n = t.length, i = new Array(n), r = 0; r < n; r++) i[r] = t[r];
      return e.exports(i);
    }, "uniqueImmutable");
  }),
  KU = ze((t, e) => {
    E(), function () {
      "use strict";

      function t(t, e) {
        var n = t.x - e.x,
          i = t.y - e.y;
        return n * n + i * i;
      }
      function n(t, e, n) {
        var i = e.x,
          r = e.y,
          o = n.x - i,
          s = n.y - r;
        if (0 !== o || 0 !== s) {
          var a = ((t.x - i) * o + (t.y - r) * s) / (o * o + s * s);
          a > 1 ? (i = n.x, r = n.y) : a > 0 && (i += o * a, r += s * a);
        }
        return (o = t.x - i) * o + (s = t.y - r) * s;
      }
      function i(e, n) {
        for (var i, r = e[0], o = [r], s = 1, a = e.length; s < a; s++) t(i = e[s], r) > n && (o.push(i), r = i);
        return r !== i && o.push(i), o;
      }
      function r(t, e, i, o, s) {
        for (var a, l = o, u = e + 1; u < i; u++) {
          var h = n(t[u], t[e], t[i]);
          h > l && (a = u, l = h);
        }
        l > o && (a - e > 1 && r(t, e, a, o, s), s.push(t[a]), i - a > 1 && r(t, a, i, o, s));
      }
      function o(t, e) {
        var n = t.length - 1,
          i = [t[0]];
        return r(t, 0, n, e, i), i.push(t[n]), i;
      }
      function s(t, e, n) {
        if (t.length <= 2) return t;
        var r = void 0 !== e ? e * e : 1;
        return t = o(t = n ? t : i(t, r), r);
      }
      u(t, "getSqDist"), u(n, "getSqSegDist"), u(i, "simplifyRadialDist"), u(r, "simplifyDPStep"), u(o, "simplifyDouglasPeucker"), u(s, "simplify"), "function" == typeof define && define.amd ? define(function () {
        return s;
      }) : void 0 !== e ? (e.exports = s, e.exports.default = s) : "undefined" != typeof self ? self.simplify = s : window.simplify = s;
    }();
  }),
  pz = ze((t, e) => {
    var n, i;
    E(), n = t, i = function () {
      var t = u(function () {
        function e(t) {
          return r.appendChild(t.dom), t;
        }
        function n(t) {
          for (var e = 0; e < r.children.length; e++) r.children[e].style.display = e === t ? "block" : "none";
          i = t;
        }
        u(e, "e"), u(n, "u");
        var i = 0,
          r = document.createElement("div");
        r.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000", r.addEventListener("click", function (t) {
          t.preventDefault(), n(++i % r.children.length);
        }, !1);
        var o = (performance || Date).now(),
          s = o,
          a = 0,
          l = e(new t.Panel("FPS", "#0ff", "#002")),
          h = e(new t.Panel("MS", "#0f0", "#020"));
        if (self.performance && self.performance.memory) var c = e(new t.Panel("MB", "#f08", "#201"));
        return n(0), {
          REVISION: 16,
          dom: r,
          addPanel: e,
          showPanel: n,
          begin: function () {
            o = (performance || Date).now();
          },
          end: function () {
            a++;
            var t = (performance || Date).now();
            if (h.update(t - o, 200), t > s + 1e3 && (l.update(1e3 * a / (t - s), 100), s = t, a = 0, c)) {
              var e = performance.memory;
              c.update(e.usedJSHeapSize / 1048576, e.jsHeapSizeLimit / 1048576);
            }
            return t;
          },
          update: function () {
            o = this.end();
          },
          domElement: r,
          setMode: n
        };
      }, "f");
      return t.Panel = function (t, e, n) {
        var i = 1 / 0,
          r = 0,
          o = Math.round,
          s = o(window.devicePixelRatio || 1),
          a = 80 * s,
          l = 48 * s,
          u = 3 * s,
          h = 2 * s,
          c = 3 * s,
          p = 15 * s,
          d = 74 * s,
          f = 30 * s,
          m = document.createElement("canvas");
        m.width = a, m.height = l, m.style.cssText = "width:80px;height:48px";
        var g = m.getContext("2d");
        return g.font = "bold " + 9 * s + "px Helvetica,Arial,sans-serif", g.textBaseline = "top", g.fillStyle = n, g.fillRect(0, 0, a, l), g.fillStyle = e, g.fillText(t, u, h), g.fillRect(c, p, d, f), g.fillStyle = n, g.globalAlpha = .9, g.fillRect(c, p, d, f), {
          dom: m,
          update: function (l, v) {
            i = Math.min(i, l), r = Math.max(r, l), g.fillStyle = n, g.globalAlpha = 1, g.fillRect(0, 0, a, p), g.fillStyle = e, g.fillText(o(l) + " " + t + " (" + o(i) + "-" + o(r) + ")", u, h), g.drawImage(m, c + s, p, d - s, f, c, p, d - s, f), g.fillRect(c + d - s, p, s, f), g.fillStyle = n, g.globalAlpha = .9, g.fillRect(c + d - s, p, s, o((1 - l / v) * f));
          }
        };
      }, t;
    }, "object" == typeof t && void 0 !== e ? e.exports = i() : "function" == typeof define && define.amd ? define(i) : n.Stats = i();
  });
E(), E(), E(), E();
var _3 = "153",
  X_ = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
  },
  Uz = 0,
  iI = 1,
  zz = 2,
  rI = 1,
  Vz = 2,
  Cu = 3,
  ja = 0,
  Ts = 1,
  Us = 2,
  jc = 0,
  Gp = 1,
  oI = 2,
  sI = 3,
  Y_ = 4,
  x3 = 5,
  Hp = 100,
  Gz = 101,
  Hz = 102,
  aI = 103,
  lI = 104,
  jz = 200,
  Wz = 201,
  Xz = 202,
  Yz = 203,
  uI = 204,
  cI = 205,
  Zz = 206,
  Jz = 207,
  Kz = 208,
  Qz = 209,
  $z = 210,
  eV = 0,
  tV = 1,
  nV = 2,
  b3 = 3,
  iV = 4,
  rV = 5,
  oV = 6,
  sV = 7,
  M3 = 0,
  aV = 1,
  lV = 2,
  Au = 0,
  uV = 1,
  cV = 2,
  hV = 3,
  fV = 4,
  pV = 5,
  Lg = 300,
  jp = 301,
  Wp = 302,
  E3 = 303,
  w3 = 304,
  Z_ = 306,
  Br = 1e3,
  Wa = 1001,
  S3 = 1002,
  ni = 1003,
  hI = 1004,
  T3 = 1005,
  ao = 1006,
  dV = 1007,
  Og = 1008,
  Wc = 1009,
  mV = 1010,
  gV = 1011,
  P3 = 1012,
  fI = 1013,
  Ps = 1014,
  Tl = 1015,
  Iu = 1016,
  pI = 1017,
  dI = 1018,
  sf = 1020,
  vV = 1021,
  Po = 1023,
  yV = 1024,
  _V = 1025,
  Lu = 1026,
  Xp = 1027,
  C3 = 1028,
  mI = 1029,
  xV = 1030,
  gI = 1031,
  vI = 1033,
  A3 = 33776,
  I3 = 33777,
  L3 = 33778,
  O3 = 33779,
  yI = 35840,
  _I = 35841,
  xI = 35842,
  bI = 35843,
  bV = 36196,
  MI = 37492,
  EI = 37496,
  wI = 37808,
  SI = 37809,
  TI = 37810,
  PI = 37811,
  CI = 37812,
  AI = 37813,
  II = 37814,
  LI = 37815,
  OI = 37816,
  RI = 37817,
  NI = 37818,
  DI = 37819,
  qI = 37820,
  kI = 37821,
  R3 = 36492,
  MV = 36283,
  FI = 36284,
  BI = 36285,
  UI = 36286,
  J_ = 2300,
  K_ = 2301,
  N3 = 2302,
  zI = 2400,
  VI = 2401,
  GI = 2402,
  HI = 3e3,
  Pl = 3001,
  EV = 3200,
  wV = 3201,
  jI = 0,
  SV = 1,
  Ou = "",
  Nt = "srgb",
  Cl = "srgb-linear",
  WI = "display-p3",
  Ru = 7680,
  Yp = 7681,
  Q_ = 514,
  Rg = 519,
  TV = 512,
  PV = 513,
  CV = 514,
  AV = 515,
  IV = 516,
  LV = 517,
  OV = 518,
  RV = 519,
  XI = 35044,
  YI = "300 es",
  D3 = 1035,
  Nu = 2e3,
  $_ = 2001,
  Al = class {
    addEventListener(t, e) {
      void 0 === this._listeners && (this._listeners = {});
      let n = this._listeners;
      void 0 === n[t] && (n[t] = []), -1 === n[t].indexOf(e) && n[t].push(e);
    }
    hasEventListener(t, e) {
      if (void 0 === this._listeners) return !1;
      let n = this._listeners;
      return void 0 !== n[t] && -1 !== n[t].indexOf(e);
    }
    removeEventListener(t, e) {
      if (void 0 === this._listeners) return;
      let n = this._listeners[t];
      if (void 0 !== n) {
        let t = n.indexOf(e);
        -1 !== t && n.splice(t, 1);
      }
    }
    dispatchEvent(t) {
      if (void 0 === this._listeners) return;
      let e = this._listeners[t.type];
      if (void 0 !== e) {
        t.target = this;
        let n = e.slice(0);
        for (let e = 0, i = n.length; e < i; e++) n[e].call(this, t);
        t.target = null;
      }
    }
  };
u(Al, "EventDispatcher");
var Ho = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"],
  q3 = Math.PI / 180,
  k3 = 180 / Math.PI;
function Zp() {
  let t = 4294967295 * Math.random() | 0,
    e = 4294967295 * Math.random() | 0,
    n = 4294967295 * Math.random() | 0,
    i = 4294967295 * Math.random() | 0;
  return (Ho[255 & t] + Ho[t >> 8 & 255] + Ho[t >> 16 & 255] + Ho[t >> 24 & 255] + "-" + Ho[255 & e] + Ho[e >> 8 & 255] + "-" + Ho[e >> 16 & 15 | 64] + Ho[e >> 24 & 255] + "-" + Ho[63 & n | 128] + Ho[n >> 8 & 255] + "-" + Ho[n >> 16 & 255] + Ho[n >> 24 & 255] + Ho[255 & i] + Ho[i >> 8 & 255] + Ho[i >> 16 & 255] + Ho[i >> 24 & 255]).toLowerCase();
}
function jo(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function NV(t, e) {
  return (t % e + e) % e;
}
function F3(t, e, n) {
  return (1 - n) * t + n * e;
}
function ZI(t) {
  return 0 == (t & t - 1) && 0 !== t;
}
function B3(t) {
  return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
}
function ex(t, e) {
  switch (e.constructor) {
    case Float32Array:
      return t;
    case Uint32Array:
      return t / 4294967295;
    case Uint16Array:
      return t / 65535;
    case Uint8Array:
      return t / 255;
    case Int32Array:
      return Math.max(t / 2147483647, -1);
    case Int16Array:
      return Math.max(t / 32767, -1);
    case Int8Array:
      return Math.max(t / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function zs(t, e) {
  switch (e.constructor) {
    case Float32Array:
      return t;
    case Uint32Array:
      return Math.round(4294967295 * t);
    case Uint16Array:
      return Math.round(65535 * t);
    case Uint8Array:
      return Math.round(255 * t);
    case Int32Array:
      return Math.round(2147483647 * t);
    case Int16Array:
      return Math.round(32767 * t);
    case Int8Array:
      return Math.round(127 * t);
    default:
      throw new Error("Invalid component type.");
  }
}
u(Zp, "generateUUID"), u(jo, "clamp"), u(NV, "euclideanModulo"), u(F3, "lerp"), u(ZI, "isPowerOfTwo"), u(B3, "floorPowerOfTwo"), u(ex, "denormalize"), u(zs, "normalize");
var je = class {
  constructor(t = 0, e = 0) {
    je.prototype.isVector2 = !0, this.x = t, this.y = e;
  }
  get width() {
    return this.x;
  }
  set width(t) {
    this.x = t;
  }
  get height() {
    return this.y;
  }
  set height(t) {
    this.y = t;
  }
  set(t, e) {
    return this.x = t, this.y = e, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this;
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  applyMatrix3(t) {
    let e = this.x,
      n = this.y,
      i = t.elements;
    return this.x = i[0] * e + i[3] * n + i[6], this.y = i[1] * e + i[4] * n + i[7], this;
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
  }
  clamp(t, e) {
    return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
  }
  clampScalar(t, e) {
    return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this;
  }
  clampLength(t, e) {
    let n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  cross(t) {
    return this.x * t.y - this.y * t.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  angleTo(t) {
    let e = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (0 === e) return Math.PI / 2;
    let n = this.dot(t) / e;
    return Math.acos(jo(n, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    let e = this.x - t.x,
      n = this.y - t.y;
    return e * e + n * n;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
  }
  lerpVectors(t, e, n) {
    return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this;
  }
  rotateAround(t, e) {
    let n = Math.cos(e),
      i = Math.sin(e),
      r = this.x - t.x,
      o = this.y - t.y;
    return this.x = r * n - o * i + t.x, this.y = r * i + o * n + t.y, this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
};
u(je, "Vector2");
var Qt = class {
  constructor(t, e, n, i, r, o, s, a, l) {
    Qt.prototype.isMatrix3 = !0, this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1], void 0 !== t && this.set(t, e, n, i, r, o, s, a, l);
  }
  set(t, e, n, i, r, o, s, a, l) {
    let u = this.elements;
    return u[0] = t, u[1] = i, u[2] = s, u[3] = e, u[4] = r, u[5] = a, u[6] = n, u[7] = o, u[8] = l, this;
  }
  identity() {
    return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
  }
  copy(t) {
    let e = this.elements,
      n = t.elements;
    return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], this;
  }
  extractBasis(t, e, n) {
    return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(t) {
    let e = t.elements;
    return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyMatrices(t, e) {
    let n = t.elements,
      i = e.elements,
      r = this.elements,
      o = n[0],
      s = n[3],
      a = n[6],
      l = n[1],
      u = n[4],
      h = n[7],
      c = n[2],
      p = n[5],
      d = n[8],
      f = i[0],
      m = i[3],
      g = i[6],
      v = i[1],
      y = i[4],
      _ = i[7],
      x = i[2],
      E = i[5],
      b = i[8];
    return r[0] = o * f + s * v + a * x, r[3] = o * m + s * y + a * E, r[6] = o * g + s * _ + a * b, r[1] = l * f + u * v + h * x, r[4] = l * m + u * y + h * E, r[7] = l * g + u * _ + h * b, r[2] = c * f + p * v + d * x, r[5] = c * m + p * y + d * E, r[8] = c * g + p * _ + d * b, this;
  }
  multiplyScalar(t) {
    let e = this.elements;
    return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
  }
  determinant() {
    let t = this.elements,
      e = t[0],
      n = t[1],
      i = t[2],
      r = t[3],
      o = t[4],
      s = t[5],
      a = t[6],
      l = t[7],
      u = t[8];
    return e * o * u - e * s * l - n * r * u + n * s * a + i * r * l - i * o * a;
  }
  invert() {
    let t = this.elements,
      e = t[0],
      n = t[1],
      i = t[2],
      r = t[3],
      o = t[4],
      s = t[5],
      a = t[6],
      l = t[7],
      u = t[8],
      h = u * o - s * l,
      c = s * a - u * r,
      p = l * r - o * a,
      d = e * h + n * c + i * p;
    if (0 === d) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    let f = 1 / d;
    return t[0] = h * f, t[1] = (i * l - u * n) * f, t[2] = (s * n - i * o) * f, t[3] = c * f, t[4] = (u * e - i * a) * f, t[5] = (i * r - s * e) * f, t[6] = p * f, t[7] = (n * a - l * e) * f, t[8] = (o * e - n * r) * f, this;
  }
  transpose() {
    let t,
      e = this.elements;
    return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
  }
  getNormalMatrix(t) {
    return this.setFromMatrix4(t).invert().transpose();
  }
  transposeIntoArray(t) {
    let e = this.elements;
    return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
  }
  setUvTransform(t, e, n, i, r, o, s) {
    let a = Math.cos(r),
      l = Math.sin(r);
    return this.set(n * a, n * l, -n * (a * o + l * s) + o + t, -i * l, i * a, -i * (-l * o + a * s) + s + e, 0, 0, 1), this;
  }
  scale(t, e) {
    return this.premultiply(U3.makeScale(t, e)), this;
  }
  rotate(t) {
    return this.premultiply(U3.makeRotation(-t)), this;
  }
  translate(t, e) {
    return this.premultiply(U3.makeTranslation(t, e)), this;
  }
  makeTranslation(t, e) {
    return t.isVector2 ? this.set(1, 0, t.x, 0, 1, t.y, 0, 0, 1) : this.set(1, 0, t, 0, 1, e, 0, 0, 1), this;
  }
  makeRotation(t) {
    let e = Math.cos(t),
      n = Math.sin(t);
    return this.set(e, -n, 0, n, e, 0, 0, 0, 1), this;
  }
  makeScale(t, e) {
    return this.set(t, 0, 0, 0, e, 0, 0, 0, 1), this;
  }
  equals(t) {
    let e = this.elements,
      n = t.elements;
    for (let t = 0; t < 9; t++) if (e[t] !== n[t]) return !1;
    return !0;
  }
  fromArray(t, e = 0) {
    for (let n = 0; n < 9; n++) this.elements[n] = t[n + e];
    return this;
  }
  toArray(t = [], e = 0) {
    let n = this.elements;
    return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
};
u(Qt, "Matrix3");
var U3 = new Qt();
function JI(t) {
  for (let e = t.length - 1; e >= 0; --e) if (t[e] >= 65535) return !0;
  return !1;
}
function Ng(t) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", t);
}
u(JI, "arrayNeedsUint32"), u(Ng, "createElementNS");
var KI = {};
function Dg(t) {
  t in KI || (KI[t] = !0, console.warn(t));
}
function Jp(t) {
  return t < .04045 ? .0773993808 * t : Math.pow(.9478672986 * t + .0521327014, 2.4);
}
function z3(t) {
  return t < .0031308 ? 12.92 * t : 1.055 * Math.pow(t, .41666) - .055;
}
u(Dg, "warnOnce"), u(Jp, "SRGBToLinear"), u(z3, "LinearToSRGB");
var DV = new Qt().fromArray([.8224621, .0331941, .0170827, .177538, .9668058, .0723974, -1e-7, 1e-7, .9105199]),
  qV = new Qt().fromArray([1.2249401, -.0420569, -.0196376, -.2249404, 1.0420571, -.0786361, 1e-7, 0, 1.0982735]);
function kV(t) {
  return t.convertSRGBToLinear().applyMatrix3(qV);
}
function FV(t) {
  return t.applyMatrix3(DV).convertLinearToSRGB();
}
u(kV, "DisplayP3ToLinearSRGB"), u(FV, "LinearSRGBToDisplayP3");
var Kp,
  BV = {
    [Cl]: t => t,
    [Nt]: t => t.convertSRGBToLinear(),
    [WI]: kV
  },
  UV = {
    [Cl]: t => t,
    [Nt]: t => t.convertLinearToSRGB(),
    [WI]: FV
  },
  Xa = {
    enabled: !0,
    get legacyMode() {
      return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), !this.enabled;
    },
    set legacyMode(t) {
      console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), this.enabled = !t;
    },
    get workingColorSpace() {
      return Cl;
    },
    set workingColorSpace(t) {
      console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function (t, e, n) {
      if (!1 === this.enabled || e === n || !e || !n) return t;
      let i = BV[e],
        r = UV[n];
      if (void 0 === i || void 0 === r) throw new Error(`Unsupported color space conversion, "${e}" to "${n}".`);
      return r(i(t));
    },
    fromWorkingColorSpace: function (t, e) {
      return this.convert(t, this.workingColorSpace, e);
    },
    toWorkingColorSpace: function (t, e) {
      return this.convert(t, e, this.workingColorSpace);
    }
  },
  tx = class {
    static getDataURL(t) {
      if (/^data:/i.test(t.src) || "undefined" == typeof HTMLCanvasElement) return t.src;
      let e;
      if (t instanceof HTMLCanvasElement) e = t;else {
        void 0 === Kp && (Kp = Ng("canvas")), Kp.width = t.width, Kp.height = t.height;
        let n = Kp.getContext("2d");
        t instanceof ImageData ? n.putImageData(t, 0, 0) : n.drawImage(t, 0, 0, t.width, t.height), e = Kp;
      }
      return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
    }
    static sRGBToLinear(t) {
      if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
        let e = Ng("canvas");
        e.width = t.width, e.height = t.height;
        let n = e.getContext("2d");
        n.drawImage(t, 0, 0, t.width, t.height);
        let i = n.getImageData(0, 0, t.width, t.height),
          r = i.data;
        for (let t = 0; t < r.length; t++) r[t] = 255 * Jp(r[t] / 255);
        return n.putImageData(i, 0, 0), e;
      }
      if (t.data) {
        let e = t.data.slice(0);
        for (let t = 0; t < e.length; t++) e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[t] = Math.floor(255 * Jp(e[t] / 255)) : e[t] = Jp(e[t]);
        return {
          data: e,
          width: t.width,
          height: t.height
        };
      }
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
    }
  };
u(tx, "ImageUtils");
var zV = 0,
  nx = class {
    constructor(t = null) {
      this.isSource = !0, Object.defineProperty(this, "id", {
        value: zV++
      }), this.uuid = Zp(), this.data = t, this.version = 0;
    }
    set needsUpdate(t) {
      !0 === t && this.version++;
    }
    toJSON(t) {
      let e = void 0 === t || "string" == typeof t;
      if (!e && void 0 !== t.images[this.uuid]) return t.images[this.uuid];
      let n = {
          uuid: this.uuid,
          url: ""
        },
        i = this.data;
      if (null !== i) {
        let t;
        if (Array.isArray(i)) {
          t = [];
          for (let e = 0, n = i.length; e < n; e++) i[e].isDataTexture ? t.push(V3(i[e].image)) : t.push(V3(i[e]));
        } else t = V3(i);
        n.url = t;
      }
      return e || (t.images[this.uuid] = n), n;
    }
  };
function V3(t) {
  return "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap ? tx.getDataURL(t) : t.data ? {
    data: Array.from(t.data),
    width: t.width,
    height: t.height,
    type: t.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
u(nx, "Source"), u(V3, "serializeImage");
var VV = 0,
  lo = class extends Al {
    constructor(t = lo.DEFAULT_IMAGE, e = lo.DEFAULT_MAPPING, n = Wa, i = Wa, r = ao, o = Og, s = Po, a = Wc, l = lo.DEFAULT_ANISOTROPY, u = Ou) {
      super(), this.isTexture = !0, Object.defineProperty(this, "id", {
        value: VV++
      }), this.uuid = Zp(), this.name = "", this.source = new nx(t), this.mipmaps = [], this.mapping = e, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = o, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = a, this.offset = new je(0, 0), this.repeat = new je(1, 1), this.center = new je(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Qt(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof u ? this.colorSpace = u : (Dg("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = u === Pl ? Nt : Ou), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
    }
    get image() {
      return this.source.data;
    }
    set image(t = null) {
      this.source.data = t;
    }
    updateMatrix() {
      this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(t) {
      return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.channel = t.channel, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.colorSpace = t.colorSpace, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
    }
    toJSON(t) {
      let e = void 0 === t || "string" == typeof t;
      if (!e && void 0 !== t.textures[this.uuid]) return t.textures[this.uuid];
      let n = {
        metadata: {
          version: 4.6,
          type: "Texture",
          generator: "Texture.toJSON"
        },
        uuid: this.uuid,
        name: this.name,
        image: this.source.toJSON(t).uuid,
        mapping: this.mapping,
        channel: this.channel,
        repeat: [this.repeat.x, this.repeat.y],
        offset: [this.offset.x, this.offset.y],
        center: [this.center.x, this.center.y],
        rotation: this.rotation,
        wrap: [this.wrapS, this.wrapT],
        format: this.format,
        internalFormat: this.internalFormat,
        type: this.type,
        colorSpace: this.colorSpace,
        minFilter: this.minFilter,
        magFilter: this.magFilter,
        anisotropy: this.anisotropy,
        flipY: this.flipY,
        generateMipmaps: this.generateMipmaps,
        premultiplyAlpha: this.premultiplyAlpha,
        unpackAlignment: this.unpackAlignment
      };
      return Object.keys(this.userData).length > 0 && (n.userData = this.userData), e || (t.textures[this.uuid] = n), n;
    }
    dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
    transformUv(t) {
      if (this.mapping !== Lg) return t;
      if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch (this.wrapS) {
        case Br:
          t.x = t.x - Math.floor(t.x);
          break;
        case Wa:
          t.x = t.x < 0 ? 0 : 1;
          break;
        case S3:
          1 === Math.abs(Math.floor(t.x) % 2) ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
      }
      if (t.y < 0 || t.y > 1) switch (this.wrapT) {
        case Br:
          t.y = t.y - Math.floor(t.y);
          break;
        case Wa:
          t.y = t.y < 0 ? 0 : 1;
          break;
        case S3:
          1 === Math.abs(Math.floor(t.y) % 2) ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
      }
      return this.flipY && (t.y = 1 - t.y), t;
    }
    set needsUpdate(t) {
      !0 === t && (this.version++, this.source.needsUpdate = !0);
    }
    get encoding() {
      return Dg("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === Nt ? Pl : HI;
    }
    set encoding(t) {
      Dg("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = t === Pl ? Nt : Ou;
    }
  };
u(lo, "Texture"), lo.DEFAULT_IMAGE = null, lo.DEFAULT_MAPPING = Lg, lo.DEFAULT_ANISOTROPY = 1;
var Er = class {
  constructor(t = 0, e = 0, n = 0, i = 1) {
    Er.prototype.isVector4 = !0, this.x = t, this.y = e, this.z = n, this.w = i;
  }
  get width() {
    return this.z;
  }
  set width(t) {
    this.z = t;
  }
  get height() {
    return this.w;
  }
  set height(t) {
    this.w = t;
  }
  set(t, e, n, i) {
    return this.x = t, this.y = e, this.z = n, this.w = i, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this.w = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setZ(t) {
    return this.z = t, this;
  }
  setW(t) {
    return this.w = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      case 2:
        this.z = e;
        break;
      case 3:
        this.w = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this.w = void 0 !== t.w ? t.w : 1, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this.w += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
  }
  applyMatrix4(t) {
    let e = this.x,
      n = this.y,
      i = this.z,
      r = this.w,
      o = t.elements;
    return this.x = o[0] * e + o[4] * n + o[8] * i + o[12] * r, this.y = o[1] * e + o[5] * n + o[9] * i + o[13] * r, this.z = o[2] * e + o[6] * n + o[10] * i + o[14] * r, this.w = o[3] * e + o[7] * n + o[11] * i + o[15] * r, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  setAxisAngleFromQuaternion(t) {
    this.w = 2 * Math.acos(t.w);
    let e = Math.sqrt(1 - t.w * t.w);
    return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
  }
  setAxisAngleFromRotationMatrix(t) {
    let e,
      n,
      i,
      r,
      o = .01,
      s = .1,
      a = t.elements,
      l = a[0],
      u = a[4],
      h = a[8],
      c = a[1],
      p = a[5],
      d = a[9],
      f = a[2],
      m = a[6],
      g = a[10];
    if (Math.abs(u - c) < o && Math.abs(h - f) < o && Math.abs(d - m) < o) {
      if (Math.abs(u + c) < s && Math.abs(h + f) < s && Math.abs(d + m) < s && Math.abs(l + p + g - 3) < s) return this.set(1, 0, 0, 0), this;
      e = Math.PI;
      let t = (l + 1) / 2,
        a = (p + 1) / 2,
        v = (g + 1) / 2,
        y = (u + c) / 4,
        _ = (h + f) / 4,
        x = (d + m) / 4;
      return t > a && t > v ? t < o ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(t), i = y / n, r = _ / n) : a > v ? a < o ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(a), n = y / i, r = x / i) : v < o ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(v), n = _ / r, i = x / r), this.set(n, i, r, e), this;
    }
    let v = Math.sqrt((m - d) * (m - d) + (h - f) * (h - f) + (c - u) * (c - u));
    return Math.abs(v) < .001 && (v = 1), this.x = (m - d) / v, this.y = (h - f) / v, this.z = (c - u) / v, this.w = Math.acos((l + p + g - 1) / 2), this;
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
  }
  clamp(t, e) {
    return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
  }
  clampScalar(t, e) {
    return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this.w = Math.max(t, Math.min(e, this.w)), this;
  }
  clampLength(t, e) {
    let n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
  }
  lerpVectors(t, e, n) {
    return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this.w = t.w + (e.w - t.w) * n, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
};
u(Er, "Vector4");
var wr = class extends Al {
  constructor(t = 1, e = 1, n = {}) {
    super(), this.isWebGLRenderTarget = !0, this.width = t, this.height = e, this.depth = 1, this.scissor = new Er(0, 0, t, e), this.scissorTest = !1, this.viewport = new Er(0, 0, t, e);
    let i = {
      width: t,
      height: e,
      depth: 1
    };
    void 0 !== n.encoding && (Dg("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."), n.colorSpace = n.encoding === Pl ? Nt : Ou), this.texture = new lo(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = void 0 !== n.generateMipmaps && n.generateMipmaps, this.texture.internalFormat = void 0 !== n.internalFormat ? n.internalFormat : null, this.texture.minFilter = void 0 !== n.minFilter ? n.minFilter : ao, this.depthBuffer = void 0 === n.depthBuffer || n.depthBuffer, this.stencilBuffer = void 0 !== n.stencilBuffer && n.stencilBuffer, this.depthTexture = void 0 !== n.depthTexture ? n.depthTexture : null, this.samples = void 0 !== n.samples ? n.samples : 0;
  }
  setSize(t, e, n = 1) {
    (this.width !== t || this.height !== e || this.depth !== n) && (this.width = t, this.height = e, this.depth = n, this.texture.image.width = t, this.texture.image.height = e, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    this.width = t.width, this.height = t.height, this.depth = t.depth, this.scissor.copy(t.scissor), this.scissorTest = t.scissorTest, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.texture.isRenderTargetTexture = !0;
    let e = Object.assign({}, t.texture.image);
    return this.texture.source = new nx(e), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, null !== t.depthTexture && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
  }
  dispose() {
    this.dispatchEvent({
      type: "dispose"
    });
  }
};
u(wr, "WebGLRenderTarget");
var ix = class extends lo {
  constructor(t = null, e = 1, n = 1, i = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = {
      data: t,
      width: e,
      height: n,
      depth: i
    }, this.magFilter = ni, this.minFilter = ni, this.wrapR = Wa, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
};
u(ix, "DataArrayTexture");
var G3 = class extends lo {
  constructor(t = null, e = 1, n = 1, i = 1) {
    super(null), this.isData3DTexture = !0, this.image = {
      data: t,
      width: e,
      height: n,
      depth: i
    }, this.magFilter = ni, this.minFilter = ni, this.wrapR = Wa, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
};
u(G3, "Data3DTexture");
var rx = class extends wr {
  constructor(t = 1, e = 1, n = 1, i = {}) {
    super(t, e, i), this.isWebGLMultipleRenderTargets = !0;
    let r = this.texture;
    this.texture = [];
    for (let t = 0; t < n; t++) this.texture[t] = r.clone(), this.texture[t].isRenderTargetTexture = !0;
  }
  setSize(t, e, n = 1) {
    if (this.width !== t || this.height !== e || this.depth !== n) {
      this.width = t, this.height = e, this.depth = n;
      for (let i = 0, r = this.texture.length; i < r; i++) this.texture[i].image.width = t, this.texture[i].image.height = e, this.texture[i].image.depth = n;
      this.dispose();
    }
    return this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e), this;
  }
  copy(t) {
    this.dispose(), this.width = t.width, this.height = t.height, this.depth = t.depth, this.scissor.copy(t.scissor), this.scissorTest = t.scissorTest, this.viewport.copy(t.viewport), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, null !== t.depthTexture && (this.depthTexture = t.depthTexture.clone()), this.texture.length = 0;
    for (let e = 0, n = t.texture.length; e < n; e++) this.texture[e] = t.texture[e].clone(), this.texture[e].isRenderTargetTexture = !0;
    return this;
  }
};
u(rx, "WebGLMultipleRenderTargets");
var Vs = class {
  constructor(t = 0, e = 0, n = 0, i = 1) {
    this.isQuaternion = !0, this._x = t, this._y = e, this._z = n, this._w = i;
  }
  static slerpFlat(t, e, n, i, r, o, s) {
    let a = n[i + 0],
      l = n[i + 1],
      u = n[i + 2],
      h = n[i + 3],
      c = r[o + 0],
      p = r[o + 1],
      d = r[o + 2],
      f = r[o + 3];
    if (0 === s) return t[e + 0] = a, t[e + 1] = l, t[e + 2] = u, void (t[e + 3] = h);
    if (1 === s) return t[e + 0] = c, t[e + 1] = p, t[e + 2] = d, void (t[e + 3] = f);
    if (h !== f || a !== c || l !== p || u !== d) {
      let t = 1 - s,
        e = a * c + l * p + u * d + h * f,
        n = e >= 0 ? 1 : -1,
        i = 1 - e * e;
      if (i > Number.EPSILON) {
        let r = Math.sqrt(i),
          o = Math.atan2(r, e * n);
        t = Math.sin(t * o) / r, s = Math.sin(s * o) / r;
      }
      let r = s * n;
      if (a = a * t + c * r, l = l * t + p * r, u = u * t + d * r, h = h * t + f * r, t === 1 - s) {
        let t = 1 / Math.sqrt(a * a + l * l + u * u + h * h);
        a *= t, l *= t, u *= t, h *= t;
      }
    }
    t[e] = a, t[e + 1] = l, t[e + 2] = u, t[e + 3] = h;
  }
  static multiplyQuaternionsFlat(t, e, n, i, r, o) {
    let s = n[i],
      a = n[i + 1],
      l = n[i + 2],
      u = n[i + 3],
      h = r[o],
      c = r[o + 1],
      p = r[o + 2],
      d = r[o + 3];
    return t[e] = s * d + u * h + a * p - l * c, t[e + 1] = a * d + u * c + l * h - s * p, t[e + 2] = l * d + u * p + s * c - a * h, t[e + 3] = u * d - s * h - a * c - l * p, t;
  }
  get x() {
    return this._x;
  }
  set x(t) {
    this._x = t, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(t) {
    this._y = t, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(t) {
    this._z = t, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(t) {
    this._w = t, this._onChangeCallback();
  }
  set(t, e, n, i) {
    return this._x = t, this._y = e, this._z = n, this._w = i, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(t) {
    return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
  }
  setFromEuler(t, e) {
    let n = t._x,
      i = t._y,
      r = t._z,
      o = t._order,
      s = Math.cos,
      a = Math.sin,
      l = s(n / 2),
      u = s(i / 2),
      h = s(r / 2),
      c = a(n / 2),
      p = a(i / 2),
      d = a(r / 2);
    switch (o) {
      case "XYZ":
        this._x = c * u * h + l * p * d, this._y = l * p * h - c * u * d, this._z = l * u * d + c * p * h, this._w = l * u * h - c * p * d;
        break;
      case "YXZ":
        this._x = c * u * h + l * p * d, this._y = l * p * h - c * u * d, this._z = l * u * d - c * p * h, this._w = l * u * h + c * p * d;
        break;
      case "ZXY":
        this._x = c * u * h - l * p * d, this._y = l * p * h + c * u * d, this._z = l * u * d + c * p * h, this._w = l * u * h - c * p * d;
        break;
      case "ZYX":
        this._x = c * u * h - l * p * d, this._y = l * p * h + c * u * d, this._z = l * u * d - c * p * h, this._w = l * u * h + c * p * d;
        break;
      case "YZX":
        this._x = c * u * h + l * p * d, this._y = l * p * h + c * u * d, this._z = l * u * d - c * p * h, this._w = l * u * h - c * p * d;
        break;
      case "XZY":
        this._x = c * u * h - l * p * d, this._y = l * p * h - c * u * d, this._z = l * u * d + c * p * h, this._w = l * u * h + c * p * d;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + o);
    }
    return !1 !== e && this._onChangeCallback(), this;
  }
  setFromAxisAngle(t, e) {
    let n = e / 2,
      i = Math.sin(n);
    return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
  }
  setFromRotationMatrix(t) {
    let e = t.elements,
      n = e[0],
      i = e[4],
      r = e[8],
      o = e[1],
      s = e[5],
      a = e[9],
      l = e[2],
      u = e[6],
      h = e[10],
      c = n + s + h;
    if (c > 0) {
      let t = .5 / Math.sqrt(c + 1);
      this._w = .25 / t, this._x = (u - a) * t, this._y = (r - l) * t, this._z = (o - i) * t;
    } else if (n > s && n > h) {
      let t = 2 * Math.sqrt(1 + n - s - h);
      this._w = (u - a) / t, this._x = .25 * t, this._y = (i + o) / t, this._z = (r + l) / t;
    } else if (s > h) {
      let t = 2 * Math.sqrt(1 + s - n - h);
      this._w = (r - l) / t, this._x = (i + o) / t, this._y = .25 * t, this._z = (a + u) / t;
    } else {
      let t = 2 * Math.sqrt(1 + h - n - s);
      this._w = (o - i) / t, this._x = (r + l) / t, this._y = (a + u) / t, this._z = .25 * t;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(t, e) {
    let n = t.dot(e) + 1;
    return n < Number.EPSILON ? (n = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = n)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = n), this.normalize();
  }
  angleTo(t) {
    return 2 * Math.acos(Math.abs(jo(this.dot(t), -1, 1)));
  }
  rotateTowards(t, e) {
    let n = this.angleTo(t);
    if (0 === n) return this;
    let i = Math.min(1, e / n);
    return this.slerp(t, i), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(t) {
    return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let t = this.length();
    return 0 === t ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
  }
  multiply(t) {
    return this.multiplyQuaternions(this, t);
  }
  premultiply(t) {
    return this.multiplyQuaternions(t, this);
  }
  multiplyQuaternions(t, e) {
    let n = t._x,
      i = t._y,
      r = t._z,
      o = t._w,
      s = e._x,
      a = e._y,
      l = e._z,
      u = e._w;
    return this._x = n * u + o * s + i * l - r * a, this._y = i * u + o * a + r * s - n * l, this._z = r * u + o * l + n * a - i * s, this._w = o * u - n * s - i * a - r * l, this._onChangeCallback(), this;
  }
  slerp(t, e) {
    if (0 === e) return this;
    if (1 === e) return this.copy(t);
    let n = this._x,
      i = this._y,
      r = this._z,
      o = this._w,
      s = o * t._w + n * t._x + i * t._y + r * t._z;
    if (s < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, s = -s) : this.copy(t), s >= 1) return this._w = o, this._x = n, this._y = i, this._z = r, this;
    let a = 1 - s * s;
    if (a <= Number.EPSILON) {
      let t = 1 - e;
      return this._w = t * o + e * this._w, this._x = t * n + e * this._x, this._y = t * i + e * this._y, this._z = t * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
    }
    let l = Math.sqrt(a),
      u = Math.atan2(l, s),
      h = Math.sin((1 - e) * u) / l,
      c = Math.sin(e * u) / l;
    return this._w = o * h + this._w * c, this._x = n * h + this._x * c, this._y = i * h + this._y * c, this._z = r * h + this._z * c, this._onChangeCallback(), this;
  }
  slerpQuaternions(t, e, n) {
    return this.copy(t).slerp(e, n);
  }
  random() {
    let t = Math.random(),
      e = Math.sqrt(1 - t),
      n = Math.sqrt(t),
      i = 2 * Math.PI * Math.random(),
      r = 2 * Math.PI * Math.random();
    return this.set(e * Math.cos(i), n * Math.sin(r), n * Math.cos(r), e * Math.sin(i));
  }
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
  }
  fromArray(t, e = 0) {
    return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
  }
  fromBufferAttribute(t, e) {
    return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(t) {
    return this._onChangeCallback = t, this;
  }
  _onChangeCallback() {}
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
};
u(Vs, "Quaternion");
var ne = class {
  constructor(t = 0, e = 0, n = 0) {
    ne.prototype.isVector3 = !0, this.x = t, this.y = e, this.z = n;
  }
  set(t, e, n) {
    return void 0 === n && (n = this.z), this.x = t, this.y = e, this.z = n, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setZ(t) {
    return this.z = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      case 2:
        this.z = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this;
  }
  multiplyVectors(t, e) {
    return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
  }
  applyEuler(t) {
    return this.applyQuaternion(QI.setFromEuler(t));
  }
  applyAxisAngle(t, e) {
    return this.applyQuaternion(QI.setFromAxisAngle(t, e));
  }
  applyMatrix3(t) {
    let e = this.x,
      n = this.y,
      i = this.z,
      r = t.elements;
    return this.x = r[0] * e + r[3] * n + r[6] * i, this.y = r[1] * e + r[4] * n + r[7] * i, this.z = r[2] * e + r[5] * n + r[8] * i, this;
  }
  applyNormalMatrix(t) {
    return this.applyMatrix3(t).normalize();
  }
  applyMatrix4(t) {
    let e = this.x,
      n = this.y,
      i = this.z,
      r = t.elements,
      o = 1 / (r[3] * e + r[7] * n + r[11] * i + r[15]);
    return this.x = (r[0] * e + r[4] * n + r[8] * i + r[12]) * o, this.y = (r[1] * e + r[5] * n + r[9] * i + r[13]) * o, this.z = (r[2] * e + r[6] * n + r[10] * i + r[14]) * o, this;
  }
  applyQuaternion(t) {
    let e = this.x,
      n = this.y,
      i = this.z,
      r = t.x,
      o = t.y,
      s = t.z,
      a = t.w,
      l = a * e + o * i - s * n,
      u = a * n + s * e - r * i,
      h = a * i + r * n - o * e,
      c = -r * e - o * n - s * i;
    return this.x = l * a + c * -r + u * -s - h * -o, this.y = u * a + c * -o + h * -r - l * -s, this.z = h * a + c * -s + l * -o - u * -r, this;
  }
  project(t) {
    return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
  }
  unproject(t) {
    return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
  }
  transformDirection(t) {
    let e = this.x,
      n = this.y,
      i = this.z,
      r = t.elements;
    return this.x = r[0] * e + r[4] * n + r[8] * i, this.y = r[1] * e + r[5] * n + r[9] * i, this.z = r[2] * e + r[6] * n + r[10] * i, this.normalize();
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
  }
  clamp(t, e) {
    return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
  }
  clampScalar(t, e) {
    return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this;
  }
  clampLength(t, e) {
    let n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
  }
  lerpVectors(t, e, n) {
    return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this;
  }
  cross(t) {
    return this.crossVectors(this, t);
  }
  crossVectors(t, e) {
    let n = t.x,
      i = t.y,
      r = t.z,
      o = e.x,
      s = e.y,
      a = e.z;
    return this.x = i * a - r * s, this.y = r * o - n * a, this.z = n * s - i * o, this;
  }
  projectOnVector(t) {
    let e = t.lengthSq();
    if (0 === e) return this.set(0, 0, 0);
    let n = t.dot(this) / e;
    return this.copy(t).multiplyScalar(n);
  }
  projectOnPlane(t) {
    return H3.copy(this).projectOnVector(t), this.sub(H3);
  }
  reflect(t) {
    return this.sub(H3.copy(t).multiplyScalar(2 * this.dot(t)));
  }
  angleTo(t) {
    let e = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (0 === e) return Math.PI / 2;
    let n = this.dot(t) / e;
    return Math.acos(jo(n, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    let e = this.x - t.x,
      n = this.y - t.y,
      i = this.z - t.z;
    return e * e + n * n + i * i;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
  }
  setFromSpherical(t) {
    return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
  }
  setFromSphericalCoords(t, e, n) {
    let i = Math.sin(e) * t;
    return this.x = i * Math.sin(n), this.y = Math.cos(e) * t, this.z = i * Math.cos(n), this;
  }
  setFromCylindrical(t) {
    return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
  }
  setFromCylindricalCoords(t, e, n) {
    return this.x = t * Math.sin(e), this.y = n, this.z = t * Math.cos(e), this;
  }
  setFromMatrixPosition(t) {
    let e = t.elements;
    return this.x = e[12], this.y = e[13], this.z = e[14], this;
  }
  setFromMatrixScale(t) {
    let e = this.setFromMatrixColumn(t, 0).length(),
      n = this.setFromMatrixColumn(t, 1).length(),
      i = this.setFromMatrixColumn(t, 2).length();
    return this.x = e, this.y = n, this.z = i, this;
  }
  setFromMatrixColumn(t, e) {
    return this.fromArray(t.elements, 4 * e);
  }
  setFromMatrix3Column(t, e) {
    return this.fromArray(t.elements, 3 * e);
  }
  setFromEuler(t) {
    return this.x = t._x, this.y = t._y, this.z = t._z, this;
  }
  setFromColor(t) {
    return this.x = t.r, this.y = t.g, this.z = t.b, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    let t = 2 * (Math.random() - .5),
      e = Math.random() * Math.PI * 2,
      n = Math.sqrt(1 - t ** 2);
    return this.x = n * Math.cos(e), this.y = n * Math.sin(e), this.z = t, this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
};
u(ne, "Vector3");
var H3 = new ne(),
  QI = new Vs(),
  $t = class {
    constructor(t = new ne(1 / 0, 1 / 0, 1 / 0), e = new ne(-1 / 0, -1 / 0, -1 / 0)) {
      this.isBox3 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
      return this.min.copy(t), this.max.copy(e), this;
    }
    setFromArray(t) {
      this.makeEmpty();
      for (let e = 0, n = t.length; e < n; e += 3) this.expandByPoint(qu.fromArray(t, e));
      return this;
    }
    setFromBufferAttribute(t) {
      this.makeEmpty();
      for (let e = 0, n = t.count; e < n; e++) this.expandByPoint(qu.fromBufferAttribute(t, e));
      return this;
    }
    setFromPoints(t) {
      this.makeEmpty();
      for (let e = 0, n = t.length; e < n; e++) this.expandByPoint(t[e]);
      return this;
    }
    setFromCenterAndSize(t, e) {
      let n = qu.copy(e).multiplyScalar(.5);
      return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
    }
    setFromObject(t, e = !1) {
      return this.makeEmpty(), this.expandByObject(t, e);
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(t) {
      return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
      return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
      return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(t) {
      return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
      return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
      return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
      return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
      return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    expandByObject(t, e = !1) {
      if (t.updateWorldMatrix(!1, !1), void 0 !== t.boundingBox) null === t.boundingBox && t.computeBoundingBox(), Qp.copy(t.boundingBox), Qp.applyMatrix4(t.matrixWorld), this.union(Qp);else {
        let n = t.geometry;
        if (void 0 !== n) if (e && void 0 !== n.attributes && void 0 !== n.attributes.position) {
          let e = n.attributes.position;
          for (let n = 0, i = e.count; n < i; n++) qu.fromBufferAttribute(e, n).applyMatrix4(t.matrixWorld), this.expandByPoint(qu);
        } else null === n.boundingBox && n.computeBoundingBox(), Qp.copy(n.boundingBox), Qp.applyMatrix4(t.matrixWorld), this.union(Qp);
      }
      let n = t.children;
      for (let t = 0, i = n.length; t < i; t++) this.expandByObject(n[t], e);
      return this;
    }
    containsPoint(t) {
      return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
    }
    containsBox(t) {
      return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }
    getParameter(t, e) {
      return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(t) {
      return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
    }
    intersectsSphere(t) {
      return this.clampPoint(t.center, qu), qu.distanceToSquared(t.center) <= t.radius * t.radius;
    }
    intersectsPlane(t) {
      let e, n;
      return t.normal.x > 0 ? (e = t.normal.x * this.min.x, n = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, n = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, n += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, n += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, n += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, n += t.normal.z * this.min.z), e <= -t.constant && n >= -t.constant;
    }
    intersectsTriangle(t) {
      if (this.isEmpty()) return !1;
      this.getCenter(qg), ox.subVectors(this.max, qg), $p.subVectors(t.a, qg), ed.subVectors(t.b, qg), td.subVectors(t.c, qg), Xc.subVectors(ed, $p), Yc.subVectors(td, ed), af.subVectors($p, td);
      let e = [0, -Xc.z, Xc.y, 0, -Yc.z, Yc.y, 0, -af.z, af.y, Xc.z, 0, -Xc.x, Yc.z, 0, -Yc.x, af.z, 0, -af.x, -Xc.y, Xc.x, 0, -Yc.y, Yc.x, 0, -af.y, af.x, 0];
      return !(!j3(e, $p, ed, td, ox) || (e = [1, 0, 0, 0, 1, 0, 0, 0, 1], !j3(e, $p, ed, td, ox))) && (sx.crossVectors(Xc, Yc), e = [sx.x, sx.y, sx.z], j3(e, $p, ed, td, ox));
    }
    clampPoint(t, e) {
      return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
      return this.clampPoint(t, qu).distanceTo(t);
    }
    getBoundingSphere(t) {
      return this.isEmpty() ? t.makeEmpty() : (this.getCenter(t.center), t.radius = .5 * this.getSize(qu).length()), t;
    }
    intersect(t) {
      return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(t) {
      return this.min.min(t.min), this.max.max(t.max), this;
    }
    applyMatrix4(t) {
      return this.isEmpty() || (Du[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), Du[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), Du[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), Du[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), Du[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), Du[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), Du[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), Du[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(Du)), this;
    }
    translate(t) {
      return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
      return t.min.equals(this.min) && t.max.equals(this.max);
    }
  };
u($t, "Box3");
var Du = [new ne(), new ne(), new ne(), new ne(), new ne(), new ne(), new ne(), new ne()],
  qu = new ne(),
  Qp = new $t(),
  $p = new ne(),
  ed = new ne(),
  td = new ne(),
  Xc = new ne(),
  Yc = new ne(),
  af = new ne(),
  qg = new ne(),
  ox = new ne(),
  sx = new ne(),
  lf = new ne();
function j3(t, e, n, i, r) {
  for (let o = 0, s = t.length - 3; o <= s; o += 3) {
    lf.fromArray(t, o);
    let s = r.x * Math.abs(lf.x) + r.y * Math.abs(lf.y) + r.z * Math.abs(lf.z),
      a = e.dot(lf),
      l = n.dot(lf),
      u = i.dot(lf);
    if (Math.max(-Math.max(a, l, u), Math.min(a, l, u)) > s) return !1;
  }
  return !0;
}
u(j3, "satForAxes");
var GV = new $t(),
  kg = new ne(),
  W3 = new ne(),
  Zc = class {
    constructor(t = new ne(), e = -1) {
      this.center = t, this.radius = e;
    }
    set(t, e) {
      return this.center.copy(t), this.radius = e, this;
    }
    setFromPoints(t, e) {
      let n = this.center;
      void 0 !== e ? n.copy(e) : GV.setFromPoints(t).getCenter(n);
      let i = 0;
      for (let e = 0, r = t.length; e < r; e++) i = Math.max(i, n.distanceToSquared(t[e]));
      return this.radius = Math.sqrt(i), this;
    }
    copy(t) {
      return this.center.copy(t.center), this.radius = t.radius, this;
    }
    isEmpty() {
      return this.radius < 0;
    }
    makeEmpty() {
      return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(t) {
      return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(t) {
      return t.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(t) {
      let e = this.radius + t.radius;
      return t.center.distanceToSquared(this.center) <= e * e;
    }
    intersectsBox(t) {
      return t.intersectsSphere(this);
    }
    intersectsPlane(t) {
      return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(t, e) {
      let n = this.center.distanceToSquared(t);
      return e.copy(t), n > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
    getBoundingBox(t) {
      return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
    }
    applyMatrix4(t) {
      return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }
    translate(t) {
      return this.center.add(t), this;
    }
    expandByPoint(t) {
      if (this.isEmpty()) return this.center.copy(t), this.radius = 0, this;
      kg.subVectors(t, this.center);
      let e = kg.lengthSq();
      if (e > this.radius * this.radius) {
        let t = Math.sqrt(e),
          n = .5 * (t - this.radius);
        this.center.addScaledVector(kg, n / t), this.radius += n;
      }
      return this;
    }
    union(t) {
      return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (!0 === this.center.equals(t.center) ? this.radius = Math.max(this.radius, t.radius) : (W3.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint(kg.copy(t.center).add(W3)), this.expandByPoint(kg.copy(t.center).sub(W3))), this);
    }
    equals(t) {
      return t.center.equals(this.center) && t.radius === this.radius;
    }
    clone() {
      return new this.constructor().copy(this);
    }
  };
u(Zc, "Sphere");
var ku = new ne(),
  X3 = new ne(),
  ax = new ne(),
  Jc = new ne(),
  Y3 = new ne(),
  lx = new ne(),
  Z3 = new ne(),
  Fg = class {
    constructor(t = new ne(), e = new ne(0, 0, -1)) {
      this.origin = t, this.direction = e;
    }
    set(t, e) {
      return this.origin.copy(t), this.direction.copy(e), this;
    }
    copy(t) {
      return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }
    at(t, e) {
      return e.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(t) {
      return this.direction.copy(t).sub(this.origin).normalize(), this;
    }
    recast(t) {
      return this.origin.copy(this.at(t, ku)), this;
    }
    closestPointToPoint(t, e) {
      e.subVectors(t, this.origin);
      let n = e.dot(this.direction);
      return n < 0 ? e.copy(this.origin) : e.copy(this.origin).addScaledVector(this.direction, n);
    }
    distanceToPoint(t) {
      return Math.sqrt(this.distanceSqToPoint(t));
    }
    distanceSqToPoint(t) {
      let e = ku.subVectors(t, this.origin).dot(this.direction);
      return e < 0 ? this.origin.distanceToSquared(t) : (ku.copy(this.origin).addScaledVector(this.direction, e), ku.distanceToSquared(t));
    }
    distanceSqToSegment(t, e, n, i) {
      X3.copy(t).add(e).multiplyScalar(.5), ax.copy(e).sub(t).normalize(), Jc.copy(this.origin).sub(X3);
      let r,
        o,
        s,
        a,
        l = .5 * t.distanceTo(e),
        u = -this.direction.dot(ax),
        h = Jc.dot(this.direction),
        c = -Jc.dot(ax),
        p = Jc.lengthSq(),
        d = Math.abs(1 - u * u);
      if (d > 0) {
        if (r = u * c - h, o = u * h - c, a = l * d, r >= 0) {
          if (o >= -a) {
            if (o <= a) {
              let t = 1 / d;
              r *= t, o *= t, s = r * (r + u * o + 2 * h) + o * (u * r + o + 2 * c) + p;
            } else o = l, r = Math.max(0, -(u * o + h)), s = -r * r + o * (o + 2 * c) + p;
          } else o = -l, r = Math.max(0, -(u * o + h)), s = -r * r + o * (o + 2 * c) + p;
        } else o <= -a ? (r = Math.max(0, -(-u * l + h)), o = r > 0 ? -l : Math.min(Math.max(-l, -c), l), s = -r * r + o * (o + 2 * c) + p) : o <= a ? (r = 0, o = Math.min(Math.max(-l, -c), l), s = o * (o + 2 * c) + p) : (r = Math.max(0, -(u * l + h)), o = r > 0 ? l : Math.min(Math.max(-l, -c), l), s = -r * r + o * (o + 2 * c) + p);
      } else o = u > 0 ? -l : l, r = Math.max(0, -(u * o + h)), s = -r * r + o * (o + 2 * c) + p;
      return n && n.copy(this.origin).addScaledVector(this.direction, r), i && i.copy(X3).addScaledVector(ax, o), s;
    }
    intersectSphere(t, e) {
      ku.subVectors(t.center, this.origin);
      let n = ku.dot(this.direction),
        i = ku.dot(ku) - n * n,
        r = t.radius * t.radius;
      if (i > r) return null;
      let o = Math.sqrt(r - i),
        s = n - o,
        a = n + o;
      return a < 0 ? null : s < 0 ? this.at(a, e) : this.at(s, e);
    }
    intersectsSphere(t) {
      return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
    }
    distanceToPlane(t) {
      let e = t.normal.dot(this.direction);
      if (0 === e) return 0 === t.distanceToPoint(this.origin) ? 0 : null;
      let n = -(this.origin.dot(t.normal) + t.constant) / e;
      return n >= 0 ? n : null;
    }
    intersectPlane(t, e) {
      let n = this.distanceToPlane(t);
      return null === n ? null : this.at(n, e);
    }
    intersectsPlane(t) {
      let e = t.distanceToPoint(this.origin);
      return 0 === e || t.normal.dot(this.direction) * e < 0;
    }
    intersectBox(t, e) {
      let n,
        i,
        r,
        o,
        s,
        a,
        l = 1 / this.direction.x,
        u = 1 / this.direction.y,
        h = 1 / this.direction.z,
        c = this.origin;
      return l >= 0 ? (n = (t.min.x - c.x) * l, i = (t.max.x - c.x) * l) : (n = (t.max.x - c.x) * l, i = (t.min.x - c.x) * l), u >= 0 ? (r = (t.min.y - c.y) * u, o = (t.max.y - c.y) * u) : (r = (t.max.y - c.y) * u, o = (t.min.y - c.y) * u), n > o || r > i || ((r > n || isNaN(n)) && (n = r), (o < i || isNaN(i)) && (i = o), h >= 0 ? (s = (t.min.z - c.z) * h, a = (t.max.z - c.z) * h) : (s = (t.max.z - c.z) * h, a = (t.min.z - c.z) * h), n > a || s > i) || ((s > n || n != n) && (n = s), (a < i || i != i) && (i = a), i < 0) ? null : this.at(n >= 0 ? n : i, e);
    }
    intersectsBox(t) {
      return null !== this.intersectBox(t, ku);
    }
    intersectTriangle(t, e, n, i, r) {
      Y3.subVectors(e, t), lx.subVectors(n, t), Z3.crossVectors(Y3, lx);
      let o,
        s = this.direction.dot(Z3);
      if (s > 0) {
        if (i) return null;
        o = 1;
      } else {
        if (!(s < 0)) return null;
        o = -1, s = -s;
      }
      Jc.subVectors(this.origin, t);
      let a = o * this.direction.dot(lx.crossVectors(Jc, lx));
      if (a < 0) return null;
      let l = o * this.direction.dot(Y3.cross(Jc));
      if (l < 0 || a + l > s) return null;
      let u = -o * Jc.dot(Z3);
      return u < 0 ? null : this.at(u / s, r);
    }
    applyMatrix4(t) {
      return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
    }
    equals(t) {
      return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    }
    clone() {
      return new this.constructor().copy(this);
    }
  };
u(Fg, "Ray");
var Bt = class {
  constructor(t, e, n, i, r, o, s, a, l, u, h, c, p, d, f, m) {
    Bt.prototype.isMatrix4 = !0, this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], void 0 !== t && this.set(t, e, n, i, r, o, s, a, l, u, h, c, p, d, f, m);
  }
  set(t, e, n, i, r, o, s, a, l, u, h, c, p, d, f, m) {
    let g = this.elements;
    return g[0] = t, g[4] = e, g[8] = n, g[12] = i, g[1] = r, g[5] = o, g[9] = s, g[13] = a, g[2] = l, g[6] = u, g[10] = h, g[14] = c, g[3] = p, g[7] = d, g[11] = f, g[15] = m, this;
  }
  identity() {
    return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
  }
  clone() {
    return new Bt().fromArray(this.elements);
  }
  copy(t) {
    let e = this.elements,
      n = t.elements;
    return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], e[9] = n[9], e[10] = n[10], e[11] = n[11], e[12] = n[12], e[13] = n[13], e[14] = n[14], e[15] = n[15], this;
  }
  copyPosition(t) {
    let e = this.elements,
      n = t.elements;
    return e[12] = n[12], e[13] = n[13], e[14] = n[14], this;
  }
  setFromMatrix3(t) {
    let e = t.elements;
    return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
  }
  extractBasis(t, e, n) {
    return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
  }
  makeBasis(t, e, n) {
    return this.set(t.x, e.x, n.x, 0, t.y, e.y, n.y, 0, t.z, e.z, n.z, 0, 0, 0, 0, 1), this;
  }
  extractRotation(t) {
    let e = this.elements,
      n = t.elements,
      i = 1 / nd.setFromMatrixColumn(t, 0).length(),
      r = 1 / nd.setFromMatrixColumn(t, 1).length(),
      o = 1 / nd.setFromMatrixColumn(t, 2).length();
    return e[0] = n[0] * i, e[1] = n[1] * i, e[2] = n[2] * i, e[3] = 0, e[4] = n[4] * r, e[5] = n[5] * r, e[6] = n[6] * r, e[7] = 0, e[8] = n[8] * o, e[9] = n[9] * o, e[10] = n[10] * o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
  }
  makeRotationFromEuler(t) {
    let e = this.elements,
      n = t.x,
      i = t.y,
      r = t.z,
      o = Math.cos(n),
      s = Math.sin(n),
      a = Math.cos(i),
      l = Math.sin(i),
      u = Math.cos(r),
      h = Math.sin(r);
    if ("XYZ" === t.order) {
      let t = o * u,
        n = o * h,
        i = s * u,
        r = s * h;
      e[0] = a * u, e[4] = -a * h, e[8] = l, e[1] = n + i * l, e[5] = t - r * l, e[9] = -s * a, e[2] = r - t * l, e[6] = i + n * l, e[10] = o * a;
    } else if ("YXZ" === t.order) {
      let t = a * u,
        n = a * h,
        i = l * u,
        r = l * h;
      e[0] = t + r * s, e[4] = i * s - n, e[8] = o * l, e[1] = o * h, e[5] = o * u, e[9] = -s, e[2] = n * s - i, e[6] = r + t * s, e[10] = o * a;
    } else if ("ZXY" === t.order) {
      let t = a * u,
        n = a * h,
        i = l * u,
        r = l * h;
      e[0] = t - r * s, e[4] = -o * h, e[8] = i + n * s, e[1] = n + i * s, e[5] = o * u, e[9] = r - t * s, e[2] = -o * l, e[6] = s, e[10] = o * a;
    } else if ("ZYX" === t.order) {
      let t = o * u,
        n = o * h,
        i = s * u,
        r = s * h;
      e[0] = a * u, e[4] = i * l - n, e[8] = t * l + r, e[1] = a * h, e[5] = r * l + t, e[9] = n * l - i, e[2] = -l, e[6] = s * a, e[10] = o * a;
    } else if ("YZX" === t.order) {
      let t = o * a,
        n = o * l,
        i = s * a,
        r = s * l;
      e[0] = a * u, e[4] = r - t * h, e[8] = i * h + n, e[1] = h, e[5] = o * u, e[9] = -s * u, e[2] = -l * u, e[6] = n * h + i, e[10] = t - r * h;
    } else if ("XZY" === t.order) {
      let t = o * a,
        n = o * l,
        i = s * a,
        r = s * l;
      e[0] = a * u, e[4] = -h, e[8] = l * u, e[1] = t * h + r, e[5] = o * u, e[9] = n * h - i, e[2] = i * h - n, e[6] = s * u, e[10] = r * h + t;
    }
    return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
  }
  makeRotationFromQuaternion(t) {
    return this.compose(HV, t, jV);
  }
  lookAt(t, e, n) {
    let i = this.elements;
    return Gs.subVectors(t, e), 0 === Gs.lengthSq() && (Gs.z = 1), Gs.normalize(), Kc.crossVectors(n, Gs), 0 === Kc.lengthSq() && (1 === Math.abs(n.z) ? Gs.x += 1e-4 : Gs.z += 1e-4, Gs.normalize(), Kc.crossVectors(n, Gs)), Kc.normalize(), ux.crossVectors(Gs, Kc), i[0] = Kc.x, i[4] = ux.x, i[8] = Gs.x, i[1] = Kc.y, i[5] = ux.y, i[9] = Gs.y, i[2] = Kc.z, i[6] = ux.z, i[10] = Gs.z, this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyMatrices(t, e) {
    let n = t.elements,
      i = e.elements,
      r = this.elements,
      o = n[0],
      s = n[4],
      a = n[8],
      l = n[12],
      u = n[1],
      h = n[5],
      c = n[9],
      p = n[13],
      d = n[2],
      f = n[6],
      m = n[10],
      g = n[14],
      v = n[3],
      y = n[7],
      _ = n[11],
      x = n[15],
      E = i[0],
      b = i[4],
      w = i[8],
      S = i[12],
      M = i[1],
      T = i[5],
      A = i[9],
      P = i[13],
      C = i[2],
      I = i[6],
      N = i[10],
      L = i[14],
      R = i[3],
      O = i[7],
      q = i[11],
      D = i[15];
    return r[0] = o * E + s * M + a * C + l * R, r[4] = o * b + s * T + a * I + l * O, r[8] = o * w + s * A + a * N + l * q, r[12] = o * S + s * P + a * L + l * D, r[1] = u * E + h * M + c * C + p * R, r[5] = u * b + h * T + c * I + p * O, r[9] = u * w + h * A + c * N + p * q, r[13] = u * S + h * P + c * L + p * D, r[2] = d * E + f * M + m * C + g * R, r[6] = d * b + f * T + m * I + g * O, r[10] = d * w + f * A + m * N + g * q, r[14] = d * S + f * P + m * L + g * D, r[3] = v * E + y * M + _ * C + x * R, r[7] = v * b + y * T + _ * I + x * O, r[11] = v * w + y * A + _ * N + x * q, r[15] = v * S + y * P + _ * L + x * D, this;
  }
  multiplyScalar(t) {
    let e = this.elements;
    return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
  }
  determinant() {
    let t = this.elements,
      e = t[0],
      n = t[4],
      i = t[8],
      r = t[12],
      o = t[1],
      s = t[5],
      a = t[9],
      l = t[13],
      u = t[2],
      h = t[6],
      c = t[10],
      p = t[14];
    return t[3] * (+r * a * h - i * l * h - r * s * c + n * l * c + i * s * p - n * a * p) + t[7] * (+e * a * p - e * l * c + r * o * c - i * o * p + i * l * u - r * a * u) + t[11] * (+e * l * h - e * s * p - r * o * h + n * o * p + r * s * u - n * l * u) + t[15] * (-i * s * u - e * a * h + e * s * c + i * o * h - n * o * c + n * a * u);
  }
  transpose() {
    let t,
      e = this.elements;
    return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
  }
  setPosition(t, e, n) {
    let i = this.elements;
    return t.isVector3 ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : (i[12] = t, i[13] = e, i[14] = n), this;
  }
  invert() {
    let t = this.elements,
      e = t[0],
      n = t[1],
      i = t[2],
      r = t[3],
      o = t[4],
      s = t[5],
      a = t[6],
      l = t[7],
      u = t[8],
      h = t[9],
      c = t[10],
      p = t[11],
      d = t[12],
      f = t[13],
      m = t[14],
      g = t[15],
      v = h * m * l - f * c * l + f * a * p - s * m * p - h * a * g + s * c * g,
      y = d * c * l - u * m * l - d * a * p + o * m * p + u * a * g - o * c * g,
      _ = u * f * l - d * h * l + d * s * p - o * f * p - u * s * g + o * h * g,
      x = d * h * a - u * f * a - d * s * c + o * f * c + u * s * m - o * h * m,
      E = e * v + n * y + i * _ + r * x;
    if (0 === E) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    let b = 1 / E;
    return t[0] = v * b, t[1] = (f * c * r - h * m * r - f * i * p + n * m * p + h * i * g - n * c * g) * b, t[2] = (s * m * r - f * a * r + f * i * l - n * m * l - s * i * g + n * a * g) * b, t[3] = (h * a * r - s * c * r - h * i * l + n * c * l + s * i * p - n * a * p) * b, t[4] = y * b, t[5] = (u * m * r - d * c * r + d * i * p - e * m * p - u * i * g + e * c * g) * b, t[6] = (d * a * r - o * m * r - d * i * l + e * m * l + o * i * g - e * a * g) * b, t[7] = (o * c * r - u * a * r + u * i * l - e * c * l - o * i * p + e * a * p) * b, t[8] = _ * b, t[9] = (d * h * r - u * f * r - d * n * p + e * f * p + u * n * g - e * h * g) * b, t[10] = (o * f * r - d * s * r + d * n * l - e * f * l - o * n * g + e * s * g) * b, t[11] = (u * s * r - o * h * r - u * n * l + e * h * l + o * n * p - e * s * p) * b, t[12] = x * b, t[13] = (u * f * i - d * h * i + d * n * c - e * f * c - u * n * m + e * h * m) * b, t[14] = (d * s * i - o * f * i - d * n * a + e * f * a + o * n * m - e * s * m) * b, t[15] = (o * h * i - u * s * i + u * n * a - e * h * a - o * n * c + e * s * c) * b, this;
  }
  scale(t) {
    let e = this.elements,
      n = t.x,
      i = t.y,
      r = t.z;
    return e[0] *= n, e[4] *= i, e[8] *= r, e[1] *= n, e[5] *= i, e[9] *= r, e[2] *= n, e[6] *= i, e[10] *= r, e[3] *= n, e[7] *= i, e[11] *= r, this;
  }
  getMaxScaleOnAxis() {
    let t = this.elements,
      e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2],
      n = t[4] * t[4] + t[5] * t[5] + t[6] * t[6],
      i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
    return Math.sqrt(Math.max(e, n, i));
  }
  makeTranslation(t, e, n) {
    return t.isVector3 ? this.set(1, 0, 0, t.x, 0, 1, 0, t.y, 0, 0, 1, t.z, 0, 0, 0, 1) : this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, n, 0, 0, 0, 1), this;
  }
  makeRotationX(t) {
    let e = Math.cos(t),
      n = Math.sin(t);
    return this.set(1, 0, 0, 0, 0, e, -n, 0, 0, n, e, 0, 0, 0, 0, 1), this;
  }
  makeRotationY(t) {
    let e = Math.cos(t),
      n = Math.sin(t);
    return this.set(e, 0, n, 0, 0, 1, 0, 0, -n, 0, e, 0, 0, 0, 0, 1), this;
  }
  makeRotationZ(t) {
    let e = Math.cos(t),
      n = Math.sin(t);
    return this.set(e, -n, 0, 0, n, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
  }
  makeRotationAxis(t, e) {
    let n = Math.cos(e),
      i = Math.sin(e),
      r = 1 - n,
      o = t.x,
      s = t.y,
      a = t.z,
      l = r * o,
      u = r * s;
    return this.set(l * o + n, l * s - i * a, l * a + i * s, 0, l * s + i * a, u * s + n, u * a - i * o, 0, l * a - i * s, u * a + i * o, r * a * a + n, 0, 0, 0, 0, 1), this;
  }
  makeScale(t, e, n) {
    return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
  }
  makeShear(t, e, n, i, r, o) {
    return this.set(1, n, r, 0, t, 1, o, 0, e, i, 1, 0, 0, 0, 0, 1), this;
  }
  compose(t, e, n) {
    let i = this.elements,
      r = e._x,
      o = e._y,
      s = e._z,
      a = e._w,
      l = r + r,
      u = o + o,
      h = s + s,
      c = r * l,
      p = r * u,
      d = r * h,
      f = o * u,
      m = o * h,
      g = s * h,
      v = a * l,
      y = a * u,
      _ = a * h,
      x = n.x,
      E = n.y,
      b = n.z;
    return i[0] = (1 - (f + g)) * x, i[1] = (p + _) * x, i[2] = (d - y) * x, i[3] = 0, i[4] = (p - _) * E, i[5] = (1 - (c + g)) * E, i[6] = (m + v) * E, i[7] = 0, i[8] = (d + y) * b, i[9] = (m - v) * b, i[10] = (1 - (c + f)) * b, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
  }
  decompose(t, e, n) {
    let i = this.elements,
      r = nd.set(i[0], i[1], i[2]).length(),
      o = nd.set(i[4], i[5], i[6]).length(),
      s = nd.set(i[8], i[9], i[10]).length();
    this.determinant() < 0 && (r = -r), t.x = i[12], t.y = i[13], t.z = i[14], Ya.copy(this);
    let a = 1 / r,
      l = 1 / o,
      u = 1 / s;
    return Ya.elements[0] *= a, Ya.elements[1] *= a, Ya.elements[2] *= a, Ya.elements[4] *= l, Ya.elements[5] *= l, Ya.elements[6] *= l, Ya.elements[8] *= u, Ya.elements[9] *= u, Ya.elements[10] *= u, e.setFromRotationMatrix(Ya), n.x = r, n.y = o, n.z = s, this;
  }
  makePerspective(t, e, n, i, r, o, s = Nu) {
    let a,
      l,
      u = this.elements,
      h = 2 * r / (e - t),
      c = 2 * r / (n - i),
      p = (e + t) / (e - t),
      d = (n + i) / (n - i);
    if (s === Nu) a = -(o + r) / (o - r), l = -2 * o * r / (o - r);else {
      if (s !== $_) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
      a = -o / (o - r), l = -o * r / (o - r);
    }
    return u[0] = h, u[4] = 0, u[8] = p, u[12] = 0, u[1] = 0, u[5] = c, u[9] = d, u[13] = 0, u[2] = 0, u[6] = 0, u[10] = a, u[14] = l, u[3] = 0, u[7] = 0, u[11] = -1, u[15] = 0, this;
  }
  makeOrthographic(t, e, n, i, r, o, s = Nu) {
    let a,
      l,
      u = this.elements,
      h = 1 / (e - t),
      c = 1 / (n - i),
      p = 1 / (o - r),
      d = (e + t) * h,
      f = (n + i) * c;
    if (s === Nu) a = (o + r) * p, l = -2 * p;else {
      if (s !== $_) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
      a = r * p, l = -1 * p;
    }
    return u[0] = 2 * h, u[4] = 0, u[8] = 0, u[12] = -d, u[1] = 0, u[5] = 2 * c, u[9] = 0, u[13] = -f, u[2] = 0, u[6] = 0, u[10] = l, u[14] = -a, u[3] = 0, u[7] = 0, u[11] = 0, u[15] = 1, this;
  }
  equals(t) {
    let e = this.elements,
      n = t.elements;
    for (let t = 0; t < 16; t++) if (e[t] !== n[t]) return !1;
    return !0;
  }
  fromArray(t, e = 0) {
    for (let n = 0; n < 16; n++) this.elements[n] = t[n + e];
    return this;
  }
  toArray(t = [], e = 0) {
    let n = this.elements;
    return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t[e + 9] = n[9], t[e + 10] = n[10], t[e + 11] = n[11], t[e + 12] = n[12], t[e + 13] = n[13], t[e + 14] = n[14], t[e + 15] = n[15], t;
  }
};
u(Bt, "Matrix4");
var nd = new ne(),
  Ya = new Bt(),
  HV = new ne(0, 0, 0),
  jV = new ne(1, 1, 1),
  Kc = new ne(),
  ux = new ne(),
  Gs = new ne(),
  $I = new Bt(),
  e8 = new Vs(),
  Qc = class {
    constructor(t = 0, e = 0, n = 0, i = Qc.DEFAULT_ORDER) {
      this.isEuler = !0, this._x = t, this._y = e, this._z = n, this._order = i;
    }
    get x() {
      return this._x;
    }
    set x(t) {
      this._x = t, this._onChangeCallback();
    }
    get y() {
      return this._y;
    }
    set y(t) {
      this._y = t, this._onChangeCallback();
    }
    get z() {
      return this._z;
    }
    set z(t) {
      this._z = t, this._onChangeCallback();
    }
    get order() {
      return this._order;
    }
    set order(t) {
      this._order = t, this._onChangeCallback();
    }
    set(t, e, n, i = this._order) {
      return this._x = t, this._y = e, this._z = n, this._order = i, this._onChangeCallback(), this;
    }
    clone() {
      return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(t) {
      return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t, e = this._order, n = !0) {
      let i = t.elements,
        r = i[0],
        o = i[4],
        s = i[8],
        a = i[1],
        l = i[5],
        u = i[9],
        h = i[2],
        c = i[6],
        p = i[10];
      switch (e) {
        case "XYZ":
          this._y = Math.asin(jo(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-u, p), this._z = Math.atan2(-o, r)) : (this._x = Math.atan2(c, l), this._z = 0);
          break;
        case "YXZ":
          this._x = Math.asin(-jo(u, -1, 1)), Math.abs(u) < .9999999 ? (this._y = Math.atan2(s, p), this._z = Math.atan2(a, l)) : (this._y = Math.atan2(-h, r), this._z = 0);
          break;
        case "ZXY":
          this._x = Math.asin(jo(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(-h, p), this._z = Math.atan2(-o, l)) : (this._y = 0, this._z = Math.atan2(a, r));
          break;
        case "ZYX":
          this._y = Math.asin(-jo(h, -1, 1)), Math.abs(h) < .9999999 ? (this._x = Math.atan2(c, p), this._z = Math.atan2(a, r)) : (this._x = 0, this._z = Math.atan2(-o, l));
          break;
        case "YZX":
          this._z = Math.asin(jo(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-u, l), this._y = Math.atan2(-h, r)) : (this._x = 0, this._y = Math.atan2(s, p));
          break;
        case "XZY":
          this._z = Math.asin(-jo(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(c, l), this._y = Math.atan2(s, r)) : (this._x = Math.atan2(-u, p), this._y = 0);
          break;
        default:
          console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
      }
      return this._order = e, !0 === n && this._onChangeCallback(), this;
    }
    setFromQuaternion(t, e, n) {
      return $I.makeRotationFromQuaternion(t), this.setFromRotationMatrix($I, e, n);
    }
    setFromVector3(t, e = this._order) {
      return this.set(t.x, t.y, t.z, e);
    }
    reorder(t) {
      return e8.setFromEuler(this), this.setFromQuaternion(e8, t);
    }
    equals(t) {
      return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }
    fromArray(t) {
      return this._x = t[0], this._y = t[1], this._z = t[2], void 0 !== t[3] && (this._order = t[3]), this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
      return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }
    _onChange(t) {
      return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
      yield this._x, yield this._y, yield this._z, yield this._order;
    }
  };
u(Qc, "Euler"), Qc.DEFAULT_ORDER = "XYZ";
var Bg = class {
  constructor() {
    this.mask = 1;
  }
  set(t) {
    this.mask = (1 << t | 0) >>> 0;
  }
  enable(t) {
    this.mask |= 1 << t | 0;
  }
  enableAll() {
    this.mask = -1;
  }
  toggle(t) {
    this.mask ^= 1 << t | 0;
  }
  disable(t) {
    this.mask &= ~(1 << t | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(t) {
    return 0 != (this.mask & t.mask);
  }
  isEnabled(t) {
    return 0 != (this.mask & (1 << t | 0));
  }
};
u(Bg, "Layers");
var WV = 0,
  t8 = new ne(),
  id = new Vs(),
  Fu = new Bt(),
  cx = new ne(),
  Ug = new ne(),
  XV = new ne(),
  YV = new Vs(),
  n8 = new ne(1, 0, 0),
  i8 = new ne(0, 1, 0),
  r8 = new ne(0, 0, 1),
  ZV = {
    type: "added"
  },
  o8 = {
    type: "removed"
  },
  jn = class extends Al {
    constructor() {
      super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
        value: WV++
      }), this.uuid = Zp(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = jn.DEFAULT_UP.clone();
      let t = new ne(),
        e = new Qc(),
        n = new Vs(),
        i = new ne(1, 1, 1);
      function r() {
        n.setFromEuler(e, !1);
      }
      function o() {
        e.setFromQuaternion(n, void 0, !1);
      }
      u(r, "onRotationChange"), u(o, "onQuaternionChange"), e._onChange(r), n._onChange(o), Object.defineProperties(this, {
        position: {
          configurable: !0,
          enumerable: !0,
          value: t
        },
        rotation: {
          configurable: !0,
          enumerable: !0,
          value: e
        },
        quaternion: {
          configurable: !0,
          enumerable: !0,
          value: n
        },
        scale: {
          configurable: !0,
          enumerable: !0,
          value: i
        },
        modelViewMatrix: {
          value: new Bt()
        },
        normalMatrix: {
          value: new Qt()
        }
      }), this.matrix = new Bt(), this.matrixWorld = new Bt(), this.matrixAutoUpdate = jn.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = jn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new Bg(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(t) {
      this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(t) {
      return this.quaternion.premultiply(t), this;
    }
    setRotationFromAxisAngle(t, e) {
      this.quaternion.setFromAxisAngle(t, e);
    }
    setRotationFromEuler(t) {
      this.quaternion.setFromEuler(t, !0);
    }
    setRotationFromMatrix(t) {
      this.quaternion.setFromRotationMatrix(t);
    }
    setRotationFromQuaternion(t) {
      this.quaternion.copy(t);
    }
    rotateOnAxis(t, e) {
      return id.setFromAxisAngle(t, e), this.quaternion.multiply(id), this;
    }
    rotateOnWorldAxis(t, e) {
      return id.setFromAxisAngle(t, e), this.quaternion.premultiply(id), this;
    }
    rotateX(t) {
      return this.rotateOnAxis(n8, t);
    }
    rotateY(t) {
      return this.rotateOnAxis(i8, t);
    }
    rotateZ(t) {
      return this.rotateOnAxis(r8, t);
    }
    translateOnAxis(t, e) {
      return t8.copy(t).applyQuaternion(this.quaternion), this.position.add(t8.multiplyScalar(e)), this;
    }
    translateX(t) {
      return this.translateOnAxis(n8, t);
    }
    translateY(t) {
      return this.translateOnAxis(i8, t);
    }
    translateZ(t) {
      return this.translateOnAxis(r8, t);
    }
    localToWorld(t) {
      return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(t) {
      return this.updateWorldMatrix(!0, !1), t.applyMatrix4(Fu.copy(this.matrixWorld).invert());
    }
    lookAt(t, e, n) {
      t.isVector3 ? cx.copy(t) : cx.set(t, e, n);
      let i = this.parent;
      this.updateWorldMatrix(!0, !1), Ug.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? Fu.lookAt(Ug, cx, this.up) : Fu.lookAt(cx, Ug, this.up), this.quaternion.setFromRotationMatrix(Fu), i && (Fu.extractRotation(i.matrixWorld), id.setFromRotationMatrix(Fu), this.quaternion.premultiply(id.invert()));
    }
    add(t) {
      if (arguments.length > 1) {
        for (let t = 0; t < arguments.length; t++) this.add(arguments[t]);
        return this;
      }
      return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (null !== t.parent && t.parent.remove(t), t.parent = this, this.children.push(t), t.dispatchEvent(ZV)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }
    remove(t) {
      if (arguments.length > 1) {
        for (let t = 0; t < arguments.length; t++) this.remove(arguments[t]);
        return this;
      }
      let e = this.children.indexOf(t);
      return -1 !== e && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(o8)), this;
    }
    removeFromParent() {
      let t = this.parent;
      return null !== t && t.remove(this), this;
    }
    clear() {
      for (let t = 0; t < this.children.length; t++) {
        let e = this.children[t];
        e.parent = null, e.dispatchEvent(o8);
      }
      return this.children.length = 0, this;
    }
    attach(t) {
      return this.updateWorldMatrix(!0, !1), Fu.copy(this.matrixWorld).invert(), null !== t.parent && (t.parent.updateWorldMatrix(!0, !1), Fu.multiply(t.parent.matrixWorld)), t.applyMatrix4(Fu), this.add(t), t.updateWorldMatrix(!1, !0), this;
    }
    getObjectById(t) {
      return this.getObjectByProperty("id", t);
    }
    getObjectByName(t) {
      return this.getObjectByProperty("name", t);
    }
    getObjectByProperty(t, e) {
      if (this[t] === e) return this;
      for (let n = 0, i = this.children.length; n < i; n++) {
        let i = this.children[n].getObjectByProperty(t, e);
        if (void 0 !== i) return i;
      }
    }
    getObjectsByProperty(t, e) {
      let n = [];
      this[t] === e && n.push(this);
      for (let i = 0, r = this.children.length; i < r; i++) {
        let r = this.children[i].getObjectsByProperty(t, e);
        r.length > 0 && (n = n.concat(r));
      }
      return n;
    }
    getWorldPosition(t) {
      return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(t) {
      return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Ug, t, XV), t;
    }
    getWorldScale(t) {
      return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Ug, YV, t), t;
    }
    getWorldDirection(t) {
      this.updateWorldMatrix(!0, !1);
      let e = this.matrixWorld.elements;
      return t.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(t) {
      t(this);
      let e = this.children;
      for (let n = 0, i = e.length; n < i; n++) e[n].traverse(t);
    }
    traverseVisible(t) {
      if (!1 === this.visible) return;
      t(this);
      let e = this.children;
      for (let n = 0, i = e.length; n < i; n++) e[n].traverseVisible(t);
    }
    traverseAncestors(t) {
      let e = this.parent;
      null !== e && (t(e), e.traverseAncestors(t));
    }
    updateMatrix() {
      this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(t) {
      this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);
      let e = this.children;
      for (let n = 0, i = e.length; n < i; n++) {
        let i = e[n];
        (!0 === i.matrixWorldAutoUpdate || !0 === t) && i.updateMatrixWorld(t);
      }
    }
    updateWorldMatrix(t, e) {
      let n = this.parent;
      if (!0 === t && null !== n && !0 === n.matrixWorldAutoUpdate && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === e) {
        let t = this.children;
        for (let e = 0, n = t.length; e < n; e++) {
          let n = t[e];
          !0 === n.matrixWorldAutoUpdate && n.updateWorldMatrix(!1, !0);
        }
      }
    }
    toJSON(t) {
      let e = void 0 === t || "string" == typeof t,
        n = {};
      e && (t = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {}
      }, n.metadata = {
        version: 4.6,
        type: "Object",
        generator: "Object3D.toJSON"
      });
      let i = {};
      function r(e, n) {
        return void 0 === e[n.uuid] && (e[n.uuid] = n.toJSON(t)), n.uuid;
      }
      if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), !0 === this.castShadow && (i.castShadow = !0), !0 === this.receiveShadow && (i.receiveShadow = !0), !1 === this.visible && (i.visible = !1), !1 === this.frustumCulled && (i.frustumCulled = !1), 0 !== this.renderOrder && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (i.instanceColor = this.instanceColor.toJSON())), u(r, "serialize"), this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (i.environment = this.environment.toJSON(t).uuid);else if (this.isMesh || this.isLine || this.isPoints) {
        i.geometry = r(t.geometries, this.geometry);
        let e = this.geometry.parameters;
        if (void 0 !== e && void 0 !== e.shapes) {
          let n = e.shapes;
          if (Array.isArray(n)) for (let e = 0, i = n.length; e < i; e++) {
            let i = n[e];
            r(t.shapes, i);
          } else r(t.shapes, n);
        }
      }
      if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), void 0 !== this.material) if (Array.isArray(this.material)) {
        let e = [];
        for (let n = 0, i = this.material.length; n < i; n++) e.push(r(t.materials, this.material[n]));
        i.material = e;
      } else i.material = r(t.materials, this.material);
      if (this.children.length > 0) {
        i.children = [];
        for (let e = 0; e < this.children.length; e++) i.children.push(this.children[e].toJSON(t).object);
      }
      if (this.animations.length > 0) {
        i.animations = [];
        for (let e = 0; e < this.animations.length; e++) {
          let n = this.animations[e];
          i.animations.push(r(t.animations, n));
        }
      }
      if (e) {
        let e = o(t.geometries),
          i = o(t.materials),
          r = o(t.textures),
          s = o(t.images),
          a = o(t.shapes),
          l = o(t.skeletons),
          u = o(t.animations),
          h = o(t.nodes);
        e.length > 0 && (n.geometries = e), i.length > 0 && (n.materials = i), r.length > 0 && (n.textures = r), s.length > 0 && (n.images = s), a.length > 0 && (n.shapes = a), l.length > 0 && (n.skeletons = l), u.length > 0 && (n.animations = u), h.length > 0 && (n.nodes = h);
      }
      return n.object = i, n;
      function o(t) {
        let e = [];
        for (let n in t) {
          let i = t[n];
          delete i.metadata, e.push(i);
        }
        return e;
      }
    }
    clone(t) {
      return new this.constructor().copy(this, t);
    }
    copy(t, e = !0) {
      if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.animations = t.animations, this.userData = JSON.parse(JSON.stringify(t.userData)), !0 === e) for (let e = 0; e < t.children.length; e++) {
        let n = t.children[e];
        this.add(n.clone());
      }
      return this;
    }
  };
u(jn, "Object3D"), jn.DEFAULT_UP = new ne(0, 1, 0), jn.DEFAULT_MATRIX_AUTO_UPDATE = !0, jn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
var Za = new ne(),
  Bu = new ne(),
  J3 = new ne(),
  Uu = new ne(),
  rd = new ne(),
  od = new ne(),
  s8 = new ne(),
  K3 = new ne(),
  Q3 = new ne(),
  $3 = new ne(),
  hx = !1,
  Hs = class {
    constructor(t = new ne(), e = new ne(), n = new ne()) {
      this.a = t, this.b = e, this.c = n;
    }
    static getNormal(t, e, n, i) {
      i.subVectors(n, e), Za.subVectors(t, e), i.cross(Za);
      let r = i.lengthSq();
      return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
    }
    static getBarycoord(t, e, n, i, r) {
      Za.subVectors(i, e), Bu.subVectors(n, e), J3.subVectors(t, e);
      let o = Za.dot(Za),
        s = Za.dot(Bu),
        a = Za.dot(J3),
        l = Bu.dot(Bu),
        u = Bu.dot(J3),
        h = o * l - s * s;
      if (0 === h) return r.set(-2, -1, -1);
      let c = 1 / h,
        p = (l * a - s * u) * c,
        d = (o * u - s * a) * c;
      return r.set(1 - p - d, d, p);
    }
    static containsPoint(t, e, n, i) {
      return this.getBarycoord(t, e, n, i, Uu), Uu.x >= 0 && Uu.y >= 0 && Uu.x + Uu.y <= 1;
    }
    static getUV(t, e, n, i, r, o, s, a) {
      return !1 === hx && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), hx = !0), this.getInterpolation(t, e, n, i, r, o, s, a);
    }
    static getInterpolation(t, e, n, i, r, o, s, a) {
      return this.getBarycoord(t, e, n, i, Uu), a.setScalar(0), a.addScaledVector(r, Uu.x), a.addScaledVector(o, Uu.y), a.addScaledVector(s, Uu.z), a;
    }
    static isFrontFacing(t, e, n, i) {
      return Za.subVectors(n, e), Bu.subVectors(t, e), Za.cross(Bu).dot(i) < 0;
    }
    set(t, e, n) {
      return this.a.copy(t), this.b.copy(e), this.c.copy(n), this;
    }
    setFromPointsAndIndices(t, e, n, i) {
      return this.a.copy(t[e]), this.b.copy(t[n]), this.c.copy(t[i]), this;
    }
    setFromAttributeAndIndices(t, e, n, i) {
      return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, n), this.c.fromBufferAttribute(t, i), this;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(t) {
      return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }
    getArea() {
      return Za.subVectors(this.c, this.b), Bu.subVectors(this.a, this.b), .5 * Za.cross(Bu).length();
    }
    getMidpoint(t) {
      return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(t) {
      return Hs.getNormal(this.a, this.b, this.c, t);
    }
    getPlane(t) {
      return t.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(t, e) {
      return Hs.getBarycoord(t, this.a, this.b, this.c, e);
    }
    getUV(t, e, n, i, r) {
      return !1 === hx && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), hx = !0), Hs.getInterpolation(t, this.a, this.b, this.c, e, n, i, r);
    }
    getInterpolation(t, e, n, i, r) {
      return Hs.getInterpolation(t, this.a, this.b, this.c, e, n, i, r);
    }
    containsPoint(t) {
      return Hs.containsPoint(t, this.a, this.b, this.c);
    }
    isFrontFacing(t) {
      return Hs.isFrontFacing(this.a, this.b, this.c, t);
    }
    intersectsBox(t) {
      return t.intersectsTriangle(this);
    }
    closestPointToPoint(t, e) {
      let n,
        i,
        r = this.a,
        o = this.b,
        s = this.c;
      rd.subVectors(o, r), od.subVectors(s, r), K3.subVectors(t, r);
      let a = rd.dot(K3),
        l = od.dot(K3);
      if (a <= 0 && l <= 0) return e.copy(r);
      Q3.subVectors(t, o);
      let u = rd.dot(Q3),
        h = od.dot(Q3);
      if (u >= 0 && h <= u) return e.copy(o);
      let c = a * h - u * l;
      if (c <= 0 && a >= 0 && u <= 0) return n = a / (a - u), e.copy(r).addScaledVector(rd, n);
      $3.subVectors(t, s);
      let p = rd.dot($3),
        d = od.dot($3);
      if (d >= 0 && p <= d) return e.copy(s);
      let f = p * l - a * d;
      if (f <= 0 && l >= 0 && d <= 0) return i = l / (l - d), e.copy(r).addScaledVector(od, i);
      let m = u * d - p * h;
      if (m <= 0 && h - u >= 0 && p - d >= 0) return s8.subVectors(s, o), i = (h - u) / (h - u + (p - d)), e.copy(o).addScaledVector(s8, i);
      let g = 1 / (m + f + c);
      return n = f * g, i = c * g, e.copy(r).addScaledVector(rd, n).addScaledVector(od, i);
    }
    equals(t) {
      return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    }
  };
u(Hs, "Triangle");
var JV = 0,
  $c = class extends Al {
    constructor() {
      super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
        value: JV++
      }), this.uuid = Zp(), this.name = "", this.type = "Material", this.blending = Gp, this.side = ja, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.blendSrc = uI, this.blendDst = cI, this.blendEquation = Hp, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = b3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = Rg, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Ru, this.stencilZFail = Ru, this.stencilZPass = Ru, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
      return this._alphaTest;
    }
    set alphaTest(t) {
      this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
      return this.onBeforeCompile.toString();
    }
    setValues(t) {
      if (void 0 !== t) for (let e in t) {
        let n = t[e];
        if (void 0 === n) {
          console.warn(`THREE.Material: parameter '${e}' has value of undefined.`);
          continue;
        }
        let i = this[e];
        void 0 !== i ? i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[e] = n : console.warn(`THREE.Material: '${e}' is not a property of THREE.${this.type}.`);
      }
    }
    toJSON(t) {
      let e = void 0 === t || "string" == typeof t;
      e && (t = {
        textures: {},
        images: {}
      });
      let n = {
        metadata: {
          version: 4.6,
          type: "Material",
          generator: "Material.toJSON"
        }
      };
      function i(t) {
        let e = [];
        for (let n in t) {
          let i = t[n];
          delete i.metadata, e.push(i);
        }
        return e;
      }
      if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), void 0 !== this.sheen && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), void 0 !== this.iridescence && (n.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (n.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), void 0 !== this.anisotropy && (n.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(t).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t).uuid, void 0 !== this.combine && (n.combine = this.combine)), void 0 !== this.envMapIntensity && (n.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t).uuid), void 0 !== this.transmission && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(t).uuid), void 0 !== this.thickness && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(t).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (n.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (n.size = this.size), null !== this.shadowSide && (n.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== Gp && (n.blending = this.blending), this.side !== ja && (n.side = this.side), this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, n.colorWrite = this.colorWrite, n.stencilWrite = this.stencilWrite, n.stencilWriteMask = this.stencilWriteMask, n.stencilFunc = this.stencilFunc, n.stencilRef = this.stencilRef, n.stencilFuncMask = this.stencilFuncMask, n.stencilFail = this.stencilFail, n.stencilZFail = this.stencilZFail, n.stencilZPass = this.stencilZPass, void 0 !== this.rotation && 0 !== this.rotation && (n.rotation = this.rotation), !0 === this.polygonOffset && (n.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (n.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (n.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.alphaToCoverage && (n.alphaToCoverage = this.alphaToCoverage), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha), !0 === this.forceSinglePass && (n.forceSinglePass = this.forceSinglePass), !0 === this.wireframe && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (n.flatShading = this.flatShading), !1 === this.visible && (n.visible = !1), !1 === this.toneMapped && (n.toneMapped = !1), !1 === this.fog && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData), u(i, "extractFromCache"), e) {
        let e = i(t.textures),
          r = i(t.images);
        e.length > 0 && (n.textures = e), r.length > 0 && (n.images = r);
      }
      return n;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(t) {
      this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
      let e = t.clippingPlanes,
        n = null;
      if (null !== e) {
        let t = e.length;
        n = new Array(t);
        for (let i = 0; i !== t; ++i) n[i] = e[i].clone();
      }
      return this.clippingPlanes = n, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
    }
    dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
    set needsUpdate(t) {
      !0 === t && this.version++;
    }
  };
u($c, "Material");
var a8 = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  },
  Ja = {
    h: 0,
    s: 0,
    l: 0
  },
  fx = {
    h: 0,
    s: 0,
    l: 0
  };
function eS(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + 6 * (e - t) * (2 / 3 - n) : t;
}
u(eS, "hue2rgb");
var yt = class {
  constructor(t, e, n) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(t, e, n);
  }
  set(t, e, n) {
    if (void 0 === e && void 0 === n) {
      let e = t;
      e && e.isColor ? this.copy(e) : "number" == typeof e ? this.setHex(e) : "string" == typeof e && this.setStyle(e);
    } else this.setRGB(t, e, n);
    return this;
  }
  setScalar(t) {
    return this.r = t, this.g = t, this.b = t, this;
  }
  setHex(t, e = Nt) {
    return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (255 & t) / 255, Xa.toWorkingColorSpace(this, e), this;
  }
  setRGB(t, e, n, i = Xa.workingColorSpace) {
    return this.r = t, this.g = e, this.b = n, Xa.toWorkingColorSpace(this, i), this;
  }
  setHSL(t, e, n, i = Xa.workingColorSpace) {
    if (t = NV(t, 1), e = jo(e, 0, 1), n = jo(n, 0, 1), 0 === e) this.r = this.g = this.b = n;else {
      let i = n <= .5 ? n * (1 + e) : n + e - n * e,
        r = 2 * n - i;
      this.r = eS(r, i, t + 1 / 3), this.g = eS(r, i, t), this.b = eS(r, i, t - 1 / 3);
    }
    return Xa.toWorkingColorSpace(this, i), this;
  }
  setStyle(t, e = Nt) {
    function n(e) {
      void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
    }
    let i;
    if (u(n, "handleAlpha"), i = /^(\w+)\(([^\)]*)\)/.exec(t)) {
      let r,
        o = i[1],
        s = i[2];
      switch (o) {
        case "rgb":
        case "rgba":
          if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return n(r[4]), this.setRGB(Math.min(255, parseInt(r[1], 10)) / 255, Math.min(255, parseInt(r[2], 10)) / 255, Math.min(255, parseInt(r[3], 10)) / 255, e);
          if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return n(r[4]), this.setRGB(Math.min(100, parseInt(r[1], 10)) / 100, Math.min(100, parseInt(r[2], 10)) / 100, Math.min(100, parseInt(r[3], 10)) / 100, e);
          break;
        case "hsl":
        case "hsla":
          if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return n(r[4]), this.setHSL(parseFloat(r[1]) / 360, parseFloat(r[2]) / 100, parseFloat(r[3]) / 100, e);
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + t);
      }
    } else if (i = /^\#([A-Fa-f\d]+)$/.exec(t)) {
      let n = i[1],
        r = n.length;
      if (3 === r) return this.setRGB(parseInt(n.charAt(0), 16) / 15, parseInt(n.charAt(1), 16) / 15, parseInt(n.charAt(2), 16) / 15, e);
      if (6 === r) return this.setHex(parseInt(n, 16), e);
      console.warn("THREE.Color: Invalid hex color " + t);
    } else if (t && t.length > 0) return this.setColorName(t, e);
    return this;
  }
  setColorName(t, e = Nt) {
    let n = a8[t.toLowerCase()];
    return void 0 !== n ? this.setHex(n, e) : console.warn("THREE.Color: Unknown color " + t), this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(t) {
    return this.r = t.r, this.g = t.g, this.b = t.b, this;
  }
  copySRGBToLinear(t) {
    return this.r = Jp(t.r), this.g = Jp(t.g), this.b = Jp(t.b), this;
  }
  copyLinearToSRGB(t) {
    return this.r = z3(t.r), this.g = z3(t.g), this.b = z3(t.b), this;
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  getHex(t = Nt) {
    return Xa.fromWorkingColorSpace(Wo.copy(this), t), 65536 * Math.round(jo(255 * Wo.r, 0, 255)) + 256 * Math.round(jo(255 * Wo.g, 0, 255)) + Math.round(jo(255 * Wo.b, 0, 255));
  }
  getHexString(t = Nt) {
    return ("000000" + this.getHex(t).toString(16)).slice(-6);
  }
  getHSL(t, e = Xa.workingColorSpace) {
    Xa.fromWorkingColorSpace(Wo.copy(this), e);
    let n,
      i,
      r = Wo.r,
      o = Wo.g,
      s = Wo.b,
      a = Math.max(r, o, s),
      l = Math.min(r, o, s),
      u = (l + a) / 2;
    if (l === a) n = 0, i = 0;else {
      let t = a - l;
      switch (i = u <= .5 ? t / (a + l) : t / (2 - a - l), a) {
        case r:
          n = (o - s) / t + (o < s ? 6 : 0);
          break;
        case o:
          n = (s - r) / t + 2;
          break;
        case s:
          n = (r - o) / t + 4;
      }
      n /= 6;
    }
    return t.h = n, t.s = i, t.l = u, t;
  }
  getRGB(t, e = Xa.workingColorSpace) {
    return Xa.fromWorkingColorSpace(Wo.copy(this), e), t.r = Wo.r, t.g = Wo.g, t.b = Wo.b, t;
  }
  getStyle(t = Nt) {
    Xa.fromWorkingColorSpace(Wo.copy(this), t);
    let e = Wo.r,
      n = Wo.g,
      i = Wo.b;
    return t !== Nt ? `color(${t} ${e.toFixed(3)} ${n.toFixed(3)} ${i.toFixed(3)})` : `rgb(${Math.round(255 * e)},${Math.round(255 * n)},${Math.round(255 * i)})`;
  }
  offsetHSL(t, e, n) {
    return this.getHSL(Ja), Ja.h += t, Ja.s += e, Ja.l += n, this.setHSL(Ja.h, Ja.s, Ja.l), this;
  }
  add(t) {
    return this.r += t.r, this.g += t.g, this.b += t.b, this;
  }
  addColors(t, e) {
    return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
  }
  addScalar(t) {
    return this.r += t, this.g += t, this.b += t, this;
  }
  sub(t) {
    return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
  }
  multiply(t) {
    return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
  }
  multiplyScalar(t) {
    return this.r *= t, this.g *= t, this.b *= t, this;
  }
  lerp(t, e) {
    return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
  }
  lerpColors(t, e, n) {
    return this.r = t.r + (e.r - t.r) * n, this.g = t.g + (e.g - t.g) * n, this.b = t.b + (e.b - t.b) * n, this;
  }
  lerpHSL(t, e) {
    this.getHSL(Ja), t.getHSL(fx);
    let n = F3(Ja.h, fx.h, e),
      i = F3(Ja.s, fx.s, e),
      r = F3(Ja.l, fx.l, e);
    return this.setHSL(n, i, r), this;
  }
  setFromVector3(t) {
    return this.r = t.x, this.g = t.y, this.b = t.z, this;
  }
  applyMatrix3(t) {
    let e = this.r,
      n = this.g,
      i = this.b,
      r = t.elements;
    return this.r = r[0] * e + r[3] * n + r[6] * i, this.g = r[1] * e + r[4] * n + r[7] * i, this.b = r[2] * e + r[5] * n + r[8] * i, this;
  }
  equals(t) {
    return t.r === this.r && t.g === this.g && t.b === this.b;
  }
  fromArray(t, e = 0) {
    return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
  }
  fromBufferAttribute(t, e) {
    return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
};
u(yt, "Color");
var Wo = new yt();
yt.NAMES = a8;
var Sr = class extends $c {
  constructor(t) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new yt(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = M3, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
  }
};
u(Sr, "MeshBasicMaterial");
var Tr = new ne(),
  px = new je(),
  ui = class {
    constructor(t, e, n = !1) {
      if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
      this.isBufferAttribute = !0, this.name = "", this.array = t, this.itemSize = e, this.count = void 0 !== t ? t.length / e : 0, this.normalized = n, this.usage = XI, this.updateRange = {
        offset: 0,
        count: -1
      }, this.gpuType = Tl, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(t) {
      !0 === t && this.version++;
    }
    setUsage(t) {
      return this.usage = t, this;
    }
    copy(t) {
      return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this.gpuType = t.gpuType, this;
    }
    copyAt(t, e, n) {
      t *= this.itemSize, n *= e.itemSize;
      for (let i = 0, r = this.itemSize; i < r; i++) this.array[t + i] = e.array[n + i];
      return this;
    }
    copyArray(t) {
      return this.array.set(t), this;
    }
    applyMatrix3(t) {
      if (2 === this.itemSize) for (let e = 0, n = this.count; e < n; e++) px.fromBufferAttribute(this, e), px.applyMatrix3(t), this.setXY(e, px.x, px.y);else if (3 === this.itemSize) for (let e = 0, n = this.count; e < n; e++) Tr.fromBufferAttribute(this, e), Tr.applyMatrix3(t), this.setXYZ(e, Tr.x, Tr.y, Tr.z);
      return this;
    }
    applyMatrix4(t) {
      for (let e = 0, n = this.count; e < n; e++) Tr.fromBufferAttribute(this, e), Tr.applyMatrix4(t), this.setXYZ(e, Tr.x, Tr.y, Tr.z);
      return this;
    }
    applyNormalMatrix(t) {
      for (let e = 0, n = this.count; e < n; e++) Tr.fromBufferAttribute(this, e), Tr.applyNormalMatrix(t), this.setXYZ(e, Tr.x, Tr.y, Tr.z);
      return this;
    }
    transformDirection(t) {
      for (let e = 0, n = this.count; e < n; e++) Tr.fromBufferAttribute(this, e), Tr.transformDirection(t), this.setXYZ(e, Tr.x, Tr.y, Tr.z);
      return this;
    }
    set(t, e = 0) {
      return this.array.set(t, e), this;
    }
    getX(t) {
      let e = this.array[t * this.itemSize];
      return this.normalized && (e = ex(e, this.array)), e;
    }
    setX(t, e) {
      return this.normalized && (e = zs(e, this.array)), this.array[t * this.itemSize] = e, this;
    }
    getY(t) {
      let e = this.array[t * this.itemSize + 1];
      return this.normalized && (e = ex(e, this.array)), e;
    }
    setY(t, e) {
      return this.normalized && (e = zs(e, this.array)), this.array[t * this.itemSize + 1] = e, this;
    }
    getZ(t) {
      let e = this.array[t * this.itemSize + 2];
      return this.normalized && (e = ex(e, this.array)), e;
    }
    setZ(t, e) {
      return this.normalized && (e = zs(e, this.array)), this.array[t * this.itemSize + 2] = e, this;
    }
    getW(t) {
      let e = this.array[t * this.itemSize + 3];
      return this.normalized && (e = ex(e, this.array)), e;
    }
    setW(t, e) {
      return this.normalized && (e = zs(e, this.array)), this.array[t * this.itemSize + 3] = e, this;
    }
    setXY(t, e, n) {
      return t *= this.itemSize, this.normalized && (e = zs(e, this.array), n = zs(n, this.array)), this.array[t + 0] = e, this.array[t + 1] = n, this;
    }
    setXYZ(t, e, n, i) {
      return t *= this.itemSize, this.normalized && (e = zs(e, this.array), n = zs(n, this.array), i = zs(i, this.array)), this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this;
    }
    setXYZW(t, e, n, i, r) {
      return t *= this.itemSize, this.normalized && (e = zs(e, this.array), n = zs(n, this.array), i = zs(i, this.array), r = zs(r, this.array)), this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this.array[t + 3] = r, this;
    }
    onUpload(t) {
      return this.onUploadCallback = t, this;
    }
    clone() {
      return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
      let t = {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: Array.from(this.array),
        normalized: this.normalized
      };
      return "" !== this.name && (t.name = this.name), this.usage !== XI && (t.usage = this.usage), (0 !== this.updateRange.offset || -1 !== this.updateRange.count) && (t.updateRange = this.updateRange), t;
    }
    copyColorsArray() {
      console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
      console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
      console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
      console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
  };
u(ui, "BufferAttribute");
var dx = class extends ui {
  constructor(t, e, n) {
    super(new Uint16Array(t), e, n);
  }
};
u(dx, "Uint16BufferAttribute");
var mx = class extends ui {
  constructor(t, e, n) {
    super(new Uint32Array(t), e, n);
  }
};
u(mx, "Uint32BufferAttribute");
var Di = class extends ui {
  constructor(t, e, n) {
    super(new Float32Array(t), e, n);
  }
};
u(Di, "Float32BufferAttribute");
var KV = 0,
  ca = new Bt(),
  tS = new jn(),
  sd = new ne(),
  js = new $t(),
  zg = new $t(),
  uo = new ne(),
  Pi = class extends Al {
    constructor() {
      super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
        value: KV++
      }), this.uuid = Zp(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
        start: 0,
        count: 1 / 0
      }, this.userData = {};
    }
    getIndex() {
      return this.index;
    }
    setIndex(t) {
      return Array.isArray(t) ? this.index = new (JI(t) ? mx : dx)(t, 1) : this.index = t, this;
    }
    getAttribute(t) {
      return this.attributes[t];
    }
    setAttribute(t, e) {
      return this.attributes[t] = e, this;
    }
    deleteAttribute(t) {
      return delete this.attributes[t], this;
    }
    hasAttribute(t) {
      return void 0 !== this.attributes[t];
    }
    addGroup(t, e, n = 0) {
      this.groups.push({
        start: t,
        count: e,
        materialIndex: n
      });
    }
    clearGroups() {
      this.groups = [];
    }
    setDrawRange(t, e) {
      this.drawRange.start = t, this.drawRange.count = e;
    }
    applyMatrix4(t) {
      let e = this.attributes.position;
      void 0 !== e && (e.applyMatrix4(t), e.needsUpdate = !0);
      let n = this.attributes.normal;
      if (void 0 !== n) {
        let e = new Qt().getNormalMatrix(t);
        n.applyNormalMatrix(e), n.needsUpdate = !0;
      }
      let i = this.attributes.tangent;
      return void 0 !== i && (i.transformDirection(t), i.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
    }
    applyQuaternion(t) {
      return ca.makeRotationFromQuaternion(t), this.applyMatrix4(ca), this;
    }
    rotateX(t) {
      return ca.makeRotationX(t), this.applyMatrix4(ca), this;
    }
    rotateY(t) {
      return ca.makeRotationY(t), this.applyMatrix4(ca), this;
    }
    rotateZ(t) {
      return ca.makeRotationZ(t), this.applyMatrix4(ca), this;
    }
    translate(t, e, n) {
      return ca.makeTranslation(t, e, n), this.applyMatrix4(ca), this;
    }
    scale(t, e, n) {
      return ca.makeScale(t, e, n), this.applyMatrix4(ca), this;
    }
    lookAt(t) {
      return tS.lookAt(t), tS.updateMatrix(), this.applyMatrix4(tS.matrix), this;
    }
    center() {
      return this.computeBoundingBox(), this.boundingBox.getCenter(sd).negate(), this.translate(sd.x, sd.y, sd.z), this;
    }
    setFromPoints(t) {
      let e = [];
      for (let n = 0, i = t.length; n < i; n++) {
        let i = t[n];
        e.push(i.x, i.y, i.z || 0);
      }
      return this.setAttribute("position", new Di(e, 3)), this;
    }
    computeBoundingBox() {
      null === this.boundingBox && (this.boundingBox = new $t());
      let t = this.attributes.position,
        e = this.morphAttributes.position;
      if (t && t.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new ne(-1 / 0, -1 / 0, -1 / 0), new ne(1 / 0, 1 / 0, 1 / 0));
      if (void 0 !== t) {
        if (this.boundingBox.setFromBufferAttribute(t), e) for (let t = 0, n = e.length; t < n; t++) {
          let n = e[t];
          js.setFromBufferAttribute(n), this.morphTargetsRelative ? (uo.addVectors(this.boundingBox.min, js.min), this.boundingBox.expandByPoint(uo), uo.addVectors(this.boundingBox.max, js.max), this.boundingBox.expandByPoint(uo)) : (this.boundingBox.expandByPoint(js.min), this.boundingBox.expandByPoint(js.max));
        }
      } else this.boundingBox.makeEmpty();
      (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
      null === this.boundingSphere && (this.boundingSphere = new Zc());
      let t = this.attributes.position,
        e = this.morphAttributes.position;
      if (t && t.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new ne(), 1 / 0);
      if (t) {
        let n = this.boundingSphere.center;
        if (js.setFromBufferAttribute(t), e) for (let t = 0, n = e.length; t < n; t++) {
          let n = e[t];
          zg.setFromBufferAttribute(n), this.morphTargetsRelative ? (uo.addVectors(js.min, zg.min), js.expandByPoint(uo), uo.addVectors(js.max, zg.max), js.expandByPoint(uo)) : (js.expandByPoint(zg.min), js.expandByPoint(zg.max));
        }
        js.getCenter(n);
        let i = 0;
        for (let e = 0, r = t.count; e < r; e++) uo.fromBufferAttribute(t, e), i = Math.max(i, n.distanceToSquared(uo));
        if (e) for (let r = 0, o = e.length; r < o; r++) {
          let o = e[r],
            s = this.morphTargetsRelative;
          for (let e = 0, r = o.count; e < r; e++) uo.fromBufferAttribute(o, e), s && (sd.fromBufferAttribute(t, e), uo.add(sd)), i = Math.max(i, n.distanceToSquared(uo));
        }
        this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
      }
    }
    computeTangents() {
      let t = this.index,
        e = this.attributes;
      if (null === t || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      let n = t.array,
        i = e.position.array,
        r = e.normal.array,
        o = e.uv.array,
        s = i.length / 3;
      !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new ui(new Float32Array(4 * s), 4));
      let a = this.getAttribute("tangent").array,
        l = [],
        h = [];
      for (let t = 0; t < s; t++) l[t] = new ne(), h[t] = new ne();
      let c = new ne(),
        p = new ne(),
        d = new ne(),
        f = new je(),
        m = new je(),
        g = new je(),
        v = new ne(),
        y = new ne();
      function _(t, e, n) {
        c.fromArray(i, 3 * t), p.fromArray(i, 3 * e), d.fromArray(i, 3 * n), f.fromArray(o, 2 * t), m.fromArray(o, 2 * e), g.fromArray(o, 2 * n), p.sub(c), d.sub(c), m.sub(f), g.sub(f);
        let r = 1 / (m.x * g.y - g.x * m.y);
        !isFinite(r) || (v.copy(p).multiplyScalar(g.y).addScaledVector(d, -m.y).multiplyScalar(r), y.copy(d).multiplyScalar(m.x).addScaledVector(p, -g.x).multiplyScalar(r), l[t].add(v), l[e].add(v), l[n].add(v), h[t].add(y), h[e].add(y), h[n].add(y));
      }
      u(_, "handleTriangle");
      let x = this.groups;
      0 === x.length && (x = [{
        start: 0,
        count: n.length
      }]);
      for (let t = 0, e = x.length; t < e; ++t) {
        let e = x[t],
          i = e.start;
        for (let t = i, r = i + e.count; t < r; t += 3) _(n[t + 0], n[t + 1], n[t + 2]);
      }
      let E = new ne(),
        b = new ne(),
        w = new ne(),
        S = new ne();
      function M(t) {
        w.fromArray(r, 3 * t), S.copy(w);
        let e = l[t];
        E.copy(e), E.sub(w.multiplyScalar(w.dot(e))).normalize(), b.crossVectors(S, e);
        let n = b.dot(h[t]) < 0 ? -1 : 1;
        a[4 * t] = E.x, a[4 * t + 1] = E.y, a[4 * t + 2] = E.z, a[4 * t + 3] = n;
      }
      u(M, "handleVertex");
      for (let t = 0, e = x.length; t < e; ++t) {
        let e = x[t],
          i = e.start;
        for (let t = i, r = i + e.count; t < r; t += 3) M(n[t + 0]), M(n[t + 1]), M(n[t + 2]);
      }
    }
    computeVertexNormals() {
      let t = this.index,
        e = this.getAttribute("position");
      if (void 0 !== e) {
        let n = this.getAttribute("normal");
        if (void 0 === n) n = new ui(new Float32Array(3 * e.count), 3), this.setAttribute("normal", n);else for (let t = 0, e = n.count; t < e; t++) n.setXYZ(t, 0, 0, 0);
        let i = new ne(),
          r = new ne(),
          o = new ne(),
          s = new ne(),
          a = new ne(),
          l = new ne(),
          u = new ne(),
          h = new ne();
        if (t) for (let c = 0, p = t.count; c < p; c += 3) {
          let p = t.getX(c + 0),
            d = t.getX(c + 1),
            f = t.getX(c + 2);
          i.fromBufferAttribute(e, p), r.fromBufferAttribute(e, d), o.fromBufferAttribute(e, f), u.subVectors(o, r), h.subVectors(i, r), u.cross(h), s.fromBufferAttribute(n, p), a.fromBufferAttribute(n, d), l.fromBufferAttribute(n, f), s.add(u), a.add(u), l.add(u), n.setXYZ(p, s.x, s.y, s.z), n.setXYZ(d, a.x, a.y, a.z), n.setXYZ(f, l.x, l.y, l.z);
        } else for (let t = 0, s = e.count; t < s; t += 3) i.fromBufferAttribute(e, t + 0), r.fromBufferAttribute(e, t + 1), o.fromBufferAttribute(e, t + 2), u.subVectors(o, r), h.subVectors(i, r), u.cross(h), n.setXYZ(t + 0, u.x, u.y, u.z), n.setXYZ(t + 1, u.x, u.y, u.z), n.setXYZ(t + 2, u.x, u.y, u.z);
        this.normalizeNormals(), n.needsUpdate = !0;
      }
    }
    merge() {
      return console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeGeometries() instead."), this;
    }
    normalizeNormals() {
      let t = this.attributes.normal;
      for (let e = 0, n = t.count; e < n; e++) uo.fromBufferAttribute(t, e), uo.normalize(), t.setXYZ(e, uo.x, uo.y, uo.z);
    }
    toNonIndexed() {
      function t(t, e) {
        let n = t.array,
          i = t.itemSize,
          r = t.normalized,
          o = new n.constructor(e.length * i),
          s = 0,
          a = 0;
        for (let r = 0, l = e.length; r < l; r++) {
          s = t.isInterleavedBufferAttribute ? e[r] * t.data.stride + t.offset : e[r] * i;
          for (let t = 0; t < i; t++) o[a++] = n[s++];
        }
        return new ui(o, i, r);
      }
      if (u(t, "convertBufferAttribute"), null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
      let e = new Pi(),
        n = this.index.array,
        i = this.attributes;
      for (let r in i) {
        let o = t(i[r], n);
        e.setAttribute(r, o);
      }
      let r = this.morphAttributes;
      for (let i in r) {
        let o = [],
          s = r[i];
        for (let e = 0, i = s.length; e < i; e++) {
          let i = t(s[e], n);
          o.push(i);
        }
        e.morphAttributes[i] = o;
      }
      e.morphTargetsRelative = this.morphTargetsRelative;
      let o = this.groups;
      for (let t = 0, n = o.length; t < n; t++) {
        let n = o[t];
        e.addGroup(n.start, n.count, n.materialIndex);
      }
      return e;
    }
    toJSON() {
      let t = {
        metadata: {
          version: 4.6,
          type: "BufferGeometry",
          generator: "BufferGeometry.toJSON"
        }
      };
      if (t.uuid = this.uuid, t.type = this.type, "" !== this.name && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), void 0 !== this.parameters) {
        let e = this.parameters;
        for (let n in e) void 0 !== e[n] && (t[n] = e[n]);
        return t;
      }
      t.data = {
        attributes: {}
      };
      let e = this.index;
      null !== e && (t.data.index = {
        type: e.array.constructor.name,
        array: Array.prototype.slice.call(e.array)
      });
      let n = this.attributes;
      for (let e in n) {
        let i = n[e];
        t.data.attributes[e] = i.toJSON(t.data);
      }
      let i = {},
        r = !1;
      for (let e in this.morphAttributes) {
        let n = this.morphAttributes[e],
          o = [];
        for (let e = 0, i = n.length; e < i; e++) {
          let i = n[e];
          o.push(i.toJSON(t.data));
        }
        o.length > 0 && (i[e] = o, r = !0);
      }
      r && (t.data.morphAttributes = i, t.data.morphTargetsRelative = this.morphTargetsRelative);
      let o = this.groups;
      o.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(o)));
      let s = this.boundingSphere;
      return null !== s && (t.data.boundingSphere = {
        center: s.center.toArray(),
        radius: s.radius
      }), t;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(t) {
      this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
      let e = {};
      this.name = t.name;
      let n = t.index;
      null !== n && this.setIndex(n.clone(e));
      let i = t.attributes;
      for (let t in i) {
        let n = i[t];
        this.setAttribute(t, n.clone(e));
      }
      let r = t.morphAttributes;
      for (let t in r) {
        let n = [],
          i = r[t];
        for (let t = 0, r = i.length; t < r; t++) n.push(i[t].clone(e));
        this.morphAttributes[t] = n;
      }
      this.morphTargetsRelative = t.morphTargetsRelative;
      let o = t.groups;
      for (let t = 0, e = o.length; t < e; t++) {
        let e = o[t];
        this.addGroup(e.start, e.count, e.materialIndex);
      }
      let s = t.boundingBox;
      null !== s && (this.boundingBox = s.clone());
      let a = t.boundingSphere;
      return null !== a && (this.boundingSphere = a.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, this;
    }
    dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  };
u(Pi, "BufferGeometry");
var l8 = new Bt(),
  uf = new Fg(),
  gx = new Zc(),
  u8 = new ne(),
  ad = new ne(),
  ld = new ne(),
  ud = new ne(),
  nS = new ne(),
  vx = new ne(),
  yx = new je(),
  _x = new je(),
  xx = new je(),
  c8 = new ne(),
  h8 = new ne(),
  f8 = new ne(),
  bx = new ne(),
  Mx = new ne(),
  Ft = class extends jn {
    constructor(t = new Pi(), e = new Sr()) {
      super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
      return super.copy(t, e), void 0 !== t.morphTargetInfluences && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), void 0 !== t.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = t.material, this.geometry = t.geometry, this;
    }
    updateMorphTargets() {
      let t = this.geometry.morphAttributes,
        e = Object.keys(t);
      if (e.length > 0) {
        let n = t[e[0]];
        if (void 0 !== n) {
          this.morphTargetInfluences = [], this.morphTargetDictionary = {};
          for (let t = 0, e = n.length; t < e; t++) {
            let e = n[t].name || String(t);
            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t;
          }
        }
      }
    }
    getVertexPosition(t, e) {
      let n = this.geometry,
        i = n.attributes.position,
        r = n.morphAttributes.position,
        o = n.morphTargetsRelative;
      e.fromBufferAttribute(i, t);
      let s = this.morphTargetInfluences;
      if (r && s) {
        vx.set(0, 0, 0);
        for (let n = 0, i = r.length; n < i; n++) {
          let i = s[n],
            a = r[n];
          0 !== i && (nS.fromBufferAttribute(a, t), o ? vx.addScaledVector(nS, i) : vx.addScaledVector(nS.sub(e), i));
        }
        e.add(vx);
      }
      return e;
    }
    raycast(t, e) {
      let n = this.geometry,
        i = this.material,
        r = this.matrixWorld;
      void 0 !== i && (null === n.boundingSphere && n.computeBoundingSphere(), gx.copy(n.boundingSphere), gx.applyMatrix4(r), uf.copy(t.ray).recast(t.near), (!1 !== gx.containsPoint(uf.origin) || !(null === uf.intersectSphere(gx, u8) || uf.origin.distanceToSquared(u8) > (t.far - t.near) ** 2)) && (l8.copy(r).invert(), uf.copy(t.ray).applyMatrix4(l8), (null === n.boundingBox || !1 !== uf.intersectsBox(n.boundingBox)) && this._computeIntersections(t, e, uf)));
    }
    _computeIntersections(t, e, n) {
      let i,
        r = this.geometry,
        o = this.material,
        s = r.index,
        a = r.attributes.position,
        l = r.attributes.uv,
        u = r.attributes.uv1,
        h = r.attributes.normal,
        c = r.groups,
        p = r.drawRange;
      if (null !== s) {
        if (Array.isArray(o)) for (let r = 0, a = c.length; r < a; r++) {
          let a = c[r],
            d = o[a.materialIndex];
          for (let r = Math.max(a.start, p.start), o = Math.min(s.count, Math.min(a.start + a.count, p.start + p.count)); r < o; r += 3) {
            i = Ex(this, d, t, n, l, u, h, s.getX(r), s.getX(r + 1), s.getX(r + 2)), i && (i.faceIndex = Math.floor(r / 3), i.face.materialIndex = a.materialIndex, e.push(i));
          }
        } else {
          for (let r = Math.max(0, p.start), a = Math.min(s.count, p.start + p.count); r < a; r += 3) {
            i = Ex(this, o, t, n, l, u, h, s.getX(r), s.getX(r + 1), s.getX(r + 2)), i && (i.faceIndex = Math.floor(r / 3), e.push(i));
          }
        }
      } else if (void 0 !== a) if (Array.isArray(o)) for (let r = 0, s = c.length; r < s; r++) {
        let s = c[r],
          d = o[s.materialIndex];
        for (let r = Math.max(s.start, p.start), o = Math.min(a.count, Math.min(s.start + s.count, p.start + p.count)); r < o; r += 3) {
          i = Ex(this, d, t, n, l, u, h, r, r + 1, r + 2), i && (i.faceIndex = Math.floor(r / 3), i.face.materialIndex = s.materialIndex, e.push(i));
        }
      } else {
        for (let r = Math.max(0, p.start), s = Math.min(a.count, p.start + p.count); r < s; r += 3) {
          i = Ex(this, o, t, n, l, u, h, r, r + 1, r + 2), i && (i.faceIndex = Math.floor(r / 3), e.push(i));
        }
      }
    }
  };
function QV(t, e, n, i, r, o, s, a) {
  let l;
  if (l = e.side === Ts ? i.intersectTriangle(s, o, r, !0, a) : i.intersectTriangle(r, o, s, e.side === ja, a), null === l) return null;
  Mx.copy(a), Mx.applyMatrix4(t.matrixWorld);
  let u = n.ray.origin.distanceTo(Mx);
  return u < n.near || u > n.far ? null : {
    distance: u,
    point: Mx.clone(),
    object: t
  };
}
function Ex(t, e, n, i, r, o, s, a, l, u) {
  t.getVertexPosition(a, ad), t.getVertexPosition(l, ld), t.getVertexPosition(u, ud);
  let h = QV(t, e, n, i, ad, ld, ud, bx);
  if (h) {
    r && (yx.fromBufferAttribute(r, a), _x.fromBufferAttribute(r, l), xx.fromBufferAttribute(r, u), h.uv = Hs.getInterpolation(bx, ad, ld, ud, yx, _x, xx, new je())), o && (yx.fromBufferAttribute(o, a), _x.fromBufferAttribute(o, l), xx.fromBufferAttribute(o, u), h.uv1 = Hs.getInterpolation(bx, ad, ld, ud, yx, _x, xx, new je()), h.uv2 = h.uv1), s && (c8.fromBufferAttribute(s, a), h8.fromBufferAttribute(s, l), f8.fromBufferAttribute(s, u), h.normal = Hs.getInterpolation(bx, ad, ld, ud, c8, h8, f8, new ne()), h.normal.dot(i.direction) > 0 && h.normal.multiplyScalar(-1));
    let t = {
      a: a,
      b: l,
      c: u,
      normal: new ne(),
      materialIndex: 0
    };
    Hs.getNormal(ad, ld, ud, t.normal), h.face = t;
  }
  return h;
}
u(Ft, "Mesh"), u(QV, "checkIntersection"), u(Ex, "checkGeometryIntersection");
var Ka = class extends Pi {
  constructor(t = 1, e = 1, n = 1, i = 1, r = 1, o = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: t,
      height: e,
      depth: n,
      widthSegments: i,
      heightSegments: r,
      depthSegments: o
    };
    let s = this;
    i = Math.floor(i), r = Math.floor(r), o = Math.floor(o);
    let a = [],
      l = [],
      h = [],
      c = [],
      p = 0,
      d = 0;
    function f(t, e, n, i, r, o, u, f, m, g, v) {
      let y = o / m,
        _ = u / g,
        x = o / 2,
        E = u / 2,
        b = f / 2,
        w = m + 1,
        S = g + 1,
        M = 0,
        T = 0,
        A = new ne();
      for (let o = 0; o < S; o++) {
        let s = o * _ - E;
        for (let a = 0; a < w; a++) {
          let u = a * y - x;
          A[t] = u * i, A[e] = s * r, A[n] = b, l.push(A.x, A.y, A.z), A[t] = 0, A[e] = 0, A[n] = f > 0 ? 1 : -1, h.push(A.x, A.y, A.z), c.push(a / m), c.push(1 - o / g), M += 1;
        }
      }
      for (let t = 0; t < g; t++) for (let e = 0; e < m; e++) {
        let n = p + e + w * t,
          i = p + e + w * (t + 1),
          r = p + (e + 1) + w * (t + 1),
          o = p + (e + 1) + w * t;
        a.push(n, i, o), a.push(i, r, o), T += 6;
      }
      s.addGroup(d, T, v), d += T, p += M;
    }
    f("z", "y", "x", -1, -1, n, e, t, o, r, 0), f("z", "y", "x", 1, -1, n, e, -t, o, r, 1), f("x", "z", "y", 1, 1, t, n, e, i, o, 2), f("x", "z", "y", 1, -1, t, n, -e, i, o, 3), f("x", "y", "z", 1, -1, t, e, n, i, r, 4), f("x", "y", "z", -1, -1, t, e, -n, i, r, 5), this.setIndex(a), this.setAttribute("position", new Di(l, 3)), this.setAttribute("normal", new Di(h, 3)), this.setAttribute("uv", new Di(c, 2)), u(f, "buildPlane");
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  static fromJSON(t) {
    return new Ka(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
  }
};
function cd(t) {
  let e = {};
  for (let n in t) {
    e[n] = {};
    for (let i in t[n]) {
      let r = t[n][i];
      r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture || r.isQuaternion) ? r.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[n][i] = null) : e[n][i] = r.clone() : Array.isArray(r) ? e[n][i] = r.slice() : e[n][i] = r;
    }
  }
  return e;
}
function ss(t) {
  let e = {};
  for (let n = 0; n < t.length; n++) {
    let i = cd(t[n]);
    for (let t in i) e[t] = i[t];
  }
  return e;
}
function $V(t) {
  let e = [];
  for (let n = 0; n < t.length; n++) e.push(t[n].clone());
  return e;
}
function p8(t) {
  return null === t.getRenderTarget() ? t.outputColorSpace : Cl;
}
u(Ka, "BoxGeometry"), u(cd, "cloneUniforms"), u(ss, "mergeUniforms"), u($V, "cloneUniformsGroups"), u(p8, "getUnlitUniformColorSpace");
var iS = {
    clone: cd,
    merge: ss
  },
  eG = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}",
  tG = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}",
  wi = class extends $c {
    constructor(t) {
      super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = eG, this.fragmentShader = tG, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
        derivatives: !1,
        fragDepth: !1,
        drawBuffers: !1,
        shaderTextureLOD: !1
      }, this.defaultAttributeValues = {
        color: [1, 1, 1],
        uv: [0, 0],
        uv1: [0, 0]
      }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== t && this.setValues(t);
    }
    copy(t) {
      return super.copy(t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = cd(t.uniforms), this.uniformsGroups = $V(t.uniformsGroups), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.fog = t.fog, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
    }
    toJSON(t) {
      let e = super.toJSON(t);
      e.glslVersion = this.glslVersion, e.uniforms = {};
      for (let n in this.uniforms) {
        let i = this.uniforms[n].value;
        i && i.isTexture ? e.uniforms[n] = {
          type: "t",
          value: i.toJSON(t).uuid
        } : i && i.isColor ? e.uniforms[n] = {
          type: "c",
          value: i.getHex()
        } : i && i.isVector2 ? e.uniforms[n] = {
          type: "v2",
          value: i.toArray()
        } : i && i.isVector3 ? e.uniforms[n] = {
          type: "v3",
          value: i.toArray()
        } : i && i.isVector4 ? e.uniforms[n] = {
          type: "v4",
          value: i.toArray()
        } : i && i.isMatrix3 ? e.uniforms[n] = {
          type: "m3",
          value: i.toArray()
        } : i && i.isMatrix4 ? e.uniforms[n] = {
          type: "m4",
          value: i.toArray()
        } : e.uniforms[n] = {
          value: i
        };
      }
      Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.lights = this.lights, e.clipping = this.clipping;
      let n = {};
      for (let t in this.extensions) !0 === this.extensions[t] && (n[t] = !0);
      return Object.keys(n).length > 0 && (e.extensions = n), e;
    }
  };
u(wi, "ShaderMaterial");
var wx = class extends jn {
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Bt(), this.projectionMatrix = new Bt(), this.projectionMatrixInverse = new Bt(), this.coordinateSystem = Nu;
  }
  copy(t, e) {
    return super.copy(t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this.coordinateSystem = t.coordinateSystem, this;
  }
  getWorldDirection(t) {
    this.updateWorldMatrix(!0, !1);
    let e = this.matrixWorld.elements;
    return t.set(-e[8], -e[9], -e[10]).normalize();
  }
  updateMatrixWorld(t) {
    super.updateMatrixWorld(t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(t, e) {
    super.updateWorldMatrix(t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
u(wx, "Camera");
var as = class extends wx {
  constructor(t = 50, e = 1, n = .1, i = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(t, e) {
    return super.copy(t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = null === t.view ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
  }
  setFocalLength(t) {
    let e = .5 * this.getFilmHeight() / t;
    this.fov = 2 * k3 * Math.atan(e), this.updateProjectionMatrix();
  }
  getFocalLength() {
    let t = Math.tan(.5 * q3 * this.fov);
    return .5 * this.getFilmHeight() / t;
  }
  getEffectiveFOV() {
    return 2 * k3 * Math.atan(Math.tan(.5 * q3 * this.fov) / this.zoom);
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  setViewOffset(t, e, n, i, r, o) {
    this.aspect = t / e, null === this.view && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = o, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    let t = this.near,
      e = t * Math.tan(.5 * q3 * this.fov) / this.zoom,
      n = 2 * e,
      i = this.aspect * n,
      r = -.5 * i,
      o = this.view;
    if (null !== this.view && this.view.enabled) {
      let t = o.fullWidth,
        s = o.fullHeight;
      r += o.offsetX * i / t, e -= o.offsetY * n / s, i *= o.width / t, n *= o.height / s;
    }
    let s = this.filmOffset;
    0 !== s && (r += t * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, e, e - n, t, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(t) {
    let e = super.toJSON(t);
    return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
  }
};
u(as, "PerspectiveCamera");
var hd = -90,
  fd = 1,
  rS = class extends jn {
    constructor(t, e, n) {
      super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null;
      let i = new as(hd, fd, t, e);
      i.layers = this.layers, this.add(i);
      let r = new as(hd, fd, t, e);
      r.layers = this.layers, this.add(r);
      let o = new as(hd, fd, t, e);
      o.layers = this.layers, this.add(o);
      let s = new as(hd, fd, t, e);
      s.layers = this.layers, this.add(s);
      let a = new as(hd, fd, t, e);
      a.layers = this.layers, this.add(a);
      let l = new as(hd, fd, t, e);
      l.layers = this.layers, this.add(l);
    }
    updateCoordinateSystem() {
      let t = this.coordinateSystem,
        e = this.children.concat(),
        [n, i, r, o, s, a] = e;
      for (let t of e) this.remove(t);
      if (t === Nu) n.up.set(0, 1, 0), n.lookAt(1, 0, 0), i.up.set(0, 1, 0), i.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), o.up.set(0, 0, 1), o.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), a.up.set(0, 1, 0), a.lookAt(0, 0, -1);else {
        if (t !== $_) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + t);
        n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), i.up.set(0, -1, 0), i.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), o.up.set(0, 0, -1), o.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), a.up.set(0, -1, 0), a.lookAt(0, 0, -1);
      }
      for (let t of e) this.add(t), t.updateMatrixWorld();
    }
    update(t, e) {
      null === this.parent && this.updateMatrixWorld();
      let n = this.renderTarget;
      this.coordinateSystem !== t.coordinateSystem && (this.coordinateSystem = t.coordinateSystem, this.updateCoordinateSystem());
      let [i, r, o, s, a, l] = this.children,
        u = t.getRenderTarget(),
        h = t.toneMapping,
        c = t.xr.enabled;
      t.toneMapping = Au, t.xr.enabled = !1;
      let p = n.texture.generateMipmaps;
      n.texture.generateMipmaps = !1, t.setRenderTarget(n, 0), t.render(e, i), t.setRenderTarget(n, 1), t.render(e, r), t.setRenderTarget(n, 2), t.render(e, o), t.setRenderTarget(n, 3), t.render(e, s), t.setRenderTarget(n, 4), t.render(e, a), n.texture.generateMipmaps = p, t.setRenderTarget(n, 5), t.render(e, l), t.setRenderTarget(u), t.toneMapping = h, t.xr.enabled = c, n.texture.needsPMREMUpdate = !0;
    }
  };
u(rS, "CubeCamera");
var Sx = class extends lo {
  constructor(t, e, n, i, r, o, s, a, l, u) {
    super(t = void 0 !== t ? t : [], e = void 0 !== e ? e : jp, n, i, r, o, s, a, l, u), this.isCubeTexture = !0, this.flipY = !1;
  }
  get images() {
    return this.image;
  }
  set images(t) {
    this.image = t;
  }
};
u(Sx, "CubeTexture");
var oS = class extends wr {
  constructor(t = 1, e = {}) {
    super(t, t, e), this.isWebGLCubeRenderTarget = !0;
    let n = {
        width: t,
        height: t,
        depth: 1
      },
      i = [n, n, n, n, n, n];
    void 0 !== e.encoding && (Dg("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."), e.colorSpace = e.encoding === Pl ? Nt : Ou), this.texture = new Sx(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = void 0 !== e.generateMipmaps && e.generateMipmaps, this.texture.minFilter = void 0 !== e.minFilter ? e.minFilter : ao;
  }
  fromEquirectangularTexture(t, e) {
    this.texture.type = e.type, this.texture.colorSpace = e.colorSpace, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
    let n = {
        uniforms: {
          tEquirect: {
            value: null
          }
        },
        vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
        fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
      },
      i = new Ka(5, 5, 5),
      r = new wi({
        name: "CubemapFromEquirect",
        uniforms: cd(n.uniforms),
        vertexShader: n.vertexShader,
        fragmentShader: n.fragmentShader,
        side: Ts,
        blending: jc
      });
    r.uniforms.tEquirect.value = e;
    let o = new Ft(i, r),
      s = e.minFilter;
    return e.minFilter === Og && (e.minFilter = ao), new rS(1, 10, this).update(t, o), e.minFilter = s, o.geometry.dispose(), o.material.dispose(), this;
  }
  clear(t, e, n, i) {
    let r = t.getRenderTarget();
    for (let r = 0; r < 6; r++) t.setRenderTarget(this, r), t.clear(e, n, i);
    t.setRenderTarget(r);
  }
};
u(oS, "WebGLCubeRenderTarget");
var sS = new ne(),
  nG = new ne(),
  iG = new Qt(),
  zu = class {
    constructor(t = new ne(1, 0, 0), e = 0) {
      this.isPlane = !0, this.normal = t, this.constant = e;
    }
    set(t, e) {
      return this.normal.copy(t), this.constant = e, this;
    }
    setComponents(t, e, n, i) {
      return this.normal.set(t, e, n), this.constant = i, this;
    }
    setFromNormalAndCoplanarPoint(t, e) {
      return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }
    setFromCoplanarPoints(t, e, n) {
      let i = sS.subVectors(n, e).cross(nG.subVectors(t, e)).normalize();
      return this.setFromNormalAndCoplanarPoint(i, t), this;
    }
    copy(t) {
      return this.normal.copy(t.normal), this.constant = t.constant, this;
    }
    normalize() {
      let t = 1 / this.normal.length();
      return this.normal.multiplyScalar(t), this.constant *= t, this;
    }
    negate() {
      return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(t) {
      return this.normal.dot(t) + this.constant;
    }
    distanceToSphere(t) {
      return this.distanceToPoint(t.center) - t.radius;
    }
    projectPoint(t, e) {
      return e.copy(t).addScaledVector(this.normal, -this.distanceToPoint(t));
    }
    intersectLine(t, e) {
      let n = t.delta(sS),
        i = this.normal.dot(n);
      if (0 === i) return 0 === this.distanceToPoint(t.start) ? e.copy(t.start) : null;
      let r = -(t.start.dot(this.normal) + this.constant) / i;
      return r < 0 || r > 1 ? null : e.copy(t.start).addScaledVector(n, r);
    }
    intersectsLine(t) {
      let e = this.distanceToPoint(t.start),
        n = this.distanceToPoint(t.end);
      return e < 0 && n > 0 || n < 0 && e > 0;
    }
    intersectsBox(t) {
      return t.intersectsPlane(this);
    }
    intersectsSphere(t) {
      return t.intersectsPlane(this);
    }
    coplanarPoint(t) {
      return t.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(t, e) {
      let n = e || iG.getNormalMatrix(t),
        i = this.coplanarPoint(sS).applyMatrix4(t),
        r = this.normal.applyMatrix3(n).normalize();
      return this.constant = -i.dot(r), this;
    }
    translate(t) {
      return this.constant -= t.dot(this.normal), this;
    }
    equals(t) {
      return t.normal.equals(this.normal) && t.constant === this.constant;
    }
    clone() {
      return new this.constructor().copy(this);
    }
  };
u(zu, "Plane");
var cf = new Zc(),
  Tx = new ne(),
  hf = class {
    constructor(t = new zu(), e = new zu(), n = new zu(), i = new zu(), r = new zu(), o = new zu()) {
      this.planes = [t, e, n, i, r, o];
    }
    set(t, e, n, i, r, o) {
      let s = this.planes;
      return s[0].copy(t), s[1].copy(e), s[2].copy(n), s[3].copy(i), s[4].copy(r), s[5].copy(o), this;
    }
    copy(t) {
      let e = this.planes;
      for (let n = 0; n < 6; n++) e[n].copy(t.planes[n]);
      return this;
    }
    setFromProjectionMatrix(t, e = Nu) {
      let n = this.planes,
        i = t.elements,
        r = i[0],
        o = i[1],
        s = i[2],
        a = i[3],
        l = i[4],
        u = i[5],
        h = i[6],
        c = i[7],
        p = i[8],
        d = i[9],
        f = i[10],
        m = i[11],
        g = i[12],
        v = i[13],
        y = i[14],
        _ = i[15];
      if (n[0].setComponents(a - r, c - l, m - p, _ - g).normalize(), n[1].setComponents(a + r, c + l, m + p, _ + g).normalize(), n[2].setComponents(a + o, c + u, m + d, _ + v).normalize(), n[3].setComponents(a - o, c - u, m - d, _ - v).normalize(), n[4].setComponents(a - s, c - h, m - f, _ - y).normalize(), e === Nu) n[5].setComponents(a + s, c + h, m + f, _ + y).normalize();else {
        if (e !== $_) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + e);
        n[5].setComponents(s, h, f, y).normalize();
      }
      return this;
    }
    intersectsObject(t) {
      if (void 0 !== t.boundingSphere) null === t.boundingSphere && t.computeBoundingSphere(), cf.copy(t.boundingSphere).applyMatrix4(t.matrixWorld);else {
        let e = t.geometry;
        null === e.boundingSphere && e.computeBoundingSphere(), cf.copy(e.boundingSphere).applyMatrix4(t.matrixWorld);
      }
      return this.intersectsSphere(cf);
    }
    intersectsSprite(t) {
      return cf.center.set(0, 0, 0), cf.radius = .7071067811865476, cf.applyMatrix4(t.matrixWorld), this.intersectsSphere(cf);
    }
    intersectsSphere(t) {
      let e = this.planes,
        n = t.center,
        i = -t.radius;
      for (let t = 0; t < 6; t++) if (e[t].distanceToPoint(n) < i) return !1;
      return !0;
    }
    intersectsBox(t) {
      let e = this.planes;
      for (let n = 0; n < 6; n++) {
        let i = e[n];
        if (Tx.x = i.normal.x > 0 ? t.max.x : t.min.x, Tx.y = i.normal.y > 0 ? t.max.y : t.min.y, Tx.z = i.normal.z > 0 ? t.max.z : t.min.z, i.distanceToPoint(Tx) < 0) return !1;
      }
      return !0;
    }
    containsPoint(t) {
      let e = this.planes;
      for (let n = 0; n < 6; n++) if (e[n].distanceToPoint(t) < 0) return !1;
      return !0;
    }
    clone() {
      return new this.constructor().copy(this);
    }
  };
function d8() {
  let t = null,
    e = !1,
    n = null,
    i = null;
  function r(e, o) {
    n(e, o), i = t.requestAnimationFrame(r);
  }
  return u(r, "onAnimationFrame"), {
    start: function () {
      !0 !== e && null !== n && (i = t.requestAnimationFrame(r), e = !0);
    },
    stop: function () {
      t.cancelAnimationFrame(i), e = !1;
    },
    setAnimationLoop: function (t) {
      n = t;
    },
    setContext: function (e) {
      t = e;
    }
  };
}
function rG(t, e) {
  let n = e.isWebGL2,
    i = new WeakMap();
  function r(e, i) {
    let r,
      o = e.array,
      s = e.usage,
      a = t.createBuffer();
    if (t.bindBuffer(i, a), t.bufferData(i, o, s), e.onUploadCallback(), o instanceof Float32Array) r = t.FLOAT;else if (o instanceof Uint16Array) {
      if (e.isFloat16BufferAttribute) {
        if (!n) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
        r = t.HALF_FLOAT;
      } else r = t.UNSIGNED_SHORT;
    } else if (o instanceof Int16Array) r = t.SHORT;else if (o instanceof Uint32Array) r = t.UNSIGNED_INT;else if (o instanceof Int32Array) r = t.INT;else if (o instanceof Int8Array) r = t.BYTE;else if (o instanceof Uint8Array) r = t.UNSIGNED_BYTE;else {
      if (!(o instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + o);
      r = t.UNSIGNED_BYTE;
    }
    return {
      buffer: a,
      type: r,
      bytesPerElement: o.BYTES_PER_ELEMENT,
      version: e.version
    };
  }
  function o(e, i, r) {
    let o = i.array,
      s = i.updateRange;
    t.bindBuffer(r, e), -1 === s.count ? t.bufferSubData(r, 0, o) : (n ? t.bufferSubData(r, s.offset * o.BYTES_PER_ELEMENT, o, s.offset, s.count) : t.bufferSubData(r, s.offset * o.BYTES_PER_ELEMENT, o.subarray(s.offset, s.offset + s.count)), s.count = -1), i.onUploadCallback();
  }
  function s(t) {
    return t.isInterleavedBufferAttribute && (t = t.data), i.get(t);
  }
  function a(e) {
    e.isInterleavedBufferAttribute && (e = e.data);
    let n = i.get(e);
    n && (t.deleteBuffer(n.buffer), i.delete(e));
  }
  function l(t, e) {
    if (t.isGLBufferAttribute) {
      let e = i.get(t);
      return void ((!e || e.version < t.version) && i.set(t, {
        buffer: t.buffer,
        type: t.type,
        bytesPerElement: t.elementSize,
        version: t.version
      }));
    }
    t.isInterleavedBufferAttribute && (t = t.data);
    let n = i.get(t);
    void 0 === n ? i.set(t, r(t, e)) : n.version < t.version && (o(n.buffer, t, e), n.version = t.version);
  }
  return u(r, "createBuffer"), u(o, "updateBuffer"), u(s, "get"), u(a, "remove"), u(l, "update"), {
    get: s,
    remove: a,
    update: l
  };
}
u(hf, "Frustum"), u(d8, "WebGLAnimation"), u(rG, "WebGLAttributes");
var co = class extends Pi {
  constructor(t = 1, e = 1, n = 1, i = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: t,
      height: e,
      widthSegments: n,
      heightSegments: i
    };
    let r = t / 2,
      o = e / 2,
      s = Math.floor(n),
      a = Math.floor(i),
      l = s + 1,
      u = a + 1,
      h = t / s,
      c = e / a,
      p = [],
      d = [],
      f = [],
      m = [];
    for (let t = 0; t < u; t++) {
      let e = t * c - o;
      for (let n = 0; n < l; n++) {
        let i = n * h - r;
        d.push(i, -e, 0), f.push(0, 0, 1), m.push(n / s), m.push(1 - t / a);
      }
    }
    for (let t = 0; t < a; t++) for (let e = 0; e < s; e++) {
      let n = e + l * t,
        i = e + l * (t + 1),
        r = e + 1 + l * (t + 1),
        o = e + 1 + l * t;
      p.push(n, i, o), p.push(i, r, o);
    }
    this.setIndex(p), this.setAttribute("position", new Di(d, 3)), this.setAttribute("normal", new Di(f, 3)), this.setAttribute("uv", new Di(m, 2));
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  static fromJSON(t) {
    return new co(t.width, t.height, t.widthSegments, t.heightSegments);
  }
};
u(co, "PlaneGeometry");
var oG = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
  sG = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
  aG = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif",
  lG = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
  uG = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
  cG = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
  hG = "vec3 transformed = vec3( position );",
  fG = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
  pG = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated",
  dG = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\t return vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat R21 = R12;\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif",
  mG = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos.xyz );\n\t\tvec3 vSigmaY = dFdy( surf_pos.xyz );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
  gG = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif",
  vG = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
  yG = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
  _G = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
  xG = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
  bG = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
  MG = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif",
  EG = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif",
  wG = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
  SG = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
  TG = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
  PG = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
  CG = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
  AG = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
  IG = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
  LG = "gl_FragColor = linearToOutputTexel( gl_FragColor );",
  OG = "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
  RG = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
  NG = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif",
  DG = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
  qG = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
  kG = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
  FG = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
  BG = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
  UG = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
  zG = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
  VG = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}",
  GG = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
  HG = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
  jG = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
  WG = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert",
  XG = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif",
  YG = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif",
  ZG = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
  JG = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon",
  KG = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
  QG = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong",
  $G = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tanisotropyV /= material.anisotropy;\n\tmaterial.anisotropy = saturate( material.anisotropy );\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif",
  eH = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
  tH = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometry.viewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
  nH = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometry.viewDir, geometry.normal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
  iH = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif",
  rH = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
  oH = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
  sH = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif",
  aH = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif",
  lH = "#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, vMapUv );\n#endif",
  uH = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
  cH = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
  hH = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
  fH = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
  pH = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
  dH = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif",
  mH = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif",
  gH = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif",
  vH = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif",
  yH = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 geometryNormal = normal;",
  _H = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
  xH = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
  bH = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
  MH = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif",
  EH = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif",
  wH = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif",
  SH = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
  TH = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif",
  PH = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif",
  CH = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
  AH = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}",
  IH = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
  LH = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
  OH = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
  RH = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
  NH = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
  DH = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
  qH = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif",
  kH = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
  FH = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif",
  BH = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
  UH = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
  zH = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif",
  VH = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
  GH = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
  HH = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
  jH = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
  WH = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
  XH = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
  YH = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
  ZH = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif",
  JH = "#ifdef USE_UV\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
  KH = "#ifdef USE_UV\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
  QH = "#ifdef USE_UV\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
  $H = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
  ej = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
  tj = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  nj = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
  ij = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  rj = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
  oj = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  sj = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
  aj = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}",
  lj = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
  uj = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
  cj = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
  hj = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  fj = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
  pj = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
  dj = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
  mj = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  gj = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  vj = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  yj = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
  _j = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  xj = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
  bj = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
  Mj = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  Ej = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  wj = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
  Sj = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  Tj = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  Pj = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  Cj = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
  Aj = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
  Ij = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  Lj = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
  Oj = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
  Rj = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
  tn = {
    alphamap_fragment: oG,
    alphamap_pars_fragment: sG,
    alphatest_fragment: aG,
    alphatest_pars_fragment: lG,
    aomap_fragment: uG,
    aomap_pars_fragment: cG,
    begin_vertex: hG,
    beginnormal_vertex: fG,
    bsdfs: pG,
    iridescence_fragment: dG,
    bumpmap_pars_fragment: mG,
    clipping_planes_fragment: gG,
    clipping_planes_pars_fragment: vG,
    clipping_planes_pars_vertex: yG,
    clipping_planes_vertex: _G,
    color_fragment: xG,
    color_pars_fragment: bG,
    color_pars_vertex: MG,
    color_vertex: EG,
    common: wG,
    cube_uv_reflection_fragment: SG,
    defaultnormal_vertex: TG,
    displacementmap_pars_vertex: PG,
    displacementmap_vertex: CG,
    emissivemap_fragment: AG,
    emissivemap_pars_fragment: IG,
    encodings_fragment: LG,
    encodings_pars_fragment: OG,
    envmap_fragment: RG,
    envmap_common_pars_fragment: NG,
    envmap_pars_fragment: DG,
    envmap_pars_vertex: qG,
    envmap_physical_pars_fragment: YG,
    envmap_vertex: kG,
    fog_vertex: FG,
    fog_pars_vertex: BG,
    fog_fragment: UG,
    fog_pars_fragment: zG,
    gradientmap_pars_fragment: VG,
    lightmap_fragment: GG,
    lightmap_pars_fragment: HG,
    lights_lambert_fragment: jG,
    lights_lambert_pars_fragment: WG,
    lights_pars_begin: XG,
    lights_toon_fragment: ZG,
    lights_toon_pars_fragment: JG,
    lights_phong_fragment: KG,
    lights_phong_pars_fragment: QG,
    lights_physical_fragment: $G,
    lights_physical_pars_fragment: eH,
    lights_fragment_begin: tH,
    lights_fragment_maps: nH,
    lights_fragment_end: iH,
    logdepthbuf_fragment: rH,
    logdepthbuf_pars_fragment: oH,
    logdepthbuf_pars_vertex: sH,
    logdepthbuf_vertex: aH,
    map_fragment: lH,
    map_pars_fragment: uH,
    map_particle_fragment: cH,
    map_particle_pars_fragment: hH,
    metalnessmap_fragment: fH,
    metalnessmap_pars_fragment: pH,
    morphcolor_vertex: dH,
    morphnormal_vertex: mH,
    morphtarget_pars_vertex: gH,
    morphtarget_vertex: vH,
    normal_fragment_begin: yH,
    normal_fragment_maps: _H,
    normal_pars_fragment: xH,
    normal_pars_vertex: bH,
    normal_vertex: MH,
    normalmap_pars_fragment: EH,
    clearcoat_normal_fragment_begin: wH,
    clearcoat_normal_fragment_maps: SH,
    clearcoat_pars_fragment: TH,
    iridescence_pars_fragment: PH,
    output_fragment: CH,
    packing: AH,
    premultiplied_alpha_fragment: IH,
    project_vertex: LH,
    dithering_fragment: OH,
    dithering_pars_fragment: RH,
    roughnessmap_fragment: NH,
    roughnessmap_pars_fragment: DH,
    shadowmap_pars_fragment: qH,
    shadowmap_pars_vertex: kH,
    shadowmap_vertex: FH,
    shadowmask_pars_fragment: BH,
    skinbase_vertex: UH,
    skinning_pars_vertex: zH,
    skinning_vertex: VH,
    skinnormal_vertex: GH,
    specularmap_fragment: HH,
    specularmap_pars_fragment: jH,
    tonemapping_fragment: WH,
    tonemapping_pars_fragment: XH,
    transmission_fragment: YH,
    transmission_pars_fragment: ZH,
    uv_pars_fragment: JH,
    uv_pars_vertex: KH,
    uv_vertex: QH,
    worldpos_vertex: $H,
    background_vert: ej,
    background_frag: tj,
    backgroundCube_vert: nj,
    backgroundCube_frag: ij,
    cube_vert: rj,
    cube_frag: oj,
    depth_vert: sj,
    depth_frag: aj,
    distanceRGBA_vert: lj,
    distanceRGBA_frag: uj,
    equirect_vert: cj,
    equirect_frag: hj,
    linedashed_vert: fj,
    linedashed_frag: pj,
    meshbasic_vert: dj,
    meshbasic_frag: mj,
    meshlambert_vert: gj,
    meshlambert_frag: vj,
    meshmatcap_vert: yj,
    meshmatcap_frag: _j,
    meshnormal_vert: xj,
    meshnormal_frag: bj,
    meshphong_vert: Mj,
    meshphong_frag: Ej,
    meshphysical_vert: wj,
    meshphysical_frag: Sj,
    meshtoon_vert: Tj,
    meshtoon_frag: Pj,
    points_vert: Cj,
    points_frag: Aj,
    shadow_vert: Ij,
    shadow_frag: Lj,
    sprite_vert: Oj,
    sprite_frag: Rj
  },
  ht = {
    common: {
      diffuse: {
        value: new yt(16777215)
      },
      opacity: {
        value: 1
      },
      map: {
        value: null
      },
      mapTransform: {
        value: new Qt()
      },
      alphaMap: {
        value: null
      },
      alphaMapTransform: {
        value: new Qt()
      },
      alphaTest: {
        value: 0
      }
    },
    specularmap: {
      specularMap: {
        value: null
      },
      specularMapTransform: {
        value: new Qt()
      }
    },
    envmap: {
      envMap: {
        value: null
      },
      flipEnvMap: {
        value: -1
      },
      reflectivity: {
        value: 1
      },
      ior: {
        value: 1.5
      },
      refractionRatio: {
        value: .98
      }
    },
    aomap: {
      aoMap: {
        value: null
      },
      aoMapIntensity: {
        value: 1
      },
      aoMapTransform: {
        value: new Qt()
      }
    },
    lightmap: {
      lightMap: {
        value: null
      },
      lightMapIntensity: {
        value: 1
      },
      lightMapTransform: {
        value: new Qt()
      }
    },
    bumpmap: {
      bumpMap: {
        value: null
      },
      bumpMapTransform: {
        value: new Qt()
      },
      bumpScale: {
        value: 1
      }
    },
    normalmap: {
      normalMap: {
        value: null
      },
      normalMapTransform: {
        value: new Qt()
      },
      normalScale: {
        value: new je(1, 1)
      }
    },
    displacementmap: {
      displacementMap: {
        value: null
      },
      displacementMapTransform: {
        value: new Qt()
      },
      displacementScale: {
        value: 1
      },
      displacementBias: {
        value: 0
      }
    },
    emissivemap: {
      emissiveMap: {
        value: null
      },
      emissiveMapTransform: {
        value: new Qt()
      }
    },
    metalnessmap: {
      metalnessMap: {
        value: null
      },
      metalnessMapTransform: {
        value: new Qt()
      }
    },
    roughnessmap: {
      roughnessMap: {
        value: null
      },
      roughnessMapTransform: {
        value: new Qt()
      }
    },
    gradientmap: {
      gradientMap: {
        value: null
      }
    },
    fog: {
      fogDensity: {
        value: 25e-5
      },
      fogNear: {
        value: 1
      },
      fogFar: {
        value: 2e3
      },
      fogColor: {
        value: new yt(16777215)
      }
    },
    lights: {
      ambientLightColor: {
        value: []
      },
      lightProbe: {
        value: []
      },
      directionalLights: {
        value: [],
        properties: {
          direction: {},
          color: {}
        }
      },
      directionalLightShadows: {
        value: [],
        properties: {
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {}
        }
      },
      directionalShadowMap: {
        value: []
      },
      directionalShadowMatrix: {
        value: []
      },
      spotLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          direction: {},
          distance: {},
          coneCos: {},
          penumbraCos: {},
          decay: {}
        }
      },
      spotLightShadows: {
        value: [],
        properties: {
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {}
        }
      },
      spotLightMap: {
        value: []
      },
      spotShadowMap: {
        value: []
      },
      spotLightMatrix: {
        value: []
      },
      pointLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          decay: {},
          distance: {}
        }
      },
      pointLightShadows: {
        value: [],
        properties: {
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
          shadowCameraNear: {},
          shadowCameraFar: {}
        }
      },
      pointShadowMap: {
        value: []
      },
      pointShadowMatrix: {
        value: []
      },
      hemisphereLights: {
        value: [],
        properties: {
          direction: {},
          skyColor: {},
          groundColor: {}
        }
      },
      rectAreaLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          width: {},
          height: {}
        }
      },
      ltc_1: {
        value: null
      },
      ltc_2: {
        value: null
      }
    },
    points: {
      diffuse: {
        value: new yt(16777215)
      },
      opacity: {
        value: 1
      },
      size: {
        value: 1
      },
      scale: {
        value: 1
      },
      map: {
        value: null
      },
      alphaMap: {
        value: null
      },
      alphaMapTransform: {
        value: new Qt()
      },
      alphaTest: {
        value: 0
      },
      uvTransform: {
        value: new Qt()
      }
    },
    sprite: {
      diffuse: {
        value: new yt(16777215)
      },
      opacity: {
        value: 1
      },
      center: {
        value: new je(.5, .5)
      },
      rotation: {
        value: 0
      },
      map: {
        value: null
      },
      mapTransform: {
        value: new Qt()
      },
      alphaMap: {
        value: null
      },
      alphaMapTransform: {
        value: new Qt()
      },
      alphaTest: {
        value: 0
      }
    }
  },
  Il = {
    basic: {
      uniforms: ss([ht.common, ht.specularmap, ht.envmap, ht.aomap, ht.lightmap, ht.fog]),
      vertexShader: tn.meshbasic_vert,
      fragmentShader: tn.meshbasic_frag
    },
    lambert: {
      uniforms: ss([ht.common, ht.specularmap, ht.envmap, ht.aomap, ht.lightmap, ht.emissivemap, ht.bumpmap, ht.normalmap, ht.displacementmap, ht.fog, ht.lights, {
        emissive: {
          value: new yt(0)
        }
      }]),
      vertexShader: tn.meshlambert_vert,
      fragmentShader: tn.meshlambert_frag
    },
    phong: {
      uniforms: ss([ht.common, ht.specularmap, ht.envmap, ht.aomap, ht.lightmap, ht.emissivemap, ht.bumpmap, ht.normalmap, ht.displacementmap, ht.fog, ht.lights, {
        emissive: {
          value: new yt(0)
        },
        specular: {
          value: new yt(1118481)
        },
        shininess: {
          value: 30
        }
      }]),
      vertexShader: tn.meshphong_vert,
      fragmentShader: tn.meshphong_frag
    },
    standard: {
      uniforms: ss([ht.common, ht.envmap, ht.aomap, ht.lightmap, ht.emissivemap, ht.bumpmap, ht.normalmap, ht.displacementmap, ht.roughnessmap, ht.metalnessmap, ht.fog, ht.lights, {
        emissive: {
          value: new yt(0)
        },
        roughness: {
          value: 1
        },
        metalness: {
          value: 0
        },
        envMapIntensity: {
          value: 1
        }
      }]),
      vertexShader: tn.meshphysical_vert,
      fragmentShader: tn.meshphysical_frag
    },
    toon: {
      uniforms: ss([ht.common, ht.aomap, ht.lightmap, ht.emissivemap, ht.bumpmap, ht.normalmap, ht.displacementmap, ht.gradientmap, ht.fog, ht.lights, {
        emissive: {
          value: new yt(0)
        }
      }]),
      vertexShader: tn.meshtoon_vert,
      fragmentShader: tn.meshtoon_frag
    },
    matcap: {
      uniforms: ss([ht.common, ht.bumpmap, ht.normalmap, ht.displacementmap, ht.fog, {
        matcap: {
          value: null
        }
      }]),
      vertexShader: tn.meshmatcap_vert,
      fragmentShader: tn.meshmatcap_frag
    },
    points: {
      uniforms: ss([ht.points, ht.fog]),
      vertexShader: tn.points_vert,
      fragmentShader: tn.points_frag
    },
    dashed: {
      uniforms: ss([ht.common, ht.fog, {
        scale: {
          value: 1
        },
        dashSize: {
          value: 1
        },
        totalSize: {
          value: 2
        }
      }]),
      vertexShader: tn.linedashed_vert,
      fragmentShader: tn.linedashed_frag
    },
    depth: {
      uniforms: ss([ht.common, ht.displacementmap]),
      vertexShader: tn.depth_vert,
      fragmentShader: tn.depth_frag
    },
    normal: {
      uniforms: ss([ht.common, ht.bumpmap, ht.normalmap, ht.displacementmap, {
        opacity: {
          value: 1
        }
      }]),
      vertexShader: tn.meshnormal_vert,
      fragmentShader: tn.meshnormal_frag
    },
    sprite: {
      uniforms: ss([ht.sprite, ht.fog]),
      vertexShader: tn.sprite_vert,
      fragmentShader: tn.sprite_frag
    },
    background: {
      uniforms: {
        uvTransform: {
          value: new Qt()
        },
        t2D: {
          value: null
        },
        backgroundIntensity: {
          value: 1
        }
      },
      vertexShader: tn.background_vert,
      fragmentShader: tn.background_frag
    },
    backgroundCube: {
      uniforms: {
        envMap: {
          value: null
        },
        flipEnvMap: {
          value: -1
        },
        backgroundBlurriness: {
          value: 0
        },
        backgroundIntensity: {
          value: 1
        }
      },
      vertexShader: tn.backgroundCube_vert,
      fragmentShader: tn.backgroundCube_frag
    },
    cube: {
      uniforms: {
        tCube: {
          value: null
        },
        tFlip: {
          value: -1
        },
        opacity: {
          value: 1
        }
      },
      vertexShader: tn.cube_vert,
      fragmentShader: tn.cube_frag
    },
    equirect: {
      uniforms: {
        tEquirect: {
          value: null
        }
      },
      vertexShader: tn.equirect_vert,
      fragmentShader: tn.equirect_frag
    },
    distanceRGBA: {
      uniforms: ss([ht.common, ht.displacementmap, {
        referencePosition: {
          value: new ne()
        },
        nearDistance: {
          value: 1
        },
        farDistance: {
          value: 1e3
        }
      }]),
      vertexShader: tn.distanceRGBA_vert,
      fragmentShader: tn.distanceRGBA_frag
    },
    shadow: {
      uniforms: ss([ht.lights, ht.fog, {
        color: {
          value: new yt(0)
        },
        opacity: {
          value: 1
        }
      }]),
      vertexShader: tn.shadow_vert,
      fragmentShader: tn.shadow_frag
    }
  };
Il.physical = {
  uniforms: ss([Il.standard.uniforms, {
    clearcoat: {
      value: 0
    },
    clearcoatMap: {
      value: null
    },
    clearcoatMapTransform: {
      value: new Qt()
    },
    clearcoatNormalMap: {
      value: null
    },
    clearcoatNormalMapTransform: {
      value: new Qt()
    },
    clearcoatNormalScale: {
      value: new je(1, 1)
    },
    clearcoatRoughness: {
      value: 0
    },
    clearcoatRoughnessMap: {
      value: null
    },
    clearcoatRoughnessMapTransform: {
      value: new Qt()
    },
    iridescence: {
      value: 0
    },
    iridescenceMap: {
      value: null
    },
    iridescenceMapTransform: {
      value: new Qt()
    },
    iridescenceIOR: {
      value: 1.3
    },
    iridescenceThicknessMinimum: {
      value: 100
    },
    iridescenceThicknessMaximum: {
      value: 400
    },
    iridescenceThicknessMap: {
      value: null
    },
    iridescenceThicknessMapTransform: {
      value: new Qt()
    },
    sheen: {
      value: 0
    },
    sheenColor: {
      value: new yt(0)
    },
    sheenColorMap: {
      value: null
    },
    sheenColorMapTransform: {
      value: new Qt()
    },
    sheenRoughness: {
      value: 1
    },
    sheenRoughnessMap: {
      value: null
    },
    sheenRoughnessMapTransform: {
      value: new Qt()
    },
    transmission: {
      value: 0
    },
    transmissionMap: {
      value: null
    },
    transmissionMapTransform: {
      value: new Qt()
    },
    transmissionSamplerSize: {
      value: new je()
    },
    transmissionSamplerMap: {
      value: null
    },
    thickness: {
      value: 0
    },
    thicknessMap: {
      value: null
    },
    thicknessMapTransform: {
      value: new Qt()
    },
    attenuationDistance: {
      value: 0
    },
    attenuationColor: {
      value: new yt(0)
    },
    specularColor: {
      value: new yt(1, 1, 1)
    },
    specularColorMap: {
      value: null
    },
    specularColorMapTransform: {
      value: new Qt()
    },
    specularIntensity: {
      value: 1
    },
    specularIntensityMap: {
      value: null
    },
    specularIntensityMapTransform: {
      value: new Qt()
    },
    anisotropyVector: {
      value: new je()
    },
    anisotropyMap: {
      value: null
    },
    anisotropyMapTransform: {
      value: new Qt()
    }
  }]),
  vertexShader: tn.meshphysical_vert,
  fragmentShader: tn.meshphysical_frag
};
var Px = {
  r: 0,
  b: 0,
  g: 0
};
function Nj(t, e, n, i, r, o, s) {
  let a,
    l,
    h = new yt(0),
    c = !0 === o ? 0 : 1,
    p = null,
    d = 0,
    f = null;
  function m(o, u) {
    let m = !1,
      v = !0 === u.isScene ? u.background : null;
    switch (v && v.isTexture && (v = (u.backgroundBlurriness > 0 ? n : e).get(v)), null === v ? g(h, c) : v && v.isColor && (g(v, 1), m = !0), t.xr.getEnvironmentBlendMode()) {
      case "opaque":
        m = !0;
        break;
      case "additive":
        i.buffers.color.setClear(0, 0, 0, 1, s), m = !0;
        break;
      case "alpha-blend":
        i.buffers.color.setClear(0, 0, 0, 0, s), m = !0;
    }
    (t.autoClear || m) && t.clear(t.autoClearColor, t.autoClearDepth, t.autoClearStencil), v && (v.isCubeTexture || v.mapping === Z_) ? (void 0 === l && (l = new Ft(new Ka(1, 1, 1), new wi({
      name: "BackgroundCubeMaterial",
      uniforms: cd(Il.backgroundCube.uniforms),
      vertexShader: Il.backgroundCube.vertexShader,
      fragmentShader: Il.backgroundCube.fragmentShader,
      side: Ts,
      depthTest: !1,
      depthWrite: !1,
      fog: !1
    })), l.geometry.deleteAttribute("normal"), l.geometry.deleteAttribute("uv"), l.onBeforeRender = function (t, e, n) {
      this.matrixWorld.copyPosition(n.matrixWorld);
    }, Object.defineProperty(l.material, "envMap", {
      get: function () {
        return this.uniforms.envMap.value;
      }
    }), r.update(l)), l.material.uniforms.envMap.value = v, l.material.uniforms.flipEnvMap.value = v.isCubeTexture && !1 === v.isRenderTargetTexture ? -1 : 1, l.material.uniforms.backgroundBlurriness.value = u.backgroundBlurriness, l.material.uniforms.backgroundIntensity.value = u.backgroundIntensity, l.material.toneMapped = v.colorSpace !== Nt, (p !== v || d !== v.version || f !== t.toneMapping) && (l.material.needsUpdate = !0, p = v, d = v.version, f = t.toneMapping), l.layers.enableAll(), o.unshift(l, l.geometry, l.material, 0, 0, null)) : v && v.isTexture && (void 0 === a && (a = new Ft(new co(2, 2), new wi({
      name: "BackgroundMaterial",
      uniforms: cd(Il.background.uniforms),
      vertexShader: Il.background.vertexShader,
      fragmentShader: Il.background.fragmentShader,
      side: ja,
      depthTest: !1,
      depthWrite: !1,
      fog: !1
    })), a.geometry.deleteAttribute("normal"), Object.defineProperty(a.material, "map", {
      get: function () {
        return this.uniforms.t2D.value;
      }
    }), r.update(a)), a.material.uniforms.t2D.value = v, a.material.uniforms.backgroundIntensity.value = u.backgroundIntensity, a.material.toneMapped = v.colorSpace !== Nt, !0 === v.matrixAutoUpdate && v.updateMatrix(), a.material.uniforms.uvTransform.value.copy(v.matrix), (p !== v || d !== v.version || f !== t.toneMapping) && (a.material.needsUpdate = !0, p = v, d = v.version, f = t.toneMapping), a.layers.enableAll(), o.unshift(a, a.geometry, a.material, 0, 0, null));
  }
  function g(e, n) {
    e.getRGB(Px, p8(t)), i.buffers.color.setClear(Px.r, Px.g, Px.b, n, s);
  }
  return u(m, "render"), u(g, "setClear"), {
    getClearColor: function () {
      return h;
    },
    setClearColor: function (t, e = 1) {
      h.set(t), c = e, g(h, c);
    },
    getClearAlpha: function () {
      return c;
    },
    setClearAlpha: function (t) {
      c = t, g(h, c);
    },
    render: m
  };
}
function Dj(t, e, n, i) {
  let r = t.getParameter(t.MAX_VERTEX_ATTRIBS),
    o = i.isWebGL2 ? null : e.get("OES_vertex_array_object"),
    s = i.isWebGL2 || null !== o,
    a = {},
    l = v(null),
    h = l,
    c = !1;
  function p(e, i, r, o, a) {
    let l = !1;
    if (s) {
      let t = g(o, r, i);
      h !== t && (h = t, f(h.object)), l = y(e, o, r, a), l && _(e, o, r, a);
    } else {
      let t = !0 === i.wireframe;
      (h.geometry !== o.id || h.program !== r.id || h.wireframe !== t) && (h.geometry = o.id, h.program = r.id, h.wireframe = t, l = !0);
    }
    null !== a && n.update(a, t.ELEMENT_ARRAY_BUFFER), (l || c) && (c = !1, M(e, i, r, o), null !== a && t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, n.get(a).buffer));
  }
  function d() {
    return i.isWebGL2 ? t.createVertexArray() : o.createVertexArrayOES();
  }
  function f(e) {
    return i.isWebGL2 ? t.bindVertexArray(e) : o.bindVertexArrayOES(e);
  }
  function m(e) {
    return i.isWebGL2 ? t.deleteVertexArray(e) : o.deleteVertexArrayOES(e);
  }
  function g(t, e, n) {
    let i = !0 === n.wireframe,
      r = a[t.id];
    void 0 === r && (r = {}, a[t.id] = r);
    let o = r[e.id];
    void 0 === o && (o = {}, r[e.id] = o);
    let s = o[i];
    return void 0 === s && (s = v(d()), o[i] = s), s;
  }
  function v(t) {
    let e = [],
      n = [],
      i = [];
    for (let t = 0; t < r; t++) e[t] = 0, n[t] = 0, i[t] = 0;
    return {
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: e,
      enabledAttributes: n,
      attributeDivisors: i,
      object: t,
      attributes: {},
      index: null
    };
  }
  function y(t, e, n, i) {
    let r = h.attributes,
      o = e.attributes,
      s = 0,
      a = n.getAttributes();
    for (let e in a) if (a[e].location >= 0) {
      let n = r[e],
        i = o[e];
      if (void 0 === i && ("instanceMatrix" === e && t.instanceMatrix && (i = t.instanceMatrix), "instanceColor" === e && t.instanceColor && (i = t.instanceColor)), void 0 === n || n.attribute !== i || i && n.data !== i.data) return !0;
      s++;
    }
    return h.attributesNum !== s || h.index !== i;
  }
  function _(t, e, n, i) {
    let r = {},
      o = e.attributes,
      s = 0,
      a = n.getAttributes();
    for (let e in a) if (a[e].location >= 0) {
      let n = o[e];
      void 0 === n && ("instanceMatrix" === e && t.instanceMatrix && (n = t.instanceMatrix), "instanceColor" === e && t.instanceColor && (n = t.instanceColor));
      let i = {};
      i.attribute = n, n && n.data && (i.data = n.data), r[e] = i, s++;
    }
    h.attributes = r, h.attributesNum = s, h.index = i;
  }
  function x() {
    let t = h.newAttributes;
    for (let e = 0, n = t.length; e < n; e++) t[e] = 0;
  }
  function E(t) {
    b(t, 0);
  }
  function b(n, r) {
    let o = h.newAttributes,
      s = h.enabledAttributes,
      a = h.attributeDivisors;
    o[n] = 1, 0 === s[n] && (t.enableVertexAttribArray(n), s[n] = 1), a[n] !== r && ((i.isWebGL2 ? t : e.get("ANGLE_instanced_arrays"))[i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, r), a[n] = r);
  }
  function w() {
    let e = h.newAttributes,
      n = h.enabledAttributes;
    for (let i = 0, r = n.length; i < r; i++) n[i] !== e[i] && (t.disableVertexAttribArray(i), n[i] = 0);
  }
  function S(e, n, i, r, o, s, a) {
    !0 === a ? t.vertexAttribIPointer(e, n, i, o, s) : t.vertexAttribPointer(e, n, i, r, o, s);
  }
  function M(r, o, s, a) {
    if (!1 === i.isWebGL2 && (r.isInstancedMesh || a.isInstancedBufferGeometry) && null === e.get("ANGLE_instanced_arrays")) return;
    x();
    let l = a.attributes,
      u = s.getAttributes(),
      h = o.defaultAttributeValues;
    for (let e in u) {
      let o = u[e];
      if (o.location >= 0) {
        let s = l[e];
        if (void 0 === s && ("instanceMatrix" === e && r.instanceMatrix && (s = r.instanceMatrix), "instanceColor" === e && r.instanceColor && (s = r.instanceColor)), void 0 !== s) {
          let e = s.normalized,
            l = s.itemSize,
            u = n.get(s);
          if (void 0 === u) continue;
          let h = u.buffer,
            c = u.type,
            p = u.bytesPerElement,
            d = !0 === i.isWebGL2 && (c === t.INT || c === t.UNSIGNED_INT || s.gpuType === fI);
          if (s.isInterleavedBufferAttribute) {
            let n = s.data,
              i = n.stride,
              u = s.offset;
            if (n.isInstancedInterleavedBuffer) {
              for (let t = 0; t < o.locationSize; t++) b(o.location + t, n.meshPerAttribute);
              !0 !== r.isInstancedMesh && void 0 === a._maxInstanceCount && (a._maxInstanceCount = n.meshPerAttribute * n.count);
            } else for (let t = 0; t < o.locationSize; t++) E(o.location + t);
            t.bindBuffer(t.ARRAY_BUFFER, h);
            for (let t = 0; t < o.locationSize; t++) S(o.location + t, l / o.locationSize, c, e, i * p, (u + l / o.locationSize * t) * p, d);
          } else {
            if (s.isInstancedBufferAttribute) {
              for (let t = 0; t < o.locationSize; t++) b(o.location + t, s.meshPerAttribute);
              !0 !== r.isInstancedMesh && void 0 === a._maxInstanceCount && (a._maxInstanceCount = s.meshPerAttribute * s.count);
            } else for (let t = 0; t < o.locationSize; t++) E(o.location + t);
            t.bindBuffer(t.ARRAY_BUFFER, h);
            for (let t = 0; t < o.locationSize; t++) S(o.location + t, l / o.locationSize, c, e, l * p, l / o.locationSize * t * p, d);
          }
        } else if (void 0 !== h) {
          let n = h[e];
          if (void 0 !== n) switch (n.length) {
            case 2:
              t.vertexAttrib2fv(o.location, n);
              break;
            case 3:
              t.vertexAttrib3fv(o.location, n);
              break;
            case 4:
              t.vertexAttrib4fv(o.location, n);
              break;
            default:
              t.vertexAttrib1fv(o.location, n);
          }
        }
      }
    }
    w();
  }
  function T() {
    C();
    for (let t in a) {
      let e = a[t];
      for (let t in e) {
        let n = e[t];
        for (let t in n) m(n[t].object), delete n[t];
        delete e[t];
      }
      delete a[t];
    }
  }
  function A(t) {
    if (void 0 === a[t.id]) return;
    let e = a[t.id];
    for (let t in e) {
      let n = e[t];
      for (let t in n) m(n[t].object), delete n[t];
      delete e[t];
    }
    delete a[t.id];
  }
  function P(t) {
    for (let e in a) {
      let n = a[e];
      if (void 0 === n[t.id]) continue;
      let i = n[t.id];
      for (let t in i) m(i[t].object), delete i[t];
      delete n[t.id];
    }
  }
  function C() {
    I(), c = !0, h !== l && (h = l, f(h.object));
  }
  function I() {
    l.geometry = null, l.program = null, l.wireframe = !1;
  }
  return u(p, "setup"), u(d, "createVertexArrayObject"), u(f, "bindVertexArrayObject"), u(m, "deleteVertexArrayObject"), u(g, "getBindingState"), u(v, "createBindingState"), u(y, "needsUpdate"), u(_, "saveCache"), u(x, "initAttributes"), u(E, "enableAttribute"), u(b, "enableAttributeAndDivisor"), u(w, "disableUnusedAttributes"), u(S, "vertexAttribPointer"), u(M, "setupVertexAttributes"), u(T, "dispose"), u(A, "releaseStatesOfGeometry"), u(P, "releaseStatesOfProgram"), u(C, "reset"), u(I, "resetDefaultState"), {
    setup: p,
    reset: C,
    resetDefaultState: I,
    dispose: T,
    releaseStatesOfGeometry: A,
    releaseStatesOfProgram: P,
    initAttributes: x,
    enableAttribute: E,
    disableUnusedAttributes: w
  };
}
function qj(t, e, n, i) {
  let r,
    o = i.isWebGL2;
  function s(t) {
    r = t;
  }
  function a(e, i) {
    t.drawArrays(r, e, i), n.update(i, r, 1);
  }
  function l(i, s, a) {
    if (0 === a) return;
    let l, u;
    if (o) l = t, u = "drawArraysInstanced";else if (l = e.get("ANGLE_instanced_arrays"), u = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
    l[u](r, i, s, a), n.update(s, r, a);
  }
  u(s, "setMode"), u(a, "render"), u(l, "renderInstances"), this.setMode = s, this.render = a, this.renderInstances = l;
}
function kj(t, e, n) {
  let i;
  function r() {
    if (void 0 !== i) return i;
    if (!0 === e.has("EXT_texture_filter_anisotropic")) {
      let n = e.get("EXT_texture_filter_anisotropic");
      i = t.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else i = 0;
    return i;
  }
  function o(e) {
    if ("highp" === e) {
      if (t.getShaderPrecisionFormat(t.VERTEX_SHADER, t.HIGH_FLOAT).precision > 0 && t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.HIGH_FLOAT).precision > 0) return "highp";
      e = "mediump";
    }
    return "mediump" === e && t.getShaderPrecisionFormat(t.VERTEX_SHADER, t.MEDIUM_FLOAT).precision > 0 && t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
  }
  u(r, "getMaxAnisotropy"), u(o, "getMaxPrecision");
  let s = "undefined" != typeof WebGL2RenderingContext && "WebGL2RenderingContext" === t.constructor.name,
    a = void 0 !== n.precision ? n.precision : "highp",
    l = o(a);
  l !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", l, "instead."), a = l);
  let h = s || e.has("WEBGL_draw_buffers"),
    c = !0 === n.logarithmicDepthBuffer,
    p = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS),
    d = t.getParameter(t.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
    f = t.getParameter(t.MAX_TEXTURE_SIZE),
    m = t.getParameter(t.MAX_CUBE_MAP_TEXTURE_SIZE),
    g = t.getParameter(t.MAX_VERTEX_ATTRIBS),
    v = t.getParameter(t.MAX_VERTEX_UNIFORM_VECTORS),
    y = t.getParameter(t.MAX_VARYING_VECTORS),
    _ = t.getParameter(t.MAX_FRAGMENT_UNIFORM_VECTORS),
    x = d > 0,
    E = s || e.has("OES_texture_float");
  return {
    isWebGL2: s,
    drawBuffers: h,
    getMaxAnisotropy: r,
    getMaxPrecision: o,
    precision: a,
    logarithmicDepthBuffer: c,
    maxTextures: p,
    maxVertexTextures: d,
    maxTextureSize: f,
    maxCubemapSize: m,
    maxAttributes: g,
    maxVertexUniforms: v,
    maxVaryings: y,
    maxFragmentUniforms: _,
    vertexTextures: x,
    floatFragmentTextures: E,
    floatVertexTextures: x && E,
    maxSamples: s ? t.getParameter(t.MAX_SAMPLES) : 0
  };
}
function Fj(t) {
  let e = this,
    n = null,
    i = 0,
    r = !1,
    o = !1,
    s = new zu(),
    a = new Qt(),
    l = {
      value: null,
      needsUpdate: !1
    };
  function h() {
    l.value !== n && (l.value = n, l.needsUpdate = i > 0), e.numPlanes = i, e.numIntersection = 0;
  }
  function c(t, n, i, r) {
    let o = null !== t ? t.length : 0,
      u = null;
    if (0 !== o) {
      if (u = l.value, !0 !== r || null === u) {
        let e = i + 4 * o,
          r = n.matrixWorldInverse;
        a.getNormalMatrix(r), (null === u || u.length < e) && (u = new Float32Array(e));
        for (let e = 0, n = i; e !== o; ++e, n += 4) s.copy(t[e]).applyMatrix4(r, a), s.normal.toArray(u, n), u[n + 3] = s.constant;
      }
      l.value = u, l.needsUpdate = !0;
    }
    return e.numPlanes = o, e.numIntersection = 0, u;
  }
  this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function (t, e) {
    let n = 0 !== t.length || e || 0 !== i || r;
    return r = e, i = t.length, n;
  }, this.beginShadows = function () {
    o = !0, c(null);
  }, this.endShadows = function () {
    o = !1;
  }, this.setGlobalState = function (t, e) {
    n = c(t, e, 0);
  }, this.setState = function (e, s, a) {
    let u = e.clippingPlanes,
      p = e.clipIntersection,
      d = e.clipShadows,
      f = t.get(e);
    if (!r || null === u || 0 === u.length || o && !d) o ? c(null) : h();else {
      let t = o ? 0 : i,
        e = 4 * t,
        r = f.clippingState || null;
      l.value = r, r = c(u, s, e, a);
      for (let t = 0; t !== e; ++t) r[t] = n[t];
      f.clippingState = r, this.numIntersection = p ? this.numPlanes : 0, this.numPlanes += t;
    }
  }, u(h, "resetGlobalState"), u(c, "projectPlanes");
}
function Bj(t) {
  let e = new WeakMap();
  function n(t, e) {
    return e === E3 ? t.mapping = jp : e === w3 && (t.mapping = Wp), t;
  }
  function i(i) {
    if (i && i.isTexture && !1 === i.isRenderTargetTexture) {
      let o = i.mapping;
      if (o === E3 || o === w3) {
        if (e.has(i)) {
          return n(e.get(i).texture, i.mapping);
        }
        {
          let o = i.image;
          if (o && o.height > 0) {
            let s = new oS(o.height / 2);
            return s.fromEquirectangularTexture(t, i), e.set(i, s), i.addEventListener("dispose", r), n(s.texture, i.mapping);
          }
          return null;
        }
      }
    }
    return i;
  }
  function r(t) {
    let n = t.target;
    n.removeEventListener("dispose", r);
    let i = e.get(n);
    void 0 !== i && (e.delete(n), i.dispose());
  }
  function o() {
    e = new WeakMap();
  }
  return u(n, "mapTextureMapping"), u(i, "get"), u(r, "onTextureDispose"), u(o, "dispose"), {
    get: i,
    dispose: o
  };
}
u(Nj, "WebGLBackground"), u(Dj, "WebGLBindingStates"), u(qj, "WebGLBufferRenderer"), u(kj, "WebGLCapabilities"), u(Fj, "WebGLClipping"), u(Bj, "WebGLCubeMaps");
var Ll = class extends wx {
  constructor(t = -1, e = 1, n = 1, i = -1, r = .1, o = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = e, this.top = n, this.bottom = i, this.near = r, this.far = o, this.updateProjectionMatrix();
  }
  copy(t, e) {
    return super.copy(t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = null === t.view ? null : Object.assign({}, t.view), this;
  }
  setViewOffset(t, e, n, i, r, o) {
    null === this.view && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = o, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    let t = (this.right - this.left) / (2 * this.zoom),
      e = (this.top - this.bottom) / (2 * this.zoom),
      n = (this.right + this.left) / 2,
      i = (this.top + this.bottom) / 2,
      r = n - t,
      o = n + t,
      s = i + e,
      a = i - e;
    if (null !== this.view && this.view.enabled) {
      let t = (this.right - this.left) / this.view.fullWidth / this.zoom,
        e = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      r += t * this.view.offsetX, o = r + t * this.view.width, s -= e * this.view.offsetY, a = s - e * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(r, o, s, a, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(t) {
    let e = super.toJSON(t);
    return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
  }
};
u(Ll, "OrthographicCamera");
var pd = 4,
  m8 = [.125, .215, .35, .446, .526, .582],
  ff = 20,
  aS = new Ll(),
  g8 = new yt(),
  lS = null,
  pf = (1 + Math.sqrt(5)) / 2,
  dd = 1 / pf,
  v8 = [new ne(1, 1, 1), new ne(-1, 1, 1), new ne(1, 1, -1), new ne(-1, 1, -1), new ne(0, pf, dd), new ne(0, pf, -dd), new ne(dd, 0, pf), new ne(-dd, 0, pf), new ne(pf, dd, 0), new ne(-pf, dd, 0)],
  Cx = class {
    constructor(t) {
      this._renderer = t, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
    }
    fromScene(t, e = 0, n = .1, i = 100) {
      lS = this._renderer.getRenderTarget(), this._setSize(256);
      let r = this._allocateTargets();
      return r.depthBuffer = !0, this._sceneToCubeUV(t, n, i, r), e > 0 && this._blur(r, 0, 0, e), this._applyPMREM(r), this._cleanup(r), r;
    }
    fromEquirectangular(t, e = null) {
      return this._fromTexture(t, e);
    }
    fromCubemap(t, e = null) {
      return this._fromTexture(t, e);
    }
    compileCubemapShader() {
      null === this._cubemapMaterial && (this._cubemapMaterial = x8(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
      null === this._equirectMaterial && (this._equirectMaterial = _8(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
      this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
    }
    _setSize(t) {
      this._lodMax = Math.floor(Math.log2(t)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
      null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
      for (let t = 0; t < this._lodPlanes.length; t++) this._lodPlanes[t].dispose();
    }
    _cleanup(t) {
      this._renderer.setRenderTarget(lS), t.scissorTest = !1, Ax(t, 0, 0, t.width, t.height);
    }
    _fromTexture(t, e) {
      t.mapping === jp || t.mapping === Wp ? this._setSize(0 === t.image.length ? 16 : t.image[0].width || t.image[0].image.width) : this._setSize(t.image.width / 4), lS = this._renderer.getRenderTarget();
      let n = e || this._allocateTargets();
      return this._textureToCubeUV(t, n), this._applyPMREM(n), this._cleanup(n), n;
    }
    _allocateTargets() {
      let t = 3 * Math.max(this._cubeSize, 112),
        e = 4 * this._cubeSize,
        n = {
          magFilter: ao,
          minFilter: ao,
          generateMipmaps: !1,
          type: Iu,
          format: Po,
          colorSpace: Cl,
          depthBuffer: !1
        },
        i = y8(t, e, n);
      if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== t || this._pingPongRenderTarget.height !== e) {
        null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = y8(t, e, n);
        let {
          _lodMax: i
        } = this;
        ({
          sizeLods: this._sizeLods,
          lodPlanes: this._lodPlanes,
          sigmas: this._sigmas
        } = Uj(i)), this._blurMaterial = zj(i, t, e);
      }
      return i;
    }
    _compileMaterial(t) {
      let e = new Ft(this._lodPlanes[0], t);
      this._renderer.compile(e, aS);
    }
    _sceneToCubeUV(t, e, n, i) {
      let r = new as(90, 1, e, n),
        o = [1, -1, 1, 1, 1, 1],
        s = [1, 1, 1, -1, -1, -1],
        a = this._renderer,
        l = a.autoClear,
        u = a.toneMapping;
      a.getClearColor(g8), a.toneMapping = Au, a.autoClear = !1;
      let h = new Sr({
          name: "PMREM.Background",
          side: Ts,
          depthWrite: !1,
          depthTest: !1
        }),
        c = new Ft(new Ka(), h),
        p = !1,
        d = t.background;
      d ? d.isColor && (h.color.copy(d), t.background = null, p = !0) : (h.color.copy(g8), p = !0);
      for (let e = 0; e < 6; e++) {
        let n = e % 3;
        0 === n ? (r.up.set(0, o[e], 0), r.lookAt(s[e], 0, 0)) : 1 === n ? (r.up.set(0, 0, o[e]), r.lookAt(0, s[e], 0)) : (r.up.set(0, o[e], 0), r.lookAt(0, 0, s[e]));
        let l = this._cubeSize;
        Ax(i, n * l, e > 2 ? l : 0, l, l), a.setRenderTarget(i), p && a.render(c, r), a.render(t, r);
      }
      c.geometry.dispose(), c.material.dispose(), a.toneMapping = u, a.autoClear = l, t.background = d;
    }
    _textureToCubeUV(t, e) {
      let n = this._renderer,
        i = t.mapping === jp || t.mapping === Wp;
      i ? (null === this._cubemapMaterial && (this._cubemapMaterial = x8()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === t.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = _8());
      let r = i ? this._cubemapMaterial : this._equirectMaterial,
        o = new Ft(this._lodPlanes[0], r);
      r.uniforms.envMap.value = t;
      let s = this._cubeSize;
      Ax(e, 0, 0, 3 * s, 2 * s), n.setRenderTarget(e), n.render(o, aS);
    }
    _applyPMREM(t) {
      let e = this._renderer,
        n = e.autoClear;
      e.autoClear = !1;
      for (let e = 1; e < this._lodPlanes.length; e++) {
        let n = Math.sqrt(this._sigmas[e] * this._sigmas[e] - this._sigmas[e - 1] * this._sigmas[e - 1]),
          i = v8[(e - 1) % v8.length];
        this._blur(t, e - 1, e, n, i);
      }
      e.autoClear = n;
    }
    _blur(t, e, n, i, r) {
      let o = this._pingPongRenderTarget;
      this._halfBlur(t, o, e, n, i, "latitudinal", r), this._halfBlur(o, t, n, n, i, "longitudinal", r);
    }
    _halfBlur(t, e, n, i, r, o, s) {
      let a = this._renderer,
        l = this._blurMaterial;
      "latitudinal" !== o && "longitudinal" !== o && console.error("blur direction must be either latitudinal or longitudinal!");
      let u = new Ft(this._lodPlanes[i], l),
        h = l.uniforms,
        c = this._sizeLods[n] - 1,
        p = isFinite(r) ? Math.PI / (2 * c) : 2 * Math.PI / (2 * ff - 1),
        d = r / p,
        f = isFinite(r) ? 1 + Math.floor(3 * d) : ff;
      f > ff && console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${f} samples when the maximum is set to ${ff}`);
      let m = [],
        g = 0;
      for (let t = 0; t < ff; ++t) {
        let e = t / d,
          n = Math.exp(-e * e / 2);
        m.push(n), 0 === t ? g += n : t < f && (g += 2 * n);
      }
      for (let t = 0; t < m.length; t++) m[t] = m[t] / g;
      h.envMap.value = t.texture, h.samples.value = f, h.weights.value = m, h.latitudinal.value = "latitudinal" === o, s && (h.poleAxis.value = s);
      let {
        _lodMax: v
      } = this;
      h.dTheta.value = p, h.mipInt.value = v - n;
      let y = this._sizeLods[i];
      Ax(e, 3 * y * (i > v - pd ? i - v + pd : 0), 4 * (this._cubeSize - y), 3 * y, 2 * y), a.setRenderTarget(e), a.render(u, aS);
    }
  };
function Uj(t) {
  let e = [],
    n = [],
    i = [],
    r = t,
    o = t - pd + 1 + m8.length;
  for (let s = 0; s < o; s++) {
    let o = Math.pow(2, r);
    n.push(o);
    let a = 1 / o;
    s > t - pd ? a = m8[s - t + pd - 1] : 0 === s && (a = 0), i.push(a);
    let l = 1 / (o - 2),
      u = -l,
      h = 1 + l,
      c = [u, u, h, u, h, h, u, u, h, h, u, h],
      p = 6,
      d = 6,
      f = 3,
      m = 2,
      g = 1,
      v = new Float32Array(f * d * p),
      y = new Float32Array(m * d * p),
      _ = new Float32Array(g * d * p);
    for (let t = 0; t < p; t++) {
      let e = t % 3 * 2 / 3 - 1,
        n = t > 2 ? 0 : -1,
        i = [e, n, 0, e + 2 / 3, n, 0, e + 2 / 3, n + 1, 0, e, n, 0, e + 2 / 3, n + 1, 0, e, n + 1, 0];
      v.set(i, f * d * t), y.set(c, m * d * t);
      let r = [t, t, t, t, t, t];
      _.set(r, g * d * t);
    }
    let x = new Pi();
    x.setAttribute("position", new ui(v, f)), x.setAttribute("uv", new ui(y, m)), x.setAttribute("faceIndex", new ui(_, g)), e.push(x), r > pd && r--;
  }
  return {
    lodPlanes: e,
    sizeLods: n,
    sigmas: i
  };
}
function y8(t, e, n) {
  let i = new wr(t, e, n);
  return i.texture.mapping = Z_, i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
}
function Ax(t, e, n, i, r) {
  t.viewport.set(e, n, i, r), t.scissor.set(e, n, i, r);
}
function zj(t, e, n) {
  let i = new Float32Array(ff),
    r = new ne(0, 1, 0);
  return new wi({
    name: "SphericalGaussianBlur",
    defines: {
      n: ff,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / n,
      CUBEUV_MAX_MIP: `${t}.0`
    },
    uniforms: {
      envMap: {
        value: null
      },
      samples: {
        value: 1
      },
      weights: {
        value: i
      },
      latitudinal: {
        value: !1
      },
      dTheta: {
        value: 0
      },
      mipInt: {
        value: 0
      },
      poleAxis: {
        value: r
      }
    },
    vertexShader: uS(),
    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
    blending: jc,
    depthTest: !1,
    depthWrite: !1
  });
}
function _8() {
  return new wi({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: {
        value: null
      }
    },
    vertexShader: uS(),
    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
    blending: jc,
    depthTest: !1,
    depthWrite: !1
  });
}
function x8() {
  return new wi({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: {
        value: null
      },
      flipEnvMap: {
        value: -1
      }
    },
    vertexShader: uS(),
    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
    blending: jc,
    depthTest: !1,
    depthWrite: !1
  });
}
function uS() {
  return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
}
function Vj(t) {
  let e = new WeakMap(),
    n = null;
  function i(i) {
    if (i && i.isTexture) {
      let s = i.mapping,
        a = s === E3 || s === w3,
        l = s === jp || s === Wp;
      if (a || l) {
        if (i.isRenderTargetTexture && !0 === i.needsPMREMUpdate) {
          i.needsPMREMUpdate = !1;
          let r = e.get(i);
          return null === n && (n = new Cx(t)), r = a ? n.fromEquirectangular(i, r) : n.fromCubemap(i, r), e.set(i, r), r.texture;
        }
        if (e.has(i)) return e.get(i).texture;
        {
          let s = i.image;
          if (a && s && s.height > 0 || l && s && r(s)) {
            null === n && (n = new Cx(t));
            let r = a ? n.fromEquirectangular(i) : n.fromCubemap(i);
            return e.set(i, r), i.addEventListener("dispose", o), r.texture;
          }
          return null;
        }
      }
    }
    return i;
  }
  function r(t) {
    let e = 0;
    for (let n = 0; n < 6; n++) void 0 !== t[n] && e++;
    return 6 === e;
  }
  function o(t) {
    let n = t.target;
    n.removeEventListener("dispose", o);
    let i = e.get(n);
    void 0 !== i && (e.delete(n), i.dispose());
  }
  function s() {
    e = new WeakMap(), null !== n && (n.dispose(), n = null);
  }
  return u(i, "get"), u(r, "isCubeTextureComplete"), u(o, "onTextureDispose"), u(s, "dispose"), {
    get: i,
    dispose: s
  };
}
function Gj(t) {
  let e = {};
  function n(n) {
    if (void 0 !== e[n]) return e[n];
    let i;
    switch (n) {
      case "WEBGL_depth_texture":
        i = t.getExtension("WEBGL_depth_texture") || t.getExtension("MOZ_WEBGL_depth_texture") || t.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        i = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        i = t.getExtension("WEBGL_compressed_texture_s3tc") || t.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        i = t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        i = t.getExtension(n);
    }
    return e[n] = i, i;
  }
  return u(n, "getExtension"), {
    has: function (t) {
      return null !== n(t);
    },
    init: function (t) {
      t.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture");
    },
    get: function (t) {
      let e = n(t);
      return null === e && console.warn("THREE.WebGLRenderer: " + t + " extension not supported."), e;
    }
  };
}
function Hj(t, e, n, i) {
  let r = {},
    o = new WeakMap();
  function s(t) {
    let a = t.target;
    null !== a.index && e.remove(a.index);
    for (let t in a.attributes) e.remove(a.attributes[t]);
    for (let t in a.morphAttributes) {
      let n = a.morphAttributes[t];
      for (let t = 0, i = n.length; t < i; t++) e.remove(n[t]);
    }
    a.removeEventListener("dispose", s), delete r[a.id];
    let l = o.get(a);
    l && (e.remove(l), o.delete(a)), i.releaseStatesOfGeometry(a), !0 === a.isInstancedBufferGeometry && delete a._maxInstanceCount, n.memory.geometries--;
  }
  function a(t, e) {
    return !0 === r[e.id] || (e.addEventListener("dispose", s), r[e.id] = !0, n.memory.geometries++), e;
  }
  function l(n) {
    let i = n.attributes;
    for (let n in i) e.update(i[n], t.ARRAY_BUFFER);
    let r = n.morphAttributes;
    for (let n in r) {
      let i = r[n];
      for (let n = 0, r = i.length; n < r; n++) e.update(i[n], t.ARRAY_BUFFER);
    }
  }
  function h(t) {
    let n = [],
      i = t.index,
      r = t.attributes.position,
      s = 0;
    if (null !== i) {
      let t = i.array;
      s = i.version;
      for (let e = 0, i = t.length; e < i; e += 3) {
        let i = t[e + 0],
          r = t[e + 1],
          o = t[e + 2];
        n.push(i, r, r, o, o, i);
      }
    } else {
      let t = r.array;
      s = r.version;
      for (let e = 0, i = t.length / 3 - 1; e < i; e += 3) {
        let t = e + 0,
          i = e + 1,
          r = e + 2;
        n.push(t, i, i, r, r, t);
      }
    }
    let a = new (JI(n) ? mx : dx)(n, 1);
    a.version = s;
    let l = o.get(t);
    l && e.remove(l), o.set(t, a);
  }
  function c(t) {
    let e = o.get(t);
    if (e) {
      let n = t.index;
      null !== n && e.version < n.version && h(t);
    } else h(t);
    return o.get(t);
  }
  return u(s, "onGeometryDispose"), u(a, "get"), u(l, "update"), u(h, "updateWireframeAttribute"), u(c, "getWireframeAttribute"), {
    get: a,
    update: l,
    getWireframeAttribute: c
  };
}
function jj(t, e, n, i) {
  let r,
    o,
    s,
    a = i.isWebGL2;
  function l(t) {
    r = t;
  }
  function h(t) {
    o = t.type, s = t.bytesPerElement;
  }
  function c(e, i) {
    t.drawElements(r, i, o, e * s), n.update(i, r, 1);
  }
  function p(i, l, u) {
    if (0 === u) return;
    let h, c;
    if (a) h = t, c = "drawElementsInstanced";else if (h = e.get("ANGLE_instanced_arrays"), c = "drawElementsInstancedANGLE", null === h) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
    h[c](r, l, o, i * s, u), n.update(l, r, u);
  }
  u(l, "setMode"), u(h, "setIndex"), u(c, "render"), u(p, "renderInstances"), this.setMode = l, this.setIndex = h, this.render = c, this.renderInstances = p;
}
function Wj(t) {
  let e = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function n(n, i, r) {
    switch (e.calls++, i) {
      case t.TRIANGLES:
        e.triangles += r * (n / 3);
        break;
      case t.LINES:
        e.lines += r * (n / 2);
        break;
      case t.LINE_STRIP:
        e.lines += r * (n - 1);
        break;
      case t.LINE_LOOP:
        e.lines += r * n;
        break;
      case t.POINTS:
        e.points += r * n;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", i);
    }
  }
  function i() {
    e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
  }
  return u(n, "update"), u(i, "reset"), {
    memory: {
      geometries: 0,
      textures: 0
    },
    render: e,
    programs: null,
    autoReset: !0,
    reset: i,
    update: n
  };
}
function Xj(t, e) {
  return t[0] - e[0];
}
function Yj(t, e) {
  return Math.abs(e[1]) - Math.abs(t[1]);
}
function Zj(t, e, n) {
  let i = {},
    r = new Float32Array(8),
    o = new WeakMap(),
    s = new Er(),
    a = [];
  for (let t = 0; t < 8; t++) a[t] = [t, 0];
  function l(l, h, c) {
    let p = l.morphTargetInfluences;
    if (!0 === e.isWebGL2) {
      let i = h.morphAttributes.position || h.morphAttributes.normal || h.morphAttributes.color,
        r = void 0 !== i ? i.length : 0,
        a = o.get(h);
      if (void 0 === a || a.count !== r) {
        let t = function () {
          y.dispose(), o.delete(h), h.removeEventListener("dispose", t);
        };
        u(t, "disposeTexture"), void 0 !== a && a.texture.dispose();
        let n = void 0 !== h.morphAttributes.position,
          i = void 0 !== h.morphAttributes.normal,
          l = void 0 !== h.morphAttributes.color,
          c = h.morphAttributes.position || [],
          p = h.morphAttributes.normal || [],
          d = h.morphAttributes.color || [],
          f = 0;
        !0 === n && (f = 1), !0 === i && (f = 2), !0 === l && (f = 3);
        let m = h.attributes.position.count * f,
          g = 1;
        m > e.maxTextureSize && (g = Math.ceil(m / e.maxTextureSize), m = e.maxTextureSize);
        let v = new Float32Array(m * g * 4 * r),
          y = new ix(v, m, g, r);
        y.type = Tl, y.needsUpdate = !0;
        let _ = 4 * f;
        for (let t = 0; t < r; t++) {
          let e = c[t],
            r = p[t],
            o = d[t],
            a = m * g * 4 * t;
          for (let t = 0; t < e.count; t++) {
            let u = t * _;
            !0 === n && (s.fromBufferAttribute(e, t), v[a + u + 0] = s.x, v[a + u + 1] = s.y, v[a + u + 2] = s.z, v[a + u + 3] = 0), !0 === i && (s.fromBufferAttribute(r, t), v[a + u + 4] = s.x, v[a + u + 5] = s.y, v[a + u + 6] = s.z, v[a + u + 7] = 0), !0 === l && (s.fromBufferAttribute(o, t), v[a + u + 8] = s.x, v[a + u + 9] = s.y, v[a + u + 10] = s.z, v[a + u + 11] = 4 === o.itemSize ? s.w : 1);
          }
        }
        a = {
          count: r,
          texture: y,
          size: new je(m, g)
        }, o.set(h, a), h.addEventListener("dispose", t);
      }
      let l = 0;
      for (let t = 0; t < p.length; t++) l += p[t];
      let d = h.morphTargetsRelative ? 1 : 1 - l;
      c.getUniforms().setValue(t, "morphTargetBaseInfluence", d), c.getUniforms().setValue(t, "morphTargetInfluences", p), c.getUniforms().setValue(t, "morphTargetsTexture", a.texture, n), c.getUniforms().setValue(t, "morphTargetsTextureSize", a.size);
    } else {
      let e = void 0 === p ? 0 : p.length,
        n = i[h.id];
      if (void 0 === n || n.length !== e) {
        n = [];
        for (let t = 0; t < e; t++) n[t] = [t, 0];
        i[h.id] = n;
      }
      for (let t = 0; t < e; t++) {
        let e = n[t];
        e[0] = t, e[1] = p[t];
      }
      n.sort(Yj);
      for (let t = 0; t < 8; t++) t < e && n[t][1] ? (a[t][0] = n[t][0], a[t][1] = n[t][1]) : (a[t][0] = Number.MAX_SAFE_INTEGER, a[t][1] = 0);
      a.sort(Xj);
      let o = h.morphAttributes.position,
        s = h.morphAttributes.normal,
        l = 0;
      for (let t = 0; t < 8; t++) {
        let e = a[t],
          n = e[0],
          i = e[1];
        n !== Number.MAX_SAFE_INTEGER && i ? (o && h.getAttribute("morphTarget" + t) !== o[n] && h.setAttribute("morphTarget" + t, o[n]), s && h.getAttribute("morphNormal" + t) !== s[n] && h.setAttribute("morphNormal" + t, s[n]), r[t] = i, l += i) : (o && !0 === h.hasAttribute("morphTarget" + t) && h.deleteAttribute("morphTarget" + t), s && !0 === h.hasAttribute("morphNormal" + t) && h.deleteAttribute("morphNormal" + t), r[t] = 0);
      }
      let u = h.morphTargetsRelative ? 1 : 1 - l;
      c.getUniforms().setValue(t, "morphTargetBaseInfluence", u), c.getUniforms().setValue(t, "morphTargetInfluences", r);
    }
  }
  return u(l, "update"), {
    update: l
  };
}
function Jj(t, e, n, i) {
  let r = new WeakMap();
  function o(o) {
    let s = i.render.frame,
      l = o.geometry,
      u = e.get(o, l);
    return r.get(u) !== s && (e.update(u), r.set(u, s)), o.isInstancedMesh && (!1 === o.hasEventListener("dispose", a) && o.addEventListener("dispose", a), n.update(o.instanceMatrix, t.ARRAY_BUFFER), null !== o.instanceColor && n.update(o.instanceColor, t.ARRAY_BUFFER)), u;
  }
  function s() {
    r = new WeakMap();
  }
  function a(t) {
    let e = t.target;
    e.removeEventListener("dispose", a), n.remove(e.instanceMatrix), null !== e.instanceColor && n.remove(e.instanceColor);
  }
  return u(o, "update"), u(s, "dispose"), u(a, "onInstancedMeshDispose"), {
    update: o,
    dispose: s
  };
}
u(Cx, "PMREMGenerator"), u(Uj, "_createPlanes"), u(y8, "_createRenderTarget"), u(Ax, "_setViewport"), u(zj, "_getBlurShader"), u(_8, "_getEquirectMaterial"), u(x8, "_getCubemapMaterial"), u(uS, "_getCommonVertexShader"), u(Vj, "WebGLCubeUVMaps"), u(Gj, "WebGLExtensions"), u(Hj, "WebGLGeometries"), u(jj, "WebGLIndexedBufferRenderer"), u(Wj, "WebGLInfo"), u(Xj, "numericalSort"), u(Yj, "absNumericalSort"), u(Zj, "WebGLMorphtargets"), u(Jj, "WebGLObjects");
var b8 = new lo(),
  M8 = new ix(),
  E8 = new G3(),
  w8 = new Sx(),
  S8 = [],
  T8 = [],
  P8 = new Float32Array(16),
  C8 = new Float32Array(9),
  A8 = new Float32Array(4);
function md(t, e, n) {
  let i = t[0];
  if (i <= 0 || i > 0) return t;
  let r = e * n,
    o = S8[r];
  if (void 0 === o && (o = new Float32Array(r), S8[r] = o), 0 !== e) {
    i.toArray(o, 0);
    for (let i = 1, r = 0; i !== e; ++i) r += n, t[i].toArray(o, r);
  }
  return o;
}
function Ur(t, e) {
  if (t.length !== e.length) return !1;
  for (let n = 0, i = t.length; n < i; n++) if (t[n] !== e[n]) return !1;
  return !0;
}
function zr(t, e) {
  for (let n = 0, i = e.length; n < i; n++) t[n] = e[n];
}
function Ix(t, e) {
  let n = T8[e];
  void 0 === n && (n = new Int32Array(e), T8[e] = n);
  for (let i = 0; i !== e; ++i) n[i] = t.allocateTextureUnit();
  return n;
}
function Kj(t, e) {
  let n = this.cache;
  n[0] !== e && (t.uniform1f(this.addr, e), n[0] = e);
}
function Qj(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y) && (t.uniform2f(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);else {
    if (Ur(n, e)) return;
    t.uniform2fv(this.addr, e), zr(n, e);
  }
}
function $j(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3f(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);else if (void 0 !== e.r) (n[0] !== e.r || n[1] !== e.g || n[2] !== e.b) && (t.uniform3f(this.addr, e.r, e.g, e.b), n[0] = e.r, n[1] = e.g, n[2] = e.b);else {
    if (Ur(n, e)) return;
    t.uniform3fv(this.addr, e), zr(n, e);
  }
}
function eW(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4f(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);else {
    if (Ur(n, e)) return;
    t.uniform4fv(this.addr, e), zr(n, e);
  }
}
function tW(t, e) {
  let n = this.cache,
    i = e.elements;
  if (void 0 === i) {
    if (Ur(n, e)) return;
    t.uniformMatrix2fv(this.addr, !1, e), zr(n, e);
  } else {
    if (Ur(n, i)) return;
    A8.set(i), t.uniformMatrix2fv(this.addr, !1, A8), zr(n, i);
  }
}
function nW(t, e) {
  let n = this.cache,
    i = e.elements;
  if (void 0 === i) {
    if (Ur(n, e)) return;
    t.uniformMatrix3fv(this.addr, !1, e), zr(n, e);
  } else {
    if (Ur(n, i)) return;
    C8.set(i), t.uniformMatrix3fv(this.addr, !1, C8), zr(n, i);
  }
}
function iW(t, e) {
  let n = this.cache,
    i = e.elements;
  if (void 0 === i) {
    if (Ur(n, e)) return;
    t.uniformMatrix4fv(this.addr, !1, e), zr(n, e);
  } else {
    if (Ur(n, i)) return;
    P8.set(i), t.uniformMatrix4fv(this.addr, !1, P8), zr(n, i);
  }
}
function rW(t, e) {
  let n = this.cache;
  n[0] !== e && (t.uniform1i(this.addr, e), n[0] = e);
}
function oW(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y) && (t.uniform2i(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);else {
    if (Ur(n, e)) return;
    t.uniform2iv(this.addr, e), zr(n, e);
  }
}
function sW(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3i(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);else {
    if (Ur(n, e)) return;
    t.uniform3iv(this.addr, e), zr(n, e);
  }
}
function aW(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4i(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);else {
    if (Ur(n, e)) return;
    t.uniform4iv(this.addr, e), zr(n, e);
  }
}
function lW(t, e) {
  let n = this.cache;
  n[0] !== e && (t.uniform1ui(this.addr, e), n[0] = e);
}
function uW(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y) && (t.uniform2ui(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);else {
    if (Ur(n, e)) return;
    t.uniform2uiv(this.addr, e), zr(n, e);
  }
}
function cW(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3ui(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);else {
    if (Ur(n, e)) return;
    t.uniform3uiv(this.addr, e), zr(n, e);
  }
}
function hW(t, e) {
  let n = this.cache;
  if (void 0 !== e.x) (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4ui(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);else {
    if (Ur(n, e)) return;
    t.uniform4uiv(this.addr, e), zr(n, e);
  }
}
function fW(t, e, n) {
  let i = this.cache,
    r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture2D(e || b8, r);
}
function pW(t, e, n) {
  let i = this.cache,
    r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(e || E8, r);
}
function dW(t, e, n) {
  let i = this.cache,
    r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTextureCube(e || w8, r);
}
function mW(t, e, n) {
  let i = this.cache,
    r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(e || M8, r);
}
function gW(t) {
  switch (t) {
    case 5126:
      return Kj;
    case 35664:
      return Qj;
    case 35665:
      return $j;
    case 35666:
      return eW;
    case 35674:
      return tW;
    case 35675:
      return nW;
    case 35676:
      return iW;
    case 5124:
    case 35670:
      return rW;
    case 35667:
    case 35671:
      return oW;
    case 35668:
    case 35672:
      return sW;
    case 35669:
    case 35673:
      return aW;
    case 5125:
      return lW;
    case 36294:
      return uW;
    case 36295:
      return cW;
    case 36296:
      return hW;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return fW;
    case 35679:
    case 36299:
    case 36307:
      return pW;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return dW;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return mW;
  }
}
function vW(t, e) {
  t.uniform1fv(this.addr, e);
}
function yW(t, e) {
  let n = md(e, this.size, 2);
  t.uniform2fv(this.addr, n);
}
function _W(t, e) {
  let n = md(e, this.size, 3);
  t.uniform3fv(this.addr, n);
}
function xW(t, e) {
  let n = md(e, this.size, 4);
  t.uniform4fv(this.addr, n);
}
function bW(t, e) {
  let n = md(e, this.size, 4);
  t.uniformMatrix2fv(this.addr, !1, n);
}
function MW(t, e) {
  let n = md(e, this.size, 9);
  t.uniformMatrix3fv(this.addr, !1, n);
}
function EW(t, e) {
  let n = md(e, this.size, 16);
  t.uniformMatrix4fv(this.addr, !1, n);
}
function wW(t, e) {
  t.uniform1iv(this.addr, e);
}
function SW(t, e) {
  t.uniform2iv(this.addr, e);
}
function TW(t, e) {
  t.uniform3iv(this.addr, e);
}
function PW(t, e) {
  t.uniform4iv(this.addr, e);
}
function CW(t, e) {
  t.uniform1uiv(this.addr, e);
}
function AW(t, e) {
  t.uniform2uiv(this.addr, e);
}
function IW(t, e) {
  t.uniform3uiv(this.addr, e);
}
function LW(t, e) {
  t.uniform4uiv(this.addr, e);
}
function OW(t, e, n) {
  let i = this.cache,
    r = e.length,
    o = Ix(n, r);
  Ur(i, o) || (t.uniform1iv(this.addr, o), zr(i, o));
  for (let t = 0; t !== r; ++t) n.setTexture2D(e[t] || b8, o[t]);
}
function RW(t, e, n) {
  let i = this.cache,
    r = e.length,
    o = Ix(n, r);
  Ur(i, o) || (t.uniform1iv(this.addr, o), zr(i, o));
  for (let t = 0; t !== r; ++t) n.setTexture3D(e[t] || E8, o[t]);
}
function NW(t, e, n) {
  let i = this.cache,
    r = e.length,
    o = Ix(n, r);
  Ur(i, o) || (t.uniform1iv(this.addr, o), zr(i, o));
  for (let t = 0; t !== r; ++t) n.setTextureCube(e[t] || w8, o[t]);
}
function DW(t, e, n) {
  let i = this.cache,
    r = e.length,
    o = Ix(n, r);
  Ur(i, o) || (t.uniform1iv(this.addr, o), zr(i, o));
  for (let t = 0; t !== r; ++t) n.setTexture2DArray(e[t] || M8, o[t]);
}
function qW(t) {
  switch (t) {
    case 5126:
      return vW;
    case 35664:
      return yW;
    case 35665:
      return _W;
    case 35666:
      return xW;
    case 35674:
      return bW;
    case 35675:
      return MW;
    case 35676:
      return EW;
    case 5124:
    case 35670:
      return wW;
    case 35667:
    case 35671:
      return SW;
    case 35668:
    case 35672:
      return TW;
    case 35669:
    case 35673:
      return PW;
    case 5125:
      return CW;
    case 36294:
      return AW;
    case 36295:
      return IW;
    case 36296:
      return LW;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return OW;
    case 35679:
    case 36299:
    case 36307:
      return RW;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return NW;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return DW;
  }
}
u(md, "flatten"), u(Ur, "arraysEqual"), u(zr, "copyArray"), u(Ix, "allocTexUnits"), u(Kj, "setValueV1f"), u(Qj, "setValueV2f"), u($j, "setValueV3f"), u(eW, "setValueV4f"), u(tW, "setValueM2"), u(nW, "setValueM3"), u(iW, "setValueM4"), u(rW, "setValueV1i"), u(oW, "setValueV2i"), u(sW, "setValueV3i"), u(aW, "setValueV4i"), u(lW, "setValueV1ui"), u(uW, "setValueV2ui"), u(cW, "setValueV3ui"), u(hW, "setValueV4ui"), u(fW, "setValueT1"), u(pW, "setValueT3D1"), u(dW, "setValueT6"), u(mW, "setValueT2DArray1"), u(gW, "getSingularSetter"), u(vW, "setValueV1fArray"), u(yW, "setValueV2fArray"), u(_W, "setValueV3fArray"), u(xW, "setValueV4fArray"), u(bW, "setValueM2Array"), u(MW, "setValueM3Array"), u(EW, "setValueM4Array"), u(wW, "setValueV1iArray"), u(SW, "setValueV2iArray"), u(TW, "setValueV3iArray"), u(PW, "setValueV4iArray"), u(CW, "setValueV1uiArray"), u(AW, "setValueV2uiArray"), u(IW, "setValueV3uiArray"), u(LW, "setValueV4uiArray"), u(OW, "setValueT1Array"), u(RW, "setValueT3DArray"), u(NW, "setValueT6Array"), u(DW, "setValueT2DArrayArray"), u(qW, "getPureArraySetter");
var cS = class {
  constructor(t, e, n) {
    this.id = t, this.addr = n, this.cache = [], this.setValue = gW(e.type);
  }
};
u(cS, "SingleUniform");
var hS = class {
  constructor(t, e, n) {
    this.id = t, this.addr = n, this.cache = [], this.size = e.size, this.setValue = qW(e.type);
  }
};
u(hS, "PureArrayUniform");
var fS = class {
  constructor(t) {
    this.id = t, this.seq = [], this.map = {};
  }
  setValue(t, e, n) {
    let i = this.seq;
    for (let r = 0, o = i.length; r !== o; ++r) {
      let o = i[r];
      o.setValue(t, e[o.id], n);
    }
  }
};
u(fS, "StructuredUniform");
var pS = /(\w+)(\])?(\[|\.)?/g;
function I8(t, e) {
  t.seq.push(e), t.map[e.id] = e;
}
function kW(t, e, n) {
  let i = t.name,
    r = i.length;
  for (pS.lastIndex = 0;;) {
    let o = pS.exec(i),
      s = pS.lastIndex,
      a = o[1],
      l = "]" === o[2],
      u = o[3];
    if (l && (a |= 0), void 0 === u || "[" === u && s + 2 === r) {
      I8(n, void 0 === u ? new cS(a, t, e) : new hS(a, t, e));
      break;
    }
    {
      let t = n.map[a];
      void 0 === t && (t = new fS(a), I8(n, t)), n = t;
    }
  }
}
u(I8, "addUniform"), u(kW, "parseUniform");
var gd = class {
  constructor(t, e) {
    this.seq = [], this.map = {};
    let n = t.getProgramParameter(e, t.ACTIVE_UNIFORMS);
    for (let i = 0; i < n; ++i) {
      let n = t.getActiveUniform(e, i);
      kW(n, t.getUniformLocation(e, n.name), this);
    }
  }
  setValue(t, e, n, i) {
    let r = this.map[e];
    void 0 !== r && r.setValue(t, n, i);
  }
  setOptional(t, e, n) {
    let i = e[n];
    void 0 !== i && this.setValue(t, n, i);
  }
  static upload(t, e, n, i) {
    for (let r = 0, o = e.length; r !== o; ++r) {
      let o = e[r],
        s = n[o.id];
      !1 !== s.needsUpdate && o.setValue(t, s.value, i);
    }
  }
  static seqWithValue(t, e) {
    let n = [];
    for (let i = 0, r = t.length; i !== r; ++i) {
      let r = t[i];
      r.id in e && n.push(r);
    }
    return n;
  }
};
function L8(t, e, n) {
  let i = t.createShader(e);
  return t.shaderSource(i, n), t.compileShader(i), i;
}
u(gd, "WebGLUniforms"), u(L8, "WebGLShader");
var FW = 0;
function BW(t, e) {
  let n = t.split("\n"),
    i = [],
    r = Math.max(e - 6, 0),
    o = Math.min(e + 6, n.length);
  for (let t = r; t < o; t++) {
    let r = t + 1;
    i.push(`${r === e ? ">" : " "} ${r}: ${n[t]}`);
  }
  return i.join("\n");
}
function UW(t) {
  switch (t) {
    case Cl:
      return ["Linear", "( value )"];
    case Nt:
      return ["sRGB", "( value )"];
    default:
      return console.warn("THREE.WebGLProgram: Unsupported color space:", t), ["Linear", "( value )"];
  }
}
function O8(t, e, n) {
  let i = t.getShaderParameter(e, t.COMPILE_STATUS),
    r = t.getShaderInfoLog(e).trim();
  if (i && "" === r) return "";
  let o = /ERROR: 0:(\d+)/.exec(r);
  if (o) {
    let i = parseInt(o[1]);
    return n.toUpperCase() + "\n\n" + r + "\n\n" + BW(t.getShaderSource(e), i);
  }
  return r;
}
function zW(t, e) {
  let n = UW(e);
  return "vec4 " + t + "( vec4 value ) { return LinearTo" + n[0] + n[1] + "; }";
}
function VW(t, e) {
  let n;
  switch (e) {
    case uV:
      n = "Linear";
      break;
    case cV:
      n = "Reinhard";
      break;
    case hV:
      n = "OptimizedCineon";
      break;
    case fV:
      n = "ACESFilmic";
      break;
    case pV:
      n = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), n = "Linear";
  }
  return "vec3 " + t + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}
function GW(t) {
  return [t.extensionDerivatives || t.envMapCubeUVHeight || t.bumpMap || t.normalMapTangentSpace || t.clearcoatNormalMap || t.flatShading || "physical" === t.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "", (t.extensionFragDepth || t.logarithmicDepthBuffer) && t.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "", t.extensionDrawBuffers && t.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "", (t.extensionShaderTextureLOD || t.envMap || t.transmission) && t.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""].filter(Vg).join("\n");
}
function HW(t) {
  let e = [];
  for (let n in t) {
    let i = t[n];
    !1 !== i && e.push("#define " + n + " " + i);
  }
  return e.join("\n");
}
function jW(t, e) {
  let n = {},
    i = t.getProgramParameter(e, t.ACTIVE_ATTRIBUTES);
  for (let r = 0; r < i; r++) {
    let i = t.getActiveAttrib(e, r),
      o = i.name,
      s = 1;
    i.type === t.FLOAT_MAT2 && (s = 2), i.type === t.FLOAT_MAT3 && (s = 3), i.type === t.FLOAT_MAT4 && (s = 4), n[o] = {
      type: i.type,
      location: t.getAttribLocation(e, o),
      locationSize: s
    };
  }
  return n;
}
function Vg(t) {
  return "" !== t;
}
function R8(t, e) {
  let n = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
  return t.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function N8(t, e) {
  return t.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
u(BW, "handleSource"), u(UW, "getEncodingComponents"), u(O8, "getShaderErrors"), u(zW, "getTexelEncodingFunction"), u(VW, "getToneMappingFunction"), u(GW, "generateExtensions"), u(HW, "generateDefines"), u(jW, "fetchAttributeLocations"), u(Vg, "filterEmptyLine"), u(R8, "replaceLightNums"), u(N8, "replaceClippingPlaneNums");
var WW = /^[ \t]*#include +<([\w\d./]+)>/gm;
function dS(t) {
  return t.replace(WW, XW);
}
function XW(t, e) {
  let n = tn[e];
  if (void 0 === n) throw new Error("Can not resolve #include <" + e + ">");
  return dS(n);
}
u(dS, "resolveIncludes"), u(XW, "includeReplacer");
var YW = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function D8(t) {
  return t.replace(YW, ZW);
}
function ZW(t, e, n, i) {
  let r = "";
  for (let t = parseInt(e); t < parseInt(n); t++) r += i.replace(/\[\s*i\s*\]/g, "[ " + t + " ]").replace(/UNROLLED_LOOP_INDEX/g, t);
  return r;
}
function q8(t) {
  let e = "precision " + t.precision + " float;\nprecision " + t.precision + " int;";
  return "highp" === t.precision ? e += "\n#define HIGH_PRECISION" : "mediump" === t.precision ? e += "\n#define MEDIUM_PRECISION" : "lowp" === t.precision && (e += "\n#define LOW_PRECISION"), e;
}
function JW(t) {
  let e = "SHADOWMAP_TYPE_BASIC";
  return t.shadowMapType === rI ? e = "SHADOWMAP_TYPE_PCF" : t.shadowMapType === Vz ? e = "SHADOWMAP_TYPE_PCF_SOFT" : t.shadowMapType === Cu && (e = "SHADOWMAP_TYPE_VSM"), e;
}
function KW(t) {
  let e = "ENVMAP_TYPE_CUBE";
  if (t.envMap) switch (t.envMapMode) {
    case jp:
    case Wp:
      e = "ENVMAP_TYPE_CUBE";
      break;
    case Z_:
      e = "ENVMAP_TYPE_CUBE_UV";
  }
  return e;
}
function QW(t) {
  let e = "ENVMAP_MODE_REFLECTION";
  if (t.envMap && t.envMapMode === Wp) e = "ENVMAP_MODE_REFRACTION";
  return e;
}
function $W(t) {
  let e = "ENVMAP_BLENDING_NONE";
  if (t.envMap) switch (t.combine) {
    case M3:
      e = "ENVMAP_BLENDING_MULTIPLY";
      break;
    case aV:
      e = "ENVMAP_BLENDING_MIX";
      break;
    case lV:
      e = "ENVMAP_BLENDING_ADD";
  }
  return e;
}
function eX(t) {
  let e = t.envMapCubeUVHeight;
  if (null === e) return null;
  let n = Math.log2(e) - 2,
    i = 1 / e;
  return {
    texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 112)),
    texelHeight: i,
    maxMip: n
  };
}
function tX(t, e, n, i) {
  let r,
    o,
    s = t.getContext(),
    a = n.defines,
    l = n.vertexShader,
    u = n.fragmentShader,
    h = JW(n),
    c = KW(n),
    p = QW(n),
    d = $W(n),
    f = eX(n),
    m = n.isWebGL2 ? "" : GW(n),
    g = HW(a),
    v = s.createProgram(),
    y = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
  n.isRawShaderMaterial ? (r = ["#define SHADER_TYPE " + n.shaderType, "#define SHADER_NAME " + n.shaderName, g].filter(Vg).join("\n"), r.length > 0 && (r += "\n"), o = [m, "#define SHADER_TYPE " + n.shaderType, "#define SHADER_NAME " + n.shaderName, g].filter(Vg).join("\n"), o.length > 0 && (o += "\n")) : (r = [q8(n), "#define SHADER_TYPE " + n.shaderType, "#define SHADER_NAME " + n.shaderName, g, n.instancing ? "#define USE_INSTANCING" : "", n.instancingColor ? "#define USE_INSTANCING_COLOR" : "", n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + p : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "", n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "", n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "", n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "", n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "", n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "", n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "", n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "", n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.transmission ? "#define USE_TRANSMISSION" : "", n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "", n.thicknessMap ? "#define USE_THICKNESSMAP" : "", n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "", n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "", n.mapUv ? "#define MAP_UV " + n.mapUv : "", n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "", n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "", n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "", n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "", n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "", n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "", n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "", n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "", n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "", n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "", n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "", n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "", n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "", n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "", n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "", n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "", n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "", n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "", n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "", n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "", n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "", n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "", n.vertexTangents ? "#define USE_TANGENT" : "", n.vertexColors ? "#define USE_COLOR" : "", n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "", n.vertexUv1s ? "#define USE_UV1" : "", n.vertexUv2s ? "#define USE_UV2" : "", n.vertexUv3s ? "#define USE_UV3" : "", n.pointsUvs ? "#define USE_POINTS_UV" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.skinning ? "#define USE_SKINNING" : "", n.morphTargets ? "#define USE_MORPHTARGETS" : "", n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "", n.morphColors && n.isWebGL2 ? "#define USE_MORPHCOLORS" : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + h : "", n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "", n.useLegacyLights ? "#define LEGACY_LIGHTS" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 modelMatrix;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform mat4 viewMatrix;", "uniform mat3 normalMatrix;", "uniform vec3 cameraPosition;", "uniform bool isOrthographic;", "#ifdef USE_INSTANCING", "\tattribute mat4 instanceMatrix;", "#endif", "#ifdef USE_INSTANCING_COLOR", "\tattribute vec3 instanceColor;", "#endif", "attribute vec3 position;", "attribute vec3 normal;", "attribute vec2 uv;", "#ifdef USE_UV1", "\tattribute vec2 uv1;", "#endif", "#ifdef USE_UV2", "\tattribute vec2 uv2;", "#endif", "#ifdef USE_UV3", "\tattribute vec2 uv3;", "#endif", "#ifdef USE_TANGENT", "\tattribute vec4 tangent;", "#endif", "#if defined( USE_COLOR_ALPHA )", "\tattribute vec4 color;", "#elif defined( USE_COLOR )", "\tattribute vec3 color;", "#endif", "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )", "\tattribute vec3 morphTarget0;", "\tattribute vec3 morphTarget1;", "\tattribute vec3 morphTarget2;", "\tattribute vec3 morphTarget3;", "\t#ifdef USE_MORPHNORMALS", "\t\tattribute vec3 morphNormal0;", "\t\tattribute vec3 morphNormal1;", "\t\tattribute vec3 morphNormal2;", "\t\tattribute vec3 morphNormal3;", "\t#else", "\t\tattribute vec3 morphTarget4;", "\t\tattribute vec3 morphTarget5;", "\t\tattribute vec3 morphTarget6;", "\t\tattribute vec3 morphTarget7;", "\t#endif", "#endif", "#ifdef USE_SKINNING", "\tattribute vec4 skinIndex;", "\tattribute vec4 skinWeight;", "#endif", "\n"].filter(Vg).join("\n"), o = [m, q8(n), "#define SHADER_TYPE " + n.shaderType, "#define SHADER_NAME " + n.shaderName, g, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.matcap ? "#define USE_MATCAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + c : "", n.envMap ? "#define " + p : "", n.envMap ? "#define " + d : "", f ? "#define CUBEUV_TEXEL_WIDTH " + f.texelWidth : "", f ? "#define CUBEUV_TEXEL_HEIGHT " + f.texelHeight : "", f ? "#define CUBEUV_MAX_MIP " + f.maxMip + ".0" : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "", n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.anisotropy ? "#define USE_ANISOTROPY" : "", n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "", n.clearcoat ? "#define USE_CLEARCOAT" : "", n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "", n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "", n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "", n.iridescence ? "#define USE_IRIDESCENCE" : "", n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "", n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "", n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.alphaTest ? "#define USE_ALPHATEST" : "", n.sheen ? "#define USE_SHEEN" : "", n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "", n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "", n.transmission ? "#define USE_TRANSMISSION" : "", n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "", n.thicknessMap ? "#define USE_THICKNESSMAP" : "", n.vertexTangents ? "#define USE_TANGENT" : "", n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "", n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "", n.vertexUv1s ? "#define USE_UV1" : "", n.vertexUv2s ? "#define USE_UV2" : "", n.vertexUv3s ? "#define USE_UV3" : "", n.pointsUvs ? "#define USE_POINTS_UV" : "", n.gradientMap ? "#define USE_GRADIENTMAP" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + h : "", n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "", n.useLegacyLights ? "#define LEGACY_LIGHTS" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 viewMatrix;", "uniform vec3 cameraPosition;", "uniform bool isOrthographic;", n.toneMapping !== Au ? "#define TONE_MAPPING" : "", n.toneMapping !== Au ? tn.tonemapping_pars_fragment : "", n.toneMapping !== Au ? VW("toneMapping", n.toneMapping) : "", n.dithering ? "#define DITHERING" : "", n.opaque ? "#define OPAQUE" : "", tn.encodings_pars_fragment, zW("linearToOutputTexel", n.outputColorSpace), n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "", "\n"].filter(Vg).join("\n")), l = dS(l), l = R8(l, n), l = N8(l, n), u = dS(u), u = R8(u, n), u = N8(u, n), l = D8(l), u = D8(u), n.isWebGL2 && !0 !== n.isRawShaderMaterial && (y = "#version 300 es\n", r = ["precision mediump sampler2DArray;", "#define attribute in", "#define varying out", "#define texture2D texture"].join("\n") + "\n" + r, o = ["#define varying in", n.glslVersion === YI ? "" : "layout(location = 0) out highp vec4 pc_fragColor;", n.glslVersion === YI ? "" : "#define gl_FragColor pc_fragColor", "#define gl_FragDepthEXT gl_FragDepth", "#define texture2D texture", "#define textureCube texture", "#define texture2DProj textureProj", "#define texture2DLodEXT textureLod", "#define texture2DProjLodEXT textureProjLod", "#define textureCubeLodEXT textureLod", "#define texture2DGradEXT textureGrad", "#define texture2DProjGradEXT textureProjGrad", "#define textureCubeGradEXT textureGrad"].join("\n") + "\n" + o);
  let _,
    x,
    E = y + r + l,
    b = y + o + u,
    w = L8(s, s.VERTEX_SHADER, E),
    S = L8(s, s.FRAGMENT_SHADER, b);
  if (s.attachShader(v, w), s.attachShader(v, S), void 0 !== n.index0AttributeName ? s.bindAttribLocation(v, 0, n.index0AttributeName) : !0 === n.morphTargets && s.bindAttribLocation(v, 0, "position"), s.linkProgram(v), t.debug.checkShaderErrors) {
    let e = s.getProgramInfoLog(v).trim(),
      n = s.getShaderInfoLog(w).trim(),
      i = s.getShaderInfoLog(S).trim(),
      a = !0,
      l = !0;
    if (!1 === s.getProgramParameter(v, s.LINK_STATUS)) {
      if (a = !1, "function" == typeof t.debug.onShaderError) t.debug.onShaderError(s, v, w, S);else {
        let t = O8(s, w, "vertex"),
          n = O8(s, S, "fragment");
        console.error("THREE.WebGLProgram: Shader Error " + s.getError() + " - VALIDATE_STATUS " + s.getProgramParameter(v, s.VALIDATE_STATUS) + "\n\nProgram Info Log: " + e + "\n" + t + "\n" + n);
      }
    } else "" !== e ? console.warn("THREE.WebGLProgram: Program Info Log:", e) : ("" === n || "" === i) && (l = !1);
    l && (this.diagnostics = {
      runnable: a,
      programLog: e,
      vertexShader: {
        log: n,
        prefix: r
      },
      fragmentShader: {
        log: i,
        prefix: o
      }
    });
  }
  return s.deleteShader(w), s.deleteShader(S), this.getUniforms = function () {
    return void 0 === _ && (_ = new gd(s, v)), _;
  }, this.getAttributes = function () {
    return void 0 === x && (x = jW(s, v)), x;
  }, this.destroy = function () {
    i.releaseStatesOfProgram(this), s.deleteProgram(v), this.program = void 0;
  }, this.type = n.shaderType, this.name = n.shaderName, this.id = FW++, this.cacheKey = e, this.usedTimes = 1, this.program = v, this.vertexShader = w, this.fragmentShader = S, this;
}
u(D8, "unrollLoops"), u(ZW, "loopReplacer"), u(q8, "generatePrecision"), u(JW, "generateShadowMapTypeDefine"), u(KW, "generateEnvMapTypeDefine"), u(QW, "generateEnvMapModeDefine"), u($W, "generateEnvMapBlendingDefine"), u(eX, "generateCubeUVSize"), u(tX, "WebGLProgram");
var nX = 0,
  mS = class {
    constructor() {
      this.shaderCache = new Map(), this.materialCache = new Map();
    }
    update(t) {
      let e = t.vertexShader,
        n = t.fragmentShader,
        i = this._getShaderStage(e),
        r = this._getShaderStage(n),
        o = this._getShaderCacheForMaterial(t);
      return !1 === o.has(i) && (o.add(i), i.usedTimes++), !1 === o.has(r) && (o.add(r), r.usedTimes++), this;
    }
    remove(t) {
      let e = this.materialCache.get(t);
      for (let t of e) t.usedTimes--, 0 === t.usedTimes && this.shaderCache.delete(t.code);
      return this.materialCache.delete(t), this;
    }
    getVertexShaderID(t) {
      return this._getShaderStage(t.vertexShader).id;
    }
    getFragmentShaderID(t) {
      return this._getShaderStage(t.fragmentShader).id;
    }
    dispose() {
      this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(t) {
      let e = this.materialCache,
        n = e.get(t);
      return void 0 === n && (n = new Set(), e.set(t, n)), n;
    }
    _getShaderStage(t) {
      let e = this.shaderCache,
        n = e.get(t);
      return void 0 === n && (n = new gS(t), e.set(t, n)), n;
    }
  };
u(mS, "WebGLShaderCache");
var gS = class {
  constructor(t) {
    this.id = nX++, this.code = t, this.usedTimes = 0;
  }
};
function iX(t, e, n, i, r, o, s) {
  let a = new Bg(),
    l = new mS(),
    h = [],
    c = r.isWebGL2,
    p = r.logarithmicDepthBuffer,
    d = r.vertexTextures,
    f = r.precision,
    m = {
      MeshDepthMaterial: "depth",
      MeshDistanceMaterial: "distanceRGBA",
      MeshNormalMaterial: "normal",
      MeshBasicMaterial: "basic",
      MeshLambertMaterial: "lambert",
      MeshPhongMaterial: "phong",
      MeshToonMaterial: "toon",
      MeshStandardMaterial: "physical",
      MeshPhysicalMaterial: "physical",
      MeshMatcapMaterial: "matcap",
      LineBasicMaterial: "basic",
      LineDashedMaterial: "dashed",
      PointsMaterial: "points",
      ShadowMaterial: "shadow",
      SpriteMaterial: "sprite"
    };
  function g(t) {
    return 0 === t ? "uv" : `uv${t}`;
  }
  function v(o, a, u, h, v) {
    let y = h.fog,
      _ = v.geometry,
      x = o.isMeshStandardMaterial ? h.environment : null,
      E = (o.isMeshStandardMaterial ? n : e).get(o.envMap || x),
      b = E && E.mapping === Z_ ? E.image.height : null,
      w = m[o.type];
    null !== o.precision && (f = r.getMaxPrecision(o.precision), f !== o.precision && console.warn("THREE.WebGLProgram.getParameters:", o.precision, "not supported, using", f, "instead."));
    let S,
      M,
      T,
      A,
      P = _.morphAttributes.position || _.morphAttributes.normal || _.morphAttributes.color,
      C = void 0 !== P ? P.length : 0,
      I = 0;
    if (void 0 !== _.morphAttributes.position && (I = 1), void 0 !== _.morphAttributes.normal && (I = 2), void 0 !== _.morphAttributes.color && (I = 3), w) {
      let t = Il[w];
      S = t.vertexShader, M = t.fragmentShader;
    } else S = o.vertexShader, M = o.fragmentShader, l.update(o), T = l.getVertexShaderID(o), A = l.getFragmentShaderID(o);
    let N = t.getRenderTarget(),
      L = !0 === v.isInstancedMesh,
      R = !!o.map,
      O = !!o.matcap,
      q = !!E,
      D = !!o.aoMap,
      k = !!o.lightMap,
      F = !!o.bumpMap,
      U = !!o.normalMap,
      B = !!o.displacementMap,
      z = !!o.emissiveMap,
      V = !!o.metalnessMap,
      j = !!o.roughnessMap,
      G = o.anisotropy > 0,
      W = o.clearcoat > 0,
      H = o.iridescence > 0,
      X = o.sheen > 0,
      Y = o.transmission > 0,
      Z = G && !!o.anisotropyMap,
      J = W && !!o.clearcoatMap,
      K = W && !!o.clearcoatNormalMap,
      Q = W && !!o.clearcoatRoughnessMap,
      $ = H && !!o.iridescenceMap,
      tt = H && !!o.iridescenceThicknessMap,
      et = X && !!o.sheenColorMap,
      nt = X && !!o.sheenRoughnessMap,
      it = !!o.specularMap,
      rt = !!o.specularColorMap,
      ot = !!o.specularIntensityMap,
      st = Y && !!o.transmissionMap,
      at = Y && !!o.thicknessMap,
      lt = !!o.gradientMap,
      ut = !!o.alphaMap,
      ht = o.alphaTest > 0,
      ct = !!o.extensions,
      pt = !!_.attributes.uv1,
      dt = !!_.attributes.uv2,
      ft = !!_.attributes.uv3;
    return {
      isWebGL2: c,
      shaderID: w,
      shaderType: o.type,
      shaderName: o.name,
      vertexShader: S,
      fragmentShader: M,
      defines: o.defines,
      customVertexShaderID: T,
      customFragmentShaderID: A,
      isRawShaderMaterial: !0 === o.isRawShaderMaterial,
      glslVersion: o.glslVersion,
      precision: f,
      instancing: L,
      instancingColor: L && null !== v.instanceColor,
      supportsVertexTextures: d,
      outputColorSpace: null === N ? t.outputColorSpace : !0 === N.isXRRenderTarget ? N.texture.colorSpace : Cl,
      map: R,
      matcap: O,
      envMap: q,
      envMapMode: q && E.mapping,
      envMapCubeUVHeight: b,
      aoMap: D,
      lightMap: k,
      bumpMap: F,
      normalMap: U,
      displacementMap: d && B,
      emissiveMap: z,
      normalMapObjectSpace: U && o.normalMapType === SV,
      normalMapTangentSpace: U && o.normalMapType === jI,
      metalnessMap: V,
      roughnessMap: j,
      anisotropy: G,
      anisotropyMap: Z,
      clearcoat: W,
      clearcoatMap: J,
      clearcoatNormalMap: K,
      clearcoatRoughnessMap: Q,
      iridescence: H,
      iridescenceMap: $,
      iridescenceThicknessMap: tt,
      sheen: X,
      sheenColorMap: et,
      sheenRoughnessMap: nt,
      specularMap: it,
      specularColorMap: rt,
      specularIntensityMap: ot,
      transmission: Y,
      transmissionMap: st,
      thicknessMap: at,
      gradientMap: lt,
      opaque: !1 === o.transparent && o.blending === Gp,
      alphaMap: ut,
      alphaTest: ht,
      combine: o.combine,
      mapUv: R && g(o.map.channel),
      aoMapUv: D && g(o.aoMap.channel),
      lightMapUv: k && g(o.lightMap.channel),
      bumpMapUv: F && g(o.bumpMap.channel),
      normalMapUv: U && g(o.normalMap.channel),
      displacementMapUv: B && g(o.displacementMap.channel),
      emissiveMapUv: z && g(o.emissiveMap.channel),
      metalnessMapUv: V && g(o.metalnessMap.channel),
      roughnessMapUv: j && g(o.roughnessMap.channel),
      anisotropyMapUv: Z && g(o.anisotropyMap.channel),
      clearcoatMapUv: J && g(o.clearcoatMap.channel),
      clearcoatNormalMapUv: K && g(o.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: Q && g(o.clearcoatRoughnessMap.channel),
      iridescenceMapUv: $ && g(o.iridescenceMap.channel),
      iridescenceThicknessMapUv: tt && g(o.iridescenceThicknessMap.channel),
      sheenColorMapUv: et && g(o.sheenColorMap.channel),
      sheenRoughnessMapUv: nt && g(o.sheenRoughnessMap.channel),
      specularMapUv: it && g(o.specularMap.channel),
      specularColorMapUv: rt && g(o.specularColorMap.channel),
      specularIntensityMapUv: ot && g(o.specularIntensityMap.channel),
      transmissionMapUv: st && g(o.transmissionMap.channel),
      thicknessMapUv: at && g(o.thicknessMap.channel),
      alphaMapUv: ut && g(o.alphaMap.channel),
      vertexTangents: !!_.attributes.tangent && (U || G),
      vertexColors: o.vertexColors,
      vertexAlphas: !0 === o.vertexColors && !!_.attributes.color && 4 === _.attributes.color.itemSize,
      vertexUv1s: pt,
      vertexUv2s: dt,
      vertexUv3s: ft,
      pointsUvs: !0 === v.isPoints && !!_.attributes.uv && (R || ut),
      fog: !!y,
      useFog: !0 === o.fog,
      fogExp2: y && y.isFogExp2,
      flatShading: !0 === o.flatShading,
      sizeAttenuation: !0 === o.sizeAttenuation,
      logarithmicDepthBuffer: p,
      skinning: !0 === v.isSkinnedMesh,
      morphTargets: void 0 !== _.morphAttributes.position,
      morphNormals: void 0 !== _.morphAttributes.normal,
      morphColors: void 0 !== _.morphAttributes.color,
      morphTargetsCount: C,
      morphTextureStride: I,
      numDirLights: a.directional.length,
      numPointLights: a.point.length,
      numSpotLights: a.spot.length,
      numSpotLightMaps: a.spotLightMap.length,
      numRectAreaLights: a.rectArea.length,
      numHemiLights: a.hemi.length,
      numDirLightShadows: a.directionalShadowMap.length,
      numPointLightShadows: a.pointShadowMap.length,
      numSpotLightShadows: a.spotShadowMap.length,
      numSpotLightShadowsWithMaps: a.numSpotLightShadowsWithMaps,
      numClippingPlanes: s.numPlanes,
      numClipIntersection: s.numIntersection,
      dithering: o.dithering,
      shadowMapEnabled: t.shadowMap.enabled && u.length > 0,
      shadowMapType: t.shadowMap.type,
      toneMapping: o.toneMapped ? t.toneMapping : Au,
      useLegacyLights: t.useLegacyLights,
      premultipliedAlpha: o.premultipliedAlpha,
      doubleSided: o.side === Us,
      flipSided: o.side === Ts,
      useDepthPacking: o.depthPacking >= 0,
      depthPacking: o.depthPacking || 0,
      index0AttributeName: o.index0AttributeName,
      extensionDerivatives: ct && !0 === o.extensions.derivatives,
      extensionFragDepth: ct && !0 === o.extensions.fragDepth,
      extensionDrawBuffers: ct && !0 === o.extensions.drawBuffers,
      extensionShaderTextureLOD: ct && !0 === o.extensions.shaderTextureLOD,
      rendererExtensionFragDepth: c || i.has("EXT_frag_depth"),
      rendererExtensionDrawBuffers: c || i.has("WEBGL_draw_buffers"),
      rendererExtensionShaderTextureLod: c || i.has("EXT_shader_texture_lod"),
      customProgramCacheKey: o.customProgramCacheKey()
    };
  }
  function y(e) {
    let n = [];
    if (e.shaderID ? n.push(e.shaderID) : (n.push(e.customVertexShaderID), n.push(e.customFragmentShaderID)), void 0 !== e.defines) for (let t in e.defines) n.push(t), n.push(e.defines[t]);
    return !1 === e.isRawShaderMaterial && (_(n, e), x(n, e), n.push(t.outputColorSpace)), n.push(e.customProgramCacheKey), n.join();
  }
  function _(t, e) {
    t.push(e.precision), t.push(e.outputColorSpace), t.push(e.envMapMode), t.push(e.envMapCubeUVHeight), t.push(e.mapUv), t.push(e.alphaMapUv), t.push(e.lightMapUv), t.push(e.aoMapUv), t.push(e.bumpMapUv), t.push(e.normalMapUv), t.push(e.displacementMapUv), t.push(e.emissiveMapUv), t.push(e.metalnessMapUv), t.push(e.roughnessMapUv), t.push(e.anisotropyMapUv), t.push(e.clearcoatMapUv), t.push(e.clearcoatNormalMapUv), t.push(e.clearcoatRoughnessMapUv), t.push(e.iridescenceMapUv), t.push(e.iridescenceThicknessMapUv), t.push(e.sheenColorMapUv), t.push(e.sheenRoughnessMapUv), t.push(e.specularMapUv), t.push(e.specularColorMapUv), t.push(e.specularIntensityMapUv), t.push(e.transmissionMapUv), t.push(e.thicknessMapUv), t.push(e.combine), t.push(e.fogExp2), t.push(e.sizeAttenuation), t.push(e.morphTargetsCount), t.push(e.morphAttributeCount), t.push(e.numDirLights), t.push(e.numPointLights), t.push(e.numSpotLights), t.push(e.numSpotLightMaps), t.push(e.numHemiLights), t.push(e.numRectAreaLights), t.push(e.numDirLightShadows), t.push(e.numPointLightShadows), t.push(e.numSpotLightShadows), t.push(e.numSpotLightShadowsWithMaps), t.push(e.shadowMapType), t.push(e.toneMapping), t.push(e.numClippingPlanes), t.push(e.numClipIntersection), t.push(e.depthPacking);
  }
  function x(t, e) {
    a.disableAll(), e.isWebGL2 && a.enable(0), e.supportsVertexTextures && a.enable(1), e.instancing && a.enable(2), e.instancingColor && a.enable(3), e.matcap && a.enable(4), e.envMap && a.enable(5), e.normalMapObjectSpace && a.enable(6), e.normalMapTangentSpace && a.enable(7), e.clearcoat && a.enable(8), e.iridescence && a.enable(9), e.alphaTest && a.enable(10), e.vertexColors && a.enable(11), e.vertexAlphas && a.enable(12), e.vertexUv1s && a.enable(13), e.vertexUv2s && a.enable(14), e.vertexUv3s && a.enable(15), e.vertexTangents && a.enable(16), e.anisotropy && a.enable(17), t.push(a.mask), a.disableAll(), e.fog && a.enable(0), e.useFog && a.enable(1), e.flatShading && a.enable(2), e.logarithmicDepthBuffer && a.enable(3), e.skinning && a.enable(4), e.morphTargets && a.enable(5), e.morphNormals && a.enable(6), e.morphColors && a.enable(7), e.premultipliedAlpha && a.enable(8), e.shadowMapEnabled && a.enable(9), e.useLegacyLights && a.enable(10), e.doubleSided && a.enable(11), e.flipSided && a.enable(12), e.useDepthPacking && a.enable(13), e.dithering && a.enable(14), e.transmission && a.enable(15), e.sheen && a.enable(16), e.opaque && a.enable(17), e.pointsUvs && a.enable(18), t.push(a.mask);
  }
  function E(t) {
    let e,
      n = m[t.type];
    if (n) {
      let t = Il[n];
      e = iS.clone(t.uniforms);
    } else e = t.uniforms;
    return e;
  }
  function b(e, n) {
    let i;
    for (let t = 0, e = h.length; t < e; t++) {
      let e = h[t];
      if (e.cacheKey === n) {
        i = e, ++i.usedTimes;
        break;
      }
    }
    return void 0 === i && (i = new tX(t, n, e, o), h.push(i)), i;
  }
  function w(t) {
    if (0 == --t.usedTimes) {
      let e = h.indexOf(t);
      h[e] = h[h.length - 1], h.pop(), t.destroy();
    }
  }
  function S(t) {
    l.remove(t);
  }
  function M() {
    l.dispose();
  }
  return u(g, "getChannel"), u(v, "getParameters"), u(y, "getProgramCacheKey"), u(_, "getProgramCacheKeyParameters"), u(x, "getProgramCacheKeyBooleans"), u(E, "getUniforms"), u(b, "acquireProgram"), u(w, "releaseProgram"), u(S, "releaseShaderCache"), u(M, "dispose"), {
    getParameters: v,
    getProgramCacheKey: y,
    getUniforms: E,
    acquireProgram: b,
    releaseProgram: w,
    releaseShaderCache: S,
    programs: h,
    dispose: M
  };
}
function rX() {
  let t = new WeakMap();
  function e(e) {
    let n = t.get(e);
    return void 0 === n && (n = {}, t.set(e, n)), n;
  }
  function n(e) {
    t.delete(e);
  }
  function i(e, n, i) {
    t.get(e)[n] = i;
  }
  function r() {
    t = new WeakMap();
  }
  return u(e, "get"), u(n, "remove"), u(i, "update"), u(r, "dispose"), {
    get: e,
    remove: n,
    update: i,
    dispose: r
  };
}
function oX(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.material.id !== e.material.id ? t.material.id - e.material.id : t.z !== e.z ? t.z - e.z : t.id - e.id;
}
function k8(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : t.id - e.id;
}
function F8() {
  let t = [],
    e = 0,
    n = [],
    i = [],
    r = [];
  function o() {
    e = 0, n.length = 0, i.length = 0, r.length = 0;
  }
  function s(n, i, r, o, s, a) {
    let l = t[e];
    return void 0 === l ? (l = {
      id: n.id,
      object: n,
      geometry: i,
      material: r,
      groupOrder: o,
      renderOrder: n.renderOrder,
      z: s,
      group: a
    }, t[e] = l) : (l.id = n.id, l.object = n, l.geometry = i, l.material = r, l.groupOrder = o, l.renderOrder = n.renderOrder, l.z = s, l.group = a), e++, l;
  }
  function a(t, e, o, a, l, u) {
    let h = s(t, e, o, a, l, u);
    o.transmission > 0 ? i.push(h) : !0 === o.transparent ? r.push(h) : n.push(h);
  }
  function l(t, e, o, a, l, u) {
    let h = s(t, e, o, a, l, u);
    o.transmission > 0 ? i.unshift(h) : !0 === o.transparent ? r.unshift(h) : n.unshift(h);
  }
  function h(t, e) {
    n.length > 1 && n.sort(t || oX), i.length > 1 && i.sort(e || k8), r.length > 1 && r.sort(e || k8);
  }
  function c() {
    for (let n = e, i = t.length; n < i; n++) {
      let e = t[n];
      if (null === e.id) break;
      e.id = null, e.object = null, e.geometry = null, e.material = null, e.group = null;
    }
  }
  return u(o, "init"), u(s, "getNextRenderItem"), u(a, "push"), u(l, "unshift"), u(h, "sort"), u(c, "finish"), {
    opaque: n,
    transmissive: i,
    transparent: r,
    init: o,
    push: a,
    unshift: l,
    finish: c,
    sort: h
  };
}
function sX() {
  let t = new WeakMap();
  function e(e, n) {
    let i,
      r = t.get(e);
    return void 0 === r ? (i = new F8(), t.set(e, [i])) : n >= r.length ? (i = new F8(), r.push(i)) : i = r[n], i;
  }
  function n() {
    t = new WeakMap();
  }
  return u(e, "get"), u(n, "dispose"), {
    get: e,
    dispose: n
  };
}
function aX() {
  let t = {};
  return {
    get: function (e) {
      if (void 0 !== t[e.id]) return t[e.id];
      let n;
      switch (e.type) {
        case "DirectionalLight":
          n = {
            direction: new ne(),
            color: new yt()
          };
          break;
        case "SpotLight":
          n = {
            position: new ne(),
            direction: new ne(),
            color: new yt(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          n = {
            position: new ne(),
            color: new yt(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          n = {
            direction: new ne(),
            skyColor: new yt(),
            groundColor: new yt()
          };
          break;
        case "RectAreaLight":
          n = {
            color: new yt(),
            position: new ne(),
            halfWidth: new ne(),
            halfHeight: new ne()
          };
      }
      return t[e.id] = n, n;
    }
  };
}
function lX() {
  let t = {};
  return {
    get: function (e) {
      if (void 0 !== t[e.id]) return t[e.id];
      let n;
      switch (e.type) {
        case "DirectionalLight":
        case "SpotLight":
          n = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new je()
          };
          break;
        case "PointLight":
          n = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new je(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
      }
      return t[e.id] = n, n;
    }
  };
}
u(gS, "WebGLShaderStage"), u(iX, "WebGLPrograms"), u(rX, "WebGLProperties"), u(oX, "painterSortStable"), u(k8, "reversePainterSortStable"), u(F8, "WebGLRenderList"), u(sX, "WebGLRenderLists"), u(aX, "UniformsCache"), u(lX, "ShadowUniformsCache");
var uX = 0;
function cX(t, e) {
  return (e.castShadow ? 2 : 0) - (t.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (t.map ? 1 : 0);
}
function hX(t, e) {
  let n = new aX(),
    i = lX(),
    r = {
      version: 0,
      hash: {
        directionalLength: -1,
        pointLength: -1,
        spotLength: -1,
        rectAreaLength: -1,
        hemiLength: -1,
        numDirectionalShadows: -1,
        numPointShadows: -1,
        numSpotShadows: -1,
        numSpotMaps: -1
      },
      ambient: [0, 0, 0],
      probe: [],
      directional: [],
      directionalShadow: [],
      directionalShadowMap: [],
      directionalShadowMatrix: [],
      spot: [],
      spotLightMap: [],
      spotShadow: [],
      spotShadowMap: [],
      spotLightMatrix: [],
      rectArea: [],
      rectAreaLTC1: null,
      rectAreaLTC2: null,
      point: [],
      pointShadow: [],
      pointShadowMap: [],
      pointShadowMatrix: [],
      hemi: [],
      numSpotLightShadowsWithMaps: 0
    };
  for (let t = 0; t < 9; t++) r.probe.push(new ne());
  let o = new ne(),
    s = new Bt(),
    a = new Bt();
  function l(o, s) {
    let a = 0,
      l = 0,
      u = 0;
    for (let t = 0; t < 9; t++) r.probe[t].set(0, 0, 0);
    let h = 0,
      c = 0,
      p = 0,
      d = 0,
      f = 0,
      m = 0,
      g = 0,
      v = 0,
      y = 0,
      _ = 0;
    o.sort(cX);
    let x = !0 === s ? Math.PI : 1;
    for (let t = 0, e = o.length; t < e; t++) {
      let e = o[t],
        s = e.color,
        E = e.intensity,
        b = e.distance,
        w = e.shadow && e.shadow.map ? e.shadow.map.texture : null;
      if (e.isAmbientLight) a += s.r * E * x, l += s.g * E * x, u += s.b * E * x;else if (e.isLightProbe) for (let t = 0; t < 9; t++) r.probe[t].addScaledVector(e.sh.coefficients[t], E);else if (e.isDirectionalLight) {
        let t = n.get(e);
        if (t.color.copy(e.color).multiplyScalar(e.intensity * x), e.castShadow) {
          let t = e.shadow,
            n = i.get(e);
          n.shadowBias = t.bias, n.shadowNormalBias = t.normalBias, n.shadowRadius = t.radius, n.shadowMapSize = t.mapSize, r.directionalShadow[h] = n, r.directionalShadowMap[h] = w, r.directionalShadowMatrix[h] = e.shadow.matrix, m++;
        }
        r.directional[h] = t, h++;
      } else if (e.isSpotLight) {
        let t = n.get(e);
        t.position.setFromMatrixPosition(e.matrixWorld), t.color.copy(s).multiplyScalar(E * x), t.distance = b, t.coneCos = Math.cos(e.angle), t.penumbraCos = Math.cos(e.angle * (1 - e.penumbra)), t.decay = e.decay, r.spot[p] = t;
        let o = e.shadow;
        if (e.map && (r.spotLightMap[y] = e.map, y++, o.updateMatrices(e), e.castShadow && _++), r.spotLightMatrix[p] = o.matrix, e.castShadow) {
          let t = i.get(e);
          t.shadowBias = o.bias, t.shadowNormalBias = o.normalBias, t.shadowRadius = o.radius, t.shadowMapSize = o.mapSize, r.spotShadow[p] = t, r.spotShadowMap[p] = w, v++;
        }
        p++;
      } else if (e.isRectAreaLight) {
        let t = n.get(e);
        t.color.copy(s).multiplyScalar(E), t.halfWidth.set(.5 * e.width, 0, 0), t.halfHeight.set(0, .5 * e.height, 0), r.rectArea[d] = t, d++;
      } else if (e.isPointLight) {
        let t = n.get(e);
        if (t.color.copy(e.color).multiplyScalar(e.intensity * x), t.distance = e.distance, t.decay = e.decay, e.castShadow) {
          let t = e.shadow,
            n = i.get(e);
          n.shadowBias = t.bias, n.shadowNormalBias = t.normalBias, n.shadowRadius = t.radius, n.shadowMapSize = t.mapSize, n.shadowCameraNear = t.camera.near, n.shadowCameraFar = t.camera.far, r.pointShadow[c] = n, r.pointShadowMap[c] = w, r.pointShadowMatrix[c] = e.shadow.matrix, g++;
        }
        r.point[c] = t, c++;
      } else if (e.isHemisphereLight) {
        let t = n.get(e);
        t.skyColor.copy(e.color).multiplyScalar(E * x), t.groundColor.copy(e.groundColor).multiplyScalar(E * x), r.hemi[f] = t, f++;
      }
    }
    d > 0 && (e.isWebGL2 || !0 === t.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = ht.LTC_FLOAT_1, r.rectAreaLTC2 = ht.LTC_FLOAT_2) : !0 === t.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = ht.LTC_HALF_1, r.rectAreaLTC2 = ht.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = a, r.ambient[1] = l, r.ambient[2] = u;
    let E = r.hash;
    (E.directionalLength !== h || E.pointLength !== c || E.spotLength !== p || E.rectAreaLength !== d || E.hemiLength !== f || E.numDirectionalShadows !== m || E.numPointShadows !== g || E.numSpotShadows !== v || E.numSpotMaps !== y) && (r.directional.length = h, r.spot.length = p, r.rectArea.length = d, r.point.length = c, r.hemi.length = f, r.directionalShadow.length = m, r.directionalShadowMap.length = m, r.pointShadow.length = g, r.pointShadowMap.length = g, r.spotShadow.length = v, r.spotShadowMap.length = v, r.directionalShadowMatrix.length = m, r.pointShadowMatrix.length = g, r.spotLightMatrix.length = v + y - _, r.spotLightMap.length = y, r.numSpotLightShadowsWithMaps = _, E.directionalLength = h, E.pointLength = c, E.spotLength = p, E.rectAreaLength = d, E.hemiLength = f, E.numDirectionalShadows = m, E.numPointShadows = g, E.numSpotShadows = v, E.numSpotMaps = y, r.version = uX++);
  }
  function h(t, e) {
    let n = 0,
      i = 0,
      l = 0,
      u = 0,
      h = 0,
      c = e.matrixWorldInverse;
    for (let e = 0, p = t.length; e < p; e++) {
      let p = t[e];
      if (p.isDirectionalLight) {
        let t = r.directional[n];
        t.direction.setFromMatrixPosition(p.matrixWorld), o.setFromMatrixPosition(p.target.matrixWorld), t.direction.sub(o), t.direction.transformDirection(c), n++;
      } else if (p.isSpotLight) {
        let t = r.spot[l];
        t.position.setFromMatrixPosition(p.matrixWorld), t.position.applyMatrix4(c), t.direction.setFromMatrixPosition(p.matrixWorld), o.setFromMatrixPosition(p.target.matrixWorld), t.direction.sub(o), t.direction.transformDirection(c), l++;
      } else if (p.isRectAreaLight) {
        let t = r.rectArea[u];
        t.position.setFromMatrixPosition(p.matrixWorld), t.position.applyMatrix4(c), a.identity(), s.copy(p.matrixWorld), s.premultiply(c), a.extractRotation(s), t.halfWidth.set(.5 * p.width, 0, 0), t.halfHeight.set(0, .5 * p.height, 0), t.halfWidth.applyMatrix4(a), t.halfHeight.applyMatrix4(a), u++;
      } else if (p.isPointLight) {
        let t = r.point[i];
        t.position.setFromMatrixPosition(p.matrixWorld), t.position.applyMatrix4(c), i++;
      } else if (p.isHemisphereLight) {
        let t = r.hemi[h];
        t.direction.setFromMatrixPosition(p.matrixWorld), t.direction.transformDirection(c), h++;
      }
    }
  }
  return u(l, "setup"), u(h, "setupView"), {
    setup: l,
    setupView: h,
    state: r
  };
}
function B8(t, e) {
  let n = new hX(t, e),
    i = [],
    r = [];
  function o() {
    i.length = 0, r.length = 0;
  }
  function s(t) {
    i.push(t);
  }
  function a(t) {
    r.push(t);
  }
  function l(t) {
    n.setup(i, t);
  }
  function h(t) {
    n.setupView(i, t);
  }
  return u(o, "init"), u(s, "pushLight"), u(a, "pushShadow"), u(l, "setupLights"), u(h, "setupLightsView"), {
    init: o,
    state: {
      lightsArray: i,
      shadowsArray: r,
      lights: n
    },
    setupLights: l,
    setupLightsView: h,
    pushLight: s,
    pushShadow: a
  };
}
function fX(t, e) {
  let n = new WeakMap();
  function i(i, r = 0) {
    let o,
      s = n.get(i);
    return void 0 === s ? (o = new B8(t, e), n.set(i, [o])) : r >= s.length ? (o = new B8(t, e), s.push(o)) : o = s[r], o;
  }
  function r() {
    n = new WeakMap();
  }
  return u(i, "get"), u(r, "dispose"), {
    get: i,
    dispose: r
  };
}
u(cX, "shadowCastingAndTexturingLightsFirst"), u(hX, "WebGLLights"), u(B8, "WebGLRenderState"), u(fX, "WebGLRenderStates");
var vS = class extends $c {
  constructor(t) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = EV, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
  }
};
u(vS, "MeshDepthMaterial");
var yS = class extends $c {
  constructor(t) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
  }
};
u(yS, "MeshDistanceMaterial");
var pX = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
  dX = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function mX(t, e, n) {
  let i = new hf(),
    r = new je(),
    o = new je(),
    s = new Er(),
    a = new vS({
      depthPacking: wV
    }),
    l = new yS(),
    h = {},
    c = n.maxTextureSize,
    p = {
      [ja]: Ts,
      [Ts]: ja,
      [Us]: Us
    },
    d = new wi({
      defines: {
        VSM_SAMPLES: 8
      },
      uniforms: {
        shadow_pass: {
          value: null
        },
        resolution: {
          value: new je()
        },
        radius: {
          value: 4
        }
      },
      vertexShader: pX,
      fragmentShader: dX
    }),
    f = d.clone();
  f.defines.HORIZONTAL_PASS = 1;
  let m = new Pi();
  m.setAttribute("position", new ui(new Float32Array([-1, -1, .5, 3, -1, .5, -1, 3, .5]), 3));
  let g = new Ft(m, d),
    v = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = rI;
  let y = this.type;
  function _(n, i) {
    let o = e.update(g);
    d.defines.VSM_SAMPLES !== n.blurSamples && (d.defines.VSM_SAMPLES = n.blurSamples, f.defines.VSM_SAMPLES = n.blurSamples, d.needsUpdate = !0, f.needsUpdate = !0), null === n.mapPass && (n.mapPass = new wr(r.x, r.y)), d.uniforms.shadow_pass.value = n.map.texture, d.uniforms.resolution.value = n.mapSize, d.uniforms.radius.value = n.radius, t.setRenderTarget(n.mapPass), t.clear(), t.renderBufferDirect(i, null, o, d, g, null), f.uniforms.shadow_pass.value = n.mapPass.texture, f.uniforms.resolution.value = n.mapSize, f.uniforms.radius.value = n.radius, t.setRenderTarget(n.map), t.clear(), t.renderBufferDirect(i, null, o, f, g, null);
  }
  function x(e, n, i, r) {
    let o = null,
      s = !0 === i.isPointLight ? e.customDistanceMaterial : e.customDepthMaterial;
    if (void 0 !== s) o = s;else if (o = !0 === i.isPointLight ? l : a, t.localClippingEnabled && !0 === n.clipShadows && Array.isArray(n.clippingPlanes) && 0 !== n.clippingPlanes.length || n.displacementMap && 0 !== n.displacementScale || n.alphaMap && n.alphaTest > 0 || n.map && n.alphaTest > 0) {
      let t = o.uuid,
        e = n.uuid,
        i = h[t];
      void 0 === i && (i = {}, h[t] = i);
      let r = i[e];
      void 0 === r && (r = o.clone(), i[e] = r), o = r;
    }
    if (o.visible = n.visible, o.wireframe = n.wireframe, o.side = r === Cu ? null !== n.shadowSide ? n.shadowSide : n.side : null !== n.shadowSide ? n.shadowSide : p[n.side], o.alphaMap = n.alphaMap, o.alphaTest = n.alphaTest, o.map = n.map, o.clipShadows = n.clipShadows, o.clippingPlanes = n.clippingPlanes, o.clipIntersection = n.clipIntersection, o.displacementMap = n.displacementMap, o.displacementScale = n.displacementScale, o.displacementBias = n.displacementBias, o.wireframeLinewidth = n.wireframeLinewidth, o.linewidth = n.linewidth, !0 === i.isPointLight && !0 === o.isMeshDistanceMaterial) {
      t.properties.get(o).light = i;
    }
    return o;
  }
  function E(n, r, o, s, a) {
    if (!1 === n.visible) return;
    if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && a === Cu) && (!n.frustumCulled || i.intersectsObject(n))) {
      n.modelViewMatrix.multiplyMatrices(o.matrixWorldInverse, n.matrixWorld);
      let i = e.update(n),
        r = n.material;
      if (Array.isArray(r)) {
        let e = i.groups;
        for (let l = 0, u = e.length; l < u; l++) {
          let u = e[l],
            h = r[u.materialIndex];
          if (h && h.visible) {
            let e = x(n, h, s, a);
            t.renderBufferDirect(o, null, i, e, n, u);
          }
        }
      } else if (r.visible) {
        let e = x(n, r, s, a);
        t.renderBufferDirect(o, null, i, e, n, null);
      }
    }
    let l = n.children;
    for (let t = 0, e = l.length; t < e; t++) E(l[t], r, o, s, a);
  }
  this.render = function (e, n, a) {
    if (!1 === v.enabled || !1 === v.autoUpdate && !1 === v.needsUpdate || 0 === e.length) return;
    let l = t.getRenderTarget(),
      u = t.getActiveCubeFace(),
      h = t.getActiveMipmapLevel(),
      p = t.state;
    p.setBlending(jc), p.buffers.color.setClear(1, 1, 1, 1), p.buffers.depth.setTest(!0), p.setScissorTest(!1);
    let d = y !== Cu && this.type === Cu,
      f = y === Cu && this.type !== Cu;
    for (let l = 0, u = e.length; l < u; l++) {
      let u = e[l],
        h = u.shadow;
      if (void 0 === h) {
        console.warn("THREE.WebGLShadowMap:", u, "has no shadow.");
        continue;
      }
      if (!1 === h.autoUpdate && !1 === h.needsUpdate) continue;
      r.copy(h.mapSize);
      let m = h.getFrameExtents();
      if (r.multiply(m), o.copy(h.mapSize), (r.x > c || r.y > c) && (r.x > c && (o.x = Math.floor(c / m.x), r.x = o.x * m.x, h.mapSize.x = o.x), r.y > c && (o.y = Math.floor(c / m.y), r.y = o.y * m.y, h.mapSize.y = o.y)), null === h.map || !0 === d || !0 === f) {
        let t = this.type !== Cu ? {
          minFilter: ni,
          magFilter: ni
        } : {};
        null !== h.map && h.map.dispose(), h.map = new wr(r.x, r.y, t), h.map.texture.name = u.name + ".shadowMap", h.camera.updateProjectionMatrix();
      }
      t.setRenderTarget(h.map), t.clear();
      let g = h.getViewportCount();
      for (let t = 0; t < g; t++) {
        let e = h.getViewport(t);
        s.set(o.x * e.x, o.y * e.y, o.x * e.z, o.y * e.w), p.viewport(s), h.updateMatrices(u, t), i = h.getFrustum(), E(n, a, h.camera, u, this.type);
      }
      !0 !== h.isPointLightShadow && this.type === Cu && _(h, a), h.needsUpdate = !1;
    }
    y = this.type, v.needsUpdate = !1, t.setRenderTarget(l, u, h);
  }, u(_, "VSMPass"), u(x, "getDepthMaterial"), u(E, "renderObject");
}
function gX(t, e, n) {
  let i = n.isWebGL2;
  function r() {
    let e = !1,
      n = new Er(),
      i = null,
      r = new Er(0, 0, 0, 0);
    return {
      setMask: function (n) {
        i !== n && !e && (t.colorMask(n, n, n, n), i = n);
      },
      setLocked: function (t) {
        e = t;
      },
      setClear: function (e, i, o, s, a) {
        !0 === a && (e *= s, i *= s, o *= s), n.set(e, i, o, s), !1 === r.equals(n) && (t.clearColor(e, i, o, s), r.copy(n));
      },
      reset: function () {
        e = !1, i = null, r.set(-1, 0, 0, 0);
      }
    };
  }
  function o() {
    let e = !1,
      n = null,
      i = null,
      r = null;
    return {
      setTest: function (e) {
        e ? G(t.DEPTH_TEST) : W(t.DEPTH_TEST);
      },
      setMask: function (i) {
        n !== i && !e && (t.depthMask(i), n = i);
      },
      setFunc: function (e) {
        if (i !== e) {
          switch (e) {
            case eV:
              t.depthFunc(t.NEVER);
              break;
            case tV:
              t.depthFunc(t.ALWAYS);
              break;
            case nV:
              t.depthFunc(t.LESS);
              break;
            case b3:
              t.depthFunc(t.LEQUAL);
              break;
            case iV:
              t.depthFunc(t.EQUAL);
              break;
            case rV:
              t.depthFunc(t.GEQUAL);
              break;
            case oV:
              t.depthFunc(t.GREATER);
              break;
            case sV:
              t.depthFunc(t.NOTEQUAL);
              break;
            default:
              t.depthFunc(t.LEQUAL);
          }
          i = e;
        }
      },
      setLocked: function (t) {
        e = t;
      },
      setClear: function (e) {
        r !== e && (t.clearDepth(e), r = e);
      },
      reset: function () {
        e = !1, n = null, i = null, r = null;
      }
    };
  }
  function s() {
    let e = !1,
      n = null,
      i = null,
      r = null,
      o = null,
      s = null,
      a = null,
      l = null,
      u = null;
    return {
      setTest: function (n) {
        e || (n ? G(t.STENCIL_TEST) : W(t.STENCIL_TEST));
      },
      setMask: function (i) {
        n !== i && !e && (t.stencilMask(i), n = i);
      },
      setFunc: function (e, n, s) {
        (i !== e || r !== n || o !== s) && (t.stencilFunc(e, n, s), i = e, r = n, o = s);
      },
      setOp: function (e, n, i) {
        (s !== e || a !== n || l !== i) && (t.stencilOp(e, n, i), s = e, a = n, l = i);
      },
      setLocked: function (t) {
        e = t;
      },
      setClear: function (e) {
        u !== e && (t.clearStencil(e), u = e);
      },
      reset: function () {
        e = !1, n = null, i = null, r = null, o = null, s = null, a = null, l = null, u = null;
      }
    };
  }
  u(r, "ColorBuffer"), u(o, "DepthBuffer"), u(s, "StencilBuffer");
  let a = new r(),
    l = new o(),
    h = new s(),
    c = new WeakMap(),
    p = new WeakMap(),
    d = {},
    f = {},
    m = new WeakMap(),
    g = [],
    v = null,
    y = !1,
    _ = null,
    x = null,
    E = null,
    b = null,
    w = null,
    S = null,
    M = null,
    T = !1,
    A = null,
    P = null,
    C = null,
    I = null,
    N = null,
    L = t.getParameter(t.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
    R = !1,
    O = 0,
    q = t.getParameter(t.VERSION);
  -1 !== q.indexOf("WebGL") ? (O = parseFloat(/^WebGL (\d)/.exec(q)[1]), R = O >= 1) : -1 !== q.indexOf("OpenGL ES") && (O = parseFloat(/^OpenGL ES (\d)/.exec(q)[1]), R = O >= 2);
  let D = null,
    k = {},
    F = t.getParameter(t.SCISSOR_BOX),
    U = t.getParameter(t.VIEWPORT),
    B = new Er().fromArray(F),
    z = new Er().fromArray(U);
  function V(e, n, r, o) {
    let s = new Uint8Array(4),
      a = t.createTexture();
    t.bindTexture(e, a), t.texParameteri(e, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(e, t.TEXTURE_MAG_FILTER, t.NEAREST);
    for (let a = 0; a < r; a++) !i || e !== t.TEXTURE_3D && e !== t.TEXTURE_2D_ARRAY ? t.texImage2D(n + a, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, s) : t.texImage3D(n, 0, t.RGBA, 1, 1, o, 0, t.RGBA, t.UNSIGNED_BYTE, s);
    return a;
  }
  u(V, "createTexture");
  let j = {};
  function G(e) {
    !0 !== d[e] && (t.enable(e), d[e] = !0);
  }
  function W(e) {
    !1 !== d[e] && (t.disable(e), d[e] = !1);
  }
  function H(e, n) {
    return f[e] !== n && (t.bindFramebuffer(e, n), f[e] = n, i && (e === t.DRAW_FRAMEBUFFER && (f[t.FRAMEBUFFER] = n), e === t.FRAMEBUFFER && (f[t.DRAW_FRAMEBUFFER] = n)), !0);
  }
  function X(i, r) {
    let o = g,
      s = !1;
    if (i) {
      if (o = m.get(r), void 0 === o && (o = [], m.set(r, o)), i.isWebGLMultipleRenderTargets) {
        let e = i.texture;
        if (o.length !== e.length || o[0] !== t.COLOR_ATTACHMENT0) {
          for (let n = 0, i = e.length; n < i; n++) o[n] = t.COLOR_ATTACHMENT0 + n;
          o.length = e.length, s = !0;
        }
      } else o[0] !== t.COLOR_ATTACHMENT0 && (o[0] = t.COLOR_ATTACHMENT0, s = !0);
    } else o[0] !== t.BACK && (o[0] = t.BACK, s = !0);
    s && (n.isWebGL2 ? t.drawBuffers(o) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(o));
  }
  function Y(e) {
    return v !== e && (t.useProgram(e), v = e, !0);
  }
  j[t.TEXTURE_2D] = V(t.TEXTURE_2D, t.TEXTURE_2D, 1), j[t.TEXTURE_CUBE_MAP] = V(t.TEXTURE_CUBE_MAP, t.TEXTURE_CUBE_MAP_POSITIVE_X, 6), i && (j[t.TEXTURE_2D_ARRAY] = V(t.TEXTURE_2D_ARRAY, t.TEXTURE_2D_ARRAY, 1, 1), j[t.TEXTURE_3D] = V(t.TEXTURE_3D, t.TEXTURE_3D, 1, 1)), a.setClear(0, 0, 0, 1), l.setClear(1), h.setClear(0), G(t.DEPTH_TEST), l.setFunc(b3), $(!1), tt(iI), G(t.CULL_FACE), K(jc), u(G, "enable"), u(W, "disable"), u(H, "bindFramebuffer"), u(X, "drawBuffers"), u(Y, "useProgram");
  let Z = {
    [Hp]: t.FUNC_ADD,
    [Gz]: t.FUNC_SUBTRACT,
    [Hz]: t.FUNC_REVERSE_SUBTRACT
  };
  if (i) Z[aI] = t.MIN, Z[lI] = t.MAX;else {
    let t = e.get("EXT_blend_minmax");
    null !== t && (Z[aI] = t.MIN_EXT, Z[lI] = t.MAX_EXT);
  }
  let J = {
    [jz]: t.ZERO,
    [Wz]: t.ONE,
    [Xz]: t.SRC_COLOR,
    [uI]: t.SRC_ALPHA,
    [$z]: t.SRC_ALPHA_SATURATE,
    [Kz]: t.DST_COLOR,
    [Zz]: t.DST_ALPHA,
    [Yz]: t.ONE_MINUS_SRC_COLOR,
    [cI]: t.ONE_MINUS_SRC_ALPHA,
    [Qz]: t.ONE_MINUS_DST_COLOR,
    [Jz]: t.ONE_MINUS_DST_ALPHA
  };
  function K(e, n, i, r, o, s, a, l) {
    if (e !== jc) {
      if (!1 === y && (G(t.BLEND), y = !0), e === x3) o = o || n, s = s || i, a = a || r, (n !== x || o !== w) && (t.blendEquationSeparate(Z[n], Z[o]), x = n, w = o), (i !== E || r !== b || s !== S || a !== M) && (t.blendFuncSeparate(J[i], J[r], J[s], J[a]), E = i, b = r, S = s, M = a), _ = e, T = !1;else if (e !== _ || l !== T) {
        if ((x !== Hp || w !== Hp) && (t.blendEquation(t.FUNC_ADD), x = Hp, w = Hp), l) switch (e) {
          case Gp:
            t.blendFuncSeparate(t.ONE, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA);
            break;
          case oI:
            t.blendFunc(t.ONE, t.ONE);
            break;
          case sI:
            t.blendFuncSeparate(t.ZERO, t.ONE_MINUS_SRC_COLOR, t.ZERO, t.ONE);
            break;
          case Y_:
            t.blendFuncSeparate(t.ZERO, t.SRC_COLOR, t.ZERO, t.SRC_ALPHA);
            break;
          default:
            console.error("THREE.WebGLState: Invalid blending: ", e);
        } else switch (e) {
          case Gp:
            t.blendFuncSeparate(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA);
            break;
          case oI:
            t.blendFunc(t.SRC_ALPHA, t.ONE);
            break;
          case sI:
            t.blendFuncSeparate(t.ZERO, t.ONE_MINUS_SRC_COLOR, t.ZERO, t.ONE);
            break;
          case Y_:
            t.blendFunc(t.ZERO, t.SRC_COLOR);
            break;
          default:
            console.error("THREE.WebGLState: Invalid blending: ", e);
        }
        E = null, b = null, S = null, M = null, _ = e, T = l;
      }
    } else !0 === y && (W(t.BLEND), y = !1);
  }
  function Q(e, n) {
    e.side === Us ? W(t.CULL_FACE) : G(t.CULL_FACE);
    let i = e.side === Ts;
    n && (i = !i), $(i), e.blending === Gp && !1 === e.transparent ? K(jc) : K(e.blending, e.blendEquation, e.blendSrc, e.blendDst, e.blendEquationAlpha, e.blendSrcAlpha, e.blendDstAlpha, e.premultipliedAlpha), l.setFunc(e.depthFunc), l.setTest(e.depthTest), l.setMask(e.depthWrite), a.setMask(e.colorWrite);
    let r = e.stencilWrite;
    h.setTest(r), r && (h.setMask(e.stencilWriteMask), h.setFunc(e.stencilFunc, e.stencilRef, e.stencilFuncMask), h.setOp(e.stencilFail, e.stencilZFail, e.stencilZPass)), nt(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits), !0 === e.alphaToCoverage ? G(t.SAMPLE_ALPHA_TO_COVERAGE) : W(t.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function $(e) {
    A !== e && (e ? t.frontFace(t.CW) : t.frontFace(t.CCW), A = e);
  }
  function tt(e) {
    e !== Uz ? (G(t.CULL_FACE), e !== P && (e === iI ? t.cullFace(t.BACK) : e === zz ? t.cullFace(t.FRONT) : t.cullFace(t.FRONT_AND_BACK))) : W(t.CULL_FACE), P = e;
  }
  function et(e) {
    e !== C && (R && t.lineWidth(e), C = e);
  }
  function nt(e, n, i) {
    e ? (G(t.POLYGON_OFFSET_FILL), (I !== n || N !== i) && (t.polygonOffset(n, i), I = n, N = i)) : W(t.POLYGON_OFFSET_FILL);
  }
  function it(e) {
    e ? G(t.SCISSOR_TEST) : W(t.SCISSOR_TEST);
  }
  function rt(e) {
    void 0 === e && (e = t.TEXTURE0 + L - 1), D !== e && (t.activeTexture(e), D = e);
  }
  function ot(e, n, i) {
    void 0 === i && (i = null === D ? t.TEXTURE0 + L - 1 : D);
    let r = k[i];
    void 0 === r && (r = {
      type: void 0,
      texture: void 0
    }, k[i] = r), (r.type !== e || r.texture !== n) && (D !== i && (t.activeTexture(i), D = i), t.bindTexture(e, n || j[e]), r.type = e, r.texture = n);
  }
  function st() {
    let e = k[D];
    void 0 !== e && void 0 !== e.type && (t.bindTexture(e.type, null), e.type = void 0, e.texture = void 0);
  }
  function at() {
    try {
      t.compressedTexImage2D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function lt() {
    try {
      t.compressedTexImage3D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function ut() {
    try {
      t.texSubImage2D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function ht() {
    try {
      t.texSubImage3D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function ct() {
    try {
      t.compressedTexSubImage2D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function pt() {
    try {
      t.compressedTexSubImage3D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function dt() {
    try {
      t.texStorage2D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function ft() {
    try {
      t.texStorage3D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function mt() {
    try {
      t.texImage2D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function gt() {
    try {
      t.texImage3D.apply(t, arguments);
    } catch (t) {
      console.error("THREE.WebGLState:", t);
    }
  }
  function vt(e) {
    !1 === B.equals(e) && (t.scissor(e.x, e.y, e.z, e.w), B.copy(e));
  }
  function yt(e) {
    !1 === z.equals(e) && (t.viewport(e.x, e.y, e.z, e.w), z.copy(e));
  }
  function _t(e, n) {
    let i = p.get(n);
    void 0 === i && (i = new WeakMap(), p.set(n, i));
    let r = i.get(e);
    void 0 === r && (r = t.getUniformBlockIndex(n, e.name), i.set(e, r));
  }
  function xt(e, n) {
    let i = p.get(n).get(e);
    c.get(n) !== i && (t.uniformBlockBinding(n, i, e.__bindingPointIndex), c.set(n, i));
  }
  function Et() {
    t.disable(t.BLEND), t.disable(t.CULL_FACE), t.disable(t.DEPTH_TEST), t.disable(t.POLYGON_OFFSET_FILL), t.disable(t.SCISSOR_TEST), t.disable(t.STENCIL_TEST), t.disable(t.SAMPLE_ALPHA_TO_COVERAGE), t.blendEquation(t.FUNC_ADD), t.blendFunc(t.ONE, t.ZERO), t.blendFuncSeparate(t.ONE, t.ZERO, t.ONE, t.ZERO), t.colorMask(!0, !0, !0, !0), t.clearColor(0, 0, 0, 0), t.depthMask(!0), t.depthFunc(t.LESS), t.clearDepth(1), t.stencilMask(4294967295), t.stencilFunc(t.ALWAYS, 0, 4294967295), t.stencilOp(t.KEEP, t.KEEP, t.KEEP), t.clearStencil(0), t.cullFace(t.BACK), t.frontFace(t.CCW), t.polygonOffset(0, 0), t.activeTexture(t.TEXTURE0), t.bindFramebuffer(t.FRAMEBUFFER, null), !0 === i && (t.bindFramebuffer(t.DRAW_FRAMEBUFFER, null), t.bindFramebuffer(t.READ_FRAMEBUFFER, null)), t.useProgram(null), t.lineWidth(1), t.scissor(0, 0, t.canvas.width, t.canvas.height), t.viewport(0, 0, t.canvas.width, t.canvas.height), d = {}, D = null, k = {}, f = {}, m = new WeakMap(), g = [], v = null, y = !1, _ = null, x = null, E = null, b = null, w = null, S = null, M = null, T = !1, A = null, P = null, C = null, I = null, N = null, B.set(0, 0, t.canvas.width, t.canvas.height), z.set(0, 0, t.canvas.width, t.canvas.height), a.reset(), l.reset(), h.reset();
  }
  return u(K, "setBlending"), u(Q, "setMaterial"), u($, "setFlipSided"), u(tt, "setCullFace"), u(et, "setLineWidth"), u(nt, "setPolygonOffset"), u(it, "setScissorTest"), u(rt, "activeTexture"), u(ot, "bindTexture"), u(st, "unbindTexture"), u(at, "compressedTexImage2D"), u(lt, "compressedTexImage3D"), u(ut, "texSubImage2D"), u(ht, "texSubImage3D"), u(ct, "compressedTexSubImage2D"), u(pt, "compressedTexSubImage3D"), u(dt, "texStorage2D"), u(ft, "texStorage3D"), u(mt, "texImage2D"), u(gt, "texImage3D"), u(vt, "scissor"), u(yt, "viewport"), u(_t, "updateUBOMapping"), u(xt, "uniformBlockBinding"), u(Et, "reset"), {
    buffers: {
      color: a,
      depth: l,
      stencil: h
    },
    enable: G,
    disable: W,
    bindFramebuffer: H,
    drawBuffers: X,
    useProgram: Y,
    setBlending: K,
    setMaterial: Q,
    setFlipSided: $,
    setCullFace: tt,
    setLineWidth: et,
    setPolygonOffset: nt,
    setScissorTest: it,
    activeTexture: rt,
    bindTexture: ot,
    unbindTexture: st,
    compressedTexImage2D: at,
    compressedTexImage3D: lt,
    texImage2D: mt,
    texImage3D: gt,
    updateUBOMapping: _t,
    uniformBlockBinding: xt,
    texStorage2D: dt,
    texStorage3D: ft,
    texSubImage2D: ut,
    texSubImage3D: ht,
    compressedTexSubImage2D: ct,
    compressedTexSubImage3D: pt,
    scissor: vt,
    viewport: yt,
    reset: Et
  };
}
function vX(t, e, n, i, r, o, s) {
  let a,
    l = r.isWebGL2,
    h = r.maxTextures,
    c = r.maxCubemapSize,
    p = r.maxTextureSize,
    d = r.maxSamples,
    f = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null,
    m = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent),
    g = new WeakMap(),
    v = new WeakMap(),
    y = !1;
  try {
    y = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
  } catch (t) {}
  function _(t, e) {
    return y ? new OffscreenCanvas(t, e) : Ng("canvas");
  }
  function x(t, e, n, i) {
    let r = 1;
    if ((t.width > i || t.height > i) && (r = i / Math.max(t.width, t.height)), r < 1 || !0 === e) {
      if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
        let i = e ? B3 : Math.floor,
          o = i(r * t.width),
          s = i(r * t.height);
        void 0 === a && (a = _(o, s));
        let l = n ? _(o, s) : a;
        return l.width = o, l.height = s, l.getContext("2d").drawImage(t, 0, 0, o, s), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + t.width + "x" + t.height + ") to (" + o + "x" + s + ")."), l;
      }
      return "data" in t && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + t.width + "x" + t.height + ")."), t;
    }
    return t;
  }
  function E(t) {
    return ZI(t.width) && ZI(t.height);
  }
  function b(t) {
    return !l && (t.wrapS !== Wa || t.wrapT !== Wa || t.minFilter !== ni && t.minFilter !== ao);
  }
  function w(t, e) {
    return t.generateMipmaps && e && t.minFilter !== ni && t.minFilter !== ao;
  }
  function S(e) {
    t.generateMipmap(e);
  }
  function M(n, i, r, o, s = !1) {
    if (!1 === l) return i;
    if (null !== n) {
      if (void 0 !== t[n]) return t[n];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
    }
    let a = i;
    return i === t.RED && (r === t.FLOAT && (a = t.R32F), r === t.HALF_FLOAT && (a = t.R16F), r === t.UNSIGNED_BYTE && (a = t.R8)), i === t.RG && (r === t.FLOAT && (a = t.RG32F), r === t.HALF_FLOAT && (a = t.RG16F), r === t.UNSIGNED_BYTE && (a = t.RG8)), i === t.RGBA && (r === t.FLOAT && (a = t.RGBA32F), r === t.HALF_FLOAT && (a = t.RGBA16F), r === t.UNSIGNED_BYTE && (a = o === Nt && !1 === s ? t.SRGB8_ALPHA8 : t.RGBA8), r === t.UNSIGNED_SHORT_4_4_4_4 && (a = t.RGBA4), r === t.UNSIGNED_SHORT_5_5_5_1 && (a = t.RGB5_A1)), (a === t.R16F || a === t.R32F || a === t.RG16F || a === t.RG32F || a === t.RGBA16F || a === t.RGBA32F) && e.get("EXT_color_buffer_float"), a;
  }
  function T(t, e, n) {
    return !0 === w(t, n) || t.isFramebufferTexture && t.minFilter !== ni && t.minFilter !== ao ? Math.log2(Math.max(e.width, e.height)) + 1 : void 0 !== t.mipmaps && t.mipmaps.length > 0 ? t.mipmaps.length : t.isCompressedTexture && Array.isArray(t.image) ? e.mipmaps.length : 1;
  }
  function A(e) {
    return e === ni || e === hI || e === T3 ? t.NEAREST : t.LINEAR;
  }
  function P(t) {
    let e = t.target;
    e.removeEventListener("dispose", P), I(e), e.isVideoTexture && g.delete(e);
  }
  function C(t) {
    let e = t.target;
    e.removeEventListener("dispose", C), L(e);
  }
  function I(t) {
    let e = i.get(t);
    if (void 0 === e.__webglInit) return;
    let n = t.source,
      r = v.get(n);
    if (r) {
      let i = r[e.__cacheKey];
      i.usedTimes--, 0 === i.usedTimes && N(t), 0 === Object.keys(r).length && v.delete(n);
    }
    i.remove(t);
  }
  function N(e) {
    let n = i.get(e);
    t.deleteTexture(n.__webglTexture);
    let r = e.source;
    delete v.get(r)[n.__cacheKey], s.memory.textures--;
  }
  function L(e) {
    let n = e.texture,
      r = i.get(e),
      o = i.get(n);
    if (void 0 !== o.__webglTexture && (t.deleteTexture(o.__webglTexture), s.memory.textures--), e.depthTexture && e.depthTexture.dispose(), e.isWebGLCubeRenderTarget) for (let e = 0; e < 6; e++) t.deleteFramebuffer(r.__webglFramebuffer[e]), r.__webglDepthbuffer && t.deleteRenderbuffer(r.__webglDepthbuffer[e]);else {
      if (t.deleteFramebuffer(r.__webglFramebuffer), r.__webglDepthbuffer && t.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && t.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer) for (let e = 0; e < r.__webglColorRenderbuffer.length; e++) r.__webglColorRenderbuffer[e] && t.deleteRenderbuffer(r.__webglColorRenderbuffer[e]);
      r.__webglDepthRenderbuffer && t.deleteRenderbuffer(r.__webglDepthRenderbuffer);
    }
    if (e.isWebGLMultipleRenderTargets) for (let e = 0, r = n.length; e < r; e++) {
      let r = i.get(n[e]);
      r.__webglTexture && (t.deleteTexture(r.__webglTexture), s.memory.textures--), i.remove(n[e]);
    }
    i.remove(n), i.remove(e);
  }
  u(_, "createCanvas"), u(x, "resizeImage"), u(E, "isPowerOfTwo$1"), u(b, "textureNeedsPowerOfTwo"), u(w, "textureNeedsGenerateMipmaps"), u(S, "generateMipmap"), u(M, "getInternalFormat"), u(T, "getMipLevels"), u(A, "filterFallback"), u(P, "onTextureDispose"), u(C, "onRenderTargetDispose"), u(I, "deallocateTexture"), u(N, "deleteTexture"), u(L, "deallocateRenderTarget");
  let R = 0;
  function O() {
    R = 0;
  }
  function q() {
    let t = R;
    return t >= h && console.warn("THREE.WebGLTextures: Trying to use " + t + " texture units while this GPU supports only " + h), R += 1, t;
  }
  function D(t) {
    let e = [];
    return e.push(t.wrapS), e.push(t.wrapT), e.push(t.wrapR || 0), e.push(t.magFilter), e.push(t.minFilter), e.push(t.anisotropy), e.push(t.internalFormat), e.push(t.format), e.push(t.type), e.push(t.generateMipmaps), e.push(t.premultiplyAlpha), e.push(t.flipY), e.push(t.unpackAlignment), e.push(t.colorSpace), e.join();
  }
  function k(e, r) {
    let o = i.get(e);
    if (e.isVideoTexture && rt(e), !1 === e.isRenderTargetTexture && e.version > 0 && o.__version !== e.version) {
      let t = e.image;
      if (null === t) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");else {
        if (!1 !== t.complete) return void H(o, e, r);
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      }
    }
    n.bindTexture(t.TEXTURE_2D, o.__webglTexture, t.TEXTURE0 + r);
  }
  function F(e, r) {
    let o = i.get(e);
    e.version > 0 && o.__version !== e.version ? H(o, e, r) : n.bindTexture(t.TEXTURE_2D_ARRAY, o.__webglTexture, t.TEXTURE0 + r);
  }
  function U(e, r) {
    let o = i.get(e);
    e.version > 0 && o.__version !== e.version ? H(o, e, r) : n.bindTexture(t.TEXTURE_3D, o.__webglTexture, t.TEXTURE0 + r);
  }
  function B(e, r) {
    let o = i.get(e);
    e.version > 0 && o.__version !== e.version ? X(o, e, r) : n.bindTexture(t.TEXTURE_CUBE_MAP, o.__webglTexture, t.TEXTURE0 + r);
  }
  u(O, "resetTextureUnits"), u(q, "allocateTextureUnit"), u(D, "getTextureCacheKey"), u(k, "setTexture2D"), u(F, "setTexture2DArray"), u(U, "setTexture3D"), u(B, "setTextureCube");
  let z = {
      [Br]: t.REPEAT,
      [Wa]: t.CLAMP_TO_EDGE,
      [S3]: t.MIRRORED_REPEAT
    },
    V = {
      [ni]: t.NEAREST,
      [hI]: t.NEAREST_MIPMAP_NEAREST,
      [T3]: t.NEAREST_MIPMAP_LINEAR,
      [ao]: t.LINEAR,
      [dV]: t.LINEAR_MIPMAP_NEAREST,
      [Og]: t.LINEAR_MIPMAP_LINEAR
    },
    j = {
      [TV]: t.NEVER,
      [RV]: t.ALWAYS,
      [PV]: t.LESS,
      [AV]: t.LEQUAL,
      [CV]: t.EQUAL,
      [OV]: t.GEQUAL,
      [IV]: t.GREATER,
      [LV]: t.NOTEQUAL
    };
  function G(n, o, s) {
    if (s ? (t.texParameteri(n, t.TEXTURE_WRAP_S, z[o.wrapS]), t.texParameteri(n, t.TEXTURE_WRAP_T, z[o.wrapT]), (n === t.TEXTURE_3D || n === t.TEXTURE_2D_ARRAY) && t.texParameteri(n, t.TEXTURE_WRAP_R, z[o.wrapR]), t.texParameteri(n, t.TEXTURE_MAG_FILTER, V[o.magFilter]), t.texParameteri(n, t.TEXTURE_MIN_FILTER, V[o.minFilter])) : (t.texParameteri(n, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(n, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), (n === t.TEXTURE_3D || n === t.TEXTURE_2D_ARRAY) && t.texParameteri(n, t.TEXTURE_WRAP_R, t.CLAMP_TO_EDGE), (o.wrapS !== Wa || o.wrapT !== Wa) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t.texParameteri(n, t.TEXTURE_MAG_FILTER, A(o.magFilter)), t.texParameteri(n, t.TEXTURE_MIN_FILTER, A(o.minFilter)), o.minFilter !== ni && o.minFilter !== ao && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), o.compareFunction && (t.texParameteri(n, t.TEXTURE_COMPARE_MODE, t.COMPARE_REF_TO_TEXTURE), t.texParameteri(n, t.TEXTURE_COMPARE_FUNC, j[o.compareFunction])), !0 === e.has("EXT_texture_filter_anisotropic")) {
      let s = e.get("EXT_texture_filter_anisotropic");
      if (o.magFilter === ni || o.minFilter !== T3 && o.minFilter !== Og || o.type === Tl && !1 === e.has("OES_texture_float_linear") || !1 === l && o.type === Iu && !1 === e.has("OES_texture_half_float_linear")) return;
      (o.anisotropy > 1 || i.get(o).__currentAnisotropy) && (t.texParameterf(n, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(o.anisotropy, r.getMaxAnisotropy())), i.get(o).__currentAnisotropy = o.anisotropy);
    }
  }
  function W(e, n) {
    let i = !1;
    void 0 === e.__webglInit && (e.__webglInit = !0, n.addEventListener("dispose", P));
    let r = n.source,
      o = v.get(r);
    void 0 === o && (o = {}, v.set(r, o));
    let a = D(n);
    if (a !== e.__cacheKey) {
      void 0 === o[a] && (o[a] = {
        texture: t.createTexture(),
        usedTimes: 0
      }, s.memory.textures++, i = !0), o[a].usedTimes++;
      let r = o[e.__cacheKey];
      void 0 !== r && (o[e.__cacheKey].usedTimes--, 0 === r.usedTimes && N(n)), e.__cacheKey = a, e.__webglTexture = o[a].texture;
    }
    return i;
  }
  function H(e, r, s) {
    let a = t.TEXTURE_2D;
    (r.isDataArrayTexture || r.isCompressedArrayTexture) && (a = t.TEXTURE_2D_ARRAY), r.isData3DTexture && (a = t.TEXTURE_3D);
    let u = W(e, r),
      h = r.source;
    n.bindTexture(a, e.__webglTexture, t.TEXTURE0 + s);
    let c = i.get(h);
    if (h.version !== c.__version || !0 === u) {
      n.activeTexture(t.TEXTURE0 + s), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, r.flipY), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), t.pixelStorei(t.UNPACK_ALIGNMENT, r.unpackAlignment), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, t.NONE);
      let e = b(r) && !1 === E(r.image),
        i = x(r.image, e, !1, p);
      i = ot(r, i);
      let d = E(i) || l,
        f = o.convert(r.format, r.colorSpace),
        m = o.convert(r.type),
        g = M(r.internalFormat, f, m, r.colorSpace);
      G(a, r, d);
      let v,
        y = r.mipmaps,
        _ = l && !0 !== r.isVideoTexture,
        A = void 0 === c.__version || !0 === u,
        P = T(r, i, d);
      if (r.isDepthTexture) g = t.DEPTH_COMPONENT, l ? g = r.type === Tl ? t.DEPTH_COMPONENT32F : r.type === Ps ? t.DEPTH_COMPONENT24 : r.type === sf ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT16 : r.type === Tl && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), r.format === Lu && g === t.DEPTH_COMPONENT && r.type !== P3 && r.type !== Ps && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), r.type = Ps, m = o.convert(r.type)), r.format === Xp && g === t.DEPTH_COMPONENT && (g = t.DEPTH_STENCIL, r.type !== sf && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), r.type = sf, m = o.convert(r.type))), A && (_ ? n.texStorage2D(t.TEXTURE_2D, 1, g, i.width, i.height) : n.texImage2D(t.TEXTURE_2D, 0, g, i.width, i.height, 0, f, m, null));else if (r.isDataTexture) {
        if (y.length > 0 && d) {
          _ && A && n.texStorage2D(t.TEXTURE_2D, P, g, y[0].width, y[0].height);
          for (let e = 0, i = y.length; e < i; e++) v = y[e], _ ? n.texSubImage2D(t.TEXTURE_2D, e, 0, 0, v.width, v.height, f, m, v.data) : n.texImage2D(t.TEXTURE_2D, e, g, v.width, v.height, 0, f, m, v.data);
          r.generateMipmaps = !1;
        } else _ ? (A && n.texStorage2D(t.TEXTURE_2D, P, g, i.width, i.height), n.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, i.width, i.height, f, m, i.data)) : n.texImage2D(t.TEXTURE_2D, 0, g, i.width, i.height, 0, f, m, i.data);
      } else if (r.isCompressedTexture) {
        if (r.isCompressedArrayTexture) {
          _ && A && n.texStorage3D(t.TEXTURE_2D_ARRAY, P, g, y[0].width, y[0].height, i.depth);
          for (let e = 0, o = y.length; e < o; e++) v = y[e], r.format !== Po ? null !== f ? _ ? n.compressedTexSubImage3D(t.TEXTURE_2D_ARRAY, e, 0, 0, 0, v.width, v.height, i.depth, f, v.data, 0, 0) : n.compressedTexImage3D(t.TEXTURE_2D_ARRAY, e, g, v.width, v.height, i.depth, 0, v.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : _ ? n.texSubImage3D(t.TEXTURE_2D_ARRAY, e, 0, 0, 0, v.width, v.height, i.depth, f, m, v.data) : n.texImage3D(t.TEXTURE_2D_ARRAY, e, g, v.width, v.height, i.depth, 0, f, m, v.data);
        } else {
          _ && A && n.texStorage2D(t.TEXTURE_2D, P, g, y[0].width, y[0].height);
          for (let e = 0, i = y.length; e < i; e++) v = y[e], r.format !== Po ? null !== f ? _ ? n.compressedTexSubImage2D(t.TEXTURE_2D, e, 0, 0, v.width, v.height, f, v.data) : n.compressedTexImage2D(t.TEXTURE_2D, e, g, v.width, v.height, 0, v.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : _ ? n.texSubImage2D(t.TEXTURE_2D, e, 0, 0, v.width, v.height, f, m, v.data) : n.texImage2D(t.TEXTURE_2D, e, g, v.width, v.height, 0, f, m, v.data);
        }
      } else if (r.isDataArrayTexture) _ ? (A && n.texStorage3D(t.TEXTURE_2D_ARRAY, P, g, i.width, i.height, i.depth), n.texSubImage3D(t.TEXTURE_2D_ARRAY, 0, 0, 0, 0, i.width, i.height, i.depth, f, m, i.data)) : n.texImage3D(t.TEXTURE_2D_ARRAY, 0, g, i.width, i.height, i.depth, 0, f, m, i.data);else if (r.isData3DTexture) _ ? (A && n.texStorage3D(t.TEXTURE_3D, P, g, i.width, i.height, i.depth), n.texSubImage3D(t.TEXTURE_3D, 0, 0, 0, 0, i.width, i.height, i.depth, f, m, i.data)) : n.texImage3D(t.TEXTURE_3D, 0, g, i.width, i.height, i.depth, 0, f, m, i.data);else if (r.isFramebufferTexture) {
        if (A) if (_) n.texStorage2D(t.TEXTURE_2D, P, g, i.width, i.height);else {
          let e = i.width,
            r = i.height;
          for (let i = 0; i < P; i++) n.texImage2D(t.TEXTURE_2D, i, g, e, r, 0, f, m, null), e >>= 1, r >>= 1;
        }
      } else if (y.length > 0 && d) {
        _ && A && n.texStorage2D(t.TEXTURE_2D, P, g, y[0].width, y[0].height);
        for (let e = 0, i = y.length; e < i; e++) v = y[e], _ ? n.texSubImage2D(t.TEXTURE_2D, e, 0, 0, f, m, v) : n.texImage2D(t.TEXTURE_2D, e, g, f, m, v);
        r.generateMipmaps = !1;
      } else _ ? (A && n.texStorage2D(t.TEXTURE_2D, P, g, i.width, i.height), n.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, f, m, i)) : n.texImage2D(t.TEXTURE_2D, 0, g, f, m, i);
      w(r, d) && S(a), c.__version = h.version, r.onUpdate && r.onUpdate(r);
    }
    e.__version = r.version;
  }
  function X(e, r, s) {
    if (6 !== r.image.length) return;
    let a = W(e, r),
      u = r.source;
    n.bindTexture(t.TEXTURE_CUBE_MAP, e.__webglTexture, t.TEXTURE0 + s);
    let h = i.get(u);
    if (u.version !== h.__version || !0 === a) {
      n.activeTexture(t.TEXTURE0 + s), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, r.flipY), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), t.pixelStorei(t.UNPACK_ALIGNMENT, r.unpackAlignment), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, t.NONE);
      let e = r.isCompressedTexture || r.image[0].isCompressedTexture,
        i = r.image[0] && r.image[0].isDataTexture,
        p = [];
      for (let t = 0; t < 6; t++) p[t] = e || i ? i ? r.image[t].image : r.image[t] : x(r.image[t], !1, !0, c), p[t] = ot(r, p[t]);
      let d,
        f = p[0],
        m = E(f) || l,
        g = o.convert(r.format, r.colorSpace),
        v = o.convert(r.type),
        y = M(r.internalFormat, g, v, r.colorSpace),
        _ = l && !0 !== r.isVideoTexture,
        b = void 0 === h.__version || !0 === a,
        A = T(r, f, m);
      if (G(t.TEXTURE_CUBE_MAP, r, m), e) {
        _ && b && n.texStorage2D(t.TEXTURE_CUBE_MAP, A, y, f.width, f.height);
        for (let e = 0; e < 6; e++) {
          d = p[e].mipmaps;
          for (let i = 0; i < d.length; i++) {
            let o = d[i];
            r.format !== Po ? null !== g ? _ ? n.compressedTexSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i, 0, 0, o.width, o.height, g, o.data) : n.compressedTexImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i, y, o.width, o.height, 0, o.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : _ ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i, 0, 0, o.width, o.height, g, v, o.data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i, y, o.width, o.height, 0, g, v, o.data);
          }
        }
      } else {
        d = r.mipmaps, _ && b && (d.length > 0 && A++, n.texStorage2D(t.TEXTURE_CUBE_MAP, A, y, p[0].width, p[0].height));
        for (let e = 0; e < 6; e++) if (i) {
          _ ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, p[e].width, p[e].height, g, v, p[e].data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, y, p[e].width, p[e].height, 0, g, v, p[e].data);
          for (let i = 0; i < d.length; i++) {
            let r = d[i].image[e].image;
            _ ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i + 1, 0, 0, r.width, r.height, g, v, r.data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i + 1, y, r.width, r.height, 0, g, v, r.data);
          }
        } else {
          _ ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, g, v, p[e]) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, y, g, v, p[e]);
          for (let i = 0; i < d.length; i++) {
            let r = d[i];
            _ ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i + 1, 0, 0, g, v, r.image[e]) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i + 1, y, g, v, r.image[e]);
          }
        }
      }
      w(r, m) && S(t.TEXTURE_CUBE_MAP), h.__version = u.version, r.onUpdate && r.onUpdate(r);
    }
    e.__version = r.version;
  }
  function Y(e, r, s, a, l) {
    let u = o.convert(s.format, s.colorSpace),
      h = o.convert(s.type),
      c = M(s.internalFormat, u, h, s.colorSpace);
    i.get(r).__hasExternalTextures || (l === t.TEXTURE_3D || l === t.TEXTURE_2D_ARRAY ? n.texImage3D(l, 0, c, r.width, r.height, r.depth, 0, u, h, null) : n.texImage2D(l, 0, c, r.width, r.height, 0, u, h, null)), n.bindFramebuffer(t.FRAMEBUFFER, e), it(r) ? f.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, a, l, i.get(s).__webglTexture, 0, nt(r)) : (l === t.TEXTURE_2D || l >= t.TEXTURE_CUBE_MAP_POSITIVE_X && l <= t.TEXTURE_CUBE_MAP_NEGATIVE_Z) && t.framebufferTexture2D(t.FRAMEBUFFER, a, l, i.get(s).__webglTexture, 0), n.bindFramebuffer(t.FRAMEBUFFER, null);
  }
  function Z(e, n, i) {
    if (t.bindRenderbuffer(t.RENDERBUFFER, e), n.depthBuffer && !n.stencilBuffer) {
      let r = t.DEPTH_COMPONENT16;
      if (i || it(n)) {
        let e = n.depthTexture;
        e && e.isDepthTexture && (e.type === Tl ? r = t.DEPTH_COMPONENT32F : e.type === Ps && (r = t.DEPTH_COMPONENT24));
        let i = nt(n);
        it(n) ? f.renderbufferStorageMultisampleEXT(t.RENDERBUFFER, i, r, n.width, n.height) : t.renderbufferStorageMultisample(t.RENDERBUFFER, i, r, n.width, n.height);
      } else t.renderbufferStorage(t.RENDERBUFFER, r, n.width, n.height);
      t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e);
    } else if (n.depthBuffer && n.stencilBuffer) {
      let r = nt(n);
      i && !1 === it(n) ? t.renderbufferStorageMultisample(t.RENDERBUFFER, r, t.DEPTH24_STENCIL8, n.width, n.height) : it(n) ? f.renderbufferStorageMultisampleEXT(t.RENDERBUFFER, r, t.DEPTH24_STENCIL8, n.width, n.height) : t.renderbufferStorage(t.RENDERBUFFER, t.DEPTH_STENCIL, n.width, n.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e);
    } else {
      let e = !0 === n.isWebGLMultipleRenderTargets ? n.texture : [n.texture];
      for (let r = 0; r < e.length; r++) {
        let s = e[r],
          a = o.convert(s.format, s.colorSpace),
          l = o.convert(s.type),
          u = M(s.internalFormat, a, l, s.colorSpace),
          h = nt(n);
        i && !1 === it(n) ? t.renderbufferStorageMultisample(t.RENDERBUFFER, h, u, n.width, n.height) : it(n) ? f.renderbufferStorageMultisampleEXT(t.RENDERBUFFER, h, u, n.width, n.height) : t.renderbufferStorage(t.RENDERBUFFER, u, n.width, n.height);
      }
    }
    t.bindRenderbuffer(t.RENDERBUFFER, null);
  }
  function J(e, r) {
    if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
    if (n.bindFramebuffer(t.FRAMEBUFFER, e), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    (!i.get(r.depthTexture).__webglTexture || r.depthTexture.image.width !== r.width || r.depthTexture.image.height !== r.height) && (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), k(r.depthTexture, 0);
    let o = i.get(r.depthTexture).__webglTexture,
      s = nt(r);
    if (r.depthTexture.format === Lu) it(r) ? f.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.TEXTURE_2D, o, 0, s) : t.framebufferTexture2D(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.TEXTURE_2D, o, 0);else {
      if (r.depthTexture.format !== Xp) throw new Error("Unknown depthTexture format");
      it(r) ? f.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.TEXTURE_2D, o, 0, s) : t.framebufferTexture2D(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.TEXTURE_2D, o, 0);
    }
  }
  function K(e) {
    let r = i.get(e),
      o = !0 === e.isWebGLCubeRenderTarget;
    if (e.depthTexture && !r.__autoAllocateDepthBuffer) {
      if (o) throw new Error("target.depthTexture not supported in Cube render targets");
      J(r.__webglFramebuffer, e);
    } else if (o) {
      r.__webglDepthbuffer = [];
      for (let i = 0; i < 6; i++) n.bindFramebuffer(t.FRAMEBUFFER, r.__webglFramebuffer[i]), r.__webglDepthbuffer[i] = t.createRenderbuffer(), Z(r.__webglDepthbuffer[i], e, !1);
    } else n.bindFramebuffer(t.FRAMEBUFFER, r.__webglFramebuffer), r.__webglDepthbuffer = t.createRenderbuffer(), Z(r.__webglDepthbuffer, e, !1);
    n.bindFramebuffer(t.FRAMEBUFFER, null);
  }
  function Q(e, n, r) {
    let o = i.get(e);
    void 0 !== n && Y(o.__webglFramebuffer, e, e.texture, t.COLOR_ATTACHMENT0, t.TEXTURE_2D), void 0 !== r && K(e);
  }
  function $(e) {
    let a = e.texture,
      u = i.get(e),
      h = i.get(a);
    e.addEventListener("dispose", C), !0 !== e.isWebGLMultipleRenderTargets && (void 0 === h.__webglTexture && (h.__webglTexture = t.createTexture()), h.__version = a.version, s.memory.textures++);
    let c = !0 === e.isWebGLCubeRenderTarget,
      p = !0 === e.isWebGLMultipleRenderTargets,
      d = E(e) || l;
    if (c) {
      u.__webglFramebuffer = [];
      for (let e = 0; e < 6; e++) u.__webglFramebuffer[e] = t.createFramebuffer();
    } else {
      if (u.__webglFramebuffer = t.createFramebuffer(), p) if (r.drawBuffers) {
        let n = e.texture;
        for (let e = 0, r = n.length; e < r; e++) {
          let r = i.get(n[e]);
          void 0 === r.__webglTexture && (r.__webglTexture = t.createTexture(), s.memory.textures++);
        }
      } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
      if (l && e.samples > 0 && !1 === it(e)) {
        let i = p ? a : [a];
        u.__webglMultisampledFramebuffer = t.createFramebuffer(), u.__webglColorRenderbuffer = [], n.bindFramebuffer(t.FRAMEBUFFER, u.__webglMultisampledFramebuffer);
        for (let n = 0; n < i.length; n++) {
          let r = i[n];
          u.__webglColorRenderbuffer[n] = t.createRenderbuffer(), t.bindRenderbuffer(t.RENDERBUFFER, u.__webglColorRenderbuffer[n]);
          let s = o.convert(r.format, r.colorSpace),
            a = o.convert(r.type),
            l = M(r.internalFormat, s, a, r.colorSpace, !0 === e.isXRRenderTarget),
            h = nt(e);
          t.renderbufferStorageMultisample(t.RENDERBUFFER, h, l, e.width, e.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + n, t.RENDERBUFFER, u.__webglColorRenderbuffer[n]);
        }
        t.bindRenderbuffer(t.RENDERBUFFER, null), e.depthBuffer && (u.__webglDepthRenderbuffer = t.createRenderbuffer(), Z(u.__webglDepthRenderbuffer, e, !0)), n.bindFramebuffer(t.FRAMEBUFFER, null);
      }
    }
    if (c) {
      n.bindTexture(t.TEXTURE_CUBE_MAP, h.__webglTexture), G(t.TEXTURE_CUBE_MAP, a, d);
      for (let n = 0; n < 6; n++) Y(u.__webglFramebuffer[n], e, a, t.COLOR_ATTACHMENT0, t.TEXTURE_CUBE_MAP_POSITIVE_X + n);
      w(a, d) && S(t.TEXTURE_CUBE_MAP), n.unbindTexture();
    } else if (p) {
      let r = e.texture;
      for (let o = 0, s = r.length; o < s; o++) {
        let s = r[o],
          a = i.get(s);
        n.bindTexture(t.TEXTURE_2D, a.__webglTexture), G(t.TEXTURE_2D, s, d), Y(u.__webglFramebuffer, e, s, t.COLOR_ATTACHMENT0 + o, t.TEXTURE_2D), w(s, d) && S(t.TEXTURE_2D);
      }
      n.unbindTexture();
    } else {
      let i = t.TEXTURE_2D;
      (e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (l ? i = e.isWebGL3DRenderTarget ? t.TEXTURE_3D : t.TEXTURE_2D_ARRAY : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), n.bindTexture(i, h.__webglTexture), G(i, a, d), Y(u.__webglFramebuffer, e, a, t.COLOR_ATTACHMENT0, i), w(a, d) && S(i), n.unbindTexture();
    }
    e.depthBuffer && K(e);
  }
  function tt(e) {
    let r = E(e) || l,
      o = !0 === e.isWebGLMultipleRenderTargets ? e.texture : [e.texture];
    for (let s = 0, a = o.length; s < a; s++) {
      let a = o[s];
      if (w(a, r)) {
        let r = e.isWebGLCubeRenderTarget ? t.TEXTURE_CUBE_MAP : t.TEXTURE_2D,
          o = i.get(a).__webglTexture;
        n.bindTexture(r, o), S(r), n.unbindTexture();
      }
    }
  }
  function et(e) {
    if (l && e.samples > 0 && !1 === it(e)) {
      let r = e.isWebGLMultipleRenderTargets ? e.texture : [e.texture],
        o = e.width,
        s = e.height,
        a = t.COLOR_BUFFER_BIT,
        l = [],
        u = e.stencilBuffer ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT,
        h = i.get(e),
        c = !0 === e.isWebGLMultipleRenderTargets;
      if (c) for (let e = 0; e < r.length; e++) n.bindFramebuffer(t.FRAMEBUFFER, h.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + e, t.RENDERBUFFER, null), n.bindFramebuffer(t.FRAMEBUFFER, h.__webglFramebuffer), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + e, t.TEXTURE_2D, null, 0);
      n.bindFramebuffer(t.READ_FRAMEBUFFER, h.__webglMultisampledFramebuffer), n.bindFramebuffer(t.DRAW_FRAMEBUFFER, h.__webglFramebuffer);
      for (let n = 0; n < r.length; n++) {
        l.push(t.COLOR_ATTACHMENT0 + n), e.depthBuffer && l.push(u);
        let p = void 0 !== h.__ignoreDepthValues && h.__ignoreDepthValues;
        if (!1 === p && (e.depthBuffer && (a |= t.DEPTH_BUFFER_BIT), e.stencilBuffer && (a |= t.STENCIL_BUFFER_BIT)), c && t.framebufferRenderbuffer(t.READ_FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.RENDERBUFFER, h.__webglColorRenderbuffer[n]), !0 === p && (t.invalidateFramebuffer(t.READ_FRAMEBUFFER, [u]), t.invalidateFramebuffer(t.DRAW_FRAMEBUFFER, [u])), c) {
          let e = i.get(r[n]).__webglTexture;
          t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e, 0);
        }
        t.blitFramebuffer(0, 0, o, s, 0, 0, o, s, a, t.NEAREST), m && t.invalidateFramebuffer(t.READ_FRAMEBUFFER, l);
      }
      if (n.bindFramebuffer(t.READ_FRAMEBUFFER, null), n.bindFramebuffer(t.DRAW_FRAMEBUFFER, null), c) for (let e = 0; e < r.length; e++) {
        n.bindFramebuffer(t.FRAMEBUFFER, h.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + e, t.RENDERBUFFER, h.__webglColorRenderbuffer[e]);
        let o = i.get(r[e]).__webglTexture;
        n.bindFramebuffer(t.FRAMEBUFFER, h.__webglFramebuffer), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + e, t.TEXTURE_2D, o, 0);
      }
      n.bindFramebuffer(t.DRAW_FRAMEBUFFER, h.__webglMultisampledFramebuffer);
    }
  }
  function nt(t) {
    return Math.min(d, t.samples);
  }
  function it(t) {
    let n = i.get(t);
    return l && t.samples > 0 && !0 === e.has("WEBGL_multisampled_render_to_texture") && !1 !== n.__useRenderToTexture;
  }
  function rt(t) {
    let e = s.render.frame;
    g.get(t) !== e && (g.set(t, e), t.update());
  }
  function ot(t, n) {
    let i = t.colorSpace,
      r = t.format,
      o = t.type;
    return !0 === t.isCompressedTexture || t.format === D3 || i !== Cl && i !== Ou && (i === Nt ? !1 === l ? !0 === e.has("EXT_sRGB") && r === Po ? (t.format = D3, t.minFilter = ao, t.generateMipmaps = !1) : n = tx.sRGBToLinear(n) : (r !== Po || o !== Wc) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", i)), n;
  }
  u(G, "setTextureParameters"), u(W, "initTexture"), u(H, "uploadTexture"), u(X, "uploadCubeTexture"), u(Y, "setupFrameBufferTexture"), u(Z, "setupRenderBufferStorage"), u(J, "setupDepthTexture"), u(K, "setupDepthRenderbuffer"), u(Q, "rebindTextures"), u($, "setupRenderTarget"), u(tt, "updateRenderTargetMipmap"), u(et, "updateMultisampleRenderTarget"), u(nt, "getRenderTargetSamples"), u(it, "useMultisampledRTT"), u(rt, "updateVideoTexture"), u(ot, "verifyColorSpace"), this.allocateTextureUnit = q, this.resetTextureUnits = O, this.setTexture2D = k, this.setTexture2DArray = F, this.setTexture3D = U, this.setTextureCube = B, this.rebindTextures = Q, this.setupRenderTarget = $, this.updateRenderTargetMipmap = tt, this.updateMultisampleRenderTarget = et, this.setupDepthRenderbuffer = K, this.setupFrameBufferTexture = Y, this.useMultisampledRTT = it;
}
function yX(t, e, n) {
  let i = n.isWebGL2;
  function r(n, r = Ou) {
    let o;
    if (n === Wc) return t.UNSIGNED_BYTE;
    if (n === pI) return t.UNSIGNED_SHORT_4_4_4_4;
    if (n === dI) return t.UNSIGNED_SHORT_5_5_5_1;
    if (n === mV) return t.BYTE;
    if (n === gV) return t.SHORT;
    if (n === P3) return t.UNSIGNED_SHORT;
    if (n === fI) return t.INT;
    if (n === Ps) return t.UNSIGNED_INT;
    if (n === Tl) return t.FLOAT;
    if (n === Iu) return i ? t.HALF_FLOAT : (o = e.get("OES_texture_half_float"), null !== o ? o.HALF_FLOAT_OES : null);
    if (n === vV) return t.ALPHA;
    if (n === Po) return t.RGBA;
    if (n === yV) return t.LUMINANCE;
    if (n === _V) return t.LUMINANCE_ALPHA;
    if (n === Lu) return t.DEPTH_COMPONENT;
    if (n === Xp) return t.DEPTH_STENCIL;
    if (n === D3) return o = e.get("EXT_sRGB"), null !== o ? o.SRGB_ALPHA_EXT : null;
    if (n === C3) return t.RED;
    if (n === mI) return t.RED_INTEGER;
    if (n === xV) return t.RG;
    if (n === gI) return t.RG_INTEGER;
    if (n === vI) return t.RGBA_INTEGER;
    if (n === A3 || n === I3 || n === L3 || n === O3) if (r === Nt) {
      if (o = e.get("WEBGL_compressed_texture_s3tc_srgb"), null === o) return null;
      if (n === A3) return o.COMPRESSED_SRGB_S3TC_DXT1_EXT;
      if (n === I3) return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
      if (n === L3) return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
      if (n === O3) return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
    } else {
      if (o = e.get("WEBGL_compressed_texture_s3tc"), null === o) return null;
      if (n === A3) return o.COMPRESSED_RGB_S3TC_DXT1_EXT;
      if (n === I3) return o.COMPRESSED_RGBA_S3TC_DXT1_EXT;
      if (n === L3) return o.COMPRESSED_RGBA_S3TC_DXT3_EXT;
      if (n === O3) return o.COMPRESSED_RGBA_S3TC_DXT5_EXT;
    }
    if (n === yI || n === _I || n === xI || n === bI) {
      if (o = e.get("WEBGL_compressed_texture_pvrtc"), null === o) return null;
      if (n === yI) return o.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
      if (n === _I) return o.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
      if (n === xI) return o.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
      if (n === bI) return o.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
    }
    if (n === bV) return o = e.get("WEBGL_compressed_texture_etc1"), null !== o ? o.COMPRESSED_RGB_ETC1_WEBGL : null;
    if (n === MI || n === EI) {
      if (o = e.get("WEBGL_compressed_texture_etc"), null === o) return null;
      if (n === MI) return r === Nt ? o.COMPRESSED_SRGB8_ETC2 : o.COMPRESSED_RGB8_ETC2;
      if (n === EI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : o.COMPRESSED_RGBA8_ETC2_EAC;
    }
    if (n === wI || n === SI || n === TI || n === PI || n === CI || n === AI || n === II || n === LI || n === OI || n === RI || n === NI || n === DI || n === qI || n === kI) {
      if (o = e.get("WEBGL_compressed_texture_astc"), null === o) return null;
      if (n === wI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : o.COMPRESSED_RGBA_ASTC_4x4_KHR;
      if (n === SI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : o.COMPRESSED_RGBA_ASTC_5x4_KHR;
      if (n === TI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : o.COMPRESSED_RGBA_ASTC_5x5_KHR;
      if (n === PI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : o.COMPRESSED_RGBA_ASTC_6x5_KHR;
      if (n === CI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : o.COMPRESSED_RGBA_ASTC_6x6_KHR;
      if (n === AI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : o.COMPRESSED_RGBA_ASTC_8x5_KHR;
      if (n === II) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : o.COMPRESSED_RGBA_ASTC_8x6_KHR;
      if (n === LI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : o.COMPRESSED_RGBA_ASTC_8x8_KHR;
      if (n === OI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : o.COMPRESSED_RGBA_ASTC_10x5_KHR;
      if (n === RI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : o.COMPRESSED_RGBA_ASTC_10x6_KHR;
      if (n === NI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : o.COMPRESSED_RGBA_ASTC_10x8_KHR;
      if (n === DI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : o.COMPRESSED_RGBA_ASTC_10x10_KHR;
      if (n === qI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : o.COMPRESSED_RGBA_ASTC_12x10_KHR;
      if (n === kI) return r === Nt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : o.COMPRESSED_RGBA_ASTC_12x12_KHR;
    }
    if (n === R3) {
      if (o = e.get("EXT_texture_compression_bptc"), null === o) return null;
      if (n === R3) return r === Nt ? o.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : o.COMPRESSED_RGBA_BPTC_UNORM_EXT;
    }
    if (n === MV || n === FI || n === BI || n === UI) {
      if (o = e.get("EXT_texture_compression_rgtc"), null === o) return null;
      if (n === R3) return o.COMPRESSED_RED_RGTC1_EXT;
      if (n === FI) return o.COMPRESSED_SIGNED_RED_RGTC1_EXT;
      if (n === BI) return o.COMPRESSED_RED_GREEN_RGTC2_EXT;
      if (n === UI) return o.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
    }
    return n === sf ? i ? t.UNSIGNED_INT_24_8 : (o = e.get("WEBGL_depth_texture"), null !== o ? o.UNSIGNED_INT_24_8_WEBGL : null) : void 0 !== t[n] ? t[n] : null;
  }
  return u(r, "convert"), {
    convert: r
  };
}
u(mX, "WebGLShadowMap"), u(gX, "WebGLState"), u(vX, "WebGLTextures"), u(yX, "WebGLUtils");
var _S = class extends as {
  constructor(t = []) {
    super(), this.isArrayCamera = !0, this.cameras = t;
  }
};
u(_S, "ArrayCamera");
var ha = class extends jn {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
};
u(ha, "Group");
var _X = {
    type: "move"
  },
  Gg = class {
    constructor() {
      this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
      return null === this._hand && (this._hand = new ha(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
        pinching: !1
      }), this._hand;
    }
    getTargetRaySpace() {
      return null === this._targetRay && (this._targetRay = new ha(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new ne(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new ne()), this._targetRay;
    }
    getGripSpace() {
      return null === this._grip && (this._grip = new ha(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new ne(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new ne()), this._grip;
    }
    dispatchEvent(t) {
      return null !== this._targetRay && this._targetRay.dispatchEvent(t), null !== this._grip && this._grip.dispatchEvent(t), null !== this._hand && this._hand.dispatchEvent(t), this;
    }
    connect(t) {
      if (t && t.hand) {
        let e = this._hand;
        if (e) for (let n of t.hand.values()) this._getHandJoint(e, n);
      }
      return this.dispatchEvent({
        type: "connected",
        data: t
      }), this;
    }
    disconnect(t) {
      return this.dispatchEvent({
        type: "disconnected",
        data: t
      }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
    }
    update(t, e, n) {
      let i = null,
        r = null,
        o = null,
        s = this._targetRay,
        a = this._grip,
        l = this._hand;
      if (t && "visible-blurred" !== e.session.visibilityState) {
        if (l && t.hand) {
          o = !0;
          for (let i of t.hand.values()) {
            let t = e.getJointPose(i, n),
              r = this._getHandJoint(l, i);
            null !== t && (r.matrix.fromArray(t.transform.matrix), r.matrix.decompose(r.position, r.rotation, r.scale), r.matrixWorldNeedsUpdate = !0, r.jointRadius = t.radius), r.visible = null !== t;
          }
          let i = l.joints["index-finger-tip"],
            r = l.joints["thumb-tip"],
            s = i.position.distanceTo(r.position),
            a = .02,
            u = .005;
          l.inputState.pinching && s > a + u ? (l.inputState.pinching = !1, this.dispatchEvent({
            type: "pinchend",
            handedness: t.handedness,
            target: this
          })) : !l.inputState.pinching && s <= a - u && (l.inputState.pinching = !0, this.dispatchEvent({
            type: "pinchstart",
            handedness: t.handedness,
            target: this
          }));
        } else null !== a && t.gripSpace && (r = e.getPose(t.gripSpace, n), null !== r && (a.matrix.fromArray(r.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), a.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(r.linearVelocity)) : a.hasLinearVelocity = !1, r.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(r.angularVelocity)) : a.hasAngularVelocity = !1));
        null !== s && (i = e.getPose(t.targetRaySpace, n), null === i && null !== r && (i = r), null !== i && (s.matrix.fromArray(i.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(i.linearVelocity)) : s.hasLinearVelocity = !1, i.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(i.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent(_X)));
      }
      return null !== s && (s.visible = null !== i), null !== a && (a.visible = null !== r), null !== l && (l.visible = null !== o), this;
    }
    _getHandJoint(t, e) {
      if (void 0 === t.joints[e.jointName]) {
        let n = new ha();
        n.matrixAutoUpdate = !1, n.visible = !1, t.joints[e.jointName] = n, t.add(n);
      }
      return t.joints[e.jointName];
    }
  };
u(Gg, "WebXRController");
var Vu = class extends lo {
  constructor(t, e, n, i, r, o, s, a, l, u) {
    if ((u = void 0 !== u ? u : Lu) !== Lu && u !== Xp) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    void 0 === n && u === Lu && (n = Ps), void 0 === n && u === Xp && (n = sf), super(null, i, r, o, s, a, u, n, l), this.isDepthTexture = !0, this.image = {
      width: t,
      height: e
    }, this.magFilter = void 0 !== s ? s : ni, this.minFilter = void 0 !== a ? a : ni, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(t) {
    return super.copy(t), this.compareFunction = t.compareFunction, this;
  }
  toJSON(t) {
    let e = super.toJSON(t);
    return null !== this.compareFunction && (e.compareFunction = this.compareFunction), e;
  }
};
u(Vu, "DepthTexture");
var xS = class extends Al {
  constructor(t, e) {
    super();
    let n = this,
      i = null,
      r = 1,
      o = null,
      s = "local-floor",
      a = 1,
      l = null,
      h = null,
      c = null,
      p = null,
      d = null,
      f = null,
      m = e.getContextAttributes(),
      g = null,
      v = null,
      y = [],
      _ = [],
      x = null,
      E = new as();
    E.layers.enable(1), E.viewport = new Er();
    let b = new as();
    b.layers.enable(2), b.viewport = new Er();
    let w = [E, b],
      S = new _S();
    S.layers.enable(1), S.layers.enable(2);
    let M = null,
      T = null;
    function A(t) {
      let e = _.indexOf(t.inputSource);
      if (-1 === e) return;
      let n = y[e];
      void 0 !== n && (n.update(t.inputSource, t.frame, l || o), n.dispatchEvent({
        type: t.type,
        data: t.inputSource
      }));
    }
    function P() {
      i.removeEventListener("select", A), i.removeEventListener("selectstart", A), i.removeEventListener("selectend", A), i.removeEventListener("squeeze", A), i.removeEventListener("squeezestart", A), i.removeEventListener("squeezeend", A), i.removeEventListener("end", P), i.removeEventListener("inputsourceschange", C);
      for (let t = 0; t < y.length; t++) {
        let e = _[t];
        null !== e && (_[t] = null, y[t].disconnect(e));
      }
      M = null, T = null, t.setRenderTarget(g), d = null, p = null, c = null, i = null, v = null, k.stop(), n.isPresenting = !1, n.dispatchEvent({
        type: "sessionend"
      });
    }
    function C(t) {
      for (let e = 0; e < t.removed.length; e++) {
        let n = t.removed[e],
          i = _.indexOf(n);
        i >= 0 && (_[i] = null, y[i].disconnect(n));
      }
      for (let e = 0; e < t.added.length; e++) {
        let n = t.added[e],
          i = _.indexOf(n);
        if (-1 === i) {
          for (let t = 0; t < y.length; t++) {
            if (t >= _.length) {
              _.push(n), i = t;
              break;
            }
            if (null === _[t]) {
              _[t] = n, i = t;
              break;
            }
          }
          if (-1 === i) break;
        }
        let r = y[i];
        r && r.connect(n);
      }
    }
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getCamera = function () {}, this.setUserCamera = function (t) {
      x = t;
    }, this.getController = function (t) {
      let e = y[t];
      return void 0 === e && (e = new Gg(), y[t] = e), e.getTargetRaySpace();
    }, this.getControllerGrip = function (t) {
      let e = y[t];
      return void 0 === e && (e = new Gg(), y[t] = e), e.getGripSpace();
    }, this.getHand = function (t) {
      let e = y[t];
      return void 0 === e && (e = new Gg(), y[t] = e), e.getHandSpace();
    }, u(A, "onSessionEvent"), u(P, "onSessionEnd"), this.setFramebufferScaleFactor = function (t) {
      r = t, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function (t) {
      s = t, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function () {
      return l || o;
    }, this.setReferenceSpace = function (t) {
      l = t;
    }, this.getBaseLayer = function () {
      return null !== p ? p : d;
    }, this.getBinding = function () {
      return c;
    }, this.getFrame = function () {
      return f;
    }, this.getSession = function () {
      return i;
    }, this.setSession = async function (u) {
      if (i = u, null !== i) {
        if (g = t.getRenderTarget(), i.addEventListener("select", A), i.addEventListener("selectstart", A), i.addEventListener("selectend", A), i.addEventListener("squeeze", A), i.addEventListener("squeezestart", A), i.addEventListener("squeezeend", A), i.addEventListener("end", P), i.addEventListener("inputsourceschange", C), !0 !== m.xrCompatible && (await e.makeXRCompatible()), void 0 === i.renderState.layers || !1 === t.capabilities.isWebGL2) {
          let n = {
            antialias: void 0 !== i.renderState.layers || m.antialias,
            alpha: !0,
            depth: m.depth,
            stencil: m.stencil,
            framebufferScaleFactor: r
          };
          d = new XRWebGLLayer(i, e, n), i.updateRenderState({
            baseLayer: d
          }), v = new wr(d.framebufferWidth, d.framebufferHeight, {
            format: Po,
            type: Wc,
            colorSpace: t.outputColorSpace,
            stencilBuffer: m.stencil
          });
        } else {
          let n = null,
            o = null,
            s = null;
          m.depth && (s = m.stencil ? e.DEPTH24_STENCIL8 : e.DEPTH_COMPONENT24, n = m.stencil ? Xp : Lu, o = m.stencil ? sf : Ps);
          let a = {
            colorFormat: e.RGBA8,
            depthFormat: s,
            scaleFactor: r
          };
          c = new XRWebGLBinding(i, e), p = c.createProjectionLayer(a), i.updateRenderState({
            layers: [p]
          }), v = new wr(p.textureWidth, p.textureHeight, {
            format: Po,
            type: Wc,
            depthTexture: new Vu(p.textureWidth, p.textureHeight, o, void 0, void 0, void 0, void 0, void 0, void 0, n),
            stencilBuffer: m.stencil,
            colorSpace: t.outputColorSpace,
            samples: m.antialias ? 4 : 0
          }), t.properties.get(v).__ignoreDepthValues = p.ignoreDepthValues;
        }
        v.isXRRenderTarget = !0, this.setFoveation(a), l = null, o = await i.requestReferenceSpace(s), k.setContext(i), k.start(), n.isPresenting = !0, n.dispatchEvent({
          type: "sessionstart"
        });
      }
    }, this.getEnvironmentBlendMode = function () {
      if (null !== i) return i.environmentBlendMode;
    }, u(C, "onInputSourcesChange");
    let I = new ne(),
      N = new ne();
    function L(t, e, n) {
      I.setFromMatrixPosition(e.matrixWorld), N.setFromMatrixPosition(n.matrixWorld);
      let i = I.distanceTo(N),
        r = e.projectionMatrix.elements,
        o = n.projectionMatrix.elements,
        s = r[14] / (r[10] - 1),
        a = r[14] / (r[10] + 1),
        l = (r[9] + 1) / r[5],
        u = (r[9] - 1) / r[5],
        h = (r[8] - 1) / r[0],
        c = (o[8] + 1) / o[0],
        p = s * h,
        d = s * c,
        f = i / (-h + c),
        m = f * -h;
      e.matrixWorld.decompose(t.position, t.quaternion, t.scale), t.translateX(m), t.translateZ(f), t.matrixWorld.compose(t.position, t.quaternion, t.scale), t.matrixWorldInverse.copy(t.matrixWorld).invert();
      let g = s + f,
        v = a + f,
        y = p - m,
        _ = d + (i - m),
        x = l * a / v * g,
        E = u * a / v * g;
      t.projectionMatrix.makePerspective(y, _, x, E, g, v), t.projectionMatrixInverse.copy(t.projectionMatrix).invert();
    }
    function R(t, e) {
      null === e ? t.matrixWorld.copy(t.matrix) : t.matrixWorld.multiplyMatrices(e.matrixWorld, t.matrix), t.matrixWorldInverse.copy(t.matrixWorld).invert();
    }
    function O(t, e) {
      let n = x;
      null === e ? n.matrix.copy(t.matrixWorld) : (n.matrix.copy(e.matrixWorld), n.matrix.invert(), n.matrix.multiply(t.matrixWorld)), n.matrix.decompose(n.position, n.quaternion, n.scale), n.updateMatrixWorld(!0);
      let i = n.children;
      for (let t = 0, e = i.length; t < e; t++) i[t].updateMatrixWorld(!0);
      n.projectionMatrix.copy(t.projectionMatrix), n.projectionMatrixInverse.copy(t.projectionMatrixInverse), n.isPerspectiveCamera && (n.fov = 2 * k3 * Math.atan(1 / n.projectionMatrix.elements[5]), n.zoom = 1);
    }
    u(L, "setProjectionFromUnion"), u(R, "updateCamera"), this.updateCameraXR = function (t) {
      if (null === i) return t;
      x && (t = x), S.near = b.near = E.near = t.near, S.far = b.far = E.far = t.far, (M !== S.near || T !== S.far) && (i.updateRenderState({
        depthNear: S.near,
        depthFar: S.far
      }), M = S.near, T = S.far);
      let e = t.parent,
        n = S.cameras;
      R(S, e);
      for (let t = 0; t < n.length; t++) R(n[t], e);
      return 2 === n.length ? L(S, E, b) : S.projectionMatrix.copy(E.projectionMatrix), x && O(S, e), S;
    }, u(O, "updateUserCamera"), this.getFoveation = function () {
      if (null !== p || null !== d) return a;
    }, this.setFoveation = function (t) {
      a = t, null !== p && (p.fixedFoveation = t), null !== d && void 0 !== d.fixedFoveation && (d.fixedFoveation = t);
    };
    let q = null;
    function D(e, i) {
      if (h = i.getViewerPose(l || o), f = i, null !== h) {
        let e = h.views;
        null !== d && (t.setRenderTargetFramebuffer(v, d.framebuffer), t.setRenderTarget(v));
        let n = !1;
        e.length !== S.cameras.length && (S.cameras.length = 0, n = !0);
        for (let i = 0; i < e.length; i++) {
          let r = e[i],
            o = null;
          if (null !== d) o = d.getViewport(r);else {
            let e = c.getViewSubImage(p, r);
            o = e.viewport, 0 === i && (t.setRenderTargetTextures(v, e.colorTexture, p.ignoreDepthValues ? void 0 : e.depthStencilTexture), t.setRenderTarget(v));
          }
          let s = w[i];
          void 0 === s && (s = new as(), s.layers.enable(i), s.viewport = new Er(), w[i] = s), s.matrix.fromArray(r.transform.matrix), s.matrix.decompose(s.position, s.quaternion, s.scale), s.projectionMatrix.fromArray(r.projectionMatrix), s.projectionMatrixInverse.copy(s.projectionMatrix).invert(), s.viewport.set(o.x, o.y, o.width, o.height), 0 === i && (S.matrix.copy(s.matrix), S.matrix.decompose(S.position, S.quaternion, S.scale)), !0 === n && S.cameras.push(s);
        }
      }
      for (let t = 0; t < y.length; t++) {
        let e = _[t],
          n = y[t];
        null !== e && void 0 !== n && n.update(e, i, l || o);
      }
      q && q(e, i), i.detectedPlanes && n.dispatchEvent({
        type: "planesdetected",
        data: i
      }), f = null;
    }
    u(D, "onAnimationFrame");
    let k = new d8();
    k.setAnimationLoop(D), this.setAnimationLoop = function (t) {
      q = t;
    }, this.dispose = function () {};
  }
};
function xX(t, e) {
  function n(t, e) {
    !0 === t.matrixAutoUpdate && t.updateMatrix(), e.value.copy(t.matrix);
  }
  function i(e, n) {
    n.color.getRGB(e.fogColor.value, p8(t)), n.isFog ? (e.fogNear.value = n.near, e.fogFar.value = n.far) : n.isFogExp2 && (e.fogDensity.value = n.density);
  }
  function r(t, e, n, i, r) {
    e.isMeshBasicMaterial || e.isMeshLambertMaterial ? o(t, e) : e.isMeshToonMaterial ? (o(t, e), p(t, e)) : e.isMeshPhongMaterial ? (o(t, e), c(t, e)) : e.isMeshStandardMaterial ? (o(t, e), d(t, e), e.isMeshPhysicalMaterial && f(t, e, r)) : e.isMeshMatcapMaterial ? (o(t, e), m(t, e)) : e.isMeshDepthMaterial ? o(t, e) : e.isMeshDistanceMaterial ? (o(t, e), g(t, e)) : e.isMeshNormalMaterial ? o(t, e) : e.isLineBasicMaterial ? (s(t, e), e.isLineDashedMaterial && a(t, e)) : e.isPointsMaterial ? l(t, e, n, i) : e.isSpriteMaterial ? h(t, e) : e.isShadowMaterial ? (t.color.value.copy(e.color), t.opacity.value = e.opacity) : e.isShaderMaterial && (e.uniformsNeedUpdate = !1);
  }
  function o(i, r) {
    i.opacity.value = r.opacity, r.color && i.diffuse.value.copy(r.color), r.emissive && i.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity), r.map && (i.map.value = r.map, n(r.map, i.mapTransform)), r.alphaMap && (i.alphaMap.value = r.alphaMap, n(r.alphaMap, i.alphaMapTransform)), r.bumpMap && (i.bumpMap.value = r.bumpMap, n(r.bumpMap, i.bumpMapTransform), i.bumpScale.value = r.bumpScale, r.side === Ts && (i.bumpScale.value *= -1)), r.normalMap && (i.normalMap.value = r.normalMap, n(r.normalMap, i.normalMapTransform), i.normalScale.value.copy(r.normalScale), r.side === Ts && i.normalScale.value.negate()), r.displacementMap && (i.displacementMap.value = r.displacementMap, n(r.displacementMap, i.displacementMapTransform), i.displacementScale.value = r.displacementScale, i.displacementBias.value = r.displacementBias), r.emissiveMap && (i.emissiveMap.value = r.emissiveMap, n(r.emissiveMap, i.emissiveMapTransform)), r.specularMap && (i.specularMap.value = r.specularMap, n(r.specularMap, i.specularMapTransform)), r.alphaTest > 0 && (i.alphaTest.value = r.alphaTest);
    let o = e.get(r).envMap;
    if (o && (i.envMap.value = o, i.flipEnvMap.value = o.isCubeTexture && !1 === o.isRenderTargetTexture ? -1 : 1, i.reflectivity.value = r.reflectivity, i.ior.value = r.ior, i.refractionRatio.value = r.refractionRatio), r.lightMap) {
      i.lightMap.value = r.lightMap;
      let e = !0 === t.useLegacyLights ? Math.PI : 1;
      i.lightMapIntensity.value = r.lightMapIntensity * e, n(r.lightMap, i.lightMapTransform);
    }
    r.aoMap && (i.aoMap.value = r.aoMap, i.aoMapIntensity.value = r.aoMapIntensity, n(r.aoMap, i.aoMapTransform));
  }
  function s(t, e) {
    t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, e.map && (t.map.value = e.map, n(e.map, t.mapTransform));
  }
  function a(t, e) {
    t.dashSize.value = e.dashSize, t.totalSize.value = e.dashSize + e.gapSize, t.scale.value = e.scale;
  }
  function l(t, e, i, r) {
    t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, t.size.value = e.size * i, t.scale.value = .5 * r, e.map && (t.map.value = e.map, n(e.map, t.uvTransform)), e.alphaMap && (t.alphaMap.value = e.alphaMap, n(e.alphaMap, t.alphaMapTransform)), e.alphaTest > 0 && (t.alphaTest.value = e.alphaTest);
  }
  function h(t, e) {
    t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, t.rotation.value = e.rotation, e.map && (t.map.value = e.map, n(e.map, t.mapTransform)), e.alphaMap && (t.alphaMap.value = e.alphaMap, n(e.alphaMap, t.alphaMapTransform)), e.alphaTest > 0 && (t.alphaTest.value = e.alphaTest);
  }
  function c(t, e) {
    t.specular.value.copy(e.specular), t.shininess.value = Math.max(e.shininess, 1e-4);
  }
  function p(t, e) {
    e.gradientMap && (t.gradientMap.value = e.gradientMap);
  }
  function d(t, i) {
    t.metalness.value = i.metalness, i.metalnessMap && (t.metalnessMap.value = i.metalnessMap, n(i.metalnessMap, t.metalnessMapTransform)), t.roughness.value = i.roughness, i.roughnessMap && (t.roughnessMap.value = i.roughnessMap, n(i.roughnessMap, t.roughnessMapTransform)), e.get(i).envMap && (t.envMapIntensity.value = i.envMapIntensity);
  }
  function f(t, e, i) {
    t.ior.value = e.ior, e.sheen > 0 && (t.sheenColor.value.copy(e.sheenColor).multiplyScalar(e.sheen), t.sheenRoughness.value = e.sheenRoughness, e.sheenColorMap && (t.sheenColorMap.value = e.sheenColorMap, n(e.sheenColorMap, t.sheenColorMapTransform)), e.sheenRoughnessMap && (t.sheenRoughnessMap.value = e.sheenRoughnessMap, n(e.sheenRoughnessMap, t.sheenRoughnessMapTransform))), e.clearcoat > 0 && (t.clearcoat.value = e.clearcoat, t.clearcoatRoughness.value = e.clearcoatRoughness, e.clearcoatMap && (t.clearcoatMap.value = e.clearcoatMap, n(e.clearcoatMap, t.clearcoatMapTransform)), e.clearcoatRoughnessMap && (t.clearcoatRoughnessMap.value = e.clearcoatRoughnessMap, n(e.clearcoatRoughnessMap, t.clearcoatRoughnessMapTransform)), e.clearcoatNormalMap && (t.clearcoatNormalMap.value = e.clearcoatNormalMap, n(e.clearcoatNormalMap, t.clearcoatNormalMapTransform), t.clearcoatNormalScale.value.copy(e.clearcoatNormalScale), e.side === Ts && t.clearcoatNormalScale.value.negate())), e.iridescence > 0 && (t.iridescence.value = e.iridescence, t.iridescenceIOR.value = e.iridescenceIOR, t.iridescenceThicknessMinimum.value = e.iridescenceThicknessRange[0], t.iridescenceThicknessMaximum.value = e.iridescenceThicknessRange[1], e.iridescenceMap && (t.iridescenceMap.value = e.iridescenceMap, n(e.iridescenceMap, t.iridescenceMapTransform)), e.iridescenceThicknessMap && (t.iridescenceThicknessMap.value = e.iridescenceThicknessMap, n(e.iridescenceThicknessMap, t.iridescenceThicknessMapTransform))), e.transmission > 0 && (t.transmission.value = e.transmission, t.transmissionSamplerMap.value = i.texture, t.transmissionSamplerSize.value.set(i.width, i.height), e.transmissionMap && (t.transmissionMap.value = e.transmissionMap, n(e.transmissionMap, t.transmissionMapTransform)), t.thickness.value = e.thickness, e.thicknessMap && (t.thicknessMap.value = e.thicknessMap, n(e.thicknessMap, t.thicknessMapTransform)), t.attenuationDistance.value = e.attenuationDistance, t.attenuationColor.value.copy(e.attenuationColor)), e.anisotropy > 0 && (t.anisotropyVector.value.set(e.anisotropy * Math.cos(e.anisotropyRotation), e.anisotropy * Math.sin(e.anisotropyRotation)), e.anisotropyMap && (t.anisotropyMap.value = e.anisotropyMap, n(e.anisotropyMap, t.anisotropyMapTransform))), t.specularIntensity.value = e.specularIntensity, t.specularColor.value.copy(e.specularColor), e.specularColorMap && (t.specularColorMap.value = e.specularColorMap, n(e.specularColorMap, t.specularColorMapTransform)), e.specularIntensityMap && (t.specularIntensityMap.value = e.specularIntensityMap, n(e.specularIntensityMap, t.specularIntensityMapTransform));
  }
  function m(t, e) {
    e.matcap && (t.matcap.value = e.matcap);
  }
  function g(t, n) {
    let i = e.get(n).light;
    t.referencePosition.value.setFromMatrixPosition(i.matrixWorld), t.nearDistance.value = i.shadow.camera.near, t.farDistance.value = i.shadow.camera.far;
  }
  return u(n, "refreshTransformUniform"), u(i, "refreshFogUniforms"), u(r, "refreshMaterialUniforms"), u(o, "refreshUniformsCommon"), u(s, "refreshUniformsLine"), u(a, "refreshUniformsDash"), u(l, "refreshUniformsPoints"), u(h, "refreshUniformsSprites"), u(c, "refreshUniformsPhong"), u(p, "refreshUniformsToon"), u(d, "refreshUniformsStandard"), u(f, "refreshUniformsPhysical"), u(m, "refreshUniformsMatcap"), u(g, "refreshUniformsDistance"), {
    refreshFogUniforms: i,
    refreshMaterialUniforms: r
  };
}
function bX(t, e, n, i) {
  let r = {},
    o = {},
    s = [],
    a = n.isWebGL2 ? t.getParameter(t.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
  function l(t, e) {
    let n = e.program;
    i.uniformBlockBinding(t, n);
  }
  function h(t, n) {
    let s = r[t.id];
    void 0 === s && (m(t), s = c(t), r[t.id] = s, t.addEventListener("dispose", v));
    let a = n.program;
    i.updateUBOMapping(t, a);
    let l = e.render.frame;
    o[t.id] !== l && (d(t), o[t.id] = l);
  }
  function c(e) {
    let n = p();
    e.__bindingPointIndex = n;
    let i = t.createBuffer(),
      r = e.__size,
      o = e.usage;
    return t.bindBuffer(t.UNIFORM_BUFFER, i), t.bufferData(t.UNIFORM_BUFFER, r, o), t.bindBuffer(t.UNIFORM_BUFFER, null), t.bindBufferBase(t.UNIFORM_BUFFER, n, i), i;
  }
  function p() {
    for (let t = 0; t < a; t++) if (-1 === s.indexOf(t)) return s.push(t), t;
    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function d(e) {
    let n = r[e.id],
      i = e.uniforms,
      o = e.__cache;
    t.bindBuffer(t.UNIFORM_BUFFER, n);
    for (let e = 0, n = i.length; e < n; e++) {
      let n = i[e];
      if (!0 === f(n, e, o)) {
        let e = n.__offset,
          i = Array.isArray(n.value) ? n.value : [n.value],
          r = 0;
        for (let o = 0; o < i.length; o++) {
          let s = i[o],
            a = g(s);
          "number" == typeof s ? (n.__data[0] = s, t.bufferSubData(t.UNIFORM_BUFFER, e + r, n.__data)) : s.isMatrix3 ? (n.__data[0] = s.elements[0], n.__data[1] = s.elements[1], n.__data[2] = s.elements[2], n.__data[3] = s.elements[0], n.__data[4] = s.elements[3], n.__data[5] = s.elements[4], n.__data[6] = s.elements[5], n.__data[7] = s.elements[0], n.__data[8] = s.elements[6], n.__data[9] = s.elements[7], n.__data[10] = s.elements[8], n.__data[11] = s.elements[0]) : (s.toArray(n.__data, r), r += a.storage / Float32Array.BYTES_PER_ELEMENT);
        }
        t.bufferSubData(t.UNIFORM_BUFFER, e, n.__data);
      }
    }
    t.bindBuffer(t.UNIFORM_BUFFER, null);
  }
  function f(t, e, n) {
    let i = t.value;
    if (void 0 === n[e]) {
      if ("number" == typeof i) n[e] = i;else {
        let t = Array.isArray(i) ? i : [i],
          r = [];
        for (let e = 0; e < t.length; e++) r.push(t[e].clone());
        n[e] = r;
      }
      return !0;
    }
    if ("number" == typeof i) {
      if (n[e] !== i) return n[e] = i, !0;
    } else {
      let t = Array.isArray(n[e]) ? n[e] : [n[e]],
        r = Array.isArray(i) ? i : [i];
      for (let e = 0; e < t.length; e++) {
        let n = t[e];
        if (!1 === n.equals(r[e])) return n.copy(r[e]), !0;
      }
    }
    return !1;
  }
  function m(t) {
    let e = t.uniforms,
      n = 0,
      i = 0;
    for (let t = 0, r = e.length; t < r; t++) {
      let r = e[t],
        o = {
          boundary: 0,
          storage: 0
        },
        s = Array.isArray(r.value) ? r.value : [r.value];
      for (let t = 0, e = s.length; t < e; t++) {
        let e = g(s[t]);
        o.boundary += e.boundary, o.storage += e.storage;
      }
      if (r.__data = new Float32Array(o.storage / Float32Array.BYTES_PER_ELEMENT), r.__offset = n, t > 0) {
        i = n % 16;
        let t = 16 - i;
        0 !== i && t - o.boundary < 0 && (n += 16 - i, r.__offset = n);
      }
      n += o.storage;
    }
    return i = n % 16, i > 0 && (n += 16 - i), t.__size = n, t.__cache = {}, this;
  }
  function g(t) {
    let e = {
      boundary: 0,
      storage: 0
    };
    return "number" == typeof t ? (e.boundary = 4, e.storage = 4) : t.isVector2 ? (e.boundary = 8, e.storage = 8) : t.isVector3 || t.isColor ? (e.boundary = 16, e.storage = 12) : t.isVector4 ? (e.boundary = 16, e.storage = 16) : t.isMatrix3 ? (e.boundary = 48, e.storage = 48) : t.isMatrix4 ? (e.boundary = 64, e.storage = 64) : t.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", t), e;
  }
  function v(e) {
    let n = e.target;
    n.removeEventListener("dispose", v);
    let i = s.indexOf(n.__bindingPointIndex);
    s.splice(i, 1), t.deleteBuffer(r[n.id]), delete r[n.id], delete o[n.id];
  }
  function y() {
    for (let e in r) t.deleteBuffer(r[e]);
    s = [], r = {}, o = {};
  }
  return u(l, "bind"), u(h, "update"), u(c, "createBuffer"), u(p, "allocateBindingPointIndex"), u(d, "updateBufferData"), u(f, "hasUniformChanged"), u(m, "prepareUniformsGroup"), u(g, "getUniformSize"), u(v, "onUniformsGroupsDispose"), u(y, "dispose"), {
    bind: l,
    update: h,
    dispose: y
  };
}
function MX() {
  let t = Ng("canvas");
  return t.style.display = "block", t;
}
u(xS, "WebXRManager"), u(xX, "WebGLMaterials"), u(bX, "WebGLUniformsGroups"), u(MX, "createCanvasElement");
var vd = class {
  constructor(t = {}) {
    let e,
      {
        canvas: n = MX(),
        context: i = null,
        depth: r = !0,
        stencil: o = !0,
        alpha: s = !1,
        antialias: a = !1,
        premultipliedAlpha: l = !0,
        preserveDrawingBuffer: h = !1,
        powerPreference: c = "default",
        failIfMajorPerformanceCaveat: p = !1
      } = t;
    this.isWebGLRenderer = !0, e = null !== i ? i.getContextAttributes().alpha : s;
    let d = new Uint32Array(4),
      f = new Int32Array(4),
      m = null,
      g = null,
      v = [],
      y = [];
    this.domElement = n, this.debug = {
      checkShaderErrors: !0,
      onShaderError: null
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputColorSpace = Nt, this.useLegacyLights = !0, this.toneMapping = Au, this.toneMappingExposure = 1;
    let _ = this,
      x = !1,
      E = 0,
      b = 0,
      w = null,
      S = -1,
      M = null,
      T = new Er(),
      A = new Er(),
      P = null,
      C = new yt(0),
      I = 0,
      N = n.width,
      L = n.height,
      R = 1,
      O = null,
      q = null,
      D = new Er(0, 0, N, L),
      k = new Er(0, 0, N, L),
      F = !1,
      U = new hf(),
      B = !1,
      z = !1,
      V = null,
      j = new Bt(),
      G = new je(),
      W = new ne(),
      H = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: !0
      };
    function X() {
      return null === w ? R : 1;
    }
    u(X, "getTargetPixelRatio");
    let Y,
      Z,
      J,
      K,
      Q,
      $,
      tt,
      et,
      nt,
      it,
      rt,
      ot,
      st,
      at,
      lt,
      ut,
      ht,
      ct,
      pt,
      dt,
      ft,
      mt,
      gt,
      vt,
      _t = i;
    function xt(t, e) {
      for (let i = 0; i < t.length; i++) {
        let r = t[i],
          o = n.getContext(r, e);
        if (null !== o) return o;
      }
      return null;
    }
    u(xt, "getContext");
    try {
      let t = {
        alpha: !0,
        depth: r,
        stencil: o,
        antialias: a,
        premultipliedAlpha: l,
        preserveDrawingBuffer: h,
        powerPreference: c,
        failIfMajorPerformanceCaveat: p
      };
      if ("setAttribute" in n && n.setAttribute("data-engine", `three.js r${_3}`), n.addEventListener("webglcontextlost", wt, !1), n.addEventListener("webglcontextrestored", St, !1), n.addEventListener("webglcontextcreationerror", Mt, !1), null === _t) {
        let e = ["webgl2", "webgl", "experimental-webgl"];
        if (!0 === _.isWebGL1Renderer && e.shift(), _t = xt(e, t), null === _t) throw xt(e) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }
      _t instanceof WebGLRenderingContext && console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."), void 0 === _t.getShaderPrecisionFormat && (_t.getShaderPrecisionFormat = function () {
        return {
          rangeMin: 1,
          rangeMax: 1,
          precision: 1
        };
      });
    } catch (t) {
      throw console.error("THREE.WebGLRenderer: " + t.message), t;
    }
    function Et() {
      Y = new Gj(_t), Z = new kj(_t, Y, t), Y.init(Z), mt = new yX(_t, Y, Z), J = new gX(_t, Y, Z), K = new Wj(_t), Q = new rX(), $ = new vX(_t, Y, J, Q, Z, mt, K), tt = new Bj(_), et = new Vj(_), nt = new rG(_t, Z), gt = new Dj(_t, Y, nt, Z), it = new Hj(_t, nt, K, gt), rt = new Jj(_t, it, nt, K), pt = new Zj(_t, Z, $), ut = new Fj(Q), ot = new iX(_, tt, et, Y, Z, gt, ut), st = new xX(_, Q), at = new sX(), lt = new fX(Y, Z), ct = new Nj(_, tt, et, J, rt, e, l), ht = new mX(_, rt, Z), vt = new bX(_t, K, Z, J), dt = new qj(_t, Y, K, Z), ft = new jj(_t, Y, K, Z), K.programs = ot.programs, _.capabilities = Z, _.extensions = Y, _.properties = Q, _.renderLists = at, _.shadowMap = ht, _.state = J, _.info = K;
    }
    u(Et, "initGLContext"), Et();
    let bt = new xS(_, _t);
    function wt(t) {
      t.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), x = !0;
    }
    function St() {
      console.log("THREE.WebGLRenderer: Context Restored."), x = !1;
      let t = K.autoReset,
        e = ht.enabled,
        n = ht.autoUpdate,
        i = ht.needsUpdate,
        r = ht.type;
      Et(), K.autoReset = t, ht.enabled = e, ht.autoUpdate = n, ht.needsUpdate = i, ht.type = r;
    }
    function Mt(t) {
      console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", t.statusMessage);
    }
    function Tt(t) {
      let e = t.target;
      e.removeEventListener("dispose", Tt), At(e);
    }
    function At(t) {
      Pt(t), Q.remove(t);
    }
    function Pt(t) {
      let e = Q.get(t).programs;
      void 0 !== e && (e.forEach(function (t) {
        ot.releaseProgram(t);
      }), t.isShaderMaterial && ot.releaseShaderCache(t));
    }
    this.xr = bt, this.getContext = function () {
      return _t;
    }, this.getContextAttributes = function () {
      return _t.getContextAttributes();
    }, this.forceContextLoss = function () {
      let t = Y.get("WEBGL_lose_context");
      t && t.loseContext();
    }, this.forceContextRestore = function () {
      let t = Y.get("WEBGL_lose_context");
      t && t.restoreContext();
    }, this.getPixelRatio = function () {
      return R;
    }, this.setPixelRatio = function (t) {
      void 0 !== t && (R = t, this.setSize(N, L, !1));
    }, this.getSize = function (t) {
      return t.set(N, L);
    }, this.setSize = function (t, e, i = !0) {
      bt.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (N = t, L = e, n.width = Math.floor(t * R), n.height = Math.floor(e * R), !0 === i && (n.style.width = t + "px", n.style.height = e + "px"), this.setViewport(0, 0, t, e));
    }, this.getDrawingBufferSize = function (t) {
      return t.set(N * R, L * R).floor();
    }, this.setDrawingBufferSize = function (t, e, i) {
      N = t, L = e, R = i, n.width = Math.floor(t * i), n.height = Math.floor(e * i), this.setViewport(0, 0, t, e);
    }, this.getCurrentViewport = function (t) {
      return t.copy(T);
    }, this.getViewport = function (t) {
      return t.copy(D);
    }, this.setViewport = function (t, e, n, i) {
      t.isVector4 ? D.set(t.x, t.y, t.z, t.w) : D.set(t, e, n, i), J.viewport(T.copy(D).multiplyScalar(R).floor());
    }, this.getScissor = function (t) {
      return t.copy(k);
    }, this.setScissor = function (t, e, n, i) {
      t.isVector4 ? k.set(t.x, t.y, t.z, t.w) : k.set(t, e, n, i), J.scissor(A.copy(k).multiplyScalar(R).floor());
    }, this.getScissorTest = function () {
      return F;
    }, this.setScissorTest = function (t) {
      J.setScissorTest(F = t);
    }, this.setOpaqueSort = function (t) {
      O = t;
    }, this.setTransparentSort = function (t) {
      q = t;
    }, this.getClearColor = function (t) {
      return t.copy(ct.getClearColor());
    }, this.setClearColor = function () {
      ct.setClearColor.apply(ct, arguments);
    }, this.getClearAlpha = function () {
      return ct.getClearAlpha();
    }, this.setClearAlpha = function () {
      ct.setClearAlpha.apply(ct, arguments);
    }, this.clear = function (t = !0, e = !0, n = !0) {
      let i = 0;
      if (t) {
        let t = !1;
        if (null !== w) {
          let e = w.texture.format;
          t = e === vI || e === gI || e === mI;
        }
        if (t) {
          let t = w.texture.type,
            e = t === Wc || t === Ps || t === P3 || t === sf || t === pI || t === dI,
            n = ct.getClearColor(),
            i = ct.getClearAlpha(),
            r = n.r,
            o = n.g,
            s = n.b,
            a = Q.get(w).__webglFramebuffer;
          e ? (d[0] = r, d[1] = o, d[2] = s, d[3] = i, _t.clearBufferuiv(_t.COLOR, a, d)) : (f[0] = r, f[1] = o, f[2] = s, f[3] = i, _t.clearBufferiv(_t.COLOR, a, f));
        } else i |= _t.COLOR_BUFFER_BIT;
      }
      e && (i |= _t.DEPTH_BUFFER_BIT), n && (i |= _t.STENCIL_BUFFER_BIT), _t.clear(i);
    }, this.clearColor = function () {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function () {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function () {
      this.clear(!1, !1, !0);
    }, this.dispose = function () {
      n.removeEventListener("webglcontextlost", wt, !1), n.removeEventListener("webglcontextrestored", St, !1), n.removeEventListener("webglcontextcreationerror", Mt, !1), at.dispose(), lt.dispose(), Q.dispose(), tt.dispose(), et.dispose(), rt.dispose(), gt.dispose(), vt.dispose(), ot.dispose(), bt.dispose(), bt.removeEventListener("sessionstart", Lt), bt.removeEventListener("sessionend", Rt), V && (V.dispose(), V = null), Ot.stop();
    }, u(wt, "onContextLost"), u(St, "onContextRestore"), u(Mt, "onContextCreationError"), u(Tt, "onMaterialDispose"), u(At, "deallocateMaterial"), u(Pt, "releaseMaterialProgramReferences"), this.renderBufferDirect = function (t, e, n, i, r, o) {
      null === e && (e = H);
      let s = r.isMesh && r.matrixWorld.determinant() < 0,
        a = jt(t, e, n, i, r);
      J.setMaterial(i, s);
      let l = n.index,
        u = 1;
      !0 === i.wireframe && (l = it.getWireframeAttribute(n), u = 2);
      let h = n.drawRange,
        c = n.attributes.position,
        p = h.start * u,
        d = (h.start + h.count) * u;
      null !== o && (p = Math.max(p, o.start * u), d = Math.min(d, (o.start + o.count) * u)), null !== l ? (p = Math.max(p, 0), d = Math.min(d, l.count)) : null != c && (p = Math.max(p, 0), d = Math.min(d, c.count));
      let f = d - p;
      if (f < 0 || f === 1 / 0) return;
      gt.setup(r, i, a, n, l);
      let m,
        g = dt;
      if (null !== l && (m = nt.get(l), g = ft, g.setIndex(m)), r.isMesh) !0 === i.wireframe ? (J.setLineWidth(i.wireframeLinewidth * X()), g.setMode(_t.LINES)) : g.setMode(_t.TRIANGLES);else if (r.isLine) {
        let t = i.linewidth;
        void 0 === t && (t = 1), J.setLineWidth(t * X()), r.isLineSegments ? g.setMode(_t.LINES) : r.isLineLoop ? g.setMode(_t.LINE_LOOP) : g.setMode(_t.LINE_STRIP);
      } else r.isPoints ? g.setMode(_t.POINTS) : r.isSprite && g.setMode(_t.TRIANGLES);
      if (r.isInstancedMesh) g.renderInstances(p, f, r.count);else if (n.isInstancedBufferGeometry) {
        let t = void 0 !== n._maxInstanceCount ? n._maxInstanceCount : 1 / 0,
          e = Math.min(n.instanceCount, t);
        g.renderInstances(p, f, e);
      } else g.render(p, f);
    }, this.compile = function (t, e) {
      function n(t, e, n) {
        !0 === t.transparent && t.side === Us && !1 === t.forceSinglePass ? (t.side = Ts, t.needsUpdate = !0, zt(t, e, n), t.side = ja, t.needsUpdate = !0, zt(t, e, n), t.side = Us) : zt(t, e, n);
      }
      u(n, "prepare"), g = lt.get(t), g.init(), y.push(g), t.traverseVisible(function (t) {
        t.isLight && t.layers.test(e.layers) && (g.pushLight(t), t.castShadow && g.pushShadow(t));
      }), g.setupLights(_.useLegacyLights), t.traverse(function (e) {
        let i = e.material;
        if (i) if (Array.isArray(i)) for (let r = 0; r < i.length; r++) {
          n(i[r], t, e);
        } else n(i, t, e);
      }), y.pop(), g = null;
    };
    let Ct = null;
    function It(t) {
      Ct && Ct(t);
    }
    function Lt() {
      Ot.stop();
    }
    function Rt() {
      Ot.start();
    }
    u(It, "onAnimationFrame"), u(Lt, "onXRSessionStart"), u(Rt, "onXRSessionEnd");
    let Ot = new d8();
    function qt(t, e, n, i) {
      if (!1 === t.visible) return;
      if (t.layers.test(e.layers)) if (t.isGroup) n = t.renderOrder;else if (t.isLOD) !0 === t.autoUpdate && t.update(e);else if (t.isLight) g.pushLight(t), t.castShadow && g.pushShadow(t);else if (t.isSprite) {
        if (!t.frustumCulled || U.intersectsSprite(t)) {
          i && W.setFromMatrixPosition(t.matrixWorld).applyMatrix4(j);
          let e = rt.update(t),
            r = t.material;
          r.visible && m.push(t, e, r, n, W.z, null);
        }
      } else if ((t.isMesh || t.isLine || t.isPoints) && (!t.frustumCulled || U.intersectsObject(t))) {
        t.isSkinnedMesh && t.skeleton.frame !== K.render.frame && (t.skeleton.update(), t.skeleton.frame = K.render.frame);
        let e = rt.update(t),
          r = t.material;
        if (i && (void 0 !== t.boundingSphere ? (null === t.boundingSphere && t.computeBoundingSphere(), W.copy(t.boundingSphere.center)) : (null === e.boundingSphere && e.computeBoundingSphere(), W.copy(e.boundingSphere.center)), W.applyMatrix4(t.matrixWorld).applyMatrix4(j)), Array.isArray(r)) {
          let i = e.groups;
          for (let o = 0, s = i.length; o < s; o++) {
            let s = i[o],
              a = r[s.materialIndex];
            a && a.visible && m.push(t, e, a, n, W.z, s);
          }
        } else r.visible && m.push(t, e, r, n, W.z, null);
      }
      let r = t.children;
      for (let t = 0, o = r.length; t < o; t++) qt(r[t], e, n, i);
    }
    function Dt(t, e, n, i) {
      let r = t.opaque,
        o = t.transmissive,
        s = t.transparent;
      g.setupLightsView(n), !0 === B && ut.setGlobalState(_.clippingPlanes, n), o.length > 0 && kt(r, o, e, n), i && J.viewport(T.copy(i)), r.length > 0 && Ft(r, e, n), o.length > 0 && Ft(o, e, n), s.length > 0 && Ft(s, e, n), J.buffers.depth.setTest(!0), J.buffers.depth.setMask(!0), J.buffers.color.setMask(!0), J.setPolygonOffset(!1);
    }
    function kt(t, e, n, i) {
      let r = Z.isWebGL2;
      null === V && (V = new wr(1, 1, {
        generateMipmaps: !0,
        type: Y.has("EXT_color_buffer_half_float") ? Iu : Wc,
        minFilter: Og,
        samples: r && !0 === a ? 4 : 0
      })), _.getDrawingBufferSize(G), r ? V.setSize(G.x, G.y) : V.setSize(B3(G.x), B3(G.y));
      let o = _.getRenderTarget();
      _.setRenderTarget(V), _.getClearColor(C), I = _.getClearAlpha(), I < 1 && _.setClearColor(16777215, .5), _.clear();
      let s = _.toneMapping;
      _.toneMapping = Au, Ft(t, n, i), $.updateMultisampleRenderTarget(V), $.updateRenderTargetMipmap(V);
      let l = !1;
      for (let t = 0, r = e.length; t < r; t++) {
        let r = e[t],
          o = r.object,
          s = r.geometry,
          a = r.material,
          u = r.group;
        if (a.side === Us && o.layers.test(i.layers)) {
          let t = a.side;
          a.side = Ts, a.needsUpdate = !0, Ut(o, n, i, s, a, u), a.side = t, a.needsUpdate = !0, l = !0;
        }
      }
      !0 === l && ($.updateMultisampleRenderTarget(V), $.updateRenderTargetMipmap(V)), _.setRenderTarget(o), _.setClearColor(C, I), _.toneMapping = s;
    }
    function Ft(t, e, n) {
      let i = !0 === e.isScene ? e.overrideMaterial : null;
      for (let r = 0, o = t.length; r < o; r++) {
        let o = t[r],
          s = o.object,
          a = o.geometry,
          l = null === i ? o.material : i,
          u = o.group;
        s.layers.test(n.layers) && Ut(s, e, n, a, l, u);
      }
    }
    function Ut(t, e, n, i, r, o) {
      t.onBeforeRender(_, e, n, i, r, o), t.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, t.matrixWorld), t.normalMatrix.getNormalMatrix(t.modelViewMatrix), r.onBeforeRender(_, e, n, i, t, o), !0 === r.transparent && r.side === Us && !1 === r.forceSinglePass ? (r.side = Ts, r.needsUpdate = !0, _.renderBufferDirect(n, e, i, r, t, o), r.side = ja, r.needsUpdate = !0, _.renderBufferDirect(n, e, i, r, t, o), r.side = Us) : _.renderBufferDirect(n, e, i, r, t, o), t.onAfterRender(_, e, n, i, r, o);
    }
    function zt(t, e, n) {
      !0 !== e.isScene && (e = H);
      let i = Q.get(t),
        r = g.state.lights,
        o = g.state.shadowsArray,
        s = r.state.version,
        a = ot.getParameters(t, r.state, o, e, n),
        l = ot.getProgramCacheKey(a),
        u = i.programs;
      i.environment = t.isMeshStandardMaterial ? e.environment : null, i.fog = e.fog, i.envMap = (t.isMeshStandardMaterial ? et : tt).get(t.envMap || i.environment), void 0 === u && (t.addEventListener("dispose", Tt), u = new Map(), i.programs = u);
      let h = u.get(l);
      if (void 0 !== h) {
        if (i.currentProgram === h && i.lightsStateVersion === s) return Vt(t, a), h;
      } else a.uniforms = ot.getUniforms(t), t.onBuild(n, a, _), t.onBeforeCompile(a, _), h = ot.acquireProgram(a, l), u.set(l, h), i.uniforms = a.uniforms;
      let c = i.uniforms;
      (!t.isShaderMaterial && !t.isRawShaderMaterial || !0 === t.clipping) && (c.clippingPlanes = ut.uniform), Vt(t, a), i.needsLights = Wt(t), i.lightsStateVersion = s, i.needsLights && (c.ambientLightColor.value = r.state.ambient, c.lightProbe.value = r.state.probe, c.directionalLights.value = r.state.directional, c.directionalLightShadows.value = r.state.directionalShadow, c.spotLights.value = r.state.spot, c.spotLightShadows.value = r.state.spotShadow, c.rectAreaLights.value = r.state.rectArea, c.ltc_1.value = r.state.rectAreaLTC1, c.ltc_2.value = r.state.rectAreaLTC2, c.pointLights.value = r.state.point, c.pointLightShadows.value = r.state.pointShadow, c.hemisphereLights.value = r.state.hemi, c.directionalShadowMap.value = r.state.directionalShadowMap, c.directionalShadowMatrix.value = r.state.directionalShadowMatrix, c.spotShadowMap.value = r.state.spotShadowMap, c.spotLightMatrix.value = r.state.spotLightMatrix, c.spotLightMap.value = r.state.spotLightMap, c.pointShadowMap.value = r.state.pointShadowMap, c.pointShadowMatrix.value = r.state.pointShadowMatrix);
      let p = h.getUniforms(),
        d = gd.seqWithValue(p.seq, c);
      return i.currentProgram = h, i.uniformsList = d, h;
    }
    function Vt(t, e) {
      let n = Q.get(t);
      n.outputColorSpace = e.outputColorSpace, n.instancing = e.instancing, n.skinning = e.skinning, n.morphTargets = e.morphTargets, n.morphNormals = e.morphNormals, n.morphColors = e.morphColors, n.morphTargetsCount = e.morphTargetsCount, n.numClippingPlanes = e.numClippingPlanes, n.numIntersection = e.numClipIntersection, n.vertexAlphas = e.vertexAlphas, n.vertexTangents = e.vertexTangents, n.toneMapping = e.toneMapping;
    }
    function jt(t, e, n, i, r) {
      !0 !== e.isScene && (e = H), $.resetTextureUnits();
      let o = e.fog,
        s = i.isMeshStandardMaterial ? e.environment : null,
        a = null === w ? _.outputColorSpace : !0 === w.isXRRenderTarget ? w.texture.colorSpace : Cl,
        l = (i.isMeshStandardMaterial ? et : tt).get(i.envMap || s),
        u = !0 === i.vertexColors && !!n.attributes.color && 4 === n.attributes.color.itemSize,
        h = !!n.attributes.tangent && (!!i.normalMap || i.anisotropy > 0),
        c = !!n.morphAttributes.position,
        p = !!n.morphAttributes.normal,
        d = !!n.morphAttributes.color,
        f = i.toneMapped ? _.toneMapping : Au,
        m = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color,
        v = void 0 !== m ? m.length : 0,
        y = Q.get(i),
        x = g.state.lights;
      if (!0 === B && (!0 === z || t !== M)) {
        let e = t === M && i.id === S;
        ut.setState(i, t, e);
      }
      let E = !1;
      i.version === y.__version ? (y.needsLights && y.lightsStateVersion !== x.state.version || y.outputColorSpace !== a || r.isInstancedMesh && !1 === y.instancing || !r.isInstancedMesh && !0 === y.instancing || r.isSkinnedMesh && !1 === y.skinning || !r.isSkinnedMesh && !0 === y.skinning || y.envMap !== l || !0 === i.fog && y.fog !== o || void 0 !== y.numClippingPlanes && (y.numClippingPlanes !== ut.numPlanes || y.numIntersection !== ut.numIntersection) || y.vertexAlphas !== u || y.vertexTangents !== h || y.morphTargets !== c || y.morphNormals !== p || y.morphColors !== d || y.toneMapping !== f || !0 === Z.isWebGL2 && y.morphTargetsCount !== v) && (E = !0) : (E = !0, y.__version = i.version);
      let b = y.currentProgram;
      !0 === E && (b = zt(i, e, r));
      let T = !1,
        A = !1,
        P = !1,
        C = b.getUniforms(),
        I = y.uniforms;
      if (J.useProgram(b.program) && (T = !0, A = !0, P = !0), i.id !== S && (S = i.id, A = !0), T || M !== t) {
        if (C.setValue(_t, "projectionMatrix", t.projectionMatrix), Z.logarithmicDepthBuffer && C.setValue(_t, "logDepthBufFC", 2 / (Math.log(t.far + 1) / Math.LN2)), M !== t && (M = t, A = !0, P = !0), i.isShaderMaterial || i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshStandardMaterial || i.envMap) {
          let e = C.map.cameraPosition;
          void 0 !== e && e.setValue(_t, W.setFromMatrixPosition(t.matrixWorld));
        }
        (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial) && C.setValue(_t, "isOrthographic", !0 === t.isOrthographicCamera), (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial || i.isShadowMaterial || r.isSkinnedMesh) && C.setValue(_t, "viewMatrix", t.matrixWorldInverse);
      }
      if (r.isSkinnedMesh) {
        C.setOptional(_t, r, "bindMatrix"), C.setOptional(_t, r, "bindMatrixInverse");
        let t = r.skeleton;
        t && (Z.floatVertexTextures ? (null === t.boneTexture && t.computeBoneTexture(), C.setValue(_t, "boneTexture", t.boneTexture, $), C.setValue(_t, "boneTextureSize", t.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
      }
      let N = n.morphAttributes;
      if ((void 0 !== N.position || void 0 !== N.normal || void 0 !== N.color && !0 === Z.isWebGL2) && pt.update(r, n, b), (A || y.receiveShadow !== r.receiveShadow) && (y.receiveShadow = r.receiveShadow, C.setValue(_t, "receiveShadow", r.receiveShadow)), i.isMeshGouraudMaterial && null !== i.envMap && (I.envMap.value = l, I.flipEnvMap.value = l.isCubeTexture && !1 === l.isRenderTargetTexture ? -1 : 1), A && (C.setValue(_t, "toneMappingExposure", _.toneMappingExposure), y.needsLights && Gt(I, P), o && !0 === i.fog && st.refreshFogUniforms(I, o), st.refreshMaterialUniforms(I, i, R, L, V), gd.upload(_t, y.uniformsList, I, $)), i.isShaderMaterial && !0 === i.uniformsNeedUpdate && (gd.upload(_t, y.uniformsList, I, $), i.uniformsNeedUpdate = !1), i.isSpriteMaterial && C.setValue(_t, "center", r.center), C.setValue(_t, "modelViewMatrix", r.modelViewMatrix), C.setValue(_t, "normalMatrix", r.normalMatrix), C.setValue(_t, "modelMatrix", r.matrixWorld), i.isShaderMaterial || i.isRawShaderMaterial) {
        let t = i.uniformsGroups;
        for (let e = 0, n = t.length; e < n; e++) if (Z.isWebGL2) {
          let n = t[e];
          vt.update(n, b), vt.bind(n, b);
        } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
      }
      return b;
    }
    function Gt(t, e) {
      t.ambientLightColor.needsUpdate = e, t.lightProbe.needsUpdate = e, t.directionalLights.needsUpdate = e, t.directionalLightShadows.needsUpdate = e, t.pointLights.needsUpdate = e, t.pointLightShadows.needsUpdate = e, t.spotLights.needsUpdate = e, t.spotLightShadows.needsUpdate = e, t.rectAreaLights.needsUpdate = e, t.hemisphereLights.needsUpdate = e;
    }
    function Wt(t) {
      return t.isMeshLambertMaterial || t.isMeshToonMaterial || t.isMeshPhongMaterial || t.isMeshStandardMaterial || t.isShadowMaterial || t.isShaderMaterial && !0 === t.lights;
    }
    Ot.setAnimationLoop(It), "undefined" != typeof self && Ot.setContext(self), this.setAnimationLoop = function (t) {
      Ct = t, bt.setAnimationLoop(t), null === t ? Ot.stop() : Ot.start();
    }, bt.addEventListener("sessionstart", Lt), bt.addEventListener("sessionend", Rt), this.render = function (t, e) {
      if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
      if (!0 === x) return;
      !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), null === e.parent && !0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), !0 === bt.enabled && !0 === bt.isPresenting && (e = bt.updateCameraXR(e)), !0 === t.isScene && t.onBeforeRender(_, t, e, w), g = lt.get(t, y.length), g.init(), y.push(g), j.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), U.setFromProjectionMatrix(j), z = this.localClippingEnabled, B = ut.init(this.clippingPlanes, z), m = at.get(t, v.length), m.init(), v.push(m), qt(t, e, 0, _.sortObjects), m.finish(), !0 === _.sortObjects && m.sort(O, q), !0 === B && ut.beginShadows();
      let n = g.state.shadowsArray;
      if (ht.render(n, t, e), !0 === B && ut.endShadows(), !0 === this.info.autoReset && this.info.reset(), this.info.render.frame++, ct.render(m, t), g.setupLights(_.useLegacyLights), e.isArrayCamera) {
        let n = e.cameras;
        for (let e = 0, i = n.length; e < i; e++) {
          let i = n[e];
          Dt(m, t, i, i.viewport);
        }
      } else Dt(m, t, e);
      null !== w && ($.updateMultisampleRenderTarget(w), $.updateRenderTargetMipmap(w)), !0 === t.isScene && t.onAfterRender(_, t, e), gt.resetDefaultState(), S = -1, M = null, y.pop(), g = y.length > 0 ? y[y.length - 1] : null, v.pop(), m = v.length > 0 ? v[v.length - 1] : null;
    }, u(qt, "projectObject"), u(Dt, "renderScene"), u(kt, "renderTransmissionPass"), u(Ft, "renderObjects"), u(Ut, "renderObject"), u(zt, "getProgram"), u(Vt, "updateCommonMaterialProperties"), u(jt, "setProgram"), u(Gt, "markUniformsLightsNeedsUpdate"), u(Wt, "materialNeedsLights"), this.getActiveCubeFace = function () {
      return E;
    }, this.getActiveMipmapLevel = function () {
      return b;
    }, this.getRenderTarget = function () {
      return w;
    }, this.setRenderTargetTextures = function (t, e, n) {
      Q.get(t.texture).__webglTexture = e, Q.get(t.depthTexture).__webglTexture = n;
      let i = Q.get(t);
      i.__hasExternalTextures = !0, i.__hasExternalTextures && (i.__autoAllocateDepthBuffer = void 0 === n, i.__autoAllocateDepthBuffer || !0 === Y.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), i.__useRenderToTexture = !1));
    }, this.setRenderTargetFramebuffer = function (t, e) {
      let n = Q.get(t);
      n.__webglFramebuffer = e, n.__useDefaultFramebuffer = void 0 === e;
    }, this.setRenderTarget = function (t, e = 0, n = 0) {
      w = t, E = e, b = n;
      let i = !0,
        r = null,
        o = !1,
        s = !1;
      if (t) {
        let n = Q.get(t);
        void 0 !== n.__useDefaultFramebuffer ? (J.bindFramebuffer(_t.FRAMEBUFFER, null), i = !1) : void 0 === n.__webglFramebuffer ? $.setupRenderTarget(t) : n.__hasExternalTextures && $.rebindTextures(t, Q.get(t.texture).__webglTexture, Q.get(t.depthTexture).__webglTexture);
        let a = t.texture;
        (a.isData3DTexture || a.isDataArrayTexture || a.isCompressedArrayTexture) && (s = !0);
        let l = Q.get(t).__webglFramebuffer;
        t.isWebGLCubeRenderTarget ? (r = l[e], o = !0) : r = Z.isWebGL2 && t.samples > 0 && !1 === $.useMultisampledRTT(t) ? Q.get(t).__webglMultisampledFramebuffer : l, T.copy(t.viewport), A.copy(t.scissor), P = t.scissorTest;
      } else T.copy(D).multiplyScalar(R).floor(), A.copy(k).multiplyScalar(R).floor(), P = F;
      if (J.bindFramebuffer(_t.FRAMEBUFFER, r) && Z.drawBuffers && i && J.drawBuffers(t, r), J.viewport(T), J.scissor(A), J.setScissorTest(P), o) {
        let i = Q.get(t.texture);
        _t.framebufferTexture2D(_t.FRAMEBUFFER, _t.COLOR_ATTACHMENT0, _t.TEXTURE_CUBE_MAP_POSITIVE_X + e, i.__webglTexture, n);
      } else if (s) {
        let i = Q.get(t.texture),
          r = e || 0;
        _t.framebufferTextureLayer(_t.FRAMEBUFFER, _t.COLOR_ATTACHMENT0, i.__webglTexture, n || 0, r);
      }
      S = -1;
    }, this.readRenderTargetPixels = function (t, e, n, i, r, o, s) {
      if (!t || !t.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      let a = Q.get(t).__webglFramebuffer;
      if (t.isWebGLCubeRenderTarget && void 0 !== s && (a = a[s]), a) {
        J.bindFramebuffer(_t.FRAMEBUFFER, a);
        try {
          let s = t.texture,
            a = s.format,
            l = s.type;
          if (a !== Po && mt.convert(a) !== _t.getParameter(_t.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
          let u = l === Iu && (Y.has("EXT_color_buffer_half_float") || Z.isWebGL2 && Y.has("EXT_color_buffer_float"));
          if (!(l === Wc || mt.convert(l) === _t.getParameter(_t.IMPLEMENTATION_COLOR_READ_TYPE) || l === Tl && (Z.isWebGL2 || Y.has("OES_texture_float") || Y.has("WEBGL_color_buffer_float")) || u)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
          e >= 0 && e <= t.width - i && n >= 0 && n <= t.height - r && _t.readPixels(e, n, i, r, mt.convert(a), mt.convert(l), o);
        } finally {
          let t = null !== w ? Q.get(w).__webglFramebuffer : null;
          J.bindFramebuffer(_t.FRAMEBUFFER, t);
        }
      }
    }, this.copyFramebufferToTexture = function (t, e, n = 0) {
      let i = Math.pow(2, -n),
        r = Math.floor(e.image.width * i),
        o = Math.floor(e.image.height * i);
      $.setTexture2D(e, 0), _t.copyTexSubImage2D(_t.TEXTURE_2D, n, 0, 0, t.x, t.y, r, o), J.unbindTexture();
    }, this.copyTextureToTexture = function (t, e, n, i = 0) {
      let r = e.image.width,
        o = e.image.height,
        s = mt.convert(n.format),
        a = mt.convert(n.type);
      $.setTexture2D(n, 0), _t.pixelStorei(_t.UNPACK_FLIP_Y_WEBGL, n.flipY), _t.pixelStorei(_t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), _t.pixelStorei(_t.UNPACK_ALIGNMENT, n.unpackAlignment), e.isDataTexture ? _t.texSubImage2D(_t.TEXTURE_2D, i, t.x, t.y, r, o, s, a, e.image.data) : e.isCompressedTexture ? _t.compressedTexSubImage2D(_t.TEXTURE_2D, i, t.x, t.y, e.mipmaps[0].width, e.mipmaps[0].height, s, e.mipmaps[0].data) : _t.texSubImage2D(_t.TEXTURE_2D, i, t.x, t.y, s, a, e.image), 0 === i && n.generateMipmaps && _t.generateMipmap(_t.TEXTURE_2D), J.unbindTexture();
    }, this.copyTextureToTexture3D = function (t, e, n, i, r = 0) {
      if (_.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
      let o,
        s = t.max.x - t.min.x + 1,
        a = t.max.y - t.min.y + 1,
        l = t.max.z - t.min.z + 1,
        u = mt.convert(i.format),
        h = mt.convert(i.type);
      if (i.isData3DTexture) $.setTexture3D(i, 0), o = _t.TEXTURE_3D;else {
        if (!i.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
        $.setTexture2DArray(i, 0), o = _t.TEXTURE_2D_ARRAY;
      }
      _t.pixelStorei(_t.UNPACK_FLIP_Y_WEBGL, i.flipY), _t.pixelStorei(_t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, i.premultiplyAlpha), _t.pixelStorei(_t.UNPACK_ALIGNMENT, i.unpackAlignment);
      let c = _t.getParameter(_t.UNPACK_ROW_LENGTH),
        p = _t.getParameter(_t.UNPACK_IMAGE_HEIGHT),
        d = _t.getParameter(_t.UNPACK_SKIP_PIXELS),
        f = _t.getParameter(_t.UNPACK_SKIP_ROWS),
        m = _t.getParameter(_t.UNPACK_SKIP_IMAGES),
        g = n.isCompressedTexture ? n.mipmaps[0] : n.image;
      _t.pixelStorei(_t.UNPACK_ROW_LENGTH, g.width), _t.pixelStorei(_t.UNPACK_IMAGE_HEIGHT, g.height), _t.pixelStorei(_t.UNPACK_SKIP_PIXELS, t.min.x), _t.pixelStorei(_t.UNPACK_SKIP_ROWS, t.min.y), _t.pixelStorei(_t.UNPACK_SKIP_IMAGES, t.min.z), n.isDataTexture || n.isData3DTexture ? _t.texSubImage3D(o, r, e.x, e.y, e.z, s, a, l, u, h, g.data) : n.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), _t.compressedTexSubImage3D(o, r, e.x, e.y, e.z, s, a, l, u, g.data)) : _t.texSubImage3D(o, r, e.x, e.y, e.z, s, a, l, u, h, g), _t.pixelStorei(_t.UNPACK_ROW_LENGTH, c), _t.pixelStorei(_t.UNPACK_IMAGE_HEIGHT, p), _t.pixelStorei(_t.UNPACK_SKIP_PIXELS, d), _t.pixelStorei(_t.UNPACK_SKIP_ROWS, f), _t.pixelStorei(_t.UNPACK_SKIP_IMAGES, m), 0 === r && i.generateMipmaps && _t.generateMipmap(o), J.unbindTexture();
    }, this.initTexture = function (t) {
      t.isCubeTexture ? $.setTextureCube(t, 0) : t.isData3DTexture ? $.setTexture3D(t, 0) : t.isDataArrayTexture || t.isCompressedArrayTexture ? $.setTexture2DArray(t, 0) : $.setTexture2D(t, 0), J.unbindTexture();
    }, this.resetState = function () {
      E = 0, b = 0, w = null, J.reset(), gt.reset();
    }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
      detail: this
    }));
  }
  get coordinateSystem() {
    return Nu;
  }
  get physicallyCorrectLights() {
    return console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), !this.useLegacyLights;
  }
  set physicallyCorrectLights(t) {
    console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), this.useLegacyLights = !t;
  }
  get outputEncoding() {
    return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace === Nt ? Pl : HI;
  }
  set outputEncoding(t) {
    console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace = t === Pl ? Nt : Cl;
  }
};
u(vd, "WebGLRenderer");
var yd = class extends vd {};
u(yd, "WebGL1Renderer"), yd.prototype.isWebGL1Renderer = !0;
var _d = class extends jn {
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
      detail: this
    }));
  }
  copy(t, e) {
    return super.copy(t, e), null !== t.background && (this.background = t.background.clone()), null !== t.environment && (this.environment = t.environment.clone()), null !== t.fog && (this.fog = t.fog.clone()), this.backgroundBlurriness = t.backgroundBlurriness, this.backgroundIntensity = t.backgroundIntensity, null !== t.overrideMaterial && (this.overrideMaterial = t.overrideMaterial.clone()), this.matrixAutoUpdate = t.matrixAutoUpdate, this;
  }
  toJSON(t) {
    let e = super.toJSON(t);
    return null !== this.fog && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (e.object.backgroundIntensity = this.backgroundIntensity), e;
  }
  get autoUpdate() {
    return console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate;
  }
  set autoUpdate(t) {
    console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate = t;
  }
};
u(_d, "Scene");
var Lx = class extends lo {
  constructor(t = null, e = 1, n = 1, i, r, o, s, a, l = ni, u = ni, h, c) {
    super(null, o, s, a, l, u, i, r, h, c), this.isDataTexture = !0, this.image = {
      data: t,
      width: e,
      height: n
    }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
};
u(Lx, "DataTexture");
var Gu = class extends ui {
  constructor(t, e, n, i = 1) {
    super(t, e, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
  }
  copy(t) {
    return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
  }
};
u(Gu, "InstancedBufferAttribute");
var Hg = class extends $c {
  constructor(t) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new yt(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
  }
};
u(Hg, "LineBasicMaterial");
var U8 = new ne(),
  z8 = new ne(),
  V8 = new Bt(),
  bS = new Fg(),
  Ox = new Zc(),
  MS = class extends jn {
    constructor(t = new Pi(), e = new Hg()) {
      super(), this.isLine = !0, this.type = "Line", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
      return super.copy(t, e), this.material = t.material, this.geometry = t.geometry, this;
    }
    computeLineDistances() {
      let t = this.geometry;
      if (null === t.index) {
        let e = t.attributes.position,
          n = [0];
        for (let t = 1, i = e.count; t < i; t++) U8.fromBufferAttribute(e, t - 1), z8.fromBufferAttribute(e, t), n[t] = n[t - 1], n[t] += U8.distanceTo(z8);
        t.setAttribute("lineDistance", new Di(n, 1));
      } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      return this;
    }
    raycast(t, e) {
      let n = this.geometry,
        i = this.matrixWorld,
        r = t.params.Line.threshold,
        o = n.drawRange;
      if (null === n.boundingSphere && n.computeBoundingSphere(), Ox.copy(n.boundingSphere), Ox.applyMatrix4(i), Ox.radius += r, !1 === t.ray.intersectsSphere(Ox)) return;
      V8.copy(i).invert(), bS.copy(t.ray).applyMatrix4(V8);
      let s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
        a = s * s,
        l = new ne(),
        u = new ne(),
        h = new ne(),
        c = new ne(),
        p = this.isLineSegments ? 2 : 1,
        d = n.index,
        f = n.attributes.position;
      if (null !== d) {
        for (let n = Math.max(0, o.start), i = Math.min(d.count, o.start + o.count) - 1; n < i; n += p) {
          let i = d.getX(n),
            r = d.getX(n + 1);
          if (l.fromBufferAttribute(f, i), u.fromBufferAttribute(f, r), bS.distanceSqToSegment(l, u, c, h) > a) continue;
          c.applyMatrix4(this.matrixWorld);
          let o = t.ray.origin.distanceTo(c);
          o < t.near || o > t.far || e.push({
            distance: o,
            point: h.clone().applyMatrix4(this.matrixWorld),
            index: n,
            face: null,
            faceIndex: null,
            object: this
          });
        }
      } else {
        for (let n = Math.max(0, o.start), i = Math.min(f.count, o.start + o.count) - 1; n < i; n += p) {
          if (l.fromBufferAttribute(f, n), u.fromBufferAttribute(f, n + 1), bS.distanceSqToSegment(l, u, c, h) > a) continue;
          c.applyMatrix4(this.matrixWorld);
          let i = t.ray.origin.distanceTo(c);
          i < t.near || i > t.far || e.push({
            distance: i,
            point: h.clone().applyMatrix4(this.matrixWorld),
            index: n,
            face: null,
            faceIndex: null,
            object: this
          });
        }
      }
    }
    updateMorphTargets() {
      let t = this.geometry.morphAttributes,
        e = Object.keys(t);
      if (e.length > 0) {
        let n = t[e[0]];
        if (void 0 !== n) {
          this.morphTargetInfluences = [], this.morphTargetDictionary = {};
          for (let t = 0, e = n.length; t < e; t++) {
            let e = n[t].name || String(t);
            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t;
          }
        }
      }
    }
  };
u(MS, "Line");
var G8 = new ne(),
  H8 = new ne(),
  Rx = class extends MS {
    constructor(t, e) {
      super(t, e), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
      let t = this.geometry;
      if (null === t.index) {
        let e = t.attributes.position,
          n = [];
        for (let t = 0, i = e.count; t < i; t += 2) G8.fromBufferAttribute(e, t), H8.fromBufferAttribute(e, t + 1), n[t] = 0 === t ? 0 : n[t - 1], n[t + 1] = n[t] + G8.distanceTo(H8);
        t.setAttribute("lineDistance", new Di(n, 1));
      } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      return this;
    }
  };
u(Rx, "LineSegments");
var df = class extends lo {
  constructor(t, e, n, i, r, o, s, a, l) {
    super(t, e, n, i, r, o, s, a, l), this.isCanvasTexture = !0, this.needsUpdate = !0;
  }
};
u(df, "CanvasTexture");
var fa = class {
  constructor() {
    this.type = "Curve", this.arcLengthDivisions = 200;
  }
  getPoint() {
    return console.warn("THREE.Curve: .getPoint() not implemented."), null;
  }
  getPointAt(t, e) {
    let n = this.getUtoTmapping(t);
    return this.getPoint(n, e);
  }
  getPoints(t = 5) {
    let e = [];
    for (let n = 0; n <= t; n++) e.push(this.getPoint(n / t));
    return e;
  }
  getSpacedPoints(t = 5) {
    let e = [];
    for (let n = 0; n <= t; n++) e.push(this.getPointAt(n / t));
    return e;
  }
  getLength() {
    let t = this.getLengths();
    return t[t.length - 1];
  }
  getLengths(t = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
    this.needsUpdate = !1;
    let e,
      n = [],
      i = this.getPoint(0),
      r = 0;
    n.push(0);
    for (let o = 1; o <= t; o++) e = this.getPoint(o / t), r += e.distanceTo(i), n.push(r), i = e;
    return this.cacheArcLengths = n, n;
  }
  updateArcLengths() {
    this.needsUpdate = !0, this.getLengths();
  }
  getUtoTmapping(t, e) {
    let n,
      i = this.getLengths(),
      r = 0,
      o = i.length;
    n = e || t * i[o - 1];
    let s,
      a = 0,
      l = o - 1;
    for (; a <= l;) if (r = Math.floor(a + (l - a) / 2), s = i[r] - n, s < 0) a = r + 1;else {
      if (!(s > 0)) {
        l = r;
        break;
      }
      l = r - 1;
    }
    if (r = l, i[r] === n) return r / (o - 1);
    let u = i[r];
    return (r + (n - u) / (i[r + 1] - u)) / (o - 1);
  }
  getTangent(t, e) {
    let n = 1e-4,
      i = t - n,
      r = t + n;
    i < 0 && (i = 0), r > 1 && (r = 1);
    let o = this.getPoint(i),
      s = this.getPoint(r),
      a = e || (o.isVector2 ? new je() : new ne());
    return a.copy(s).sub(o).normalize(), a;
  }
  getTangentAt(t, e) {
    let n = this.getUtoTmapping(t);
    return this.getTangent(n, e);
  }
  computeFrenetFrames(t, e) {
    let n = new ne(),
      i = [],
      r = [],
      o = [],
      s = new ne(),
      a = new Bt();
    for (let e = 0; e <= t; e++) {
      let n = e / t;
      i[e] = this.getTangentAt(n, new ne());
    }
    r[0] = new ne(), o[0] = new ne();
    let l = Number.MAX_VALUE,
      u = Math.abs(i[0].x),
      h = Math.abs(i[0].y),
      c = Math.abs(i[0].z);
    u <= l && (l = u, n.set(1, 0, 0)), h <= l && (l = h, n.set(0, 1, 0)), c <= l && n.set(0, 0, 1), s.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], s), o[0].crossVectors(i[0], r[0]);
    for (let e = 1; e <= t; e++) {
      if (r[e] = r[e - 1].clone(), o[e] = o[e - 1].clone(), s.crossVectors(i[e - 1], i[e]), s.length() > Number.EPSILON) {
        s.normalize();
        let t = Math.acos(jo(i[e - 1].dot(i[e]), -1, 1));
        r[e].applyMatrix4(a.makeRotationAxis(s, t));
      }
      o[e].crossVectors(i[e], r[e]);
    }
    if (!0 === e) {
      let e = Math.acos(jo(r[0].dot(r[t]), -1, 1));
      e /= t, i[0].dot(s.crossVectors(r[0], r[t])) > 0 && (e = -e);
      for (let n = 1; n <= t; n++) r[n].applyMatrix4(a.makeRotationAxis(i[n], e * n)), o[n].crossVectors(i[n], r[n]);
    }
    return {
      tangents: i,
      normals: r,
      binormals: o
    };
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return this.arcLengthDivisions = t.arcLengthDivisions, this;
  }
  toJSON() {
    let t = {
      metadata: {
        version: 4.6,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
  }
  fromJSON(t) {
    return this.arcLengthDivisions = t.arcLengthDivisions, this;
  }
};
u(fa, "Curve");
var jg = class extends fa {
  constructor(t = 0, e = 0, n = 1, i = 1, r = 0, o = 2 * Math.PI, s = !1, a = 0) {
    super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t, this.aY = e, this.xRadius = n, this.yRadius = i, this.aStartAngle = r, this.aEndAngle = o, this.aClockwise = s, this.aRotation = a;
  }
  getPoint(t, e) {
    let n = e || new je(),
      i = 2 * Math.PI,
      r = this.aEndAngle - this.aStartAngle,
      o = Math.abs(r) < Number.EPSILON;
    for (; r < 0;) r += i;
    for (; r > i;) r -= i;
    r < Number.EPSILON && (r = o ? 0 : i), !0 === this.aClockwise && !o && (r === i ? r = -i : r -= i);
    let s = this.aStartAngle + t * r,
      a = this.aX + this.xRadius * Math.cos(s),
      l = this.aY + this.yRadius * Math.sin(s);
    if (0 !== this.aRotation) {
      let t = Math.cos(this.aRotation),
        e = Math.sin(this.aRotation),
        n = a - this.aX,
        i = l - this.aY;
      a = n * t - i * e + this.aX, l = n * e + i * t + this.aY;
    }
    return n.set(a, l);
  }
  copy(t) {
    return super.copy(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
  }
};
u(jg, "EllipseCurve");
var ES = class extends jg {
  constructor(t, e, n, i, r, o) {
    super(t, e, n, n, i, r, o), this.isArcCurve = !0, this.type = "ArcCurve";
  }
};
function wS() {
  let t = 0,
    e = 0,
    n = 0,
    i = 0;
  function r(r, o, s, a) {
    t = r, e = s, n = -3 * r + 3 * o - 2 * s - a, i = 2 * r - 2 * o + s + a;
  }
  return u(r, "init"), {
    initCatmullRom: function (t, e, n, i, o) {
      r(e, n, o * (n - t), o * (i - e));
    },
    initNonuniformCatmullRom: function (t, e, n, i, o, s, a) {
      let l = (e - t) / o - (n - t) / (o + s) + (n - e) / s,
        u = (n - e) / s - (i - e) / (s + a) + (i - n) / a;
      l *= s, u *= s, r(e, n, l, u);
    },
    calc: function (r) {
      let o = r * r;
      return t + e * r + n * o + i * (o * r);
    }
  };
}
u(ES, "ArcCurve"), u(wS, "CubicPoly");
var Nx = new ne(),
  SS = new wS(),
  TS = new wS(),
  PS = new wS(),
  Wg = class extends fa {
    constructor(t = [], e = !1, n = "centripetal", i = .5) {
      super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t, this.closed = e, this.curveType = n, this.tension = i;
    }
    getPoint(t, e = new ne()) {
      let n,
        i,
        r = e,
        o = this.points,
        s = o.length,
        a = (s - (this.closed ? 0 : 1)) * t,
        l = Math.floor(a),
        u = a - l;
      this.closed ? l += l > 0 ? 0 : (Math.floor(Math.abs(l) / s) + 1) * s : 0 === u && l === s - 1 && (l = s - 2, u = 1), this.closed || l > 0 ? n = o[(l - 1) % s] : (Nx.subVectors(o[0], o[1]).add(o[0]), n = Nx);
      let h = o[l % s],
        c = o[(l + 1) % s];
      if (this.closed || l + 2 < s ? i = o[(l + 2) % s] : (Nx.subVectors(o[s - 1], o[s - 2]).add(o[s - 1]), i = Nx), "centripetal" === this.curveType || "chordal" === this.curveType) {
        let t = "chordal" === this.curveType ? .5 : .25,
          e = Math.pow(n.distanceToSquared(h), t),
          r = Math.pow(h.distanceToSquared(c), t),
          o = Math.pow(c.distanceToSquared(i), t);
        r < 1e-4 && (r = 1), e < 1e-4 && (e = r), o < 1e-4 && (o = r), SS.initNonuniformCatmullRom(n.x, h.x, c.x, i.x, e, r, o), TS.initNonuniformCatmullRom(n.y, h.y, c.y, i.y, e, r, o), PS.initNonuniformCatmullRom(n.z, h.z, c.z, i.z, e, r, o);
      } else "catmullrom" === this.curveType && (SS.initCatmullRom(n.x, h.x, c.x, i.x, this.tension), TS.initCatmullRom(n.y, h.y, c.y, i.y, this.tension), PS.initCatmullRom(n.z, h.z, c.z, i.z, this.tension));
      return r.set(SS.calc(u), TS.calc(u), PS.calc(u)), r;
    }
    copy(t) {
      super.copy(t), this.points = [];
      for (let e = 0, n = t.points.length; e < n; e++) {
        let n = t.points[e];
        this.points.push(n.clone());
      }
      return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
    toJSON() {
      let t = super.toJSON();
      t.points = [];
      for (let e = 0, n = this.points.length; e < n; e++) {
        let n = this.points[e];
        t.points.push(n.toArray());
      }
      return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
    }
    fromJSON(t) {
      super.fromJSON(t), this.points = [];
      for (let e = 0, n = t.points.length; e < n; e++) {
        let n = t.points[e];
        this.points.push(new ne().fromArray(n));
      }
      return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
  };
function j8(t, e, n, i, r) {
  let o = .5 * (i - e),
    s = .5 * (r - n),
    a = t * t;
  return (2 * n - 2 * i + o + s) * (t * a) + (-3 * n + 3 * i - 2 * o - s) * a + o * t + n;
}
function EX(t, e) {
  let n = 1 - t;
  return n * n * e;
}
function wX(t, e) {
  return 2 * (1 - t) * t * e;
}
function SX(t, e) {
  return t * t * e;
}
function Xg(t, e, n, i) {
  return EX(t, e) + wX(t, n) + SX(t, i);
}
function TX(t, e) {
  let n = 1 - t;
  return n * n * n * e;
}
function PX(t, e) {
  let n = 1 - t;
  return 3 * n * n * t * e;
}
function CX(t, e) {
  return 3 * (1 - t) * t * t * e;
}
function AX(t, e) {
  return t * t * t * e;
}
function Yg(t, e, n, i, r) {
  return TX(t, e) + PX(t, n) + CX(t, i) + AX(t, r);
}
u(Wg, "CatmullRomCurve3"), u(j8, "CatmullRom"), u(EX, "QuadraticBezierP0"), u(wX, "QuadraticBezierP1"), u(SX, "QuadraticBezierP2"), u(Xg, "QuadraticBezier"), u(TX, "CubicBezierP0"), u(PX, "CubicBezierP1"), u(CX, "CubicBezierP2"), u(AX, "CubicBezierP3"), u(Yg, "CubicBezier");
var Dx = class extends fa {
  constructor(t = new je(), e = new je(), n = new je(), i = new je()) {
    super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t, this.v1 = e, this.v2 = n, this.v3 = i;
  }
  getPoint(t, e = new je()) {
    let n = e,
      i = this.v0,
      r = this.v1,
      o = this.v2,
      s = this.v3;
    return n.set(Yg(t, i.x, r.x, o.x, s.x), Yg(t, i.y, r.y, o.y, s.y)), n;
  }
  copy(t) {
    return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
  }
};
u(Dx, "CubicBezierCurve");
var CS = class extends fa {
  constructor(t = new ne(), e = new ne(), n = new ne(), i = new ne()) {
    super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = n, this.v3 = i;
  }
  getPoint(t, e = new ne()) {
    let n = e,
      i = this.v0,
      r = this.v1,
      o = this.v2,
      s = this.v3;
    return n.set(Yg(t, i.x, r.x, o.x, s.x), Yg(t, i.y, r.y, o.y, s.y), Yg(t, i.z, r.z, o.z, s.z)), n;
  }
  copy(t) {
    return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
  }
};
u(CS, "CubicBezierCurve3");
var Zg = class extends fa {
  constructor(t = new je(), e = new je()) {
    super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t, this.v2 = e;
  }
  getPoint(t, e = new je()) {
    let n = e;
    return 1 === t ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
  }
  getPointAt(t, e) {
    return this.getPoint(t, e);
  }
  getTangent(t, e = new je()) {
    return e.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(t, e) {
    return this.getTangent(t, e);
  }
  copy(t) {
    return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
  }
};
u(Zg, "LineCurve");
var AS = class extends fa {
  constructor(t = new ne(), e = new ne()) {
    super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t, this.v2 = e;
  }
  getPoint(t, e = new ne()) {
    let n = e;
    return 1 === t ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
  }
  getPointAt(t, e) {
    return this.getPoint(t, e);
  }
  getTangent(t, e = new ne()) {
    return e.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(t, e) {
    return this.getTangent(t, e);
  }
  copy(t) {
    return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
  }
};
u(AS, "LineCurve3");
var qx = class extends fa {
  constructor(t = new je(), e = new je(), n = new je()) {
    super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t, this.v1 = e, this.v2 = n;
  }
  getPoint(t, e = new je()) {
    let n = e,
      i = this.v0,
      r = this.v1,
      o = this.v2;
    return n.set(Xg(t, i.x, r.x, o.x), Xg(t, i.y, r.y, o.y)), n;
  }
  copy(t) {
    return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
  }
};
u(qx, "QuadraticBezierCurve");
var kx = class extends fa {
  constructor(t = new ne(), e = new ne(), n = new ne()) {
    super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = n;
  }
  getPoint(t, e = new ne()) {
    let n = e,
      i = this.v0,
      r = this.v1,
      o = this.v2;
    return n.set(Xg(t, i.x, r.x, o.x), Xg(t, i.y, r.y, o.y), Xg(t, i.z, r.z, o.z)), n;
  }
  copy(t) {
    return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
  }
};
u(kx, "QuadraticBezierCurve3");
var Fx = class extends fa {
  constructor(t = []) {
    super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t;
  }
  getPoint(t, e = new je()) {
    let n = e,
      i = this.points,
      r = (i.length - 1) * t,
      o = Math.floor(r),
      s = r - o,
      a = i[0 === o ? o : o - 1],
      l = i[o],
      u = i[o > i.length - 2 ? i.length - 1 : o + 1],
      h = i[o > i.length - 3 ? i.length - 1 : o + 2];
    return n.set(j8(s, a.x, l.x, u.x, h.x), j8(s, a.y, l.y, u.y, h.y)), n;
  }
  copy(t) {
    super.copy(t), this.points = [];
    for (let e = 0, n = t.points.length; e < n; e++) {
      let n = t.points[e];
      this.points.push(n.clone());
    }
    return this;
  }
  toJSON() {
    let t = super.toJSON();
    t.points = [];
    for (let e = 0, n = this.points.length; e < n; e++) {
      let n = this.points[e];
      t.points.push(n.toArray());
    }
    return t;
  }
  fromJSON(t) {
    super.fromJSON(t), this.points = [];
    for (let e = 0, n = t.points.length; e < n; e++) {
      let n = t.points[e];
      this.points.push(new je().fromArray(n));
    }
    return this;
  }
};
u(Fx, "SplineCurve");
var IS = Object.freeze({
    __proto__: null,
    ArcCurve: ES,
    CatmullRomCurve3: Wg,
    CubicBezierCurve: Dx,
    CubicBezierCurve3: CS,
    EllipseCurve: jg,
    LineCurve: Zg,
    LineCurve3: AS,
    QuadraticBezierCurve: qx,
    QuadraticBezierCurve3: kx,
    SplineCurve: Fx
  }),
  LS = class extends fa {
    constructor() {
      super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
    }
    add(t) {
      this.curves.push(t);
    }
    closePath() {
      let t = this.curves[0].getPoint(0),
        e = this.curves[this.curves.length - 1].getPoint(1);
      t.equals(e) || this.curves.push(new Zg(e, t));
    }
    getPoint(t, e) {
      let n = t * this.getLength(),
        i = this.getCurveLengths(),
        r = 0;
      for (; r < i.length;) {
        if (i[r] >= n) {
          let t = i[r] - n,
            o = this.curves[r],
            s = o.getLength(),
            a = 0 === s ? 0 : 1 - t / s;
          return o.getPointAt(a, e);
        }
        r++;
      }
      return null;
    }
    getLength() {
      let t = this.getCurveLengths();
      return t[t.length - 1];
    }
    updateArcLengths() {
      this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
    getCurveLengths() {
      if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
      let t = [],
        e = 0;
      for (let n = 0, i = this.curves.length; n < i; n++) e += this.curves[n].getLength(), t.push(e);
      return this.cacheLengths = t, t;
    }
    getSpacedPoints(t = 40) {
      let e = [];
      for (let n = 0; n <= t; n++) e.push(this.getPoint(n / t));
      return this.autoClose && e.push(e[0]), e;
    }
    getPoints(t = 12) {
      let e,
        n = [];
      for (let i = 0, r = this.curves; i < r.length; i++) {
        let o = r[i],
          s = o.isEllipseCurve ? 2 * t : o.isLineCurve || o.isLineCurve3 ? 1 : o.isSplineCurve ? t * o.points.length : t,
          a = o.getPoints(s);
        for (let t = 0; t < a.length; t++) {
          let i = a[t];
          e && e.equals(i) || (n.push(i), e = i);
        }
      }
      return this.autoClose && n.length > 1 && !n[n.length - 1].equals(n[0]) && n.push(n[0]), n;
    }
    copy(t) {
      super.copy(t), this.curves = [];
      for (let e = 0, n = t.curves.length; e < n; e++) {
        let n = t.curves[e];
        this.curves.push(n.clone());
      }
      return this.autoClose = t.autoClose, this;
    }
    toJSON() {
      let t = super.toJSON();
      t.autoClose = this.autoClose, t.curves = [];
      for (let e = 0, n = this.curves.length; e < n; e++) {
        let n = this.curves[e];
        t.curves.push(n.toJSON());
      }
      return t;
    }
    fromJSON(t) {
      super.fromJSON(t), this.autoClose = t.autoClose, this.curves = [];
      for (let e = 0, n = t.curves.length; e < n; e++) {
        let n = t.curves[e];
        this.curves.push(new IS[n.type]().fromJSON(n));
      }
      return this;
    }
  };
u(LS, "CurvePath");
var mf = class extends LS {
  constructor(t) {
    super(), this.type = "Path", this.currentPoint = new je(), t && this.setFromPoints(t);
  }
  setFromPoints(t) {
    this.moveTo(t[0].x, t[0].y);
    for (let e = 1, n = t.length; e < n; e++) this.lineTo(t[e].x, t[e].y);
    return this;
  }
  moveTo(t, e) {
    return this.currentPoint.set(t, e), this;
  }
  lineTo(t, e) {
    let n = new Zg(this.currentPoint.clone(), new je(t, e));
    return this.curves.push(n), this.currentPoint.set(t, e), this;
  }
  quadraticCurveTo(t, e, n, i) {
    let r = new qx(this.currentPoint.clone(), new je(t, e), new je(n, i));
    return this.curves.push(r), this.currentPoint.set(n, i), this;
  }
  bezierCurveTo(t, e, n, i, r, o) {
    let s = new Dx(this.currentPoint.clone(), new je(t, e), new je(n, i), new je(r, o));
    return this.curves.push(s), this.currentPoint.set(r, o), this;
  }
  splineThru(t) {
    let e = [this.currentPoint.clone()].concat(t),
      n = new Fx(e);
    return this.curves.push(n), this.currentPoint.copy(t[t.length - 1]), this;
  }
  arc(t, e, n, i, r, o) {
    let s = this.currentPoint.x,
      a = this.currentPoint.y;
    return this.absarc(t + s, e + a, n, i, r, o), this;
  }
  absarc(t, e, n, i, r, o) {
    return this.absellipse(t, e, n, n, i, r, o), this;
  }
  ellipse(t, e, n, i, r, o, s, a) {
    let l = this.currentPoint.x,
      u = this.currentPoint.y;
    return this.absellipse(t + l, e + u, n, i, r, o, s, a), this;
  }
  absellipse(t, e, n, i, r, o, s, a) {
    let l = new jg(t, e, n, i, r, o, s, a);
    if (this.curves.length > 0) {
      let t = l.getPoint(0);
      t.equals(this.currentPoint) || this.lineTo(t.x, t.y);
    }
    this.curves.push(l);
    let u = l.getPoint(1);
    return this.currentPoint.copy(u), this;
  }
  copy(t) {
    return super.copy(t), this.currentPoint.copy(t.currentPoint), this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.currentPoint = this.currentPoint.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.currentPoint.fromArray(t.currentPoint), this;
  }
};
u(mf, "Path");
var xd = class extends Pi {
  constructor(t = 1, e = 1, n = 1, i = 32, r = 1, o = !1, s = 0, a = 2 * Math.PI) {
    super(), this.type = "CylinderGeometry", this.parameters = {
      radiusTop: t,
      radiusBottom: e,
      height: n,
      radialSegments: i,
      heightSegments: r,
      openEnded: o,
      thetaStart: s,
      thetaLength: a
    };
    let l = this;
    i = Math.floor(i), r = Math.floor(r);
    let h = [],
      c = [],
      p = [],
      d = [],
      f = 0,
      m = [],
      g = n / 2,
      v = 0;
    function y() {
      let o = new ne(),
        u = new ne(),
        y = 0,
        _ = (e - t) / n;
      for (let l = 0; l <= r; l++) {
        let h = [],
          v = l / r,
          y = v * (e - t) + t;
        for (let t = 0; t <= i; t++) {
          let e = t / i,
            r = e * a + s,
            l = Math.sin(r),
            m = Math.cos(r);
          u.x = y * l, u.y = -v * n + g, u.z = y * m, c.push(u.x, u.y, u.z), o.set(l, _, m).normalize(), p.push(o.x, o.y, o.z), d.push(e, 1 - v), h.push(f++);
        }
        m.push(h);
      }
      for (let t = 0; t < i; t++) for (let e = 0; e < r; e++) {
        let n = m[e][t],
          i = m[e + 1][t],
          r = m[e + 1][t + 1],
          o = m[e][t + 1];
        h.push(n, i, o), h.push(i, r, o), y += 6;
      }
      l.addGroup(v, y, 0), v += y;
    }
    function _(n) {
      let r = f,
        o = new je(),
        u = new ne(),
        m = 0,
        y = !0 === n ? t : e,
        _ = !0 === n ? 1 : -1;
      for (let t = 1; t <= i; t++) c.push(0, g * _, 0), p.push(0, _, 0), d.push(.5, .5), f++;
      let x = f;
      for (let t = 0; t <= i; t++) {
        let e = t / i * a + s,
          n = Math.cos(e),
          r = Math.sin(e);
        u.x = y * r, u.y = g * _, u.z = y * n, c.push(u.x, u.y, u.z), p.push(0, _, 0), o.x = .5 * n + .5, o.y = .5 * r * _ + .5, d.push(o.x, o.y), f++;
      }
      for (let t = 0; t < i; t++) {
        let e = r + t,
          i = x + t;
        !0 === n ? h.push(i, i + 1, e) : h.push(i + 1, i, e), m += 3;
      }
      l.addGroup(v, m, !0 === n ? 1 : 2), v += m;
    }
    y(), !1 === o && (t > 0 && _(!0), e > 0 && _(!1)), this.setIndex(h), this.setAttribute("position", new Di(c, 3)), this.setAttribute("normal", new Di(p, 3)), this.setAttribute("uv", new Di(d, 2)), u(y, "generateTorso"), u(_, "generateCap");
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  static fromJSON(t) {
    return new xd(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
  }
};
u(xd, "CylinderGeometry");
var Qa = class extends mf {
  constructor(t) {
    super(t), this.uuid = Zp(), this.type = "Shape", this.holes = [];
  }
  getPointsHoles(t) {
    let e = [];
    for (let n = 0, i = this.holes.length; n < i; n++) e[n] = this.holes[n].getPoints(t);
    return e;
  }
  extractPoints(t) {
    return {
      shape: this.getPoints(t),
      holes: this.getPointsHoles(t)
    };
  }
  copy(t) {
    super.copy(t), this.holes = [];
    for (let e = 0, n = t.holes.length; e < n; e++) {
      let n = t.holes[e];
      this.holes.push(n.clone());
    }
    return this;
  }
  toJSON() {
    let t = super.toJSON();
    t.uuid = this.uuid, t.holes = [];
    for (let e = 0, n = this.holes.length; e < n; e++) {
      let n = this.holes[e];
      t.holes.push(n.toJSON());
    }
    return t;
  }
  fromJSON(t) {
    super.fromJSON(t), this.uuid = t.uuid, this.holes = [];
    for (let e = 0, n = t.holes.length; e < n; e++) {
      let n = t.holes[e];
      this.holes.push(new mf().fromJSON(n));
    }
    return this;
  }
};
u(Qa, "Shape");
var IX = {
  triangulate: function (t, e, n = 2) {
    let i,
      r,
      o,
      s,
      a,
      l,
      u,
      h = e && e.length,
      c = h ? e[0] * n : t.length,
      p = W8(t, 0, c, n, !0),
      d = [];
    if (!p || p.next === p.prev) return d;
    if (h && (p = DX(t, e, p, n)), t.length > 80 * n) {
      i = o = t[0], r = s = t[1];
      for (let e = n; e < c; e += n) a = t[e], l = t[e + 1], a < i && (i = a), l < r && (r = l), a > o && (o = a), l > s && (s = l);
      u = Math.max(o - i, s - r), u = 0 !== u ? 32767 / u : 0;
    }
    return Jg(p, d, n, i, r, u, 0), d;
  }
};
function W8(t, e, n, i, r) {
  let o, s;
  if (r === WX(t, e, n, i) > 0) for (o = e; o < n; o += i) s = Z8(o, t[o], t[o + 1], s);else for (o = n - i; o >= e; o -= i) s = Z8(o, t[o], t[o + 1], s);
  return s && Bx(s, s.next) && (Qg(s), s = s.next), s;
}
function gf(t, e) {
  if (!t) return t;
  e || (e = t);
  let n,
    i = t;
  do {
    if (n = !1, i.steiner || !Bx(i, i.next) && 0 !== Zi(i.prev, i, i.next)) i = i.next;else {
      if (Qg(i), i = e = i.prev, i === i.next) break;
      n = !0;
    }
  } while (n || i !== e);
  return e;
}
function Jg(t, e, n, i, r, o, s) {
  if (!t) return;
  !s && o && UX(t, i, r, o);
  let a,
    l,
    u = t;
  for (; t.prev !== t.next;) if (a = t.prev, l = t.next, o ? OX(t, i, r, o) : LX(t)) e.push(a.i / n | 0), e.push(t.i / n | 0), e.push(l.i / n | 0), Qg(t), t = l.next, u = l.next;else if ((t = l) === u) {
    s ? 1 === s ? Jg(t = RX(gf(t), e, n), e, n, i, r, o, 2) : 2 === s && NX(t, e, n, i, r, o) : Jg(gf(t), e, n, i, r, o, 1);
    break;
  }
}
function LX(t) {
  let e = t.prev,
    n = t,
    i = t.next;
  if (Zi(e, n, i) >= 0) return !1;
  let r = e.x,
    o = n.x,
    s = i.x,
    a = e.y,
    l = n.y,
    u = i.y,
    h = r < o ? r < s ? r : s : o < s ? o : s,
    c = a < l ? a < u ? a : u : l < u ? l : u,
    p = r > o ? r > s ? r : s : o > s ? o : s,
    d = a > l ? a > u ? a : u : l > u ? l : u,
    f = i.next;
  for (; f !== e;) {
    if (f.x >= h && f.x <= p && f.y >= c && f.y <= d && bd(r, a, o, l, s, u, f.x, f.y) && Zi(f.prev, f, f.next) >= 0) return !1;
    f = f.next;
  }
  return !0;
}
function OX(t, e, n, i) {
  let r = t.prev,
    o = t,
    s = t.next;
  if (Zi(r, o, s) >= 0) return !1;
  let a = r.x,
    l = o.x,
    u = s.x,
    h = r.y,
    c = o.y,
    p = s.y,
    d = a < l ? a < u ? a : u : l < u ? l : u,
    f = h < c ? h < p ? h : p : c < p ? c : p,
    m = a > l ? a > u ? a : u : l > u ? l : u,
    g = h > c ? h > p ? h : p : c > p ? c : p,
    v = OS(d, f, e, n, i),
    y = OS(m, g, e, n, i),
    _ = t.prevZ,
    x = t.nextZ;
  for (; _ && _.z >= v && x && x.z <= y;) {
    if (_.x >= d && _.x <= m && _.y >= f && _.y <= g && _ !== r && _ !== s && bd(a, h, l, c, u, p, _.x, _.y) && Zi(_.prev, _, _.next) >= 0 || (_ = _.prevZ, x.x >= d && x.x <= m && x.y >= f && x.y <= g && x !== r && x !== s && bd(a, h, l, c, u, p, x.x, x.y) && Zi(x.prev, x, x.next) >= 0)) return !1;
    x = x.nextZ;
  }
  for (; _ && _.z >= v;) {
    if (_.x >= d && _.x <= m && _.y >= f && _.y <= g && _ !== r && _ !== s && bd(a, h, l, c, u, p, _.x, _.y) && Zi(_.prev, _, _.next) >= 0) return !1;
    _ = _.prevZ;
  }
  for (; x && x.z <= y;) {
    if (x.x >= d && x.x <= m && x.y >= f && x.y <= g && x !== r && x !== s && bd(a, h, l, c, u, p, x.x, x.y) && Zi(x.prev, x, x.next) >= 0) return !1;
    x = x.nextZ;
  }
  return !0;
}
function RX(t, e, n) {
  let i = t;
  do {
    let r = i.prev,
      o = i.next.next;
    !Bx(r, o) && X8(r, i, i.next, o) && Kg(r, o) && Kg(o, r) && (e.push(r.i / n | 0), e.push(i.i / n | 0), e.push(o.i / n | 0), Qg(i), Qg(i.next), i = t = o), i = i.next;
  } while (i !== t);
  return gf(i);
}
function NX(t, e, n, i, r, o) {
  let s = t;
  do {
    let t = s.next.next;
    for (; t !== s.prev;) {
      if (s.i !== t.i && GX(s, t)) {
        let a = Y8(s, t);
        return s = gf(s, s.next), a = gf(a, a.next), Jg(s, e, n, i, r, o, 0), void Jg(a, e, n, i, r, o, 0);
      }
      t = t.next;
    }
    s = s.next;
  } while (s !== t);
}
function DX(t, e, n, i) {
  let r,
    o,
    s,
    a,
    l,
    u = [];
  for (r = 0, o = e.length; r < o; r++) s = e[r] * i, a = r < o - 1 ? e[r + 1] * i : t.length, l = W8(t, s, a, i, !1), l === l.next && (l.steiner = !0), u.push(VX(l));
  for (u.sort(qX), r = 0; r < u.length; r++) n = kX(u[r], n);
  return n;
}
function qX(t, e) {
  return t.x - e.x;
}
function kX(t, e) {
  let n = FX(t, e);
  if (!n) return e;
  let i = Y8(n, t);
  return gf(i, i.next), gf(n, n.next);
}
function FX(t, e) {
  let n,
    i = e,
    r = -1 / 0,
    o = t.x,
    s = t.y;
  do {
    if (s <= i.y && s >= i.next.y && i.next.y !== i.y) {
      let t = i.x + (s - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
      if (t <= o && t > r && (r = t, n = i.x < i.next.x ? i : i.next, t === o)) return n;
    }
    i = i.next;
  } while (i !== e);
  if (!n) return null;
  let a,
    l = n,
    u = n.x,
    h = n.y,
    c = 1 / 0;
  i = n;
  do {
    o >= i.x && i.x >= u && o !== i.x && bd(s < h ? o : r, s, u, h, s < h ? r : o, s, i.x, i.y) && (a = Math.abs(s - i.y) / (o - i.x), Kg(i, t) && (a < c || a === c && (i.x > n.x || i.x === n.x && BX(n, i))) && (n = i, c = a)), i = i.next;
  } while (i !== l);
  return n;
}
function BX(t, e) {
  return Zi(t.prev, t, e.prev) < 0 && Zi(e.next, t, t.next) < 0;
}
function UX(t, e, n, i) {
  let r = t;
  do {
    0 === r.z && (r.z = OS(r.x, r.y, e, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
  } while (r !== t);
  r.prevZ.nextZ = null, r.prevZ = null, zX(r);
}
function zX(t) {
  let e,
    n,
    i,
    r,
    o,
    s,
    a,
    l,
    u = 1;
  do {
    for (n = t, t = null, o = null, s = 0; n;) {
      for (s++, i = n, a = 0, e = 0; e < u && (a++, i = i.nextZ, i); e++);
      for (l = u; a > 0 || l > 0 && i;) 0 !== a && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, a--) : (r = i, i = i.nextZ, l--), o ? o.nextZ = r : t = r, r.prevZ = o, o = r;
      n = i;
    }
    o.nextZ = null, u *= 2;
  } while (s > 1);
  return t;
}
function OS(t, e, n, i, r) {
  return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - n) * r | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - i) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
}
function VX(t) {
  let e = t,
    n = t;
  do {
    (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
  } while (e !== t);
  return n;
}
function bd(t, e, n, i, r, o, s, a) {
  return (r - s) * (e - a) >= (t - s) * (o - a) && (t - s) * (i - a) >= (n - s) * (e - a) && (n - s) * (o - a) >= (r - s) * (i - a);
}
function GX(t, e) {
  return t.next.i !== e.i && t.prev.i !== e.i && !HX(t, e) && (Kg(t, e) && Kg(e, t) && jX(t, e) && (Zi(t.prev, t, e.prev) || Zi(t, e.prev, e)) || Bx(t, e) && Zi(t.prev, t, t.next) > 0 && Zi(e.prev, e, e.next) > 0);
}
function Zi(t, e, n) {
  return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
}
function Bx(t, e) {
  return t.x === e.x && t.y === e.y;
}
function X8(t, e, n, i) {
  let r = zx(Zi(t, e, n)),
    o = zx(Zi(t, e, i)),
    s = zx(Zi(n, i, t)),
    a = zx(Zi(n, i, e));
  return !!(r !== o && s !== a || 0 === r && Ux(t, n, e) || 0 === o && Ux(t, i, e) || 0 === s && Ux(n, t, i) || 0 === a && Ux(n, e, i));
}
function Ux(t, e, n) {
  return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
}
function zx(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}
function HX(t, e) {
  let n = t;
  do {
    if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && X8(n, n.next, t, e)) return !0;
    n = n.next;
  } while (n !== t);
  return !1;
}
function Kg(t, e) {
  return Zi(t.prev, t, t.next) < 0 ? Zi(t, e, t.next) >= 0 && Zi(t, t.prev, e) >= 0 : Zi(t, e, t.prev) < 0 || Zi(t, t.next, e) < 0;
}
function jX(t, e) {
  let n = t,
    i = !1,
    r = (t.x + e.x) / 2,
    o = (t.y + e.y) / 2;
  do {
    n.y > o != n.next.y > o && n.next.y !== n.y && r < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
  } while (n !== t);
  return i;
}
function Y8(t, e) {
  let n = new RS(t.i, t.x, t.y),
    i = new RS(e.i, e.x, e.y),
    r = t.next,
    o = e.prev;
  return t.next = e, e.prev = t, n.next = r, r.prev = n, i.next = n, n.prev = i, o.next = i, i.prev = o, i;
}
function Z8(t, e, n, i) {
  let r = new RS(t, e, n);
  return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
}
function Qg(t) {
  t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
}
function RS(t, e, n) {
  this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
function WX(t, e, n, i) {
  let r = 0;
  for (let o = e, s = n - i; o < n; o += i) r += (t[s] - t[o]) * (t[o + 1] + t[s + 1]), s = o;
  return r;
}
u(W8, "linkedList"), u(gf, "filterPoints"), u(Jg, "earcutLinked"), u(LX, "isEar"), u(OX, "isEarHashed"), u(RX, "cureLocalIntersections"), u(NX, "splitEarcut"), u(DX, "eliminateHoles"), u(qX, "compareX"), u(kX, "eliminateHole"), u(FX, "findHoleBridge"), u(BX, "sectorContainsSector"), u(UX, "indexCurve"), u(zX, "sortLinked"), u(OS, "zOrder"), u(VX, "getLeftmost"), u(bd, "pointInTriangle"), u(GX, "isValidDiagonal"), u(Zi, "area"), u(Bx, "equals"), u(X8, "intersects"), u(Ux, "onSegment"), u(zx, "sign"), u(HX, "intersectsPolygon"), u(Kg, "locallyInside"), u(jX, "middleInside"), u(Y8, "splitPolygon"), u(Z8, "insertNode"), u(Qg, "removeNode"), u(RS, "Node"), u(WX, "signedArea");
var eh = class {
  static area(t) {
    let e = t.length,
      n = 0;
    for (let i = e - 1, r = 0; r < e; i = r++) n += t[i].x * t[r].y - t[r].x * t[i].y;
    return .5 * n;
  }
  static isClockWise(t) {
    return eh.area(t) < 0;
  }
  static triangulateShape(t, e) {
    let n = [],
      i = [],
      r = [];
    J8(t), K8(n, t);
    let o = t.length;
    e.forEach(J8);
    for (let t = 0; t < e.length; t++) i.push(o), o += e[t].length, K8(n, e[t]);
    let s = IX.triangulate(n, i);
    for (let t = 0; t < s.length; t += 3) r.push(s.slice(t, t + 3));
    return r;
  }
};
function J8(t) {
  let e = t.length;
  e > 2 && t[e - 1].equals(t[0]) && t.pop();
}
function K8(t, e) {
  for (let n = 0; n < e.length; n++) t.push(e[n].x), t.push(e[n].y);
}
u(eh, "ShapeUtils"), u(J8, "removeDupEndPts"), u(K8, "addContour");
var $a = class extends Pi {
  constructor(t = new Qa([new je(.5, .5), new je(-.5, .5), new je(-.5, -.5), new je(.5, -.5)]), e = {}) {
    super(), this.type = "ExtrudeGeometry", this.parameters = {
      shapes: t,
      options: e
    }, t = Array.isArray(t) ? t : [t];
    let n = this,
      i = [],
      r = [];
    for (let e = 0, n = t.length; e < n; e++) {
      o(t[e]);
    }
    function o(t) {
      let o,
        s,
        a,
        l,
        h,
        c = [],
        p = void 0 !== e.curveSegments ? e.curveSegments : 12,
        d = void 0 !== e.steps ? e.steps : 1,
        f = void 0 !== e.depth ? e.depth : 1,
        m = void 0 === e.bevelEnabled || e.bevelEnabled,
        g = void 0 !== e.bevelThickness ? e.bevelThickness : .2,
        v = void 0 !== e.bevelSize ? e.bevelSize : g - .1,
        y = void 0 !== e.bevelOffset ? e.bevelOffset : 0,
        _ = void 0 !== e.bevelSegments ? e.bevelSegments : 3,
        x = e.extrudePath,
        E = void 0 !== e.UVGenerator ? e.UVGenerator : XX,
        b = !1;
      x && (o = x.getSpacedPoints(d), b = !0, m = !1, s = x.computeFrenetFrames(d, !1), a = new ne(), l = new ne(), h = new ne()), m || (_ = 0, g = 0, v = 0, y = 0);
      let w = t.extractPoints(p),
        S = w.shape,
        M = w.holes;
      if (!eh.isClockWise(S)) {
        S = S.reverse();
        for (let t = 0, e = M.length; t < e; t++) {
          let e = M[t];
          eh.isClockWise(e) && (M[t] = e.reverse());
        }
      }
      let T = eh.triangulateShape(S, M),
        A = S;
      for (let t = 0, e = M.length; t < e; t++) {
        let e = M[t];
        S = S.concat(e);
      }
      function P(t, e, n) {
        return e || console.error("THREE.ExtrudeGeometry: vec does not exist"), t.clone().addScaledVector(e, n);
      }
      u(P, "scalePt2");
      let C = S.length,
        I = T.length;
      function N(t, e, n) {
        let i,
          r,
          o,
          s = t.x - e.x,
          a = t.y - e.y,
          l = n.x - t.x,
          u = n.y - t.y,
          h = s * s + a * a,
          c = s * u - a * l;
        if (Math.abs(c) > Number.EPSILON) {
          let c = Math.sqrt(h),
            p = Math.sqrt(l * l + u * u),
            d = e.x - a / c,
            f = e.y + s / c,
            m = ((n.x - u / p - d) * u - (n.y + l / p - f) * l) / (s * u - a * l);
          i = d + s * m - t.x, r = f + a * m - t.y;
          let g = i * i + r * r;
          if (g <= 2) return new je(i, r);
          o = Math.sqrt(g / 2);
        } else {
          let t = !1;
          s > Number.EPSILON ? l > Number.EPSILON && (t = !0) : s < -Number.EPSILON ? l < -Number.EPSILON && (t = !0) : Math.sign(a) === Math.sign(u) && (t = !0), t ? (i = -a, r = s, o = Math.sqrt(h)) : (i = s, r = a, o = Math.sqrt(h / 2));
        }
        return new je(i / o, r / o);
      }
      u(N, "getBevelVec");
      let L = [];
      for (let t = 0, e = A.length, n = e - 1, i = t + 1; t < e; t++, n++, i++) n === e && (n = 0), i === e && (i = 0), L[t] = N(A[t], A[n], A[i]);
      let R,
        O = [],
        q = L.concat();
      for (let t = 0, e = M.length; t < e; t++) {
        let e = M[t];
        R = [];
        for (let t = 0, n = e.length, i = n - 1, r = t + 1; t < n; t++, i++, r++) i === n && (i = 0), r === n && (r = 0), R[t] = N(e[t], e[i], e[r]);
        O.push(R), q = q.concat(R);
      }
      for (let t = 0; t < _; t++) {
        let e = t / _,
          n = g * Math.cos(e * Math.PI / 2),
          i = v * Math.sin(e * Math.PI / 2) + y;
        for (let t = 0, e = A.length; t < e; t++) {
          let e = P(A[t], L[t], i);
          B(e.x, e.y, -n);
        }
        for (let t = 0, e = M.length; t < e; t++) {
          let e = M[t];
          R = O[t];
          for (let t = 0, r = e.length; t < r; t++) {
            let r = P(e[t], R[t], i);
            B(r.x, r.y, -n);
          }
        }
      }
      let D = v + y;
      for (let t = 0; t < C; t++) {
        let e = m ? P(S[t], q[t], D) : S[t];
        b ? (l.copy(s.normals[0]).multiplyScalar(e.x), a.copy(s.binormals[0]).multiplyScalar(e.y), h.copy(o[0]).add(l).add(a), B(h.x, h.y, h.z)) : B(e.x, e.y, 0);
      }
      for (let t = 1; t <= d; t++) for (let e = 0; e < C; e++) {
        let n = m ? P(S[e], q[e], D) : S[e];
        b ? (l.copy(s.normals[t]).multiplyScalar(n.x), a.copy(s.binormals[t]).multiplyScalar(n.y), h.copy(o[t]).add(l).add(a), B(h.x, h.y, h.z)) : B(n.x, n.y, f / d * t);
      }
      for (let t = _ - 1; t >= 0; t--) {
        let e = t / _,
          n = g * Math.cos(e * Math.PI / 2),
          i = v * Math.sin(e * Math.PI / 2) + y;
        for (let t = 0, e = A.length; t < e; t++) {
          let e = P(A[t], L[t], i);
          B(e.x, e.y, f + n);
        }
        for (let t = 0, e = M.length; t < e; t++) {
          let e = M[t];
          R = O[t];
          for (let t = 0, r = e.length; t < r; t++) {
            let r = P(e[t], R[t], i);
            b ? B(r.x, r.y + o[d - 1].y, o[d - 1].x + n) : B(r.x, r.y, f + n);
          }
        }
      }
      function k() {
        let t = i.length / 3;
        if (m) {
          let t = 0,
            e = C * t;
          for (let t = 0; t < I; t++) {
            let n = T[t];
            z(n[2] + e, n[1] + e, n[0] + e);
          }
          t = d + 2 * _, e = C * t;
          for (let t = 0; t < I; t++) {
            let n = T[t];
            z(n[0] + e, n[1] + e, n[2] + e);
          }
        } else {
          for (let t = 0; t < I; t++) {
            let e = T[t];
            z(e[2], e[1], e[0]);
          }
          for (let t = 0; t < I; t++) {
            let e = T[t];
            z(e[0] + C * d, e[1] + C * d, e[2] + C * d);
          }
        }
        n.addGroup(t, i.length / 3 - t, 0);
      }
      function F() {
        let t = i.length / 3,
          e = 0;
        U(A, e), e += A.length;
        for (let t = 0, n = M.length; t < n; t++) {
          let n = M[t];
          U(n, e), e += n.length;
        }
        n.addGroup(t, i.length / 3 - t, 1);
      }
      function U(t, e) {
        let n = t.length;
        for (; --n >= 0;) {
          let i = n,
            r = n - 1;
          r < 0 && (r = t.length - 1);
          for (let t = 0, n = d + 2 * _; t < n; t++) {
            let n = C * t,
              o = C * (t + 1);
            V(e + i + n, e + r + n, e + r + o, e + i + o);
          }
        }
      }
      function B(t, e, n) {
        c.push(t), c.push(e), c.push(n);
      }
      function z(t, e, r) {
        j(t), j(e), j(r);
        let o = i.length / 3,
          s = E.generateTopUV(n, i, o - 3, o - 2, o - 1);
        G(s[0]), G(s[1]), G(s[2]);
      }
      function V(t, e, r, o) {
        j(t), j(e), j(o), j(e), j(r), j(o);
        let s = i.length / 3,
          a = E.generateSideWallUV(n, i, s - 6, s - 3, s - 2, s - 1);
        G(a[0]), G(a[1]), G(a[3]), G(a[1]), G(a[2]), G(a[3]);
      }
      function j(t) {
        i.push(c[3 * t + 0]), i.push(c[3 * t + 1]), i.push(c[3 * t + 2]);
      }
      function G(t) {
        r.push(t.x), r.push(t.y);
      }
      k(), F(), u(k, "buildLidFaces"), u(F, "buildSideFaces"), u(U, "sidewalls"), u(B, "v"), u(z, "f3"), u(V, "f4"), u(j, "addVertex"), u(G, "addUV");
    }
    this.setAttribute("position", new Di(i, 3)), this.setAttribute("uv", new Di(r, 2)), this.computeVertexNormals(), u(o, "addShape");
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  toJSON() {
    let t = super.toJSON();
    return YX(this.parameters.shapes, this.parameters.options, t);
  }
  static fromJSON(t, e) {
    let n = [];
    for (let i = 0, r = t.shapes.length; i < r; i++) {
      let r = e[t.shapes[i]];
      n.push(r);
    }
    let i = t.options.extrudePath;
    return void 0 !== i && (t.options.extrudePath = new IS[i.type]().fromJSON(i)), new $a(n, t.options);
  }
};
u($a, "ExtrudeGeometry");
var XX = {
  generateTopUV: function (t, e, n, i, r) {
    let o = e[3 * n],
      s = e[3 * n + 1],
      a = e[3 * i],
      l = e[3 * i + 1],
      u = e[3 * r],
      h = e[3 * r + 1];
    return [new je(o, s), new je(a, l), new je(u, h)];
  },
  generateSideWallUV: function (t, e, n, i, r, o) {
    let s = e[3 * n],
      a = e[3 * n + 1],
      l = e[3 * n + 2],
      u = e[3 * i],
      h = e[3 * i + 1],
      c = e[3 * i + 2],
      p = e[3 * r],
      d = e[3 * r + 1],
      f = e[3 * r + 2],
      m = e[3 * o],
      g = e[3 * o + 1],
      v = e[3 * o + 2];
    return Math.abs(a - h) < Math.abs(s - u) ? [new je(s, 1 - l), new je(u, 1 - c), new je(p, 1 - f), new je(m, 1 - v)] : [new je(a, 1 - l), new je(h, 1 - c), new je(d, 1 - f), new je(g, 1 - v)];
  }
};
function YX(t, e, n) {
  if (n.shapes = [], Array.isArray(t)) for (let e = 0, i = t.length; e < i; e++) {
    let i = t[e];
    n.shapes.push(i.uuid);
  } else n.shapes.push(t.uuid);
  return n.options = Object.assign({}, e), void 0 !== e.extrudePath && (n.options.extrudePath = e.extrudePath.toJSON()), n;
}
u(YX, "toJSON$1");
var Md = class extends Pi {
  constructor(t = new kx(new ne(-1, -1, 0), new ne(-1, 1, 0), new ne(1, 1, 0)), e = 64, n = 1, i = 8, r = !1) {
    super(), this.type = "TubeGeometry", this.parameters = {
      path: t,
      tubularSegments: e,
      radius: n,
      radialSegments: i,
      closed: r
    };
    let o = t.computeFrenetFrames(e, r);
    this.tangents = o.tangents, this.normals = o.normals, this.binormals = o.binormals;
    let s = new ne(),
      a = new ne(),
      l = new je(),
      h = new ne(),
      c = [],
      p = [],
      d = [],
      f = [];
    function m() {
      for (let t = 0; t < e; t++) g(t);
      g(!1 === r ? e : 0), y(), v();
    }
    function g(r) {
      h = t.getPointAt(r / e, h);
      let l = o.normals[r],
        u = o.binormals[r];
      for (let t = 0; t <= i; t++) {
        let e = t / i * Math.PI * 2,
          r = Math.sin(e),
          o = -Math.cos(e);
        a.x = o * l.x + r * u.x, a.y = o * l.y + r * u.y, a.z = o * l.z + r * u.z, a.normalize(), p.push(a.x, a.y, a.z), s.x = h.x + n * a.x, s.y = h.y + n * a.y, s.z = h.z + n * a.z, c.push(s.x, s.y, s.z);
      }
    }
    function v() {
      for (let t = 1; t <= e; t++) for (let e = 1; e <= i; e++) {
        let n = (i + 1) * (t - 1) + (e - 1),
          r = (i + 1) * t + (e - 1),
          o = (i + 1) * t + e,
          s = (i + 1) * (t - 1) + e;
        f.push(n, r, s), f.push(r, o, s);
      }
    }
    function y() {
      for (let t = 0; t <= e; t++) for (let n = 0; n <= i; n++) l.x = t / e, l.y = n / i, d.push(l.x, l.y);
    }
    m(), this.setIndex(f), this.setAttribute("position", new Di(c, 3)), this.setAttribute("normal", new Di(p, 3)), this.setAttribute("uv", new Di(d, 2)), u(m, "generateBufferData"), u(g, "generateSegment"), u(v, "generateIndices"), u(y, "generateUVs");
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.path = this.parameters.path.toJSON(), t;
  }
  static fromJSON(t) {
    return new Md(new IS[t.path.type]().fromJSON(t.path), t.tubularSegments, t.radius, t.radialSegments, t.closed);
  }
};
u(Md, "TubeGeometry");
var Vx = class extends wi {
  constructor(t) {
    super(t), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
  }
};
u(Vx, "RawShaderMaterial");
var Ol = class extends $c {
  constructor(t) {
    super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new yt(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new yt(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = jI, this.normalScale = new je(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = M3, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this.fog = t.fog, this;
  }
};
function th(t, e, n) {
  return Q8(t) ? new t.constructor(t.subarray(e, void 0 !== n ? n : t.length)) : t.slice(e, n);
}
function Gx(t, e, n) {
  return !t || !n && t.constructor === e ? t : "number" == typeof e.BYTES_PER_ELEMENT ? new e(t) : Array.prototype.slice.call(t);
}
function Q8(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
u(Ol, "MeshLambertMaterial"), u(th, "arraySlice"), u(Gx, "convertArray"), u(Q8, "isTypedArray");
var Ed = class {
  constructor(t, e, n, i) {
    this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = void 0 !== i ? i : new e.constructor(n), this.sampleValues = e, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
  }
  evaluate(t) {
    let e = this.parameterPositions,
      n = this._cachedIndex,
      i = e[n],
      r = e[n - 1];
    t: {
      e: {
        let o;
        n: {
          i: if (!(t < i)) {
            for (let o = n + 2;;) {
              if (void 0 === i) {
                if (t < r) break i;
                return n = e.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
              }
              if (n === o) break;
              if (r = i, i = e[++n], t < i) break e;
            }
            o = e.length;
            break n;
          }
          if (t >= r) break t;
          {
            let s = e[1];
            t < s && (n = 2, r = s);
            for (let o = n - 2;;) {
              if (void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
              if (n === o) break;
              if (i = r, r = e[--n - 1], t >= r) break e;
            }
            o = n, n = 0;
          }
        }
        for (; n < o;) {
          let i = n + o >>> 1;
          t < e[i] ? o = i : n = i + 1;
        }
        if (i = e[n], r = e[n - 1], void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
        if (void 0 === i) return n = e.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
      }
      this._cachedIndex = n, this.intervalChanged_(n, r, i);
    }
    return this.interpolate_(n, r, t, i);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(t) {
    let e = this.resultBuffer,
      n = this.sampleValues,
      i = this.valueSize,
      r = t * i;
    for (let t = 0; t !== i; ++t) e[t] = n[r + t];
    return e;
  }
  interpolate_() {
    throw new Error("call to abstract method");
  }
  intervalChanged_() {}
};
u(Ed, "Interpolant");
var NS = class extends Ed {
  constructor(t, e, n, i) {
    super(t, e, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
      endingStart: zI,
      endingEnd: zI
    };
  }
  intervalChanged_(t, e, n) {
    let i = this.parameterPositions,
      r = t - 2,
      o = t + 1,
      s = i[r],
      a = i[o];
    if (void 0 === s) switch (this.getSettings_().endingStart) {
      case VI:
        r = t, s = 2 * e - n;
        break;
      case GI:
        r = i.length - 2, s = e + i[r] - i[r + 1];
        break;
      default:
        r = t, s = n;
    }
    if (void 0 === a) switch (this.getSettings_().endingEnd) {
      case VI:
        o = t, a = 2 * n - e;
        break;
      case GI:
        o = 1, a = n + i[1] - i[0];
        break;
      default:
        o = t - 1, a = e;
    }
    let l = .5 * (n - e),
      u = this.valueSize;
    this._weightPrev = l / (e - s), this._weightNext = l / (a - n), this._offsetPrev = r * u, this._offsetNext = o * u;
  }
  interpolate_(t, e, n, i) {
    let r = this.resultBuffer,
      o = this.sampleValues,
      s = this.valueSize,
      a = t * s,
      l = a - s,
      u = this._offsetPrev,
      h = this._offsetNext,
      c = this._weightPrev,
      p = this._weightNext,
      d = (n - e) / (i - e),
      f = d * d,
      m = f * d,
      g = -c * m + 2 * c * f - c * d,
      v = (1 + c) * m + (-1.5 - 2 * c) * f + (-.5 + c) * d + 1,
      y = (-1 - p) * m + (1.5 + p) * f + .5 * d,
      _ = p * m - p * f;
    for (let t = 0; t !== s; ++t) r[t] = g * o[u + t] + v * o[l + t] + y * o[a + t] + _ * o[h + t];
    return r;
  }
};
u(NS, "CubicInterpolant");
var DS = class extends Ed {
  constructor(t, e, n, i) {
    super(t, e, n, i);
  }
  interpolate_(t, e, n, i) {
    let r = this.resultBuffer,
      o = this.sampleValues,
      s = this.valueSize,
      a = t * s,
      l = a - s,
      u = (n - e) / (i - e),
      h = 1 - u;
    for (let t = 0; t !== s; ++t) r[t] = o[l + t] * h + o[a + t] * u;
    return r;
  }
};
u(DS, "LinearInterpolant");
var qS = class extends Ed {
  constructor(t, e, n, i) {
    super(t, e, n, i);
  }
  interpolate_(t) {
    return this.copySampleValue_(t - 1);
  }
};
u(qS, "DiscreteInterpolant");
var el = class {
  constructor(t, e, n, i) {
    if (void 0 === t) throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
    this.name = t, this.times = Gx(e, this.TimeBufferType), this.values = Gx(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
  }
  static toJSON(t) {
    let e,
      n = t.constructor;
    if (n.toJSON !== this.toJSON) e = n.toJSON(t);else {
      e = {
        name: t.name,
        times: Gx(t.times, Array),
        values: Gx(t.values, Array)
      };
      let n = t.getInterpolation();
      n !== t.DefaultInterpolation && (e.interpolation = n);
    }
    return e.type = t.ValueTypeName, e;
  }
  InterpolantFactoryMethodDiscrete(t) {
    return new qS(this.times, this.values, this.getValueSize(), t);
  }
  InterpolantFactoryMethodLinear(t) {
    return new DS(this.times, this.values, this.getValueSize(), t);
  }
  InterpolantFactoryMethodSmooth(t) {
    return new NS(this.times, this.values, this.getValueSize(), t);
  }
  setInterpolation(t) {
    let e;
    switch (t) {
      case J_:
        e = this.InterpolantFactoryMethodDiscrete;
        break;
      case K_:
        e = this.InterpolantFactoryMethodLinear;
        break;
      case N3:
        e = this.InterpolantFactoryMethodSmooth;
    }
    if (void 0 === e) {
      let e = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (void 0 === this.createInterpolant) {
        if (t === this.DefaultInterpolation) throw new Error(e);
        this.setInterpolation(this.DefaultInterpolation);
      }
      return console.warn("THREE.KeyframeTrack:", e), this;
    }
    return this.createInterpolant = e, this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return J_;
      case this.InterpolantFactoryMethodLinear:
        return K_;
      case this.InterpolantFactoryMethodSmooth:
        return N3;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  shift(t) {
    if (0 !== t) {
      let e = this.times;
      for (let n = 0, i = e.length; n !== i; ++n) e[n] += t;
    }
    return this;
  }
  scale(t) {
    if (1 !== t) {
      let e = this.times;
      for (let n = 0, i = e.length; n !== i; ++n) e[n] *= t;
    }
    return this;
  }
  trim(t, e) {
    let n = this.times,
      i = n.length,
      r = 0,
      o = i - 1;
    for (; r !== i && n[r] < t;) ++r;
    for (; -1 !== o && n[o] > e;) --o;
    if (++o, 0 !== r || o !== i) {
      r >= o && (o = Math.max(o, 1), r = o - 1);
      let t = this.getValueSize();
      this.times = th(n, r, o), this.values = th(this.values, r * t, o * t);
    }
    return this;
  }
  validate() {
    let t = !0,
      e = this.getValueSize();
    e - Math.floor(e) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
    let n = this.times,
      i = this.values,
      r = n.length;
    0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
    let o = null;
    for (let e = 0; e !== r; e++) {
      let i = n[e];
      if ("number" == typeof i && isNaN(i)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, e, i), t = !1;
        break;
      }
      if (null !== o && o > i) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, e, i, o), t = !1;
        break;
      }
      o = i;
    }
    if (void 0 !== i && Q8(i)) for (let e = 0, n = i.length; e !== n; ++e) {
      let n = i[e];
      if (isNaN(n)) {
        console.error("THREE.KeyframeTrack: Value is not a valid number.", this, e, n), t = !1;
        break;
      }
    }
    return t;
  }
  optimize() {
    let t = th(this.times),
      e = th(this.values),
      n = this.getValueSize(),
      i = this.getInterpolation() === N3,
      r = t.length - 1,
      o = 1;
    for (let s = 1; s < r; ++s) {
      let r = !1,
        a = t[s];
      if (a !== t[s + 1] && (1 !== s || a !== t[0])) if (i) r = !0;else {
        let t = s * n,
          i = t - n,
          o = t + n;
        for (let s = 0; s !== n; ++s) {
          let n = e[t + s];
          if (n !== e[i + s] || n !== e[o + s]) {
            r = !0;
            break;
          }
        }
      }
      if (r) {
        if (s !== o) {
          t[o] = t[s];
          let i = s * n,
            r = o * n;
          for (let t = 0; t !== n; ++t) e[r + t] = e[i + t];
        }
        ++o;
      }
    }
    if (r > 0) {
      t[o] = t[r];
      for (let t = r * n, i = o * n, s = 0; s !== n; ++s) e[i + s] = e[t + s];
      ++o;
    }
    return o !== t.length ? (this.times = th(t, 0, o), this.values = th(e, 0, o * n)) : (this.times = t, this.values = e), this;
  }
  clone() {
    let t = th(this.times, 0),
      e = th(this.values, 0),
      n = new (0, this.constructor)(this.name, t, e);
    return n.createInterpolant = this.createInterpolant, n;
  }
};
u(el, "KeyframeTrack"), el.prototype.TimeBufferType = Float32Array, el.prototype.ValueBufferType = Float32Array, el.prototype.DefaultInterpolation = K_;
var vf = class extends el {};
u(vf, "BooleanKeyframeTrack"), vf.prototype.ValueTypeName = "bool", vf.prototype.ValueBufferType = Array, vf.prototype.DefaultInterpolation = J_, vf.prototype.InterpolantFactoryMethodLinear = void 0, vf.prototype.InterpolantFactoryMethodSmooth = void 0;
var kS = class extends el {};
u(kS, "ColorKeyframeTrack"), kS.prototype.ValueTypeName = "color";
var FS = class extends el {};
u(FS, "NumberKeyframeTrack"), FS.prototype.ValueTypeName = "number";
var BS = class extends Ed {
  constructor(t, e, n, i) {
    super(t, e, n, i);
  }
  interpolate_(t, e, n, i) {
    let r = this.resultBuffer,
      o = this.sampleValues,
      s = this.valueSize,
      a = (n - e) / (i - e),
      l = t * s;
    for (let t = l + s; l !== t; l += 4) Vs.slerpFlat(r, 0, o, l - s, o, l, a);
    return r;
  }
};
u(BS, "QuaternionLinearInterpolant");
var $g = class extends el {
  InterpolantFactoryMethodLinear(t) {
    return new BS(this.times, this.values, this.getValueSize(), t);
  }
};
u($g, "QuaternionKeyframeTrack"), $g.prototype.ValueTypeName = "quaternion", $g.prototype.DefaultInterpolation = K_, $g.prototype.InterpolantFactoryMethodSmooth = void 0;
var yf = class extends el {};
u(yf, "StringKeyframeTrack"), yf.prototype.ValueTypeName = "string", yf.prototype.ValueBufferType = Array, yf.prototype.DefaultInterpolation = J_, yf.prototype.InterpolantFactoryMethodLinear = void 0, yf.prototype.InterpolantFactoryMethodSmooth = void 0;
var US = class extends el {};
u(US, "VectorKeyframeTrack"), US.prototype.ValueTypeName = "vector";
var $8 = {
    enabled: !1,
    files: {},
    add: function (t, e) {
      !1 !== this.enabled && (this.files[t] = e);
    },
    get: function (t) {
      if (!1 !== this.enabled) return this.files[t];
    },
    remove: function (t) {
      delete this.files[t];
    },
    clear: function () {
      this.files = {};
    }
  },
  zS = class {
    constructor(t, e, n) {
      let i,
        r = this,
        o = !1,
        s = 0,
        a = 0,
        l = [];
      this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = n, this.itemStart = function (t) {
        a++, !1 === o && void 0 !== r.onStart && r.onStart(t, s, a), o = !0;
      }, this.itemEnd = function (t) {
        s++, void 0 !== r.onProgress && r.onProgress(t, s, a), s === a && (o = !1, void 0 !== r.onLoad && r.onLoad());
      }, this.itemError = function (t) {
        void 0 !== r.onError && r.onError(t);
      }, this.resolveURL = function (t) {
        return i ? i(t) : t;
      }, this.setURLModifier = function (t) {
        return i = t, this;
      }, this.addHandler = function (t, e) {
        return l.push(t, e), this;
      }, this.removeHandler = function (t) {
        let e = l.indexOf(t);
        return -1 !== e && l.splice(e, 2), this;
      }, this.getHandler = function (t) {
        for (let e = 0, n = l.length; e < n; e += 2) {
          let n = l[e],
            i = l[e + 1];
          if (n.global && (n.lastIndex = 0), n.test(t)) return i;
        }
        return null;
      };
    }
  };
u(zS, "LoadingManager");
var ZX = new zS(),
  e0 = class {
    constructor(t) {
      this.manager = void 0 !== t ? t : ZX, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    load() {}
    loadAsync(t, e) {
      let n = this;
      return new Promise(function (i, r) {
        n.load(t, i, e, r);
      });
    }
    parse() {}
    setCrossOrigin(t) {
      return this.crossOrigin = t, this;
    }
    setWithCredentials(t) {
      return this.withCredentials = t, this;
    }
    setPath(t) {
      return this.path = t, this;
    }
    setResourcePath(t) {
      return this.resourcePath = t, this;
    }
    setRequestHeader(t) {
      return this.requestHeader = t, this;
    }
  };
u(e0, "Loader");
var VS = class extends e0 {
  constructor(t) {
    super(t);
  }
  load(t, e, n, i) {
    void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
    let r = this,
      o = $8.get(t);
    if (void 0 !== o) return r.manager.itemStart(t), setTimeout(function () {
      e && e(o), r.manager.itemEnd(t);
    }, 0), o;
    let s = Ng("img");
    function a() {
      h(), $8.add(t, this), e && e(this), r.manager.itemEnd(t);
    }
    function l(e) {
      h(), i && i(e), r.manager.itemError(t), r.manager.itemEnd(t);
    }
    function h() {
      s.removeEventListener("load", a, !1), s.removeEventListener("error", l, !1);
    }
    return u(a, "onImageLoad"), u(l, "onImageError"), u(h, "removeEventListeners"), s.addEventListener("load", a, !1), s.addEventListener("error", l, !1), "data:" !== t.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(t), s.src = t, s;
  }
};
u(VS, "ImageLoader");
var pa = class extends e0 {
  constructor(t) {
    super(t);
  }
  load(t, e, n, i) {
    let r = new lo(),
      o = new VS(this.manager);
    return o.setCrossOrigin(this.crossOrigin), o.setPath(this.path), o.load(t, function (t) {
      r.image = t, r.needsUpdate = !0, void 0 !== e && e(r);
    }, n, i), r;
  }
};
u(pa, "TextureLoader");
var Hx = class extends jn {
  constructor(t, e = 1) {
    super(), this.isLight = !0, this.type = "Light", this.color = new yt(t), this.intensity = e;
  }
  dispose() {}
  copy(t, e) {
    return super.copy(t, e), this.color.copy(t.color), this.intensity = t.intensity, this;
  }
  toJSON(t) {
    let e = super.toJSON(t);
    return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), e;
  }
};
u(Hx, "Light");
var GS = new Bt(),
  e7 = new ne(),
  t7 = new ne(),
  HS = class {
    constructor(t) {
      this.camera = t, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new je(512, 512), this.map = null, this.mapPass = null, this.matrix = new Bt(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new hf(), this._frameExtents = new je(1, 1), this._viewportCount = 1, this._viewports = [new Er(0, 0, 1, 1)];
    }
    getViewportCount() {
      return this._viewportCount;
    }
    getFrustum() {
      return this._frustum;
    }
    updateMatrices(t) {
      let e = this.camera,
        n = this.matrix;
      e7.setFromMatrixPosition(t.matrixWorld), e.position.copy(e7), t7.setFromMatrixPosition(t.target.matrixWorld), e.lookAt(t7), e.updateMatrixWorld(), GS.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(GS), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(GS);
    }
    getViewport(t) {
      return this._viewports[t];
    }
    getFrameExtents() {
      return this._frameExtents;
    }
    dispose() {
      this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    copy(t) {
      return this.camera = t.camera.clone(), this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    toJSON() {
      let t = {};
      return 0 !== this.bias && (t.bias = this.bias), 0 !== this.normalBias && (t.normalBias = this.normalBias), 1 !== this.radius && (t.radius = this.radius), (512 !== this.mapSize.x || 512 !== this.mapSize.y) && (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
    }
  };
u(HS, "LightShadow");
var jS = class extends HS {
  constructor() {
    super(new Ll(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
  }
};
u(jS, "DirectionalLightShadow");
var jx = class extends Hx {
  constructor(t, e) {
    super(t, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(jn.DEFAULT_UP), this.updateMatrix(), this.target = new jn(), this.shadow = new jS();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(t) {
    return super.copy(t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
  }
};
u(jx, "DirectionalLight");
var Wx = class extends Hx {
  constructor(t, e) {
    super(t, e), this.isAmbientLight = !0, this.type = "AmbientLight";
  }
};
u(Wx, "AmbientLight");
var Xx = class extends Pi {
  constructor() {
    super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
  }
  copy(t) {
    return super.copy(t), this.instanceCount = t.instanceCount, this;
  }
  toJSON() {
    let t = super.toJSON();
    return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
  }
};
u(Xx, "InstancedBufferGeometry");
var wd = class {
  constructor(t = !0) {
    this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
  }
  start() {
    this.startTime = n7(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
  }
  stop() {
    this.getElapsedTime(), this.running = !1, this.autoStart = !1;
  }
  getElapsedTime() {
    return this.getDelta(), this.elapsedTime;
  }
  getDelta() {
    let t = 0;
    if (this.autoStart && !this.running) return this.start(), 0;
    if (this.running) {
      let e = n7();
      t = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t;
    }
    return t;
  }
};
function n7() {
  return ("undefined" == typeof performance ? Date : performance).now();
}
u(wd, "Clock"), u(n7, "now");
var WS = "\\[\\]\\.:\\/",
  JX = new RegExp("[" + WS + "]", "g"),
  XS = "[^" + WS + "]",
  KX = "[^" + WS.replace("\\.", "") + "]",
  QX = /((?:WC+[\/:])*)/.source.replace("WC", XS),
  $X = /(WCOD+)?/.source.replace("WCOD", KX),
  eY = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", XS),
  tY = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", XS),
  nY = new RegExp("^" + QX + $X + eY + tY + "$"),
  iY = ["material", "materials", "bones", "map"],
  YS = class {
    constructor(t, e, n) {
      let i = n || ci.parseTrackName(e);
      this._targetGroup = t, this._bindings = t.subscribe_(e, i);
    }
    getValue(t, e) {
      this.bind();
      let n = this._targetGroup.nCachedObjects_,
        i = this._bindings[n];
      void 0 !== i && i.getValue(t, e);
    }
    setValue(t, e) {
      let n = this._bindings;
      for (let i = this._targetGroup.nCachedObjects_, r = n.length; i !== r; ++i) n[i].setValue(t, e);
    }
    bind() {
      let t = this._bindings;
      for (let e = this._targetGroup.nCachedObjects_, n = t.length; e !== n; ++e) t[e].bind();
    }
    unbind() {
      let t = this._bindings;
      for (let e = this._targetGroup.nCachedObjects_, n = t.length; e !== n; ++e) t[e].unbind();
    }
  };
u(YS, "Composite");
var ci = class {
  constructor(t, e, n) {
    this.path = e, this.parsedPath = n || ci.parseTrackName(e), this.node = ci.findNode(t, this.parsedPath.nodeName), this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
  static create(t, e, n) {
    return t && t.isAnimationObjectGroup ? new ci.Composite(t, e, n) : new ci(t, e, n);
  }
  static sanitizeNodeName(t) {
    return t.replace(/\s/g, "_").replace(JX, "");
  }
  static parseTrackName(t) {
    let e = nY.exec(t);
    if (null === e) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
    let n = {
        nodeName: e[2],
        objectName: e[3],
        objectIndex: e[4],
        propertyName: e[5],
        propertyIndex: e[6]
      },
      i = n.nodeName && n.nodeName.lastIndexOf(".");
    if (void 0 !== i && -1 !== i) {
      let t = n.nodeName.substring(i + 1);
      -1 !== iY.indexOf(t) && (n.nodeName = n.nodeName.substring(0, i), n.objectName = t);
    }
    if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
    return n;
  }
  static findNode(t, e) {
    if (void 0 === e || "" === e || "." === e || -1 === e || e === t.name || e === t.uuid) return t;
    if (t.skeleton) {
      let n = t.skeleton.getBoneByName(e);
      if (void 0 !== n) return n;
    }
    if (t.children) {
      let n = u(function (t) {
          for (let i = 0; i < t.length; i++) {
            let r = t[i];
            if (r.name === e || r.uuid === e) return r;
            let o = n(r.children);
            if (o) return o;
          }
          return null;
        }, "searchNodeSubtree"),
        i = n(t.children);
      if (i) return i;
    }
    return null;
  }
  _getValue_unavailable() {}
  _setValue_unavailable() {}
  _getValue_direct(t, e) {
    t[e] = this.targetObject[this.propertyName];
  }
  _getValue_array(t, e) {
    let n = this.resolvedProperty;
    for (let i = 0, r = n.length; i !== r; ++i) t[e++] = n[i];
  }
  _getValue_arrayElement(t, e) {
    t[e] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(t, e) {
    this.resolvedProperty.toArray(t, e);
  }
  _setValue_direct(t, e) {
    this.targetObject[this.propertyName] = t[e];
  }
  _setValue_direct_setNeedsUpdate(t, e) {
    this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
    this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _setValue_array(t, e) {
    let n = this.resolvedProperty;
    for (let i = 0, r = n.length; i !== r; ++i) n[i] = t[e++];
  }
  _setValue_array_setNeedsUpdate(t, e) {
    let n = this.resolvedProperty;
    for (let i = 0, r = n.length; i !== r; ++i) n[i] = t[e++];
    this.targetObject.needsUpdate = !0;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
    let n = this.resolvedProperty;
    for (let i = 0, r = n.length; i !== r; ++i) n[i] = t[e++];
    this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _setValue_arrayElement(t, e) {
    this.resolvedProperty[this.propertyIndex] = t[e];
  }
  _setValue_arrayElement_setNeedsUpdate(t, e) {
    this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
    this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _setValue_fromArray(t, e) {
    this.resolvedProperty.fromArray(t, e);
  }
  _setValue_fromArray_setNeedsUpdate(t, e) {
    this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
    this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _getValue_unbound(t, e) {
    this.bind(), this.getValue(t, e);
  }
  _setValue_unbound(t, e) {
    this.bind(), this.setValue(t, e);
  }
  bind() {
    let t = this.node,
      e = this.parsedPath,
      n = e.objectName,
      i = e.propertyName,
      r = e.propertyIndex;
    if (t || (t = ci.findNode(this.rootNode, e.nodeName), this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) return void console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
    if (n) {
      let i = e.objectIndex;
      switch (n) {
        case "materials":
          if (!t.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
          if (!t.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
          t = t.material.materials;
          break;
        case "bones":
          if (!t.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
          t = t.skeleton.bones;
          for (let e = 0; e < t.length; e++) if (t[e].name === i) {
            i = e;
            break;
          }
          break;
        case "map":
          if ("map" in t) {
            t = t.map;
            break;
          }
          if (!t.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
          if (!t.material.map) return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
          t = t.material.map;
          break;
        default:
          if (void 0 === t[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
          t = t[n];
      }
      if (void 0 !== i) {
        if (void 0 === t[i]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
        t = t[i];
      }
    }
    let o = t[i];
    if (void 0 === o) {
      let n = e.nodeName;
      return void console.error("THREE.PropertyBinding: Trying to update property for track: " + n + "." + i + " but it wasn't found.", t);
    }
    let s = this.Versioning.None;
    this.targetObject = t, void 0 !== t.needsUpdate ? s = this.Versioning.NeedsUpdate : void 0 !== t.matrixWorldNeedsUpdate && (s = this.Versioning.MatrixWorldNeedsUpdate);
    let a = this.BindingType.Direct;
    if (void 0 !== r) {
      if ("morphTargetInfluences" === i) {
        if (!t.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
        if (!t.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
        void 0 !== t.morphTargetDictionary[r] && (r = t.morphTargetDictionary[r]);
      }
      a = this.BindingType.ArrayElement, this.resolvedProperty = o, this.propertyIndex = r;
    } else void 0 !== o.fromArray && void 0 !== o.toArray ? (a = this.BindingType.HasFromToArray, this.resolvedProperty = o) : Array.isArray(o) ? (a = this.BindingType.EntireArray, this.resolvedProperty = o) : this.propertyName = i;
    this.getValue = this.GetterByBindingType[a], this.setValue = this.SetterByBindingTypeAndVersioning[a][s];
  }
  unbind() {
    this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
};
u(ci, "PropertyBinding"), ci.Composite = YS, ci.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
}, ci.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
}, ci.prototype.GetterByBindingType = [ci.prototype._getValue_direct, ci.prototype._getValue_array, ci.prototype._getValue_arrayElement, ci.prototype._getValue_toArray], ci.prototype.SetterByBindingTypeAndVersioning = [[ci.prototype._setValue_direct, ci.prototype._setValue_direct_setNeedsUpdate, ci.prototype._setValue_direct_setMatrixWorldNeedsUpdate], [ci.prototype._setValue_array, ci.prototype._setValue_array_setNeedsUpdate, ci.prototype._setValue_array_setMatrixWorldNeedsUpdate], [ci.prototype._setValue_arrayElement, ci.prototype._setValue_arrayElement_setNeedsUpdate, ci.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate], [ci.prototype._setValue_fromArray, ci.prototype._setValue_fromArray_setNeedsUpdate, ci.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]];
var qme = new Float32Array(1),
  nh = class {
    constructor(t, e, n = 0, i = 1 / 0) {
      this.ray = new Fg(t, e), this.near = n, this.far = i, this.camera = null, this.layers = new Bg(), this.params = {
        Mesh: {},
        Line: {
          threshold: 1
        },
        LOD: {},
        Points: {
          threshold: 1
        },
        Sprite: {}
      };
    }
    set(t, e) {
      this.ray.set(t, e);
    }
    setFromCamera(t, e) {
      e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
    }
    intersectObject(t, e = !0, n = []) {
      return ZS(t, this, n, e), n.sort(i7), n;
    }
    intersectObjects(t, e = !0, n = []) {
      for (let i = 0, r = t.length; i < r; i++) ZS(t[i], this, n, e);
      return n.sort(i7), n;
    }
  };
function i7(t, e) {
  return t.distance - e.distance;
}
function ZS(t, e, n, i) {
  if (t.layers.test(e.layers) && t.raycast(e, n), !0 === i) {
    let i = t.children;
    for (let t = 0, r = i.length; t < r; t++) ZS(i[t], e, n, !0);
  }
}
u(nh, "Raycaster"), u(i7, "ascSort"), u(ZS, "intersectObject");
var Yx = class extends Rx {
  constructor(t = 10, e = 10, n = 4473924, i = 8947848) {
    n = new yt(n), i = new yt(i);
    let r = e / 2,
      o = t / e,
      s = t / 2,
      a = [],
      l = [];
    for (let t = 0, u = 0, h = -s; t <= e; t++, h += o) {
      a.push(-s, 0, h, s, 0, h), a.push(h, 0, -s, h, 0, s);
      let e = t === r ? n : i;
      e.toArray(l, u), u += 3, e.toArray(l, u), u += 3, e.toArray(l, u), u += 3, e.toArray(l, u), u += 3;
    }
    let u = new Pi();
    u.setAttribute("position", new Di(a, 3)), u.setAttribute("color", new Di(l, 3)), super(u, new Hg({
      vertexColors: !0,
      toneMapped: !1
    })), this.type = "GridHelper";
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose();
  }
};
u(Yx, "GridHelper");
var Zx = new $t(),
  Jx = class extends Rx {
    constructor(t, e = 16776960) {
      let n = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]),
        i = new Float32Array(24),
        r = new Pi();
      r.setIndex(new ui(n, 1)), r.setAttribute("position", new ui(i, 3)), super(r, new Hg({
        color: e,
        toneMapped: !1
      })), this.object = t, this.type = "BoxHelper", this.matrixAutoUpdate = !1, this.update();
    }
    update(t) {
      if (void 0 !== t && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && Zx.setFromObject(this.object), Zx.isEmpty()) return;
      let e = Zx.min,
        n = Zx.max,
        i = this.geometry.attributes.position,
        r = i.array;
      r[0] = n.x, r[1] = n.y, r[2] = n.z, r[3] = e.x, r[4] = n.y, r[5] = n.z, r[6] = e.x, r[7] = e.y, r[8] = n.z, r[9] = n.x, r[10] = e.y, r[11] = n.z, r[12] = n.x, r[13] = n.y, r[14] = e.z, r[15] = e.x, r[16] = n.y, r[17] = e.z, r[18] = e.x, r[19] = e.y, r[20] = e.z, r[21] = n.x, r[22] = e.y, r[23] = e.z, i.needsUpdate = !0, this.geometry.computeBoundingSphere();
    }
    setFromObject(t) {
      return this.object = t, this.update(), this;
    }
    copy(t, e) {
      return super.copy(t, e), this.object = t.object, this;
    }
    dispose() {
      this.geometry.dispose(), this.material.dispose();
    }
  };
u(Jx, "BoxHelper");
var Kx = class {
  constructor() {
    this.type = "ShapePath", this.color = new yt(), this.subPaths = [], this.currentPath = null;
  }
  moveTo(t, e) {
    return this.currentPath = new mf(), this.subPaths.push(this.currentPath), this.currentPath.moveTo(t, e), this;
  }
  lineTo(t, e) {
    return this.currentPath.lineTo(t, e), this;
  }
  quadraticCurveTo(t, e, n, i) {
    return this.currentPath.quadraticCurveTo(t, e, n, i), this;
  }
  bezierCurveTo(t, e, n, i, r, o) {
    return this.currentPath.bezierCurveTo(t, e, n, i, r, o), this;
  }
  splineThru(t) {
    return this.currentPath.splineThru(t), this;
  }
  toShapes(t) {
    function e(t) {
      let e = [];
      for (let n = 0, i = t.length; n < i; n++) {
        let i = t[n],
          r = new Qa();
        r.curves = i.curves, e.push(r);
      }
      return e;
    }
    function n(t, e) {
      let n = e.length,
        i = !1;
      for (let r = n - 1, o = 0; o < n; r = o++) {
        let n = e[r],
          s = e[o],
          a = s.x - n.x,
          l = s.y - n.y;
        if (Math.abs(l) > Number.EPSILON) {
          if (l < 0 && (n = e[o], a = -a, s = e[r], l = -l), t.y < n.y || t.y > s.y) continue;
          if (t.y === n.y) {
            if (t.x === n.x) return !0;
          } else {
            let e = l * (t.x - n.x) - a * (t.y - n.y);
            if (0 === e) return !0;
            if (e < 0) continue;
            i = !i;
          }
        } else {
          if (t.y !== n.y) continue;
          if (s.x <= t.x && t.x <= n.x || n.x <= t.x && t.x <= s.x) return !0;
        }
      }
      return i;
    }
    u(e, "toShapesNoHoles"), u(n, "isPointInsidePolygon");
    let i = eh.isClockWise,
      r = this.subPaths;
    if (0 === r.length) return [];
    let o,
      s,
      a,
      l = [];
    if (1 === r.length) return s = r[0], a = new Qa(), a.curves = s.curves, l.push(a), l;
    let h = !i(r[0].getPoints());
    h = t ? !h : h;
    let c,
      p,
      d = [],
      f = [],
      m = [],
      g = 0;
    f[g] = void 0, m[g] = [];
    for (let e = 0, n = r.length; e < n; e++) s = r[e], c = s.getPoints(), o = i(c), o = t ? !o : o, o ? (!h && f[g] && g++, f[g] = {
      s: new Qa(),
      p: c
    }, f[g].s.curves = s.curves, h && g++, m[g] = []) : m[g].push({
      h: s,
      p: c[0]
    });
    if (!f[0]) return e(r);
    if (f.length > 1) {
      let t = !1,
        e = 0;
      for (let t = 0, e = f.length; t < e; t++) d[t] = [];
      for (let i = 0, r = f.length; i < r; i++) {
        let r = m[i];
        for (let o = 0; o < r.length; o++) {
          let s = r[o],
            a = !0;
          for (let r = 0; r < f.length; r++) n(s.p, f[r].p) && (i !== r && e++, a ? (a = !1, d[r].push(s)) : t = !0);
          a && d[i].push(s);
        }
      }
      e > 0 && !1 === t && (m = d);
    }
    for (let t = 0, e = f.length; t < e; t++) {
      a = f[t].s, l.push(a), p = m[t];
      for (let t = 0, e = p.length; t < e; t++) a.holes.push(p[t].h);
    }
    return l;
  }
};
u(Kx, "ShapePath");
var Qx = class extends co {
  constructor(t, e, n, i) {
    console.warn("THREE.PlaneBufferGeometry has been renamed to THREE.PlaneGeometry."), super(t, e, n, i);
  }
};
u(Qx, "PlaneBufferGeometry"), "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
  detail: {
    revision: _3
  }
})), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = _3), E(), E();
var r7 = " ",
  Xo = class {
    static get separator() {
      return r7;
    }
    static set separator(t) {
      r7 = t;
    }
    static parse(t) {
      if (!isNaN(parseFloat(t)) && isFinite(t)) return Number(t);
      let e = String(t).trim().replace(/^-/, "").replace(/[NSEW]$/i, "").split(/[^0-9.,]+/);
      if ("" == e[e.length - 1] && e.splice(e.length - 1), "" == e) return NaN;
      let n = null;
      switch (e.length) {
        case 3:
          n = e[0] / 1 + e[1] / 60 + e[2] / 3600;
          break;
        case 2:
          n = e[0] / 1 + e[1] / 60;
          break;
        case 1:
          n = e[0];
          break;
        default:
          return NaN;
      }
      return /^-|[WS]$/i.test(t.trim()) && (n = -n), Number(n);
    }
    static toDms(t, e = "d", n) {
      if (isNaN(t) || "string" == typeof t && "" == t.trim() || "boolean" == typeof t || t == 1 / 0 || null == t) return null;
      if (void 0 === n) switch (e) {
        case "d":
        case "deg":
          n = 4;
          break;
        case "dm":
        case "deg+min":
          n = 2;
          break;
        case "dms":
        case "deg+min+sec":
          n = 0;
          break;
        default:
          e = "d", n = 4;
      }
      t = Math.abs(t);
      let i = null,
        r = null,
        o = null,
        s = null;
      switch (e) {
        default:
        case "d":
        case "deg":
          r = t.toFixed(n), r < 100 && (r = "0" + r), r < 10 && (r = "0" + r), i = r + "°";
          break;
        case "dm":
        case "deg+min":
          r = Math.floor(t), o = (60 * t % 60).toFixed(n), 60 == o && (o = 0 .toFixed(n), r++), r = ("000" + r).slice(-3), o < 10 && (o = "0" + o), i = r + "°" + Xo.separator + o + "′";
          break;
        case "dms":
        case "deg+min+sec":
          r = Math.floor(t), o = Math.floor(3600 * t / 60) % 60, s = (3600 * t % 60).toFixed(n), 60 == s && (s = 0 .toFixed(n), o++), 60 == o && (o = 0, r++), r = ("000" + r).slice(-3), o = ("00" + o).slice(-2), s < 10 && (s = "0" + s), i = r + "°" + Xo.separator + o + "′" + Xo.separator + s + "″";
      }
      return i;
    }
    static toLat(t, e, n) {
      let i = Xo.toDms(Xo.wrap90(t), e, n);
      return null === i ? "–" : i.slice(1) + Xo.separator + (t < 0 ? "S" : "N");
    }
    static toLon(t, e, n) {
      let i = Xo.toDms(Xo.wrap180(t), e, n);
      return null === i ? "–" : i + Xo.separator + (t < 0 ? "W" : "E");
    }
    static toBrng(t, e, n) {
      let i = Xo.toDms(Xo.wrap360(t), e, n);
      return null === i ? "–" : i.replace("360", "0");
    }
    static fromLocale(t) {
      let e = 123456.789.toLocaleString(),
        n = {
          thousands: e.slice(3, 4),
          decimal: e.slice(7, 8)
        };
      return t.replace(n.thousands, "⁜").replace(n.decimal, ".").replace("⁜", ",");
    }
    static toLocale(t) {
      let e = 123456.789.toLocaleString(),
        n = {
          thousands: e.slice(3, 4),
          decimal: e.slice(7, 8)
        };
      return t.replace(/,([0-9])/, "⁜$1").replace(".", n.decimal).replace("⁜", n.thousands);
    }
    static compassPoint(t, e = 3) {
      if (![1, 2, 3].includes(Number(e))) throw new RangeError(`invalid precision ‘${e}’`);
      t = Xo.wrap360(t);
      let n = 4 * 2 ** (e - 1);
      return ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"][Math.round(t * n / 360) % n * 16 / n];
    }
    static wrap360(t) {
      return 0 <= t && t < 360 ? t : (t % 360 + 360) % 360;
    }
    static wrap180(t) {
      return -180 < t && t <= 180 ? t : (t + 540) % 360 - 180;
    }
    static wrap90(t) {
      return -90 <= t && t <= 90 ? t : Math.abs((t % 360 + 270) % 360 - 180) - 90;
    }
  };
u(Xo, "Dms"), Number.prototype.toRadians = function () {
  return this * Math.PI / 180;
}, Number.prototype.toDegrees = function () {
  return 180 * this / Math.PI;
};
var Dn = Xo,
  Ji = Math.PI,
  _t = class {
    constructor(t, e) {
      if (isNaN(t)) throw new TypeError(`invalid lat ‘${t}’`);
      if (isNaN(e)) throw new TypeError(`invalid lon ‘${e}’`);
      this._lat = Dn.wrap90(Number(t)), this._lon = Dn.wrap180(Number(e));
    }
    get lat() {
      return this._lat;
    }
    get latitude() {
      return this._lat;
    }
    set lat(t) {
      if (this._lat = isNaN(t) ? Dn.wrap90(Dn.parse(t)) : Dn.wrap90(Number(t)), isNaN(this._lat)) throw new TypeError(`invalid lat ‘${t}’`);
    }
    set latitude(t) {
      if (this._lat = isNaN(t) ? Dn.wrap90(Dn.parse(t)) : Dn.wrap90(Number(t)), isNaN(this._lat)) throw new TypeError(`invalid latitude ‘${t}’`);
    }
    get lon() {
      return this._lon;
    }
    get lng() {
      return this._lon;
    }
    get longitude() {
      return this._lon;
    }
    set lon(t) {
      if (this._lon = isNaN(t) ? Dn.wrap180(Dn.parse(t)) : Dn.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid lon ‘${t}’`);
    }
    set lng(t) {
      if (this._lon = isNaN(t) ? Dn.wrap180(Dn.parse(t)) : Dn.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid lng ‘${t}’`);
    }
    set longitude(t) {
      if (this._lon = isNaN(t) ? Dn.wrap180(Dn.parse(t)) : Dn.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid longitude ‘${t}’`);
    }
    static get metresToKm() {
      return .001;
    }
    static get metresToMiles() {
      return 1 / 1609.344;
    }
    static get metresToNauticalMiles() {
      return 1 / 1852;
    }
    static parse(...t) {
      if (0 == t.length) throw new TypeError("invalid (empty) point");
      if (null === t[0] || null === t[1]) throw new TypeError("invalid (null) point");
      let e, n;
      if (2 == t.length && ([e, n] = t, e = Dn.wrap90(Dn.parse(e)), n = Dn.wrap180(Dn.parse(n)), isNaN(e) || isNaN(n))) throw new TypeError(`invalid point ‘${t.toString()}’`);
      if (1 == t.length && "string" == typeof t[0] && ([e, n] = t[0].split(","), e = Dn.wrap90(Dn.parse(e)), n = Dn.wrap180(Dn.parse(n)), isNaN(e) || isNaN(n))) throw new TypeError(`invalid point ‘${t[0]}’`);
      if (1 == t.length && "object" == typeof t[0]) {
        let i = t[0];
        if ("Point" == i.type && Array.isArray(i.coordinates) ? [n, e] = i.coordinates : (null != i.latitude && (e = i.latitude), null != i.lat && (e = i.lat), null != i.longitude && (n = i.longitude), null != i.lng && (n = i.lng), null != i.lon && (n = i.lon), e = Dn.wrap90(Dn.parse(e)), n = Dn.wrap180(Dn.parse(n))), isNaN(e) || isNaN(n)) throw new TypeError(`invalid point ‘${JSON.stringify(t[0])}’`);
      }
      if (isNaN(e) || isNaN(n)) throw new TypeError(`invalid point ‘${t.toString()}’`);
      return new _t(e, n);
    }
    distanceTo(t, e = 6371e3) {
      if (t instanceof _t || (t = _t.parse(t)), isNaN(e)) throw new TypeError(`invalid radius ‘${e}’`);
      let n = e,
        i = this.lat.toRadians(),
        r = this.lon.toRadians(),
        o = t.lat.toRadians(),
        s = o - i,
        a = t.lon.toRadians() - r,
        l = Math.sin(s / 2) * Math.sin(s / 2) + Math.cos(i) * Math.cos(o) * Math.sin(a / 2) * Math.sin(a / 2);
      return n * (2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)));
    }
    initialBearingTo(t) {
      if (t instanceof _t || (t = _t.parse(t)), this.equals(t)) return NaN;
      let e = this.lat.toRadians(),
        n = t.lat.toRadians(),
        i = (t.lon - this.lon).toRadians(),
        r = Math.cos(e) * Math.sin(n) - Math.sin(e) * Math.cos(n) * Math.cos(i),
        o = Math.sin(i) * Math.cos(n),
        s = Math.atan2(o, r).toDegrees();
      return Dn.wrap360(s);
    }
    finalBearingTo(t) {
      t instanceof _t || (t = _t.parse(t));
      let e = t.initialBearingTo(this) + 180;
      return Dn.wrap360(e);
    }
    midpointTo(t) {
      t instanceof _t || (t = _t.parse(t));
      let e = this.lat.toRadians(),
        n = this.lon.toRadians(),
        i = t.lat.toRadians(),
        r = (t.lon - this.lon).toRadians(),
        o = Math.cos(e),
        s = 0,
        a = Math.sin(e),
        l = {
          x: o + Math.cos(i) * Math.cos(r),
          y: s + Math.cos(i) * Math.sin(r),
          z: a + Math.sin(i)
        },
        u = Math.atan2(l.z, Math.sqrt(l.x * l.x + l.y * l.y)),
        h = n + Math.atan2(l.y, l.x),
        c = u.toDegrees(),
        p = h.toDegrees();
      return new _t(c, p);
    }
    intermediatePointTo(t, e) {
      if (t instanceof _t || (t = _t.parse(t)), this.equals(t)) return new _t(this.lat, this.lon);
      let n = this.lat.toRadians(),
        i = this.lon.toRadians(),
        r = t.lat.toRadians(),
        o = t.lon.toRadians(),
        s = r - n,
        a = o - i,
        l = Math.sin(s / 2) * Math.sin(s / 2) + Math.cos(n) * Math.cos(r) * Math.sin(a / 2) * Math.sin(a / 2),
        u = 2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)),
        h = Math.sin((1 - e) * u) / Math.sin(u),
        c = Math.sin(e * u) / Math.sin(u),
        p = h * Math.cos(n) * Math.cos(i) + c * Math.cos(r) * Math.cos(o),
        d = h * Math.cos(n) * Math.sin(i) + c * Math.cos(r) * Math.sin(o),
        f = h * Math.sin(n) + c * Math.sin(r),
        m = Math.atan2(f, Math.sqrt(p * p + d * d)),
        g = Math.atan2(d, p),
        v = m.toDegrees(),
        y = g.toDegrees();
      return new _t(v, y);
    }
    destinationPoint(t, e, n = 6371e3) {
      let i = t / n,
        r = Number(e).toRadians(),
        o = this.lat.toRadians(),
        s = this.lon.toRadians(),
        a = Math.sin(o) * Math.cos(i) + Math.cos(o) * Math.sin(i) * Math.cos(r),
        l = Math.asin(a),
        u = Math.sin(r) * Math.sin(i) * Math.cos(o),
        h = Math.cos(i) - Math.sin(o) * a,
        c = s + Math.atan2(u, h),
        p = l.toDegrees(),
        d = c.toDegrees();
      return new _t(p, d);
    }
    static intersection(t, e, n, i) {
      if (t instanceof _t || (t = _t.parse(t)), n instanceof _t || (n = _t.parse(n)), isNaN(e)) throw new TypeError(`invalid brng1 ‘${e}’`);
      if (isNaN(i)) throw new TypeError(`invalid brng2 ‘${i}’`);
      let r = t.lat.toRadians(),
        o = t.lon.toRadians(),
        s = n.lat.toRadians(),
        a = n.lon.toRadians(),
        l = Number(e).toRadians(),
        u = Number(i).toRadians(),
        h = s - r,
        c = a - o,
        p = 2 * Math.asin(Math.sqrt(Math.sin(h / 2) * Math.sin(h / 2) + Math.cos(r) * Math.cos(s) * Math.sin(c / 2) * Math.sin(c / 2)));
      if (Math.abs(p) < Number.EPSILON) return new _t(t.lat, t.lon);
      let d = (Math.sin(s) - Math.sin(r) * Math.cos(p)) / (Math.sin(p) * Math.cos(r)),
        f = (Math.sin(r) - Math.sin(s) * Math.cos(p)) / (Math.sin(p) * Math.cos(s)),
        m = Math.acos(Math.min(Math.max(d, -1), 1)),
        g = Math.acos(Math.min(Math.max(f, -1), 1)),
        v = l - (Math.sin(a - o) > 0 ? m : 2 * Ji - m),
        y = (Math.sin(a - o) > 0 ? 2 * Ji - g : g) - u;
      if (0 == Math.sin(v) && 0 == Math.sin(y) || Math.sin(v) * Math.sin(y) < 0) return null;
      let _ = -Math.cos(v) * Math.cos(y) + Math.sin(v) * Math.sin(y) * Math.cos(p),
        x = Math.atan2(Math.sin(p) * Math.sin(v) * Math.sin(y), Math.cos(y) + Math.cos(v) * _),
        E = Math.asin(Math.min(Math.max(Math.sin(r) * Math.cos(x) + Math.cos(r) * Math.sin(x) * Math.cos(l), -1), 1)),
        b = o + Math.atan2(Math.sin(l) * Math.sin(x) * Math.cos(r), Math.cos(x) - Math.sin(r) * Math.sin(E)),
        w = E.toDegrees(),
        S = b.toDegrees();
      return new _t(w, S);
    }
    crossTrackDistanceTo(t, e, n = 6371e3) {
      t instanceof _t || (t = _t.parse(t)), e instanceof _t || (e = _t.parse(e));
      let i = n;
      if (this.equals(t)) return 0;
      let r = t.distanceTo(this, i) / i,
        o = t.initialBearingTo(this).toRadians(),
        s = t.initialBearingTo(e).toRadians();
      return Math.asin(Math.sin(r) * Math.sin(o - s)) * i;
    }
    alongTrackDistanceTo(t, e, n = 6371e3) {
      t instanceof _t || (t = _t.parse(t)), e instanceof _t || (e = _t.parse(e));
      let i = n;
      if (this.equals(t)) return 0;
      let r = t.distanceTo(this, i) / i,
        o = t.initialBearingTo(this).toRadians(),
        s = t.initialBearingTo(e).toRadians(),
        a = Math.asin(Math.sin(r) * Math.sin(o - s));
      return Math.acos(Math.cos(r) / Math.abs(Math.cos(a))) * Math.sign(Math.cos(s - o)) * i;
    }
    maxLatitude(t) {
      let e = Number(t).toRadians(),
        n = this.lat.toRadians();
      return Math.acos(Math.abs(Math.sin(e) * Math.cos(n))).toDegrees();
    }
    static crossingParallels(t, e, n) {
      if (t.equals(e)) return null;
      let i = Number(n).toRadians(),
        r = t.lat.toRadians(),
        o = t.lon.toRadians(),
        s = e.lat.toRadians(),
        a = e.lon.toRadians() - o,
        l = Math.sin(r) * Math.cos(s) * Math.cos(i) * Math.sin(a),
        u = Math.sin(r) * Math.cos(s) * Math.cos(i) * Math.cos(a) - Math.cos(r) * Math.sin(s) * Math.cos(i),
        h = Math.cos(r) * Math.cos(s) * Math.sin(i) * Math.sin(a);
      if (h * h > l * l + u * u) return null;
      let c = Math.atan2(-u, l),
        p = Math.acos(h / Math.sqrt(l * l + u * u)),
        d = o + c + p,
        f = (o + c - p).toDegrees(),
        m = d.toDegrees();
      return {
        lon1: Dn.wrap180(f),
        lon2: Dn.wrap180(m)
      };
    }
    rhumbDistanceTo(t, e = 6371e3) {
      t instanceof _t || (t = _t.parse(t));
      let n = e,
        i = this.lat.toRadians(),
        r = t.lat.toRadians(),
        o = r - i,
        s = Math.abs(t.lon - this.lon).toRadians();
      Math.abs(s) > Ji && (s = s > 0 ? -(2 * Ji - s) : 2 * Ji + s);
      let a = Math.log(Math.tan(r / 2 + Ji / 4) / Math.tan(i / 2 + Ji / 4)),
        l = Math.abs(a) > 1e-11 ? o / a : Math.cos(i);
      return Math.sqrt(o * o + l * l * s * s) * n;
    }
    rhumbBearingTo(t) {
      if (t instanceof _t || (t = _t.parse(t)), this.equals(t)) return NaN;
      let e = this.lat.toRadians(),
        n = t.lat.toRadians(),
        i = (t.lon - this.lon).toRadians();
      Math.abs(i) > Ji && (i = i > 0 ? -(2 * Ji - i) : 2 * Ji + i);
      let r = Math.log(Math.tan(n / 2 + Ji / 4) / Math.tan(e / 2 + Ji / 4)),
        o = Math.atan2(i, r).toDegrees();
      return Dn.wrap360(o);
    }
    rhumbDestinationPoint(t, e, n = 6371e3) {
      let i = this.lat.toRadians(),
        r = this.lon.toRadians(),
        o = Number(e).toRadians(),
        s = t / n,
        a = s * Math.cos(o),
        l = i + a;
      Math.abs(l) > Ji / 2 && (l = l > 0 ? Ji - l : -Ji - l);
      let u = Math.log(Math.tan(l / 2 + Ji / 4) / Math.tan(i / 2 + Ji / 4)),
        h = Math.abs(u) > 1e-11 ? a / u : Math.cos(i),
        c = r + s * Math.sin(o) / h,
        p = l.toDegrees(),
        d = c.toDegrees();
      return new _t(p, d);
    }
    rhumbMidpointTo(t) {
      t instanceof _t || (t = _t.parse(t));
      let e = this.lat.toRadians(),
        n = this.lon.toRadians(),
        i = t.lat.toRadians(),
        r = t.lon.toRadians();
      Math.abs(r - n) > Ji && (n += 2 * Ji);
      let o = (e + i) / 2,
        s = Math.tan(Ji / 4 + e / 2),
        a = Math.tan(Ji / 4 + i / 2),
        l = Math.tan(Ji / 4 + o / 2),
        u = ((r - n) * Math.log(l) + n * Math.log(a) - r * Math.log(s)) / Math.log(a / s);
      isFinite(u) || (u = (n + r) / 2);
      let h = o.toDegrees(),
        c = u.toDegrees();
      return new _t(h, c);
    }
    static areaOf(t, e = 6371e3) {
      let n = e,
        i = t[0].equals(t[t.length - 1]);
      i || t.push(t[0]);
      let r = t.length - 1,
        o = 0;
      for (let e = 0; e < r; e++) {
        let n = t[e].lat.toRadians(),
          i = t[e + 1].lat.toRadians(),
          r = (t[e + 1].lon - t[e].lon).toRadians();
        o += 2 * Math.atan2(Math.tan(r / 2) * (Math.tan(n / 2) + Math.tan(i / 2)), 1 + Math.tan(n / 2) * Math.tan(i / 2));
      }
      a(t) && (o = Math.abs(o) - 2 * Ji);
      let s = Math.abs(o * n * n);
      return i || t.pop(), s;
      function a(t) {
        let e = 0,
          n = t[0].initialBearingTo(t[1]);
        for (let i = 0; i < t.length - 1; i++) {
          let r = t[i].initialBearingTo(t[i + 1]),
            o = t[i].finalBearingTo(t[i + 1]);
          e += (r - n + 540) % 360 - 180, e += (o - r + 540) % 360 - 180, n = o;
        }
        return e += (t[0].initialBearingTo(t[1]) - n + 540) % 360 - 180, Math.abs(e) < 90;
      }
    }
    equals(t) {
      return t instanceof _t || (t = _t.parse(t)), !(Math.abs(this.lat - t.lat) > Number.EPSILON || Math.abs(this.lon - t.lon) > Number.EPSILON);
    }
    toGeoJSON() {
      return {
        type: "Point",
        coordinates: [this.lon, this.lat]
      };
    }
    toString(t = "d", e) {
      if (!["d", "dm", "dms", "n"].includes(t)) throw new RangeError(`invalid format ‘${t}’`);
      if ("n" == t) return null == e && (e = 4), `${this.lat.toFixed(e)},${this.lon.toFixed(e)}`;
      return `${Dn.toLat(this.lat, t, e)}, ${Dn.toLon(this.lon, t, e)}`;
    }
  };
u(_t, "LatLonSpherical"), E();
var Rl,
  o7 = "mi-debug";
function s7(t) {
  0 <= t && t <= 3 && (a7.logState = t);
}
!function (t) {
  t[t.LOG = 0] = "LOG", t[t.WARN = 1] = "WARN", t[t.ERROR = 2] = "ERROR", t[t.SILENT = 3] = "SILENT";
}(Rl || (Rl = {})), u(s7, "setLoggerLevel");
var a7 = {
    logState: 0,
    log(...t) {
      this.logState <= 0 && console.log("[MappedInJS]", ...t);
    },
    warn(...t) {
      this.logState <= 1 && console.warn("[MappedInJS]", ...t);
    },
    error(...t) {
      this.logState <= 2 && console.error("[MappedInJS]", ...t);
    },
    assert(...t) {
      console.assert(...t);
    },
    time(t) {
      console.time(t);
    },
    timeEnd(t) {
      console.timeEnd(t);
    }
  },
  ke = a7;
E(), E();
var _f,
  tl,
  nl,
  JS = [0, 4, 6, 8, 10],
  ls = u(() => {
    let t = new Array(16).fill(0),
      e = 4294967296 * Math.random();
    for (let n = 0; n < t.length; n++) n > 0 && 0 == (3 & n) && (e = 4294967296 * Math.random()), t[n] = e >>> ((3 & n) << 3) & 255;
    let n = t.map(t => t.toString(16).padStart(2, "0"));
    return n[6] = "4" + n[6][1], n[8] = ["8", "9", "a", "b"].includes(n[7][0]) ? n[7] : "a" + n[7][1], JS.map((t, e) => n.slice(t, e === JS.length - 1 ? void 0 : JS[e + 1]).join("")).join("-");
  }, "randomId"),
  l7 = "mi-session-data",
  u7 = "mi-local-data",
  KS = class {
    constructor() {
      re(this, tl, void 0), re(this, nl, void 0);
      try {
        let t = sessionStorage.getItem(l7);
        he(this, tl, t ? JSON.parse(t) : {
          id: ls()
        });
      } catch {
        he(this, tl, {
          id: ls()
        });
      }
      try {
        let t = localStorage.getItem(u7);
        he(this, nl, t ? JSON.parse(t) : {
          deviceId: ls()
        });
      } catch {
        he(this, nl, {
          deviceId: ls()
        });
      }
      w(this, tl).id || (w(this, tl).id = ls()), w(this, nl).deviceId || (w(this, nl).deviceId = ls());
    }
    static getInstance() {
      return w(this, _f) || he(this, _f, new KS()), w(this, _f);
    }
    static ___clearInstance() {
      he(this, _f, void 0);
    }
    saveSessionData(t, e) {
      w(this, tl)[t] = e;
      try {
        return sessionStorage.setItem(l7, JSON.stringify(w(this, tl))), !0;
      } catch {
        return !1;
      }
    }
    loadSessionData(t) {
      let e = w(this, tl)[t];
      if (null != e) return e;
    }
    saveLocalData(t, e) {
      w(this, nl)[t] = e;
      try {
        return localStorage.setItem(u7, JSON.stringify(w(this, nl))), !0;
      } catch {
        return !1;
      }
    }
    loadLocalData(t) {
      let e = w(this, nl)[t];
      if (null != e) return e;
    }
  },
  Sd = KS;
u(Sd, "SafeStorage"), _f = new WeakMap(), tl = new WeakMap(), nl = new WeakMap(), re(Sd, _f, void 0);
var tT = Rt(il());
function c7(t) {
  return /^[\da-f]{24}$/i.test(t);
}
function ih(t) {
  t && (t.map && (t.map.dispose(), t.map = void 0), t.dispose());
}
function $x() {
  return Sd.getInstance().loadLocalData("deviceId");
}
function e2() {
  return Sd.getInstance().loadSessionData("id");
}
function Vr(t) {
  return "string" == typeof t ? t : t.id;
}
function rl(t, e) {
  return null == e ? t : "string" == typeof t ? e.find(function (e) {
    return e.id == t;
  }) : t;
}
function t2(t) {
  if (t.scale || t.x_scale) return 1 / (t.scale || t.x_scale);
  let e;
  try {
    let n = t.georeference[0],
      i = t.georeference[2],
      r = new _t(n.target.x, n.target.y),
      o = new _t(i.target.x, i.target.y),
      s = r.distanceTo(o),
      a = n.control.x - i.control.x,
      l = n.control.y - i.control.y;
    e = Math.sqrt(a * a + l * l) / s;
  } catch (n) {
    e = 1, ke.warn(n), ke.warn("Couldn't georeference " + (t.name || t.shortName || t.id) + ". Probably not enough geocoordinates.");
  }
  return e;
}
function h7(t) {
  let e;
  try {
    let n = t.georeference[0],
      i = t.georeference[2],
      r = new _t(n.target.x, n.target.y),
      o = new _t(i.target.x, i.target.y);
    e = -((r.finalBearingTo(o) + 0) * Math.PI / 180 - Math.atan2(i.control.y - n.control.y, i.control.x - n.control.x) - Math.PI / 2);
  } catch (n) {
    e = 0, ke.warn(n), ke.warn("Couldn't georeference " + (t.name || t.shortName || t.id) + ". Probably not enough geocoordinates.");
  }
  return e;
}
function f7(t, e, n) {
  let i,
    r,
    o,
    s = null,
    a = 0;
  n || (n = {});
  let l = u(function () {
    a = !1 === n.leading ? 0 : Date.now(), s = null, o = t.apply(i, r), s || (i = r = null);
  }, "later");
  return function () {
    let u = Date.now();
    !a && !1 === n.leading && (a = u);
    let h = e - (u - a);
    return i = this, r = arguments, h <= 0 || h > e ? (s && (clearTimeout(s), s = null), a = u, o = t.apply(i, r), s || (i = r = null)) : !s && !1 !== n.trailing && (s = setTimeout(l, h)), o;
  };
}
function ol(t, e, n) {
  let i;
  return function () {
    let r = this,
      o = arguments,
      s = u(function () {
        i = null, n || t.apply(r, o);
      }, "later"),
      a = n && !i;
    clearTimeout(i), i = setTimeout(s, e), a && t.apply(r, o);
  };
}
function nT(t, e, n) {
  let i = t * (Math.PI / 180) / 2,
    r = e / 2;
  return n * Math.tan(i) / r;
}
function p7(t, e, n) {
  let i = [t],
    r = (e.x - t.x) / n,
    o = (e.y - t.y) / n,
    s = (e.z - t.z) / n;
  for (let e = 1; e < n; e++) {
    let n = t.clone(),
      a = new ne(e * r, e * o, e * s);
    n.add(a), i.push(n);
  }
  return i.push(e), i;
}
u(c7, "isGatewayKey"), u(ih, "scrubMaterial"), u($x, "getDeviceID"), u(e2, "getSessionID"), u(Vr, "getObjectId"), u(rl, "getObject"), u(t2, "getMapScale"), u(h7, "getNorth"), u(f7, "throttle"), u(ol, "debounce"), u(nT, "getProjectionScaleFactor"), u(p7, "splitLine");
var Td = u((t, e) => {
    if ("string" == typeof t) {
      if (null == e || !Array.isArray(e.polygons)) return null;
      t = e.polygons.find(function (e) {
        return e.id == t;
      });
    }
    let n = null;
    if (null != t && null != t.locations && t.locations.length > 0) {
      n = t.locations[0];
      for (let e = 0, i = t.locations.length; e < i; e++) {
        let i = t.locations[e];
        for (; null != i.parent;) i = i.parent, i.polygons.includes(t) && (n = i);
        if (null == i.parent && i.polygons.includes(t)) return i;
      }
    }
    return n;
  }, "getPrimaryLocationForPolygon"),
  t0 = u((t, e) => {
    let n,
      i = t.venue.defaultMap;
    if (e && e.firstMap) {
      let t = Vr(e.firstMap);
      null == t ? ke.warn("Invalid map id provided to 'firstMap' option. Ignoring.") : i = t;
    }
    if (i) for (let e = 0, r = t.maps.length; e < r; ++e) if (t.maps[e].id === i) {
      n = t.maps[e];
      break;
    }
    if (!n) {
      let e = t.maps[0];
      for (let n of t.maps.slice(1)) e = Math.abs(n.elevation) === Math.abs(e.elevation) ? n.elevation > e.elevation ? n : e : Math.abs(n.elevation) < Math.abs(e.elevation) ? n : e;
      n = e;
    }
    return n;
  }, "determineStartingMap");
function iT(t, e = 0) {
  let n = 3735928559 ^ e,
    i = 1103547991 ^ e;
  for (let e, r = 0; r < t.length; r++) e = t.charCodeAt(r), n = Math.imul(n ^ e, 2654435761), i = Math.imul(i ^ e, 1597334677);
  return n = Math.imul(n ^ n >>> 16, 2246822507) ^ Math.imul(i ^ i >>> 13, 3266489909), i = Math.imul(i ^ i >>> 16, 2246822507) ^ Math.imul(n ^ n >>> 13, 3266489909), 4294967296 * (2097151 & i) + (n >>> 0);
}
function d7(t, e) {
  let n = t.getCenter(new ne()),
    i = t.getSize(new ne()),
    {
      x: r,
      y: o,
      z: s
    } = i,
    a = r * e,
    l = o * e,
    u = s * e,
    h = n.x - a / 2,
    c = n.x + a / 2,
    p = n.y - l / 2,
    d = n.y + l / 2,
    f = n.z - u / 2,
    m = n.z + u / 2;
  return new $t({
    x: h,
    y: p,
    z: f
  }, {
    x: c,
    y: d,
    z: m
  });
}
function Nl({
  from: t,
  to: e,
  duration: n = 300,
  easing: i = tT.default.Easing.Quadratic.Out,
  delay: r = 0,
  onUpdate: o = u(t => {}, "onUpdate"),
  onStart: s = u(() => {}, "onStart"),
  onComplete: a = u(() => {}, "onComplete")
}) {
  let l = new tT.default.Tween(t).to(e, n).easing(i).delay(r).onStart(s).onUpdate(t => {
    o(t);
  });
  return {
    start: t => new Promise(e => {
      l.onComplete(() => {
        a(), e();
      }).start(), t.tryRendering();
    })
  };
}
u(iT, "cyrb53"), u(d7, "addMarginMultiplierToBoundingBox"), u(Nl, "tweenPromise");
var tF = Rt(R7());
E();
var Jk = Rt(N7());
E(), E(), E();
var qL = Rt(DL());
E();
var AT = class {
  constructor({
    origin: t,
    destination: e,
    vortex: n,
    elevationDelta: i = 0,
    distance: r = 0,
    angle: o = 0
  }) {
    let s, a;
    if (A(this, "origin"), A(this, "destination"), A(this, "vortex"), A(this, "distance"), A(this, "angle"), A(this, "weight"), this.origin = t, this.destination = e, this.vortex = n, this.distance = r, this.angle = o, n ? (this.distance = 0, this.angle = 0, s = void 0 !== n.weight && n.weight > 0 ? n.weight : "elevator" === n.type ? 2e3 : 1e3, a = n.multiplier && n.multiplier >= 1 ? n.multiplier : 1, this.weight = i * a + s) : (s = e.weight && e.weight >= 0 ? e.weight : 0, a = e.multiplier && e.multiplier >= 1 ? e.multiplier : 1, this.weight = this.distance * a + s), isNaN(this.angle)) throw new Error("nan angle");
  }
};
u(AT, "Edge");
var nb = AT;
function HK(t) {
  if (t.scale || t.x_scale) return 1 / (t.scale || t.x_scale || 1);
  try {
    if (!t.georeference) throw new Error(`map ${t.name || t.shortName || t.id} does not have a georeference field`);
    if (t.georeference.length < 3) throw new Error(`map ${t.name || t.shortName || t.id} has less than 3 georeference points, we require at least 3 for proper map scaling`);
    let e = t.georeference[0],
      n = t.georeference[2],
      i = (0, qL.getDistance)({
        latitude: e.target.x,
        longitude: e.target.y
      }, {
        latitude: n.target.x,
        longitude: n.target.y
      }),
      r = e.control.x - n.control.x,
      o = e.control.y - n.control.y;
    return Math.sqrt(r * r + o * o) / i;
  } catch (t) {
    return ke.error(t), 1;
  }
}
function jK(t, e) {
  let n = t.x - e.x,
    i = t.y - e.y;
  return (Math.atan2(i, n) + 2.5 * Math.PI) % (2 * Math.PI);
}
u(HK, "getMapScale"), u(jK, "getAngle");
var IT = class {
  constructor({
    nodes: t,
    vortexes: e,
    maps: n,
    showVortexNames: i = !1
  }) {
    A(this, "edges"), A(this, "nodesById"), A(this, "mapsById"), this.edges = {}, this.mapsById = n.map(t => ({
      ...t,
      _scale: HK(t)
    })).reduce((t, e) => (t[e.id] = e, t), {});
    let r = t.filter(t => !!this.mapsById[t.map]).map(t => ({
      ...t,
      paths: t.paths ? t.paths.filter(({
        map: e
      }) => e === t.map) : []
    }));
    this.nodesById = r.reduce((t, e) => (t[e.id] = e, t), {});
    for (let t in this.nodesById) this.nodesById.hasOwnProperty(t) && (this.nodesById[t].paths = this.nodesById[t].paths.filter(({
      node: t
    }) => !!this.nodesById[t]));
    let o = e.map(t => ({
      ...t,
      name: i ? t.name : t.type,
      nodes: t.nodes ? t.nodes.filter(t => !!this.nodesById[t]) : []
    }));
    r.forEach(t => {
      this.edges[t.id] = t.paths.map(({
        node: e
      }) => {
        let n = this.nodesById[e];
        return new nb({
          angle: jK(t, n),
          destination: n,
          distance: this.getDistance(t, n),
          origin: t
        });
      });
    }), o.forEach(t => {
      if (null == t.nodes || 0 === t.nodes.length) return;
      let e = 0;
      for (; e < t.nodes.length - 1;) {
        let n = this.nodesById[t.nodes[e]];
        if (e++, null == n) continue;
        let i = e;
        for (; i < t.nodes.length;) {
          let e = this.nodesById[t.nodes[i]];
          if (i++, null == e) continue;
          let r = this.mapsById[n.map].elevation || 0,
            o = this.mapsById[e.map].elevation || 0,
            s = Math.abs(r - o);
          this.edges[n.id].push(new nb({
            destination: e,
            elevationDelta: s,
            origin: n,
            vortex: t
          })), this.edges[e.id].push(new nb({
            destination: n,
            elevationDelta: s,
            origin: e,
            vortex: t
          }));
        }
      }
    });
  }
  aStar(t, e, n) {
    let i = t.map(t => this.nodesById[t]).filter(t => t),
      r = e.map(t => this.nodesById[t]).filter(t => t);
    if (0 === i.length || 0 === r.length) return [];
    let o = [],
      s = {},
      a = {};
    for (i.forEach(t => {
      let e = this.getShortestEuclideanDistance(t, r);
      o.push({
        origin: t,
        priority: e
      }), s[t.id] = null, a[t.id] = 0;
    }), o.sort((t, e) => t.priority - e.priority); o.length > 0;) {
      let t = o[0];
      if (r.includes(t.origin)) {
        let e = [],
          n = s[t.origin.id];
        for (; null != n;) {
          e.push(n);
          let t = s[n.origin.id];
          n = null != t ? t : null;
        }
        return e.reverse();
      }
      for (let e of this.edges[t.origin.id]) {
        let i = e.vortex && !1 === e.vortex.accessible;
        if (n && (i || !1 === e.origin.accessible || !1 === e.destination.accessible)) continue;
        let l = a[t.origin.id] + e.weight;
        if (null == a[e.destination.id] || l < a[e.destination.id]) {
          a[e.destination.id] = l;
          let t = l + this.getShortestEuclideanDistance(e.destination, r);
          o.push({
            origin: e.destination,
            priority: t
          }), s[e.destination.id] = e;
        }
      }
      o.splice(0, 1), o.sort((t, e) => t.priority - e.priority);
    }
    return [];
  }
  getDistance(t, e) {
    let n,
      i = t.x - e.x,
      r = t.y - e.y,
      o = i * i + r * r;
    return n = null == this.mapsById[t.map] ? 1 : this.mapsById[t.map]._scale, Math.sqrt(o) / n;
  }
  getShortestEuclideanDistance(t, e) {
    return e.reduce((e, n) => {
      let i = this.getDistance(t, n);
      return Math.min(e, i);
    }, Number.MAX_VALUE);
  }
};
u(IT, "NavigationGraph");
var Ai,
  us,
  oh,
  LT = IT;
function WK(t) {
  switch (t) {
    case oh.DOWN:
    case oh.UP:
      return `${t} `;
    default:
      return "";
  }
}
E(), E(), function (t) {
  t.DEPARTURE = "Departure", t.TAKEVORTEX = "TakeVortex", t.EXITVORTEX = "ExitVortex", t.TURN = "Turn", t.ARRIVAL = "Arrival";
}(Ai || (Ai = {})), function (t) {
  t.STRAIGHT = "Straight", t.RIGHT = "Right", t.SLIGHTRIGHT = "SlightRight", t.LEFT = "Left", t.SLIGHTLEFT = "SlightLeft";
}(us || (us = {})), function (t) {
  t.UP = "up", t.DOWN = "down", t.NONE = "none";
}(oh || (oh = {})), u(WK, "vortexDirectionTest");
var OT = class {
  constructor({
    origin: t,
    action: e,
    distance: n,
    atLocation: i,
    instruction: r
  }) {
    A(this, "node"), A(this, "instruction"), A(this, "action"), A(this, "atLocation"), A(this, "type"), A(this, "distance", 0), this.node = t, this.action = e, this.distance = n || 0, this.atLocation = i, this.instruction = "", r ? this.instruction = r : (null != e && e.type === Ai.DEPARTURE ? this.instruction = null != i ? `Depart from ${i.name}` : "Depart from current location" : null != e && e.type === Ai.ARRIVAL ? this.instruction = null != i ? `Arrive at ${i.name}` : "Arrive at destination" : null != e && e.type === Ai.TAKEVORTEX ? this.instruction = `Take ${i && i.name} ${WK(e.direction)}to ${e.toMap.name}` : null != e && e.type === Ai.EXITVORTEX ? this.instruction = `Exit ${i && i.name} at ${e.toMap.name}` : null != e && e.bearing === us.RIGHT ? this.instruction = "Turn right" : null != e && e.bearing === us.SLIGHTRIGHT ? this.instruction = "Turn slightly right" : null != e && e.bearing === us.STRAIGHT ? this.instruction = "Head straight" : null != e && e.bearing === us.SLIGHTLEFT ? this.instruction = "Turn slightly left" : null != e && e.bearing === us.LEFT && (this.instruction = "Turn left"), null != e && e.type === Ai.TURN && i && (this.instruction += ` at ${i.name}`));
  }
};
u(OT, "Directive");
var ib,
  sh = OT;
(ib || (ib = {})).NO_VALID_PATH = "No Valid Path Available";
var rb = .1 * Math.PI;
function ob(t, e) {
  return ((e - t + Math.PI) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI) - Math.PI;
}
u(ob, "differenceBetweenAngles");
var RT = class {
  constructor({
    locations: t,
    nodes: e,
    vortexes: n,
    maps: i,
    showVortexNames: r
  }) {
    A(this, "graph"), A(this, "locationsByNodeId"), this.graph = new LT({
      maps: i,
      nodes: e,
      showVortexNames: r,
      vortexes: n
    }), this.locationsByNodeId = t.reduce((t, e) => (e.nodes && e.nodes.forEach(n => {
      t[n.node] = e;
    }), e.polygons && e.polygons.forEach(n => {
      n.entrances && n.entrances.forEach(n => {
        t[n] = e;
      });
    }), t), {});
  }
  getClosestLocationInRay(t, e = .5 * Math.PI, n = 10) {
    let i = 0,
      r = 0,
      o = t;
    for (; Math.abs(i) < e && r < n;) {
      let t = this.graph.edges[o.destination.id],
        s = null,
        a = 0;
      for (let e of t) if (e.distance > 0) if (null != s) {
        let t = -ob(o.angle, e.angle);
        Math.abs(t) < Math.abs(a) && (s = e, a = t);
      } else s = e, a = -ob(o.angle, e.angle);
      if (null == s) return null;
      {
        if (Math.abs(a) >= e || (i += a, r += s.distance, Math.abs(i) >= e || r > n)) return null;
        let t = this.locationsByNodeId[s.destination.id];
        if (null != t) return t;
        o = s;
      }
    }
    return null;
  }
  getDirections({
    originIds: t,
    destinationNodeIds: e,
    accessible: n,
    departFrom: i,
    arriveAt: r
  }) {
    let o = this.graph.aStar(t, e, n);
    if (0 === o.length) return {
      distance: 0,
      instructions: [new sh({
        distance: 0,
        instruction: ib.NO_VALID_PATH
      })],
      path: []
    };
    let s = 0,
      a = new Array(o.length + 1);
    for (let t = 0; t < o.length; t++) a[t] = o[t].origin;
    a[o.length] = o[o.length - 1].destination;
    let l = [],
      u = null,
      h = null,
      c = 0,
      p = 0;
    for (let t = 0; t < o.length; t++) {
      let e = o[t],
        n = e.origin,
        a = e.destination;
      if (s += e.distance, c += (null == h ? void 0 : h.distance) || 0, 0 === t && l.push(new sh({
        action: {
          type: Ai.DEPARTURE
        },
        atLocation: i,
        distance: 0,
        origin: n
      })), null != e.vortex) {
        let t = this.graph.mapsById[n.map],
          i = this.graph.mapsById[a.map],
          r = oh.NONE;
        if (null != t.elevation && null != i.elevation) {
          let e = t.elevation - i.elevation;
          e > 0 ? r = oh.DOWN : e < 0 && (r = oh.UP);
        }
        l.push(new sh({
          action: {
            direction: r,
            fromMap: t,
            toMap: i,
            type: Ai.TAKEVORTEX
          },
          atLocation: e.vortex,
          distance: c,
          origin: n
        })), p += c, c = 0;
      } else if (null != u && null != h) if (null != h.vortex) {
        let t = this.graph.mapsById[u.map],
          e = this.graph.mapsById[h.destination.map];
        l.push(new sh({
          action: {
            fromMap: t,
            toMap: e,
            type: Ai.EXITVORTEX
          },
          atLocation: h.vortex,
          distance: c,
          origin: n
        })), p += c, c = 0;
      } else {
        let t = this.graph.edges[n.id].filter(t => t.destination !== u && t.destination !== e.destination);
        if (t.length > 0) {
          let i = -ob(h.angle, e.angle),
            r = t.reduce((t, n) => {
              let i = -ob(e.angle, n.angle);
              return Math.min(t, Math.abs(i));
            }, Math.PI);
          if (Math.abs(i) >= rb || Math.abs(r) <= rb) {
            let t;
            t = i <= -Math.PI / 4 ? us.RIGHT : i <= -rb ? us.SLIGHTRIGHT : i <= rb ? us.STRAIGHT : i <= Math.PI / 4 ? us.SLIGHTLEFT : us.LEFT;
            let e = this.locationsByNodeId[n.id];
            if (e || (e = this.getClosestLocationInRay(h, .5 * Math.PI, 10)), null != e) {
              let i = new sh({
                action: {
                  bearing: t,
                  referencePosition: "At",
                  type: Ai.TURN
                },
                atLocation: e,
                distance: c,
                origin: n
              });
              i.type = t, l.push(i);
            } else l.push(new sh({
              action: {
                bearing: t,
                referencePosition: "At",
                type: Ai.TURN
              },
              distance: c,
              origin: n
            }));
            p += c, c = 0;
          }
        }
      }
      t === o.length - 1 && (l.push(new sh({
        action: {
          type: Ai.ARRIVAL
        },
        atLocation: r,
        distance: s - p < 0 ? 0 : s - p,
        origin: e.destination
      })), p += c, c = 0), u = n, h = e;
    }
    let d = [],
      f = null;
    for (let t = l.length - 1; t >= 0; t--) {
      let e = l[t],
        {
          action: n
        } = e;
      n && n.type === Ai.TAKEVORTEX ? (f = e.node, d.unshift(e)) : n && n.type === Ai.TURN && null != f ? this.graph.getDistance(e.node, f) > 5 && d.unshift(e) : d.unshift(e);
    }
    return {
      distance: s,
      instructions: d,
      path: a
    };
  }
};
u(RT, "Navigator");
var NT = RT;
function DT(t) {
  let e = +this._x.call(null, t),
    n = +this._y.call(null, t);
  return kL(this.cover(e, n), e, n, t);
}
function kL(t, e, n, i) {
  if (isNaN(e) || isNaN(n)) return t;
  var r,
    o,
    s,
    a,
    l,
    u,
    h,
    c,
    p,
    d = t._root,
    f = {
      data: i
    },
    m = t._x0,
    g = t._y0,
    v = t._x1,
    y = t._y1;
  if (!d) return t._root = f, t;
  for (; d.length;) if ((u = e >= (o = (m + v) / 2)) ? m = o : v = o, (h = n >= (s = (g + y) / 2)) ? g = s : y = s, r = d, !(d = d[c = h << 1 | u])) return r[c] = f, t;
  if (a = +t._x.call(null, d.data), l = +t._y.call(null, d.data), e === a && n === l) return f.next = d, r ? r[c] = f : t._root = f, t;
  do {
    r = r ? r[c] = new Array(4) : t._root = new Array(4), (u = e >= (o = (m + v) / 2)) ? m = o : v = o, (h = n >= (s = (g + y) / 2)) ? g = s : y = s;
  } while ((c = h << 1 | u) == (p = (l >= s) << 1 | a >= o));
  return r[p] = d, r[c] = f, t;
}
function FL(t) {
  var e,
    n,
    i,
    r,
    o = t.length,
    s = new Array(o),
    a = new Array(o),
    l = 1 / 0,
    u = 1 / 0,
    h = -1 / 0,
    c = -1 / 0;
  for (n = 0; n < o; ++n) isNaN(i = +this._x.call(null, e = t[n])) || isNaN(r = +this._y.call(null, e)) || (s[n] = i, a[n] = r, i < l && (l = i), i > h && (h = i), r < u && (u = r), r > c && (c = r));
  if (l > h || u > c) return this;
  for (this.cover(l, u).cover(h, c), n = 0; n < o; ++n) kL(this, s[n], a[n], t[n]);
  return this;
}
function qT(t, e) {
  if (isNaN(t = +t) || isNaN(e = +e)) return this;
  var n = this._x0,
    i = this._y0,
    r = this._x1,
    o = this._y1;
  if (isNaN(n)) r = (n = Math.floor(t)) + 1, o = (i = Math.floor(e)) + 1;else {
    for (var s, a, l = r - n || 1, u = this._root; n > t || t >= r || i > e || e >= o;) switch (a = (e < i) << 1 | t < n, s = new Array(4), s[a] = u, u = s, l *= 2, a) {
      case 0:
        r = n + l, o = i + l;
        break;
      case 1:
        n = r - l, o = i + l;
        break;
      case 2:
        r = n + l, i = o - l;
        break;
      case 3:
        n = r - l, i = o - l;
    }
    this._root && this._root.length && (this._root = u);
  }
  return this._x0 = n, this._y0 = i, this._x1 = r, this._y1 = o, this;
}
function kT() {
  var t = [];
  return this.visit(function (e) {
    if (!e.length) do {
      t.push(e.data);
    } while (e = e.next);
  }), t;
}
function FT(t) {
  return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Gr(t, e, n, i, r) {
  this.node = t, this.x0 = e, this.y0 = n, this.x1 = i, this.y1 = r;
}
function BT(t, e, n) {
  var i,
    r,
    o,
    s,
    a,
    l,
    u,
    h = this._x0,
    c = this._y0,
    p = this._x1,
    d = this._y1,
    f = [],
    m = this._root;
  for (m && f.push(new Gr(m, h, c, p, d)), null == n ? n = 1 / 0 : (h = t - n, c = e - n, p = t + n, d = e + n, n *= n); l = f.pop();) if (!(!(m = l.node) || (r = l.x0) > p || (o = l.y0) > d || (s = l.x1) < h || (a = l.y1) < c)) if (m.length) {
    var g = (r + s) / 2,
      v = (o + a) / 2;
    f.push(new Gr(m[3], g, v, s, a), new Gr(m[2], r, v, g, a), new Gr(m[1], g, o, s, v), new Gr(m[0], r, o, g, v)), (u = (e >= v) << 1 | t >= g) && (l = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - u], f[f.length - 1 - u] = l);
  } else {
    var y = t - +this._x.call(null, m.data),
      _ = e - +this._y.call(null, m.data),
      x = y * y + _ * _;
    if (x < n) {
      var E = Math.sqrt(n = x);
      h = t - E, c = e - E, p = t + E, d = e + E, i = m.data;
    }
  }
  return i;
}
function UT(t) {
  if (isNaN(o = +this._x.call(null, t)) || isNaN(s = +this._y.call(null, t))) return this;
  var e,
    n,
    i,
    r,
    o,
    s,
    a,
    l,
    u,
    h,
    c,
    p,
    d = this._root,
    f = this._x0,
    m = this._y0,
    g = this._x1,
    v = this._y1;
  if (!d) return this;
  if (d.length) for (;;) {
    if ((u = o >= (a = (f + g) / 2)) ? f = a : g = a, (h = s >= (l = (m + v) / 2)) ? m = l : v = l, e = d, !(d = d[c = h << 1 | u])) return this;
    if (!d.length) break;
    (e[c + 1 & 3] || e[c + 2 & 3] || e[c + 3 & 3]) && (n = e, p = c);
  }
  for (; d.data !== t;) if (i = d, !(d = d.next)) return this;
  return (r = d.next) && delete d.next, i ? (r ? i.next = r : delete i.next, this) : e ? (r ? e[c] = r : delete e[c], (d = e[0] || e[1] || e[2] || e[3]) && d === (e[3] || e[2] || e[1] || e[0]) && !d.length && (n ? n[p] = d : this._root = d), this) : (this._root = r, this);
}
function BL(t) {
  for (var e = 0, n = t.length; e < n; ++e) this.remove(t[e]);
  return this;
}
function zT() {
  return this._root;
}
function VT() {
  var t = 0;
  return this.visit(function (e) {
    if (!e.length) do {
      ++t;
    } while (e = e.next);
  }), t;
}
function GT(t) {
  var e,
    n,
    i,
    r,
    o,
    s,
    a = [],
    l = this._root;
  for (l && a.push(new Gr(l, this._x0, this._y0, this._x1, this._y1)); e = a.pop();) if (!t(l = e.node, i = e.x0, r = e.y0, o = e.x1, s = e.y1) && l.length) {
    var u = (i + o) / 2,
      h = (r + s) / 2;
    (n = l[3]) && a.push(new Gr(n, u, h, o, s)), (n = l[2]) && a.push(new Gr(n, i, h, u, s)), (n = l[1]) && a.push(new Gr(n, u, r, o, h)), (n = l[0]) && a.push(new Gr(n, i, r, u, h));
  }
  return this;
}
function HT(t) {
  var e,
    n = [],
    i = [];
  for (this._root && n.push(new Gr(this._root, this._x0, this._y0, this._x1, this._y1)); e = n.pop();) {
    var r = e.node;
    if (r.length) {
      var o,
        s = e.x0,
        a = e.y0,
        l = e.x1,
        u = e.y1,
        h = (s + l) / 2,
        c = (a + u) / 2;
      (o = r[0]) && n.push(new Gr(o, s, a, h, c)), (o = r[1]) && n.push(new Gr(o, h, a, l, c)), (o = r[2]) && n.push(new Gr(o, s, c, h, u)), (o = r[3]) && n.push(new Gr(o, h, c, l, u));
    }
    i.push(e);
  }
  for (; e = i.pop();) t(e.node, e.x0, e.y0, e.x1, e.y1);
  return this;
}
function UL(t) {
  return t[0];
}
function jT(t) {
  return arguments.length ? (this._x = t, this) : this._x;
}
function zL(t) {
  return t[1];
}
function WT(t) {
  return arguments.length ? (this._y = t, this) : this._y;
}
function u0(t, e, n) {
  var i = new XT(null == e ? UL : e, null == n ? zL : n, NaN, NaN, NaN, NaN);
  return null == t ? i : i.addAll(t);
}
function XT(t, e, n, i, r, o) {
  this._x = t, this._y = e, this._x0 = n, this._y0 = i, this._x1 = r, this._y1 = o, this._root = void 0;
}
function VL(t) {
  for (var e = {
      data: t.data
    }, n = e; t = t.next;) n = n.next = {
    data: t.data
  };
  return e;
}
E(), E(), E(), E(), u(DT, "default"), u(kL, "add"), u(FL, "addAll"), E(), u(qT, "default"), E(), u(kT, "default"), E(), u(FT, "default"), E(), E(), u(Gr, "default"), u(BT, "default"), E(), u(UT, "default"), u(BL, "removeAll"), E(), u(zT, "default"), E(), u(VT, "default"), E(), u(GT, "default"), E(), u(HT, "default"), E(), u(UL, "defaultX"), u(jT, "default"), E(), u(zL, "defaultY"), u(WT, "default"), u(u0, "quadtree"), u(XT, "Quadtree"), u(VL, "leaf_copy");
var cs = u0.prototype = XT.prototype;
cs.copy = function () {
  var t,
    e,
    n = new XT(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
    i = this._root;
  if (!i) return n;
  if (!i.length) return n._root = VL(i), n;
  for (t = [{
    source: i,
    target: n._root = new Array(4)
  }]; i = t.pop();) for (var r = 0; r < 4; ++r) (e = i.source[r]) && (e.length ? t.push({
    source: e,
    target: i.target[r] = new Array(4)
  }) : i.target[r] = VL(e));
  return n;
}, cs.add = DT, cs.addAll = FL, cs.cover = qT, cs.data = kT, cs.extent = FT, cs.find = BT, cs.remove = UT, cs.removeAll = BL, cs.root = zT, cs.size = VT, cs.visit = GT, cs.visitAfter = HT, cs.x = jT, cs.y = WT;
var ql,
  Pr,
  bf = class {
    constructor(t) {
      re(this, ql, void 0), A(this, "categories"), A(this, "locations"), A(this, "vortexes"), A(this, "maps"), A(this, "nodes"), A(this, "polygons"), A(this, "events"), A(this, "mapGroups"), A(this, "locationStates"), A(this, "rankings"), re(this, Pr, {}), he(this, ql, t);
    }
    get polygonsByMapId() {
      if (w(this, Pr).polygonsByMapId) return w(this, Pr).polygonsByMapId;
      let t,
        e = {};
      for (let n = 0, i = w(this, ql).polygons.length; n < i; ++n) t = w(this, ql).polygons[n], e[t.map.id] || (e[t.map.id] = []), e[t.map.id].push(t);
      let n = Object.entries(e).reduce((t, [e, n]) => (t.set(e, n), t), new Map());
      return w(this, Pr).polygonsByMapId = n, w(this, Pr).polygonsByMapId;
    }
    get nodesByMapId() {
      if (w(this, Pr).nodesByMapId) return w(this, Pr).nodesByMapId;
      let t,
        e = {};
      for (let n = 0, i = w(this, ql).nodes.length; n < i; ++n) t = w(this, ql).nodes[n], e[t.map.id] || (e[t.map.id] = []), e[t.map.id].push(t);
      let n = Object.entries(e).reduce((t, [e, n]) => (t.set(e, n), t), new Map());
      return w(this, Pr).nodesByMapId = n, w(this, Pr).nodesByMapId;
    }
    findNearestNodeOnMap(t, e) {
      var n;
      if (w(this, Pr).nodeTreesByMap || (w(this, Pr).nodeTreesByMap = new Map()), !w(this, Pr).nodeTreesByMap.has(t)) {
        let e = null != (n = this.nodesByMapId.get(t)) ? n : [],
          i = u0();
        i.x(t => t.x), i.y(t => t.y), i.addAll(e), w(this, Pr).nodeTreesByMap.set(t, i);
      }
      return w(this, Pr).nodeTreesByMap.get(t).find(e.x, e.y);
    }
    get locationsByMapId() {
      if (w(this, Pr).locationsByMapId) return w(this, Pr).locationsByMapId;
      let t,
        e = {};
      for (let n = 0, i = w(this, ql).locations.length; n < i; ++n) {
        t = w(this, ql).locations[n];
        for (let n = 0, i = t.polygons.length; n < i; ++n) e[t.polygons[n].map.id] || (e[t.polygons[n].map.id] = []), e[t.polygons[n].map.id].push(t);
      }
      let n = Object.entries(e).reduce((t, [e, n]) => (t.set(e, n), t), new Map());
      return w(this, Pr).locationsByMapId = n, w(this, Pr).locationsByMapId;
    }
    static create(t) {
      return bf.instances.has(t) || bf.instances.set(t, new bf(t)), bf.instances.get(t);
    }
    static clear() {
      bf.instances.clear();
    }
  },
  sb = bf;
u(sb, "MappedinCache"), ql = new WeakMap(), Pr = new WeakMap(), A(sb, "instances", new Map());
var Ws = sb;
E(), E(), E(), E(), E();
var va = class {
  constructor(t) {
    A(this, "destinations", []), this.destinations = t;
  }
};
u(va, "MappedinDestinationSet"), E();
var c0,
  Wu,
  Mf = class {
    constructor(t, e) {
      re(this, c0, void 0), re(this, Wu, void 0), A(this, "distance", 0), A(this, "path", []), A(this, "instructions", []), he(this, Wu, t), he(this, c0, e), this.distance = e.distance, this.instructions = e.instructions.map(t => {
        var e, n, i, r, o, s, a, l, u, h, c, p;
        let d = {
          ...t,
          action: {
            ...t.action
          },
          atLocation: (null == (e = t.atLocation) ? void 0 : e.id) ? null == (i = null == (n = w(this, Wu)) ? void 0 : n._vortexesById) ? void 0 : i[t.atLocation.id] : void 0,
          node: (null == (r = t.node) ? void 0 : r.id) ? null == (s = null == (o = w(this, Wu)) ? void 0 : o._nodesById) ? void 0 : s[t.node.id] : void 0
        };
        if ((null == (a = d.action) ? void 0 : a.type) === Ai.TAKEVORTEX || (null == (l = d.action) ? void 0 : l.type) === Ai.EXITVORTEX) {
          let t = null == (h = w(this, Wu)._mapsById) ? void 0 : h[null == (u = d.action) ? void 0 : u.fromMap.id],
            e = null == (p = w(this, Wu)._mapsById) ? void 0 : p[null == (c = d.action) ? void 0 : c.toMap.id];
          t && e && (d.action.fromMap = t, d.action.toMap = e);
        }
        return d;
      }), this.path = e.path.reduce((t, {
        id: e
      }) => {
        var n, i;
        let r = null == (i = null == (n = w(this, Wu)) ? void 0 : n._nodesById) ? void 0 : i[e];
        return r && t.push(r), t;
      }, []);
    }
    toJSON() {
      return w(this, c0);
    }
  };
u(Mf, "MappedinDirections"), c0 = new WeakMap(), Wu = new WeakMap();
var Xu,
  kl = class {
    constructor(t) {
      re(this, Xu, void 0), he(this, Xu, t);
    }
    directionsTo(t, e) {
      let n = w(this, Xu).analytics;
      if (t instanceof va) {
        if (0 === t.destinations.length) return [];
        n.getDirections(this, t.destinations[t.destinations.length - 1]);
        let i,
          r = [],
          o = h0(this);
        for (let n = 0; n < t.destinations.length; n++) {
          i = h0(t.destinations[n]);
          let s = w(this, Xu).navigator.getDirections({
              originIds: o,
              destinationNodeIds: i,
              accessible: (null == e ? void 0 : e.accessible) || !1
            }),
            a = new Mf(w(this, Xu), s);
          r.push(a), o = 0 === a.path.length ? i : [a.path[a.path.length - 1].id];
        }
        return r;
      }
      {
        n.getDirections(this, t);
        let i = h0(this),
          r = h0(t),
          o = w(this, Xu).navigator.getDirections({
            originIds: i,
            destinationNodeIds: r,
            accessible: (null == e ? void 0 : e.accessible) || !1
          });
        return new Mf(w(this, Xu), o);
      }
    }
    distanceTo(t, e) {
      let n = this.directionsTo(t, e);
      return (null == n ? void 0 : n.distance) || 0;
    }
  };
u(kl, "MappedinNavigatable"), Xu = new WeakMap(), E(), E(), E(), E();
var ah,
  fo,
  Yu,
  lh,
  hs,
  As,
  Ki,
  Id,
  h9 = Rt(c9()),
  {
    __extends: Fl,
    __assign: bt,
    __rest: f0,
    __decorate: W0e,
    __param: X0e,
    __metadata: Y0e,
    __awaiter: Et,
    __generator: wt,
    __exportStar: Z0e,
    __createBinding: J0e,
    __values: ya,
    __read: Hr,
    __spread: K0e,
    __spreadArrays: Q0e,
    __spreadArray: al,
    __await: $0e,
    __asyncGenerator: e1e,
    __asyncDelegator: t1e,
    __asyncValues: n1e,
    __makeTemplateObject: i1e,
    __importStar: r1e,
    __importDefault: o1e,
    __classPrivateFieldGet: s1e,
    __classPrivateFieldSet: a1e,
    __classPrivateFieldIn: l1e
  } = h9.default;
E(), E(), E(), E(), E(), function (t) {
  t.US = "US", t.EU = "EU";
}(ah || (ah = {})), E(), function (t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.ADD = "$add", t.APPEND = "$append", t.PREPEND = "$prepend", t.REMOVE = "$remove", t.PREINSERT = "$preInsert", t.POSTINSERT = "$postInsert", t.UNSET = "$unset", t.CLEAR_ALL = "$clearAll";
}(fo || (fo = {})), function (t) {
  t.REVENUE_PRODUCT_ID = "$productId", t.REVENUE_QUANTITY = "$quantity", t.REVENUE_PRICE = "$price", t.REVENUE_TYPE = "$revenueType", t.REVENUE = "$revenue";
}(Yu || (Yu = {})), function (t) {
  t.IDENTIFY = "$identify", t.GROUP_IDENTIFY = "$groupidentify", t.REVENUE = "revenue_amount";
}(lh || (lh = {})), E(), function (t) {
  t[t.None = 0] = "None", t[t.Error = 1] = "Error", t[t.Warn = 2] = "Warn", t[t.Verbose = 3] = "Verbose", t[t.Debug = 4] = "Debug";
}(hs || (hs = {})), E(), function (t) {
  t.BEFORE = "before", t.ENRICHMENT = "enrichment", t.DESTINATION = "destination";
}(As || (As = {})), E(), function (t) {
  t.Unknown = "unknown", t.Skipped = "skipped", t.Success = "success", t.RateLimit = "rate_limit", t.PayloadTooLarge = "payload_too_large", t.Invalid = "invalid", t.Failed = "failed", t.Timeout = "Timeout", t.SystemError = "SystemError";
}(Ki || (Ki = {})), E(), function (t) {
  t.XHR = "xhr", t.SendBeacon = "beacon", t.Fetch = "fetch";
}(Id || (Id = {})), E(), E();
var ZT = "-",
  p0 = "AMP",
  f9 = "".concat(p0, "_unsent"),
  JT = "https://api2.amplitude.com/2/httpapi",
  p9 = "https://api.eu.amplitude.com/2/httpapi",
  d9 = "https://api2.amplitude.com/batch",
  m9 = "https://api.eu.amplitude.com/batch";
E();
var XK = 1e3,
  cb = u(function (t) {
    if (Object.keys(t).length > XK) return !1;
    for (var e in t) {
      var n = t[e];
      if (!KT(e, n)) return !1;
    }
    return !0;
  }, "isValidObject"),
  KT = u(function (t, e) {
    var n, i;
    if ("string" != typeof t) return !1;
    if (Array.isArray(e)) {
      var r = !0;
      try {
        for (var o = ya(e), s = o.next(); !s.done; s = o.next()) {
          var a = s.value;
          if (Array.isArray(a)) return !1;
          if ("object" == typeof a) r = r && cb(a);else if (!["number", "string"].includes(typeof a)) return !1;
          if (!r) return !1;
        }
      } catch (t) {
        n = {
          error: t
        };
      } finally {
        try {
          s && !s.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    } else {
      if (null == e) return !1;
      if ("object" == typeof e) return cb(e);
      if (!["number", "string", "boolean"].includes(typeof e)) return !1;
    }
    return !0;
  }, "isValidProperties"),
  ll = function () {
    function t() {
      this._propertySet = new Set(), this._properties = {};
    }
    return u(t, "Identify"), t.prototype.getUserProperties = function () {
      return bt({}, this._properties);
    }, t.prototype.set = function (t, e) {
      return this._safeSet(fo.SET, t, e), this;
    }, t.prototype.setOnce = function (t, e) {
      return this._safeSet(fo.SET_ONCE, t, e), this;
    }, t.prototype.append = function (t, e) {
      return this._safeSet(fo.APPEND, t, e), this;
    }, t.prototype.prepend = function (t, e) {
      return this._safeSet(fo.PREPEND, t, e), this;
    }, t.prototype.postInsert = function (t, e) {
      return this._safeSet(fo.POSTINSERT, t, e), this;
    }, t.prototype.preInsert = function (t, e) {
      return this._safeSet(fo.PREINSERT, t, e), this;
    }, t.prototype.remove = function (t, e) {
      return this._safeSet(fo.REMOVE, t, e), this;
    }, t.prototype.add = function (t, e) {
      return this._safeSet(fo.ADD, t, e), this;
    }, t.prototype.unset = function (t) {
      return this._safeSet(fo.UNSET, t, ZT), this;
    }, t.prototype.clearAll = function () {
      return this._properties = {}, this._properties[fo.CLEAR_ALL] = ZT, this;
    }, t.prototype._safeSet = function (t, e, n) {
      if (this._validate(t, e, n)) {
        var i = this._properties[t];
        return void 0 === i && (i = {}, this._properties[t] = i), i[e] = n, this._propertySet.add(e), !0;
      }
      return !1;
    }, t.prototype._validate = function (t, e, n) {
      return void 0 === this._properties[fo.CLEAR_ALL] && !this._propertySet.has(e) && (t === fo.ADD ? "number" == typeof n : t === fo.UNSET || t === fo.REMOVE || KT(e, n));
    }, t;
  }(),
  g9 = u(function (t, e, n) {
    return bt(bt(bt({}, "string" == typeof t ? {
      event_type: t
    } : t), n), e && {
      event_properties: e
    });
  }, "createTrackEvent"),
  d0 = u(function (t, e) {
    return bt(bt({}, e), {
      event_type: lh.IDENTIFY,
      user_properties: t.getUserProperties()
    });
  }, "createIdentifyEvent"),
  v9 = u(function (t, e, n, i) {
    var r;
    return bt(bt({}, i), {
      event_type: lh.GROUP_IDENTIFY,
      group_properties: n.getUserProperties(),
      groups: (r = {}, r[t] = e, r)
    });
  }, "createGroupIdentifyEvent"),
  y9 = u(function (t, e, n) {
    var i,
      r = new ll();
    return r.set(t, e), bt(bt({}, n), {
      event_type: lh.IDENTIFY,
      user_properties: r.getUserProperties(),
      groups: (i = {}, i[t] = e, i)
    });
  }, "createGroupEvent"),
  _9 = u(function (t, e) {
    return bt(bt({}, e), {
      event_type: lh.REVENUE,
      event_properties: t.getEventProperties()
    });
  }, "createRevenueEvent");
E(), E();
var uh = u(function (t, e, n) {
    return void 0 === e && (e = 0), void 0 === n && (n = Ki.Unknown), {
      event: t,
      code: e,
      message: n
    };
  }, "buildResult"),
  x9 = function () {
    function t() {
      this.queue = [], this.applying = !1, this.plugins = [];
    }
    return u(t, "Timeline"), t.prototype.register = function (t, e) {
      return Et(this, void 0, void 0, function () {
        return wt(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, t.setup(e)];
            case 1:
              return n.sent(), this.plugins.push(t), [2];
          }
        });
      });
    }, t.prototype.deregister = function (t) {
      return this.plugins.splice(this.plugins.findIndex(function (e) {
        return e.name === t;
      }), 1), Promise.resolve();
    }, t.prototype.reset = function () {
      this.applying = !1, this.plugins = [];
    }, t.prototype.push = function (t) {
      var e = this;
      return new Promise(function (n) {
        e.queue.push([t, n]), e.scheduleApply(0);
      });
    }, t.prototype.scheduleApply = function (t) {
      var e = this;
      this.applying || (this.applying = !0, setTimeout(function () {
        e.apply(e.queue.shift()).then(function () {
          e.applying = !1, e.queue.length > 0 && e.scheduleApply(0);
        });
      }, t));
    }, t.prototype.apply = function (t) {
      return Et(this, void 0, void 0, function () {
        var e, n, i, r, o, s, a, l, u, h, c, p, d, f, m, g, v, y;
        return wt(this, function (_) {
          switch (_.label) {
            case 0:
              if (!t) return [2];
              e = Hr(t, 1), n = e[0], i = Hr(t, 2), r = i[1], o = this.plugins.filter(function (t) {
                return t.type === As.BEFORE;
              }), _.label = 1;
            case 1:
              _.trys.push([1, 6, 7, 8]), s = ya(o), a = s.next(), _.label = 2;
            case 2:
              return a.done ? [3, 5] : [4, a.value.execute(bt({}, n))];
            case 3:
              n = _.sent(), _.label = 4;
            case 4:
              return a = s.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return l = _.sent(), m = {
                error: l
              }, [3, 8];
            case 7:
              try {
                a && !a.done && (g = s.return) && g.call(s);
              } finally {
                if (m) throw m.error;
              }
              return [7];
            case 8:
              u = this.plugins.filter(function (t) {
                return t.type === As.ENRICHMENT;
              }), _.label = 9;
            case 9:
              _.trys.push([9, 14, 15, 16]), h = ya(u), c = h.next(), _.label = 10;
            case 10:
              return c.done ? [3, 13] : [4, c.value.execute(bt({}, n))];
            case 11:
              n = _.sent(), _.label = 12;
            case 12:
              return c = h.next(), [3, 10];
            case 13:
              return [3, 16];
            case 14:
              return p = _.sent(), v = {
                error: p
              }, [3, 16];
            case 15:
              try {
                c && !c.done && (y = h.return) && y.call(h);
              } finally {
                if (v) throw v.error;
              }
              return [7];
            case 16:
              return d = this.plugins.filter(function (t) {
                return t.type === As.DESTINATION;
              }), f = d.map(function (t) {
                var e = bt({}, n);
                return t.execute(e).catch(function (t) {
                  return uh(e, 0, String(t));
                });
              }), Promise.all(f).then(function (t) {
                var e = Hr(t, 1)[0];
                r(e);
              }), [2];
          }
        });
      });
    }, t.prototype.flush = function () {
      return Et(this, void 0, void 0, function () {
        var t,
          e,
          n,
          i = this;
        return wt(this, function (r) {
          switch (r.label) {
            case 0:
              return t = this.queue, this.queue = [], [4, Promise.all(t.map(function (t) {
                return i.apply(t);
              }))];
            case 1:
              return r.sent(), e = this.plugins.filter(function (t) {
                return t.type === As.DESTINATION;
              }), n = e.map(function (t) {
                return t.flush && t.flush();
              }), [4, Promise.all(n)];
            case 2:
              return r.sent(), [2];
          }
        });
      });
    }, t;
  }();
E();
var b9 = "Event tracked successfully",
  M9 = "Unexpected error occurred",
  E9 = "Event rejected due to exceeded retry count",
  w9 = "Event skipped due to optOut config",
  S9 = "Event rejected due to missing API key",
  T9 = "Invalid API key",
  P9 = "Client not initialized",
  QT = function () {
    function t(t) {
      void 0 === t && (t = "$default"), this.initializing = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new x9(), this.name = t;
    }
    return u(t, "AmplitudeCore"), t.prototype._init = function (t) {
      return Et(this, void 0, void 0, function () {
        return wt(this, function (e) {
          switch (e.label) {
            case 0:
              return this.config = t, this.timeline.reset(), [4, this.runQueuedFunctions("q")];
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, t.prototype.runQueuedFunctions = function (t) {
      return Et(this, void 0, void 0, function () {
        var e, n, i, r, o, s;
        return wt(this, function (a) {
          switch (a.label) {
            case 0:
              e = this[t], this[t] = [], a.label = 1;
            case 1:
              a.trys.push([1, 6, 7, 8]), n = ya(e), i = n.next(), a.label = 2;
            case 2:
              return i.done ? [3, 5] : [4, (0, i.value)()];
            case 3:
              a.sent(), a.label = 4;
            case 4:
              return i = n.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return r = a.sent(), o = {
                error: r
              }, [3, 8];
            case 7:
              try {
                i && !i.done && (s = n.return) && s.call(n);
              } finally {
                if (o) throw o.error;
              }
              return [7];
            case 8:
              return [2];
          }
        });
      });
    }, t.prototype.track = function (t, e, n) {
      var i = g9(t, e, n);
      return this.dispatch(i);
    }, t.prototype.identify = function (t, e) {
      var n = d0(t, e);
      return this.dispatch(n);
    }, t.prototype.groupIdentify = function (t, e, n, i) {
      var r = v9(t, e, n, i);
      return this.dispatch(r);
    }, t.prototype.setGroup = function (t, e, n) {
      var i = y9(t, e, n);
      return this.dispatch(i);
    }, t.prototype.revenue = function (t, e) {
      var n = _9(t, e);
      return this.dispatch(n);
    }, t.prototype.add = function (t) {
      return Et(this, void 0, void 0, function () {
        return wt(this, function (e) {
          return this.config ? [2, this.timeline.register(t, this.config)] : (this.q.push(this.add.bind(this, t)), [2]);
        });
      });
    }, t.prototype.remove = function (t) {
      return Et(this, void 0, void 0, function () {
        return wt(this, function (e) {
          return this.config ? [2, this.timeline.deregister(t)] : (this.q.push(this.remove.bind(this, t)), [2]);
        });
      });
    }, t.prototype.dispatchWithCallback = function (t, e) {
      if (!this.config) return e(uh(t, 0, P9));
      this.process(t).then(e);
    }, t.prototype.dispatch = function (t) {
      return Et(this, void 0, void 0, function () {
        var e = this;
        return wt(this, function (n) {
          return this.config ? [2, this.process(t)] : [2, new Promise(function (n) {
            e.dispatchQ.push(e.dispatchWithCallback.bind(e, t, n));
          })];
        });
      });
    }, t.prototype.process = function (t) {
      return Et(this, void 0, void 0, function () {
        var e, n, i;
        return wt(this, function (r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2,, 3]), this.config.optOut ? [2, uh(t, 0, w9)] : [4, this.timeline.push(t)];
            case 1:
              return 200 === (i = r.sent()).code ? this.config.loggerProvider.log(i.message) : this.config.loggerProvider.error(i.message), [2, i];
            case 2:
              return e = r.sent(), n = String(e), this.config.loggerProvider.error(n), [2, i = uh(t, 0, n)];
            case 3:
              return [2];
          }
        });
      });
    }, t.prototype.setOptOut = function (t) {
      this.config ? this.config.optOut = Boolean(t) : this.q.push(this.setOptOut.bind(this, Boolean(t)));
    }, t.prototype.flush = function () {
      return this.timeline.flush();
    }, t;
  }();
E();
var hb = function () {
  function t() {
    this.productId = "", this.quantity = 1, this.price = 0;
  }
  return u(t, "Revenue"), t.prototype.setProductId = function (t) {
    return this.productId = t, this;
  }, t.prototype.setQuantity = function (t) {
    return t > 0 && (this.quantity = t), this;
  }, t.prototype.setPrice = function (t) {
    return this.price = t, this;
  }, t.prototype.setRevenueType = function (t) {
    return this.revenueType = t, this;
  }, t.prototype.setRevenue = function (t) {
    return this.revenue = t, this;
  }, t.prototype.setEventProperties = function (t) {
    return cb(t) && (this.properties = t), this;
  }, t.prototype.getEventProperties = function () {
    var t = this.properties ? bt({}, this.properties) : {};
    return t[Yu.REVENUE_PRODUCT_ID] = this.productId, t[Yu.REVENUE_QUANTITY] = this.quantity, t[Yu.REVENUE_PRICE] = this.price, t[Yu.REVENUE_TYPE] = this.revenueType, t[Yu.REVENUE] = this.revenue, t;
  }, t;
}();
E(), E();
var C9 = u(function (t, e) {
  var n = Math.max(e, 1);
  return t.reduce(function (t, e, i) {
    var r = Math.floor(i / n);
    return t[r] || (t[r] = []), t[r].push(e), t;
  }, []);
}, "chunk");
E(), E();
var fb = "Amplitude Logger ",
  A9 = function () {
    function t() {
      this.logLevel = hs.None;
    }
    return u(t, "Logger"), t.prototype.disable = function () {
      this.logLevel = hs.None;
    }, t.prototype.enable = function (t) {
      void 0 === t && (t = hs.Warn), this.logLevel = t;
    }, t.prototype.log = function () {
      for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
      this.logLevel < hs.Verbose || console.log("".concat(fb, "[Log]: ").concat(t.join(" ")));
    }, t.prototype.warn = function () {
      for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
      this.logLevel < hs.Warn || console.warn("".concat(fb, "[Warn]: ").concat(t.join(" ")));
    }, t.prototype.error = function () {
      for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
      this.logLevel < hs.Error || console.error("".concat(fb, "[Error]: ").concat(t.join(" ")));
    }, t.prototype.debug = function () {
      for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
      this.logLevel < hs.Debug || console.log("".concat(fb, "[Debug]: ").concat(t.join(" ")));
    }, t;
  }(),
  pb = u(function () {
    return {
      flushMaxRetries: 12,
      flushQueueSize: 200,
      flushIntervalMillis: 1e4,
      logLevel: hs.Warn,
      loggerProvider: new A9(),
      optOut: !1,
      serverUrl: JT,
      serverZone: ah.US,
      useBatch: !1
    };
  }, "getDefaultConfig"),
  $T = function () {
    function t(t) {
      var e, n, i;
      this._optOut = !1;
      var r = pb();
      this.apiKey = t.apiKey, this.flushIntervalMillis = t.flushIntervalMillis || r.flushIntervalMillis, this.flushMaxRetries = t.flushMaxRetries || r.flushMaxRetries, this.flushQueueSize = t.flushQueueSize || r.flushQueueSize, this.loggerProvider = t.loggerProvider || r.loggerProvider, this.logLevel = null !== (e = t.logLevel) && void 0 !== e ? e : r.logLevel, this.minIdLength = t.minIdLength, this.plan = t.plan, this.ingestionMetadata = t.ingestionMetadata, this.optOut = null !== (n = t.optOut) && void 0 !== n ? n : r.optOut, this.serverUrl = t.serverUrl, this.serverZone = t.serverZone || r.serverZone, this.storageProvider = t.storageProvider, this.transportProvider = t.transportProvider, this.useBatch = null !== (i = t.useBatch) && void 0 !== i ? i : r.useBatch, this.loggerProvider.enable(this.logLevel);
      var o = e4(t.serverUrl, t.serverZone, t.useBatch);
      this.serverZone = o.serverZone, this.serverUrl = o.serverUrl;
    }
    return u(t, "Config"), Object.defineProperty(t.prototype, "optOut", {
      get: function () {
        return this._optOut;
      },
      set: function (t) {
        this._optOut = t;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(),
  YK = u(function (t, e) {
    return t === ah.EU ? e ? m9 : p9 : e ? d9 : JT;
  }, "getServerUrl"),
  e4 = u(function (t, e, n) {
    if (void 0 === t && (t = ""), void 0 === e && (e = pb().serverZone), void 0 === n && (n = pb().useBatch), t) return {
      serverUrl: t,
      serverZone: void 0
    };
    var i = [ah.US, ah.EU].includes(e) ? e : pb().serverZone;
    return {
      serverZone: i,
      serverUrl: YK(i, n)
    };
  }, "createServerConfig"),
  t4 = function () {
    function t() {
      this.name = "amplitude", this.type = As.DESTINATION, this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduled = null, this.queue = [];
    }
    return u(t, "Destination"), t.prototype.setup = function (t) {
      var e;
      return Et(this, void 0, void 0, function () {
        var n,
          i = this;
        return wt(this, function (r) {
          switch (r.label) {
            case 0:
              return this.config = t, this.storageKey = "".concat(f9, "_").concat(this.config.apiKey.substring(0, 10)), [4, null === (e = this.config.storageProvider) || void 0 === e ? void 0 : e.get(this.storageKey)];
            case 1:
              return n = r.sent(), this.saveEvents(), n && n.length > 0 && Promise.all(n.map(function (t) {
                return i.execute(t);
              })).catch(), [2, Promise.resolve(void 0)];
          }
        });
      });
    }, t.prototype.execute = function (t) {
      var e = this;
      return new Promise(function (n) {
        var i = {
          event: t,
          attempts: 0,
          callback: function (t) {
            return n(t);
          },
          timeout: 0
        };
        e.addToQueue(i);
      });
    }, t.prototype.addToQueue = function () {
      for (var t = this, e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
      var i = e.filter(function (e) {
        return e.attempts < t.config.flushMaxRetries ? (e.attempts += 1, !0) : (t.fulfillRequest([e], 500, E9), !1);
      });
      i.forEach(function (e) {
        t.queue = t.queue.concat(e), 0 !== e.timeout ? setTimeout(function () {
          e.timeout = 0, t.schedule(0);
        }, e.timeout) : t.schedule(t.config.flushIntervalMillis);
      }), this.saveEvents();
    }, t.prototype.schedule = function (t) {
      var e = this;
      this.scheduled || (this.scheduled = setTimeout(function () {
        e.flush(!0).then(function () {
          e.queue.length > 0 && e.schedule(t);
        });
      }, t));
    }, t.prototype.flush = function (t) {
      return void 0 === t && (t = !1), Et(this, void 0, void 0, function () {
        var e,
          n,
          i,
          r = this;
        return wt(this, function (o) {
          switch (o.label) {
            case 0:
              return e = [], n = [], this.queue.forEach(function (t) {
                return 0 === t.timeout ? e.push(t) : n.push(t);
              }), this.queue = n, this.scheduled && (clearTimeout(this.scheduled), this.scheduled = null), i = C9(e, this.config.flushQueueSize), [4, Promise.all(i.map(function (e) {
                return r.send(e, t);
              }))];
            case 1:
              return o.sent(), [2];
          }
        });
      });
    }, t.prototype.send = function (t, e) {
      return void 0 === e && (e = !0), Et(this, void 0, void 0, function () {
        var n, i, r, o, s;
        return wt(this, function (a) {
          switch (a.label) {
            case 0:
              if (!this.config.apiKey) return [2, this.fulfillRequest(t, 400, S9)];
              n = {
                api_key: this.config.apiKey,
                events: t.map(function (t) {
                  var e = t.event;
                  e.extra;
                  return f0(e, ["extra"]);
                }),
                options: {
                  min_id_length: this.config.minIdLength
                }
              }, a.label = 1;
            case 1:
              return a.trys.push([1, 3,, 4]), i = e4(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(i, n)];
            case 2:
              if (null === (r = a.sent())) return this.fulfillRequest(t, 0, M9), [2];
              if (!e) {
                if ("body" in r) {
                  o = "";
                  try {
                    o = JSON.stringify(r.body, null, 2);
                  } catch (t) {}
                  this.fulfillRequest(t, r.statusCode, "".concat(r.status, ": ").concat(o));
                } else this.fulfillRequest(t, r.statusCode, r.status);
                return [2];
              }
              return this.handleReponse(r, t), [3, 4];
            case 3:
              return s = a.sent(), this.fulfillRequest(t, 0, String(s)), [3, 4];
            case 4:
              return [2];
          }
        });
      });
    }, t.prototype.handleReponse = function (t, e) {
      switch (t.status) {
        case Ki.Success:
          this.handleSuccessResponse(t, e);
          break;
        case Ki.Invalid:
          this.handleInvalidResponse(t, e);
          break;
        case Ki.PayloadTooLarge:
          this.handlePayloadTooLargeResponse(t, e);
          break;
        case Ki.RateLimit:
          this.handleRateLimitResponse(t, e);
          break;
        default:
          this.handleOtherReponse(e);
      }
    }, t.prototype.handleSuccessResponse = function (t, e) {
      this.fulfillRequest(e, t.statusCode, b9);
    }, t.prototype.handleInvalidResponse = function (t, e) {
      var n = this;
      if (t.body.missingField || t.body.error.startsWith(T9)) this.fulfillRequest(e, t.statusCode, t.body.error);else {
        var i = al(al(al(al([], Hr(Object.values(t.body.eventsWithInvalidFields)), !1), Hr(Object.values(t.body.eventsWithMissingFields)), !1), Hr(Object.values(t.body.eventsWithInvalidIdLengths)), !1), Hr(t.body.silencedEvents), !1).flat(),
          r = new Set(i),
          o = e.filter(function (e, i) {
            if (!r.has(i)) return !0;
            n.fulfillRequest([e], t.statusCode, t.body.error);
          });
        this.addToQueue.apply(this, al([], Hr(o), !1));
      }
    }, t.prototype.handlePayloadTooLargeResponse = function (t, e) {
      1 !== e.length ? (this.config.flushQueueSize /= 2, this.addToQueue.apply(this, al([], Hr(e), !1))) : this.fulfillRequest(e, t.statusCode, t.body.error);
    }, t.prototype.handleRateLimitResponse = function (t, e) {
      var n = this,
        i = Object.keys(t.body.exceededDailyQuotaUsers),
        r = Object.keys(t.body.exceededDailyQuotaDevices),
        o = t.body.throttledEvents,
        s = new Set(i),
        a = new Set(r),
        l = new Set(o),
        u = e.filter(function (e, i) {
          if (!(e.event.user_id && s.has(e.event.user_id) || e.event.device_id && a.has(e.event.device_id))) return l.has(i) && (e.timeout = n.throttleTimeout), !0;
          n.fulfillRequest([e], t.statusCode, t.body.error);
        });
      this.addToQueue.apply(this, al([], Hr(u), !1));
    }, t.prototype.handleOtherReponse = function (t) {
      var e = this;
      this.addToQueue.apply(this, al([], Hr(t.map(function (t) {
        return t.timeout = t.attempts * e.retryTimeout, t;
      })), !1));
    }, t.prototype.fulfillRequest = function (t, e, n) {
      this.saveEvents(), t.forEach(function (t) {
        return t.callback(uh(t.event, e, n));
      });
    }, t.prototype.saveEvents = function () {
      if (this.config.storageProvider) {
        var t = Array.from(this.queue.map(function (t) {
          return t.event;
        }));
        this.config.storageProvider.set(this.storageKey, t);
      }
    }, t;
  }();
E();
var _a = u(function (t) {
  return function () {
    for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
    return {
      promise: t.apply(void 0, al([], Hr(e), !1))
    };
  };
}, "returnWrapper");
E();
var ZK = u(function (t) {
    return void 0 === t && (t = 0), (new Error().stack || "").split("\n").slice(2 + t).map(function (t) {
      return t.trim();
    });
  }, "getStacktrace"),
  fr = u(function (t) {
    return function () {
      var e = bt({}, t.config);
      return {
        logger: e.loggerProvider,
        logLevel: e.logLevel
      };
    };
  }, "getClientLogConfig"),
  JK = u(function (t, e) {
    var n, i;
    e = (e = e.replace(/\[(\w+)\]/g, ".$1")).replace(/^\./, "");
    try {
      for (var r = ya(e.split(".")), o = r.next(); !o.done; o = r.next()) {
        var s = o.value;
        if (!(s in t)) return;
        t = t[s];
      }
    } catch (t) {
      n = {
        error: t
      };
    } finally {
      try {
        o && !o.done && (i = r.return) && i.call(r);
      } finally {
        if (n) throw n.error;
      }
    }
    return t;
  }, "getValueByStringPath"),
  pr = u(function (t, e) {
    return function () {
      var n,
        i,
        r = {};
      try {
        for (var o = ya(e), s = o.next(); !s.done; s = o.next()) {
          var a = s.value;
          r[a] = JK(t, a);
        }
      } catch (t) {
        n = {
          error: t
        };
      } finally {
        try {
          s && !s.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
      return r;
    };
  }, "getClientStates"),
  dr = u(function (t, e, n, i, r) {
    return void 0 === r && (r = null), function () {
      for (var o = [], s = 0; s < arguments.length; s++) o[s] = arguments[s];
      var a = n(),
        l = a.logger,
        u = a.logLevel;
      if (u && u < hs.Debug || !u || !l) return t.apply(r, o);
      var h = {
        type: "invoke public method",
        name: e,
        args: o,
        stacktrace: ZK(1),
        time: {
          start: new Date().toISOString()
        },
        states: {}
      };
      i && h.states && (h.states.before = i());
      var c = t.apply(r, o);
      return c && c.promise ? c.promise.then(function () {
        i && h.states && (h.states.after = i()), h.time && (h.time.end = new Date().toISOString()), l.debug(JSON.stringify(h, null, 2));
      }) : (i && h.states && (h.states.after = i()), h.time && (h.time.end = new Date().toISOString()), l.debug(JSON.stringify(h, null, 2))), c;
    };
  }, "debugWrapper");
E();
var ch = u(function (t) {
  return t ? (t ^ 16 * Math.random() >> t / 4).toString(16) : (String(1e7) + String(-1e3) + String(-4e3) + String(-8e3) + String(-1e11)).replace(/[018]/g, ch);
}, "UUID");
E();
var m0 = function () {
  function t() {
    this.memoryStorage = new Map();
  }
  return u(t, "MemoryStorage"), t.prototype.isEnabled = function () {
    return Et(this, void 0, void 0, function () {
      return wt(this, function (t) {
        return [2, !0];
      });
    });
  }, t.prototype.get = function (t) {
    return Et(this, void 0, void 0, function () {
      return wt(this, function (e) {
        return [2, this.memoryStorage.get(t)];
      });
    });
  }, t.prototype.getRaw = function (t) {
    return Et(this, void 0, void 0, function () {
      var e;
      return wt(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this.get(t)];
          case 1:
            return [2, (e = n.sent()) ? JSON.stringify(e) : void 0];
        }
      });
    });
  }, t.prototype.set = function (t, e) {
    return Et(this, void 0, void 0, function () {
      return wt(this, function (n) {
        return this.memoryStorage.set(t, e), [2];
      });
    });
  }, t.prototype.remove = function (t) {
    return Et(this, void 0, void 0, function () {
      return wt(this, function (e) {
        return this.memoryStorage.delete(t), [2];
      });
    });
  }, t.prototype.reset = function () {
    return Et(this, void 0, void 0, function () {
      return wt(this, function (t) {
        return this.memoryStorage.clear(), [2];
      });
    });
  }, t;
}();
E();
var Ef = function () {
  function t() {}
  return u(t, "BaseTransport"), t.prototype.send = function (t, e) {
    return Promise.resolve(null);
  }, t.prototype.buildResponse = function (t) {
    var e, n, i, r, o, s, a, l, u, h, c, p, d, f, m, g, v, y, _, x, E, b;
    if ("object" != typeof t) return null;
    var w = t.code || 0,
      S = this.buildStatus(w);
    switch (S) {
      case Ki.Success:
        return {
          status: S,
          statusCode: w,
          body: {
            eventsIngested: null !== (e = t.events_ingested) && void 0 !== e ? e : 0,
            payloadSizeBytes: null !== (n = t.payload_size_bytes) && void 0 !== n ? n : 0,
            serverUploadTime: null !== (i = t.server_upload_time) && void 0 !== i ? i : 0
          }
        };
      case Ki.Invalid:
        return {
          status: S,
          statusCode: w,
          body: {
            error: null !== (r = t.error) && void 0 !== r ? r : "",
            missingField: null !== (o = t.missing_field) && void 0 !== o ? o : "",
            eventsWithInvalidFields: null !== (s = t.events_with_invalid_fields) && void 0 !== s ? s : {},
            eventsWithMissingFields: null !== (a = t.events_with_missing_fields) && void 0 !== a ? a : {},
            eventsWithInvalidIdLengths: null !== (l = t.events_with_invalid_id_lengths) && void 0 !== l ? l : {},
            epsThreshold: null !== (u = t.eps_threshold) && void 0 !== u ? u : 0,
            exceededDailyQuotaDevices: null !== (h = t.exceeded_daily_quota_devices) && void 0 !== h ? h : {},
            silencedDevices: null !== (c = t.silenced_devices) && void 0 !== c ? c : [],
            silencedEvents: null !== (p = t.silenced_events) && void 0 !== p ? p : [],
            throttledDevices: null !== (d = t.throttled_devices) && void 0 !== d ? d : {},
            throttledEvents: null !== (f = t.throttled_events) && void 0 !== f ? f : []
          }
        };
      case Ki.PayloadTooLarge:
        return {
          status: S,
          statusCode: w,
          body: {
            error: null !== (m = t.error) && void 0 !== m ? m : ""
          }
        };
      case Ki.RateLimit:
        return {
          status: S,
          statusCode: w,
          body: {
            error: null !== (g = t.error) && void 0 !== g ? g : "",
            epsThreshold: null !== (v = t.eps_threshold) && void 0 !== v ? v : 0,
            throttledDevices: null !== (y = t.throttled_devices) && void 0 !== y ? y : {},
            throttledUsers: null !== (_ = t.throttled_users) && void 0 !== _ ? _ : {},
            exceededDailyQuotaDevices: null !== (x = t.exceeded_daily_quota_devices) && void 0 !== x ? x : {},
            exceededDailyQuotaUsers: null !== (E = t.exceeded_daily_quota_users) && void 0 !== E ? E : {},
            throttledEvents: null !== (b = t.throttled_events) && void 0 !== b ? b : []
          }
        };
      case Ki.Timeout:
      default:
        return {
          status: S,
          statusCode: w
        };
    }
  }, t.prototype.buildStatus = function (t) {
    return t >= 200 && t < 300 ? Ki.Success : 429 === t ? Ki.RateLimit : 413 === t ? Ki.PayloadTooLarge : 408 === t ? Ki.Timeout : t >= 400 && t < 500 ? Ki.Invalid : t >= 500 ? Ki.Failed : Ki.Unknown;
  }, t;
}();
E(), E(), E(), E();
var fs = u(function () {
    return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof self ? self : "undefined" != typeof global ? global : void 0;
  }, "getGlobalScope"),
  Ld = u(function () {
    var t,
      e = fs();
    return (null === (t = null == e ? void 0 : e.location) || void 0 === t ? void 0 : t.search) ? e.location.search.substring(1).split("&").filter(Boolean).reduce(function (t, e) {
      var n = e.split("=", 2),
        i = I9(n[0]),
        r = I9(n[1]);
      return r && (t[i] = r), t;
    }, {}) : {};
  }, "getQueryParams"),
  I9 = u(function (t) {
    void 0 === t && (t = "");
    try {
      return decodeURIComponent(t);
    } catch (t) {
      return "";
    }
  }, "tryDecodeURIComponent");
E();
var L9 = "utm_campaign",
  O9 = "utm_content",
  R9 = "utm_id",
  N9 = "utm_medium",
  D9 = "utm_source",
  q9 = "utm_term",
  n4 = "dclid",
  i4 = "fbclid",
  r4 = "gbraid",
  o4 = "gclid",
  s4 = "ko_click_id",
  a4 = "msclkid",
  l4 = "ttclid",
  u4 = "twclid",
  c4 = "wbraid",
  k9 = "EMPTY",
  db = {
    utm_campaign: void 0,
    utm_content: void 0,
    utm_id: void 0,
    utm_medium: void 0,
    utm_source: void 0,
    utm_term: void 0,
    referrer: void 0,
    referring_domain: void 0,
    dclid: void 0,
    gbraid: void 0,
    gclid: void 0,
    fbclid: void 0,
    ko_click_id: void 0,
    msclkid: void 0,
    ttclid: void 0,
    twclid: void 0,
    wbraid: void 0
  },
  F9 = "MKTG",
  B9 = function () {
    function t() {}
    return u(t, "CampaignParser"), t.prototype.parse = function () {
      return Et(this, void 0, void 0, function () {
        return wt(this, function (t) {
          return [2, bt(bt(bt(bt({}, db), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, t.prototype.getUtmParam = function () {
      var t = Ld();
      return {
        utm_campaign: t[L9],
        utm_content: t[O9],
        utm_id: t[R9],
        utm_medium: t[N9],
        utm_source: t[D9],
        utm_term: t[q9]
      };
    }, t.prototype.getReferrer = function () {
      var t,
        e,
        n = {
          referrer: void 0,
          referring_domain: void 0
        };
      try {
        n.referrer = document.referrer || void 0, n.referring_domain = null !== (e = null === (t = n.referrer) || void 0 === t ? void 0 : t.split("/")[2]) && void 0 !== e ? e : void 0;
      } catch (t) {}
      return n;
    }, t.prototype.getClickIds = function () {
      var t,
        e = Ld();
      return (t = {})[n4] = e[n4], t[i4] = e[i4], t[r4] = e[r4], t[o4] = e[o4], t[s4] = e[s4], t[a4] = e[a4], t[l4] = e[l4], t[u4] = e[u4], t[c4] = e[c4], t;
    }, t;
  }();
E(), E();
var wf = u(function (t, e, n) {
    return void 0 === e && (e = ""), void 0 === n && (n = 10), [p0, e, t.substring(0, n)].filter(Boolean).join("_");
  }, "getCookieName"),
  h4 = u(function (t) {
    return "".concat(p0.toLowerCase(), "_").concat(t.substring(0, 6));
  }, "getOldCookieName"),
  f4 = function () {
    function t(t, e) {
      var n, i;
      this.storage = e.storage, this.storageKey = wf(t, F9), this.parser = new B9(), this.track = e.track, this.onNewCampaign = e.onNewCampaign, this.disabled = Boolean(e.disabled), this.trackNewCampaigns = Boolean(e.trackNewCampaigns), this.trackPageViews = Boolean(e.trackPageViews), this.excludeReferrers = null !== (n = e.excludeReferrers) && void 0 !== n ? n : [], "undefined" != typeof location && this.excludeReferrers.unshift(location.hostname), this.initialEmptyValue = null !== (i = e.initialEmptyValue) && void 0 !== i ? i : k9;
    }
    return u(t, "CampaignTracker"), t.prototype.isNewCampaign = function (t, e, n) {
      void 0 === n && (n = !1);
      t.referrer;
      var i = t.referring_domain,
        r = f0(t, ["referrer", "referring_domain"]),
        o = e || {},
        s = (o.referrer, o.referring_domain),
        a = f0(o, ["referrer", "referring_domain"]);
      if (t.referring_domain && this.excludeReferrers.includes(t.referring_domain)) return !1;
      var l = JSON.stringify(r) !== JSON.stringify(a),
        u = n ? U9(i || "") !== U9(s || "") : i !== s;
      return !e || l || u;
    }, t.prototype.saveCampaignToStorage = function (t) {
      return Et(this, void 0, void 0, function () {
        return wt(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this.storage.set(this.storageKey, t)];
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, t.prototype.getCampaignFromStorage = function () {
      return Et(this, void 0, void 0, function () {
        return wt(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.storage.get(this.storageKey)];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, t.prototype.createCampaignEvent = function (t) {
      var e = this,
        n = bt(bt({}, db), t),
        i = Object.entries(n).reduce(function (t, n) {
          var i = Hr(n, 2),
            r = i[0],
            o = i[1];
          return t.setOnce("initial_".concat(r), o || e.initialEmptyValue), o ? t.set(r, o) : t.unset(r);
        }, new ll()),
        r = {
          event_type: "Page View",
          event_properties: {
            page_title: "undefined" != typeof document && document.title || "",
            page_location: "undefined" != typeof location && location.href || "",
            page_path: "undefined" != typeof location && location.pathname || ""
          }
        };
      return bt(bt({}, d0(i)), this.trackPageViews && r);
    }, t.prototype.send = function (t) {
      return Et(this, void 0, void 0, function () {
        var e, n;
        return wt(this, function (i) {
          switch (i.label) {
            case 0:
              return this.disabled ? [2] : [4, this.parser.parse()];
            case 1:
              return e = i.sent(), [4, this.getCampaignFromStorage()];
            case 2:
              if (n = i.sent(), !t) {
                if (!this.trackNewCampaigns || !this.isNewCampaign(e, n)) return [2];
                this.onNewCampaign(e);
              }
              return [4, this.track(this.createCampaignEvent(e))];
            case 3:
              return i.sent(), [4, this.saveCampaignToStorage(e)];
            case 4:
              return i.sent(), [2];
          }
        });
      });
    }, t;
  }(),
  U9 = u(function (t) {
    var e = t.split(".");
    return e.length <= 2 ? t : e.slice(e.length - 2, e.length).join(".");
  }, "domainWithoutSubdomain");
E();
var Sf = function () {
  function t(t) {
    this.options = bt({}, t);
  }
  return u(t, "CookieStorage"), t.prototype.isEnabled = function () {
    return Et(this, void 0, void 0, function () {
      var e, n, i;
      return wt(this, function (r) {
        switch (r.label) {
          case 0:
            if (!fs()) return [2, !1];
            e = String(Date.now()), n = new t(this.options), i = "AMP_TEST", r.label = 1;
          case 1:
            return r.trys.push([1, 4, 5, 7]), [4, n.set(i, e)];
          case 2:
            return r.sent(), [4, n.get(i)];
          case 3:
            return [2, r.sent() === e];
          case 4:
            return r.sent(), [2, !1];
          case 5:
            return [4, n.remove(i)];
          case 6:
            return r.sent(), [7];
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.get = function (t) {
    return Et(this, void 0, void 0, function () {
      var e;
      return wt(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this.getRaw(t)];
          case 1:
            if (!(e = n.sent())) return [2, void 0];
            try {
              try {
                e = decodeURIComponent(atob(e));
              } catch (t) {}
              return [2, JSON.parse(e)];
            } catch (t) {
              return [2, void 0];
            }
            return [2];
        }
      });
    });
  }, t.prototype.getRaw = function (t) {
    var e;
    return Et(this, void 0, void 0, function () {
      var n, i, r;
      return wt(this, function (o) {
        return n = fs(), i = null !== (e = null == n ? void 0 : n.document.cookie.split("; ")) && void 0 !== e ? e : [], (r = i.find(function (e) {
          return 0 === e.indexOf(t + "=");
        })) ? [2, r.substring(t.length + 1)] : [2, void 0];
      });
    });
  }, t.prototype.set = function (t, e) {
    var n;
    return Et(this, void 0, void 0, function () {
      var i, r, o, s, a, l;
      return wt(this, function (u) {
        try {
          i = null !== (n = this.options.expirationDays) && void 0 !== n ? n : 0, o = void 0, (r = null !== e ? i : -1) && ((s = new Date()).setTime(s.getTime() + 24 * r * 60 * 60 * 1e3), o = s), a = "".concat(t, "=").concat(btoa(encodeURIComponent(JSON.stringify(e)))), o && (a += "; expires=".concat(o.toUTCString())), a += "; path=/", this.options.domain && (a += "; domain=".concat(this.options.domain)), this.options.secure && (a += "; Secure"), this.options.sameSite && (a += "; SameSite=".concat(this.options.sameSite)), (l = fs()) && (l.document.cookie = a);
        } catch (t) {}
        return [2];
      });
    });
  }, t.prototype.remove = function (t) {
    return Et(this, void 0, void 0, function () {
      return wt(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, this.set(t, null)];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, t.prototype.reset = function () {
    return Et(this, void 0, void 0, function () {
      return wt(this, function (t) {
        return [2];
      });
    });
  }, t;
}();
E();
var mb = function () {
  function t(t, e) {
    this.storage = t, this.storageKey = wf(e), this.cache = {
      optOut: !1
    };
  }
  return u(t, "SessionManager"), t.prototype.load = function () {
    var t;
    return Et(this, void 0, void 0, function () {
      var e;
      return wt(this, function (n) {
        switch (n.label) {
          case 0:
            return e = this, [4, this.storage.get(this.storageKey)];
          case 1:
            return e.cache = null !== (t = n.sent()) && void 0 !== t ? t : {
              optOut: !1
            }, [2, this];
        }
      });
    });
  }, t.prototype.setSession = function (t) {
    this.cache = bt(bt({}, this.cache), t), this.storage.set(this.storageKey, this.cache);
  }, t.prototype.getSessionId = function () {
    return this.cache.sessionId;
  }, t.prototype.setSessionId = function (t) {
    this.setSession({
      sessionId: t
    });
  }, t.prototype.getDeviceId = function () {
    return this.cache.deviceId;
  }, t.prototype.setDeviceId = function (t) {
    this.setSession({
      deviceId: t
    });
  }, t.prototype.getUserId = function () {
    return this.cache.userId;
  }, t.prototype.setUserId = function (t) {
    this.setSession({
      userId: t
    });
  }, t.prototype.getLastEventTime = function () {
    return this.cache.lastEventTime;
  }, t.prototype.setLastEventTime = function (t) {
    this.setSession({
      lastEventTime: t
    });
  }, t.prototype.getOptOut = function () {
    return this.cache.optOut;
  }, t.prototype.setOptOut = function (t) {
    this.setSession({
      optOut: t
    });
  }, t.prototype.getLastEventId = function () {
    return this.cache.lastEventId;
  }, t.prototype.setLastEventId = function (t) {
    this.setSession({
      lastEventId: t
    });
  }, t;
}();
E();
var p4 = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }
  return Fl(e, t), u(e, "FetchTransport"), e.prototype.send = function (t, e) {
    return Et(this, void 0, void 0, function () {
      var n, i;
      return wt(this, function (r) {
        switch (r.label) {
          case 0:
            if ("undefined" == typeof fetch) throw new Error("FetchTransport is not supported");
            return n = {
              headers: {
                "Content-Type": "application/json",
                Accept: "*/*"
              },
              body: JSON.stringify(e),
              method: "POST"
            }, [4, fetch(t, n)];
          case 1:
            return [4, r.sent().json()];
          case 2:
            return i = r.sent(), [2, this.buildResponse(i)];
        }
      });
    });
  }, e;
}(Ef);
E(), E();
var z9 = Rt(d4()),
  KK = function () {
    function t() {
      this.ua = new z9.UAParser("undefined" != typeof navigator ? navigator.userAgent : null).getResult();
    }
    return u(t, "ApplicationContextProviderImpl"), t.prototype.getApplicationContext = function () {
      return {
        versionName: this.versionName,
        language: eQ(),
        platform: "Web",
        os: QK(this.ua),
        deviceModel: $K(this.ua)
      };
    }, t;
  }(),
  QK = u(function (t) {
    var e, n;
    return [null === (e = t.browser) || void 0 === e ? void 0 : e.name, null === (n = t.browser) || void 0 === n ? void 0 : n.major].filter(function (t) {
      return null != t;
    }).join(" ");
  }, "getOs"),
  $K = u(function (t) {
    var e;
    return null === (e = t.os) || void 0 === e ? void 0 : e.name;
  }, "getDeviceModel"),
  eQ = u(function () {
    return "undefined" != typeof navigator && (navigator.languages && navigator.languages[0] || navigator.language) || "";
  }, "getLanguage"),
  tQ = function () {
    function t() {
      this.queue = [];
    }
    return u(t, "EventBridgeImpl"), t.prototype.logEvent = function (t) {
      this.receiver ? this.receiver(t) : this.queue.length < 512 && this.queue.push(t);
    }, t.prototype.setEventReceiver = function (t) {
      this.receiver = t, this.queue.length > 0 && (this.queue.forEach(function (e) {
        t(e);
      }), this.queue = []);
    }, t;
  }(),
  hh = u(function () {
    return hh = Object.assign || u(function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      return t;
    }, "__assign"), hh.apply(this, arguments);
  }, "__assign"),
  vb = u(function (t, e) {
    var n = typeof t;
    if (n !== typeof e) return !1;
    for (var i = 0, r = ["string", "number", "boolean", "undefined"]; i < r.length; i++) {
      if (r[i] === n) return t === e;
    }
    if (null == t && null == e) return !0;
    if (null == t || null == e || t.length !== e.length) return !1;
    var o = Array.isArray(t),
      s = Array.isArray(e);
    if (o !== s) return !1;
    if (!o || !s) {
      var a = Object.keys(t).sort(),
        l = Object.keys(e).sort();
      if (!vb(a, l)) return !1;
      var u = !0;
      return Object.keys(t).forEach(function (n) {
        vb(t[n], e[n]) || (u = !1);
      }), u;
    }
    for (var h = 0; h < t.length; h++) if (!vb(t[h], e[h])) return !1;
    return !0;
  }, "isEqual"),
  nQ = "$set",
  iQ = "$unset",
  rQ = "$clearAll";
Object.entries || (Object.entries = function (t) {
  for (var e = Object.keys(t), n = e.length, i = new Array(n); n--;) i[n] = [e[n], t[e[n]]];
  return i;
});
var oQ = function () {
    function t() {
      this.identity = {
        userProperties: {}
      }, this.listeners = new Set();
    }
    return u(t, "IdentityStoreImpl"), t.prototype.editIdentity = function () {
      var t = this,
        e = hh({}, this.identity.userProperties),
        n = hh(hh({}, this.identity), {
          userProperties: e
        });
      return {
        setUserId: function (t) {
          return n.userId = t, this;
        },
        setDeviceId: function (t) {
          return n.deviceId = t, this;
        },
        setUserProperties: function (t) {
          return n.userProperties = t, this;
        },
        updateUserProperties: function (t) {
          for (var e = n.userProperties || {}, i = 0, r = Object.entries(t); i < r.length; i++) {
            var o = r[i],
              s = o[0],
              a = o[1];
            switch (s) {
              case nQ:
                for (var l = 0, u = Object.entries(a); l < u.length; l++) {
                  var h = u[l],
                    c = h[0],
                    p = h[1];
                  e[c] = p;
                }
                break;
              case iQ:
                for (var d = 0, f = Object.keys(a); d < f.length; d++) {
                  delete e[c = f[d]];
                }
                break;
              case rQ:
                e = {};
            }
          }
          return n.userProperties = e, this;
        },
        commit: function () {
          return t.setIdentity(n), this;
        }
      };
    }, t.prototype.getIdentity = function () {
      return hh({}, this.identity);
    }, t.prototype.setIdentity = function (t) {
      var e = hh({}, this.identity);
      this.identity = hh({}, t), vb(e, this.identity) || this.listeners.forEach(function (e) {
        e(t);
      });
    }, t.prototype.addIdentityListener = function (t) {
      this.listeners.add(t);
    }, t.prototype.removeIdentityListener = function (t) {
      this.listeners.delete(t);
    }, t;
  }(),
  v0 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof global ? global : self,
  V9 = function () {
    function t() {
      this.identityStore = new oQ(), this.eventBridge = new tQ(), this.applicationContextProvider = new KK();
    }
    return u(t, "AnalyticsConnector"), t.getInstance = function (e) {
      return v0.analyticsConnectorInstances || (v0.analyticsConnectorInstances = {}), v0.analyticsConnectorInstances[e] || (v0.analyticsConnectorInstances[e] = new t()), v0.analyticsConnectorInstances[e];
    }, t;
  }(),
  y0 = u(function () {
    return V9.getInstance("$default_instance");
  }, "getAnalyticsConnector");
E();
var m4 = function () {
  function t() {
    this.name = "identity", this.type = As.BEFORE, this.identityStore = y0().identityStore;
  }
  return u(t, "IdentityEventSender"), t.prototype.execute = function (t) {
    return Et(this, void 0, void 0, function () {
      var e;
      return wt(this, function (n) {
        return (e = t.user_properties) && this.identityStore.editIdentity().updateUserProperties(e).commit(), [2, t];
      });
    });
  }, t.prototype.setup = function (t) {
    return Promise.resolve(void 0);
  }, t;
}();
E();
var g4 = u(function () {
  var t, e, n, i;
  if ("undefined" == typeof navigator) return "";
  var r = navigator.userLanguage;
  return null !== (i = null !== (n = null !== (e = null === (t = navigator.languages) || void 0 === t ? void 0 : t[0]) && void 0 !== e ? e : navigator.language) && void 0 !== n ? n : r) && void 0 !== i ? i : "";
}, "getLanguage");
E();
var yb = u(function (t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n],
        r = i.name,
        o = i.args,
        s = i.resolve,
        a = t && t[r];
      if ("function" == typeof a) {
        var l = a.apply(t, o);
        "function" == typeof s && s(null == l ? void 0 : l.promise);
      }
    }
    return t;
  }, "convertProxyObjectToRealObject"),
  _b = u(function (t) {
    return t && void 0 !== t._q;
  }, "isInstanceProxy");
E();
var H9 = Rt(d4());
E();
var G9 = "1.6.8",
  sQ = "Web",
  aQ = "$remote",
  j9 = function () {
    function t() {
      var t;
      this.name = "context", this.type = As.BEFORE, this.eventId = 0, this.library = "amplitude-ts/".concat(G9), "undefined" != typeof navigator && (t = navigator.userAgent), this.uaResult = new H9.default(t).getResult();
    }
    return u(t, "Context"), t.prototype.setup = function (t) {
      return this.config = t, Promise.resolve(void 0);
    }, t.prototype.execute = function (t) {
      return Et(this, void 0, void 0, function () {
        var e, n, i, r, o;
        return wt(this, function (s) {
          return this.isSessionValid() || (this.config.sessionId = Date.now()), this.config.lastEventTime = Date.now(), e = new Date().getTime(), n = this.uaResult.browser.name, i = this.uaResult.browser.version, r = this.uaResult.device.model || this.uaResult.os.name, o = this.uaResult.device.vendor, [2, bt(bt(bt(bt(bt(bt(bt(bt(bt(bt(bt(bt({
            user_id: this.config.userId,
            device_id: this.config.deviceId,
            session_id: this.config.sessionId,
            time: e
          }, this.config.appVersion && {
            app_version: this.config.appVersion
          }), this.config.trackingOptions.platform && {
            platform: sQ
          }), this.config.trackingOptions.osName && {
            os_name: n
          }), this.config.trackingOptions.osVersion && {
            os_version: i
          }), this.config.trackingOptions.deviceManufacturer && {
            device_manufacturer: o
          }), this.config.trackingOptions.deviceModel && {
            device_model: r
          }), this.config.trackingOptions.language && {
            language: g4()
          }), this.config.trackingOptions.ipAddress && {
            ip: aQ
          }), {
            insert_id: ch(),
            partner_id: this.config.partnerId,
            plan: this.config.plan
          }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), t), {
            event_id: this.eventId++,
            library: this.library
          })];
        });
      });
    }, t.prototype.isSessionValid = function () {
      var t = this.config.lastEventTime || Date.now();
      return Date.now() - t < this.config.sessionTimeout;
    }, t;
  }();
E(), E();
var _0 = function () {
  function t() {}
  return u(t, "LocalStorage"), t.prototype.isEnabled = function () {
    return Et(this, void 0, void 0, function () {
      var e, n, i;
      return wt(this, function (r) {
        switch (r.label) {
          case 0:
            if (!fs()) return [2, !1];
            e = String(Date.now()), n = new t(), i = "AMP_TEST", r.label = 1;
          case 1:
            return r.trys.push([1, 4, 5, 7]), [4, n.set(i, e)];
          case 2:
            return r.sent(), [4, n.get(i)];
          case 3:
            return [2, r.sent() === e];
          case 4:
            return r.sent(), [2, !1];
          case 5:
            return [4, n.remove(i)];
          case 6:
            return r.sent(), [7];
          case 7:
            return [2];
        }
      });
    });
  }, t.prototype.get = function (t) {
    return Et(this, void 0, void 0, function () {
      var e;
      return wt(this, function (n) {
        switch (n.label) {
          case 0:
            return n.trys.push([0, 2,, 3]), [4, this.getRaw(t)];
          case 1:
            return (e = n.sent()) ? [2, JSON.parse(e)] : [2, void 0];
          case 2:
            return n.sent(), [2, void 0];
          case 3:
            return [2];
        }
      });
    });
  }, t.prototype.getRaw = function (t) {
    var e;
    return Et(this, void 0, void 0, function () {
      return wt(this, function (n) {
        return [2, (null === (e = fs()) || void 0 === e ? void 0 : e.localStorage.getItem(t)) || void 0];
      });
    });
  }, t.prototype.set = function (t, e) {
    var n;
    return Et(this, void 0, void 0, function () {
      return wt(this, function (i) {
        try {
          null === (n = fs()) || void 0 === n || n.localStorage.setItem(t, JSON.stringify(e));
        } catch (t) {}
        return [2];
      });
    });
  }, t.prototype.remove = function (t) {
    var e;
    return Et(this, void 0, void 0, function () {
      return wt(this, function (n) {
        try {
          null === (e = fs()) || void 0 === e || e.localStorage.removeItem(t);
        } catch (t) {}
        return [2];
      });
    });
  }, t.prototype.reset = function () {
    var t;
    return Et(this, void 0, void 0, function () {
      return wt(this, function (e) {
        try {
          null === (t = fs()) || void 0 === t || t.localStorage.clear();
        } catch (t) {}
        return [2];
      });
    });
  }, t;
}();
E();
var W9 = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.state = {
      done: 4
    }, e;
  }
  return Fl(e, t), u(e, "XHRTransport"), e.prototype.send = function (t, e) {
    return Et(this, void 0, void 0, function () {
      var n = this;
      return wt(this, function (i) {
        return [2, new Promise(function (i, r) {
          "undefined" == typeof XMLHttpRequest && r(new Error("XHRTransport is not supported."));
          var o = new XMLHttpRequest();
          o.open("POST", t, !0), o.onreadystatechange = function () {
            if (o.readyState === n.state.done) try {
              var t = o.responseText,
                e = JSON.parse(t),
                s = n.buildResponse(e);
              i(s);
            } catch (t) {
              r(t);
            }
          }, o.setRequestHeader("Content-Type", "application/json"), o.setRequestHeader("Accept", "*/*"), o.send(JSON.stringify(e));
        })];
      });
    });
  }, e;
}(Ef);
E();
var X9 = function (t) {
    function e() {
      return null !== t && t.apply(this, arguments) || this;
    }
    return Fl(e, t), u(e, "SendBeaconTransport"), e.prototype.send = function (t, e) {
      return Et(this, void 0, void 0, function () {
        var n = this;
        return wt(this, function (i) {
          return [2, new Promise(function (i, r) {
            var o = fs();
            if (!(null == o ? void 0 : o.navigator.sendBeacon)) throw new Error("SendBeaconTransport is not supported");
            try {
              var s = JSON.stringify(e);
              return i(o.navigator.sendBeacon(t, JSON.stringify(e)) ? n.buildResponse({
                code: 200,
                events_ingested: e.events.length,
                payload_size_bytes: s.length,
                server_upload_time: Date.now()
              }) : n.buildResponse({
                code: 500
              }));
            } catch (t) {
              r(t);
            }
          })];
        });
      });
    }, e;
  }(Ef),
  xb = u(function () {
    var t = new m0();
    return {
      cookieExpiration: 365,
      cookieSameSite: "Lax",
      cookieSecure: !1,
      cookieStorage: t,
      disableCookies: !1,
      domain: "",
      sessionManager: new mb(t, ""),
      sessionTimeout: 18e5,
      storageProvider: new m0(),
      trackingOptions: {
        deviceManufacturer: !0,
        deviceModel: !0,
        ipAddress: !0,
        language: !0,
        osName: !0,
        osVersion: !0,
        platform: !0
      },
      transportProvider: new p4()
    };
  }, "getDefaultConfig"),
  Y9 = function (t) {
    function e(e, n, i) {
      var r,
        o,
        s,
        a,
        l,
        u,
        h,
        c,
        p,
        d,
        f,
        m,
        g = this,
        v = xb();
      return (g = t.call(this, bt(bt({
        flushIntervalMillis: 1e3,
        flushMaxRetries: 5,
        flushQueueSize: 30
      }, i), {
        apiKey: e,
        storageProvider: null !== (r = null == i ? void 0 : i.storageProvider) && void 0 !== r ? r : v.storageProvider,
        transportProvider: null !== (o = null == i ? void 0 : i.transportProvider) && void 0 !== o ? o : v.transportProvider
      })) || this).cookieStorage = null !== (s = null == i ? void 0 : i.cookieStorage) && void 0 !== s ? s : v.cookieStorage, g.sessionManager = null !== (a = null == i ? void 0 : i.sessionManager) && void 0 !== a ? a : v.sessionManager, g.sessionTimeout = null !== (l = null == i ? void 0 : i.sessionTimeout) && void 0 !== l ? l : v.sessionTimeout, g.appVersion = null == i ? void 0 : i.appVersion, g.attribution = null == i ? void 0 : i.attribution, g.cookieExpiration = null !== (u = null == i ? void 0 : i.cookieExpiration) && void 0 !== u ? u : v.cookieExpiration, g.cookieSameSite = null !== (h = null == i ? void 0 : i.cookieSameSite) && void 0 !== h ? h : v.cookieSameSite, g.cookieSecure = null !== (c = null == i ? void 0 : i.cookieSecure) && void 0 !== c ? c : v.cookieSecure, g.deviceId = null == i ? void 0 : i.deviceId, g.disableCookies = null !== (p = null == i ? void 0 : i.disableCookies) && void 0 !== p ? p : v.disableCookies, g.domain = null !== (d = null == i ? void 0 : i.domain) && void 0 !== d ? d : v.domain, g.lastEventTime = null !== (f = g.lastEventTime) && void 0 !== f ? f : null == i ? void 0 : i.lastEventTime, g.optOut = Boolean(null == i ? void 0 : i.optOut), g.partnerId = null == i ? void 0 : i.partnerId, g.sessionId = null == i ? void 0 : i.sessionId, g.trackingOptions = null !== (m = null == i ? void 0 : i.trackingOptions) && void 0 !== m ? m : v.trackingOptions, g.userId = n, g;
    }
    return Fl(e, t), u(e, "BrowserConfig"), Object.defineProperty(e.prototype, "deviceId", {
      get: function () {
        return this.sessionManager.getDeviceId();
      },
      set: function (t) {
        this.sessionManager.setDeviceId(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "userId", {
      get: function () {
        return this.sessionManager.getUserId();
      },
      set: function (t) {
        this.sessionManager.setUserId(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "sessionId", {
      get: function () {
        return this.sessionManager.getSessionId();
      },
      set: function (t) {
        this.sessionManager.setSessionId(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "optOut", {
      get: function () {
        return this.sessionManager.getOptOut();
      },
      set: function (t) {
        var e;
        null === (e = this.sessionManager) || void 0 === e || e.setOptOut(Boolean(t));
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastEventTime", {
      get: function () {
        return this.sessionManager.getLastEventTime();
      },
      set: function (t) {
        this.sessionManager.setLastEventTime(t);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }($T),
  Z9 = u(function (t, e, n) {
    return Et(void 0, void 0, void 0, function () {
      var i, r, o, s, a, l, u, h, c, p, d, f, m, g, v, y, _;
      return wt(this, function (x) {
        switch (x.label) {
          case 0:
            return i = xb(), null !== (m = null == n ? void 0 : n.domain) && void 0 !== m ? (o = m, [3, 3]) : [3, 1];
          case 1:
            return [4, hQ()];
          case 2:
            o = x.sent(), x.label = 3;
          case 3:
            return r = o, [4, lQ(bt(bt({}, n), {
              domain: r
            }))];
          case 4:
            return s = x.sent(), a = wf(t), [4, s.get(a)];
          case 5:
            return l = x.sent(), u = Ld(), [4, new mb(s, t).load()];
          case 6:
            return h = x.sent(), c = Y9.bind, p = [void 0, t, null != e ? e : null == l ? void 0 : l.userId], d = [bt({}, n)], f = {
              cookieStorage: s,
              sessionManager: h,
              deviceId: cQ(null == l ? void 0 : l.deviceId, null == n ? void 0 : n.deviceId, u.deviceId),
              domain: r,
              optOut: null !== (g = null == n ? void 0 : n.optOut) && void 0 !== g ? g : Boolean(null == l ? void 0 : l.optOut)
            }, [4, s.get(a)];
          case 7:
            return f.sessionId = null !== (y = null === (v = x.sent()) || void 0 === v ? void 0 : v.sessionId) && void 0 !== y ? y : null == n ? void 0 : n.sessionId, [4, uQ(n)];
          case 8:
            return [2, new (c.apply(Y9, p.concat([bt.apply(void 0, d.concat([(f.storageProvider = x.sent(), f.trackingOptions = bt(bt({}, i.trackingOptions), null == n ? void 0 : n.trackingOptions), f.transportProvider = null !== (_ = null == n ? void 0 : n.transportProvider) && void 0 !== _ ? _ : y4(null == n ? void 0 : n.transport), f)]))])))()];
        }
      });
    });
  }, "useBrowserConfig"),
  lQ = u(function (t, e) {
    return void 0 === e && (e = xb()), Et(void 0, void 0, void 0, function () {
      var n, i, r;
      return wt(this, function (o) {
        switch (o.label) {
          case 0:
            return n = bt(bt({}, e), t), i = null == t ? void 0 : t.cookieStorage, (r = !i) ? [3, 2] : [4, i.isEnabled()];
          case 1:
            r = !o.sent(), o.label = 2;
          case 2:
            return r ? [2, v4(n)] : [2, i];
        }
      });
    });
  }, "createCookieStorage"),
  v4 = u(function (t) {
    return Et(void 0, void 0, void 0, function () {
      var e, n;
      return wt(this, function (i) {
        switch (i.label) {
          case 0:
            return e = new Sf({
              domain: t.domain,
              expirationDays: t.cookieExpiration,
              sameSite: t.cookieSameSite,
              secure: t.cookieSecure
            }), (n = t.disableCookies) ? [3, 2] : [4, e.isEnabled()];
          case 1:
            n = !i.sent(), i.label = 2;
          case 2:
            return n ? [4, (e = new _0()).isEnabled()] : [3, 4];
          case 3:
            i.sent() || (e = new m0()), i.label = 4;
          case 4:
            return [2, e];
        }
      });
    });
  }, "createFlexibleStorage"),
  uQ = u(function (t) {
    return Et(void 0, void 0, void 0, function () {
      var e, n, i, r, o, s, a;
      return wt(this, function (l) {
        switch (l.label) {
          case 0:
            if (t && Object.prototype.hasOwnProperty.call(t, "storageProvider") && !t.storageProvider) return [3, 9];
            l.label = 1;
          case 1:
            l.trys.push([1, 7, 8, 9]), e = ya([null == t ? void 0 : t.storageProvider, new _0()]), n = e.next(), l.label = 2;
          case 2:
            return n.done ? [3, 6] : (i = n.value, (r = i) ? [4, i.isEnabled()] : [3, 4]);
          case 3:
            r = l.sent(), l.label = 4;
          case 4:
            if (r) return [2, i];
            l.label = 5;
          case 5:
            return n = e.next(), [3, 2];
          case 6:
            return [3, 9];
          case 7:
            return o = l.sent(), s = {
              error: o
            }, [3, 9];
          case 8:
            try {
              n && !n.done && (a = e.return) && a.call(e);
            } finally {
              if (s) throw s.error;
            }
            return [7];
          case 9:
            return [2, void 0];
        }
      });
    });
  }, "createEventsStorage"),
  cQ = u(function (t, e, n) {
    return e || n || t || ch();
  }, "createDeviceId"),
  y4 = u(function (t) {
    return t === Id.XHR ? new W9() : t === Id.SendBeacon ? new X9() : xb().transportProvider;
  }, "createTransport"),
  hQ = u(function (t) {
    return Et(void 0, void 0, void 0, function () {
      var e, n, i, r, o, s, a;
      return wt(this, function (l) {
        switch (l.label) {
          case 0:
            return [4, new Sf().isEnabled()];
          case 1:
            if (!l.sent() || !t && "undefined" == typeof location) return [2, ""];
            for (e = null != t ? t : location.hostname, n = e.split("."), i = [], r = "AMP_TLDTEST", o = n.length - 2; o >= 0; --o) i.push(n.slice(o).join("."));
            o = 0, l.label = 2;
          case 2:
            return o < i.length ? (s = i[o], [4, (a = new Sf({
              domain: "." + s
            })).set(r, 1)]) : [3, 7];
          case 3:
            return l.sent(), [4, a.get(r)];
          case 4:
            return l.sent() ? [4, a.remove(r)] : [3, 6];
          case 5:
            return l.sent(), [2, "." + s];
          case 6:
            return o++, [3, 2];
          case 7:
            return [2, ""];
        }
      });
    });
  }, "getTopLevelDomain");
E();
var J9 = u(function (t, e) {
    return Et(void 0, void 0, void 0, function () {
      var n, i, r, o, s, a, l, u, h;
      return wt(this, function (c) {
        switch (c.label) {
          case 0:
            return [4, (n = new Sf()).isEnabled()];
          case 1:
            return (!c.sent() || (null == e ? void 0 : e.disableCookies)) && (n = new _0()), [4, n.isEnabled()];
          case 2:
            return c.sent() ? (i = h4(t), [4, n.getRaw(i)]) : [2, {
              optOut: !1
            }];
          case 3:
            return (r = c.sent()) ? [4, n.remove(i)] : [2, {
              optOut: !1
            }];
          case 4:
            return c.sent(), o = Hr(r.split("."), 5), s = o[0], a = o[1], l = o[2], u = o[3], h = o[4], [2, {
              deviceId: s,
              userId: fQ(a),
              sessionId: K9(u),
              lastEventTime: K9(h),
              optOut: Boolean(l)
            }];
        }
      });
    });
  }, "parseOldCookies"),
  K9 = u(function (t) {
    var e = parseInt(t, 32);
    if (!isNaN(e)) return e;
  }, "parseTime"),
  fQ = u(function (t) {
    if (atob && escape && t) try {
      return decodeURIComponent(escape(atob(t)));
    } catch (t) {
      return;
    }
  }, "decode"),
  pQ = function (t) {
    function e() {
      return null !== t && t.apply(this, arguments) || this;
    }
    return Fl(e, t), u(e, "AmplitudeBrowser"), e.prototype.init = function (e, n, i) {
      var r, o, s;
      return void 0 === e && (e = ""), Et(this, void 0, void 0, function () {
        var a,
          l,
          u,
          h,
          c = this;
        return wt(this, function (p) {
          switch (p.label) {
            case 0:
              return this.initializing ? [2] : (this.initializing = !0, [4, J9(e, i)]);
            case 1:
              return a = p.sent(), [4, Z9(e, n || a.userId, bt(bt({}, i), {
                deviceId: null !== (r = a.deviceId) && void 0 !== r ? r : null == i ? void 0 : i.deviceId,
                sessionId: null !== (o = a.sessionId) && void 0 !== o ? o : null == i ? void 0 : i.sessionId,
                optOut: null !== (s = null == i ? void 0 : i.optOut) && void 0 !== s ? s : a.optOut,
                lastEventTime: a.lastEventTime
              }))];
            case 2:
              return l = p.sent(), [4, t.prototype._init.call(this, l)];
            case 3:
              return p.sent(), u = !this.config.lastEventTime, (!this.config.sessionId || this.config.lastEventTime && Date.now() - this.config.lastEventTime > this.config.sessionTimeout) && (this.setSessionId(Date.now()), u = !0), (h = y0()).eventBridge.setEventReceiver(function (t) {
                c.track(t.eventType, t.eventProperties);
              }), h.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              }), [4, this.add(new j9())];
            case 4:
              return p.sent(), [4, this.add(new m4())];
            case 5:
              return p.sent(), [4, this.add(new t4())];
            case 6:
              return p.sent(), this.initializing = !1, [4, this.runAttributionStrategy(l.attribution, u)];
            case 7:
              return p.sent(), [4, this.runQueuedFunctions("dispatchQ")];
            case 8:
              return p.sent(), [2];
          }
        });
      });
    }, e.prototype.runAttributionStrategy = function (t, e) {
      return void 0 === e && (e = !1), Et(this, void 0, void 0, function () {
        var n, i, r;
        return wt(this, function (o) {
          switch (o.label) {
            case 0:
              return n = this.track.bind(this), i = this.setSessionId.bind(this, Date.now()), [4, v4(this.config)];
            case 1:
              return r = o.sent(), [4, new f4(this.config.apiKey, bt(bt({}, t), {
                storage: r,
                track: n,
                onNewCampaign: i
              })).send(e)];
            case 2:
              return o.sent(), [2];
          }
        });
      });
    }, e.prototype.getUserId = function () {
      var t;
      return null === (t = this.config) || void 0 === t ? void 0 : t.userId;
    }, e.prototype.setUserId = function (t) {
      this.config ? this.config.userId = t : this.q.push(this.setUserId.bind(this, t));
    }, e.prototype.getDeviceId = function () {
      var t;
      return null === (t = this.config) || void 0 === t ? void 0 : t.deviceId;
    }, e.prototype.setDeviceId = function (t) {
      this.config ? this.config.deviceId = t : this.q.push(this.setDeviceId.bind(this, t));
    }, e.prototype.reset = function () {
      this.setUserId(void 0), this.setDeviceId(ch());
    }, e.prototype.getSessionId = function () {
      var t;
      return null === (t = this.config) || void 0 === t ? void 0 : t.sessionId;
    }, e.prototype.setSessionId = function (t) {
      this.config ? (this.config.sessionId = t, this.config.lastEventTime = void 0) : this.q.push(this.setSessionId.bind(this, t));
    }, e.prototype.setTransport = function (t) {
      this.config ? this.config.transportProvider = y4(t) : this.q.push(this.setTransport.bind(this, t));
    }, e.prototype.identify = function (e, n) {
      if (_b(e)) {
        var i = e._q;
        e._q = [], e = yb(new ll(), i);
      }
      return (null == n ? void 0 : n.user_id) && this.setUserId(n.user_id), (null == n ? void 0 : n.device_id) && this.setDeviceId(n.device_id), t.prototype.identify.call(this, e, n);
    }, e.prototype.groupIdentify = function (e, n, i, r) {
      if (_b(i)) {
        var o = i._q;
        i._q = [], i = yb(new ll(), o);
      }
      return t.prototype.groupIdentify.call(this, e, n, i, r);
    }, e.prototype.revenue = function (e, n) {
      if (_b(e)) {
        var i = e._q;
        e._q = [], e = yb(new hb(), i);
      }
      return t.prototype.revenue.call(this, e, n);
    }, e;
  }(QT),
  bb = u(function () {
    var t = new pQ();
    return {
      init: dr(_a(t.init.bind(t)), "init", fr(t), pr(t, ["config"])),
      add: dr(_a(t.add.bind(t)), "add", fr(t), pr(t, ["config.apiKey", "timeline.plugins"])),
      remove: dr(_a(t.remove.bind(t)), "remove", fr(t), pr(t, ["config.apiKey", "timeline.plugins"])),
      track: dr(_a(t.track.bind(t)), "track", fr(t), pr(t, ["config.apiKey", "timeline.queue.length"])),
      logEvent: dr(_a(t.logEvent.bind(t)), "logEvent", fr(t), pr(t, ["config.apiKey", "timeline.queue.length"])),
      identify: dr(_a(t.identify.bind(t)), "identify", fr(t), pr(t, ["config.apiKey", "timeline.queue.length"])),
      groupIdentify: dr(_a(t.groupIdentify.bind(t)), "groupIdentify", fr(t), pr(t, ["config.apiKey", "timeline.queue.length"])),
      setGroup: dr(_a(t.setGroup.bind(t)), "setGroup", fr(t), pr(t, ["config.apiKey", "timeline.queue.length"])),
      revenue: dr(_a(t.revenue.bind(t)), "revenue", fr(t), pr(t, ["config.apiKey", "timeline.queue.length"])),
      flush: dr(_a(t.flush.bind(t)), "flush", fr(t), pr(t, ["config.apiKey", "timeline.queue.length"])),
      getUserId: dr(t.getUserId.bind(t), "getUserId", fr(t), pr(t, ["config", "config.userId"])),
      setUserId: dr(t.setUserId.bind(t), "setUserId", fr(t), pr(t, ["config", "config.userId"])),
      getDeviceId: dr(t.getDeviceId.bind(t), "getDeviceId", fr(t), pr(t, ["config", "config.deviceId"])),
      setDeviceId: dr(t.setDeviceId.bind(t), "setDeviceId", fr(t), pr(t, ["config", "config.deviceId"])),
      reset: dr(t.reset.bind(t), "reset", fr(t), pr(t, ["config", "config.userId", "config.deviceId"])),
      getSessionId: dr(t.getSessionId.bind(t), "getSessionId", fr(t), pr(t, ["config"])),
      setSessionId: dr(t.setSessionId.bind(t), "setSessionId", fr(t), pr(t, ["config"])),
      setOptOut: dr(t.setOptOut.bind(t), "setOptOut", fr(t), pr(t, ["config"])),
      setTransport: dr(t.setTransport.bind(t), "setTransport", fr(t), pr(t, ["config"]))
    };
  }, "createInstance"),
  Cr = bb(),
  h_e = Cr.add,
  f_e = Cr.flush,
  p_e = Cr.getDeviceId,
  d_e = Cr.getSessionId,
  m_e = Cr.getUserId,
  g_e = Cr.groupIdentify,
  v_e = Cr.identify,
  y_e = Cr.init,
  __e = Cr.logEvent,
  x_e = Cr.remove,
  b_e = Cr.reset,
  M_e = Cr.revenue,
  E_e = Cr.setDeviceId,
  w_e = Cr.setGroup,
  S_e = Cr.setOptOut,
  T_e = Cr.setSessionId,
  P_e = Cr.setTransport,
  C_e = Cr.setUserId,
  A_e = Cr.track,
  _4 = {
    production: "40ead723d18886045e302513245edb27",
    development: ""
  },
  Od = {
    plan: {
      version: "22",
      branch: "main",
      source: "websdk",
      versionId: "197467d1-8926-452d-a088-b3817cbac89f"
    },
    ingestionMetadata: {
      sourceName: "browser-typescript-ampli",
      sourceVersion: "2.0.0"
    }
  },
  x0 = class {
    constructor(t) {
      this.event_properties = t, A(this, "event_type", "Analytics:categorySelected-call"), this.event_properties = t;
    }
  };
u(x0, "AnalyticsCategorySelectedCall");
var b0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Analytics:locationSelected-call"), this.event_properties = t;
  }
};
u(b0, "AnalyticsLocationSelectedCall");
var M0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "BlueDot:disable-call"), this.event_properties = t;
  }
};
u(M0, "BlueDotDisableCall");
var E0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "BlueDot:enable-call"), this.event_properties = t;
  }
};
u(E0, "BlueDotEnableCall");
var w0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "BlueDot:off-call"), this.event_properties = t;
  }
};
u(w0, "BlueDotOffCall");
var S0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "BlueDot:on-call"), this.event_properties = t;
  }
};
u(S0, "BlueDotOnCall");
var T0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:animate-call"), this.event_properties = t;
  }
};
u(T0, "CameraAnimateCall");
var P0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:cancelAnimation-call"), this.event_properties = t;
  }
};
u(P0, "CameraCancelAnimationCall");
var C0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:focusOn-call"), this.event_properties = t;
  }
};
u(C0, "CameraFocusOnCall");
var A0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:getSafeAreaInsets-call"), this.event_properties = t;
  }
};
u(A0, "CameraGetSafeAreaInsetsCall");
var I0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:interaction.disable-call"), this.event_properties = t;
  }
};
u(I0, "CameraInteractionDisableCall");
var L0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:interaction.enable-call"), this.event_properties = t;
  }
};
u(L0, "CameraInteractionEnableCall");
var O0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:set-call"), this.event_properties = t;
  }
};
u(O0, "CameraSetCall");
var R0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:setSafeAreaInsets-call"), this.event_properties = t;
  }
};
u(R0, "CameraSetSafeAreaInsetsCall");
var N0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Camera:translate-call"), this.event_properties = t;
  }
};
u(N0, "CameraTranslateCall");
var D0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FlatLabels:add-call"), this.event_properties = t;
  }
};
u(D0, "FlatLabelsAddCall");
var q0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FlatLabels:labelAllLocations-call"), this.event_properties = t;
  }
};
u(q0, "FlatLabelsLabelAllLocationsCall");
var k0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FlatLabels:remove-call"), this.event_properties = t;
  }
};
u(k0, "FlatLabelsRemoveCall");
var x4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FlatLabels:removeAll-call"), this.event_properties = t;
  }
};
u(x4, "FlatLabelsRemoveAllCall");
var F0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FlatLabels:setAppearance-call"), this.event_properties = t;
  }
};
u(F0, "FlatLabelsSetAppearanceCall");
var B0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FloatingLabels:add-call"), this.event_properties = t;
  }
};
u(B0, "FloatingLabelsAddCall");
var U0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FloatingLabels:labelAllLocations-call"), this.event_properties = t;
  }
};
u(U0, "FloatingLabelsLabelAllLocationsCall");
var z0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FloatingLabels:remove-call"), this.event_properties = t;
  }
};
u(z0, "FloatingLabelsRemoveCall");
var b4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FloatingLabels:removeAll-call"), this.event_properties = t;
  }
};
u(b4, "FloatingLabelsRemoveAllCall");
var V0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FloatingLabels:resetPriority-call"), this.event_properties = t;
  }
};
u(V0, "FloatingLabelsResetPriorityCall");
var G0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FloatingLabels:setAppearance-call"), this.event_properties = t;
  }
};
u(G0, "FloatingLabelsSetAppearanceCall");
var H0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "FloatingLabels:setPriority-call"), this.event_properties = t;
  }
};
u(H0, "FloatingLabelsSetPriorityCall");
var j0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "global:getVenue-call"), this.event_properties = t;
  }
};
u(j0, "GlobalGetVenueCall");
var W0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "global:getVenueMVF-call"), this.event_properties = t;
  }
};
u(W0, "GlobalGetVenueMvfCall");
var X0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "global:showVenue-call"), this.event_properties = t;
  }
};
u(X0, "GlobalShowVenueCall");
var Y0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Journey:clear-call"), this.event_properties = t;
  }
};
u(Y0, "JourneyClearCall");
var Z0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Journey:draw-call"), this.event_properties = t;
  }
};
u(Z0, "JourneyDrawCall");
var J0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Journey:setStep-call"), this.event_properties = t;
  }
};
u(J0, "JourneySetStepCall");
var M4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "Mappedin:getCollectionItemById-call"), this.event_properties = t;
  }
};
u(M4, "MappedinGetCollectionItemByIdCall");
var E4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinCoordinate:absoluteDistanceTo-call"), this.event_properties = t;
  }
};
u(E4, "MappedinCoordinateAbsoluteDistanceToCall");
var w4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinCoordinate:nearestNode-call"), this.event_properties = t;
  }
};
u(w4, "MappedinCoordinateNearestNodeCall");
var K0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinLocation:clone-call"), this.event_properties = t;
  }
};
u(K0, "MappedinLocationCloneCall");
var Q0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinLocation:directionsTo-call"), this.event_properties = t;
  }
};
u(Q0, "MappedinLocationDirectionsToCall");
var $0 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinLocation:distanceTo-call"), this.event_properties = t;
  }
};
u($0, "MappedinLocationDistanceToCall");
var S4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinMap:createCoordinate-call"), this.event_properties = t;
  }
};
u(S4, "MappedinMapCreateCoordinateCall");
var T4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinMap:createCoordinateByXY-call"), this.event_properties = t;
  }
};
u(T4, "MappedinMapCreateCoordinateByXyCall");
var P4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinMap:getNorth-call"), this.event_properties = t;
  }
};
u(P4, "MappedinMapGetNorthCall");
var e1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinNode:directionsTo-call"), this.event_properties = t;
  }
};
u(e1, "MappedinNodeDirectionsToCall");
var t1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinNode:distanceTo-call"), this.event_properties = t;
  }
};
u(t1, "MappedinNodeDistanceToCall");
var n1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinPolygon:directionsTo-call"), this.event_properties = t;
  }
};
u(n1, "MappedinPolygonDirectionsToCall");
var i1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinPolygon:distanceTo-call"), this.event_properties = t;
  }
};
u(i1, "MappedinPolygonDistanceToCall");
var r1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MappedinVenue:metadata-read"), this.event_properties = t;
  }
};
u(r1, "MappedinVenueMetadataRead");
var o1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:addInteractivePolygon-call"), this.event_properties = t;
  }
};
u(o1, "MapViewAddInteractivePolygonCall");
var s1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:addInteractivePolygonsForAllLocations-call"), this.event_properties = t;
  }
};
u(s1, "MapViewAddInteractivePolygonsForAllLocationsCall");
var a1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:clearPolygonColor-call"), this.event_properties = t;
  }
};
u(a1, "MapViewClearPolygonColorCall");
var l1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:createCustomTooltip-call"), this.event_properties = t;
  }
};
u(l1, "MapViewCreateCustomTooltipCall");
var C4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:createMarker-call"), this.event_properties = t;
  }
};
u(C4, "MapViewCreateMarkerCall");
var u1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:createTooltip-call"), this.event_properties = t;
  }
};
u(u1, "MapViewCreateTooltipCall");
var c1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:destroy-call"), this.event_properties = t;
  }
};
u(c1, "MapViewDestroyCall");
var h1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:disableImageFlippingForAllPolygons-call"), this.event_properties = t;
  }
};
u(h1, "MapViewDisableImageFlippingForAllPolygonsCall");
var f1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:drawPath-call"), this.event_properties = t;
  }
};
u(f1, "MapViewDrawPathCall");
var p1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:enableImageFlippingForAllLocations-call"), this.event_properties = t;
  }
};
u(p1, "MapViewEnableImageFlippingForAllLocationsCall");
var d1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:enableImageFlippingForPolygon-call"), this.event_properties = t;
  }
};
u(d1, "MapViewEnableImageFlippingForPolygonCall");
var m1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:getNearestNodeByScreenCoordinates-call"), this.event_properties = t;
  }
};
u(m1, "MapViewGetNearestNodeByScreenCoordinatesCall");
var g1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:getPolygonAtCoordinate-call"), this.event_properties = t;
  }
};
u(g1, "MapViewGetPolygonAtCoordinateCall");
var v1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:getPrimaryLocationForPolygon-call"), this.event_properties = t;
  }
};
u(v1, "MapViewGetPrimaryLocationForPolygonCall");
var y1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:labelAllLocations-call"), this.event_properties = t;
  }
};
u(y1, "MapViewLabelAllLocationsCall");
var _1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:removeAllInteractivePolygons-call"), this.event_properties = t;
  }
};
u(_1, "MapViewRemoveAllInteractivePolygonsCall");
var x1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:removeAllMarkers-call"), this.event_properties = t;
  }
};
u(x1, "MapViewRemoveAllMarkersCall");
var b1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:removeAllPaths-call"), this.event_properties = t;
  }
};
u(b1, "MapViewRemoveAllPathsCall");
var M1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:removeAllTooltips-call"), this.event_properties = t;
  }
};
u(M1, "MapViewRemoveAllTooltipsCall");
var E1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:removeInteractivePolygon-call"), this.event_properties = t;
  }
};
u(E1, "MapViewRemoveInteractivePolygonCall");
var A4 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:removeMarker-call"), this.event_properties = t;
  }
};
u(A4, "MapViewRemoveMarkerCall");
var w1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:removePath-call"), this.event_properties = t;
  }
};
u(w1, "MapViewRemovePathCall");
var S1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:removeTooltip-call"), this.event_properties = t;
  }
};
u(S1, "MapViewRemoveTooltipCall");
var T1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:setBackgroundColor-call"), this.event_properties = t;
  }
};
u(T1, "MapViewSetBackgroundColorCall");
var P1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:setHoverColor-call"), this.event_properties = t;
  }
};
u(P1, "MapViewSetHoverColorCall");
var C1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:setMap-call"), this.event_properties = t;
  }
};
u(C1, "MapViewSetMapCall");
var A1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:setPolygonColor-call"), this.event_properties = t;
  }
};
u(A1, "MapViewSetPolygonColorCall");
var I1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "MapView:setState-call"), this.event_properties = t;
  }
};
u(I1, "MapViewSetStateCall");
var L1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "metrics:mapLoad-event"), this.event_properties = t;
  }
};
u(L1, "MetricsMapLoadEvent");
var O1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "OfflineSearch:addQuery-call"), this.event_properties = t;
  }
};
u(O1, "OfflineSearchAddQueryCall");
var R1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "OfflineSearch:constructor-call"), this.event_properties = t;
  }
};
u(R1, "OfflineSearchConstructorCall");
var N1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "OfflineSearch:search-call"), this.event_properties = t;
  }
};
u(N1, "OfflineSearchSearchCall");
var D1 = class {
  constructor(t) {
    this.event_properties = t, A(this, "event_type", "OfflineSearch:suggest-call"), this.event_properties = t;
  }
};
u(D1, "OfflineSearchSuggestCall");
var Mb = u(() => ({
    promise: Promise.resolve()
  }), "getVoidPromiseResult"),
  I4 = class {
    constructor() {
      A(this, "disabled", !1), A(this, "amplitude");
    }
    get client() {
      return this.isInitializedAndEnabled(), this.amplitude;
    }
    get isLoaded() {
      return null != this.amplitude;
    }
    isInitializedAndEnabled() {
      return this.amplitude ? !this.disabled : (console.error("ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?"), !1);
    }
    load(t) {
      var e, n;
      if (this.disabled = null != (e = t.disabled) && e, this.amplitude) return console.warn("WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup."), Mb();
      let i = null;
      if (t.client && "apiKey" in t.client ? i = t.client.apiKey : "environment" in t && (i = _4[t.environment]), t.client && "instance" in t.client) this.amplitude = t.client.instance;else {
        if (i) return this.amplitude = bb(), this.amplitude.init(i, void 0, {
          ...Od,
          ...(null == (n = t.client) ? void 0 : n.configuration)
        });
        console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
      }
      return Mb();
    }
    identify(t, e, n) {
      if (!this.isInitializedAndEnabled()) return Mb();
      t && (n = {
        ...n,
        user_id: t
      });
      let i = new ll(),
        r = e;
      if (null != r) for (let [t, e] of Object.entries(r)) i.set(t, e);
      return this.amplitude.identify(i, n);
    }
    track(t, e) {
      return this.isInitializedAndEnabled() ? this.amplitude.track(t, void 0, e) : Mb();
    }
    analyticsCategorySelectedCall(t, e) {
      return this.track(new x0(t), e);
    }
    analyticsLocationSelectedCall(t, e) {
      return this.track(new b0(t), e);
    }
    blueDotDisableCall(t, e) {
      return this.track(new M0(t), e);
    }
    blueDotEnableCall(t, e) {
      return this.track(new E0(t), e);
    }
    blueDotOffCall(t, e) {
      return this.track(new w0(t), e);
    }
    blueDotOnCall(t, e) {
      return this.track(new S0(t), e);
    }
    cameraAnimateCall(t, e) {
      return this.track(new T0(t), e);
    }
    cameraCancelAnimationCall(t, e) {
      return this.track(new P0(t), e);
    }
    cameraFocusOnCall(t, e) {
      return this.track(new C0(t), e);
    }
    cameraGetSafeAreaInsetsCall(t, e) {
      return this.track(new A0(t), e);
    }
    cameraInteractionDisableCall(t, e) {
      return this.track(new I0(t), e);
    }
    cameraInteractionEnableCall(t, e) {
      return this.track(new L0(t), e);
    }
    cameraSetCall(t, e) {
      return this.track(new O0(t), e);
    }
    cameraSetSafeAreaInsetsCall(t, e) {
      return this.track(new R0(t), e);
    }
    cameraTranslateCall(t, e) {
      return this.track(new N0(t), e);
    }
    flatLabelsAddCall(t, e) {
      return this.track(new D0(t), e);
    }
    flatLabelsLabelAllLocationsCall(t, e) {
      return this.track(new q0(t), e);
    }
    flatLabelsRemoveCall(t, e) {
      return this.track(new k0(t), e);
    }
    flatLabelsRemoveAllCall(t, e) {
      return this.track(new x4(t), e);
    }
    flatLabelsSetAppearanceCall(t, e) {
      return this.track(new F0(t), e);
    }
    floatingLabelsAddCall(t, e) {
      return this.track(new B0(t), e);
    }
    floatingLabelsLabelAllLocationsCall(t, e) {
      return this.track(new U0(t), e);
    }
    floatingLabelsRemoveCall(t, e) {
      return this.track(new z0(t), e);
    }
    floatingLabelsRemoveAllCall(t, e) {
      return this.track(new b4(t), e);
    }
    floatingLabelsResetPriorityCall(t, e) {
      return this.track(new V0(t), e);
    }
    floatingLabelsSetAppearanceCall(t, e) {
      return this.track(new G0(t), e);
    }
    floatingLabelsSetPriorityCall(t, e) {
      return this.track(new H0(t), e);
    }
    globalGetVenueCall(t, e) {
      return this.track(new j0(t), e);
    }
    globalGetVenueMvfCall(t, e) {
      return this.track(new W0(t), e);
    }
    globalShowVenueCall(t, e) {
      return this.track(new X0(t), e);
    }
    journeyClearCall(t, e) {
      return this.track(new Y0(t), e);
    }
    journeyDrawCall(t, e) {
      return this.track(new Z0(t), e);
    }
    journeySetStepCall(t, e) {
      return this.track(new J0(t), e);
    }
    mappedinGetCollectionItemByIdCall(t, e) {
      return this.track(new M4(t), e);
    }
    mappedinCoordinateAbsoluteDistanceToCall(t, e) {
      return this.track(new E4(t), e);
    }
    mappedinCoordinateNearestNodeCall(t, e) {
      return this.track(new w4(t), e);
    }
    mappedinLocationCloneCall(t, e) {
      return this.track(new K0(t), e);
    }
    mappedinLocationDirectionsToCall(t, e) {
      return this.track(new Q0(t), e);
    }
    mappedinLocationDistanceToCall(t, e) {
      return this.track(new $0(t), e);
    }
    mappedinMapCreateCoordinateCall(t, e) {
      return this.track(new S4(t), e);
    }
    mappedinMapCreateCoordinateByXyCall(t, e) {
      return this.track(new T4(t), e);
    }
    mappedinMapGetNorthCall(t, e) {
      return this.track(new P4(t), e);
    }
    mappedinNodeDirectionsToCall(t, e) {
      return this.track(new e1(t), e);
    }
    mappedinNodeDistanceToCall(t, e) {
      return this.track(new t1(t), e);
    }
    mappedinPolygonDirectionsToCall(t, e) {
      return this.track(new n1(t), e);
    }
    mappedinPolygonDistanceToCall(t, e) {
      return this.track(new i1(t), e);
    }
    mappedinVenueMetadataRead(t, e) {
      return this.track(new r1(t), e);
    }
    mapViewAddInteractivePolygonCall(t, e) {
      return this.track(new o1(t), e);
    }
    mapViewAddInteractivePolygonsForAllLocationsCall(t, e) {
      return this.track(new s1(t), e);
    }
    mapViewClearPolygonColorCall(t, e) {
      return this.track(new a1(t), e);
    }
    mapViewCreateCustomTooltipCall(t, e) {
      return this.track(new l1(t), e);
    }
    mapViewCreateMarkerCall(t, e) {
      return this.track(new C4(t), e);
    }
    mapViewCreateTooltipCall(t, e) {
      return this.track(new u1(t), e);
    }
    mapViewDestroyCall(t, e) {
      return this.track(new c1(t), e);
    }
    mapViewDisableImageFlippingForAllPolygonsCall(t, e) {
      return this.track(new h1(t), e);
    }
    mapViewDrawPathCall(t, e) {
      return this.track(new f1(t), e);
    }
    mapViewEnableImageFlippingForAllLocationsCall(t, e) {
      return this.track(new p1(t), e);
    }
    mapViewEnableImageFlippingForPolygonCall(t, e) {
      return this.track(new d1(t), e);
    }
    mapViewGetNearestNodeByScreenCoordinatesCall(t, e) {
      return this.track(new m1(t), e);
    }
    mapViewGetPolygonAtCoordinateCall(t, e) {
      return this.track(new g1(t), e);
    }
    mapViewGetPrimaryLocationForPolygonCall(t, e) {
      return this.track(new v1(t), e);
    }
    mapViewLabelAllLocationsCall(t, e) {
      return this.track(new y1(t), e);
    }
    mapViewRemoveAllInteractivePolygonsCall(t, e) {
      return this.track(new _1(t), e);
    }
    mapViewRemoveAllMarkersCall(t, e) {
      return this.track(new x1(t), e);
    }
    mapViewRemoveAllPathsCall(t, e) {
      return this.track(new b1(t), e);
    }
    mapViewRemoveAllTooltipsCall(t, e) {
      return this.track(new M1(t), e);
    }
    mapViewRemoveInteractivePolygonCall(t, e) {
      return this.track(new E1(t), e);
    }
    mapViewRemoveMarkerCall(t, e) {
      return this.track(new A4(t), e);
    }
    mapViewRemovePathCall(t, e) {
      return this.track(new w1(t), e);
    }
    mapViewRemoveTooltipCall(t, e) {
      return this.track(new S1(t), e);
    }
    mapViewSetBackgroundColorCall(t, e) {
      return this.track(new T1(t), e);
    }
    mapViewSetHoverColorCall(t, e) {
      return this.track(new P1(t), e);
    }
    mapViewSetMapCall(t, e) {
      return this.track(new C1(t), e);
    }
    mapViewSetPolygonColorCall(t, e) {
      return this.track(new A1(t), e);
    }
    mapViewSetStateCall(t, e) {
      return this.track(new I1(t), e);
    }
    metricsMapLoadEvent(t, e) {
      return this.track(new L1(t), e);
    }
    offlineSearchAddQueryCall(t, e) {
      return this.track(new O1(t), e);
    }
    offlineSearchConstructorCall(t, e) {
      return this.track(new R1(t), e);
    }
    offlineSearchSearchCall(t, e) {
      return this.track(new N1(t), e);
    }
    offlineSearchSuggestCall(t, e) {
      return this.track(new D1(t), e);
    }
  };
u(I4, "Ampli");
var q1 = new I4();
E();
var $u,
  Rf,
  ul,
  Bd,
  Ul,
  Gb,
  Ute,
  Hb,
  zte,
  Z1,
  fR,
  J1,
  pR,
  cl,
  uR = Rt(OO()),
  cR = Rt(Q4()),
  hR = Rt(aR()),
  lR = "5.16.0",
  kte = "https://api2.amplitude.com/2/httpapi",
  Fte = "https://api2.amplitude.com/batch",
  Bte = "__unspecified__",
  $4 = {
    branch: "main",
    version: "0",
    source: "websdk"
  },
  xa = class {
    constructor() {
      re(this, Gb), re(this, Hb), re(this, Z1), re(this, J1), re(this, ul, {}), re(this, Bd, !1), re(this, Ul, void 0), re(this, cl, u(async t => {
        Gte(t.type) && (window.removeEventListener("visibilitychange", w(this, cl)), window.removeEventListener("pagehide", w(this, cl)), window.removeEventListener("beforeunload", w(this, cl)), window.removeEventListener("unload", w(this, cl)), await this.sendAllPendingEvents());
      }, "#handlePageUnload")), null == w(xa, Rf) && he(xa, Rf, lR), null != navigator.userAgent && he(this, Ul, new hR.UAParser(navigator.userAgent).getResult());
    }
    static setContext(t) {
      he(xa, $u, t);
    }
    static setVersion(t) {
      he(xa, Rf, t);
    }
    addPendingEvent(t) {
      var e;
      if (null == w(xa, $u)) return;
      let n = t.event_type;
      if (!mt(this, Hb, zte).call(this, t)) return;
      null == t.event_properties && (t.event_properties = {});
      let i = w(this, ul)[n];
      (0, cR.default)(t.event_properties, null != (e = null == i ? void 0 : i.event_properties) ? e : {}), w(this, ul)[n] = t;
    }
    async sendAllPendingEvents() {
      if (null == w(xa, $u) || Object.keys(w(this, ul)).length < 1) return;
      if (w(this, Bd)) return void ke.warn("The current batch of analytics is already sending. Wait until this finishes before trying to send again.");
      let t = [];
      for (let e in w(this, ul)) {
        let n = w(this, ul)[e],
          i = mt(this, Z1, fR).call(this, n);
        null != i && t.push(i);
      }
      if (!(t.length < 1)) try {
        he(this, Bd, !0), 200 === (await mt(this, J1, pR).call(this, Fte, t)).status && he(this, ul, {});
      } catch (t) {
        ke.warn("Error sending batch product analytics!", t);
      } finally {
        he(this, Bd, !1);
      }
    }
    async load() {
      if (!q1.isLoaded) {
        let {
          promise: t
        } = q1.load({
          environment: "production",
          client: {
            configuration: {
              trackingOptions: {
                osName: !0
              }
            }
          }
        });
        t.then(() => {
          window.addEventListener("pagehide", w(this, cl)), window.addEventListener("beforeunload", w(this, cl)), window.addEventListener("unload", w(this, cl)), window.addEventListener("visibilitychange", w(this, cl));
        });
      }
    }
    async sendEventNow(t) {
      if (null == w(xa, $u)) return;
      let e = mt(this, Z1, fR).call(this, t);
      if (null != e) try {
        await mt(this, J1, pR).call(this, kte, [e]);
      } catch (t) {
        ke.warn("Error sending single product analytics event!", t);
      }
    }
  },
  Y1 = xa;
u(Y1, "ProductAnalytics"), $u = new WeakMap(), Rf = new WeakMap(), ul = new WeakMap(), Bd = new WeakMap(), Ul = new WeakMap(), Gb = new WeakSet(), Ute = u(function (t) {
  let e = t.event_type;
  return null != w(this, ul)[e];
}, "#isEventTypePending"), Hb = new WeakSet(), zte = u(function (t) {
  if (!mt(this, Gb, Ute).call(this, t)) return !0;
  let e = t.event_type,
    n = w(this, ul)[e];
  return !(0, uR.default)(n.event_properties, t.event_properties);
}, "#didEventPropertiesChange"), Z1 = new WeakSet(), fR = u(function (t) {
  var e, n, i, r, o, s, a, l, u, h, c, p, d, f, m, g, v;
  if (null != w(xa, $u)) return null == (null == (e = t.event_properties) ? void 0 : e.venue) && ke.warn("Error processing product analytics event! Unspecified venue slug", t), null == Od.plan && ke.warn("Error processing product analytics event! Unknown coinfiguration plan", t), {
    event_type: t.event_type,
    session_id: null != (n = q1.client.getSessionId()) ? n : e2(),
    device_id: null != (i = q1.client.getDeviceId()) ? i : $x(),
    plan: {
      branch: null != (o = null == (r = Od.plan) ? void 0 : r.branch) ? o : $4.branch,
      version: null != (a = null == (s = Od.plan) ? void 0 : s.version) ? a : $4.version,
      source: null != (u = null == (l = Od.plan) ? void 0 : l.source) ? u : $4.source
    },
    os_name: null == (h = w(this, Ul)) ? void 0 : h.browser.name,
    os_version: null == (c = w(this, Ul)) ? void 0 : c.browser.version,
    device_manufacturer: null == (p = w(this, Ul)) ? void 0 : p.device.vendor,
    device_model: null == (d = w(this, Ul)) ? void 0 : d.device.model,
    event_properties: {
      ...t.event_properties,
      context: w(xa, $u),
      sdk_version: w(xa, Rf),
      browser_name: null == (f = w(this, Ul)) ? void 0 : f.browser.name,
      browser_version: null == (m = w(this, Ul)) ? void 0 : m.browser.version,
      venue: null != (v = null == (g = t.event_properties) ? void 0 : g.venue) ? v : Bte
    },
    time: t.time
  };
}, "#makeBatchFormattedEvent"), J1 = new WeakSet(), pR = u(async function (t, e) {
  return await Xs()(t, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*"
    },
    body: JSON.stringify({
      api_key: _4.production,
      events: e
    })
  });
}, "#batchSend"), cl = new WeakMap(), re(Y1, $u, void 0), re(Y1, Rf, void 0);
var Vte = new Y1(),
  at = Vte;
function Gte(t) {
  return "beforeunload" === t || "pagehide" === t || "unload" === t || "hidden" === document.visibilityState;
}
u(Gte, "areWeLeavingThePage");
var Hte = 0,
  jte = "9999-12-31T00:00:00.000Z";
function Wte(t, e, n = new Date()) {
  if (!t.states) return;
  let i = n || new Date(),
    r = t.states.find(t => {
      let e = new Date(t.start || Hte),
        n = new Date(t.end || jte);
      return e < i && n > i;
    });
  return r ? e.find(t => t.value === r.type) : void 0;
}
u(Wte, "getCurrentLocationState");
var Ys,
  dh,
  Zs,
  K1,
  Q1,
  $1,
  ev = class extends kl {
    constructor(t, e) {
      super(t), re(this, Ys, void 0), re(this, dh, void 0), re(this, Zs, {}), A(this, "states"), A(this, "id", ""), A(this, "name", ""), A(this, "type", ""), A(this, "description"), A(this, "sortOrder"), A(this, "logo"), A(this, "phone"), A(this, "social"), A(this, "color"), A(this, "shortName"), A(this, "detailsUrl"), A(this, "tags"), A(this, "externalId"), A(this, "showLabelWhenImagePresent"), A(this, "showSmartLabelWhenImagePresent"), A(this, "picture"), A(this, "operationHours"), A(this, "siblingGroups"), A(this, "gallery"), A(this, "amenity"), re(this, K1, void 0), re(this, Q1, []), re(this, $1, void 0), he(this, Ys, t), he(this, dh, e);
      let n = Object.assign({}, e);
      delete n.categories, Object.assign(this, n);
    }
    get polygons() {
      let t = w(this, Zs).polygons;
      if (void 0 !== t) return t;
      let e = [],
        n = w(this, K1),
        i = w(this, Ys)._polygonsById;
      if (Array.isArray(n)) for (let t = 0, r = n.length; t < r; ++t) {
        let r = i[n[t].id];
        null != r && e.push(r);
      }
      return w(this, Zs).polygons = e, e;
    }
    set polygons(t) {
      he(this, K1, t);
    }
    get nodes() {
      let t = w(this, Zs).nodes;
      if (void 0 !== t) return t;
      let e = [],
        n = w(this, Q1),
        i = w(this, Ys)._nodesById;
      if (n) for (let t = 0, r = n.length; t < r; ++t) {
        let r = i[n[t].node];
        null != r && e.push(r);
      }
      return w(this, Zs).nodes = e, e;
    }
    set nodes(t) {
      he(this, Q1, t);
    }
    get parent() {
      let t = w(this, Zs).parent;
      if (void 0 !== t) return t;
      let e,
        n = w(this, Ys)._locationsById,
        i = w(this, $1);
      return void 0 !== i && (e = n[i]), w(this, Zs).parent = e, e;
    }
    set parent(t) {
      he(this, $1, t);
    }
    get categories() {
      let t = w(this, Zs).categories;
      if (void 0 !== t) return t;
      let e = [];
      return w(this, dh).categories.forEach(t => {
        let n = w(this, Ys).getCollectionItemById(ii.CATEGORY, t);
        n && e.push(n);
      }), w(this, Zs).categories = e, e;
    }
    get state() {
      return Wte(this, w(this, Ys).locationStates);
    }
    clone() {
      let t = w(this, Ys).venue.slug;
      return at.addPendingEvent(new K0({
        venue: t
      })), new ev(w(this, Ys), w(this, dh));
    }
    get nodeOperationHours() {
      let t = w(this, Zs).nodeOperationHours;
      if (void 0 !== t) return t;
      if (null == this.nodes) return {};
      let e = w(this, dh).nodes.reduce((t, e) => (null != e.operationHours && (t[e.node] = e.operationHours), t), {});
      return w(this, Zs).nodeOperationHours = e, e;
    }
    static hydrate(t, e) {
      return t.map(t => new ev(e, t));
    }
    static async fetch(t) {
      let e = t.options.things.locations.slice();
      t.options.things.categories && or(e, "categories"), t.options.things.nodes && or(e, "nodes"), t.options.things.polygons && or(e, "polygons"), t.options.things.locationStates && or(e, "states");
      let n = {
        fields: e,
        venue: t.options.venue
      };
      try {
        let e = await rr(t.options, "location", n);
        return t.options.includeHidden || (e = e.filter(t => !t.hidden)), e.map(e => new ev(t, e));
      } catch (t) {
        return ke.error("Fetch Locations:", t), [];
      }
    }
    directionsTo(t, e) {
      let n = t instanceof va,
        i = w(this, Ys).venue.slug,
        r = new Q0({
          with_destination_set: n || void 0,
          venue: i
        });
      return at.addPendingEvent(r), super.directionsTo(t, e);
    }
    distanceTo(t, e) {
      let n = w(this, Ys).venue.slug;
      return at.addPendingEvent(new $0({
        venue: n
      })), super.distanceTo(t, e);
    }
    toJSON() {
      let t = w(this, dh);
      return delete t.color, t;
    }
  },
  zl = ev;
u(zl, "MappedinLocation"), Ys = new WeakMap(), dh = new WeakMap(), Zs = new WeakMap(), K1 = new WeakMap(), Q1 = new WeakMap(), $1 = new WeakMap(), E();
var Vl,
  Ud,
  ba,
  tv,
  jb = class extends kl {
    constructor(t, e) {
      super(t), re(this, Vl, void 0), re(this, Ud, void 0), re(this, ba, {}), A(this, "geometry"), A(this, "perspectives"), A(this, "image"), A(this, "holes"), A(this, "textures"), A(this, "material"), A(this, "label"), A(this, "id", ""), A(this, "layer"), A(this, "layerId"), A(this, "name"), A(this, "externalId"), A(this, "vertexes"), A(this, "canvasBounds"), re(this, tv, void 0), he(this, Vl, t), he(this, Ud, e);
      let n = Object.assign({}, e);
      delete n.map, Object.assign(this, n);
    }
    get map() {
      let t = w(this, ba).map;
      if (void 0 !== t) return t;
      let e = w(this, Vl).getCollectionItemById(ii.MAP, w(this, Ud).map);
      return w(this, ba).map = e, e;
    }
    get locations() {
      var t, e;
      let n = w(this, ba).locations;
      if (void 0 !== n) return n;
      let i = [],
        r = null != (e = null == (t = Ws.instances.get(w(this, Vl))) ? void 0 : t.locationsByMapId.get(this.map.id)) ? e : [],
        {
          id: o
        } = this;
      for (let t = 0, e = r.length; t < e; ++t) {
        let e = r[t],
          n = e.polygons;
        if (Array.isArray(n)) for (let t = 0, r = n.length; t < r; ++t) if (n[t].id === o) {
          i.push(e);
          break;
        }
      }
      return w(this, ba).locations = i, i;
    }
    get entrances() {
      let t = w(this, ba).entrances;
      if (void 0 !== t) return t;
      let e = [],
        n = w(this, tv),
        i = w(this, Vl)._nodesById;
      if (Array.isArray(n)) {
        for (let t = 0, r = n.length; t < r; ++t) {
          let r = i[n[t].id];
          null != r && e.push(r);
        }
        return w(this, ba).entrances = e, e;
      }
      return [];
    }
    set entrances(t) {
      he(this, tv, t);
    }
    get rank() {
      let t = w(this, ba).rank;
      if (void 0 !== t) return t;
      let {
        rankings: e
      } = w(this, Vl);
      if (!e || !e.polygons) return null;
      let n = e.polygons.find(t => t.polygonId === this.id);
      return n ? (w(this, ba).rank = {
        score: n.score,
        node: n.entranceNodeId
      }, {
        score: n.score,
        node: n.entranceNodeId
      }) : (w(this, ba).rank = null, null);
    }
    static hydrate(t, e) {
      return t.map(t => new jb(e, t));
    }
    static async fetch(t) {
      let e = t.options.things.polygons.slice();
      t.options.things.maps && or(e, "map"), t.options.things.nodes && or(e, "entrances");
      let n = {
        fields: e,
        venue: t.options.venue
      };
      try {
        return (await rr(t.options, "polygon", n)).map(e => new jb(t, e));
      } catch (t) {
        return ke.error("Fetch Polygons:", t), [];
      }
    }
    directionsTo(t, e) {
      let n = t instanceof va,
        i = w(this, Vl).venue.slug,
        r = new n1({
          with_destination_set: n || void 0,
          venue: i
        });
      return at.addPendingEvent(r), super.directionsTo(t, e);
    }
    distanceTo(t, e) {
      let n = w(this, Vl).venue.slug;
      return at.addPendingEvent(new i1({
        venue: n
      })), super.distanceTo(t, e);
    }
    toJSON() {
      return w(this, Ud);
    }
  },
  ec = jb;
function dR(t) {
  return /^[\da-f]{24}$/i.test(t);
}
function mR(t, e = !1) {
  let n = "";
  if (null != t) {
    let i = "?",
      r = e ? Object.keys(t).filter(t => !["slug", "venue"].includes(t)) : Object.keys(t);
    for (let e = 0, o = r.length; e < o; ++e) {
      let o = r[e],
        s = t[o];
      null != s && (n += `${i + encodeURIComponent(o)}=${encodeURIComponent(s)}`, i = "&");
    }
  }
  return n;
}
function Xte(t, e, n, i = !1) {
  var r, o;
  return i ? `${t.supplementaryUrl}${e}?venue=${n.venue || n.slug}` : (null == (r = t.baseUrl) ? void 0 : r.includes("gateway")) ? `${t.baseUrl}${e}/${n.venue || n.slug}${mR(n, null == (o = t.baseUrl) ? void 0 : o.includes("gateway"))}` : t.baseUrl + e + mR(n);
}
async function rr(t, e, n, i = !1) {
  return nv(t, e, n, i, !0);
}
async function nv(t, e, n, i = !1, r = !1) {
  let o = Xte(t, e, n, i),
    s = await Wb(t, o, i);
  if (!r && Array.isArray(s)) {
    if (1 === s.length) return s[0];
    throw new Error("Invalid response object");
  }
  return s;
}
async function Wb(t, e, n = !1) {
  let i = {
    language: t.language,
    clientId: t.clientId,
    clientSecret: t.clientSecret
  };
  n && delete i.language, i.language && (e += `&lang=${encodeURIComponent(i.language)}`);
  let {
    headers: r
  } = t;
  r["Content-Type"] = r["Content-Type"] || "text/json", t.authorization && (r.Authorization = t.authorization), i.language && (r["Accept-Language"] = i.language);
  let o = {
    method: "GET",
    headers: r
  };
  t.secure && (e += "&withcdntoken");
  let s = await Xs()(e, o);
  if (!s.ok) throw new Error(`${s.status} ${s.statusText}`);
  return s.json();
}
function or(t, e) {
  t.indexOf(e) < 0 && t.push(e);
}
function gR([t, e], [n, i]) {
  let r = new _t(t, e),
    o = new _t(n, i);
  return r.distanceTo(o);
}
function vR(t) {
  if (t.scale || t.x_scale) return 1 / (t.scale || t.x_scale);
  let e;
  try {
    let n = t.georeference[0],
      i = t.georeference[2],
      r = new _t(n.target.x, n.target.y),
      o = new _t(i.target.x, i.target.y),
      s = r.distanceTo(o),
      a = n.control.x - i.control.x,
      l = n.control.y - i.control.y;
    e = Math.sqrt(a * a + l * l) / s;
  } catch (n) {
    e = 1, ke.warn(n), ke.warn(`Couldn't georeference ${t.name || t.shortName || t.id}. Probably not enough geocoordinates.`);
  }
  return e;
}
function h0(t) {
  var e;
  return t instanceof ec ? t.entrances.map(t => t.id) : t instanceof zl ? (null == (e = t.nodes) ? void 0 : e.map(t => t.id)) || [] : [t.id];
}
async function yR(t) {
  let e = {},
    {
      maps: n,
      images: i,
      scenes: r,
      polygons: o
    } = t;
  if (null != i) try {
    let t = Object.keys(i).map(t => fetch(`data:image/png;base64,${i[t]}`).then(t => t.blob()).then(n => {
      e[t] = n;
    }).catch(t => {
      ke.error(t);
    }));
    await Promise.all(t);
  } catch (t) {
    ke.error(t);
  }
  return n.forEach(t => {
    var n;
    !(null == (n = t.scene) ? void 0 : n.polygons) && !r[t.id] || (null != r && r[t.id] && (t.scene || (t.scene = {}), Object.defineProperty(t.scene, "polygons", {
      get: () => r[t.id]
    })), null != i && (t.scene.images = t.scene.images.map(({
      filename: t
    }) => ({
      filename: t,
      url: e[t]
    })), t.scene.polygons.forEach(t => {
      var n, i;
      if ((null == (n = null == t ? void 0 : t.image) ? void 0 : n.url) && (null == (i = null == t ? void 0 : t.image) ? void 0 : i.url)) {
        let n = t.image.url.split("/"),
          i = e[n[n.length - 1]];
        i && (t.image.url = i);
      }
    })));
  }), null != i && o.forEach(t => {
    var n;
    if (null == (n = null == t ? void 0 : t.image) ? void 0 : n.url) {
      let n = t.image.url.split("/"),
        i = e[n[n.length - 1]];
      i && (t.image.url = i);
    }
  }), null != t.images && delete t.images, null != t.scenes && delete t.scenes, t;
}
function Xb(t, e, n) {
  let i;
  return function (...r) {
    let o = this,
      s = u(function () {
        i = null, n || t.apply(o, r);
      }, "later"),
      a = n && !i;
    clearTimeout(i), i = setTimeout(s, e), a && t.apply(o, r);
  };
}
u(ec, "MappedinPolygon"), Vl = new WeakMap(), Ud = new WeakMap(), ba = new WeakMap(), tv = new WeakMap(), u(dR, "isGatewayKey"), u(mR, "stringifyQuery"), u(Xte, "buildUrl"), u(rr, "getArray"), u(nv, "getObject"), u(Wb, "generateAPIRequest"), u(or, "addToSet"), u(gR, "getDistanceBetweenLatLon"), u(vR, "getMapScale"), u(h0, "getNodesForNavigatable"), u(yR, "populateBundledImagesAsBlobs"), u(Xb, "debounce");
var iv,
  rv,
  ov,
  Yb = class {
    constructor(t, e) {
      re(this, iv, void 0), re(this, rv, {}), re(this, ov, void 0), A(this, "name"), A(this, "externalId"), A(this, "parents"), A(this, "id"), A(this, "icon"), A(this, "iconFromDefaultList"), this.id = e.id, he(this, ov, e), he(this, iv, t), Object.assign(this, e);
    }
    get locations() {
      var t;
      let e = w(this, rv).locations;
      if (void 0 !== e) return e;
      let n = [],
        {
          locations: i
        } = w(this, iv),
        {
          id: r
        } = this;
      for (let e = 0, o = i.length; e < o; ++e) {
        let o = i[e],
          s = o.categories;
        if (Array.isArray(s)) for (let e = 0, i = s.length; e < i; ++e) if ((null == (t = s[e]) ? void 0 : t.id) === r) {
          n.push(o);
          break;
        }
      }
      return w(this, rv).locations = n, n;
    }
    static hydrate(t, e) {
      return t.map(t => new Yb(e, t));
    }
    static async fetch(t) {
      let e = {
        fields: t.options.things.categories,
        venue: t.options.venue
      };
      try {
        return (await rr(t.options, "category", e)).map(e => new Yb(t, e));
      } catch (t) {
        return ke.error("Fetch Categories:", t), [];
      }
    }
    toJSON() {
      return w(this, ov);
    }
  },
  mh = Yb;
u(mh, "MappedinCategory"), iv = new WeakMap(), rv = new WeakMap(), ov = new WeakMap(), E();
var sv,
  Vd,
  av,
  Zb = class {
    constructor(t, e) {
      re(this, sv, void 0), re(this, Vd, void 0), re(this, av, {}), A(this, "id", ""), A(this, "type", ""), A(this, "name", ""), A(this, "description"), A(this, "image"), A(this, "startDate"), A(this, "endDate"), A(this, "showDate"), he(this, Vd, e), he(this, sv, t), Object.assign(this, e);
    }
    location() {
      let t = w(this, av).location;
      if (void 0 !== t) return t;
      let e,
        n = w(this, sv)._locationsById,
        i = w(this, Vd).location;
      if (null != i) {
        let t = n[i];
        null != t && (e = t);
      }
      return w(this, av).location = e, e;
    }
    static hydrate(t, e) {
      return t.map(t => new Zb(e, t));
    }
    static async fetch(t) {
      let e = t.options.things.events.slice();
      t.options.things.locations && or(e, "location");
      let n = {
        fields: e,
        venue: t.options.venue,
        activeAtOrAfter: Date.now()
      };
      try {
        return (await rr(t.options, "event", n)).map(e => new Zb(t, e));
      } catch (t) {
        return ke.error("Fetch Events:", t), [];
      }
    }
    toJSON() {
      return w(this, Vd);
    }
  },
  zd = Zb;
u(zd, "MappedinEvent"), sv = new WeakMap(), Vd = new WeakMap(), av = new WeakMap(), E();
var lv,
  Kb = class {
    constructor(t) {
      re(this, lv, void 0), A(this, "id", ""), A(this, "name", ""), A(this, "value", ""), he(this, lv, t), Object.assign(this, t);
    }
    static hydrate(t) {
      return t.map(t => new Kb(t));
    }
    static async fetch(t) {
      let e = {
        fields: t.options.things.locationStates.slice(),
        venue: t.options.venue
      };
      try {
        return (await rr(t.options, "location-state", e)).map(t => new Kb(t));
      } catch (t) {
        return ke.error("Fetch Location States:", t), [];
      }
    }
    toJSON() {
      return w(this, lv);
    }
  },
  Jb = Kb;
u(Jb, "MappedinLocationState"), lv = new WeakMap(), E(), E();
var uv,
  _R,
  cv,
  xR,
  hv,
  fv,
  Qb,
  Yte,
  $b,
  Zte,
  Gl,
  Hl,
  jl,
  Wl,
  gh = class {
    constructor(t) {
      re(this, uv), re(this, cv), re(this, Qb), re(this, $b), A(this, "map"), re(this, hv, {}), re(this, fv, void 0), re(this, Gl, void 0), re(this, Hl, void 0), re(this, jl, void 0), re(this, Wl, void 0);
      let {
        map: e,
        mappedin: n
      } = t;
      null != t.lat && null != t.lon && (he(this, Gl, t.lat), he(this, Hl, t.lon)), null != t.x && null != t.y && (he(this, jl, t.x), he(this, Wl, t.y)), this.map = e, he(this, fv, n);
    }
    get x() {
      return mt(this, cv, xR).call(this, "x");
    }
    get y() {
      return mt(this, cv, xR).call(this, "y");
    }
    get lat() {
      return mt(this, uv, _R).call(this, "lat");
    }
    get lon() {
      return mt(this, uv, _R).call(this, "lon");
    }
    absoluteDistanceTo(t) {
      return gR([t.lat, t.lon], [this.lat, this.lon]);
    }
    get nearestNode() {
      let t = w(this, hv).nearestNode;
      if (void 0 !== t) return t;
      let e = Ws.instances.get(w(this, fv)).findNearestNodeOnMap(this.map.id, this);
      return w(this, hv).nearestNode = e, e;
    }
    toJSON() {
      return {
        x: this.x,
        y: this.y,
        map: this.map,
        lat: this.lat,
        lon: this.lon
      };
    }
  };
u(gh, "MappedinCoordinate"), uv = new WeakSet(), _R = u(function (t) {
  if (void 0 !== w(this, Gl) && void 0 !== w(this, Hl)) return w(this, "lat" === t ? Gl : Hl);
  if (void 0 !== w(this, jl) && void 0 !== w(this, Wl)) {
    let [e, n] = mt(this, $b, Zte).call(this, w(this, jl), w(this, Wl));
    return he(this, Gl, e), he(this, Hl, n), w(this, "lat" === t ? Gl : Hl);
  }
  throw Error("MappedinCoordinate is missing x and y");
}, "#getLatLon"), cv = new WeakSet(), xR = u(function (t) {
  if (w(this, jl) && w(this, Wl)) return w(this, "x" === t ? jl : Wl);
  if (null != w(this, Gl) && null != w(this, Hl)) {
    let [e, n] = mt(this, Qb, Yte).call(this, w(this, Gl), w(this, Hl));
    return he(this, jl, e), he(this, Wl, n), w(this, "x" === t ? jl : Wl);
  }
  throw Error("MappedinCoordinate is missing lat and lon");
}, "#getXY"), hv = new WeakMap(), fv = new WeakMap(), Qb = new WeakSet(), Yte = u(function (t, e) {
  let n = this.map.georeference[0],
    i = new _t(n.target.x, n.target.y),
    r = new _t(t, e),
    o = i.distanceTo(r),
    s = (i.finalBearingTo(r) + 360) % 360 * Math.PI / 180 || 0,
    a = o * (1 / this.map.scale),
    l = s + this.map.getNorth(),
    u = Math.sin(l) * a,
    h = Math.cos(l) * a;
  return [n.control.x + u, n.control.y - h];
}, "#latLonToXY"), $b = new WeakSet(), Zte = u(function (t, e) {
  let n,
    i = this.map.georeference[0],
    r = new _t(i.target.x, i.target.y),
    o = t - i.control.x,
    s = i.control.y - e,
    a = Math.atan2(o, s);
  n = 0 === o && 0 === s ? 0 : 0 === o ? s : o / Math.sin(a);
  let l = a - this.map.getNorth(),
    u = n / this.map._scale,
    h = r.destinationPoint(u, 180 * l / Math.PI);
  return [h.lat, h.lon];
}, "#xyToLatLon"), Gl = new WeakMap(), Hl = new WeakMap(), jl = new WeakMap(), Wl = new WeakMap();
var Xl,
  pv,
  dv,
  eM = class {
    constructor(t, e) {
      re(this, Xl, void 0), re(this, pv, {}), re(this, dv, void 0), A(this, "id", ""), A(this, "group", ""), A(this, "name", ""), A(this, "shortName", ""), A(this, "elevation", 0), A(this, "scale", 0), A(this, "layers"), A(this, "x_scale"), A(this, "perspectiveId"), A(this, "scene"), A(this, "width", 0), A(this, "height", 0), A(this, "georeference", []), A(this, "_scale", 0), he(this, Xl, t), he(this, dv, e), Object.assign(this, e), this._scale = vR(this), this.scale = this.x_scale || 1 / this._scale;
    }
    get polygons() {
      var t, e, n;
      return null != (n = null == (e = null == (t = Ws.instances.get(w(this, Xl))) ? void 0 : t.polygonsByMapId) ? void 0 : e.get(this.id)) ? n : [];
    }
    get locations() {
      var t, e, n;
      return null != (n = null == (e = null == (t = Ws.instances.get(w(this, Xl))) ? void 0 : t.locationsByMapId) ? void 0 : e.get(this.id)) ? n : [];
    }
    get nodes() {
      var t, e, n;
      return null != (n = null == (e = null == (t = Ws.instances.get(w(this, Xl))) ? void 0 : t.nodesByMapId) ? void 0 : e.get(this.id)) ? n : [];
    }
    get mapGroup() {
      let t = w(this, pv).mapGroup;
      if (void 0 !== t) return t;
      let e = this.group,
        n = e && w(this, Xl)._mapGroupsById[e] || null;
      return w(this, pv).mapGroup = n, n;
    }
    createCoordinateByXY(t, e) {
      return new gh({
        x: t,
        y: e,
        map: this,
        mappedin: w(this, Xl)
      });
    }
    createCoordinate(t, e) {
      return new gh({
        lat: t,
        lon: e,
        map: this,
        mappedin: w(this, Xl)
      });
    }
    getNorth() {
      let t;
      try {
        let e = this.georeference[0],
          n = this.georeference[2],
          i = new _t(e.target.x, e.target.y),
          r = new _t(n.target.x, n.target.y);
        t = -((i.finalBearingTo(r) + 0) * Math.PI / 180 - Math.atan2(n.control.y - e.control.y, n.control.x - e.control.x) - Math.PI / 2);
      } catch (e) {
        t = 0, ke.warn(e), ke.warn(`Couldn't georeference ${this.name || this.shortName || this.id}. Probably not enough geocoordinates.`);
      }
      return t;
    }
    static hydrate(t, e) {
      return t.map(t => new eM(e, t));
    }
    static async fetch(t) {
      var e;
      let n = t.options.things.maps.slice();
      t.options.perspective && or(n, "perspectives"), t.options.things.mapGroups && or(n, "group"), or(n, "elevation"), or(n, "x_scale"), or(n, "scale"), or(n, "georeference");
      let i = {
        fields: n,
        perspective: t.options.perspective,
        venue: t.options.venue
      };
      try {
        let o = await rr(t.options, "map", i),
          s = u(t => {
            let e = r.layers.find(e => e.id === t);
            e ? e.visible = !0 : r.layers.push({
              id: t,
              visible: !0
            });
          }, "setVisibleLayer");
        for (let i = 0, a = o.length; i < a; ++i) {
          var r = o[i];
          if (r) {
            let t = r.perspective;
            null != t && (r.perspectiveId = t.id, n.indexOf("scene") > -1 && (r.scene = t.scene), t.layers ? (r.layers.forEach(t => {
              t.visible = !1;
            }), t.layers.forEach(s)) : r.layers.forEach(t => {
              t.visible = !0;
            })), delete r.perspective;
          }
          if (t.options.preloadMapGeometry && (null == (e = r.scene) ? void 0 : e.polygons) && "string" == typeof r.scene.polygons) {
            let t = await Xs()(r.scene.polygons);
            r.scene.polygons = await t.json();
          }
          o[i] = new eM(t, r);
        }
        return o;
      } catch (t) {
        return ke.error("Fetch Maps:", t), [];
      }
    }
    toJSON() {
      return w(this, dv);
    }
  },
  Nf = eM;
u(Nf, "MappedinMap"), Xl = new WeakMap(), pv = new WeakMap(), dv = new WeakMap(), E();
var mv,
  Hd,
  gv,
  tM = class {
    constructor(t, e) {
      re(this, mv, void 0), re(this, Hd, void 0), re(this, gv, {}), A(this, "id", ""), A(this, "name", ""), he(this, Hd, e), he(this, mv, t), Object.assign(this, e);
    }
    get maps() {
      let t = w(this, gv).maps;
      if (void 0 !== t) return t;
      let e = [],
        {
          maps: n
        } = w(this, mv),
        {
          id: i
        } = w(this, Hd);
      for (let t = 0, r = n.length; t < r; ++t) {
        let r = n[t];
        r.group === i && e.push(r);
      }
      return w(this, gv).maps = e, e;
    }
    static hydrate(t, e) {
      return t.map(t => new tM(e, t));
    }
    static async fetch(t) {
      let e = {
        fields: t.options.things.mapGroups.slice(),
        venue: t.options.venue
      };
      try {
        return (await rr(t.options, "map-group", e)).map(e => new tM(t, e));
      } catch (t) {
        return ke.error("Fetch Map Groups:", t), [];
      }
    }
    toJSON() {
      return w(this, Hd);
    }
  },
  Gd = tM;
u(Gd, "MappedinMapGroup"), mv = new WeakMap(), Hd = new WeakMap(), gv = new WeakMap(), E();
var Ma,
  jd,
  Ao,
  vv,
  nM = class extends kl {
    constructor(t, e) {
      super(t), re(this, Ma, void 0), re(this, jd, void 0), re(this, Ao, {}), A(this, "id", ""), A(this, "x", 0), A(this, "y", 0), A(this, "operationHours"), A(this, "externalId"), re(this, vv, void 0), he(this, Ma, t), he(this, jd, e);
      let n = Object.assign({}, e);
      delete n.map, Object.assign(this, n);
    }
    get map() {
      let t = w(this, Ao).map;
      if (void 0 !== t) return t;
      let e = w(this, Ma).getCollectionItemById(ii.MAP, w(this, jd).map);
      return w(this, Ao).map = e, e;
    }
    get lat() {
      var t;
      let e = w(this, Ao).cachedLatLon;
      if (null != e) return e.lat;
      let n = null == (t = w(this, Ma)._mapsById) ? void 0 : t[this.map.id];
      if (null == n) throw new Error("Map not found");
      return w(this, Ao).cachedLatLon = n.createCoordinateByXY(this.x, this.y), w(this, Ao).cachedLatLon.lat;
    }
    get lon() {
      var t;
      let e = w(this, Ao).cachedLatLon;
      if (null != e) return e.lon;
      let n = null == (t = w(this, Ma)._mapsById) ? void 0 : t[this.map.id];
      if (null == n) throw new Error("Map not found");
      return w(this, Ao).cachedLatLon = n.createCoordinateByXY(this.x, this.y), w(this, Ao).cachedLatLon.lon;
    }
    get paths() {
      let t = w(this, Ao).paths;
      if (void 0 !== t) return t;
      let e = [],
        n = w(this, Ma)._nodesById,
        i = w(this, vv);
      if (Array.isArray(i)) for (let t = 0, r = i.length; t < r; ++t) {
        let r = n[i[t].node];
        null != r && e.push(r);
      }
      return w(this, Ao).paths = e, e;
    }
    set paths(t) {
      he(this, vv, t);
    }
    get locations() {
      var t, e, n;
      let i = w(this, Ao).locations;
      if (void 0 !== i) return i;
      let r = [],
        o = null != (n = null == (e = null == (t = Ws.instances.get(w(this, Ma))) ? void 0 : t.locationsByMapId) ? void 0 : e.get(this.map.id)) ? n : [],
        s = this.id;
      for (let t = 0, e = o.length; t < e; ++t) {
        let e = o[t],
          n = e.nodes;
        if (Array.isArray(n)) for (let t = 0, i = n.length; t < i; ++t) if (n[t].id === s) {
          r.push(e);
          break;
        }
      }
      return w(this, Ao).locations = r, r;
    }
    get polygon() {
      var t, e, n;
      let i = w(this, Ao).polygon;
      if (void 0 !== i) return i;
      let r,
        o = null != (n = null == (e = null == (t = Ws.instances.get(w(this, Ma))) ? void 0 : t.polygonsByMapId) ? void 0 : e.get(this.map.id)) ? n : [],
        s = this.id;
      for (let t = 0, e = o.length; t < e; ++t) {
        let e = o[t];
        e.entrances.map(t => t.id).includes(s) && (r = e);
      }
      return w(this, Ao).polygon = r, r;
    }
    static hydrate(t, e) {
      return t.map(t => new nM(e, t));
    }
    static async fetch(t) {
      let e = t.options.things.nodes.slice();
      t.options.things.maps && or(e, "map"), ["weight", "multiplier", "accessible"].forEach(function (t) {
        or(e, t);
      });
      let n = {
        fields: e,
        venue: t.options.venue
      };
      try {
        return (await rr(t.options, "node", n)).map(e => new nM(t, e));
      } catch (t) {
        return ke.error("Fetch Nodes:", t), [];
      }
    }
    directionsTo(t, e) {
      let n = t instanceof va,
        i = w(this, Ma).venue.slug,
        r = new e1({
          with_destination_set: n || void 0,
          venue: i
        });
      return at.addPendingEvent(r), super.directionsTo(t, e);
    }
    distanceTo(t, e) {
      let n = w(this, Ma).venue.slug;
      return at.addPendingEvent(new t1({
        venue: n
      })), super.distanceTo(t, e);
    }
    toJSON() {
      return w(this, jd);
    }
  },
  hl = nM;
u(hl, "MappedinNode"), Ma = new WeakMap(), jd = new WeakMap(), Ao = new WeakMap(), vv = new WeakMap(), E();
var _v,
  iM = class {
    constructor(t) {
      re(this, _v, void 0), A(this, "polygons", []), he(this, _v, t), Object.assign(this, t);
    }
    static hydrate(t) {
      return new iM(t);
    }
    static async fetch(t) {
      try {
        let e = await nv({
          ...t.options,
          secure: !1
        }, "smart-labels/polygon-label-ranking", {
          venue: t.options.venue
        }, !0);
        return new iM(e);
      } catch (t) {
        return ke.error("Fetch Rankings:", t), null;
      }
    }
    toJSON() {
      return w(this, _v);
    }
  },
  yv = iM;
u(yv, "MappedinRankings"), _v = new WeakMap(), E();
var xv,
  oM = class {
    constructor(t) {
      A(this, "id", ""), re(this, xv, void 0), he(this, xv, t), Object.assign(this, t);
    }
    static hydrate(t) {
      return t.map(t => new oM(t));
    }
    static async fetch(t) {
      let e = {
        fields: t.options.things.themes.slice(),
        venue: t.options.venue
      };
      try {
        return (await rr(t.options, "apollo-theme", e)).map(t => new oM(t));
      } catch (t) {
        return ke.error("Fetch Theme:", t), [];
      }
    }
    toJSON() {
      return w(this, xv);
    }
  },
  rM = oM;
u(rM, "MappedinTheme"), xv = new WeakMap(), E();
var bv,
  Mv,
  Ev,
  Wd,
  sM = class {
    constructor(t, e) {
      re(this, bv, void 0), re(this, Mv, void 0), re(this, Ev, void 0), re(this, Wd, {}), A(this, "defaultMap", ""), A(this, "address", ""), A(this, "city", ""), A(this, "countrycode", ""), A(this, "externalId", ""), A(this, "id", ""), A(this, "latitude"), A(this, "logo"), A(this, "longitude"), A(this, "name", ""), A(this, "operationHours"), A(this, "postal", ""), A(this, "slug", ""), A(this, "state", ""), A(this, "telephone", ""), A(this, "tzid", ""), A(this, "tzidOverride", ""), A(this, "utcOffset", ""), A(this, "website", ""), A(this, "secureContentStorage", !1), A(this, "languages", []), he(this, Mv, t), he(this, bv, e), Object.assign(this, e);
    }
    get metadata() {
      return at.addPendingEvent(new r1({
        venue: this.slug
      })), w(this, Ev);
    }
    set metadata(t) {
      he(this, Ev, t);
    }
    static hydrate(t, e) {
      return new sM(e, t);
    }
    static async fetch(t) {
      let e = {
        fields: t.options.things.venue,
        slug: t.options.venue,
        limit: 1
      };
      try {
        let n = await rr(t.options, "venue", e);
        return new sM(t, n[0]);
      } catch (t) {
        return ke.error("Fetch Venue:", t), {};
      }
    }
    get isMultiBuilding() {
      if (null == w(this, Wd).isMultiBuilding) {
        let t = w(this, Mv).maps,
          e = t.reduce((t, e) => t.add(e.elevation), new Set()),
          n = t.length !== e.size;
        w(this, Wd).isMultiBuilding = n;
      }
      return w(this, Wd).isMultiBuilding;
    }
    toJSON() {
      return w(this, bv);
    }
  },
  Df = sM;
u(Df, "MappedinVenue"), bv = new WeakMap(), Mv = new WeakMap(), Ev = new WeakMap(), Wd = new WeakMap(), E();
var wv,
  aM = class {
    constructor(t) {
      A(this, "id", ""), re(this, wv, void 0), A(this, "name"), A(this, "type"), A(this, "weight"), A(this, "multiplier"), A(this, "nodes"), he(this, wv, t), Object.assign(this, t);
    }
    static hydrate(t) {
      return t.map(t => new aM(t));
    }
    static async fetch(t) {
      let e = t.options.things.vortexes.slice();
      ["name", "type", "accessible", "weight", "multiplier", "nodes"].forEach(function (t) {
        or(e, t);
      });
      let n = {
        fields: e,
        venue: t.options.venue
      };
      try {
        return (await rr(t.options, "vortex", n)).map(t => new aM(t));
      } catch (t) {
        return ke.error("Fetch Vortexes:", t), [];
      }
    }
    toJSON() {
      return w(this, wv);
    }
  },
  Xd = aM;
u(Xd, "MappedinVortex"), wv = new WeakMap(), E(), E(), E(), E();
var jr = 6371008.8,
  bR = {
    centimeters: 100 * jr,
    centimetres: 100 * jr,
    degrees: jr / 111325,
    feet: 3.28084 * jr,
    inches: 39.37 * jr,
    kilometers: jr / 1e3,
    kilometres: jr / 1e3,
    meters: jr,
    metres: jr,
    miles: jr / 1609.344,
    millimeters: 1e3 * jr,
    millimetres: 1e3 * jr,
    nauticalmiles: jr / 1852,
    radians: 1,
    yards: 1.0936 * jr
  },
  c2e = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: .001,
    kilometres: .001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1e3,
    millimetres: 1e3,
    nauticalmiles: 1 / 1852,
    radians: 1 / jr,
    yards: 1.0936133
  };
function Wr(t, e, n) {
  void 0 === n && (n = {});
  var i = {
    type: "Feature"
  };
  return (0 === n.id || n.id) && (i.id = n.id), n.bbox && (i.bbox = n.bbox), i.properties = e || {}, i.geometry = t, i;
}
function Yn(t, e, n) {
  if (void 0 === n && (n = {}), !t) throw new Error("coordinates is required");
  if (!Array.isArray(t)) throw new Error("coordinates must be an Array");
  if (t.length < 2) throw new Error("coordinates must be at least 2 numbers long");
  if (!Yl(t[0]) || !Yl(t[1])) throw new Error("coordinates must contain numbers");
  return Wr({
    type: "Point",
    coordinates: t
  }, e, n);
}
function Ii(t, e, n) {
  void 0 === n && (n = {});
  for (var i = 0, r = t; i < r.length; i++) {
    var o = r[i];
    if (o.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
    for (var s = 0; s < o[o.length - 1].length; s++) if (o[o.length - 1][s] !== o[0][s]) throw new Error("First and last Position are not equivalent.");
  }
  return Wr({
    type: "Polygon",
    coordinates: t
  }, e, n);
}
function Qi(t, e, n) {
  if (void 0 === n && (n = {}), t.length < 2) throw new Error("coordinates must be an array of two or more positions");
  return Wr({
    type: "LineString",
    coordinates: t
  }, e, n);
}
function Zt(t, e) {
  void 0 === e && (e = {});
  var n = {
    type: "FeatureCollection"
  };
  return e.id && (n.id = e.id), e.bbox && (n.bbox = e.bbox), n.features = t, n;
}
function qf(t, e, n) {
  return void 0 === n && (n = {}), Wr({
    type: "MultiLineString",
    coordinates: t
  }, e, n);
}
function e5(t, e, n) {
  return void 0 === n && (n = {}), Wr({
    type: "MultiPoint",
    coordinates: t
  }, e, n);
}
function Sv(t, e) {
  void 0 === e && (e = "kilometers");
  var n = bR[e];
  if (!n) throw new Error(e + " units is invalid");
  return t * n;
}
function Tv(t, e) {
  void 0 === e && (e = "kilometers");
  var n = bR[e];
  if (!n) throw new Error(e + " units is invalid");
  return t / n;
}
function kf(t) {
  return 180 * (t % (2 * Math.PI)) / Math.PI;
}
function po(t) {
  return t % 360 * Math.PI / 180;
}
function Yl(t) {
  return !isNaN(t) && null !== t && !Array.isArray(t);
}
function Ar(t, e, n) {
  if (null !== t) for (var i, r, o, s, a, l, u, h, c = 0, p = 0, d = t.type, f = "FeatureCollection" === d, m = "Feature" === d, g = f ? t.features.length : 1, v = 0; v < g; v++) {
    a = (h = !!(u = f ? t.features[v].geometry : m ? t.geometry : t) && "GeometryCollection" === u.type) ? u.geometries.length : 1;
    for (var y = 0; y < a; y++) {
      var _ = 0,
        x = 0;
      if (null !== (s = h ? u.geometries[y] : u)) {
        l = s.coordinates;
        var E = s.type;
        switch (c = !n || "Polygon" !== E && "MultiPolygon" !== E ? 0 : 1, E) {
          case null:
            break;
          case "Point":
            if (!1 === e(l, p, v, _, x)) return !1;
            p++, _++;
            break;
          case "LineString":
          case "MultiPoint":
            for (i = 0; i < l.length; i++) {
              if (!1 === e(l[i], p, v, _, x)) return !1;
              p++, "MultiPoint" === E && _++;
            }
            "LineString" === E && _++;
            break;
          case "Polygon":
          case "MultiLineString":
            for (i = 0; i < l.length; i++) {
              for (r = 0; r < l[i].length - c; r++) {
                if (!1 === e(l[i][r], p, v, _, x)) return !1;
                p++;
              }
              "MultiLineString" === E && _++, "Polygon" === E && x++;
            }
            "Polygon" === E && _++;
            break;
          case "MultiPolygon":
            for (i = 0; i < l.length; i++) {
              for (x = 0, r = 0; r < l[i].length; r++) {
                for (o = 0; o < l[i][r].length - c; o++) {
                  if (!1 === e(l[i][r][o], p, v, _, x)) return !1;
                  p++;
                }
                x++;
              }
              _++;
            }
            break;
          case "GeometryCollection":
            for (i = 0; i < s.geometries.length; i++) if (!1 === Ar(s.geometries[i], e, n)) return !1;
            break;
          default:
            throw new Error("Unknown Geometry Type");
        }
      }
    }
  }
}
function MR(t, e, n, i) {
  var r = n;
  return Ar(t, function (t, i, o, s, a) {
    r = 0 === i && void 0 === n ? t : e(r, t, i, o, s, a);
  }, i), r;
}
function vi(t, e) {
  if ("Feature" === t.type) e(t, 0);else if ("FeatureCollection" === t.type) for (var n = 0; n < t.features.length && !1 !== e(t.features[n], n); n++);
}
function Zl(t, e) {
  var n,
    i,
    r,
    o,
    s,
    a,
    l,
    u,
    h,
    c,
    p = 0,
    d = "FeatureCollection" === t.type,
    f = "Feature" === t.type,
    m = d ? t.features.length : 1;
  for (n = 0; n < m; n++) {
    for (a = d ? t.features[n].geometry : f ? t.geometry : t, u = d ? t.features[n].properties : f ? t.properties : {}, h = d ? t.features[n].bbox : f ? t.bbox : void 0, c = d ? t.features[n].id : f ? t.id : void 0, s = (l = !!a && "GeometryCollection" === a.type) ? a.geometries.length : 1, r = 0; r < s; r++) if (null !== (o = l ? a.geometries[r] : a)) switch (o.type) {
      case "Point":
      case "LineString":
      case "MultiPoint":
      case "Polygon":
      case "MultiLineString":
      case "MultiPolygon":
        if (!1 === e(o, p, u, h, c)) return !1;
        break;
      case "GeometryCollection":
        for (i = 0; i < o.geometries.length; i++) if (!1 === e(o.geometries[i], p, u, h, c)) return !1;
        break;
      default:
        throw new Error("Unknown Geometry Type");
    } else if (!1 === e(null, p, u, h, c)) return !1;
    p++;
  }
}
function Yo(t, e) {
  Zl(t, function (t, n, i, r, o) {
    var s,
      a = null === t ? null : t.type;
    switch (a) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        return !1 !== e(Wr(t, i, {
          bbox: r,
          id: o
        }), n, 0) && void 0;
    }
    switch (a) {
      case "MultiPoint":
        s = "Point";
        break;
      case "MultiLineString":
        s = "LineString";
        break;
      case "MultiPolygon":
        s = "Polygon";
    }
    for (var l = 0; l < t.coordinates.length; l++) {
      var u = t.coordinates[l];
      if (!1 === e(Wr({
        type: s,
        coordinates: u
      }, i), n, l)) return !1;
    }
  });
}
function lM(t, e) {
  Yo(t, function (t, n, i) {
    var r = 0;
    if (t.geometry) {
      var o = t.geometry.type;
      if ("Point" !== o && "MultiPoint" !== o) {
        var s,
          a = 0,
          l = 0,
          u = 0;
        if (!1 === Ar(t, function (o, h, c, p, d) {
          if (void 0 === s || n > a || p > l || d > u) return s = o, a = n, l = p, u = d, void (r = 0);
          var f = Qi([s, o], t.properties);
          if (!1 === e(f, n, i, d, r)) return !1;
          r++, s = o;
        })) return !1;
      }
    }
  });
}
function ER(t, e, n) {
  var i = n,
    r = !1;
  return lM(t, function (t, o, s, a, l) {
    i = !1 === r && void 0 === n ? t : e(i, t, o, s, a, l), r = !0;
  }), i;
}
function t5(t) {
  var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
  return Ar(t, function (t) {
    e[0] > t[0] && (e[0] = t[0]), e[1] > t[1] && (e[1] = t[1]), e[2] < t[0] && (e[2] = t[0]), e[3] < t[1] && (e[3] = t[1]);
  }), e;
}
u(Wr, "feature"), u(Yn, "point"), u(Ii, "polygon"), u(Qi, "lineString"), u(Zt, "featureCollection"), u(qf, "multiLineString"), u(e5, "multiPoint"), u(Sv, "radiansToLength"), u(Tv, "lengthToRadians"), u(kf, "radiansToDegrees"), u(po, "degreesToRadians"), u(Yl, "isNumber"), u(Ar, "coordEach"), u(MR, "coordReduce"), u(vi, "featureEach"), u(Zl, "geomEach"), u(Yo, "flattenEach"), u(lM, "segmentEach"), u(ER, "segmentReduce"), u(t5, "bbox"), t5.default = t5;
var mo = t5;
function er(t) {
  if (!t) throw new Error("coord is required");
  if (!Array.isArray(t)) {
    if ("Feature" === t.type && null !== t.geometry && "Point" === t.geometry.type) return t.geometry.coordinates;
    if ("Point" === t.type) return t.coordinates;
  }
  if (Array.isArray(t) && t.length >= 2 && !Array.isArray(t[0]) && !Array.isArray(t[1])) return t;
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function yi(t) {
  if (Array.isArray(t)) return t;
  if ("Feature" === t.type) {
    if (null !== t.geometry) return t.geometry.coordinates;
  } else if (t.coordinates) return t.coordinates;
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function n5(t, e, n) {
  if (!t) throw new Error("No feature passed");
  if (!n) throw new Error(".featureOf() requires a name");
  if (!t || "Feature" !== t.type || !t.geometry) throw new Error("Invalid input to " + n + ", Feature with geometry required");
  if (!t.geometry || t.geometry.type !== e) throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.geometry.type);
}
function Io(t) {
  return "Feature" === t.type ? t.geometry : t;
}
function Js(t, e) {
  return "FeatureCollection" === t.type ? "FeatureCollection" : "GeometryCollection" === t.type ? "GeometryCollection" : "Feature" === t.type && null !== t.geometry ? t.geometry.type : t.type;
}
E(), E(), E(), E(), u(er, "getCoord"), u(yi, "getCoords"), u(n5, "featureOf"), u(Io, "getGeom"), u(Js, "getType");
var ine = Rt(uM());
E();
var pne = Rt(VR());
function go(t, e, n) {
  if (void 0 === n && (n = {}), !t) throw new Error("point is required");
  if (!e) throw new Error("polygon is required");
  var i = er(t),
    r = Io(e),
    o = r.type,
    s = e.bbox,
    a = r.coordinates;
  if (s && !1 === dne(i, s)) return !1;
  "Polygon" === o && (a = [a]);
  for (var l = !1, u = 0; u < a.length && !l; u++) if (GR(i, a[u][0], n.ignoreBoundary)) {
    for (var h = !1, c = 1; c < a[u].length && !h;) GR(i, a[u][c], !n.ignoreBoundary) && (h = !0), c++;
    h || (l = !0);
  }
  return l;
}
function GR(t, e, n) {
  var i = !1;
  e[0][0] === e[e.length - 1][0] && e[0][1] === e[e.length - 1][1] && (e = e.slice(0, e.length - 1));
  for (var r = 0, o = e.length - 1; r < e.length; o = r++) {
    var s = e[r][0],
      a = e[r][1],
      l = e[o][0],
      u = e[o][1];
    if (t[1] * (s - l) + a * (l - t[0]) + u * (t[0] - s) == 0 && (s - t[0]) * (l - t[0]) <= 0 && (a - t[1]) * (u - t[1]) <= 0) return !n;
    a > t[1] != u > t[1] && t[0] < (l - s) * (t[1] - a) / (u - a) + s && (i = !i);
  }
  return i;
}
function dne(t, e) {
  return e[0] <= t[0] && e[1] <= t[1] && e[2] >= t[0] && e[3] >= t[1];
}
function mne(t, e, n) {
  void 0 === n && (n = {});
  var i = er(t),
    r = er(e),
    o = po(r[1] - i[1]),
    s = po(r[0] - i[0]),
    a = po(i[1]),
    l = po(r[1]),
    u = Math.pow(Math.sin(o / 2), 2) + Math.pow(Math.sin(s / 2), 2) * Math.cos(a) * Math.cos(l);
  return Sv(2 * Math.atan2(Math.sqrt(u), Math.sqrt(1 - u)), n.units);
}
E(), E(), u(go, "booleanPointInPolygon"), u(GR, "inRing"), u(dne, "inBBox"), E(), E(), u(mne, "distance");
var Hi = mne;
E();
var F2e = function () {
  function t(t, e, n) {
    this.a = t, this.b = e, this.c = n;
    var i,
      r,
      o = e.x - t.x,
      s = e.y - t.y,
      a = n.x - t.x,
      l = n.y - t.y,
      u = o * (t.x + e.x) + s * (t.y + e.y),
      h = a * (t.x + n.x) + l * (t.y + n.y),
      c = 2 * (o * (n.y - e.y) - s * (n.x - e.x));
    this.x = (l * u - s * h) / c, this.y = (o * h - a * u) / c, i = this.x - t.x, r = this.y - t.y, this.r = i * i + r * r;
  }
  return u(t, "Triangle"), t;
}();
E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E();
var jR = new ArrayBuffer(16),
  Ube = new Float64Array(jR),
  zbe = new Uint32Array(jR);
E(), E(), E(), E(), E(), E();
var Ine = Rt(v5());
E(), E(), E(), E(), E();
var pEe = function () {
  function t(t) {
    this.points = t.points || [], this.duration = t.duration || 1e4, this.sharpness = t.sharpness || .85, this.centers = [], this.controls = [], this.stepLength = t.stepLength || 60, this.length = this.points.length, this.delay = 0;
    for (var e = 0; e < this.length; e++) this.points[e].z = this.points[e].z || 0;
    for (e = 0; e < this.length - 1; e++) {
      var n = this.points[e],
        i = this.points[e + 1];
      this.centers.push({
        x: (n.x + i.x) / 2,
        y: (n.y + i.y) / 2,
        z: (n.z + i.z) / 2
      });
    }
    this.controls.push([this.points[0], this.points[0]]);
    for (e = 0; e < this.centers.length - 1; e++) {
      var r = this.points[e + 1].x - (this.centers[e].x + this.centers[e + 1].x) / 2,
        o = this.points[e + 1].y - (this.centers[e].y + this.centers[e + 1].y) / 2,
        s = this.points[e + 1].z - (this.centers[e].y + this.centers[e + 1].z) / 2;
      this.controls.push([{
        x: (1 - this.sharpness) * this.points[e + 1].x + this.sharpness * (this.centers[e].x + r),
        y: (1 - this.sharpness) * this.points[e + 1].y + this.sharpness * (this.centers[e].y + o),
        z: (1 - this.sharpness) * this.points[e + 1].z + this.sharpness * (this.centers[e].z + s)
      }, {
        x: (1 - this.sharpness) * this.points[e + 1].x + this.sharpness * (this.centers[e + 1].x + r),
        y: (1 - this.sharpness) * this.points[e + 1].y + this.sharpness * (this.centers[e + 1].y + o),
        z: (1 - this.sharpness) * this.points[e + 1].z + this.sharpness * (this.centers[e + 1].z + s)
      }]);
    }
    return this.controls.push([this.points[this.length - 1], this.points[this.length - 1]]), this.steps = this.cacheSteps(this.stepLength), this;
  }
  return u(t, "Spline"), t.prototype.cacheSteps = function (t) {
    var e = [],
      n = this.pos(0);
    e.push(0);
    for (var i = 0; i < this.duration; i += 10) {
      var r = this.pos(i);
      Math.sqrt((r.x - n.x) * (r.x - n.x) + (r.y - n.y) * (r.y - n.y) + (r.z - n.z) * (r.z - n.z)) > t && (e.push(i), n = r);
    }
    return e;
  }, t.prototype.vector = function (t) {
    var e = this.pos(t + 10),
      n = this.pos(t - 10);
    return {
      angle: 180 * Math.atan2(e.y - n.y, e.x - n.x) / 3.14,
      speed: Math.sqrt((n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y) + (n.z - e.z) * (n.z - e.z))
    };
  }, t.prototype.pos = function (t) {
    var e = t - this.delay;
    e < 0 && (e = 0), e > this.duration && (e = this.duration - 1);
    var n = e / this.duration;
    if (n >= 1) return this.points[this.length - 1];
    var i = Math.floor((this.points.length - 1) * n);
    return Lne((this.length - 1) * n - i, this.points[i], this.controls[i][1], this.controls[i + 1][0], this.points[i + 1]);
  }, t;
}();
function Lne(t, e, n, i, r) {
  var o = One(t);
  return {
    x: r.x * o[0] + i.x * o[1] + n.x * o[2] + e.x * o[3],
    y: r.y * o[0] + i.y * o[1] + n.y * o[2] + e.y * o[3],
    z: r.z * o[0] + i.z * o[1] + n.z * o[2] + e.z * o[3]
  };
}
function One(t) {
  var e = t * t;
  return [e * t, 3 * e * (1 - t), 3 * t * (1 - t) * (1 - t), (1 - t) * (1 - t) * (1 - t)];
}
function Iv(t, e) {
  void 0 === e && (e = {});
  var n = Number(t[0]),
    i = Number(t[1]),
    r = Number(t[2]),
    o = Number(t[3]);
  if (6 === t.length) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
  var s = [n, i];
  return Ii([[s, [r, i], [r, o], [n, o], s]], e.properties, {
    bbox: t,
    id: e.id
  });
}
function Rne(t) {
  return Iv(mo(t));
}
u(Lne, "bezier"), u(One, "B"), E(), E(), E(), E(), u(Iv, "bboxPolygon"), u(Rne, "envelope");
var y5 = Rne;
function Jl(t, e, n, i) {
  void 0 === i && (i = {});
  var r = er(t),
    o = po(r[0]),
    s = po(r[1]),
    a = po(n),
    l = Tv(e, i.units),
    u = Math.asin(Math.sin(s) * Math.cos(l) + Math.cos(s) * Math.sin(l) * Math.cos(a));
  return Yn([kf(o + Math.atan2(Math.sin(a) * Math.sin(l) * Math.cos(s), Math.cos(l) - Math.sin(s) * Math.sin(u))), kf(u)], i.properties);
}
function tc(t, e, n) {
  if (void 0 === n && (n = {}), !0 === n.final) return Nne(t, e);
  var i = er(t),
    r = er(e),
    o = po(i[0]),
    s = po(r[0]),
    a = po(i[1]),
    l = po(r[1]),
    u = Math.sin(s - o) * Math.cos(l),
    h = Math.cos(a) * Math.sin(l) - Math.sin(a) * Math.cos(l) * Math.cos(s - o);
  return kf(Math.atan2(u, h));
}
function Nne(t, e) {
  var n = tc(e, t);
  return n = (n + 180) % 360;
}
function Dne(t, e) {
  void 0 === e && (e = {});
  var n = mo(t);
  return Yn([(n[0] + n[2]) / 2, (n[1] + n[3]) / 2], e.properties, e);
}
E(), E(), E(), u(Jl, "destination"), E(), E(), u(tc, "bearing"), u(Nne, "calculateFinalBearing"), E(), u(Dne, "center");
var Ff = Dne;
E(), E(), E(), E(), E();
var Qne = Rt(tN());
function $ne(t) {
  if (!t) throw new Error("geojson is required");
  var e = [];
  return Yo(t, function (t) {
    eie(t, e);
  }), Zt(e);
}
function eie(t, e) {
  var n = [],
    i = t.geometry;
  if (null !== i) {
    switch (i.type) {
      case "Polygon":
        n = yi(i);
        break;
      case "LineString":
        n = [yi(i)];
    }
    n.forEach(function (n) {
      tie(n, t.properties).forEach(function (t) {
        t.id = e.length, e.push(t);
      });
    });
  }
}
function tie(t, e) {
  var n = [];
  return t.reduce(function (t, i) {
    var r = Qi([t, i], e);
    return r.bbox = nie(t, i), n.push(r), i;
  }), n;
}
function nie(t, e) {
  var n = t[0],
    i = t[1],
    r = e[0],
    o = e[1];
  return [n < r ? n : r, i < o ? i : o, n > r ? n : r, i > o ? i : o];
}
E(), E(), E(), E(), u($ne, "lineSegment"), u(eie, "lineSegmentFeature"), u(tie, "createSegments"), u(nie, "bbox");
var Uf = $ne,
  vN = Rt(SM());
function Aie(t, e) {
  var n = {},
    i = [];
  if ("LineString" === t.type && (t = Wr(t)), "LineString" === e.type && (e = Wr(e)), "Feature" === t.type && "Feature" === e.type && null !== t.geometry && null !== e.geometry && "LineString" === t.geometry.type && "LineString" === e.geometry.type && 2 === t.geometry.coordinates.length && 2 === e.geometry.coordinates.length) {
    var r = yN(t, e);
    return r && i.push(r), Zt(i);
  }
  var o = (0, vN.default)();
  return o.load(Uf(e)), vi(Uf(t), function (t) {
    vi(o.search(t), function (e) {
      var r = yN(t, e);
      if (r) {
        var o = yi(r).join(",");
        n[o] || (n[o] = !0, i.push(r));
      }
    });
  }), Zt(i);
}
function yN(t, e) {
  var n = yi(t),
    i = yi(e);
  if (2 !== n.length) throw new Error("<intersects> line1 must only contain 2 coordinates");
  if (2 !== i.length) throw new Error("<intersects> line2 must only contain 2 coordinates");
  var r = n[0][0],
    o = n[0][1],
    s = n[1][0],
    a = n[1][1],
    l = i[0][0],
    u = i[0][1],
    h = i[1][0],
    c = i[1][1],
    p = (c - u) * (s - r) - (h - l) * (a - o),
    d = (h - l) * (o - u) - (c - u) * (r - l),
    f = (s - r) * (o - u) - (a - o) * (r - l);
  if (0 === p) return null;
  var m = d / p,
    g = f / p;
  return m >= 0 && m <= 1 && g >= 0 && g <= 1 ? Yn([r + m * (s - r), o + m * (a - o)]) : null;
}
u(Aie, "lineIntersect"), u(yN, "intersects");
var zf = Aie;
function Iie(t, e, n) {
  void 0 === n && (n = {});
  var i = Yn([1 / 0, 1 / 0], {
      dist: 1 / 0
    }),
    r = 0;
  return Yo(t, function (t) {
    for (var o = yi(t), s = 0; s < o.length - 1; s++) {
      var a = Yn(o[s]);
      a.properties.dist = Hi(e, a, n);
      var l = Yn(o[s + 1]);
      l.properties.dist = Hi(e, l, n);
      var u = Hi(a, l, n),
        h = Math.max(a.properties.dist, l.properties.dist),
        c = tc(a, l),
        p = Jl(e, h, c + 90, n),
        d = Jl(e, h, c - 90, n),
        f = zf(Qi([p.geometry.coordinates, d.geometry.coordinates]), Qi([a.geometry.coordinates, l.geometry.coordinates])),
        m = null;
      f.features.length > 0 && ((m = f.features[0]).properties.dist = Hi(e, m, n), m.properties.location = r + Hi(a, m, n)), a.properties.dist < i.properties.dist && ((i = a).properties.index = s, i.properties.location = r), l.properties.dist < i.properties.dist && ((i = l).properties.index = s + 1, i.properties.location = r + u), m && m.properties.dist < i.properties.dist && ((i = m).properties.index = s), r += u;
    }
  }), i;
}
u(Iie, "nearestPointOnLine");
var nc = Iie;
E(), E(), E();
var Oie = Rt(uM());
function Vf(t, e) {
  return void 0 === e && (e = {}), ER(t, function (t, n) {
    var i = n.geometry.coordinates;
    return t + Hi(i[0], i[1], e);
  }, 0);
}
function Rie(t, e, n) {
  var i = yi(n);
  if ("LineString" !== Js(n)) throw new Error("line must be a LineString");
  for (var r, o = nc(n, t), s = nc(n, e), a = [(r = o.properties.index <= s.properties.index ? [o, s] : [s, o])[0].geometry.coordinates], l = r[0].properties.index + 1; l < r[1].properties.index + 1; l++) a.push(i[l]);
  return a.push(r[1].geometry.coordinates), Qi(a, n.properties);
}
E(), E(), E(), E(), E(), E(), u(Vf, "length"), E(), u(Rie, "lineSlice");
var PM = Rie;
function Nie(t, e, n) {
  void 0 === n && (n = {});
  for (var i = er(t), r = yi(e), o = 0; o < r.length - 1; o++) {
    var s = !1;
    if (n.ignoreEndVertices && (0 === o && (s = "start"), o === r.length - 2 && (s = "end"), 0 === o && o + 1 === r.length - 1 && (s = "both")), Die(r[o], r[o + 1], i, s, void 0 === n.epsilon ? null : n.epsilon)) return !0;
  }
  return !1;
}
function Die(t, e, n, i, r) {
  var o = n[0],
    s = n[1],
    a = t[0],
    l = t[1],
    u = e[0],
    h = e[1],
    c = u - a,
    p = h - l,
    d = (n[0] - a) * p - (n[1] - l) * c;
  if (null !== r) {
    if (Math.abs(d) > r) return !1;
  } else if (0 !== d) return !1;
  return i ? "start" === i ? Math.abs(c) >= Math.abs(p) ? c > 0 ? a < o && o <= u : u <= o && o < a : p > 0 ? l < s && s <= h : h <= s && s < l : "end" === i ? Math.abs(c) >= Math.abs(p) ? c > 0 ? a <= o && o < u : u < o && o <= a : p > 0 ? l <= s && s < h : h < s && s <= l : "both" === i && (Math.abs(c) >= Math.abs(p) ? c > 0 ? a < o && o < u : u < o && o < a : p > 0 ? l < s && s < h : h < s && s < l) : Math.abs(c) >= Math.abs(p) ? c > 0 ? a <= o && o <= u : u <= o && o <= a : p > 0 ? l <= s && s <= h : h <= s && s <= l;
}
E(), E(), E(), E(), u(Nie, "booleanPointOnLine"), u(Die, "isPointOnLineSegment");
var em = Nie;
E(), E(), E(), E();
var Fie = Rt(v5());
E();
var xN = Math.PI / 180,
  bN = 180 / Math.PI,
  Dv = u(function (t, e) {
    this.lon = t, this.lat = e, this.x = xN * t, this.y = xN * e;
  }, "Coord");
Dv.prototype.view = function () {
  return String(this.lon).slice(0, 4) + "," + String(this.lat).slice(0, 4);
}, Dv.prototype.antipode = function () {
  var t = -1 * this.lat,
    e = this.lon < 0 ? 180 + this.lon : -1 * (180 - this.lon);
  return new Dv(e, t);
};
var MN = u(function () {
  this.coords = [], this.length = 0;
}, "LineString");
MN.prototype.move_to = function (t) {
  this.length++, this.coords.push(t);
};
var F5 = u(function (t) {
  this.properties = t || {}, this.geometries = [];
}, "Arc");
F5.prototype.json = function () {
  if (this.geometries.length <= 0) return {
    geometry: {
      type: "LineString",
      coordinates: null
    },
    type: "Feature",
    properties: this.properties
  };
  if (1 === this.geometries.length) return {
    geometry: {
      type: "LineString",
      coordinates: this.geometries[0].coords
    },
    type: "Feature",
    properties: this.properties
  };
  for (var t = [], e = 0; e < this.geometries.length; e++) t.push(this.geometries[e].coords);
  return {
    geometry: {
      type: "MultiLineString",
      coordinates: t
    },
    type: "Feature",
    properties: this.properties
  };
}, F5.prototype.wkt = function () {
  for (var t = "", e = "LINESTRING(", n = u(function (t) {
      e += t[0] + " " + t[1] + ",";
    }, "collect"), i = 0; i < this.geometries.length; i++) {
    if (0 === this.geometries[i].coords.length) return "LINESTRING(empty)";
    this.geometries[i].coords.forEach(n), t += e.substring(0, e.length - 1) + ")";
  }
  return t;
};
var EN = u(function (t, e, n) {
  if (!t || void 0 === t.x || void 0 === t.y) throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
  if (!e || void 0 === e.x || void 0 === e.y) throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
  this.start = new Dv(t.x, t.y), this.end = new Dv(e.x, e.y), this.properties = n || {};
  var i = this.start.x - this.end.x,
    r = this.start.y - this.end.y,
    o = Math.pow(Math.sin(r / 2), 2) + Math.cos(this.start.y) * Math.cos(this.end.y) * Math.pow(Math.sin(i / 2), 2);
  if (this.g = 2 * Math.asin(Math.sqrt(o)), this.g === Math.PI) throw new Error("it appears " + t.view() + " and " + e.view() + " are 'antipodal', e.g diametrically opposite, thus there is no single route but rather infinite");
  if (isNaN(this.g)) throw new Error("could not calculate great circle between " + t + " and " + e);
}, "GreatCircle");
EN.prototype.interpolate = function (t) {
  var e = Math.sin((1 - t) * this.g) / Math.sin(this.g),
    n = Math.sin(t * this.g) / Math.sin(this.g),
    i = e * Math.cos(this.start.y) * Math.cos(this.start.x) + n * Math.cos(this.end.y) * Math.cos(this.end.x),
    r = e * Math.cos(this.start.y) * Math.sin(this.start.x) + n * Math.cos(this.end.y) * Math.sin(this.end.x),
    o = e * Math.sin(this.start.y) + n * Math.sin(this.end.y),
    s = bN * Math.atan2(o, Math.sqrt(Math.pow(i, 2) + Math.pow(r, 2)));
  return [bN * Math.atan2(r, i), s];
}, EN.prototype.Arc = function (t, e) {
  var n = [];
  if (!t || t <= 2) n.push([this.start.lon, this.start.lat]), n.push([this.end.lon, this.end.lat]);else for (var i = 1 / (t - 1), r = 0; r < t; ++r) {
    var o = i * r,
      s = this.interpolate(o);
    n.push(s);
  }
  for (var a = !1, l = 0, u = e && e.offset ? e.offset : 10, h = 180 - u, c = -180 + u, p = 360 - u, d = 1; d < n.length; ++d) {
    var f = n[d - 1][0],
      m = n[d][0],
      g = Math.abs(m - f);
    g > p && (m > h && f < c || f > h && m < c) ? a = !0 : g > l && (l = g);
  }
  var v = [];
  if (a && l < u) {
    var y = [];
    v.push(y);
    for (var _ = 0; _ < n.length; ++_) {
      var x = parseFloat(n[_][0]);
      if (_ > 0 && Math.abs(x - n[_ - 1][0]) > p) {
        var E = parseFloat(n[_ - 1][0]),
          b = parseFloat(n[_ - 1][1]),
          w = parseFloat(n[_][0]),
          S = parseFloat(n[_][1]);
        if (E > -180 && E < c && 180 === w && _ + 1 < n.length && n[_ - 1][0] > -180 && n[_ - 1][0] < c) {
          y.push([-180, n[_][1]]), _++, y.push([n[_][0], n[_][1]]);
          continue;
        }
        if (E > h && E < 180 && -180 === w && _ + 1 < n.length && n[_ - 1][0] > h && n[_ - 1][0] < 180) {
          y.push([180, n[_][1]]), _++, y.push([n[_][0], n[_][1]]);
          continue;
        }
        if (E < c && w > h) {
          var M = E;
          E = w, w = M;
          var T = b;
          b = S, S = T;
        }
        if (E > h && w < c && (w += 360), E <= 180 && w >= 180 && E < w) {
          var A = (180 - E) / (w - E),
            P = A * S + (1 - A) * b;
          y.push([n[_ - 1][0] > h ? 180 : -180, P]), (y = []).push([n[_ - 1][0] > h ? -180 : 180, P]), v.push(y);
        } else y = [], v.push(y);
        y.push([x, n[_][1]]);
      } else y.push([n[_][0], n[_][1]]);
    }
  } else {
    var C = [];
    v.push(C);
    for (var I = 0; I < n.length; ++I) C.push([n[I][0], n[I][1]]);
  }
  for (var N = new F5(this.properties), L = 0; L < v.length; ++L) {
    var R = new MN();
    N.geometries.push(R);
    for (var O = v[L], q = 0; q < O.length; ++q) R.move_to(O[q]);
  }
  return N;
}, E();
var zie = Rt(SM());
E(), E(), E(), E(), E(), E();
var goe = Rt(SM()),
  voe = Rt(hP());
E(), E(), E(), E(), E(), E(), E();
var xoe = Rt(uM()),
  sn = [],
  an = [],
  ln = [],
  un = [],
  cn = [],
  hn = [],
  fn = [],
  pn = [],
  dn = [],
  mn = [],
  gn = [],
  vn = [],
  yn = [],
  _n = [],
  xn = [],
  bn = [],
  Mn = [],
  En = [],
  wn = [],
  Sn = [],
  Tn = [],
  Pn = [],
  Cn = [],
  An = [];
fn[85] = mn[85] = -1, pn[85] = gn[85] = 0, dn[85] = vn[85] = 1, wn[85] = Pn[85] = 1, Sn[85] = Cn[85] = 0, Tn[85] = An[85] = 1, sn[85] = un[85] = 0, an[85] = cn[85] = -1, ln[85] = xn[85] = 0, bn[85] = yn[85] = 0, Mn[85] = _n[85] = 1, hn[85] = En[85] = 1, Pn[1] = Pn[169] = 0, Cn[1] = Cn[169] = -1, An[1] = An[169] = 0, yn[1] = yn[169] = -1, _n[1] = _n[169] = 0, xn[1] = xn[169] = 0, mn[4] = mn[166] = 0, gn[4] = gn[166] = -1, vn[4] = vn[166] = 1, bn[4] = bn[166] = 1, Mn[4] = Mn[166] = 0, En[4] = En[166] = 0, fn[16] = fn[154] = 0, pn[16] = pn[154] = 1, dn[16] = dn[154] = 1, un[16] = un[154] = 1, cn[16] = cn[154] = 0, hn[16] = hn[154] = 1, wn[64] = wn[106] = 0, Sn[64] = Sn[106] = 1, Tn[64] = Tn[106] = 0, sn[64] = sn[106] = -1, an[64] = an[106] = 0, ln[64] = ln[106] = 1, wn[2] = wn[168] = 0, Sn[2] = Sn[168] = -1, Tn[2] = Tn[168] = 1, Pn[2] = Pn[168] = 0, Cn[2] = Cn[168] = -1, An[2] = An[168] = 0, yn[2] = yn[168] = -1, _n[2] = _n[168] = 0, xn[2] = xn[168] = 0, bn[2] = bn[168] = -1, Mn[2] = Mn[168] = 0, En[2] = En[168] = 1, fn[8] = fn[162] = 0, pn[8] = pn[162] = -1, dn[8] = dn[162] = 0, mn[8] = mn[162] = 0, gn[8] = gn[162] = -1, vn[8] = vn[162] = 1, yn[8] = yn[162] = 1, _n[8] = _n[162] = 0, xn[8] = xn[162] = 1, bn[8] = bn[162] = 1, Mn[8] = Mn[162] = 0, En[8] = En[162] = 0, fn[32] = fn[138] = 0, pn[32] = pn[138] = 1, dn[32] = dn[138] = 1, mn[32] = mn[138] = 0, gn[32] = gn[138] = 1, vn[32] = vn[138] = 0, sn[32] = sn[138] = 1, an[32] = an[138] = 0, ln[32] = ln[138] = 0, un[32] = un[138] = 1, cn[32] = cn[138] = 0, hn[32] = hn[138] = 1, Pn[128] = Pn[42] = 0, Cn[128] = Cn[42] = 1, An[128] = An[42] = 1, wn[128] = wn[42] = 0, Sn[128] = Sn[42] = 1, Tn[128] = Tn[42] = 0, sn[128] = sn[42] = -1, an[128] = an[42] = 0, ln[128] = ln[42] = 1, un[128] = un[42] = -1, cn[128] = cn[42] = 0, hn[128] = hn[42] = 0, mn[5] = mn[165] = -1, gn[5] = gn[165] = 0, vn[5] = vn[165] = 0, Pn[5] = Pn[165] = 1, Cn[5] = Cn[165] = 0, An[5] = An[165] = 0, bn[20] = bn[150] = 0, Mn[20] = Mn[150] = 1, En[20] = En[150] = 1, un[20] = un[150] = 0, cn[20] = cn[150] = -1, hn[20] = hn[150] = 1, fn[80] = fn[90] = -1, pn[80] = pn[90] = 0, dn[80] = dn[90] = 1, wn[80] = wn[90] = 1, Sn[80] = Sn[90] = 0, Tn[80] = Tn[90] = 1, yn[65] = yn[105] = 0, _n[65] = _n[105] = 1, xn[65] = xn[105] = 0, sn[65] = sn[105] = 0, an[65] = an[105] = -1, ln[65] = ln[105] = 0, fn[160] = fn[10] = -1, pn[160] = pn[10] = 0, dn[160] = dn[10] = 1, mn[160] = mn[10] = -1, gn[160] = gn[10] = 0, vn[160] = vn[10] = 0, Pn[160] = Pn[10] = 1, Cn[160] = Cn[10] = 0, An[160] = An[10] = 0, wn[160] = wn[10] = 1, Sn[160] = Sn[10] = 0, Tn[160] = Tn[10] = 1, bn[130] = bn[40] = 0, Mn[130] = Mn[40] = 1, En[130] = En[40] = 1, yn[130] = yn[40] = 0, _n[130] = _n[40] = 1, xn[130] = xn[40] = 0, sn[130] = sn[40] = 0, an[130] = an[40] = -1, ln[130] = ln[40] = 0, un[130] = un[40] = 0, cn[130] = cn[40] = -1, hn[130] = hn[40] = 1, mn[37] = mn[133] = 0, gn[37] = gn[133] = 1, vn[37] = vn[133] = 1, Pn[37] = Pn[133] = 0, Cn[37] = Cn[133] = 1, An[37] = An[133] = 0, sn[37] = sn[133] = -1, an[37] = an[133] = 0, ln[37] = ln[133] = 0, un[37] = un[133] = 1, cn[37] = cn[133] = 0, hn[37] = hn[133] = 0, bn[148] = bn[22] = -1, Mn[148] = Mn[22] = 0, En[148] = En[22] = 0, Pn[148] = Pn[22] = 0, Cn[148] = Cn[22] = -1, An[148] = An[22] = 1, wn[148] = wn[22] = 0, Sn[148] = Sn[22] = 1, Tn[148] = Tn[22] = 1, un[148] = un[22] = -1, cn[148] = cn[22] = 0, hn[148] = hn[22] = 1, fn[82] = fn[88] = 0, pn[82] = pn[88] = -1, dn[82] = dn[88] = 1, bn[82] = bn[88] = 1, Mn[82] = Mn[88] = 0, En[82] = En[88] = 1, yn[82] = yn[88] = -1, _n[82] = _n[88] = 0, xn[82] = xn[88] = 1, wn[82] = wn[88] = 0, Sn[82] = Sn[88] = -1, Tn[82] = Tn[88] = 0, fn[73] = fn[97] = 0, pn[73] = pn[97] = 1, dn[73] = dn[97] = 0, mn[73] = mn[97] = 0, gn[73] = gn[97] = -1, vn[73] = vn[97] = 0, yn[73] = yn[97] = 1, _n[73] = _n[97] = 0, xn[73] = xn[97] = 0, sn[73] = sn[97] = 1, an[73] = an[97] = 0, ln[73] = ln[97] = 1, fn[145] = fn[25] = 0, pn[145] = pn[25] = -1, dn[145] = dn[25] = 0, yn[145] = yn[25] = 1, _n[145] = _n[25] = 0, xn[145] = xn[25] = 1, Pn[145] = Pn[25] = 0, Cn[145] = Cn[25] = 1, An[145] = An[25] = 1, un[145] = un[25] = -1, cn[145] = cn[25] = 0, hn[145] = hn[25] = 0, mn[70] = mn[100] = 0, gn[70] = gn[100] = 1, vn[70] = vn[100] = 0, bn[70] = bn[100] = -1, Mn[70] = Mn[100] = 0, En[70] = En[100] = 1, wn[70] = wn[100] = 0, Sn[70] = Sn[100] = -1, Tn[70] = Tn[100] = 1, sn[70] = sn[100] = 1, an[70] = an[100] = 0, ln[70] = ln[100] = 0, mn[101] = mn[69] = 0, gn[101] = gn[69] = 1, vn[101] = vn[69] = 0, sn[101] = sn[69] = 1, an[101] = an[69] = 0, ln[101] = ln[69] = 0, Pn[149] = Pn[21] = 0, Cn[149] = Cn[21] = 1, An[149] = An[21] = 1, un[149] = un[21] = -1, cn[149] = cn[21] = 0, hn[149] = hn[21] = 0, bn[86] = bn[84] = -1, Mn[86] = Mn[84] = 0, En[86] = En[84] = 1, wn[86] = wn[84] = 0, Sn[86] = Sn[84] = -1, Tn[86] = Tn[84] = 1, fn[89] = fn[81] = 0, pn[89] = pn[81] = -1, dn[89] = dn[81] = 0, yn[89] = yn[81] = 1, _n[89] = _n[81] = 0, xn[89] = xn[81] = 1, fn[96] = fn[74] = 0, pn[96] = pn[74] = 1, dn[96] = dn[74] = 0, mn[96] = mn[74] = -1, gn[96] = gn[74] = 0, vn[96] = vn[74] = 1, wn[96] = wn[74] = 1, Sn[96] = Sn[74] = 0, Tn[96] = Tn[74] = 0, sn[96] = sn[74] = 1, an[96] = an[74] = 0, ln[96] = ln[74] = 1, fn[24] = fn[146] = 0, pn[24] = pn[146] = -1, dn[24] = dn[146] = 1, bn[24] = bn[146] = 1, Mn[24] = Mn[146] = 0, En[24] = En[146] = 1, yn[24] = yn[146] = 0, _n[24] = _n[146] = 1, xn[24] = xn[146] = 1, un[24] = un[146] = 0, cn[24] = cn[146] = -1, hn[24] = hn[146] = 0, mn[6] = mn[164] = -1, gn[6] = gn[164] = 0, vn[6] = vn[164] = 1, bn[6] = bn[164] = -1, Mn[6] = Mn[164] = 0, En[6] = En[164] = 0, Pn[6] = Pn[164] = 0, Cn[6] = Cn[164] = -1, An[6] = An[164] = 1, wn[6] = wn[164] = 1, Sn[6] = Sn[164] = 0, Tn[6] = Tn[164] = 0, yn[129] = yn[41] = 0, _n[129] = _n[41] = 1, xn[129] = xn[41] = 1, Pn[129] = Pn[41] = 0, Cn[129] = Cn[41] = 1, An[129] = An[41] = 0, sn[129] = sn[41] = -1, an[129] = an[41] = 0, ln[129] = ln[41] = 0, un[129] = un[41] = 0, cn[129] = cn[41] = -1, hn[129] = hn[41] = 0, bn[66] = bn[104] = 0, Mn[66] = Mn[104] = 1, En[66] = En[104] = 0, yn[66] = yn[104] = -1, _n[66] = _n[104] = 0, xn[66] = xn[104] = 1, wn[66] = wn[104] = 0, Sn[66] = Sn[104] = -1, Tn[66] = Tn[104] = 0, sn[66] = sn[104] = 0, an[66] = an[104] = -1, ln[66] = ln[104] = 1, fn[144] = fn[26] = -1, pn[144] = pn[26] = 0, dn[144] = dn[26] = 0, Pn[144] = Pn[26] = 1, Cn[144] = Cn[26] = 0, An[144] = An[26] = 1, wn[144] = wn[26] = 0, Sn[144] = Sn[26] = 1, Tn[144] = Tn[26] = 1, un[144] = un[26] = -1, cn[144] = cn[26] = 0, hn[144] = hn[26] = 1, mn[36] = mn[134] = 0, gn[36] = gn[134] = 1, vn[36] = vn[134] = 1, bn[36] = bn[134] = 0, Mn[36] = Mn[134] = 1, En[36] = En[134] = 0, sn[36] = sn[134] = 0, an[36] = an[134] = -1, ln[36] = ln[134] = 1, un[36] = un[134] = 1, cn[36] = cn[134] = 0, hn[36] = hn[134] = 0, fn[9] = fn[161] = -1, pn[9] = pn[161] = 0, dn[9] = dn[161] = 0, mn[9] = mn[161] = 0, gn[9] = gn[161] = -1, vn[9] = vn[161] = 0, yn[9] = yn[161] = 1, _n[9] = _n[161] = 0, xn[9] = xn[161] = 0, Pn[9] = Pn[161] = 1, Cn[9] = Cn[161] = 0, An[9] = An[161] = 1, fn[136] = 0, pn[136] = 1, dn[136] = 1, mn[136] = 0, gn[136] = 1, vn[136] = 0, bn[136] = -1, Mn[136] = 0, En[136] = 1, yn[136] = -1, _n[136] = 0, xn[136] = 0, Pn[136] = 0, Cn[136] = -1, An[136] = 0, wn[136] = 0, Sn[136] = -1, Tn[136] = 1, sn[136] = 1, an[136] = 0, ln[136] = 0, un[136] = 1, cn[136] = 0, hn[136] = 1, fn[34] = 0, pn[34] = -1, dn[34] = 0, mn[34] = 0, gn[34] = -1, vn[34] = 1, bn[34] = 1, Mn[34] = 0, En[34] = 0, yn[34] = 1, _n[34] = 0, xn[34] = 1, Pn[34] = 0, Cn[34] = 1, An[34] = 1, wn[34] = 0, Sn[34] = 1, Tn[34] = 0, sn[34] = -1, an[34] = 0, ln[34] = 1, un[34] = -1, cn[34] = 0, hn[34] = 0, fn[35] = 0, pn[35] = 1, dn[35] = 1, mn[35] = 0, gn[35] = -1, vn[35] = 1, bn[35] = 1, Mn[35] = 0, En[35] = 0, yn[35] = -1, _n[35] = 0, xn[35] = 0, Pn[35] = 0, Cn[35] = -1, An[35] = 0, wn[35] = 0, Sn[35] = 1, Tn[35] = 0, sn[35] = -1, an[35] = 0, ln[35] = 1, un[35] = 1, cn[35] = 0, hn[35] = 1, fn[153] = 0, pn[153] = 1, dn[153] = 1, yn[153] = -1, _n[153] = 0, xn[153] = 0, Pn[153] = 0, Cn[153] = -1, An[153] = 0, un[153] = 1, cn[153] = 0, hn[153] = 1, mn[102] = 0, gn[102] = -1, vn[102] = 1, bn[102] = 1, Mn[102] = 0, En[102] = 0, wn[102] = 0, Sn[102] = 1, Tn[102] = 0, sn[102] = -1, an[102] = 0, ln[102] = 1, fn[155] = 0, pn[155] = -1, dn[155] = 0, yn[155] = 1, _n[155] = 0, xn[155] = 1, Pn[155] = 0, Cn[155] = 1, An[155] = 1, un[155] = -1, cn[155] = 0, hn[155] = 0, mn[103] = 0, gn[103] = 1, vn[103] = 0, bn[103] = -1, Mn[103] = 0, En[103] = 1, wn[103] = 0, Sn[103] = -1, Tn[103] = 1, sn[103] = 1, an[103] = 0, ln[103] = 0, fn[152] = 0, pn[152] = 1, dn[152] = 1, bn[152] = -1, Mn[152] = 0, En[152] = 1, yn[152] = -1, _n[152] = 0, xn[152] = 0, Pn[152] = 0, Cn[152] = -1, An[152] = 0, wn[152] = 0, Sn[152] = -1, Tn[152] = 1, un[152] = 1, cn[152] = 0, hn[152] = 1, fn[156] = 0, pn[156] = -1, dn[156] = 1, bn[156] = 1, Mn[156] = 0, En[156] = 1, yn[156] = -1, _n[156] = 0, xn[156] = 0, Pn[156] = 0, Cn[156] = -1, An[156] = 0, wn[156] = 0, Sn[156] = 1, Tn[156] = 1, un[156] = -1, cn[156] = 0, hn[156] = 1, fn[137] = 0, pn[137] = 1, dn[137] = 1, mn[137] = 0, gn[137] = 1, vn[137] = 0, yn[137] = -1, _n[137] = 0, xn[137] = 0, Pn[137] = 0, Cn[137] = -1, An[137] = 0, sn[137] = 1, an[137] = 0, ln[137] = 0, un[137] = 1, cn[137] = 0, hn[137] = 1, fn[139] = 0, pn[139] = 1, dn[139] = 1, mn[139] = 0, gn[139] = -1, vn[139] = 0, yn[139] = 1, _n[139] = 0, xn[139] = 0, Pn[139] = 0, Cn[139] = 1, An[139] = 0, sn[139] = -1, an[139] = 0, ln[139] = 0, un[139] = 1, cn[139] = 0, hn[139] = 1, fn[98] = 0, pn[98] = -1, dn[98] = 0, mn[98] = 0, gn[98] = -1, vn[98] = 1, bn[98] = 1, Mn[98] = 0, En[98] = 0, yn[98] = 1, _n[98] = 0, xn[98] = 1, wn[98] = 0, Sn[98] = 1, Tn[98] = 0, sn[98] = -1, an[98] = 0, ln[98] = 1, fn[99] = 0, pn[99] = 1, dn[99] = 0, mn[99] = 0, gn[99] = -1, vn[99] = 1, bn[99] = 1, Mn[99] = 0, En[99] = 0, yn[99] = -1, _n[99] = 0, xn[99] = 1, wn[99] = 0, Sn[99] = -1, Tn[99] = 0, sn[99] = 1, an[99] = 0, ln[99] = 1, mn[38] = 0, gn[38] = -1, vn[38] = 1, bn[38] = 1, Mn[38] = 0, En[38] = 0, Pn[38] = 0, Cn[38] = 1, An[38] = 1, wn[38] = 0, Sn[38] = 1, Tn[38] = 0, sn[38] = -1, an[38] = 0, ln[38] = 1, un[38] = -1, cn[38] = 0, hn[38] = 0, mn[39] = 0, gn[39] = 1, vn[39] = 1, bn[39] = -1, Mn[39] = 0, En[39] = 0, Pn[39] = 0, Cn[39] = -1, An[39] = 1, wn[39] = 0, Sn[39] = 1, Tn[39] = 0, sn[39] = -1, an[39] = 0, ln[39] = 1, un[39] = 1, cn[39] = 0, hn[39] = 0;
var fP = u(function (t) {
    return [[t.bottomleft, 0], [0, 0], [0, t.leftbottom]];
  }, "p00"),
  pP = u(function (t) {
    return [[1, t.rightbottom], [1, 0], [t.bottomright, 0]];
  }, "p01"),
  dP = u(function (t) {
    return [[t.topright, 1], [1, 1], [1, t.righttop]];
  }, "p02"),
  mP = u(function (t) {
    return [[0, t.lefttop], [0, 1], [t.topleft, 1]];
  }, "p03"),
  gP = u(function (t) {
    return [[t.bottomright, 0], [t.bottomleft, 0], [0, t.leftbottom], [0, t.lefttop]];
  }, "p04"),
  vP = u(function (t) {
    return [[t.bottomright, 0], [t.bottomleft, 0], [1, t.righttop], [1, t.rightbottom]];
  }, "p05"),
  yP = u(function (t) {
    return [[1, t.righttop], [1, t.rightbottom], [t.topleft, 1], [t.topright, 1]];
  }, "p06"),
  _P = u(function (t) {
    return [[0, t.leftbottom], [0, t.lefttop], [t.topleft, 1], [t.topright, 1]];
  }, "p07"),
  boe = u(function (t) {
    return [[0, 0], [0, t.leftbottom], [1, t.rightbottom], [1, 0]];
  }, "p08"),
  Moe = u(function (t) {
    return [[1, 0], [t.bottomright, 0], [t.topright, 1], [1, 1]];
  }, "p09"),
  Eoe = u(function (t) {
    return [[1, 1], [1, t.righttop], [0, t.lefttop], [0, 1]];
  }, "p10"),
  woe = u(function (t) {
    return [[t.bottomleft, 0], [0, 0], [0, 1], [t.topleft, 1]];
  }, "p11"),
  Soe = u(function (t) {
    return [[1, t.righttop], [1, t.rightbottom], [0, t.leftbottom], [0, t.lefttop]];
  }, "p12"),
  Toe = u(function (t) {
    return [[t.topleft, 1], [t.topright, 1], [t.bottomright, 0], [t.bottomleft, 0]];
  }, "p13"),
  Poe = u(function () {
    return [[0, 0], [0, 1], [1, 1], [1, 0]];
  }, "p14"),
  Coe = u(function (t) {
    return [[1, t.rightbottom], [1, 0], [0, 0], [0, 1], [t.topleft, 1]];
  }, "p15"),
  Aoe = u(function (t) {
    return [[t.topright, 1], [1, 1], [1, 0], [0, 0], [0, t.leftbottom]];
  }, "p16"),
  Ioe = u(function (t) {
    return [[1, 0], [t.bottomright, 0], [0, t.lefttop], [0, 1], [1, 1]];
  }, "p17"),
  Loe = u(function (t) {
    return [[1, 1], [1, t.righttop], [t.bottomleft, 0], [0, 0], [0, 1]];
  }, "p18"),
  Ooe = u(function (t) {
    return [[1, t.righttop], [1, t.rightbottom], [0, t.lefttop], [0, 1], [t.topleft, 1]];
  }, "p19"),
  Roe = u(function (t) {
    return [[1, 1], [1, t.righttop], [t.bottomright, 0], [t.bottomleft, 0], [t.topright, 1]];
  }, "p20"),
  Noe = u(function (t) {
    return [[1, t.rightbottom], [1, 0], [t.bottomright, 0], [0, t.leftbottom], [0, t.lefttop]];
  }, "p21"),
  Doe = u(function (t) {
    return [[t.topright, 1], [t.bottomleft, 0], [0, 0], [0, t.leftbottom], [t.topleft, 1]];
  }, "p22"),
  qoe = u(function (t) {
    return [[t.bottomright, 0], [t.bottomleft, 0], [0, t.lefttop], [0, 1], [t.topleft, 1]];
  }, "p23"),
  koe = u(function (t) {
    return [[1, 1], [1, t.righttop], [0, t.leftbottom], [0, t.lefttop], [t.topright, 1]];
  }, "p24"),
  Foe = u(function (t) {
    return [[1, t.rightbottom], [1, 0], [t.bottomright, 0], [t.topleft, 1], [t.topright, 1]];
  }, "p25"),
  Boe = u(function (t) {
    return [[1, t.righttop], [1, t.rightbottom], [t.bottomleft, 0], [0, 0], [0, t.leftbottom]];
  }, "p26"),
  Uoe = u(function (t) {
    return [[1, t.rightbottom], [1, 0], [0, 0], [0, t.leftbottom], [t.topleft, 1], [t.topright, 1]];
  }, "p27"),
  zoe = u(function (t) {
    return [[1, 1], [1, 0], [t.bottomright, 0], [0, t.leftbottom], [0, t.lefttop], [t.topright, 1]];
  }, "p28"),
  Voe = u(function (t) {
    return [[1, 1], [1, t.righttop], [t.bottomright, 0], [t.bottomleft, 0], [0, t.lefttop], [0, 1]];
  }, "p29"),
  Goe = u(function (t) {
    return [[1, t.righttop], [1, t.rightbottom], [t.bottomleft, 0], [0, 0], [0, 1], [t.topleft, 1]];
  }, "p30"),
  Hoe = u(function (t) {
    return [[1, 1], [1, t.righttop], [t.bottomleft, 0], [0, 0], [0, t.leftbottom], [t.topright, 1]];
  }, "p31"),
  joe = u(function (t) {
    return [[1, t.rightbottom], [1, 0], [t.bottomright, 0], [0, t.lefttop], [0, 1], [t.topleft, 1]];
  }, "p32"),
  Woe = u(function (t) {
    return [[1, t.righttop], [1, t.rightbottom], [t.bottomright, 0], [t.bottomleft, 0], [0, t.leftbottom], [0, t.lefttop], [t.topleft, 1], [t.topright, 1]];
  }, "p33"),
  Xoe = u(function (t) {
    return [[1, 1], [1, t.righttop], [t.bottomleft, 0], [0, 0], [0, t.leftbottom], [t.topright, 1]];
  }, "p34"),
  Yoe = u(function (t) {
    return [[1, t.rightbottom], [1, 0], [t.bottomright, 0], [0, t.lefttop], [0, 1], [t.topleft, 1]];
  }, "p35"),
  Zoe = u(function (t) {
    return [[1, 1], [1, t.righttop], [t.bottomright, 0], [t.bottomleft, 0], [0, t.leftbottom], [0, t.lefttop], [t.topright, 1]];
  }, "p36"),
  Joe = u(function (t) {
    return [[1, t.righttop], [1, t.rightbottom], [t.bottomleft, 0], [0, 0], [0, t.leftbottom], [t.topleft, 1], [t.topright, 1]];
  }, "p37"),
  Koe = u(function (t) {
    return [[1, t.righttop], [1, t.rightbottom], [t.bottomright, 0], [t.bottomleft, 0], [0, t.lefttop], [0, 1], [t.topleft, 1]];
  }, "p38"),
  Qoe = u(function (t) {
    return [[1, t.rightbottom], [1, 0], [t.bottomright, 0], [0, t.leftbottom], [0, t.lefttop], [t.topleft, 1], [t.topright, 1]];
  }, "p39"),
  qn = [],
  kn = [],
  Fn = [],
  Bn = [],
  Un = [],
  zn = [],
  Vn = [],
  Gn = [];
Bn[1] = Un[1] = 18, Bn[169] = Un[169] = 18, Fn[4] = kn[4] = 12, Fn[166] = kn[166] = 12, qn[16] = Gn[16] = 4, qn[154] = Gn[154] = 4, zn[64] = Vn[64] = 22, zn[106] = Vn[106] = 22, Fn[2] = zn[2] = 17, Bn[2] = Un[2] = 18, Fn[168] = zn[168] = 17, Bn[168] = Un[168] = 18, qn[8] = Bn[8] = 9, kn[8] = Fn[8] = 12, qn[162] = Bn[162] = 9, kn[162] = Fn[162] = 12, qn[32] = Gn[32] = 4, kn[32] = Vn[32] = 1, qn[138] = Gn[138] = 4, kn[138] = Vn[138] = 1, Un[128] = Gn[128] = 21, zn[128] = Vn[128] = 22, Un[42] = Gn[42] = 21, zn[42] = Vn[42] = 22, kn[5] = Un[5] = 14, kn[165] = Un[165] = 14, Fn[20] = Gn[20] = 6, Fn[150] = Gn[150] = 6, qn[80] = zn[80] = 11, qn[90] = zn[90] = 11, Bn[65] = Vn[65] = 3, Bn[105] = Vn[105] = 3, qn[160] = zn[160] = 11, kn[160] = Un[160] = 14, qn[10] = zn[10] = 11, kn[10] = Un[10] = 14, Fn[130] = Gn[130] = 6, Bn[130] = Vn[130] = 3, Fn[40] = Gn[40] = 6, Bn[40] = Vn[40] = 3, kn[101] = Vn[101] = 1, kn[69] = Vn[69] = 1, Un[149] = Gn[149] = 21, Un[21] = Gn[21] = 21, Fn[86] = zn[86] = 17, Fn[84] = zn[84] = 17, qn[89] = Bn[89] = 9, qn[81] = Bn[81] = 9, qn[96] = Vn[96] = 0, kn[96] = zn[96] = 15, qn[74] = Vn[74] = 0, kn[74] = zn[74] = 15, qn[24] = Fn[24] = 8, Bn[24] = Gn[24] = 7, qn[146] = Fn[146] = 8, Bn[146] = Gn[146] = 7, kn[6] = zn[6] = 15, Fn[6] = Un[6] = 16, kn[164] = zn[164] = 15, Fn[164] = Un[164] = 16, Bn[129] = Gn[129] = 7, Un[129] = Vn[129] = 20, Bn[41] = Gn[41] = 7, Un[41] = Vn[41] = 20, Fn[66] = Vn[66] = 2, Bn[66] = zn[66] = 19, Fn[104] = Vn[104] = 2, Bn[104] = zn[104] = 19, qn[144] = Un[144] = 10, zn[144] = Gn[144] = 23, qn[26] = Un[26] = 10, zn[26] = Gn[26] = 23, kn[36] = Gn[36] = 5, Fn[36] = Vn[36] = 2, kn[134] = Gn[134] = 5, Fn[134] = Vn[134] = 2, qn[9] = Un[9] = 10, kn[9] = Bn[9] = 13, qn[161] = Un[161] = 10, kn[161] = Bn[161] = 13, kn[37] = Gn[37] = 5, Un[37] = Vn[37] = 20, kn[133] = Gn[133] = 5, Un[133] = Vn[133] = 20, Fn[148] = Un[148] = 16, zn[148] = Gn[148] = 23, Fn[22] = Un[22] = 16, zn[22] = Gn[22] = 23, qn[82] = Fn[82] = 8, Bn[82] = zn[82] = 19, qn[88] = Fn[88] = 8, Bn[88] = zn[88] = 19, qn[73] = Vn[73] = 0, kn[73] = Bn[73] = 13, qn[97] = Vn[97] = 0, kn[97] = Bn[97] = 13, qn[145] = Bn[145] = 9, Un[145] = Gn[145] = 21, qn[25] = Bn[25] = 9, Un[25] = Gn[25] = 21, kn[70] = Vn[70] = 1, Fn[70] = zn[70] = 17, kn[100] = Vn[100] = 1, Fn[100] = zn[100] = 17, qn[34] = Bn[34] = 9, kn[34] = Fn[34] = 12, Un[34] = Gn[34] = 21, zn[34] = Vn[34] = 22, qn[136] = Gn[136] = 4, kn[136] = Vn[136] = 1, Fn[136] = zn[136] = 17, Bn[136] = Un[136] = 18, qn[35] = Gn[35] = 4, kn[35] = Fn[35] = 12, Bn[35] = Un[35] = 18, zn[35] = Vn[35] = 22, qn[153] = Gn[153] = 4, Bn[153] = Un[153] = 18, kn[102] = Fn[102] = 12, zn[102] = Vn[102] = 22, qn[155] = Bn[155] = 9, Un[155] = Gn[155] = 23, kn[103] = Vn[103] = 1, Fn[103] = zn[103] = 17, qn[152] = Gn[152] = 4, Fn[152] = zn[152] = 17, Bn[152] = Un[152] = 18, qn[156] = Fn[156] = 8, Bn[156] = Un[156] = 18, zn[156] = Gn[156] = 23, qn[137] = Gn[137] = 4, kn[137] = Vn[137] = 1, Bn[137] = Un[137] = 18, qn[139] = Gn[139] = 4, kn[139] = Bn[139] = 13, Un[139] = Vn[139] = 20, qn[98] = Bn[98] = 9, kn[98] = Fn[98] = 12, zn[98] = Vn[98] = 22, qn[99] = Vn[99] = 0, kn[99] = Fn[99] = 12, Bn[99] = zn[99] = 19, kn[38] = Fn[38] = 12, Un[38] = Gn[38] = 21, zn[38] = Vn[38] = 22, kn[39] = Gn[39] = 5, Fn[39] = Un[39] = 16, zn[39] = Vn[39] = 22;
var ct = [];
function ese(t) {
  return (t > 0) - (t < 0) || +t;
}
function hm(t, e, n) {
  var i = e[0] - t[0],
    r = e[1] - t[1],
    o = n[0] - e[0];
  return ese(i * (n[1] - e[1]) - o * r);
}
function dq(t, e) {
  var n = t.geometry.coordinates[0].map(function (t) {
      return t[0];
    }),
    i = t.geometry.coordinates[0].map(function (t) {
      return t[1];
    }),
    r = e.geometry.coordinates[0].map(function (t) {
      return t[0];
    }),
    o = e.geometry.coordinates[0].map(function (t) {
      return t[1];
    });
  return Math.max.apply(null, n) === Math.max.apply(null, r) && Math.max.apply(null, i) === Math.max.apply(null, o) && Math.min.apply(null, n) === Math.min.apply(null, r) && Math.min.apply(null, i) === Math.min.apply(null, o);
}
function xP(t, e) {
  return e.geometry.coordinates[0].every(function (e) {
    return go(Yn(e), t);
  });
}
function mq(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}
ct[1] = ct[169] = fP, ct[4] = ct[166] = pP, ct[16] = ct[154] = dP, ct[64] = ct[106] = mP, ct[168] = ct[2] = gP, ct[162] = ct[8] = vP, ct[138] = ct[32] = yP, ct[42] = ct[128] = _P, ct[5] = ct[165] = boe, ct[20] = ct[150] = Moe, ct[80] = ct[90] = Eoe, ct[65] = ct[105] = woe, ct[160] = ct[10] = Soe, ct[130] = ct[40] = Toe, ct[85] = Poe, ct[101] = ct[69] = Coe, ct[149] = ct[21] = Aoe, ct[86] = ct[84] = Ioe, ct[89] = ct[81] = Loe, ct[96] = ct[74] = Ooe, ct[24] = ct[146] = Roe, ct[6] = ct[164] = Noe, ct[129] = ct[41] = Doe, ct[66] = ct[104] = qoe, ct[144] = ct[26] = koe, ct[36] = ct[134] = Foe, ct[9] = ct[161] = Boe, ct[37] = ct[133] = Uoe, ct[148] = ct[22] = zoe, ct[82] = ct[88] = Voe, ct[73] = ct[97] = Goe, ct[145] = ct[25] = Hoe, ct[70] = ct[100] = joe, ct[34] = function (t) {
  return [_P(t), vP(t)];
}, ct[35] = Woe, ct[136] = function (t) {
  return [yP(t), gP(t)];
}, ct[153] = function (t) {
  return [dP(t), fP(t)];
}, ct[102] = function (t) {
  return [pP(t), mP(t)];
}, ct[155] = Xoe, ct[103] = Yoe, ct[152] = function (t) {
  return [dP(t), gP(t)];
}, ct[156] = Zoe, ct[137] = function (t) {
  return [yP(t), fP(t)];
}, ct[139] = Joe, ct[98] = function (t) {
  return [vP(t), mP(t)];
}, ct[99] = Koe, ct[38] = function (t) {
  return [pP(t), _P(t)];
}, ct[39] = Qoe, E(), E(), E(), E(), E(), E(), E(), E(), u(ese, "mathSign"), u(hm, "orientationIndex"), u(dq, "envelopeIsEqual"), u(xP, "envelopeContains"), u(mq, "coordinatesEqual");
var tse = function () {
    function t(e) {
      this.id = t.buildId(e), this.coordinates = e, this.innerEdges = [], this.outerEdges = [], this.outerEdgesSorted = !1;
    }
    return u(t, "Node"), t.buildId = function (t) {
      return t.join(",");
    }, t.prototype.removeInnerEdge = function (t) {
      this.innerEdges = this.innerEdges.filter(function (e) {
        return e.from.id !== t.from.id;
      });
    }, t.prototype.removeOuterEdge = function (t) {
      this.outerEdges = this.outerEdges.filter(function (e) {
        return e.to.id !== t.to.id;
      });
    }, t.prototype.addOuterEdge = function (t) {
      this.outerEdges.push(t), this.outerEdgesSorted = !1;
    }, t.prototype.sortOuterEdges = function () {
      var t = this;
      this.outerEdgesSorted || (this.outerEdges.sort(function (e, n) {
        var i = e.to,
          r = n.to;
        if (i.coordinates[0] - t.coordinates[0] >= 0 && r.coordinates[0] - t.coordinates[0] < 0) return 1;
        if (i.coordinates[0] - t.coordinates[0] < 0 && r.coordinates[0] - t.coordinates[0] >= 0) return -1;
        if (i.coordinates[0] - t.coordinates[0] == 0 && r.coordinates[0] - t.coordinates[0] == 0) return i.coordinates[1] - t.coordinates[1] >= 0 || r.coordinates[1] - t.coordinates[1] >= 0 ? i.coordinates[1] - r.coordinates[1] : r.coordinates[1] - i.coordinates[1];
        var o = hm(t.coordinates, i.coordinates, r.coordinates);
        return o < 0 ? 1 : o > 0 ? -1 : Math.pow(i.coordinates[0] - t.coordinates[0], 2) + Math.pow(i.coordinates[1] - t.coordinates[1], 2) - (Math.pow(r.coordinates[0] - t.coordinates[0], 2) + Math.pow(r.coordinates[1] - t.coordinates[1], 2));
      }), this.outerEdgesSorted = !0);
    }, t.prototype.getOuterEdges = function () {
      return this.sortOuterEdges(), this.outerEdges;
    }, t.prototype.getOuterEdge = function (t) {
      return this.sortOuterEdges(), this.outerEdges[t];
    }, t.prototype.addInnerEdge = function (t) {
      this.innerEdges.push(t);
    }, t;
  }(),
  bP = tse;
E();
var nse = function () {
    function t(t, e) {
      this.from = t, this.to = e, this.next = void 0, this.label = void 0, this.symetric = void 0, this.ring = void 0, this.from.addOuterEdge(this), this.to.addInnerEdge(this);
    }
    return u(t, "Edge"), t.prototype.getSymetric = function () {
      return this.symetric || (this.symetric = new t(this.to, this.from), this.symetric.symetric = this), this.symetric;
    }, t.prototype.deleteEdge = function () {
      this.from.removeOuterEdge(this), this.to.removeInnerEdge(this);
    }, t.prototype.isEqual = function (t) {
      return this.from.id === t.from.id && this.to.id === t.to.id;
    }, t.prototype.toString = function () {
      return "Edge { " + this.from.id + " -> " + this.to.id + " }";
    }, t.prototype.toLineString = function () {
      return Qi([this.from.coordinates, this.to.coordinates]);
    }, t.prototype.compareTo = function (t) {
      return hm(t.from.coordinates, t.to.coordinates, this.to.coordinates);
    }, t;
  }(),
  gq = nse;
E();
var ise = function () {
    function t() {
      this.edges = [], this.polygon = void 0, this.envelope = void 0;
    }
    return u(t, "EdgeRing"), t.prototype.push = function (t) {
      this.edges.push(t), this.polygon = this.envelope = void 0;
    }, t.prototype.get = function (t) {
      return this.edges[t];
    }, Object.defineProperty(t.prototype, "length", {
      get: function () {
        return this.edges.length;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.forEach = function (t) {
      this.edges.forEach(t);
    }, t.prototype.map = function (t) {
      return this.edges.map(t);
    }, t.prototype.some = function (t) {
      return this.edges.some(t);
    }, t.prototype.isValid = function () {
      return !0;
    }, t.prototype.isHole = function () {
      var t = this,
        e = this.edges.reduce(function (e, n, i) {
          return n.from.coordinates[1] > t.edges[e].from.coordinates[1] && (e = i), e;
        }, 0),
        n = (0 === e ? this.length : e) - 1,
        i = (e + 1) % this.length,
        r = hm(this.edges[n].from.coordinates, this.edges[e].from.coordinates, this.edges[i].from.coordinates);
      return 0 === r ? this.edges[n].from.coordinates[0] > this.edges[i].from.coordinates[0] : r > 0;
    }, t.prototype.toMultiPoint = function () {
      return e5(this.edges.map(function (t) {
        return t.from.coordinates;
      }));
    }, t.prototype.toPolygon = function () {
      if (this.polygon) return this.polygon;
      var t = this.edges.map(function (t) {
        return t.from.coordinates;
      });
      return t.push(this.edges[0].from.coordinates), this.polygon = Ii([t]);
    }, t.prototype.getEnvelope = function () {
      return this.envelope ? this.envelope : this.envelope = y5(this.toPolygon());
    }, t.findEdgeRingContaining = function (t, e) {
      var n,
        i,
        r = t.getEnvelope();
      return e.forEach(function (e) {
        var o = e.getEnvelope();
        if (i && (n = i.getEnvelope()), !dq(o, r) && xP(o, r)) {
          for (var s = t.map(function (t) {
              return t.from.coordinates;
            }), a = void 0, l = u(function (t) {
              e.some(function (e) {
                return mq(t, e.from.coordinates);
              }) || (a = t);
            }, "_loop_1"), h = 0, c = s; h < c.length; h++) {
            l(c[h]);
          }
          a && e.inside(Yn(a)) && (!i || xP(n, o)) && (i = e);
        }
      }), i;
    }, t.prototype.inside = function (t) {
      return go(t, this.toPolygon());
    }, t;
  }(),
  MP = ise;
function rse(t) {
  if (!t) throw new Error("No geojson passed");
  if ("FeatureCollection" !== t.type && "GeometryCollection" !== t.type && "MultiLineString" !== t.type && "LineString" !== t.type && "Feature" !== t.type) throw new Error("Invalid input type '" + t.type + "'. Geojson must be FeatureCollection, GeometryCollection, LineString, MultiLineString or Feature");
}
u(rse, "validateGeoJson");
var X4e = function () {
  function t() {
    this.edges = [], this.nodes = {};
  }
  return u(t, "Graph"), t.fromGeoJson = function (e) {
    rse(e);
    var n = new t();
    return Yo(e, function (t) {
      n5(t, "LineString", "Graph::fromGeoJson"), MR(t, function (t, e) {
        if (t) {
          var i = n.getNode(t),
            r = n.getNode(e);
          n.addEdge(i, r);
        }
        return e;
      });
    }), n;
  }, t.prototype.getNode = function (t) {
    var e = bP.buildId(t),
      n = this.nodes[e];
    return n || (n = this.nodes[e] = new bP(t)), n;
  }, t.prototype.addEdge = function (t, e) {
    var n = new gq(t, e),
      i = n.getSymetric();
    this.edges.push(n), this.edges.push(i);
  }, t.prototype.deleteDangles = function () {
    var t = this;
    Object.keys(this.nodes).map(function (e) {
      return t.nodes[e];
    }).forEach(function (e) {
      return t._removeIfDangle(e);
    });
  }, t.prototype._removeIfDangle = function (t) {
    var e = this;
    if (t.innerEdges.length <= 1) {
      var n = t.getOuterEdges().map(function (t) {
        return t.to;
      });
      this.removeNode(t), n.forEach(function (t) {
        return e._removeIfDangle(t);
      });
    }
  }, t.prototype.deleteCutEdges = function () {
    var t = this;
    this._computeNextCWEdges(), this._findLabeledEdgeRings(), this.edges.forEach(function (e) {
      e.label === e.symetric.label && (t.removeEdge(e.symetric), t.removeEdge(e));
    });
  }, t.prototype._computeNextCWEdges = function (t) {
    var e = this;
    void 0 === t ? Object.keys(this.nodes).forEach(function (t) {
      return e._computeNextCWEdges(e.nodes[t]);
    }) : t.getOuterEdges().forEach(function (e, n) {
      t.getOuterEdge((0 === n ? t.getOuterEdges().length : n) - 1).symetric.next = e;
    });
  }, t.prototype._computeNextCCWEdges = function (t, e) {
    for (var n, i, r = t.getOuterEdges(), o = r.length - 1; o >= 0; --o) {
      var s = r[o],
        a = s.symetric,
        l = void 0,
        u = void 0;
      s.label === e && (l = s), a.label === e && (u = a), l && u && (u && (i = u), l && (i && (i.next = l, i = void 0), n || (n = l)));
    }
    i && (i.next = n);
  }, t.prototype._findLabeledEdgeRings = function () {
    var t = [],
      e = 0;
    return this.edges.forEach(function (n) {
      if (!(n.label >= 0)) {
        t.push(n);
        var i = n;
        do {
          i.label = e, i = i.next;
        } while (!n.isEqual(i));
        e++;
      }
    }), t;
  }, t.prototype.getEdgeRings = function () {
    var t = this;
    this._computeNextCWEdges(), this.edges.forEach(function (t) {
      t.label = void 0;
    }), this._findLabeledEdgeRings().forEach(function (e) {
      t._findIntersectionNodes(e).forEach(function (n) {
        t._computeNextCCWEdges(n, e.label);
      });
    });
    var e = [];
    return this.edges.forEach(function (n) {
      n.ring || e.push(t._findEdgeRing(n));
    }), e;
  }, t.prototype._findIntersectionNodes = function (t) {
    var e = [],
      n = t,
      i = u(function () {
        var i = 0;
        n.from.getOuterEdges().forEach(function (e) {
          e.label === t.label && ++i;
        }), i > 1 && e.push(n.from), n = n.next;
      }, "_loop_1");
    do {
      i();
    } while (!t.isEqual(n));
    return e;
  }, t.prototype._findEdgeRing = function (t) {
    var e = t,
      n = new MP();
    do {
      n.push(e), e.ring = n, e = e.next;
    } while (!t.isEqual(e));
    return n;
  }, t.prototype.removeNode = function (t) {
    var e = this;
    t.getOuterEdges().forEach(function (t) {
      return e.removeEdge(t);
    }), t.innerEdges.forEach(function (t) {
      return e.removeEdge(t);
    }), delete this.nodes[t.id];
  }, t.prototype.removeEdge = function (t) {
    this.edges = this.edges.filter(function (e) {
      return !e.isEqual(t);
    }), t.deleteEdge();
  }, t;
}();
E(), E(), E(), E();
var lse = Rt(EP());
E();
var use = Rt(EP());
E(), E();
var hse = Rt(Sq());
E();
var yse = Rt(Dq());
function kq(t) {
  for (var e = t, n = []; e.parent;) n.unshift(e), e = e.parent;
  return n;
}
function xse() {
  return new Fq(function (t) {
    return t.f;
  });
}
E(), E(), u(kq, "pathTo"), u(xse, "getHeap");
var PP = {
  search: function (t, e, n, i) {
    t.cleanDirty();
    var r = (i = i || {}).heuristic || PP.heuristics.manhattan,
      o = i.closest || !1,
      s = xse(),
      a = e;
    for (e.h = r(e, n), s.push(e); s.size() > 0;) {
      var l = s.pop();
      if (l === n) return kq(l);
      l.closed = !0;
      for (var u = t.neighbors(l), h = 0, c = u.length; h < c; ++h) {
        var p = u[h];
        if (!p.closed && !p.isWall()) {
          var d = l.g + p.getCost(l),
            f = p.visited;
          (!f || d < p.g) && (p.visited = !0, p.parent = l, p.h = p.h || r(p, n), p.g = d, p.f = p.g + p.h, t.markDirty(p), o && (p.h < a.h || p.h === a.h && p.g < a.g) && (a = p), f ? s.rescoreElement(p) : s.push(p));
        }
      }
    }
    return o ? kq(a) : [];
  },
  heuristics: {
    manhattan: function (t, e) {
      return Math.abs(e.x - t.x) + Math.abs(e.y - t.y);
    },
    diagonal: function (t, e) {
      var n = Math.sqrt(2),
        i = Math.abs(e.x - t.x),
        r = Math.abs(e.y - t.y);
      return 1 * (i + r) + (n - 2) * Math.min(i, r);
    }
  },
  cleanNode: function (t) {
    t.f = 0, t.g = 0, t.h = 0, t.visited = !1, t.closed = !1, t.parent = null;
  }
};
function Gv(t, e) {
  e = e || {}, this.nodes = [], this.diagonal = !!e.diagonal, this.grid = [];
  for (var n = 0; n < t.length; n++) {
    this.grid[n] = [];
    for (var i = 0, r = t[n]; i < r.length; i++) {
      var o = new XM(n, i, r[i]);
      this.grid[n][i] = o, this.nodes.push(o);
    }
  }
  this.init();
}
function XM(t, e, n) {
  this.x = t, this.y = e, this.weight = n;
}
function Fq(t) {
  this.content = [], this.scoreFunction = t;
}
function CP() {
  this._ = null;
}
function pm(t) {
  t.U = t.C = t.L = t.R = t.P = t.N = null;
}
function Hv(t, e) {
  var n = e,
    i = e.R,
    r = n.U;
  r ? r.L === n ? r.L = i : r.R = i : t._ = i, i.U = r, n.U = i, n.R = i.L, n.R && (n.R.U = n), i.L = n;
}
function jv(t, e) {
  var n = e,
    i = e.L,
    r = n.U;
  r ? r.L === n ? r.L = i : r.R = i : t._ = i, i.U = r, n.U = i, n.L = i.R, n.L && (n.L.U = n), i.R = n;
}
function Bq(t) {
  for (; t.L;) t = t.L;
  return t;
}
u(Gv, "Graph"), Gv.prototype.init = function () {
  this.dirtyNodes = [];
  for (var t = 0; t < this.nodes.length; t++) PP.cleanNode(this.nodes[t]);
}, Gv.prototype.cleanDirty = function () {
  for (var t = 0; t < this.dirtyNodes.length; t++) PP.cleanNode(this.dirtyNodes[t]);
  this.dirtyNodes = [];
}, Gv.prototype.markDirty = function (t) {
  this.dirtyNodes.push(t);
}, Gv.prototype.neighbors = function (t) {
  var e = [],
    n = t.x,
    i = t.y,
    r = this.grid;
  return r[n - 1] && r[n - 1][i] && e.push(r[n - 1][i]), r[n + 1] && r[n + 1][i] && e.push(r[n + 1][i]), r[n] && r[n][i - 1] && e.push(r[n][i - 1]), r[n] && r[n][i + 1] && e.push(r[n][i + 1]), this.diagonal && (r[n - 1] && r[n - 1][i - 1] && e.push(r[n - 1][i - 1]), r[n + 1] && r[n + 1][i - 1] && e.push(r[n + 1][i - 1]), r[n - 1] && r[n - 1][i + 1] && e.push(r[n - 1][i + 1]), r[n + 1] && r[n + 1][i + 1] && e.push(r[n + 1][i + 1])), e;
}, Gv.prototype.toString = function () {
  for (var t, e, n, i, r = [], o = this.grid, s = 0, a = o.length; s < a; s++) {
    for (t = [], n = 0, i = (e = o[s]).length; n < i; n++) t.push(e[n].weight);
    r.push(t.join(" "));
  }
  return r.join("\n");
}, u(XM, "GridNode"), XM.prototype.toString = function () {
  return "[" + this.x + " " + this.y + "]";
}, XM.prototype.getCost = function (t) {
  return t && t.x !== this.x && t.y !== this.y ? 1.41421 * this.weight : this.weight;
}, XM.prototype.isWall = function () {
  return 0 === this.weight;
}, u(Fq, "BinaryHeap"), Fq.prototype = {
  push: function (t) {
    this.content.push(t), this.sinkDown(this.content.length - 1);
  },
  pop: function () {
    var t = this.content[0],
      e = this.content.pop();
    return this.content.length > 0 && (this.content[0] = e, this.bubbleUp(0)), t;
  },
  remove: function (t) {
    var e = this.content.indexOf(t),
      n = this.content.pop();
    e !== this.content.length - 1 && (this.content[e] = n, this.scoreFunction(n) < this.scoreFunction(t) ? this.sinkDown(e) : this.bubbleUp(e));
  },
  size: function () {
    return this.content.length;
  },
  rescoreElement: function (t) {
    this.sinkDown(this.content.indexOf(t));
  },
  sinkDown: function (t) {
    for (var e = this.content[t]; t > 0;) {
      var n = (t + 1 >> 1) - 1,
        i = this.content[n];
      if (!(this.scoreFunction(e) < this.scoreFunction(i))) break;
      this.content[n] = e, this.content[t] = i, t = n;
    }
  },
  bubbleUp: function (t) {
    for (var e = this.content.length, n = this.content[t], i = this.scoreFunction(n);;) {
      var r,
        o = t + 1 << 1,
        s = o - 1,
        a = null;
      if (s < e) {
        var l = this.content[s];
        (r = this.scoreFunction(l)) < i && (a = s);
      }
      if (o < e) {
        var u = this.content[o];
        this.scoreFunction(u) < (null === a ? i : r) && (a = o);
      }
      if (null === a) break;
      this.content[t] = this.content[a], this.content[a] = n, t = a;
    }
  }
}, E(), E(), E(), E(), E(), E(), E(), E(), u(CP, "RedBlackTree"), u(pm, "RedBlackNode"), CP.prototype = {
  constructor: CP,
  insert: function (t, e) {
    var n, i, r;
    if (t) {
      if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
        for (t = t.R; t.L;) t = t.L;
        t.L = e;
      } else t.R = e;
      n = t;
    } else this._ ? (t = Bq(this._), e.P = null, e.N = t, t.P = t.L = e, n = t) : (e.P = e.N = null, this._ = e, n = null);
    for (e.L = e.R = null, e.U = n, e.C = !0, t = e; n && n.C;) n === (i = n.U).L ? (r = i.R) && r.C ? (n.C = r.C = !1, i.C = !0, t = i) : (t === n.R && (Hv(this, n), n = (t = n).U), n.C = !1, i.C = !0, jv(this, i)) : (r = i.L) && r.C ? (n.C = r.C = !1, i.C = !0, t = i) : (t === n.L && (jv(this, n), n = (t = n).U), n.C = !1, i.C = !0, Hv(this, i)), n = t.U;
    this._.C = !1;
  },
  remove: function (t) {
    t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
    var e,
      n,
      i,
      r = t.U,
      o = t.L,
      s = t.R;
    if (n = o ? s ? Bq(s) : o : s, r ? r.L === t ? r.L = n : r.R = n : this._ = n, o && s ? (i = n.C, n.C = t.C, n.L = o, o.U = n, n !== s ? (r = n.U, n.U = t.U, t = n.R, r.L = t, n.R = s, s.U = n) : (n.U = r, r = n, t = n.R)) : (i = t.C, t = n), t && (t.U = r), !i) {
      if (t && t.C) return void (t.C = !1);
      do {
        if (t === this._) break;
        if (t === r.L) {
          if ((e = r.R).C && (e.C = !1, r.C = !0, Hv(this, r), e = r.R), e.L && e.L.C || e.R && e.R.C) {
            (!e.R || !e.R.C) && (e.L.C = !1, e.C = !0, jv(this, e), e = r.R), e.C = r.C, r.C = e.R.C = !1, Hv(this, r), t = this._;
            break;
          }
        } else if ((e = r.L).C && (e.C = !1, r.C = !0, jv(this, r), e = r.L), e.L && e.L.C || e.R && e.R.C) {
          (!e.L || !e.L.C) && (e.R.C = !1, e.C = !0, Hv(this, e), e = r.L), e.C = r.C, r.C = e.L.C = !1, jv(this, r), t = this._;
          break;
        }
        e.C = !0, t = r, r = r.U;
      } while (!t.C);
      t && (t.C = !1);
    }
  }
}, u(Hv, "RedBlackRotateLeft"), u(jv, "RedBlackRotateRight"), u(Bq, "RedBlackFirst");
var AP = CP;
function dm(t, e, n, i) {
  var r = [null, null],
    o = vo.push(r) - 1;
  return r.left = t, r.right = e, n && Wv(r, t, e, n), i && Wv(r, e, t, i), ps[t.index].halfedges.push(o), ps[e.index].halfedges.push(o), r;
}
function mm(t, e, n) {
  var i = [e, n];
  return i.left = t, i;
}
function Wv(t, e, n, i) {
  t[0] || t[1] ? t.left === n ? t[1] = i : t[0] = i : (t[0] = i, t.left = e, t.right = n);
}
function bse(t, e, n, i, r) {
  var o,
    s = t[0],
    a = t[1],
    l = s[0],
    u = s[1],
    h = 0,
    c = 1,
    p = a[0] - l,
    d = a[1] - u;
  if (o = e - l, p || !(o > 0)) {
    if (o /= p, p < 0) {
      if (o < h) return;
      o < c && (c = o);
    } else if (p > 0) {
      if (o > c) return;
      o > h && (h = o);
    }
    if (o = i - l, p || !(o < 0)) {
      if (o /= p, p < 0) {
        if (o > c) return;
        o > h && (h = o);
      } else if (p > 0) {
        if (o < h) return;
        o < c && (c = o);
      }
      if (o = n - u, d || !(o > 0)) {
        if (o /= d, d < 0) {
          if (o < h) return;
          o < c && (c = o);
        } else if (d > 0) {
          if (o > c) return;
          o > h && (h = o);
        }
        if (o = r - u, d || !(o < 0)) {
          if (o /= d, d < 0) {
            if (o > c) return;
            o > h && (h = o);
          } else if (d > 0) {
            if (o < h) return;
            o < c && (c = o);
          }
          return !(h > 0) && !(c < 1) || (h > 0 && (t[0] = [l + h * p, u + h * d]), c < 1 && (t[1] = [l + c * p, u + c * d])), !0;
        }
      }
    }
  }
}
function Mse(t, e, n, i, r) {
  var o = t[1];
  if (o) return !0;
  var s,
    a,
    l = t[0],
    u = t.left,
    h = t.right,
    c = u[0],
    p = u[1],
    d = h[0],
    f = h[1],
    m = (c + d) / 2,
    g = (p + f) / 2;
  if (f === p) {
    if (m < e || m >= i) return;
    if (c > d) {
      if (l) {
        if (l[1] >= r) return;
      } else l = [m, n];
      o = [m, r];
    } else {
      if (l) {
        if (l[1] < n) return;
      } else l = [m, r];
      o = [m, n];
    }
  } else if (a = g - (s = (c - d) / (f - p)) * m, s < -1 || s > 1) {
    if (c > d) {
      if (l) {
        if (l[1] >= r) return;
      } else l = [(n - a) / s, n];
      o = [(r - a) / s, r];
    } else {
      if (l) {
        if (l[1] < n) return;
      } else l = [(r - a) / s, r];
      o = [(n - a) / s, n];
    }
  } else if (p < f) {
    if (l) {
      if (l[0] >= i) return;
    } else l = [e, s * e + a];
    o = [i, s * i + a];
  } else {
    if (l) {
      if (l[0] < e) return;
    } else l = [i, s * i + a];
    o = [e, s * e + a];
  }
  return t[0] = l, t[1] = o, !0;
}
function Uq(t, e, n, i) {
  for (var r, o = vo.length; o--;) Mse(r = vo[o], t, e, n, i) && bse(r, t, e, n, i) && (Math.abs(r[0][0] - r[1][0]) > _i || Math.abs(r[0][1] - r[1][1]) > _i) || delete vo[o];
}
function zq(t) {
  return ps[t.index] = {
    site: t,
    halfedges: []
  };
}
function Ese(t, e) {
  var n = t.site,
    i = e.left,
    r = e.right;
  return n === r && (r = i, i = n), r ? Math.atan2(r[1] - i[1], r[0] - i[0]) : (n === i ? (i = e[1], r = e[0]) : (i = e[0], r = e[1]), Math.atan2(i[0] - r[0], r[1] - i[1]));
}
function IP(t, e) {
  return e[+(e.left !== t.site)];
}
function wse(t, e) {
  return e[+(e.left === t.site)];
}
function Vq() {
  for (var t, e, n, i, r = 0, o = ps.length; r < o; ++r) if ((t = ps[r]) && (i = (e = t.halfedges).length)) {
    var s = new Array(i),
      a = new Array(i);
    for (n = 0; n < i; ++n) s[n] = n, a[n] = Ese(t, vo[e[n]]);
    for (s.sort(function (t, e) {
      return a[e] - a[t];
    }), n = 0; n < i; ++n) a[n] = e[s[n]];
    for (n = 0; n < i; ++n) e[n] = a[n];
  }
}
function Gq(t, e, n, i) {
  var r,
    o,
    s,
    a,
    l,
    u,
    h,
    c,
    p,
    d,
    f,
    m,
    g = ps.length,
    v = !0;
  for (r = 0; r < g; ++r) if (o = ps[r]) {
    for (s = o.site, a = (l = o.halfedges).length; a--;) vo[l[a]] || l.splice(a, 1);
    for (a = 0, u = l.length; a < u;) f = (d = wse(o, vo[l[a]]))[0], m = d[1], c = (h = IP(o, vo[l[++a % u]]))[0], p = h[1], (Math.abs(f - c) > _i || Math.abs(m - p) > _i) && (l.splice(a, 0, vo.push(mm(s, d, Math.abs(f - t) < _i && i - m > _i ? [t, Math.abs(c - t) < _i ? p : i] : Math.abs(m - i) < _i && n - f > _i ? [Math.abs(p - i) < _i ? c : n, i] : Math.abs(f - n) < _i && m - e > _i ? [n, Math.abs(c - n) < _i ? p : e] : Math.abs(m - e) < _i && f - t > _i ? [Math.abs(p - e) < _i ? c : t, e] : null)) - 1), ++u);
    u && (v = !1);
  }
  if (v) {
    var y,
      _,
      x,
      E = 1 / 0;
    for (r = 0, v = null; r < g; ++r) (o = ps[r]) && (x = (y = (s = o.site)[0] - t) * y + (_ = s[1] - e) * _) < E && (E = x, v = o);
    if (v) {
      var b = [t, e],
        w = [t, i],
        S = [n, i],
        M = [n, e];
      v.halfedges.push(vo.push(mm(s = v.site, b, w)) - 1, vo.push(mm(s, w, S)) - 1, vo.push(mm(s, S, M)) - 1, vo.push(mm(s, M, b)) - 1);
    }
  }
  for (r = 0; r < g; ++r) (o = ps[r]) && (o.halfedges.length || delete ps[r]);
}
E(), E(), u(dm, "createEdge"), u(mm, "createBorderEdge"), u(Wv, "setEdgeEnd"), u(bse, "clipEdge"), u(Mse, "connectEdge"), u(Uq, "clipEdges"), u(zq, "createCell"), u(Ese, "cellHalfedgeAngle"), u(IP, "cellHalfedgeStart"), u(wse, "cellHalfedgeEnd"), u(Vq, "sortCellHalfedges"), u(Gq, "clipCells"), E();
var YM,
  Hq = [];
function Sse() {
  pm(this), this.x = this.y = this.arc = this.site = this.cy = null;
}
function Wf(t) {
  var e = t.P,
    n = t.N;
  if (e && n) {
    var i = e.site,
      r = t.site,
      o = n.site;
    if (i !== o) {
      var s = r[0],
        a = r[1],
        l = i[0] - s,
        u = i[1] - a,
        h = o[0] - s,
        c = o[1] - a,
        p = 2 * (l * c - u * h);
      if (!(p >= -jq)) {
        var d = l * l + u * u,
          f = h * h + c * c,
          m = (c * d - u * f) / p,
          g = (l * f - h * d) / p,
          v = Hq.pop() || new Sse();
        v.arc = t, v.site = r, v.x = m + s, v.y = (v.cy = g + a) + Math.sqrt(m * m + g * g), t.circle = v;
        for (var y = null, _ = gm._; _;) if (v.y < _.y || v.y === _.y && v.x <= _.x) {
          if (!_.L) {
            y = _.P;
            break;
          }
          _ = _.L;
        } else {
          if (!_.R) {
            y = _;
            break;
          }
          _ = _.R;
        }
        gm.insert(y, v), y || (YM = v);
      }
    }
  }
}
function Xf(t) {
  var e = t.circle;
  e && (e.P || (YM = e.N), gm.remove(e), Hq.push(e), pm(e), t.circle = null);
}
u(Sse, "Circle"), u(Wf, "attachCircle"), u(Xf, "detachCircle");
var Wq = [];
function Tse() {
  pm(this), this.edge = this.site = this.circle = null;
}
function Xq(t) {
  var e = Wq.pop() || new Tse();
  return e.site = t, e;
}
function LP(t) {
  Xf(t), Yf.remove(t), Wq.push(t), pm(t);
}
function Yq(t) {
  var e = t.circle,
    n = e.x,
    i = e.cy,
    r = [n, i],
    o = t.P,
    s = t.N,
    a = [t];
  LP(t);
  for (var l = o; l.circle && Math.abs(n - l.circle.x) < _i && Math.abs(i - l.circle.cy) < _i;) o = l.P, a.unshift(l), LP(l), l = o;
  a.unshift(l), Xf(l);
  for (var u = s; u.circle && Math.abs(n - u.circle.x) < _i && Math.abs(i - u.circle.cy) < _i;) s = u.N, a.push(u), LP(u), u = s;
  a.push(u), Xf(u);
  var h,
    c = a.length;
  for (h = 1; h < c; ++h) u = a[h], l = a[h - 1], Wv(u.edge, l.site, u.site, r);
  l = a[0], (u = a[c - 1]).edge = dm(l.site, u.site, null, r), Wf(l), Wf(u);
}
function Zq(t) {
  for (var e, n, i, r, o = t[0], s = t[1], a = Yf._; a;) if ((i = Jq(a, s) - o) > _i) a = a.L;else {
    if (!((r = o - Pse(a, s)) > _i)) {
      i > -_i ? (e = a.P, n = a) : r > -_i ? (e = a, n = a.N) : e = n = a;
      break;
    }
    if (!a.R) {
      e = a;
      break;
    }
    a = a.R;
  }
  zq(t);
  var l = Xq(t);
  if (Yf.insert(e, l), e || n) {
    if (e === n) return Xf(e), n = Xq(e.site), Yf.insert(l, n), l.edge = n.edge = dm(e.site, l.site), Wf(e), void Wf(n);
    if (!n) return void (l.edge = dm(e.site, l.site));
    Xf(e), Xf(n);
    var u = e.site,
      h = u[0],
      c = u[1],
      p = t[0] - h,
      d = t[1] - c,
      f = n.site,
      m = f[0] - h,
      g = f[1] - c,
      v = 2 * (p * g - d * m),
      y = p * p + d * d,
      _ = m * m + g * g,
      x = [(g * y - d * _) / v + h, (p * _ - m * y) / v + c];
    Wv(n.edge, u, f, x), l.edge = dm(u, t, null, x), n.edge = dm(t, f, null, x), Wf(e), Wf(n);
  }
}
function Jq(t, e) {
  var n = t.site,
    i = n[0],
    r = n[1],
    o = r - e;
  if (!o) return i;
  var s = t.P;
  if (!s) return -1 / 0;
  var a = (n = s.site)[0],
    l = n[1],
    u = l - e;
  if (!u) return a;
  var h = a - i,
    c = 1 / o - 1 / u,
    p = h / u;
  return c ? (-p + Math.sqrt(p * p - 2 * c * (h * h / (-2 * u) - l + u / 2 + r - o / 2))) / c + i : (i + a) / 2;
}
function Pse(t, e) {
  var n = t.N;
  if (n) return Jq(n, e);
  var i = t.site;
  return i[1] === e ? i[0] : 1 / 0;
}
u(Tse, "Beach"), u(Xq, "createBeach"), u(LP, "detachBeach"), u(Yq, "removeBeach"), u(Zq, "addBeach"), u(Jq, "leftBreakPoint"), u(Pse, "rightBreakPoint");
var Yf,
  ps,
  gm,
  vo,
  _i = 1e-6,
  jq = 1e-12;
function Cse(t, e, n) {
  return (t[0] - n[0]) * (e[1] - t[1]) - (t[0] - e[0]) * (n[1] - t[1]);
}
function Ase(t, e) {
  return e[1] - t[1] || e[0] - t[0];
}
function ZM(t, e) {
  var n,
    i,
    r,
    o = t.sort(Ase).pop();
  for (vo = [], ps = new Array(t.length), Yf = new AP(), gm = new AP();;) if (r = YM, o && (!r || o[1] < r.y || o[1] === r.y && o[0] < r.x)) (o[0] !== n || o[1] !== i) && (Zq(o), n = o[0], i = o[1]), o = t.pop();else {
    if (!r) break;
    Yq(r.arc);
  }
  if (Vq(), e) {
    var s = +e[0][0],
      a = +e[0][1],
      l = +e[1][0],
      u = +e[1][1];
    Uq(s, a, l, u), Gq(s, a, l, u);
  }
  this.edges = vo, this.cells = ps, Yf = gm = vo = ps = null;
}
u(Cse, "triangleArea"), u(Ase, "lexicographic"), u(ZM, "Diagram"), ZM.prototype = {
  constructor: ZM,
  polygons: function () {
    var t = this.edges;
    return this.cells.map(function (e) {
      var n = e.halfedges.map(function (n) {
        return IP(e, t[n]);
      });
      return n.data = e.site.data, n;
    });
  },
  triangles: function () {
    var t = [],
      e = this.edges;
    return this.cells.forEach(function (n, i) {
      if (o = (r = n.halfedges).length) for (var r, o, s, a = n.site, l = -1, u = e[r[o - 1]], h = u.left === a ? u.right : u.left; ++l < o;) s = h, h = (u = e[r[l]]).left === a ? u.right : u.left, s && h && i < s.index && i < h.index && Cse(a, s, h) < 0 && t.push([a.data, s.data, h.data]);
    }), t;
  },
  links: function () {
    return this.edges.filter(function (t) {
      return t.right;
    }).map(function (t) {
      return {
        source: t.left.data,
        target: t.right.data
      };
    });
  },
  find: function (t, e, n) {
    for (var i, r, o = this, s = o._found || 0, a = o.cells.length; !(r = o.cells[s]);) if (++s >= a) return null;
    var l = t - r.site[0],
      u = e - r.site[1],
      h = l * l + u * u;
    do {
      r = o.cells[i = s], s = null, r.halfedges.forEach(function (n) {
        var i = o.edges[n],
          a = i.left;
        if (a !== r.site && a || (a = i.right)) {
          var l = t - a[0],
            u = e - a[1],
            c = l * l + u * u;
          c < h && (h = c, s = a.index);
        }
      });
    } while (null !== s);
    return o._found = i, null == n || h <= n * n ? r.site : null;
  }
}, E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E();
var kse = Rt(vm());
E();
var Em = Rt(ek());
function ds() {
  return new KM();
}
function KM() {
  this.reset();
}
E(), E(), E(), u(ds, "default"), u(KM, "Adder"), KM.prototype = {
  constructor: KM,
  reset: function () {
    this.s = this.t = 0;
  },
  add: function (t) {
    tk(QM, t, this.t), tk(this, QM.s, this.s), this.s ? this.t += QM.t : this.s = QM.t;
  },
  valueOf: function () {
    return this.s;
  }
};
var QM = new KM();
function tk(t, e, n) {
  var i = t.s = e + n,
    r = i - e,
    o = i - r;
  t.t = e - o + (n - r);
}
u(tk, "add"), E();
var jt = 1e-6,
  In = Math.PI,
  Yr = In / 2,
  $M = In / 4,
  Lo = 2 * In,
  ms = 180 / In,
  nr = In / 180,
  ri = Math.abs,
  fl = Math.atan,
  yo = Math.atan2,
  zt = Math.cos,
  eE = Math.exp,
  Xv = Math.log,
  Vt = Math.sin,
  Ir = Math.sqrt,
  Yv = Math.tan;
function tE(t) {
  return t > 1 ? 0 : t < -1 ? In : Math.acos(t);
}
function Zr(t) {
  return t > 1 ? Yr : t < -1 ? -Yr : Math.asin(t);
}
function gs() {}
function nE(t, e) {
  t && ik.hasOwnProperty(t.type) && ik[t.type](t, e);
}
u(tE, "acos"), u(Zr, "asin"), E(), u(gs, "noop"), E(), u(nE, "streamGeometry");
var nk = {
    Feature: function (t, e) {
      nE(t.geometry, e);
    },
    FeatureCollection: function (t, e) {
      for (var n = t.features, i = -1, r = n.length; ++i < r;) nE(n[i].geometry, e);
    }
  },
  ik = {
    Sphere: function (t, e) {
      e.sphere();
    },
    Point: function (t, e) {
      t = t.coordinates, e.point(t[0], t[1], t[2]);
    },
    MultiPoint: function (t, e) {
      for (var n = t.coordinates, i = -1, r = n.length; ++i < r;) t = n[i], e.point(t[0], t[1], t[2]);
    },
    LineString: function (t, e) {
      NP(t.coordinates, e, 0);
    },
    MultiLineString: function (t, e) {
      for (var n = t.coordinates, i = -1, r = n.length; ++i < r;) NP(n[i], e, 0);
    },
    Polygon: function (t, e) {
      rk(t.coordinates, e);
    },
    MultiPolygon: function (t, e) {
      for (var n = t.coordinates, i = -1, r = n.length; ++i < r;) rk(n[i], e);
    },
    GeometryCollection: function (t, e) {
      for (var n = t.geometries, i = -1, r = n.length; ++i < r;) nE(n[i], e);
    }
  };
function NP(t, e, n) {
  var i,
    r = -1,
    o = t.length - n;
  for (e.lineStart(); ++r < o;) i = t[r], e.point(i[0], i[1], i[2]);
  e.lineEnd();
}
function rk(t, e) {
  var n = -1,
    i = t.length;
  for (e.polygonStart(); ++n < i;) NP(t[n], e, 1);
  e.polygonEnd();
}
function rc(t, e) {
  t && nk.hasOwnProperty(t.type) ? nk[t.type](t, e) : nE(t, e);
}
u(NP, "streamLine"), u(rk, "streamPolygon"), u(rc, "default");
var Fse = ds(),
  zCe = ds();
function ym(t) {
  return [yo(t[1], t[0]), Zr(t[2])];
}
function pl(t) {
  var e = t[0],
    n = t[1],
    i = zt(n);
  return [i * zt(e), i * Vt(e), Vt(n)];
}
function Zv(t, e) {
  return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
}
function Zf(t, e) {
  return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
}
function iE(t, e) {
  t[0] += e[0], t[1] += e[1], t[2] += e[2];
}
function Jv(t, e) {
  return [t[0] * e, t[1] * e, t[2] * e];
}
function _m(t) {
  var e = Ir(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
  t[0] /= e, t[1] /= e, t[2] /= e;
}
E(), E(), u(ym, "spherical"), u(pl, "cartesian"), u(Zv, "cartesianDot"), u(Zf, "cartesianCross"), u(iE, "cartesianAddInPlace"), u(Jv, "cartesianScale"), u(_m, "cartesianNormalizeInPlace");
var KCe = ds();
function Kv(t, e) {
  function n(n, i) {
    return n = t(n, i), e(n[0], n[1]);
  }
  return u(n, "compose"), t.invert && e.invert && (n.invert = function (n, i) {
    return (n = e.invert(n, i)) && t.invert(n[0], n[1]);
  }), n;
}
function DP(t, e) {
  return [t > In ? t - Lo : t < -In ? t + Lo : t, e];
}
function qP(t, e, n) {
  return (t %= Lo) ? e || n ? Kv(sk(t), ak(e, n)) : sk(t) : e || n ? ak(e, n) : DP;
}
function ok(t) {
  return function (e, n) {
    return [(e += t) > In ? e - Lo : e < -In ? e + Lo : e, n];
  };
}
function sk(t) {
  var e = ok(t);
  return e.invert = ok(-t), e;
}
function ak(t, e) {
  var n = zt(t),
    i = Vt(t),
    r = zt(e),
    o = Vt(e);
  function s(t, e) {
    var s = zt(e),
      a = zt(t) * s,
      l = Vt(t) * s,
      u = Vt(e),
      h = u * n + a * i;
    return [yo(l * r - h * o, a * n - u * i), Zr(h * r + l * o)];
  }
  return u(s, "rotation"), s.invert = function (t, e) {
    var s = zt(e),
      a = zt(t) * s,
      l = Vt(t) * s,
      u = Vt(e),
      h = u * r - l * o;
    return [yo(l * r + u * o, a * n + h * i), Zr(h * n - a * i)];
  }, s;
}
function lk(t, e, n, i, r, o) {
  if (n) {
    var s = zt(e),
      a = Vt(e),
      l = i * n;
    null == r ? (r = e + i * Lo, o = e - l / 2) : (r = uk(s, r), o = uk(s, o), (i > 0 ? r < o : r > o) && (r += i * Lo));
    for (var u, h = r; i > 0 ? h > o : h < o; h -= l) u = ym([s, -a * zt(h), -a * Vt(h)]), t.point(u[0], u[1]);
  }
}
function uk(t, e) {
  (e = pl(e))[0] -= t, _m(e);
  var n = tE(-e[1]);
  return ((-e[2] < 0 ? -n : n) + Lo - jt) % Lo;
}
function Qv() {
  var t,
    e = [];
  return {
    point: function (e, n) {
      t.push([e, n]);
    },
    lineStart: function () {
      e.push(t = []);
    },
    lineEnd: gs,
    rejoin: function () {
      e.length > 1 && e.push(e.pop().concat(e.shift()));
    },
    result: function () {
      var n = e;
      return e = [], t = null, n;
    }
  };
}
function kP(t, e, n, i, r, o) {
  var s,
    a = t[0],
    l = t[1],
    u = 0,
    h = 1,
    c = e[0] - a,
    p = e[1] - l;
  if (s = n - a, c || !(s > 0)) {
    if (s /= c, c < 0) {
      if (s < u) return;
      s < h && (h = s);
    } else if (c > 0) {
      if (s > h) return;
      s > u && (u = s);
    }
    if (s = r - a, c || !(s < 0)) {
      if (s /= c, c < 0) {
        if (s > h) return;
        s > u && (u = s);
      } else if (c > 0) {
        if (s < u) return;
        s < h && (h = s);
      }
      if (s = i - l, p || !(s > 0)) {
        if (s /= p, p < 0) {
          if (s < u) return;
          s < h && (h = s);
        } else if (p > 0) {
          if (s > h) return;
          s > u && (u = s);
        }
        if (s = o - l, p || !(s < 0)) {
          if (s /= p, p < 0) {
            if (s > h) return;
            s > u && (u = s);
          } else if (p > 0) {
            if (s < u) return;
            s < h && (h = s);
          }
          return u > 0 && (t[0] = a + u * c, t[1] = l + u * p), h < 1 && (e[0] = a + h * c, e[1] = l + h * p), !0;
        }
      }
    }
  }
}
function Jf(t, e) {
  return ri(t[0] - e[0]) < jt && ri(t[1] - e[1]) < jt;
}
function rE(t, e, n, i) {
  this.x = t, this.z = e, this.o = n, this.e = i, this.v = !1, this.n = this.p = null;
}
function $v(t, e, n, i, r) {
  var o,
    s,
    a = [],
    l = [];
  if (t.forEach(function (t) {
    if (!((e = t.length - 1) <= 0)) {
      var e,
        n,
        i = t[0],
        s = t[e];
      if (Jf(i, s)) {
        for (r.lineStart(), o = 0; o < e; ++o) r.point((i = t[o])[0], i[1]);
        return void r.lineEnd();
      }
      a.push(n = new rE(i, t, null, !0)), l.push(n.o = new rE(i, null, n, !1)), a.push(n = new rE(s, t, null, !1)), l.push(n.o = new rE(s, null, n, !0));
    }
  }), a.length) {
    for (l.sort(e), ck(a), ck(l), o = 0, s = l.length; o < s; ++o) l[o].e = n = !n;
    for (var u, h, c = a[0];;) {
      for (var p = c, d = !0; p.v;) if ((p = p.n) === c) return;
      u = p.z, r.lineStart();
      do {
        if (p.v = p.o.v = !0, p.e) {
          if (d) for (o = 0, s = u.length; o < s; ++o) r.point((h = u[o])[0], h[1]);else i(p.x, p.n.x, 1, r);
          p = p.n;
        } else {
          if (d) for (u = p.p.z, o = u.length - 1; o >= 0; --o) r.point((h = u[o])[0], h[1]);else i(p.x, p.p.x, -1, r);
          p = p.p;
        }
        u = (p = p.o).z, d = !d;
      } while (!p.v);
      r.lineEnd();
    }
  }
}
function ck(t) {
  if (e = t.length) {
    for (var e, n, i = 0, r = t[0]; ++i < e;) r.n = n = t[i], n.p = r, r = n;
    r.n = n = t[0], n.p = r;
  }
}
function oc(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function oE(t) {
  return 1 === t.length && (t = Bse(t)), {
    left: function (e, n, i, r) {
      for (null == i && (i = 0), null == r && (r = e.length); i < r;) {
        var o = i + r >>> 1;
        t(e[o], n) < 0 ? i = o + 1 : r = o;
      }
      return i;
    },
    right: function (e, n, i, r) {
      for (null == i && (i = 0), null == r && (r = e.length); i < r;) {
        var o = i + r >>> 1;
        t(e[o], n) > 0 ? r = o : i = o + 1;
      }
      return i;
    }
  };
}
function Bse(t) {
  return function (e, n) {
    return oc(t(e), n);
  };
}
E(), E(), E(), E(), E(), u(Kv, "default"), u(DP, "rotationIdentity"), DP.invert = DP, u(qP, "rotateRadians"), u(ok, "forwardRotationLambda"), u(sk, "rotationLambda"), u(ak, "rotationPhiGamma"), u(lk, "circleStream"), u(uk, "circleRadius"), E(), E(), u(Qv, "default"), E(), u(kP, "default"), E(), E(), u(Jf, "default"), u(rE, "Intersection"), u($v, "default"), u(ck, "link"), E(), E(), E(), u(oc, "default"), E(), u(oE, "default"), u(Bse, "ascendingComparator");
var hk = oE(oc),
  Use = hk.right,
  zse = hk.left;
E(), E(), E(), E(), E(), E(), E(), E(), E();
var fk = Array.prototype,
  Gse = fk.slice,
  Hse = fk.map;
E(), E(), E(), E();
var GAe = Math.sqrt(50),
  HAe = Math.sqrt(10),
  jAe = Math.sqrt(2);
function xm(t) {
  for (var e, n, i, r = t.length, o = -1, s = 0; ++o < r;) s += t[o].length;
  for (n = new Array(s); --r >= 0;) for (e = (i = t[r]).length; --e >= 0;) n[--s] = i[e];
  return n;
}
E(), E(), E(), E(), E(), E(), E(), E(), u(xm, "default"), E(), E(), E(), E(), E(), E(), E();
var ey = 1e9,
  aE = -ey;
function FP(t, e, n, i) {
  function r(r, o) {
    return t <= r && r <= n && e <= o && o <= i;
  }
  function o(r, o, a, u) {
    var h = 0,
      c = 0;
    if (null == r || (h = s(r, a)) !== (c = s(o, a)) || l(r, o) < 0 ^ a > 0) do {
      u.point(0 === h || 3 === h ? t : n, h > 1 ? i : e);
    } while ((h = (h + a + 4) % 4) !== c);else u.point(o[0], o[1]);
  }
  function s(i, r) {
    return ri(i[0] - t) < jt ? r > 0 ? 0 : 3 : ri(i[0] - n) < jt ? r > 0 ? 2 : 1 : ri(i[1] - e) < jt ? r > 0 ? 1 : 0 : r > 0 ? 3 : 2;
  }
  function a(t, e) {
    return l(t.x, e.x);
  }
  function l(t, e) {
    var n = s(t, 1),
      i = s(e, 1);
    return n !== i ? n - i : 0 === n ? e[1] - t[1] : 1 === n ? t[0] - e[0] : 2 === n ? t[1] - e[1] : e[0] - t[0];
  }
  return u(r, "visible"), u(o, "interpolate"), u(s, "corner"), u(a, "compareIntersection"), u(l, "comparePoint"), function (s) {
    var l,
      h,
      c,
      p,
      d,
      f,
      m,
      g,
      v,
      y,
      _,
      x = s,
      E = Qv(),
      b = {
        point: w,
        lineStart: A,
        lineEnd: P,
        polygonStart: M,
        polygonEnd: T
      };
    function w(t, e) {
      r(t, e) && x.point(t, e);
    }
    function S() {
      for (var e = 0, n = 0, r = h.length; n < r; ++n) for (var o, s, a = h[n], l = 1, u = a.length, c = a[0], p = c[0], d = c[1]; l < u; ++l) o = p, s = d, p = (c = a[l])[0], d = c[1], s <= i ? d > i && (p - o) * (i - s) > (d - s) * (t - o) && ++e : d <= i && (p - o) * (i - s) < (d - s) * (t - o) && --e;
      return e;
    }
    function M() {
      x = E, l = [], h = [], _ = !0;
    }
    function T() {
      var t = S(),
        e = _ && t,
        n = (l = xm(l)).length;
      (e || n) && (s.polygonStart(), e && (s.lineStart(), o(null, null, 1, s), s.lineEnd()), n && $v(l, a, t, o, s), s.polygonEnd()), x = s, l = h = c = null;
    }
    function A() {
      b.point = C, h && h.push(c = []), y = !0, v = !1, m = g = NaN;
    }
    function P() {
      l && (C(p, d), f && v && E.rejoin(), l.push(E.result())), b.point = w, v && x.lineEnd();
    }
    function C(o, s) {
      var a = r(o, s);
      if (h && c.push([o, s]), y) p = o, d = s, f = a, y = !1, a && (x.lineStart(), x.point(o, s));else if (a && v) x.point(o, s);else {
        var l = [m = Math.max(aE, Math.min(ey, m)), g = Math.max(aE, Math.min(ey, g))],
          u = [o = Math.max(aE, Math.min(ey, o)), s = Math.max(aE, Math.min(ey, s))];
        kP(l, u, t, e, n, i) ? (v || (x.lineStart(), x.point(l[0], l[1])), x.point(u[0], u[1]), a || x.lineEnd(), _ = !1) : a && (x.lineStart(), x.point(o, s), _ = !1);
      }
      m = o, g = s, v = a;
    }
    return u(w, "point"), u(S, "polygonInside"), u(M, "polygonStart"), u(T, "polygonEnd"), u(A, "lineStart"), u(P, "lineEnd"), u(C, "linePoint"), b;
  };
}
u(FP, "clipExtent"), E(), E();
var BP = ds();
function lE(t, e) {
  var n = e[0],
    i = e[1],
    r = [Vt(n), -zt(n), 0],
    o = 0,
    s = 0;
  BP.reset();
  for (var a = 0, l = t.length; a < l; ++a) if (h = (u = t[a]).length) for (var u, h, c = u[h - 1], p = c[0], d = c[1] / 2 + $M, f = Vt(d), m = zt(d), g = 0; g < h; ++g, p = y, f = x, m = E, c = v) {
    var v = u[g],
      y = v[0],
      _ = v[1] / 2 + $M,
      x = Vt(_),
      E = zt(_),
      b = y - p,
      w = b >= 0 ? 1 : -1,
      S = w * b,
      M = S > In,
      T = f * x;
    if (BP.add(yo(T * w * Vt(S), m * E + T * zt(S))), o += M ? b + w * Lo : b, M ^ p >= n ^ y >= n) {
      var A = Zf(pl(c), pl(v));
      _m(A);
      var P = Zf(r, A);
      _m(P);
      var C = (M ^ b >= 0 ? -1 : 1) * Zr(P[2]);
      (i > C || i === C && (A[0] || A[1])) && (s += M ^ b >= 0 ? 1 : -1);
    }
  }
  return (o < -jt || o < jt && BP < -jt) ^ 1 & s;
}
u(lE, "default"), E(), E();
var qIe = ds();
function bm(t) {
  return t;
}
E(), E(), E(), E(), u(bm, "default"), E();
var t8e = ds(),
  n8e = ds();
E();
var Mm = 1 / 0,
  uE = Mm,
  ty = -Mm,
  cE = ty,
  eae = {
    point: tae,
    lineStart: gs,
    lineEnd: gs,
    polygonStart: gs,
    polygonEnd: gs,
    result: function () {
      var t = [[Mm, uE], [ty, cE]];
      return ty = cE = -(uE = Mm = 1 / 0), t;
    }
  };
function tae(t, e) {
  t < Mm && (Mm = t), t > ty && (ty = t), e < uE && (uE = e), e > cE && (cE = e);
}
u(tae, "boundsPoint");
var hE = eae;
function UP(t) {
  this._context = t;
}
E(), E(), u(UP, "PathContext"), UP.prototype = {
  _radius: 4.5,
  pointRadius: function (t) {
    return this._radius = t, this;
  },
  polygonStart: function () {
    this._line = 0;
  },
  polygonEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    0 === this._line && this._context.closePath(), this._point = NaN;
  },
  point: function (t, e) {
    switch (this._point) {
      case 0:
        this._context.moveTo(t, e), this._point = 1;
        break;
      case 1:
        this._context.lineTo(t, e);
        break;
      default:
        this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, Lo);
    }
  },
  result: gs
}, E();
var d8e = ds();
function zP() {
  this._string = [];
}
function mk(t) {
  return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
}
function ny(t, e, n, i) {
  return function (r, o) {
    var s,
      a,
      l,
      h = e(o),
      c = r.invert(i[0], i[1]),
      p = Qv(),
      d = e(p),
      f = !1,
      m = {
        point: g,
        lineStart: y,
        lineEnd: _,
        polygonStart: function () {
          m.point = x, m.lineStart = E, m.lineEnd = b, a = [], s = [];
        },
        polygonEnd: function () {
          m.point = g, m.lineStart = y, m.lineEnd = _, a = xm(a);
          var t = lE(s, c);
          a.length ? (f || (o.polygonStart(), f = !0), $v(a, iae, t, n, o)) : t && (f || (o.polygonStart(), f = !0), o.lineStart(), n(null, null, 1, o), o.lineEnd()), f && (o.polygonEnd(), f = !1), a = s = null;
        },
        sphere: function () {
          o.polygonStart(), o.lineStart(), n(null, null, 1, o), o.lineEnd(), o.polygonEnd();
        }
      };
    function g(e, n) {
      var i = r(e, n);
      t(e = i[0], n = i[1]) && o.point(e, n);
    }
    function v(t, e) {
      var n = r(t, e);
      h.point(n[0], n[1]);
    }
    function y() {
      m.point = v, h.lineStart();
    }
    function _() {
      m.point = g, h.lineEnd();
    }
    function x(t, e) {
      l.push([t, e]);
      var n = r(t, e);
      d.point(n[0], n[1]);
    }
    function E() {
      d.lineStart(), l = [];
    }
    function b() {
      x(l[0][0], l[0][1]), d.lineEnd();
      var t,
        e,
        n,
        i,
        r = d.clean(),
        u = p.result(),
        h = u.length;
      if (l.pop(), s.push(l), l = null, h) {
        if (1 & r) {
          if ((e = (n = u[0]).length - 1) > 0) {
            for (f || (o.polygonStart(), f = !0), o.lineStart(), t = 0; t < e; ++t) o.point((i = n[t])[0], i[1]);
            o.lineEnd();
          }
          return;
        }
        h > 1 && 2 & r && u.push(u.pop().concat(u.shift())), a.push(u.filter(nae));
      }
    }
    return u(g, "point"), u(v, "pointLine"), u(y, "lineStart"), u(_, "lineEnd"), u(x, "pointRing"), u(E, "ringStart"), u(b, "ringEnd"), m;
  };
}
function nae(t) {
  return t.length > 1;
}
function iae(t, e) {
  return ((t = t.x)[0] < 0 ? t[1] - Yr - jt : Yr - t[1]) - ((e = e.x)[0] < 0 ? e[1] - Yr - jt : Yr - e[1]);
}
E(), u(zP, "PathString"), zP.prototype = {
  _radius: 4.5,
  _circle: mk(4.5),
  pointRadius: function (t) {
    return (t = +t) !== this._radius && (this._radius = t, this._circle = null), this;
  },
  polygonStart: function () {
    this._line = 0;
  },
  polygonEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    0 === this._line && this._string.push("Z"), this._point = NaN;
  },
  point: function (t, e) {
    switch (this._point) {
      case 0:
        this._string.push("M", t, ",", e), this._point = 1;
        break;
      case 1:
        this._string.push("L", t, ",", e);
        break;
      default:
        null == this._circle && (this._circle = mk(this._radius)), this._string.push("M", t, ",", e, this._circle);
    }
  },
  result: function () {
    if (this._string.length) {
      var t = this._string.join("");
      return this._string = [], t;
    }
    return null;
  }
}, u(mk, "circle"), E(), E(), E(), E(), E(), E(), u(ny, "default"), u(nae, "validSegment"), u(iae, "compareIntersection");
var VP = ny(function () {
  return !0;
}, rae, sae, [-In, -Yr]);
function rae(t) {
  var e,
    n = NaN,
    i = NaN,
    r = NaN;
  return {
    lineStart: function () {
      t.lineStart(), e = 1;
    },
    point: function (o, s) {
      var a = o > 0 ? In : -In,
        l = ri(o - n);
      ri(l - In) < jt ? (t.point(n, i = (i + s) / 2 > 0 ? Yr : -Yr), t.point(r, i), t.lineEnd(), t.lineStart(), t.point(a, i), t.point(o, i), e = 0) : r !== a && l >= In && (ri(n - r) < jt && (n -= r * jt), ri(o - a) < jt && (o -= a * jt), i = oae(n, i, o, s), t.point(r, i), t.lineEnd(), t.lineStart(), t.point(a, i), e = 0), t.point(n = o, i = s), r = a;
    },
    lineEnd: function () {
      t.lineEnd(), n = i = NaN;
    },
    clean: function () {
      return 2 - e;
    }
  };
}
function oae(t, e, n, i) {
  var r,
    o,
    s = Vt(t - n);
  return ri(s) > jt ? fl((Vt(e) * (o = zt(i)) * Vt(n) - Vt(i) * (r = zt(e)) * Vt(t)) / (r * o * s)) : (e + i) / 2;
}
function sae(t, e, n, i) {
  var r;
  if (null == t) r = n * Yr, i.point(-In, r), i.point(0, r), i.point(In, r), i.point(In, 0), i.point(In, -r), i.point(0, -r), i.point(-In, -r), i.point(-In, 0), i.point(-In, r);else if (ri(t[0] - e[0]) > jt) {
    var o = t[0] < e[0] ? In : -In;
    r = n * o / 2, i.point(-o, r), i.point(0, r), i.point(o, r);
  } else i.point(e[0], e[1]);
}
function GP(t, e) {
  var n = zt(t),
    i = n > 0,
    r = ri(n) > jt;
  function o(n, i, r, o) {
    lk(o, t, e, r, n, i);
  }
  function s(t, e) {
    return zt(t) * zt(e) > n;
  }
  function a(t) {
    var e, n, o, a, u;
    return {
      lineStart: function () {
        a = o = !1, u = 1;
      },
      point: function (c, p) {
        var d,
          f = [c, p],
          m = s(c, p),
          g = i ? m ? 0 : h(c, p) : m ? h(c + (c < 0 ? In : -In), p) : 0;
        if (!e && (a = o = m) && t.lineStart(), m !== o && (!(d = l(e, f)) || Jf(e, d) || Jf(f, d)) && (f[0] += jt, f[1] += jt, m = s(f[0], f[1])), m !== o) u = 0, m ? (t.lineStart(), d = l(f, e), t.point(d[0], d[1])) : (d = l(e, f), t.point(d[0], d[1]), t.lineEnd()), e = d;else if (r && e && i ^ m) {
          var v;
          !(g & n) && (v = l(f, e, !0)) && (u = 0, i ? (t.lineStart(), t.point(v[0][0], v[0][1]), t.point(v[1][0], v[1][1]), t.lineEnd()) : (t.point(v[1][0], v[1][1]), t.lineEnd(), t.lineStart(), t.point(v[0][0], v[0][1])));
        }
        m && (!e || !Jf(e, f)) && t.point(f[0], f[1]), e = f, o = m, n = g;
      },
      lineEnd: function () {
        o && t.lineEnd(), e = null;
      },
      clean: function () {
        return u | (a && o) << 1;
      }
    };
  }
  function l(t, e, i) {
    var r = [1, 0, 0],
      o = Zf(pl(t), pl(e)),
      s = Zv(o, o),
      a = o[0],
      l = s - a * a;
    if (!l) return !i && t;
    var u = n * s / l,
      h = -n * a / l,
      c = Zf(r, o),
      p = Jv(r, u);
    iE(p, Jv(o, h));
    var d = c,
      f = Zv(p, d),
      m = Zv(d, d),
      g = f * f - m * (Zv(p, p) - 1);
    if (!(g < 0)) {
      var v = Ir(g),
        y = Jv(d, (-f - v) / m);
      if (iE(y, p), y = ym(y), !i) return y;
      var _,
        x = t[0],
        E = e[0],
        b = t[1],
        w = e[1];
      E < x && (_ = x, x = E, E = _);
      var S = E - x,
        M = ri(S - In) < jt;
      if (!M && w < b && (_ = b, b = w, w = _), M || S < jt ? M ? b + w > 0 ^ y[1] < (ri(y[0] - x) < jt ? b : w) : b <= y[1] && y[1] <= w : S > In ^ (x <= y[0] && y[0] <= E)) {
        var T = Jv(d, (-f + v) / m);
        return iE(T, p), [y, ym(T)];
      }
    }
  }
  function h(e, n) {
    var r = i ? t : In - t,
      o = 0;
    return e < -r ? o |= 1 : e > r && (o |= 2), n < -r ? o |= 4 : n > r && (o |= 8), o;
  }
  return u(o, "interpolate"), u(s, "visible"), u(a, "clipLine"), u(l, "intersect"), u(h, "code"), ny(s, a, o, i ? [0, -t] : [-In, t - In]);
}
function iy(t) {
  return function (e) {
    var n = new HP();
    for (var i in t) n[i] = t[i];
    return n.stream = e, n;
  };
}
function HP() {}
function ry(t, e, n) {
  var i = e[1][0] - e[0][0],
    r = e[1][1] - e[0][1],
    o = t.clipExtent && t.clipExtent();
  t.scale(150).translate([0, 0]), null != o && t.clipExtent(null), rc(n, t.stream(hE));
  var s = hE.result(),
    a = Math.min(i / (s[1][0] - s[0][0]), r / (s[1][1] - s[0][1])),
    l = +e[0][0] + (i - a * (s[1][0] + s[0][0])) / 2,
    u = +e[0][1] + (r - a * (s[1][1] + s[0][1])) / 2;
  return null != o && t.clipExtent(o), t.scale(150 * a).translate([l, u]);
}
function fE(t, e, n) {
  return ry(t, [[0, 0], e], n);
}
u(rae, "clipAntimeridianLine"), u(oae, "clipAntimeridianIntersect"), u(sae, "clipAntimeridianInterpolate"), E(), u(GP, "default"), E(), u(iy, "transformer"), u(HP, "TransformStream"), HP.prototype = {
  constructor: HP,
  point: function (t, e) {
    this.stream.point(t, e);
  },
  sphere: function () {
    this.stream.sphere();
  },
  lineStart: function () {
    this.stream.lineStart();
  },
  lineEnd: function () {
    this.stream.lineEnd();
  },
  polygonStart: function () {
    this.stream.polygonStart();
  },
  polygonEnd: function () {
    this.stream.polygonEnd();
  }
}, E(), u(ry, "fitExtent"), u(fE, "fitSize"), E();
var gk = 16,
  aae = zt(30 * nr);
function pE(t, e) {
  return +e ? uae(t, e) : lae(t);
}
function lae(t) {
  return iy({
    point: function (e, n) {
      e = t(e, n), this.stream.point(e[0], e[1]);
    }
  });
}
function uae(t, e) {
  function n(i, r, o, s, a, l, u, h, c, p, d, f, m, g) {
    var v = u - i,
      y = h - r,
      _ = v * v + y * y;
    if (_ > 4 * e && m--) {
      var x = s + p,
        E = a + d,
        b = l + f,
        w = Ir(x * x + E * E + b * b),
        S = Zr(b /= w),
        M = ri(ri(b) - 1) < jt || ri(o - c) < jt ? (o + c) / 2 : yo(E, x),
        T = t(M, S),
        A = T[0],
        P = T[1],
        C = A - i,
        I = P - r,
        N = y * C - v * I;
      (N * N / _ > e || ri((v * C + y * I) / _ - .5) > .3 || s * p + a * d + l * f < aae) && (n(i, r, o, s, a, l, A, P, M, x /= w, E /= w, b, m, g), g.point(A, P), n(A, P, M, x, E, b, u, h, c, p, d, f, m, g));
    }
  }
  return u(n, "resampleLineTo"), function (e) {
    var i,
      r,
      o,
      s,
      a,
      l,
      h,
      c,
      p,
      d,
      f,
      m,
      g = {
        point: v,
        lineStart: y,
        lineEnd: x,
        polygonStart: function () {
          e.polygonStart(), g.lineStart = E;
        },
        polygonEnd: function () {
          e.polygonEnd(), g.lineStart = y;
        }
      };
    function v(n, i) {
      n = t(n, i), e.point(n[0], n[1]);
    }
    function y() {
      c = NaN, g.point = _, e.lineStart();
    }
    function _(i, r) {
      var o = pl([i, r]),
        s = t(i, r);
      n(c, p, h, d, f, m, c = s[0], p = s[1], h = i, d = o[0], f = o[1], m = o[2], gk, e), e.point(c, p);
    }
    function x() {
      g.point = v, e.lineEnd();
    }
    function E() {
      y(), g.point = b, g.lineEnd = w;
    }
    function b(t, e) {
      _(i = t, e), r = c, o = p, s = d, a = f, l = m, g.point = _;
    }
    function w() {
      n(c, p, h, d, f, m, r, o, i, s, a, l, gk, e), g.lineEnd = x, x();
    }
    return u(v, "point"), u(y, "lineStart"), u(_, "linePoint"), u(x, "lineEnd"), u(E, "ringStart"), u(b, "ringPoint"), u(w, "ringEnd"), g;
  };
}
u(pE, "default"), u(lae, "resampleNone"), u(uae, "resample");
var cae = iy({
  point: function (t, e) {
    this.stream.point(t * nr, e * nr);
  }
});
function dl(t) {
  return jP(function () {
    return t;
  })();
}
function jP(t) {
  var e,
    n,
    i,
    r,
    o,
    s,
    a,
    l,
    h,
    c,
    p = 150,
    d = 480,
    f = 250,
    m = 0,
    g = 0,
    v = 0,
    y = 0,
    _ = 0,
    x = null,
    E = VP,
    b = null,
    w = bm,
    S = .5,
    M = pE(P, S);
  function T(t) {
    return [(t = o(t[0] * nr, t[1] * nr))[0] * p + n, i - t[1] * p];
  }
  function A(t) {
    return (t = o.invert((t[0] - n) / p, (i - t[1]) / p)) && [t[0] * ms, t[1] * ms];
  }
  function P(t, r) {
    return [(t = e(t, r))[0] * p + n, i - t[1] * p];
  }
  function C() {
    o = Kv(r = qP(v, y, _), e);
    var t = e(m, g);
    return n = d - t[0] * p, i = f + t[1] * p, I();
  }
  function I() {
    return h = c = null, T;
  }
  return u(T, "projection"), u(A, "invert"), u(P, "projectTransform"), T.stream = function (t) {
    return h && c === t ? h : h = cae(E(r, M(w(c = t))));
  }, T.clipAngle = function (t) {
    return arguments.length ? (E = +t ? GP(x = t * nr, 6 * nr) : (x = null, VP), I()) : x * ms;
  }, T.clipExtent = function (t) {
    return arguments.length ? (w = null == t ? (b = s = a = l = null, bm) : FP(b = +t[0][0], s = +t[0][1], a = +t[1][0], l = +t[1][1]), I()) : null == b ? null : [[b, s], [a, l]];
  }, T.scale = function (t) {
    return arguments.length ? (p = +t, C()) : p;
  }, T.translate = function (t) {
    return arguments.length ? (d = +t[0], f = +t[1], C()) : [d, f];
  }, T.center = function (t) {
    return arguments.length ? (m = t[0] % 360 * nr, g = t[1] % 360 * nr, C()) : [m * ms, g * ms];
  }, T.rotate = function (t) {
    return arguments.length ? (v = t[0] % 360 * nr, y = t[1] % 360 * nr, _ = t.length > 2 ? t[2] % 360 * nr : 0, C()) : [v * ms, y * ms, _ * ms];
  }, T.precision = function (t) {
    return arguments.length ? (M = pE(P, S = t * t), I()) : Ir(S);
  }, T.fitExtent = function (t, e) {
    return ry(T, t, e);
  }, T.fitSize = function (t, e) {
    return fE(T, t, e);
  }, u(C, "recenter"), u(I, "reset"), function () {
    return e = t.apply(this, arguments), T.invert = e.invert && A, C();
  };
}
function dE(t) {
  return function (e, n) {
    var i = zt(e),
      r = zt(n),
      o = t(i * r);
    return [o * r * Vt(e), o * Vt(n)];
  };
}
function eu(t) {
  return function (e, n) {
    var i = Ir(e * e + n * n),
      r = t(i),
      o = Vt(r),
      s = zt(r);
    return [yo(e * o, i * s), Zr(i && n * o / i)];
  };
}
u(dl, "projection"), u(jP, "projectionMutator"), E(), E(), E(), E(), u(dE, "azimuthalRaw"), u(eu, "azimuthalInvert");
var xk = dE(function (t) {
  return Ir(2 / (1 + t));
});
xk.invert = eu(function (t) {
  return 2 * Zr(t / 2);
}), E();
var WP = dE(function (t) {
  return (t = tE(t)) && t / Vt(t);
});
function mE() {
  return dl(WP).scale(79.4188).clipAngle(179.999);
}
function XP(t, e) {
  return [t, Xv(Yv((Yr + e) / 2))];
}
function gE(t, e) {
  return [t, e];
}
function bk(t, e) {
  var n = zt(e),
    i = zt(t) * n;
  return [n * Vt(t) / i, Vt(e) / i];
}
function Mk(t, e) {
  var n = e * e,
    i = n * n;
  return [t * (.8707 - .131979 * n + i * (i * (.003971 * n - .001529 * i) - .013791)), e * (1.007226 + n * (.015085 + i * (.028874 * n - .044475 - .005916 * i)))];
}
function Ek(t, e) {
  return [zt(e) * Vt(t), Vt(e)];
}
function wk(t, e) {
  var n = zt(e),
    i = 1 + zt(t) * n;
  return [n * Vt(t) / i, Vt(e) / i];
}
function Sk(t, e) {
  return [Xv(Yv((Yr + e) / 2)), -t];
}
function pae(t, e, n) {
  var i = (n = n || {}).units || "kilometers",
    r = n.steps || 8;
  if (!t) throw new Error("geojson is required");
  if ("object" != typeof n) throw new Error("options must be an object");
  if ("number" != typeof r) throw new Error("steps must be an number");
  if (void 0 === e) throw new Error("radius is required");
  if (r <= 0) throw new Error("steps must be greater than 0");
  var o = [];
  switch (t.type) {
    case "GeometryCollection":
      return Zl(t, function (t) {
        var n = vE(t, e, i, r);
        n && o.push(n);
      }), Zt(o);
    case "FeatureCollection":
      return vi(t, function (t) {
        var n = vE(t, e, i, r);
        n && vi(n, function (t) {
          t && o.push(t);
        });
      }), Zt(o);
  }
  return vE(t, e, i, r);
}
function vE(t, e, n, i) {
  var r = t.properties || {},
    o = "Feature" === t.type ? t.geometry : t;
  if ("GeometryCollection" === o.type) {
    var s = [];
    return Zl(t, function (t) {
      var r = vE(t, e, n, i);
      r && s.push(r);
    }), Zt(s);
  }
  var a = dae(o),
    l = {
      type: o.type,
      coordinates: Pk(o.coordinates, a)
    },
    u = new Em.GeoJSONReader().read(l),
    h = Sv(Tv(e, n), "meters"),
    c = Em.BufferOp.bufferOp(u, h, i);
  if (!Tk((c = new Em.GeoJSONWriter().write(c)).coordinates)) return Wr({
    type: c.type,
    coordinates: Ck(c.coordinates, a)
  }, r);
}
function Tk(t) {
  return Array.isArray(t[0]) ? Tk(t[0]) : isNaN(t[0]);
}
function Pk(t, e) {
  return "object" != typeof t[0] ? e(t) : t.map(function (t) {
    return Pk(t, e);
  });
}
function Ck(t, e) {
  return "object" != typeof t[0] ? e.invert(t) : t.map(function (t) {
    return Ck(t, e);
  });
}
function dae(t) {
  var e = Ff(t).geometry.coordinates,
    n = [-e[0], -e[1]];
  return mE().rotate(n).scale(jr);
}
WP.invert = eu(function (t) {
  return t;
}), u(mE, "default"), E(), E(), u(XP, "mercatorRaw"), XP.invert = function (t, e) {
  return [t, 2 * fl(eE(e)) - Yr];
}, E(), E(), u(gE, "equirectangularRaw"), gE.invert = gE, E(), u(bk, "gnomonicRaw"), bk.invert = eu(fl), E(), E(), u(Mk, "naturalEarth1Raw"), Mk.invert = function (t, e) {
  var n,
    i = e,
    r = 25;
  do {
    var o = i * i,
      s = o * o;
    i -= n = (i * (1.007226 + o * (.015085 + s * (.028874 * o - .044475 - .005916 * s))) - e) / (1.007226 + o * (.045255 + s * (.259866 * o - .311325 - .005916 * 11 * s)));
  } while (ri(n) > jt && --r > 0);
  return [t / (.8707 + (o = i * i) * (o * (o * o * o * (.003971 - .001529 * o) - .013791) - .131979)), i];
}, E(), u(Ek, "orthographicRaw"), Ek.invert = eu(Zr), E(), u(wk, "stereographicRaw"), wk.invert = eu(function (t) {
  return 2 * fl(t);
}), E(), u(Sk, "transverseMercatorRaw"), Sk.invert = function (t, e) {
  return [-e, 2 * fl(eE(t)) - Yr];
}, u(pae, "buffer"), u(vE, "bufferFeature"), u(Tk, "coordsIsNaN"), u(Pk, "projectCoords"), u(Ck, "unprojectCoords"), u(dae, "defineProjection");
var YP = pae;
E();
var mae = Rt(vm());
E();
var gae = Rt(vm());
E();
var yae = Rt(vm());
E(), E();
var _ae = Rt(vm());
E(), E(), E(), E();
var Cae = 1e-7,
  Aae = .11,
  Ik = ["connection.json", "manifest.geojson", "map.geojson", "node.geojson", "styles.json", "mapstack.geojson"];
function Lk(t, e) {
  let n = Oae(e),
    [i, r] = t.features.reduce((t, e) => {
      let [i, r] = t,
        o = [e],
        {
          properties: s
        } = e,
        a = (s.entrances || []).reduce((t, e) => (n.has(e) && t.push(n.get(e)), t), []);
      if (a.length && (o = Iae(e, a)), "LineString" === o[0].geometry.type) {
        let t = o[0].properties.kind;
        i.has(t) || i.set(t, []), i.get(t).push(...o);
      } else r.push(...o);
      return t;
    }, [new Map(), []]);
  return i.forEach((t, e) => {
    let n = {
      kind: e,
      id: t[0].properties.id,
      externalId: t[0].properties.externalId
    };
    if (t.length) {
      let e = YP(qf(t.map(({
        geometry: t
      }) => t.coordinates)), Aae, {
        units: "meters"
      });
      e.properties = {
        ...n,
        ...e.properties
      };
      let i = [];
      i = "MultiPolygon" === e.geometry.type ? e.geometry.coordinates.map(t => ({
        ...Ii(t),
        properties: n
      })) : [e], r = r.concat(i);
    }
  }), Zt(r);
}
function Iae(t, e) {
  return e.reduce((t, e) => {
    let n = {
        epsilon: Cae
      },
      i = t.findIndex(t => em(Ff(e), t, n)),
      r = t[i];
    if (r) {
      let [n, o] = Lae(r, e);
      t.splice(i, 1, n, o);
    }
    return t;
  }, [t]);
}
function Lae(t, e) {
  let {
      coordinates: n
    } = e.geometry,
    {
      coordinates: i
    } = t.geometry,
    r = n.map(e => nc(t, Yn(e)));
  return i.reduce((e, n) => {
    let i = PM(Yn(n), r[0], t),
      o = PM(Yn(n), r[1], t),
      s = Vf(i) < Vf(o) ? i : o;
    return s.properties = {
      ...t.properties,
      entrances: []
    }, e.concat([s]);
  }, []);
}
function Oae(t) {
  return new Map(t.features.map(t => {
    let {
        properties: e
      } = t,
      {
        id: n
      } = e;
    return [n, t];
  }));
}
function Rae(t) {
  if (null == t || "object" != typeof t) return !1;
  for (let e of Ik) if ("Uint8Array" !== t[e][Symbol.toStringTag]) return !1;
  return !0;
}
async function Ok(t) {
  return new Promise(async (e, n) => {
    try {
      if (null == t || "object" != typeof t) throw new Error("Error parsing data! Unzipping failed.");
      if ("Uint8Array" !== t[Symbol.toStringTag]) throw new Error("Unexpected file type! Unzipping failed.");
      let n = (await import("./browser-42K2OAVV.js")).unzipSync(t);
      if (!Rae(n)) throw new Error("MVF is missing some expect static files. Unzipping failed.");
      let i = {
          "connection.json": n["connection.json"],
          "manifest.geojson": n["manifest.geojson"],
          "node.geojson": n["node.geojson"],
          "map.geojson": n["map.geojson"],
          "mapstack.geojson": n["mapstack.geojson"],
          "styles.json": n["styles.json"],
          space: {},
          obstruction: {},
          entrance: {}
        },
        r = Object.keys(n);
      for (let t of r) {
        if (0 === n[t].length) continue;
        let e = t.split("/");
        if (e.length < 0) throw new Error("Encounted a file with no name! Unzipping failed.");
        if (e.length > 2) throw new Error("Encountered unexpected nesting in MVF! Unzipping failed.");
        if (1 !== e.length) {
          if ("image" === e[0]) {
            ke.warn("MVF unzipping encountered an image. Ignoring as this case has not been implemented.");
            continue;
          }
          null == i[e[0]] && (i[e[0]] = {}), i[e[0]][e[1]] = n[t];
        }
      }
      e(i);
    } catch (t) {
      n(t);
    }
  });
}
function Nae(t) {
  let [e, n, i, r] = mo(t);
  return {
    minLat: n,
    minLong: e,
    maxLat: r,
    maxLong: i
  };
}
function Dae(t) {
  return null != t && (null != t.polygons || null != t.lineStrings);
}
function qae(t) {
  let e = new Map();
  for (let n in t) {
    let i = t[n];
    if (!Dae(i)) continue;
    let {
      altitude: r,
      color: o,
      height: s,
      opacity: a
    } = i;
    (i.polygons || i.lineStrings).forEach(t => {
      e.set(t, {
        altitude: r,
        color: o,
        height: s,
        opacity: a
      });
    });
  }
  return e;
}
function kae(t, e, n, i) {
  let r = i.createGeoreferences(),
    o = new Set();
  n.forEach(t => {
    t.layer && o.add(t.layer);
  });
  let s = [...o].map(t => ({
      id: t,
      visible: !0
    })),
    a = 1 / i.mapScale;
  return {
    id: t,
    georeference: r,
    name: e,
    shortName: e,
    scene: {
      polygons: n
    },
    elevation: 0,
    scale: a,
    x_scale: a,
    layers: s,
    width: i.widthInMapUnits,
    height: i.heightInMapUnits
  };
}
u(Lk, "processObstructions"), u(Iae, "splitObstructionByAllEntrances"), u(Lae, "splitObstructionByEntrance"), u(Oae, "getEntranceMap"), u(Rae, "validateStaticMVFFiles"), u(Ok, "unzipMVF"), u(Nae, "getMapExtent"), u(Dae, "isPolygonStyle"), u(qae, "getStylesMap"), u(kae, "convertMap");
var ZP = class {
  constructor(t) {
    A(this, "mapExtent"), A(this, "stretchRatio"), A(this, "midLat"), A(this, "midLong"), A(this, "mapUnitRatio", 1e6), A(this, "latDistance"), A(this, "longDistance"), A(this, "mapScale"), A(this, "widthInMapUnits"), A(this, "heightInMapUnits"), this.mapExtent = t;
    let {
        minLat: e,
        minLong: n,
        maxLat: i,
        maxLong: r
      } = t,
      o = (e + i) / 2,
      s = (n + r) / 2,
      a = new _t(o, r),
      l = new _t(o, n),
      u = new _t(e, s),
      h = new _t(i, s);
    this.latDistance = u.distanceTo(h), this.longDistance = a.distanceTo(l);
    let c = this.latDistance / this.longDistance,
      p = (i - e) / (r - n);
    this.stretchRatio = c / p, this.midLat = o, this.midLong = s, this.widthInMapUnits = (r - n) * this.mapUnitRatio, this.heightInMapUnits = (i - e) * this.mapUnitRatio * this.stretchRatio, this.mapScale = this.widthInMapUnits / this.longDistance;
  }
  convert(t) {
    let e = t[1],
      n = (t[0] - this.midLong) * this.mapUnitRatio,
      i = (this.midLat - e) * this.mapUnitRatio * this.stretchRatio;
    return {
      x: n + this.widthInMapUnits / 2,
      y: i + this.heightInMapUnits / 2
    };
  }
  createGeoreferences() {
    let {
      minLat: t,
      minLong: e,
      maxLat: n,
      maxLong: i
    } = this.mapExtent;
    return [[t, e], [t, i], [n, i], [n, e]].map(t => ({
      target: {
        x: t[0],
        y: t[1]
      },
      control: this.convert([t[1], t[0]])
    }));
  }
};
function Fae(t, e) {
  return [];
}
u(ZP, "CoordinateConverter"), u(Fae, "convertNodes");
var Rk = u((t, e, n, i) => {
  let r = [];
  return e.features.forEach(e => {
    if (!e.geometry.coordinates[0].forEach) return;
    let o = n.get(e.properties.id),
      s = e.geometry.coordinates[0].map(t => i.convert(t)),
      a = e.geometry.coordinates.slice(1).map(t => t.map(t => i.convert(t))),
      l = Math.max(i.widthInMapUnits, i.heightInMapUnits) / 1e3;
    r.push({
      entrances: [],
      map: t,
      id: e.properties.externalId || "",
      externalId: e.properties.externalId || "",
      layer: e.properties.kind || "",
      geometry: {
        visible: !0,
        position: {
          x: 0,
          y: 0,
          z: ((null == o ? void 0 : o.altitude) || 0) * i.mapScale / l
        },
        scale: {
          x: 1,
          y: 1,
          z: ((null == o ? void 0 : o.height) || 1) * i.mapScale / l
        }
      },
      material: {
        color: (null == o ? void 0 : o.color) || "#000000"
      },
      vertexes: s,
      holes: a
    });
  }), r;
}, "generateMappedinPolygons");
function Bae(t, e, n, i, r) {
  let o = Rk(t, n, i, r),
    s = Rk(t, e, i, r);
  return o.concat(s);
}
function Uae(t) {
  return [];
}
function Nk(t) {
  let e = new TextDecoder(),
    n = e.decode.bind(e);
  try {
    let e = {
        "connection.json": JSON.parse(n(t["connection.json"])),
        "manifest.geojson": JSON.parse(n(t["manifest.geojson"])),
        "styles.json": JSON.parse(n(t["styles.json"])),
        "map.geojson": JSON.parse(n(t["map.geojson"])),
        "mapstack.geojson": JSON.parse(n(t["mapstack.geojson"])),
        "node.geojson": JSON.parse(n(t["node.geojson"])),
        obstruction: {},
        space: {},
        entrance: {}
      },
      i = Object.keys(t.space);
    for (let r of i) {
      let i = r.replace(/\.json|\.geojson/g, "");
      e.space[i] = JSON.parse(n(t.space[r]));
    }
    let r = Object.keys(t.obstruction);
    for (let i of r) {
      let r = i.replace(/\.json|\.geojson/g, "");
      e.obstruction[r] = JSON.parse(n(t.obstruction[i]));
    }
    let o = Object.keys(t.entrance);
    for (let i of o) {
      let r = i.replace(/\.json|\.geojson/g, "");
      e.entrance[r] = JSON.parse(n(t.entrance[i]));
    }
    return e;
  } catch (t) {
    throw ke.error(t), new Error("MVF parsing failed! Probably encountered a bad file.");
  }
}
function Dk(t) {
  var e, n, i, r, o, s, a, l, u;
  let h = null != (e = t.obstruction) ? e : {},
    c = null != (n = t.space) ? n : {},
    p = null != (i = t.entrance) ? i : {},
    d = null != (r = t["mapstack.geojson"]) ? r : {},
    f = null != (o = t["styles.json"]) ? o : {},
    m = null != (s = t["manifest.geojson"]) ? s : {},
    g = null != (a = t["node.geojson"]) ? a : {},
    v = null != (l = t["connection.json"]) ? l : {},
    y = {},
    _ = new Map(),
    x = [],
    E = [],
    b = qae(f);
  d.forEach(({
    maps: t
  }) => {
    t.forEach((t, e) => {
      let n = Lk(h[t], p[t]);
      if (n.features.length) {
        let i = Nae(n),
          r = new ZP(i);
        _.set(t, r), y[t] = Bae(t, n, c[t], b, r), E = E.concat(Fae(g[t], r)), x.push(kae(t, `Map #${e + 1}`, y[t], r));
      }
    });
  });
  let w = Object.values(y).flat(),
    S = Uae(v),
    M = m.features[0],
    T = M.properties.name,
    A = M.geometry.coordinates[0];
  return {
    polygons: w,
    venue: {
      name: T,
      latitude: M.geometry.coordinates[1],
      longitude: A,
      defaultMap: (null == (u = x[0]) ? void 0 : u.id) || ""
    },
    maps: x,
    vortexes: S,
    nodes: E,
    locations: [],
    mapGroups: [],
    locationStates: [],
    categories: [],
    themes: [],
    imageBinaries: new Map()
  };
}
u(Bae, "convertPolygons"), u(Uae, "convertVortexes"), u(Nk, "parseMVF"), u(Dk, "convertMVFToMappedin");
var ii,
  JP = {
    supplementaryUrl: "https://api-gateway.mappedin.com/analytics/",
    headers: {},
    accessToken: "",
    clientId: "",
    noAuth: !1,
    includeHidden: !0,
    clientSecret: "",
    apiGateway: "",
    authorization: "",
    perspective: "Website",
    language: "",
    things: {},
    venue: ""
  };
!function (t) {
  t.CATEGORY = "categories", t.EVENT = "events", t.LOCATION = "locations", t.MAPGROUP = "mapGroups", t.MAP = "maps", t.NODE = "nodes", t.POLYGON = "polygons", t.VORTEX = "vortexes";
}(ii || (ii = {}));
var Eh,
  Sm,
  Tm,
  yE,
  zae,
  wm = {
    categories: mh,
    locations: zl,
    vortexes: Xd,
    maps: Nf,
    nodes: hl,
    polygons: ec,
    venue: Df,
    events: zd,
    mapGroups: Gd,
    themes: rM,
    locationStates: Jb,
    rankings: yv
  },
  tu = class {
    constructor(t) {
      re(this, yE), A(this, "perspective"), A(this, "things"), A(this, "options"), re(this, Eh, void 0), re(this, Sm, ""), A(this, "updatedAt"), A(this, "categories", []), A(this, "locations", []), A(this, "vortexes", []), A(this, "maps", []), A(this, "nodes", []), A(this, "polygons", []), A(this, "venue", {}), A(this, "events", []), A(this, "mapGroups", []), A(this, "themes", []), A(this, "locationStates", []), A(this, "rankings"), A(this, "_categoriesById"), A(this, "_locationsById"), A(this, "_vortexesById"), A(this, "_mapsById"), A(this, "_nodesById"), A(this, "_polygonsById"), A(this, "_eventsById"), A(this, "_mapGroupsById"), A(this, "_locationStatesById"), A(this, "_locationRankingsById"), A(this, "_rankingsById"), A(this, "_categoriesByExternalId"), A(this, "_locationsByExternalId"), A(this, "_vortexesByExternalId"), A(this, "_mapsByExternalId"), A(this, "_nodesByExternalId"), A(this, "_polygonsByExternalId"), A(this, "_eventsByExternalId"), A(this, "_mapGroupsByExternalId"), A(this, "_locationStatesByExternalId"), A(this, "_locationRankingsByExternalId"), A(this, "_rankingsByExternalId"), re(this, Tm, void 0), A(this, "images"), A(this, "imageBinaries"), A(this, "scenes"), A(this, "analytics"), A(this, "navigator"), this.options = t, he(this, Eh, Ws.create(this));
      let e = new Ea({
        ...t,
        testMode: !(null == t ? void 0 : t.emitAnalyticsEvents)
      });
      this.analytics = {
        locationSelected: e.locationSelected,
        categorySelected: e.categorySelected,
        getDirections: e.getDirections
      }, globalThis.MappedinDebug || (globalThis.MappedinDebug = {
        enable() {
          globalThis.sessionStorage.setItem(o7, "true");
        }
      });
    }
    generateGetters(t) {
      try {
        for (let e = 0, n = t.length; e < n; ++e) {
          let n = t[e];
          Array.isArray(this[n]) && (Object.defineProperty(this, `_${n}ByExternalId`, {
            get() {
              let t = w(this, Eh)[n];
              if (null != t) return t;
              let e = {};
              return this[n].forEach(t => e[t.externalId] = t), w(this, Eh)[n] = e, e;
            }
          }), Object.defineProperty(this, `_${n}ById`, {
            get() {
              let t = w(this, Eh)[n];
              if (null != t) return t;
              let e = {};
              return this[n].forEach(t => e[t.id] = t), w(this, Eh)[n] = e, e;
            }
          }));
        }
        return this;
      } catch (t) {
        throw new Error("Unable to generate getters, " + t);
      }
    }
    getCollectionItemById(t, e) {
      let n = `_${t}ByExternalId`,
        i = this[`_${t}ById`];
      return null != i && null != i[e] || (i = this[n], null != i && null != i[e]) ? i[e] : null;
    }
    async hydrateFromMVF(t) {
      let e = Dk(t);
      return this.hydrate(e);
    }
    async hydrate(t, e) {
      let n;
      if ("string" == typeof t) try {
        he(this, Sm, t), n = JSON.parse(t);
      } catch (t) {
        return void ke.error("Unable to parse JSON", t);
      } else n = t, he(this, Sm, JSON.stringify(n));
      let i = Object.keys(n);
      for (let t = 0, e = i.length; t < e; ++t) {
        let e = i[t],
          r = n[e];
        null != wm[e] && "function" == typeof wm[e].hydrate && (this[e] = wm[e].hydrate(r, this));
      }
      e && (await yR(n));
      let {
        images: r,
        scenes: o,
        imageBinaries: s
      } = n;
      this.images = r, this.scenes = o, this.imageBinaries = s, this.generateGetters(i), this.initNavigator();
    }
    async fetch() {
      "vortexes" in this.options.things || (this.options.things.vortexes = ["name", "type", "accessible", "weight", "multiplier", "nodes"]), "locationStates" in this.options.things || (this.options.things.locationStates = ["name", "id", "value"]), dR(this.options.clientId) || this.options.things.rankings && delete this.options.things.rankings;
      let {
          things: t
        } = this.options,
        e = [],
        n = Object.keys(t);
      for (let t = 0, i = n.length; t < i; ++t) {
        let i = n[t];
        wm[i] && e.push(wm[i].fetch(this).then(t => (this[i] = t, Promise.resolve())));
      }
      return e.push(nv(this.options, "cdn-access-token", {
        venue: this.options.venue
      }, !1).then(t => he(this, Tm, t.token), () => Promise.resolve())), this.generateGetters(n), Promise.all(e).then(() => {
        mt(this, yE, zae).call(this), this.initNavigator();
      });
    }
    initNavigator() {
      this.navigator = new NT({
        locations: this.locations.map(t => t.toJSON()),
        nodes: this.nodes.map(t => t.toJSON()),
        vortexes: this.vortexes.map(t => t.toJSON()),
        maps: this.maps.map(t => t.toJSON())
      });
    }
    toJSON() {
      var t;
      let e = {};
      for (let t in wm) Array.isArray(this[t]) && (e[t] = this[t].map(t => t.toJSON()));
      let n = {
        ...e,
        venue: this.venue.toJSON()
      };
      return null != this.rankings && (n.rankings = null == (t = this.rankings) ? void 0 : t.toJSON()), delete n.locationRankings, n;
    }
    toString() {
      return w(this, Sm) || JSON.stringify(this.toJSON());
    }
  };
u(tu, "Mappedin"), Eh = new WeakMap(), Sm = new WeakMap(), Tm = new WeakMap(), yE = new WeakSet(), zae = u(function () {
  w(this, Tm) && this.maps.forEach(t => {
    var e;
    (null == (e = t.scene) ? void 0 : e.polygons) && (t.scene.polygons += `?${w(this, Tm)}`);
  });
}, "#transformData"), E();
var qk = {
  venue: ["slug", "name", "defaultMap", "metadata", "countrycode", "tzid", "logo", "externalId", "secureContentStorage", "languages"],
  nodes: ["externalId", "x", "y", "paths", "accessible", "operationHours"],
  vortexes: ["externalId", "nodes", "types", "accessible"],
  polygons: ["vertexes", "geometry", "canvasBounds", "layer", "externalId", "entrances"],
  locations: ["externalId", "name", "type", "picture", "description", "icon", "logo", "sortOrder", "phone", "operationHours", "social", "color", "toMap", "tags", "shortName", "detailsUrl", "locationState", "metadata", "siblingGroups", "gallery", "showSmartLabelWhenImagePresent", "amenity"],
  categories: ["name", "color", "sortOrder", "parents", "icon", "iconFromDefaultList"],
  maps: ["name", "elevation", "height", "width", "layers", "shortName", "scene", "group", "x_scale"],
  mapGroups: ["name"],
  themes: ["name", "themeData"],
  rankings: ["polygons"]
};
E(), E();
var Lr = u(function () {
  return Lr = Object.assign || u(function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    return t;
  }, "__assign"), Lr.apply(this, arguments);
}, "__assign");
function oi(t) {
  var e = "function" == typeof Symbol && Symbol.iterator,
    n = e && t[e],
    i = 0;
  if (n) return n.call(t);
  if (t && "number" == typeof t.length) return {
    next: function () {
      return t && i >= t.length && (t = void 0), {
        value: t && t[i++],
        done: !t
      };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Oo(t, e) {
  var n = "function" == typeof Symbol && t[Symbol.iterator];
  if (!n) return t;
  var i,
    r,
    o = n.call(t),
    s = [];
  try {
    for (; (void 0 === e || e-- > 0) && !(i = o.next()).done;) s.push(i.value);
  } catch (t) {
    r = {
      error: t
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (r) throw r.error;
    }
  }
  return s;
}
u(oi, "__values"), u(Oo, "__read");
var oy,
  Vae = "ENTRIES",
  kk = "KEYS",
  Fk = "VALUES",
  Ro = "",
  KP = function () {
    function t(t, e) {
      var n = t._tree,
        i = Array.from(n.keys());
      this.set = t, this._type = e, this._path = i.length > 0 ? [{
        node: n,
        keys: i
      }] : [];
    }
    return u(t, "TreeIterator"), t.prototype.next = function () {
      var t = this.dive();
      return this.backtrack(), t;
    }, t.prototype.dive = function () {
      if (0 === this._path.length) return {
        done: !0,
        value: void 0
      };
      var t = Pm(this._path),
        e = t.node,
        n = t.keys;
      if (Pm(n) === Ro) return {
        done: !1,
        value: this.result()
      };
      var i = e.get(Pm(n));
      return this._path.push({
        node: i,
        keys: Array.from(i.keys())
      }), this.dive();
    }, t.prototype.backtrack = function () {
      if (0 !== this._path.length) {
        var t = Pm(this._path).keys;
        t.pop(), !(t.length > 0) && (this._path.pop(), this.backtrack());
      }
    }, t.prototype.key = function () {
      return this.set._prefix + this._path.map(function (t) {
        var e = t.keys;
        return Pm(e);
      }).filter(function (t) {
        return t !== Ro;
      }).join("");
    }, t.prototype.value = function () {
      return Pm(this._path).node.get(Ro);
    }, t.prototype.result = function () {
      switch (this._type) {
        case Fk:
          return this.value();
        case kk:
          return this.key();
        default:
          return [this.key(), this.value()];
      }
    }, t.prototype[Symbol.iterator] = function () {
      return this;
    }, t;
  }(),
  Pm = u(function (t) {
    return t[t.length - 1];
  }, "last$1"),
  Gae = u(function (t, e, n) {
    var i = new Map();
    if (void 0 === e) return i;
    for (var r = e.length + 1, o = r + n, s = new Uint8Array(o * r).fill(n + 1), a = 0; a < r; ++a) s[a] = a;
    for (var l = 1; l < o; ++l) s[l * r] = l;
    return Bk(t, e, n, i, s, 1, r, ""), i;
  }, "fuzzySearch"),
  Bk = u(function (t, e, n, i, r, o, s, a) {
    var l,
      u,
      h = o * s;
    try {
      t: for (var c = oi(t.keys()), p = c.next(); !p.done; p = c.next()) {
        var d = p.value;
        if (d === Ro) {
          var f = r[h - 1];
          f <= n && i.set(a, [t.get(d), f]);
        } else {
          for (var m = o, g = 0; g < d.length; ++g, ++m) {
            for (var v = d[g], y = s * m, _ = y - s, x = r[y], E = Math.max(0, m - n - 1), b = Math.min(s - 1, m + n), w = E; w < b; ++w) {
              var S = v !== e[w],
                M = r[_ + w] + +S,
                T = r[_ + w + 1] + 1,
                A = r[y + w] + 1,
                P = r[y + w + 1] = Math.min(M, T, A);
              P < x && (x = P);
            }
            if (x > n) continue t;
          }
          Bk(t.get(d), e, n, i, r, m, s, a + d);
        }
      }
    } catch (t) {
      l = {
        error: t
      };
    } finally {
      try {
        p && !p.done && (u = c.return) && u.call(c);
      } finally {
        if (l) throw l.error;
      }
    }
  }, "recurse"),
  QP = function () {
    function t(t, e) {
      void 0 === t && (t = new Map()), void 0 === e && (e = ""), this._size = void 0, this._tree = t, this._prefix = e;
    }
    return u(t, "SearchableMap"), t.prototype.atPrefix = function (e) {
      var n, i;
      if (!e.startsWith(this._prefix)) throw new Error("Mismatched prefix");
      var r = Oo(_E(this._tree, e.slice(this._prefix.length)), 2),
        o = r[0],
        s = r[1];
      if (void 0 === o) {
        var a = Oo(tC(s), 2),
          l = a[0],
          u = a[1];
        try {
          for (var h = oi(l.keys()), c = h.next(); !c.done; c = h.next()) {
            var p = c.value;
            if (p !== Ro && p.startsWith(u)) {
              var d = new Map();
              return d.set(p.slice(u.length), l.get(p)), new t(d, e);
            }
          }
        } catch (t) {
          n = {
            error: t
          };
        } finally {
          try {
            c && !c.done && (i = h.return) && i.call(h);
          } finally {
            if (n) throw n.error;
          }
        }
      }
      return new t(o, e);
    }, t.prototype.clear = function () {
      this._size = void 0, this._tree.clear();
    }, t.prototype.delete = function (t) {
      return this._size = void 0, Hae(this._tree, t);
    }, t.prototype.entries = function () {
      return new KP(this, Vae);
    }, t.prototype.forEach = function (t) {
      var e, n;
      try {
        for (var i = oi(this), r = i.next(); !r.done; r = i.next()) {
          var o = Oo(r.value, 2);
          t(o[0], o[1], this);
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          r && !r.done && (n = i.return) && n.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
    }, t.prototype.fuzzyGet = function (t, e) {
      return Gae(this._tree, t, e);
    }, t.prototype.get = function (t) {
      var e = $P(this._tree, t);
      return void 0 !== e ? e.get(Ro) : void 0;
    }, t.prototype.has = function (t) {
      var e = $P(this._tree, t);
      return void 0 !== e && e.has(Ro);
    }, t.prototype.keys = function () {
      return new KP(this, kk);
    }, t.prototype.set = function (t, e) {
      if ("string" != typeof t) throw new Error("key must be a string");
      return this._size = void 0, eC(this._tree, t).set(Ro, e), this;
    }, Object.defineProperty(t.prototype, "size", {
      get: function () {
        if (this._size) return this._size;
        this._size = 0;
        for (var t = this.entries(); !t.next().done;) this._size += 1;
        return this._size;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.update = function (t, e) {
      if ("string" != typeof t) throw new Error("key must be a string");
      this._size = void 0;
      var n = eC(this._tree, t);
      return n.set(Ro, e(n.get(Ro))), this;
    }, t.prototype.fetch = function (t, e) {
      if ("string" != typeof t) throw new Error("key must be a string");
      this._size = void 0;
      var n = eC(this._tree, t),
        i = n.get(Ro);
      return void 0 === i && n.set(Ro, i = e()), i;
    }, t.prototype.values = function () {
      return new KP(this, Fk);
    }, t.prototype[Symbol.iterator] = function () {
      return this.entries();
    }, t.from = function (e) {
      var n,
        i,
        r = new t();
      try {
        for (var o = oi(e), s = o.next(); !s.done; s = o.next()) {
          var a = Oo(s.value, 2),
            l = a[0],
            u = a[1];
          r.set(l, u);
        }
      } catch (t) {
        n = {
          error: t
        };
      } finally {
        try {
          s && !s.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
      return r;
    }, t.fromObject = function (e) {
      return t.from(Object.entries(e));
    }, t;
  }(),
  _E = u(function (t, e, n) {
    var i, r;
    if (void 0 === n && (n = []), 0 === e.length || null == t) return [t, n];
    try {
      for (var o = oi(t.keys()), s = o.next(); !s.done; s = o.next()) {
        var a = s.value;
        if (a !== Ro && e.startsWith(a)) return n.push([t, a]), _E(t.get(a), e.slice(a.length), n);
      }
    } catch (t) {
      i = {
        error: t
      };
    } finally {
      try {
        s && !s.done && (r = o.return) && r.call(o);
      } finally {
        if (i) throw i.error;
      }
    }
    return n.push([t, e]), _E(void 0, "", n);
  }, "trackDown"),
  $P = u(function (t, e) {
    var n, i;
    if (0 === e.length || null == t) return t;
    try {
      for (var r = oi(t.keys()), o = r.next(); !o.done; o = r.next()) {
        var s = o.value;
        if (s !== Ro && e.startsWith(s)) return $P(t.get(s), e.slice(s.length));
      }
    } catch (t) {
      n = {
        error: t
      };
    } finally {
      try {
        o && !o.done && (i = r.return) && i.call(r);
      } finally {
        if (n) throw n.error;
      }
    }
  }, "lookup"),
  eC = u(function (t, e) {
    var n,
      i,
      r = e.length;
    t: for (var o = 0; t && o < r;) {
      try {
        for (var s = (n = void 0, oi(t.keys())), a = s.next(); !a.done; a = s.next()) {
          var l = a.value;
          if (l !== Ro && e[o] === l[0]) {
            for (var u = Math.min(r - o, l.length), h = 1; h < u && e[o + h] === l[h];) ++h;
            var c = t.get(l);
            if (h === l.length) t = c;else {
              var p = new Map();
              p.set(l.slice(h), c), t.set(e.slice(o, o + h), p), t.delete(l), t = p;
            }
            o += h;
            continue t;
          }
        }
      } catch (t) {
        n = {
          error: t
        };
      } finally {
        try {
          a && !a.done && (i = s.return) && i.call(s);
        } finally {
          if (n) throw n.error;
        }
      }
      var d = new Map();
      return t.set(e.slice(o), d), d;
    }
    return t;
  }, "createPath"),
  Hae = u(function (t, e) {
    var n = Oo(_E(t, e), 2),
      i = n[0],
      r = n[1];
    if (void 0 !== i) if (i.delete(Ro), 0 === i.size) Uk(r);else if (1 === i.size) {
      var o = Oo(i.entries().next().value, 2),
        s = o[0],
        a = o[1];
      zk(r, s, a);
    }
  }, "remove"),
  Uk = u(function (t) {
    if (0 !== t.length) {
      var e = Oo(tC(t), 2),
        n = e[0],
        i = e[1];
      if (n.delete(i), 0 === n.size) Uk(t.slice(0, -1));else if (1 === n.size) {
        var r = Oo(n.entries().next().value, 2),
          o = r[0],
          s = r[1];
        o !== Ro && zk(t.slice(0, -1), o, s);
      }
    }
  }, "cleanup"),
  zk = u(function (t, e, n) {
    if (0 !== t.length) {
      var i = Oo(tC(t), 2),
        r = i[0],
        o = i[1];
      r.set(o + e, n), r.delete(o);
    }
  }, "merge"),
  tC = u(function (t) {
    return t[t.length - 1];
  }, "last"),
  nC = "or",
  jae = "and",
  Wae = "and_not",
  Kf = function () {
    function t(t) {
      if (null == (null == t ? void 0 : t.fields)) throw new Error('MiniSearch: option "fields" must be provided');
      this._options = Lr(Lr(Lr({}, rC), t), {
        searchOptions: Lr(Lr({}, Hk), t.searchOptions || {})
      }), this._index = new QP(), this._documentCount = 0, this._documentIds = new Map(), this._fieldIds = {}, this._fieldLength = new Map(), this._avgFieldLength = [], this._nextId = 0, this._storedFields = new Map(), this.addFields(this._options.fields);
    }
    return u(t, "MiniSearch"), t.prototype.add = function (t) {
      var e,
        n,
        i,
        r,
        o = this._options,
        s = o.extractField,
        a = o.tokenize,
        l = o.processTerm,
        u = o.fields,
        h = o.idField,
        c = s(t, h);
      if (null == c) throw new Error('MiniSearch: document does not have ID field "'.concat(h, '"'));
      var p = this.addDocumentId(c);
      this.saveStoredFields(p, t);
      try {
        for (var d = oi(u), f = d.next(); !f.done; f = d.next()) {
          var m = f.value,
            g = s(t, m);
          if (null != g) {
            var v = a(g.toString(), m),
              y = this._fieldIds[m],
              _ = new Set(v).size;
            this.addFieldLength(p, y, this._documentCount - 1, _);
            try {
              for (var x = (i = void 0, oi(v)), E = x.next(); !E.done; E = x.next()) {
                var b = l(E.value, m);
                b && this.addTerm(y, p, b);
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                E && !E.done && (r = x.return) && r.call(x);
              } finally {
                if (i) throw i.error;
              }
            }
          }
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          f && !f.done && (n = d.return) && n.call(d);
        } finally {
          if (e) throw e.error;
        }
      }
    }, t.prototype.addAll = function (t) {
      var e, n;
      try {
        for (var i = oi(t), r = i.next(); !r.done; r = i.next()) {
          var o = r.value;
          this.add(o);
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          r && !r.done && (n = i.return) && n.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
    }, t.prototype.addAllAsync = function (t, e) {
      var n = this;
      void 0 === e && (e = {});
      var i = e.chunkSize,
        r = void 0 === i ? 10 : i,
        o = {
          chunk: [],
          promise: Promise.resolve()
        },
        s = t.reduce(function (t, e, i) {
          var o = t.chunk,
            s = t.promise;
          return o.push(e), (i + 1) % r == 0 ? {
            chunk: [],
            promise: s.then(function () {
              return new Promise(function (t) {
                return setTimeout(t, 0);
              });
            }).then(function () {
              return n.addAll(o);
            })
          } : {
            chunk: o,
            promise: s
          };
        }, o),
        a = s.chunk;
      return s.promise.then(function () {
        return n.addAll(a);
      });
    }, t.prototype.remove = function (t) {
      var e,
        n,
        i,
        r,
        o,
        s,
        a = this._options,
        l = a.tokenize,
        u = a.processTerm,
        h = a.extractField,
        c = a.fields,
        p = a.idField,
        d = h(t, p);
      if (null == d) throw new Error('MiniSearch: document does not have ID field "'.concat(p, '"'));
      try {
        for (var f = oi(this._documentIds), m = f.next(); !m.done; m = f.next()) {
          var g = Oo(m.value, 2),
            v = g[0];
          if (d === g[1]) {
            try {
              for (var y = (i = void 0, oi(c)), _ = y.next(); !_.done; _ = y.next()) {
                var x = _.value,
                  E = h(t, x);
                if (null != E) {
                  var b = l(E.toString(), x),
                    w = this._fieldIds[x],
                    S = new Set(b).size;
                  this.removeFieldLength(v, w, this._documentCount, S);
                  try {
                    for (var M = (o = void 0, oi(b)), T = M.next(); !T.done; T = M.next()) {
                      var A = u(T.value, x);
                      A && this.removeTerm(w, v, A);
                    }
                  } catch (t) {
                    o = {
                      error: t
                    };
                  } finally {
                    try {
                      T && !T.done && (s = M.return) && s.call(M);
                    } finally {
                      if (o) throw o.error;
                    }
                  }
                }
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                _ && !_.done && (r = y.return) && r.call(y);
              } finally {
                if (i) throw i.error;
              }
            }
            return this._storedFields.delete(v), this._documentIds.delete(v), this._fieldLength.delete(v), void (this._documentCount -= 1);
          }
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          m && !m.done && (n = f.return) && n.call(f);
        } finally {
          if (e) throw e.error;
        }
      }
      throw new Error("MiniSearch: cannot remove document with ID ".concat(d, ": it is not in the index"));
    }, t.prototype.removeAll = function (t) {
      var e, n;
      if (t) try {
        for (var i = oi(t), r = i.next(); !r.done; r = i.next()) {
          var o = r.value;
          this.remove(o);
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          r && !r.done && (n = i.return) && n.call(i);
        } finally {
          if (e) throw e.error;
        }
      } else {
        if (arguments.length > 0) throw new Error("Expected documents to be present. Omit the argument to remove all documents.");
        this._index = new QP(), this._documentCount = 0, this._documentIds = new Map(), this._fieldLength = new Map(), this._avgFieldLength = [], this._storedFields = new Map(), this._nextId = 0;
      }
    }, t.prototype.search = function (t, e) {
      var n, i;
      void 0 === e && (e = {});
      var r = this.executeQuery(t, e),
        o = [];
      try {
        for (var s = oi(r), a = s.next(); !a.done; a = s.next()) {
          var l = Oo(a.value, 2),
            u = l[0],
            h = l[1],
            c = h.score,
            p = h.terms,
            d = h.match,
            f = p.length,
            m = {
              id: this._documentIds.get(u),
              score: c * f,
              terms: Object.keys(d),
              match: d
            };
          Object.assign(m, this._storedFields.get(u)), (null == e.filter || e.filter(m)) && o.push(m);
        }
      } catch (t) {
        n = {
          error: t
        };
      } finally {
        try {
          a && !a.done && (i = s.return) && i.call(s);
        } finally {
          if (n) throw n.error;
        }
      }
      return o.sort(Wk), o;
    }, t.prototype.autoSuggest = function (t, e) {
      var n, i, r, o;
      void 0 === e && (e = {}), e = Lr(Lr({}, Kae), e);
      var s = new Map();
      try {
        for (var a = oi(this.search(t, e)), l = a.next(); !l.done; l = a.next()) {
          var u = l.value,
            h = u.score,
            c = (y = u.terms).join(" ");
          null != (g = s.get(c)) ? (g.score += h, g.count += 1) : s.set(c, {
            score: h,
            terms: y,
            count: 1
          });
        }
      } catch (t) {
        n = {
          error: t
        };
      } finally {
        try {
          l && !l.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      var p = [];
      try {
        for (var d = oi(s), f = d.next(); !f.done; f = d.next()) {
          var m = Oo(f.value, 2),
            g = m[0],
            v = m[1],
            y = (h = v.score, v.terms),
            _ = v.count;
          p.push({
            suggestion: g,
            terms: y,
            score: h / _
          });
        }
      } catch (t) {
        r = {
          error: t
        };
      } finally {
        try {
          f && !f.done && (o = d.return) && o.call(d);
        } finally {
          if (r) throw r.error;
        }
      }
      return p.sort(Wk), p;
    }, Object.defineProperty(t.prototype, "documentCount", {
      get: function () {
        return this._documentCount;
      },
      enumerable: !1,
      configurable: !0
    }), t.loadJSON = function (e, n) {
      if (null == n) throw new Error("MiniSearch: loadJSON should be given the same options used when serializing the index");
      return t.loadJS(JSON.parse(e), n);
    }, t.getDefault = function (t) {
      if (rC.hasOwnProperty(t)) return iC(rC, t);
      throw new Error('MiniSearch: unknown option "'.concat(t, '"'));
    }, t.loadJS = function (e, n) {
      var i,
        r,
        o,
        s,
        a = e.index,
        l = e.documentCount,
        u = e.nextId,
        h = e.documentIds,
        c = e.fieldIds,
        p = e.fieldLength,
        d = e.averageFieldLength,
        f = e.storedFields,
        m = e.serializationVersion;
      if (1 !== m && 2 !== m) throw new Error("MiniSearch: cannot deserialize an index created with an incompatible version");
      var g = new t(n);
      g._documentCount = l, g._nextId = u, g._documentIds = xE(h), g._fieldIds = c, g._fieldLength = xE(p), g._avgFieldLength = d, g._storedFields = xE(f), g._index = new QP();
      try {
        for (var v = oi(a), y = v.next(); !y.done; y = v.next()) {
          var _ = Oo(y.value, 2),
            x = _[0],
            E = _[1],
            b = new Map();
          try {
            for (var w = (o = void 0, oi(Object.keys(E))), S = w.next(); !S.done; S = w.next()) {
              var M = S.value,
                T = E[M];
              1 === m && (T = T.ds), b.set(parseInt(M, 10), xE(T));
            }
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              S && !S.done && (s = w.return) && s.call(w);
            } finally {
              if (o) throw o.error;
            }
          }
          g._index.set(x, b);
        }
      } catch (t) {
        i = {
          error: t
        };
      } finally {
        try {
          y && !y.done && (r = v.return) && r.call(v);
        } finally {
          if (i) throw i.error;
        }
      }
      return g;
    }, t.prototype.executeQuery = function (t, e) {
      var n = this;
      if (void 0 === e && (e = {}), "string" != typeof t) {
        var i = Lr(Lr(Lr({}, e), t), {
            queries: void 0
          }),
          r = t.queries.map(function (t) {
            return n.executeQuery(t, i);
          });
        return this.combineResults(r, t.combineWith);
      }
      var o = this._options,
        s = o.tokenize,
        a = o.processTerm,
        l = o.searchOptions,
        u = Lr(Lr({
          tokenize: s,
          processTerm: a
        }, l), e),
        h = u.tokenize,
        c = u.processTerm,
        p = h(t).map(function (t) {
          return c(t);
        }).filter(function (t) {
          return !!t;
        }).map(Jae(u)).map(function (t) {
          return n.executeQuerySpec(t, u);
        });
      return this.combineResults(p, u.combineWith);
    }, t.prototype.executeQuerySpec = function (t, e) {
      var n,
        i,
        r,
        o,
        s,
        a,
        l = Lr(Lr({}, this._options.searchOptions), e),
        u = (l.fields || this._options.fields).reduce(function (t, e) {
          var n;
          return Lr(Lr({}, t), ((n = {})[e] = iC(t, e) || 1, n));
        }, l.boost || {}),
        h = l.boostDocument,
        c = l.weights,
        p = l.maxFuzzy,
        d = Lr(Lr({}, Hk.weights), c),
        f = d.fuzzy,
        m = d.prefix,
        g = this._index.get(t.term),
        v = this.termResults(t.term, t.term, 1, g, u, h);
      if (t.prefix && (s = this._index.atPrefix(t.term)), t.fuzzy) {
        var y = !0 === t.fuzzy ? .2 : t.fuzzy,
          _ = y < 1 ? Math.min(p, Math.round(t.term.length * y)) : y;
        _ && (a = this._index.fuzzyGet(t.term, _));
      }
      if (s) try {
        for (var x = oi(s), E = x.next(); !E.done; E = x.next()) {
          var b = Oo(E.value, 2),
            w = b[0],
            S = b[1];
          if (P = w.length - t.term.length) {
            null == a || a.delete(w);
            var M = m * w.length / (w.length + .3 * P);
            this.termResults(t.term, w, M, S, u, h, v);
          }
        }
      } catch (t) {
        n = {
          error: t
        };
      } finally {
        try {
          E && !E.done && (i = x.return) && i.call(x);
        } finally {
          if (n) throw n.error;
        }
      }
      if (a) try {
        for (var T = oi(a.keys()), A = T.next(); !A.done; A = T.next()) {
          w = A.value;
          var P,
            C = Oo(a.get(w), 2),
            I = C[0];
          if (P = C[1]) {
            M = f * w.length / (w.length + P);
            this.termResults(t.term, w, M, I, u, h, v);
          }
        }
      } catch (t) {
        r = {
          error: t
        };
      } finally {
        try {
          A && !A.done && (o = T.return) && o.call(T);
        } finally {
          if (r) throw r.error;
        }
      }
      return v;
    }, t.prototype.combineResults = function (t, e) {
      if (void 0 === e && (e = nC), 0 === t.length) return new Map();
      var n = e.toLowerCase();
      return t.reduce(Xae[n]) || new Map();
    }, t.prototype.toJSON = function () {
      var t,
        e,
        n,
        i,
        r = [];
      try {
        for (var o = oi(this._index), s = o.next(); !s.done; s = o.next()) {
          var a = Oo(s.value, 2),
            l = a[0],
            u = a[1],
            h = {};
          try {
            for (var c = (n = void 0, oi(u)), p = c.next(); !p.done; p = c.next()) {
              var d = Oo(p.value, 2),
                f = d[0],
                m = d[1];
              h[f] = Object.fromEntries(m);
            }
          } catch (t) {
            n = {
              error: t
            };
          } finally {
            try {
              p && !p.done && (i = c.return) && i.call(c);
            } finally {
              if (n) throw n.error;
            }
          }
          r.push([l, h]);
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          s && !s.done && (e = o.return) && e.call(o);
        } finally {
          if (t) throw t.error;
        }
      }
      return {
        documentCount: this._documentCount,
        nextId: this._nextId,
        documentIds: Object.fromEntries(this._documentIds),
        fieldIds: this._fieldIds,
        fieldLength: Object.fromEntries(this._fieldLength),
        averageFieldLength: this._avgFieldLength,
        storedFields: Object.fromEntries(this._storedFields),
        index: r,
        serializationVersion: 2
      };
    }, t.prototype.termResults = function (t, e, n, i, r, o, s) {
      var a, l, u, h, c;
      if (void 0 === s && (s = new Map()), null == i) return s;
      try {
        for (var p = oi(Object.keys(r)), d = p.next(); !d.done; d = p.next()) {
          var f = d.value,
            m = r[f],
            g = this._fieldIds[f],
            v = i.get(g);
          if (null != v) {
            var y = v.size,
              _ = this._avgFieldLength[g];
            try {
              for (var x = (u = void 0, oi(v.keys())), E = x.next(); !E.done; E = x.next()) {
                var b = E.value,
                  w = o ? o(this._documentIds.get(b), e) : 1;
                if (w) {
                  var S = v.get(b),
                    M = this._fieldLength.get(b)[g],
                    T = n * m * w * Zae(S, y, this._documentCount, M, _),
                    A = s.get(b);
                  if (A) {
                    A.score += T, Qae(A.terms, t);
                    var P = iC(A.match, e);
                    P ? P.push(f) : A.match[e] = [f];
                  } else s.set(b, {
                    score: T,
                    terms: [t],
                    match: (c = {}, c[e] = [f], c)
                  });
                }
              }
            } catch (t) {
              u = {
                error: t
              };
            } finally {
              try {
                E && !E.done && (h = x.return) && h.call(x);
              } finally {
                if (u) throw u.error;
              }
            }
          }
        }
      } catch (t) {
        a = {
          error: t
        };
      } finally {
        try {
          d && !d.done && (l = p.return) && l.call(p);
        } finally {
          if (a) throw a.error;
        }
      }
      return s;
    }, t.prototype.addTerm = function (t, e, n) {
      var i = this._index.fetch(n, Xk),
        r = i.get(t);
      if (null == r) (r = new Map()).set(e, 1), i.set(t, r);else {
        var o = r.get(e);
        r.set(e, (o || 0) + 1);
      }
    }, t.prototype.removeTerm = function (t, e, n) {
      if (this._index.has(n)) {
        var i = this._index.fetch(n, Xk),
          r = i.get(t);
        null == r || null == r.get(e) ? this.warnDocumentChanged(e, t, n) : r.get(e) <= 1 ? r.size <= 1 ? i.delete(t) : r.delete(e) : r.set(e, r.get(e) - 1), 0 === this._index.get(n).size && this._index.delete(n);
      } else this.warnDocumentChanged(e, t, n);
    }, t.prototype.warnDocumentChanged = function (t, e, n) {
      var i, r;
      if (null != console && null != console.warn) try {
        for (var o = oi(Object.keys(this._fieldIds)), s = o.next(); !s.done; s = o.next()) {
          var a = s.value;
          if (this._fieldIds[a] === e) return void console.warn("MiniSearch: document with ID ".concat(this._documentIds.get(t), ' has changed before removal: term "').concat(n, '" was not present in field "').concat(a, '". Removing a document after it has changed can corrupt the index!'));
        }
      } catch (t) {
        i = {
          error: t
        };
      } finally {
        try {
          s && !s.done && (r = o.return) && r.call(o);
        } finally {
          if (i) throw i.error;
        }
      }
    }, t.prototype.addDocumentId = function (t) {
      var e = this._nextId;
      return this._documentIds.set(e, t), this._documentCount += 1, this._nextId += 1, e;
    }, t.prototype.addFields = function (t) {
      for (var e = 0; e < t.length; e++) this._fieldIds[t[e]] = e;
    }, t.prototype.addFieldLength = function (t, e, n, i) {
      var r = this._fieldLength.get(t);
      null == r && this._fieldLength.set(t, r = []), r[e] = i;
      var o = (this._avgFieldLength[e] || 0) * n + i;
      this._avgFieldLength[e] = o / (n + 1);
    }, t.prototype.removeFieldLength = function (t, e, n, i) {
      var r = this._avgFieldLength[e] * n - i;
      this._avgFieldLength[e] = r / (n - 1);
    }, t.prototype.saveStoredFields = function (t, e) {
      var n,
        i,
        r = this._options,
        o = r.storeFields,
        s = r.extractField;
      if (null != o && 0 !== o.length) {
        var a = this._storedFields.get(t);
        null == a && this._storedFields.set(t, a = {});
        try {
          for (var l = oi(o), u = l.next(); !u.done; u = l.next()) {
            var h = u.value,
              c = s(e, h);
            void 0 !== c && (a[h] = c);
          }
        } catch (t) {
          n = {
            error: t
          };
        } finally {
          try {
            u && !u.done && (i = l.return) && i.call(l);
          } finally {
            if (n) throw n.error;
          }
        }
      }
    }, t;
  }(),
  iC = u(function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e) ? t[e] : void 0;
  }, "getOwnProperty"),
  Xae = ((oy = {})[nC] = function (t, e) {
    var n, i;
    try {
      for (var r = oi(e.keys()), o = r.next(); !o.done; o = r.next()) {
        var s = o.value,
          a = t.get(s);
        if (null == a) t.set(s, e.get(s));else {
          var l = e.get(s),
            u = l.score,
            h = l.terms,
            c = l.match;
          a.score = a.score + u, a.match = Object.assign(a.match, c), jk(a.terms, h);
        }
      }
    } catch (t) {
      n = {
        error: t
      };
    } finally {
      try {
        o && !o.done && (i = r.return) && i.call(r);
      } finally {
        if (n) throw n.error;
      }
    }
    return t;
  }, oy[jae] = function (t, e) {
    var n,
      i,
      r = new Map();
    try {
      for (var o = oi(e.keys()), s = o.next(); !s.done; s = o.next()) {
        var a = s.value,
          l = t.get(a);
        if (null != l) {
          var u = e.get(a),
            h = u.score,
            c = u.terms,
            p = u.match;
          jk(l.terms, c), r.set(a, {
            score: l.score + h,
            terms: l.terms,
            match: Object.assign(l.match, p)
          });
        }
      }
    } catch (t) {
      n = {
        error: t
      };
    } finally {
      try {
        s && !s.done && (i = o.return) && i.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
    return r;
  }, oy[Wae] = function (t, e) {
    var n, i;
    try {
      for (var r = oi(e.keys()), o = r.next(); !o.done; o = r.next()) {
        var s = o.value;
        t.delete(s);
      }
    } catch (t) {
      n = {
        error: t
      };
    } finally {
      try {
        o && !o.done && (i = r.return) && i.call(r);
      } finally {
        if (n) throw n.error;
      }
    }
    return t;
  }, oy),
  Vk = 1.2,
  Gk = .7,
  Yae = .5,
  Zae = u(function (t, e, n, i, r) {
    return Math.log(1 + (n - e + .5) / (e + .5)) * (Yae + t * (Vk + 1) / (t + Vk * (1 - Gk + Gk * i / r)));
  }, "calcBM25Score"),
  Jae = u(function (t) {
    return function (e, n, i) {
      return {
        term: e,
        fuzzy: "function" == typeof t.fuzzy ? t.fuzzy(e, n, i) : t.fuzzy || !1,
        prefix: "function" == typeof t.prefix ? t.prefix(e, n, i) : !0 === t.prefix
      };
    };
  }, "termToQuerySpec"),
  rC = {
    idField: "id",
    extractField: function (t, e) {
      return t[e];
    },
    tokenize: function (t, e) {
      return t.split($ae);
    },
    processTerm: function (t, e) {
      return t.toLowerCase();
    },
    fields: void 0,
    searchOptions: void 0,
    storeFields: []
  },
  Hk = {
    combineWith: nC,
    prefix: !1,
    fuzzy: !1,
    maxFuzzy: 6,
    boost: {},
    weights: {
      fuzzy: .45,
      prefix: .375
    }
  },
  Kae = {
    prefix: function (t, e, n) {
      return e === n.length - 1;
    }
  },
  Qae = u(function (t, e) {
    t.includes(e) || t.push(e);
  }, "assignUniqueTerm"),
  jk = u(function (t, e) {
    var n, i;
    try {
      for (var r = oi(e), o = r.next(); !o.done; o = r.next()) {
        var s = o.value;
        t.includes(s) || t.push(s);
      }
    } catch (t) {
      n = {
        error: t
      };
    } finally {
      try {
        o && !o.done && (i = r.return) && i.call(r);
      } finally {
        if (n) throw n.error;
      }
    }
  }, "assignUniqueTerms"),
  Wk = u(function (t, e) {
    var n = t.score;
    return e.score - n;
  }, "byScore"),
  Xk = u(function () {
    return new Map();
  }, "createMap"),
  xE = u(function (t) {
    var e,
      n,
      i = new Map();
    try {
      for (var r = oi(Object.keys(t)), o = r.next(); !o.done; o = r.next()) {
        var s = o.value;
        i.set(parseInt(s, 10), t[s]);
      }
    } catch (t) {
      e = {
        error: t
      };
    } finally {
      try {
        o && !o.done && (n = r.return) && n.call(r);
      } finally {
        if (e) throw e.error;
      }
    }
    return i;
  }, "objectToNumericMap"),
  $ae = /[\n\r -#%-*,-/:;?@[-\]_{}\u00A0\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u1680\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2000-\u200A\u2010-\u2029\u202F-\u2043\u2045-\u2051\u2053-\u205F\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u3000-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]+/u;
E();
var ele = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  tle = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"],
  nle = ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
  ile = ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
  VDe = [...ele, ...tle, ...nle, ...ile],
  Yk = ["about", "after", "all", "also", "am", "an", "and", "another", "any", "are", "as", "at", "be", "because", "been", "before", "being", "between", "both", "but", "by", "came", "can", "come", "could", "did", "do", "each", "for", "from", "get", "got", "has", "had", "he", "have", "her", "here", "him", "himself", "his", "how", "if", "in", "into", "is", "it", "like", "make", "many", "me", "might", "more", "most", "much", "must", "my", "never", "now", "of", "on", "only", "or", "other", "our", "out", "over", "said", "same", "should", "since", "some", "still", "such", "take", "than", "that", "the", "their", "them", "then", "there", "these", "they", "this", "those", "through", "to", "too", "under", "up", "very", "was", "way", "we", "well", "were", "what", "where", "which", "while", "who", "with", "would", "you", "your", "a", "i"];
E();
var rle = 32,
  Is = !1,
  ole = 120,
  oC = 0,
  _o = class {
    constructor(t) {
      A(this, "_callback"), A(this, "_frameCount"), A(this, "_ordering"), A(this, "_supersededBy"), A(this, "name"), A(this, "_remainingFrameCount"), A(this, "_lastFrameTime"), A(this, "userdata"), this._callback = t.callback, this._frameCount = null != t.frameCount ? t.frameCount : 1, this._ordering = null != t.ordering ? t.ordering : 0, this._supersededBy = null != t.supersededBy ? new Set(t.supersededBy) : new Set(), this.name = t.name, this.userdata = t.userdata, this._remainingFrameCount = this._frameCount, this._lastFrameTime = 0, Is && ke.log("update instantiated", this.name);
    }
    getLastFrameTime() {
      return this._lastFrameTime;
    }
  };
u(_o, "FrameUpdate");
var ji = class {
  constructor(t) {
    if (A(this, "_postponed"), A(this, "userdata"), A(this, "_priority"), A(this, "_group"), A(this, "name"), A(this, "_lastFrameTime"), A(this, "_callback"), A(this, "_complete"), A(this, "_scheduled"), A(this, "_cancelled"), null != t.group && null != t.priority) throw new Error("cannot specify task priority individually within group");
    if (null != t.group && null != t.postponeOnAdd) throw new Error("cannot specify task postpone individually within group");
    this._callback = t.callback, this._group = null != t.group ? t.group : null, this._priority = null != t.priority ? t.priority : 0, this._postponed = null != t.postponeOnAdd && t.postponeOnAdd, this.name = t.name, this.userdata = t.userdata || {}, this._complete = !1, this._scheduled = !1, this._cancelled = !1, this._lastFrameTime = 0, Is && ke.log("task instantiated", this.name);
  }
  isComplete() {
    return this._complete;
  }
  getLastFrameTime() {
    return this._lastFrameTime;
  }
};
u(ji, "FrameTask");
var sc = class {
  constructor(t) {
    A(this, "_postponed"), A(this, "_onComplete"), A(this, "_priority"), A(this, "userdata"), A(this, "name"), A(this, "_tasks"), A(this, "_scheduledTasks"), A(this, "_scheduled"), A(this, "_cancelled"), this._onComplete = null != t.onComplete ? t.onComplete : () => {}, this._priority = null != t.priority ? t.priority : 0, this._postponed = null != t.postponeOnAdd && t.postponeOnAdd, this.name = t.name, this.userdata = t.userdata, this._tasks = new Set(), this._scheduledTasks = new Set(), this._scheduled = !1, this._cancelled = !1, Is && ke.log("task group instantiated", this.name);
  }
  isComplete() {
    return 0 === this._scheduledTasks.size;
  }
  getTasks() {
    return Array.from(this._tasks.values());
  }
  clear() {
    this._tasks.clear(), this._scheduledTasks.clear();
  }
  _popTask() {
    for (let t of this._scheduledTasks) return this._scheduledTasks.delete(t), t;
  }
};
u(sc, "FrameTaskGroup");
var sC = class {
  constructor(t) {
    A(this, "_maxMillisecondsPerFrame"), A(this, "_time"), this._maxMillisecondsPerFrame = null != (null == t ? void 0 : t.maxMillisecondsPerFrame) ? t.maxMillisecondsPerFrame : rle, this._time = 0;
  }
  beginFrame() {
    this._time = performance.now() + this._maxMillisecondsPerFrame;
  }
  hasTimeRemaining() {
    return performance.now() <= this._time;
  }
};
u(sC, "RealTimeTimer");
var Qf = class {
  constructor(t) {
    var e;
    A(this, "_raf"), A(this, "_timer"), A(this, "_performance"), A(this, "_scheduledUpdatesByOrdering"), A(this, "_scheduledTasksByPriority"), A(this, "_postponedTasks"), A(this, "_requestAnimationFrameHandle"), A(this, "_updatesToRunThisFrame"), A(this, "_lastFrameTime", 0), A(this, "_updatesRunLastFrame"), this._timer = null != (null == t ? void 0 : t.timer) ? t.timer : new sC(), this._performance = null != (null == t ? void 0 : t.performance) && t.performance, this._scheduledUpdatesByOrdering = new Cm(), this._scheduledTasksByPriority = new Cm(), this._postponedTasks = new Set(), this._requestAnimationFrameHandle = null, this._updatesToRunThisFrame = [], this._lastFrameTime = 0, this._updatesRunLastFrame = new Set(), this.update = this.update.bind(this), Is && ke.log("task scheduler instantiated"), (null == (e = globalThis.MappedinDebug) ? void 0 : e.TEST_IOS) && (this._raf = t => setTimeout(t, 16));
  }
  clear() {
    for (let t of this._scheduledTasksByPriority.values()) t._cancelled = !0;
    for (let t of this._postponedTasks.values()) t._cancelled = !0;
    this._scheduledUpdatesByOrdering = new Cm(), this._scheduledTasksByPriority = new Cm(), this._postponedTasks = new Set(), this._lastFrameTime = 0, this._updatesRunLastFrame.clear(), Is && ke.log("task scheduler cleared");
  }
  destroy() {
    this.clear();
  }
  requestAnimationFrame() {
    null == this._requestAnimationFrameHandle && (this._requestAnimationFrameHandle = "function" == typeof this._raf ? this._raf(this.update) : requestAnimationFrame(this.update));
  }
  update(t) {
    let e;
    this._timer.beginFrame(), this._performance && (e = performance.now());
    let n = !1;
    Is && (0 === oC && (n = !0), ++oC, oC %= ole);
    let i = this._scheduledUpdatesByOrdering.keys();
    for (let t = i.length - 1; t >= 0; --t) {
      let e = i[t];
      for (let t of this._scheduledUpdatesByOrdering.get(e).values()) this._updatesToRunThisFrame.push(t), n && ke.log("update scheduled to run this frame", t.name);
    }
    for (let t of this._updatesToRunThisFrame) {
      --t._remainingFrameCount, t._remainingFrameCount <= 0 && this._scheduledUpdatesByOrdering.delete(t._ordering, t), t._superseded = !1;
      for (let e of this._updatesToRunThisFrame) t._supersededBy.has(e) && (t._superseded = !0, n && ke.log("update superseded", t.name, e.name));
    }
    for (let t = 0; t < this._updatesToRunThisFrame.length; ++t) this._updatesToRunThisFrame[t]._superseded && (this._updatesToRunThisFrame.splice(t, 1), --t);
    for (let e of this._updatesToRunThisFrame) {
      let i;
      this._performance && (i = performance.now()), e._callback(t), this._performance && (e._lastFrameTime = performance.now() - i), n && ke.log("update completed", e.name);
    }
    this._updatesRunLastFrame.clear();
    for (let t of this._updatesToRunThisFrame) this._updatesRunLastFrame.add(t);
    if (this._updatesToRunThisFrame.splice(0, this._updatesToRunThisFrame.length), this._scheduledTasksByPriority.size > 0) do {
      this._executeOneTask(t);
    } while (this._timer.hasTimeRemaining() && this._scheduledTasksByPriority.size > 0);
    this._performance && (this._lastFrameTime = performance.now() - e), this._requestAnimationFrameHandle = null, (this._scheduledUpdatesByOrdering.size > 0 || this._scheduledTasksByPriority.size > 0) && this.requestAnimationFrame();
  }
  flushTasks() {
    for (; this._scheduledTasksByPriority.size > 0;) this._executeOneTask(performance.now());
  }
  getLastFrameTime() {
    return this._lastFrameTime;
  }
  getUpdatesRunLastFrame() {
    return this._updatesRunLastFrame;
  }
  _executeOneTask(t) {
    let e,
      n = this._scheduledTasksByPriority.popFromMaxKey(),
      i = null;
    ke.assert(void 0 !== n), Object.getPrototypeOf(n) === sc.prototype && (i = n, n = i._popTask()), ke.assert(void 0 !== n), ke.assert(Object.getPrototypeOf(n) === ji.prototype), this._performance && (e = performance.now()), n._callback(t), n._complete = !0, this._performance && (n._lastFrameTime = performance.now() - e), Is && ke.log("task completed", n.name), null != i && (i.isComplete() ? (i.clear(), i._onComplete(), Is && ke.log("group completed", i.name)) : this._scheduledTasksByPriority.insert(i._priority, i));
  }
  scheduleUpdate(t) {
    t._remainingFrameCount = t._frameCount, this._scheduledUpdatesByOrdering.insert(t._ordering, t), this.requestAnimationFrame();
  }
  scheduleTask(t) {
    if (Object.getPrototypeOf(t) === sc) throw new Error("frame task groups are automatically scheduled when a task is added to them and cannot be manually scheduled: " + t.name);
    if (t._scheduled) throw new Error("cannot schedule already scheduled task: " + t.name);
    if (t._cancelled) throw new Error("cannot schedule cancelled task: " + t.name);
    let e = t;
    "_group" in t && null != t._group && (t._group._tasks.add(t), t._group._scheduledTasks.add(t), e = t._group), e._postponed ? this._postponedTasks.add(e) : this._scheduledTasksByPriority.insert(e._priority, e), t._scheduled = !0, e._scheduled = !0, Is && ke.log("task scheduled", t.name), this.requestAnimationFrame();
  }
  cancelUpdate(t) {
    this._scheduledUpdatesByOrdering.delete(t._ordering, t), Is && ke.log("update cancelled", t.name);
  }
  cancelTask(t) {
    if (!t._scheduled) throw new Error("cannot cancel task that has not been scheduled: " + t.name);
    if (t._cancelled) throw new Error("cannot cancel task that has already been cancelled: " + t.name);
    if ("_group" in t && null != t._group) {
      let e = t._group.isComplete();
      t._group._tasks.delete(t), t._group._scheduledTasks.delete(t), t._group.isComplete() && (this._scheduledTasksByPriority.delete(t._group._priority, t._group), e || t._group._onComplete());
    } else this._scheduledTasksByPriority.delete(t._priority, t), this._postponedTasks.delete(t);
    Object.getPrototypeOf(t) === ji.prototype ? t._cancelled = !0 : "clear" in t && t.clear(), Is && ke.log("task cancelled", t.name);
  }
  postponeTask(t) {
    if ("_group" in t && null != t._group) throw new Error("cannot postpone individual tasks in group: " + t.name);
    if (t._cancelled) throw new Error("cannot postpone cancelled task: " + t.name);
    if (!t._postponed) {
      if (Object.getPrototypeOf(t) === ji.prototype) {
        if ("_complete" in t) return;
        if (!t._scheduled) throw new Error("cannot postpone task that has not been scheduled: " + t.name);
      }
      this._scheduledTasksByPriority.delete(t._priority, t), (Object.getPrototypeOf(t) === ji.prototype || !t.isComplete()) && this._postponedTasks.add(t), t._postponed = !0, Is && ke.log("task postponed", t.name);
    }
  }
  resumeTask(t) {
    if ("_group" in t && null != t._group) throw new Error("cannot resume individual tasks in groups");
    if (t._cancelled) throw new Error("cannot resume cancelled task");
    if (t._postponed) {
      if (Object.getPrototypeOf(t) === ji.prototype) {
        if ("_complete" in t && t._complete) return;
        if (!t._scheduled) throw new Error("cannot resume unscheduled task");
      }
      this._postponedTasks.delete(t), (Object.getPrototypeOf(t) === ji.prototype || !t.isComplete()) && this._scheduledTasksByPriority.insert(t._priority, t), t._postponed = !1, this.requestAnimationFrame(), Is && ke.log("task resumed", t.name);
    }
  }
  setTaskPriority(t, e) {
    if (Object.getPrototypeOf(t) === ji.prototype && !t._scheduled) throw new Error("task must be scheduled to be reprioritized");
    this._scheduledTasksByPriority.has(t._priority, t) && (this._scheduledTasksByPriority.delete(t._priority, t), this._scheduledTasksByPriority.insert(e, t)), t._priority = e, Is && ke.log("task priority changed", t.name, e);
  }
};
u(Qf, "TaskScheduler");
var Cm = class {
  constructor() {
    A(this, "_map"), A(this, "_size"), A(this, "_sortedKeys"), this._map = new Map(), this._size = 0, this._sortedKeys = [];
  }
  has(t, e) {
    return null != this._map.get(t) && this._map.get(t).has(e);
  }
  get(t) {
    return this._map.get(t);
  }
  insert(t, e) {
    if (ke.assert("number" == typeof t && Number.isFinite(t)), null == this._map.get(t)) {
      this._map.set(t, new Set());
      for (let e = 0; e <= this._sortedKeys.length; ++e) if (e === this._sortedKeys.length || t < this._sortedKeys[e]) {
        this._sortedKeys.splice(e, 0, t);
        break;
      }
    }
    this._map.get(t).has(e) || (this._map.get(t).add(e), ++this._size);
  }
  delete(t, e) {
    null != this._map.get(t) && this._map.get(t).has(e) && (this._map.get(t).delete(e), --this._size, 0 === this._map.get(t).size && (this._map.delete(t), this._sortedKeys.splice(this._sortedKeys.indexOf(t), 1)));
  }
  pop(t) {
    if (null != this._map.get(t)) {
      let e;
      for (e of this._map.get(t).values()) {
        this._map.get(t).delete(e), --this._size;
        break;
      }
      return 0 === this._map.get(t).size && (this._map.delete(t), this._sortedKeys.splice(this._sortedKeys.indexOf(t), 1)), e;
    }
  }
  popFromMaxKey() {
    if (this._sortedKeys.length > 0) return this.pop(this._sortedKeys[this._sortedKeys.length - 1]);
  }
  values() {
    let t = this._map.keys(),
      e = null,
      n = {
        [Symbol.iterator]: () => n,
        next: () => {
          if (null == e) {
            let n = t.next();
            if (n.done) return n;
            e = this._map.get(n.value).values();
          }
          let n = e.next();
          for (; n.done;) {
            let i = t.next();
            if (i.done) return i;
            e = this._map.get(i.value).values(), n = e.next();
          }
          return n;
        }
      };
    return n;
  }
  keys() {
    return this._sortedKeys;
  }
  get size() {
    let t = 0;
    for (let e of this._map.values()) t += e.size;
    return ke.assert(t === this._size), t;
  }
};
u(Cm, "Multimap");
var wh,
  wa,
  Sh,
  nu,
  sr,
  sy,
  ay,
  Im,
  ly,
  Lm,
  lc,
  ME,
  EE,
  Th,
  uy,
  wE,
  SE,
  TE,
  yle,
  cy,
  hy,
  fy,
  Or,
  ac = u(t => t.normalize("NFD").replace(/[\u0300-\u036f|\u2019|\u0027|\']/g, "").toLowerCase(), "removeAccents"),
  Am = "",
  sle = .09,
  ale = 1,
  lle = .025,
  ule = .5,
  cle = 5e-4,
  hle = 5e-4,
  fle = .01,
  ple = .05,
  Zk = 1,
  dle = .01,
  mle = .2,
  gle = {
    MappedinCategory: "categories",
    MappedinLocation: "locations"
  },
  vle = {
    searchDescriptions: !0,
    searchTags: !0,
    searchTagsInCategories: !1,
    searchDescriptionsInCategories: !1,
    stopWords: Yk,
    jsonIndex: void 0,
    useLocationRank: !0,
    emitAnalyticsEvents: "production" === D.env.NODE_ENV,
    constants: {
      PRIMARY_INDEX_FUZZYNESS: sle,
      PRIMARY_INDEX_WEIGHT: ale,
      SECONDARY_INDEX_WEIGHT: lle,
      CATEGORY_NAME_WEIGHT: ule,
      LOCATION_NAME_WEIGHT: Zk,
      CATEGORY_LOCATION_DESCRIPTION_WEIGHT: cle,
      CATEGORY_LOCATION_TAGS_WEIGHT: hle,
      CATEGORY_LOCATION_NAME_WEIGHT: fle,
      PRIMARY_INDEX_TAGS_NAME_WEIGHT: ple,
      LOCATION_DEFAULT_RANK: Zk,
      RATIO_OF_FUZZY_TO_EXACT: dle,
      RATIO_OF_PREFIX_TO_EXACT: mle
    }
  },
  bE = class {
    constructor(t, e) {
      var n, i, r;
      re(this, TE), re(this, wh, void 0), re(this, wa, void 0), re(this, Sh, void 0), re(this, nu, void 0), re(this, sr, void 0), re(this, sy, new Qf({
        performance: !0
      })), re(this, ay, void 0), re(this, Im, void 0), re(this, ly, new Map()), re(this, Lm, 0), re(this, lc, u(t => {
        y3(this, Lm)._++, w(this, sy).scheduleUpdate(new _o({
          name: "updateIndex",
          ordering: 0,
          frameCount: 1,
          callback: () => {
            t(), y3(this, Lm)._--, 0 === w(this, Lm) && w(this, uy).call(this);
          }
        }));
      }, "#addTask")), re(this, ME, u(t => {
        var e, n, i;
        let {
            SECONDARY_INDEX_WEIGHT: r,
            LOCATION_DEFAULT_RANK: o,
            PRIMARY_INDEX_TAGS_NAME_WEIGHT: s
          } = w(this, sr).constants,
          a = o;
        (null == (e = w(this, sr)) ? void 0 : e.useLocationRank) && (a = Array.isArray(t.polygons) ? Math.max(...t.polygons.map(t => {
          var e, n;
          return (null == (e = t.rank) ? void 0 : e.score) ? null == (n = t.rank) ? void 0 : n.score : o;
        }), o) : o), w(this, lc).call(this, () => {
          w(this, wa).add({
            name: ac(t.name),
            tags: "",
            id: "MappedinLocation_" + t.id,
            weight: o,
            rank: a
          });
        }), (null == (n = w(this, sr)) ? void 0 : n.searchTags) && Array.isArray(t.tags) && t.tags.forEach(e => {
          w(this, wa).add({
            name: "",
            tag: ac(e),
            id: "MappedinLocation_" + t.id,
            weight: s,
            rank: a
          });
        }), (null == (i = w(this, sr)) ? void 0 : i.searchDescriptions) && w(this, lc).call(this, () => w(this, Sh).add({
          description: ac(t.description || ""),
          id: "MappedinLocation_" + t.id,
          weight: r,
          rank: a
        }));
      }, "#processLocation")), re(this, EE, u(t => {
        var e, n;
        let {
          CATEGORY_LOCATION_DESCRIPTION_WEIGHT: i,
          CATEGORY_LOCATION_TAGS_WEIGHT: r,
          CATEGORY_LOCATION_NAME_WEIGHT: o,
          CATEGORY_NAME_WEIGHT: s
        } = w(this, sr).constants;
        w(this, lc).call(this, () => w(this, wa).add({
          name: ac(t.name || ""),
          description: "",
          id: "MappedinCategory_" + t.id,
          weight: s
        }));
        let a = t.locations.reduce((t, e) => t + ` ${Am} ` + e.name, "") + ` ${Am}`;
        if ((null == (e = w(this, sr)) ? void 0 : e.searchDescriptionsInCategories) && t.locations.forEach(e => {
          null != e.description && w(this, lc).call(this, () => w(this, nu).add({
            id: "MappedinCategory_" + t.id,
            "category.locations.description": ac(e.description),
            ref: e.name,
            weight: i
          }));
        }), null == (n = w(this, sr)) ? void 0 : n.searchTagsInCategories) {
          let e = t.locations.reduce((t, e) => {
            var n;
            return t + (null == (n = e.tags) ? void 0 : n.reduce((t, e) => t + ` ${Am} ` + e, "")) + ` ${Am}`;
          }, "");
          w(this, lc).call(this, () => w(this, nu).add({
            "category.locations.tags": ac(e),
            id: "MappedinCategory_" + t.id,
            weight: r
          }));
        }
        w(this, lc).call(this, () => w(this, nu).add({
          "category.locations.name": ac(a),
          id: "MappedinCategory_" + t.id,
          weight: o
        }));
      }, "#processCategory")), re(this, Th, void 0), re(this, uy, void 0), re(this, wE, u(t => {
        var e;
        let n = t.score,
          {
            object: i,
            id: r,
            weight: o,
            rank: s
          } = t,
          [a, l] = r.split("_"),
          u = i || w(this, wh).getCollectionItemById(gle[a], l);
        return s && (null == (e = w(this, sr)) ? void 0 : e.useLocationRank) && (n += s), o && (n *= o), {
          score: n,
          type: a,
          object: u
        };
      }, "#processSearchResult")), re(this, SE, u((t, e) => {
        for (let n in t.match) t.match[n].forEach(i => {
          let r = t.ref || t[i] || e.object[i];
          if ("category.locations.tags" === i || "category.locations.name" === i) {
            let e = new RegExp(`[^${Am}]* ` + n + ` [^${Am}]*`, "ig").exec(t[i]);
            null != e && (r = e[0].slice(1, -1));
          }
          e.matches.push({
            term: n,
            weight: t.weight,
            matchesOn: i,
            value: r
          });
        });
      }, "#addMatches")), re(this, cy, void 0), re(this, hy, void 0), re(this, fy, void 0), he(this, Im, new Ea({
        ...t.options,
        testMode: !1 === (null == e ? void 0 : e.emitAnalyticsEvents)
      })), he(this, sr, {
        ...vle,
        ...e
      }), he(this, wh, t), he(this, ay, new Set(null == (n = w(this, sr)) ? void 0 : n.stopWords));
      let o = w(this, wh).venue.slug,
        {
          PRIMARY_INDEX_FUZZYNESS: s,
          PRIMARY_INDEX_WEIGHT: a,
          CATEGORY_NAME_WEIGHT: l,
          RATIO_OF_FUZZY_TO_EXACT: h,
          RATIO_OF_PREFIX_TO_EXACT: c,
          PRIMARY_INDEX_TAGS_NAME_WEIGHT: p
        } = w(this, sr).constants,
        d = ["object", "query", "weight", "tag", "rank"],
        f = {
          fields: ["query", "name", "tag"],
          storeFields: d,
          searchOptions: {
            combineWith: "OR",
            prefix: !0,
            fuzzy: s
          },
          boost: {
            name: a,
            query: a,
            tag: p
          },
          weights: {
            fuzzy: h,
            prefix: c
          },
          boostDocument: t => t.includes("MappedinLocation") ? a : t.includes("MappedinCategory") ? l : a
        },
        m = {
          fields: ["description"],
          storeFields: d,
          searchOptions: {
            combineWith: "AND",
            prefix: !0,
            fuzzy: .1
          },
          processTerm: (t, e) => {
            var n;
            return (null == (n = w(this, ay)) ? void 0 : n.has(t.toLowerCase())) ? null : t.toLowerCase();
          }
        },
        g = {
          fields: ["category.locations.description", "category.locations.tags", "category.locations.name"],
          storeFields: [...d, "ref", "category.locations.tags", "category.locations.name", "category.locations.description"],
          searchOptions: {
            combineWith: "AND",
            prefix: !0,
            fuzzy: !1
          }
        };
      if (he(this, Th, new Promise(t => {
        he(this, uy, t);
      })), null == (i = w(this, sr)) ? void 0 : i.jsonIndex) {
        let {
          primary: t,
          secondary: e,
          extra: n
        } = JSON.parse(null == (r = w(this, sr)) ? void 0 : r.jsonIndex);
        he(this, wa, Kf.loadJS(t, f)), he(this, Sh, Kf.loadJS(e, m)), he(this, nu, Kf.loadJS(n, g));
      } else he(this, wa, new Kf(f)), he(this, Sh, new Kf(m)), he(this, nu, new Kf(g)), w(this, wh).locations.forEach(w(this, ME)), w(this, wh).categories.forEach(w(this, EE));
      w(this, sy).update(performance.now()), he(this, cy, Xb((t, e) => {
        w(this, Im).trackSearchSuggest({
          query: t,
          hits: e
        }), at.addPendingEvent(new D1({
          venue: o
        }));
      }, 300)), he(this, hy, Xb((t, e) => {
        w(this, Im).trackSearch({
          query: t,
          hits: e
        }), at.addPendingEvent(new N1({
          venue: o
        }));
      }, 300)), he(this, fy, Xb(() => {
        at.addPendingEvent(new O1({
          venue: o
        }));
      }, 300)), at.addPendingEvent(new R1({
        search_descriptions: w(this, sr).searchDescriptions,
        search_tags: w(this, sr).searchTags,
        search_descriptions_in_categories: w(this, sr).searchDescriptionsInCategories,
        search_tags_in_categories: w(this, sr).searchTagsInCategories,
        use_location_rank: w(this, sr).useLocationRank,
        venue: o
      }));
    }
    async suggest(t) {
      await w(this, Th);
      let {
          PRIMARY_INDEX_FUZZYNESS: e,
          PRIMARY_INDEX_WEIGHT: n,
          PRIMARY_INDEX_TAGS_NAME_WEIGHT: i,
          RATIO_OF_FUZZY_TO_EXACT: r,
          RATIO_OF_PREFIX_TO_EXACT: o
        } = w(this, sr).constants,
        s = w(this, wa).autoSuggest(t, {
          fields: ["name", "tag", "query"],
          combineWith: "AND",
          prefix: !0,
          fuzzy: e,
          boost: {
            name: n,
            query: n,
            tag: i
          },
          weights: {
            fuzzy: r,
            prefix: o
          }
        });
      return w(this, cy).call(this, t, s.length), {
        total: s.length,
        hits: s.map(t => ({
          text: t.suggestion
        }))
      };
    }
    async search(t) {
      await w(this, Th);
      let e = mt(this, TE, yle).call(this, t);
      return w(this, hy).call(this, t, e.length), e;
    }
    async toJSON() {
      return await w(this, Th), JSON.stringify({
        primary: w(this, wa),
        secondary: w(this, Sh),
        extra: w(this, nu)
      });
    }
    async addQuery(t) {
      let e,
        n,
        {
          query: i,
          object: r,
          weight: o = 1
        } = t;
      await w(this, Th), e = r instanceof zl ? "MappedinLocation" : r instanceof mh ? "MappedinCategory" : "Custom", "MappedinLocation" === e || "MappedinCategory" === e ? n = e + "_" + r.id : "string" == typeof r.id ? n = "Custom_" + r.id : (n = w(this, ly).get(r), n || (n = "Custom_" + ls(), w(this, ly).set(r, n))), w(this, wa).add({
        id: n,
        weight: o,
        object: r,
        query: ac(i)
      }), w(this, fy).call(this);
    }
  };
u(bE, "OfflineSearch"), wh = new WeakMap(), wa = new WeakMap(), Sh = new WeakMap(), nu = new WeakMap(), sr = new WeakMap(), sy = new WeakMap(), ay = new WeakMap(), Im = new WeakMap(), ly = new WeakMap(), Lm = new WeakMap(), lc = new WeakMap(), ME = new WeakMap(), EE = new WeakMap(), Th = new WeakMap(), uy = new WeakMap(), wE = new WeakMap(), SE = new WeakMap(), TE = new WeakSet(), yle = u(function (t) {
  let e = [],
    n = ac(t);
  e = [...w(this, wa).search(n), ...w(this, Sh).search(n), ...w(this, nu).search(n)].sort((t, e) => e.score - t.score);
  let i = {};
  for (let t of e) {
    let e = w(this, wE).call(this, t);
    i[t.id] ? i[t.id].score += e.score : i[t.id] = {
      ...e,
      matches: []
    }, w(this, SE).call(this, t, i[t.id]);
  }
  return Object.keys(i).map(t => ({
    ...i[t],
    matches: i[t].matches.sort((t, e) => e.weight - t.weight)
  })).sort((t, e) => e.score - t.score);
}, "#doSearch"), cy = new WeakMap(), hy = new WeakMap(), fy = new WeakMap(), E(), function (t) {
  t.MULTI_GEOMETRY = "MULTI_GEOMETRY", t.SINGLE_GEOMETRY = "SINGLE_GEOMETRY";
}(Or || (Or = {}));
var aC = globalThis.fetch;
function Xs() {
  if (null == aC) throw new Error("fetch is not available in your environment. Pass your own function into `setFetch` (node-fetch, etc)");
  return aC;
}
function _le(t) {
  aC = t;
}
u(Xs, "isomorphicFetch"), u(_le, "setFetchFn");
var $k,
  eF,
  xle = null == (eF = null == ($k = D) ? void 0 : $k.env) ? void 0 : eF.npm_package_version;
globalThis.btoa || (globalThis.btoa = Jk.encode);
var ble = ["ar"];
function Om(t) {
  let e = {
    ...JP,
    things: qk,
    ...t
  };
  return e.headers = {
    ...e.headers,
    "mappedin-sdk-version": xle
  }, t.platformString && (e.headers = {
    ...e.headers,
    "mappedin-platform-version": t.platformString
  }), e.noAuth || (e.accessToken ? e.authorization = `Bearer ${e.accessToken}` : e.clientId && e.clientSecret && (e.authorization = `Basic ${globalThis.btoa(`${e.clientId}:${e.clientSecret}`)}`)), e;
}
async function Mle(t) {
  let e = Om({
      ...{
        emitAnalyticsEvents: !0,
        ...t
      }
    }),
    n = new tu(e),
    i = await Qk(e),
    r = Nk(await Ok(i));
  return n.hydrateFromMVF(r), at.addPendingEvent(new W0({
    venue: e.venue
  })), n;
}
async function Ele(t) {
  let e = {
      emitAnalyticsEvents: !0,
      secure: !0,
      ...t
    },
    n = Om({
      baseUrl: "https://api-gateway.mappedin.com/",
      ...e
    }),
    i = "public/1/" + (n.useDraftData ? "draft/" : ""),
    r = new tu({
      ...n,
      baseUrl: n.baseUrl + i
    });
  return await r.fetch(), e.emitAnalyticsEvents, at.addPendingEvent(new j0({
    venue: n.venue
  })), r;
}
u(Om, "parseOptions"), u(Mle, "getVenueMVF"), u(Ele, "getVenue");
var lC = {
  shouldPopulateBundledImagesAsBlobs: !(void 0 !== globalThis.navigator && "ReactNative" == globalThis.navigator.product)
};
async function wle(t) {
  let e = Om({
      baseUrl: "https://api-gateway.mappedin.com/",
      ...lC,
      ...t
    }),
    {
      url: n,
      updated_at: i
    } = await Kk(t),
    r = await Xs()(n, {
      mode: "cors"
    }),
    {
      data: o,
      format: s = "jsonstring"
    } = await r.json();
  if ("jsonstring" !== s) throw new Error(`Unrecognized format ${s}`);
  let a = new tu(e);
  return await a.hydrate(o, e.shouldPopulateBundledImagesAsBlobs), a.updatedAt = i, a;
}
async function Kk(t) {
  let e = Om({
      baseUrl: "https://api-gateway.mappedin.com/",
      ...lC,
      ...t
    }),
    {
      version: n,
      venue: i
    } = t,
    r = `${t.bundleBaseUri || e.baseUrl + `exports/legacy${null != e.language && ble.includes(e.language) ? "-" + e.language : ""}/1/bundle`}?venue=${i}&version=1.0.0`;
  return e.language = void 0, await Wb(e, r);
}
async function Sle(t, {
  url: e,
  updated_at: n
}) {
  let i = Om({
      baseUrl: "https://api-gateway.mappedin.com/",
      ...lC,
      ...t
    }),
    r = await Xs()(e, {
      mode: "cors"
    }),
    {
      data: o,
      format: s = "jsonstring"
    } = await r.json();
  if ("jsonstring" !== s) throw new Error(`Unrecognized format${s}`);
  let a = new tu(i);
  return await a.hydrate(o, i.shouldPopulateBundledImagesAsBlobs), a.updatedAt = n, a;
}
async function Tle(t) {
  let e = Om({
      baseUrl: "https://api-gateway.mappedin.com/",
      ...JP,
      ...t
    }),
    n = `${e.bundleBaseUri || e.baseUrl + "exports/mvf/1/bundle"}?venue=${e.venue}&version=2.0.0`;
  return e.headers["Content-Type"] = "application/zip", await Wb(e, n);
}
async function Qk(t) {
  return new Promise(async (e, n) => {
    try {
      let {
          url: n
        } = await Tle(t),
        i = await Xs()(n).then(t => t.arrayBuffer());
      e(new Uint8Array(i));
    } catch (t) {
      n(t);
    }
  });
}
u(wle, "getVenueBundle"), u(Kk, "getVenueBundleURL"), u(Sle, "downloadBundle"), u(Tle, "getVenueMVFURL"), u(Qk, "downloadVenueBundleMVF");
var nF,
  iF,
  py,
  Rm,
  Nm,
  dy,
  Dm,
  qm,
  km,
  $f,
  my,
  Fm,
  Bm,
  gy,
  Um,
  Ple = null == (iF = null == (nF = D) ? void 0 : nF.env) ? void 0 : iF.npm_package_version,
  uC = ["websdk", "web", "webv2"],
  cC = "websdk",
  hC = class {
    constructor(t) {
      var e;
      re(this, py, void 0), re(this, Rm, void 0), re(this, Nm, void 0), re(this, dy, void 0), re(this, Dm, void 0), re(this, qm, void 0), re(this, km, void 0), re(this, $f, void 0), re(this, my, void 0), re(this, Fm, void 0), re(this, Bm, void 0), re(this, gy, void 0), re(this, Um, void 0), he(this, $f, t.clientId), he(this, my, t.clientSecret), he(this, Fm, t.accessToken), he(this, km, t.noAuth || !1);
      let n = "https://api-gateway.mappedin.com/track-analytics/a/";
      !w(this, km) && w(this, $f) && !c7(w(this, $f)) && (n = "https://web-proxy.mappedin.com/a/"), he(this, Nm, n), he(this, Nm, w(this, Nm) + (t.venue + "/")), he(this, Um, t.venue), he(this, Rm, !1), he(this, py, "boolean" == typeof t.testMode ? t.testMode : "true" === (null == (e = t.testMode) ? void 0 : e.toLowerCase())), he(this, dy, uC.find(e => e === t.context) || uC[0]), he(this, Dm, $x()), he(this, qm, e2()), he(this, Bm, new Set()), he(this, gy, t.platformString || ""), this.locationSelected = this.locationSelected.bind(this), this.categorySelected = this.categorySelected.bind(this), this.getDirections = this.getDirections.bind(this);
    }
    track(t, e) {
      if (w(this, py)) return;
      let n = {
          ...e,
          g: w(this, Rm)
        },
        i = w(this, Nm) + t + "?" + tF.default.stringify(n),
        r = {
          "mi-context": cC || w(this, dy),
          "mi-session": w(this, qm),
          "mi-device": w(this, Dm),
          "mappedin-sdk-version": Ple,
          "mappedin-platform-version": w(this, gy)
        };
      w(this, Fm) ? r.Authorization = `Bearer ${w(this, Fm)}` : w(this, km) || (r.Authorization = `Basic ${btoa(`${w(this, $f)}:${w(this, my)}`)}`), Xs()(i, {
        method: "GET",
        mode: "cors",
        headers: r
      });
    }
    locationSelected(t) {
      let e = t.id || t;
      at.addPendingEvent(new b0({
        venue: w(this, Um)
      })), this.track("select-location", {
        id: e
      });
    }
    categorySelected(t) {
      let e = t.id || t;
      at.addPendingEvent(new x0({
        venue: w(this, Um)
      })), this.track("select-category", {
        id: e
      });
    }
    mapViewLoaded(t, e, n, i) {
      this.track("load-mapview", {
        type: t,
        force: e,
        benchmark: n || -1,
        reason: i || "success"
      });
    }
    getDirections(t, e) {
      let n = {
        start: t.id,
        end: e.id,
        type: "location_to_location"
      };
      this.track("query-directions", n);
    }
    getSessionID() {
      return w(this, qm);
    }
    getDeviceID() {
      return w(this, Dm);
    }
    setGeolocationMode(t) {
      he(this, Rm, t);
    }
    trackBlueDotEvent(t) {
      t && Object.values(hC.BLUEDOT_EVENT).includes(t) && !w(this, Bm).has(t) ? (this.track(t), w(this, Bm).add(t)) : ke.warn(`Ignored unsupported blue dot event: "${t}".`);
    }
    trackSearch(t) {
      null != t && this.track("query-search", t);
    }
    trackSearchSuggest(t) {
      null != t && this.track("query-suggest", t);
    }
    static setContext(t) {
      let e = uC.find(e => e === t);
      e && (cC = e);
    }
    static clearContext() {
      cC = void 0;
    }
  },
  PE = hC;
u(PE, "Analytics"), py = new WeakMap(), Rm = new WeakMap(), Nm = new WeakMap(), dy = new WeakMap(), Dm = new WeakMap(), qm = new WeakMap(), km = new WeakMap(), $f = new WeakMap(), my = new WeakMap(), Fm = new WeakMap(), Bm = new WeakMap(), gy = new WeakMap(), Um = new WeakMap(), A(PE, "BLUEDOT_EVENT", {
  ATTEMPT_BLUEDOT: "attempt-bluedot",
  FOUND_POSITION: "found-position",
  FOUND_FLOOR: "found-floor"
});
var Ea = PE;
E(), E();
var fC,
  No,
  ep,
  Kt,
  iu,
  xo,
  zm,
  ml,
  tp,
  Ls,
  uc,
  CE,
  vy = Rt(il());
!function (t) {
  t[t.SUCCESS = 0] = "SUCCESS";
}(fC || (fC = {})), function (t) {
  t[t.OPTIONAL_MINIMUM = 0] = "OPTIONAL_MINIMUM", t[t.OPTIONAL_MAXIMUM = 1] = "OPTIONAL_MAXIMUM", t[t.MEDIUM = 2] = "MEDIUM", t[t.HIGH = 3] = "HIGH", t[t.ALWAYS_VISIBLE = 4] = "ALWAYS_VISIBLE";
}(No || (No = {})), function (t) {
  t[t.OUTSIDE_MAP = 0] = "OUTSIDE_MAP", t[t.NO_POSITIONS_PROVIDED = 1] = "NO_POSITIONS_PROVIDED", t[t.GEOLOCATION_PROVIDER_ERROR = 2] = "GEOLOCATION_PROVIDER_ERROR", t[t.CUSTOM_GEOLOCATION_PROVIDER_ERROR = 3] = "CUSTOM_GEOLOCATION_PROVIDER_ERROR";
}(ep || (ep = {})), function (t) {
  t[t.NOT_LISTENING = 0] = "NOT_LISTENING", t[t.LISTENING = 1] = "LISTENING", t[t.HAS_POSITION = 2] = "HAS_POSITION", t[t.HAS_INDOOR_POSITION = 3] = "HAS_INDOOR_POSITION", t[t.LOCATION_UNCERTAIN = 4] = "LOCATION_UNCERTAIN";
}(Kt || (Kt = {})), function (t) {
  t[t.HIDDEN = 0] = "HIDDEN", t[t.GHOST = 1] = "GHOST", t[t.NORMAL = 2] = "NORMAL", t[t.UNCERTAIN = 3] = "UNCERTAIN";
}(iu || (iu = {})), function (t) {
  t.EXPLORE = "explore", t.FOLLOW = "follow", t.STACKED = "STACKED";
}(xo || (xo = {})), function (t) {
  t[t.CENTER = 0] = "CENTER", t[t.TOP = 1] = "TOP", t[t.LEFT = 2] = "LEFT", t[t.BOTTOM = 3] = "BOTTOM", t[t.RIGHT = 4] = "RIGHT";
}(zm || (zm = {})), function (t) {
  t.CLICK = "CLICK", t.STATE_CHANGE = "STATE_CHANGE", t.POLYGON_CLICKED = "POLYGON_CLICKED", t.NOTHING_CLICKED = "NOTHING_CLICKED", t.MAP_CHANGED = "MAP_CHANGED";
}(ml || (ml = {})), function (t) {
  t.POSITION_UPDATE = "POSITION_UPDATE", t.STATE_CHANGE = "STATE_CHANGE";
}(tp || (tp = {})), function (t) {
  t.USER_INTERACTION_START = "USER_INTERACTION_START", t.USER_INTERACTION_END = "USER_INTERACTION_END", t.ZOOM_CHANGED = "ZOOM_CHANGED", t.ROTATION_CHANGED = "ROTATION_CHANGED", t.TILT_CHANGED = "TILT_CHANGED", t.POSITION_CHANGED = "POSITION_CHANGED", t.CHANGED = "CHANGED";
}(Ls || (Ls = {})), function (t) {
  t.UP = "up", t.DOWN = "down", t.LEFT = "left", t.RIGHT = "right";
}(uc || (uc = {})), function (t) {
  t.PIXELS = "pixels", t.PORTIONS = "portions";
}(CE || (CE = {}));
var cc,
  Wi,
  Os = {
    linear: vy.default.Easing.Linear.None,
    "ease-in": vy.default.Easing.Quadratic.In,
    "ease-out": vy.default.Easing.Quadratic.Out,
    "ease-in-out": vy.default.Easing.Quadratic.InOut
  };
!function (t) {
  t.LINEAR = "linear", t.EASE_IN = "ease-in", t.EASE_OUT = "ease-out", t.EASE_IN_OUT = "ease-in-out";
}(cc || (cc = {})), function (t) {
  t.ACTIVE = "ACTIVE", t.INACTIVE = "INACTIVE", t.OVERVIEW = "OVERVIEW", t.ZOOMED_IN = "ZOOMED_IN";
}(Wi || (Wi = {})), E();
var Ks = class {
  constructor() {
    A(this, "_subscribers", {});
  }
  publish(t, e) {
    !this._subscribers || !this._subscribers[t] || this._subscribers[t].forEach(function (t) {
      "function" == typeof t && t(e);
    });
  }
  on(t, e) {
    this._subscribers || (this._subscribers = {}), this._subscribers[t] = this._subscribers[t] || [], this._subscribers[t].push(e);
  }
  off(t, e) {
    if (!this._subscribers || null == this._subscribers[t]) return;
    let n = this._subscribers[t].indexOf(e);
    -1 !== n && this._subscribers[t].splice(n, 1);
  }
  destroy() {
    this._subscribers = {};
  }
};
u(Ks, "PubSub"), E(), E(), E();
var rF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M25.86,2.59A10.12,10.12,0,0,0,22.4.65a14,14,0,0,0-8.85.14A10.33,10.33,0,0,0,10,3.1,9.78,9.78,0,0,0,7.72,6.68,10,10,0,0,0,7,11h6a6.3,6.3,0,0,1,.18-2.33,5.57,5.57,0,0,1,1-1.77,4.05,4.05,0,0,1,1.5-1.13,6.87,6.87,0,0,1,4.5-.08,4.4,4.4,0,0,1,1.6.88,3.37,3.37,0,0,1,.93,1.22A3.84,3.84,0,0,1,23,9.29a3.15,3.15,0,0,1-.38,1.5,10.54,10.54,0,0,1-1.26,1.72,18.9,18.9,0,0,1-1.78,1.8c-.71.66-1.4,1.34-2,2C16.31,17.55,14,19,14,21v6h6V23c0-.63,0-1,1-2s1.24-1.3,2-2,1.69-1.66,2.5-2.52a14,14,0,0,0,2.28-2.81,7.51,7.51,0,0,0,1.08-4.05,9.68,9.68,0,0,0-.78-3.91A8.34,8.34,0,0,0,25.86,2.59Z"/><circle cx="17" cy="33" r="3"/></svg>',
  oF = "data:image/png;base64,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",
  sF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><polygon points="36 14.99 28 7.99 28 12.99 17 12.99 17 16.99 28 16.99 28 21.99 36 14.99"/><path d="M24,29H15V7L6,2H24v9h2V0H0V29l14.94,7L15,31H26V19H24Z"/></svg>',
  aF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M12.85,18.24H9.25a1.27,1.27,0,0,0-1.2,1.2v4.8c0,.43.65,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42c.43-.11,1.08-.75,1.08-1.18v-4.8A1.26,1.26,0,0,0,12.85,18.24Z"/><circle cx="11.05" cy="15.85" r="1.5"/><path d="M26.82,18.24h-3.6a1.26,1.26,0,0,0-1.2,1.2v4.8c0,.43.65,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42c.43-.11,1.08-.75,1.08-1.18v-4.8A1.27,1.27,0,0,0,26.82,18.24Z"/><circle cx="25.02" cy="15.85" r="1.5"/><path d="M19.79,18.24h-3.6a1.27,1.27,0,0,0-1.2,1.2v4.8c0,.43.66,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42A1.68,1.68,0,0,0,21,24.24v-4.8A1.26,1.26,0,0,0,19.79,18.24Z"/><path d="M18,17.35a1.5,1.5,0,1,0-1.5-1.5A1.51,1.51,0,0,0,18,17.35Z"/><path d="M28.79,10H7.27c-2.82,0-5.11,2-5.11,4.51V31.6c0,2.49,2.29,4.51,5.11,4.51H28.79c2.82,0,5.12-2,5.12-4.51V14.51C33.91,12,31.61,10,28.79,10Zm2.85,21.6a2.7,2.7,0,0,1-2.85,2.51H7.27A2.7,2.7,0,0,1,4.42,31.6V14.51A2.7,2.7,0,0,1,7.27,12H28.79a2.7,2.7,0,0,1,2.85,2.51Z"/><polygon points="27 4 26 3 24 5 24 0 22 0 22 5 20 3 19 4 23 8 27 4"/><polygon points="17 4 16 5 14 3 14 8 12 8 12 3 10 5 9 4 13 0 17 4"/></svg>',
  lF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M12.85,18.24H9.25a1.27,1.27,0,0,0-1.2,1.2v4.8c0,.43.65,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42c.43-.11,1.08-.75,1.08-1.18v-4.8A1.26,1.26,0,0,0,12.85,18.24Z"/><circle cx="11.05" cy="15.85" r="1.5"/><path d="M26.82,18.24h-3.6a1.26,1.26,0,0,0-1.2,1.2v4.8c0,.43.65,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42c.43-.11,1.08-.75,1.08-1.18v-4.8A1.27,1.27,0,0,0,26.82,18.24Z"/><circle cx="25.02" cy="15.85" r="1.5"/><path d="M19.79,18.24h-3.6a1.27,1.27,0,0,0-1.2,1.2v4.8c0,.43.66,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42A1.68,1.68,0,0,0,21,24.24v-4.8A1.26,1.26,0,0,0,19.79,18.24Z"/><path d="M18,17.35a1.5,1.5,0,1,0-1.5-1.5A1.51,1.51,0,0,0,18,17.35Z"/><path d="M28.79,10H7.27c-2.82,0-5.11,2-5.11,4.51V31.6c0,2.49,2.29,4.51,5.11,4.51H28.79c2.82,0,5.12-2,5.12-4.51V14.51C33.91,12,31.61,10,28.79,10Zm2.85,21.6a2.7,2.7,0,0,1-2.85,2.51H7.27A2.7,2.7,0,0,1,4.42,31.6V14.51A2.7,2.7,0,0,1,7.27,12H28.79a2.7,2.7,0,0,1,2.85,2.51Z"/><polygon points="22 4 21 5 19 3 19 8 17 8 17 3 15 5 14 4 18 0 22 4"/></svg>',
  uF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M12.85,18.24H9.25a1.27,1.27,0,0,0-1.2,1.2v4.8c0,.43.65,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42c.43-.11,1.08-.75,1.08-1.18v-4.8A1.26,1.26,0,0,0,12.85,18.24Z"/><circle cx="11.05" cy="15.85" r="1.5"/><path d="M26.82,18.24h-3.6a1.26,1.26,0,0,0-1.2,1.2v4.8c0,.43.65,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42c.43-.11,1.08-.75,1.08-1.18v-4.8A1.27,1.27,0,0,0,26.82,18.24Z"/><circle cx="25.02" cy="15.85" r="1.5"/><path d="M19.79,18.24h-3.6a1.27,1.27,0,0,0-1.2,1.2v4.8c0,.43.66,1.07,1.08,1.18v5.52c0,1.09,1.2,1.09,1.2,0v-5.5h1.44v5.5c0,1.09,1.2,1.09,1.2,0V25.42A1.68,1.68,0,0,0,21,24.24v-4.8A1.26,1.26,0,0,0,19.79,18.24Z"/><path d="M18,17.35a1.5,1.5,0,1,0-1.5-1.5A1.51,1.51,0,0,0,18,17.35Z"/><path d="M28.79,10H7.27c-2.82,0-5.11,2-5.11,4.51V31.6c0,2.49,2.29,4.51,5.11,4.51H28.79c2.82,0,5.12-2,5.12-4.51V14.51C33.91,12,31.61,10,28.79,10Zm2.85,21.6a2.7,2.7,0,0,1-2.85,2.51H7.27A2.7,2.7,0,0,1,4.42,31.6V14.51A2.7,2.7,0,0,1,7.27,12H28.79a2.7,2.7,0,0,1,2.85,2.51Z"/><polygon points="22 4 21 3 19 5 19 0 17 0 17 5 15 3 14 4 18 8 22 4"/></svg>',
  cF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><polygon points="4 16 18 0 31.99 16 4 16"/><polygon points="31.99 20 18 36 4 20 31.99 20"/></svg>',
  hF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M18,8a3,3,0,1,0-3-3A3,3,0,0,0,18,8Z"/><path d="M33,10H27a3.65,3.65,0,0,0-3,1l-2.76,2.75V12.39a2.48,2.48,0,0,0-2.46-2.47H17.22a2.48,2.48,0,0,0-2.47,2.47v7.87L9,26a3.26,3.26,0,0,1-2,1H3c-2.28,0-3,1.79-3,3.93A2.76,2.76,0,0,0,3,34H9a3.77,3.77,0,0,0,3-1L27,18a3.29,3.29,0,0,1,2.49-1h3.26A3.43,3.43,0,0,0,36,13.44C36,12.08,35,10,33,10Zm0,5H29c-1.47,0-1.92-.08-3,1L11,31a3.15,3.15,0,0,1-2,1H3c-.82,0-1-.29-1-1.16S2.12,28.9,3,29H7a3.87,3.87,0,0,0,3-1L25,13a2.72,2.72,0,0,1,2-1h6c.68,0,1,1.05,1,1.44S34,15,33,15Z"/><polygon points="30.18 26.18 26 31 26 28 24 28 24 34 31 34 31 32 28 32 31.69 27.59 30.18 26.18"/></svg>',
  fF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M18,8a3,3,0,1,0-3-3A3,3,0,0,0,18,8Z"/><path d="M33,10H27a3.65,3.65,0,0,0-3,1l-2.76,2.75V12.39a2.48,2.48,0,0,0-2.46-2.47H17.22a2.48,2.48,0,0,0-2.47,2.47v7.87L9,26a3.26,3.26,0,0,1-2,1H3c-2.28,0-3,1.79-3,3.93A2.76,2.76,0,0,0,3,34H9a3.77,3.77,0,0,0,3-1L27,18a3.29,3.29,0,0,1,2.49-1h3.26A3.43,3.43,0,0,0,36,13.44C36,12.08,35,10,33,10Zm0,5H29c-1.47,0-1.92-.08-3,1L11,31a3.15,3.15,0,0,1-2,1H3c-.82,0-1-.29-1-1.16S2.12,28.9,3,29H7a3.87,3.87,0,0,0,3-1L25,13a2.72,2.72,0,0,1,2-1h6c.68,0,1,1.05,1,1.44S34,15,33,15Z"/><polygon points="25.67 34 29.84 29.18 29.84 32.18 31.84 32.18 31.84 26.18 24.84 26.18 24.84 28.18 27.84 28.18 24.16 32.58 25.67 34"/></svg>',
  pF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M36,34H0L36,2ZM12,30H32V12Z"/></svg>',
  dF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M36,34H0L36,2ZM12,30H32V12Z"/><polygon points="18.18 4.18 14 9 14 6 12 6 12 12 19 12 19 10 16 10 19.69 5.59 18.18 4.18"/></svg>',
  mF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M36,34H0L36,2ZM12,30H32V12Z"/><polygon points="13.82 13.82 18 9 18 12 20 12 20 6 13 6 13 8 16 8 12.31 12.41 13.82 13.82"/></svg>',
  gF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M10,0,26,2s-5.59,5.68-5.56,5.71C23.32,10.88,23.94,15.27,24,18V36H20V18c-.05-2.09-.54-5.32-2.47-7.53L12,16Z"/></svg>',
  vF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M26,0,10,2s5.59,5.68,5.57,5.71C12.68,10.88,12.06,15.27,12,18V36h4V18c.06-2.09.54-5.32,2.47-7.53L24,16Z"/></svg>',
  yF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><polygon points="35.99 2 30 2 25.99 2 25.99 6.59 25.99 8.84 24 8.84 19.99 8.84 19.99 13.43 19.99 15.67 13.99 15.67 13.99 15.69 13.99 20.27 13.99 22.52 12 22.52 7.99 22.52 7.99 27.12 7.99 29.36 0 29.36 0 33.95 7.99 33.95 11.99 33.95 12 33.95 12 27.12 13.99 27.12 18 27.12 18 22.52 18 20.27 19.99 20.27 24 20.27 24 15.67 24 13.43 25.99 13.43 30 13.43 30 8.84 30 6.59 35.99 6.59 35.99 2"/></svg>',
  _F = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><polygon points="30 2.03 25.99 2.03 25.99 6.63 25.99 8.87 24 8.87 19.99 8.87 19.99 13.47 19.99 15.71 13.99 15.71 13.99 15.73 13.99 20.31 13.99 22.57 12 22.57 7.99 22.57 7.99 27.16 7.99 29.4 0 29.4 0 34 7.99 34 11.99 34 12 34 12 27.16 13.99 27.16 18 27.16 18 22.57 18 20.31 19.99 20.31 24 20.31 24 15.71 24 13.47 25.99 13.47 30 13.47 30 8.87 30 6.63 35.99 6.63 35.99 2.03 30 2.03"/><polygon points="30.17 26.18 26 31 26 28 24 28 24 34 31 34 31 32 28 32 31.68 27.59 30.17 26.18"/></svg>',
  xF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><polygon points="30 2.03 25.99 2.03 25.99 6.63 25.99 8.87 24 8.87 19.99 8.87 19.99 13.47 19.99 15.71 13.99 15.71 13.99 15.73 13.99 20.31 13.99 22.57 12 22.57 7.99 22.57 7.99 27.16 7.99 29.4 0 29.4 0 34 7.99 34 11.99 34 12 34 12 27.16 13.99 27.16 18 27.16 18 22.57 18 20.31 19.99 20.31 24 20.31 24 15.71 24 13.47 25.99 13.47 30 13.47 30 8.87 30 6.63 35.99 6.63 35.99 2.03 30 2.03"/><polygon points="24.83 33.82 29 29 29 32 31 32 31 26 24 26 24 28 27 28 23.32 32.41 24.83 33.82"/></svg>',
  bF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M5,10,17,0V8a11,11,0,0,1,8.44,3.5c2.88,3.2,3.5,7.8,3.56,10.5V36H25V22c-.05-2.11-.54-5.61-2.53-7.82A7.1,7.1,0,0,0,17,12v8Z"/></svg>',
  MF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M29,10,17,0V8a11,11,0,0,0-8.44,3.5C5.68,14.7,5.06,19.3,5,22V36H9V22c.06-2.11.54-5.61,2.53-7.82A7.1,7.1,0,0,1,17,12v8Z"/></svg>',
  EF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M20,0c-5.38,0-9.79,5.34-10,12H2L12,24,22,12H14c.19-4.39,2.86-8,6-8s6,4.58,6,10V36h4V14C30,6.13,25.6,0,20,0Z"/></svg>',
  wF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M21,3c-.44-.92-1-3-3-3s-2.63,2.16-3,3C15,3,2,29,2,33a2.65,2.65,0,0,0,3,3c2,0,6.1-2.2,9-4,2-1,3-2,4-2s2,1,4,2c0,0,7,4,9,4a2.65,2.65,0,0,0,3-3C34,29,21,3,21,3Z"/></svg>',
  SF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M18,4A14,14,0,1,1,4,18,14,14,0,0,1,18,4m0-4A18,18,0,1,0,36,18,18,18,0,0,0,18,0Z"/><circle cx="18" cy="18" r="6"/></svg>',
  TF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M18,0A13.83,13.83,0,0,0,4,14c0,4,1,9,7,12,2,1,6.15,8.67,7,10,3.38-5.44,5-9,7-10,6-3,7-8,7-12A13.83,13.83,0,0,0,18,0Zm0,19a5,5,0,1,1,5-5A5,5,0,0,1,18,19Z"/></svg>',
  PF = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><title>mappedin-icon</title><path d="M18,0A13.83,13.83,0,0,0,4,14c0,4,1,9,7,12,2,1,6.15,8.67,7,10,3.38-5.44,5-9,7-10,6-3,7-8,7-12A13.83,13.83,0,0,0,18,0Z"/></svg>',
  CF = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="25px" height="30px" viewBox="0 0 25 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    \x3c!-- Generator: Sketch 57.1 (83088) - https://sketch.com --\x3e\n    <title>Marker Pin</title>\n    <desc>Created with Sketch.</desc>\n    <defs>\n        <path d="M5.5,15 C6.34615385,14.1176471 7.33333333,12.9411765 8.46153846,11.4705882 C10.1538462,9.26470588 11,7.18962511 11,5.73529412 C11,2.56777864 8.53756612,0 5.5,0 C2.46243388,0 0,2.56777864 0,5.73529412 C0,7.1924534 0.846153846,9.26470588 2.53846154,11.4705882 C3.66666667,12.9411765 4.65384615,14.1176471 5.5,15 Z" id="path-1"></path>\n        <filter x="-104.5%" y="-63.3%" width="309.1%" height="259.8%" filterUnits="objectBoundingBox" id="filter-2">\n            <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>\n            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>\n            <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>\n            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>\n            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>\n        </filter>\n    </defs>\n    <g id="CE-1261" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Final-MVP-Markers" transform="translate(-204.000000, -523.000000)">\n            <g id="Marker-Pin" transform="translate(211.000000, 528.000000)">\n                <g id="Oval-Copy-25">\n                    <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>\n                    <path stroke="#FFFFFF" stroke-width="1.5" d="M4.95868222,15.5191099 C4.09118889,14.6145045 3.08708286,13.4178617 1.94340415,11.9271041 C0.219570966,9.68012899 -0.75,7.4435468 -0.75,5.73529412 C-0.75,2.16043095 2.04102866,-0.75 5.5,-0.75 C8.95897134,-0.75 11.75,2.16043095 11.75,5.73529412 C11.75,7.44173178 10.7794284,9.68143336 9.05659585,11.9271041 C7.91291714,13.4178617 6.90881111,14.6145045 6.04131778,15.5191099 L5.5,16.0835856 L4.95868222,15.5191099 Z" fill="#FFFFFF" fill-rule="evenodd"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n',
  AF = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="23px" height="27px" viewBox="0 0 23 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    \x3c!-- Generator: Sketch 57.1 (83088) - https://sketch.com --\x3e\n    <title>Oval Copy 25</title>\n    <desc>Created with Sketch.</desc>\n    <defs>\n        <path d="M5.5,15 C6.34615385,14.1176471 7.33333333,12.9411765 8.46153846,11.4705882 C10.1538462,9.26470588 11,7.18962511 11,5.73529412 C11,2.56777864 8.53756612,0 5.5,0 C2.46243388,0 0,2.56777864 0,5.73529412 C0,7.1924534 0.846153846,9.26470588 2.53846154,11.4705882 C3.66666667,12.9411765 4.65384615,14.1176471 5.5,15 Z" id="path-1"></path>\n        <filter x="-90.9%" y="-53.3%" width="281.8%" height="236.1%" filterUnits="objectBoundingBox" id="filter-2">\n            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>\n            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>\n            <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>\n            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>\n        </filter>\n    </defs>\n    <g id="CE-1261" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Final-MVP-Markers" transform="translate(-205.000000, -524.000000)">\n            <g id="Marker-Pin" transform="translate(211.000000, 528.000000)">\n                <g id="Oval-Copy-25">\n                    <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>\n                    <use fill="#000000" fill-rule="evenodd" xlink:href="#path-1"></use>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n',
  IF = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="36px" height="36px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    \x3c!-- Generator: Sketch 57.1 (83088) - https://sketch.com --\x3e\n    <defs>\n      <filter id="f3" x="-50%" y="-50%" width="200%" height="200%">\n        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>\n        <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>\n        <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>\n        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>\n        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>\n      </filter>\n    </defs>\n    <circle cx="50" cy="50" r="40" fill="white" filter="url(#f3)"/>\n    <circle cx="50" cy="50" r="40" fill="white"/>\n</svg>\n',
  LF = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="36px" height="36px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    \x3c!-- Generator: Sketch 57.1 (83088) - https://sketch.com --\x3e\n    <circle cx="50" cy="50" r="30" />\n</svg>\n',
  OF = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 468.614 468.614">\n    <g>\n        <path d="M291.299 116.517h-3.501c10.635-12.36 17.102-28.378 17.102-45.915C304.899 31.666 273.219 0 234.305 0c-38.93 0-70.584 31.666-70.584 70.602 0 17.537 6.477 33.555 17.093 45.915h-3.51c-19.645 0-35.626 15.997-35.626 35.645v117.105c0 19.648 15.982 35.633 35.626 35.633h1.372v128.07c0 20.332 10.697 35.645 24.884 35.645h61.468c14.208 0 24.908-15.312 24.908-35.645V304.9h1.363c19.642 0 35.639-15.984 35.639-35.633V152.161c-.006-19.647-15.998-35.644-35.639-35.644z" fill="#386460" />\n        <path d="M291.299 116.517h-3.501c10.635-12.36 17.102-28.378 17.102-45.915C304.899 31.666 273.219 0 234.305 0c-38.93 0-70.584 31.666-70.584 70.602 0 17.537 6.477 33.555 17.093 45.915h-3.51c-19.645 0-35.626 15.997-35.626 35.645v117.105c0 19.648 15.982 35.633 35.626 35.633h1.372v128.07c0 20.332 10.697 35.645 24.884 35.645h61.468c14.208 0 24.908-15.312 24.908-35.645V304.9h1.363c19.642 0 35.639-15.984 35.639-35.633V152.161c-.006-19.647-15.998-35.644-35.639-35.644z" style="fill:none;stroke-width:8px;stroke:white" />\n    </g>\n</svg>',
  RF = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n    <g>\n        <path d="M12 0a8 8 0 00-8 8c0 1.421.382 2.75 1.031 3.906.108.192.221.381.344.563L12 24l6.625-11.531c.102-.151.19-.311.281-.469l.063-.094A7.954 7.954 0 0020 8a8 8 0 00-8-8zm0 4a4 4 0 110 8 4 4 0 010-8z" fill="#e74c3c"/>\n        <path d="M12 0a8 8 0 00-8 8c0 1.421.382 2.75 1.031 3.906.108.192.221.381.344.563L12 24l6.625-11.531c.102-.151.19-.311.281-.469l.063-.094A7.954 7.954 0 0020 8a8 8 0 00-8-8zm0 4a4 4 0 110 8 4 4 0 010-8z" style="fill:none;stroke-width:1px;stroke-linecap:round;stroke:white"/>\n        <path d="M12 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z" fill="#c0392b"/>\n    </g>\n</svg>',
  np = new Map([["journey-departure", OF], ["journey-destination", RF], ["question-mark", rF], ["arrow", oF], ["door", sF], ["elevator", aF], ["elevator-up", lF], ["elevator-down", uF], ["elevator-alt", cF], ["escalator-down", hF], ["escalator-up", fF], ["ramp", pF], ["ramp-down", dF], ["ramp-up", mF], ["sligntTurnLeft", gF], ["sightTurnRight", vF], ["stairs", yF], ["stairs-down", _F], ["stairs-up", xF], ["turnLeft", bF], ["turnRight", MF], ["uTurn", EF], ["blue-arrow", wF], ["start", SF], ["destination-marker-back", TF], ["destination-marker-front", PF], ["smart-label-pin-back", CF], ["smart-label-pin-front", AF], ["smart-label-circle-back", IF], ["smart-label-circle-front", LF]]);
E(), E();
var dC,
  Vm = {
    margin: 6,
    text: {
      numLines: 2,
      lineHeight: 1.2,
      size: 11.5,
      maxWidth: 150,
      foregroundColor: "white",
      backgroundColor: "#333"
    },
    marker: {
      size: 5,
      foregroundColor: {
        active: "white",
        inactive: void 0
      },
      backgroundColor: {
        active: "#333",
        inactive: void 0
      }
    }
  },
  pC = {
    lightOnDark: {
      ...Vm,
      text: {
        ...Vm.text,
        foregroundColor: "white",
        backgroundColor: "#333"
      },
      marker: {
        ...Vm.marker,
        foregroundColor: {
          active: "white",
          inactive: void 0
        },
        backgroundColor: {
          active: "#333",
          inactive: void 0
        }
      }
    },
    darkOnLight: {
      ...Vm,
      text: {
        ...Vm.text,
        foregroundColor: "#333",
        backgroundColor: "white"
      },
      marker: {
        ...Vm.marker,
        foregroundColor: {
          active: "#333",
          inactive: void 0
        },
        backgroundColor: {
          active: "white",
          inactive: void 0
        }
      }
    }
  };
E(), function (t) {
  t.ANIMATED = "animated", t.ALWAYS_ON_TOP = "always_on_top", t.ALL = "all", t.TWEEN = "tween";
}(dC || (dC = {}));
var hi = dC;
E();
var Sa,
  NF = 0,
  rue = !1,
  mC = class {
    constructor(t, e) {
      re(this, Sa, void 0), A(this, "currentScene"), A(this, "processedMapObjects", new Set()), he(this, Sa, t), rue && this.renderGrid(), this.transitionTo(e).then(() => {
        w(this, Sa).publish(Xe.ON_FIRST_MAP_LOADED);
      }).catch(t => {
        ke.error(t);
      });
    }
    get currentMap() {
      return this.currentScene.currentMap;
    }
    renderGrid() {
      var t = new Yx(1e4, 10);
      t.setColors(233696766, 14606046), t.position.z = -10, t.rotation.x = Math.PI / 2, w(this, Sa).scene.add(t);
    }
    async transitionTo(t, e) {
      w(this, Sa).publish(Xe.SET_SCENE_START);
      let n = this.currentScene;
      t.transitionOptions = e || {}, t.currentMap = (null == e ? void 0 : e.activeMap) || t.maps[0], this.currentScene = t;
      let i = await t.preRender(e);
      t.mapObjectsArray = await Promise.all(i);
      let r = [],
        o = [],
        s = !1;
      if (n) {
        s = n.currentMap.mapGroup !== t.currentMap.mapGroup;
        for (let t of n.mapObjects.values()) r.push(t.fadeOut({
          duration: NF,
          onComplete: () => {
            t.onInvisible(), n.object.remove(t.object);
          }
        }));
      }
      for (let e of t.mapObjects.values()) t.object.add(null == e ? void 0 : e.object), e.object.position.z = 0, o.push(e.fadeIn({
        duration: NF,
        onComplete: () => {
          e.onVisible();
        }
      }));
      w(this, Sa).tryRendering(), await Promise.all(r.map(t => t.start())), w(this, Sa).scene.add(t.object), await Promise.all([...o.map(t => t.start()), t.focusOnCurrentMap(s ? {
        ...e,
        autoFocusOnActiveMap: !0
      } : void 0, null == n)]), null != n && w(this, Sa).scene.remove(n.object), t.postRender(), w(this, Sa).publish(Xe.SET_SCENE), null == n && w(this, Sa).publish(Xe.ON_FIRST_MAP_LOADED);
    }
  };
u(mC, "SceneManager"), Sa = new WeakMap();
var gC = mC;
function AE(t, e = !1) {
  let n = null !== t[0].index,
    i = new Set(Object.keys(t[0].attributes)),
    r = new Set(Object.keys(t[0].morphAttributes)),
    o = {},
    s = {},
    a = t[0].morphTargetsRelative,
    l = new Pi(),
    u = 0;
  for (let h = 0; h < t.length; ++h) {
    let c = t[h],
      p = 0;
    if (n !== (null !== c.index)) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + h + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
    for (let t in c.attributes) {
      if (!i.has(t)) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + h + '. All geometries must have compatible attributes; make sure "' + t + '" attribute exists among all geometries, or in none of them.'), null;
      void 0 === o[t] && (o[t] = []), o[t].push(c.attributes[t]), p++;
    }
    if (p !== i.size) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + h + ". Make sure all geometries have the same number of attributes."), null;
    if (a !== c.morphTargetsRelative) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + h + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
    for (let t in c.morphAttributes) {
      if (!r.has(t)) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + h + ".  .morphAttributes must be consistent throughout all geometries."), null;
      void 0 === s[t] && (s[t] = []), s[t].push(c.morphAttributes[t]);
    }
    if (e) {
      let t;
      if (n) t = c.index.count;else {
        if (void 0 === c.attributes.position) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + h + ". The geometry must have either an index or a position attribute"), null;
        t = c.attributes.position.count;
      }
      l.addGroup(u, t, h), u += t;
    }
  }
  if (n) {
    let e = 0,
      n = [];
    for (let i = 0; i < t.length; ++i) {
      let r = t[i].index;
      for (let t = 0; t < r.count; ++t) n.push(r.getX(t) + e);
      e += t[i].attributes.position.count;
    }
    l.setIndex(n);
  }
  for (let t in o) {
    let e = DF(o[t]);
    if (!e) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + t + " attribute."), null;
    l.setAttribute(t, e);
  }
  for (let t in s) {
    let e = s[t][0].length;
    if (0 === e) break;
    l.morphAttributes = l.morphAttributes || {}, l.morphAttributes[t] = [];
    for (let n = 0; n < e; ++n) {
      let e = [];
      for (let i = 0; i < s[t].length; ++i) e.push(s[t][i][n]);
      let i = DF(e);
      if (!i) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + t + " morphAttribute."), null;
      l.morphAttributes[t].push(i);
    }
  }
  return l;
}
function DF(t) {
  let e,
    n,
    i,
    r = -1,
    o = 0;
  for (let s = 0; s < t.length; ++s) {
    let a = t[s];
    if (a.isInterleavedBufferAttribute) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported."), null;
    if (void 0 === e && (e = a.array.constructor), e !== a.array.constructor) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
    if (void 0 === n && (n = a.itemSize), n !== a.itemSize) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
    if (void 0 === i && (i = a.normalized), i !== a.normalized) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
    if (-1 === r && (r = a.gpuType), r !== a.gpuType) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes."), null;
    o += a.array.length;
  }
  let s = new e(o),
    a = 0;
  for (let e = 0; e < t.length; ++e) s.set(t[e].array, a), a += t[e].array.length;
  let l = new ui(s, n, i);
  return void 0 !== r && (l.gpuType = r), l;
}
E(), E(), u(AE, "mergeGeometries"), u(DF, "mergeAttributes"), E();
var Ta = class {
  constructor() {
    A(this, "_subscribers", {});
  }
  publish(t, e) {
    !this._subscribers || !this._subscribers[t] || this._subscribers[t].forEach(function (t) {
      "function" == typeof t && t(e);
    });
  }
  on(t, e) {
    this._subscribers || (this._subscribers = {}), this._subscribers[t] = this._subscribers[t] || [], this._subscribers[t].push(e);
  }
  off(t, e) {
    if (!this._subscribers || null == this._subscribers[t]) return;
    let n = this._subscribers[t].indexOf(e);
    -1 !== n && this._subscribers[t].splice(n, 1);
  }
  destroy() {
    this._subscribers = {};
  }
};
function Ph(t) {
  let e = new Ta();
  Object.assign(e, t);
  for (let n in t) if (null != n) {
    let i = t[n];
    if ("function" == typeof i) continue;
    e[`_${n}`] = i, Object.defineProperty(e, n, {
      get: () => e[`_${n}`],
      set(t) {
        let i = e[`_${n}`];
        e[`_${n}`] = t, e.publish(`${n}Changed`, {
          oldValue: i,
          newValue: e[n]
        });
      }
    });
  }
  return e;
}
u(Ta, "PubSub"), u(Ph, "tinyObservable"), E(), E(), E();
var IE = class extends $a {
  constructor(t, e = {}) {
    let n = e.font;
    if (void 0 === n) super();else {
      let i = n.generateShapes(t, e.size);
      e.depth = void 0 !== e.height ? e.height : 50, void 0 === e.bevelThickness && (e.bevelThickness = 10), void 0 === e.bevelSize && (e.bevelSize = 8), void 0 === e.bevelEnabled && (e.bevelEnabled = !1), super(i, e);
    }
    this.type = "TextGeometry";
  }
};
u(IE, "TextGeometry");
var fc = Rt(GF());
E();
var MC = Rt($F());
function eB(t) {
  this.name = "JSClipperError", this.message = t, this.stack = new Error().stack;
}
u(eB, "JSClipperError"), eB.prototype = Error.prototype, MC.default.Error = function (t) {
  throw new eB(t);
};
var My = MC.default;
E(), E();
var DE = class {
  constructor(t) {
    this.isFont = !0, this.type = "Font", this.data = t;
  }
  generateShapes(t, e = 100) {
    let n = [],
      i = bhe(t, e, this.data);
    for (let t = 0, e = i.length; t < e; t++) n.push(...i[t].toShapes());
    return n;
  }
};
function bhe(t, e, n) {
  let i = Array.from(t),
    r = e / n.resolution,
    o = (n.boundingBox.yMax - n.boundingBox.yMin + n.underlineThickness) * r,
    s = [],
    a = 0,
    l = 0;
  for (let t = 0; t < i.length; t++) {
    let e = i[t];
    if ("\n" === e) a = 0, l -= o;else {
      let t = Mhe(e, r, a, l, n);
      a += t.offsetX, s.push(t.path);
    }
  }
  return s;
}
function Mhe(t, e, n, i, r) {
  let o = r.glyphs[t] || r.glyphs["?"];
  if (!o) return void console.error('THREE.Font: character "' + t + '" does not exists in font family ' + r.familyName + ".");
  let s,
    a,
    l,
    u,
    h,
    c,
    p,
    d,
    f = new Kx();
  if (o.o) {
    let t = o._cachedOutline || (o._cachedOutline = o.o.split(" "));
    for (let r = 0, o = t.length; r < o;) switch (t[r++]) {
      case "m":
        s = t[r++] * e + n, a = t[r++] * e + i, f.moveTo(s, a);
        break;
      case "l":
        s = t[r++] * e + n, a = t[r++] * e + i, f.lineTo(s, a);
        break;
      case "q":
        l = t[r++] * e + n, u = t[r++] * e + i, h = t[r++] * e + n, c = t[r++] * e + i, f.quadraticCurveTo(h, c, l, u);
        break;
      case "b":
        l = t[r++] * e + n, u = t[r++] * e + i, h = t[r++] * e + n, c = t[r++] * e + i, p = t[r++] * e + n, d = t[r++] * e + i, f.bezierCurveTo(h, c, p, d, l, u);
    }
  }
  return {
    offsetX: o.ha * e,
    path: f
  };
}
u(DE, "Font"), u(bhe, "createPaths"), u(Mhe, "createPath");
var Ehe = {
    0: {
      ha: 765,
      x_min: 66,
      x_max: 700,
      o: "m 700 497 q 683 282 700 377 q 627 121 665 187 q 528 21 589 56 q 382 -14 468 -14 q 242 21 302 -14 q 144 121 183 56 q 86 282 105 187 q 66 497 66 377 q 84 712 66 617 q 139 872 101 807 q 236 972 176 938 q 382 1007 296 1007 q 522 973 463 1007 q 621 873 582 939 q 680 713 661 808 q 700 497 700 618 m 192 497 q 202 319 192 395 q 235 193 212 243 q 293 117 257 142 q 382 92 330 92 q 471 117 434 92 q 531 192 507 142 q 565 318 554 242 q 575 497 575 395 q 565 675 575 599 q 531 801 554 751 q 471 876 507 851 q 382 901 434 901 q 293 876 330 901 q 235 801 257 851 q 202 675 212 751 q 192 497 192 599 z "
    },
    1: {
      ha: 765,
      x_min: 121,
      x_max: 482,
      o: "m 482 0 l 363 0 l 363 619 q 363 682 363 648 q 365 748 363 715 q 367 811 366 781 q 368 864 368 841 q 348 843 357 852 q 330 826 339 834 q 311 809 321 818 q 286 787 300 800 l 186 705 l 121 789 l 380 991 l 482 991 l 482 0 z "
    },
    2: {
      ha: 765,
      x_min: 65,
      x_max: 684,
      o: "m 684 0 l 65 0 l 65 106 l 302 364 q 393 465 353 419 q 461 553 433 510 q 505 641 490 597 q 519 736 519 684 q 508 806 519 776 q 475 858 496 837 q 425 890 454 880 q 359 901 395 901 q 243 875 295 901 q 144 808 191 849 l 75 889 q 134 935 102 913 q 201 972 165 956 q 277 997 237 987 q 361 1006 317 1006 q 478 987 426 1006 q 568 935 531 969 q 624 851 604 901 q 644 741 644 802 q 626 631 644 683 q 577 528 608 578 q 502 427 545 477 q 407 321 458 376 l 216 118 l 216 113 l 684 113 l 684 0 z "
    },
    3: {
      ha: 765,
      x_min: 56,
      x_max: 682,
      o: "m 652 760 q 636 669 652 710 q 592 599 621 629 q 525 550 564 569 q 437 522 486 530 l 437 518 q 620 442 557 503 q 682 282 682 380 q 660 163 682 217 q 593 69 638 109 q 480 8 549 30 q 318 -14 412 -14 q 179 -2 244 -14 q 56 40 113 9 l 56 155 q 183 107 115 124 q 315 90 252 90 q 423 104 378 90 q 498 142 469 117 q 542 204 528 168 q 555 286 555 241 q 537 365 555 332 q 486 419 519 398 q 405 451 453 441 q 297 461 357 461 l 207 461 l 207 564 l 297 564 q 395 577 352 564 q 466 616 437 591 q 510 675 495 641 q 525 751 525 710 q 513 814 525 787 q 478 862 500 842 q 425 891 456 881 q 355 901 393 901 q 228 879 283 901 q 122 819 172 856 l 60 904 q 117 943 85 925 q 186 976 149 962 q 266 998 223 989 q 355 1006 308 1006 q 484 987 429 1006 q 576 936 539 969 q 633 858 614 903 q 652 760 652 813 z "
    },
    4: {
      ha: 765,
      x_min: 16,
      x_max: 737,
      o: "m 737 222 l 593 222 l 593 0 l 473 0 l 473 222 l 16 222 l 16 330 l 465 997 l 593 997 l 593 335 l 737 335 l 737 222 m 473 335 l 473 576 q 474 656 473 614 q 477 738 475 698 q 480 812 478 777 q 482 869 481 846 l 476 869 q 464 839 471 856 q 449 806 457 823 q 431 774 440 789 q 415 747 422 758 l 136 335 l 473 335 z "
    },
    5: {
      ha: 765,
      x_min: 89,
      x_max: 688,
      o: "m 370 608 q 495 590 437 608 q 596 534 553 571 q 663 444 639 498 q 688 318 688 389 q 665 179 688 241 q 596 75 642 117 q 484 9 551 32 q 330 -14 417 -14 q 262 -10 296 -14 q 198 0 229 -7 q 139 16 167 6 q 89 40 111 26 l 89 157 q 141 129 111 141 q 205 109 172 117 q 272 96 238 100 q 334 92 305 92 q 429 104 387 92 q 500 143 471 117 q 545 210 530 170 q 561 304 561 250 q 501 453 561 401 q 328 504 441 504 q 288 502 309 504 q 245 498 267 500 q 204 492 224 495 q 171 486 185 489 l 110 525 l 147 991 l 615 991 l 615 879 l 254 879 l 228 595 q 285 604 250 599 q 370 608 321 608 z "
    },
    6: {
      ha: 765,
      x_min: 77,
      x_max: 701,
      o: "m 77 424 q 84 566 77 495 q 109 701 91 636 q 158 821 127 766 q 237 918 189 877 q 353 982 286 959 q 510 1006 420 1006 q 538 1005 523 1006 q 570 1003 554 1004 q 601 999 586 1001 q 627 993 615 996 l 627 888 q 573 900 603 896 q 514 904 543 904 q 407 889 453 904 q 326 848 360 875 q 270 785 292 822 q 233 704 247 749 q 212 610 218 660 q 203 505 205 559 l 211 505 q 244 551 224 530 q 289 588 263 572 q 347 612 315 603 q 419 621 379 621 q 536 601 484 621 q 625 542 588 581 q 681 447 661 503 q 701 319 701 391 q 680 180 701 242 q 620 76 659 119 q 525 9 581 33 q 400 -14 469 -14 q 273 13 332 -14 q 170 94 214 39 q 102 230 127 148 q 77 424 77 312 m 399 90 q 473 104 439 90 q 531 146 507 118 q 569 217 555 174 q 582 319 582 260 q 571 405 582 367 q 537 469 559 442 q 481 509 515 495 q 403 524 448 524 q 320 508 357 524 q 256 466 282 492 q 215 408 229 441 q 200 343 200 376 q 213 253 200 298 q 250 172 225 208 q 312 113 275 136 q 399 90 349 90 z "
    },
    7: {
      ha: 765,
      x_min: 61,
      x_max: 699,
      o: "m 191 0 l 572 879 l 61 879 l 61 991 l 699 991 l 699 893 l 322 0 l 191 0 z "
    },
    8: {
      ha: 765,
      x_min: 72,
      x_max: 694,
      o: "m 383 1007 q 491 992 440 1007 q 579 947 541 977 q 640 873 618 918 q 663 768 663 828 q 649 686 663 723 q 612 620 635 650 q 555 567 588 591 q 485 525 523 544 q 562 478 524 504 q 629 420 600 452 q 676 348 659 388 q 694 258 694 308 q 672 145 694 196 q 608 60 649 95 q 510 5 567 24 q 383 -14 452 -14 q 251 5 309 -14 q 153 57 193 23 q 93 141 113 92 q 72 253 72 191 q 87 345 72 304 q 128 418 102 385 q 189 475 154 450 q 264 519 224 500 q 201 565 231 541 q 151 621 172 590 q 117 688 130 651 q 104 770 104 725 q 127 873 104 829 q 189 947 150 918 q 278 992 227 977 q 383 1007 328 1007 m 193 252 q 204 185 193 216 q 238 134 215 155 q 296 101 261 113 q 380 89 332 89 q 464 101 428 89 q 525 135 500 113 q 562 188 549 157 q 574 257 574 219 q 561 321 574 292 q 523 374 547 349 q 463 420 498 398 q 386 463 429 441 l 366 472 q 237 379 280 431 q 193 252 193 326 m 382 904 q 268 868 310 904 q 225 764 225 832 q 237 697 225 725 q 270 648 249 669 q 320 609 291 626 q 385 575 350 591 q 446 608 417 590 q 496 648 475 625 q 530 699 517 670 q 542 764 542 727 q 499 868 542 832 q 382 904 456 904 z "
    },
    9: {
      ha: 765,
      x_min: 72,
      x_max: 697,
      o: "m 697 568 q 690 426 697 497 q 665 291 683 355 q 616 171 647 227 q 536 74 585 115 q 421 10 488 33 q 264 -14 354 -14 q 235 -13 251 -14 q 204 -11 220 -12 q 174 -7 189 -9 q 147 -1 159 -5 l 147 104 q 201 92 171 96 q 260 87 231 87 q 410 119 351 87 q 504 206 469 151 q 553 333 538 260 q 571 486 568 406 l 562 486 q 530 441 549 462 q 485 404 511 420 q 427 380 459 389 q 354 371 394 371 q 237 391 290 371 q 149 450 185 411 q 92 544 112 488 q 72 672 72 600 q 93 811 72 749 q 154 917 115 873 q 249 983 193 960 q 374 1006 304 1006 q 501 979 442 1006 q 604 899 560 953 q 672 762 647 844 q 697 568 697 680 m 375 901 q 301 888 334 901 q 243 846 267 874 q 205 774 218 817 q 192 672 192 731 q 203 587 192 625 q 237 523 214 549 q 293 482 259 496 q 371 468 326 468 q 454 484 417 468 q 518 525 492 500 q 559 583 545 551 q 574 648 574 616 q 561 739 574 694 q 524 820 549 784 q 462 879 499 857 q 375 901 425 901 z "
    },
    " ": {
      ha: 361,
      x_min: 0,
      x_max: 0,
      o: ""
    },
    "!": {
      ha: 374,
      x_min: 100,
      x_max: 272,
      o: "m 228 281 l 146 281 l 111 991 l 262 991 l 228 281 m 100 75 q 106 119 100 101 q 125 148 113 137 q 152 164 136 159 q 186 170 168 170 q 219 164 203 170 q 247 148 235 159 q 265 119 258 137 q 272 75 272 101 q 265 32 272 50 q 247 3 258 14 q 219 -14 235 -9 q 186 -20 203 -20 q 152 -14 168 -20 q 125 3 136 -9 q 106 32 113 14 q 100 75 100 50 z "
    },
    '"': {
      ha: 558,
      x_min: 90,
      x_max: 468,
      o: "m 224 991 l 196 633 l 118 633 l 90 991 l 224 991 m 468 991 l 440 633 l 363 633 l 335 991 l 468 991 z "
    },
    "#": {
      ha: 897,
      x_min: 35,
      x_max: 863,
      o: "m 667 606 l 624 383 l 814 383 l 814 290 l 606 290 l 550 0 l 450 0 l 507 290 l 310 290 l 254 0 l 157 0 l 210 290 l 35 290 l 35 383 l 228 383 l 272 606 l 86 606 l 86 699 l 289 699 l 345 991 l 444 991 l 389 699 l 587 699 l 644 991 l 742 991 l 685 699 l 863 699 l 863 606 l 667 606 m 328 383 l 525 383 l 568 606 l 371 606 l 328 383 z "
    },
    $: {
      ha: 765,
      x_min: 83,
      x_max: 668,
      o: "m 668 302 q 651 216 668 255 q 603 149 634 178 q 526 102 571 121 q 424 75 481 83 l 424 -81 l 330 -81 l 330 69 q 262 72 296 69 q 195 81 227 75 q 134 96 162 87 q 83 117 105 105 l 83 233 q 135 211 106 222 q 197 191 165 200 q 264 177 230 182 q 330 171 298 171 l 330 465 q 225 508 270 486 q 152 559 181 530 q 109 625 123 588 q 94 713 94 663 q 111 796 94 758 q 158 862 127 833 q 233 908 189 890 q 330 932 277 926 l 330 1054 l 424 1054 l 424 935 q 549 917 492 931 q 652 882 606 903 l 607 783 q 522 814 569 800 q 424 832 474 828 l 424 546 q 529 503 484 525 q 606 452 575 480 q 652 388 637 424 q 668 302 668 351 m 549 302 q 542 343 549 325 q 520 377 535 362 q 482 406 506 393 q 424 431 458 418 l 424 178 q 518 220 487 187 q 549 302 549 254 m 214 711 q 219 668 214 687 q 239 632 225 648 q 275 604 252 616 q 330 579 297 591 l 330 829 q 242 788 270 819 q 214 711 214 758 z "
    },
    "%": {
      ha: 1146,
      x_min: 69,
      x_max: 1076,
      o: "m 170 696 q 194 528 170 584 q 272 472 218 472 q 378 696 378 472 q 272 918 378 918 q 194 863 218 918 q 170 696 170 808 m 478 696 q 466 564 478 623 q 429 466 454 506 q 365 405 404 426 q 272 383 326 383 q 184 405 222 383 q 121 466 146 426 q 82 564 95 506 q 69 696 69 623 q 81 827 69 769 q 118 924 93 884 q 181 985 142 964 q 272 1006 219 1006 q 361 985 323 1006 q 426 924 399 964 q 465 827 452 884 q 478 696 478 769 m 768 298 q 792 131 768 186 q 871 75 817 75 q 977 298 977 75 q 871 521 977 521 q 792 466 817 521 q 768 298 768 410 m 1076 298 q 1064 167 1076 225 q 1027 69 1053 109 q 963 8 1002 29 q 871 -14 924 -14 q 783 8 821 -14 q 719 69 745 29 q 681 167 694 109 q 668 298 668 225 q 680 429 668 372 q 716 527 692 487 q 780 587 741 566 q 871 608 818 608 q 960 587 922 608 q 1024 527 998 566 q 1063 429 1050 487 q 1076 298 1076 372 m 903 991 l 353 0 l 245 0 l 796 991 l 903 991 z "
    },
    "&": {
      ha: 975,
      x_min: 74,
      x_max: 953,
      o: "m 286 790 q 292 745 286 767 q 308 701 297 723 q 337 656 319 679 q 379 608 355 633 q 448 653 419 632 q 496 696 477 674 q 525 741 515 718 q 534 793 534 765 q 526 838 534 817 q 502 873 517 859 q 463 897 486 888 q 412 905 441 905 q 320 875 354 905 q 286 790 286 845 m 378 96 q 450 103 417 96 q 512 125 484 111 q 565 157 541 138 q 611 196 589 175 l 349 472 q 286 428 313 450 q 240 382 259 407 q 212 329 222 358 q 203 262 203 300 q 215 195 203 226 q 249 142 227 164 q 304 108 271 120 q 378 96 336 96 m 74 258 q 87 353 74 311 q 127 428 101 394 q 191 491 153 462 q 277 549 229 520 q 235 599 256 573 q 200 655 215 625 q 175 718 184 684 q 165 790 165 751 q 182 881 165 841 q 231 950 199 922 q 310 992 263 978 q 416 1007 357 1007 q 517 992 473 1007 q 592 950 562 978 q 640 881 623 922 q 656 790 656 841 q 639 710 656 747 q 593 641 622 673 q 528 583 565 610 q 450 532 491 556 l 689 279 q 722 319 707 299 q 748 363 736 340 q 769 412 760 386 q 785 471 778 439 l 909 471 q 885 388 899 426 q 853 317 871 351 q 813 255 836 284 q 765 199 791 227 l 953 0 l 800 0 l 686 117 q 621 62 653 86 q 551 21 588 38 q 473 -4 515 5 q 378 -14 431 -14 q 250 4 307 -14 q 154 57 193 22 q 95 143 115 92 q 74 258 74 193 z "
    },
    "'": {
      ha: 314,
      x_min: 90,
      x_max: 224,
      o: "m 224 991 l 196 633 l 118 633 l 90 991 l 224 991 z "
    },
    "(": {
      ha: 418,
      x_min: 56,
      x_max: 376,
      o: "m 56 380 q 68 548 56 465 q 105 708 80 630 q 169 857 130 785 q 260 991 207 928 l 376 991 q 232 704 281 861 q 183 382 183 547 q 196 221 183 301 q 232 64 208 141 q 292 -84 256 -12 q 375 -220 328 -156 l 260 -220 q 169 -89 207 -159 q 105 57 130 -19 q 68 215 80 134 q 56 380 56 296 z "
    },
    ")": {
      ha: 418,
      x_min: 41,
      x_max: 363,
      o: "m 363 380 q 351 215 363 296 q 313 57 338 134 q 249 -89 288 -19 q 158 -220 211 -159 l 43 -220 q 125 -84 90 -156 q 186 64 161 -12 q 222 221 210 141 q 235 382 235 301 q 186 704 235 547 q 41 991 137 861 l 158 991 q 249 857 211 928 q 313 708 288 785 q 351 548 338 630 q 363 380 363 465 z "
    },
    "*": {
      ha: 765,
      x_min: 56,
      x_max: 708,
      o: "m 450 1055 l 421 789 l 690 864 l 708 733 l 452 714 l 618 493 l 497 428 l 378 671 l 271 428 l 146 493 l 310 714 l 56 733 l 75 864 l 340 789 l 311 1055 l 450 1055 z "
    },
    "+": {
      ha: 765,
      x_min: 69,
      x_max: 696,
      o: "m 332 439 l 69 439 l 69 541 l 332 541 l 332 804 l 433 804 l 433 541 l 696 541 l 696 439 l 433 439 l 433 178 l 332 178 l 332 439 z "
    },
    ",": {
      ha: 347,
      x_min: 43,
      x_max: 256,
      o: "m 245 161 l 256 146 q 233 68 246 109 q 204 -16 220 26 q 171 -99 188 -58 q 136 -179 153 -141 l 43 -179 q 63 -93 53 -138 q 82 -4 73 -48 q 98 83 91 41 q 111 161 106 125 l 245 161 z "
    },
    "-": {
      ha: 447,
      x_min: 56,
      x_max: 392,
      o: "m 56 315 l 56 429 l 392 429 l 392 315 l 56 315 z "
    },
    ".": {
      ha: 372,
      x_min: 100,
      x_max: 272,
      o: "m 100 75 q 106 119 100 101 q 125 148 113 137 q 152 164 136 159 q 186 170 168 170 q 219 164 203 170 q 247 148 235 159 q 265 119 258 137 q 272 75 272 101 q 265 32 272 50 q 247 3 258 14 q 219 -14 235 -9 q 186 -20 203 -20 q 152 -14 168 -20 q 125 3 136 -9 q 106 32 113 14 q 100 75 100 50 z "
    },
    "/": {
      ha: 518,
      x_min: 14,
      x_max: 504,
      o: "m 504 991 l 135 0 l 14 0 l 383 991 l 504 991 z "
    },
    ":": {
      ha: 372,
      x_min: 100,
      x_max: 272,
      o: "m 100 75 q 106 119 100 101 q 125 148 113 137 q 152 164 136 159 q 186 170 168 170 q 219 164 203 170 q 247 148 235 159 q 265 119 258 137 q 272 75 272 101 q 265 32 272 50 q 247 3 258 14 q 219 -14 235 -9 q 186 -20 203 -20 q 152 -14 168 -20 q 125 3 136 -9 q 106 32 113 14 q 100 75 100 50 m 100 669 q 106 714 100 696 q 125 743 113 732 q 152 759 136 754 q 186 764 168 764 q 219 759 203 764 q 247 743 235 754 q 265 714 258 732 q 272 669 272 696 q 265 627 272 644 q 247 597 258 609 q 219 581 235 586 q 186 575 203 575 q 152 581 168 575 q 125 597 136 586 q 106 627 113 609 q 100 669 100 644 z "
    },
    ";": {
      ha: 372,
      x_min: 43,
      x_max: 272,
      o: "m 245 161 l 256 146 q 233 68 246 109 q 204 -16 220 26 q 171 -99 188 -58 q 136 -179 153 -141 l 43 -179 q 63 -93 53 -138 q 82 -4 73 -48 q 98 83 91 41 q 111 161 106 125 l 245 161 m 100 669 q 106 714 100 696 q 125 743 113 732 q 152 759 136 754 q 186 764 168 764 q 219 759 203 764 q 247 743 235 754 q 265 714 258 732 q 272 669 272 696 q 265 627 272 644 q 247 597 258 609 q 219 581 235 586 q 186 575 203 575 q 152 581 168 575 q 125 597 136 586 q 106 627 113 609 q 100 669 100 644 z "
    },
    "<": {
      ha: 765,
      x_min: 69,
      x_max: 696,
      o: "m 696 161 l 69 449 l 69 518 l 696 844 l 696 736 l 197 489 l 696 271 l 696 161 z "
    },
    "=": {
      ha: 765,
      x_min: 69,
      x_max: 696,
      o: "m 69 578 l 69 679 l 696 679 l 696 578 l 69 578 m 69 300 l 69 401 l 696 401 l 696 300 l 69 300 z "
    },
    ">": {
      ha: 765,
      x_min: 69,
      x_max: 696,
      o: "m 69 271 l 568 489 l 69 736 l 69 844 l 696 518 l 696 449 l 69 161 l 69 271 z "
    },
    "?": {
      ha: 591,
      x_min: 25,
      x_max: 546,
      o: "m 191 281 l 191 306 q 196 376 191 345 q 214 434 201 407 q 250 487 227 461 q 306 542 272 513 q 361 592 338 570 q 399 638 385 615 q 421 689 414 662 q 428 751 428 715 q 418 811 428 784 q 388 857 408 838 q 340 887 369 876 q 273 897 311 897 q 166 880 217 897 q 68 839 115 862 l 25 937 q 144 986 80 966 q 273 1006 208 1006 q 387 988 336 1006 q 473 939 437 971 q 527 859 508 906 q 546 753 546 812 q 537 672 546 707 q 509 606 528 636 q 464 547 491 575 q 400 486 437 518 q 342 433 365 456 q 307 389 320 410 q 290 345 294 368 q 285 293 285 323 l 285 281 l 191 281 m 158 75 q 165 119 158 101 q 183 148 172 137 q 210 164 195 159 q 244 170 226 170 q 278 164 262 170 q 305 148 294 159 q 323 119 317 137 q 330 75 330 101 q 323 32 330 50 q 305 3 317 14 q 278 -14 294 -9 q 244 -20 262 -20 q 210 -14 226 -20 q 183 3 195 -9 q 165 32 172 14 q 158 75 158 50 z "
    },
    "@": {
      ha: 1203,
      x_min: 74,
      x_max: 1129,
      o: "m 1129 496 q 1123 411 1129 454 q 1104 331 1116 369 q 1072 259 1091 292 q 1027 202 1053 227 q 968 164 1001 178 q 896 150 935 150 q 841 160 865 150 q 798 187 816 170 q 769 226 781 204 q 754 272 758 248 l 751 272 q 721 224 739 247 q 679 185 703 202 q 624 159 654 169 q 558 150 594 150 q 466 169 506 150 q 397 222 425 188 q 355 304 370 256 q 340 411 340 353 q 360 536 340 479 q 418 635 380 593 q 509 699 456 676 q 629 722 563 722 q 690 720 660 722 q 749 712 721 717 q 800 702 777 707 q 839 690 823 696 l 823 408 q 822 384 823 393 q 822 370 822 375 q 822 361 822 364 q 822 357 822 359 q 829 298 822 321 q 848 261 836 275 q 874 242 859 248 q 904 237 888 237 q 959 258 935 237 q 999 314 983 279 q 1023 397 1015 349 q 1031 497 1031 444 q 1002 668 1031 593 q 921 795 972 743 q 799 873 869 846 q 644 900 728 900 q 442 862 530 900 q 295 757 355 825 q 205 597 236 690 q 175 395 175 505 q 202 213 175 292 q 280 79 229 134 q 409 -3 332 25 q 586 -31 486 -31 q 668 -26 627 -31 q 746 -13 708 -21 q 817 6 783 -5 q 880 28 851 16 l 880 -68 q 749 -109 822 -94 q 587 -123 675 -123 q 371 -89 466 -123 q 209 12 275 -54 q 109 173 143 78 q 74 390 74 269 q 114 628 74 517 q 228 819 154 738 q 408 945 302 899 q 644 991 513 991 q 839 957 750 991 q 992 859 928 923 q 1093 703 1057 795 q 1129 496 1129 611 m 449 408 q 483 278 449 318 q 575 237 517 237 q 639 253 612 237 q 682 296 665 268 q 708 363 699 324 q 720 449 717 402 l 729 621 q 684 630 710 626 q 629 635 658 635 q 545 615 579 635 q 489 564 511 595 q 458 491 468 532 q 449 408 449 450 z "
    },
    A: {
      ha: 844,
      x_min: 0,
      x_max: 844,
      o: "m 715 0 l 607 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 567 419 l 467 707 q 457 736 463 719 q 445 774 451 754 q 433 817 439 795 q 421 860 427 839 q 410 817 416 839 q 398 773 404 794 q 386 735 392 753 q 376 707 380 718 l 278 419 l 567 419 z "
    },
    B: {
      ha: 863,
      x_min: 135,
      x_max: 786,
      o: "m 135 991 l 406 991 q 558 978 492 991 q 669 936 625 965 q 736 858 713 906 q 758 741 758 810 q 745 662 758 699 q 707 597 732 625 q 645 551 682 570 q 561 526 608 532 l 561 519 q 649 496 608 511 q 720 454 690 481 q 768 387 751 427 q 786 288 786 346 q 764 166 786 220 q 700 76 742 113 q 599 20 659 39 q 464 0 539 0 l 135 0 l 135 991 m 261 571 l 427 571 q 522 581 484 571 q 585 611 561 591 q 619 662 608 631 q 629 732 629 692 q 577 848 629 813 q 412 884 525 884 l 261 884 l 261 571 m 261 465 l 261 107 l 441 107 q 542 121 501 107 q 607 159 582 134 q 642 217 631 183 q 653 293 653 252 q 642 363 653 331 q 605 417 631 395 q 538 453 580 440 q 433 465 496 465 l 261 465 z "
    },
    C: {
      ha: 838,
      x_min: 85,
      x_max: 798,
      o: "m 538 895 q 406 867 465 895 q 306 788 347 840 q 241 663 264 736 q 218 496 218 589 q 238 326 218 400 q 298 201 258 252 q 398 123 338 150 q 538 97 458 97 q 652 109 598 97 q 760 136 707 121 l 760 26 q 707 8 733 16 q 651 -4 680 1 q 590 -11 623 -9 q 517 -14 557 -14 q 324 23 406 -14 q 190 127 243 60 q 111 288 136 194 q 85 497 85 382 q 114 703 85 610 q 201 864 144 797 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 842 q 652 879 702 863 q 538 895 602 895 z "
    },
    D: {
      ha: 950,
      x_min: 135,
      x_max: 865,
      o: "m 865 505 q 833 285 865 380 q 739 127 800 191 q 587 32 677 64 q 383 0 497 0 l 135 0 l 135 991 l 411 991 q 599 960 515 991 q 742 868 683 929 q 833 715 801 806 q 865 505 865 625 m 732 501 q 709 672 732 600 q 644 791 687 745 q 539 861 602 838 q 397 884 477 884 l 261 884 l 261 109 l 371 109 q 641 208 550 109 q 732 501 732 307 z "
    },
    E: {
      ha: 733,
      x_min: 135,
      x_max: 650,
      o: "m 650 0 l 135 0 l 135 991 l 650 991 l 650 880 l 261 880 l 261 574 l 624 574 l 624 464 l 261 464 l 261 111 l 650 111 l 650 0 z "
    },
    F: {
      ha: 682,
      x_min: 135,
      x_max: 650,
      o: "m 261 0 l 135 0 l 135 991 l 650 991 l 650 880 l 261 880 l 261 530 l 624 530 l 624 419 l 261 419 l 261 0 z "
    },
    G: {
      ha: 958,
      x_min: 85,
      x_max: 859,
      o: "m 530 524 l 859 524 l 859 37 q 783 16 821 25 q 705 0 745 6 q 621 -10 665 -7 q 526 -14 577 -14 q 338 22 420 -14 q 199 124 256 58 q 114 284 143 190 q 85 497 85 379 q 117 708 85 614 q 211 868 149 802 q 363 970 273 935 q 570 1006 454 1006 q 714 991 645 1006 q 843 947 783 976 l 794 838 q 742 859 770 849 q 684 877 713 869 q 622 890 654 885 q 559 895 591 895 q 413 867 477 895 q 306 788 349 840 q 241 663 263 736 q 218 496 218 589 q 237 334 218 408 q 296 208 256 261 q 401 126 337 155 q 557 97 466 97 q 611 99 587 97 q 657 103 636 100 q 697 110 678 106 q 733 117 715 113 l 733 412 l 530 412 l 530 524 z "
    },
    H: {
      ha: 974,
      x_min: 135,
      x_max: 839,
      o: "m 839 0 l 713 0 l 713 463 l 261 463 l 261 0 l 135 0 l 135 991 l 261 991 l 261 574 l 713 574 l 713 991 l 839 991 l 839 0 z "
    },
    I: {
      ha: 471,
      x_min: 56,
      x_max: 415,
      o: "m 415 0 l 56 0 l 56 69 l 172 97 l 172 895 l 56 922 l 56 991 l 415 991 l 415 922 l 298 895 l 298 97 l 415 69 l 415 0 z "
    },
    J: {
      ha: 376,
      x_min: -125,
      x_max: 252,
      o: "m -20 -264 q -80 -259 -54 -264 q -125 -248 -106 -255 l -125 -139 q -75 -149 -102 -145 q -18 -153 -49 -153 q 32 -146 7 -153 q 78 -123 58 -140 q 112 -76 99 -106 q 125 0 125 -46 l 125 991 l 252 991 l 252 14 q 232 -110 252 -58 q 176 -196 212 -162 q 91 -247 140 -231 q -20 -264 41 -264 z "
    },
    K: {
      ha: 804,
      x_min: 135,
      x_max: 804,
      o: "m 804 0 l 661 0 l 355 473 l 261 396 l 261 0 l 135 0 l 135 991 l 261 991 l 261 496 l 343 610 l 650 991 l 791 991 l 439 559 l 804 0 z "
    },
    L: {
      ha: 682,
      x_min: 135,
      x_max: 650,
      o: "m 135 0 l 135 991 l 261 991 l 261 113 l 650 113 l 650 0 l 135 0 z "
    },
    M: {
      ha: 1208,
      x_min: 135,
      x_max: 1074,
      o: "m 545 0 l 244 868 l 239 868 q 245 768 243 818 q 250 679 248 726 q 252 593 252 631 l 252 0 l 135 0 l 135 991 l 322 991 l 602 183 l 606 183 l 886 991 l 1074 991 l 1074 0 l 947 0 l 947 602 q 949 682 947 637 q 952 769 950 728 q 957 867 955 817 l 951 867 l 648 0 l 545 0 z "
    },
    N: {
      ha: 1013,
      x_min: 135,
      x_max: 878,
      o: "m 878 0 l 732 0 l 244 821 l 239 821 q 245 717 243 768 q 250 625 248 673 q 252 538 252 576 l 252 0 l 135 0 l 135 991 l 279 991 l 765 175 l 770 175 q 765 277 768 227 q 763 321 764 298 q 761 367 762 344 q 760 410 760 389 q 760 449 760 431 l 760 991 l 878 991 l 878 0 z "
    },
    O: {
      ha: 1031,
      x_min: 85,
      x_max: 945,
      o: "m 945 497 q 917 288 945 382 q 836 127 890 194 q 701 23 781 60 q 515 -14 621 -14 q 324 23 405 -14 q 190 127 243 60 q 111 289 136 194 q 85 498 85 383 q 111 708 85 614 q 190 868 136 802 q 325 971 243 935 q 517 1007 406 1007 q 702 971 622 1007 q 836 868 781 935 q 917 707 890 801 q 945 497 945 613 m 218 497 q 236 330 218 404 q 290 204 254 256 q 382 124 326 152 q 515 97 438 97 q 649 124 593 97 q 741 204 705 152 q 794 330 777 256 q 811 497 811 404 q 794 665 811 591 q 741 790 777 739 q 650 868 705 841 q 517 896 594 896 q 383 868 439 896 q 290 790 327 841 q 236 665 254 739 q 218 497 218 591 z "
    },
    P: {
      ha: 800,
      x_min: 135,
      x_max: 729,
      o: "m 729 701 q 710 583 729 640 q 649 482 692 526 q 536 412 606 438 q 363 386 466 386 l 261 386 l 261 0 l 135 0 l 135 991 l 380 991 q 537 972 471 991 q 646 916 603 953 q 709 825 688 879 q 729 701 729 770 m 261 493 l 349 493 q 459 504 412 493 q 537 539 506 515 q 583 601 568 563 q 599 694 599 640 q 543 837 599 791 q 370 884 488 884 l 261 884 l 261 493 z "
    },
    Q: {
      ha: 1029,
      x_min: 85,
      x_max: 945,
      o: "m 945 497 q 928 332 945 408 q 879 194 911 255 q 799 87 847 132 q 688 17 751 43 q 763 -95 717 -47 q 871 -184 810 -144 l 789 -281 q 660 -164 719 -231 q 567 -11 602 -97 q 542 -13 555 -12 q 515 -14 528 -14 q 324 23 405 -14 q 190 127 243 60 q 111 289 136 194 q 85 498 85 383 q 111 708 85 614 q 190 868 136 802 q 325 971 243 935 q 517 1007 406 1007 q 702 971 622 1007 q 836 868 781 935 q 917 707 890 801 q 945 497 945 613 m 218 497 q 236 330 218 404 q 290 204 254 256 q 382 124 326 152 q 515 97 438 97 q 649 124 593 97 q 741 204 705 152 q 794 330 777 256 q 811 497 811 404 q 794 665 811 591 q 741 790 777 739 q 650 868 705 841 q 517 896 594 896 q 383 868 439 896 q 290 790 327 841 q 236 665 254 739 q 218 497 218 591 z "
    },
    R: {
      ha: 819,
      x_min: 135,
      x_max: 803,
      o: "m 261 410 l 261 0 l 135 0 l 135 991 l 376 991 q 643 922 557 991 q 729 710 729 852 q 712 607 729 651 q 668 531 696 563 q 606 479 641 500 q 533 444 570 458 l 803 0 l 654 0 l 416 410 l 261 410 m 261 517 l 372 517 q 476 529 433 517 q 546 564 519 541 q 586 622 574 587 q 599 704 599 657 q 585 787 599 753 q 543 842 571 821 q 472 874 515 864 q 370 884 429 884 l 261 884 l 261 517 z "
    },
    S: {
      ha: 721,
      x_min: 71,
      x_max: 657,
      o: "m 657 265 q 634 148 657 199 q 567 60 610 96 q 461 5 524 24 q 321 -14 399 -14 q 180 -2 245 -14 q 71 33 115 10 l 71 154 q 123 133 94 143 q 185 114 153 122 q 252 101 218 106 q 321 96 287 96 q 481 136 429 96 q 533 253 533 177 q 523 317 533 290 q 489 367 513 344 q 422 411 464 389 q 318 457 381 432 q 213 509 258 481 q 140 572 169 537 q 97 652 111 608 q 83 754 83 697 q 105 861 83 814 q 166 940 127 907 q 260 989 205 972 q 380 1006 315 1006 q 526 990 461 1006 q 640 951 590 975 l 595 846 q 495 880 551 865 q 379 895 439 895 q 251 856 296 895 q 205 753 205 818 q 216 686 205 714 q 250 635 226 658 q 312 592 273 612 q 408 550 351 572 q 516 500 470 526 q 594 441 563 474 q 641 366 625 409 q 657 265 657 323 z "
    },
    T: {
      ha: 721,
      x_min: 14,
      x_max: 707,
      o: "m 424 0 l 297 0 l 297 880 l 14 880 l 14 991 l 707 991 l 707 880 l 424 880 l 424 0 z "
    },
    U: {
      ha: 970,
      x_min: 125,
      x_max: 844,
      o: "m 844 993 l 844 350 q 822 206 844 273 q 754 91 800 140 q 641 14 709 42 q 481 -14 573 -14 q 328 13 394 -14 q 216 87 261 39 q 148 202 171 135 q 125 353 125 270 l 125 991 l 252 991 l 252 346 q 310 162 252 227 q 488 97 369 97 q 591 115 548 97 q 663 167 635 134 q 704 246 690 200 q 718 347 718 292 l 718 993 l 844 993 z "
    },
    V: {
      ha: 789,
      x_min: 0,
      x_max: 789,
      o: "m 654 991 l 789 991 l 457 0 l 330 0 l 0 991 l 134 991 l 334 363 q 368 244 353 301 q 393 136 382 186 q 419 244 404 186 q 456 367 435 301 l 654 991 z "
    },
    W: {
      ha: 1227,
      x_min: 14,
      x_max: 1214,
      o: "m 549 991 l 682 991 l 838 411 q 858 335 848 373 q 876 261 867 297 q 891 194 884 226 q 901 136 897 162 q 908 193 904 162 q 918 257 912 223 q 929 325 923 290 q 943 393 936 360 l 1079 991 l 1214 991 l 965 0 l 838 0 l 665 636 q 647 707 656 671 q 631 776 638 744 q 615 848 623 813 q 600 777 608 814 q 585 707 593 745 q 567 632 576 669 l 403 0 l 275 0 l 14 991 l 147 991 l 298 389 q 313 324 307 357 q 326 257 320 290 q 336 193 332 224 q 345 136 341 162 q 353 195 348 161 q 365 264 358 228 q 379 339 372 301 q 396 410 387 376 l 549 991 z "
    },
    X: {
      ha: 760,
      x_min: 0,
      x_max: 760,
      o: "m 760 0 l 616 0 l 376 431 l 127 0 l 0 0 l 307 518 l 21 991 l 155 991 l 380 612 l 607 991 l 736 991 l 450 522 l 760 0 z "
    },
    Y: {
      ha: 732,
      x_min: 0,
      x_max: 732,
      o: "m 366 490 l 596 991 l 732 991 l 429 386 l 429 0 l 302 0 l 302 379 l 0 991 l 138 991 l 366 490 z "
    },
    Z: {
      ha: 749,
      x_min: 56,
      x_max: 693,
      o: "m 693 0 l 56 0 l 56 98 l 538 879 l 69 879 l 69 991 l 679 991 l 679 893 l 197 113 l 693 113 l 693 0 z "
    },
    "[": {
      ha: 421,
      x_min: 111,
      x_max: 386,
      o: "m 386 -220 l 111 -220 l 111 991 l 386 991 l 386 890 l 235 890 l 235 -118 l 386 -118 l 386 -220 z "
    },
    "\\": {
      ha: 518,
      x_min: 16,
      x_max: 505,
      o: "m 136 991 l 505 0 l 385 0 l 16 991 l 136 991 z "
    },
    "]": {
      ha: 421,
      x_min: 35,
      x_max: 310,
      o: "m 35 -118 l 186 -118 l 186 890 l 35 890 l 35 991 l 310 991 l 310 -220 l 35 -220 l 35 -118 z "
    },
    "^": {
      ha: 739,
      x_min: 28,
      x_max: 711,
      o: "m 28 372 l 339 999 l 408 999 l 711 372 l 602 372 l 374 871 l 137 372 l 28 372 z "
    },
    _: {
      ha: 571,
      x_min: -3,
      x_max: 574,
      o: "m 574 -220 l -3 -220 l -3 -125 l 574 -125 l 574 -220 z "
    },
    "`": {
      ha: 802,
      x_min: 267,
      x_max: 533,
      o: "m 533 842 l 452 842 q 400 889 428 861 q 346 947 372 917 q 299 1004 320 977 q 267 1050 277 1031 l 267 1064 l 415 1064 q 440 1014 426 1041 q 471 959 455 986 q 503 905 486 931 q 533 860 519 880 l 533 842 z "
    },
    a: {
      ha: 737,
      x_min: 64,
      x_max: 627,
      o: "m 538 0 l 513 103 l 507 103 q 463 51 485 73 q 414 14 440 28 q 355 -7 387 0 q 279 -14 322 -14 q 193 0 233 -14 q 125 40 154 13 q 80 110 96 68 q 64 208 64 151 q 142 379 64 319 q 380 444 220 439 l 505 449 l 505 496 q 495 572 505 541 q 467 621 486 602 q 421 648 448 640 q 358 656 393 656 q 253 640 302 656 q 160 600 205 623 l 117 693 q 229 739 167 720 q 358 758 290 758 q 478 744 427 758 q 561 700 528 730 q 610 623 594 670 q 627 510 627 576 l 627 0 l 538 0 m 311 86 q 388 99 353 86 q 449 138 423 112 q 489 204 475 164 q 504 297 504 243 l 504 364 l 407 359 q 304 346 346 357 q 238 316 263 335 q 203 269 214 296 q 192 207 192 241 q 225 115 192 144 q 311 86 258 86 z "
    },
    b: {
      ha: 814,
      x_min: 118,
      x_max: 737,
      o: "m 454 758 q 570 734 518 758 q 660 661 623 709 q 717 541 696 612 q 737 374 737 469 q 717 206 737 278 q 660 85 696 134 q 570 11 623 36 q 454 -14 518 -14 q 382 -5 414 -14 q 323 19 349 4 q 277 53 297 33 q 241 94 257 73 l 233 94 l 208 0 l 118 0 l 118 1055 l 241 1055 l 241 800 q 241 750 241 777 q 239 700 240 723 q 236 647 237 673 l 241 647 q 277 691 257 671 q 322 726 296 711 q 381 750 349 741 q 454 758 414 758 m 431 656 q 340 638 376 656 q 282 586 304 621 q 251 498 260 551 q 241 374 241 445 q 251 252 241 305 q 282 162 260 199 q 340 107 304 126 q 432 89 377 89 q 567 163 524 89 q 610 375 610 237 q 567 586 610 516 q 431 656 524 656 z "
    },
    c: {
      ha: 643,
      x_min: 77,
      x_max: 596,
      o: "m 403 -14 q 275 8 334 -14 q 171 76 215 29 q 102 194 127 122 q 77 368 77 267 q 102 549 77 475 q 173 670 128 623 q 279 737 218 716 q 408 758 339 758 q 512 747 461 758 q 596 718 562 735 l 559 614 q 525 627 544 621 q 486 638 506 633 q 446 647 465 644 q 408 650 426 650 q 253 582 302 650 q 204 370 204 513 q 253 160 204 227 q 403 94 302 94 q 502 107 458 94 q 583 136 547 119 l 583 26 q 505 -3 547 7 q 403 -14 463 -14 z "
    },
    d: {
      ha: 814,
      x_min: 77,
      x_max: 696,
      o: "m 578 100 l 572 100 q 537 56 557 77 q 491 20 517 35 q 433 -5 465 4 q 359 -14 400 -14 q 244 11 296 -14 q 155 84 192 35 q 97 204 117 132 q 77 371 77 276 q 97 539 77 467 q 155 660 117 611 q 244 733 192 709 q 359 758 296 758 q 432 749 399 758 q 491 726 465 741 q 537 691 517 711 q 572 650 557 671 l 581 650 q 576 694 578 673 q 574 730 575 711 q 572 760 572 749 l 572 1055 l 696 1055 l 696 0 l 596 0 l 578 100 m 383 89 q 470 104 435 89 q 528 152 506 120 q 561 232 550 184 q 572 343 571 279 l 572 371 q 563 493 572 439 q 532 582 554 546 q 473 637 510 618 q 382 656 437 656 q 247 582 290 656 q 204 370 204 508 q 247 158 204 228 q 383 89 290 89 z "
    },
    e: {
      ha: 743,
      x_min: 77,
      x_max: 673,
      o: "m 412 -14 q 276 12 338 -14 q 170 85 214 37 q 101 204 125 133 q 77 367 77 275 q 99 532 77 459 q 162 655 121 604 q 259 732 203 705 q 385 758 316 758 q 505 734 452 758 q 596 666 559 710 q 653 561 633 623 q 673 425 673 500 l 673 349 l 204 349 q 259 156 208 218 q 414 94 311 94 q 478 98 448 94 q 535 107 507 101 q 588 124 562 114 q 640 146 614 134 l 640 36 q 587 14 613 23 q 533 -2 561 4 q 476 -11 506 -8 q 412 -14 447 -14 m 382 656 q 259 603 304 656 q 207 449 214 550 l 541 449 q 531 533 541 495 q 503 599 522 572 q 454 641 484 626 q 382 656 424 656 z "
    },
    f: {
      ha: 457,
      x_min: 20,
      x_max: 510,
      o: "m 441 652 l 275 652 l 275 0 l 151 0 l 151 652 l 20 652 l 20 703 l 151 749 l 151 814 q 166 934 151 886 q 211 1010 182 982 q 281 1051 239 1039 q 376 1063 323 1063 q 450 1055 416 1063 q 510 1038 484 1047 l 478 942 q 432 955 457 949 q 380 961 408 961 q 334 955 353 961 q 301 932 314 948 q 282 887 288 916 q 275 815 275 859 l 275 745 l 441 745 l 441 652 z "
    },
    g: {
      ha: 720,
      x_min: 25,
      x_max: 692,
      o: "m 692 745 l 692 668 l 558 650 q 590 589 577 626 q 603 505 603 552 q 587 410 603 454 q 539 334 571 366 q 459 284 507 302 q 349 267 412 267 q 319 267 334 267 q 294 269 304 267 q 272 254 283 262 q 251 235 260 245 q 236 210 242 224 q 231 180 231 197 q 239 151 231 162 q 261 134 247 140 q 294 125 275 127 q 334 123 313 123 l 453 123 q 559 107 516 123 q 630 64 603 92 q 670 0 658 37 q 682 -78 682 -37 q 660 -185 682 -138 q 593 -266 638 -233 q 478 -316 547 -298 q 314 -334 408 -334 q 187 -319 241 -334 q 97 -278 133 -305 q 43 -213 61 -251 q 25 -126 25 -174 q 38 -55 25 -85 q 74 -1 52 -24 q 126 35 96 21 q 187 57 155 50 q 140 98 159 70 q 122 161 122 125 q 144 233 122 203 q 212 292 165 263 q 159 325 183 304 q 118 374 135 347 q 93 434 102 401 q 83 501 83 467 q 100 609 83 562 q 151 690 117 656 q 233 741 184 723 q 349 758 283 758 q 400 754 374 758 q 446 745 427 751 l 692 745 m 142 -122 q 151 -169 142 -147 q 179 -206 159 -191 q 232 -231 199 -222 q 314 -240 265 -240 q 503 -201 440 -240 q 566 -89 566 -162 q 557 -38 566 -58 q 531 -7 549 -18 q 481 8 512 4 q 407 12 451 12 l 288 12 q 238 7 264 12 q 191 -14 212 1 q 156 -55 170 -28 q 142 -122 142 -81 m 204 505 q 241 389 204 427 q 345 351 277 351 q 447 389 412 351 q 482 507 482 427 q 447 630 482 591 q 343 669 411 669 q 240 629 276 669 q 204 505 204 588 z "
    },
    h: {
      ha: 818,
      x_min: 118,
      x_max: 707,
      o: "m 583 0 l 583 479 q 548 612 583 568 q 436 656 512 656 q 344 638 381 656 q 284 586 307 621 q 251 501 261 551 q 241 386 241 451 l 241 0 l 118 0 l 118 1055 l 241 1055 l 241 742 l 236 644 l 243 644 q 283 695 260 673 q 334 730 307 716 q 393 751 362 745 q 457 758 425 758 q 644 693 581 758 q 707 486 707 629 l 707 0 l 583 0 z "
    },
    i: {
      ha: 359,
      x_min: 109,
      x_max: 253,
      o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 109 946 q 129 1005 109 987 q 180 1023 150 1023 q 209 1019 195 1023 q 232 1005 222 1015 q 247 981 241 996 q 253 946 253 966 q 232 887 253 907 q 180 868 210 868 q 129 887 150 868 q 109 946 109 906 z "
    },
    j: {
      ha: 359,
      x_min: -46,
      x_max: 253,
      o: "m 45 -334 q -9 -329 12 -334 q -46 -317 -31 -324 l -46 -216 q -10 -227 -28 -223 q 32 -231 8 -231 q 66 -225 50 -231 q 93 -207 81 -220 q 112 -172 105 -194 q 118 -115 118 -150 l 118 745 l 241 745 l 241 -107 q 230 -201 241 -159 q 194 -272 218 -243 q 133 -318 170 -302 q 45 -334 96 -334 m 109 946 q 129 1005 109 987 q 180 1023 150 1023 q 209 1019 195 1023 q 232 1005 222 1015 q 247 981 241 996 q 253 946 253 966 q 232 887 253 907 q 180 868 210 868 q 129 887 150 868 q 109 946 109 906 z "
    },
    k: {
      ha: 689,
      x_min: 118,
      x_max: 684,
      o: "m 232 385 l 323 500 l 522 745 l 665 745 l 393 422 l 684 0 l 542 0 l 314 342 l 240 286 l 240 0 l 118 0 l 118 1055 l 240 1055 l 240 571 l 229 385 l 232 385 z "
    },
    l: {
      ha: 359,
      x_min: 118,
      x_max: 241,
      o: "m 241 0 l 118 0 l 118 1055 l 241 1055 l 241 0 z "
    },
    m: {
      ha: 1244,
      x_min: 118,
      x_max: 1133,
      o: "m 1010 0 l 1010 479 q 976 612 1010 568 q 871 656 942 656 q 787 640 821 656 q 730 593 752 624 q 698 516 708 562 q 688 411 688 471 l 688 0 l 564 0 l 564 479 q 530 612 564 568 q 425 656 496 656 q 338 638 373 656 q 281 586 302 621 q 251 501 260 551 q 241 386 241 451 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 243 644 q 281 695 259 673 q 331 730 304 716 q 388 751 357 745 q 449 758 418 758 q 584 728 530 758 q 664 635 638 699 l 669 635 q 712 690 687 667 q 766 728 736 713 q 828 751 795 743 q 895 758 861 758 q 1073 693 1013 758 q 1133 486 1133 629 l 1133 0 l 1010 0 z "
    },
    n: {
      ha: 818,
      x_min: 118,
      x_max: 707,
      o: "m 583 0 l 583 479 q 548 612 583 568 q 436 656 512 656 q 344 638 381 656 q 284 586 307 621 q 251 501 261 551 q 241 386 241 451 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 243 644 q 283 695 260 673 q 334 730 307 716 q 393 751 362 745 q 457 758 425 758 q 644 693 581 758 q 707 486 707 629 l 707 0 l 583 0 z "
    },
    o: {
      ha: 802,
      x_min: 77,
      x_max: 725,
      o: "m 725 374 q 702 209 725 281 q 637 87 680 136 q 534 12 595 38 q 399 -14 474 -14 q 270 12 329 -14 q 168 87 211 38 q 101 209 125 136 q 77 374 77 281 q 99 537 77 466 q 164 658 122 609 q 267 733 206 707 q 403 758 328 758 q 532 733 473 758 q 634 658 591 707 q 701 537 677 609 q 725 374 725 466 m 204 374 q 251 160 204 232 q 401 89 297 89 q 552 160 506 89 q 597 374 597 232 q 551 586 597 515 q 400 656 505 656 q 250 586 296 656 q 204 374 204 515 z "
    },
    p: {
      ha: 814,
      x_min: 118,
      x_max: 737,
      o: "m 454 -14 q 382 -5 414 -14 q 323 19 349 4 q 277 53 297 33 q 241 94 257 73 l 233 94 q 237 50 235 71 q 240 14 239 33 q 241 -16 241 -5 l 241 -334 l 118 -334 l 118 745 l 218 745 l 236 644 l 241 644 q 277 689 257 668 q 322 725 296 709 q 381 749 349 740 q 454 758 414 758 q 570 734 518 758 q 660 661 623 709 q 717 541 696 612 q 737 374 737 469 q 717 206 737 278 q 660 85 696 134 q 570 11 623 36 q 454 -14 518 -14 m 431 656 q 343 640 379 656 q 286 593 308 625 q 253 513 264 561 q 241 401 243 466 l 241 374 q 251 252 241 305 q 282 162 260 199 q 340 107 304 126 q 432 89 377 89 q 567 163 524 89 q 610 375 610 237 q 567 586 610 516 q 431 656 524 656 z "
    },
    q: {
      ha: 814,
      x_min: 77,
      x_max: 696,
      o: "m 383 89 q 470 104 435 89 q 528 152 506 120 q 561 232 550 184 q 572 343 571 279 l 572 371 q 563 493 572 439 q 532 582 554 546 q 473 637 510 618 q 382 656 437 656 q 247 582 290 656 q 204 370 204 508 q 247 158 204 228 q 383 89 290 89 m 359 -14 q 244 11 296 -14 q 155 84 192 35 q 97 204 117 132 q 77 371 77 276 q 97 539 77 467 q 155 660 117 611 q 244 733 192 709 q 359 758 296 758 q 432 749 399 758 q 490 725 465 740 q 536 689 516 709 q 572 644 557 668 l 578 644 l 596 745 l 696 745 l 696 -334 l 572 -334 l 572 -16 q 574 17 572 -3 q 576 55 575 37 q 581 100 578 77 l 572 100 q 537 56 557 77 q 491 20 517 35 q 433 -5 465 4 q 359 -14 400 -14 z "
    },
    r: {
      ha: 554,
      x_min: 118,
      x_max: 526,
      o: "m 440 758 q 484 756 460 758 q 526 751 509 755 l 510 637 q 471 643 491 641 q 433 646 451 646 q 355 628 391 646 q 295 579 320 611 q 255 502 269 547 q 241 401 241 456 l 241 0 l 118 0 l 118 745 l 218 745 l 233 608 l 239 608 q 275 665 256 637 q 318 712 294 692 q 372 746 342 733 q 440 758 402 758 z "
    },
    s: {
      ha: 627,
      x_min: 61,
      x_max: 564,
      o: "m 564 204 q 544 109 564 150 q 487 41 524 68 q 398 0 450 14 q 281 -14 346 -14 q 154 -2 207 -14 q 61 33 101 10 l 61 146 q 108 124 82 135 q 162 106 134 114 q 221 93 191 98 q 281 87 251 87 q 356 95 325 87 q 406 116 387 102 q 434 150 425 130 q 443 195 443 170 q 436 233 443 216 q 411 266 429 250 q 362 300 393 283 q 282 338 331 317 q 194 379 233 359 q 128 425 155 399 q 86 483 101 450 q 72 561 72 515 q 91 645 72 608 q 143 707 109 682 q 224 745 177 732 q 330 758 272 758 q 451 744 396 758 q 554 707 505 730 l 511 607 q 421 641 467 627 q 326 656 374 656 q 224 633 257 656 q 191 568 191 610 q 198 527 191 545 q 225 494 206 509 q 276 462 244 478 q 355 427 308 446 q 443 386 404 406 q 508 340 481 366 q 549 282 535 315 q 564 204 564 250 z "
    },
    t: {
      ha: 471,
      x_min: 22,
      x_max: 444,
      o: "m 343 87 q 371 89 355 87 q 400 92 386 90 q 426 97 414 94 q 444 102 438 100 l 444 8 q 422 0 435 4 q 392 -7 408 -4 q 358 -12 376 -10 q 323 -14 340 -14 q 245 -3 281 -14 q 183 35 210 8 q 142 106 157 61 q 127 220 127 151 l 127 652 l 22 652 l 22 707 l 127 760 l 180 916 l 252 916 l 252 745 l 439 745 l 439 652 l 252 652 l 252 220 q 273 121 252 154 q 343 87 294 87 z "
    },
    u: {
      ha: 818,
      x_min: 111,
      x_max: 700,
      o: "m 600 0 l 582 100 l 575 100 q 535 49 558 71 q 484 14 511 28 q 425 -7 456 0 q 361 -14 393 -14 q 252 2 299 -14 q 174 51 205 18 q 127 136 143 84 q 111 258 111 187 l 111 745 l 235 745 l 235 265 q 271 133 235 177 q 382 89 307 89 q 474 106 437 89 q 534 158 511 124 q 567 243 557 193 q 576 358 576 293 l 576 745 l 700 745 l 700 0 l 600 0 z "
    },
    v: {
      ha: 665,
      x_min: 0,
      x_max: 665,
      o: "m 254 0 l 0 745 l 127 745 l 262 330 q 280 273 270 308 q 300 201 290 237 q 319 132 311 164 q 330 82 328 99 l 335 82 q 347 132 338 99 q 365 201 355 164 q 385 273 375 237 q 403 330 395 308 l 538 745 l 665 745 l 411 0 l 254 0 z "
    },
    w: {
      ha: 1036,
      x_min: 14,
      x_max: 1022,
      o: "m 684 0 l 570 418 q 563 445 567 430 q 555 477 559 460 q 546 512 551 494 q 538 547 542 530 q 518 628 528 586 l 514 628 q 496 546 505 585 q 480 476 488 512 q 464 415 471 440 l 347 0 l 204 0 l 14 745 l 143 745 l 232 349 q 245 282 239 318 q 258 212 252 247 q 269 146 264 177 q 277 96 274 115 l 281 96 q 290 143 284 113 q 303 205 296 172 q 317 270 310 238 q 332 325 325 302 l 453 745 l 586 745 l 703 325 q 716 271 709 302 q 732 207 724 239 q 745 145 739 175 q 754 96 751 115 l 758 96 q 765 143 760 113 q 775 208 769 172 q 788 280 781 243 q 803 349 795 317 l 896 745 l 1022 745 l 829 0 l 684 0 z "
    },
    x: {
      ha: 694,
      x_min: 24,
      x_max: 669,
      o: "m 277 382 l 37 745 l 178 745 l 347 467 l 517 745 l 657 745 l 416 382 l 669 0 l 529 0 l 347 296 l 164 0 l 24 0 l 277 382 z "
    },
    y: {
      ha: 679,
      x_min: 7,
      x_max: 672,
      o: "m 7 745 l 135 745 l 281 329 q 300 272 290 302 q 318 212 310 242 q 333 155 327 182 q 342 103 339 127 l 346 103 q 357 149 349 120 q 373 211 364 178 q 392 276 382 244 q 410 330 402 308 l 545 745 l 672 745 l 378 -97 q 337 -196 359 -152 q 286 -270 315 -239 q 217 -317 256 -300 q 123 -334 178 -334 q 62 -330 88 -334 q 18 -322 37 -326 l 18 -224 q 54 -230 33 -227 q 100 -232 76 -232 q 156 -224 132 -232 q 197 -201 180 -216 q 228 -165 215 -186 q 250 -115 240 -143 l 289 -7 l 7 745 z "
    },
    z: {
      ha: 612,
      x_min: 56,
      x_max: 557,
      o: "m 557 0 l 56 0 l 56 85 l 419 652 l 78 652 l 78 745 l 545 745 l 545 646 l 189 93 l 557 93 l 557 0 z "
    },
    "{": {
      ha: 492,
      x_min: 41,
      x_max: 457,
      o: "m 339 -11 q 347 -64 339 -43 q 371 -97 355 -85 q 408 -113 386 -109 q 457 -118 430 -117 l 457 -220 q 360 -208 405 -219 q 284 -173 316 -197 q 233 -111 252 -149 q 215 -21 215 -74 l 215 205 q 171 304 215 275 q 41 334 126 334 l 41 439 q 171 468 126 439 q 215 567 215 497 l 215 793 q 233 883 215 846 q 284 944 252 920 q 360 980 316 968 q 457 991 405 991 l 457 890 q 408 885 430 890 q 371 869 386 881 q 347 837 355 857 q 339 783 339 816 l 339 558 q 299 445 339 487 q 180 390 258 404 l 180 382 q 299 327 258 368 q 339 214 339 286 l 339 -11 z "
    },
    "|": {
      ha: 765,
      x_min: 332,
      x_max: 433,
      o: "m 332 1055 l 433 1055 l 433 -334 l 332 -334 l 332 1055 z "
    },
    "}": {
      ha: 492,
      x_min: 35,
      x_max: 450,
      o: "m 153 214 q 193 327 153 286 q 311 382 233 368 l 311 390 q 193 445 233 404 q 153 558 153 487 l 153 783 q 144 837 153 816 q 121 869 136 857 q 84 885 106 881 q 35 890 62 890 l 35 991 q 131 980 87 991 q 208 944 176 968 q 258 883 240 920 q 277 793 277 846 l 277 567 q 288 507 277 532 q 321 468 299 483 q 376 446 343 452 q 450 439 408 439 l 450 334 q 321 304 366 334 q 277 205 277 275 l 277 -21 q 258 -111 277 -74 q 208 -173 240 -149 q 131 -208 176 -197 q 35 -220 87 -219 l 35 -118 q 84 -113 62 -117 q 121 -97 106 -109 q 144 -64 136 -85 q 153 -11 153 -43 l 153 214 z "
    },
    "~": {
      ha: 765,
      x_min: 69,
      x_max: 696,
      o: "m 359 441 q 316 460 334 452 q 282 472 297 467 q 253 478 267 476 q 224 479 239 479 q 184 473 205 479 q 144 455 164 467 q 105 429 124 444 q 69 397 86 414 l 69 507 q 237 581 137 581 q 274 579 257 581 q 310 573 291 577 q 351 560 328 568 q 406 538 374 551 q 449 519 431 527 q 484 508 468 512 q 513 502 500 503 q 542 500 527 500 q 581 506 561 500 q 622 524 602 513 q 661 550 642 535 q 696 582 680 565 l 696 472 q 528 399 629 399 q 491 400 508 399 q 455 407 474 402 q 414 419 437 411 q 359 441 391 428 z "
    },
    " ": {
      ha: 361,
      x_min: 0,
      x_max: 0,
      o: ""
    },
    "¡": {
      ha: 374,
      x_min: 100,
      x_max: 272,
      o: "m 144 458 l 227 458 l 261 -253 l 110 -253 l 144 458 m 272 664 q 266 620 272 638 q 247 591 259 602 q 220 575 235 580 q 186 570 204 570 q 153 575 168 570 q 125 591 137 580 q 106 620 113 602 q 100 664 100 638 q 106 707 100 689 q 125 736 113 724 q 153 753 137 747 q 186 758 168 758 q 220 753 204 758 q 247 736 235 747 q 266 707 259 724 q 272 664 272 689 z "
    },
    "¢": {
      ha: 765,
      x_min: 127,
      x_max: 647,
      o: "m 635 163 q 564 134 601 144 q 475 122 526 123 l 475 -14 l 382 -14 l 382 126 q 276 160 323 135 q 196 231 229 186 q 145 343 163 276 q 127 504 127 411 q 145 668 127 600 q 196 783 163 737 q 276 855 229 829 q 382 889 323 880 l 382 1006 l 475 1006 l 475 895 q 570 881 524 892 q 647 854 616 870 l 611 750 q 576 763 595 757 q 537 775 557 770 q 497 783 517 780 q 460 786 477 786 q 304 718 353 786 q 256 505 256 649 q 305 297 256 363 q 454 231 354 231 q 554 243 509 231 q 635 272 598 256 l 635 163 z "
    },
    "£": {
      ha: 765,
      x_min: 46,
      x_max: 718,
      o: "m 452 1004 q 583 989 524 1004 q 686 950 642 974 l 642 852 q 556 887 604 872 q 457 901 508 901 q 397 892 425 901 q 349 863 369 883 q 317 811 328 843 q 306 734 306 779 l 306 534 l 561 534 l 561 441 l 306 441 l 306 298 q 298 226 306 256 q 277 174 290 196 q 247 138 264 153 q 211 113 229 123 l 718 113 l 718 0 l 46 0 l 46 104 q 101 126 76 112 q 143 163 125 140 q 172 219 161 186 q 182 297 182 252 l 182 441 l 47 441 l 47 534 l 182 534 l 182 754 q 202 860 182 813 q 257 938 222 906 q 342 987 293 970 q 452 1004 392 1004 z "
    },
    "¤": {
      ha: 765,
      x_min: 83,
      x_max: 681,
      o: "m 126 490 q 138 567 126 530 q 171 635 150 603 l 83 722 l 150 789 l 236 701 q 304 735 268 723 q 382 747 341 747 q 459 735 422 747 q 526 701 495 723 l 614 789 l 681 724 l 593 636 q 626 568 614 605 q 639 490 639 531 q 627 412 639 450 q 593 345 615 375 l 679 258 l 614 193 l 526 279 q 459 247 495 258 q 382 235 422 235 q 304 247 341 235 q 236 281 267 259 l 150 195 l 85 260 l 171 346 q 138 413 150 376 q 126 490 126 450 m 220 490 q 232 427 220 456 q 267 375 245 397 q 318 340 289 353 q 382 328 348 328 q 447 340 416 328 q 499 375 477 353 q 534 427 522 397 q 547 490 547 456 q 534 555 547 525 q 499 608 522 585 q 447 643 477 630 q 382 656 416 656 q 318 643 348 656 q 267 608 289 630 q 232 555 245 585 q 220 490 220 525 z "
    },
    "¥": {
      ha: 765,
      x_min: 20,
      x_max: 746,
      o: "m 382 490 l 616 991 l 746 991 l 485 471 l 647 471 l 647 378 l 443 378 l 443 271 l 647 271 l 647 178 l 443 178 l 443 0 l 322 0 l 322 178 l 118 178 l 118 271 l 322 271 l 322 378 l 118 378 l 118 471 l 277 471 l 20 991 l 150 991 l 382 490 z "
    },
    "¦": {
      ha: 765,
      x_min: 332,
      x_max: 433,
      o: "m 332 1055 l 433 1055 l 433 526 l 332 526 l 332 1055 m 332 196 l 433 196 l 433 -334 l 332 -334 l 332 196 z "
    },
    "§": {
      ha: 675,
      x_min: 82,
      x_max: 585,
      o: "m 93 549 q 102 611 93 583 q 126 661 111 640 q 161 698 141 683 q 201 724 180 713 q 122 788 151 749 q 93 884 93 827 q 112 958 93 925 q 164 1015 130 991 q 245 1050 198 1038 q 351 1063 293 1063 q 470 1049 417 1063 q 572 1014 524 1036 l 534 920 q 443 952 490 939 q 347 965 395 965 q 245 945 280 965 q 211 886 211 925 q 219 852 211 868 q 247 822 227 837 q 298 791 266 807 q 378 755 330 775 q 465 714 427 736 q 530 666 503 692 q 570 607 556 640 q 585 532 585 574 q 576 468 585 496 q 554 416 568 439 q 523 376 541 393 q 486 349 505 359 q 559 286 533 323 q 585 196 585 249 q 565 110 585 148 q 508 46 545 73 q 419 7 471 20 q 301 -7 366 -7 q 175 4 228 -7 q 82 37 122 16 l 82 144 q 129 124 103 134 q 183 106 155 114 q 242 94 212 98 q 301 89 272 89 q 379 97 348 89 q 430 118 411 105 q 456 149 448 132 q 464 184 464 166 q 458 219 464 204 q 435 250 452 235 q 386 282 418 265 q 302 319 354 298 q 214 361 253 340 q 148 409 175 382 q 107 469 121 435 q 93 549 93 503 m 197 564 q 207 517 197 538 q 238 476 216 496 q 293 438 259 456 q 376 399 328 419 l 400 389 q 428 410 414 397 q 453 437 441 422 q 471 472 464 453 q 478 514 478 491 q 469 562 478 540 q 438 603 460 583 q 380 643 416 623 q 288 682 343 662 q 255 666 271 677 q 226 641 239 656 q 205 606 213 625 q 197 564 197 586 z "
    },
    "¨": {
      ha: 802,
      x_min: 208,
      x_max: 593,
      o: "m 208 946 q 227 999 208 983 q 273 1015 246 1015 q 319 999 300 1015 q 339 946 339 982 q 319 893 339 910 q 273 876 300 876 q 227 893 246 876 q 208 946 208 910 m 463 946 q 481 999 463 983 q 528 1015 500 1015 q 552 1011 541 1015 q 573 999 564 1007 q 587 977 582 990 q 593 946 593 964 q 573 893 593 910 q 528 876 553 876 q 481 893 500 876 q 463 946 463 910 z "
    },
    "©": {
      ha: 1156,
      x_min: 68,
      x_max: 1088,
      o: "m 604 714 q 531 699 563 714 q 477 656 499 684 q 445 587 456 628 q 433 496 433 547 q 443 402 433 443 q 474 334 453 361 q 527 291 494 306 q 604 277 559 277 q 638 279 620 277 q 676 286 656 281 q 714 295 695 290 q 750 307 733 301 l 750 218 q 717 205 734 211 q 683 194 701 199 q 644 187 665 189 q 600 184 624 184 q 479 207 531 184 q 394 271 428 229 q 342 370 359 312 q 325 497 325 427 q 343 622 325 566 q 397 720 361 679 q 485 783 433 760 q 604 806 536 806 q 692 794 647 806 q 777 764 736 783 l 734 677 q 666 705 699 695 q 604 714 633 714 m 68 496 q 86 631 68 566 q 137 753 104 696 q 217 857 170 810 q 320 936 264 903 q 442 987 377 969 q 578 1006 507 1006 q 713 987 648 1006 q 835 936 779 969 q 939 857 892 903 q 1018 753 985 810 q 1069 631 1051 696 q 1088 496 1088 566 q 1069 360 1088 425 q 1018 238 1051 295 q 939 135 985 182 q 835 56 892 89 q 713 4 779 22 q 578 -14 648 -14 q 442 4 507 -14 q 320 56 377 22 q 217 135 264 89 q 137 238 170 182 q 86 360 104 295 q 68 496 68 425 m 142 496 q 176 326 142 406 q 270 188 210 247 q 408 94 329 128 q 578 60 488 60 q 747 94 668 60 q 886 188 827 128 q 980 326 945 247 q 1014 496 1014 406 q 980 665 1014 586 q 886 804 945 745 q 747 898 827 863 q 578 932 668 932 q 408 898 488 932 q 270 804 329 863 q 176 665 210 745 q 142 496 142 586 z "
    },
    "ª": {
      ha: 460,
      x_min: 46,
      x_max: 392,
      o: "m 330 541 l 311 596 q 286 569 299 581 q 257 549 273 557 q 222 536 241 541 q 179 532 203 532 q 125 541 150 532 q 83 567 101 549 q 56 610 66 584 q 46 671 46 636 q 94 777 46 740 q 239 817 142 813 l 306 819 l 306 840 q 285 908 306 889 q 227 928 264 928 q 163 918 194 928 q 104 893 133 908 l 72 961 q 146 991 106 979 q 227 1003 186 1003 q 352 967 311 1003 q 392 848 392 931 l 392 541 l 330 541 m 256 753 q 198 745 221 751 q 161 728 175 739 q 141 704 147 718 q 135 669 135 689 q 152 620 135 635 q 197 604 169 604 q 240 611 220 604 q 274 633 260 618 q 297 670 289 648 q 306 722 306 692 l 306 755 l 256 753 z "
    },
    "«": {
      ha: 676,
      x_min: 56,
      x_max: 621,
      o: "m 56 375 l 265 656 l 345 603 l 183 367 l 345 131 l 265 78 l 56 357 l 56 375 m 332 375 l 542 656 l 621 603 l 460 367 l 621 131 l 542 78 l 332 357 l 332 375 z "
    },
    "¬": {
      ha: 765,
      x_min: 69,
      x_max: 696,
      o: "m 696 541 l 696 178 l 595 178 l 595 439 l 69 439 l 69 541 l 696 541 z "
    },
    "­": {
      ha: 447,
      x_min: 56,
      x_max: 392,
      o: "m 56 315 l 56 429 l 392 429 l 392 315 l 56 315 z "
    },
    "®": {
      ha: 1092,
      x_min: 61,
      x_max: 1023,
      o: "m 61 494 q 124 749 61 631 q 300 933 188 866 q 543 1001 412 1001 q 785 933 673 1001 q 960 749 897 866 q 1023 494 1023 631 q 962 244 1023 361 q 789 57 901 127 q 543 -14 677 -14 q 297 56 409 -14 q 123 243 184 126 q 61 494 61 359 m 139 494 q 193 278 139 378 q 341 123 248 179 q 543 66 434 66 q 745 124 652 66 q 892 279 839 181 q 945 494 945 378 q 892 708 945 610 q 745 863 839 806 q 543 920 652 920 q 340 864 434 920 q 193 709 247 808 q 139 494 139 610 m 443 444 l 443 214 l 347 214 l 347 790 l 534 790 q 695 746 638 790 q 753 616 753 701 q 666 489 753 533 q 749 351 749 455 l 749 309 q 761 225 749 251 l 761 214 l 663 214 q 653 301 653 239 q 651 376 653 364 q 562 444 640 441 l 443 444 m 443 530 l 549 530 q 627 554 597 532 q 657 613 657 576 q 631 683 657 663 q 536 704 604 704 l 443 704 l 443 530 z "
    },
    "¯": {
      ha: 694,
      x_min: -4,
      x_max: 699,
      o: "m 699 1055 l -4 1055 l -4 1150 l 699 1150 l 699 1055 z "
    },
    "°": {
      ha: 595,
      x_min: 83,
      x_max: 511,
      o: "m 83 791 q 100 874 83 836 q 146 943 117 913 q 214 989 175 972 q 297 1006 253 1006 q 380 989 341 1006 q 448 943 419 972 q 494 874 477 913 q 511 791 511 836 q 494 709 511 747 q 448 641 477 670 q 380 596 419 612 q 297 579 341 579 q 214 596 253 579 q 146 641 175 612 q 100 709 117 670 q 83 791 83 747 m 167 791 q 177 742 167 765 q 205 701 187 718 q 246 673 222 683 q 297 663 270 663 q 348 673 324 663 q 390 701 372 683 q 418 742 408 718 q 428 791 428 765 q 418 843 428 819 q 390 885 408 867 q 348 913 372 903 q 297 924 324 924 q 246 913 270 924 q 205 885 222 903 q 177 843 187 867 q 167 791 167 819 z "
    },
    "±": {
      ha: 765,
      x_min: 69,
      x_max: 696,
      o: "m 332 439 l 69 439 l 69 541 l 332 541 l 332 804 l 433 804 l 433 541 l 696 541 l 696 439 l 433 439 l 433 178 l 332 178 l 332 439 m 69 0 l 69 102 l 696 102 l 696 0 l 69 0 z "
    },
    "²": {
      ha: 460,
      x_min: 33,
      x_max: 421,
      o: "m 421 397 l 33 397 l 33 473 l 175 628 q 238 699 214 670 q 276 750 262 728 q 295 793 290 773 q 300 836 300 813 q 277 902 300 880 q 218 924 255 924 q 152 907 184 924 q 90 864 121 890 l 37 928 q 119 982 74 960 q 220 1004 164 1004 q 293 993 260 1004 q 349 961 326 982 q 385 908 372 939 q 397 839 397 878 q 388 776 397 805 q 359 718 378 747 q 314 658 341 689 q 253 590 288 627 l 153 484 l 421 484 l 421 397 z "
    },
    "³": {
      ha: 460,
      x_min: 21,
      x_max: 418,
      o: "m 400 851 q 373 762 400 798 q 298 710 345 726 q 388 659 358 694 q 418 570 418 623 q 404 495 418 529 q 362 437 391 461 q 292 399 334 413 q 191 386 249 386 q 101 394 143 386 q 21 424 60 403 l 21 514 q 109 478 64 491 q 189 465 153 465 q 286 493 256 465 q 315 571 315 522 q 279 644 315 621 q 178 667 243 667 l 111 667 l 111 743 l 178 743 q 269 770 240 743 q 297 840 297 797 q 290 878 297 862 q 272 904 283 894 q 244 919 260 914 q 210 924 228 924 q 137 910 170 924 q 69 871 104 896 l 22 936 q 63 964 42 951 q 106 985 83 977 q 155 999 130 994 q 211 1004 181 1004 q 293 993 258 1004 q 353 961 329 981 q 388 912 376 941 q 400 851 400 884 z "
    },
    "´": {
      ha: 802,
      x_min: 267,
      x_max: 533,
      o: "m 267 860 q 297 905 281 880 q 329 959 313 931 q 359 1014 345 986 q 385 1064 374 1041 l 533 1064 l 533 1050 q 501 1004 522 1031 q 453 947 479 977 q 400 889 427 917 q 349 842 372 861 l 267 842 l 267 860 z "
    },
    "µ": {
      ha: 825,
      x_min: 118,
      x_max: 707,
      o: "m 241 265 q 277 133 241 177 q 389 89 313 89 q 481 106 444 89 q 542 158 519 124 q 574 243 564 193 q 583 358 583 293 l 583 745 l 707 745 l 707 0 l 607 0 l 589 100 l 582 100 q 500 15 549 43 q 382 -14 452 -14 q 297 2 333 -14 q 237 46 261 18 q 239 -7 238 20 q 241 -59 241 -31 q 241 -117 241 -88 l 241 -334 l 118 -334 l 118 745 l 241 745 l 241 265 z "
    },
    "¶": {
      ha: 909,
      x_min: 77,
      x_max: 764,
      o: "m 764 -176 l 682 -176 l 682 947 l 542 947 l 542 -176 l 460 -176 l 460 379 q 361 367 418 367 q 244 384 296 367 q 154 441 191 401 q 97 547 117 481 q 77 707 77 612 q 99 873 77 806 q 161 981 121 940 q 258 1038 201 1021 q 382 1055 314 1055 l 764 1055 l 764 -176 z "
    },
    "·": {
      ha: 372,
      x_min: 100,
      x_max: 272,
      o: "m 100 490 q 106 534 100 516 q 125 563 113 552 q 152 579 136 574 q 186 585 168 585 q 219 579 203 585 q 247 563 235 574 q 265 534 258 552 q 272 490 272 516 q 265 448 272 465 q 247 418 258 430 q 219 401 235 407 q 186 396 203 396 q 152 401 168 396 q 125 418 136 407 q 106 448 113 430 q 100 490 100 465 z "
    },
    "¸": {
      ha: 285,
      x_min: 24,
      x_max: 277,
      o: "m 277 -195 q 229 -297 277 -260 q 79 -334 181 -334 q 49 -332 64 -334 q 24 -328 34 -330 l 24 -254 q 51 -257 34 -256 q 78 -258 67 -258 q 153 -244 126 -258 q 180 -196 180 -229 q 172 -168 180 -180 q 147 -147 163 -156 q 110 -132 132 -138 q 64 -119 89 -125 l 125 0 l 207 0 l 168 -78 q 211 -92 191 -83 q 245 -115 231 -101 q 268 -149 260 -129 q 277 -195 277 -168 z "
    },
    "¹": {
      ha: 460,
      x_min: 43,
      x_max: 300,
      o: "m 208 991 l 300 991 l 300 397 l 201 397 l 201 747 q 202 785 201 764 q 203 825 202 805 q 205 865 204 846 q 207 899 206 884 q 184 873 197 887 q 157 848 172 860 l 93 799 l 43 864 l 208 991 z "
    },
    "º": {
      ha: 486,
      x_min: 45,
      x_max: 441,
      o: "m 441 768 q 428 668 441 712 q 388 594 414 624 q 325 548 361 564 q 241 532 288 532 q 163 548 199 532 q 100 594 127 564 q 59 668 74 624 q 45 768 45 712 q 59 868 45 825 q 98 942 73 912 q 161 987 124 972 q 244 1003 198 1003 q 322 987 286 1003 q 385 942 359 972 q 427 868 412 912 q 441 768 441 825 m 134 768 q 159 647 134 688 q 243 606 184 606 q 326 647 300 606 q 351 768 351 688 q 326 889 351 850 q 243 928 300 928 q 159 889 184 928 q 134 768 134 850 z "
    },
    "»": {
      ha: 676,
      x_min: 57,
      x_max: 623,
      o: "m 623 357 l 412 78 l 334 131 l 494 367 l 334 603 l 412 656 l 623 375 l 623 357 m 346 357 l 136 78 l 57 131 l 218 367 l 57 603 l 136 656 l 346 375 l 346 357 z "
    },
    "¼": {
      ha: 1023,
      x_min: 43,
      x_max: 962,
      o: "m 208 991 l 300 991 l 300 397 l 201 397 l 201 747 q 202 785 201 764 q 203 825 202 805 q 205 865 204 846 q 207 899 206 884 q 184 873 197 887 q 157 848 172 860 l 93 799 l 43 864 l 208 991 m 815 991 l 265 0 l 159 0 l 709 991 l 815 991 m 962 131 l 878 131 l 878 1 l 781 1 l 781 131 l 526 131 l 526 206 l 782 599 l 878 599 l 878 217 l 962 217 l 962 131 m 781 217 l 781 349 q 782 411 781 378 q 785 478 783 445 q 774 458 781 471 q 760 431 768 446 q 745 404 753 417 q 730 380 736 390 l 625 217 l 781 217 z "
    },
    "½": {
      ha: 1023,
      x_min: 30,
      x_max: 977,
      o: "m 195 991 l 287 991 l 287 397 l 189 397 l 189 747 q 189 785 189 764 q 190 825 189 805 q 192 865 191 846 q 194 899 193 884 q 172 873 184 887 q 144 848 159 860 l 80 799 l 30 864 l 195 991 m 801 991 l 251 0 l 144 0 l 694 991 l 801 991 m 977 1 l 589 1 l 589 77 l 730 231 q 793 302 769 273 q 831 354 818 331 q 850 396 845 376 q 855 439 855 416 q 833 505 855 484 q 774 527 810 527 q 708 510 739 527 q 646 467 676 493 l 593 531 q 674 586 629 564 q 775 608 720 608 q 849 596 816 608 q 905 564 882 585 q 940 512 928 543 q 953 442 953 481 q 943 379 953 408 q 915 321 933 350 q 870 261 897 292 q 808 193 843 231 l 708 87 l 977 87 l 977 1 z "
    },
    "¾": {
      ha: 1023,
      x_min: 21,
      x_max: 1008,
      o: "m 400 851 q 373 762 400 798 q 298 710 345 726 q 388 659 358 694 q 418 570 418 623 q 404 495 418 529 q 362 437 391 461 q 292 399 334 413 q 191 386 249 386 q 101 394 143 386 q 21 424 60 403 l 21 514 q 109 478 64 491 q 189 465 153 465 q 286 493 256 465 q 315 571 315 522 q 279 644 315 621 q 178 667 243 667 l 111 667 l 111 743 l 178 743 q 269 770 240 743 q 297 840 297 797 q 290 878 297 862 q 272 904 283 894 q 244 919 260 914 q 210 924 228 924 q 137 910 170 924 q 69 871 104 896 l 22 936 q 63 964 42 951 q 106 985 83 977 q 155 999 130 994 q 211 1004 181 1004 q 293 993 258 1004 q 353 961 329 981 q 388 912 376 941 q 400 851 400 884 m 879 991 l 329 0 l 222 0 l 772 991 l 879 991 m 1008 131 l 923 131 l 923 1 l 826 1 l 826 131 l 572 131 l 572 206 l 827 599 l 923 599 l 923 217 l 1008 217 l 1008 131 m 826 217 l 826 349 q 827 411 826 378 q 830 478 828 445 q 820 458 827 471 q 806 431 813 446 q 790 404 798 417 q 776 380 782 390 l 671 217 l 826 217 z "
    },
    "¿": {
      ha: 591,
      x_min: 46,
      x_max: 567,
      o: "m 401 458 l 401 433 q 396 363 401 394 q 377 305 391 332 q 342 252 364 277 q 286 197 320 226 q 231 147 254 170 q 193 101 208 124 q 171 51 178 77 q 164 -12 164 24 q 174 -72 164 -45 q 204 -118 184 -98 q 252 -148 223 -137 q 318 -158 281 -158 q 426 -141 375 -158 q 524 -100 477 -123 l 567 -199 q 448 -247 511 -227 q 318 -267 384 -267 q 204 -249 255 -267 q 119 -199 154 -232 q 65 -120 84 -167 q 46 -14 46 -73 q 55 68 46 33 q 82 134 64 103 q 128 193 100 164 q 192 253 155 221 q 250 306 227 283 q 285 350 272 329 q 302 394 298 371 q 307 446 307 416 l 307 458 l 401 458 m 433 664 q 427 620 433 638 q 409 591 420 602 q 381 575 397 580 q 347 570 366 570 q 314 575 330 570 q 287 591 298 580 q 268 620 275 602 q 261 664 261 638 q 268 707 261 689 q 287 736 275 724 q 314 753 298 747 q 347 758 330 758 q 381 753 366 758 q 409 736 397 747 q 427 707 420 724 q 433 664 433 689 z "
    },
    "À": {
      ha: 844,
      x_min: 0,
      x_max: 844,
      o: "m 715 0 l 607 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 567 419 l 467 707 q 457 736 463 719 q 445 774 451 754 q 433 817 439 795 q 421 860 427 839 q 410 817 416 839 q 398 773 404 794 q 386 735 392 753 q 376 707 380 718 l 278 419 l 567 419 m 488 1071 l 406 1071 q 355 1118 382 1090 q 301 1176 327 1146 q 253 1233 275 1206 q 221 1279 232 1261 l 221 1293 l 370 1293 q 395 1243 380 1270 q 425 1188 410 1215 q 457 1135 441 1160 q 488 1089 473 1109 l 488 1071 z "
    },
    "Á": {
      ha: 844,
      x_min: 0,
      x_max: 844,
      o: "m 715 0 l 607 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 567 419 l 467 707 q 457 736 463 719 q 445 774 451 754 q 433 817 439 795 q 421 860 427 839 q 410 817 416 839 q 398 773 404 794 q 386 735 392 753 q 376 707 380 718 l 278 419 l 567 419 m 362 1089 q 393 1135 377 1109 q 425 1188 409 1160 q 455 1243 441 1215 q 480 1293 469 1270 l 629 1293 l 629 1279 q 596 1233 618 1261 q 549 1176 575 1206 q 495 1118 523 1146 q 444 1071 468 1090 l 362 1071 l 362 1089 z "
    },
    "Â": {
      ha: 844,
      x_min: 0,
      x_max: 844,
      o: "m 715 0 l 607 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 567 419 l 467 707 q 457 736 463 719 q 445 774 451 754 q 433 817 439 795 q 421 860 427 839 q 410 817 416 839 q 398 773 404 794 q 386 735 392 753 q 376 707 380 718 l 278 419 l 567 419 m 646 1071 l 564 1071 q 493 1127 530 1094 q 421 1197 456 1160 q 349 1127 385 1160 q 278 1071 313 1094 l 196 1071 l 196 1089 q 237 1135 214 1109 q 282 1188 260 1160 q 325 1243 305 1215 q 356 1293 345 1270 l 486 1293 q 517 1243 497 1270 q 560 1188 537 1215 q 606 1135 583 1160 q 646 1089 629 1109 l 646 1071 z "
    },
    "Ã": {
      ha: 844,
      x_min: 0,
      x_max: 844,
      o: "m 715 0 l 607 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 567 419 l 467 707 q 457 736 463 719 q 445 774 451 754 q 433 817 439 795 q 421 860 427 839 q 410 817 416 839 q 398 773 404 794 q 386 735 392 753 q 376 707 380 718 l 278 419 l 567 419 m 524 1072 q 470 1084 496 1072 q 417 1111 443 1096 q 368 1137 391 1125 q 322 1149 344 1149 q 275 1131 292 1149 q 250 1071 259 1113 l 179 1071 q 194 1145 182 1112 q 223 1201 205 1178 q 266 1237 241 1225 q 322 1250 291 1250 q 378 1238 351 1250 q 431 1212 406 1226 q 480 1186 457 1198 q 524 1174 504 1174 q 570 1192 554 1174 q 595 1251 585 1209 l 667 1251 q 652 1178 663 1211 q 623 1121 641 1145 q 580 1085 605 1098 q 524 1072 555 1072 z "
    },
    "Ä": {
      ha: 844,
      x_min: 0,
      x_max: 844,
      o: "m 715 0 l 607 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 567 419 l 467 707 q 457 736 463 719 q 445 774 451 754 q 433 817 439 795 q 421 860 427 839 q 410 817 416 839 q 398 773 404 794 q 386 735 392 753 q 376 707 380 718 l 278 419 l 567 419 m 231 1175 q 250 1228 231 1212 q 296 1244 269 1244 q 342 1228 322 1244 q 361 1175 361 1211 q 342 1122 361 1139 q 296 1105 322 1105 q 250 1122 269 1105 q 231 1175 231 1139 m 485 1175 q 504 1228 485 1212 q 550 1244 523 1244 q 575 1240 563 1244 q 595 1228 587 1236 q 610 1206 604 1219 q 615 1175 615 1194 q 595 1122 615 1139 q 550 1105 576 1105 q 504 1122 523 1105 q 485 1175 485 1139 z "
    },
    "Å": {
      ha: 844,
      x_min: 0,
      x_max: 844,
      o: "m 715 0 l 607 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 567 419 l 467 707 q 457 736 463 719 q 445 774 451 754 q 433 817 439 795 q 421 860 427 839 q 410 817 416 839 q 398 773 404 794 q 386 735 392 753 q 376 707 380 718 l 278 419 l 567 419 m 575 1074 q 563 1011 575 1039 q 531 965 551 984 q 481 936 510 946 q 420 926 453 926 q 358 936 386 926 q 310 965 330 946 q 279 1011 290 984 q 269 1072 269 1038 q 279 1134 269 1107 q 310 1179 290 1160 q 358 1208 330 1198 q 420 1218 386 1218 q 481 1208 452 1218 q 530 1180 509 1198 q 563 1134 551 1161 q 575 1074 575 1107 m 496 1072 q 474 1128 496 1108 q 420 1149 453 1149 q 365 1128 386 1149 q 343 1072 343 1108 q 362 1016 343 1036 q 420 996 382 996 q 474 1016 453 996 q 496 1072 496 1036 z "
    },
    "Æ": {
      ha: 1183,
      x_min: -1,
      x_max: 1100,
      o: "m 1100 0 l 585 0 l 585 307 l 262 307 l 125 0 l -1 0 l 443 991 l 1100 991 l 1100 880 l 711 880 l 711 574 l 1074 574 l 1074 464 l 711 464 l 711 111 l 1100 111 l 1100 0 m 311 419 l 585 419 l 585 880 l 511 880 l 311 419 z "
    },
    "Ç": {
      ha: 838,
      x_min: 85,
      x_max: 798,
      o: "m 538 895 q 406 867 465 895 q 306 788 347 840 q 241 663 264 736 q 218 496 218 589 q 238 326 218 400 q 298 201 258 252 q 398 123 338 150 q 538 97 458 97 q 652 109 598 97 q 760 136 707 121 l 760 26 q 707 8 733 16 q 651 -4 680 1 q 590 -11 623 -9 q 517 -14 557 -14 q 324 23 406 -14 q 190 127 243 60 q 111 288 136 194 q 85 497 85 382 q 114 703 85 610 q 201 864 144 797 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 842 q 652 879 702 863 q 538 895 602 895 m 621 -195 q 573 -297 621 -260 q 424 -334 526 -334 q 394 -332 409 -334 q 368 -328 378 -330 l 368 -254 q 395 -257 378 -256 q 422 -258 412 -258 q 498 -244 471 -258 q 525 -196 525 -229 q 516 -168 525 -180 q 492 -147 507 -156 q 455 -132 476 -138 q 408 -119 433 -125 l 469 0 l 551 0 l 513 -78 q 555 -92 536 -83 q 590 -115 575 -101 q 613 -149 604 -129 q 621 -195 621 -168 z "
    },
    "È": {
      ha: 733,
      x_min: 135,
      x_max: 650,
      o: "m 650 0 l 135 0 l 135 991 l 650 991 l 650 880 l 261 880 l 261 574 l 624 574 l 624 464 l 261 464 l 261 111 l 650 111 l 650 0 m 484 1071 l 402 1071 q 351 1118 378 1090 q 297 1176 323 1146 q 249 1233 271 1206 q 217 1279 228 1261 l 217 1293 l 366 1293 q 391 1243 376 1270 q 421 1188 406 1215 q 453 1135 437 1160 q 484 1089 469 1109 l 484 1071 z "
    },
    "É": {
      ha: 733,
      x_min: 135,
      x_max: 650,
      o: "m 650 0 l 135 0 l 135 991 l 650 991 l 650 880 l 261 880 l 261 574 l 624 574 l 624 464 l 261 464 l 261 111 l 650 111 l 650 0 m 309 1089 q 340 1135 324 1109 q 372 1188 356 1160 q 402 1243 388 1215 q 427 1293 416 1270 l 576 1293 l 576 1279 q 544 1233 565 1261 q 496 1176 522 1206 q 443 1118 470 1146 q 391 1071 415 1090 l 309 1071 l 309 1089 z "
    },
    "Ê": {
      ha: 733,
      x_min: 135,
      x_max: 650,
      o: "m 650 0 l 135 0 l 135 991 l 650 991 l 650 880 l 261 880 l 261 574 l 624 574 l 624 464 l 261 464 l 261 111 l 650 111 l 650 0 m 615 1071 l 533 1071 q 462 1127 498 1094 q 390 1197 425 1160 q 317 1127 353 1160 q 247 1071 281 1094 l 165 1071 l 165 1089 q 205 1135 182 1109 q 251 1188 229 1160 q 294 1243 274 1215 q 325 1293 314 1270 l 455 1293 q 486 1243 466 1270 q 529 1188 506 1215 q 575 1135 551 1160 q 615 1089 598 1109 l 615 1071 z "
    },
    "Ë": {
      ha: 733,
      x_min: 135,
      x_max: 650,
      o: "m 650 0 l 135 0 l 135 991 l 650 991 l 650 880 l 261 880 l 261 574 l 624 574 l 624 464 l 261 464 l 261 111 l 650 111 l 650 0 m 201 1175 q 220 1228 201 1212 q 266 1244 239 1244 q 312 1228 292 1244 q 332 1175 332 1211 q 312 1122 332 1139 q 266 1105 292 1105 q 220 1122 239 1105 q 201 1175 201 1139 m 455 1175 q 474 1228 455 1212 q 520 1244 493 1244 q 545 1240 533 1244 q 566 1228 557 1236 q 580 1206 574 1219 q 585 1175 585 1194 q 566 1122 585 1139 q 520 1105 546 1105 q 474 1122 493 1105 q 455 1175 455 1139 z "
    },
    "Ì": {
      ha: 471,
      x_min: 42,
      x_max: 415,
      o: "m 415 0 l 56 0 l 56 69 l 172 97 l 172 895 l 56 922 l 56 991 l 415 991 l 415 922 l 298 895 l 298 97 l 415 69 l 415 0 m 309 1071 l 227 1071 q 176 1118 203 1090 q 122 1176 148 1146 q 74 1233 96 1206 q 42 1279 53 1261 l 42 1293 l 191 1293 q 216 1243 201 1270 q 246 1188 231 1215 q 278 1135 262 1160 q 309 1089 294 1109 l 309 1071 z "
    },
    "Í": {
      ha: 471,
      x_min: 56,
      x_max: 441,
      o: "m 415 0 l 56 0 l 56 69 l 172 97 l 172 895 l 56 922 l 56 991 l 415 991 l 415 922 l 298 895 l 298 97 l 415 69 l 415 0 m 174 1089 q 205 1135 189 1109 q 237 1188 221 1160 q 267 1243 253 1215 q 292 1293 281 1270 l 441 1293 l 441 1279 q 409 1233 430 1261 q 361 1176 387 1206 q 308 1118 335 1146 q 256 1071 280 1090 l 174 1071 l 174 1089 z "
    },
    "Î": {
      ha: 471,
      x_min: 12,
      x_max: 462,
      o: "m 415 0 l 56 0 l 56 69 l 172 97 l 172 895 l 56 922 l 56 991 l 415 991 l 415 922 l 298 895 l 298 97 l 415 69 l 415 0 m 462 1071 l 380 1071 q 309 1127 345 1094 q 237 1197 272 1160 q 164 1127 200 1160 q 94 1071 128 1094 l 12 1071 l 12 1089 q 52 1135 29 1109 q 98 1188 75 1160 q 141 1243 121 1215 q 172 1293 161 1270 l 302 1293 q 333 1243 313 1270 q 375 1188 353 1215 q 421 1135 398 1160 q 462 1089 445 1109 l 462 1071 z "
    },
    "Ï": {
      ha: 471,
      x_min: 43,
      x_max: 428,
      o: "m 415 0 l 56 0 l 56 69 l 172 97 l 172 895 l 56 922 l 56 991 l 415 991 l 415 922 l 298 895 l 298 97 l 415 69 l 415 0 m 43 1175 q 62 1228 43 1212 q 109 1244 81 1244 q 155 1228 135 1244 q 174 1175 174 1211 q 155 1122 174 1139 q 109 1105 135 1105 q 62 1122 81 1105 q 43 1175 43 1139 m 298 1175 q 317 1228 298 1212 q 363 1244 336 1244 q 388 1240 376 1244 q 408 1228 399 1236 q 422 1206 417 1219 q 428 1175 428 1194 q 408 1122 428 1139 q 363 1105 389 1105 q 317 1122 336 1105 q 298 1175 298 1139 z "
    },
    "Ð": {
      ha: 950,
      x_min: 32,
      x_max: 865,
      o: "m 32 546 l 135 546 l 135 991 l 411 991 q 599 960 515 991 q 742 868 683 929 q 833 715 801 806 q 865 505 865 625 q 833 285 865 380 q 739 127 800 191 q 587 32 677 64 q 383 0 497 0 l 135 0 l 135 436 l 32 436 l 32 546 m 732 501 q 709 672 732 600 q 644 791 687 745 q 539 861 602 838 q 397 884 477 884 l 261 884 l 261 546 l 489 546 l 489 436 l 261 436 l 261 109 l 371 109 q 641 208 550 109 q 732 501 732 307 z "
    },
    "Ñ": {
      ha: 1013,
      x_min: 135,
      x_max: 878,
      o: "m 878 0 l 732 0 l 244 821 l 239 821 q 245 717 243 768 q 250 625 248 673 q 252 538 252 576 l 252 0 l 135 0 l 135 991 l 279 991 l 765 175 l 770 175 q 765 277 768 227 q 763 321 764 298 q 761 367 762 344 q 760 410 760 389 q 760 449 760 431 l 760 991 l 878 991 l 878 0 m 614 1072 q 560 1084 587 1072 q 507 1111 533 1096 q 458 1137 481 1125 q 412 1149 434 1149 q 366 1131 382 1149 q 340 1071 349 1113 l 269 1071 q 284 1145 273 1112 q 313 1201 295 1178 q 356 1237 331 1225 q 412 1250 381 1250 q 468 1238 441 1250 q 522 1212 496 1226 q 571 1186 547 1198 q 614 1174 594 1174 q 660 1192 644 1174 q 686 1251 675 1209 l 757 1251 q 742 1178 753 1211 q 713 1121 731 1145 q 670 1085 695 1098 q 614 1072 645 1072 z "
    },
    "Ò": {
      ha: 1031,
      x_min: 85,
      x_max: 945,
      o: "m 945 497 q 917 288 945 382 q 836 127 890 194 q 701 23 781 60 q 515 -14 621 -14 q 324 23 405 -14 q 190 127 243 60 q 111 289 136 194 q 85 498 85 383 q 111 708 85 614 q 190 868 136 802 q 325 971 243 935 q 517 1007 406 1007 q 702 971 622 1007 q 836 868 781 935 q 917 707 890 801 q 945 497 945 613 m 218 497 q 236 330 218 404 q 290 204 254 256 q 382 124 326 152 q 515 97 438 97 q 649 124 593 97 q 741 204 705 152 q 794 330 777 256 q 811 497 811 404 q 794 665 811 591 q 741 790 777 739 q 650 868 705 841 q 517 896 594 896 q 383 868 439 896 q 290 790 327 841 q 236 665 254 739 q 218 497 218 591 m 590 1071 l 509 1071 q 457 1118 485 1090 q 403 1176 429 1146 q 356 1233 377 1206 q 323 1279 334 1261 l 323 1293 l 472 1293 q 497 1243 483 1270 q 528 1188 512 1215 q 559 1135 543 1160 q 590 1089 576 1109 l 590 1071 z "
    },
    "Ó": {
      ha: 1031,
      x_min: 85,
      x_max: 945,
      o: "m 945 497 q 917 288 945 382 q 836 127 890 194 q 701 23 781 60 q 515 -14 621 -14 q 324 23 405 -14 q 190 127 243 60 q 111 289 136 194 q 85 498 85 383 q 111 708 85 614 q 190 868 136 802 q 325 971 243 935 q 517 1007 406 1007 q 702 971 622 1007 q 836 868 781 935 q 917 707 890 801 q 945 497 945 613 m 218 497 q 236 330 218 404 q 290 204 254 256 q 382 124 326 152 q 515 97 438 97 q 649 124 593 97 q 741 204 705 152 q 794 330 777 256 q 811 497 811 404 q 794 665 811 591 q 741 790 777 739 q 650 868 705 841 q 517 896 594 896 q 383 868 439 896 q 290 790 327 841 q 236 665 254 739 q 218 497 218 591 m 441 1089 q 472 1135 456 1109 q 504 1188 488 1160 q 534 1243 520 1215 q 559 1293 549 1270 l 708 1293 l 708 1279 q 676 1233 697 1261 q 628 1176 654 1206 q 575 1118 602 1146 q 524 1071 547 1090 l 441 1071 l 441 1089 z "
    },
    "Ô": {
      ha: 1031,
      x_min: 85,
      x_max: 945,
      o: "m 945 497 q 917 288 945 382 q 836 127 890 194 q 701 23 781 60 q 515 -14 621 -14 q 324 23 405 -14 q 190 127 243 60 q 111 289 136 194 q 85 498 85 383 q 111 708 85 614 q 190 868 136 802 q 325 971 243 935 q 517 1007 406 1007 q 702 971 622 1007 q 836 868 781 935 q 917 707 890 801 q 945 497 945 613 m 218 497 q 236 330 218 404 q 290 204 254 256 q 382 124 326 152 q 515 97 438 97 q 649 124 593 97 q 741 204 705 152 q 794 330 777 256 q 811 497 811 404 q 794 665 811 591 q 741 790 777 739 q 650 868 705 841 q 517 896 594 896 q 383 868 439 896 q 290 790 327 841 q 236 665 254 739 q 218 497 218 591 m 743 1071 l 661 1071 q 590 1127 627 1094 q 518 1197 553 1160 q 446 1127 481 1160 q 375 1071 410 1094 l 293 1071 l 293 1089 q 334 1135 311 1109 q 379 1188 357 1160 q 422 1243 402 1215 q 453 1293 442 1270 l 583 1293 q 614 1243 594 1270 q 657 1188 634 1215 q 703 1135 680 1160 q 743 1089 726 1109 l 743 1071 z "
    },
    "Õ": {
      ha: 1031,
      x_min: 85,
      x_max: 945,
      o: "m 945 497 q 917 288 945 382 q 836 127 890 194 q 701 23 781 60 q 515 -14 621 -14 q 324 23 405 -14 q 190 127 243 60 q 111 289 136 194 q 85 498 85 383 q 111 708 85 614 q 190 868 136 802 q 325 971 243 935 q 517 1007 406 1007 q 702 971 622 1007 q 836 868 781 935 q 917 707 890 801 q 945 497 945 613 m 218 497 q 236 330 218 404 q 290 204 254 256 q 382 124 326 152 q 515 97 438 97 q 649 124 593 97 q 741 204 705 152 q 794 330 777 256 q 811 497 811 404 q 794 665 811 591 q 741 790 777 739 q 650 868 705 841 q 517 896 594 896 q 383 868 439 896 q 290 790 327 841 q 236 665 254 739 q 218 497 218 591 m 604 1072 q 550 1084 577 1072 q 498 1111 524 1096 q 448 1137 472 1125 q 403 1149 425 1149 q 356 1131 372 1149 q 330 1071 340 1113 l 260 1071 q 274 1145 263 1112 q 303 1201 286 1178 q 347 1237 321 1225 q 403 1250 372 1250 q 459 1238 431 1250 q 512 1212 486 1226 q 561 1186 538 1198 q 604 1174 585 1174 q 650 1192 635 1174 q 676 1251 666 1209 l 747 1251 q 733 1178 744 1211 q 704 1121 722 1145 q 661 1085 686 1098 q 604 1072 635 1072 z "
    },
    "Ö": {
      ha: 1031,
      x_min: 85,
      x_max: 945,
      o: "m 945 497 q 917 288 945 382 q 836 127 890 194 q 701 23 781 60 q 515 -14 621 -14 q 324 23 405 -14 q 190 127 243 60 q 111 289 136 194 q 85 498 85 383 q 111 708 85 614 q 190 868 136 802 q 325 971 243 935 q 517 1007 406 1007 q 702 971 622 1007 q 836 868 781 935 q 917 707 890 801 q 945 497 945 613 m 218 497 q 236 330 218 404 q 290 204 254 256 q 382 124 326 152 q 515 97 438 97 q 649 124 593 97 q 741 204 705 152 q 794 330 777 256 q 811 497 811 404 q 794 665 811 591 q 741 790 777 739 q 650 868 705 841 q 517 896 594 896 q 383 868 439 896 q 290 790 327 841 q 236 665 254 739 q 218 497 218 591 m 323 1175 q 342 1228 323 1212 q 389 1244 361 1244 q 435 1228 415 1244 q 454 1175 454 1211 q 435 1122 454 1139 q 389 1105 415 1105 q 342 1122 361 1105 q 323 1175 323 1139 m 578 1175 q 597 1228 578 1212 q 643 1244 616 1244 q 668 1240 656 1244 q 688 1228 680 1236 q 703 1206 697 1219 q 708 1175 708 1194 q 688 1122 708 1139 q 643 1105 669 1105 q 597 1122 616 1105 q 578 1175 578 1139 z "
    },
    "×": {
      ha: 765,
      x_min: 96,
      x_max: 671,
      o: "m 311 490 l 96 707 l 167 778 l 382 562 l 600 778 l 671 708 l 453 490 l 669 273 l 600 204 l 382 419 l 167 205 l 97 275 l 311 490 z "
    },
    "Ø": {
      ha: 1031,
      x_min: 85,
      x_max: 945,
      o: "m 882 986 l 819 885 q 913 720 881 818 q 945 497 945 621 q 917 288 945 382 q 836 127 890 194 q 701 23 781 60 q 515 -14 621 -14 q 297 35 387 -14 l 244 -52 l 151 1 l 212 100 q 116 269 146 168 q 85 498 85 370 q 111 708 85 614 q 190 868 136 802 q 325 971 243 935 q 517 1007 406 1007 q 635 993 581 1007 q 734 953 690 979 l 789 1039 l 882 986 m 218 497 q 234 337 218 408 q 282 214 250 267 l 675 854 q 604 885 642 874 q 517 896 565 896 q 383 868 439 896 q 290 790 327 841 q 236 665 254 739 q 218 497 218 591 m 811 497 q 751 774 811 671 l 359 136 q 430 107 391 117 q 515 97 469 97 q 649 124 593 97 q 741 204 705 152 q 794 330 777 256 q 811 497 811 404 z "
    },
    "Ù": {
      ha: 970,
      x_min: 125,
      x_max: 844,
      o: "m 844 993 l 844 350 q 822 206 844 273 q 754 91 800 140 q 641 14 709 42 q 481 -14 573 -14 q 328 13 394 -14 q 216 87 261 39 q 148 202 171 135 q 125 353 125 270 l 125 991 l 252 991 l 252 346 q 310 162 252 227 q 488 97 369 97 q 591 115 548 97 q 663 167 635 134 q 704 246 690 200 q 718 347 718 292 l 718 993 l 844 993 m 574 1071 l 493 1071 q 441 1118 469 1090 q 388 1176 414 1146 q 340 1233 361 1206 q 308 1279 319 1261 l 308 1293 l 456 1293 q 482 1243 467 1270 q 512 1188 496 1215 q 544 1135 528 1160 q 574 1089 560 1109 l 574 1071 z "
    },
    "Ú": {
      ha: 970,
      x_min: 125,
      x_max: 844,
      o: "m 844 993 l 844 350 q 822 206 844 273 q 754 91 800 140 q 641 14 709 42 q 481 -14 573 -14 q 328 13 394 -14 q 216 87 261 39 q 148 202 171 135 q 125 353 125 270 l 125 991 l 252 991 l 252 346 q 310 162 252 227 q 488 97 369 97 q 591 115 548 97 q 663 167 635 134 q 704 246 690 200 q 718 347 718 292 l 718 993 l 844 993 m 400 1089 q 431 1135 415 1109 q 463 1188 447 1160 q 493 1243 479 1215 q 518 1293 507 1270 l 667 1293 l 667 1279 q 634 1233 656 1261 q 587 1176 613 1206 q 533 1118 561 1146 q 482 1071 506 1090 l 400 1071 l 400 1089 z "
    },
    "Û": {
      ha: 970,
      x_min: 125,
      x_max: 844,
      o: "m 844 993 l 844 350 q 822 206 844 273 q 754 91 800 140 q 641 14 709 42 q 481 -14 573 -14 q 328 13 394 -14 q 216 87 261 39 q 148 202 171 135 q 125 353 125 270 l 125 991 l 252 991 l 252 346 q 310 162 252 227 q 488 97 369 97 q 591 115 548 97 q 663 167 635 134 q 704 246 690 200 q 718 347 718 292 l 718 993 l 844 993 m 707 1071 l 625 1071 q 554 1127 591 1094 q 482 1197 517 1160 q 410 1127 446 1160 q 339 1071 374 1094 l 257 1071 l 257 1089 q 298 1135 275 1109 q 343 1188 321 1160 q 386 1243 366 1215 q 417 1293 406 1270 l 547 1293 q 578 1243 558 1270 q 621 1188 598 1215 q 667 1135 644 1160 q 707 1089 690 1109 l 707 1071 z "
    },
    "Ü": {
      ha: 970,
      x_min: 125,
      x_max: 844,
      o: "m 844 993 l 844 350 q 822 206 844 273 q 754 91 800 140 q 641 14 709 42 q 481 -14 573 -14 q 328 13 394 -14 q 216 87 261 39 q 148 202 171 135 q 125 353 125 270 l 125 991 l 252 991 l 252 346 q 310 162 252 227 q 488 97 369 97 q 591 115 548 97 q 663 167 635 134 q 704 246 690 200 q 718 347 718 292 l 718 993 l 844 993 m 293 1175 q 312 1228 293 1212 q 358 1244 331 1244 q 404 1228 385 1244 q 424 1175 424 1211 q 404 1122 424 1139 q 358 1105 385 1105 q 312 1122 331 1105 q 293 1175 293 1139 m 547 1175 q 566 1228 547 1212 q 612 1244 585 1244 q 637 1240 625 1244 q 658 1228 649 1236 q 672 1206 667 1219 q 677 1175 677 1194 q 658 1122 677 1139 q 612 1105 638 1105 q 566 1122 585 1105 q 547 1175 547 1139 z "
    },
    "Ý": {
      ha: 732,
      x_min: 0,
      x_max: 732,
      o: "m 366 490 l 596 991 l 732 991 l 429 386 l 429 0 l 302 0 l 302 379 l 0 991 l 138 991 l 366 490 m 300 1089 q 331 1135 315 1109 q 362 1188 347 1160 q 393 1243 378 1215 q 418 1293 407 1270 l 566 1293 l 566 1279 q 534 1233 555 1261 q 487 1176 513 1206 q 433 1118 460 1146 q 382 1071 406 1090 l 300 1071 l 300 1089 z "
    },
    "Þ": {
      ha: 800,
      x_min: 135,
      x_max: 729,
      o: "m 729 530 q 710 412 729 469 q 649 311 692 355 q 536 241 606 267 q 363 215 466 215 l 261 215 l 261 0 l 135 0 l 135 991 l 261 991 l 261 821 l 380 821 q 537 801 471 821 q 646 745 603 782 q 709 654 688 708 q 729 530 729 600 m 261 322 l 349 322 q 459 333 412 322 q 537 368 506 344 q 583 430 568 392 q 599 524 599 469 q 543 667 599 621 q 370 713 488 713 l 261 713 l 261 322 z "
    },
    "ß": {
      ha: 836,
      x_min: 118,
      x_max: 774,
      o: "m 685 854 q 670 786 685 816 q 634 731 656 755 q 588 686 613 706 q 541 647 562 665 q 505 610 519 628 q 490 571 490 591 q 495 546 490 557 q 513 521 500 534 q 550 491 526 508 q 612 449 574 475 q 680 399 650 424 q 731 347 710 375 q 763 287 751 319 q 774 212 774 254 q 755 111 774 153 q 702 40 736 68 q 620 0 667 13 q 514 -14 572 -14 q 401 -2 448 -14 q 318 33 354 10 l 318 146 q 358 124 336 135 q 404 106 380 114 q 454 93 429 98 q 505 87 480 87 q 571 96 543 87 q 616 120 598 104 q 642 157 633 135 q 650 205 650 178 q 644 250 650 230 q 624 289 638 270 q 585 328 609 308 q 522 371 560 347 q 451 421 479 398 q 404 467 422 444 q 378 513 386 490 q 371 566 371 537 q 385 629 371 602 q 420 677 399 656 q 465 717 441 699 q 511 755 490 735 q 546 797 532 774 q 559 850 559 820 q 548 899 559 878 q 517 934 537 920 q 468 955 496 948 q 406 961 440 961 q 342 955 372 961 q 290 932 313 948 q 255 887 268 916 q 241 815 241 859 l 241 0 l 118 0 l 118 814 q 139 932 118 884 q 199 1009 161 980 q 290 1050 237 1038 q 406 1063 343 1063 q 519 1050 468 1063 q 608 1011 571 1037 q 665 946 644 985 q 685 854 685 907 z "
    },
    "à": {
      ha: 737,
      x_min: 64,
      x_max: 627,
      o: "m 538 0 l 513 103 l 507 103 q 463 51 485 73 q 414 14 440 28 q 355 -7 387 0 q 279 -14 322 -14 q 193 0 233 -14 q 125 40 154 13 q 80 110 96 68 q 64 208 64 151 q 142 379 64 319 q 380 444 220 439 l 505 449 l 505 496 q 495 572 505 541 q 467 621 486 602 q 421 648 448 640 q 358 656 393 656 q 253 640 302 656 q 160 600 205 623 l 117 693 q 229 739 167 720 q 358 758 290 758 q 478 744 427 758 q 561 700 528 730 q 610 623 594 670 q 627 510 627 576 l 627 0 l 538 0 m 311 86 q 388 99 353 86 q 449 138 423 112 q 489 204 475 164 q 504 297 504 243 l 504 364 l 407 359 q 304 346 346 357 q 238 316 263 335 q 203 269 214 296 q 192 207 192 241 q 225 115 192 144 q 311 86 258 86 m 460 842 l 378 842 q 327 889 355 861 q 273 947 299 917 q 225 1004 247 977 q 193 1050 204 1031 l 193 1064 l 342 1064 q 367 1014 353 1041 q 397 959 382 986 q 429 905 413 931 q 460 860 446 880 l 460 842 z "
    },
    "á": {
      ha: 737,
      x_min: 64,
      x_max: 627,
      o: "m 538 0 l 513 103 l 507 103 q 463 51 485 73 q 414 14 440 28 q 355 -7 387 0 q 279 -14 322 -14 q 193 0 233 -14 q 125 40 154 13 q 80 110 96 68 q 64 208 64 151 q 142 379 64 319 q 380 444 220 439 l 505 449 l 505 496 q 495 572 505 541 q 467 621 486 602 q 421 648 448 640 q 358 656 393 656 q 253 640 302 656 q 160 600 205 623 l 117 693 q 229 739 167 720 q 358 758 290 758 q 478 744 427 758 q 561 700 528 730 q 610 623 594 670 q 627 510 627 576 l 627 0 l 538 0 m 311 86 q 388 99 353 86 q 449 138 423 112 q 489 204 475 164 q 504 297 504 243 l 504 364 l 407 359 q 304 346 346 357 q 238 316 263 335 q 203 269 214 296 q 192 207 192 241 q 225 115 192 144 q 311 86 258 86 m 302 860 q 333 905 317 880 q 365 959 349 931 q 395 1014 381 986 q 420 1064 410 1041 l 569 1064 l 569 1050 q 537 1004 558 1031 q 489 947 515 977 q 436 889 463 917 q 385 842 408 861 l 302 842 l 302 860 z "
    },
    "â": {
      ha: 737,
      x_min: 64,
      x_max: 627,
      o: "m 538 0 l 513 103 l 507 103 q 463 51 485 73 q 414 14 440 28 q 355 -7 387 0 q 279 -14 322 -14 q 193 0 233 -14 q 125 40 154 13 q 80 110 96 68 q 64 208 64 151 q 142 379 64 319 q 380 444 220 439 l 505 449 l 505 496 q 495 572 505 541 q 467 621 486 602 q 421 648 448 640 q 358 656 393 656 q 253 640 302 656 q 160 600 205 623 l 117 693 q 229 739 167 720 q 358 758 290 758 q 478 744 427 758 q 561 700 528 730 q 610 623 594 670 q 627 510 627 576 l 627 0 l 538 0 m 311 86 q 388 99 353 86 q 449 138 423 112 q 489 204 475 164 q 504 297 504 243 l 504 364 l 407 359 q 304 346 346 357 q 238 316 263 335 q 203 269 214 296 q 192 207 192 241 q 225 115 192 144 q 311 86 258 86 m 605 842 l 523 842 q 452 898 488 865 q 380 968 415 930 q 307 898 343 930 q 237 842 271 865 l 155 842 l 155 860 q 195 905 172 880 q 241 959 218 931 q 284 1014 264 986 q 315 1064 304 1041 l 445 1064 q 476 1014 456 1041 q 518 959 496 986 q 565 905 541 931 q 605 860 588 880 l 605 842 z "
    },
    "ã": {
      ha: 737,
      x_min: 64,
      x_max: 627,
      o: "m 538 0 l 513 103 l 507 103 q 463 51 485 73 q 414 14 440 28 q 355 -7 387 0 q 279 -14 322 -14 q 193 0 233 -14 q 125 40 154 13 q 80 110 96 68 q 64 208 64 151 q 142 379 64 319 q 380 444 220 439 l 505 449 l 505 496 q 495 572 505 541 q 467 621 486 602 q 421 648 448 640 q 358 656 393 656 q 253 640 302 656 q 160 600 205 623 l 117 693 q 229 739 167 720 q 358 758 290 758 q 478 744 427 758 q 561 700 528 730 q 610 623 594 670 q 627 510 627 576 l 627 0 l 538 0 m 311 86 q 388 99 353 86 q 449 138 423 112 q 489 204 475 164 q 504 297 504 243 l 504 364 l 407 359 q 304 346 346 357 q 238 316 263 335 q 203 269 214 296 q 192 207 192 241 q 225 115 192 144 q 311 86 258 86 m 474 843 q 420 855 447 843 q 368 881 393 867 q 318 908 342 896 q 273 920 294 920 q 226 902 242 920 q 200 842 210 884 l 130 842 q 144 916 133 882 q 173 972 155 949 q 216 1008 191 996 q 273 1021 241 1021 q 329 1009 301 1021 q 382 983 356 997 q 431 957 408 968 q 474 945 454 945 q 520 962 505 945 q 546 1022 536 980 l 617 1022 q 603 948 614 981 q 573 892 591 916 q 530 856 555 869 q 474 843 505 843 z "
    },
    "ä": {
      ha: 737,
      x_min: 64,
      x_max: 627,
      o: "m 538 0 l 513 103 l 507 103 q 463 51 485 73 q 414 14 440 28 q 355 -7 387 0 q 279 -14 322 -14 q 193 0 233 -14 q 125 40 154 13 q 80 110 96 68 q 64 208 64 151 q 142 379 64 319 q 380 444 220 439 l 505 449 l 505 496 q 495 572 505 541 q 467 621 486 602 q 421 648 448 640 q 358 656 393 656 q 253 640 302 656 q 160 600 205 623 l 117 693 q 229 739 167 720 q 358 758 290 758 q 478 744 427 758 q 561 700 528 730 q 610 623 594 670 q 627 510 627 576 l 627 0 l 538 0 m 311 86 q 388 99 353 86 q 449 138 423 112 q 489 204 475 164 q 504 297 504 243 l 504 364 l 407 359 q 304 346 346 357 q 238 316 263 335 q 203 269 214 296 q 192 207 192 241 q 225 115 192 144 q 311 86 258 86 m 185 946 q 204 999 185 983 q 250 1015 223 1015 q 296 999 277 1015 q 316 946 316 982 q 296 893 316 910 q 250 876 277 876 q 204 893 223 876 q 185 946 185 910 m 439 946 q 458 999 439 983 q 505 1015 477 1015 q 529 1011 517 1015 q 550 999 541 1007 q 564 977 559 990 q 570 946 570 964 q 550 893 570 910 q 505 876 530 876 q 458 893 477 876 q 439 946 439 910 z "
    },
    "å": {
      ha: 737,
      x_min: 64,
      x_max: 627,
      o: "m 538 0 l 513 103 l 507 103 q 463 51 485 73 q 414 14 440 28 q 355 -7 387 0 q 279 -14 322 -14 q 193 0 233 -14 q 125 40 154 13 q 80 110 96 68 q 64 208 64 151 q 142 379 64 319 q 380 444 220 439 l 505 449 l 505 496 q 495 572 505 541 q 467 621 486 602 q 421 648 448 640 q 358 656 393 656 q 253 640 302 656 q 160 600 205 623 l 117 693 q 229 739 167 720 q 358 758 290 758 q 478 744 427 758 q 561 700 528 730 q 610 623 594 670 q 627 510 627 576 l 627 0 l 538 0 m 311 86 q 388 99 353 86 q 449 138 423 112 q 489 204 475 164 q 504 297 504 243 l 504 364 l 407 359 q 304 346 346 357 q 238 316 263 335 q 203 269 214 296 q 192 207 192 241 q 225 115 192 144 q 311 86 258 86 m 531 989 q 519 927 531 954 q 487 880 507 899 q 437 851 466 861 q 376 842 409 842 q 314 851 342 842 q 266 880 286 861 q 235 926 246 899 q 224 987 224 953 q 235 1049 224 1022 q 266 1095 246 1076 q 314 1123 286 1114 q 376 1133 342 1133 q 437 1123 408 1133 q 486 1095 465 1114 q 519 1049 507 1076 q 531 989 531 1023 m 452 987 q 430 1044 452 1023 q 376 1064 409 1064 q 320 1044 342 1064 q 299 987 299 1023 q 318 931 299 951 q 376 911 338 911 q 430 931 409 911 q 452 987 452 951 z "
    },
    "æ": {
      ha: 1157,
      x_min: 64,
      x_max: 1088,
      o: "m 64 208 q 142 379 64 319 q 380 444 220 439 l 505 449 l 505 496 q 495 572 505 541 q 467 621 486 602 q 421 648 448 640 q 358 656 393 656 q 253 640 302 656 q 160 600 205 623 l 117 693 q 229 739 167 720 q 358 758 290 758 q 503 729 447 758 q 589 637 559 701 q 680 727 623 695 q 806 758 736 758 q 924 734 871 758 q 1013 666 976 710 q 1068 561 1049 623 q 1088 425 1088 500 l 1088 349 l 632 349 q 685 156 635 218 q 835 94 735 94 q 897 98 868 94 q 952 107 926 101 q 1004 124 979 114 q 1054 146 1029 134 l 1054 36 q 1002 14 1027 23 q 950 -2 977 4 q 894 -11 923 -8 q 832 -14 865 -14 q 670 25 739 -14 q 559 142 602 64 q 511 76 536 105 q 453 27 485 47 q 381 -3 420 7 q 292 -14 342 -14 q 202 0 243 -14 q 130 40 160 13 q 81 110 99 68 q 64 208 64 151 m 192 207 q 225 115 192 144 q 311 86 258 86 q 388 99 353 86 q 449 138 423 112 q 489 204 475 164 q 504 297 504 243 l 504 364 l 407 359 q 304 346 346 357 q 238 316 263 335 q 203 269 214 296 q 192 207 192 241 m 803 656 q 685 603 728 656 q 635 449 642 550 l 954 449 q 945 533 954 495 q 918 599 937 572 q 871 641 899 626 q 803 656 842 656 z "
    },
    "ç": {
      ha: 643,
      x_min: 77,
      x_max: 596,
      o: "m 403 -14 q 275 8 334 -14 q 171 76 215 29 q 102 194 127 122 q 77 368 77 267 q 102 549 77 475 q 173 670 128 623 q 279 737 218 716 q 408 758 339 758 q 512 747 461 758 q 596 718 562 735 l 559 614 q 525 627 544 621 q 486 638 506 633 q 446 647 465 644 q 408 650 426 650 q 253 582 302 650 q 204 370 204 513 q 253 160 204 227 q 403 94 302 94 q 502 107 458 94 q 583 136 547 119 l 583 26 q 505 -3 547 7 q 403 -14 463 -14 m 495 -195 q 447 -297 495 -260 q 298 -334 399 -334 q 268 -332 283 -334 q 242 -328 252 -330 l 242 -254 q 269 -257 252 -256 q 296 -258 286 -258 q 372 -244 345 -258 q 399 -196 399 -229 q 390 -168 399 -180 q 366 -147 381 -156 q 329 -132 350 -138 q 282 -119 307 -125 l 343 0 l 425 0 l 387 -78 q 429 -92 410 -83 q 464 -115 449 -101 q 487 -149 478 -129 q 495 -195 495 -168 z "
    },
    "è": {
      ha: 743,
      x_min: 77,
      x_max: 673,
      o: "m 412 -14 q 276 12 338 -14 q 170 85 214 37 q 101 204 125 133 q 77 367 77 275 q 99 532 77 459 q 162 655 121 604 q 259 732 203 705 q 385 758 316 758 q 505 734 452 758 q 596 666 559 710 q 653 561 633 623 q 673 425 673 500 l 673 349 l 204 349 q 259 156 208 218 q 414 94 311 94 q 478 98 448 94 q 535 107 507 101 q 588 124 562 114 q 640 146 614 134 l 640 36 q 587 14 613 23 q 533 -2 561 4 q 476 -11 506 -8 q 412 -14 447 -14 m 382 656 q 259 603 304 656 q 207 449 214 550 l 541 449 q 531 533 541 495 q 503 599 522 572 q 454 641 484 626 q 382 656 424 656 m 460 842 l 378 842 q 327 889 355 861 q 273 947 299 917 q 225 1004 247 977 q 193 1050 204 1031 l 193 1064 l 342 1064 q 367 1014 353 1041 q 397 959 382 986 q 429 905 413 931 q 460 860 446 880 l 460 842 z "
    },
    "é": {
      ha: 743,
      x_min: 77,
      x_max: 673,
      o: "m 412 -14 q 276 12 338 -14 q 170 85 214 37 q 101 204 125 133 q 77 367 77 275 q 99 532 77 459 q 162 655 121 604 q 259 732 203 705 q 385 758 316 758 q 505 734 452 758 q 596 666 559 710 q 653 561 633 623 q 673 425 673 500 l 673 349 l 204 349 q 259 156 208 218 q 414 94 311 94 q 478 98 448 94 q 535 107 507 101 q 588 124 562 114 q 640 146 614 134 l 640 36 q 587 14 613 23 q 533 -2 561 4 q 476 -11 506 -8 q 412 -14 447 -14 m 382 656 q 259 603 304 656 q 207 449 214 550 l 541 449 q 531 533 541 495 q 503 599 522 572 q 454 641 484 626 q 382 656 424 656 m 322 860 q 353 905 337 880 q 385 959 369 931 q 415 1014 401 986 q 440 1064 429 1041 l 589 1064 l 589 1050 q 556 1004 578 1031 q 509 947 535 977 q 455 889 483 917 q 404 842 428 861 l 322 842 l 322 860 z "
    },
    "ê": {
      ha: 743,
      x_min: 77,
      x_max: 673,
      o: "m 412 -14 q 276 12 338 -14 q 170 85 214 37 q 101 204 125 133 q 77 367 77 275 q 99 532 77 459 q 162 655 121 604 q 259 732 203 705 q 385 758 316 758 q 505 734 452 758 q 596 666 559 710 q 653 561 633 623 q 673 425 673 500 l 673 349 l 204 349 q 259 156 208 218 q 414 94 311 94 q 478 98 448 94 q 535 107 507 101 q 588 124 562 114 q 640 146 614 134 l 640 36 q 587 14 613 23 q 533 -2 561 4 q 476 -11 506 -8 q 412 -14 447 -14 m 382 656 q 259 603 304 656 q 207 449 214 550 l 541 449 q 531 533 541 495 q 503 599 522 572 q 454 641 484 626 q 382 656 424 656 m 602 842 l 520 842 q 449 898 486 865 q 377 968 412 930 q 304 898 340 930 q 234 842 269 865 l 152 842 l 152 860 q 193 905 170 880 q 238 959 216 931 q 281 1014 261 986 q 312 1064 301 1041 l 442 1064 q 473 1014 453 1041 q 516 959 493 986 q 562 905 538 931 q 602 860 585 880 l 602 842 z "
    },
    "ë": {
      ha: 743,
      x_min: 77,
      x_max: 673,
      o: "m 412 -14 q 276 12 338 -14 q 170 85 214 37 q 101 204 125 133 q 77 367 77 275 q 99 532 77 459 q 162 655 121 604 q 259 732 203 705 q 385 758 316 758 q 505 734 452 758 q 596 666 559 710 q 653 561 633 623 q 673 425 673 500 l 673 349 l 204 349 q 259 156 208 218 q 414 94 311 94 q 478 98 448 94 q 535 107 507 101 q 588 124 562 114 q 640 146 614 134 l 640 36 q 587 14 613 23 q 533 -2 561 4 q 476 -11 506 -8 q 412 -14 447 -14 m 382 656 q 259 603 304 656 q 207 449 214 550 l 541 449 q 531 533 541 495 q 503 599 522 572 q 454 641 484 626 q 382 656 424 656 m 182 946 q 201 999 182 983 q 248 1015 220 1015 q 294 999 274 1015 q 313 946 313 982 q 294 893 313 910 q 248 876 274 876 q 201 893 220 876 q 182 946 182 910 m 437 946 q 456 999 437 983 q 502 1015 475 1015 q 527 1011 515 1015 q 547 999 538 1007 q 562 977 556 990 q 567 946 567 964 q 547 893 567 910 q 502 876 528 876 q 456 893 475 876 q 437 946 437 910 z "
    },
    "ì": {
      ha: 359,
      x_min: -23,
      x_max: 243,
      o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 243 842 l 162 842 q 111 889 138 861 q 57 947 83 917 q 9 1004 31 977 q -23 1050 -12 1031 l -23 1064 l 125 1064 q 151 1014 136 1041 q 181 959 165 986 q 213 905 197 931 q 243 860 229 880 l 243 842 z "
    },
    "í": {
      ha: 359,
      x_min: 118,
      x_max: 392,
      o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 125 860 q 156 905 140 880 q 188 959 172 931 q 218 1014 204 986 q 243 1064 233 1041 l 392 1064 l 392 1050 q 360 1004 381 1031 q 312 947 338 977 q 259 889 286 917 q 208 842 231 861 l 125 842 l 125 860 z "
    },
    "î": {
      ha: 359,
      x_min: -45,
      x_max: 405,
      o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 405 842 l 323 842 q 252 898 288 865 q 180 968 215 930 q 107 898 143 930 q 37 842 71 865 l -45 842 l -45 860 q -5 905 -28 880 q 41 959 18 931 q 84 1014 64 986 q 115 1064 104 1041 l 245 1064 q 276 1014 256 1041 q 318 959 296 986 q 365 905 341 931 q 405 860 388 880 l 405 842 z "
    },
    "ï": {
      ha: 359,
      x_min: -12,
      x_max: 372,
      o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m -12 946 q 7 999 -12 983 q 53 1015 26 1015 q 99 999 79 1015 q 119 946 119 982 q 99 893 119 910 q 53 876 79 876 q 7 893 26 876 q -12 946 -12 910 m 242 946 q 261 999 242 983 q 307 1015 280 1015 q 332 1011 320 1015 q 353 999 344 1007 q 367 977 361 990 q 372 946 372 964 q 353 893 372 910 q 307 876 333 876 q 261 893 280 876 q 242 946 242 910 z "
    },
    "ð": {
      ha: 802,
      x_min: 75,
      x_max: 725,
      o: "m 725 389 q 702 218 725 292 q 637 92 680 143 q 534 13 595 40 q 399 -14 474 -14 q 269 9 328 -14 q 166 74 210 31 q 99 180 123 117 q 75 323 75 243 q 97 467 75 404 q 158 572 118 529 q 255 636 198 614 q 383 659 312 659 q 505 638 452 659 q 586 578 557 618 l 591 581 q 530 726 570 661 q 428 846 489 791 l 254 742 l 204 819 l 351 908 q 295 946 324 927 q 235 982 267 964 l 282 1065 q 368 1019 326 1044 q 449 965 409 995 l 603 1059 l 653 982 l 521 903 q 604 806 566 859 q 668 689 642 753 q 710 551 695 626 q 725 389 725 476 m 597 357 q 586 431 597 395 q 551 495 574 467 q 490 540 527 523 q 401 557 452 557 q 312 541 349 557 q 252 496 275 526 q 217 421 228 466 q 205 319 205 377 q 217 225 205 268 q 252 153 228 183 q 313 105 276 122 q 401 89 350 89 q 552 156 506 89 q 597 357 597 224 z "
    },
    "ñ": {
      ha: 818,
      x_min: 118,
      x_max: 707,
      o: "m 583 0 l 583 479 q 548 612 583 568 q 436 656 512 656 q 344 638 381 656 q 284 586 307 621 q 251 501 261 551 q 241 386 241 451 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 243 644 q 283 695 260 673 q 334 730 307 716 q 393 751 362 745 q 457 758 425 758 q 644 693 581 758 q 707 486 707 629 l 707 0 l 583 0 m 515 843 q 461 855 488 843 q 408 881 434 867 q 359 908 382 896 q 313 920 335 920 q 267 902 283 920 q 241 842 250 884 l 170 842 q 185 916 174 882 q 214 972 196 949 q 257 1008 232 996 q 313 1021 282 1021 q 369 1009 342 1021 q 422 983 397 997 q 472 957 448 968 q 515 945 495 945 q 561 962 545 945 q 587 1022 576 980 l 658 1022 q 643 948 654 981 q 614 892 632 916 q 571 856 596 869 q 515 843 546 843 z "
    },
    "ò": {
      ha: 802,
      x_min: 77,
      x_max: 725,
      o: "m 725 374 q 702 209 725 281 q 637 87 680 136 q 534 12 595 38 q 399 -14 474 -14 q 270 12 329 -14 q 168 87 211 38 q 101 209 125 136 q 77 374 77 281 q 99 537 77 466 q 164 658 122 609 q 267 733 206 707 q 403 758 328 758 q 532 733 473 758 q 634 658 591 707 q 701 537 677 609 q 725 374 725 466 m 204 374 q 251 160 204 232 q 401 89 297 89 q 552 160 506 89 q 597 374 597 232 q 551 586 597 515 q 400 656 505 656 q 250 586 296 656 q 204 374 204 515 m 506 842 l 425 842 q 373 889 401 861 q 319 947 345 917 q 272 1004 293 977 q 239 1050 250 1031 l 239 1064 l 388 1064 q 413 1014 399 1041 q 444 959 428 986 q 475 905 459 931 q 506 860 492 880 l 506 842 z "
    },
    "ó": {
      ha: 802,
      x_min: 77,
      x_max: 725,
      o: "m 725 374 q 702 209 725 281 q 637 87 680 136 q 534 12 595 38 q 399 -14 474 -14 q 270 12 329 -14 q 168 87 211 38 q 101 209 125 136 q 77 374 77 281 q 99 537 77 466 q 164 658 122 609 q 267 733 206 707 q 403 758 328 758 q 532 733 473 758 q 634 658 591 707 q 701 537 677 609 q 725 374 725 466 m 204 374 q 251 160 204 232 q 401 89 297 89 q 552 160 506 89 q 597 374 597 232 q 551 586 597 515 q 400 656 505 656 q 250 586 296 656 q 204 374 204 515 m 321 860 q 352 905 336 880 q 384 959 368 931 q 414 1014 399 986 q 439 1064 428 1041 l 587 1064 l 587 1050 q 555 1004 576 1031 q 508 947 534 977 q 454 889 481 917 q 403 842 427 861 l 321 842 l 321 860 z "
    },
    "ô": {
      ha: 802,
      x_min: 77,
      x_max: 725,
      o: "m 725 374 q 702 209 725 281 q 637 87 680 136 q 534 12 595 38 q 399 -14 474 -14 q 270 12 329 -14 q 168 87 211 38 q 101 209 125 136 q 77 374 77 281 q 99 537 77 466 q 164 658 122 609 q 267 733 206 707 q 403 758 328 758 q 532 733 473 758 q 634 658 591 707 q 701 537 677 609 q 725 374 725 466 m 204 374 q 251 160 204 232 q 401 89 297 89 q 552 160 506 89 q 597 374 597 232 q 551 586 597 515 q 400 656 505 656 q 250 586 296 656 q 204 374 204 515 m 622 842 l 540 842 q 469 898 505 865 q 397 968 432 930 q 324 898 360 930 q 254 842 288 865 l 172 842 l 172 860 q 212 905 189 880 q 258 959 235 931 q 301 1014 281 986 q 332 1064 321 1041 l 462 1064 q 493 1014 473 1041 q 535 959 513 986 q 582 905 558 931 q 622 860 605 880 l 622 842 z "
    },
    "õ": {
      ha: 802,
      x_min: 77,
      x_max: 725,
      o: "m 725 374 q 702 209 725 281 q 637 87 680 136 q 534 12 595 38 q 399 -14 474 -14 q 270 12 329 -14 q 168 87 211 38 q 101 209 125 136 q 77 374 77 281 q 99 537 77 466 q 164 658 122 609 q 267 733 206 707 q 403 758 328 758 q 532 733 473 758 q 634 658 591 707 q 701 537 677 609 q 725 374 725 466 m 204 374 q 251 160 204 232 q 401 89 297 89 q 552 160 506 89 q 597 374 597 232 q 551 586 597 515 q 400 656 505 656 q 250 586 296 656 q 204 374 204 515 m 499 843 q 445 855 472 843 q 393 881 418 867 q 343 908 367 896 q 298 920 319 920 q 251 902 267 920 q 225 842 235 884 l 155 842 q 169 916 158 882 q 198 972 180 949 q 241 1008 216 996 q 298 1021 267 1021 q 354 1009 326 1021 q 407 983 381 997 q 456 957 433 968 q 499 945 479 945 q 545 962 530 945 q 571 1022 561 980 l 642 1022 q 628 948 639 981 q 598 892 616 916 q 555 856 581 869 q 499 843 530 843 z "
    },
    "ö": {
      ha: 802,
      x_min: 77,
      x_max: 725,
      o: "m 725 374 q 702 209 725 281 q 637 87 680 136 q 534 12 595 38 q 399 -14 474 -14 q 270 12 329 -14 q 168 87 211 38 q 101 209 125 136 q 77 374 77 281 q 99 537 77 466 q 164 658 122 609 q 267 733 206 707 q 403 758 328 758 q 532 733 473 758 q 634 658 591 707 q 701 537 677 609 q 725 374 725 466 m 204 374 q 251 160 204 232 q 401 89 297 89 q 552 160 506 89 q 597 374 597 232 q 551 586 597 515 q 400 656 505 656 q 250 586 296 656 q 204 374 204 515 m 203 946 q 222 999 203 983 q 269 1015 241 1015 q 315 999 295 1015 q 334 946 334 982 q 315 893 334 910 q 269 876 295 876 q 222 893 241 876 q 203 946 203 910 m 458 946 q 477 999 458 983 q 523 1015 496 1015 q 548 1011 536 1015 q 568 999 559 1007 q 583 977 577 990 q 588 946 588 964 q 568 893 588 910 q 523 876 549 876 q 477 893 496 876 q 458 946 458 910 z "
    },
    "÷": {
      ha: 765,
      x_min: 69,
      x_max: 696,
      o: "m 69 439 l 69 541 l 696 541 l 696 439 l 69 439 m 304 253 q 311 293 304 277 q 327 319 317 309 q 352 333 338 329 q 382 338 366 338 q 412 333 397 338 q 437 319 426 329 q 454 293 448 309 q 460 253 460 277 q 454 215 460 231 q 437 188 448 199 q 412 173 426 178 q 382 168 397 168 q 352 173 366 168 q 327 188 338 178 q 311 215 317 199 q 304 253 304 231 m 304 726 q 311 766 304 750 q 327 792 317 782 q 352 807 338 802 q 382 811 366 811 q 412 807 397 811 q 437 792 426 802 q 454 766 448 782 q 460 726 460 750 q 454 688 460 704 q 437 662 448 672 q 412 646 426 651 q 382 642 397 642 q 352 646 366 642 q 327 662 338 651 q 311 688 317 672 q 304 726 304 704 z "
    },
    "ø": {
      ha: 802,
      x_min: 78,
      x_max: 726,
      o: "m 726 374 q 704 209 726 281 q 638 87 681 136 q 536 12 596 38 q 400 -14 475 -14 q 249 22 315 -14 l 203 -52 l 114 -1 l 168 87 q 102 209 125 136 q 78 374 78 281 q 101 537 78 466 q 165 658 123 609 q 268 733 208 707 q 404 758 329 758 q 485 748 447 758 q 557 720 524 739 l 603 793 l 692 743 l 637 656 q 703 535 680 606 q 726 374 726 465 m 205 374 q 212 272 205 317 q 233 193 218 228 l 503 632 q 457 650 483 644 q 401 656 432 656 q 251 586 297 656 q 205 374 205 515 m 599 374 q 572 549 599 481 l 302 111 q 348 94 323 100 q 403 89 372 89 q 553 160 507 89 q 599 374 599 232 z "
    },
    "ù": {
      ha: 818,
      x_min: 111,
      x_max: 700,
      o: "m 600 0 l 582 100 l 575 100 q 535 49 558 71 q 484 14 511 28 q 425 -7 456 0 q 361 -14 393 -14 q 252 2 299 -14 q 174 51 205 18 q 127 136 143 84 q 111 258 111 187 l 111 745 l 235 745 l 235 265 q 271 133 235 177 q 382 89 307 89 q 474 106 437 89 q 534 158 511 124 q 567 243 557 193 q 576 358 576 293 l 576 745 l 700 745 l 700 0 l 600 0 m 470 842 l 389 842 q 337 889 365 861 q 283 947 309 917 q 236 1004 257 977 q 203 1050 214 1031 l 203 1064 l 352 1064 q 377 1014 363 1041 q 408 959 392 986 q 439 905 423 931 q 470 860 456 880 l 470 842 z "
    },
    "ú": {
      ha: 818,
      x_min: 111,
      x_max: 700,
      o: "m 600 0 l 582 100 l 575 100 q 535 49 558 71 q 484 14 511 28 q 425 -7 456 0 q 361 -14 393 -14 q 252 2 299 -14 q 174 51 205 18 q 127 136 143 84 q 111 258 111 187 l 111 745 l 235 745 l 235 265 q 271 133 235 177 q 382 89 307 89 q 474 106 437 89 q 534 158 511 124 q 567 243 557 193 q 576 358 576 293 l 576 745 l 700 745 l 700 0 l 600 0 m 332 860 q 362 905 347 880 q 394 959 378 931 q 425 1014 410 986 q 450 1064 439 1041 l 598 1064 l 598 1050 q 566 1004 587 1031 q 518 947 545 977 q 465 889 492 917 q 414 842 437 861 l 332 842 l 332 860 z "
    },
    "û": {
      ha: 818,
      x_min: 111,
      x_max: 700,
      o: "m 600 0 l 582 100 l 575 100 q 535 49 558 71 q 484 14 511 28 q 425 -7 456 0 q 361 -14 393 -14 q 252 2 299 -14 q 174 51 205 18 q 127 136 143 84 q 111 258 111 187 l 111 745 l 235 745 l 235 265 q 271 133 235 177 q 382 89 307 89 q 474 106 437 89 q 534 158 511 124 q 567 243 557 193 q 576 358 576 293 l 576 745 l 700 745 l 700 0 l 600 0 m 631 842 l 549 842 q 477 898 514 865 q 406 968 441 930 q 333 898 369 930 q 262 842 297 865 l 180 842 l 180 860 q 221 905 198 880 q 267 959 244 931 q 310 1014 290 986 q 340 1064 330 1041 l 471 1064 q 502 1014 481 1041 q 544 959 522 986 q 590 905 567 931 q 631 860 614 880 l 631 842 z "
    },
    "ü": {
      ha: 818,
      x_min: 111,
      x_max: 700,
      o: "m 600 0 l 582 100 l 575 100 q 535 49 558 71 q 484 14 511 28 q 425 -7 456 0 q 361 -14 393 -14 q 252 2 299 -14 q 174 51 205 18 q 127 136 143 84 q 111 258 111 187 l 111 745 l 235 745 l 235 265 q 271 133 235 177 q 382 89 307 89 q 474 106 437 89 q 534 158 511 124 q 567 243 557 193 q 576 358 576 293 l 576 745 l 700 745 l 700 0 l 600 0 m 210 946 q 229 999 210 983 q 275 1015 248 1015 q 321 999 301 1015 q 340 946 340 982 q 321 893 340 910 q 275 876 301 876 q 229 893 248 876 q 210 946 210 910 m 464 946 q 483 999 464 983 q 529 1015 502 1015 q 554 1011 542 1015 q 574 999 566 1007 q 589 977 583 990 q 594 946 594 964 q 574 893 594 910 q 529 876 555 876 q 483 893 502 876 q 464 946 464 910 z "
    },
    "ý": {
      ha: 679,
      x_min: 7,
      x_max: 672,
      o: "m 7 745 l 135 745 l 281 329 q 300 272 290 302 q 318 212 310 242 q 333 155 327 182 q 342 103 339 127 l 346 103 q 357 149 349 120 q 373 211 364 178 q 392 276 382 244 q 410 330 402 308 l 545 745 l 672 745 l 378 -97 q 337 -196 359 -152 q 286 -270 315 -239 q 217 -317 256 -300 q 123 -334 178 -334 q 62 -330 88 -334 q 18 -322 37 -326 l 18 -224 q 54 -230 33 -227 q 100 -232 76 -232 q 156 -224 132 -232 q 197 -201 180 -216 q 228 -165 215 -186 q 250 -115 240 -143 l 289 -7 l 7 745 m 276 860 q 307 905 291 880 q 339 959 323 931 q 369 1014 355 986 q 394 1064 383 1041 l 543 1064 l 543 1050 q 510 1004 532 1031 q 463 947 489 977 q 409 889 437 917 q 358 842 382 861 l 276 842 l 276 860 z "
    },
    "þ": {
      ha: 814,
      x_min: 118,
      x_max: 737,
      o: "m 241 644 q 277 689 257 668 q 322 725 296 709 q 381 749 349 740 q 454 758 414 758 q 570 734 518 758 q 660 661 623 709 q 717 541 696 612 q 737 374 737 469 q 717 206 737 278 q 660 85 696 134 q 570 11 623 36 q 454 -14 518 -14 q 382 -5 414 -14 q 323 19 349 4 q 277 53 297 33 q 241 94 257 73 l 233 94 q 237 50 235 71 q 240 14 239 33 q 241 -16 241 -5 l 241 -334 l 118 -334 l 118 1055 l 241 1055 l 241 745 l 236 644 l 241 644 m 431 656 q 343 640 379 656 q 286 593 308 625 q 253 513 264 561 q 241 401 243 466 l 241 374 q 251 252 241 305 q 282 162 260 199 q 340 107 304 126 q 432 89 377 89 q 567 163 524 89 q 610 375 610 237 q 567 586 610 516 q 431 656 524 656 z "
    },
    "ÿ": {
      ha: 679,
      x_min: 7,
      x_max: 672,
      o: "m 7 745 l 135 745 l 281 329 q 300 272 290 302 q 318 212 310 242 q 333 155 327 182 q 342 103 339 127 l 346 103 q 357 149 349 120 q 373 211 364 178 q 392 276 382 244 q 410 330 402 308 l 545 745 l 672 745 l 378 -97 q 337 -196 359 -152 q 286 -270 315 -239 q 217 -317 256 -300 q 123 -334 178 -334 q 62 -330 88 -334 q 18 -322 37 -326 l 18 -224 q 54 -230 33 -227 q 100 -232 76 -232 q 156 -224 132 -232 q 197 -201 180 -216 q 228 -165 215 -186 q 250 -115 240 -143 l 289 -7 l 7 745 m 155 946 q 174 999 155 983 q 220 1015 193 1015 q 266 999 246 1015 q 286 946 286 982 q 266 893 286 910 q 220 876 246 876 q 174 893 193 876 q 155 946 155 910 m 409 946 q 428 999 409 983 q 474 1015 447 1015 q 499 1011 487 1015 q 519 999 511 1007 q 534 977 528 990 q 539 946 539 964 q 519 893 539 910 q 474 876 500 876 q 428 893 447 876 q 409 946 409 910 z "
    },
    "ı": {
      ha: 359,
      x_min: 118,
      x_max: 241,
      o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 z "
    },
    "ˆ": {
      ha: 802,
      x_min: 175,
      x_max: 625,
      o: "m 625 842 l 543 842 q 472 898 509 865 q 400 968 435 930 q 328 898 363 930 q 257 842 292 865 l 175 842 l 175 860 q 216 905 193 880 q 261 959 239 931 q 304 1014 284 986 q 335 1064 324 1041 l 465 1064 q 496 1014 476 1041 q 539 959 516 986 q 585 905 562 931 q 625 860 608 880 l 625 842 z "
    },
    "˚": {
      ha: 802,
      x_min: 248,
      x_max: 554,
      o: "m 554 989 q 542 927 554 954 q 510 880 530 899 q 460 851 489 861 q 399 842 432 842 q 337 851 365 842 q 289 880 309 861 q 258 926 269 899 q 248 987 248 953 q 258 1049 248 1022 q 289 1095 269 1076 q 337 1123 309 1114 q 399 1133 365 1133 q 460 1123 431 1133 q 509 1095 488 1114 q 542 1049 530 1076 q 554 989 554 1023 m 475 987 q 453 1044 475 1023 q 399 1064 432 1064 q 343 1044 365 1064 q 322 987 322 1023 q 341 931 322 951 q 399 911 361 911 q 453 931 432 911 q 475 987 475 951 z "
    },
    "˜": {
      ha: 802,
      x_min: 175,
      x_max: 663,
      o: "m 519 843 q 466 855 492 843 q 413 881 439 867 q 363 908 387 896 q 318 920 340 920 q 271 902 288 920 q 245 842 255 884 l 175 842 q 190 916 178 882 q 219 972 201 949 q 262 1008 237 996 q 318 1021 287 1021 q 374 1009 347 1021 q 427 983 401 997 q 476 957 453 968 q 519 945 500 945 q 566 962 550 945 q 591 1022 581 980 l 663 1022 q 648 948 659 981 q 619 892 637 916 q 576 856 601 869 q 519 843 551 843 z "
    },
    "–": {
      ha: 694,
      x_min: 56,
      x_max: 639,
      o: "m 56 315 l 56 429 l 639 429 l 639 315 l 56 315 z "
    },
    "—": {
      ha: 1389,
      x_min: 56,
      x_max: 1333,
      o: "m 56 315 l 56 429 l 1333 429 l 1333 315 l 56 315 z "
    },
    "‘": {
      ha: 243,
      x_min: 16,
      x_max: 228,
      o: "m 25 652 l 16 667 q 38 745 25 703 q 67 828 52 786 q 100 912 83 870 q 135 991 118 954 l 228 991 q 208 905 218 950 q 189 816 198 861 q 173 730 180 772 q 160 652 165 688 l 25 652 z "
    },
    "’": {
      ha: 243,
      x_min: 16,
      x_max: 228,
      o: "m 218 991 l 228 977 q 205 898 218 939 q 176 815 192 857 q 143 731 160 772 q 109 652 125 690 l 16 652 q 35 737 25 692 q 54 827 45 782 q 71 913 63 871 q 83 991 78 956 l 218 991 z "
    },
    "‚": {
      ha: 347,
      x_min: 43,
      x_max: 256,
      o: "m 245 161 l 256 146 q 233 68 246 109 q 204 -16 220 26 q 171 -99 188 -58 q 136 -179 153 -141 l 43 -179 q 63 -93 53 -138 q 82 -4 73 -48 q 98 83 91 41 q 111 161 106 125 l 245 161 z "
    },
    "“": {
      ha: 504,
      x_min: 16,
      x_max: 489,
      o: "m 286 652 l 277 667 q 299 745 286 703 q 328 828 313 786 q 361 912 344 870 q 396 991 379 954 l 489 991 q 469 905 479 950 q 450 816 459 861 q 434 730 441 772 q 421 652 427 688 l 286 652 m 25 652 l 16 667 q 38 745 25 703 q 67 828 52 786 q 100 912 83 870 q 135 991 118 954 l 228 991 q 208 905 218 950 q 189 816 198 861 q 173 730 180 772 q 160 652 165 688 l 25 652 z "
    },
    "”": {
      ha: 504,
      x_min: 16,
      x_max: 489,
      o: "m 218 991 l 228 977 q 205 898 218 939 q 176 815 192 857 q 143 731 160 772 q 109 652 125 690 l 16 652 q 35 737 25 692 q 54 827 45 782 q 71 913 63 871 q 83 991 78 956 l 218 991 m 479 991 l 489 977 q 466 898 479 939 q 437 815 453 857 q 404 731 421 772 q 370 652 387 690 l 277 652 q 296 737 286 692 q 315 827 306 782 q 332 913 324 871 q 345 991 339 956 l 479 991 z "
    },
    "„": {
      ha: 608,
      x_min: 43,
      x_max: 517,
      o: "m 245 161 l 256 146 q 233 68 246 109 q 204 -16 220 26 q 171 -99 188 -58 q 136 -179 153 -141 l 43 -179 q 63 -93 53 -138 q 82 -4 73 -48 q 98 83 91 41 q 111 161 106 125 l 245 161 m 507 161 l 517 146 q 494 68 507 109 q 465 -16 481 26 q 432 -99 449 -58 q 397 -179 414 -141 l 304 -179 q 324 -93 314 -138 q 343 -4 334 -48 q 359 83 352 41 q 372 161 367 125 l 507 161 z "
    },
    "•": {
      ha: 522,
      x_min: 102,
      x_max: 421,
      o: "m 102 507 q 114 589 102 555 q 148 645 126 623 q 198 675 169 666 q 261 685 227 685 q 323 675 294 685 q 374 645 353 666 q 409 589 396 623 q 421 507 421 555 q 409 426 421 460 q 374 371 396 392 q 323 339 353 349 q 261 329 294 329 q 198 339 227 329 q 148 371 169 349 q 114 426 126 392 q 102 507 102 460 z "
    },
    "‹": {
      ha: 400,
      x_min: 56,
      x_max: 345,
      o: "m 56 375 l 265 656 l 345 603 l 183 367 l 345 131 l 265 78 l 56 357 l 56 375 z "
    },
    "›": {
      ha: 400,
      x_min: 56,
      x_max: 345,
      o: "m 345 357 l 135 78 l 56 131 l 216 367 l 56 603 l 135 656 l 345 375 l 345 357 z "
    },
    "⁄": {
      ha: 180,
      x_min: -239,
      x_max: 418,
      o: "m 418 991 l -132 0 l -239 0 l 311 991 l 418 991 z "
    }
  },
  whe = "Droid Sans",
  She = 1293,
  The = -334,
  Phe = -154,
  Che = 102,
  Ahe = {
    yMin: -492,
    xMin: -352,
    yMax: 1907,
    xMax: 1966
  },
  Ihe = 1e3,
  Lhe = {
    format: 0,
    copyright: "Digitized data copyright © 2007, Google Corporation.",
    fontFamily: "Droid Sans",
    fontSubfamily: "Regular",
    uniqueID: "Ascender - Droid Sans",
    fullName: "Droid Sans",
    version: "Version 1.00 build 113",
    postScriptName: "DroidSans",
    trademark: "Droid is a trademark of Google and may be registered in certain jurisdictions.",
    manufacturer: "Ascender Corporation",
    description: "Droid Sans is a humanist sans serif typeface designed for user interfaces and electronic communication.",
    manufacturerURL: "http://www.ascendercorp.com/",
    designerURL: "http://www.ascendercorp.com/typedesigners.html",
    licence: "Licensed under the Apache License, Version 2.0",
    licenceURL: "http://®www.apache.org/licenses/LICENSE-2.0",
    compatibleFullName: "Droid Sans"
  },
  Ohe = "normal",
  Rhe = "normal",
  jm = {
    glyphs: Ehe,
    familyName: whe,
    ascender: She,
    descender: The,
    underlinePosition: Phe,
    underlineThickness: Che,
    boundingBox: Ahe,
    resolution: Ihe,
    original_font_information: Lhe,
    cssFontWeight: Ohe,
    cssFontStyle: Rhe
  },
  EC = class {
    constructor() {
      this.fonts = {}, this.getFont = this.getFont.bind(this);
    }
    getFont(t) {
      if (this.fonts[t]) return this.fonts[t];
      if (!t) return Promise.resolve(nB);
      switch (t) {
        case "arrival":
          return this.fonts[t] = import("./Arrival-7GULGCVJ.js").then(t => hc(t)), this.fonts[t];
        case "chalet-parisnineteensixty":
          return this.fonts[t] = import("./Chalet-4E7PX7WT.js").then(t => hc(t)), this.fonts[t];
        case "helvetica neue":
          return this.fonts[t] = import("./HelveticaNeue-UEVLJKVU.js").then(t => hc(t)), this.fonts[t];
        case "helvetiker":
          return this.fonts[t] = import("./Helvetiker-SNVJCSDR.js").then(t => hc(t)), this.fonts[t];
        case "lato":
          return this.fonts[t] = import("./Lato-FDCJ5GCG.js").then(t => hc(t)), this.fonts[t];
        case "myriad pro":
          return this.fonts[t] = import("./MyriadPro-NQ2DCXFB.js").then(t => hc(t)), this.fonts[t];
        case "proxima nova medium":
          return this.fonts[t] = import("./ProximaNova-MIBCMRZX.js").then(t => hc(t)), this.fonts[t];
        case "simon circular book":
          return this.fonts[t] = import("./SimonCircular-B2HEOOJY.js").then(t => hc(t)), this.fonts[t];
        default:
          return Promise.resolve(nB);
      }
    }
  };
u(EC, "FontLib");
var tB = new EC(),
  hc = u(function (t) {
    let e = {},
      n = {};
    Object.keys(jm.glyphs).forEach(function (t) {
      n[t] = jm.glyphs[t];
    }), Object.keys(t.glyphs).forEach(function (e) {
      n[e] = t.glyphs[e];
    }), Object.keys(jm).forEach(function (t) {
      e[t] = jm[t];
    }), e.glyphs = n;
    let i = new DE(e);
    i._mSupportedCharacters = Object.keys(e.glyphs).join("");
    let r = i._mSupportedCharacters.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    return i._mInvalidCharacters = new RegExp("[^" + r + "]", "g"), i;
  }, "createFont"),
  nB = hc(jm);
E();
var Ey = "x",
  wy = "y",
  sp = "z";
function wC(t, e, n) {
  t.computeBoundingBox();
  let i = t.boundingBox,
    r = Math.max(n.width, n.height) / 1e3,
    o = Math.max(n.width * r, n.height * r),
    s = {
      min: new ne(0, 0, 0),
      max: new ne(1, 1, 1).multiplyScalar(o)
    },
    a = {};
  e.forEach(t => {
    a[t.name] = t;
  });
  let l,
    h,
    c = t.getAttribute("position"),
    p = t.getAttribute("normal"),
    d = t.getAttribute("uv");
  ke.assert(c.count == p.count), ke.assert(c.count == d.count), t.index ? (ke.assert(t.index.count % 3 == 0), l = t.index.count / 3, h = u(function (e, n) {
    return t.index.getX(3 * e + n);
  }, "meshIndex")) : (ke.assert(c.count % 3 == 0), l = c.count / 3, h = u(function (t, e) {
    return 3 * t + e;
  }, "meshIndex"));
  let f = a.side || {},
    m = a.front || {},
    g = null != f.repeat ? f.repeat.u : 1,
    v = null != f.repeat ? f.repeat.v : 1,
    y = null != f.offset ? f.offset.u : 1,
    _ = null != f.offset ? f.offset.v : 1,
    x = null != f.rotation ? f.rotation : 0,
    E = f.useLocalScaling || !1,
    b = null != m.repeat ? m.repeat.u : 1,
    w = null != m.repeat ? m.repeat.v : 1,
    S = null != m.offset ? m.offset.u : 1,
    M = null != m.offset ? m.offset.v : 1,
    T = null != m.rotation ? m.rotation : 0,
    A = m.useLocalScaling || !1;
  for (let t = 0; t < l; ++t) {
    let e = p.getX(h(t, 0)) + p.getX(h(t, 1)) + p.getX(h(t, 2)),
      n = p.getY(h(t, 0)) + p.getY(h(t, 1)) + p.getY(h(t, 2)),
      r = p.getZ(h(t, 0)) + p.getZ(h(t, 1)) + p.getZ(h(t, 2)),
      o = Math.abs(e),
      a = Math.abs(n),
      l = Math.abs(r);
    var P, C, I, N, L, R, O, q;
    o <= a && o <= l ? (P = Ey, C = a <= l ? wy : sp) : a <= o && a <= l ? (P = wy, C = o <= l ? Ey : sp) : (P = sp, C = o <= a ? Ey : wy), P === sp && (P = C, C = sp), C === sp || P === sp ? (I = g, N = v, L = y, R = _, O = x, q = E ? i : s) : (I = b, N = w, L = S, R = M, O = T, q = A ? i : s);
    let u = q.min,
      f = q.max,
      m = Math.abs(f[P] - u[P]),
      F = Math.abs(f[C] - u[C]),
      U = O * Math.PI / 180 || 0,
      B = Math.cos(U),
      z = Math.sin(U);
    for (let e = 0; e < 3; e++) {
      let n = c.getX(h(t, e)),
        i = c.getY(h(t, e)),
        r = c.getZ(h(t, e));
      var D, k;
      D = P === Ey ? I * (n - u[P]) / m + L : P === wy ? I * (i - u[P]) / m + L : I * (r - u[P]) / m + L, k = C === Ey ? N * (n - u[C]) / F + R : C === wy ? N * (i - u[C]) / F + R : N * (r - u[C]) / F + R;
      let o = (D -= .5) * B - (k -= .5) * z + .5,
        s = D * z + k * B + .5;
      d.setX(h(t, e), o), d.setY(h(t, e), s);
    }
  }
  t.uvsNeedUpdate = !0;
}
u(wC, "updateUVs");
var ai = class extends Ta {
    constructor(t, e, n, i, r = Or.SINGLE_GEOMETRY) {
      var o, s;
      super(), A(this, "polygon"), A(this, "mapClass"), A(this, "container"), A(this, "visible"), A(this, "mode"), A(this, "assetManager"), A(this, "imageVisible"), A(this, "labelVisible"), A(this, "boundingBox"), A(this, "polygonHeight"), A(this, "geometry"), A(this, "mesh"), A(this, "material"), A(this, "labelMesh"), A(this, "imageMesh"), this.mode = r, this.polygon = t, this.mapClass = e, this.container = n, this.assetManager = i;
      let a = !1 !== t.geometry.visible,
        l = !0 === (null == (o = t.image) ? void 0 : o.visible) && (null != t.image.url || null != t.image.original),
        u = !0 === (null == (s = t.label) ? void 0 : s.visible) && null != t.label.text;
      (a || l || u) && ai._setPolygonDefaults(t), this.visible = a, this.imageVisible = l, this.labelVisible = u, this.load = this.load.bind(this);
    }
    static getDefaultMaterial() {
      return ai.defaultMaterial || (ai.defaultMaterial = new Ol({
        color: 0
      })), ai.defaultMaterial;
    }
    static getWeightedCenter(t) {
      let e = t.reduce((t, e) => ({
        x: t.x + e.x,
        y: t.y + e.y
      }), {
        x: 0,
        y: 0
      });
      return e.x /= t.length, e.y /= t.length, e;
    }
    static getBoundingCentre(t) {
      let e = 1 / 0,
        n = 1 / 0,
        i = -1 / 0,
        r = -1 / 0;
      return t.forEach(t => {
        t.x > i && (i = t.x), t.x < e && (e = t.x), t.y > r && (r = t.y), t.y < n && (n = t.y);
      }), {
        x: (e + i) / 2,
        y: (n + r) / 2
      };
    }
    static _makeFromCoords(t, e, n) {
      let i = new t();
      return i.moveTo(e[0].x - n.width / 2, -e[0].y + n.height / 2), e.slice(1).forEach(t => i.lineTo(t.x - n.width / 2, -t.y + n.height / 2)), i.lineTo(e[0].x - n.width / 2, -e[0].y + n.height / 2), i;
    }
    static _setPolygonDefaults(t) {
      let e = {
        visible: !0,
        position: {
          x: 0,
          y: 0,
          z: 0
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0
        },
        scale: {
          x: 1,
          y: 1,
          z: 5
        },
        bevel: {
          size: 0,
          thickness: 0,
          segments: 1
        },
        offset: 0
      };
      return t.layer || (t.layer = "Polygon"), t.geometry = (0, fc.default)(t.geometry, e), t.geometry.bevel = (0, fc.default)(t.geometry.bevel, e.bevel), t.image && (t.image.position = (0, fc.default)(t.image.position, e.position), t.image.rotation = (0, fc.default)(t.image.rotation, e.rotation), t.image.scale = (0, fc.default)(t.image.scale, e.scale)), t.label && (t.label.position = (0, fc.default)(t.label.position, e.position), t.label.rotation = (0, fc.default)(t.label.rotation, e.rotation), t.label.scale = (0, fc.default)(t.label.scale, e.scale), t.label.color = t.label.color || "#000000", t.label.fontSize = t.label.fontSize || 20), t;
    }
    getBoundingBox() {
      if (this.boundingBox) return this.boundingBox;
      let t = 1 / 0,
        e = 1 / 0,
        n = -1 / 0,
        i = -1 / 0,
        r = -this.mapClass.width / 2,
        o = this.mapClass.height / 2;
      return this.polygon.vertexes.forEach(s => {
        s.x + r > n && (n = s.x + r), s.x + r < t && (t = s.x + r), -s.y + o > i && (i = -s.y + o), -s.y + o < e && (e = -s.y + o);
      }), this.boundingBox = {
        min: {
          x: t,
          y: e,
          z: 0
        },
        max: {
          x: n,
          y: i,
          z: 0
        }
      }, this.boundingBox;
    }
    async load() {
      var t;
      let e = this.polygon,
        n = this.mapClass;
      if (this.visible) {
        let i = e.vertexes,
          r = Math.max(n.width, n.height) / 1e3;
        (this.imageVisible || e.geometry.offset) && (i = ai._clip(i, 0), i = ai._clip(i, e.geometry.offset), e.vertexes = i);
        let o,
          s = ai._makeFromCoords(Qa, i, n);
        e.holes && (s.holes = e.holes.map(t => ai._makeFromCoords(mf, t, n))), o = e.geometry.bevel ? {
          bevelEnabled: !0,
          depth: e.geometry.scale.z * r,
          bevelThickness: e.geometry.bevel.thickness * e.geometry.scale.z * r,
          bevelSize: e.geometry.bevel.size * r,
          bevelSegments: e.geometry.bevel.segments || 1
        } : {
          bevelEnabled: !1,
          depth: e.geometry.scale.z * r
        }, this.polygonHeight = e.geometry.scale.z * Math.max(this.mapClass.width, this.mapClass.height) / 1e3;
        let a = Array.isArray(e.textures) && e.textures.filter(t => t.image && Object.keys(t.image).length).length,
          l = ai._normalizeColor(e.material.color),
          u = null != (t = e.material.opacity) ? t : 1;
        if (this.geometry = new $a(s, o), a && Array.isArray(e.textures)) {
          let t,
            i,
            r = e.textures.find(t => "front" === t.name),
            o = e.textures.find(t => "side" === t.name),
            s = o && o.useFrontFaceImage,
            a = r && r.image && (r.image.url || r.image.original),
            h = o && o.image && (o.image.url || o.image.original);
          wC(this.geometry, e.textures, n), a && (t = await this.assetManager.loadImage(a), t.mapping = Lg, t.wrapS = Br, t.wrapT = Br, t.anisotropy = 16), !s && h ? (i = await this.assetManager.loadImage(h), i.mapping = Lg, i.wrapS = Br, i.wrapT = Br, i.anisotropy = 16) : t && (i = t);
          let c = {
            color: l,
            transparent: !0,
            opacity: u,
            side: u < 1 ? Us : ja
          };
          this.material = i === t ? new Ol({
            ...c,
            map: t
          }) : [new Ol({
            ...c,
            map: t
          }), new Ol({
            ...c,
            map: i
          })];
        } else this.material = ai._getMaterial(e.material.color, u, e.map);
        this.mesh = new Ft(this.geometry, this.mode === Or.MULTI_GEOMETRY ? this.material : ai.hoverMeshMaterial), this.mesh.name = e.id, Array.isArray(this.mesh.material) || (this.mesh.material.needsUpdate = !0), this.mode === Or.MULTI_GEOMETRY ? (this.mesh.translateZ(e.geometry.position.z * r), this.container.add(this.mesh)) : (this.geometry.translate(0, 0, e.geometry.position.z * r), this.mesh.renderOrder = 1);
      }
      return this.imageVisible || this.labelVisible ? (this.imageVisible && this._addImage(e, n), this.labelVisible && this._addLabel(e, n), this) : this;
    }
    _addLabel(t, e) {
      var n;
      if (null == (null == (n = null == t ? void 0 : t.label) ? void 0 : n.text)) return;
      let i = Math.max(e.width, e.height) / 1e3,
        r = ai.getWeightedCenter(t.vertexes),
        o = t.label.position,
        s = t.label.rotation.z,
        a = t.label.text.split("\n");
      tB.getFont(t.label.fontFamily).then(n => {
        if (!t.label) return;
        let l = {
            font: n,
            size: t.label.fontSize * i,
            height: ai.overlayHeight,
            bevelEnabled: !1,
            curveSegments: 4,
            align: t.label.align || "left"
          },
          u = 0,
          h = a.reverse().map((t, e) => (t.length > a[u].length && (u = e), new IE(t, l))),
          c = h[u],
          p = new Ft(c),
          d = new $t().setFromObject(p).getSize(new ne()).x,
          f = ai._getMaterial(t.label.color, void 0, t.map),
          m = 0,
          g = AE(a.map((t, e) => {
            let n,
              i = h[e],
              r = new Ft(i, f),
              o = new $t().setFromObject(r).getSize(new ne());
            return n = "left" === l.align ? 0 : "right" === l.align ? d - o.x : (d - o.x) / 2, r.position.set(n, m, 0), r.geometry.translate(n, m, 0), m += 1.25 * l.size, r.geometry;
          })),
          v = new Ft(g, f);
        g.computeBoundingBox();
        let y = g.boundingBox,
          _ = y.max.x - y.min.x,
          x = y.max.y - y.min.y,
          E = t.geometry.position.z + t.geometry.scale.z;
        v.translateX(r.x - e.width / 2 + o.x - _ / 2), v.translateY(-r.y + e.height / 2 + o.y - x / 2), v.rotation.set(0, 0, s * Math.PI / 180), v.translateZ((ai.overlayHeight + E) * i), this.labelMesh = v, this.container.add(v);
      });
    }
    _addImage(t, e) {
      var n, i;
      if (null == (null == t ? void 0 : t.image)) return;
      let r = t.image.url || t.image.original;
      r instanceof Blob && (r = URL.createObjectURL(r));
      let o,
        s = new Ft(new co(1, 1)),
        a = new Ol({
          transparent: !0,
          depthWrite: !1,
          side: Us
        });
      a.userData = {
        originalOpacity: null != (n = a.opacity) ? n : 1,
        originalTransparency: null != (i = a.transparent) && i
      }, s.material = a, s.renderOrder = 2, s.name = t.id + "_image", this.container.add(s), this.imageMesh = s, ai.imagesLoadingInProgress.has(r) ? o = ai.imagesLoadingInProgress.get(r) : (o = this.assetManager.loadImage(r).then(t => (t.anisotropy = 16, [t])), ai.imagesLoadingInProgress.set(r, o)), o.then(([n]) => {
        if (null == t.image) return;
        a.map = n, a.needsUpdate = !0;
        let i,
          o = this.getBoundingBox(),
          l = Math.max(e.width, e.height) / 1e3,
          u = t.vertexes;
        i = t.image._isAbsolutelyPositioned ? {
          x: t.image.position.x,
          y: t.image.position.y
        } : t.image.fitToBounds ? ai.getBoundingCentre(u) : ai.getWeightedCenter(u);
        let h = t.image.fitToBounds || t.image._isAbsolutelyPositioned ? 0 : t.image.position.x,
          c = t.image.fitToBounds || t.image._isAbsolutelyPositioned ? 0 : t.image.position.y,
          p = t.geometry.position.z + t.geometry.scale.z;
        t.image.position && (s.position.x = i.x - e.width / 2 + h, s.position.y = -i.y + e.height / 2 + c, s.translateZ((p + t.image.position.z) * l)), t.image.rotation && s.rotation.set(t.image.rotation.x * Math.PI / 180, t.image.rotation.y * Math.PI / 180, t.image.rotation.z * Math.PI / 180);
        let d = n.image.width,
          f = n.image.height;
        "string" == typeof r && null != URL && "function" == typeof URL.revokeObjectURL && URL.revokeObjectURL(r);
        let m,
          g = {
            x: t.image.viewBox.width,
            y: t.image.viewBox.height
          };
        m = !1 === t.image.useLocalScaling ? l : Math.min(o.max.x - o.min.x, o.max.y - o.min.y) / Math.max(g.x, g.y), t.image.fitToBounds ? s.scale.set(o.max.x - o.min.x, o.max.y - o.min.y, 1) : t.image.scale && s.scale.set(t.image.scale.x * m * t.image.viewBox.width, t.image.scale.y * m * t.image.viewBox.height, 1), s.translateZ(ai.overlayHeight * l), n.repeat = new je(t.image.viewBox.width / d, t.image.viewBox.height / f), n.offset = new je(0, (n.image.height - t.image.viewBox.height) / n.image.height), n.premultiplyAlpha = !0, a.blending = x3, this.publish("texture-loaded", n);
      });
    }
    static _normalizeColor(t) {
      let e = t.replace(/#/, "");
      return 3 === e.length && (e = `${e[0]}${e[0]}${e[1]}${e[1]}${e[2]}${e[2]}`), parseInt(e, 16);
    }
    static _getMaterial(t, e, n) {
      let i,
        r = ai._normalizeColor(t),
        o = e < 1 ? r + "_" + e : r;
      if (ai.materials[n] = ai.materials[n] || {}, ai.materials[n][o]) i = ai.materials[n][o];else {
        let t = {
          color: r,
          side: e < 1 ? Us : ja
        };
        e < 1 && (t.transparent = !0, t.opacity = e), ai.materials[n][o] = new Ol(t), i = ai.materials[n][o];
      }
      return i;
    }
    static _clip(t, e) {
      e /= 2;
      let n = ai.scale,
        i = t.map(t => ({
          X: t.x * n,
          Y: t.y * n
        }));
      for (let t = 8; 0 !== t; t--) {
        let t = new My.ClipperOffset();
        t.AddPath(i, My.JoinType.jtMiter, My.EndType.etClosedPolygon);
        let r = new My.Paths();
        try {
          if (t.Execute(r, e * n), r.length) return r[0].map(t => ({
            x: t.X / n,
            y: t.Y / n
          }));
          e /= 2;
        } catch (t) {
          e /= 2;
        }
      }
      return i;
    }
  },
  ru = ai;
u(ru, "Element"), A(ru, "defaultMaterial"), A(ru, "hoverMeshMaterial", new Ol({
  color: "#333"
})), A(ru, "materials", {}), A(ru, "defaultExtrudeSettings", {
  depth: 10,
  bevelEnabled: !1
}), A(ru, "scale", 100), A(ru, "overlayHeight", .15), A(ru, "imagesLoadingInProgress", new Map());
var Sy = ru;
E();
var iB = !1,
  pc = class {
    constructor() {
      A(this, "textureLoader", new pa());
    }
    async loadMapPolygons(t) {
      return iB && ke.log("loading map: ", t.scene.polygons), (await Xs()(t.scene.polygons)).json();
    }
    loadImage(t) {
      return new Promise((e, n) => {
        iB && ke.log("loading image: ", t), this.textureLoader.load(t, t => {
          t.colorSpace = Nt, e(t);
        }, () => {}, n);
      });
    }
  };
u(pc, "DefaultAssetManager");
var SC = class {
  constructor() {
    A(this, "defaultExtrudeSettings", {
      amount: 10,
      bevelEnabled: !1
    }), A(this, "materials", {}), A(this, "scale", 100), A(this, "assetManager", new pc()), A(this, "overlayHeight", .15);
  }
  setAssetManager(t) {
    this.assetManager = t;
  }
  load(t, e, n) {
    if ("string" == typeof t) return this.assetManager.loadMapPolygons(e).then(t => null == t || 0 === t.length ? Promise.reject("No polygons found for venue") : this._build(t, e, n)).catch(t => Promise.reject(t));
    try {
      return this._build(t, e, n);
    } catch (t) {
      return Promise.reject(t);
    }
  }
  _build(t, e, n) {
    let i = new Set();
    e.layers.forEach(t => {
      !1 !== t.visible && i.add(t.id);
    });
    let r = new ha(),
      o = t.map(t => {
        let o = t.layer || "Polygon",
          s = /__.*__/.exec(o);
        return i.has(o) || s ? new Sy(t, e, r, this.assetManager, n) : null;
      }).filter(t => t);
    return Promise.resolve({
      container: r,
      elements: o,
      visibleLayers: i
    });
  }
};
u(SC, "JSONSceneLoader");
var aB,
  Ty = new SC(),
  qE = Rt(il()),
  gl = {
    VISIBLE_MAP_HIGH: 5,
    VISIBLE_MAP_LOW: 4,
    VISIBLE_MAP_MARKER: 3,
    ASYNC_MAP_HIGH: 2,
    ASYNC_MAP_LOW: 1,
    ASYNC_MAP_MARKER: 0,
    MAP_LOADED: -1
  },
  rB = new jn(),
  Nhe = 1,
  Dhe = !1,
  oB = {
    Floor: 1,
    Wall: 2,
    "Outer Wall": 2.2,
    Anchors: 4,
    Anchor: 4,
    "Anchor Store": 4,
    Polygon: 5,
    Kiosks: 6,
    "Inner Wall": 7,
    "Non Public": 7.5
  },
  sB = u(t => {
    if (oB[t.layer]) return oB[t.layer];
    let e = t.geometry.scale,
      n = t.geometry.position;
    return 100 + (e ? e.z : 1) + (n ? n.z : 0);
  }, "calculateScore"),
  TC = class extends Ta {
    constructor(t, e, n, i, r = {}) {
      super(), A(this, "_flippableImagedById", {}), A(this, "_started", !1), A(this, "_loaderPromise", null), A(this, "_promiseResolve", null), A(this, "hoverableMeshChildren", []), A(this, "visible", !1), A(this, "objectsDictionary", {}), A(this, "north", null), A(this, "mapScale", null), A(this, "object", new jn()), A(this, "labels", new Set()), A(this, "tooltips", new Set()), A(this, "markers", new Set()), A(this, "box", new $t()), A(this, "textObjects", []), A(this, "labelBatchCreator", null), A(this, "imagesToFlip", []), A(this, "seenByCamera", !1), A(this, "threeJSMarkers", new Map()), this.core = i, this.mapClass = t, this.polygonMeshesById = e, this._showCount = n, this.loadMethod = "json", this.loadAsync = r.async, this._taskScheduler = r.taskScheduler, this.id = this.mapClass.id, this.mapRenderingStrategy = (null == r ? void 0 : r.mapRenderStrategy) || Or.SINGLE_GEOMETRY, this._highPriorityTasks = new sc({
        name: "_highPriorityTasks",
        onComplete: this._checkIfLoaded.bind(this),
        priority: !this.visible && this.loadAsync ? gl.ASYNC_MAP_HIGH : gl.VISIBLE_MAP_HIGH,
        postponeOnAdd: !this.visible && !this.loadAsync
      }), this._lowPriorityTasks = new sc({
        name: "_lowPriorityTasks",
        onComplete: this._checkIfLoaded.bind(this),
        priority: !this.visible && this.loadAsync ? gl.ASYNC_MAP_LOW : gl.VISIBLE_MAP_LOW,
        postponeOnAdd: !this.visible && !this.loadAsync
      }), this._markerTasks = new sc({
        name: "_markerTasks",
        priority: !this.visible && this.loadAsync ? gl.ASYNC_MAP_MARKER : gl.VISIBLE_MAP_MARKER,
        postponeOnAdd: !this.visible
      }), this._mapLoadedTasks = new sc({
        name: "_mapLoadedTasks",
        priority: gl.MAP_LOADED,
        postponeOnAdd: !this.isReady()
      }), this._visibilityLatch = null, this._objLoadedComplete = !1, this._loaderPromise = new Promise((t, e) => {
        this._promiseResolve = t, aB = e;
      }), this._objLoaded = this._objLoaded.bind(this), this._objLoadedMerged = this._objLoadedMerged.bind(this), this.enableImageFlipping = this.enableImageFlipping.bind(this), this.destroy = this.destroy.bind(this);
    }
    fadeIn(t = {}) {
      let {
        duration: e = 300,
        delay: n = 0,
        easing: i = qE.default.Easing.Quadratic.InOut,
        onStart: r = u(() => {}, "onStart"),
        onComplete: o = u(() => {}, "onComplete"),
        layers: s = ["indoor", "outdoor", "path", "vertical-path"]
      } = t;
      return this.fade({
        direction: "in",
        duration: e,
        delay: n,
        easing: i,
        onComplete: o,
        onStart: r,
        layers: s
      });
    }
    fadeOut(t = {}) {
      let {
        duration: e = 300,
        delay: n = 0,
        easing: i = qE.default.Easing.Quadratic.InOut,
        onStart: r = u(() => {}, "onStart"),
        onComplete: o = u(() => {}, "onComplete"),
        layers: s = ["indoor", "outdoor", "path", "vertical-path"]
      } = t;
      return this.fade({
        direction: "out",
        duration: e,
        delay: n,
        easing: i,
        layers: s
      });
    }
    fade({
      direction: t = "in",
      duration: e = 300,
      delay: n = 0,
      easing: i = qE.default.Easing.Quadratic.InOut,
      onStart: r = u(() => {}, "onStart"),
      onComplete: o = u(() => {}, "onComplete"),
      layers: s = []
    }) {
      var a, l, h, c, p;
      let d = [],
        f = [];
      for (let r of this.object.children) {
        let {
          material: o
        } = r;
        if (null != o && s.includes(null == (a = o.userData) ? void 0 : a.layer)) {
          if (["vertical-path", "path"].includes(null == (l = o.userData) ? void 0 : l.layer)) {
            f.push(r);
            continue;
          }
          d.push(Nl({
            from: {
              opacity: null != (h = o.opacity) ? h : 1
            },
            to: {
              opacity: "out" === t ? 0 : null != (p = null == (c = o.userData) ? void 0 : c.originalOpacity) ? p : 1
            },
            duration: e,
            delay: n,
            easing: i,
            onStart: () => {
              "in" === t && (r.visible = !0);
            },
            onUpdate: t => {
              r.material.transparent = !0, r.material.opacity = t.opacity, r.material.needsUpdate = !0, this.core.tryRendering();
            },
            onComplete: () => {
              var e, n, i, o;
              "out" === t ? r.visible = !1 : (r.material.transparent = null != (n = null == (e = r.material.userData) ? void 0 : e.originalTransparency) && n, r.material.opacity = null != (o = null == (i = r.material.userData) ? void 0 : i.originalOpacity) ? o : 1, r.material.needsUpdate = !0);
            }
          }));
        }
      }
      return {
        start: async () => {
          r(), "out" === t && (f.forEach(t => {
            t.material.visible = !1;
          }), this.core.tryRendering()), await Promise.all(d.map(t => t.start(this.core))), "in" === t && (f.forEach(t => {
            t.material.visible = !0;
          }), this.core.tryRendering()), o();
        }
      };
    }
    async _objLoadedMerged(t) {
      if (t.elements) {
        this.elements = t.elements;
        let e = Object.values(this.elements),
          n = new ne(1 / 0, 1 / 0, 0),
          i = new ne(-1 / 0, -1 / 0, 0);
        this.boundingBox = {
          min: n,
          max: i
        }, t = t.container;
        this.object.children;
        this.object = t, this.object.userData.type = "mappedin_map", this.object.userData.mapId = this.mapClass.id, await Promise.all(e.map(t => {
          let e = t.getBoundingBox();
          return n.min(e.min), i.max(e.max), t.load();
        })).then(t => t.reduce((t, e) => {
          if (e && e.imageMesh && (this.core.outdoorGeometryLayers.includes(e.polygon.layer) ? e.imageMesh.material.userData = {
            layer: "outdoor"
          } : e.imageMesh.material.userData = {
            layer: "indoor"
          }), e && e.visible) {
            if (this.core.outdoorGeometryLayers.includes(e.polygon.layer)) {
              let n = e.material.clone();
              return n.userData = {
                layer: "outdoor"
              }, e.mesh.material = n, e.mesh.visible = !1, this._addElementToScene(e), this.object.add(e.mesh), this.hoverableMeshChildren.push(e.mesh), t.set(n, [e]), t;
            }
            t.has(e.material) || (t.set(e.material, []), e.material.userData = {
              layer: "indoor"
            });
            let n = t.get(e.material);
            this._addElementToScene(e), n.push(e), e.mesh.visible = !1, this.object.add(e.mesh), this.hoverableMeshChildren.push(e.mesh);
          }
          return t;
        }, new Map())).then(t => {
          var e, n;
          for (let [i, r] of t) {
            let t = AE(r.map(t => t.geometry), !1);
            i.userData = {
              ...i.userData,
              originalOpacity: null != (e = i.opacity) ? e : 1,
              originalTransparency: null != (n = i.transparent) && n
            };
            let o = new Ft(t, i);
            this.object.add(o);
          }
          this._promiseResolve(this);
        }).catch(t => {
          throw ke.error(t), new Error("Error loading map using SINGLE_GEOMETRY strategy");
        }), this._objLoadedComplete = !0, this._onRootObjectCreated(), this._checkIfLoaded();
      }
      return this._promiseResolve(this);
    }
    _objLoaded(t) {
      if (t.elements) {
        this.elements = t.elements;
        let e = Object.values(this.elements);
        this.loadAsync && e.sort((t, e) => (null == t.sortScore && (t.sortScore = sB(t.polygon)), null == e.sortScore && (e.sortScore = sB(e.polygon)), e.sortScore - t.sortScore));
        let n = new ne(1 / 0, 1 / 0, 0),
          i = new ne(-1 / 0, -1 / 0, 0);
        for (let t of e) {
          let e = t.getBoundingBox();
          n.min(e.min), i.max(e.max), this.loadAsync ? this._addPendingHighPriorityTask("addPolygon", () => this._addElementToScene(t)) : this._addElementToScene(t);
        }
        this.boundingBox = {
          min: n,
          max: i
        }, t = t.container;
      }
      let e = t.children;
      for (let t = 0, n = e.length; t < n; ++t) {
        let n = e[t];
        this.objectsDictionary[n.name] = n, this.polygonMeshesById[n.name] = n;
      }
      return this.object = t, this.object.userData.type = "mappedin_map", this.object.userData.mapId = this.mapClass.id, this._objLoadedComplete = !0, this._onRootObjectCreated(), this._checkIfLoaded(), this._promiseResolve(this);
    }
    loadPolygonNow(t) {
      if (!this.elements) return;
      let e = this.elements[t];
      e && this._addElementToScene(e);
    }
    _addElementToScene(t) {
      if (!this.objectsDictionary[t.polygon.id]) {
        if (t.imageVisible && t.on("texture-loaded", t => {
          this.core.publish(Xe.TEXTURE_LOADED, t);
        }), t.mesh) {
          let e = t.mesh;
          this.objectsDictionary[e.name] = e, this.polygonMeshesById[e.name] = e;
        }
        if (t.imageMesh) {
          let e = t.imageMesh;
          this.objectsDictionary[e.name] = e, this.polygonMeshesById[e.name] = e;
        }
        if (t.polygon.image) {
          let e = null != t.polygon.image.rotation ? t.polygon.image.rotation.z : 0;
          this.core._imageFlippingEnabled && this.enableImageFlipping(t.polygon.id, e * (Math.PI / 180));
        }
      }
    }
    load() {
      if (!this._started) {
        this._started = !0;
        try {
          let t = Dhe && this.core.venue.polygons.filter(t => t.map.id === this.mapClass.id),
            e = this.mapClass.scene.polygons;
          if ("json" !== this.loadMethod && void 0 !== this.loadMethod || !e && !t) throw new Error("Error parsing JSON scene");
          {
            let n = e || t;
            this.loadMethodUsed = "JSON - " + (e ? "published" : "live"), Ty.load(n, this.mapClass, this.mapRenderingStrategy).then(this.mapRenderingStrategy === Or.MULTI_GEOMETRY ? this._objLoaded : this._objLoadedMerged);
          }
        } catch (t) {
          aB("ERROR: No 3D files for map " + (this.mapClass.name || this.mapClass.shortName || this.mapClass.id || this.mapClass));
        }
      }
      return this._loaderPromise;
    }
    _dispose(t) {
      let e = t;
      for (let t = e.children.length - 1; t >= 0; t--) this._dispose(e.children[t]);
      e.destroy(), delete this.objectsDictionary[e.name], delete this.polygonMeshesById[e.name];
    }
    destroy() {
      for (let t of this.hoverableMeshChildren) t.destroy();
      this.hoverableMeshChildren = [], this.removeLabels(), this._removeThreeJSMarkers(), this.disableAllImageFlipping(), this.elements = [], this._dispose(this.object), this.objectsDictionary = {}, this.polygonMeshesById = {};
    }
    add(t) {
      rB.add(t), this.load().then(() => {
        1 === rB.children.filter(e => e.uuid === t.uuid).length && this.object.add(t);
      });
    }
    getPositionLatLon(t, e) {
      let n = this.mapClass.createCoordinate(t, e);
      return this.core.convertTo3DMapPosition(n);
    }
    addToObject(t) {
      t.applyMatrix4(new Bt().copy(this.object.matrix).invert());
      let e = 1 / this.object.scale.x;
      t.scale.set(e, e, e), this.object.add(t);
    }
    translateChild(t, e) {
      t.position.set(e.x, e.y, e.z), t.applyMatrix4(new Bt().copy(this.object.matrix).invert());
      let n = 1 / this.object.scale.x;
      t.scale.set(n, n, n);
    }
    getMapScale() {
      return null == this.mapScale && (this.mapScale = t2(this.mapClass)), this.mapScale;
    }
    getNorth() {
      return null == this.north && (this.north = h7(this.mapClass)), this.north;
    }
    enableImageFlipping(t, e) {
      if (e = e || 0, !this._flippableImagedById[t] && this.object && Object.keys(this.object).length > 0) {
        let n = this.object.getObjectByName(t + "_image");
        if (n) {
          let i = new PC({
            image: n,
            rotation: e
          });
          this.imagesToFlip.push(i), this.core.publish(Xe.UPDATE_FLIPPABLES), this.core.publish(Xe.RENDER), this._flippableImagedById[t] = !0;
        }
      }
    }
    disableAllImageFlipping() {
      for (let t = 0, e = this.imagesToFlip.length; t < e; t++) this.imagesToFlip[t].reset();
      this.imagesToFlip = [], this._flippableImagedById = {};
    }
    isReady() {
      return (this.loadAsync ? this._highPriorityTasks.isComplete() : this.isFullyLoaded()) && this._objLoadedComplete;
    }
    isFullyLoaded() {
      return this._highPriorityTasks.isComplete() && this._lowPriorityTasks.isComplete();
    }
    onVisible() {
      !0 !== this._visibilityLatch && (this.loadAsync ? (this._taskScheduler.setTaskPriority(this._highPriorityTasks, gl.VISIBLE_MAP_HIGH), this._taskScheduler.setTaskPriority(this._lowPriorityTasks, gl.VISIBLE_MAP_LOW), this._taskScheduler.resumeTask(this._markerTasks)) : (this._taskScheduler.resumeTask(this._highPriorityTasks), this._taskScheduler.resumeTask(this._lowPriorityTasks), this._taskScheduler.resumeTask(this._markerTasks)), this._visibilityLatch = !0), this.visible = !0;
    }
    onInvisible() {
      !1 !== this._visibilityLatch && (this.loadAsync ? (this._taskScheduler.setTaskPriority(this._highPriorityTasks, gl.ASYNC_MAP_HIGH), this._taskScheduler.setTaskPriority(this._lowPriorityTasks, gl.ASYNC_MAP_LOW), this._taskScheduler.postponeTask(this._markerTasks)) : (this._taskScheduler.postponeTask(this._highPriorityTasks), this._taskScheduler.postponeTask(this._lowPriorityTasks), this._taskScheduler.postponeTask(this._markerTasks)), this._visibilityLatch = !1), this.visible = !1;
    }
    addPendingMarkerTask(t, e) {
      this._taskScheduler.scheduleTask(new ji({
        name: "addMarker",
        group: this._markerTasks,
        callback: e,
        userdata: {
          marker: t
        }
      }));
    }
    addPendingLowPriorityTask(t, e) {
      this._taskScheduler.scheduleTask(new ji({
        name: t,
        group: this._lowPriorityTasks,
        callback: e
      }));
    }
    addPendingMapLoadedTask(t, e) {
      this._taskScheduler.scheduleTask(new ji({
        name: t,
        group: this._mapLoadedTasks,
        callback: e
      })), this._checkIfLoaded();
    }
    _addPendingHighPriorityTask(t, e) {
      this._taskScheduler.scheduleTask(new ji({
        name: t,
        group: this._highPriorityTasks,
        callback: e
      }));
    }
    addThreeJSMarker(t) {
      if (!(t.object instanceof jn)) throw new Error("threeJSMarker `object` must be an instance of `Object3D`");
      let e = new kE({
          mapId: this.id,
          object: t.object
        }),
        n = {
          object: t.object
        };
      return t.object.layers.set(bo.ANIMATED), null != t.position && t.object.position.copy(t.position), null != t.rotation && t.object.rotation.copy(t.rotation), null != t.scale && t.object.scale.copy(t.scale), this.threeJSMarkers.set(e, n), this._objLoadedComplete ? this.addToObject(n.object) : this.load().then(() => {
        e._deleted || this.addToObject(n.object);
      }), e;
    }
    removeThreeJSMarker(t) {
      let e = this.threeJSMarkers.get(t);
      return null != e && (t._deleted = !0, this.threeJSMarkers.delete(t), this._objLoadedComplete && this.object.remove(e.object), t._destroy(), !0);
    }
    _removeThreeJSMarkers() {
      if (this._objLoadedComplete) for (let [t, e] of this.threeJSMarkers.entries()) this.object.remove(e.object), t._destroy();
      this.threeJSMarkers.clear();
    }
    removeLabels() {
      if (this.labels.forEach(t => {
        t.disable(), t.removeSelf();
      }), this.labels = new Set(), Array.isArray(this.textObjects)) {
        for (let t = 0, e = this.textObjects.length; t < e; ++t) {
          let e = this.textObjects[t];
          e.removeSelf(!0), e = void 0;
        }
        this.textObjects = [];
      }
    }
    _checkIfLoaded() {
      this.isReady() && this._taskScheduler.scheduleTask(new ji({
        name: "onMapLoaded",
        callback: () => {
          this._taskScheduler.resumeTask(this._mapLoadedTasks), this.mapLoaded && typeof this.mapLoaded == typeof Function && (this.mapLoaded(), this.mapLoaded = null);
        }
      }));
    }
    _onRootObjectCreated() {
      for (let t in this.threeJSMarkers.values()) this.object.add(t.object);
    }
    _popinChildObjects() {
      this.loadAsync || this.mapRenderingStrategy === Or.SINGLE_GEOMETRY || this.object.traverse(t => {
        0 == t.children.length && "Mesh" == t.type && t.material.map && (t.visible = !1, this._addPendingHighPriorityTask("addPolygon", () => {
          t.visible = !0, this._showCount >= Nhe && (this._showCount = 0, this.core.publish(Xe.RENDER_NOW)), this._showCount++;
        }));
      });
    }
  };
u(TC, "MapObject");
var kE = class {
  constructor({
    mapId: t,
    object: e
  }) {
    this._mapId = t, this._object = e;
  }
  get object() {
    return this._object;
  }
  _destroy() {
    this._mapId = null, this._object = null;
  }
};
u(kE, "ThreeJSMarkerHandle");
var FE = TC;
E();
var qhe = {
    STATIC: 0,
    ANIMATED: 1,
    ALWAYS_ON_TOP: 2
  },
  bo = qhe;
E();
var khe = !1,
  BE = class extends pc {
    constructor(t) {
      super(), A(this, "venueData"), this.venueData = t;
    }
    async loadMapPolygons(t) {
      return khe && ke.log("loading map: ", t.id), Promise.resolve(this.venueData.scenes[t.id]);
    }
    async loadImage(t) {
      return new Promise((e, n) => {
        let i = t.split("/"),
          r = i[i.length - 1],
          o = "data:image/png;base64," + this.venueData.images[r];
        this.textureLoader.load(o, t => {
          t.colorSpace = Nt, e(t);
        }, () => {}, n);
      });
    }
  };
u(BE, "BundleAssetManager"), E();
var lB = "precision mediump float;\n\nuniform sampler2D textureLabel;\n\nvarying vec2 vUV;\nvarying vec3 vColor;\n\nvoid main() {\n\tgl_FragColor = texture2D(textureLabel, vUV);\n\tgl_FragColor.rgb = vColor;\n}",
  uB = "attribute vec2 position;\nattribute vec3 origin;\nattribute vec2 size;\nattribute float rotation;\nattribute vec4 uv;\nattribute vec3 color;\n\nuniform mat4 projectionMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 modelMatrix;\n\nvarying vec2 vUV;\nvarying vec3 vColor;\n\nvoid main() {\n\tvec4 mapDirectionVector = vec4(0, 1, 0, 0) * viewMatrix * modelMatrix;\n\tfloat mapDirection = atan(mapDirectionVector.y, mapDirectionVector.x);\n\n\tfloat cosRotation = cos(rotation);\n\tfloat sinRotation = sin(rotation);\n\n\tmat4 rotationMatrix = mat4(\n\t\tvec4(cosRotation, -sinRotation, 0.0, 0.0),\n\t\tvec4(sinRotation, cosRotation, 0.0, 0.0),\n\t\tvec4(0.0, 0.0, 1.0, 0.0),\n\t\tvec4(0.0, 0.0, 0.0, 1.0)\n\t);\n\n\tmat4 translate = mat4(\n\t\tvec4(1, 0, 0, 0),\n\t\tvec4(0, 1, 0, 0),\n\t\tvec4(0, 0, 1, 0),\n\t\tvec4(origin, 1)\n\t);\n\n\tgl_Position = projectionMatrix *\n\t              viewMatrix *\n\t              modelMatrix *\n\t              translate *\n\t              rotationMatrix *\n\t              (vec4(position * size - vec2(0, size.y / 2.0), 0, 1));\n\n\n\tvec2 uvStart = uv.xy;\n\tvec2 uvSize = uv.zw;\n\n\tif (sin(mapDirection + rotation) > 0.0) {\n\t\tvUV = position * uvSize + vec2(uvStart.x, uvStart.y - uvSize.y);\n\t} else {\n\t\tvUV = (vec2(1, 1) - position) * uvSize + vec2(uvStart.x, uvStart.y - uvSize.y);\t\t\n\t}\n\n\tvColor = color;\n} ",
  CC = {
    MARGIN: 2,
    HEIGHT_MARGIN: .5,
    SIZE: 1.2
  },
  AC = 56,
  Uhe = AC / CC.SIZE,
  cB = AC / 2,
  zhe = 1 / cB,
  Vhe = 64,
  hB = 16,
  UE = 4,
  IC = class {
    constructor() {
      this.x = 0, this.y = 0, this.width = 0, this.height = 0, this.layer = null, this.index = null;
    }
    layout(t, e, n, i, r, o) {
      let s,
        a = this.canvasBounds.rotation * Math.PI / 180,
        l = this.width * this.pixelsPerMu,
        u = this.height * this.pixelsPerMu;
      "left" == this.canvasBounds.align ? s = this.margin : "right" == this.canvasBounds.align ? s = this.canvasBounds.maxWidth - l - this.margin : "center" == this.canvasBounds.align && (s = (this.canvasBounds.maxWidth - l - this.margin) / 2);
      let h = s * Math.cos(a),
        c = -s * Math.sin(a),
        p = this.index;
      e.setXYZ(p, this.canvasBounds.x - t.width / 2 + h, -this.canvasBounds.y + t.height / 2 + c, this.z + .1), n.setXY(p, l, u), i.setX(p, a);
      let d = this.layer.canvas;
      r.setXYZW(p, this.x / d.width, 1 - this.y / d.height, this.width / d.width, this.height / d.height), o.setXYZ(p, this.color.r, this.color.g, this.color.b), e.needsUpdate = !0, n.needsUpdate = !0, i.needsUpdate = !0, r.needsUpdate = !0, o.needsUpdate = !0;
    }
  };
u(IC, "Label");
var dc = class {
  constructor(t, e, n, i) {
    this.x = t, this.y = e, this.width = n, this.height = i;
  }
  leftOverSpace(t) {
    return this.width < t.width || this.height < t.height ? null : this.height * (this.width - t.width) + this.width * (this.height - t.height);
  }
  split(t, e, n) {
    t.x = this.x, t.y = this.y, this.width - t.height < hB && this.height - t.height < hB ? e.splice(n, 1) : this.width === t.width ? e.splice(n, 1, new dc(this.x, this.y + t.height, this.width, this.height - t.height)) : this.height === t.height ? e.splice(n, 1, new dc(this.x + t.width, this.y, this.width - t.width, this.height)) : e.splice(n, 1, new dc(this.x + t.width, this.y, this.width - t.width, t.height), new dc(this.x, this.y + t.height, this.width, this.height - t.height));
  }
};
u(dc, "Slot");
var LC = class {
  constructor(t, e, n, i) {
    let r = 5;
    for (; Math.pow(2, r) < i;) r += 1;
    for (i = Math.pow(2, r), r = 10; Math.pow(2, r) < n;) r += 1;
    n = Math.pow(2, r), this.atlas = t, this.map = e, this.canvasWidth = n, this.canvasHeight = i, this.canvas = document.createElement("canvas"), this.canvas.width = this.canvasWidth, this.canvas.height = this.canvasHeight, this.context = this.canvas.getContext("2d"), this.context.textBaseline = "bottom", this.spaces = [new dc(0, 0, this.canvas.width, this.canvas.height)], this.free = [], this.labels = [], this.count = Vhe;
    let o = new Float32Array(3 * this.count),
      s = new Float32Array(2 * this.count),
      a = new Float32Array(this.count),
      l = new Float32Array(4 * this.count),
      u = new Float32Array(3 * this.count);
    this.uv = new Gu(l, 4, !1, 1), this.uv.set(l), this.uv.needsUpdate = !0, this.origin = new Gu(o, 3, !1, 1), this.origin.set(o), this.origin.needsUpdate = !0, this.size = new Gu(s, 2, !1, 1), this.size.set(s), this.size.needsUpdate = !0, this.rotation = new Gu(a, 1, !1, 1), this.rotation.set(a), this.rotation.needsUpdate = !0, this.color = new Gu(u, 3, !0, 1), this.color.set(u), this.color.needsUpdate = !0;
    for (let t = 0; t < this.count; t++) this.zero(t);
    let h = new Float32Array([0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0]);
    this.geometry = new Xx(), this.geometry.setIndex([0, 3, 1, 3, 2, 1]), this.geometry.setAttribute("position", new ui(h, 3)), this.geometry.setAttribute("size", this.size), this.geometry.setAttribute("origin", this.origin), this.geometry.setAttribute("rotation", this.rotation), this.geometry.setAttribute("uv", this.uv), this.geometry.setAttribute("color", this.color), this.texture = new df(this.canvas), this.texture.anisotropy = 16, this.material = new Vx(), this.material.vertexShader = uB, this.material.fragmentShader = lB, this.material.uniforms = {
      textureLabel: {
        value: this.texture
      }
    }, this.material.transparent = !0, this.mesh = new Ft(this.geometry, this.material), this.obj = new jn(), this.obj.add(this.mesh), this.obj.frustumCulled = !1, this.mesh.frustumCulled = !1, this.map.add(this.obj);
  }
  space() {
    return this.spaces.map(t => t.width * t.height).reduce((t, e) => t + e);
  }
  zero(t) {
    this.origin.array[3 * t + 0] = 0, this.origin.array[3 * t + 1] = 0, this.origin.array[3 * t + 2] = 0, this.size.array[2 * t + 0] = 0, this.size.array[2 * t + 1] = 0, this.rotation.array[t] = 0, this.uv.array[4 * t + 0] = 0, this.uv.array[4 * t + 1] = 0, this.uv.array[4 * t + 2] = 0, this.uv.array[4 * t + 3] = 0, this.color.array[3 * t + 0] = 0, this.color.array[3 * t + 1] = 0, this.color.array[3 * t + 2] = 0, this.origin.needsUpdate = !0, this.size.needsUpdate = !0, this.rotation.needsUpdate = !0, this.uv.needsUpdate = !0, this.color.needsUpdate = !0;
  }
  findSpace(t) {
    if (0 != this.free.length && this.labels.length == this.count) return !1;
    let e = -1;
    for (let n = 0; n < this.spaces.length; n++) {
      let i = this.spaces[n].leftOverSpace(t);
      null !== i && (-1 === e || this.spaces[n].leftOverSpace(t) < i) && (e = n);
    }
    return -1 !== e && (this.spaces[e].split(t, this.spaces, e), t.layer = this, 0 === this.free.length ? (t.index = this.labels.length, this.labels.push(t)) : (t.index = this.free.pop(), this.labels[t.index] = t)), -1 != e;
  }
  remove(t) {
    if (void 0 === t.index) return;
    this.zero(t.index), this.context.clearRect(t.x, t.y, t.width, t.height), this.spaces.push(new dc(t.x, t.y, t.width, t.height)), this.free.push(t.index), this.labels[t.index] = null;
    let e = !0;
    for (let t of this.labels) if (e = e && null != t, !e) break;
    e && this.atlas.removeLayer(this);
  }
  render(t) {
    this.context.save(), this.context.rect(t.x + 1, t.y + 1, t.width - 2, t.height - 2), this.context.clip(), this.context.font = t.size + "px " + t.font;
    for (let e of t.lines) this.context.fillText(e.text, e.x + t.x + UE, e.y + t.y + e.height + UE);
    this.texture.needsUpdate = !0, this.context.restore();
  }
  onWebGLContextRestored() {
    this.canvas = document.createElement("canvas"), this.canvas.width = this.canvasWidth, this.canvas.height = this.canvasHeight, this.context = this.canvas.getContext("2d"), this.context.textBaseline = "bottom", this.texture = new df(this.canvas), this.texture.anisotropy = 16, this.material.uniforms.textureLabel.value = this.texture;
    for (let t of this.labels) null != t && this.render(t);
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose(), this.texture.dispose();
  }
};
u(LC, "AtlasLayer");
var ap = class {
  constructor() {
    this.layers = [], this.canvas = document.createElement("canvas"), this.context = this.canvas.getContext("2d");
  }
  addLabel(t, e, n, i, r, o) {
    let s = 0,
      a = 0;
    for (let t of e) a = Math.max(Math.ceil(t.width + t.x), a), s = Math.max(Math.ceil(t.height + t.y), s);
    let l,
      u = new IC();
    u.map = t, u.width = a + 2 * UE, u.height = s + 2 * UE, u.lines = e, u.font = n, u.size = i, u.canvasBounds = r.canvasBounds, u.margin = r.margin, u.heightMargin = r.heightMargin, u.pixelsPerMu = o, u.z = r.height, u.view = r, u.color = r.color;
    for (let e of this.layers) if (l = e, l.map === t) {
      if (l.findSpace(u)) break;
      l = null;
    } else l = null;
    if (null == l) {
      if (l = new LC(this, t, u.width, u.height), this.layers.push(l), !l.findSpace(u)) return;
      this.layers.sort((t, e) => e.space() - t.space());
    }
    return l.render(u), u.layout(t.mapClass, l.origin, l.size, l.rotation, l.uv, l.color), u.layer = l, u;
  }
  removeLayer(t) {
    let e = this.layers.indexOf(t);
    -1 != e && this.layers.splice(e, 1);
  }
  measure(t, e, n) {
    return this.context.font = n + "px " + e, this.context.measureText(t);
  }
  onWebGLContextRestored() {
    for (let t of this.layers) t.onWebGLContextRestored();
  }
  dispose() {
    for (let t of this.layers) t.dispose();
  }
};
u(ap, "Atlas");
var Py = class {
  constructor(t, e, n, i, r, o, s, a, l) {
    A(this, "setHoverColor", u(t => {
      this.hoverColor = new yt(t);
    }, "setHoverColor"));
    let h = rl(t.polygon, e.polygons);
    this.id = h.id, this.text = (t.shortText || t.text).trim(), this.stateText = t.stateText ? " (" + t.stateText + ")" : "", this.fullText = this.stateText ? this.text + this.stateText : this.text, this.font = t.font || i, this.atlas = l, this.canvasBounds = t.canvasBounds || h.canvasBounds, this.mapScale = n.getMapScale() || 1, this.margin = (t.margin || CC.MARGIN) * this.mapScale, this.heightMargin = (t.heightMargin || CC.HEIGHT_MARGIN) * this.mapScale, this.scaleMin = t.scaleMin || .25, this.scaleStep = t.scaleStep > 0 ? t.scaleStep : .25, this.multiline = null == t.multiline || t.multiline, this.height = Number(t.height) || null, this.polygonMeshesById = r, this.polyId = t.polygonId || Vr(t.polygon, e.polygons), this.map = n, this.color = new yt(t.color || a.colors.text || "#000000"), this.hoverColor = new yt(t.hoverColor || this.color), this.baseColor = this.color, this.hideOnCreate = !1, this.hoverLabelText = t.text.trim(), this.fontSize = t.fontSize * this.mapScale || t.size * Uhe || AC, this.hoverLabelMode = t.hoverLabelMode3D || ou.MODES.ALL, this.hoverLabelClass = t.hoverLabelClass || "mMapviewHoverLabel", this.showHoverLabel = this.hoverLabelMode == ou.MODES.ALL || this.hoverLabelMode == ou.MODES.NO_TEXT_LABEL_ONLY, this.hoverIfLabelFails = this.hoverLabelMode == ou.MODES.ALL || this.hoverLabelMode == ou.MODES.NO_TEXT_LABEL_ONLY, this.textLabelsByPolygonId = o, this.map.textObjects.push(this);
  }
  create() {
    let t = this;
    if (this.doNotCreate) return;
    if (null == t.canvasBounds) return t.invalid = !0, t.message = "No Canvas Bounds. Can't draw text '" + t.text + "'", void (t.showHoverLabel = t.hoverIfLabelFails);
    t.showHoverLabel = this.hoverLabelMode == ou.MODES.ALL;
    let e = zhe * this.mapScale,
      n = cB / this.mapScale,
      i = [this.text];
    this.stateText.length && i.unshift(this.fullText);
    for (let e of i) {
      let i = e.split(" ").map(function (e) {
          return {
            width: t.atlas.measure(e, t.font, t.fontSize).width,
            word: e
          };
        }),
        a = (this.canvasBounds.maxWidth - 2 * this.margin) * n,
        l = (this.canvasBounds.maxHeight - 2 * this.heightMargin) * n,
        u = (1 - this.scaleMin) / this.scaleStep,
        h = 0,
        c = this.atlas.measure(" ", this.font, this.fontSize).width,
        p = Ghe(this.fontSize + "px " + this.font);
      for (let t = 0, e = i.length; t < e; t++) {
        let e = i[t].width,
          n = Math.ceil((e - a) / (e * this.scaleStep));
        h = Math.max(n, h);
      }
      if (null == this.height) if (this.polygonMeshesById[this.polyId]) {
        let t = this.polygonMeshesById[this.polyId];
        t.geometry.boundingBox || t.geometry.computeBoundingBox(), this.height = t.geometry.boundingBox.max.z + t.position.z;
      } else this.height = 0;
      var r, o, s;
      let d = this.scaleStep;
      t: for (o = h; o <= u; o++) {
        s = 1 - o * d;
        let t = i[0].width * s;
        r = [{
          text: i[0].word,
          width: t,
          height: p * s,
          x: 0,
          y: 0
        }];
        for (let e = 1; e < i.length; e++) {
          let n = i[e],
            o = (n.width + c) * s;
          if (t + o < a) r[r.length - 1].text += " " + n.word, r[r.length - 1].width += o, t += o;else {
            if (!this.multiline) continue t;
            r[r.length - 1].width = t, t = n.width * s, r.push({
              text: n.word,
              width: t,
              height: p * s,
              x: 0,
              y: r[r.length - 1].height + r[r.length - 1].y
            });
          }
        }
        if (r.length * p * s <= l) {
          this.invalid = !1;
          break;
        }
      }
      if (0 == this.invalid) break;
    }
    if (0 == this.invalid) {
      let t = r.map(t => Math.ceil(t.width)).reduce((t, e) => Math.max(t, e));
      for (let e of r) e.x = (t - e.width) / 2;
      this.label = this.atlas.addLabel(this.map, r, this.font, this.fontSize * s, this, e);
    }
    this.created = !0;
  }
  flipIfNeeded(t) {}
  removeSelf(t) {
    this.created ? (null != this.label && (this.label.layer.remove(this.label), this.label = null), t || (this.map.textObjects = this.map.textObjects.filter(t => t != this), Object.keys(this.textLabelsByPolygonId).forEach(t => {
      this.textLabelsByPolygonId[t] == this && delete this.textLabelsByPolygonId[t];
    }))) : this.doNotCreate = !0;
  }
  setColor(t) {
    var e;
    let n = new yt(t),
      i = this.color.equals(n),
      r = Boolean(null == (e = this.label) ? void 0 : e.layer);
    this.color = n, !i && r && (this.label.color = this.color, this.label.layout(this.map.mapClass, this.label.layer.origin, this.label.layer.size, this.label.layer.rotation, this.label.layer.uv, this.label.layer.color));
  }
  clearColor() {
    this.setColor(this.baseColor);
  }
  hide() {
    this.label ? this.label.layer.zero(this.label.index) : this.hideOnCreate = !0;
  }
  show() {
    if (this.label) {
      let t = this.label.layer,
        e = this.map;
      this.label.layout(e.mapClass, t.origin, t.size, t.rotation, t.uv, t.color);
    } else this.hideOnCreate = !1;
  }
  toString() {
    return this.hoverLabelText;
  }
};
u(Py, "FlatLabel");
var fB = new Map(),
  Ghe = u(function (t) {
    let e = fB[t];
    if (null != e) return e;
    let n = document.createElement("span");
    n.textContent = "Hg", n.style.font = t;
    let i = document.createElement("div");
    i.style.cssText = "display: inline-block; width: 1px; height: 0px;";
    let r = document.createElement("div");
    r.appendChild(n), r.appendChild(i), document.body.appendChild(r);
    try {
      var o = n.getBoundingClientRect();
    } finally {
      r.remove();
    }
    return null != o.height && (fB[t] = o.height, e = o.height), e;
  }, "getTextHeight");
E();
var pB = u(function (t) {
  let e,
    n,
    i = this,
    r = document.createElement("div");
  r.style.display = "none!important", r.style.position = "absolute", r.style.top = "0px", r.style.left = "0px", r.style.pointerEvents = "none", this.hovering = !1, t.appendChild(r), this.show = function (t) {
    i.hovering || i.setPosition(e, n), i.hovering = !0, r.style.removeProperty("display"), r.textContent = t.toString(), r.className = t.hoverLabelClass;
  }, this.hide = function () {
    i.hovering && (i.hovering = !1, r.style.setProperty("display", "none", "important"), r.textContent = "");
  }, this.setZIndex = function (t) {
    r.style.zIndex = t;
  }, this.setPosition = function (o, s) {
    e = o, n = s, i.hovering && (s - r.clientHeight > 0 ? (s -= r.clientHeight, o + r.clientWidth > t.clientWidth && (o -= r.clientWidth)) : o = o - r.clientWidth - 10, r.style.transform = "translate(" + o + "px, " + s + "px)");
  }, this.destroy = function () {
    t.removeChild(r);
  };
}, "HoverLabel");
pB.MODES = {
  NONE: 1,
  NO_TEXT_LABEL_ONLY: 2,
  ALL: 3
};
var Kr,
  ou = pB;
E(), function (t) {
  t[t.initial = 0] = "initial", t[t.show = 1] = "show", t[t.hide = 2] = "hide";
}(Kr || (Kr = {}));
var OC = class {
  constructor(t) {
    A(this, "__engine"), A(this, "_initialRank", 0), A(this, "screenPosition", [0, 0]), A(this, "enabled", !1), A(this, "options", {}), A(this, "mapId", ""), A(this, "id", "0"), A(this, "action", 0), A(this, "getBoundingBoxForCurrentStrategy"), A(this, "rank", 0), A(this, "visible", !1), A(this, "offscreen", !1), A(this, "position", new ne(0, 0, 0)), A(this, "dimensions", {
      width: 0,
      height: 0
    });
    let {
      rank: e
    } = t;
    this._initialRank = e, this.rank = e;
  }
  flipIfNeeded() {}
  setPosition(t, e = !0) {
    let n = {
      nodeOrCoordinate: t,
      height: this.position.height
    };
    this.mapId = t.map.id, this.position = n, null != this.__engine && e && this.__engine.update();
  }
  setPriority(t) {
    this.rank = t, null != this.__engine && this.__engine.update();
  }
  setAction(t) {
    this.action = t;
  }
  resetPriority() {
    this.rank !== this._initialRank && (this.setPriority(this._initialRank), null != this.__engine && this.__engine.update());
  }
  promote() {}
  demote() {}
  get strategies() {
    return [];
  }
  removeSelf() {
    this.__engine = null;
  }
  enable() {
    this.enabled = !0;
  }
  disable() {
    this.enabled = !1;
  }
  colliderDidUpdatePosition(t) {
    this.screenPosition = t;
  }
  colliderDidNotFindAHome() {
    this.visible = !1;
  }
  colliderDidMount() {
    this.dimensions = {
      width: 0,
      height: 0
    };
  }
  colliderDidUpdateVisiblity() {}
};
u(OC, "BaseCollider");
var lp = OC;
E(), E();
var Cy = document.createElement("canvas");
Cy.width = 500 * devicePixelRatio, Cy.height = 500 * devicePixelRatio, Cy.style.width = "500px", Cy.style.height = "500px";
var su,
  yc,
  RC = Cy.getContext("2d"),
  dB = u((t, e, n, i = 2, r = 1.2, o = {
    strokeText: !0
  }) => {
    let s = `bold ${e * devicePixelRatio}px 'InterUI-Regular', Helvetica Neue, Arial, sans-serif`;
    RC.font = s;
    let a = [],
      l = t.split(" "),
      u = 0,
      h = 0,
      c = 0;
    for (; h < l.length;) {
      let t = l[h];
      if (u === i && u > 0) {
        a[u - 1] += "...";
        break;
      }
      if (null == a[u] && (a[u] = t, h++), 1 === l.length) {
        a[u] = t;
        break;
      }
      if (null == l[h]) break;
      let {
        width: e
      } = RC.measureText(a[u] + " " + l[h]);
      e <= n ? (a[u] += " " + l[h], h++) : u++;
    }
    a.forEach(t => {
      let {
        width: e
      } = RC.measureText(t);
      c = Math.max(e, c);
    });
    let p = e * devicePixelRatio * r,
      d = a.length * p;
    return {
      maxWidth: c,
      maxHeight: d,
      lines: a.length,
      draw: (t, e, n) => {
        1 === a.length ? (o.strokeText && t.strokeText(a[0], e, n), t.fillText(a[0], e, n)) : (o.strokeText && (t.strokeText(a[0], e, n - p / 2), t.strokeText(a[1], e, n + p / 2)), t.fillText(a[0], e, n - p / 2), t.fillText(a[1], e, n + p / 2));
      }
    };
  }, "shaveText"),
  jC = Rt(mB()),
  WB = Rt(Ny()),
  Bi = u(t => t * devicePixelRatio, "dp"),
  vl = 2.5,
  WC = 4,
  Dpe = 6,
  qpe = 10,
  kpe = 4,
  XB = .5,
  Fpe = 6.5,
  Bpe = 4.5,
  YB = 2.5,
  Upe = 2,
  zpe = 5,
  Vpe = {
    heightAbovePolygon: 0,
    scale: devicePixelRatio,
    appearance: pC.darkOnLight
  };
!function (t) {
  t[t.OPAQUE = 1] = "OPAQUE", t[t.SEMI_TRANSPARENT = .5] = "SEMI_TRANSPARENT";
}(su || (su = {})), function (t) {
  t.LEFT = "left", t.CENTER = "center", t.RIGHT = "right";
}(yc || (yc = {}));
var Dy,
  qy,
  ZB,
  Jm,
  ky,
  Fy,
  _c,
  By,
  JE,
  Hpe,
  Uy,
  JB,
  zy,
  xc,
  Ih,
  Gpe = "Smart Labels do not support setting and clearing colors. Re-label the polygon with desired colors instead",
  $s = class extends lp {
    constructor(t, e) {
      if (super(t), re(this, qy), re(this, JE), re(this, Uy), A(this, "lines", 0), A(this, "contextConfigured", !1), A(this, "fillText"), A(this, "newStyle", {
        pinVisibility: 1
      }), A(this, "style", {
        top: 0,
        left: 0,
        textLabelVisible: !0,
        pinVisibility: 1,
        textAlign: yc.LEFT
      }), A(this, "setColor", u(() => {
        ke.warn(Gpe);
      }, "setColor")), A(this, "clearColor", u(() => {}, "clearColor")), A(this, "zoomProportion", 0), A(this, "_cache", {}), A(this, "appearance"), A(this, "mapView"), re(this, Dy, !1), re(this, Jm, !0), re(this, ky, void 0), re(this, Fy, void 0), re(this, By, void 0), re(this, zy, void 0), re(this, xc, void 0), re(this, Ih, !1), null == w($s, _c) && he($s, _c, {}), this.id = t.id, this.mapView = e, this.options = (0, WB.default)({}, {
        text: t.shortText || t.text || ""
      }, t, Vpe), null != t.rank && t.rank > 0) this.rank = t.rank, this._initialRank = t.rank;else {
        let t = "test" === D.env.NODE_ENV ? $s.testId : Math.random();
        $s.testId++, this.rank = t, this._initialRank = t;
      }
      let {
        mapId: n,
        position: i
      } = this.options;
      t.stateText && (this.options.text += ` (${t.stateText})`), this.mapId = n;
      let {
        appearance: r
      } = this.options;
      this.appearance = {
        margin: r.margin,
        text: {
          lineHeight: r.lineHeight,
          numLines: r.text.numLines,
          size: r.text.size,
          maxWidth: r.text.maxWidth,
          foregroundColor: r.text.foregroundColor,
          backgroundColor: r.text.backgroundColor
        },
        marker: {
          size: r.marker.size,
          foregroundColor: {
            active: r.marker.foregroundColor.active,
            inactive: r.marker.foregroundColor.inactive || (0, jC.default)(r.marker.foregroundColor.active).setAlpha(.5).toRgbString()
          },
          backgroundColor: {
            active: r.marker.backgroundColor.active,
            inactive: r.marker.backgroundColor.inactive || (0, jC.default)(r.marker.backgroundColor.active).setAlpha(.5).toRgbString()
          },
          icon: r.marker.icon,
          iconSize: r.marker.iconSize || qpe,
          iconVisibilityThreshold: null == r.marker.iconVisibilityThreshold ? XB : r.marker.iconVisibilityThreshold
        }
      }, this.position = i, this.appearance.marker.icon && (he(this, Dy, !0), mt(this, JE, Hpe).call(this));
    }
    enable(t = !0) {
      super.enable(), t && this.__engine.update();
    }
    get totalTextBoxHeight() {
      let {
        height: t
      } = this.dimensions;
      return t + 2 * vl;
    }
    get totalTextBoxWidth() {
      let {
        width: t
      } = this.dimensions;
      return t + 2 * vl;
    }
    get totalMarkerSize() {
      return w(this, Jm) && (he(this, ky, w(this, xc) / devicePixelRatio + YB), he(this, Jm, !1)), w(this, ky);
    }
    get strategies() {
      let {
          width: t,
          height: e
        } = this.dimensions,
        {
          margin: n
        } = this.appearance;
      mt(this, qy, ZB).call(this);
      let i = Math.max(Dpe, n),
        r = w(this, Ih) ? i / 2 : 0,
        o = [{
          name: "RIGHT",
          getBoundingBox: ({
            x: n,
            y: r
          }) => {
            let o = Math.max(this.totalMarkerSize, e);
            return [r - o / 2 - i, r + o / 2 + i, n - this.totalMarkerSize / 2 - i, n + this.totalMarkerSize + t + i];
          },
          onStrategySelected: t => {
            this.newStyle = Object.assign({}, t.style, {
              textAlign: yc.RIGHT,
              pinVisibility: 1,
              top: -this.totalTextBoxHeight / 2,
              left: this.totalMarkerSize / 2 + WC / 2,
              textLabelVisible: !0,
              cachedSymbol: this.getCachedSymbol("RIGHT", yc.LEFT, 0)
            });
          }
        }, {
          name: "LEFT",
          getBoundingBox: ({
            x: n,
            y: r
          }) => {
            let o = Math.max(this.totalMarkerSize, e);
            return [r - o / 2 - i, r + o / 2 + i, n - this.totalMarkerSize - t - i, n + this.totalMarkerSize / 2 + i];
          },
          onStrategySelected: e => {
            this.newStyle = Object.assign({}, e.style, {
              textAlign: yc.RIGHT,
              pinVisibility: 1,
              top: -this.totalTextBoxHeight / 2,
              left: -this.totalTextBoxWidth - this.totalMarkerSize / 2 - WC / 2,
              textLabelVisible: !0,
              cachedSymbol: this.getCachedSymbol("LEFT", yc.RIGHT, Bi(t))
            });
          }
        }, {
          name: "TOP",
          getBoundingBox: ({
            x: n,
            y: r
          }) => [r - (e + this.totalMarkerSize) - i, r + this.totalMarkerSize / 2 + i, n - t / 2 - i, n + t / 2 + i],
          onStrategySelected: e => {
            this.newStyle = Object.assign({}, e.style, {
              pinVisibility: 1,
              textAlign: yc.CENTER,
              textLabelVisible: !0,
              top: -this.totalTextBoxHeight - this.totalMarkerSize / 2 - WC / 2,
              left: -this.totalTextBoxWidth / 2,
              cachedSymbol: this.getCachedSymbol("TOP", yc.CENTER, Bi(t / 2))
            });
          }
        }, {
          name: XC,
          getBoundingBox: ({
            x: t,
            y: e
          }) => [e - this.totalMarkerSize / 2 - r, e + this.totalMarkerSize / 2 + r, t - this.totalMarkerSize / 2 - r, t + this.totalMarkerSize / 2 + r],
          onStrategySelected: t => {
            this.newStyle = Object.assign({}, t.style, {
              pinVisibility: .5,
              textLabelVisible: !1
            });
          }
        }];
      return "" === this.options.text ? [{
        name: "ICON_ONLY",
        getBoundingBox: ({
          x: t,
          y: e
        }) => [e - this.totalMarkerSize / 2 - i / 2, e + this.totalMarkerSize / 2 + i / 2, t - this.totalMarkerSize / 2 - i / 2, t + this.totalMarkerSize / 2 + i / 2],
        onStrategySelected: t => {
          this.newStyle = Object.assign({}, t.style, {
            pinVisibility: 1,
            textLabelVisible: !1
          });
        }
      }] : o;
    }
    getCachedSymbol(t, e, n) {
      let {
        width: i,
        height: r
      } = this.dimensions;
      if (null == this._cache[t]) {
        let o,
          s = i + 2 * vl,
          a = r + 2 * vl;
        null != window.OffscreenCanvas ? o = new OffscreenCanvas(Bi(s + vl), Bi(a + vl)) : (o = document.createElement("canvas"), o.width = Bi(s + vl), o.height = Bi(a + vl), o.style.width = s + "px", o.style.height = a + "px");
        let l = o.getContext("2d"),
          {
            size: u
          } = this.options.appearance.text;
        l.textAlign = e, l.font = `bold ${u * devicePixelRatio}px 'InterUI-Regular', Helvetica Neue, Arial, sans-serif`, l.textBaseline = "middle", l.lineJoin = "miter", l.miterLimit = 2, l.strokeStyle = "white", l.lineWidth = Bi(vl), l.fillStyle = this.appearance.text.foregroundColor, l.strokeStyle = this.appearance.text.backgroundColor, this.fillText && "function" == typeof this.fillText && this.fillText(l, n + Bi(vl), Bi(a + vl / 2) / 2), this._cache[t] = o;
      }
      return this._cache[t];
    }
    invalidate() {
      this._cache = {}, this.colliderDidMount();
    }
    colliderDidMount() {
      let {
          size: t,
          maxWidth: e,
          numLines: n,
          lineHeight: i
        } = this.appearance.text,
        r = this.options.text || "",
        {
          draw: o,
          lines: s,
          maxWidth: a,
          maxHeight: l
        } = dB(r, t, Bi(e), n, i);
      this.fillText = o, this.lines = s, this.dimensions = {
        width: a / devicePixelRatio,
        height: l / devicePixelRatio
      };
    }
    colliderDidUpdatePosition(t) {
      this.screenPosition = t;
    }
    setPriority(t) {
      super.setPriority(t), null != this.__engine && this.__engine.update();
    }
    colliderDidUpdateVisiblity() {
      mt(this, qy, ZB).call(this), this.action === Kr.show ? this.visible = !0 : this.visible = !1, this.action = Kr.initial, this.style = this.newStyle;
    }
    colliderDidGoOutsideGrid() {}
    colliderDidNotFindAHome() {
      this.action = Kr.hide;
    }
    disable(t = !0) {
      super.disable(), this.visible = !1, t && this.__engine.update();
    }
    get pinCanvasSize() {
      return 2 * this.totalMarkerSize;
    }
    draw(t) {
      var e;
      if (!this.visible) return;
      let [n, i] = this.screenPosition,
        {
          pinVisibility: r,
          textLabelVisible: o,
          top: s,
          left: a,
          textAlign: l,
          cachedSymbol: u
        } = this.style,
        h = Bi(n),
        c = Bi(i),
        {
          marker: p
        } = this.appearance,
        {
          foregroundColor: d,
          backgroundColor: f
        } = p,
        m = iT(`${d.active}-${d.inactive}-${f.active}-${f.inactive}-${w(this, xc)}`);
      if (w($s, _c)[m]) {
        let e = 1 === r ? w($s, _c)[m][0] : w($s, _c)[m][1];
        t.drawImage(e, h - Bi(this.pinCanvasSize / 2), c - Bi(this.pinCanvasSize / 2));
      } else {
        t.lineWidth = Bi(4);
        let e = mt(this, Uy, JB).call(this, w(this, xc), this.appearance.marker.backgroundColor.active, this.appearance.marker.foregroundColor.active),
          n = mt(this, Uy, JB).call(this, w(this, Ih) ? w(this, xc) : Bi(Bpe), this.appearance.marker.backgroundColor.inactive, this.appearance.marker.foregroundColor.inactive);
        w($s, _c)[m] = [e, n];
      }
      if (w(this, Ih)) {
        let n = Bi(this.appearance.marker.iconSize);
        null == (e = $s.imagePromiseCache[w(this, By)]) || e.then(e => {
          t.drawImage(e, h - n / 2, c - n / 2, n, n);
        });
      }
      w(this, Fy) !== l && (t.textAlign = l, he(this, Fy, l)), o && null != u && (t.shadowColor = "transparent", t.drawImage(u, h + Bi(a), c + Bi(s)));
    }
  },
  Zm = $s;
u(Zm, "FloatingLabel"), Dy = new WeakMap(), qy = new WeakSet(), ZB = u(function () {
  if (w(this, zy) !== this.mapView.currentScale) {
    let {
      iconVisibilityThreshold: t = XB
    } = this.appearance.marker;
    this.mapView.currentScale <= t && void 0 !== this.appearance.marker.iconSize && w(this, Dy) ? (he(this, xc, Bi(this.appearance.marker.iconSize + kpe)), he(this, Ih, !0)) : (he(this, Ih, !1), he(this, xc, Bi(Fpe))), he(this, zy, this.mapView.currentScale);
  }
  he(this, Jm, !0);
}, "#calculateMarkerSize"), Jm = new WeakMap(), ky = new WeakMap(), Fy = new WeakMap(), _c = new WeakMap(), By = new WeakMap(), JE = new WeakSet(), Hpe = u(function () {
  let t = iT(this.appearance.marker.icon);
  he(this, By, t), $s.imagePromiseCache[t] || ($s.imagePromiseCache[t] = fetch(`data:image/svg+xml;base64, ${btoa(this.appearance.marker.icon)}`).then(t => t.blob()).then(t => new Promise(e => {
    let n = new Image();
    n.onload = function () {
      e(n);
    }, n.src = URL.createObjectURL(t);
  })));
}, "#cacheImage"), Uy = new WeakSet(), JB = u(function (t, e, n) {
  let i,
    r = Bi(this.pinCanvasSize);
  null != window.OffscreenCanvas ? i = new OffscreenCanvas(r, r) : (i = document.createElement("canvas"), i.width = r, i.height = r, i.style.width = r / devicePixelRatio + "px", i.style.height = r / devicePixelRatio + "px");
  let o = i.getContext("2d");
  return o.shadowColor = "rgba(0,0,0,0.3)", o.shadowOffsetY = Bi(Upe), o.shadowBlur = Bi(zpe), o.beginPath(), o.arc(r / 2, r / 2, t / 2 + Bi(YB) / 2, 0, 2 * Math.PI), o.fillStyle = e, o.fill(), o.beginPath(), o.arc(r / 2, r / 2, t / 2, 0, 2 * Math.PI), o.shadowColor = "transparent", o.fillStyle = n, o.fill(), i;
}, "#createPinCanvas"), zy = new WeakMap(), xc = new WeakMap(), Ih = new WeakMap(), A(Zm, "testId", 0), re(Zm, _c, void 0), A(Zm, "imagePromiseCache", {});
var Qs = Zm;
E();
var Lh,
  YC = class extends lp {
    constructor() {
      super(...arguments), A(this, "contentEl", document.createElement("div")), A(this, "containerEl", document.createElement("div")), A(this, "ready", !1), re(this, Lh, !1);
    }
    removeSelf() {
      var t;
      this.__engine = null, (null == (t = this.containerEl.parentElement) ? void 0 : t.contains(this.containerEl)) && this.containerEl.parentElement.removeChild(this.containerEl), this.containerEl = null, this.contentEl = null;
    }
    enable() {
      !this.__engine || (this.enabled = !0, this.containerEl.style.opacity = 0, this.__engine.collisionEngineContainerEl.appendChild(this.containerEl), this.updateDimensionsImmediately());
    }
    disable() {
      !this.__engine || (this.enabled = !1, this.ready = !1, this.containerEl.style.opacity = 0, this.__engine.collisionEngineContainerEl.contains(this.containerEl) && this.__engine.collisionEngineContainerEl.removeChild(this.containerEl));
    }
    colliderDidGoOffscreen() {
      this.visible = !1, this.containerEl.style.opacity = "0";
    }
    colliderDidNotFindAHome() {
      this.visible = !1;
    }
    colliderDidUpdatePosition(t) {
      this.enabled && !this.ready && (this.containerEl.style.opacity = 1, this.ready = !0), this.containerEl.style.transform = `translate3D(${t[0]}px, ${t[1]}px, 0)`;
    }
    updateDimensions() {
      he(this, Lh, !0), this.visible && (this.updateDimensionsImmediately(), he(this, Lh, !1));
    }
    updateDimensionsImmediately() {
      if (w(this, Lh)) {
        let {
          width: t,
          height: e
        } = this.containerEl.getBoundingClientRect();
        this.dimensions = {
          width: t,
          height: e
        }, Object.assign(this.containerEl, {
          width: t + "px",
          height: e + "px"
        }), he(this, Lh, !1), this.__engine.update();
      }
    }
    colliderDidMount() {
      this.updateDimensions();
    }
    colliderDidUpdateVisiblity() {
      this.containerEl.style.opacity = this.visible ? "1" : "0", this.visible && w(this, Lh) && this.updateDimensionsImmediately();
    }
  };
u(YC, "HTMLCollider"), Lh = new WeakMap();
var Vy = YC;
E();
var ZC = Rt(il()),
  Km = {};
function jpe(t, e) {
  var n;
  return null != (null == (n = Km[t.id]) ? void 0 : n[e]) || (null == Km[t.id] && (Km[t.id] = {}), t.polygons.forEach(e => {
    e.entrances.forEach(n => {
      Km[t.id][n.id] = e;
    });
  })), Km[t.id][e];
}
u(jpe, "getPolygonByNodeId");
var hp,
  Gy = class {
    constructor(t) {
      re(this, hp, void 0), he(this, hp, t);
    }
    get id() {
      return w(this, hp).id;
    }
    get containerEl() {
      return w(this, hp).containerEl;
    }
    get contentEl() {
      return w(this, hp).contentEl;
    }
  };
u(Gy, "Marker"), hp = new WeakMap();
var fi,
  JC = class {
    constructor(t) {
      re(this, fi, void 0), A(this, "markersMap"), A(this, "animations"), he(this, fi, t), this.markersMap = new Map(), this.animations = new Map();
    }
    create(t, e, n) {
      if (null == w(this, fi).currentMap) throw new Error("Unable to retrieve the current map");
      let i = w(this, fi).mapObjects.get(t.map.id || w(this, fi).currentMap),
        r = 0;
      if (t instanceof hl) {
        let e = jpe(i.mapClass, t.id);
        null != e && (r = e.geometry.scale.z * Math.max(i.mapClass.width, i.mapClass.height) / 1e3);
      }
      return new KE({
        ...n,
        collisionRank: null == n ? void 0 : n.rank,
        contentHtml: e,
        mapId: i.id,
        position: {
          nodeOrCoordinate: t,
          height: r
        }
      });
    }
    addInternal(t, e, n) {
      if (null == w(this, fi).currentMap) throw new Error("Unable to retrieve the current map");
      let i = this.create(t, e, n);
      return w(this, fi).smartCollisionEngine.add(i.id, i), i;
    }
    add(t, e, n) {
      if (null == w(this, fi).currentMap) throw new Error("Unable to retrieve the current map");
      let i = w(this, fi).mapObjects.get(t.map.id || w(this, fi).currentMap),
        r = this.create(t, e, n);
      w(this, fi).smartCollisionEngine.add(r.id, r), i.markers.add(r), w(this, fi).taskScheduler.scheduleTask(new ji({
        name: "addMarker",
        callback: () => {
          w(this, fi).visibleMapsInCurrentScene.map(t => t.id).includes(r.mapId) && (r.enable(), w(this, fi).smartCollisionEngine.update());
        }
      })), w(this, fi).tryRendering();
      let o = new Gy(r);
      return this.markersMap.set(r.id, {
        marker: o,
        internalMarker: r
      }), o;
    }
    updateMap(t, e, n) {
      var i, r;
      null == (i = w(this, fi).mapObjects.get(e)) || i.markers.delete(t), null == (r = w(this, fi).mapObjects.get(n)) || r.markers.add(t), w(this, fi).smartCollisionEngine.updateMap(t.id, e, n), w(this, fi).visibleMapsInCurrentScene.map(t => t.id).includes(t.mapId) ? t.enable() : t.disable();
    }
    setPosition(t, e, n) {
      var i, r;
      let o;
      if ("string" == typeof t ? o = null == (i = this.markersMap.get(t)) ? void 0 : i.internalMarker : t instanceof Gy ? o = null == (r = this.markersMap.get(t.id)) ? void 0 : r.internalMarker : t instanceof KE && (o = t), !o) return;
      let s = o.position.nodeOrCoordinate;
      s.map.id !== e.map.id && this.updateMap(o, s.map.id, e.map.id), o.setPosition(e, n), w(this, fi).tryRendering(hi.ALL);
    }
    animate(t, e, n) {
      var i;
      let r = "string" == typeof t ? t : t.id,
        o = null == (i = this.markersMap.get(r)) ? void 0 : i.internalMarker;
      if (!o) return Promise.resolve();
      let s = this.animations.get(r);
      s && (s.tween.stop(), s.resolver(), this.animations.delete(r));
      let a,
        l = o.position.nodeOrCoordinate,
        u = {
          lat: l.lat,
          lon: l.lon
        },
        h = {
          lat: e.lat,
          lon: e.lon
        },
        c = (null == n ? void 0 : n.easing) && Os[n.easing] || ZC.default.Easing.Cubic.InOut,
        p = new ZC.default.Tween(u).to(h, (null == n ? void 0 : n.duration) || 1e3).easing(c).onUpdate(t => {
          let n = e.map.createCoordinate(t.lat, t.lon);
          this.setPosition(o, n);
        }).onComplete(() => {
          this.animations.delete(r), a();
        }).start();
      l.map.id !== e.map.id && this.updateMap(o, l.map.id, e.map.id);
      let d = new Promise(t => {
        a = t, this.animations.set(r, {
          tween: p,
          resolver: a
        });
      });
      return w(this, fi).tryRendering(), d;
    }
    remove(t) {
      let e = "string" == typeof t ? t : t.id;
      w(this, fi).smartCollisionEngine.remove(e), w(this, fi).smartCollisionEngine.update(), w(this, fi).tryRendering(), this.markersMap.delete(e);
    }
    removeAll() {
      Array.from(w(this, fi).mapObjects.values()).forEach(t => {
        t.markers.forEach(t => {
          w(this, fi).smartCollisionEngine.remove(t.id);
        });
      }), w(this, fi).smartCollisionEngine.update(), w(this, fi).tryRendering(), this.markersMap = new Map();
    }
  };
u(JC, "MarkersController"), fi = new WeakMap();
var KC = JC;
E();
var Hy,
  Qm,
  Wpe = {
    top: !0,
    left: !0,
    topLeft: !0,
    right: !0,
    topRight: !0,
    bottom: !0,
    bottomLeft: !0,
    bottomRight: !0
  },
  QC = class extends Vy {
    constructor(t) {
      super(t), A(this, "className", "top"), A(this, "_el", null), A(this, "style", {}), A(this, "updateClassName", u(t => {
        this.containerEl.classList.item(1) && this.containerEl.classList.remove(this.containerEl.classList.item(1)), this.containerEl.classList.add(`tooltip--anchor-${t}`), he(this, Qm, t);
      }, "updateClassName")), re(this, Hy, "-1"), re(this, Qm, "");
      let {
        html: e,
        contentHtml: n,
        text: i,
        position: r,
        selector: o,
        map: s,
        padding: a = 0,
        collisionRank: l = No.HIGH,
        defaultAnchorType: h = "top",
        enabledAnchorTypes: c
      } = t;
      this.containerEl.innerHTML = e || `<div class="mappedin-tooltip"><div class="mappedin-tooltip__content" style="padding: ${a}px">${i || n}</div></div>`, this.position = r, this.rank = l, this.mapId = s, this.id = ls();
      let p = e ? o : ".mappedin-tooltip";
      this.containerEl = this.containerEl.querySelector(p), this.contentEl = this.containerEl.firstElementChild, this._el = this.contentEl, this.options = {
        collisionRank: l,
        padding: a / Math.SQRT2,
        defaultAnchorType: h,
        enabledAnchorTypes: {
          ...Wpe,
          ...c
        }
      };
    }
    get strategies() {
      let {
          width: t,
          height: e
        } = this.dimensions,
        {
          padding: n
        } = this.options,
        i = n / 2;
      return [{
        name: "top",
        getBoundingBox: ({
          x: i,
          y: r
        }) => [r - e - n, r - n, i - t / 2, i + t / 2 + n / 2],
        onStrategySelected: () => {
          this.style.top = -e - n + "px", this.style.left = -t / 2 + "px", this.className = "top";
        }
      }, {
        name: "right",
        getBoundingBox: ({
          x: i,
          y: r
        }) => [r - e / 2 - n / 2, r + e / 2 + n / 2, i + n, i + n + t],
        onStrategySelected: () => {
          this.style.top = -e / 2 + "px", this.style.left = n + "px", this.className = "right";
        }
      }, {
        name: "left",
        getBoundingBox: ({
          x: i,
          y: r
        }) => [r - e / 2, r + e / 2, i - t - n, i],
        onStrategySelected: () => {
          this.style.top = -e / 2 + "px", this.style.left = -t - n + "px", this.className = "left";
        }
      }, {
        name: "bottom",
        getBoundingBox: ({
          x: i,
          y: r
        }) => [r + n, r + n + e, i - t / 2, i + t / 2],
        onStrategySelected: () => {
          this.style.top = n + "px", this.style.left = -t / 2 + "px", this.className = "bottom";
        }
      }, {
        name: "bottomLeft",
        getBoundingBox: ({
          x: r,
          y: o
        }) => [o + i + n, o + i + e + n, r - t - i, r - i],
        onStrategySelected: () => {
          this.style.top = n + "px", this.style.left = -t - n + "px", this.className = "bottom-left";
        }
      }, {
        name: "bottomRight",
        getBoundingBox: ({
          x: r,
          y: o
        }) => [o + i, o + i + e + n, r + i, r + i + t + n],
        onStrategySelected: () => {
          this.style.top = n + "px", this.style.left = n + "px", this.className = "bottom-right";
        }
      }, {
        name: "topLeft",
        getBoundingBox: ({
          x: n,
          y: r
        }) => [r - e - i, r - i, n - t - i, n - i],
        onStrategySelected: () => {
          this.style.top = -e - n + "px", this.style.left = -t - n + "px", this.className = "top-left";
        }
      }, {
        name: "topRight",
        getBoundingBox: ({
          x: r,
          y: o
        }) => [o - e - i, o - i, r + i + n, r + i + t + n],
        onStrategySelected: () => {
          this.style.top = -e - n + "px", this.style.left = n + "px", this.className = "top-right";
        }
      }].filter(t => !0 === this.options.enabledAnchorTypes[t.name]);
    }
    colliderDidMount() {
      this.updateDimensions();
    }
    updateDimensionsImmediately() {
      super.updateDimensionsImmediately(), he(this, Qm, ""), he(this, Hy, "-1");
    }
    setAction(t) {
      super.setAction(t), this.visible = t === Kr.show;
    }
    colliderDidNotFindAHome() {
      this.options.collisionRank === No.ALWAYS_VISIBLE ? this.visible = !0 : this.setAction(Kr.hide);
    }
    colliderDidGoOffscreen() {}
    colliderDidUpdateVisiblity() {
      let t = this.action === Kr.show ? "1" : "0";
      w(this, Hy) != t && (this.containerEl.style.opacity = t), w(this, Qm) !== this.className && (this.updateClassName(this.className), !0 === this.visible && (this.updateDimensionsImmediately(), Object.assign(this.containerEl.style, this.style)));
    }
  };
u(QC, "SmartTooltip"), Hy = new WeakMap(), Qm = new WeakMap();
var Aa,
  $C = QC;
E(), function (t) {
  t[t.CENTER = 0] = "CENTER", t[t.TOP = 1] = "TOP", t[t.BOTTOM = 2] = "BOTTOM", t[t.LEFT = 3] = "LEFT", t[t.RIGHT = 4] = "RIGHT";
}(Aa || (Aa = {}));
var Xpe = {
    anchor: 0
  },
  eA = class extends Vy {
    constructor(t) {
      super(t), A(this, "_el", null), A(this, "style", {}), A(this, "polygon");
      let {
        contentHtml: e,
        position: n,
        mapId: i,
        id: r,
        collisionRank: o = No.HIGH
      } = t;
      this.containerEl.innerHTML = `<div class="mappedin-marker__wrapper"><div class="mappedin-marker">${e}</div></div>`, this.position = n, this.rank = o, this.mapId = i, this.id = "string" == typeof r ? r : ls(), this.containerEl = this.containerEl.querySelector(".mappedin-marker"), this.contentEl = this.containerEl.firstElementChild, this._el = this.contentEl, this.options = {
        ...Xpe,
        ...t
      };
    }
    get strategies() {
      let {
        width: t,
        height: e
      } = this.dimensions;
      return [{
        name: "center",
        getBoundingBox: ({
          x: n,
          y: i
        }) => {
          let r = i - e / 2,
            o = i + e / 2,
            s = n - t / 2,
            a = n + t / 2;
          switch (this.options.anchor) {
            case 1:
              r = i - e, o = i;
              break;
            case 2:
              r = i, o = i + e;
              break;
            case 3:
              s = n - t, a = n;
              break;
            case 4:
              s = n, a = n + t;
          }
          return [r, o, s, a];
        },
        onStrategySelected: () => {
          let n = -e / 2 + "px",
            i = -t / 2 + "px";
          switch (this.style.top = n, this.style.left = i, this.options.anchor) {
            case 1:
              this.style.top = -e + "px";
              break;
            case 2:
              this.style.top = e + "px";
              break;
            case 3:
              this.style.left = -t + "px";
              break;
            case 4:
              this.style.left = t + "px";
              break;
            default:
              this.style.top = n, this.style.left = i;
          }
        }
      }];
    }
    colliderDidMount() {
      this.updateDimensions();
    }
    setAction(t) {
      super.setAction(t), this.visible = t === Kr.show;
    }
    colliderDidNotFindAHome() {
      this.setAction(Kr.hide);
    }
    colliderDidGoOffscreen() {}
    colliderDidUpdateVisiblity() {
      this.containerEl.style.opacity = this.action === Kr.show ? "1" : "0", super.colliderDidUpdateVisiblity(), !0 === this.visible && Object.assign(this.containerEl.style, this.style);
    }
  };
u(eA, "InternalMarker");
var KE = eA;
E(), E();
var QE = 500,
  $E = cc.EASE_OUT,
  KB = .6,
  jy = void 0,
  QB = 7.9,
  tA = 1;
function Ype(t, e) {
  let n = t.getCenter(new ne()),
    i = t.getSize(new ne()),
    {
      x: r,
      y: o,
      z: s
    } = i,
    a = r * e,
    l = o * e,
    u = s * e,
    h = n.x - a / 2,
    c = n.x + a / 2,
    p = n.y - l / 2,
    d = n.y + l / 2,
    f = n.z - u / 2,
    m = n.z + u / 2;
  return new $t({
    x: h,
    y: p,
    z: f
  }, {
    x: c,
    y: d,
    z: m
  });
}
function $B(t, e) {
  let {
      margin: n,
      radius: i
    } = e,
    r = t.boundingBox,
    o = Ype(new $t(r.min, r.max).clone().applyMatrix4(t.object.matrix), null != n ? n : 1),
    s = {
      min: o.min,
      max: o.max,
      margin: n,
      radius: i,
      center: o.getCenter(new ne())
    };
  s.min.z = (s.max.z + s.min.z) / 2, s.max.z = s.min.z;
  let a = (s.max.x + s.min.x) / 2,
    l = (s.max.y + s.min.y) / 2,
    u = (s.max.z, s.min.z, Math.sqrt((s.max.x - a) ** 2 + (s.max.y - l) ** 2));
  return s.radius = u, s.center = o.getCenter(new ne()), s;
}
u(Ype, "addMarginMultiplierToBoundingBox"), u($B, "getPanBoundsForObject");
var xi,
  nA = class {
    constructor(t, e) {
      A(this, "maps"), re(this, xi, void 0), A(this, "mapObjectsArray", []), A(this, "transitionOptions"), A(this, "object", new jn()), A(this, "currentMap"), A(this, "mapObjects", new Map()), he(this, xi, e), this.object.userData.name = "mappedin-scene", this.maps = t.sort((t, e) => t.elevation - e.elevation), t.forEach(t => {
        let e = w(this, xi).mapObjects.get(t.id);
        this.mapObjects.set(t.id, e);
      }), this.object.position.set(0, 0, 0);
    }
    get mapObjectsByMapGroup() {
      let t = Array.from(this.mapObjects.values());
      return 0 === t.filter(t => {
        var e;
        return null == (e = t.mapClass.mapGroup) ? void 0 : e.id;
      }).length ? {
        _: t
      } : Array.from(this.mapObjects.values()).reduce((t, e) => (t[e.mapClass.mapGroup.id] ? t[e.mapClass.mapGroup.id].push(e) : t[e.mapClass.mapGroup.id] = [e], t), {});
    }
    determineMapPositionAndRotation(t) {
      var e, n;
      let i = (null == (e = w(this, xi).referenceMap) ? void 0 : e.scale) || 1,
        r = t.scale || 1,
        o = (null == (n = w(this, xi).referenceMap) ? void 0 : n.getNorth()) || 0,
        s = t.getNorth() || 0,
        {
          x: a,
          y: l
        } = t.georeference[0].target,
        {
          x: u,
          y: h
        } = t.georeference[2].target,
        c = new _t(a, l),
        p = new _t(u, h),
        {
          lat: d,
          lon: f
        } = c.midpointTo(p),
        m = w(this, xi).referenceMap.createCoordinate(d, f),
        {
          x: g,
          y: v
        } = w(this, xi).convertTo3DMapPosition(m),
        y = r / i;
      return {
        position: [g, v, 0],
        scale: [y, y, y],
        rotation: [0, 0, s - o]
      };
    }
    async prepare(t, e) {
      this.transitionOptions = e || {}, this.currentMap = (null == e ? void 0 : e.activeMap) || this.maps[0], t.currentScene = this;
      let n = await this.preRender(e);
      this.mapObjectsArray = await Promise.all(n);
    }
    resize() {}
    focusOnCurrentMap(t, e) {
      return new Promise(n => {
        var i, r, o, s, a, l;
        let u = this.mapObjects.get(this.currentMap.id);
        u.object.updateMatrixWorld();
        let h = w(this, xi).loadOptions && w(this, xi).loadOptions.zoomOverrides && w(this, xi).loadOptions.zoomOverrides.zoomMultiplier || QB,
          c = u.getMapScale() * u.object.scale.x;
        w(this, xi).controls.zoomFactor = c / h;
        let p = $B(u, w(this, xi).controls.panBounds);
        w(this, xi).controls.panBounds = p;
        let d = null == (i = null == t ? void 0 : t.focusOn) ? void 0 : i.targets,
          f = (null == (r = null == t ? void 0 : t.focusOn) ? void 0 : r.options) || {},
          m = {
            boundingBox: p
          },
          g = null != (o = null == f ? void 0 : f.rotation) ? o : jy,
          v = null == f ? void 0 : f.tilt,
          y = null != (s = null == f ? void 0 : f.easing) ? s : $E,
          _ = null != (a = null == f ? void 0 : f.duration) ? a : QE,
          {
            min: x,
            max: E
          } = p,
          b = [new ne(x.x, x.y, x.z), new ne(x.x, E.y, x.z), new ne(E.x, x.y, x.z), new ne(E.x, E.y, x.z), new ne(x.x, x.y, E.z), new ne(x.x, E.y, E.z), new ne(E.x, x.y, E.z), new ne(E.x, E.y, E.z)],
          {
            zoom: S
          } = w(this, xi).getCameraFrameForPoints(b, 1, 1, w(this, xi).cachedPadding, !1);
        w(this, xi).controls.restrictZoomLimits(S), w(this, xi).controls.expandZoomLimits(S), e ? (w(this, xi).controls.setMulti(p.center, S, jy, KB), n(void 0)) : (null == t ? void 0 : t.autoFocusOnActiveMap) ? (null != d && (m = {
          ...d,
          points: (null == (l = null == d ? void 0 : d.coordinates) ? void 0 : l.map(t => w(this, xi).convertTo3DMapPosition({
            x: t.x,
            y: t.y
          }))) || []
        }), w(this, xi).focusOn({
          ...m,
          ...f,
          duration: _,
          rotation: g,
          doNotEmitFocusOnEvent: !0,
          focusZoomFactor: 1,
          minZoom: null == f ? void 0 : f.minZoom,
          padding: f.safeAreaInsets,
          tilt: v,
          curve: Os[y],
          callback: () => {
            n(void 0);
          },
          cancelledCallback: () => {
            n(void 0);
          }
        })) : (w(this, xi).tryRendering(), n(void 0));
      });
    }
    async preRender(t) {
      this.currentMap = (null == t ? void 0 : t.activeMap) || this.maps[0], this.transitionOptions = t;
      let e = [];
      for (let t in this.mapObjectsByMapGroup) this.mapObjectsByMapGroup[t].forEach(t => {
        e.push(t.load().then(() => {
          if (!w(this, xi).sceneManager.processedMapObjects.has(t)) {
            let {
              position: e,
              rotation: n,
              scale: i
            } = this.determineMapPositionAndRotation(t.mapClass);
            t.object.position.set(...e), t.object.rotation.set(...n), t.object.scale.set(...i), t.box = new $t().setFromObject(t.object), t.object.name = t.mapClass.id, w(this, xi).sceneManager.processedMapObjects.add(t);
          }
          return t;
        }).catch(t => {
          ke.error(t);
        }));
      });
      return e;
    }
    unmount() {}
    postRender() {
      w(this, xi).imageFlippingEnabled && (this.mapObjectsArray.forEach(t => {
        var e;
        null == (e = w(this, xi).imageFlippingCache[t.id]) || e.forEach(([e, n]) => {
          t.enableImageFlipping(e, n);
        });
      }), w(this, xi).publish(Xe.UPDATE_FLIPPABLES, !0));
    }
  };
u(nA, "MapViewScene"), xi = new WeakMap();
var bc = nA;
E();
var At,
  iA = Rt(il()),
  rA = !1,
  Zpe = 2e3,
  Jpe = 2e3,
  Kpe = u(([t, e], [n, i]) => {
    let r = {
        x: t,
        y: e
      },
      o = n,
      s = i;
    function a(t, e) {
      let n = e.x - t.x,
        i = e.y - t.y;
      return Math.sqrt(n * n + i * i);
    }
    return u(a, "distanceBetweenPoints"), a({
      x: (r.x + o) / 2,
      y: (r.y + s) / 2
    }, r);
  }, "getRadiusOfSquare"),
  oA = u(t => {
    let e = new ne(),
      n = new ne();
    for (let i of t) e.min(i), n.max(i);
    let i = new Pi(),
      r = new ui(new Float32Array(24), 3);
    for (let e = 0; e < 8; e++) {
      let n = t[e].clone();
      r.setXYZ(e, n.x, n.y, n.z);
    }
    i.setAttribute("position", r);
    let o = new ui(new Uint16Array([0, 2, 1, 0, 3, 2, 1, 6, 5, 1, 2, 6, 5, 7, 4, 5, 6, 7, 4, 3, 0, 4, 7, 3, 3, 6, 2, 3, 7, 6, 0, 5, 4, 0, 1, 5]), 1);
    return i.setIndex(o), i;
  }, "createBoxFromPoints"),
  eU = 50,
  sA = class extends bc {
    constructor(t, e) {
      super(t, e), re(this, At, void 0), A(this, "containerBoxHelper"), A(this, "viewportBox"), A(this, "currentMapWrapperMesh"), A(this, "currentMapWrapperBoxHelper"), A(this, "viewportMesh"), A(this, "stackContainerMesh"), A(this, "currentMinTilt"), A(this, "scrollToMap", u(async (t, e = 500) => new Promise(n => {
        let i = this.mapObjects.get(t.id);
        new iA.default.Tween({
          z: w(this, At).controls.getPedestal()
        }).to({
          z: i.object.position.z
        }, e).easing(iA.default.Easing.Quadratic.InOut).onUpdate(({
          z: t
        }) => {
          w(this, At).controls.setPedestal(t);
        }).onComplete(() => {
          w(this, At).controls.setPedestal(w(this, At).controls.getPedestal(), !0), w(this, At).tryRendering(), n(void 0);
        }).start();
      }), "scrollToMap")), A(this, "updateFrame", u(t => {
        let e = this.containerBoxHelper.max.z,
          n = this.containerBoxHelper.min.z;
        t.pedestal < e && t.pedestal > n && (this.currentMapWrapperMesh.position.z = t.pedestal, this.viewportMesh.position.z = t.pedestal, this.currentMapWrapperBoxHelper.setFromObject(this.currentMapWrapperMesh), this.viewportBox.setFromObject(this.viewportMesh), this.mapObjects.forEach(t => {
          t.box.setFromObject(t.object), (this.currentMapWrapperBoxHelper.containsBox(t.box) || this.currentMapWrapperBoxHelper.intersectsBox(t.box)) && this.currentMap !== t.mapClass && (this.currentMap = t.mapClass, w(this, At).publish(Xe.SET_SCENE_MAP, t.mapClass));
        }), w(this, At).controls.orbit.position.z = t.pedestal, w(this, At).tryRendering());
      }, "updateFrame")), A(this, "labels", new Map()), A(this, "createMapLabels", u(() => {
        for (let t of this.mapObjects.values()) {
          let e = t.object.position.clone(),
            n = Kpe([this.containerBoxHelper.min.x, this.containerBoxHelper.min.y], [this.containerBoxHelper.max.x, this.containerBoxHelper.max.y]),
            i = Math.PI / 4,
            r = new ne(Math.cos(i) * n, Math.sin(i) * n, 0),
            o = w(this, At).cameraObject,
            s = new ne();
          o.getWorldDirection(s);
          let a = new Vs().setFromUnitVectors(r.clone().normalize(), s.clone().cross(new ne(0, 0, -1)).normalize()),
            l = e.clone().add(r.clone().applyQuaternion(a));
          l.z = t.object.position.z;
          let u = new Ka(100, 100, 100),
            h = new Sr({
              color: "red"
            });
          new Ft(u, h).position.copy(l);
          let c = w(this, At).markers.addInternal(w(this, At).convert3DMapPositionToCoordinate(l, t.mapClass), `<div style="color: #333333; text-shadow: 0px 0px #efefef;font-family: 'Lato', sans-serif; font-size: 24px; font-weight: 300; line-height: 58px;">${t.mapClass.shortName}</div>`, {
            rank: No.ALWAYS_VISIBLE
          });
          c.enable(), this.labels.set(t, [r, e, c]);
        }
        w(this, At).controls.dispatcher.addEventListener(w(this, At).controls.CAMERA_EVENTS.CHANGE_EVENT.type, this.updateLabels);
      }, "createMapLabels")), A(this, "updateLabels", u(() => {
        let t = w(this, At).cameraObject;
        t.updateMatrixWorld(!0), t.updateProjectionMatrix();
        for (let [e, [n, i, r]] of this.labels) {
          let o = new ne();
          t.getWorldDirection(o);
          let s = new Vs().setFromUnitVectors(n.clone().normalize(), o.clone().cross(new ne(0, 0, -1)).normalize()),
            a = i.clone().add(n.clone().applyQuaternion(s));
          w(this, At).markers.setPosition(r, w(this, At).convert3DMapPositionToCoordinate(a, e.mapClass), !1);
        }
      }, "updateLabels")), A(this, "destroyLabels", u(() => {
        w(this, At).controls.dispatcher.removeEventListener(w(this, At).controls.CAMERA_EVENTS.CHANGE_EVENT.type, this.updateLabels);
        for (let [t, e, n] of this.labels.values()) w(this, At).smartCollisionEngine.remove(n.id);
        w(this, At).smartCollisionEngine.update(), this.labels = new Map(), w(this, At).tryRendering();
      }, "destroyLabels")), he(this, At, e), this.object.position.set(0, 0, 0);
    }
    lockControls() {
      w(this, At).controls.enablePedestal = !0, w(this, At).controls.enableRotate = !0, w(this, At).controls.enablePan = !1, w(this, At).controls.enableZoom = !1;
      let {
        minTilt: t
      } = w(this, At).controls;
      this.currentMinTilt = t, w(this, At).controls.minTilt = tA;
    }
    unlockControls() {
      var t;
      w(this, At).controls.enablePedestal = !1, w(this, At).controls.enableRotate = !0, w(this, At).controls.enablePan = !0, w(this, At).controls.enableZoom = !0, w(this, At).controls.minTilt = null != (t = this.currentMinTilt) ? t : w(this, At).controls.minTilt;
    }
    createStackBoundingBox() {
      var t, e;
      let n = new Jx(this.object, "rgba(160, 160, 160)");
      rA && w(this, At).scene.add(n);
      let i = new $t().setFromObject(n),
        r = (null != (e = null == (t = this.transitionOptions) ? void 0 : t.verticalDistanceBetweenMaps) ? e : eU) / w(this, At).venue.maps[0].scale,
        o = this.computeMapZ(this.mapObjectsArray[0], 0, this.transitionOptions),
        s = this.computeMapZ(this.mapObjectsArray[this.mapObjectsArray.length - 1], this.mapObjectsArray.length - 1, this.transitionOptions),
        a = [new ne(i.min.x, i.min.y, o), new ne(i.min.x, i.max.y, o), new ne(i.max.x, i.min.y, o), new ne(i.max.x, i.max.y, o), new ne(i.min.x, i.min.y, s), new ne(i.min.x, i.max.y, s), new ne(i.max.x, i.min.y, s), new ne(i.max.x, i.max.y, s)],
        l = new Ft(oA(a), new Sr({
          color: "blue",
          wireframe: !0
        }));
      rA && w(this, At).scene.add(l);
      let u = [new ne(i.min.x, i.min.y, -r / 2), new ne(i.min.x, i.max.y, -r / 2), new ne(i.max.x, i.min.y, -r / 2), new ne(i.max.x, i.max.y, -r / 2), new ne(i.min.x, i.min.y, r / 2), new ne(i.min.x, i.max.y, r / 2), new ne(i.max.x, i.min.y, r / 2), new ne(i.max.x, i.max.y, r / 2)],
        h = new Ft(oA(u), new Sr({
          color: "red",
          wireframe: !0
        }));
      h.visible = !1, h.applyMatrix4(this.object.matrixWorld);
      let c = [new ne(i.min.x, i.min.y, -550), new ne(i.min.x, i.max.y, -550), new ne(i.max.x, i.min.y, -550), new ne(i.max.x, i.max.y, -550), new ne(i.min.x, i.min.y, 550), new ne(i.min.x, i.max.y, 550), new ne(i.max.x, i.min.y, 550), new ne(i.max.x, i.max.y, 550)],
        p = new Ft(oA(c), new Sr({
          color: "blue",
          wireframe: !0
        }));
      p.visible = !1, p.applyMatrix4(this.object.matrixWorld), this.viewportBox = new $t().setFromObject(p), w(this, At).scene.add(p);
      let d = new $t().setFromObject(h);
      w(this, At).scene.add(h), this.stackContainerMesh = l, this.containerBoxHelper = new $t().setFromObject(l), this.currentMapWrapperMesh = h, rA && (this.currentMapWrapperMesh.visible = !0), this.currentMapWrapperBoxHelper = d, this.viewportMesh = p;
      let f = w(this, At).controls.getPedestal();
      this.currentMapWrapperMesh.position.z = f, this.viewportMesh.position.z = f, this.currentMapWrapperBoxHelper.setFromObject(this.currentMapWrapperMesh), this.viewportBox.setFromObject(this.viewportMesh);
    }
    focusOnStackBox(t) {
      return new Promise(e => {
        var n, i, r, o, s;
        let a = (null == (n = null == t ? void 0 : t.focusOn) ? void 0 : n.options) || {},
          l = null != (i = null == a ? void 0 : a.rotation) ? i : jy,
          u = null != (r = null == a ? void 0 : a.tilt) ? r : tA,
          h = null != (o = null == a ? void 0 : a.easing) ? o : $E,
          c = null != (s = null == a ? void 0 : a.duration) ? s : QE;
        w(this, At).focusOn({
          ...a,
          boundingBox: this.currentMapWrapperBoxHelper,
          duration: c,
          rotation: l,
          padding: a.safeAreaInsets,
          tilt: u,
          focusZoomFactor: 1,
          curve: Os[h],
          callback: () => {
            e(void 0);
          }
        });
      });
    }
    unmount() {
      this.unlockControls(), w(this, At).controls.dispatcher.removeEventListener(w(this, At).controls.CAMERA_EVENTS.PEDESTAL_CHANGE_EVENT.type, this.updateFrame), w(this, At).scene.remove(this.currentMapWrapperMesh), w(this, At).scene.remove(this.viewportMesh), w(this, At).scene.remove(this.currentMapWrapperBoxHelper), w(this, At).scene.remove(this.viewportBox), w(this, At).scene.remove(this.stackContainerMesh), this.destroyLabels();
    }
    computeMapZ(t, e, n) {
      var i;
      return (null != e ? e : t.mapClass.elevation) * ((null != (i = null == n ? void 0 : n.verticalDistanceBetweenMaps) ? i : eU) / w(this, At).referenceMap.scale);
    }
    async prepare(t, e) {
      await super.prepare(t, e);
    }
    postRender() {
      super.postRender(), this.createMapLabels(), w(this, At).cameraObject.updateProjectionMatrix(), w(this, At).controls.dispatcher.addEventListener(w(this, At).controls.CAMERA_EVENTS.PEDESTAL_CHANGE_EVENT.type, this.updateFrame);
    }
    expandMaps(t, e) {
      var n, i;
      let r = this.mapObjects.get(this.currentMap.id),
        o = (null == (i = null == (n = null == e ? void 0 : e.focusOn) ? void 0 : n.options) ? void 0 : i.duration) || Jpe,
        s = t.flatMap((t, n) => {
          if (t.onVisible(), t === r) return {
            start: () => Promise.resolve()
          };
          let i = this.computeMapZ(t, n, e);
          return this.object.add(t.object), [Nl({
            from: {
              z: r.object.position.z
            },
            to: {
              z: i
            },
            duration: o,
            onUpdate: ({
              z: e
            }) => {
              t.object.position.z = e, w(this, At).tryRendering();
            }
          }), t.fadeIn({
            delay: 50,
            layers: ["indoor", "path", "vertical-path"]
          })];
        });
      return {
        start: () => Promise.all(s.map(t => t.start(w(this, At))))
      };
    }
    contractMaps(t = this.mapObjects.get(this.currentMap.id)) {
      var e, n;
      let i = this.mapObjectsArray,
        r = this.transitionOptions,
        o = (null == (n = null == (e = null == r ? void 0 : r.focusOn) ? void 0 : e.options) ? void 0 : n.duration) || Zpe,
        s = i.flatMap(e => t === e ? {
          start: () => Promise.resolve()
        } : [Nl({
          from: {
            z: e.object.position.z
          },
          to: {
            z: t.object.position.z
          },
          duration: o,
          onUpdate: ({
            z: t
          }) => {
            e.object.position.z = t, w(this, At).tryRendering();
          }
        }), e.fadeOut({
          duration: o - 100
        })]);
      return {
        start: () => Promise.all(s.map(t => t.start(w(this, At))))
      };
    }
    resize() {
      this.focusOnStackBox({
        focusOn: {
          options: {
            tilt: w(this, At).controls.getTilt(),
            rotation: w(this, At).controls.getRotation()
          }
        }
      });
    }
  };
u(sA, "MapViewStackScene"), At = new WeakMap();
var Wy = sA;
E(), E();
var ew = 2 * Math.PI,
  Xy = Math.PI / 2,
  aA = 1.5 * Math.PI,
  Qpe = u(function (t) {
    let e = t.image,
      n = t.rotation || 0,
      i = e.position.clone(),
      r = e.rotation.z,
      o = n,
      s = u(function () {
        let t = e.geometry;
        t.boundingBox || t.computeBoundingBox(), n = (n + Math.PI) % ew, e.rotation.z = e.rotation.z + Math.PI, e.translateX(-2 * (t.boundingBox.min.x + (t.boundingBox.max.x - t.boundingBox.min.x) / 2)), e.translateY(-2 * (t.boundingBox.min.y + (t.boundingBox.max.y - t.boundingBox.min.y) / 2));
      }, "flip");
    this.flipIfNeeded = function (t) {
      let e = (n - t + ew) % ew;
      (e > Xy && e < aA || e < -Xy && e > -aA) && s();
    }, this.reset = function () {
      e.position.x = i.x, e.position.y = i.y, e.rotation.z = r, n = o;
    };
  }, "FlippableImage"),
  PC = Qpe;
E();
var $m,
  au = Rt(il()),
  tU = "attribute float pathDistance;\nattribute vec3 pathNormal;\nattribute vec3 pathTangent;\n\nuniform vec2 uvScale;\nuniform float vertexes;\nuniform float complete;\nuniform float nearRadius;\nuniform float farRadius;\nuniform float nearZoom;\nuniform float farZoom;\nuniform float pulse;\nuniform float pulseLength;\nuniform bool pulseBulge;\nuniform bool pathIsVertical;\nuniform bool displayArrowsOnPath;\nuniform vec2 cameraParameters;\nuniform float flattenFactor;\n\nvarying float zoomLevel;\nvarying float radius;\nvarying vec2 fragTexcoord;\nvarying float fragTopTextureU;\nvarying float fragPathDistance;\n\n// Map the x value from the range [xMin, xMax] to the range [yMin, yMax] using\n// linear interpolation/extrapolation.\n//\n// This performs a pure linear mapping `y = mx + b` where\n// `m = (yMax - yMin) / (xMax - xMin)`,\n// `b = -xMin * (yMax - yMin) / (xMax - xMin) + yMin`.\nfloat remap(float x, float xMin, float xMax, float yMin, float yMax) {\n\treturn (x - xMin) / (xMax - xMin) * (yMax - yMin) + yMin;\n}\n\n// Map the x value from [xMin, xMax] to the range [yMin, yMax] using linear\n// interpolation, clamping result values outside [yMin, yMax].\nfloat clampRemap(float x, float xMin, float xMax, float yMin, float yMax) {\n\treturn clamp(remap(x, xMin, xMax, yMin, yMax), yMin, yMax);\n}\n\nvoid main() {\n\tfragPathDistance = pathDistance;\n\n\t// We can get an origin point for the cross-section of the path by\n\t// subtracting the surface normal times the radius, since the surface normal\n\t// points strictly away from the centre.\n\tvec3 origin = position - nearRadius * normal;\n\n\t// Inflate the path along its surface normal to increase its radius from\n\t// `nearRadius` to `farRadius` when the camera is at `farZoom`.\n\tvec3 adjustedPosition = position;\n\tzoomLevel = clampRemap(cameraParameters.x, nearZoom, farZoom, 0.0, 1.0);\n\tadjustedPosition += normal * (farRadius - nearRadius) * zoomLevel;\n\n\t// Determine how far the path extends \"up\" or \"down\" in the direction of the\n\t// path normal.\n\tfloat height = dot(adjustedPosition - origin, pathNormal);\n\n\t// Flatten the bottom half of the path entirely so that it's flat\n\t// against the floor. This makes the path look nicer when it's\n\t// semitransparent behind opaque geometry, so you don't see it\n\t// peeking through.\n\tfloat desiredHeight = max(height, 0.0);\n\n\tdesiredHeight = desiredHeight * flattenFactor;\n\n\tfloat flattenMagnitude = height - desiredHeight;\n\tadjustedPosition = adjustedPosition - pathNormal * flattenMagnitude;\n\n\t// Transform the vertices into NDC.\n\tvec4 mvPosition = modelViewMatrix * vec4(adjustedPosition, 1.0);\n\tgl_Position = projectionMatrix * mvPosition;\n\n\tfragTexcoord = uv;\n\n\t// Compute a texture coordinate for mapping the arrow texture to the path.\n\t// We don't want to use the u-value that Three.js provides, because the\n\t// path may end up twisting arbitrarily -- but we want the arrow texture to\n\t// always be on the top of the path.\n\tvec3 bitangent = cross(normal, pathTangent);\n\tfragTopTextureU = -dot(bitangent, pathNormal) * 0.5 + 0.5;\n\n\tradius = mix(nearRadius, farRadius, zoomLevel);\n}\n",
  nU = '#define ARROW_FADING_POINT 0.15\n\nuniform float complete;\nuniform float nearRadius;\nuniform float farRadius;\nuniform vec2 resolution;\nuniform vec2 cameraParameters;\nuniform vec3 color;\nuniform float pathLength;\nuniform bool showPulse;\nuniform vec3 pulseColor;\nuniform float pulse;\nuniform float pulseLength;\nuniform bool pathIsVertical;\nuniform bool displayArrowsOnPath;\nuniform float arrowAnimationTimer;\nuniform sampler2D arrowTexture;\n\nvarying float zoomLevel;\nvarying float radius;\nvarying vec2 fragTexcoord;\nvarying float fragTopTextureU;\nvarying float fragPathDistance;\n\n// How long the arrow should be, as a factor of `pathRadius`. Since we\'ve\n// mostly flattened the top of the path, values near 2.0 (the diameter)\n// will probably look best.\nconst float arrowLength = 2.0;\n\n// How much of a relative margin the arrow texture should have inside the\n// area laid out for it. Useful to pull the arrow away from the edges of the\n// path, which slope down.\nconst float arrowMargin = 0.1;\n\n// How many arrow-lengths of space should be between arrows on a short path.\nconst float arrowSpacingOnShortPath = 6.0;\n\n// How many arrow-lengths of space should be between arrows on a long path.\nconst float arrowSpacingOnLongPath = 7.5;\n\n// How long a path must be to be considered "long", as a factor of\n// the path radius.\nconst float longPathLength = 200.;\n\n// How long a path must be to be considered "short", as a factor of the\n// path radius.\nconst float shortPathLength = 75.;\n\n// How much of the path\'s length the fade-in should comprise when going from\n// zero opacity to full opacity.\nconst float completeLength = 0.1;\n\n// Map the x value from the range [xMin, xMax] to the range [yMin, yMax] using\n// linear interpolation/extrapolation.\n//\n// This performs a pure linear mapping `y = mx + b` where\n// `m = (yMax - yMin) / (xMax - xMin)`,\n// `b = -xMin * (yMax - yMin) / (xMax - xMin) + yMin`.\nfloat remap(float x, float xMin, float xMax, float yMin, float yMax) {\n\treturn (x - xMin) / (xMax - xMin) * (yMax - yMin) + yMin;\n}\n\n// Map the x value from [xMin, xMax] to the range [yMin, yMax] using linear\n// interpolation, clamping result values outside [yMin, yMax].\nfloat clampRemap(float x, float xMin, float xMax, float yMin, float yMax) {\n\treturn clamp(remap(x, xMin, xMax, yMin, yMax), yMin, yMax);\n}\n\nvoid main(void) {\n\t// Compute the opacity of the path based on the distance from the current\n\t// fragment to the `complete` value as it varies from 0.0 to 1.0.\n\t// Fragments that are at the `complete` value or past it will be fully\n\t// transparent, while fragments that are at `complete - completeLength`\n\t// or before it will be fully opaque. However, we adjust the `complete`\n\t// value here so that it overshoots by one full `completeLength`, so that\n\t// the entire path will be opaque when the `complete` value is at 1.0.\n\tfloat completeLocation = complete * (1.0 + completeLength);\n\tfloat completeAmount = clampRemap(\n\t\tfragPathDistance,\n\t\tcompleteLocation - completeLength,\n\t\tcompleteLocation,\n\t\t0.0,\n\t\t1.0\n\t);\n\tfloat opacity = 1.0 - smoothstep(0.0, 1.0, completeAmount);\n\n\t// 2020/01/09 Terence Dickson\n\t// When we render the background and overlay for the mapbox outdoor context\n\t// behind everything else in single-buffer rendering, the fact that the path\n\t// writes to the depth buffer means that the background and overlay will not\n\t// be drawn behind the path even when the path is still fading in. The effect\n\t// is subtle and is only visible in single-buffer rendering so this quick fix\n\t// prevents writes to the depth buffer for zero opacity fragments, which gets\n\t// rid of the most visually-offensive ghosting.\n\tif (opacity <= 0.0) {\n\t\tdiscard;\n\t}\n\n\t// Push in the texture coordinates so that they ramp up\n\t// at `arrowMargin` instead of at zero; this remapping looks somewhat\n\t// like this:\n\t// 1 ^        ___\n\t//   |       /\n\t//   |      /\n\t//   |     /\n\t//   |    /\n\t//   |___/\n\t// 0 +----------\x3e\n\t//   0   ^      1\n\t//       arrowMargin\n\t// Making the arrows narrower on the path.\n\tfloat u = fragTopTextureU;\n\tu = clamp(\n\t\tu * (1. / (1. - arrowMargin * 2.)) - (1. / (1. - arrowMargin * 2.) - 1.) / 2.,\n\t\t0.0,\n\t\t1.0\n\t);\n\n\tfloat arrowSpacing = clampRemap(\n\t\tpathLength,\n\t\tshortPathLength * radius,\n\t\tlongPathLength * radius,\n\t\tarrowSpacingOnShortPath,\n\t\tarrowSpacingOnLongPath\n\t);\n\n\t// Reduce the spacing between arrows when the camera zooms out, as increasing\n\t// the path radius will increase the arrow size and thus be able to fit\n\t// fewer arrows on in total, and this secondary movement of the arrows\n\t// "zooming off" the end of the path is unpleasant\n\tfloat expandAmount = mix(1.0, farRadius / nearRadius, zoomLevel);\n\tfloat effectiveArrowSpacing =\n\t\tarrowSpacing * 1.0 / expandAmount +\n\t\tarrowMargin * 2.0;\n\n\tfloat effectiveArrowLength = arrowLength * radius * (1. - arrowMargin * 2.0);\n\n\t// Adjust the slope of the vertical texture coordinate so that it goes\n\t// from 0 to 1 along the length of the arrow plus the spacing between\n\t// arrows, and adjust its x-intercept so that one arrow moves to the\n\t// exact position of the next arrow as `arrowAnimationTimer` goes\n\t// from 0 to 1\n\tfloat v = (\n\t\tfragTexcoord.x * (pathLength / effectiveArrowLength)\n\t\t- arrowAnimationTimer * (1. + effectiveArrowSpacing)\n\t);\n\n\t// Compute a "looping sawtooth" wave for determining the vertical texture\n\t// coordinates of the arrow texture, roughly as follows:\n\t// 3 ^              /\n\t//   |          ___/\n\t// 2 |         /\n\t//   |     ___/\n\t// 1 |    /\n\t//   |___/\n\t// 0 +---------------\x3e\n\t//   0   ^ ^\n\t//   ^   |_|\n\t//   |   effectiveArrowLength\n\t//   |___|\n\t//   effectiveArrowSpacing\n\t//\n\t// This is effectively equivalent to this sort of sawtooth wave:\n\t//   ^\n\t// 1 |    /    /    /\n\t//   |___/ ___/ ___/\n\t// 0 +---------------\x3e\n\t//\n\t// Causing the image of the arrow to repeat, with dead space (the bottom\n\t// edge of the texture stretched out) between the arrows at the provided\n\t// spacing. The reason why the "looping" design is preferred is because\n\t// it takes advantage of WebGL\'s `GL_REPEAT` texture wrapping behaviour\n\t// to avoid the discontinuity that can end up causing visual artifacts.\n\tif (mod(v, (1. + effectiveArrowSpacing)) < 1.) {\n\t\tv = v - effectiveArrowSpacing * floor(v / (1. + effectiveArrowSpacing));\n\t} else {\n\t\tv = ceil(v / (1. + effectiveArrowSpacing));\n\t}\n\n\t// Use the r-component of the texture to determine whether the arrow covers\n\t// this fragment or not\n\tvec2 sampleTexcoord = vec2(u, v);\n\tfloat arrowAmount = 0.0;\n\tvec3 secondColor = color;\n\n\tif (displayArrowsOnPath) {\n\t\tarrowAmount = texture2D(arrowTexture, sampleTexcoord).r;\n\t\tfloat delta = 1.0 - abs(fragPathDistance * 2.0 - 1.0);\n\t\tsecondColor = mix(color, pulseColor, 1.0 - smoothstep(ARROW_FADING_POINT, 0.0, delta));\n\t}\n\n\tif (showPulse) {\n\t\t// Add the pulse color to the path by determining how far the current fragment\n\t\t// is from `pulse`\n\t\tfloat pulseLocation = remap(\n\t\tpulse,\n\t\t0.0,\n\t\t1.0,\n\t\t-pulseLength,\n\t\t1.0 + pulseLength\n\t\t);\n\t\tfloat pulseDistance = smoothstep(\n\t\t0.0,\n\t\tpulseLength,\n\t\tabs(fragPathDistance - pulseLocation)\n\t\t);\n\n\t\t// Blend the pulse color to the path based on how close this fragment is to\n\t\t// the `pulse` value and whether it\'s covered by an arrow -- but if it\'s\n\t\t// covered by *both*, then we go back to using the regular path color\n\t\t// (making arrows look like "holes" when they\'re overlapping the pulse.)\n\t\tfloat pulseLevel = abs(1.0 - pulseDistance - arrowAmount);\n\n\t\tgl_FragColor = vec4(mix(color, secondColor, pulseLevel), opacity);\n\t} else if (displayArrowsOnPath) {\n\t\tgl_FragColor = vec4(mix(color, pulseColor, arrowAmount), opacity);\n\t} else {\n\t\tgl_FragColor = vec4(color, opacity);\n\t}\n\t#include <encodings_fragment>\n}',
  tde = 10,
  nde = new pa(),
  ide = {
    color: "#4b90e2",
    pulseColor: "#ffffff",
    pulseIterations: 1,
    nearRadius: 1.8,
    nearZoom: 375,
    farZoom: 1e4,
    drawDuration: 1200,
    curve: au.default.Easing.Cubic.InOut,
    displayArrowsOnPath: !1
  },
  rde = {
    color: "#7ed321",
    pulseColor: "#ffffff",
    nearRadius: 1.8,
    nearZoom: 375,
    farZoom: 1e4,
    drawDuration: 800,
    curve: au.default.Easing.Cubic.InOut,
    displayArrowsOnPath: !1
  },
  iU = 2.3,
  ode = 600,
  tw = class {
    constructor(t) {
      re(this, $m, void 0), he(this, $m, t);
    }
    get id() {
      return w(this, $m).id;
    }
    get nodes() {
      return w(this, $m).nodes;
    }
  };
u(tw, "Path"), $m = new WeakMap();
var lA = class {
  constructor(t, e, n) {
    A(this, "id"), A(this, "nodes"), A(this, "pathSegments"), A(this, "options"), this.id = ls(), this.nodes = t, this.pathSegments = e, this.options = n;
  }
};
u(lA, "InternalPath");
var $n,
  Yy,
  rU,
  Zy,
  oU,
  Jy,
  sU,
  Ky,
  aU,
  nw,
  sde,
  iw,
  ade,
  Qy,
  lU,
  uA = class {
    constructor(t) {
      re(this, Yy), re(this, Zy), re(this, Jy), re(this, Ky), re(this, nw), re(this, iw), re(this, Qy), re(this, $n, void 0), A(this, "pathSegments", new Map()), A(this, "pathsById", new Map()), A(this, "pathsByMeshId", new Map()), A(this, "connectionsPathMeshes", new ha()), he(this, $n, t), w(this, $n).scene.add(this.connectionsPathMeshes);
    }
    getPathLength(t) {
      let e = 0;
      for (let n = 0, i = t.length - 1; n < i; ++n) {
        let i = t[n],
          r = t[n + 1];
        i.path.includes(r) && (e += Math.sqrt(Math.pow(r.x - i.x, 2) + Math.pow(r.y - i.y, 2)));
      }
      return e;
    }
    drawPath(t, e = {}) {
      let n = mt(this, Jy, sU).call(this, t, e),
        i = new lA(t, n, e),
        r = new tw(i);
      return mt(this, Yy, rU).call(this, r, i), r;
    }
    redrawPath(t, e = {}) {
      var n;
      let i = null == (n = this.pathsById.get(t.id)) ? void 0 : n.internalPath;
      if (null == i) return void ke.warn("A path that does not exist cannot be redrawn.");
      (null == e || Object.keys(e).length < 1) && (e = i.options), i.pathSegments.forEach(t => {
        mt(this, Qy, lU).call(this, t);
      });
      let r = mt(this, Jy, sU).call(this, i.nodes, e);
      i.pathSegments = r, mt(this, Zy, oU).call(this, t), mt(this, Yy, rU).call(this, t, i);
    }
    removePath(t) {
      let e;
      e = "string" == typeof t ? t : t.id;
      let n = this.pathsById.get(e);
      if (null == n) return;
      let i = n.internalPath.pathSegments;
      if (i) for (let t of i) {
        let e = this.pathSegments.get(t.id);
        mt(this, Qy, lU).call(this, e);
      }
      mt(this, Zy, oU).call(this, n.path);
    }
    hideConnectionSegments() {
      this.connectionsPathMeshes.children.forEach(t => {
        t.visible = !1;
      }), w(this, $n).tryRendering();
    }
    showConnectionSegments() {
      this.connectionsPathMeshes.children.forEach(t => {
        t.visible = !0;
      }), w(this, $n).tryRendering();
    }
    removeAllPaths() {
      for (let {
        path: t
      } of this.pathsById.values()) this.removePath(t);
      this.pathSegments.clear(), w(this, $n).renderer.disposeOfRenderLists(), w(this, $n).tryRendering();
    }
  };
u(uA, "PathsController"), $n = new WeakMap(), Yy = new WeakSet(), rU = u(function (t, e) {
  for (let n of e.pathSegments) this.pathSegments.set(n.id, n), this.pathsByMeshId.set(n.object.uuid, {
    path: t,
    internalPath: e
  });
  this.pathsById.set(e.id, {
    path: t,
    internalPath: e
  });
}, "#addPathToCache"), Zy = new WeakSet(), oU = u(function (t) {
  let e = this.pathsById.get(t.id);
  if (null == e) return;
  let n = e.internalPath;
  for (let t of n.pathSegments) this.pathSegments.delete(t.id), this.pathsByMeshId.delete(t.object.uuid);
  this.pathsById.delete(n.id);
}, "#removePathFromCache"), Jy = new WeakSet(), sU = u(function (t, e = {}) {
  let n = {
      ...ide,
      ...e,
      connectionPathOptions: {
        ...rde,
        ...e.connectionPathOptions
      }
    },
    i = e.pulsePauseDuration || ode;
  null == n.connectionPathOptions.farRadius && null != n.connectionPathOptions.nearRadius && (n.connectionPathOptions.farRadius = n.connectionPathOptions.nearRadius * iU), null == n.farRadius && null != n.nearRadius && (n.farRadius = n.nearRadius * iU);
  let r,
    o,
    s,
    a = 0,
    l = t.reduce((e, i, l) => {
      let u = t[l + 1],
        h = t[l - 1];
      if (0 === l) r = i.map.id;else if (i.map.id != r || null == u) {
        let c = null == u && i.map.id === r ? l : l - 1;
        s = mt(this, nw, sde).call(this, t.slice(a, c + 1), r, {
          ...n,
          animateDrawing: r === w(this, $n).currentMap && n.animateDrawing,
          drawDuration: r === w(this, $n).currentMap ? n.drawDuration : 0
        }), a = l, e.push(s), null != o && (o.tween.chain(s.tween), o.pulseTween.chain(s.pulseTween), o.pulseTween.onComplete(o.resetPulse)), o = s, null != h && h.map.id != i.map.id && !0 === n.drawConnectionSegments && w(this, $n).visibleMapsInCurrentScene.length > 1 && (s = mt(this, iw, ade).call(this, [h, i], n.connectionPathOptions), e.push(s), null != o && (o.tween.chain(s.tween), o.pulseTween.chain(s.pulseTween), o.pulseTween.onComplete(o.resetPulse)), o = s), r = i.map.id;
      }
      return e;
    }, []),
    u = 1,
    h = n.pulseIterations || 1 / 0;
  if (l.length > 0) {
    let t = l[0],
      e = l[l.length - 1];
    t.tween.start(), t.tween.onComplete(() => {
      t.pulseTween.start();
    }), e.endPauseTween = new au.default.Tween({}).to({
      value: 1
    }, i).chain(t.pulseTween).onUpdate(() => w(this, $n).tryRendering(hi.TWEEN)), h > 1 && e.pulseTween.chain(e.endPauseTween), e.pulseTween.onComplete(() => {
      u + 1 >= h ? l.forEach(t => {
        t.pulseTween.onComplete(() => {}), t.pulseTween.stop(), t.endPauseTween && t.endPauseTween.stop(), t.resetPulse(), w(this, $n).tryRendering(hi.ANIMATED);
      }) : (e.resetPulse(), t.resetPulse()), u++;
    });
  }
  return w(this, $n).tryRendering(hi.ANIMATED), l;
}, "#drawAllPathSegments"), Ky = new WeakSet(), aU = u(function (t, e, n) {
  let i = (n = n || {}).color || "#ff834c",
    r = n.pulseColor || "#000000",
    o = void 0 !== n.nearRadius ? n.nearRadius : 1.8,
    s = void 0 !== n.farRadius ? n.farRadius : o,
    a = void 0 !== n.nearZoom ? n.nearZoom : 375,
    l = void 0 !== n.farZoom ? n.farZoom : 1e4,
    h = void 0 !== n.drawDuration ? n.drawDuration : 1500,
    c = n.curve || au.default.Easing.Cubic.InOut,
    p = n.displayArrowsOnPath || !1,
    d = n.isConnectionPathSegment || !1,
    f = n.displayArrowsOnPath || n.flattenPath || !1,
    m = void 0 === n.showPulse || n.showPulse,
    g = void 0 === n.animateDrawing || n.animateDrawing,
    v = 0;
  if (d) for (let e = 1; e < t.length; ++e) {
    let n = t[e].x - t[e - 1].x,
      i = t[e].z - t[e - 1].z;
    v += Math.sqrt(n * n + i * i);
  } else for (let e = 1; e < t.length; ++e) {
    let n = t[e].x - t[e - 1].x,
      i = t[e].y - t[e - 1].y,
      r = t[e].z - t[e - 1].z;
    v += Math.sqrt(n * n + i * i + r * r);
  }
  let y = nde.load(np.get("arrow"));
  y.colorSpace = Nt;
  let _ = {
      vertexes: {
        type: "f",
        value: 1
      },
      resolution: {
        type: "v2",
        value: w(this, $n).resolution
      },
      cameraParameters: {
        type: "v2",
        value: w(this, $n).cameraParameters
      },
      complete: {
        type: "f",
        value: g ? 0 : 1
      },
      color: {
        type: "c",
        value: new yt(i)
      },
      pathLength: {
        type: "f",
        value: v
      },
      nearRadius: {
        type: "f",
        value: o
      },
      farRadius: {
        type: "f",
        value: s
      },
      nearZoom: {
        type: "f",
        value: a
      },
      farZoom: {
        type: "f",
        value: l
      },
      pulseColor: {
        type: "c",
        value: new yt(r)
      },
      pulse: {
        type: "f",
        value: 0
      },
      pulseLength: {
        type: "f",
        value: .075
      },
      pulseBulge: {
        type: "b",
        value: !1
      },
      pathIsVertical: {
        type: "b",
        value: d
      },
      arrowAnimationTimer: {
        type: "f",
        value: 0
      },
      arrowTexture: {
        type: "t",
        value: y
      },
      displayArrowsOnPath: {
        type: "b",
        value: p
      },
      flattenFactor: {
        type: "f",
        value: f ? .05 : 1
      },
      showPulse: {
        type: "b",
        value: m
      }
    },
    x = new Wg(t);
  x.curveType = "catmullrom", x.tension = 0;
  let E = 30 * e.length,
    b = new Md(x, E, o, 8, !1),
    S = new Float32Array(b.attributes.position.count);
  for (let t = e.length; t < S.length; t++) S[t] = t;
  b.setAttribute("vertexIndex", new ui(S, 1));
  let M = new Float32Array(b.attributes.position.count),
    T = new ui(M, 1);
  for (let t = 0; t < E; t++) for (let e = 0; e <= 8; ++e) T.setX(9 * t + e, t / E);
  b.setAttribute("pathDistance", T);
  let A = new Float32Array(3 * b.attributes.normal.count),
    P = new ui(A, 3);
  for (let t = 0; t < E; t++) {
    let e = b.tangents[t];
    for (let n = 0; n <= 8; ++n) P.setXYZ(9 * t + n, e.x, e.y, e.z);
  }
  b.setAttribute("pathTangent", P);
  let C = new Float32Array(3 * b.attributes.normal.count),
    I = new ui(C, 3);
  for (let t = 0; t < E; t++) {
    let e = b.tangents[t];
    var N, L, R;
    d ? (N = e.x * e.y, L = e.y * e.y - 1, R = e.z * e.y) : (N = -e.x * e.z, L = -e.y * e.z, R = 1 - e.z * e.z);
    let n = Math.sqrt(N * N + L * L + R * R);
    0 === n && (n = 1);
    let i = N / n,
      r = L / n,
      o = R / n;
    for (let e = 0; e <= 8; ++e) I.setXYZ(9 * t + e, i, r, o);
  }
  b.setAttribute("pathNormal", I);
  let O = new wi({
    uniforms: _,
    vertexShader: tU,
    fragmentShader: nU
  });
  O.transparent = !0, O.alphaTest = .5, _.resolution.value.x = w(this, $n).renderer.getBufferSize().width, _.resolution.value.y = w(this, $n).renderer.getBufferSize().height, _.vertexes.value = S.length, _.arrowTexture.value.wrapS = Br, _.arrowTexture.value.wrapT = Br, _.arrowTexture.value.anisotropy = w(this, $n).renderer.getMaxAnisotropy();
  let q = new Ft(b, O),
    D = u(() => {
      w(this, $n).tryRendering(hi.ANIMATED);
    }, "tryRenderingAnimated"),
    k = new au.default.Tween(_.pulse).to({
      value: 1
    }, h).easing(c).onUpdate(D),
    F = new au.default.Tween(_.complete).to({
      value: 1
    }, h).easing(c).onUpdate(D),
    U = new au.default.Tween(_.arrowAnimationTimer).to({
      value: 1
    }, 3e3).easing(au.default.Easing.Linear.None).repeat(1 / 0).onUpdate(D);
  p && U.start();
  let B = {
    id: q.id,
    nodes: e,
    mapId: n.mapId,
    object: q,
    tween: F,
    pulseTween: k,
    arrowAnimationTween: U,
    reset: function () {
      _.complete.value = 0;
    },
    resetPulse: function () {
      _.pulse.value = 0;
    }
  };
  return O.userData = {
    layer: d ? "vertical-path" : "path"
  }, B;
}, "#drawSegment"), nw = new WeakSet(), sde = u(function (t, e, n = {
  color: "#ff834c",
  pulseColor: "white",
  pulseIterations: 1 / 0,
  nearRadius: 1.8,
  nearZoom: 375,
  farZoom: 1e4,
  drawDuration: 1500,
  displayArrowsOnPath: !1
}) {
  let i = n.nearRadius || 2,
    r = n.farRadius || n.nearRadius || 2,
    o = e ? w(this, $n).venue.maps.find(t => t.id === e) : w(this, $n).venue.maps.find(t => t.id === w(this, $n).currentMap),
    s = (null == o ? void 0 : o.scale) || 1;
  if (i /= s, r /= s, null == w(this, $n).currentMap) throw new Error("Unable to retrieve the current map");
  let a = e ? Vr(e) : w(this, $n).currentMap,
    l = [];
  for (let e = 0; e < t.length; e++) {
    let n = t[e],
      r = new ne(n.x - o.width / 2, -n.y + o.height / 2, i / 2);
    l.push(r);
  }
  l.push(l[l.length - 1].clone().setZ(0)), l.unshift(l[0].clone().setZ(0));
  let u = mt(this, Ky, aU).call(this, l, t, {
    ...n,
    nearRadius: i,
    farRadius: r,
    mapId: a
  });
  return u.object.name = "path", u.object.layers.set(bo.ANIMATED), w(this, $n).mapObjects.get(a).add(u.object), u;
}, "#drawPathSegment"), iw = new WeakSet(), ade = u(function (t, e = {
  color: "#7dd322",
  pulseColor: "#ffffff",
  pulseIterations: 1 / 0,
  nearRadius: 1.8,
  nearZoom: 375,
  farZoom: 1e4,
  drawDuration: 1500,
  curve: au.default.Easing.Cubic.InOut,
  displayArrowsOnPath: !1
}) {
  let n = e.nearRadius || 2,
    i = e.farRadius || e.nearRadius || 2,
    r = w(this, $n).referenceMap,
    o = (null == r ? void 0 : r.scale) || 1;
  n /= o, i /= o;
  let s = p7(w(this, $n).convertTo3DMapPosition(t[0]), w(this, $n).convertTo3DMapPosition(t[1]), tde),
    a = mt(this, Ky, aU).call(this, s, t, {
      ...e,
      nearRadius: n,
      farRadius: i,
      mapId: w(this, $n).referenceMap.id,
      isConnectionPathSegment: !0
    }),
    l = new $t().setFromObject(a.object),
    u = new ne();
  return l.getCenter(u), a.object.layers.set(bo.ANIMATED), a.object.geometry.center(), a.object.position.copy(u), w(this, $n).billboardManager.add(a.object), this.connectionsPathMeshes.add(a.object), a;
}, "#drawConnectionPathSegment"), Qy = new WeakSet(), lU = u(function (t) {
  t && (w(this, $n).scene.remove(t.object), "function" == typeof t.object.destroy && t.object.destroy(), t.pulseTween.stop(), t.endPauseTween && t.endPauseTween.stop(), t.tween.stop(), t.arrowAnimationTween.stop(), t.pulseTween = void 0, t.tween = void 0, t.arrowAnimationTween = void 0, this.pathSegments.delete(t.id), this.connectionsPathMeshes.remove(t.object), w(this, $n).billboardManager.remove(t.object));
}, "#removePathSegment");
var cA = uA;
E(), E(), E();
var lde = u(({
    image: t
  }) => !!(null == t ? void 0 : t.visible) && Boolean(t.url || t.original), "imageVisible"),
  rw = u((t, e) => lde(t) && e[t.id + "_image"], "imageVisibleAndRendered");
function uU(t, e, n, i) {
  let r = [],
    o = (null == n ? void 0 : n.locations) || t.locations;
  for (let s of t.polygons) {
    let a,
      [l] = s.entrances;
    if (l && (!(null == i ? void 0 : i.id) || i.id === l.map.id) && s.geometry.visible && (a = Td(s, t))) {
      let t = (null == n ? void 0 : n.createDespiteImage) || a.showLabelWhenImagePresent || a.showSmartLabelWhenImagePresent;
      if (rw(s, e) && !t || !o.includes(a)) continue;
      let i = (null == n ? void 0 : n.excludeTypes) || [];
      if (i.length > 0 && i.includes(a.type)) continue;
      let u = ude(s, l, a, n || {});
      null != u && r.push(u);
    }
  }
  return r;
}
function ude(t, e, n, i) {
  var r, o, s, a, l;
  let u = "test" === D.env.NODE_ENV ? Qs.testId : Math.random();
  Qs.testId++;
  let h,
    c = n.name,
    p = n.shortName;
  return n.states && n.states.length > 0 && (h = (null == (r = n.state) ? void 0 : r.id) && (null == (s = null == i ? void 0 : i.translationMap) ? void 0 : s[null == (o = n.state) ? void 0 : o.id]) || (null == (a = n.state) ? void 0 : a.name) || null), {
    interactive: i.interactive,
    polygon: t,
    rank: (null == (l = t.rank) ? void 0 : l.score) || u,
    entranceNode: e,
    text: null == h ? p || c : (p || c) + ` (${h})`,
    appearance: i.appearance,
    createDespiteImage: i.createDespiteImage
  };
}
u(uU, "createLabelObjects"), u(ude, "createLabelOptionsObject");
var fp,
  hU = Rt(Ny());
E(), function (t) {
  t.FONT_ZOOM_CHANGED = "FONT_ZOOM_CHANGED", t.PAGE_ZOOM_CHANGED = "PAGE_ZOOM_CHANGED", t.TOTAL_ZOOM_CHANGED = "TOTAL_ZOOM_CHANGED";
}(fp || (fp = {}));
var hA = class extends Ks {
  constructor() {
    var t;
    super(), A(this, "_recalculateDebounced"), A(this, "totalZoomLevel", 0), A(this, "fontZoomLevel", 0), A(this, "pageZoomLevel", 0), this._recalculateDebounced = ol(this.recalculate, 100), window.addEventListener("resize", () => {
      this._recalculateDebounced();
    }), null == (t = window.visualViewport) || t.addEventListener("resize", () => {
      this._recalculateDebounced();
    }), this.recalculate();
  }
  detectSafari() {
    let {
      userAgent: t
    } = navigator;
    return t.indexOf("Safari") > -1 && -1 === t.indexOf("Chrome");
  }
  recalculate() {
    var t;
    let e = 1;
    this.detectSafari() && (e = Math.max(1, window.outerWidth / window.innerWidth)), this.fontZoomLevel = window.devicePixelRatio * e, this.pageZoomLevel = (null == (t = window.visualViewport) ? void 0 : t.scale) || 1, this.totalZoomLevel = this.fontZoomLevel * this.pageZoomLevel, this.publish(fp.FONT_ZOOM_CHANGED, this.fontZoomLevel), this.publish(fp.PAGE_ZOOM_CHANGED, this.pageZoomLevel), this.publish(fp.TOTAL_ZOOM_CHANGED, this.totalZoomLevel);
  }
};
u(hA, "ZoomListener");
var Mc,
  Oh,
  $y,
  pU,
  eg,
  pA,
  ow,
  cde,
  sw,
  hde,
  tg,
  dA,
  aw,
  fde,
  e_,
  dU,
  lw,
  pde,
  t_,
  mU,
  uw,
  dde,
  cw,
  mde,
  n_,
  gU,
  i_,
  r_,
  vU,
  hw,
  gde,
  cU = new hA(),
  fU = "Adding or removing individual labels after calling labelAllLocations() may cause unexpected behaviour. We recommend adding all labels individually if more specific control is desired. https://developer.mappedin.com/web-sdk-api/v5/latest/classes/floatinglabels#add",
  fA = class {
    constructor(t) {
      re(this, $y), re(this, eg), re(this, ow), re(this, sw), re(this, tg), re(this, aw), re(this, e_), re(this, lw), re(this, t_), re(this, uw), re(this, cw), re(this, n_), re(this, r_), re(this, hw), A(this, "core"), re(this, Mc, !1), re(this, Oh, {}), re(this, i_, {}), A(this, "floatingLabels", {}), this.core = t, t.on(Xe.SET_SCENE, () => {
        t.visibleMapsInCurrentScene.forEach(t => {
          !w(this, Oh)[t.id] && w(this, Mc) && mt(this, $y, pU).call(this, t);
        });
      }), cU.on(fp.FONT_ZOOM_CHANGED, () => {
        mt(this, sw, hde).call(this);
      });
    }
    addLabel(t, e, n) {
      return null != this.core.venue.getCollectionItemById(ii.NODE, t.id) ? mt(this, eg, pA).call(this, t, e, n) : mt(this, ow, cde).call(this, t, e, n);
    }
    removeLabel(t, e = !1) {
      null != this.core.venue.getCollectionItemById(ii.NODE, t.id) ? mt(this, tg, dA).call(this, t, e) : mt(this, aw, fde).call(this, t, e), delete w(this, Oh)[t.map.id];
    }
    setPriority(t, e) {
      null != this.core.venue.getCollectionItemById(ii.NODE, t.id) ? mt(this, e_, dU).call(this, t, e) : mt(this, lw, pde).call(this, t, e);
    }
    resetPriority(t) {
      null != this.core.venue.getCollectionItemById(ii.NODE, t.id) ? mt(this, t_, mU).call(this, t) : mt(this, uw, dde).call(this, t);
    }
    removeAllLabels() {
      he(this, Mc, !1);
      for (let t in this.floatingLabels) mt(this, cw, mde).call(this, t, !0);
      Array.from(this.core.mapObjects.values()).forEach(t => {
        t.labels.clear();
      }), this.floatingLabels = {}, he(this, Oh, {}), this.core.smartCollisionEngine.update(), this.core.renderer.disposeOfRenderLists(), this.core.tryRendering();
    }
    setAppearance(t, e) {
      null != this.core.venue.getCollectionItemById(ii.NODE, t.id) ? mt(this, r_, vU).call(this, t, e) : mt(this, hw, gde).call(this, t, e), this.core.tryRendering();
    }
    labelAllLocations(t) {
      he(this, Mc, !0), null != t && he(this, i_, t);
      let e = [];
      return this.core.visibleMapsInCurrentScene.forEach(t => {
        !w(this, Oh)[t.id] && w(this, Mc) && e.push(...mt(this, $y, pU).call(this, t));
      }), e;
    }
  };
u(fA, "FloatingLabelsController"), Mc = new WeakMap(), Oh = new WeakMap(), $y = new WeakSet(), pU = u(function (t) {
  let e = uU(this.core.venue, this.core.polygonMeshesById, w(this, i_), t);
  if (null == e) return [];
  let n = e.map(t => mt(this, n_, gU).call(this, t, !0));
  return this.core.taskScheduler.scheduleTask(new ji({
    name: "addFloatingLabel",
    callback: () => {
      n.forEach(t => {
        t.enable(!1);
      }), w(this, Oh)[t.id] = !0, this.core.determineNewLabelSize(), this.core.smartCollisionEngine.update();
    }
  })), n;
}, "#processLabelsForMap"), eg = new WeakSet(), pA = u(function (t, e, n) {
  var i, r;
  w(this, Mc) && ke.warn(fU), this.floatingLabels[t.id] && mt(this, tg, dA).call(this, t);
  let o = "test" === D.env.NODE_ENV ? Qs.testId : Math.random();
  Qs.testId++;
  let s = {
    polygon: t.polygon,
    rank: (null == (r = null == (i = t.polygon) ? void 0 : i.rank) ? void 0 : r.score) || o,
    entranceNode: t,
    text: e,
    appearance: null == n ? void 0 : n.appearance,
    createDespiteImage: !0,
    ...(n || {})
  };
  return mt(this, n_, gU).call(this, s);
}, "#labelNode"), ow = new WeakSet(), cde = u(function (t, e, n) {
  var i, r;
  let o = [];
  for (let s of t.entrances) null != (null == (i = t.rank) ? void 0 : i.node) && (null == (r = t.rank) ? void 0 : r.node) != s.id || o.push(mt(this, eg, pA).call(this, s, e, n));
  return 0 === o.length ? (ke.warn("No entrances found on this polygon. Skipping."), null) : o;
}, "#labelPolygon"), sw = new WeakSet(), hde = u(function () {
  Object.values(this.floatingLabels).forEach(t => {
    t.invalidate();
  }), this.core.smartCollisionEngine.update();
}, "#invalidateAll"), tg = new WeakSet(), dA = u(function (t, e = !1) {
  w(this, Mc) && ke.warn(fU), this.core.smartCollisionEngine.remove(t.id), e || (delete this.floatingLabels[t.id], this.core.smartCollisionEngine.update());
}, "#removeLabelNode"), aw = new WeakSet(), fde = u(function (t, e = !1) {
  t.entrances.forEach(t => mt(this, tg, dA).call(this, t, e));
}, "#removeLabelPolygon"), e_ = new WeakSet(), dU = u(function (t, e) {
  t.id in this.floatingLabels && this.floatingLabels[t.id].setPriority(e);
}, "#setPriorityNode"), lw = new WeakSet(), pde = u(function (t, e) {
  t.entrances.forEach(t => mt(this, e_, dU).call(this, t, e));
}, "#setPriorityPolygon"), t_ = new WeakSet(), mU = u(function (t) {
  t.id in this.floatingLabels && this.floatingLabels[t.id].resetPriority();
}, "#resetPriorityNode"), uw = new WeakSet(), dde = u(function (t) {
  t.entrances.forEach(t => mt(this, t_, mU).call(this, t));
}, "#resetPriorityPolygon"), cw = new WeakSet(), mde = u(function (t, e = !1) {
  this.core.smartCollisionEngine.remove(t), e || delete this.floatingLabels[t];
}, "#removeLabelByNode"), n_ = new WeakSet(), gU = u(function (t, e = !1) {
  let {
      polygon: n,
      entranceNode: i
    } = t,
    r = (n || i).map.id,
    o = this.core.mapObjects.get(r),
    s = 0;
  null != n && (s = n.geometry.scale.z * Math.max(o.mapClass.width, o.mapClass.height) / 1e3);
  let a = new Qs({
    id: t.entranceNode.id,
    polygonHeight: s,
    ...t,
    position: {
      nodeOrCoordinate: i,
      height: s
    },
    mapId: r
  }, this.core);
  return this.floatingLabels[t.entranceNode.id] = a, o.labels.add(a), this.core.smartCollisionEngine.add(t.entranceNode.id, a), this.core.taskScheduler.scheduleUpdate(new _o({
    name: "addFloatingLabel",
    ordering: Ia.BEFORE_CAMERA,
    callback: () => {
      e || (a.enable(!1), this.core.determineNewLabelSize(), this.core.smartCollisionEngine.update());
    }
  })), e || this.core.tryRendering(), a;
}, "#renderLabel"), i_ = new WeakMap(), r_ = new WeakSet(), vU = u(function (t, e) {
  let n = this.floatingLabels[t.id];
  if (!n) return void ke.warn("No label found for this node. Skipping...");
  this.removeLabel(t);
  let i = {
    appearance: (0, hU.default)(e, n.appearance),
    interactive: n.options.interactive
  };
  mt(this, eg, pA).call(this, t, n.options.text, i);
}, "#setNodeAppearance"), hw = new WeakSet(), gde = u(function (t, e) {
  for (let n of t.entrances) mt(this, r_, vU).call(this, n, e);
}, "#setPolygonAppearance");
var mA = fA;
function yU(t, e, n, i) {
  let r = (null == i ? void 0 : i.excludeTypes) || [],
    o = null == i ? void 0 : i.sortFunction,
    s = ((null == i ? void 0 : i.locations) || []).filter(t => -1 === r.indexOf(t.type)),
    a = s;
  null != o && (a = s.sort(o));
  let l = {};
  for (let r = 0, o = a.length; r < o; ++r) {
    let o = a[r],
      s = o.polygons;
    for (let r = 0, a = s.length; r < a; ++r) {
      let a = s[r];
      if (rw(a, t.polygonMeshesById) || !a.geometry.visible) continue;
      let u = vde(s[r], o, n, t.venue, e, i);
      null != u && (l[a.id] = u);
    }
  }
  return Object.values(l);
}
function vde(t, e, n, i, r, o) {
  var s, a, l;
  let u = null == o ? void 0 : o.sortFunction,
    h = (null == o ? void 0 : o.translationMap) || {},
    c = n[t.id];
  if (!0 === c) return null;
  {
    let p = t.canvasBounds;
    n[t.id] = !0;
    let d = r,
      f = 0;
    if (p) {
      let t = p.x - d.width / 2,
        e = -p.y + d.height / 2;
      f = Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2));
    }
    let m = e;
    if (u ? n[t.id] = !0 : !1 === c ? (m = Td(t, i.venue), n[t.id] = !0) : n[t.id] = !1, null == m) return null;
    let g = m.name,
      v = m.shortName,
      y = t.rank,
      _ = "";
    return m.states && m.states.length > 0 && (_ = (null == (s = m.state) ? void 0 : s.id) && h[null == (a = m.state) ? void 0 : a.id] || (null == (l = m.state) ? void 0 : l.name) || ""), {
      ...(null == o ? void 0 : o.appearance),
      polygon: t,
      text: g,
      shortText: v,
      stateText: _,
      distance: f,
      rank: y,
      createDispiteImage: m.showLabelWhenImagePresent
    };
  }
}
E(), E(), u(yU, "createLabelObjects"), u(vde, "createLabelOptionsObject");
var Rh,
  Nh,
  Ec,
  o_,
  bU,
  s_,
  MU,
  _U = Rt(Ny()),
  yde = "Sans-Serif",
  _de = new ap(),
  xde = {},
  xU = "Adding or removing individual labels after calling labelAllLocations() may cause unexpected behaviour. We recommend adding all labels individually if more specific control is desired. https://developer.mappedin.com/web-sdk-api/v5/latest/classes/flatlabels#add",
  gA = class {
    constructor(t) {
      re(this, o_), re(this, s_), A(this, "core"), re(this, Rh, !1), re(this, Nh, {}), re(this, Ec, {}), A(this, "flatLabels", {}), A(this, "labeledPolygons", {}), this.core = t, t.on(Xe.SET_SCENE, () => {
        t.visibleMapsInCurrentScene.forEach(t => {
          !w(this, Nh)[t.id] && w(this, Rh) && mt(this, o_, bU).call(this, t);
        });
      });
    }
    labelAllLocations(t) {
      he(this, Rh, !0), null != t && he(this, Ec, {
        ...t,
        ...(null == t ? void 0 : t.appearance)
      });
      let e = [];
      return this.core.visibleMapsInCurrentScene.forEach(t => {
        w(this, Nh)[t.id] || e.push(...mt(this, o_, bU).call(this, t));
      }), e;
    }
    labelPolygon(t, e, n) {
      w(this, Rh) && ke.warn(xU);
      let i = {
        polygon: "string" == typeof t ? this.core.venue.getCollectionItemById(ii.POLYGON, t) : t,
        showLabelWhenImagePresent: !0,
        text: e,
        ...n,
        ...(null == n ? void 0 : n.appearance)
      };
      return mt(this, s_, MU).call(this, i);
    }
    removeLabel(t) {
      w(this, Rh) && ke.warn(xU);
      let e = "string" == typeof t ? this.core.venue.getCollectionItemById(ii.POLYGON, t) : t;
      if (!this.core.textLabelsByPolygonId[e.id]) return;
      let n = this.core.textLabelsByPolygonId[e.id];
      n.removeSelf();
      let {
        textObjects: i
      } = this.core.mapObjects.get(n.map.mapClass.id);
      i.splice(i.indexOf(n), 1), delete this.core.textLabelsByPolygonId[e.id], delete this.flatLabels[e.id], delete w(this, Nh)[e.map.id], this.core.tryRendering();
    }
    setAppearance(t, e) {
      let n = this.flatLabels[t.id];
      if (n) {
        if (1 === Object.keys(e).length && null != e.color) n.baseColor = e.color, n.setColor(e.color);else {
          let i = n.fullText;
          this.removeLabel(t), this.labelPolygon(t, i, {
            appearance: (0, _U.default)(e, {
              height: n.height,
              margin: n.margin / n.mapScale,
              color: n.color,
              hoverColor: n.hoverColor,
              fontSize: n.fontSize / n.mapScale,
              font: n.font,
              scaleMin: n.scaleMin,
              scaleStep: n.scaleStep
            })
          });
        }
        this.core.tryRendering();
      }
    }
    setHoverColorForAll(t) {
      w(this, Ec).appearance || (w(this, Ec).appearance = {}), w(this, Ec).appearance.hoverColor = t;
      for (let e in this.flatLabels) this.flatLabels.hasOwnProperty(e) && this.flatLabels[e].setHoverColor(t);
    }
    removeAllLabels() {
      he(this, Rh, !1), Array.from(this.core.mapObjects.values()).forEach(t => {
        t.textObjects.forEach(t => t.removeSelf()), t.labels.clear(), t.textObjects = [];
      }), this.core.textLabelsByPolygonId = {}, this.flatLabels = {}, this.labeledPolygons = {}, he(this, Nh, {}), this.core.tryRendering();
    }
  };
u(gA, "FlatLabelsController"), Rh = new WeakMap(), Nh = new WeakMap(), Ec = new WeakMap(), o_ = new WeakSet(), bU = u(function (t) {
  var e;
  let n = [],
    i = yU(this.core, t, this.labeledPolygons, {
      ...w(this, Ec),
      locations: (null == (e = w(this, Ec)) ? void 0 : e.locations) || this.core.venue.getCollectionItemById(ii.MAP, t.id).locations
    });
  for (let t = 0, e = i.length; t < e; ++t) {
    let e = i[t];
    n.push(mt(this, s_, MU).call(this, e));
  }
  return w(this, Nh)[t.id] = !0, n;
}, "#processLabelsForMap"), s_ = new WeakSet(), MU = u(function (t) {
  let e = this.core.mapObjects.get(t.polygon.map.id),
    n = new Py(t, this.core.venue, e, yde, this.core.polygonMeshesById, this.core.textLabelsByPolygonId, xde, this.core, _de);
  return t.polygon && this.core.textLabelsByPolygonId[t.polygon.id] && this.removeLabel(t.polygon), this.flatLabels[t.polygon.id] = n, e.addPendingLowPriorityTask("addFlatLabel", () => {
    n.create(), this.core.tryRendering();
  }), this.core.textLabelsByPolygonId[t.polygon.id] = n, n;
}, "#renderLabel");
var vA = gA;
E();
var Xi,
  fw,
  bde,
  a_,
  EU,
  yA = class {
    constructor(t) {
      re(this, fw), re(this, a_), re(this, Xi, void 0), he(this, Xi, t);
    }
    setPolygonColor(t, e, n) {
      if (void 0 === w(this, Xi).polygonMeshesById[t.id]) {
        let i = rl(t, w(this, Xi).venue.polygons);
        return null != i && null != i.map.id && null != w(this, Xi).mapObjects.get(i.map.id).object ? void mt(this, fw, bde).call(this, i, e, n) : void ke.error("Cannot set color of polygon " + i.id + ", could be bad polygon or data mismatch.");
      }
      mt(this, a_, EU).call(this, t, e, n);
    }
    clearPolygonColor(t) {
      var e;
      let n = t;
      "string" == typeof t && (n = w(this, Xi).venue.getCollectionItemById(ii.POLYGON, t));
      let i = w(this, Xi).polygonMeshesById[n.id];
      !i || (i._MIOriginalMaterial && ((i.material.length ? i.material : [i.material]).forEach(t => ih(t)), i.material = i._MIOriginalMaterial, delete i._MIOriginalMaterial), delete w(this, Xi).highlightedPolygons[n.id], (null == (e = w(this, Xi).loadOptions) ? void 0 : e.mapRenderStrategy) === Or.SINGLE_GEOMETRY && (i.visible = !1), w(this, Xi).tryRendering());
    }
    clearAllPolygonColors() {
      let t = Object.keys(w(this, Xi).highlightedPolygons);
      for (let e = 0, n = t.length; e < n; ++e) {
        let n = t[e];
        this.clearPolygonColor(w(this, Xi).highlightedPolygons[n]);
      }
      w(this, Xi).highlightedPolygons = {}, w(this, Xi).tryRendering(), w(this, Xi).renderer.disposeOfRenderLists();
    }
  };
u(yA, "PolygonColorsController"), Xi = new WeakMap(), fw = new WeakSet(), bde = u(function (t, e, n) {
  w(this, Xi).mapObjects.get(t.map.id).load().then(() => {
    w(this, Xi).mapObjects.get(t.map.id).elements && w(this, Xi).mapObjects.get(t.map.id).loadPolygonNow(t.id), mt(this, a_, EU).call(this, t, e, n);
  });
}, "#setPolygonColorLater"), a_ = new WeakSet(), EU = u(function (t, e, n = !0) {
  var i;
  let r = w(this, Xi).polygonMeshesById[t.id];
  if (null != r) {
    n && (w(this, Xi).highlightedPolygons[t.id] = t.id), r._MIOriginalMaterial || (r._MIOriginalMaterial = r.material.length ? [...r.material] : r.material);
    let o = (r.material.length ? r.material : [r.material]).map(t => {
      let n = t.clone();
      return n.color.set(e || "#4ca1fc"), n;
    });
    1 === o.length ? r.material = o[0] : r.material = o, (null == (i = w(this, Xi).loadOptions) ? void 0 : i.mapRenderStrategy) === Or.SINGLE_GEOMETRY && (r.visible = !0), w(this, Xi).tryRendering();
  } else ke.error("Cannot set color of polygon " + t.id + ", could be bad polygon or data mismatch.");
}, "#setPolygonColorNow");
var _A = yA;
E();
var Dh,
  xA = class {
    constructor(t) {
      re(this, Dh, void 0), he(this, Dh, t);
    }
    addInteractivePolygon(t) {
      let e = Vr(t);
      w(this, Dh).interactivePolygons[e] = !0;
    }
    addInteractivePolygonsForAllLocations(t) {
      t || (t = {});
      let e = t.excludeTypes || [],
        n = (t.locations || w(this, Dh).venue.locations.slice()).filter(t => !e.includes(t.type)),
        i = {};
      for (let t = 0, e = n.length; t < e; ++t) {
        let e = n[t].polygons;
        for (let t = 0, n = e.length; t < n; ++t) {
          let n = e[t];
          i[n.id] || (i[n.id] = !0, this.addInteractivePolygon(n));
        }
      }
    }
    removeInteractivePolygon(t) {
      let e = Vr(t);
      delete w(this, Dh).interactivePolygons[e];
    }
    removeAllInteractivePolygons() {
      for (let t in w(this, Dh).interactivePolygons) this.removeInteractivePolygon(t);
    }
  };
u(xA, "PolygonInteractionController"), Dh = new WeakMap();
var bA = xA;
E();
var Ko,
  MA = class {
    constructor(t) {
      re(this, Ko, void 0), he(this, Ko, t);
    }
    createTooltip(t, e, n) {
      return this.createTooltipInternal({
        nodeOrCoordinate: t,
        contentHtml: e,
        options: n
      });
    }
    createCustomTooltip(t, e, n, i) {
      return this.createTooltipInternal({
        nodeOrCoordinate: t,
        html: e,
        selector: n,
        options: i
      });
    }
    createTooltipInternal({
      nodeOrCoordinate: t,
      html: e,
      contentHtml: n,
      selector: i,
      options: r
    }) {
      let o = t.map.id,
        s = w(this, Ko).mapObjects.get(o),
        a = 0;
      if (t instanceof hl) {
        let e = t.polygon;
        null != e && (a = e.geometry.scale.z * Math.max(s.mapClass.width, s.mapClass.height) / 1e3);
      }
      let l = new $C({
        ...r,
        map: o,
        position: {
          nodeOrCoordinate: t,
          height: a
        },
        html: e,
        contentHtml: n,
        selector: i
      });
      return w(this, Ko).smartCollisionEngine.add(l.id, l), s.tooltips.add(l), w(this, Ko).taskScheduler.scheduleTask(new ji({
        name: "addTooltip",
        callback: () => {
          w(this, Ko).visibleMapsInCurrentScene.map(t => t.id).includes(l.mapId) && (l.enable(), w(this, Ko).smartCollisionEngine.update()), w(this, Ko).tryRendering();
        }
      })), w(this, Ko).tryRendering(), l;
    }
    removeTooltip(t) {
      w(this, Ko).smartCollisionEngine.remove("string" == typeof t ? t : t.id), w(this, Ko).tryRendering();
    }
    removeAllTooltips() {
      Array.from(w(this, Ko).mapObjects.values()).forEach(t => {
        t.tooltips.forEach(t => {
          w(this, Ko).smartCollisionEngine.remove(t.id);
        });
      }), w(this, Ko).tryRendering();
    }
  };
u(MA, "TooltipsController"), Ko = new WeakMap();
var EA = MA;
E();
var La,
  qh,
  wA = class {
    constructor(t) {
      re(this, La, void 0), re(this, qh, void 0), he(this, La, t), he(this, qh, new TA({
        scene: w(this, La).scene,
        tryRendering: () => w(this, La).tryRendering(),
        getPolygonMeshFromId: t => w(this, La).polygonMeshesById[t]
      }));
    }
    updateClosedStateForPolygon(t) {
      if (null == t || null == t.polygon) return;
      let e,
        n = Vr(t.polygon);
      if ("string" != typeof n) return void ke.error(`Invalid or no polygon provided. Expecting a MappedinPolygon or a string id. Received: ${t.polygon} of type ${typeof t.polygon}`);
      if (null != t.closed) e = !!t.closed;else {
        if (null == t.open) return;
        e = !t.open;
      }
      let i = rl(n, w(this, La).venue.polygons).map.id || w(this, La).currentMap;
      w(this, La).mapObjects.get(i).addPendingMapLoadedTask(`Set closed status of polygon ${n} to ${e}`, () => {
        e ? w(this, qh).markPolygonAsClosed(n) : w(this, qh).markPolygonAsOpen(n);
      });
    }
    openAllPolygons() {
      [...w(this, La).mapObjects.values()].reduce((t, e) => (t.set(e, w(this, La).venue.polygons.filter(t => t.map === e.id)), t), new Map()).forEach((t, e) => {
        e.addPendingMapLoadedTask(`Open all polygons belonging to map ${e.id}`, () => t.forEach(t => w(this, qh).markPolygonAsOpen(t.id)));
      });
    }
    destroy() {
      w(this, qh).dispose();
    }
  };
u(wA, "PolygonStatesController"), La = new WeakMap(), qh = new WeakMap();
var SA = wA;
E();
var ys,
  PA = class {
    constructor(t) {
      re(this, ys, void 0), he(this, ys, t);
    }
    enableImageFlippingForAllLocations(t) {
      w(this, ys).imageFlippingEnabled = !0, t || (t = {});
      let e = t.excludeTypes || [],
        n = (t.locations || w(this, ys).venue.locations.slice()).filter(function (t) {
          return -1 === e.indexOf(t.type);
        }),
        i = {};
      for (let t = 0, e = n.length; t < e; ++t) {
        let e = n[t].polygons;
        for (let t = 0, n = e.length; t < n; ++t) {
          let n = e[t];
          i[n.id] || (i[n.id] = !0, this.enableImageFlippingForPolygon(n));
        }
      }
    }
    enableImageFlippingForPolygon(t) {
      let e = w(this, ys).mapObjects.get(t.map.id),
        n = 0,
        i = w(this, ys).venue.maps.find(t => t.id === w(this, ys).currentMap).perspectiveId;
      i && t && t.perspectives && t.perspectives[i] && t.perspectives[i].image && t.perspectives[i].image.rotation && !isNaN(t.perspectives[i].image.rotation.z) ? n = t.perspectives[i].image.rotation.z * (Math.PI / 180) : t && t.image && t.image.rotation && !isNaN(t.image.rotation.z) && (n = t.image.rotation.z * (Math.PI / 180)), w(this, ys).imageFlippingCache[t.map.id] = w(this, ys).imageFlippingCache[t.map.id] || [], w(this, ys).imageFlippingCache[t.map.id].push([t.id, n]), e.mapClass.id === w(this, ys).currentMap && e.load().then(() => {
        e.enableImageFlipping(t.id, n);
      });
    }
    disableImageFlippingForAllPolygons() {
      let t = Object.keys(w(this, ys).mapObjects);
      for (let e = 0, n = t.length; e < n; e++) {
        let n = t[e];
        w(this, ys).mapObjects.get(n).disableAllImageFlipping();
      }
    }
  };
u(PA, "PolygonImagesController"), ys = new WeakMap();
var CA = PA;
E();
var wc,
  u_,
  AA = class {
    constructor(t) {
      re(this, wc, void 0), re(this, u_, new Set()), he(this, wc, t);
    }
    createThreeJSMarker(t) {
      let e = w(this, wc).currentMap;
      null != t.mapOrMapId && (e = "string" == typeof t.mapOrMapId ? t.mapOrMapId : t.mapOrMapId.id);
      let n = w(this, wc).mapObjects.get(e).addThreeJSMarker(t);
      return w(this, u_).add(n), w(this, wc).tryRendering(hi.ANIMATED), n;
    }
    removeThreeJSMarker(t) {
      if (null == t._mapId) return !1;
      let e = !1,
        n = w(this, wc).mapObjects.get(t._mapId);
      return n && (e = n.removeThreeJSMarker(t)), w(this, wc).tryRendering(hi.ANIMATED), e;
    }
    removeAllThreeJSMarkers() {
      w(this, u_).forEach(t => {
        this.removeThreeJSMarker(t);
      });
    }
  };
u(AA, "ThreeDMarkersController"), wc = new WeakMap(), u_ = new WeakMap();
var l_ = AA;
E();
var Oa,
  c_,
  pw,
  Mde,
  IA = class extends Ks {
    constructor(t) {
      super(), re(this, pw), A(this, "core"), A(this, "blueDotCore"), re(this, Oa, void 0), re(this, c_, void 0), this.core = t, he(this, c_, t0(this.core.venue, this.core.options));
      let e = new l_(this.core);
      he(this, Oa, new RA({
        threeDMarkerLayer: e,
        core: this.core
      })), this.core.eventSystem.setBlueDotManager(w(this, Oa)), this.blueDotCore = OA({
        data: this.core.venue,
        core: this.core,
        manager: w(this, Oa)
      });
      let n = NA({
        core: this.core,
        blueDotManager: w(this, Oa),
        controller: this.blueDotCore,
        data: this.core.venue
      });
      n.on("isFollowingChanged", ({
        newValue: t
      }) => {
        !1 === t && this.core.state === xo.FOLLOW && (this.core.state = xo.EXPLORE, this.core.publish(Xe.SET_STATE_SILENT, {
          state: xo.EXPLORE
        }));
      }), this.core.on(Xe.BLUE_DOT_SET_FOLLOWING, t => {
        n.isFollowing = t, this.blueDotCore.enabled && n.isFollowing && n.centerBlueDot();
      }), this.core.on(Xe.BLUE_DOT_UPDATE_POSITION, ({
        x: t,
        y: e
      }) => {
        w(this, Oa).publish("update-position", {
          x: t,
          y: e
        });
      });
      let i = ol(mt(this, pw, Mde).bind(this), 300);
      this.core.on(Xe.PUBLISH_BLUE_DOT, i), this.core.on(Xe.SET_BLUE_DOT_SIZE_FROM_ZOOM, t => {
        w(this, Oa).setBlueDotSizeFromZoom(t);
      });
    }
    enable(t) {
      this.blueDotCore.enableBlueDot(t);
    }
    disable() {
      this.blueDotCore.disableBlueDot();
    }
  };
u(IA, "BlueDotController"), Oa = new WeakMap(), c_ = new WeakMap(), pw = new WeakSet(), Mde = u(function () {
  if (!w(this, Oa).blueDots) return;
  let t = w(this, Oa).blueDots.filter(t => t.handle._mapId === this.core.currentMap)[0].handle.object.position.clone(),
    e = this.core.mapObjects.get(w(this, c_).id || this.core.venue.venue.defaultMap);
  if (!e) throw new Error("Unable to retrieve the target map");
  let n = t.applyMatrix4(e.object.matrix).project(this.core.cameraObject),
    i = (n.x + 1) / 2 * this.core.canvasWidth,
    r = (1 - n.y) / 2 * this.core.canvasHeight;
  w(this, Oa).publish("update-position", {
    x: i,
    y: r
  });
}, "#publishBlueDot");
var LA = IA;
E(), E();
var wU = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAkklEQVRoge3awQ3AIAxD0VAMYf+F0yUixbL8JshXuLSwIqJCwDc9QBeZEOy9p2doAQDTM7TQ2cg5Z3qGFjpHS2YjDiGDe+/0DC0cwkYpJKdnaIFMkY1kymzEIVQcwsYhbPDem56hhc5GHELGIWwcwsYhbJS+2R1CxSFsdH5iO4SMr97Y6FxPqxytVVV+HcTEIWx+9mcIqHSOm9QAAAAASUVORK5CYII=";
E(), E();
var DA = class {
  constructor(t) {
    this.active = !1, this.positions = [], this.positionIndex = 0, this.timerList = [], this.timeElapsed = 0, this.startTime = void 0, this.startPos = 0, this.endPos = 0, this.smoothingType = void 0, this.isActive = this.isActive.bind(this), this.setCallbacks = this.setCallbacks.bind(this), this.watchPosition = this.watchPosition.bind(this), this.sendPositionResponse = this.sendPositionResponse.bind(this), this.start = this.start.bind(this), this.pause = this.pause.bind(this), this.speed = t.speed || 10, window.positions && this.setPositions(window.positions);
  }
  isActive() {
    return this.active;
  }
  setPositions(t) {
    this.reset(), this.positions = t, this.endPos = t.length - 1;
  }
  setCallbacks(t, e, n) {
    this.successCallback = t, this.errorCallback = e, this.options = n;
  }
  clearWatch() {
    this.reset();
  }
  watchPosition(t, e, n) {
    this.setCallbacks(t, e, n), this.start();
  }
  sendPositionResponse(t) {
    switch (this.timeElapsed = Date.now() - this.startTime, t.type) {
      case "ERROR":
        this.errorCallback({
          code: t.code,
          message: t.message,
          timestamp: Date.now()
        });
        break;
      case "ANNOTATION":
        ke.log(`Annotation Update: ${t.annotation}`);
        break;
      default:
        this.successCallback({
          coords: t.coords,
          timestamp: t.timestamp,
          positionIndex: this.positionIndex
        });
    }
    this.positionIndex === this.endPos ? this.reset() : this.positionIndex += 1;
  }
  start() {
    let t = 0;
    this.positions[this.positionIndex - 1] ? t = this.positions[this.positionIndex - 1].timestamp : this.positions[0].timestamp > 1e6 && (t = this.positions[0].timestamp), this.startTime = Date.now(), this.positions.slice(this.positionIndex, this.endPos + 1).forEach(e => {
      let {
        timestamp: n
      } = e;
      this.timerList.push(setTimeout(() => this.sendPositionResponse(e), (n - t) / this.speed));
    }), this.active = !0;
  }
  pause() {
    this.timerList.forEach(t => {
      clearTimeout(t);
    }), this.timerList = [], this.active = !1;
  }
  reset() {
    this.pause(), this.positionIndex = this.startPos;
  }
};
u(DA, "FakeGeolocation");
var mi,
  SU = DA;
E(), function (t) {
  t[t.gotPosition = 0] = "gotPosition", t[t.gotPositionWithFloor = 1] = "gotPositionWithFloor", t[t.gotError = 2] = "gotError", t[t.timedOut = 3] = "timedOut", t[t.disabledBlueDot = 4] = "disabledBlueDot", t[t.enabledBlueDot = 5] = "enabledBlueDot";
}(mi || (mi = {}));
var TU,
  qA = {
    [Kt.NOT_LISTENING]: {
      actions: {
        5: Kt.LISTENING
      }
    },
    [Kt.LISTENING]: {
      actions: {
        0: Kt.HAS_POSITION,
        1: Kt.HAS_INDOOR_POSITION,
        3: Kt.LOCATION_UNCERTAIN,
        4: Kt.NOT_LISTENING
      },
      markerState: iu.HIDDEN
    },
    [Kt.HAS_POSITION]: {
      actions: {
        1: Kt.HAS_INDOOR_POSITION,
        3: Kt.LOCATION_UNCERTAIN,
        2: Kt.LISTENING,
        4: Kt.NOT_LISTENING
      },
      markerState: iu.GHOST
    },
    [Kt.HAS_INDOOR_POSITION]: {
      actions: {
        0: Kt.HAS_POSITION,
        3: Kt.LOCATION_UNCERTAIN,
        2: Kt.LISTENING,
        4: Kt.NOT_LISTENING
      },
      markerState: iu.NORMAL
    },
    [Kt.LOCATION_UNCERTAIN]: {
      actions: {
        0: Kt.HAS_POSITION,
        1: Kt.HAS_INDOOR_POSITION,
        3: Kt.LOCATION_UNCERTAIN,
        2: Kt.LISTENING,
        4: Kt.NOT_LISTENING
      },
      markerState: iu.UNCERTAIN
    }
  };
!function (t) {
  t[t.stateChanged = 0] = "stateChanged", t[t.markerStateChanged = 1] = "markerStateChanged";
}(TU || (TU = {}));
var wde = u(() => {
    let t = Ph({
      state: Kt.NOT_LISTENING,
      markerState: iu.HIDDEN,
      transition: e => {
        if (null == qA[t.state]) return;
        let n = qA[t.state].actions[e];
        null != n && t.state !== n && (t.state = n, t.markerState = qA[t.state].markerState);
      },
      reset: () => {
        t.state = Kt.NOT_LISTENING;
      }
    });
    return t;
  }, "StateMachine"),
  PU = wde;
E();
var kA = u((t, e, n, i = 1.5) => {
  let r = !1;
  return (n ? [n] : e).forEach(e => {
    Math.abs(t.x) < e.width * i && Math.abs(t.y) < e.height * i && (r = !0);
  }), !r;
}, "isOutsideMap");
E();
var UA = Rt(IU());
function FA(t) {
  return null === t || "number" == typeof t;
}
E(), u(FA, "isValidLevel");
var BA = class {
  constructor(t = 2) {
    this.nextLevel = void 0, this.inertia = t, this.levelConfirmations = 0;
  }
  _resetConfirmations() {
    this.levelConfirmations = 0, this.nextLevel = void 0;
  }
  _resetFilter() {
    this._resetConfirmations(), this.previousLevel = void 0;
  }
  filter(t) {
    let e = null,
      n = void 0 === t ? null : t;
    if (!FA(n)) throw new TypeError("The argument given to filter() must be null, undefined, or a number");
    return null === n ? this._resetFilter() : (FA(this.previousLevel) && n !== this.previousLevel ? FA(this.nextLevel) && n === this.nextLevel ? this.levelConfirmations >= this.inertia ? (this._resetConfirmations(), e = n) : (this.levelConfirmations++, e = this.previousLevel) : (this.levelConfirmations++, this.nextLevel = n, e = this.previousLevel) : e = n, this.previousLevel = e), e;
  }
};
u(BA, "LevelFilter");
var dw = BA,
  Cde = 1.4,
  zA = {
    NONE: "none",
    KALMAN: "kalman"
  },
  Ade = u(t => ({
    floorLevel: t.coords.floorLevel,
    timestamp: t.timestamp,
    latitude: t.coords.latitude,
    longitude: t.coords.longitude,
    accuracy: t.coords.accuracy,
    speed: -1,
    type: t.type
  }), "parseLocation"),
  VA = class {
    constructor(t) {
      this.smooth = this.smooth.bind(this), this.smoothingType = window.mappedin && window.mappedin.smoothingType || zA.KALMAN, this.lastLocation = null, this.levelFilter = t;
    }
    formatLocation(t) {
      return {
        type: "SUCCESS",
        timestamp: t.timestamp,
        coords: {
          latitude: t.latitude,
          longitude: t.longitude,
          accuracy: t.accuracy,
          floorLevel: this.levelFilter.filter(t.floorLevel)
        }
      };
    }
    kalman(t, e) {
      if (e) {
        let n = t.timestamp - e.timestamp,
          i = Cde * n / 1e3;
        this.latitudeKF.setProcessNoise(i), this.longitudeKF.setProcessNoise(i), this.latitudeKF.setMeasurementNoise(t.accuracy), this.longitudeKF.setMeasurementNoise(t.accuracy);
      } else this.latitudeKF = new UA.default({
        R: 1,
        Q: t.accuracy
      }), this.longitudeKF = new UA.default({
        R: 1,
        Q: t.accuracy
      });
      return {
        ...t,
        latitude: this.latitudeKF.filter(t.latitude),
        longitude: this.longitudeKF.filter(t.longitude)
      };
    }
    setSmoothingType(t) {
      this.smoothingType = t;
    }
    smooth(t) {
      let e;
      switch (this.smoothingType) {
        case zA.KALMAN:
          return e = this.kalman(Ade(t), this.lastLocation), this.lastLocation = e, this.formatLocation(e);
        case zA.NONE:
        default:
          return t;
      }
    }
    reset() {
      this.lastLocation = null, this.levelFilter = new dw(this.levelFilter.inertia);
    }
  };
u(VA, "PositionSmoothing");
var LU = VA;
E();
var kh,
  mw = u(t => t * Math.PI / 180, "toRadians"),
  Ide = u(t => 180 * t / Math.PI, "toDegrees"),
  Lde = u(function () {
    let t,
      e = Ph({
        bearingExpired: !1,
        previousLat: null,
        previousLong: null,
        calculateHeading(t, n, i) {
          e.previousLat || (e.previousLat = t), e.previousLong || (e.previousLong = n);
          let r = ((e.previousLat - t) ** 2 + (e.previousLong - n) ** 2) ** .5,
            o = i && i.coords.accuracy < 20,
            s = parseFloat(r.toFixed(5)) > 0;
          if (o && s) {
            e.resetBearingExpirationTimer();
            let i = e.getBearing([e.previousLat, e.previousLong], [t, n]);
            return e.previousLat = t, e.previousLong = n, i;
          }
          return !1;
        },
        getBearing([t, e], [n, i]) {
          let r = mw(t),
            o = mw(e),
            s = mw(n),
            a = mw(i),
            l = Math.sin(a - o) * Math.cos(s),
            u = Math.cos(r) * Math.sin(s) - Math.sin(r) * Math.cos(s) * Math.cos(a - o),
            h = Math.atan2(l, u);
          return h = Ide(h), (h + 360) % 360;
        },
        resetBearingExpirationTimer() {
          null !== t && e.clearBearingExpirationTimer(), t = setTimeout(() => {
            e.bearingExpired = !0, e.clearBearingExpirationTimer();
          }, 5e3);
        },
        clearBearingExpirationTimer() {
          null !== t && (clearTimeout(t), t = null);
        }
      });
    return e;
  }, "BlueDotBearing"),
  OU = Lde,
  gw = "#2266ff";
!function (t) {
  t[t.POSITION_UPDATE = 0] = "POSITION_UPDATE", t[t.ERROR = 1] = "ERROR";
}(kh || (kh = {}));
var vw = class extends Ta {
  constructor() {
    super(...arguments), A(this, "update", u(t => {
      this.publish(0, t);
    }, "update")), A(this, "throwError", u(t => {
      this.publish(1, t);
    }, "throwError"));
  }
};
u(vw, "PositionUpdater");
var h_,
  RU = {
    showBearing: !1,
    allowImplicitFloorLevel: !1,
    smoothing: !0,
    positionUpdater: void 0,
    baseColor: gw,
    useRotationMode: !1
  },
  GA = class extends vw {
    constructor() {
      super(...arguments), re(this, h_, -1);
    }
    start(t) {
      he(this, h_, globalThis.navigator.geolocation.watchPosition(this.update, this.throwError, t));
    }
    stop() {
      globalThis.navigator.geolocation.clearWatch(w(this, h_));
    }
  };
u(GA, "GeolocationUpdater"), h_ = new WeakMap();
var Ode = 3e4,
  Rde = 1e4,
  NU = u(({
    data: t,
    core: e,
    manager: n
  }) => {
    let i,
      r,
      o,
      {
        maps: s,
        venue: a
      } = t,
      l = {
        enableHighAccuracy: !0
      },
      h = PU(),
      c = u(() => {
        null != i && (clearTimeout(i), i = null);
      }, "clearFallbackToGPSTimer"),
      p = s.length > 1,
      d = !1,
      f = OU();
    f.on("bearingExpiredChanged", t => {
      t.newValue && (E.bearing = null, g(E.userPosition, null));
    });
    let m = u((t, e, n) => {
        "string" == typeof t && (y(e, n), E.stateMachine.transition(mi.gotError), g(null, null));
      }, "setError"),
      g = u((t, n, i) => {
        if (E.userPosition = t, null != n) {
          E.userMap = n;
          let r = (E.userMap || e.venue.maps.find(t => t.id === e.currentMap)).createCoordinate(t.coords.latitude, t.coords.longitude);
          E.nearestNode = i || r.nearestNode;
        }
        E.userData = {
          state: h.state,
          position: E.userPosition,
          map: E.userMap,
          bearing: E.bearing,
          nearestNode: E.nearestNode
        }, e.blueDot.publish(tp.POSITION_UPDATE, {
          nearestNode: E.nearestNode,
          bearing: E.bearing,
          map: E.userMap,
          position: E.userPosition
        });
      }, "updateInternalState"),
      v = u(t => {
        m("position-error", t.code, t.message), ke.warn(`ERROR(${t.code}): ${t.message}`);
      }, "onPositionError");
    function y(t, n) {
      E.state = {
        reason: t,
        message: n,
        markerVisibility: h.markerState,
        name: h.state
      }, e.blueDot.publish(tp.STATE_CHANGE, E.state);
    }
    u(y, "setReason");
    let _ = u((t, e) => {
        let n = s,
          i = t.coords.latitude,
          r = t.coords.longitude;
        null != e && (n = s.filter(t => t.elevation === e));
        let o = n.reduce((t, e) => {
          let n = e.createCoordinate(i, r),
            o = n.nearestNode,
            s = e.createCoordinateByXY(o.x, o.y).absoluteDistanceTo(n);
          return s < t[1] ? [e, s, o] : t;
        }, [n[0], 1 / 0, null]);
        return {
          targetMap: o[0],
          nearestNode: o[2]
        };
      }, "determineCurrentMapFromCoordinates"),
      x = u(t => {
        var n, l;
        {
          let u = t.coords.floorLevel;
          void 0 !== window.floorLevel && (u = window.floorLevel);
          let m = {
            timestamp: t.timestamp,
            type: t.type,
            coords: {
              accuracy: t.coords.accuracy,
              latitude: t.coords.latitude,
              longitude: t.coords.longitude,
              floorLevel: u
            }
          };
          null != u && (d = !0), window.mappedin && (Array.isArray(window.mappedin.bluedotCaptureData) ? window.mappedin.bluedotCaptureData.push(m) : window.mappedin.bluedotCaptureData = [m]), o && clearTimeout(o), o = setTimeout(() => {
            h.transition(mi.timedOut), y(), E.positionSmoothing.reset(), g(E.userPosition, null);
          }, E.locationUncertainTimeoutPeriod);
          let v = e.getPositionLatLon(m.coords.latitude, m.coords.longitude),
            x = kA(v, s);
          if (null == m.coords.latitude || null == m.coords.longitude) return E.positionSmoothing.reset(), void y(ep.NO_POSITIONS_PROVIDED);
          if (x) return E.positionSmoothing.reset(), E.stateMachine.transition(mi.gotError), y(ep.OUTSIDE_MAP), void (E.userData = {
            state: h.state,
            position: null,
            map: null,
            bearing: null,
            nearestNode: null
          });
          let b,
            w = null == (n = E.enableBlueDotOptions) ? void 0 : n.smoothing;
          b = !0 === w || void 0 === w && null == m.coords.floorLevel ? E.positionSmoothing.smooth(m) : m, u = b.coords.floorLevel;
          let S = b.coords.latitude,
            M = b.coords.longitude;
          if (null == (l = E.enableBlueDotOptions) ? void 0 : l.showBearing) {
            let t = f.calculateHeading(S, M, b);
            !1 !== t && (E.bearing = t);
          }
          let T = null,
            A = null,
            P = a.isMultiBuilding;
          if (P && "hudson-yards" !== a.slug && null != u) {
            let t = _(b, u);
            T = t.targetMap, A = t.nearestNode;
          }
          if ("hudson-yards" === a.slug) {
            let t = E.userMap;
            if (null == u && kA(v, s, t, .55) && (T = s.filter(t => "5b5f5becadd5444692000001" === t.id)[0]), null != u) {
              let t = s.filter(t => t.elevation === u);
              t.length > 1 && (t = t.filter(t => "5b5f20e3f3ea231068000000" === t.group)), T = t[0];
            }
          }
          if (!T && null != u) {
            let t = s.filter(t => t.elevation === u);
            1 === t.length && (T = t[0]);
          }
          if (E.forceBlueDot && E.userMap && !d ? T = E.userMap : p || (T = s[0]), T || E.forceBlueDot && h.state !== Kt.HAS_INDOOR_POSITION) h.transition(mi.gotPositionWithFloor), c();else {
            if (h.state === Kt.HAS_INDOOR_POSITION) return r = {
              ...b
            }, void (null == i && (i = setTimeout(() => {
              if (h.transition(mi.gotPosition), P) {
                let t = _(r);
                T = t.targetMap, A = t.nearestNode;
              }
              g(r, T, A), i = null;
            }, E.fallbackToGPSTimeoutPeriod)));
            h.transition(mi.gotPosition);
          }
          y(), g(b, T);
        }
      }, "onPositionReceived"),
      E = Ph({
        bearing: null,
        state: {
          reason: void 0,
          message: void 0,
          markerVisibility: h.markerState,
          name: h.state
        },
        positionUpdater: null,
        positionSmoothing: new LU(new dw()),
        locationUncertainTimeoutPeriod: Ode,
        fallbackToGPSTimeoutPeriod: Rde,
        userMap: s.find(t => t.id === a.defaultMap),
        userPosition: null,
        nearestNode: null,
        forceBlueDot: !1,
        userData: null,
        enabled: !1,
        stateMachine: h,
        enableBlueDotOptions: RU,
        enableBlueDot: t => {
          var e, n, i, r, o;
          E.enableBlueDotOptions = {
            ...RU,
            ...t
          }, E.enabled = !0, E.enableBlueDotOptions && E.enableBlueDotOptions.allowImplicitFloorLevel && (E.forceBlueDot = E.enableBlueDotOptions.allowImplicitFloorLevel), null != (null == (e = E.enableBlueDotOptions) ? void 0 : e.positionUpdater) ? (E.positionUpdater = E.enableBlueDotOptions.positionUpdater, "function" == typeof (null == (n = null == E ? void 0 : E.positionUpdater) ? void 0 : n.start) && (null == (i = null == E ? void 0 : E.positionUpdater) || i.start())) : (E.positionUpdater = new GA(), null == (o = null == (r = E.positionUpdater) ? void 0 : r.start) || o.call(r, l)), E.positionUpdater.on(0, x), E.positionUpdater.on(1, v), h.transition(mi.enabledBlueDot);
        },
        disableBlueDot() {
          var t, e, i, r;
          E.enabled = !1, "function" == typeof (null == (t = null == E ? void 0 : E.positionUpdater) ? void 0 : t.stop) && (null == (e = null == E ? void 0 : E.positionUpdater) || e.stop()), null == (i = E.positionUpdater) || i.off(0, x), null == (r = E.positionUpdater) || r.off(1, v), h.transition(mi.disabledBlueDot), n.cleanup();
        }
      });
    return E;
  }, "BlueDot");
NU.FakeGeolocation = SU;
var OA = NU,
  pp = {
    GHOST: "ghost",
    GREY: "grey",
    BLUE: "blue"
  },
  Sc = u((t, e) => new Sr({
    color: t,
    transparent: !0,
    depthTest: !1,
    opacity: e
  }), "makeMeshBasicMaterial"),
  DU = u(t => {
    let e = new Qa(),
      n = 0;
    for (e.moveTo(t, 0); n <= 2 * Math.PI;) e.lineTo(Math.cos(n) * t, Math.sin(n) * t), n += Math.PI / 16;
    return e;
  }, "drawCircle"),
  Nde = u(({
    baseColor: t = gw
  }) => ({
    outer: {
      blue: Sc(16777215, 1),
      ghost: Sc(16777215, .5)
    },
    inner: {
      blue: Sc(t, 1),
      grey: Sc(14540253, 1),
      ghost: Sc(t, .5)
    },
    aura: {
      inner: Sc(t, .2),
      outer: Sc(t, .3)
    },
    bearing: {
      blue: Sc(t, .7),
      ghost: Sc(t, .4)
    }
  }), "makeMaterials"),
  qU = u((t, e) => {
    let n = DU(t);
    if (e && e < t) {
      let t = DU(e);
      n.holes = [t];
    }
    return new $a(n, {
      depth: 0,
      bevelEnabled: !1,
      steps: 2
    });
  }, "createAnnularGeometry"),
  HA = u((t, e, n) => {
    let i = Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2)) / n;
    return i > 1 ? i = 1 : i < 0 && (i = 0), new je(0, i);
  }, "generateRadialUV"),
  Dde = u(t => ({
    generateTopUV: (e, n, i, r, o) => {
      let s = n[3 * i],
        a = n[3 * i + 1],
        l = n[3 * r],
        u = n[3 * r + 1],
        h = n[3 * o],
        c = n[3 * o + 1];
      return [HA(s, a, t), HA(l, u, t), HA(h, c, t)];
    },
    generateSideWallUV: () => [new je(0, 1), new je(0, 1), new je(0, 1), new je(0, 1)]
  }), "radialUVGenerator"),
  qde = u((t, e, n = 0) => {
    if (Math.abs(t) >= Math.PI) throw new Error("Sector angle too wide!");
    let i = n / Math.tan(t / 2),
      r = n / Math.sin(t / 2),
      o = r + e,
      s = 10,
      a = new Qa();
    a.moveTo(r * Math.cos(t / 2) - i, r * Math.sin(t / 2));
    for (let e = 0; e < s; e++) a.lineTo(o * Math.cos(t / 2 - t / s * e) - i, o * Math.sin(t / 2 - t / s * e));
    for (let t = 0; t < s; t++) a.lineTo(n * Math.cos(Math.PI / -2 + Math.PI / s * t), n * Math.sin(Math.PI / -2 + Math.PI / s * t));
    return new $a(a, {
      depth: 1,
      bevelEnabled: !1,
      UVGenerator: Dde(e)
    });
  }, "createSectorGeometry"),
  kU = u(function (t, e = 0, n = 0, {
    baseColor: i = gw
  }) {
    let r,
      o,
      s = new jn(),
      a = new jn(),
      l = Nde({
        baseColor: new yt(i)
      });
    if (l.outer.grey = l.outer.blue, e >= 0) {
      let t = new xd(1, 1, 10, 32),
        n = l.aura.inner;
      r = new Ft(t, n), r.position.set(0, 0, 0), r.rotation.set(Math.PI / 2, 0, 0), r.scale.set(e, 1, e), a.add(r);
    }
    let u = qde(Math.PI / 6, 120, 30),
      h = l.bearing[t];
    h && new pa().load(wU, t => {
      h.colorSpace = Nt, h.alphaMap = t, h.needsUpdate = !0;
    }), o = new Ft(u, h), o.rotation.set(0, 0, n), a.add(o);
    let c = qU(30, 22.5),
      p = qU(22.5),
      d = new Ft(c, l.outer[t]),
      f = new Ft(p, l.inner[t]);
    return s.add(d), s.add(f), a.add(s), [a, s, d, f, o, r].forEach(t => {
      t.renderOrder = 999, t.layers.set(bo.ALWAYS_ON_TOP);
    }), {
      outerObject: a,
      radiusObject: r,
      dotObject: s,
      bearingObject: o
    };
  }, "makeBlueDot"),
  kde = u((t, e, n) => {
    let i = (e.x - n.x) ** 2 + (e.y - n.y) ** 2,
      r = 0;
    i && (r = ((t.x - e.x) * (n.x - e.x) + (t.y - e.y) * (n.y - e.y)) / i), r > 1 && (r = 1), r < 0 && (r = 0);
    let o = e.x + r * (n.x - e.x),
      s = e.y + r * (n.y - e.y);
    return {
      proportion: r,
      distance: Math.sqrt((t.x - o) ** 2 + (t.y - s) ** 2)
    };
  }, "distanceToSegment"),
  jA = u((t, e) => null != t ? yw(-t) - e + Math.PI / 2 : null, "getBearing"),
  yw = u(t => t * Math.PI / 180, "degToRadians"),
  FU = u((t, e) => {
    let n,
      i,
      r,
      o = Number.MAX_SAFE_INTEGER;
    for (let s = 0; s < t.length - 1; s++) {
      let a = t[s],
        l = t[s + 1],
        u = kde(e, a, l);
      u.distance <= o && (o = u.distance, i = u.proportion, r = s, n = u.proportion > .5 ? l : a);
    }
    return {
      nearestNode: n,
      proportion: i,
      index: r
    };
  }, "getNearestPathSegment"),
  BU = u((t, e, n) => {
    let i = [],
      r = [];
    for (let e = 0; e < t.length - 1; e++) {
      let n = t[e],
        o = t[e + 1],
        s = o.x - n.x,
        a = o.y - n.y,
        l = Math.atan2(s, a);
      i.push(l);
      let u = Math.sqrt(s ** 2 + a ** 2);
      r.push(u);
    }
    let o,
      s = [];
    for (let e = 0; e < i.length; e++) {
      let n = i[e],
        a = r[e];
      null == o || Math.abs(o - n) > .2 ? (o = n, s.push({
        angle: n,
        distance: a,
        nodes: [t[e]]
      })) : (s[s.length - 1].distance += a, s[s.length - 1].nodes.push(t[e]));
    }
    s[s.length - 1].nodes.push(t[t.length - 1]);
    let a = n || 100,
      l = u(() => s.filter(t => t.distance >= a).length, "validGroups");
    for (; !l();) a /= 2;
    let h = s.find(t => t.nodes.indexOf(e) > -1),
      c = s.indexOf(h);
    for (; c > 0 && s[c].distance < a;) c -= 1;
    return s[c].angle;
  }, "getHeadingOnPath"),
  UU = u((t, e, n, i, r = .8) => {
    let o = n * (i ? .05 : 0),
      s = null != e ? Math.cos(e - Math.PI / 2) * o : 0,
      a = null != e ? Math.sin(e - Math.PI / 2) * o : 0;
    return {
      position: {
        x: t.x - s,
        y: t.y - a
      },
      rotation: e || void 0,
      zoom: n,
      tilt: r
    };
  }, "getCameraLookahead"),
  dp = Rt(il()),
  Fde = 2e3,
  Bde = 8,
  Ude = 65,
  zde = 3,
  Vde = {
    duration: 2e3,
    easing: dp.default.Easing.Cubic.Out
  };
function _w(t) {
  return "number" == typeof t && !isNaN(t) && t >= 0;
}
u(_w, "isNonNegativeNumber");
var Gde = u((t, e, n) => t < e ? t : t < n ? e : t * e / n, "ledge"),
  WA = class extends Ta {
    constructor({
      threeDMarkerLayer: t,
      core: e,
      minRadius: n = Bde,
      maxRadius: i = Ude,
      radiusUpdateInterval: r = zde,
      radiusTweenOptions: o = Vde
    }) {
      if (super(), this.threeDMarkerLayer = t, this.core = e, !_w(n)) throw new Error(`Expecting minRadius parameter to be a valid number >= 0. Provided: ${n}`);
      if (this.minRadius = n, !_w(i)) throw new Error(`Expecting maxRadius parameter to be a valid number >= 0. Provided: ${i}`);
      if (i < this.minRadius) throw new Error(`Expecting maxRadius parameter to be >= minRadius parameter. Provided: ${i}; minRadius = ${this.minRadius}`);
      if (this.maxRadius = i, !_w(r)) throw new Error(`Expecting radiusUpdateInterval parameter to be a valid number >= 0. Provided: ${r}`);
      this.radiusUpdateInterval = r, this.radiusTweenOptions = o, this.state = null, this.prevRadius = null, this.radiusTween = null, this.prevBearing = null, this.bearingTween = null, this.currentX = null;
    }
    computeNewRadius(t) {
      if (!_w(t) || t < this.minRadius) return 0;
      if (t >= this.maxRadius) return this.maxRadius;
      if (0 === this.radiusUpdateInterval) return t;
      {
        let e = t - this.minRadius;
        return e - e % this.radiusUpdateInterval + this.minRadius;
      }
    }
    updateBlueDotSize() {
      !this.blueDots || this.blueDots.forEach(t => {
        let e = this.core.controls.getZoomScaledMin(),
          n = 3 * e,
          i = 5 * e,
          r = Gde(this.currentX, n, i) / 2e3;
        t.dotObject.scale.set(r, r, r), t.bearing && t.bearing.scale.set(r, r, r);
      });
    }
    setBlueDotSizeFromZoom(t) {
      this.currentX = t, this.updateBlueDotSize();
    }
    update(t) {
      var e;
      let n = t.mode || this.state.mode,
        i = t.mapId || t.map && t.map.id || this.core.currentMap;
      null == t.bearing && (this.prevBearing = null), this.positionTween && this.positionTween.stop(), this.state && (n !== this.state.mode || i !== this.state.targetMap) && this.cleanup();
      let r = this.computeNewRadius(t.radius);
      if (!this.blueDots) {
        let e = [];
        this.core.mapObjects.forEach(r => {
          let o = r.getPositionLatLon(t.coordinates.latitude, t.coordinates.longitude),
            s = r.id !== i && n === pp.BLUE ? pp.GHOST : n,
            a = kU(s, 0, jA(t.bearing, this.core.venue.maps.find(t => t.id === this.core.currentMap).getNorth()), {
              baseColor: t.baseColor
            });
          this.prevRadius = 0;
          let l = this.threeDMarkerLayer.createThreeJSMarker({
            object: a.outerObject,
            mapOrMapId: r,
            position: o
          });
          e.push({
            handle: l,
            radius: a.radiusObject,
            dotObject: a.dotObject,
            bearing: a.bearingObject
          });
        }), this.blueDots = e, this.currentX && this.updateBlueDotSize();
      }
      this.currentPositionLatLon ? (this.positionTween = new dp.default.Tween(this.currentPositionLatLon).to({
        lat: t.coordinates.latitude,
        lon: t.coordinates.longitude
      }, Fde).easing(dp.default.Easing.Cubic.Out).onUpdate(t => {
        this.currentPositionLatLon = t, this.blueDots.forEach(e => {
          let n = e.handle._mapId,
            i = this.core.mapObjects.get(n),
            r = i.getPositionLatLon(t.lat, t.lon);
          i.translateChild(e.handle.object, r);
        }), this.core.tryRendering(hi.ALWAYS_ON_TOP);
      }), this.positionTween.start()) : (this.currentPositionLatLon = {
        lat: t.coordinates.latitude,
        lon: t.coordinates.longitude
      }, this.blueDots.forEach(e => {
        let n = e.handle._mapId,
          i = this.core.mapObjects.get(n),
          r = i.getPositionLatLon(t.coordinates.latitude, t.coordinates.longitude);
        i.translateChild(e.handle.object, r);
      })), Math.abs(r - this.prevRadius) >= Number.EPSILON && (null != this.radiusTween && this.radiusTween.stop(), this.radiusTween = new dp.default.Tween({
        value: this.prevRadius
      }).to({
        value: r
      }, this.radiusTweenOptions.duration).easing(this.radiusTweenOptions.easing).onUpdate(({
        value: t
      }) => {
        this.prevRadius = t, null != this.blueDots && this.blueDots.forEach(e => {
          if (e.radius) {
            let n = e.handle._mapId,
              i = this.core.mapObjects.get(n),
              r = t * i.getMapScale();
            e.radius.scale.set(r, 1, r);
          }
        }), this.core.tryRendering(hi.ALWAYS_ON_TOP);
      }).start());
      let o = t.bearing;
      if (null != t.bearing) {
        if (null == this.prevBearing) this.prevBearing = t.bearing, this.setBearing(t.bearing);else if (Math.abs(o - this.prevBearing) >= Number.EPSILON) {
          let t = (null != (e = this.prevBearing) ? e : o) % 360,
            n = o % 360;
          Math.abs(t - n) > 180 && (t > n ? n += 360 : t += 360), this.animateBearing(t, n);
        }
      } else null != this.blueDots && this.blueDots.forEach(t => {
        t.bearing && (t.bearing.visible = !1);
      });
      this.state = {
        mode: n,
        targetMap: i
      }, this.core.tryRendering(hi.ALWAYS_ON_TOP);
    }
    animateBearing(t, e) {
      this.bearingTween = new dp.default.Tween({
        value: t
      }).to({
        value: e
      }, 1e3).easing(dp.default.Easing.Cubic.Out).onUpdate(({
        value: t
      }) => {
        this.prevBearing = t, this.setBearing(t), this.core.tryRendering(hi.ALWAYS_ON_TOP);
      }).start();
    }
    setBearing(t) {
      null != this.blueDots && this.blueDots.forEach(e => {
        e.bearing && (e.bearing.visible = !0, e.bearing.rotation.set(0, 0, jA(t, this.core.venue.maps.find(t => t.id === this.core.currentMap).getNorth())));
      });
    }
    getBlueDotForMap(t) {
      if (!Array.isArray(this.blueDots)) return;
      let e = ("string" == typeof t && t.length > 0 ? t : "object" == typeof t ? t.id : void 0) || this.core.currentMap,
        n = this.blueDots.filter(t => t.handle._mapId === e);
      if (n.length > 0) {
        let t = new ne(),
          e = new ne();
        return n[0].dotObject.updateMatrixWorld(), n[0].dotObject.getWorldPosition(t), n[0].dotObject.getWorldScale(e), e.divideScalar(2), e.setZ(0), t.sub(e), n[0].dotObject;
      }
    }
    cleanup() {
      this.blueDots && (this.blueDots.forEach(t => {
        t.handle._object.children.forEach(t => {
          t.geometry ? t.geometry.dispose() : t.children.forEach(t => {
            t.geometry.dispose();
          });
        }), this.threeDMarkerLayer.removeThreeJSMarker(t.handle);
      }), delete this.blueDots), this.state = null, null != this.positionTween && this.positionTween.stop(), null != this.radiusTween && this.radiusTween.stop();
    }
  };
u(WA, "BlueDotManager");
var RA = WA;
E();
var lu,
  Tc,
  mp,
  XA = class extends Ks {
    constructor(t) {
      super(), A(this, "core"), A(this, "currentAnimation"), re(this, lu, void 0), re(this, Tc, void 0), re(this, mp, void 0), A(this, "interactions", {
        enable: () => {
          this.core.controls.enablePan = !0, this.core.controls.enableZoom = !0, this.core.controls.enableRotate = !0;
        },
        disable: () => {
          this.core.controls.enablePan = !1, this.core.controls.enableZoom = !1, this.core.controls.enableRotate = !1;
        }
      }), this.core = t, he(this, mp, !1);
      let e = ol(() => this.publish(Ls.CHANGED, {
        tilt: this.tilt,
        zoom: this.zoom,
        rotation: this.rotation,
        position: this.position
      }), 0);
      this.core.controls.dispatcher.addEventListener("positionUpdated", () => {
        this.publish(Ls.POSITION_CHANGED, this.position), e();
      }), this.core.controls.dispatcher.addEventListener("zoomUpdated", () => {
        this.publish(Ls.ZOOM_CHANGED, this.zoom), e();
      }), this.core.controls.dispatcher.addEventListener("rotationUpdated", () => {
        this.publish(Ls.ROTATION_CHANGED, this.rotation), e();
      }), this.core.controls.dispatcher.addEventListener("tiltUpdated", () => {
        this.publish(Ls.TILT_CHANGED, this.tilt), e();
      });
      let n = u(() => {
          w(this, mp) || (this.publish(Ls.USER_INTERACTION_START, void 0), he(this, mp, !0));
        }, "publishVoidEventStart"),
        i = u(() => {
          this.publish(Ls.USER_INTERACTION_END, void 0), he(this, mp, !1);
        }, "publishVoidEventEnd");
      this.core.controls.dispatcher.addEventListener("userPanStart", n), this.core.controls.dispatcher.addEventListener("userZoomStart", n), this.core.controls.dispatcher.addEventListener("userRotateStart", n), this.core.controls.dispatcher.addEventListener("userTiltStart", n), this.core.controls.dispatcher.addEventListener("userPedestalStart", n), this.core.controls.dispatcher.addEventListener("userDollyStart", n), this.core.controls.dispatcher.addEventListener("userPanEnd", i), this.core.controls.dispatcher.addEventListener("userPedestalEnd", i), this.core.controls.dispatcher.addEventListener("userZoomEnd", i), this.core.controls.dispatcher.addEventListener("userRotateEnd", i), this.core.controls.dispatcher.addEventListener("userDollyEnd", i), this.core.controls.dispatcher.addEventListener("userTiltEnd", i);
    }
    get zoom() {
      return this.core.controls.getZoom();
    }
    get rotation() {
      return this.core.controls.getRotation();
    }
    get tilt() {
      return this.core.controls.getTilt();
    }
    get minZoom() {
      return this.core.controls.minZoom;
    }
    set minZoom(t) {
      this.core.controls.minZoom = t;
    }
    get maxZoom() {
      return this.core.controls.maxZoom;
    }
    set maxZoom(t) {
      this.core.controls.maxZoom = t;
    }
    get maxTilt() {
      return this.core.controls.maxTilt;
    }
    set maxTilt(t) {
      this.core.controls.maxTilt = Math.max(0, Math.min(t, Xy));
    }
    get position() {
      let t = this.core.controls.getPosition();
      return this.core.convert3DMapPositionToCoordinate(t);
    }
    setSafeAreaInsets(t) {
      this.core.setPadding(t);
    }
    getSafeAreaInsets() {
      return this.core.cachedPadding;
    }
    focusOn(t, e) {
      var n;
      if (this.core.stackedMaps.currentState === Wi.OVERVIEW) return Promise.reject(new Error("Cannot focus on a map when in overview mode"));
      let i = null == (n = t.coordinates) ? void 0 : n.map(t => this.core.convertTo3DMapPosition({
          x: t.x,
          y: t.y
        })),
        r = new Promise((t, e) => {
          he(this, lu, t), he(this, Tc, e);
        });
      return this.core.focusOn({
        changeZoom: null == e ? void 0 : e.changeZoom,
        duration: null == e ? void 0 : e.duration,
        focusZoomFactor: 1,
        curve: (null == e ? void 0 : e.easing) && Os[e.easing],
        minZoom: null == e ? void 0 : e.minZoom,
        nodes: t.nodes,
        points: i,
        polygons: t.polygons,
        padding: null == e ? void 0 : e.safeAreaInsets,
        tilt: null == e ? void 0 : e.tilt,
        rotation: null == e ? void 0 : e.rotation,
        callback: () => {
          this.currentAnimation = void 0, w(this, lu).call(this), he(this, lu, void 0), he(this, Tc, void 0);
        }
      }), this.currentAnimation = r, r;
    }
    set(t) {
      if (!t) return;
      if (this.core.stackedMaps.currentState === Wi.OVERVIEW) throw new Error("Cannot set camera on a map when in overview mode");
      let e,
        {
          zoom: n,
          rotation: i,
          tilt: r,
          position: o
        } = t;
      o && (e = this.core.convertTo3DMapPosition(o)), this.core.controls.setMulti(e || this.core.controls.getPosition(), n, i, r);
    }
    animate(t, e) {
      if (this.core.stackedMaps.currentState === Wi.OVERVIEW) return Promise.reject(new Error("Cannot animate on a map when in overview mode"));
      let n;
      t.position && (n = this.core.convertTo3DMapPosition(t.position));
      let i = {
          position: n,
          zoom: t.zoom,
          tilt: t.tilt,
          rotation: t.rotation
        },
        r = new Promise((t, e) => {
          he(this, lu, t), he(this, Tc, e);
        });
      return this.core.controls.animateCamera(i, null == e ? void 0 : e.duration, (null == e ? void 0 : e.easing) && Os[e.easing], () => {
        this.currentAnimation = void 0, w(this, lu).call(this), he(this, lu, void 0), he(this, Tc, void 0);
      }), this.currentAnimation = r, r;
    }
    async translate(t, e, n) {
      if (this.core.stackedMaps.currentState === Wi.OVERVIEW) return Promise.reject(new Error("Cannot translate a map when in overview mode"));
      if (!t || !e || null == this.core.currentMap) return;
      let i = this.core.mapObjects.get(this.core.currentMap).mapClass,
        r = this.rotation,
        o = r + yw(90),
        s = r - yw(90),
        a = r + Math.PI,
        l = r,
        u = this.position,
        {
          x: h,
          y: c
        } = this.position,
        p = t2(i);
      if (1 === p) {
        h += e * Math.cos(o), c -= e * Math.sin(o);
        let t = this.core.convertTo3DMapPosition(i.createCoordinateByXY(h, c)),
          n = this.core.convert3DMapPositionToCoordinate(t);
        p = e / u.absoluteDistanceTo(n);
      }
      let d = e * p;
      switch (t) {
        case uc.UP:
          h += d * Math.cos(o), c -= d * Math.sin(o);
          break;
        case uc.DOWN:
          h += d * Math.cos(s), c -= d * Math.sin(s);
          break;
        case uc.LEFT:
          h += d * Math.cos(a), c -= d * Math.sin(a);
          break;
        case uc.RIGHT:
          h += d * Math.cos(l), c -= d * Math.sin(l);
      }
      return 0 !== this.tilt && e && (await this.animate({
        tilt: 0
      }, n)), this.animate({
        position: i.createCoordinateByXY(h, c)
      }, n);
    }
    cancelAnimation() {
      !this.currentAnimation || (this.core.controls.cancelAnimation(), w(this, Tc).call(this), this.currentAnimation = void 0, he(this, lu, void 0), he(this, Tc, void 0));
    }
  };
u(XA, "CameraController"), lu = new WeakMap(), Tc = new WeakMap(), mp = new WeakMap();
var YA = XA;
E();
var JA = Rt(zU());
E();
var bw = 1 * devicePixelRatio;
function Hde(t, e) {
  return e.x + e.w < t.x + t.w && e.x > t.x && e.y > t.y && e.y + e.h < t.y + t.h;
}
function ZA(t, e) {
  let n = e.x,
    i = e.y,
    r = e.x + e.w,
    o = e.y + e.h,
    s = t.x,
    a = t.y,
    l = t.x + t.w,
    u = t.y + t.h;
  return n < l && s < r && i < u && a < o;
}
u(Hde, "contains"), u(ZA, "intersects");
var _s = class {
  constructor(t, e, n, i, r) {
    A(this, "x"), A(this, "y"), A(this, "w"), A(this, "h"), A(this, "userData"), this.userData = r, this.x = t - bw, this.y = e - bw, this.w = n + 2 * bw, this.h = i + 2 * bw;
  }
  contains(t) {
    return t !== this && Hde(this, t);
  }
  intersects(t) {
    return ZA(this, t);
  }
  draw(t) {
    t.fillStyle = "rgba(123,222,26, 0.5)", t.fillRect(this.x, this.y, this.w, this.h);
  }
};
u(_s, "Rectangle");
var uu = class {
  constructor(t, e) {
    A(this, "boundary"), A(this, "capacity", 4), A(this, "objects", []), A(this, "topLeft"), A(this, "topRight"), A(this, "bottomLeft"), A(this, "bottomRight"), A(this, "divided", !1), A(this, "parent"), this.parent = e, this.boundary = t;
  }
  getSize() {
    return this.divided ? this.objects.length + this.topLeft.getSize() + this.topRight.getSize() + this.bottomLeft.getSize() + this.bottomRight.getSize() : this.objects.length;
  }
  subdivide() {
    let {
      x: t,
      y: e,
      w: n,
      h: i
    } = this.boundary;
    this.topLeft = new uu(new _s(t, e, n / 2, i / 2), this), this.topRight = new uu(new _s(t + n / 2, e, n / 2, i / 2), this), this.bottomLeft = new uu(new _s(t, e + i / 2, n / 2, i / 2), this), this.bottomRight = new uu(new _s(t + n / 2, e + i / 2, n / 2, i / 2), this), this.divided = !0;
  }
  query(t) {
    let e = [];
    return this.boundary.intersects(t) ? (e.push(...this.objects), this.divided && (e.push(...this.topLeft.query(t)), e.push(...this.topRight.query(t)), e.push(...this.bottomLeft.query(t)), e.push(...this.bottomRight.query(t))), e) : [];
  }
  insert(t) {
    return !!this.boundary.contains(t) && (this.objects.length < this.capacity ? (this.objects.push(t), !0) : (this.divided || this.subdivide(), !1 === (this.topLeft.insert(t) || this.topRight.insert(t) || this.bottomLeft.insert(t) || this.bottomRight.insert(t)) && this.objects.push(t), !0));
  }
  drawObjects(t) {
    this.objects.forEach(e => e.draw(t)), this.divided && (this.topLeft.drawObjects(t), this.topRight.drawObjects(t), this.bottomLeft.drawObjects(t), this.bottomRight.drawObjects(t));
  }
  draw(t) {
    t.rect(this.boundary.x, this.boundary.y, this.boundary.w, this.boundary.h), this.divided && (this.topLeft.draw(t), this.topRight.draw(t), this.bottomLeft.draw(t), this.bottomRight.draw(t)), t.strokeStyle = "black", t.lineWidth = 4, t.stroke();
  }
};
u(uu, "QuadTree");
var ng,
  jde = 300,
  Wde = 30,
  Xde = 1.5,
  VU = 250,
  GU = 300,
  Yde = 50,
  Mo = [];
function KA() {
  Mo = [], ng && (clearTimeout(ng), ng = null);
}
u(KA, "flushTapEvents");
var QA = class {
  constructor(t) {
    A(this, "type", "SINGLE"), A(this, "event"), A(this, "timestamp"), this.event = t, this.timestamp = performance.now();
  }
};
u(QA, "Tap");
var $A = class {
  constructor(t) {
    A(this, "core"), A(this, "blueDotManager"), A(this, "rendererDomElement"), A(this, "currentHover", null), A(this, "hoverLabel"), A(this, "hoverColor", new yt("#cccccc")), A(this, "options", {
      disableHover: !1
    }), A(this, "setBlueDotManager", u(t => {
      this.blueDotManager = t;
    }, "setBlueDotManager")), A(this, "touchCount", 0), A(this, "onPointerMove", u(t => {
      t.preventDefault(), !this.core.controls.isUserInteracting() && (this.calculateMouseCoordinates(t), ("touch" !== t.pointerType || null == t.pointerType && this.hasTouched) && (this.doHoverEffect(), this.hoverLabel.setPosition(this.cursorPos.x, this.cursorPos.y)));
    }, "onPointerMove")), A(this, "onPointerUp", u(t => {
      if ("touch" === t.pointerType && (Mo = Mo.filter(t => performance.now() - t.timestamp < GU)), "grabbing" === this.rendererDomElement.style.cursor && (this.rendererDomElement.style.cursor = "grab"), this.touchCount && this.decrementTouches(t), t.target.parentNode != this.core.container) return;
      let e = Math.sqrt(Math.pow(t.clientX - this.mouseDownStart.clientX, 2) + Math.pow(t.clientY - this.mouseDownStart.clientY, 2));
      Date.now() < this.mouseDownStart.time + jde && e <= Wde ? "touch" === t.pointerType ? 1 === Mo.length && "TWO_FINGER" === Mo[0].type ? (this.zoomOut(), KA()) : 1 === Mo.length && "SINGLE" === Mo[0].type ? (null != ng && clearTimeout(ng), ng = setTimeout(() => {
        this.handleMapClick(Mo[0].event), KA();
      }, GU)) : 2 === Mo.length && "SINGLE" === Mo[0].type && "SINGLE" === Mo[1].type && (this.zoomIn(Mo[1].event), KA()) : this.handleMapClick(t) : this.touchCount || (this.core.publish(this.core.currentInteractionEvent), this.core.currentInteractionEvent = void 0);
    }, "onPointerUp")), A(this, "onPointerDown", u(t => {
      if ("pointer" !== this.rendererDomElement.style.cursor && (this.rendererDomElement.style.cursor = "grabbing"), this.mouseDownStart = {
        time: Date.now(),
        clientX: t.clientX,
        clientY: t.clientY
      }, this.incrementTouches(t), "touch" === t.pointerType) {
        let e = new QA(t);
        Mo.length >= 1 && e.timestamp - Mo[Mo.length - 1].timestamp < Yde ? Mo[Mo.length - 1].type = "TWO_FINGER" : Mo.push(e);
      }
    }, "onPointerDown")), A(this, "incrementTouches", u(t => {
      window.PointerEvent && "touch" === t.pointerType && (this.touchCount = (this.touchCount || 0) + 1, 1 === this.touchCount && this.core.publish(Xe.USER_HANDS_ON));
    }, "incrementTouches")), A(this, "decrementTouches", u(t => {
      window.PointerEvent && "touch" === t.pointerType && (this.touchCount--, this.touchCount || this.core.publish(Xe.USER_HANDS_OFF));
    }, "decrementTouches")), A(this, "clearMouse", u(() => {
      this.mouse.x = 1 / 0, this.mouse.y = 1 / 0;
    }, "clearMouse")), A(this, "getMousePos", u(t => ({
      x: t.offsetX,
      y: t.offsetY
    }), "getMousePos")), A(this, "getScaledMousePos", u(t => ({
      x: t.offsetX * devicePixelRatio,
      y: t.offsetY * devicePixelRatio
    }), "getScaledMousePos")), A(this, "cursorPos", {
      x: 0,
      y: 0
    }), A(this, "mouse", {
      x: 0,
      y: 0
    }), A(this, "mouseDownStart", {
      time: 0,
      clientX: 0,
      clientY: 0
    }), A(this, "scaledCursorPos", {
      x: 0,
      y: 0
    }), A(this, "hasTouched", !1), A(this, "calculateMouseCoordinates", u(t => {
      this.cursorPos = this.getMousePos(t), this.scaledCursorPos = this.getScaledMousePos(t), this.mouse.x = this.cursorPos.x / this.core.canvasWidth * 2 - 1, this.mouse.y = -this.cursorPos.y / this.core.canvasHeight * 2 + 1;
    }, "calculateMouseCoordinates")), A(this, "getMouseRayIntersects", u(t => (Do.setFromCamera(this.mouse, this.core.cameraObject), Array.isArray(t) ? Do.intersectObjects(t, !0) : Do.intersectObject(t, !0)), "getMouseRayIntersects")), A(this, "detectCollidersUnderMouse", u(() => {
      let {
        interactiveCollidersQTree: t
      } = this.core.smartCollisionEngine;
      if (null != t) {
        let {
            x: e,
            y: n
          } = this.scaledCursorPos,
          i = new _s(e, n, 2, 2);
        return t.query(i).filter(t => i.intersects(t)).map(t => {
          var e;
          return null == (e = t.userData) ? void 0 : e.collider;
        });
      }
      return [];
    }, "detectCollidersUnderMouse")), A(this, "detectPolygonsUnderMouse", u(() => {
      var t;
      let e = null == (t = this.core.sceneManager) ? void 0 : t.currentScene.mapObjectsArray.flatMap(t => t.hoverableMeshChildren),
        n = this.getMouseRayIntersects(e).map(function (t) {
          return t.object.name;
        });
      (0, JA.default)(n);
      let i = [];
      for (let t = 0, e = n.length; t < e; ++t) {
        let e = n[t];
        e && this.core.interactivePolygons[e] && i.push(e);
      }
      return i;
    }, "detectPolygonsUnderMouse")), A(this, "detectPathsUnderMouse", u(() => {
      var t;
      Do.setFromCamera(this.mouse, this.core.cameraObject), Do.layers.set(bo.ANIMATED);
      let e = [];
      this.core.paths.pathsById.forEach(({
        internalPath: t
      }) => {
        t.options.interactive && t.pathSegments.forEach(t => {
          let n = t.object;
          e.push(n);
        });
      });
      let n = null != (t = Do.intersectObjects(e)) ? t : [];
      return Do.layers.set(bo.STATIC), n.map(t => {
        var e;
        return null == (e = this.core.paths.pathsByMeshId.get(t.object.uuid)) ? void 0 : e.path;
      });
    }, "detectPathsUnderMouse")), A(this, "detectMapsUnderMouse", u(() => {
      Do.setFromCamera(this.mouse, this.core.cameraObject);
      let t = Array.from(this.core.mapObjects.values()).filter(t => t.visible).map(t => t.object),
        e = Do.intersectObjects(t, !0).map(function (t) {
          var e;
          return null == (e = t.object) ? void 0 : e.parent.name;
        }).filter(t => t);
      return (0, JA.default)(e), e.map(t => this.core.venue.getCollectionItemById(ii.MAP, t));
    }, "detectMapsUnderMouse")), A(this, "getMouseMapPosition", u(() => {
      let t = this.getMouseRayIntersects(this.core.cameraPlane);
      if (t.length > 0) {
        let e = t[t.length - 1],
          n = this.core.mapObjects.get(this.core.currentMap);
        return {
          x: e.point.x + n.mapClass.width / 2,
          y: -e.point.y + n.mapClass.height / 2
        };
      }
      return {
        x: NaN,
        y: NaN
      };
    }, "getMouseMapPosition")), A(this, "checkMouseIntersectsBlueDot", u(() => {
      if (!this.blueDotManager) return !1;
      let t = this.blueDotManager.getBlueDotForMap(this.core.venue.maps.find(t => t.id === this.core.currentMap));
      if (t) {
        let e = new ne(),
          n = new ne();
        t.updateMatrixWorld(), t.getWorldPosition(e), t.getWorldScale(n), n.divideScalar(2), n.setZ(0), e.sub(n);
        let i = this.core.canvasWidth / 2,
          r = this.core.canvasHeight / 2;
        this.core.cameraObject.updateProjectionMatrix(), this.core.cameraObject.updateMatrixWorld(!0), e.project(this.core.cameraObject);
        let o = {
            x: e.x * i + i,
            y: -e.y * r + r
          },
          s = Math.pow(this.cursorPos.x - o.x, 2),
          a = Math.pow(this.cursorPos.y - o.y, 2);
        return Math.sqrt(s + a) <= 23;
      }
      return !1;
    }, "checkMouseIntersectsBlueDot")), A(this, "doHoverEffect", u(() => {
      if (this.options.disableHover) return;
      let t = this.detectPolygonsUnderMouse(),
        e = this.detectCollidersUnderMouse(),
        n = this.detectPathsUnderMouse(),
        i = !1;
      for (let e = 0, n = t.length; e < n; ++e) {
        let n = t[e];
        if (this.core.interactivePolygons[n]) {
          if (n != this.currentHover) {
            this.currentHover && (this.onPolygonHoverOut(this.currentHover), this.currentHover = null), this.core.highlightedPolygons[n] || (this.currentHover = n, this.onPolygonHoverOver(n));
            let t = this.core.textLabelsByPolygonId[Vr(n)];
            t && t.showHoverLabel ? this.hoverLabel.show(t) : this.hoverLabel.hide();
          }
          i = !0;
          break;
        }
      }
      i || (this.currentHover && (this.onPolygonHoverOut(this.currentHover), this.currentHover = null), this.hoverLabel.hide()), i || e.length > 0 || n.length > 0 ? this.rendererDomElement.style.cursor = "pointer" : this.rendererDomElement.style.cursor = "grab";
    }, "doHoverEffect")), A(this, "onPolygonHoverOut", u(t => {
      let e = this.core.polygonMeshesById[t],
        n = this.core.venue.getCollectionItemById(ii.POLYGON, t);
      if (!e) return;
      let i = this.core.textLabelsByPolygonId[t];
      i && i.setColor(i.baseColor);
      let r = !1;
      if (e._MIOriginalMaterial) {
        let n = (e.material.length && e.material[0] || e.material).color.getHex();
        this.hoverColor.getHex() === n && !this.core.highlightedPolygons[t] && (r = !0);
      }
      if (r) return this.core.polygonColors.setPolygonColor(n, n.material.color, !1), !1;
      i && this.core.tryRendering();
    }, "onPolygonHoverOut")), A(this, "onPolygonHoverOver", u(t => {
      let e = Vr(t),
        n = this.core.polygonMeshesById[e],
        i = this.core.textLabelsByPolygonId[e];
      if (n) return this.core.polygonColors.setPolygonColor(t, `#${this.hoverColor.getHexString()}`, !1), i && (i.setColor(i.hoverColor), this.core.tryRendering()), !1;
    }, "onPolygonHoverOver")), A(this, "setHoverColor", u(t => {
      this.hoverColor = new yt(t);
    }, "setHoverColor")), this.core = t;
    let e = this.core.renderer.domElement();
    this.core.container.style.touchAction = "auto", this.rendererDomElement = e, this.hoverLabel = new ou(this.core.container), this.core.on(Xe.CLEAR_MOUSE, this.clearMouse), this.core.on(Xe.CAMERA_MOVING, () => {
      this.currentHover && (this.onPolygonHoverOut(this.currentHover), this.currentHover = null), this.hoverLabel.hovering && this.hoverLabel.hide();
    }), e.addEventListener("pointerdown", this.onPointerDown, !1), e.addEventListener("pointermove", this.onPointerMove, !1), e.addEventListener("pointerup", this.onPointerUp, !1), e.addEventListener("pointercancel", this.onPointerUp, !1);
  }
  zoomOut() {
    this.core.controls.zoomOut(VU, Os["ease-out"]);
  }
  zoomIn(t) {
    let e = this.core.convertScreenCoordinateToMapCoordinate(t.clientX, t.clientY, this.core.venue.maps.find(t => t.id === this.core.currentMap)),
      n = this.core.convertTo3DMapPosition(e),
      i = this.core.controls.getZoom();
    this.core.controls.animateCamera({
      position: n,
      zoom: i / Xde
    }, VU, Os["ease-in"]);
  }
  handleMapClick(t) {
    this.calculateMouseCoordinates(t);
    let e = this.detectPolygonsUnderMouse(),
      n = this.detectMapsUnderMouse(),
      i = this.detectCollidersUnderMouse(),
      r = this.detectPathsUnderMouse(),
      o = i.filter(t => t instanceof Qs).map(t => ({
        text: t.options.text,
        node: t.position.nodeOrCoordinate
      })),
      s = this.getMouseMapPosition(),
      a = {
        lat: NaN,
        lon: NaN
      };
    !isNaN(s.x) && !isNaN(s.y) && (a = this.core.venue.maps.find(t => t.id === this.core.currentMap).createCoordinateByXY(s.x, s.y)), this.core.publish(Xe.MAP_CLICK, {
      position: {
        latitude: a.lat,
        longitude: a.lon
      },
      polygons: e.filter(t => this.core.interactivePolygons[t]).map(t => this.core.venue.getCollectionItemById(ii.POLYGON, t)),
      floatingLabels: o || [],
      maps: n || [],
      nearBlueDot: this.checkMouseIntersectsBlueDot(),
      paths: r
    });
    for (let t = 0, n = e.length; t < n; ++t) {
      let n = e[t];
      if (this.core.interactivePolygons[n] && "function" == typeof this.core.onPolygonClicked && !this.core.onPolygonClicked(n)) return;
    }
    "function" == typeof this.core.onNothingClicked && this.core.onNothingClicked();
  }
  destroy() {
    this.rendererDomElement.removeEventListener("pointerdown", this.onPointerDown, !1), this.rendererDomElement.removeEventListener("pointermove", this.onPointerMove, !1), this.rendererDomElement.removeEventListener("pointerup", this.onPointerUp, !1), this.rendererDomElement.removeEventListener("pointercancel", this.onPointerUp, !1);
  }
};
u($A, "EventSystem");
var e6 = $A;
E();
var HU = "varying vec2 vUV;\n\nvoid main() {\n   vUV = uv;\n\n   gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(position, 1.0);\n}",
  jU = 'precision mediump float;\n\n// The following uniforms are documented in Mappedin.ClosedPolygonManager.js\nuniform vec3 stripe1_color;\nuniform vec3 stripe2_color;\nuniform vec2 surface_dimensions;\nuniform float stripe1_width;\nuniform float stripe1_proportion;\nuniform float stripes_direction; \n\nvarying vec2 vUV;\n\nvec4 stripes(vec2 coord) {\n   vec4 color1 = vec4(stripe1_color, 1.0);\n   vec4 color2 = vec4(stripe2_color, 1.0);\n\n   // Transform the uv to surface coordinates in world space units\n   vec2 coord_absolute = coord * surface_dimensions;\n   \n   // Compute the width of a single texture "tile"\n   // For example, if the first stripe is 10 units and it forms 25% of the tile, we know that the tile itself is 40 units wide\n   float tile_width = stripe1_width / stripe1_proportion;\n\n   // Lerp the x and y coordinates of the component using the "direction" parameter; clever way of "rotating" the stripe without using trig functions, courtesy of https://andreashackel.de/tech-art/stripes-shader-1/\n   float stripe_coord = mix(coord_absolute.x, coord_absolute.y, stripes_direction);\n\n   // Normalize the above "coordinate" to obtain its position within a single texture "tile"\n   float stripe_coord_normalized = mod(stripe_coord, tile_width) / tile_width;\n\n   // Decide which of the two stripes this coordinate belongs to!\n   return mix(color1, color2, step(1. - stripe1_proportion, stripe_coord_normalized));\n}\n\nvoid main() {   \n   gl_FragColor = vec4(stripes(vUV).rgb, 1);\n}\n';
function Kde(t) {
  let e = new Qx(1, 1, 1, 1),
    n = 500,
    i = 500,
    r = new ne(0, 0, 0),
    o = 0;
  if (null != t && null != t.boundingBox && null != t.boundingBox.min && null != t.boundingBox.max) {
    let e = new $t(t.boundingBox.min, t.boundingBox.max),
      s = e.getSize(new ne());
    n = s.x, i = s.y, e.getCenter(r), o = (isNaN(e.max.z) ? 0 : e.max.z) + 10;
  }
  let s = new wi({
    vertexShader: HU,
    fragmentShader: jU,
    uniforms: {
      stripe1_color: {
        type: "c",
        value: new yt(.91372549019, .91372549019, .91372549019)
      },
      stripe2_color: {
        type: "c",
        value: new yt(.80784313725, .80784313725, .80784313725)
      },
      stripe1_width: {
        type: "f",
        value: 7
      },
      stripe1_proportion: {
        type: "f",
        value: .3
      },
      stripes_direction: {
        type: "f",
        value: 2 / 3
      },
      surface_dimensions: {
        type: "v2",
        value: new je(n, i)
      }
    }
  });
  s.transparent = !0, s.blending = Y_, s.depthTest = !1, s.stencilWrite = !0, s.stencilFunc = Q_, s.stencilFuncMask = 255, s.stencilRef = 1, s.stencilFail = Ru, s.stencilZFail = Ru, s.stencilZPass = Ru;
  let a = new Ft(e, s);
  return a.position.set(r.x, r.y, o), a.rotation.set(0, 0, 0), a.scale.set(n, i, 1), a;
}
function WU(t) {
  null != t && ih(t.material);
}
function XU(t) {
  return t.stencilWrite = !0, t.stencilFunc = Rg, t.stencilRef = 1, t.stencilFuncMask = 255, t.stencilFail = Ru, t.stencilZFail = Ru, t.stencilZPass = Yp, t;
}
function Qde(t, e, n) {
  null == e || null == n || (null != t && n.remove(t), n.add(e));
}
function $de(t, e) {
  return Math.abs(t - e) < Number.EPSILON;
}
u(Kde, "makeStencilSheet"), u(WU, "destroyStencilSheet"), u(XU, "enableStencilTestingAndConfigure"), u(Qde, "replaceObjectInScene"), u($de, "almostEqual");
var t6 = class {
  constructor({
    scene: t,
    getPolygonMeshFromId: e,
    tryRendering: n
  }) {
    this.scene = t, this.getPolygonMeshFromId = e, this.tryRendering = n, this.stencilSheet = null, this.polygonsMarkedAsClosed = {};
  }
  onMapChanged(t) {
    t.load().then(() => {
      this.currentMap = t, WU(this.stencilSheet);
      let e = Kde(t);
      Qde(this.stencilSheet, e, this.scene), this.stencilSheet = e, this.tryRendering();
    });
  }
  dispose() {
    this.markAllPolygonsAsOpen(), WU(this.stencilSheet);
  }
  markPolygonAsClosed(t) {
    if ("string" != typeof t || null != this.polygonsMarkedAsClosed[t]) return;
    let e = this.getPolygonMeshFromId(t);
    if (null == e || null == e.material) return;
    let n = e.geometry;
    if (ke.assert(n instanceof Pi), ke.assert(null == n.index), e.material.length) return;
    let i = {};
    i.geometryGroups = [...n.groups], n.clearGroups();
    let r = e.material,
      o = XU(e.material.clone());
    e.material = [r, o], e._MIOriginalMaterial && (e._MIOriginalMaterial.length || (e._MIOriginalMaterial = [e._MIOriginalMaterial, XU(e._MIOriginalMaterial.clone())]));
    let s = n.getAttribute("normal");
    ke.assert(3 === s.itemSize), ke.assert(s.array.length / 3 === s.count), ke.assert(s.count % 3 == 0);
    let a = new ne(0, 0, 1);
    for (let t = 0; t < s.count; t += 3) {
      let e = (s.getX(t) + s.getX(t + 1) + s.getX(t + 2)) / 3,
        i = (s.getY(t) + s.getY(t + 1) + s.getY(t + 2)) / 3,
        r = (s.getZ(t) + s.getZ(t + 1) + s.getZ(t + 2)) / 3;
      $de(new ne(e, i, r).normalize().dot(a), 1) ? n.addGroup(t, 3, 1) : n.addGroup(t, 3, 0);
    }
    this.tryRendering(), this.polygonsMarkedAsClosed[t] = i;
  }
  markPolygonAsOpen(t) {
    if ("string" != typeof t || null == this.polygonsMarkedAsClosed[t]) return;
    let e = this.polygonsMarkedAsClosed[t],
      n = this.getPolygonMeshFromId(t),
      i = n.geometry;
    i.clearGroups(), e.geometryGroups.forEach(({
      start: t,
      count: e,
      materialIndex: n
    }) => i.addGroup(t, e, n)), ih(n.material[1]), n.material = n.material[0], n._MIOriginalMaterial && n._MIOriginalMaterial.length && (n._MIOriginalMaterial = n._MIOriginalMaterial[0]), delete this.polygonsMarkedAsClosed[t], this.tryRendering();
  }
  markAllPolygonsAsOpen() {
    for (let t in this.polygonsMarkedAsClosed) this.markPolygonAsOpen(t);
  }
};
u(t6, "ClosedPolygonManager");
var TA = t6;
E();
var eme = !1,
  ig = class {
    constructor(t) {
      A(this, "textureLoader", new pa()), A(this, "data"), this.data = t;
    }
    async loadMapPolygons() {}
    loadImage(t) {
      let e = this.data.get(t.split(/[\/\.]/)[1]);
      return new Promise((n, i) => {
        eme && ke.log("loading image: ", t);
        let r = new Blob([e]),
          o = URL.createObjectURL(r);
        this.textureLoader.load(o, t => {
          t.colorSpace = Nt, n(t);
        }, () => {}, i);
      });
    }
  };
u(ig, "BinaryAssetManager"), E();
var n6 = !1,
  tme = !1,
  nme = !1,
  Mw = 10 * devicePixelRatio,
  Ew = 100,
  XC = "LOW_PRIORITY",
  i6 = class extends lp {
    get strategies() {
      let t = u(() => {}, "noop");
      return [{
        name: "left",
        getBoundingBox: u(t => [0, t.totalHeight, -Mw, 5], "leftBoundingBox"),
        onStrategySelected: t
      }, {
        name: "top",
        getBoundingBox: u(t => [-Mw, 5, 0, t.totalWidth], "topBoundingBox"),
        onStrategySelected: t
      }, {
        name: "right",
        getBoundingBox: u(t => [0, t.totalHeight, t.totalWidth - 5, t.totalWidth + Mw], "rightBoundingBox"),
        onStrategySelected: t
      }, {
        name: "bottom",
        getBoundingBox: u(t => [t.totalHeight - 5, t.totalHeight + Mw, 0, t.totalWidth], "bottomBoundingBox"),
        onStrategySelected: t
      }];
    }
  };
u(i6, "OffscreenCollider");
var Li,
  gp,
  ww,
  Sw,
  f_,
  rg,
  YU = u((t, e) => e.length ? (e.splice(r6(t, e), 0, t), e) : (e.push(t), e), "insertOne"),
  ZU = u((t, e) => (e.length && e.splice(e.indexOf(t), 1), e), "removeOne"),
  r6 = u((t, e, n, i) => {
    let r = n || 0,
      o = i || e.length,
      s = Math.floor(r + (o - r) / 2);
    return e[s].rank === t.rank ? s : o - r <= 1 ? e[s].rank < t.rank ? s : s + 1 : e[s].rank > t.rank ? r6(t, e, s, i) : r6(t, e, n, s);
  }, "locationOf"),
  o6 = class {
    constructor(t) {
      A(this, "colliderCanvas"), A(this, "debugCanvas"), A(this, "colliderCanvasContext"), A(this, "debugCanvasContext"), A(this, "collisionEngineContainerEl"), A(this, "stepsX"), A(this, "stepsY"), A(this, "totalWidth"), A(this, "totalHeight"), A(this, "project"), A(this, "colliders", new Map()), A(this, "offscreenRanges", []), re(this, Li, {}), re(this, gp, !1), A(this, "initialized", !1), A(this, "core"), A(this, "screen"), A(this, "updateStartEvents"), A(this, "updateEndEvents"), A(this, "init", u((t, e) => {
        this.project = e, t.appendChild(this.collisionEngineContainerEl), t.appendChild(this.colliderCanvas), this.totalWidth = t.clientWidth, this.totalHeight = t.clientHeight, this.screen = new _s(0, 0, this.totalWidth, this.totalHeight), this.colliderCanvas.width = this.totalWidth * devicePixelRatio, this.colliderCanvas.height = this.totalHeight * devicePixelRatio, this.colliderCanvas.style.width = this.totalWidth + "px", this.colliderCanvas.style.height = this.totalHeight + "px", n6 && (this.debugCanvasContext = this.debugCanvas.getContext("2d"), t.appendChild(this.debugCanvas), this.debugCanvas.width = this.totalWidth, this.debugCanvas.height = this.totalHeight, this.debugCanvas.style.width = this.totalWidth + "px", this.debugCanvas.style.height = this.totalHeight + "px", this.debugCanvas.style.opacity = "0.4");
        let n = new i6({
          rank: 999
        });
        this.offscreenRanges = n.strategies.map(({
          getBoundingBox: t
        }) => t({
          x: 0,
          y: 0,
          totalHeight: this.totalHeight,
          totalWidth: this.totalWidth
        }).map(t => Math.round(t))), this.initialized = !0, w(this, gp) || (w(this, ww).call(this), he(this, gp, !0)), w(this, rg).call(this);
      }, "init")), A(this, "handleBeginUpdate", u(t => {
        if (!1 === this.updateStartEvents[t.type]) this.beginUpdate();else if (null != t.message) {
          let {
            zooming: e,
            rotating: n,
            tilting: i
          } = t.message;
          (e || n || i) && this.beginUpdate();
        }
      }, "handleBeginUpdate")), A(this, "handleEndUpdate", u(t => {
        if (!1 === this.updateEndEvents[t.type]) this.update();else if (null != t.message) {
          let {
            zooming: e,
            rotating: n,
            tilting: i
          } = t.message;
          (e || n || i) && this.update();
        }
      }, "handleEndUpdate")), re(this, ww, u(() => {
        he(this, gp, !0);
        for (let t in this.updateStartEvents) this.core.controls.dispatcher.addEventListener(t, this.handleBeginUpdate);
        for (let t in this.updateEndEvents) this.core.controls.dispatcher.addEventListener(t, this.handleEndUpdate);
        this.core.on(Xe.SET_SCENE_START, w(this, f_)), this.core.on(Xe.SET_SCENE, w(this, rg));
      }, "#addListeners")), re(this, Sw, u(() => {
        for (let t in this.updateStartEvents) this.core.controls.dispatcher.removeEventListener(t, this.handleBeginUpdate);
        for (let t in this.updateEndEvents) this.core.controls.dispatcher.removeEventListener(t, this.handleEndUpdate);
        this.core.off(Xe.SET_SCENE_START, w(this, f_)), this.core.off(Xe.SET_SCENE, w(this, rg)), he(this, gp, !1);
      }, "#removeListeners")), re(this, f_, u(() => {
        let t = this.core.visibleMapsInCurrentScene.map(t => t.id) || [];
        this.colliders.forEach(t => {
          t.disable(!1);
        }), t.forEach(t => {
          null != w(this, Li)[t] && (w(this, Li)[t].needsSort = !0);
        }), this.update();
      }, "#onSetSceneStart")), re(this, rg, u(() => {
        let t = this.core.visibleMapsInCurrentScene.map(t => t.id) || [];
        this.colliders.forEach(e => {
          t.includes(e.mapId) && e.enable(!1);
        }), t.forEach(t => {
          null != w(this, Li)[t] && (w(this, Li)[t].needsSort = !0);
        }), this.update();
      }, "#onSetSceneEnd")), A(this, "qtree"), A(this, "interactiveCollidersQTree"), A(this, "recompute", u(() => {
        if (!this.initialized) return;
        let t,
          e,
          n,
          [i, r, o, s] = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
          a = this.offscreenRanges.map(t => {
            let e = t[3] - t[2],
              n = t[1] - t[0];
            return i = Math.min(i, t[2]), o = Math.max(o, t[3]), r = Math.min(r, t[0]), s = Math.max(s, t[1]), new _s(Math.round(t[2] * devicePixelRatio), Math.round(t[0] * devicePixelRatio), Math.round(e * devicePixelRatio), Math.round(n * devicePixelRatio));
          });
        for (let a of this.sortedColliders) t = a.position, e = a.mapId, a.getBoundingBoxForCurrentStrategy = void 0, a.enabled && (n = this.project(t, e), "function" == typeof a.colliderDidUpdatePosition && a.colliderDidUpdatePosition([n.x, n.y]), a._bboxes = a.strategies.map(({
          name: t,
          getBoundingBox: e,
          onStrategySelected: l
        }) => {
          let u = e({
              x: n.x,
              y: n.y
            }),
            h = u[3] - u[2],
            c = u[1] - u[0];
          return i = Math.min(i, u[2]), o = Math.max(o, u[3]), r = Math.min(r, u[0]), s = Math.max(s, u[1]), null == a._bboxes && (a._bboxes = []), [t, new _s(Math.round(u[2] * devicePixelRatio), Math.round(u[0] * devicePixelRatio), Math.round(h * devicePixelRatio), Math.round(c * devicePixelRatio), {
            collider: a
          }), l, e];
        }));
        let l,
          u = new _s(Math.round(i * devicePixelRatio) - Ew, Math.round(r * devicePixelRatio) - Ew, Math.round(o * devicePixelRatio - i * devicePixelRatio) + 2 * Ew, Math.round(s * devicePixelRatio - r * devicePixelRatio) + 2 * Ew);
        this.qtree = new uu(u), a.forEach(t => {
          this.qtree.insert(t);
        });
        for (let t = 0; t < this.sortedColliders.length; t++) {
          let e = !1;
          if (l = this.sortedColliders[t], null == l._bboxes || !l.enabled) continue;
          let [n, i] = [1 / 0, null];
          for (let [, t, r, o] of l._bboxes) {
            let s = this.qtree.query(t).filter(e => t.intersects(e));
            if (s.length <= n && (i = [t, r, o]), 0 === s.length) {
              this.qtree.insert(t), l.getBoundingBoxForCurrentStrategy = o, e = !0, l.setAction(Kr.show), r(l);
              break;
            }
          }
          if (l.rank === No.ALWAYS_VISIBLE && null != i) {
            let [t, n, r] = i;
            this.qtree.insert(t), l.getBoundingBoxForCurrentStrategy = r, e = !0, l.setAction(Kr.show), n(l);
          }
          !e && "function" == typeof l.colliderDidNotFindAHome && l.colliderDidNotFindAHome(), "function" == typeof l.colliderDidUpdateVisiblity && l.colliderDidUpdateVisiblity();
        }
        this.draw(), this.colliderCanvas.classList.remove("interacting");
      }, "recompute")), A(this, "draw", u(() => {
        this.colliderCanvasContext.clearRect(0, 0, this.totalWidth * devicePixelRatio, this.totalHeight * devicePixelRatio);
        for (let t of this.sortedColliders) t.offscreen || t instanceof Qs && t.draw(this.colliderCanvasContext);
        n6 && this.qtree && (this.colliderCanvasContext.beginPath(), nme && this.qtree.draw(this.colliderCanvasContext), this.qtree.drawObjects(this.colliderCanvasContext)), tme && null != this.interactiveCollidersQTree && this.interactiveCollidersQTree.drawObjects(this.colliderCanvasContext);
      }, "draw")), A(this, "reposition", u(() => {
        var t;
        if (!this.initialized) return;
        let e, n, i;
        this.interactiveCollidersQTree = new uu(new _s(0, 0, this.totalWidth * devicePixelRatio, this.totalHeight * devicePixelRatio));
        for (let r of this.sortedColliders) if (e = r.position, n = r.mapId, i = this.project(e, n), r.enabled) {
          if ("function" == typeof r.getBoundingBoxForCurrentStrategy) {
            let [e, n, o, s] = r.getBoundingBoxForCurrentStrategy({
              x: i.x,
              y: i.y
            });
            r instanceof Qs && (null == (t = r.options) ? void 0 : t.interactive) && this.interactiveCollidersQTree.insert(new _s(o * devicePixelRatio, e * devicePixelRatio, (s - o) * devicePixelRatio, (n - e) * devicePixelRatio, {
              collider: r
            })), ZA(this.screen, {
              x: o,
              y: e,
              w: s - o,
              h: n - e
            }) ? r.offscreen = !1 : r.offscreen = !0;
          }
          "function" == typeof r.colliderDidUpdatePosition && r.colliderDidUpdatePosition([i.x, i.y]);
        }
        this.draw();
      }, "reposition")), A(this, "add", u((t, e) => {
        e.__engine = this, "function" == typeof e.colliderDidMount && e.colliderDidMount(), this.colliders.set(t, e), null == w(this, Li)[e.mapId] && (w(this, Li)[e.mapId] = {
          needsSort: !1,
          colliders: []
        }), YU(e, w(this, Li)[e.mapId].colliders);
      }, "add")), A(this, "remove", u(t => {
        let e = this.colliders.get(t);
        null != e && (e.disable(), e.__engine = void 0, this.colliders.delete(t), ZU(e, w(this, Li)[e.mapId].colliders));
      }, "remove")), A(this, "updateMap", u((t, e, n) => {
        let i = this.colliders.get(t);
        if (null == i) return;
        i.mapId = n, ZU(i, w(this, Li)[e].colliders), null == w(this, Li)[n] && (w(this, Li)[n] = {
          needsSort: !1,
          colliders: []
        }), YU(i, w(this, Li)[n].colliders);
        let r = this.core.visibleMapsInCurrentScene.map(t => t.id) || [];
        r.includes(e) && i.disable(), r.includes(n) && i.enable();
      }, "updateMap")), A(this, "update", u(() => {
        this.initialized && ((this.core.visibleMapsInCurrentScene.map(t => t.id) || []).forEach(t => {
          w(this, Li)[t] && (w(this, Li)[t].needsSort = !0);
        }), this.recompute(), this.reposition());
      }, "update")), A(this, "resize", u(t => {
        !this.initialized || (w(this, Sw).call(this), this.init(t, this.project), this.update());
      }, "resize")), A(this, "destroy", u(() => {
        for (let t of Array.from(this.colliders.values())) this.remove(t.id);
      }, "destroy")), this.core = t, this.colliderCanvas = document.createElement("canvas"), this.collisionEngineContainerEl = document.createElement("div"), n6 && (this.debugCanvas = document.createElement("canvas"), this.debugCanvas.classList.add("mappedin__smart-collision-engine-debug__container")), this.colliderCanvas.classList.add("mappedin__smart-collision-engine-debug__container"), this.collisionEngineContainerEl.classList.add("mappedin__smart-collision-engine__container"), this.colliderCanvasContext = this.colliderCanvas.getContext("2d");
      let {
        INTERACTION_EVENTS: e,
        CAMERA_EVENTS: n
      } = this.core.controls;
      this.updateStartEvents = {
        [e.USER_DOLLY_START_EVENT.type]: !1,
        [n.ROTATE_START_EVENT.type]: !1,
        [n.ZOOM_START_EVENT.type]: !1,
        [e.USER_TILT_START_EVENT.type]: !1,
        [n.MULTI_START_EVENT.type]: !0,
        [n.PEDESTAL_START_EVENT.type]: !1
      }, this.updateEndEvents = {
        [e.USER_DOLLY_END_EVENT.type]: !1,
        [n.ROTATE_END_EVENT.type]: !1,
        [n.ZOOM_END_EVENT.type]: !1,
        [e.USER_TILT_END_EVENT.type]: !1,
        [n.MULTI_END_EVENT.type]: !0,
        [n.MULTI_CANCEL_EVENT.type]: !0,
        [n.PEDESTAL_END_EVENT.type]: !1
      };
    }
    get sortedColliders() {
      return this.initialized ? (this.core.visibleMapsInCurrentScene.map(t => t.id) || []).flatMap(t => {
        var e;
        return w(this, Li)[t] && (null == (e = w(this, Li)[t].colliders) ? void 0 : e.length) > 0 && !1 === w(this, Li)[t].needsSort || (null == w(this, Li)[t] && (w(this, Li)[t] = {
          needsSort: !0,
          colliders: []
        }), w(this, Li)[t].colliders = Array.from(this.colliders.values()).filter(e => e.mapId === t).sort((t, e) => e.rank - t.rank), w(this, Li)[t].needsSort = !1), w(this, Li)[t].colliders;
      }) : [];
    }
    beginUpdate() {
      this.colliderCanvas.classList.add("interacting");
    }
  };
u(o6, "SmartCollisionEngine"), Li = new WeakMap(), gp = new WeakMap(), ww = new WeakMap(), Sw = new WeakMap(), f_ = new WeakMap(), rg = new WeakMap();
var s6 = o6;
E();
var a6 = class {
  constructor(t) {
    A(this, "orbit"), A(this, "billboards", new Map()), this.orbit = t;
  }
  add(t, e = "Z") {
    this.billboards.set(t.uuid, [t, e]);
  }
  remove(t) {
    this.billboards.delete(t.uuid);
  }
  update() {
    for (let [t, e] of this.billboards.values()) e.includes("Z") && (t.rotation.z = this.orbit.rotation.z);
  }
  destroy() {
    this.billboards.clear();
  }
};
u(a6, "BillboardManager");
var l6 = a6;
E();
var Qo,
  JU = Rt(Ny());
!function (t) {
  t.enable = "enable", t.disable = "disable", t.showOverview = "showOverview", t.zoomInToMap = "zoomInToMap", t.scrollToMap = "scrollToMap";
}(Qo || (Qo = {}));
var en,
  u6 = class {
    constructor(t) {
      re(this, en, void 0), A(this, "options", {}), A(this, "enabled", !1), A(this, "stackScene"), A(this, "directions"), A(this, "needsUpdate", !1), A(this, "currentState", Wi.INACTIVE), A(this, "mapsInJourney", []), A(this, "getZoomIntoMapOptions", u(t => {
        if ("map" in t && "nodes" in t && "rotation" in t) {
          let {
            map: e,
            nodes: n,
            rotation: i
          } = t;
          return [new bc([e], w(this, en)), {
            activeMap: e,
            focusOn: {
              targets: {
                nodes: n
              },
              options: {
                tilt: .7,
                rotation: i,
                easing: cc.EASE_IN_OUT,
                ...t.cameraTransform
              }
            }
          }];
        }
      }, "getZoomIntoMapOptions")), A(this, "getDisableOptions", u(t => {
        if ("map" in t) return [new bc([t.map], w(this, en)), {
          activeMap: t.map
        }];
      }, "getDisableOptions")), A(this, "getShowOverviewOptions", u(t => {
        var e;
        if ("stackScene" in t) return [t.stackScene, {
          activeMap: t.stackScene.currentMap,
          focusOn: {
            options: {
              tilt: 1.2,
              duration: 500
            }
          },
          verticalDistanceBetweenMaps: null == (e = this.options) ? void 0 : e.verticalDistanceBetweenMaps
        }];
      }, "getShowOverviewOptions")), A(this, "getScrollToMapOptions", u(t => {
        if ("stackScene" in t && "map" in t && "nodes" in t) {
          let {
            stackScene: e,
            map: n,
            nodes: i
          } = t;
          return [e, {
            focusOn: {
              targets: {
                nodes: i
              },
              options: {
                tilt: .7,
                easing: cc.EASE_IN_OUT
              }
            },
            activeMap: n
          }];
        }
      }, "getScrollToMapOptions")), A(this, "getEnableOptions", u(t => {
        "directions" in t && (this.directions = t.directions, this.stackScene = new Wy(this.mapsInJourney, w(this, en)));
      }, "getEnableOptions")), A(this, "getShowOverviewTransition", u(t => {
        var e;
        let [n, i] = t,
          r = null == (e = w(this, en).sceneManager) ? void 0 : e.currentScene,
          o = n;
        return async () => {
          w(this, en).publish(Xe.SET_SCENE_START), await w(this, en).tileManager.fadeOut(), await o.prepare(w(this, en).sceneManager, i);
          let t = o.mapObjects.get(o.currentMap.id);
          t.object.position.z = o.computeMapZ(t, o.mapObjectsArray.indexOf(t), i), t.fadeIn({
            duration: 0
          }).start(), w(this, en).controls.setPedestal(t.object.position.z), w(this, en).scene.add(o.object), o.object.add(t.object), await Promise.all(o.mapObjectsArray.map(t => t.fadeOut({
            layers: ["outdoor"]
          }).start())), i.animate ? await Promise.all([w(this, en).tileManager.fadeOut(), ...r.mapObjectsArray.filter(e => e !== t).map(t => t.fadeOut().start())]) : o.mapObjectsArray.forEach((t, e) => {
            t.object.position.z = o.computeMapZ(t, e, i), o.object.add(t.object), t.onVisible();
          }), o.createStackBoundingBox(), o.resize(), i.animate ? (await o.focusOnStackBox({
            ...i,
            autoFocusOnActiveMap: !0
          }), await o.expandMaps(o.mapObjectsArray, i).start()) : await Promise.all([o.focusOnStackBox({
            ...i,
            autoFocusOnActiveMap: !0
          }), ...o.mapObjectsArray.map(t => t.fadeOut({
            layers: ["outdoor"]
          }).start()), ...o.mapObjectsArray.map(t => t.fadeIn({
            layers: ["indoor"]
          }).start())]), o.postRender(), o.lockControls(), r.maps.includes(o.currentMap) || r.mapObjects.forEach(t => {
            t.onInvisible();
          }), w(this, en).scene.remove(r.object), w(this, en).publish(Xe.SET_SCENE);
        };
      }, "getShowOverviewTransition")), A(this, "getZoomInToMapTransition", u(t => {
        var e;
        let [n, i] = t,
          r = null == (e = w(this, en).sceneManager) ? void 0 : e.currentScene;
        return async () => {
          w(this, en).publish(Xe.SET_SCENE_START);
          let t = n.mapObjects.get(i.activeMap.id),
            e = t.object.position.z;
          await n.prepare(w(this, en).sceneManager, i), t.object.position.z = e, w(this, en).paths.hideConnectionSegments(), r.destroyLabels(), n.mapObjects.forEach(t => {
            n.object.add(null == t ? void 0 : t.object), t.fadeIn({
              duration: 0
            }).start(), t.onVisible();
          }), w(this, en).scene.add(n.object), await Promise.all([t.fadeIn().start(), n.focusOnCurrentMap({
            ...i,
            autoFocusOnActiveMap: !0
          }), ...r.mapObjectsArray.filter(e => e !== t).map(t => t.fadeOut().start())]), r.unmount(), n.postRender(), w(this, en).scene.remove(r.object), w(this, en).publish(Xe.SET_SCENE);
        };
      }, "getZoomInToMapTransition")), A(this, "getScrollToMapTransition", u(t => {
        var e;
        let [n, i] = t,
          r = null == (e = w(this, en).sceneManager) ? void 0 : e.currentScene;
        return async () => {
          r.currentMap = i.activeMap, await r.scrollToMap(i.activeMap), w(this, en).publish(Xe.SET_SCENE);
        };
      }, "getScrollToMapTransition")), A(this, "getDisableTransition", u(t => {
        let [e, n] = t,
          i = w(this, en).sceneManager.currentScene;
        return async () => {
          var t;
          let r = i.mapObjects.get(i.currentMap.id);
          w(this, en).publish(Xe.SET_SCENE_START);
          let o = e.mapObjects.get(n.activeMap.id);
          i instanceof Wy && i.destroyLabels(), await e.prepare(w(this, en).sceneManager, n), w(this, en).scene.add(e.object), e.mapObjects.forEach(t => {
            e.object.add(null == t ? void 0 : t.object), t.fadeIn({
              duration: 0,
              layers: ["indoor"]
            }).start(), t.onVisible();
          }), w(this, en).paths.hideConnectionSegments(), await Promise.all([i instanceof Wy && i.contractMaps(r).start(), i.focusOnCurrentMap({
            ...n,
            autoFocusOnActiveMap: !0
          })].filter(t => t)), w(this, en).scene.remove(i.object), w(this, en).tryRendering(), o.object.position.z = 0, w(this, en).controls.setPedestal(0), e.focusOnCurrentMap({
            ...n,
            focusOn: {
              ...n.focusOn,
              options: {
                ...(null == (t = n.focusOn) ? void 0 : t.options),
                duration: 150
              }
            },
            autoFocusOnActiveMap: !0
          }), i.unmount(), await Promise.all([w(this, en).tileManager.fadeIn(), ...e.mapObjectsArray.map(t => t.fadeIn().start())]), e.postRender(), w(this, en).publish(Xe.SET_SCENE);
        };
      }, "getDisableTransition")), A(this, "getEnableTransition", u(() => () => {}, "getEnableTransition")), A(this, "states", {
        [Wi.INACTIVE]: {
          actions: {
            [Qo.enable]: [Wi.ACTIVE, [t => this.getEnableOptions(t)]]
          }
        },
        [Wi.ACTIVE]: {
          actions: {
            [Qo.disable]: [Wi.INACTIVE, [t => this.getDisableTransition(this.getDisableOptions(t))]],
            [Qo.showOverview]: [Wi.OVERVIEW, [t => {
              let e = this.getShowOverviewOptions(t);
              if (null != e && "directions" in t && "map" in t) {
                let [n, i] = e;
                return this.getShowOverviewTransition([n, (0, JU.default)({}, i, e, {
                  activeMap: t.map,
                  animate: !0,
                  focusOn: {
                    options: {
                      tilt: 1.2,
                      duration: 500
                    }
                  }
                })]);
              }
              return Promise.reject();
            }]]
          }
        },
        [Wi.OVERVIEW]: {
          actions: {
            [Qo.disable]: [Wi.INACTIVE, [t => this.getDisableTransition(this.getDisableOptions(t))]],
            [Qo.zoomInToMap]: [Wi.ZOOMED_IN, [t => this.getScrollToMapTransition(this.getScrollToMapOptions(t)), t => this.getZoomInToMapTransition(this.getZoomIntoMapOptions(t))]],
            [Qo.scrollToMap]: [Wi.OVERVIEW, [t => this.getScrollToMapTransition(this.getScrollToMapOptions(t))]]
          }
        },
        [Wi.ZOOMED_IN]: {
          actions: {
            [Qo.disable]: [Wi.INACTIVE, [t => this.getDisableTransition(this.getDisableOptions(t))]],
            [Qo.showOverview]: [Wi.OVERVIEW, [t => this.getShowOverviewTransition(this.getShowOverviewOptions(t))]],
            [Qo.zoomInToMap]: [Wi.ZOOMED_IN, [t => this.getShowOverviewTransition(this.getShowOverviewOptions(t)), t => this.getScrollToMapTransition(this.getScrollToMapOptions(t)), t => this.getZoomInToMapTransition(this.getZoomIntoMapOptions(t))]]
          }
        }
      }), A(this, "disable", u(() => {
        w(this, en).setState(xo.EXPLORE), this.options = {};
        let t = this.transition(this.currentState, Qo.disable);
        return null != t ? (this.enabled = !1, this.mapsInJourney = [], this.exec(t, {
          map: this.currentMap
        })) : Promise.reject();
      }, "disable")), A(this, "enable", u(t => {
        if (null == xs.instance) return Promise.reject("Can't enable stacked maps without a journey enabled");
        let e = this.transition(this.currentState, Qo.enable);
        if (null != e) {
          this.options = t || {}, w(this, en).setState(xo.STACKED), this.enabled = !0;
          let n = xs.instance.activeDirections;
          return this.mapsInJourney = xs.instance.mapsInJourney, this.exec(e, {
            directions: n
          });
        }
        return Promise.reject();
      }, "enable")), A(this, "showOverview", u(async () => {
        let t = this.transition(this.currentState, Qo.showOverview);
        return this.exec(t, {
          map: this.mapsInJourney.includes(this.currentMap) ? this.currentMap : this.mapsInJourney[0],
          stackScene: this.stackScene,
          directions: this.directions
        });
      }, "showOverview")), A(this, "scrollToMap", u(t => {
        let e = this.transition(this.currentState, Qo.scrollToMap);
        return this.exec(e, {
          stackScene: this.stackScene,
          map: t,
          rotation: void 0,
          nodes: this.nodesInJourney.filter(e => e.map === t)
        });
      }, "scrollToMap")), A(this, "zoomInToMap", u((t, e) => {
        let n = t || this.currentMap,
          i = this.nodesInJourney.filter(t => t.map === n),
          r = this.transition(this.currentState, Qo.zoomInToMap);
        return this.exec(r, {
          map: t,
          nodes: i,
          stackScene: this.stackScene,
          rotation: w(this, en).controls.getRotation(),
          cameraTransform: e
        });
      }, "zoomInToMap")), he(this, en, t);
    }
    transition(t, e) {
      var n, i;
      let r = null == (n = this.states[t]) ? void 0 : n.actions[e],
        o = null != (i = null == r ? void 0 : r[0]) ? i : t;
      if (null != o && null != r) return this.currentState = o, this.needsUpdate = !0, r[1];
      this.needsUpdate = !1;
    }
    async exec(t, e) {
      if (this.needsUpdate && null != t && Array.isArray(t) && t.filter(t => t).length > 0) {
        for (let n of t) {
          let t = n(e);
          "function" == typeof t && (await t());
        }
        return Promise.resolve();
      }
    }
    get nodesInJourney() {
      return Array.isArray(this.directions) ? this.directions.map(t => t.path).flat() : this.directions.path;
    }
    get currentMap() {
      return w(this, en).venue.getCollectionItemById(ii.MAP, w(this, en).currentMap);
    }
  };
u(u6, "StackedMapsController"), en = new WeakMap();
var c6 = u6;
E();
var Pc,
  QU = Rt(KU()),
  p_ = !1;
!function (t) {
  t[t.EXPIRED = 0] = "EXPIRED", t[t.IN_PROGRESS = 1] = "IN_PROGRESS", t[t.COMPLETED = 2] = "COMPLETED";
}(Pc || (Pc = {}));
var ime = u(function ({
    core: t,
    blueDotManager: e,
    controller: n
  }) {
    var i, r, o;
    let s = new Ea({
        ...(null == (i = null == t ? void 0 : t.venue) ? void 0 : i.options),
        testMode: !(null == (o = null == (r = null == t ? void 0 : t.venue) ? void 0 : r.options) ? void 0 : o.emitAnalyticsEvents)
      }),
      {
        stateMachine: a
      } = n,
      l = f7(t.smartCollisionEngine.update, 1e4),
      u = Ph({
        isFollowing: !1,
        blueDotTooltips: [],
        zoomCondition: 0,
        setBlueDotPosition() {
          if (e && n.userPosition && n.userMap) {
            let t = a.state === Kt.HAS_POSITION || a.state === Kt.HAS_INDOOR_POSITION;
            e.update({
              coordinates: n.userPosition.coords,
              bearing: n.bearing,
              radius: t && n.userPosition.coords.accuracy || 0,
              mapId: n.userMap.id
            });
          }
        },
        showBlueDotBearing() {
          if (e && n.userPosition && n.userMap) {
            let t = a.state === Kt.HAS_POSITION || a.state === Kt.HAS_INDOOR_POSITION;
            e.update({
              coordinates: n.userPosition.coords,
              bearing: n.bearing,
              radius: t && n.userPosition.coords.accuracy || 0,
              mapId: n.userMap.id
            });
          }
        },
        addGhostMarkers() {
          e && n.userPosition && n.userMap && e.update({
            mode: pp.GHOST,
            coordinates: n.userPosition.coords,
            bearing: n.bearing,
            radius: n.userPosition.coords.accuracy,
            mapId: n.userMap.id
          });
        },
        addLocationUncertainMarkersAndTooltips() {
          e && n.userPosition && n.userMap && e.update({
            mode: pp.GREY,
            coordinates: n.userPosition.coords,
            radius: 0,
            mapId: n.userMap.id
          });
        },
        addBlueDotMarker() {
          e && n.userPosition && n.userMap && e.update({
            mode: pp.BLUE,
            coordinates: n.userPosition.coords,
            bearing: n.bearing,
            radius: n.userPosition.coords.accuracy,
            mapId: n.userMap.id,
            baseColor: n.enableBlueDotOptions.baseColor
          });
        },
        removeTooltips() {
          u.blueDotTooltips.forEach(t.tooltips.removeTooltip), u.blueDotTooltips = [];
        },
        removeBlueDot() {
          e.cleanup();
        },
        centerBlueDot() {
          var e, i, r, o, s;
          if (!n.userPosition) return;
          let {
            latitude: a,
            longitude: h
          } = n.userPosition.coords;
          (null == (e = n.userMap) ? void 0 : e.id) !== t.currentMap && null != n.userMap && t.setMap(n.userMap);
          let c = n.userMap.createCoordinate(a, h),
            p = t.getPositionLatLon(a, h),
            d = null != t.currentPath && n.enableBlueDotOptions.useRotationMode,
            f = t.controls.zoomFactor || 1,
            m = (null == (r = null == (i = t.options.loadOptions) ? void 0 : i.zoomOverrides) ? void 0 : r.blueDotFollowingZoomFactor) || 2.5,
            g = f * m;
          if (0 === u.zoomCondition && null != (null == (s = null == (o = t.options.loadOptions) ? void 0 : o.zoomOverrides) ? void 0 : s.blueDotFollowingZoomFactor)) {
            u.zoomCondition = 1, p_ = !0;
            let e = t.convertTo3DMapPosition({
              x: c.x,
              y: c.y
            });
            t.focusOn({
              points: [e],
              changeZoom: !0,
              duration: 500,
              focusZoomFactor: g,
              callback: () => {
                u.zoomCondition = 2;
              }
            }), p_ = !1;
          } else if (1 !== this.zoomCondition && d) {
            let e = n.userMap;
            if (null == e) return;
            let i = t.currentPath,
              r = t.camera.rotation,
              o = {
                x: p.x + e.width / 2,
                y: -p.y + e.height / 2
              },
              s = null == i ? void 0 : i.filter(t => t.map.id === e.id);
            if (null == s ? void 0 : s.length) {
              let t,
                n = (0, QU.default)(s, e._scale),
                i = FU(n, o);
              t = (null == i ? void 0 : i.proportion) && i.proportion > .5 ? n[i.index || 1] : n[i.index || 0], r = BU(n, t) + Math.PI;
            }
            let a = t.canvasHeight > t.canvasWidth && t.canvasHeight > 600 && t.canvasWidth > 500,
              u = 900,
              h = UU(p, r, m * t.controls.getZoomScaledMin(), a);
            t.controls.animateCamera({
              ...h,
              duration: u
            }), l();
          } else 1 !== this.zoomCondition && (p_ = !0, t.camera.focusOn({
            coordinates: [c]
          }, {
            changeZoom: !1,
            duration: 1e3
          }), p_ = !1);
        },
        endFollowing() {
          u.isFollowing = !1, u.zoomCondition = 0;
        }
      }),
      h = null,
      c = !1;
    return t.on(Xe.USER_PAN_BEGIN, () => {
      !h && c && (h = setTimeout(() => {
        u.endFollowing(), clearTimeout(h), h = null;
      }, 60));
    }), t.on(Xe.FOCUSON_BEGIN, () => {
      p_ || u.endFollowing();
    }), t.on(Xe.USER_HANDS_ON, () => {
      c = !0;
    }), t.on(Xe.USER_HANDS_OFF, () => {
      h && (clearTimeout(h), h = null, c = !1);
    }), t.on(Xe.USER_ZOOM_BEGIN, () => {
      u.endFollowing();
    }), t.on("user-tilt-begin", () => {
      u.endFollowing();
    }), t.on(Xe.USER_ROTATE_BEGIN, () => {
      u.endFollowing();
    }), n.on("userDataChanged", t => {
      let {
        position: e,
        state: n
      } = t.newValue;
      switch (n) {
        case Kt.HAS_POSITION:
          u.removeTooltips(), u.addGhostMarkers(), s.trackBlueDotEvent(Ea.BLUEDOT_EVENT.FOUND_POSITION), u.setBlueDotPosition(), u.showBlueDotBearing();
          break;
        case Kt.HAS_INDOOR_POSITION:
          u.removeTooltips(), u.addBlueDotMarker(), s.trackBlueDotEvent(Ea.BLUEDOT_EVENT.FOUND_FLOOR), u.setBlueDotPosition(), u.showBlueDotBearing();
          break;
        case Kt.LOCATION_UNCERTAIN:
          u.removeTooltips(), u.addLocationUncertainMarkersAndTooltips(), u.setBlueDotPosition(), u.showBlueDotBearing();
          break;
        default:
          u.removeTooltips(), u.removeBlueDot();
      }
      let i = !0,
        r = !1;
      t.oldValue && (i = t.oldValue.position && t.newValue.position && (e.coords.latitude !== t.oldValue.position.coords.latitude || e.coords.longitude !== t.oldValue.position.coords.longitude), r = t.oldValue.map !== t.newValue.map), u.isFollowing && (i || r) && u.centerBlueDot();
    }), u;
  }, "BlueDotUI"),
  NA = ime;
E(), E();
var rme = u(function (t, e, n) {
    this.touch = t, this.camera = e, this.cameraPlane = n, this.viewCoordinate = {
      x: t.x,
      y: t.y
    }, this.camera.updateMatrixWorld(), this.camera.updateMatrix(), this.snapHolderMatrix = this.camera.matrixWorld.clone(), this.snapCamera = this.camera.clone(), this.snapshotCameraState = function () {
      this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.cameraPosition = this.camera.position;
      let t = new ne(this.viewCoordinate.x, this.viewCoordinate.y, 1);
      this.raycaster = this.raycaster || new nh(), this.raycaster.setFromCamera(t, this.snapCamera);
      let e = this.raycaster.intersectObject(this.cameraPlane, !1);
      this.worldCoordinate = e && e[0] && e[0].point, this.snapshotted = !0;
    }, this.updateAnchorState = function (t, e) {
      this.camera = t, this.snapCamera = t.clone(), this.snapHolderMatrix = t.matrixWorld.clone(), this.updateViewCoordinate(e), this.snapshotCameraState();
    }, this.updateViewCoordinate = function (t) {
      this.viewCoordinate = {
        x: t.x,
        y: t.y
      };
    }, this.reUnproject = function () {
      let t = new ne(this.viewCoordinate.x, this.viewCoordinate.y, 1);
      this.raycaster.setFromCamera(t, this.snapCamera);
      let e = this.raycaster.intersectObject(this.cameraPlane, !1)[0];
      if (e) return e.point;
    }, this.snapshotCameraState();
  }, "TouchAnchor"),
  h6 = rme;
function $U(t, e) {
  return Math.atan2(e.y - t.y, e.x - t.x);
}
function ez(t, e) {
  return Math.sqrt((e.y - t.y) ** 2 + (e.x - t.x) ** 2);
}
function tz(t, e) {
  return {
    x: (t.x + e.x) / 2,
    y: (t.y + e.y) / 2
  };
}
E(), u($U, "angle"), u(ez, "distance"), u(tz, "average");
var ome = u(function (t, e) {
    this.input1 = t, this.input2 = e, this.lastAngle = $U(t, e), this.lastDistance = ez(t, e), this.first = t, this.second = e, this.update = function (t, e) {
      let n = ez(t, e);
      this.input1 = t, this.input2 = e;
      let i = $U(t, e);
      this.lastAngle = i, this.lastDistance = n, this.first = tz(this.first, t), this.second = tz(this.second, e);
    };
  }, "InputSet"),
  nz = ome;
E();
var iz = Rt(il()),
  Pw = {
    SINGLE_FLOOR: "single_floor",
    MULTI_FLOOR: "multi_floor"
  },
  FGe = Math.PI / 2,
  BGe = iz.default.Easing.Quadratic.InOut;
function og(t, e, n) {
  null == e && (e = t.g, n = t.b, t = t.r);
  let i = 0,
    r = t;
  e > t && (i = 1, r = e), n > e && n > t && (i = 2, r = n);
  let o = t;
  e < t && (o = e), n < e && n < t && (o = n);
  let s = 0,
    a = 0,
    l = 0;
  return r !== o && (s = 0 === i ? 60 / 360 * (e - n) / (r - o) : 1 === i ? 60 / 360 * (2 + (n - t) / (r - o)) : 60 / 360 * (4 + (t - e) / (r - o)), a = 0 === r ? 0 : (r - o) / r), l = r, [s, a, l];
}
function Cc(t, e, n) {
  let i = 360 * t % 360 / 60,
    r = 0 | i,
    o = i - r,
    s = n * (1 - e),
    a = n * (1 - e * o),
    l = n * (1 - e * (1 - o)),
    u = 0,
    h = 0,
    c = 0;
  switch (r) {
    case 0:
      u = n, h = l, c = s;
      break;
    case 1:
      u = a, h = n, c = s;
      break;
    case 2:
      u = s, h = n, c = l;
      break;
    case 3:
      u = s, h = a, c = n;
      break;
    case 4:
      u = l, h = s, c = n;
      break;
    case 5:
      u = n, h = s, c = a;
  }
  return new yt(u, h, c);
}
E(), E(), u(og, "rgb2hsv"), u(Cc, "hsv2rgb");
var rz = 16,
  d_ = class {
    constructor({
      minimum: t,
      maximum: e,
      step: n,
      current: i,
      onValueChanged: r
    }) {
      this._minimum = t, this._maximum = e, this._step = n, this._onValueChanged = r, this._element = document.createElement("input"), this._element.type = "range", this._element.min = this._minimum, this._element.max = this._maximum, null != this._step && (this._element.step = this._step), this._element.value = null != i ? i : this._minimum, null != r && (this._element.addEventListener("input", t => {
        r(this._element.value);
      }), r(this._element.value)), Object.assign(this._element.style, {
        height: rz + "px"
      });
    }
    destroy() {
      this._element = null, Object.setPrototypeOf(this, null);
    }
    addValueChangedListener(t) {
      this._element.addEventListener("input", e => t(this._element.value));
    }
    setValue(t) {
      this._element.value = t;
    }
    get element() {
      return this._element;
    }
    get value() {
      return this._element.value;
    }
    get displayedValue() {
      return "" + this._element.value;
    }
    get height() {
      return rz;
    }
  };
u(d_, "DebugUIScalarSlider");
var f6 = 16,
  Cw = class {
    constructor({
      current: t,
      onValueChanged: e
    }) {
      this._onValueChanged = e, this._element = document.createElement("div"), this._titleElement = document.createElement("input"), this._titleElement.type = "checkbox", this._titleElement.checked = t || !1, Object.assign(this._titleElement.style, {
        width: f6 + "px",
        height: f6 + "px",
        margin: "0px"
      }), null != e && (this._titleElement.addEventListener("click", t => {
        e(this._titleElement.checked);
      }), e(this._titleElement.checked));
    }
    destroy() {
      this._element = null, this._titleElement = null, Object.setPrototypeOf(this, null);
    }
    addValueChangedListener(t) {
      this._titleElement.addEventListener("click", e => t(this._titleElement.checked));
    }
    get element() {
      return this._element;
    }
    get titleElement() {
      return this._titleElement;
    }
    get value() {
      return this._titleElement.checked;
    }
    get displayedValue() {
      return this._titleElement.checked ? "true" : "false";
    }
    get height() {
      return 0;
    }
    get titleElementWidth() {
      return f6;
    }
  };
u(Cw, "DebugUICheckbox");
var p6 = 12,
  Aw = 2,
  sg = 64,
  Iw = 16,
  d6 = 24,
  oz = 48,
  m_ = class {
    constructor({
      current: t,
      onValueChanged: e
    }) {
      this._onValueChanged = e, this._element = document.createElement("div"), this._titleElement = document.createElement("div"), this._color = t || new yt(), this._listeners = [], Object.assign(this._element.style, {
        width: "100%",
        height: this.height + "px"
      }), Object.assign(this._titleElement.style, {
        width: p6 - 2 + "px",
        height: p6 - 2 + "px",
        "border-radius": "2px"
      }), this._colorPickerMain = document.createElement("canvas"), this._colorPickerMain.height = sg - 2, Object.assign(this._colorPickerMain.style, {
        position: "absolute",
        left: "0px",
        right: "0px",
        top: "0px",
        height: sg - 2 + "px"
      }), this._element.appendChild(this._colorPickerMain), this._colorPickerBottomSlider = document.createElement("canvas"), this._colorPickerBottomSlider.height = Iw - 2, Object.assign(this._colorPickerBottomSlider.style, {
        position: "absolute",
        left: "0px",
        right: "0px",
        top: sg + Aw + "px",
        height: Iw - 2 + "px"
      }), this._element.appendChild(this._colorPickerBottomSlider), this._requestAnimationFrameHandle = null, this._requestAnimationFrameUpdate = this._requestAnimationFrameUpdate.bind(this), this._pickingMain = !1, this._pickingX = 0, this._pickingY = 0, this._colorPickerMain.addEventListener("pointerdown", t => {
        this._pickingMain = !0, this._updateMain(t.offsetX, t.offsetY), this._notify(), this._moveListener = t => {
          let e = t.clientX - this._colorPickerMain.getBoundingClientRect().x,
            n = t.clientY - this._colorPickerMain.getBoundingClientRect().y;
          this._pickingX = Math.min(Math.max(e, 0), this._colorPickerMain.clientWidth), this._pickingY = Math.min(Math.max(n, 0), this._colorPickerMain.clientHeight), this._requestAnimationFrame();
        }, document.body.addEventListener("pointermove", this._moveListener), this._upListener = t => {
          this._pickingMain = !1, this.redraw(), document.body.removeEventListener("pointermove", this._moveListener), document.body.removeEventListener("pointerup", this._upListener), delete this._moveListener, delete this._upListener;
        }, document.body.addEventListener("pointerup", this._upListener);
      }), this._pickingBottomSlider = !1, this._colorPickerBottomSlider.addEventListener("pointerdown", t => {
        this._pickingBottomSlider = !0, this._updateBottomSlider(t.offsetX), this._notify(), this._bottomMoveListener = t => {
          let e = t.clientX - this._colorPickerBottomSlider.getBoundingClientRect().x;
          this._pickingX = Math.min(Math.max(e, 0), this._colorPickerMain.clientWidth), this._requestAnimationFrame();
        }, document.body.addEventListener("pointermove", this._bottomMoveListener), this._bottomUpListener = t => {
          this._pickingBottomSlider = !1, this.redraw(), document.body.removeEventListener("pointermove", this._bottomMoveListener), document.body.removeEventListener("pointerup", this._bottomUpListener), delete this._bottomMoveListener, delete this._bottomUpListener;
        }, document.body.addEventListener("pointerup", this._bottomUpListener);
      });
      let n = 0,
        i = u((t, e) => {
          let i = document.createElement("button");
          return Object.assign(i.style, {
            position: "absolute",
            top: this.height - d6 + "px",
            left: n + "px",
            height: d6 + "px",
            width: oz + "px",
            color: "grey"
          }), i.innerHTML = e, n += oz + Aw, i.addEventListener("click", () => {
            this._modeButtons[this._mode].style.color = "grey", this._mode = t, i.style.color = "black", this.redraw();
          }), this._element.appendChild(i), i;
        }, "createModeButton");
      this._modeButtons = {}, this._modeButtons.hsv = i("hsv", "HSV"), this._modeButtons.svh = i("svh", "SVH"), this._modeButtons.rgb = i("rgb", "RGB"), this._mode = "hsv", this._modeButtons.hsv.style.color = "black", this._requestAnimationFrame(), this._notify();
    }
    destroy() {
      document.body.removeEventListener("pointermove", this._moveListener), document.body.removeEventListener("pointerup", this._upListener), document.body.removeEventListener("pointermove", this._bottomMoveListener), document.body.removeEventListener("pointerup", this._bottomUpListener), this._element = null, this._titleElement = null, this._destroyed = !0, Object.setPrototypeOf(this, null);
    }
    addValueChangedListener(t) {
      this._listeners.push(t);
    }
    setValue(t) {
      this._color.copy(t), this.redraw(), this._notify();
    }
    _requestAnimationFrame() {
      null == this._requestAnimationFrameHandle && !this._destroyed && (this._requestAnimationFrameHandle = requestAnimationFrame(this._requestAnimationFrameUpdate));
    }
    _requestAnimationFrameUpdate() {
      this._pickingMain && (this._updateMain(this._pickingX, this._pickingY), this._notify()), this._pickingBottomSlider && (this._updateBottomSlider(this._pickingX), this._notify()), this._requestAnimationFrameHandle = null;
    }
    _notify() {
      null != this._onValueChanged && this._onValueChanged(this._color);
      for (let t of this._listeners) t(this._color);
    }
    _updateMain(t, e) {
      let n = this._colorPickerMain.clientWidth,
        i = sg;
      this._pickingX = Math.min(Math.max(t, 1), n - 1) - 1, this._pickingY = Math.min(Math.max(e, 1), i - 1) - 1;
      let r = this._pickingX / (n - 1),
        o = this._pickingY / (i - 1);
      if ("hsv" === this._mode) {
        let [,, t] = og(this._color);
        this._color.set(Cc(r, o, t));
      } else if ("svh" === this._mode) {
        let [t,,] = og(this._color);
        this._color.set(Cc(t, r, 1 - o));
      } else this._color.r = r, this._color.g = o;
      this.redraw();
    }
    _updateBottomSlider(t) {
      let e = this._colorPickerBottomSlider.clientWidth;
      this._pickingX = Math.min(Math.max(t, 1), e - 1) - 1;
      let n = this._pickingX / (e - 1);
      if ("hsv" === this._mode) {
        let [t, e] = og(this._color);
        this._color.set(Cc(t, e, n));
      } else if ("svh" === this._mode) {
        let [, t, e] = og(this._color);
        this._color.set(Cc(n, t, e));
      } else this._color.b = n;
      this.redraw();
    }
    redraw() {
      let t = this._element.clientWidth - 2,
        e = sg - 2,
        n = Iw - 2;
      this._colorPickerMain.width !== t && (this._colorPickerMain.width = t);
      let [i, r, o] = og(this._color),
        s = this._colorPickerMain.getContext("2d");
      for (let n = 0; n < e; ++n) for (let r = 0; r < t; ++r) {
        if ("hsv" === this._mode) {
          let i = r / (t - 1),
            a = n / (e - 1),
            l = o,
            {
              r: u,
              g: h,
              b: c
            } = Cc(i, a, l);
          s.fillStyle = `rgb(${255 * u},${255 * h},${255 * c})`;
        } else if ("svh" === this._mode) {
          let o = r / (t - 1),
            a = 1 - n / (e - 1),
            l = i,
            {
              r: u,
              g: h,
              b: c
            } = Cc(l, o, a);
          s.fillStyle = `rgb(${255 * u},${255 * h},${255 * c})`;
        } else {
          let i = r / t * 255,
            o = n / e * 255,
            a = 255 * this._color.b;
          s.fillStyle = `rgb(${i},${o},${a})`;
        }
        s.fillRect(r, n, 1, 1);
      }
      this._pickingMain && (s.fillStyle = "rgba(0,0,0,0.5)", s.fillRect(0, this._pickingY, t, 1), s.fillRect(this._pickingX, 0, 1, e)), this._colorPickerBottomSlider.width !== t && (this._colorPickerBottomSlider.width = t);
      let a = this._colorPickerBottomSlider.getContext("2d");
      for (let e = 0; e < t; ++e) {
        if ("hsv" === this._mode) {
          let n = i,
            o = r,
            s = e / (t - 1),
            {
              r: l,
              g: u,
              b: h
            } = Cc(n, o, s);
          a.fillStyle = `rgb(${255 * l},${255 * u},${255 * h})`;
        } else if ("svh" === this._mode) {
          let n = r,
            i = o,
            s = e / (t - 1),
            {
              r: l,
              g: u,
              b: h
            } = Cc(s, n, i);
          a.fillStyle = `rgb(${255 * l},${255 * u},${255 * h})`;
        } else {
          let n = 255 * this._color.r,
            i = 255 * this._color.g,
            r = e / (t - 2) * 255;
          a.fillStyle = `rgb(${n},${i},${r})`;
        }
        a.fillRect(e, 0, 1, n);
      }
      this._pickingBottomSlider && (a.fillStyle = "rgba(0,0,0,0.5)", a.fillRect(this._pickingX, 0, 1, n));
      let l = 255 * this._color.r,
        u = 255 * this._color.g,
        h = 255 * this._color.b,
        c = `1px solid rgb(${.9 * l},${.9 * u},${.9 * h})`;
      Object.assign(this._colorPickerMain.style, {
        border: c
      }), Object.assign(this._colorPickerBottomSlider.style, {
        border: c
      }), Object.assign(this._titleElement.style, {
        "background-color": `rgb(${l},${u},${h})`,
        border: c
      });
    }
    get element() {
      return this._element;
    }
    get titleElement() {
      return this._titleElement;
    }
    get value() {
      return this._color;
    }
    get displayedValue() {
      return "#" + this._color.getHexString().toUpperCase();
    }
    get height() {
      return sg + Aw + Iw + Aw + d6;
    }
    get titleElementWidth() {
      return p6;
    }
  };
u(m_, "DebugUIColorPicker");
var Lw = 16,
  sz = 12,
  ame = 4,
  az = 10,
  lz = 12,
  Ow = class {
    constructor({
      name: t
    }) {
      this._name = t, this._element = document.createElement("div"), this._entries = [], this._height = lz;
    }
    destroy() {
      for (let t of this._entries) t.destroy();
      this._entries = null, this._element = null, Object.setPrototypeOf(this, null);
    }
    get element() {
      return this._element;
    }
    get height() {
      return this._height;
    }
    addControl(t, e, n) {
      if (-1 !== this._entries.findIndex(e => e.name === t)) return;
      let i = new m6({
        name: t,
        description: e,
        control: n
      });
      this._entries.push(i), this._element.appendChild(i.element), null != n.redraw && n.redraw();
    }
    removeControl(t) {
      let e = this._entries.findIndex(e => e.name === t);
      if (-1 !== e) {
        let [t] = this._entries.splice(e, 1);
        this._element.removeChild(t.element), t.destroy();
      }
    }
    _updateLayout() {
      this._height = 0;
      for (let t of this._entries) t.element.style.top = this._height + "px", this._height += t.height + lz;
      Object.assign(this._element.style, {
        height: this._height + "px"
      });
    }
  };
u(Ow, "DebugUIPanel");
var m6 = class {
  constructor({
    name: t,
    description: e,
    control: n
  }) {
    this._name = t, this._description = e, this._control = n, this._element = document.createElement("div"), this._element.title = e, Object.assign(this._element.style, {
      position: "absolute",
      left: "0px",
      right: "0px"
    }), this._element.appendChild(this._control.element), Object.assign(this._control.element.style, {
      position: "absolute",
      left: "0px",
      width: "100%",
      top: Lw + "px",
      "font-size": az + "px"
    });
    let i = 0;
    null != this._control.titleElement && (this._element.appendChild(this._control.titleElement), Object.assign(this._control.titleElement.style, {
      position: "absolute",
      left: "0px",
      top: "0px",
      "font-size": az + "px"
    }), i = this._control.titleElementWidth + ame), this._control.addValueChangedListener(t => {
      this._displayedValueElement.innerHTML = uz(this._control.displayedValue);
    }), this._nameElement = document.createElement("span"), this._nameElement.innerHTML = t, Object.assign(this._nameElement.style, {
      position: "absolute",
      left: i + "px",
      right: "0px",
      height: Lw + "px",
      color: "#666666",
      "font-size": sz + "px",
      "text-align": "left",
      "vertical-align": "middle"
    }), this._element.appendChild(this._nameElement), this._displayedValueElement = document.createElement("span"), this._displayedValueElement.innerHTML = uz(this._control.displayedValue), Object.assign(this._displayedValueElement.style, {
      position: "absolute",
      left: i + "px",
      right: "0px",
      height: Lw + "px",
      "font-size": sz + "px",
      "text-align": "right",
      "vertical-align": "middle"
    }), this._element.appendChild(this._displayedValueElement);
  }
  destroy() {
    this._element = null, this._nameElement = null, this._displayedValueElement = null, this._control.destroy(), Object.setPrototypeOf(this, null);
  }
  get name() {
    return this._name;
  }
  get element() {
    return this._element;
  }
  get value() {
    return this._control.value;
  }
  get height() {
    return this._control.height + Lw;
  }
};
function uz(t) {
  return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
u(m6, "DebugUIEntry"), u(uz, "escapeHTML");
var g_ = Rt(il()),
  g6 = 1e4,
  cz = {
    chain: "chain",
    cancel: "cancel"
  },
  lme = new Al(),
  ume = u(function (t, e, n, i) {
    this.dispatcher = lme, this.camera = t, this.canvas = e, this.elevation = t.parent, this.orbit = this.elevation.parent;
    let r,
      o = 2 * Math.PI,
      s = 100;
    this.zoomSpeed = 5, this.rotateSpeed = 100, this.enabled = !0, this.enableZoom = !0, this.enablePan = !0, this.enablePedestal = !1, this.maxPedestal = 1 / 0, this.minPedestal = -1 / 0, this.enableRotate = !0, this.minZoom = 375, this.maxZoom = 1e4, this.initialMinZoom = 375, this.initialMaxZoom = 1e4, this.ignoreZoomLimits = !1, this.minExpandedZoom = 375, this.maxExpandedZoom = 1e5, this.zoomFactor = 1, this.panBounds = {
      margin: 1.25,
      min: {
        x: 1 / 0,
        y: 1 / 0
      },
      max: {
        x: -1 / 0,
        y: -1 / 0
      },
      center: {
        x: 0,
        y: 0
      },
      radius: 200
    }, this.minTilt = 0, this.maxTilt = 1.2, this.mouseButtons = {
      ORBIT: X_.RIGHT,
      ZOOM: X_.MIDDLE,
      PAN: X_.LEFT
    };
    let a = this,
      l = new co(1e6, 1e6),
      h = new Sr({
        color: 0,
        visible: !1
      }),
      c = new Ft(l, h);
    i.on(Xe.SET_SCENE, () => {
      var t;
      let e = null == (t = i.mapObjects.get(i.currentMap)) ? void 0 : t.object;
      if (null != e) {
        let t = new ne();
        t.applyMatrix4(e.matrix), c.position.z = t.z;
      }
      i.tryRendering();
    });
    let p = new nh();
    n.add(c);
    let d,
      f = -1,
      m = 0,
      g = 1,
      v = 2,
      y = 3,
      _ = 4,
      x = 5,
      E = 6,
      b = 7,
      w = 8,
      S = 9,
      M = f,
      T = new je(),
      A = [],
      P = {
        offsetLeft: 0,
        offsetTop: 0
      },
      C = new je(),
      I = new je(),
      N = new je(),
      L = new je(),
      R = new je(),
      O = new je(),
      q = new ne(),
      k = new ne(),
      F = new je(),
      U = new je(),
      B = new je(),
      z = !1,
      V = new wd(!0),
      j = 0,
      G = !0;
    this.CAMERA_EVENTS = {}, this.CAMERA_EVENTS.CHANGE_EVENT = {
      type: "change"
    }, this.CAMERA_EVENTS.PAN_START_EVENT = {
      type: "panStart"
    }, this.CAMERA_EVENTS.PAN_END_EVENT = {
      type: "panEnd"
    }, this.CAMERA_EVENTS.PEDESTAL_START_EVENT = {
      type: "pedestalStart"
    }, this.CAMERA_EVENTS.PEDESTAL_CHANGE_EVENT = {
      type: "pedestalChange"
    }, this.CAMERA_EVENTS.PEDESTAL_END_EVENT = {
      type: "pedestalEnd"
    }, this.CAMERA_EVENTS.ROTATE_START_EVENT = {
      type: "rotateStart"
    }, this.CAMERA_EVENTS.ROTATE_END_EVENT = {
      type: "rotateEnd"
    }, this.CAMERA_EVENTS.ZOOM_START_EVENT = {
      type: "zoomStart"
    }, this.CAMERA_EVENTS.ZOOM_END_EVENT = {
      type: "zoomEnd"
    }, this.CAMERA_EVENTS.MULTI_START_EVENT = {
      type: "multiStart"
    }, this.CAMERA_EVENTS.MULTI_END_EVENT = {
      type: "multiEnd"
    }, this.CAMERA_EVENTS.MULTI_CANCEL_EVENT = {
      type: "multiCancel"
    }, this.INTERACTION_EVENTS = {}, this.INTERACTION_EVENTS.USER_PAN_START_EVENT = {
      type: "userPanStart"
    }, this.INTERACTION_EVENTS.USER_PEDESTAL_START_EVENT = {
      type: "userPedestalStart"
    }, this.INTERACTION_EVENTS.USER_ROTATE_START_EVENT = {
      type: "userRotateStart"
    }, this.INTERACTION_EVENTS.USER_DOLLY_START_EVENT = {
      type: "userDollyStart"
    }, this.INTERACTION_EVENTS.USER_ZOOM_START_EVENT = {
      type: "userZoomStart"
    }, this.INTERACTION_EVENTS.USER_TILT_START_EVENT = {
      type: "userTiltStart"
    }, this.INTERACTION_EVENTS.USER_PAN_END_EVENT = {
      type: "userPanEnd"
    }, this.INTERACTION_EVENTS.USER_PEDESTAL_END_EVENT = {
      type: "userPedestalEnd"
    }, this.INTERACTION_EVENTS.USER_ROTATE_END_EVENT = {
      type: "userRotateEnd"
    }, this.INTERACTION_EVENTS.USER_DOLLY_END_EVENT = {
      type: "userDollyEnd"
    }, this.INTERACTION_EVENTS.USER_ZOOM_END_EVENT = {
      type: "userZoomEnd"
    }, this.INTERACTION_EVENTS.USER_TILT_END_EVENT = {
      type: "userTiltEnd"
    }, this.UPDATE_EVENTS = {}, this.UPDATE_EVENTS.POSITION_UPDATED_EVENT = {
      type: "positionUpdated"
    }, this.UPDATE_EVENTS.ZOOM_UPDATED_EVENT = {
      type: "zoomUpdated"
    }, this.UPDATE_EVENTS.TILT_UPDATED_EVENT = {
      type: "tiltUpdated"
    }, this.UPDATE_EVENTS.ROTATION_UPDATED_EVENT = {
      type: "rotationUpdated"
    };
    let W = !1,
      H = u(() => {
        W = !0;
      }, "setUserInteracting"),
      X = u(() => {
        W = !1;
      }, "unsetUserInteracting");
    for (let t in this.INTERACTION_EVENTS) {
      let e = this.INTERACTION_EVENTS[t];
      e.type.endsWith("Start") && a.dispatcher.addEventListener(e.type, H);
    }
    for (let t in this.INTERACTION_EVENTS) {
      let e = this.INTERACTION_EVENTS[t];
      e.type.endsWith("End") && a.dispatcher.addEventListener(e.type, X);
    }
    let Y = u(t => {
      a.dispatcher.dispatchEvent({
        ...a.CAMERA_EVENTS.PEDESTAL_CHANGE_EVENT,
        pedestal: t,
        scrolledToTop: a.scrolledToTop,
        scrolledToBottom: a.scrolledToBottom,
        scrollPercent: a.scrollPercent
      });
    }, "dispatchPedestalChangeEvent");
    function Z(t, e = !1) {
      "number" == typeof t && !isNaN(t) && (a.orbit.position.z = t, e && Y(t), i.tryRendering());
    }
    this.addDebugControls = function (t) {
      t.addDebugControls({
        CameraControls: [{
          name: "Stay Inside Bounds",
          description: "Ensure the camera stays inside its bounds.\n\nCaution: going too far outside-of-bounds may slow renderingsignificantly.",
          control: new Cw({
            current: !0,
            onValueChanged: t => {
              G = t;
            }
          })
        }]
      });
    }, this.removeDebugControls = function (t) {
      t.removeDebugControls({
        CameraControls: ["Stay Inside Bounds"]
      });
    }, this.pan = function (t, e) {
      isNaN(t) || isNaN(e) || (a.setPosition(a.orbit.position.x + t, a.orbit.position.y + e), a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.POSITION_UPDATED_EVENT));
    }, this.setPosition = function (t, e) {
      if (isNaN(t) || isNaN(e)) return;
      M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.PAN_START_EVENT);
      let n = t - a.panBounds.center.x,
        i = e - a.panBounds.center.y,
        r = Math.sqrt(n * n + i * i);
      if (G && r > a.panBounds.radius) {
        let t = Math.atan2(i, n),
          e = {
            x: Math.cos(t) * a.panBounds.radius + a.panBounds.center.x,
            y: Math.sin(t) * a.panBounds.radius + a.panBounds.center.y
          };
        a.orbit.position.x = e.x, a.orbit.position.y = e.y;
      } else a.orbit.position.x = t, a.orbit.position.y = e;
      a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.POSITION_UPDATED_EVENT), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT), M == f && a.dispatcher.dispatchEvent(a.this.CAMERA_EVENTS.PAN_END_EVENT);
    }, this.setRotation = function (t, e) {
      if (isNaN(t)) return;
      M == f && !e && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_START_EVENT);
      let n = t % o;
      n !== a.orbit.rotation.z && (a.orbit.rotation.z = n, e || a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.ROTATION_UPDATED_EVENT)), e || a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT), M == f && !e && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_END_EVENT);
    }, this.rotate = function (t) {
      if (isNaN(t)) return;
      M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_START_EVENT);
      let e = (a.orbit.rotation.z + t) % o;
      e !== a.orbit.rotation.z && (a.orbit.rotation.z = e, a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.ROTATION_UPDATED_EVENT)), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT), M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_END_EVENT);
    }, this.setTilt = function (t, e) {
      if (isNaN(t)) return;
      M == f && !e && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_START_EVENT);
      let n = G ? Math.max(Math.min(t, a.maxTilt), a.minTilt) : t;
      n !== a.elevation.rotation.x && (a.elevation.rotation.x = n, e || a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.TILT_UPDATED_EVENT)), e || a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT), M == f && !e && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_END_EVENT);
    }, this.tilt = function (t) {
      if (isNaN(t)) return;
      M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_START_EVENT);
      let e = G ? Math.max(Math.min(t + a.getTilt(), a.maxTilt), a.minTilt) : t + a.getTilt();
      e !== a.elevation.rotation.x && (a.elevation.rotation.x = e, a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.TILT_UPDATED_EVENT)), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT), M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_END_EVENT);
    }, this.setZoom = function (t) {
      if (isNaN(t)) return;
      M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_START_EVENT);
      let e = G ? Math.min(Math.max(t, a.getZoomScaledMin()), a.getZoomScaledMax()) : t;
      e !== a.camera.position.z && (a.camera.position.z = e, a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.ZOOM_UPDATED_EVENT)), a.camera.near = e / s, a.camera.far = e * s, a.camera.updateProjectionMatrix(), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT), M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_END_EVENT);
    }, this.zoom = function (t) {
      if (isNaN(t)) return;
      M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_START_EVENT);
      let e = a.getZoom() - t;
      a.camera.position.z = G ? Math.min(Math.max(e, a.minZoom * a.zoomFactor), a.maxZoom * a.zoomFactor) : e, a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.ZOOM_UPDATED_EVENT), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT), M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_END_EVENT);
    }, this.zoomIn = function (t, e, n) {
      let i = this.getZoom();
      this.animateCamera({
        zoom: i / 1.5
      }, t, e, n);
    }, this.zoomOut = function (t, e, n) {
      let i = this.getZoom();
      this.animateCamera({
        zoom: 1.5 * i
      }, t, e, n);
    }, this.expandZoomLimits = function (t, e) {
      e || (e = 1.2), t * e > a.maxZoom && (a.maxZoom = Math.min(t * e, a.maxExpandedZoom)), t / e < a.minZoom && (a.minZoom = Math.max(t / e, a.minExpandedZoom));
    }, this.restrictZoomLimits = function (t, e) {
      e || (e = 1.2), t * e > a.initialMaxZoom && t * e < a.maxZoom && (a.maxZoom = Math.max(a.getZoom(), t * e)), t / e < a.initialMinZoom && t / e > a.minZoom && (a.minZoom = Math.min(a.getZoom(), t / e));
    }, this.getPosition = function () {
      return {
        x: a.orbit.position.x,
        y: a.orbit.position.y,
        z: a.orbit.position.z
      };
    }, this.getPedestal = function () {
      return a.orbit.position.z;
    }, u(Z, "setPedestal"), Object.defineProperty(this, "setPedestal", {
      enumerable: !1,
      value: Z
    }), Object.defineProperty(this, "scrollPercent", {
      get() {
        let t = this.minPedestal,
          e = this.maxPedestal,
          n = this.getPedestal();
        return n = Math.min(n, e), n = Math.max(n, t), (n - t) / (e - t) * 100;
      }
    }), Object.defineProperty(this, "scrolledToTop", {
      get() {
        return 0 === this.maxPedestal || Math.ceil(this.getPedestal()) >= this.maxPedestal;
      }
    }), Object.defineProperty(this, "scrolledToBottom", {
      get() {
        return 0 === this.minPedestal || Math.floor(this.getPedestal()) <= this.minPedestal;
      }
    }), this.getRotation = function () {
      return a.orbit.rotation.z;
    }, this.getTilt = function () {
      return a.elevation.rotation.x;
    }, this.getZoom = function () {
      return a.camera.position.z;
    }, this.isCameraMoving = function () {
      return M != f;
    }, this.isUserInteracting = function () {
      return W;
    }, this.getZoomScaledMin = function () {
      return a.minZoom * a.zoomFactor;
    }, this.getZoomScaledMax = function () {
      let t = a.minZoom * a.zoomFactor;
      return Math.max(a.maxZoom, 1.5 * t);
    };
    let J = u(function () {
        return g_.default.getAll().some(function (t) {
          return t._mMapAnimation;
        });
      }, "isAnimating"),
      K = new Set();
    function Q(t) {
      t.isPlaying ? t.stop() : t.end(), K.delete(t);
    }
    function $(t) {
      C.set(t.clientX, t.clientY), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_START_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_ROTATE_START_EVENT);
    }
    function tt(t) {
      F.set(t.clientX, t.clientY), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_START_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_DOLLY_START_EVENT);
    }
    function et() {
      let t = Ot(T);
      L.set(t.x, t.y), R.set(a.orbit.position.x, a.orbit.position.y), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.PAN_START_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_PAN_START_EVENT);
    }
    function nt(t) {
      let e = {
        x: t.clientX,
        y: t.clientY
      };
      a.initialShiftPos = e, a.initialPedestal = a.getPedestal(), a.pedestalScaleFactor = nT(a.camera.fov, a.canvas.clientHeight, a.getZoom()), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.PEDESTAL_START_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_PEDESTAL_START_EVENT);
    }
    function it(t) {
      t.clientX;
      let e = t.clientY,
        n = a.initialPedestal + a.pedestalScaleFactor * (e - a.initialShiftPos.y);
      G && (n < a.minPedestal ? n = Math.max(n, a.minPedestal) : n > a.maxPedestal && (n = Math.min(n, a.maxPedestal))), n !== a.getPedestal() && Y(n);
    }
    function rt(t) {
      I.set(t.clientX, t.clientY), N.subVectors(I, C), a.rotate(-N.x / a.rotateSpeed), a.setTilt(a.getTilt() - N.y / a.rotateSpeed), C.copy(I), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT);
    }
    function ot(t) {
      U.set(t.clientX, t.clientY), B.subVectors(U, F), a.setZoom(B.y * a.zoomSpeed), F.copy(U), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT);
    }
    function st() {
      let t = Ot(T);
      O.set(t.x, t.y), q.subVectors(O, L), a.setPosition(R.x - q.x, R.y - q.y), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT);
    }
    function at(t) {
      let e = 0;
      return void 0 !== t.wheelDelta ? e = t.wheelDelta : void 0 !== t.detail && (e = -t.detail), e;
    }
    function lt(t) {
      let e = at(t),
        n = a.getZoom();
      return !(e < 0 && n == a.getZoomScaledMax() || e > 0 && n == a.getZoomScaledMin());
    }
    function ut(t) {
      if (a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_START_EVENT), !lt(t)) return j > 0 && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_END_EVENT), j = 0, void (M = f);
      let e = a.getZoom(),
        n = e - at(t) * e / 1e4 * a.zoomSpeed;
      a.setZoom(n);
      let i = n / d;
      q.subVectors(k, R).multiplyScalar(1 - i), a.setPosition(R.x + q.x, R.y + q.y), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT);
    }
    function ht(t) {
      if (!1 !== a.enabled) {
        if (qt(t), t.preventDefault(), M == y && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_END_EVENT), t.button === a.mouseButtons.ORBIT) {
          if (!1 === a.enableRotate) return;
          $(t), M = m;
        } else if (t.button === a.mouseButtons.ZOOM) {
          if (!1 === a.enableZoom) return;
          tt(t), M = g;
        } else t.button === a.mouseButtons.PAN && (a.enablePan ? (et(), M = v) : a.enablePedestal && (nt(t), M = w));
        M !== f && (a.canvas.addEventListener("mousemove", ct, !1), window.addEventListener("mouseup", pt, !1), window.addEventListener("mouseout", pt, !1));
      }
    }
    function ct(t) {
      if (!1 !== a.enabled) if (t.preventDefault(), qt(t), M === m) {
        if (!1 === a.enableRotate) return;
        rt(t);
      } else if (M === g) {
        if (!1 === a.enableZoom) return;
        ot(t);
      } else if (M === v) {
        if (!1 === a.enablePan) return;
        st();
      } else M === y ? (z = !0, M = f) : M === w && it(t);
    }
    function pt() {
      if (!1 !== a.enabled) {
        switch (document.removeEventListener("mousemove", ct, !1), window.removeEventListener("mouseup", pt, !1), window.removeEventListener("mouseout", pt, !1), M) {
          case v:
            a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.PAN_END_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_PAN_END_EVENT);
            break;
          case g:
            a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_END_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_DOLLY_END_EVENT);
            break;
          case m:
            a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_END_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_ROTATE_END_EVENT);
            break;
          case w:
            a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.PEDESTAL_END_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_PEDESTAL_END_EVENT);
        }
        M = f;
      }
    }
    u(Q, "completeTween"), this.cancelAnimation = function () {
      let t = Array.from(K),
        e = t[t.length - 1];
      e.state === b && a.dispatcher.dispatchEvent({
        type: a.CAMERA_EVENTS.MULTI_CANCEL_EVENT.type,
        message: {
          zooming: !0,
          rotating: !0,
          tilting: !0
        }
      }), Q(e);
    }, this.animateCamera = function (t, e, n, r, o, s) {
      let l = {
          mode: cz.cancel,
          ...s
        },
        u = {},
        h = {},
        c = a.getPosition();
      if (null != t.position && (void 0 !== t.position.x && (u.x = c.x, h.x = t.position.x), void 0 !== t.position.y && (u.y = c.y, h.y = t.position.y), void 0 !== t.position.z && (u.z = c.z, h.z = t.position.z)), void 0 !== t.zoom && (u.zoom = G ? Math.min(Math.max(a.getZoom(), a.getZoomScaledMin()), a.getZoomScaledMax()) : a.getZoom(), a.viewState !== Pw.MULTI_FLOOR && G ? h.zoom = Math.min(Math.max(t.zoom, a.getZoomScaledMin()), a.getZoomScaledMax()) : h.zoom = t.zoom), void 0 !== t.rotation) {
        u.rotation = a.getRotation();
        let e = t.rotation % (2 * Math.PI);
        Math.abs(e - u.rotation) > Math.PI ? h.rotation = e < 0 ? 2 * Math.PI + e : -(2 * Math.PI - e) : h.rotation = e;
      }
      void 0 !== t.tilt && (u.tilt = a.getTilt(), a.viewState !== Pw.MULTI_FLOOR && G ? h.tilt = Math.max(Math.min(t.tilt, a.maxTilt), a.minTilt) : h.tilt = t.tilt);
      let p = u.zoom !== h.zoom,
        d = u.rotation !== h.rotation,
        f = u.tilt !== h.tilt;
      var m = new g_.default.Tween(u).to(h, D.env.TESTING ? 0 : e).onUpdate(function (t) {
        a.setMulti({
          x: t.x,
          y: t.y,
          z: t.z
        }, t.zoom, t.rotation, t.tilt);
      }).onComplete(function () {
        r && r(), Q(m), a.dispatcher.dispatchEvent({
          type: a.CAMERA_EVENTS.MULTI_END_EVENT.type,
          message: {
            zooming: p,
            rotating: d,
            tilting: f
          }
        });
      }).onStart(function () {
        M != b && (M = b, m.state = b, a.dispatcher.dispatchEvent({
          type: a.CAMERA_EVENTS.MULTI_START_EVENT.type,
          message: {
            zooming: p,
            rotating: d,
            tilting: f
          }
        })), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT);
      });
      let g = Array.from(K),
        v = g[g.length - 1],
        y = !1;
      return null != v && (l.mode === cz.chain ? (y = !0, v.chain(m)) : (Q(v), "function" == typeof o && o(), v = null)), K.add(m), n ? m.easing(n) : m.easing(g_.default.Easing.Quadratic.In), !t.doNotAutoStart && !y && (m.start(), i.tryRendering()), m._mMapAnimation = !0, m;
    }, this.setMulti = function (t, e, n, i) {
      M == f && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.MULTI_START_EVENT);
      let r = !1;
      null != t && (void 0 !== t.x && !isNaN(t.x) && (a.orbit.position.x = t.x, r = !0), void 0 !== t.y && !isNaN(t.y) && (a.orbit.position.y = t.y, r = !0), void 0 !== t.z && !isNaN(t.z) && this.setPedestal(t.z)), r && a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.POSITION_UPDATED_EVENT);
      let o = {
        zooming: !1,
        tilting: e,
        rotating: !1
      };
      if (void 0 !== e && !isNaN(e)) {
        let t = G ? Math.min(Math.max(e, a.getZoomScaledMin()), a.getZoomScaledMax()) : e;
        t !== a.camera.position.z && (o.zooming = !0, a.camera.position.z = t, a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.ZOOM_UPDATED_EVENT), a.viewState === Pw.MULTI_FLOOR ? e > g6 && (a.camera.near = e - g6, a.camera.far = e + g6) : (a.camera.near = e / s, a.camera.far = e * s), a.camera.updateProjectionMatrix());
      }
      if (void 0 !== n && !isNaN(n) && n !== a.orbit.rotation.z && (o.rotating = !0, a.orbit.rotation.z = n, a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.ROTATION_UPDATED_EVENT)), void 0 !== i && !isNaN(i)) {
        let t = G ? Math.max(Math.min(i, a.maxTilt), a.minTilt) : i;
        t !== a.elevation.rotation.x && (o.tilting = !0, a.elevation.rotation.x = t, a.dispatcher.dispatchEvent(a.UPDATE_EVENTS.TILT_UPDATED_EVENT));
      }
      a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT), M == f && a.dispatcher.dispatchEvent({
        type: a.CAMERA_EVENTS.MULTI_END_EVENT.type,
        message: o
      });
    }, u($, "handleMouseDownRotate"), u(tt, "handleMouseDownDolly"), u(et, "handleMouseDownPan"), u(nt, "handleMouseDownPedestal"), u(it, "handleMouseMovePedestal"), u(rt, "handleMouseMoveRotate"), u(ot, "handleMouseMoveDolly"), u(st, "handleMouseMovePan"), this.getProjectionScaleFactor = nT, this.postRender = function () {
      (M == v || M == E) && (p.setFromCamera(T, t), r = p.intersectObject(c, !1)[0], r && (L.set(r.point.x, r.point.y), R.set(a.orbit.position.x, a.orbit.position.y))), M == y && z && (z = !1, d = a.getZoom(), k = Ot(T), R.set(a.orbit.position.x, a.orbit.position.y)), M == b && 0 == J() && (M = f, a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.MULTI_END_EVENT));
    }, u(at, "scrollDelta"), u(lt, "canScrollZoom"), u(ut, "handleMouseWheel"), u(ht, "onMouseDown"), u(ct, "onMouseMove"), u(pt, "onMouseUp");
    let dt = null;
    function ft(t) {
      !1 === a.enabled || !1 === a.enableZoom || M !== f && M !== y || (t.preventDefault(), t.stopPropagation(), qt(t), lt(t) && (j = V.getElapsedTime(), a.dispatchUserZoomEvent()), M != y && lt(t) && (a.canvas.addEventListener("mousemove", ct, !1), M = y, d = a.getZoom(), k = Ot(T), R.set(a.orbit.position.x, a.orbit.position.y), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_START_EVENT)), null != dt && clearTimeout(dt), dt = setTimeout(() => {
        a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_END_EVENT);
      }, 50), ut(t));
    }
    function mt(t) {
      let e = Ot(t.x ? t : A[0]);
      L.set(e.x, e.y), R.set(a.orbit.position.x, a.orbit.position.y), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_PAN_START_EVENT), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.PAN_START_EVENT);
    }
    function gt(t) {
      let e = Ot(t.x ? t : A[0]);
      O.set(e.x, e.y), q.subVectors(O, L), a.setPosition(R.x - q.x, R.y - q.y), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.CHANGE_EVENT);
    }
    function vt() {
      a.touchInputs = new nz(A[0], A[1]);
      let t = A[0].x - A[1].x,
        e = A[0].y - A[1].y;
      d = a.getZoom();
      let n = {
        x: A[0].x - t / 2,
        y: A[0].y - e / 2
      };
      k = Ot(n), a.orbit.updateMatrixWorld(), a.touchAnchor1 = new h6(A[0], a.camera, c), a.touchAnchor2 = new h6(A[1], a.camera, c), R.set(a.orbit.position.x, a.orbit.position.y), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_DOLLY_START_EVENT), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.MULTI_START_EVENT);
    }
    function yt() {
      a.touchInputs.update(A[0], A[1]);
      let t = a.touchInputs.first,
        e = a.touchInputs.second;
      a.touchAnchor1.viewCoordinate = {
        x: t.x,
        y: t.y
      }, a.touchAnchor2.viewCoordinate = {
        x: e.x,
        y: e.y
      };
      let n = Ct(a.touchAnchor1, a.touchAnchor2);
      n && It(n), a.orbit.updateMatrixWorld(), a.touchAnchor1.updateAnchorState(a.camera, t), a.touchAnchor2.updateAnchorState(a.camera, e);
    }
    function _t(t) {
      C.set(t.touches[1].clientX, t.touches[1].clientY), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_TILT_START_EVENT), a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_START_EVENT);
    }
    function xt(t) {
      I.set(t.touches[1].clientX, t.touches[1].clientY), N.subVectors(I, C), a.setTilt(a.getTilt() - N.y / a.rotateSpeed), C.copy(I);
    }
    function Et(t) {
      nt(t.touches[0]);
    }
    function bt(t) {
      it(t.touches[0]);
    }
    function wt() {
      (M === _ || M === x) && a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.MULTI_END_EVENT);
    }
    function St(t) {
      if (!1 !== a.enabled) switch (Rt(t), Dt(t), t.touches.length) {
        case 1:
          a.enablePedestal ? (Et(t), M = S) : a.enableRotate && (mt(t), M = E);
          break;
        case 2:
          if (!1 === a.enableZoom) return;
          vt(), M = x;
          break;
        case 3:
          if (!1 === a.enablePan) return;
          _t(t), M = _;
          break;
        default:
          M = f;
      }
    }
    function Mt(t) {
      if (!1 !== a.enabled) switch (t.preventDefault(), t.stopPropagation(), Dt(t), t.touches.length) {
        case 3:
          if (!1 === a.enableRotate || M !== _) return;
          xt(t);
          break;
        case 2:
          if (!1 === a.enableZoom || M !== x) return;
          yt();
          break;
        case 1:
          a.enablePedestal && M === S ? bt(t) : a.enablePan && M === E && gt(t);
          break;
        default:
          M = f;
      }
    }
    function Tt(t) {
      if (!1 !== a.enabled) {
        switch (wt(), M) {
          case v:
          case E:
            a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_PAN_END_EVENT);
            break;
          case _:
            a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.PAN_END_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_TILT_END_EVENT);
            break;
          case g:
          case x:
            a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_END_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_DOLLY_END_EVENT);
            break;
          case m:
            a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ROTATE_END_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_ROTATE_END_EVENT);
            break;
          case w:
          case S:
            a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.PEDESTAL_END_EVENT), a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_PEDESTAL_END_EVENT);
        }
        M = f;
      }
    }
    function At(t) {
      t.preventDefault();
    }
    function Pt(t, e) {
      return (e - t + Math.PI) % (2 * Math.PI) + 2 * Math.PI % (2 * Math.PI) - Math.PI;
    }
    function Ct(t, e) {
      a.orbit.updateMatrixWorld(), a.camera.updateProjectionMatrix();
      let n = a.camera.projectionMatrix.clone(),
        i = t.worldCoordinate,
        r = e.worldCoordinate,
        o = t.reUnproject(),
        s = e.reUnproject();
      if (!o || !s) return null;
      let l = t.viewCoordinate,
        h = e.viewCoordinate,
        c = r.x - i.x,
        p = r.y - i.y,
        d = Math.atan2(p, c),
        f = s.x - o.x,
        m = s.y - o.y,
        g = Pt(d, Math.atan2(m, f)),
        v = new Bt();
      v.makeRotationZ(-g);
      let y = v.clone();
      y.multiply(t.snapHolderMatrix);
      let _ = u((t, e, n) => t.elements[4 * (e - 1) + n - 1], "m"),
        x = _(n, 1, 1) * _(y, 1, 1) - l.x * _(n, 3, 4) * _(y, 3, 1),
        E = _(n, 1, 1) * _(y, 1, 2) - l.x * _(n, 3, 4) * _(y, 3, 2),
        b = _(n, 1, 1) * _(y, 1, 3) - l.x * _(n, 3, 4) * _(y, 3, 3),
        w = i.x * x + i.y * E + i.z * b,
        S = _(n, 2, 2) * _(y, 2, 1) - l.y * _(n, 3, 4) * _(y, 3, 1),
        M = _(n, 2, 2) * _(y, 2, 2) - l.y * _(n, 3, 4) * _(y, 3, 2),
        T = _(n, 2, 2) * _(y, 2, 3) - l.y * _(n, 3, 4) * _(y, 3, 3),
        A = i.x * S + i.y * M + i.z * T,
        P = _(n, 1, 1) * _(y, 1, 1) - h.x * _(n, 3, 4) * _(y, 3, 1),
        C = _(n, 1, 1) * _(y, 1, 2) - h.x * _(n, 3, 4) * _(y, 3, 2),
        I = _(n, 1, 1) * _(y, 1, 3) - h.x * _(n, 3, 4) * _(y, 3, 3),
        N = r.x * P + r.y * C + r.z * I,
        L = _(n, 2, 2) * _(y, 2, 1) - h.y * _(n, 3, 4) * _(y, 3, 1),
        R = _(n, 2, 2) * _(y, 2, 2) - h.y * _(n, 3, 4) * _(y, 3, 2),
        O = _(n, 2, 2) * _(y, 2, 3) - h.y * _(n, 3, 4) * _(y, 3, 3),
        q = r.x * L + r.y * R + r.z * O,
        D = Math.abs(P - x),
        k = Math.abs(C - E),
        F = Math.abs(I - b),
        U = Math.abs(P - S),
        B = Math.abs(C - M),
        z = Math.abs(I - T),
        V = Math.abs(L - x),
        j = Math.abs(R - E),
        G = Math.abs(O - b),
        W = Math.abs(L - S),
        H = Math.abs(R - M),
        X = Math.abs(O - T);
      Math.min(D + k + F, U + B + z) < Math.min(V + j + G, W + H + X) && (P = L, C = R, I = O, N = q);
      let Y = S * b - x * T,
        Z = M * b - E * T,
        J = A * b - w * T,
        K = P * T - S * I,
        Q = C * T - M * I,
        $ = N * T - A * I,
        tt = ($ * Z - J * Q) / (K * Z - Y * Q),
        et = ($ * Y - J * K) / (Q * Y - Z * K),
        nt = M * x - E * S,
        it = C * S - M * P,
        rt = ((N * S - A * P) * nt - (A * x - w * S) * it) / ((I * S - T * P) * nt - (T * x - b * S) * it),
        ot = y.clone();
      return ot.elements[12] = tt, ot.elements[13] = et, ot.elements[14] = rt, rt > 0 ? ot : null;
    }
    function It(t) {
      a.orbit.updateMatrixWorld();
      let e = new Qc();
      e.setFromRotationMatrix(t, "ZYX");
      let n = (t.elements[14] - c.position.z) / Math.cos(e.x),
        i = e.z,
        r = new ne(0, 0, 1);
      r.applyEuler(e), r.setLength(n);
      let o = new ne();
      o.setFromMatrixPosition(t), o.sub(r), a.setPosition(o.x, o.y), a.setZoom(n), a.setRotation(i);
    }
    function Nt(t, e) {
      return {
        x: e.offsetX,
        y: e.offsetY
      };
    }
    function Lt(t, e) {
      return {
        x: e.clientX - P.offsetLeft,
        y: e.clientY - P.offsetTop
      };
    }
    function Rt(t) {
      let e = a.canvas;
      P.offsetLeft = e.getBoundingClientRect().left, P.offsetTop = e.getBoundingClientRect().top;
    }
    function Ot(e) {
      p.setFromCamera(e, t);
      let n = p.intersectObject(c, !1)[0];
      return n ? n.point : new ne();
    }
    function qt(t) {
      let e = Nt(a.canvas, t);
      return T.x = e.x / a.canvas.width * i.resolutionScale * 2 - 1, T.y = -e.y / a.canvas.height * i.resolutionScale * 2 + 1, T;
    }
    function Dt(t) {
      A = [];
      for (let e = 0, n = t.touches.length; e < n; e++) {
        let n = t.touches[e],
          r = Lt(a.canvas, n);
        A.push(new je(r.x / a.canvas.width * i.resolutionScale * 2 - 1, -r.y / a.canvas.height * i.resolutionScale * 2 + 1));
      }
      T = A[0];
    }
    u(ft, "onMouseWheel"), u(mt, "handleTouchStartPan"), u(gt, "handleTouchMovePan"), u(vt, "handleTouchStartDolly"), u(yt, "handleTouchMoveDolly"), u(_t, "handleTouchStartTilt"), u(xt, "handleTouchMoveTilt"), u(Et, "handleTouchStartPedestal"), u(bt, "handleTouchMovePedestal"), u(wt, "handleTouchEnd"), u(St, "onTouchStart"), u(Mt, "onTouchMove"), u(Tt, "onTouchEnd"), u(At, "onContextMenu"), u(Pt, "differenceBetweenAngles"), u(Ct, "makeTransformFromTouchAnchors"), u(It, "setCameraFromTransformMatrix"), u(Nt, "getMousePos"), u(Lt, "getTouchPos"), u(Rt, "updateTouchOrigin"), u(Ot, "raycastToFloor"), u(qt, "mouseToScene"), u(Dt, "touchToScene"), this.update = function () {
      g_.default.update(), j > 0 && M == y && V.getElapsedTime() - j > .2 && (j = 0, M = f, a.dispatcher.dispatchEvent(a.CAMERA_EVENTS.ZOOM_END_EVENT), a.canvas.removeEventListener("mousemove", ct, !1));
    };
    let kt = !1;
    this.dispatchUserZoomDebounced = ol(() => {
      kt = !1, a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_ZOOM_END_EVENT);
    }, 250), this.dispatchUserZoomEvent = function () {
      kt || (a.dispatcher.dispatchEvent(a.INTERACTION_EVENTS.USER_ZOOM_START_EVENT), kt = !0), a.dispatchUserZoomDebounced();
    }, this.dispose = function () {
      for (let t in this.INTERACTION_EVENTS) {
        let e = this.INTERACTION_EVENTS[t];
        e.type.endsWith("Start") && a.dispatcher.removeEventListener(e.type, H);
      }
      for (let t in this.INTERACTION_EVENTS) {
        let e = this.INTERACTION_EVENTS[t];
        e.type.endsWith("End") && a.dispatcher.removeEventListener(e.type, X);
      }
      a.canvas.removeEventListener("contextmenu", At, !1), a.canvas.removeEventListener("mousedown", ht, !1), a.canvas.removeEventListener("wheel", ft, {
        passive: !1
      }), a.canvas.removeEventListener("touchstart", St, !1), a.canvas.removeEventListener("touchend", Tt, !1), a.canvas.removeEventListener("touchmove", Mt, !1), a.canvas.removeEventListener("mousemove", ct, !1), window.removeEventListener("mouseup", pt, !1), window.removeEventListener("mouseout", pt, !1), n.remove(c), a.dispatcher._listeners = {};
    }, this.canvas.addEventListener("contextmenu", At, !1), this.canvas.addEventListener("mousedown", ht, !1), this.canvas.addEventListener("wheel", ft, {
      passive: !1
    }), this.canvas.addEventListener("touchstart", St, !1), this.canvas.addEventListener("touchend", Tt, !1), this.canvas.addEventListener("touchmove", Mt, !1);
  }, "CameraControls"),
  Rw = ume;
E(), E(), E();
var yl = class {
  constructor() {
    this.isPass = !0, this.enabled = !0, this.needsSwap = !0, this.clear = !1, this.renderToScreen = !1;
  }
  setSize() {}
  render() {
    console.error("THREE.Pass: .render() must be implemented in derived pass.");
  }
  dispose() {}
};
u(yl, "Pass");
var cme = new Ll(-1, 1, 1, -1, 0, 1),
  v6 = new Pi();
v6.setAttribute("position", new Di([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)), v6.setAttribute("uv", new Di([0, 2, 0, 0, 2, 0], 2));
var Nw = class {
  constructor(t) {
    this._mesh = new Ft(v6, t);
  }
  dispose() {
    this._mesh.geometry.dispose();
  }
  render(t) {
    t.render(this._mesh, cme);
  }
  get material() {
    return this._mesh.material;
  }
  set material(t) {
    this._mesh.material = t;
  }
};
u(Nw, "FullScreenQuad");
var v_ = new Pi();
v_.setAttribute("position", new ui(new Float32Array([-1, -1, 3, -1, -1, 3]), 2)), v_.setAttribute("uv", new ui(new Float32Array([0, 0, 2, 0, 0, 2]), 2)), v_.boundingSphere = new Zc(), v_.computeBoundingSphere = function () {};
var hme = new Ll(),
  ag = class {
    constructor(t) {
      this._mesh = new Ft(v_, t), this._mesh.frustumCulled = !1;
    }
    render(t) {
      t.render(this._mesh, hme);
    }
    get material() {
      return this._mesh.material;
    }
    set material(t) {
      this._mesh.material = t;
    }
    dispose() {
      this._mesh.material.dispose(), this._mesh.geometry.dispose();
    }
  };
u(ag, "$e4ca8dcb0218f846$export$dcd670d73db751f5");
var fme = {
    uniforms: {
      sceneDiffuse: {
        value: null
      },
      sceneDepth: {
        value: null
      },
      sceneNormal: {
        value: null
      },
      projMat: {
        value: new Bt()
      },
      viewMat: {
        value: new Bt()
      },
      projViewMat: {
        value: new Bt()
      },
      projectionMatrixInv: {
        value: new Bt()
      },
      viewMatrixInv: {
        value: new Bt()
      },
      cameraPos: {
        value: new ne()
      },
      resolution: {
        value: new je()
      },
      time: {
        value: 0
      },
      samples: {
        value: []
      },
      samplesR: {
        value: []
      },
      bluenoise: {
        value: null
      },
      distanceFalloff: {
        value: 1
      },
      radius: {
        value: 5
      },
      near: {
        value: .1
      },
      far: {
        value: 1e3
      },
      logDepth: {
        value: !1
      },
      ortho: {
        value: !1
      },
      screenSpaceRadius: {
        value: !1
      }
    },
    vertexShader: "\nvarying vec2 vUv;\nvoid main() {\n  vUv = uv;\n  gl_Position = vec4(position, 1);\n}",
    fragmentShader: "\n    #define SAMPLES 16\n    #define FSAMPLES 16.0\nuniform sampler2D sceneDiffuse;\nuniform sampler2D sceneNormal;\nuniform highp sampler2D sceneDepth;\nuniform mat4 projectionMatrixInv;\nuniform mat4 viewMatrixInv;\nuniform mat4 projMat;\nuniform mat4 viewMat;\nuniform mat4 projViewMat;\nuniform vec3 cameraPos;\nuniform vec2 resolution;\nuniform float time;\nuniform vec3[SAMPLES] samples;\nuniform float[SAMPLES] samplesR;\nuniform float radius;\nuniform float distanceFalloff;\nuniform float near;\nuniform float far;\nuniform bool logDepth;\nuniform bool ortho;\nuniform bool screenSpaceRadius;\nuniform sampler2D bluenoise;\n    varying vec2 vUv;\n    highp float linearize_depth(highp float d, highp float zNear,highp float zFar)\n    {\n        return (zFar * zNear) / (zFar - d * (zFar - zNear));\n    }\n    highp float linearize_depth_ortho(highp float d, highp float nearZ, highp float farZ) {\n      return nearZ + (farZ - nearZ) * d;\n    }\n    highp float linearize_depth_log(highp float d, highp float nearZ,highp float farZ) {\n      float depth = pow(2.0, d * log2(farZ + 1.0)) - 1.0;\n      float a = farZ / (farZ - nearZ);\n      float b = farZ * nearZ / (nearZ - farZ);\n      float linDepth = a + b / depth;\n      return ortho ? linearize_depth_ortho(\n        linDepth,\n        nearZ,\n        farZ\n      ) :linearize_depth(linDepth, nearZ, farZ);\n    }\n\n    vec3 getWorldPosLog(vec3 posS) {\n      vec2 uv = posS.xy;\n      float z = posS.z;\n      float nearZ =near;\n      float farZ = far;\n      float depth = pow(2.0, z * log2(farZ + 1.0)) - 1.0;\n      float a = farZ / (farZ - nearZ);\n      float b = farZ * nearZ / (nearZ - farZ);\n      float linDepth = a + b / depth;\n      vec4 clipVec = vec4(uv, linDepth, 1.0) * 2.0 - 1.0;\n      vec4 wpos = viewMatrixInv * projectionMatrixInv * clipVec;\n      return wpos.xyz / wpos.w;\n    }\n    vec3 getWorldPos(float depth, vec2 coord) {\n      #ifdef LOGDEPTH\n        return getWorldPosLog(vec3(coord, depth));\n      #endif\n      float z = depth * 2.0 - 1.0;\n      vec4 clipSpacePosition = vec4(coord * 2.0 - 1.0, z, 1.0);\n      vec4 viewSpacePosition = projectionMatrixInv * clipSpacePosition;\n      // Perspective division\n     vec4 worldSpacePosition = viewMatrixInv * viewSpacePosition;\n     worldSpacePosition.xyz /= worldSpacePosition.w;\n      return worldSpacePosition.xyz;\n  }\n\n  vec3 computeNormal(vec3 worldPos, vec2 vUv) {\n    ivec2 p = ivec2(vUv * resolution);\n    float c0 = texelFetch(sceneDepth, p, 0).x;\n    float l2 = texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;\n    float l1 = texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;\n    float r1 = texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;\n    float r2 = texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;\n    float b2 = texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;\n    float b1 = texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;\n    float t1 = texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;\n    float t2 = texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;\n\n    float dl = abs((2.0 * l1 - l2) - c0);\n    float dr = abs((2.0 * r1 - r2) - c0);\n    float db = abs((2.0 * b1 - b2) - c0);\n    float dt = abs((2.0 * t1 - t2) - c0);\n\n    vec3 ce = getWorldPos(c0, vUv).xyz;\n\n    vec3 dpdx = (dl < dr) ? ce - getWorldPos(l1, (vUv - vec2(1.0 / resolution.x, 0.0))).xyz\n                          : -ce + getWorldPos(r1, (vUv + vec2(1.0 / resolution.x, 0.0))).xyz;\n    vec3 dpdy = (db < dt) ? ce - getWorldPos(b1, (vUv - vec2(0.0, 1.0 / resolution.y))).xyz\n                          : -ce + getWorldPos(t1, (vUv + vec2(0.0, 1.0 / resolution.y))).xyz;\n\n    return normalize(cross(dpdx, dpdy));\n}\n\nvoid main() {\n      vec4 diffuse = texture2D(sceneDiffuse, vUv);\n      float depth = texture2D(sceneDepth, vUv).x;\n      if (depth == 1.0) {\n        gl_FragColor = vec4(vec3(1.0), 1.0);\n        return;\n      }\n      vec3 worldPos = getWorldPos(depth, vUv);\n    //  vec3 normal = texture2D(sceneNormal, vUv).rgb;//computeNormal(worldPos, vUv);\n      #ifdef HALFRES\n        vec3 normal = texture2D(sceneNormal, vUv).rgb;\n      #else\n        vec3 normal = computeNormal(worldPos, vUv);\n      #endif\n      vec4 noise = texture2D(bluenoise, gl_FragCoord.xy / 128.0);\n      vec3 randomVec = normalize(noise.rgb * 2.0 - 1.0);\n      vec3 tangent = normalize(randomVec - normal * dot(randomVec, normal));\n      vec3 bitangent = cross(normal, tangent);\n      mat3 tbn = mat3(tangent, bitangent, normal);\n      float occluded = 0.0;\n      float totalWeight = 0.0;\n     /* float radiusScreen = distance(\n        worldPos,\n        getWorldPos(depth, vUv + \n          vec2(48.0, 0.0) / resolution)\n      );/*vUv.x < 0.5 ? radius : min(distance(\n        worldPos,\n        getWorldPos(depth, vUv + \n          vec2(100.0, 0.0) / resolution)\n      ), radius);\n      float distanceFalloffScreen = radiusScreen * 0.2;*/\n      float radiusToUse = screenSpaceRadius ? distance(\n        worldPos,\n        getWorldPos(depth, vUv +\n          vec2(radius, 0.0) / resolution)\n      ) : radius;\n      float distanceFalloffToUse =screenSpaceRadius ?\n          radiusToUse * distanceFalloff\n      : distanceFalloff;\n      float bias = (0.1 / near) * fwidth(distance(worldPos, cameraPos)) / radiusToUse;\n      for(float i = 0.0; i < FSAMPLES; i++) {\n        vec3 sampleDirection = \n        tbn * \n        samples[int(i)];\n        ;\n        float moveAmt = samplesR[int(mod(i + noise.a * FSAMPLES, FSAMPLES))];\n        vec3 samplePos = worldPos + radiusToUse * moveAmt * sampleDirection;\n        vec4 offset = projViewMat * vec4(samplePos, 1.0);\n        offset.xyz /= offset.w;\n        offset.xyz = offset.xyz * 0.5 + 0.5;\n        float sampleDepth = textureLod(sceneDepth, offset.xy, 0.0).x;\n        /*float distSample = logDepth ? linearize_depth_log(sampleDepth, near, far) \n         (ortho ?  linearize_depth_ortho(sampleDepth, near, far) : linearize_depth(sampleDepth, near, far));*/\n        #ifdef LOGDEPTH\n        float distSample = linearize_depth_log(sampleDepth, near, far);\n        #else\n        float distSample = ortho ? linearize_depth_ortho(sampleDepth, near, far) : linearize_depth(sampleDepth, near, far);\n        #endif\n        float distWorld = ortho ? linearize_depth_ortho(offset.z, near, far) : linearize_depth(offset.z, near, far);\n        float rangeCheck = smoothstep(0.0, 1.0, distanceFalloffToUse / (abs(distSample - distWorld)));\n        vec2 diff = gl_FragCoord.xy - ( offset.xy * resolution);\n        float weight = dot(sampleDirection, normal);\n          occluded += rangeCheck * weight * \n            (distSample + bias\n               < distWorld ? 1.0 : 0.0) * (\n          (dot(\n            diff,\n            diff\n             \n            ) < 1.0 || (sampleDepth == depth) || (\n              offset.x < 0.0 || offset.x > 1.0 || offset.y < 0.0 || offset.y > 1.0\n            ) ? 0.0 : 1.0)\n          );\n          totalWeight += weight;\n      }\n      float occ = clamp(1.0 - occluded / totalWeight, 0.0, 1.0);\n      gl_FragColor = vec4(0.5 + 0.5 * normal, occ);\n}"
  },
  pme = {
    uniforms: {
      sceneDiffuse: {
        value: null
      },
      sceneDepth: {
        value: null
      },
      tDiffuse: {
        value: null
      },
      projMat: {
        value: new Bt()
      },
      viewMat: {
        value: new Bt()
      },
      projectionMatrixInv: {
        value: new Bt()
      },
      viewMatrixInv: {
        value: new Bt()
      },
      cameraPos: {
        value: new ne()
      },
      resolution: {
        value: new je()
      },
      color: {
        value: new ne(0, 0, 0)
      },
      blueNoise: {
        value: null
      },
      downsampledDepth: {
        value: null
      },
      time: {
        value: 0
      },
      intensity: {
        value: 10
      },
      renderMode: {
        value: 0
      },
      gammaCorrection: {
        value: !1
      },
      logDepth: {
        value: !1
      },
      ortho: {
        value: !1
      },
      near: {
        value: .1
      },
      far: {
        value: 1e3
      },
      screenSpaceRadius: {
        value: !1
      },
      radius: {
        value: 0
      },
      distanceFalloff: {
        value: 1
      },
      fog: {
        value: !1
      },
      fogExp: {
        value: !1
      },
      fogDensity: {
        value: 0
      },
      fogNear: {
        value: 1 / 0
      },
      fogFar: {
        value: 1 / 0
      }
    },
    vertexShader: "\n\t\tvarying vec2 vUv;\n\t\tvoid main() {\n\t\t\tvUv = uv;\n\t\t\tgl_Position = vec4(position, 1);\n\t\t}",
    fragmentShader: "\n\t\tuniform sampler2D sceneDiffuse;\n    uniform sampler2D sceneDepth;\n    uniform sampler2D downsampledDepth;\n    uniform sampler2D tDiffuse;\n    uniform sampler2D blueNoise;\n    uniform vec2 resolution;\n    uniform vec3 color;\n    uniform mat4 projectionMatrixInv;\n    uniform mat4 viewMatrixInv;\n    uniform float intensity;\n    uniform float renderMode;\n    uniform float near;\n    uniform float far;\n    uniform bool gammaCorrection;\n    uniform bool logDepth;\n    uniform bool ortho;\n    uniform bool screenSpaceRadius;\n    uniform bool fog;\n    uniform bool fogExp;\n    uniform float fogDensity;\n    uniform float fogNear;\n    uniform float fogFar;\n    uniform float radius;\n    uniform float distanceFalloff;\n    uniform vec3 cameraPos;\n    varying vec2 vUv;\n    highp float linearize_depth(highp float d, highp float zNear,highp float zFar)\n    {\n        return (zFar * zNear) / (zFar - d * (zFar - zNear));\n    }\n    highp float linearize_depth_ortho(highp float d, highp float nearZ, highp float farZ) {\n      return nearZ + (farZ - nearZ) * d;\n    }\n    highp float linearize_depth_log(highp float d, highp float nearZ,highp float farZ) {\n      float depth = pow(2.0, d * log2(farZ + 1.0)) - 1.0;\n      float a = farZ / (farZ - nearZ);\n      float b = farZ * nearZ / (nearZ - farZ);\n      float linDepth = a + b / depth;\n      return ortho ? linearize_depth_ortho(\n        linDepth,\n        nearZ,\n        farZ\n      ) :linearize_depth(linDepth, nearZ, farZ);\n    }\n    vec3 getWorldPosLog(vec3 posS) {\n        vec2 uv = posS.xy;\n        float z = posS.z;\n        float nearZ =near;\n        float farZ = far;\n        float depth = pow(2.0, z * log2(farZ + 1.0)) - 1.0;\n        float a = farZ / (farZ - nearZ);\n        float b = farZ * nearZ / (nearZ - farZ);\n        float linDepth = a + b / depth;\n        vec4 clipVec = vec4(uv, linDepth, 1.0) * 2.0 - 1.0;\n        vec4 wpos = viewMatrixInv * projectionMatrixInv * clipVec;\n        return wpos.xyz / wpos.w;\n      }\n      vec3 getWorldPos(float depth, vec2 coord) {\n       // if (logDepth) {\n        #ifdef LOGDEPTH\n          return getWorldPosLog(vec3(coord, depth));\n        #endif\n      //  }\n        float z = depth * 2.0 - 1.0;\n        vec4 clipSpacePosition = vec4(coord * 2.0 - 1.0, z, 1.0);\n        vec4 viewSpacePosition = projectionMatrixInv * clipSpacePosition;\n        // Perspective division\n       vec4 worldSpacePosition = viewMatrixInv * viewSpacePosition;\n       worldSpacePosition.xyz /= worldSpacePosition.w;\n        return worldSpacePosition.xyz;\n    }\n  \n    vec3 computeNormal(vec3 worldPos, vec2 vUv) {\n      ivec2 p = ivec2(vUv * resolution);\n      float c0 = texelFetch(sceneDepth, p, 0).x;\n      float l2 = texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;\n      float l1 = texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;\n      float r1 = texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;\n      float r2 = texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;\n      float b2 = texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;\n      float b1 = texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;\n      float t1 = texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;\n      float t2 = texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;\n  \n      float dl = abs((2.0 * l1 - l2) - c0);\n      float dr = abs((2.0 * r1 - r2) - c0);\n      float db = abs((2.0 * b1 - b2) - c0);\n      float dt = abs((2.0 * t1 - t2) - c0);\n  \n      vec3 ce = getWorldPos(c0, vUv).xyz;\n  \n      vec3 dpdx = (dl < dr) ? ce - getWorldPos(l1, (vUv - vec2(1.0 / resolution.x, 0.0))).xyz\n                            : -ce + getWorldPos(r1, (vUv + vec2(1.0 / resolution.x, 0.0))).xyz;\n      vec3 dpdy = (db < dt) ? ce - getWorldPos(b1, (vUv - vec2(0.0, 1.0 / resolution.y))).xyz\n                            : -ce + getWorldPos(t1, (vUv + vec2(0.0, 1.0 / resolution.y))).xyz;\n  \n      return normalize(cross(dpdx, dpdy));\n  }\n\n    #include <common>\n    #include <dithering_pars_fragment>\n    void main() {\n        //vec4 texel = texture2D(tDiffuse, vUv);//vec3(0.0);\n        vec4 sceneTexel = texture2D(sceneDiffuse, vUv);\n        float depth = texture2D(\n            sceneDepth,\n            vUv\n        ).x;\n        #ifdef HALFRES \n        vec4 texel;\n        if (depth == 1.0) {\n            texel = vec4(0.0, 0.0, 0.0, 1.0);\n        } else {\n        vec3 worldPos = getWorldPos(depth, vUv);\n        vec3 normal = computeNormal(getWorldPos(depth, vUv), vUv);\n       // vec4 texel = texture2D(tDiffuse, vUv);\n       // Find closest depth;\n       float totalWeight = 0.0;\n       float radiusToUse = screenSpaceRadius ? distance(\n        worldPos,\n        getWorldPos(depth, vUv +\n          vec2(radius, 0.0) / resolution)\n      ) : radius;\n      float distanceFalloffToUse =screenSpaceRadius ?\n          radiusToUse * distanceFalloff\n      : distanceFalloff;\n        for(float x = -1.0; x <= 1.0; x++) {\n            for(float y = -1.0; y <= 1.0; y++) {\n                vec2 offset = vec2(x, y);\n                ivec2 p = ivec2(\n                    (vUv * resolution * 0.5) + offset\n                );\n                vec2 pUv = vec2(p) / (resolution * 0.5);\n                float sampleDepth = texelFetch(downsampledDepth,p, 0).x;\n                vec4 sampleInfo = texelFetch(tDiffuse, p, 0);\n                vec3 normalSample = sampleInfo.xyz * 2.0 - 1.0;\n                vec3 worldPosSample = getWorldPos(sampleDepth, pUv);\n                float tangentPlaneDist = abs(dot(worldPos - worldPosSample, normal));\n                float rangeCheck = exp(-1.0 * tangentPlaneDist * (1.0 / distanceFalloffToUse)) * max(dot(normal, normalSample), 0.0);\n                float weight = rangeCheck;\n                totalWeight += weight;\n                texel += sampleInfo * weight;\n            }\n        }\n        if (totalWeight == 0.0) {\n            texel = texture2D(tDiffuse, vUv);\n        } else {\n            texel /= totalWeight;\n        }\n    }\n        #else\n        vec4 texel = texture2D(tDiffuse, vUv);\n        #endif\n\n     \n        float finalAo = pow(texel.a, intensity);\n        float fogFactor;\n        float fogDepth = distance(\n            cameraPos,\n            getWorldPos(depth, vUv)\n        );\n        if (fog) {\n            if (fogExp) {\n                fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n            } else {\n                fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n            }\n        }\n        finalAo = mix(finalAo, 1.0, fogFactor);\n        if (renderMode == 0.0) {\n            gl_FragColor = vec4( mix(sceneTexel.rgb, color * sceneTexel.rgb, 1.0 - finalAo), sceneTexel.a);\n        } else if (renderMode == 1.0) {\n            gl_FragColor = vec4( mix(vec3(1.0), color * sceneTexel.rgb, 1.0 - finalAo), sceneTexel.a);\n        } else if (renderMode == 2.0) {\n            gl_FragColor = vec4( sceneTexel.rgb, sceneTexel.a);\n        } else if (renderMode == 3.0) {\n            if (vUv.x < 0.5) {\n                gl_FragColor = vec4( sceneTexel.rgb, sceneTexel.a);\n            } else if (abs(vUv.x - 0.5) < 1.0 / resolution.x) {\n                gl_FragColor = vec4(1.0);\n            } else {\n                gl_FragColor = vec4( mix(sceneTexel.rgb, color * sceneTexel.rgb, 1.0 - finalAo), sceneTexel.a);\n            }\n        } else if (renderMode == 4.0) {\n            if (vUv.x < 0.5) {\n                gl_FragColor = vec4( sceneTexel.rgb, sceneTexel.a);\n            } else if (abs(vUv.x - 0.5) < 1.0 / resolution.x) {\n                gl_FragColor = vec4(1.0);\n            } else {\n                gl_FragColor = vec4( mix(vec3(1.0), color * sceneTexel.rgb, 1.0 - finalAo), sceneTexel.a);\n            }\n        }\n        #include <dithering_fragment>\n        if (gammaCorrection) {\n            gl_FragColor = LinearTosRGB(gl_FragColor);\n        }\n    }\n    "
  },
  dme = {
    uniforms: {
      sceneDiffuse: {
        value: null
      },
      sceneDepth: {
        value: null
      },
      tDiffuse: {
        value: null
      },
      projMat: {
        value: new Bt()
      },
      viewMat: {
        value: new Bt()
      },
      projectionMatrixInv: {
        value: new Bt()
      },
      viewMatrixInv: {
        value: new Bt()
      },
      cameraPos: {
        value: new ne()
      },
      resolution: {
        value: new je()
      },
      time: {
        value: 0
      },
      r: {
        value: 5
      },
      blueNoise: {
        value: null
      },
      radius: {
        value: 12
      },
      worldRadius: {
        value: 5
      },
      index: {
        value: 0
      },
      poissonDisk: {
        value: []
      },
      distanceFalloff: {
        value: 1
      },
      near: {
        value: .1
      },
      far: {
        value: 1e3
      },
      logDepth: {
        value: !1
      },
      screenSpaceRadius: {
        value: !1
      }
    },
    vertexShader: "\n\t\tvarying vec2 vUv;\n\t\tvoid main() {\n\t\t\tvUv = uv;\n\t\t\tgl_Position = vec4(position, 1.0);\n\t\t}",
    fragmentShader: "\n\t\tuniform sampler2D sceneDiffuse;\n    uniform highp sampler2D sceneDepth;\n    uniform sampler2D tDiffuse;\n    uniform sampler2D blueNoise;\n    uniform mat4 projectionMatrixInv;\n    uniform mat4 viewMatrixInv;\n    uniform vec2 resolution;\n    uniform float r;\n    uniform float radius;\n     uniform float worldRadius;\n    uniform float index;\n     uniform float near;\n     uniform float far;\n     uniform float distanceFalloff;\n     uniform bool logDepth;\n     uniform bool screenSpaceRadius;\n    varying vec2 vUv;\n\n    highp float linearize_depth(highp float d, highp float zNear,highp float zFar)\n    {\n        highp float z_n = 2.0 * d - 1.0;\n        return 2.0 * zNear * zFar / (zFar + zNear - z_n * (zFar - zNear));\n    }\n    highp float linearize_depth_log(highp float d, highp float nearZ,highp float farZ) {\n     float depth = pow(2.0, d * log2(farZ + 1.0)) - 1.0;\n     float a = farZ / (farZ - nearZ);\n     float b = farZ * nearZ / (nearZ - farZ);\n     float linDepth = a + b / depth;\n     return linearize_depth(linDepth, nearZ, farZ);\n   }\n   highp float linearize_depth_ortho(highp float d, highp float nearZ, highp float farZ) {\n     return nearZ + (farZ - nearZ) * d;\n   }\n   vec3 getWorldPosLog(vec3 posS) {\n     vec2 uv = posS.xy;\n     float z = posS.z;\n     float nearZ =near;\n     float farZ = far;\n     float depth = pow(2.0, z * log2(farZ + 1.0)) - 1.0;\n     float a = farZ / (farZ - nearZ);\n     float b = farZ * nearZ / (nearZ - farZ);\n     float linDepth = a + b / depth;\n     vec4 clipVec = vec4(uv, linDepth, 1.0) * 2.0 - 1.0;\n     vec4 wpos = viewMatrixInv * projectionMatrixInv * clipVec;\n     return wpos.xyz / wpos.w;\n   }\n    vec3 getWorldPos(float depth, vec2 coord) {\n     #ifdef LOGDEPTH\n          return getWorldPosLog(vec3(coord, depth));\n     #endif\n        \n        float z = depth * 2.0 - 1.0;\n        vec4 clipSpacePosition = vec4(coord * 2.0 - 1.0, z, 1.0);\n        vec4 viewSpacePosition = projectionMatrixInv * clipSpacePosition;\n        // Perspective division\n       vec4 worldSpacePosition = viewMatrixInv * viewSpacePosition;\n       worldSpacePosition.xyz /= worldSpacePosition.w;\n        return worldSpacePosition.xyz;\n    }\n    #include <common>\n    #define NUM_SAMPLES 16\n    uniform vec2 poissonDisk[NUM_SAMPLES];\n    void main() {\n        const float pi = 3.14159;\n        vec2 texelSize = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n        vec2 uv = vUv;\n        vec4 data = texture2D(tDiffuse, vUv);\n        float occlusion = data.a;\n        float baseOcc = data.a;\n        vec3 normal = data.rgb * 2.0 - 1.0;\n        float count = 1.0;\n        float d = texture2D(sceneDepth, vUv).x;\n        vec3 worldPos = getWorldPos(d, vUv);\n        float size = radius;\n        float angle;\n        if (index == 0.0) {\n             angle = texture2D(blueNoise, gl_FragCoord.xy / 128.0).x * PI2;\n        } else if (index == 1.0) {\n             angle = texture2D(blueNoise, gl_FragCoord.xy / 128.0).y * PI2;\n        } else if (index == 2.0) {\n             angle = texture2D(blueNoise, gl_FragCoord.xy / 128.0).z * PI2;\n        } else {\n             angle = texture2D(blueNoise, gl_FragCoord.xy / 128.0).w * PI2;\n        }\n\n        mat2 rotationMatrix = mat2(cos(angle), -sin(angle), sin(angle), cos(angle));\n        float radiusToUse = screenSpaceRadius ? distance(\n          worldPos,\n          getWorldPos(d, vUv +\n            vec2(worldRadius, 0.0) / resolution)\n        ) : worldRadius;\n        float distanceFalloffToUse =screenSpaceRadius ?\n            radiusToUse * distanceFalloff\n        : distanceFalloff;\n\n\n        for(int i = 0; i < NUM_SAMPLES; i++) {\n            vec2 offset = (rotationMatrix * poissonDisk[i]) * texelSize * size;\n            vec4 dataSample = texture2D(tDiffuse, uv + offset);\n            float occSample = dataSample.a;\n            vec3 normalSample = dataSample.rgb * 2.0 - 1.0;\n            float dSample = texture2D(sceneDepth, uv + offset).x;\n            vec3 worldPosSample = getWorldPos(dSample, uv + offset);\n            float tangentPlaneDist = abs(dot(worldPos - worldPosSample, normal));\n            float rangeCheck = exp(-1.0 * tangentPlaneDist * (1.0 / distanceFalloffToUse)) * max(dot(normal, normalSample), 0.0) * (1.0 - abs(occSample - baseOcc));\n            occlusion += occSample * rangeCheck;\n            count += rangeCheck;\n        }\n        occlusion /= count;\n        gl_FragColor = vec4(0.5 + 0.5 * normal, occlusion);\n    }\n    "
  },
  mme = {
    uniforms: {
      sceneDepth: {
        value: null
      },
      resolution: {
        value: new je()
      },
      near: {
        value: .1
      },
      far: {
        value: 1e3
      },
      viewMatrixInv: {
        value: new Bt()
      },
      projectionMatrixInv: {
        value: new Bt()
      },
      logDepth: {
        value: !1
      }
    },
    vertexShader: "\n    varying vec2 vUv;\n    void main() {\n        vUv = uv;\n        gl_Position = vec4(position, 1);\n    }",
    fragmentShader: "\n    uniform sampler2D sceneDepth;\n    uniform vec2 resolution;\n    uniform float near;\n    uniform float far;\n    uniform bool logDepth;\n    uniform mat4 viewMatrixInv;\n    uniform mat4 projectionMatrixInv;\n    varying vec2 vUv;\n    layout(location = 1) out vec4 gNormal;\n    vec3 getWorldPosLog(vec3 posS) {\n        vec2 uv = posS.xy;\n        float z = posS.z;\n        float nearZ =near;\n        float farZ = far;\n        float depth = pow(2.0, z * log2(farZ + 1.0)) - 1.0;\n        float a = farZ / (farZ - nearZ);\n        float b = farZ * nearZ / (nearZ - farZ);\n        float linDepth = a + b / depth;\n        vec4 clipVec = vec4(uv, linDepth, 1.0) * 2.0 - 1.0;\n        vec4 wpos = viewMatrixInv * projectionMatrixInv * clipVec;\n        return wpos.xyz / wpos.w;\n      }\n      vec3 getWorldPos(float depth, vec2 coord) {\n        if (logDepth) {\n          return getWorldPosLog(vec3(coord, depth));\n        }\n        float z = depth * 2.0 - 1.0;\n        vec4 clipSpacePosition = vec4(coord * 2.0 - 1.0, z, 1.0);\n        vec4 viewSpacePosition = projectionMatrixInv * clipSpacePosition;\n        // Perspective division\n       vec4 worldSpacePosition = viewMatrixInv * viewSpacePosition;\n       worldSpacePosition.xyz /= worldSpacePosition.w;\n        return worldSpacePosition.xyz;\n    }\n  \n    vec3 computeNormal(vec3 worldPos, vec2 vUv) {\n      ivec2 p = ivec2(vUv * resolution);\n      float c0 = texelFetch(sceneDepth, p, 0).x;\n      float l2 = texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;\n      float l1 = texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;\n      float r1 = texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;\n      float r2 = texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;\n      float b2 = texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;\n      float b1 = texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;\n      float t1 = texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;\n      float t2 = texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;\n  \n      float dl = abs((2.0 * l1 - l2) - c0);\n      float dr = abs((2.0 * r1 - r2) - c0);\n      float db = abs((2.0 * b1 - b2) - c0);\n      float dt = abs((2.0 * t1 - t2) - c0);\n  \n      vec3 ce = getWorldPos(c0, vUv).xyz;\n  \n      vec3 dpdx = (dl < dr) ? ce - getWorldPos(l1, (vUv - vec2(1.0 / resolution.x, 0.0))).xyz\n                            : -ce + getWorldPos(r1, (vUv + vec2(1.0 / resolution.x, 0.0))).xyz;\n      vec3 dpdy = (db < dt) ? ce - getWorldPos(b1, (vUv - vec2(0.0, 1.0 / resolution.y))).xyz\n                            : -ce + getWorldPos(t1, (vUv + vec2(0.0, 1.0 / resolution.y))).xyz;\n  \n      return normalize(cross(dpdx, dpdy));\n  }\n    void main() {\n        vec2 uv = vUv - vec2(0.5) / resolution;\n        vec2 pixelSize = vec2(1.0) / resolution;\n        vec2[] uvSamples = vec2[4](\n            uv,\n            uv + vec2(pixelSize.x, 0.0),\n            uv + vec2(0.0, pixelSize.y),\n            uv + pixelSize\n        );\n        float depth00 = texture2D(sceneDepth, uvSamples[0]).r;\n        float depth10 = texture2D(sceneDepth, uvSamples[1]).r;\n        float depth01 = texture2D(sceneDepth, uvSamples[2]).r;\n        float depth11 = texture2D(sceneDepth, uvSamples[3]).r;\n        float minDepth = min(min(depth00, depth10), min(depth01, depth11));\n        float maxDepth = max(max(depth00, depth10), max(depth01, depth11));\n        float targetDepth = minDepth;\n        // Checkerboard pattern to avoid artifacts\n        if (mod(gl_FragCoord.x + gl_FragCoord.y, 2.0) > 0.5) { \n            targetDepth = maxDepth;\n        }\n        int chosenIndex = 0;\n        float[] samples = float[4](depth00, depth10, depth01, depth11);\n        for(int i = 0; i < 4; ++i) {\n            if (samples[i] == targetDepth) {\n                chosenIndex = i;\n                break;\n            }\n        }\n        gl_FragColor = vec4(samples[chosenIndex], 0.0, 0.0, 1.0);\n        gNormal = vec4(computeNormal(\n            getWorldPos(samples[chosenIndex], uvSamples[chosenIndex]), uvSamples[chosenIndex]\n        ), 0.0);\n       /* float[] samples = float[4](depth00, depth10, depth01, depth11);\n        float c = 0.25 * (depth00 + depth10 + depth01 + depth11);\n        float[] distances = float[4](depth00, depth10, depth01, depth11);\n        float maxDistance = max(max(distances[0], distances[1]), max(distances[2], distances[3]));\n\n        int remaining[3];\n        int rejected[3];\n        int i, j, k;\n\n        for(i = 0, j = 0, k = 0; i < 4; ++i) {\n            if (distances[i] < maxDistance) {\n                remaining[j++] = i;\n            } else {\n                rejected[k++] = i;\n            }\n        }\n        for(;j < 3;++j) {\n            remaining[j] = rejected[--k];\n        }\n        vec3 s = vec3(\n            samples[remaining[0]],\n            samples[remaining[1]],\n            samples[remaining[2]]\n        );\n        c = (s.x + s.y + s.z) / 3.0;\n\n        distances[0] = abs(c - s.x);\n        distances[1] = abs(c - s.y);\n        distances[2] = abs(c - s.z);\n\n        float minDistance = min(min(distances[0], distances[1]), distances[2]);\n\n        for(i = 0; i < 3; ++i) {\n            if (distances[i] == minDistance) {\n                break;\n            }\n        }*/\n      /*  gl_FragColor = vec4(samples[remaining[i]], 0.0, 0.0, 0.0);\n        gNormal = vec4(computeNormal(\n            getWorldPos(samples[remaining[i]], uvSamples[remaining[i]]), uvSamples[remaining[i]]\n        ), 0.0);*/\n    }"
  },
  hz = "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",
  oHe = Uint8Array.from(atob(hz), t => t.charCodeAt(0)),
  gme = Uint8Array.from(atob(hz), t => t.charCodeAt(0));
function fz(t, e, n) {
  if (e.getQueryParameter(t, e.QUERY_RESULT_AVAILABLE)) {
    let i = e.getQueryParameter(t, e.QUERY_RESULT) / 1e6;
    n.lastTime = i;
  } else setTimeout(() => {
    fz(t, e, n);
  }, 1);
}
u(fz, "$05f6997e4b65da14$var$checkTimerQuery");
var Dw = class extends yl {
  constructor(t, e, n = 512, i = 512) {
    super(), this.width = n, this.height = i, this.clear = !0, this.camera = e, this.scene = t, this.configuration = new Proxy({
      aoSamples: 16,
      aoRadius: 5,
      denoiseSamples: 8,
      denoiseRadius: 12,
      distanceFalloff: 1,
      intensity: 5,
      denoiseIterations: 2,
      renderMode: 0,
      color: new yt(0, 0, 0),
      gammaCorrection: !0,
      logarithmicDepthBuffer: !1,
      screenSpaceRadius: !1,
      halfRes: !1,
      depthAwareUpsampling: !0,
      autoRenderBeauty: !0
    }, {
      set: (t, e, n) => {
        let i = t[e];
        return t[e] = n, "aoSamples" === e && i !== n && this.configureAOPass(this.configuration.logarithmicDepthBuffer), "denoiseSamples" === e && i !== n && this.configureDenoisePass(this.configuration.logarithmicDepthBuffer), "halfRes" === e && i !== n && (this.configureAOPass(this.configuration.logarithmicDepthBuffer), this.configureHalfResTargets(), this.configureEffectCompositer(this.configuration.logarithmicDepthBuffer), this.setSize(this.width, this.height)), "depthAwareUpsampling" === e && i !== n && this.configureEffectCompositer(this.configuration.logarithmicDepthBuffer), !0;
      }
    }), this.samples = [], this.samplesR = [], this.samplesDenoise = [], this.configureEffectCompositer(this.configuration.logarithmicDepthBuffer), this.configureSampleDependentPasses(), this.configureHalfResTargets(), this.beautyRenderTarget = new wr(this.width, this.height, {
      minFilter: ao,
      magFilter: ni
    }), this.beautyRenderTarget.depthTexture = new Vu(this.width, this.height, Ps), this.beautyRenderTarget.depthTexture.format = Lu, this.writeTargetInternal = new wr(this.width, this.height, {
      minFilter: ao,
      magFilter: ao,
      depthBuffer: !1
    }), this.readTargetInternal = new wr(this.width, this.height, {
      minFilter: ao,
      magFilter: ao,
      depthBuffer: !1
    }), this.bluenoise = new Lx(gme, 128, 128), this.bluenoise.colorSpace = Ou, this.bluenoise.wrapS = Br, this.bluenoise.wrapT = Br, this.bluenoise.minFilter = ni, this.bluenoise.magFilter = ni, this.bluenoise.needsUpdate = !0, this.lastTime = 0, this._r = new je(), this._c = new yt();
  }
  configureHalfResTargets() {
    this.configuration.halfRes ? (this.depthDownsampleTarget = new rx(this.width / 2, this.height / 2, 2), this.depthDownsampleTarget.texture[0].format = C3, this.depthDownsampleTarget.texture[0].type = Tl, this.depthDownsampleTarget.texture[0].minFilter = ni, this.depthDownsampleTarget.texture[0].magFilter = ni, this.depthDownsampleTarget.texture[0].depthBuffer = !1, this.depthDownsampleTarget.texture[1].format = Po, this.depthDownsampleTarget.texture[1].type = Iu, this.depthDownsampleTarget.texture[1].minFilter = ni, this.depthDownsampleTarget.texture[1].magFilter = ni, this.depthDownsampleTarget.texture[1].depthBuffer = !1, this.depthDownsampleQuad = new ag(new wi(mme))) : (this.depthDownsampleTarget && (this.depthDownsampleTarget.dispose(), this.depthDownsampleTarget = null), this.depthDownsampleQuad && (this.depthDownsampleQuad.dispose(), this.depthDownsampleQuad = null));
  }
  configureSampleDependentPasses() {
    this.configureAOPass(this.configuration.logarithmicDepthBuffer), this.configureDenoisePass(this.configuration.logarithmicDepthBuffer);
  }
  configureAOPass(t = !1) {
    this.samples = this.generateHemisphereSamples(this.configuration.aoSamples), this.samplesR = this.generateHemisphereSamplesR(this.configuration.aoSamples);
    let e = {
      ...fme
    };
    e.fragmentShader = e.fragmentShader.replace("16", this.configuration.aoSamples).replace("16.0", this.configuration.aoSamples + ".0"), t && (e.fragmentShader = "#define LOGDEPTH\n" + e.fragmentShader), this.configuration.halfRes && (e.fragmentShader = "#define HALFRES\n" + e.fragmentShader), this.effectShaderQuad ? (this.effectShaderQuad.material.dispose(), this.effectShaderQuad.material = new wi(e)) : this.effectShaderQuad = new ag(new wi(e));
  }
  configureDenoisePass(t = !1) {
    this.samplesDenoise = this.generateDenoiseSamples(this.configuration.denoiseSamples, 11);
    let e = {
      ...dme
    };
    e.fragmentShader = e.fragmentShader.replace("16", this.configuration.denoiseSamples), t && (e.fragmentShader = "#define LOGDEPTH\n" + e.fragmentShader), this.poissonBlurQuad ? (this.poissonBlurQuad.material.dispose(), this.poissonBlurQuad.material = new wi(e)) : this.poissonBlurQuad = new ag(new wi(e));
  }
  configureEffectCompositer(t = !1) {
    let e = {
      ...pme
    };
    t && (e.fragmentShader = "#define LOGDEPTH\n" + e.fragmentShader), this.configuration.halfRes && this.configuration.depthAwareUpsampling && (e.fragmentShader = "#define HALFRES\n" + e.fragmentShader), this.effectCompositerQuad ? (this.effectCompositerQuad.material.dispose(), this.effectCompositerQuad.material = new wi(e)) : this.effectCompositerQuad = new ag(new wi(e));
  }
  generateHemisphereSamples(t) {
    let e = [];
    for (let n = 0; n < t; n++) {
      let i = 2.399963 * n,
        r = Math.sqrt(n + .5) / Math.sqrt(t),
        o = r * Math.cos(i),
        s = r * Math.sin(i),
        a = Math.sqrt(1 - (o * o + s * s));
      e.push(new ne(o, s, a));
    }
    return e;
  }
  generateHemisphereSamplesR(t) {
    let e = [];
    for (let n = 0; n < t; n++) e.push((n + 1) / t);
    return e;
  }
  generateDenoiseSamples(t, e) {
    let n = 2 * Math.PI * e / t,
      i = 1 / t,
      r = i,
      o = [],
      s = i,
      a = 0;
    for (let e = 0; e < t; e++) o.push(new je(Math.cos(a), Math.sin(a)).multiplyScalar(Math.pow(s, .75))), s += r, a += n;
    return o;
  }
  setSize(t, e) {
    this.width = t, this.height = e;
    let n = this.configuration.halfRes ? .5 : 1;
    this.beautyRenderTarget.setSize(t, e), this.writeTargetInternal.setSize(t * n, e * n), this.readTargetInternal.setSize(t * n, e * n), this.configuration.halfRes && this.depthDownsampleTarget.setSize(t * n, e * n);
  }
  render(t, e, n, i, r) {
    let o, s, a;
    t.capabilities.logarithmicDepthBuffer !== this.configuration.logarithmicDepthBuffer && (this.configuration.logarithmicDepthBuffer = t.capabilities.logarithmicDepthBuffer, this.configureAOPass(this.configuration.logarithmicDepthBuffer), this.configureDenoisePass(this.configuration.logarithmicDepthBuffer), this.configureEffectCompositer(this.configuration.logarithmicDepthBuffer)), this.debugMode && (o = t.getContext(), s = o.getExtension("EXT_disjoint_timer_query_webgl2"), null === s && (console.error("EXT_disjoint_timer_query_webgl2 not available, disabling debug mode."), this.debugMode = !1)), this.configuration.autoRenderBeauty && (t.setRenderTarget(this.beautyRenderTarget), t.render(this.scene, this.camera)), this.debugMode && (a = o.createQuery(), o.beginQuery(s.TIME_ELAPSED_EXT, a));
    let l = t.xr.enabled;
    t.xr.enabled = !1, this.camera.updateMatrixWorld(), this._r.set(this.width, this.height);
    let u = this.configuration.aoRadius;
    this.configuration.halfRes && this.configuration.screenSpaceRadius && (u *= .5), this.configuration.halfRes && (t.setRenderTarget(this.depthDownsampleTarget), this.depthDownsampleQuad.material.uniforms.sceneDepth.value = this.beautyRenderTarget.depthTexture, this.depthDownsampleQuad.material.uniforms.resolution.value = this._r, this.depthDownsampleQuad.material.uniforms.near.value = this.camera.near, this.depthDownsampleQuad.material.uniforms.far.value = this.camera.far, this.depthDownsampleQuad.material.uniforms.projectionMatrixInv.value = this.camera.projectionMatrixInverse, this.depthDownsampleQuad.material.uniforms.viewMatrixInv.value = this.camera.matrixWorld, this.depthDownsampleQuad.material.uniforms.logDepth.value = this.configuration.logarithmicDepthBuffer, this.depthDownsampleQuad.render(t)), this.effectShaderQuad.material.uniforms.sceneDiffuse.value = this.beautyRenderTarget.texture, this.effectShaderQuad.material.uniforms.sceneDepth.value = this.configuration.halfRes ? this.depthDownsampleTarget.texture[0] : this.beautyRenderTarget.depthTexture, this.effectShaderQuad.material.uniforms.sceneNormal.value = this.configuration.halfRes ? this.depthDownsampleTarget.texture[1] : null, this.effectShaderQuad.material.uniforms.projMat.value = this.camera.projectionMatrix, this.effectShaderQuad.material.uniforms.viewMat.value = this.camera.matrixWorldInverse, this.effectShaderQuad.material.uniforms.projViewMat.value = this.camera.projectionMatrix.clone().multiply(this.camera.matrixWorldInverse.clone()), this.effectShaderQuad.material.uniforms.projectionMatrixInv.value = this.camera.projectionMatrixInverse, this.effectShaderQuad.material.uniforms.viewMatrixInv.value = this.camera.matrixWorld, this.effectShaderQuad.material.uniforms.cameraPos.value = this.camera.getWorldPosition(new ne()), this.effectShaderQuad.material.uniforms.resolution.value = this.configuration.halfRes ? this._r.clone().multiplyScalar(.5).floor() : this._r, this.effectShaderQuad.material.uniforms.time.value = performance.now() / 1e3, this.effectShaderQuad.material.uniforms.samples.value = this.samples, this.effectShaderQuad.material.uniforms.samplesR.value = this.samplesR, this.effectShaderQuad.material.uniforms.bluenoise.value = this.bluenoise, this.effectShaderQuad.material.uniforms.radius.value = u, this.effectShaderQuad.material.uniforms.distanceFalloff.value = this.configuration.distanceFalloff, this.effectShaderQuad.material.uniforms.near.value = this.camera.near, this.effectShaderQuad.material.uniforms.far.value = this.camera.far, this.effectShaderQuad.material.uniforms.logDepth.value = t.capabilities.logarithmicDepthBuffer, this.effectShaderQuad.material.uniforms.ortho.value = this.camera.isOrthographicCamera, this.effectShaderQuad.material.uniforms.screenSpaceRadius.value = this.configuration.screenSpaceRadius, t.setRenderTarget(this.writeTargetInternal), this.effectShaderQuad.render(t);
    for (let e = 0; e < this.configuration.denoiseIterations; e++) [this.writeTargetInternal, this.readTargetInternal] = [this.readTargetInternal, this.writeTargetInternal], this.poissonBlurQuad.material.uniforms.tDiffuse.value = this.readTargetInternal.texture, this.poissonBlurQuad.material.uniforms.sceneDepth.value = this.configuration.halfRes ? this.depthDownsampleTarget.texture[0] : this.beautyRenderTarget.depthTexture, this.poissonBlurQuad.material.uniforms.projMat.value = this.camera.projectionMatrix, this.poissonBlurQuad.material.uniforms.viewMat.value = this.camera.matrixWorldInverse, this.poissonBlurQuad.material.uniforms.projectionMatrixInv.value = this.camera.projectionMatrixInverse, this.poissonBlurQuad.material.uniforms.viewMatrixInv.value = this.camera.matrixWorld, this.poissonBlurQuad.material.uniforms.cameraPos.value = this.camera.getWorldPosition(new ne()), this.poissonBlurQuad.material.uniforms.resolution.value = this.configuration.halfRes ? this._r.clone().multiplyScalar(.5).floor() : this._r, this.poissonBlurQuad.material.uniforms.time.value = performance.now() / 1e3, this.poissonBlurQuad.material.uniforms.blueNoise.value = this.bluenoise, this.poissonBlurQuad.material.uniforms.radius.value = this.configuration.denoiseRadius * (this.configuration.halfRes ? .5 : 1), this.poissonBlurQuad.material.uniforms.worldRadius.value = u, this.poissonBlurQuad.material.uniforms.distanceFalloff.value = this.configuration.distanceFalloff, this.poissonBlurQuad.material.uniforms.index.value = e, this.poissonBlurQuad.material.uniforms.poissonDisk.value = this.samplesDenoise, this.poissonBlurQuad.material.uniforms.near.value = this.camera.near, this.poissonBlurQuad.material.uniforms.far.value = this.camera.far, this.poissonBlurQuad.material.uniforms.logDepth.value = t.capabilities.logarithmicDepthBuffer, this.poissonBlurQuad.material.uniforms.screenSpaceRadius.value = this.configuration.screenSpaceRadius, t.setRenderTarget(this.writeTargetInternal), this.poissonBlurQuad.render(t);
    this.effectCompositerQuad.material.uniforms.sceneDiffuse.value = this.beautyRenderTarget.texture, this.effectCompositerQuad.material.uniforms.sceneDepth.value = this.beautyRenderTarget.depthTexture, this.effectCompositerQuad.material.uniforms.near.value = this.camera.near, this.effectCompositerQuad.material.uniforms.far.value = this.camera.far, this.effectCompositerQuad.material.uniforms.projectionMatrixInv.value = this.camera.projectionMatrixInverse, this.effectCompositerQuad.material.uniforms.viewMatrixInv.value = this.camera.matrixWorld, this.effectCompositerQuad.material.uniforms.logDepth.value = t.capabilities.logarithmicDepthBuffer, this.effectCompositerQuad.material.uniforms.ortho.value = this.camera.isOrthographicCamera, this.effectCompositerQuad.material.uniforms.downsampledDepth.value = this.configuration.halfRes ? this.depthDownsampleTarget.texture[0] : this.beautyRenderTarget.depthTexture, this.effectCompositerQuad.material.uniforms.resolution.value = this._r, this.effectCompositerQuad.material.uniforms.blueNoise.value = this.bluenoise, this.effectCompositerQuad.material.uniforms.intensity.value = this.configuration.intensity, this.effectCompositerQuad.material.uniforms.renderMode.value = this.configuration.renderMode, this.effectCompositerQuad.material.uniforms.screenSpaceRadius.value = this.configuration.screenSpaceRadius, this.effectCompositerQuad.material.uniforms.radius.value = u, this.effectCompositerQuad.material.uniforms.distanceFalloff.value = this.configuration.distanceFalloff, this.effectCompositerQuad.material.uniforms.gammaCorrection.value = this.configuration.gammaCorrection, this.effectCompositerQuad.material.uniforms.tDiffuse.value = this.writeTargetInternal.texture, this.effectCompositerQuad.material.uniforms.color.value = this._c.copy(this.configuration.color).convertSRGBToLinear(), this.effectCompositerQuad.material.uniforms.cameraPos.value = this.camera.getWorldPosition(new ne()), this.effectCompositerQuad.material.uniforms.fog.value = !!this.scene.fog, this.scene.fog && (this.scene.fog.isFog ? (this.effectCompositerQuad.material.uniforms.fogExp.value = !1, this.effectCompositerQuad.material.uniforms.fogNear.value = this.scene.fog.near, this.effectCompositerQuad.material.uniforms.fogFar.value = this.scene.fog.far) : this.scene.fog.isFogExp2 ? (this.effectCompositerQuad.material.uniforms.fogExp.value = !0, this.effectCompositerQuad.material.uniforms.fogDensity.value = this.scene.fog.density) : console.error(`Unsupported fog type ${this.scene.fog.constructor.name} in SSAOPass.`)), t.setRenderTarget(this.renderToScreen ? null : e), this.effectCompositerQuad.render(t), this.debugMode && (o.endQuery(s.TIME_ELAPSED_EXT), fz(a, o, this)), t.xr.enabled = l;
  }
  enableDebugMode() {
    this.debugMode = !0;
  }
  disableDebugMode() {
    this.debugMode = !1;
  }
  setDisplayMode(t) {
    this.configuration.renderMode = ["Combined", "AO", "No AO", "Split", "Split AO"].indexOf(t);
  }
  setQualityMode(t) {
    "Performance" === t ? (this.configuration.aoSamples = 8, this.configuration.denoiseSamples = 4, this.configuration.denoiseRadius = 12) : "Low" === t ? (this.configuration.aoSamples = 16, this.configuration.denoiseSamples = 4, this.configuration.denoiseRadius = 12) : "Medium" === t ? (this.configuration.aoSamples = 16, this.configuration.denoiseSamples = 8, this.configuration.denoiseRadius = 12) : "High" === t ? (this.configuration.aoSamples = 64, this.configuration.denoiseSamples = 8, this.configuration.denoiseRadius = 6) : "Ultra" === t && (this.configuration.aoSamples = 64, this.configuration.denoiseSamples = 16, this.configuration.denoiseRadius = 6);
  }
};
u(Dw, "$05f6997e4b65da14$export$2d57db20b5eb5e0a");
var qw = "varying vec2 vUv;\n\nvoid main() {\n    vUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n\n",
  kw = "varying vec2 vUv;\nuniform float animatedColorOpacity;\nuniform sampler2D staticSceneColorTexture;\nuniform sampler2D staticSceneDepthTexture;\nuniform sampler2D animatedSceneColorTexture;\nuniform sampler2D animatedSceneDepthTexture;\nuniform sampler2D alwaysOnTopSceneColorTexture;\n\n// Perform alpha blending between two colors with non-premultiplied\n// alpha, and return their non-premultiplied composite.\n//\n// This corresponds to the OVER porter-duff operation, aka, standard alpha\n// blending as implemented in most image editors.\nvec4 alphaBlend(vec4 background, vec4 foreground) {\n\tvec3 resultColor = (\n\t\tforeground.rgb * foreground.a +\n\t\tbackground.rgb * background.a * (1.0 - foreground.a)\n\t);\n\tfloat resultAlpha = foreground.a + background.a * (1.0 - foreground.a);\n\treturn vec4(resultColor / resultAlpha, resultAlpha);\n}\n\n// Assumes that the foreground (src) color is premultiplied with its alpha.\n// This corresponds to GL_ONE source factor and GL_ONE_MINUS_SRC_ALPHA for destination factor.\nvec4 alphaBlendPremultipliedAlpha(vec4 background, vec4 foreground) {\n\treturn foreground + (background * (1.0 - foreground.a));\n}\n\nvoid main() {\n\tfloat staticDepth = texture2D(staticSceneDepthTexture, vUv).r;\n\tfloat animatedDepth = texture2D(animatedSceneDepthTexture, vUv).r;\n\n\tvec4 staticColor = texture2D(staticSceneColorTexture, vUv).rgba;\n\tvec4 animatedColor = texture2D(animatedSceneColorTexture, vUv).rgba;\n\n\tif (staticDepth < animatedDepth) {\n\t\tanimatedColor.a *= animatedColorOpacity;\n\t}\n\t\n\tvec4 lowerColor = alphaBlend(staticColor, animatedColor);\n\tvec4 alwaysOnTopColor = texture2D(alwaysOnTopSceneColorTexture, vUv).rgba;\n\n\tgl_FragColor = alphaBlendPremultipliedAlpha(lowerColor, alwaysOnTopColor);\n\t#include <encodings_fragment>\n}\n",
  yz = Rt(pz());
E();
var gz = Rt(Q4());
E(), E();
var dz = {
  name: "CopyShader",
  uniforms: {
    tDiffuse: {
      value: null
    },
    opacity: {
      value: 1
    }
  },
  vertexShader: "\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvUv = uv;\n\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n\t\t}",
  fragmentShader: "\n\n\t\tuniform float opacity;\n\n\t\tuniform sampler2D tDiffuse;\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tgl_FragColor = texture2D( tDiffuse, vUv );\n\t\t\tgl_FragColor.a *= opacity;\n\n\n\t\t}"
};
E();
var lg = class extends yl {
  constructor(t, e) {
    super(), this.textureID = void 0 !== e ? e : "tDiffuse", t instanceof wi ? (this.uniforms = t.uniforms, this.material = t) : t && (this.uniforms = iS.clone(t.uniforms), this.material = new wi({
      name: void 0 !== t.name ? t.name : "unspecified",
      defines: Object.assign({}, t.defines),
      uniforms: this.uniforms,
      vertexShader: t.vertexShader,
      fragmentShader: t.fragmentShader
    })), this.fsQuad = new Nw(this.material);
  }
  render(t, e, n) {
    this.uniforms[this.textureID] && (this.uniforms[this.textureID].value = n.texture), this.fsQuad.material = this.material, this.renderToScreen ? (t.setRenderTarget(null), this.fsQuad.render(t)) : (t.setRenderTarget(e), this.clear && t.clear(t.autoClearColor, t.autoClearDepth, t.autoClearStencil), this.fsQuad.render(t));
  }
  dispose() {
    this.material.dispose(), this.fsQuad.dispose();
  }
};
u(lg, "ShaderPass"), E();
var y_ = class extends yl {
  constructor(t, e) {
    super(), this.scene = t, this.camera = e, this.clear = !0, this.needsSwap = !1, this.inverse = !1;
  }
  render(t, e, n) {
    let i,
      r,
      o = t.getContext(),
      s = t.state;
    s.buffers.color.setMask(!1), s.buffers.depth.setMask(!1), s.buffers.color.setLocked(!0), s.buffers.depth.setLocked(!0), this.inverse ? (i = 0, r = 1) : (i = 1, r = 0), s.buffers.stencil.setTest(!0), s.buffers.stencil.setOp(o.REPLACE, o.REPLACE, o.REPLACE), s.buffers.stencil.setFunc(o.ALWAYS, i, 4294967295), s.buffers.stencil.setClear(r), s.buffers.stencil.setLocked(!0), t.setRenderTarget(n), this.clear && t.clear(), t.render(this.scene, this.camera), t.setRenderTarget(e), this.clear && t.clear(), t.render(this.scene, this.camera), s.buffers.color.setLocked(!1), s.buffers.depth.setLocked(!1), s.buffers.stencil.setLocked(!1), s.buffers.stencil.setFunc(o.EQUAL, 1, 4294967295), s.buffers.stencil.setOp(o.KEEP, o.KEEP, o.KEEP), s.buffers.stencil.setLocked(!0);
  }
};
u(y_, "MaskPass");
var Fw = class extends yl {
  constructor() {
    super(), this.needsSwap = !1;
  }
  render(t) {
    t.state.buffers.stencil.setLocked(!1), t.state.buffers.stencil.setTest(!1);
  }
};
u(Fw, "ClearMaskPass");
var Bw = class {
  constructor(t, e) {
    if (this.renderer = t, this._pixelRatio = t.getPixelRatio(), void 0 === e) {
      let n = t.getSize(new je());
      this._width = n.width, this._height = n.height, (e = new wr(this._width * this._pixelRatio, this._height * this._pixelRatio, {
        type: Iu
      })).texture.name = "EffectComposer.rt1";
    } else this._width = e.width, this._height = e.height;
    this.renderTarget1 = e, this.renderTarget2 = e.clone(), this.renderTarget2.texture.name = "EffectComposer.rt2", this.writeBuffer = this.renderTarget1, this.readBuffer = this.renderTarget2, this.renderToScreen = !0, this.passes = [], this.copyPass = new lg(dz), this.clock = new wd();
  }
  swapBuffers() {
    let t = this.readBuffer;
    this.readBuffer = this.writeBuffer, this.writeBuffer = t;
  }
  addPass(t) {
    this.passes.push(t), t.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
  }
  insertPass(t, e) {
    this.passes.splice(e, 0, t), t.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
  }
  removePass(t) {
    let e = this.passes.indexOf(t);
    -1 !== e && this.passes.splice(e, 1);
  }
  isLastEnabledPass(t) {
    for (let e = t + 1; e < this.passes.length; e++) if (this.passes[e].enabled) return !1;
    return !0;
  }
  render(t) {
    void 0 === t && (t = this.clock.getDelta());
    let e = this.renderer.getRenderTarget(),
      n = !1;
    for (let e = 0, i = this.passes.length; e < i; e++) {
      let i = this.passes[e];
      if (!1 !== i.enabled) {
        if (i.renderToScreen = this.renderToScreen && this.isLastEnabledPass(e), i.render(this.renderer, this.writeBuffer, this.readBuffer, t, n), i.needsSwap) {
          if (n) {
            let e = this.renderer.getContext(),
              n = this.renderer.state.buffers.stencil;
            n.setFunc(e.NOTEQUAL, 1, 4294967295), this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, t), n.setFunc(e.EQUAL, 1, 4294967295);
          }
          this.swapBuffers();
        }
        void 0 !== y_ && (i instanceof y_ ? n = !0 : i instanceof Fw && (n = !1));
      }
    }
    this.renderer.setRenderTarget(e);
  }
  reset(t) {
    if (void 0 === t) {
      let e = this.renderer.getSize(new je());
      this._pixelRatio = this.renderer.getPixelRatio(), this._width = e.width, this._height = e.height, (t = this.renderTarget1.clone()).setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    this.renderTarget1.dispose(), this.renderTarget2.dispose(), this.renderTarget1 = t, this.renderTarget2 = t.clone(), this.writeBuffer = this.renderTarget1, this.readBuffer = this.renderTarget2;
  }
  setSize(t, e) {
    this._width = t, this._height = e;
    let n = this._width * this._pixelRatio,
      i = this._height * this._pixelRatio;
    this.renderTarget1.setSize(n, i), this.renderTarget2.setSize(n, i);
    for (let t = 0; t < this.passes.length; t++) this.passes[t].setSize(n, i);
  }
  setPixelRatio(t) {
    this._pixelRatio = t, this.setSize(this._width, this._height);
  }
  dispose() {
    this.renderTarget1.dispose(), this.renderTarget2.dispose(), this.copyPass.dispose();
  }
};
u(Bw, "EffectComposer"), E();
var Uw = class extends yl {
  constructor(t, e, n, i, r) {
    super(), this.scene = t, this.camera = e, this.overrideMaterial = n, this.clearColor = i, this.clearAlpha = void 0 !== r ? r : 0, this.clear = !0, this.clearDepth = !1, this.needsSwap = !1, this._oldClearColor = new yt();
  }
  render(t, e, n) {
    let i,
      r,
      o = t.autoClear;
    t.autoClear = !1, void 0 !== this.overrideMaterial && (r = this.scene.overrideMaterial, this.scene.overrideMaterial = this.overrideMaterial), this.clearColor && (t.getClearColor(this._oldClearColor), i = t.getClearAlpha(), t.setClearColor(this.clearColor, this.clearAlpha)), this.clearDepth && t.clearDepth(), t.setRenderTarget(this.renderToScreen ? null : n), this.clear && t.clear(t.autoClearColor, t.autoClearDepth, t.autoClearStencil), t.render(this.scene, this.camera), this.clearColor && t.setClearColor(this._oldClearColor, i), void 0 !== this.overrideMaterial && (this.scene.overrideMaterial = r), t.autoClear = o;
  }
};
u(Uw, "RenderPass"), E();
var __,
  mz = {
    uniforms: {
      tDiffuse: {
        value: null
      },
      resolution: {
        value: new je(1 / 1024, 1 / 512)
      }
    },
    vertexShader: "\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvUv = uv;\n\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n\t\t}",
    fragmentShader: "\n\tprecision highp float;\n\n\tuniform sampler2D tDiffuse;\n\n\tuniform vec2 resolution;\n\n\tvarying vec2 vUv;\n\n\t// FXAA 3.11 implementation by NVIDIA, ported to WebGL by Agost Biro (biro@archilogic.com)\n\n\t//----------------------------------------------------------------------------------\n\t// File:        es3-keplerFXAAassetsshaders/FXAA_DefaultES.frag\n\t// SDK Version: v3.00\n\t// Email:       gameworks@nvidia.com\n\t// Site:        http://developer.nvidia.com/\n\t//\n\t// Copyright (c) 2014-2015, NVIDIA CORPORATION. All rights reserved.\n\t//\n\t// Redistribution and use in source and binary forms, with or without\n\t// modification, are permitted provided that the following conditions\n\t// are met:\n\t//  * Redistributions of source code must retain the above copyright\n\t//    notice, this list of conditions and the following disclaimer.\n\t//  * Redistributions in binary form must reproduce the above copyright\n\t//    notice, this list of conditions and the following disclaimer in the\n\t//    documentation and/or other materials provided with the distribution.\n\t//  * Neither the name of NVIDIA CORPORATION nor the names of its\n\t//    contributors may be used to endorse or promote products derived\n\t//    from this software without specific prior written permission.\n\t//\n\t// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS ''AS IS'' AND ANY\n\t// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n\t// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR\n\t// PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR\n\t// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,\n\t// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,\n\t// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR\n\t// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY\n\t// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n\t// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n\t// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n\t//\n\t//----------------------------------------------------------------------------------\n\n\t#ifndef FXAA_DISCARD\n\t\t\t//\n\t\t\t// Only valid for PC OpenGL currently.\n\t\t\t// Probably will not work when FXAA_GREEN_AS_LUMA = 1.\n\t\t\t//\n\t\t\t// 1 = Use discard on pixels which don't need AA.\n\t\t\t//     For APIs which enable concurrent TEX+ROP from same surface.\n\t\t\t// 0 = Return unchanged color on pixels which don't need AA.\n\t\t\t//\n\t\t\t#define FXAA_DISCARD 0\n\t#endif\n\n\t/*--------------------------------------------------------------------------*/\n\t#define FxaaTexTop(t, p) texture2D(t, p, -100.0)\n\t#define FxaaTexOff(t, p, o, r) texture2D(t, p + (o * r), -100.0)\n\t/*--------------------------------------------------------------------------*/\n\n\t#define NUM_SAMPLES 5\n\n\t// assumes colors have premultipliedAlpha, so that the calculated color contrast is scaled by alpha\n\tfloat contrast( vec4 a, vec4 b ) {\n\t\t\tvec4 diff = abs( a - b );\n\t\t\treturn max( max( max( diff.r, diff.g ), diff.b ), diff.a );\n\t}\n\n\t/*============================================================================\n\n\t\t\t\t\t\t\t\t\tFXAA3 QUALITY - PC\n\n\t============================================================================*/\n\n\t/*--------------------------------------------------------------------------*/\n\tvec4 FxaaPixelShader(\n\t\t\tvec2 posM,\n\t\t\tsampler2D tex,\n\t\t\tvec2 fxaaQualityRcpFrame,\n\t\t\tfloat fxaaQualityEdgeThreshold,\n\t\t\tfloat fxaaQualityinvEdgeThreshold\n\t) {\n\t\t\tvec4 rgbaM = FxaaTexTop(tex, posM);\n\t\t\tvec4 rgbaS = FxaaTexOff(tex, posM, vec2( 0.0, 1.0), fxaaQualityRcpFrame.xy);\n\t\t\tvec4 rgbaE = FxaaTexOff(tex, posM, vec2( 1.0, 0.0), fxaaQualityRcpFrame.xy);\n\t\t\tvec4 rgbaN = FxaaTexOff(tex, posM, vec2( 0.0,-1.0), fxaaQualityRcpFrame.xy);\n\t\t\tvec4 rgbaW = FxaaTexOff(tex, posM, vec2(-1.0, 0.0), fxaaQualityRcpFrame.xy);\n\t\t\t// . S .\n\t\t\t// W M E\n\t\t\t// . N .\n\n\t\t\tbool earlyExit = max( max( max(\n\t\t\t\t\tcontrast( rgbaM, rgbaN ),\n\t\t\t\t\tcontrast( rgbaM, rgbaS ) ),\n\t\t\t\t\tcontrast( rgbaM, rgbaE ) ),\n\t\t\t\t\tcontrast( rgbaM, rgbaW ) )\n\t\t\t\t\t< fxaaQualityEdgeThreshold;\n\t\t\t// . 0 .\n\t\t\t// 0 0 0\n\t\t\t// . 0 .\n\n\t\t\t#if (FXAA_DISCARD == 1)\n\t\t\t\t\tif(earlyExit) FxaaDiscard;\n\t\t\t#else\n\t\t\t\t\tif(earlyExit) return rgbaM;\n\t\t\t#endif\n\n\t\t\tfloat contrastN = contrast( rgbaM, rgbaN );\n\t\t\tfloat contrastS = contrast( rgbaM, rgbaS );\n\t\t\tfloat contrastE = contrast( rgbaM, rgbaE );\n\t\t\tfloat contrastW = contrast( rgbaM, rgbaW );\n\n\t\t\tfloat relativeVContrast = ( contrastN + contrastS ) - ( contrastE + contrastW );\n\t\t\trelativeVContrast *= fxaaQualityinvEdgeThreshold;\n\n\t\t\tbool horzSpan = relativeVContrast > 0.;\n\t\t\t// . 1 .\n\t\t\t// 0 0 0\n\t\t\t// . 1 .\n\n\t\t\t// 45 deg edge detection and corners of objects, aka V/H contrast is too similar\n\t\t\tif( abs( relativeVContrast ) < .3 ) {\n\t\t\t\t\t// locate the edge\n\t\t\t\t\tvec2 dirToEdge;\n\t\t\t\t\tdirToEdge.x = contrastE > contrastW ? 1. : -1.;\n\t\t\t\t\tdirToEdge.y = contrastS > contrastN ? 1. : -1.;\n\t\t\t\t\t// . 2 .      . 1 .\n\t\t\t\t\t// 1 0 2  ~=  0 0 1\n\t\t\t\t\t// . 1 .      . 0 .\n\n\t\t\t\t\t// tap 2 pixels and see which ones are \"outside\" the edge, to\n\t\t\t\t\t// determine if the edge is vertical or horizontal\n\n\t\t\t\t\tvec4 rgbaAlongH = FxaaTexOff(tex, posM, vec2( dirToEdge.x, -dirToEdge.y ), fxaaQualityRcpFrame.xy);\n\t\t\t\t\tfloat matchAlongH = contrast( rgbaM, rgbaAlongH );\n\t\t\t\t\t// . 1 .\n\t\t\t\t\t// 0 0 1\n\t\t\t\t\t// . 0 H\n\n\t\t\t\t\tvec4 rgbaAlongV = FxaaTexOff(tex, posM, vec2( -dirToEdge.x, dirToEdge.y ), fxaaQualityRcpFrame.xy);\n\t\t\t\t\tfloat matchAlongV = contrast( rgbaM, rgbaAlongV );\n\t\t\t\t\t// V 1 .\n\t\t\t\t\t// 0 0 1\n\t\t\t\t\t// . 0 .\n\n\t\t\t\t\trelativeVContrast = matchAlongV - matchAlongH;\n\t\t\t\t\trelativeVContrast *= fxaaQualityinvEdgeThreshold;\n\n\t\t\t\t\tif( abs( relativeVContrast ) < .3 ) { // 45 deg edge\n\t\t\t\t\t\t\t// 1 1 .\n\t\t\t\t\t\t\t// 0 0 1\n\t\t\t\t\t\t\t// . 0 1\n\n\t\t\t\t\t\t\t// do a simple blur\n\t\t\t\t\t\t\treturn mix(\n\t\t\t\t\t\t\t\t\trgbaM,\n\t\t\t\t\t\t\t\t\t(rgbaN + rgbaS + rgbaE + rgbaW) * .25,\n\t\t\t\t\t\t\t\t\t.4\n\t\t\t\t\t\t\t);\n\t\t\t\t\t}\n\n\t\t\t\t\thorzSpan = relativeVContrast > 0.;\n\t\t\t}\n\n\t\t\tif(!horzSpan) rgbaN = rgbaW;\n\t\t\tif(!horzSpan) rgbaS = rgbaE;\n\t\t\t// . 0 .      1\n\t\t\t// 1 0 1  ->  0\n\t\t\t// . 0 .      1\n\n\t\t\tbool pairN = contrast( rgbaM, rgbaN ) > contrast( rgbaM, rgbaS );\n\t\t\tif(!pairN) rgbaN = rgbaS;\n\n\t\t\tvec2 offNP;\n\t\t\toffNP.x = (!horzSpan) ? 0.0 : fxaaQualityRcpFrame.x;\n\t\t\toffNP.y = ( horzSpan) ? 0.0 : fxaaQualityRcpFrame.y;\n\n\t\t\tbool doneN = false;\n\t\t\tbool doneP = false;\n\n\t\t\tfloat nDist = 0.;\n\t\t\tfloat pDist = 0.;\n\n\t\t\tvec2 posN = posM;\n\t\t\tvec2 posP = posM;\n\n\t\t\tint iterationsUsed = 0;\n\t\t\tint iterationsUsedN = 0;\n\t\t\tint iterationsUsedP = 0;\n\t\t\tfor( int i = 0; i < NUM_SAMPLES; i++ ) {\n\t\t\t\t\titerationsUsed = i;\n\n\t\t\t\t\tfloat increment = float(i + 1);\n\n\t\t\t\t\tif(!doneN) {\n\t\t\t\t\t\t\tnDist += increment;\n\t\t\t\t\t\t\tposN = posM + offNP * nDist;\n\t\t\t\t\t\t\tvec4 rgbaEndN = FxaaTexTop(tex, posN.xy);\n\t\t\t\t\t\t\tdoneN = contrast( rgbaEndN, rgbaM ) > contrast( rgbaEndN, rgbaN );\n\t\t\t\t\t\t\titerationsUsedN = i;\n\t\t\t\t\t}\n\n\t\t\t\t\tif(!doneP) {\n\t\t\t\t\t\t\tpDist += increment;\n\t\t\t\t\t\t\tposP = posM - offNP * pDist;\n\t\t\t\t\t\t\tvec4 rgbaEndP = FxaaTexTop(tex, posP.xy);\n\t\t\t\t\t\t\tdoneP = contrast( rgbaEndP, rgbaM ) > contrast( rgbaEndP, rgbaN );\n\t\t\t\t\t\t\titerationsUsedP = i;\n\t\t\t\t\t}\n\n\t\t\t\t\tif(doneN || doneP) break;\n\t\t\t}\n\n\n\t\t\tif ( !doneP && !doneN ) return rgbaM; // failed to find end of edge\n\n\t\t\tfloat dist = min(\n\t\t\t\t\tdoneN ? float( iterationsUsedN ) / float( NUM_SAMPLES - 1 ) : 1.,\n\t\t\t\t\tdoneP ? float( iterationsUsedP ) / float( NUM_SAMPLES - 1 ) : 1.\n\t\t\t);\n\n\t\t\t// hacky way of reduces blurriness of mostly diagonal edges\n\t\t\t// but reduces AA quality\n\t\t\tdist = pow(dist, .5);\n\n\t\t\tdist = 1. - dist;\n\n\t\t\treturn mix(\n\t\t\t\t\trgbaM,\n\t\t\t\t\trgbaN,\n\t\t\t\t\tdist * .5\n\t\t\t);\n\t}\n\n\tvoid main() {\n\t\t\tconst float edgeDetectionQuality = .2;\n\t\t\tconst float invEdgeDetectionQuality = 1. / edgeDetectionQuality;\n\n\t\t\tgl_FragColor = FxaaPixelShader(\n\t\t\t\t\tvUv,\n\t\t\t\t\ttDiffuse,\n\t\t\t\t\tresolution,\n\t\t\t\t\tedgeDetectionQuality, // [0,1] contrast needed, otherwise early discard\n\t\t\t\t\tinvEdgeDetectionQuality\n\t\t\t);\n\n\t}\n\t"
  },
  _me = ["Performance", "Low", "Medium", "High", "Ultra"],
  xme = u(t => {
    for (let e of _me) if (t.toLowerCase() === e.toLowerCase()) return e;
    return "Medium";
  }, "getAmbientOcclusionQuality"),
  bme = u((t, e, n, i) => {
    let r = xme(i.aoQuality),
      o = i.aoResolution,
      s = new Dw(t, e, n.width, n.height);
    return s.configuration.aoRadius = 5, s.configuration.intensity = 5, s.configuration.screenSpaceRadius = !0, "half" === o && (s.configuration.halfRes = !0), s.setQualityMode(r), s;
  }, "initAmbientOcclusion"),
  vz = u((t, e, n, i) => {
    let {
      aoQuality: r,
      aoResolution: o,
      antialias: s,
      aoEnabled: a
    } = (0, gz.default)({}, {
      antialias: !1,
      aoEnabled: !1,
      aoQuality: "medium",
      aoResolution: "half"
    }, i);
    n.renderer.autoClearStencil = !1;
    let l = [],
      u = new Bw(n.renderer),
      h = new Uw(t, e);
    if (h.clearColor = n.backgroundColor, h.clearAlpha = n.backgroundAlpha, l.push(h), a) {
      let i = bme(t, e, n, {
        aoQuality: r,
        aoResolution: o
      });
      l.push(i);
    }
    if (s) {
      let t = new lg(mz);
      t.material.uniforms.resolution.value.x = 1 / n.width, t.material.uniforms.resolution.value.y = 1 / n.height, l.push(t);
    }
    for (let t of l) u.addPass(t);
    n.composer = u;
  }, "initPostprocessing"),
  x6 = !1;
x6 && ((__ = new yz.default()).showPanel(0), document.body.appendChild(__.dom));
var ug = class {
  constructor(t) {
    t.multiBufferRendering = t.multiBufferRendering || !1, this.contextLost = !1, this.implementation = this.getRenderer(t), this.onWebGLContextCreationError = t.onWebGLContextCreationError, this.onWebGLContextLost = t.onWebGLContextLost, this.onWebGLContextRestored = t.onWebGLContextRestored, this.webGLContextCreationErrorListener = this.domElement().addEventListener("webglcontextcreationerror", t => this.reportWebGlContextCreationError(t)), this.webGLContextLostListener = this.domElement().addEventListener("webglcontextlost", t => this.reportWebGlContextLost(t)), this.webGLContextRestoredListener = this.domElement().addEventListener("webglcontextrestored", t => this.reportWebGLContextRestored(t));
    let e = t.backgroundColor;
    "string" == typeof e && (e = new yt(t.backgroundColor)), null == e && (e = new yt("#ffffff"));
    let n = t.backgroundAlpha;
    null == n && (n = 1), this.shouldConsiderAlpha = t.alpha || !1, this.antialias = t.antialias || !1, this.setBackgroundColor(e, n);
  }
  destroy() {
    this.domElement().removeEventListener("webglcontextcreationerror", this.webGLContextCreationErrorListener), this.domElement().removeEventListener("webglcontextlost", this.webGLContextLostListener), this.domElement().removeEventListener("webglcontextrestored", this.webGLContextRestoredListener), this.implementation.destroy();
  }
  render(t, e, n, i) {
    this.implementation.render(t, e, n, i);
  }
  getMaxAnisotropy() {
    return this.implementation.renderer.capabilities.getMaxAnisotropy();
  }
  getBufferSize() {
    return this.implementation.renderer.getSize(new je());
  }
  getContext() {
    return this.implementation.renderer.getContext();
  }
  preloadTexture(t) {
    this.implementation.renderer.initTexture(t);
  }
  setBufferSize(t, e) {
    this.implementation.setBufferSize(t, e);
  }
  get backgroundColor() {
    return this.implementation.backgroundColor;
  }
  get backgroundAlpha() {
    return this.implementation.backgroundAlpha;
  }
  setBackgroundColor(t, e) {
    this.shouldConsiderAlpha || (e = 1), e = (e = void 0 !== e ? +e : 1) >= 0 && e <= 1 ? e : 1, this.implementation.setBackgroundColor(t, e);
  }
  setMapboxOutdoorContext(t) {
    this.implementation.setMapboxOutdoorContext(t);
  }
  domElement() {
    return this.implementation.renderer.domElement;
  }
  isAvailable() {
    return null != this.implementation.renderer && !this.contextLost;
  }
  disposeOfRenderLists() {
    this.implementation.renderer.renderLists.dispose();
  }
  reportWebGlContextCreationError(t) {
    this.onWebGLContextCreationError && this.onWebGLContextCreationError(t);
  }
  reportWebGlContextLost(t) {
    t.preventDefault(), this.onWebGLContextLost && this.onWebGLContextLost(t), this.contextLost = !0;
  }
  reportWebGLContextRestored() {
    this.onWebGLContextRestored && this.onWebGLContextRestored(), this.contextLost = !1;
  }
  getTargetWebGLVersion(t) {
    let e = /(AppleWebKit)/.test(navigator.userAgent),
      n = /(Mac)/.test(navigator.platform),
      i = t.getExtension("WEBGL_debug_renderer_info"),
      r = /radeon\spro\s4\d\d|radeon\spro\s5\d\d/i.test(t.getParameter(i.UNMASKED_RENDERER_WEBGL));
    return e && n && r ? 1 : 2;
  }
  getRenderer(t) {
    let e = t.multiBufferRendering ? M6 : b6,
      n = new e(t),
      i = this.getTargetWebGLVersion(n.renderer.getContext());
    return 2 === i ? n : new e(t, i);
  }
};
u(ug, "Renderer");
var x_,
  b6 = class {
    constructor(t, e = 2) {
      re(this, x_, !1);
      try {
        this.aoEnabled = 2 === e && t.aoEnabled, this.options = t;
        let n = {
          alpha: t.alpha || !1,
          stencil: !0,
          outputEncoding: Pl,
          antialias: !this.aoEnabled && t.antialias,
          powerPreference: "high-performance",
          preserveDrawingBuffer: !0
        };
        this.renderer = 2 === e ? new vd(n) : new yd(n);
      } catch (e) {
        t.onWebGLRendererError && t.onWebGLRendererError(e);
      }
      this.backgroundColor = new yt(), this.backgroundAlpha = 1, this.mapboxOutdoorContext = null;
    }
    destroy() {
      this.renderer.dispose();
    }
    render(t, e, n, i) {
      i.layers.enable(bo.STATIC), i.layers.enable(bo.ANIMATED), i.layers.enable(bo.ALWAYS_ON_TOP), x6 && __.begin(), this.renderer.setClearColor(this.backgroundColor, this.backgroundAlpha), this.aoEnabled ? (w(this, x_) || (vz(n, i, this, this.options), he(this, x_, !0)), this.renderer.clearStencil(), this.composer.render(this.renderer)) : (this.renderer.autoClear = !1, this.renderer.setRenderTarget(e), this.renderer.clear(), this.renderer.render(n, i)), x6 && __.end(), null != this.mapboxOutdoorContext && (this.renderer.state.reset(), this.mapboxOutdoorContext.render({
        resolution: this.renderer.getSize(new je()),
        camera: i
      }), this.renderer.state.reset());
    }
    setBufferSize(t, e) {
      this.width = t, this.height = e, this.renderer.setSize(t, e, !1), this.composer && this.composer.setSize(t, e, !1);
    }
    setBackgroundColor(t, e) {
      this.backgroundColor = t, this.backgroundAlpha = e;
    }
    setMapboxOutdoorContext(t) {
      this.mapboxOutdoorContext = t;
    }
  };
u(b6, "SingleBufferRenderer"), x_ = new WeakMap();
var E6,
  M6 = class {
    constructor(t, e = 2) {
      re(this, E6, !1);
      try {
        this.options = t;
        let n = {
          alpha: t.alpha || !1,
          stencil: !0,
          outputEncoding: Pl,
          powerPreference: "high-performance",
          preserveDrawingBuffer: !0
        };
        this.renderer = 2 === e ? new vd(n) : new yd(n);
      } catch (e) {
        t.onWebGLRendererError && t.onWebGLRendererError(e);
      }
      this.journeyOpacity = t.xRayPath ? .3 : 0, this.backgroundColor = new yt(), this.backgroundAlpha = 1, this.mapboxOutdoorContext = null;
      this.staticSceneRenderTarget = new wr(this.renderer.width, this.renderer.height), this.staticSceneRenderTarget.texture.format = Po, this.staticSceneRenderTarget.texture.minFilter = ni, this.staticSceneRenderTarget.texture.magFilter = ni, this.staticSceneRenderTarget.texture.generateMipmaps = !1, this.staticSceneRenderTarget.stencilBuffer = !0, this.staticSceneRenderTarget.depthBuffer = !0, this.staticSceneRenderTarget.depthTexture = new Vu(this.renderer.width, this.renderer.height), this.staticSceneRenderTarget.depthTexture.type = Ps, this.staticSceneRenderTarget.samples = 0, this.animatedSceneRenderTarget = new wr(this.renderer.width, this.renderer.height), this.animatedSceneRenderTarget.texture.format = Po, this.animatedSceneRenderTarget.stencilBuffer = !0, this.animatedSceneRenderTarget.texture.minFilter = ni, this.animatedSceneRenderTarget.texture.magFilter = ni, this.animatedSceneRenderTarget.texture.generateMipmaps = !1, this.animatedSceneRenderTarget.stencilBuffer = !0, this.animatedSceneRenderTarget.depthBuffer = !0, this.animatedSceneRenderTarget.depthTexture = new Vu(this.renderer.width, this.renderer.height), this.animatedSceneRenderTarget.depthTexture.type = Ps, this.animatedSceneRenderTarget.samples = 0, this.alwaysOnTopSceneRenderTarget = new wr(this.renderer.width, this.renderer.height), this.alwaysOnTopSceneRenderTarget.texture.format = Po, this.alwaysOnTopSceneRenderTarget.texture.minFilter = ni, this.alwaysOnTopSceneRenderTarget.texture.magFilter = ni, this.alwaysOnTopSceneRenderTarget.texture.generateMipmaps = !1, this.alwaysOnTopSceneRenderTarget.stencilBuffer = !0, this.alwaysOnTopSceneRenderTarget.depthBuffer = !0, this.alwaysOnTopSceneRenderTarget.depthTexture = new Vu(this.renderer.width, this.renderer.height), this.alwaysOnTopSceneRenderTarget.depthTexture.type = Ps, this.alwaysOnTopSceneRenderTarget.samples = 0, this.compositeUniforms = {
        animatedColorOpacity: {
          type: "f",
          value: this.journeyOpacity
        },
        staticSceneColorTexture: {
          type: "t",
          value: this.staticSceneRenderTarget.texture
        },
        staticSceneDepthTexture: {
          type: "t",
          value: this.staticSceneRenderTarget.depthTexture
        },
        animatedSceneColorTexture: {
          type: "t",
          value: this.animatedSceneRenderTarget.texture
        },
        animatedSceneDepthTexture: {
          type: "t",
          value: this.animatedSceneRenderTarget.depthTexture
        },
        alwaysOnTopSceneColorTexture: {
          type: "t",
          value: this.alwaysOnTopSceneRenderTarget.texture
        }
      }, this.compositeCamera = new Ll(-1, 1, 1, -1, 0, 1), this.compositeMaterial = new wi({
        uniforms: this.compositeUniforms,
        vertexShader: qw,
        fragmentShader: kw
      }), this.compositeFullscreenQuad = new Ft(new co(2, 2), this.compositeMaterial), this.compositeScene = new _d(), this.compositeScene.add(this.compositeFullscreenQuad);
    }
    destroy() {
      this.staticSceneRenderTarget.dispose(), this.animatedSceneRenderTarget.dispose(), this.alwaysOnTopSceneRenderTarget.dispose(), this.renderer.dispose();
    }
    renderComposite(t) {
      this.renderer.setRenderTarget(t), this.renderer.clear(), this.renderer.getContext().depthMask(!1), this.renderer.render(this.compositeScene, this.compositeCamera), this.renderer.getContext().depthMask(!0);
    }
    renderToAnimatedBuffer(t, e) {
      e.layers.set(bo.ANIMATED), this.renderer.setClearColor(new yt(), 0), this.renderer.setRenderTarget(this.animatedSceneRenderTarget), this.renderer.clear(), this.renderer.render(t, e);
    }
    renderAnimated(t, e, n) {
      this.renderToAnimatedBuffer(e, n), this.renderComposite(t);
    }
    renderToAlwaysOnTopBuffer(t, e) {
      e.layers.set(bo.ALWAYS_ON_TOP), this.renderer.setClearColor(new yt(), 0), this.renderer.setRenderTarget(this.alwaysOnTopSceneRenderTarget), this.renderer.clear(), this.renderer.render(t, e);
    }
    renderAlwaysOnTop(t, e, n) {
      this.renderToAlwaysOnTopBuffer(e, n), this.renderComposite(t);
    }
    renderAll(t, e, n) {
      n.layers.set(bo.STATIC), this.renderer.autoClear = !1, this.renderer.setClearColor(this.backgroundColor, this.backgroundAlpha), this.renderer.setRenderTarget(this.staticSceneRenderTarget), this.renderer.clear(), this.renderer.render(e, n), null != this.mapboxOutdoorContext && (this.renderer.state.reset(), this.mapboxOutdoorContext.render({
        resolution: this.renderer.getSize(new je()),
        camera: n,
        renderTarget: this.staticSceneRenderTarget
      }), this.renderer.state.reset()), this.renderToAnimatedBuffer(e, n), this.renderToAlwaysOnTopBuffer(e, n), this.renderComposite(t);
    }
    render(t, e, n, i) {
      this.options.aoEnabled;
      t === hi.ANIMATED ? this.renderAnimated(e, n, i) : t === hi.ALWAYS_ON_TOP ? this.renderAlwaysOnTop(e, n, i) : t === hi.ALL ? this.renderAll(e, n, i) : ke.error("Renderer.render called with invalid renderTask");
    }
    setBufferSize(t, e) {
      this.width = t, this.height = e, this.renderer.setSize(t, e, !1), this.staticSceneRenderTarget.setSize(t, e), this.animatedSceneRenderTarget.setSize(t, e), this.alwaysOnTopSceneRenderTarget.setSize(t, e);
    }
    setBackgroundColor(t, e) {
      this.backgroundColor = t, this.backgroundAlpha = e;
    }
    setMapboxOutdoorContext(t) {
      this.mapboxOutdoorContext = t;
    }
  };
u(M6, "MultiBufferRenderer"), E6 = new WeakMap(), E(), E();
var vp = 20,
  Mme = 14,
  _z = 8,
  zw = 72,
  b_ = 16,
  xz = 12,
  Eme = 52,
  wme = 4,
  Vw = 2,
  w6 = 8,
  S6 = 128,
  T6 = 320,
  mr = 8,
  bz = 2,
  Sme = 2 / (Math.sqrt(5) + 1) * 360 / 6,
  Tme = 60,
  Pme = 5,
  cg = class {
    constructor() {
      this._element = document.createElement("div"), this._titleElement = document.createElement("select"), this._minimizeElement = document.createElement("button"), this._performancePanelElement = document.createElement("div"), this._performanceEntries = new Map(), this._sortedPerformanceEntryNames = [];
      let t = document.createElement("option");
      t.value = "Performance", t.innerHTML = "Performance", t.selected = "selected", this._titleElement.appendChild(t), this._titleElement.addEventListener("change", this._onCategoryChanged.bind(this)), this._overviewGraph = new Gw({
        width: T6,
        height: S6,
        seriesList: []
      }), this._controlPanels = new Map(), this._sortedControlPanelNames = [], this._minimized = !1, this._element.appendChild(this._titleElement), this._element.appendChild(this._minimizeElement), this._element.appendChild(this._performancePanelElement), this._performancePanelElement.appendChild(this._overviewGraph.element), this._layout(), this._minimizeElement.addEventListener("click", this._onMinimizeClicked.bind(this)), null == window.MappedinDebug && (window.MappedinDebug = {}), window.MappedinDebug.DebugUI = this;
    }
    destroy() {
      for (let t of this._performanceEntries.values()) t.destroy();
      for (let t of this._controlPanels.values()) t.destroy();
      this._controlPanels = null, this._performanceEntries = null, this._element = null, this._titleElement = null, this._minimizeElement = null, this._performancePanelElement = null, this._overviewGraph = null, Object.setPrototypeOf(this, null);
    }
    get element() {
      return this._element;
    }
    reportFramePerformance(t) {
      let e = !1;
      for (let n in t) {
        if (!this._performanceEntries.has(n)) {
          let t = new P6({
            name: n
          });
          this._performanceEntries.set(n, t), this._performancePanelElement.appendChild(t.element), this._sortedPerformanceEntryNames.push(n), this._sortedPerformanceEntryNames.sort(), e = !0;
        }
        this._performanceEntries.get(n).report(t[n]);
      }
      for (let e of this._performanceEntries.keys()) null == t[e] && this._performanceEntries.get(e).report(0);
      e && this._updateLayout();
      for (let t of this._performanceEntries.values()) if (t.series.changed()) {
        this._overviewGraph.redraw();
        break;
      }
    }
    addDebugControls(t) {
      for (let e in t) {
        for (let n of t[e]) {
          let {
            name: t,
            description: i,
            control: r
          } = n;
          this._addDebugControl(e, t, i, r);
        }
        this._controlPanels.get(e)._updateLayout();
      }
      this._updateLayout();
    }
    addDebugControl(t, e, n, i) {
      this._addDebugControl(t, e, n, i), this._updateLayout(), this._controlPanels.get(t)._updateLayout();
    }
    removeDebugControls(t) {
      for (let e in t) {
        for (let n of t[e]) this._removeDebugControl(e, n);
        this._controlPanels.get(e)._updateLayout();
      }
      this._updateLayout();
    }
    removeDebugControl(t, e) {
      this._removeDebugControl(t, e), this._updateLayout(), this._controlPanels.get(t)._updateLayout();
    }
    _addDebugControl(t, e, n, i) {
      if (!this._controlPanels.has(t)) {
        let e = new Ow({
          name: t
        });
        this._controlPanels.set(t, e), this._element.appendChild(e.element);
        let n = document.createElement("option");
        n.value = t, n.innerHTML = t;
        let i = this._titleElement.children,
          r = 1;
        for (; r < i.length && !(i[r].value > t); ++r);
        r === i.length ? this._titleElement.appendChild(n) : this._titleElement.insertBefore(n, i[r]), Object.assign(e.element.style, {
          display: "hidden",
          position: "absolute",
          left: mr + "px",
          right: mr + "px",
          top: mr + vp + mr + "px"
        });
      }
      this._controlPanels.get(t).addControl(e, n, i);
    }
    _removeDebugControl(t, e) {
      this._controlPanels.get(t).removeControl(e);
    }
    _layout() {
      Object.assign(this._element.style, {
        display: "block",
        position: "absolute",
        right: _z + "px",
        top: _z + "px",
        width: T6 + 2 * mr + "px",
        "font-family": "sans-serif",
        background: "rgba(255, 255, 255, 0.9)",
        outline: "1px solid white"
      }), Object.assign(this._titleElement.style, {
        display: "block",
        position: "absolute",
        left: mr + "px",
        top: mr + "px",
        "font-size": Mme + "px"
      }), Object.assign(this._minimizeElement.style, {
        display: "block",
        position: "absolute",
        right: mr + "px",
        top: mr + "px",
        width: 1.5 * vp + "px",
        height: vp + "px"
      }), Object.assign(this._performancePanelElement.style, {
        display: "block",
        position: "absolute",
        left: mr + "px",
        right: mr + "px",
        top: mr + vp + mr + "px"
      }), Object.assign(this._overviewGraph.element.style, {
        display: "block",
        position: "absolute",
        left: "0px",
        right: "0px",
        height: S6 + "px",
        border: "1px solid white",
        outline: "1px solid #bbb"
      }), this._updateLayout();
    }
    _updateLayout() {
      let t = null;
      for (let e of this._titleElement.children) {
        e.selected && (t = e);
        let n = e.selected && !this._minimized;
        "Performance" === e.value ? this._performancePanelElement.style.display = n ? "block" : "none" : this._controlPanels.get(e.value).element.style.display = n ? "block" : "none";
      }
      this._minimized ? this._element.style.height = mr + vp + mr + "px" : "Performance" === t.value ? this._element.style.height = mr + vp + (zw + w6) * this._performanceEntries.size + S6 + mr + 2 * mr + "px" : this._element.style.height = mr + vp + this._controlPanels.get(t.value).height + mr + "px";
      for (let t = 0; t < this._sortedPerformanceEntryNames.length; ++t) {
        let e = this._sortedPerformanceEntryNames[t],
          n = this._performanceEntries.get(e);
        n.setHue(t * Sme), n.element.style.top = (zw + w6) * t + "px";
      }
      this._overviewGraph.setSeriesList(this._sortedPerformanceEntryNames.map(t => this._performanceEntries.get(t).series)), this._overviewGraph.element.style.top = (zw + w6) * this._performanceEntries.size + mr + "px", this._minimizeElement.innerHTML = this._minimized ? "⇕" : "⇗";
    }
    _onMinimizeClicked() {
      this._minimized = !this._minimized, this._updateLayout();
    }
    _onCategoryChanged() {
      this._updateLayout();
    }
  };
u(cg, "DebugUI");
var P6 = class {
  constructor({
    name: t,
    hue: e
  }) {
    this._name = t, this.series = new C6({
      hue: e
    }), this._graph = new Gw({
      width: T6,
      height: Eme,
      seriesList: [this.series]
    }), this._element = document.createElement("div"), this._nameElement = document.createElement("div"), this._hueElement = document.createElement("div"), this._lastFrameTimeElement = document.createElement("div"), this._element.appendChild(this._graph.element), this._element.appendChild(this._nameElement), this._element.appendChild(this._hueElement), this._element.appendChild(this._lastFrameTimeElement), this._layout();
  }
  destroy() {
    this._element.removeChild(this._graph.element), this._element.removeChild(this._nameElement), this._element.removeChild(this._hueElement), this._element.removeChild(this._lastFrameTimeElement), this._graph.destroy(), this._element = null, this._nameElement = null, this._hueElement = null, this._lastFrameTimeElement = null;
  }
  _layout() {
    Object.assign(this._element.style, {
      display: "block",
      position: "absolute",
      left: "0px",
      right: "0px",
      height: zw + "px"
    }), Object.assign(this._hueElement.style, {
      display: "block",
      position: "absolute",
      left: "-1px",
      top: Vw - 1 + "px",
      width: b_ - 2 * Vw + "px",
      height: b_ - 2 * Vw + "px",
      "background-color": M_(this.series.hue, .3, .9),
      border: "1px solid " + M_(this.series.hue, .9, .9),
      "border-radius": "2px"
    }), Object.assign(this._nameElement.style, {
      display: "block",
      position: "absolute",
      left: b_ - Vw + wme + "px",
      right: "0px",
      top: "0px",
      height: b_ + "px",
      "font-size": xz + "px",
      "text-align": "left",
      "vertical-align": "middle"
    }), Object.assign(this._lastFrameTimeElement.style, {
      display: "block",
      position: "absolute",
      left: "0px",
      right: "0px",
      top: "0px",
      height: b_ + "px",
      "font-size": xz + "px",
      "text-align": "right",
      "vertical-align": "middle"
    }), Object.assign(this._graph.element.style, {
      display: "block",
      position: "absolute",
      left: "0px",
      right: "0px",
      bottom: "0px",
      "text-align": "right",
      border: "1px solid white",
      outline: "1px solid " + M_(this.series.hue, .2, 1)
    }), this._nameElement.innerHTML = this._name;
  }
  get element() {
    return this._element;
  }
  report(t) {
    if (this.series.report(t), this.series.changed()) {
      if (this.series.length >= 1) {
        let t = 0;
        for (let e = 0; e < this.series.length; ++e) t += this.series.at(e);
        let e = this.series.maximumValue();
        this._lastFrameTimeElement.innerHTML = "∫ " + (t / this.series.length).toFixed(bz) + "ms, ⤒ " + e.toFixed(bz) + " ms";
      }
      this._graph.redraw();
    }
  }
  setHue(t) {
    this.series.hue = t, this._graph.setSeriesList([this.series]), this._layout();
  }
};
u(P6, "PerformanceEntry");
var Gw = class {
  constructor({
    seriesList: t,
    width: e,
    height: n
  }) {
    this._gradients = new Map(), this._canvas = document.createElement("canvas"), this._layout(e, n), this._context = this._canvas.getContext("2d"), this.setSeriesList(t);
  }
  destroy() {
    this._gradients = null, this._canvas = null, this._context = null, Object.setPrototypeOf(this, null);
  }
  _layout(t, e) {
    Object.assign(this._canvas.style, {
      display: "block",
      position: "absolute",
      left: "0px",
      right: "0px",
      width: t + "px",
      height: e + "px"
    }), this._canvas.width = t * window.devicePixelRatio, this._canvas.height = e * window.devicePixelRatio;
  }
  get element() {
    return this._canvas;
  }
  redraw() {
    this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    let t = 0;
    for (let e of this._seriesList) t = Math.max(t, e.maximumValue());
    for (let e of this._seriesList) if (e.length >= 1) {
      this._context.beginPath();
      let n = 1 - (e.length - 1) / (e.windowSize - 1),
        i = 1 - e.at(0) / t;
      this._context.moveTo(n * this._canvas.width, i * this._canvas.height);
      for (let n = 1; n < e.length; ++n) {
        let i = 1 - (e.length - 1 - n) / (e.windowSize - 1),
          r = 1 - e.at(n) / t;
        this._context.lineTo(i * this._canvas.width, r * this._canvas.height);
      }
      this._context.strokeStyle = this._gradients.get(e), this._context.lineWidth = window.devicePixelRatio, this._context.stroke();
    }
  }
  setSeriesList(t) {
    this._seriesList = t;
    for (let t of this._seriesList) {
      let e = this._context.createLinearGradient(0, 0, 0, this._canvas.height);
      e.addColorStop(0, M_(t.hue, 1, 1)), e.addColorStop(1, M_(t.hue, .5, .5)), this._gradients.set(t, e);
    }
  }
};
u(Gw, "LineGraph");
var C6 = class {
  constructor({
    windowSize: t = Tme,
    totalAccumulationCount: e = Pme,
    hue: n = 0
  }) {
    this.windowSize = t, this.hue = n, this._totalAccumulationCount = e, this._ringBuffer = new Array(this.windowSize).fill(0), this._ringBufferLength = 0, this._ringBufferPointer = 0, this._accumulatorValue = 0, this._accumulatorCount = 0, this._changed = !0;
  }
  destroy() {}
  report(t) {
    this._accumulatorValue += t, ++this._accumulatorCount, this._changed = !1, this._accumulatorCount === this._totalAccumulationCount && (this._push(this._accumulatorValue / this._totalAccumulationCount), this._accumulatorValue = 0, this._accumulatorCount = 0, this._changed = !0);
  }
  at(t) {
    if (!Number.isFinite(t) || t >= this._ringBufferLength || t < 0) throw new Error("invalid index: " + t + " (length: " + this.length + ")");
    let e = (this._ringBufferPointer + t - this._ringBufferLength + this.windowSize) % this.windowSize;
    return this._ringBuffer[e];
  }
  _push(t) {
    this._ringBuffer[this._ringBufferPointer] = t, ++this._ringBufferLength, this._ringBufferLength > this.windowSize && (this._ringBufferLength = this.windowSize), ++this._ringBufferPointer, this._ringBufferPointer >= this.windowSize && (this._ringBufferPointer = 0);
  }
  maximumValue() {
    let t = 0;
    for (let e = 0; e < this._ringBufferLength; ++e) t = Math.max(t, this.at(e));
    return t;
  }
  changed() {
    return this._changed;
  }
  get length() {
    return this._ringBufferLength;
  }
};
function M_(t, e, n, i) {
  let r = t % 360 / 60,
    o = 0 | r,
    s = r - o,
    a = n * (1 - e),
    l = n * (1 - e * s),
    u = n * (1 - e * (1 - s)),
    h = 0,
    c = 0,
    p = 0;
  switch (o) {
    case 0:
      h = n, c = u, p = a;
      break;
    case 1:
      h = l, c = n, p = a;
      break;
    case 2:
      h = a, c = n, p = u;
      break;
    case 3:
      h = a, c = l, p = n;
      break;
    case 4:
      h = u, c = a, p = n;
      break;
    case 5:
      h = n, c = a, p = l;
  }
  return "#" + A6(h) + A6(c) + A6(p);
}
function A6(t) {
  let e = (255 * t | 0).toString(16);
  return 1 === e.length && (e = "0" + e), e;
}
u(C6, "TimeSeries"), u(M_, "hsv2rgb"), u(A6, "toHex"), E(), E(), E();
var Ac,
  Cme = new pa(),
  Mz = 6371e3;
function Ez(t, e, n, i) {
  let r = new Vs();
  return r.setFromAxisAngle(n, i), t.applyQuaternion(r), t.position.sub(e), t.position.applyQuaternion(r), t.position.add(e), t;
}
function wz(t) {
  let e = t.max.x - t.min.x,
    n = t.max.y - t.min.y,
    i = Math.max(e, n),
    r = new $t(new ne(), new ne(i, i, 0)),
    o = new ne();
  return o.subVectors(t.getCenter(new ne()), r.getCenter(new ne())), r.translate(o), r;
}
function Hw(t, e, n, i) {
  if (0 === e) return t;
  let {
      lat: r,
      lon: o
    } = t,
    s = I6(n),
    a = I6(r),
    l = I6(o),
    u = e / Mz * Math.cos(s),
    h = l + e / Mz * Math.sin(s) / Math.cos(a),
    c = Sz(a + u),
    p = Sz(h);
  return i.createCoordinate(c, p);
}
function I6(t) {
  return t * Math.PI / 180;
}
function Sz(t) {
  return 180 * t / Math.PI;
}
async function Tz(t, e, n, i, r) {
  let o,
    {
      signal: s
    } = i;
  try {
    o = await (await r.fetchTile(t, e, n, s)).blob();
  } catch (t) {
    return;
  }
  try {
    let t = await createImageBitmap(o, {
        imageOrientation: "flipY",
        colorSpaceConversion: "none"
      }),
      e = new df(t);
    return e.wrapS = Br, e.wrapT = Br, e;
  } catch (t) {
    return new Promise(t => {
      let e = URL.createObjectURL(o),
        n = Cme.load(e, () => {
          n.colorSpace = Nt, n.wrapS = Br, n.wrapT = Br, t(n);
        });
    });
  }
}
function Pz(t) {
  return Math.sqrt(Math.pow(t, 2) + Math.pow(t, 2)) / 2;
}
u(Ez, "rotateAroundWorldAxis"), u(wz, "getSquareBoundingBoxByLongestSide"), function (t) {
  t[t.NORTH = 0] = "NORTH", t[t.EAST = 90] = "EAST", t[t.SOUTH = 180] = "SOUTH", t[t.WEST = 270] = "WEST";
}(Ac || (Ac = {})), u(Hw, "translateCoordinate"), u(I6, "toRadians"), u(Sz, "toDegrees"), u(Tz, "loadTextureByTile"), u(Pz, "calculateCircleRadius"), E();
var ea = class {
  static MapSize(t, e) {
    return Math.ceil(e * Math.pow(2, t));
  }
  static Clip(t, e, n) {
    return Math.min(Math.max(t, e), n);
  }
  static GlobalPixelToPosition(t, e, n) {
    var i = this.MapSize(e, n),
      r = this.Clip(t[0], 0, i - 1) / i - .5,
      o = .5 - this.Clip(t[1], 0, i - 1) / i;
    return [360 * r, 90 - 360 * Math.atan(Math.exp(2 * -o * Math.PI)) / Math.PI];
  }
  static GroundResolution(t, e, n) {
    return t = this.Clip(t, this.MinLatitude, this.MaxLatitude), 2 * Math.cos(t * Math.PI / 180) * Math.PI * this.EarthRadius / this.MapSize(e, n);
  }
  static TileXYToBoundingBox(t, e, n, i) {
    var r = t * i,
      o = e * i,
      s = r + i,
      a = o + i,
      l = this.GlobalPixelToPosition([r, o], n, i),
      u = this.GlobalPixelToPosition([s, a], n, i);
    return [l[0], u[1], u[0], l[1]];
  }
  static PositionToTileXY(t, e, n) {
    var i = this.Clip(t[1], this.MinLatitude, this.MaxLatitude),
      r = (this.Clip(t[0], this.MinLongitude, this.MaxLongitude) + 180) / 360,
      o = Math.sin(i * Math.PI / 180),
      s = .5 - Math.log((1 + o) / (1 - o)) / (4 * Math.PI),
      a = this.MapSize(e, n);
    return {
      tileX: Math.floor(this.Clip(r * a + .5, 0, a - 1) / n),
      tileY: Math.floor(this.Clip(s * a + .5, 0, a - 1) / n)
    };
  }
  static TileXYToQuadKey(t, e, n) {
    for (var i = [], r = n; r > 0; r--) {
      var o = 0,
        s = 1 << r - 1;
      0 != (t & s) && o++, 0 != (e & s) && (o += 2), i.push(o);
    }
    return i.join("");
  }
};
u(ea, "TileMath"), A(ea, "EarthRadius", 6378137), A(ea, "MinLatitude", -85.05112878), A(ea, "MaxLatitude", 85.05112878), A(ea, "MinLongitude", -180), A(ea, "MaxLongitude", 180);
var cu,
  hu,
  w_,
  E_ = class {
    constructor(t, e, n, i, r) {
      A(this, "center"), A(this, "zoomLevel"), re(this, cu, void 0), re(this, hu, void 0), re(this, w_, void 0), A(this, "mesh"), A(this, "material"), A(this, "texture"), A(this, "cache", {}), A(this, "rendered", !1), this.center = t, this.zoomLevel = e, he(this, cu, n), he(this, hu, i), he(this, w_, r);
    }
    get tileXY() {
      if (this.cache.tileXY) return this.cache.tileXY;
      let {
        tileX: t,
        tileY: e
      } = ea.PositionToTileXY([this.center.lon, this.center.lat], this.zoomLevel, w(this, cu).tileSize);
      return this.cache.tileXY = {
        tileX: t,
        tileY: e
      }, {
        tileX: t,
        tileY: e
      };
    }
    get tileBoundingBoxInLatLon() {
      if (this.cache.tileBoundingBoxInLatLon) return this.cache.tileBoundingBoxInLatLon;
      let {
          tileX: t,
          tileY: e
        } = this.tileXY,
        {
          tileSize: n
        } = w(this, cu),
        i = ea.TileXYToBoundingBox(t, e, this.zoomLevel, n);
      return this.cache.tileBoundingBoxInLatLon = i, i;
    }
    discardTexture() {
      if (w(this, cu).tileRenderMode === hg.AGGRESSIVE) {
        this.rendered = !1, this.material.opacity = 0, this.material.map = null, this.material.needsUpdate = !0;
        try {
          this.texture.dispose();
        } catch (t) {}
        w(this, hu).tryRendering();
      }
    }
    applyTexture() {
      if (this.rendered && w(this, cu).tileRenderMode !== hg.AGGRESSIVE) return;
      this.rendered = !0;
      let {
        tileX: t,
        tileY: e
      } = this.tileXY;
      w(this, hu).taskScheduler.scheduleTask(new ji({
        name: "fetchTile",
        callback: () => {
          Tz(t, e, this.zoomLevel, w(this, w_), w(this, cu).outdoorContextProvider).then(t => {
            this.texture = t, this.material.map = t, Nl({
              from: {
                opacity: 0
              },
              to: {
                opacity: 1
              },
              duration: 500,
              onStart: () => {
                this.mesh.visible = !0;
              },
              onUpdate: ({
                opacity: t
              }) => {
                this.material.opacity = !0 === w(this, cu).visible ? t : 0, this.material.needsUpdate = !0, w(this, hu).tryRendering();
              }
            }).start(w(this, hu));
          });
        }
      }));
    }
    render(t, e) {
      let n = t / e.scale,
        i = new co(n, n, 1, 1);
      this.material = new Sr({
        opacity: 0,
        transparent: !0,
        stencilWrite: !0,
        stencilFunc: Q_,
        stencilRef: 1
      }), this.mesh = new Ft(i, this.material), this.mesh.visible = !1;
      let r = this.tileBoundingBoxInLatLon,
        o = w(this, hu).referenceMap.createCoordinate(r[3], r[2]),
        s = w(this, hu).convertTo3DMapPosition(o);
      return this.mesh.position.set(s.x - n / 2, s.y - n / 2, -1), Ez(this.mesh, s, new ne(0, 0, 1), -e.getNorth()), this.mesh;
    }
  };
u(E_, "Tile"), cu = new WeakMap(), hu = new WeakMap(), w_ = new WeakMap();
var hg,
  Ame = 2;
!function (t) {
  t[t.NORMAL = 0] = "NORMAL", t[t.AGGRESSIVE = 1] = "AGGRESSIVE";
}(hg || (hg = {}));
var Oi,
  jw = "#f0f0f1",
  Ic = class {
    constructor(t) {
      var e, n, i, r;
      A(this, "tileSize", 256), A(this, "token", ""), A(this, "apiKey"), A(this, "tileRenderMode", 1), A(this, "currentAbortController", new AbortController()), re(this, Oi, void 0), A(this, "attributionEl"), A(this, "outdoorContextProvider"), A(this, "renderVisibleTiles"), A(this, "cachedZoomLevel", -1 / 0), A(this, "visible", !0), A(this, "zoomLevelToAltitudeMap", [[18, -1 / 0], [17, 800], [16, 1800], [15, 3e3]]), A(this, "plane"), A(this, "tiles", []), A(this, "maskMeshBoundingBox"), he(this, Oi, t), this.renderVisibleTiles = ol(this._renderVisibleTiles, 32), Ic.ENABLED && null !== (null == (e = Ic.OPTIONS) ? void 0 : e.provider) && (this.outdoorContextProvider = null == (n = Ic.OPTIONS) ? void 0 : n.provider, this.tileRenderMode = null != (r = null == (i = Ic.OPTIONS) ? void 0 : i.tileRenderMode) ? r : this.tileRenderMode, w(this, Oi).camera.on(Ls.CHANGED, () => {
        this.fetchTiles(), this.renderVisibleTiles();
      }), w(this, Oi).on(Xe.SET_SCENE, () => {
        this.fetchTiles(), this.renderVisibleTiles();
      }));
    }
    createAttributionEl() {
      this.attributionEl = document.createElement("div"), Object.assign(this.attributionEl.style, {
        position: "absolute",
        bottom: 0,
        right: 0,
        padding: "2px",
        pointerEvents: "none"
      }), w(this, Oi).container.append(this.attributionEl);
    }
    _renderVisibleTiles() {
      let t = w(this, Oi).cameraObject,
        e = new hf();
      e.setFromProjectionMatrix(new Bt().multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse));
      for (let t of this.tiles) {
        let n = t.mesh,
          i = n.geometry.attributes.position.array,
          r = [n.localToWorld(new ne(i[0], i[1], i[2])), n.localToWorld(new ne(i[3], i[4], i[5])), n.localToWorld(new ne(i[6], i[7], i[8])), n.localToWorld(new ne(i[9], i[10], i[11]))],
          o = !1;
        for (let i = 0; i < 4; i++) if ((e.containsPoint(r[i]) || e.intersectsObject(n)) && (o = !0, !t.rendered)) {
          t.applyTexture();
          break;
        }
        t.rendered && !o && t.discardTexture();
      }
    }
    fadeOut() {
      return Ic.ENABLED && this.visible ? Nl({
        from: {
          opacity: 1
        },
        to: {
          opacity: 0
        },
        onUpdate: ({
          opacity: t
        }) => {
          this.plane.children.forEach(e => {
            e.material.opacity = t, e.material.needsUpdate = !0, w(this, Oi).tryRendering();
          });
        },
        onComplete: () => {
          this.visible = !1, this.plane.visible = !1, w(this, Oi).tryRendering();
        }
      }).start(w(this, Oi)) : Promise.resolve();
    }
    fadeIn() {
      return !Ic.ENABLED || this.visible ? Promise.resolve() : Nl({
        from: {
          opacity: 0
        },
        to: {
          opacity: 1
        },
        onStart: () => {
          this.plane.visible = !0, w(this, Oi).tryRendering();
        },
        onUpdate: ({
          opacity: t
        }) => {
          this.plane.children.forEach(e => {
            e.material.opacity = t, e.material.needsUpdate = !0, w(this, Oi).tryRendering();
          });
        },
        onComplete: () => {
          this.visible = !0;
        }
      }).start(w(this, Oi));
    }
    fetchTiles() {
      let t = w(this, Oi).controls.getZoom() * w(this, Oi).referenceMap.scale,
        e = -1 / 0;
      this.zoomLevelToAltitudeMap.forEach(([n, i]) => {
        t > i && (e = n);
      }), e !== this.cachedZoomLevel && (this.currentAbortController.signal.aborted || (this.currentAbortController.abort(), this.currentAbortController = new AbortController()), this.fetchTilesForZoomLevel(e));
    }
    async fetchTilesForZoomLevel(t) {
      var e, n;
      this.plane && (this.tiles = [], w(this, Oi).scene.remove(this.plane), this.plane.destroy(), w(this, Oi).tryRendering()), this.cachedZoomLevel = t, this.plane = new ha();
      let i = w(this, Oi).referenceMap,
        r = w(this, Oi).mapObjects.get(i.id);
      await r.load();
      let o = r.boundingBox,
        s = d7(wz(new $t(new ne(o.min.x, o.min.y, o.min.z), new ne(o.max.x, o.max.y, o.max.z))), null != (n = null == (e = Ic.OPTIONS) ? void 0 : e.boundingBoxMultiplier) ? n : Ame),
        {
          min: a,
          max: l
        } = s,
        u = new co(l.x - a.x, l.y - a.y),
        h = new Sr({
          color: jw,
          stencilWrite: !0,
          stencilRef: 1,
          depthWrite: !1,
          stencilFunc: Rg,
          stencilFail: Yp,
          stencilZFail: Yp,
          stencilZPass: Yp
        }),
        c = new Ft(u, h);
      c.renderOrder = -1, c.applyMatrix4(r.object.matrix), this.maskMeshBoundingBox = new $t().setFromObject(c), this.maskMeshBoundingBox.min.z = -100, this.maskMeshBoundingBox.max.z = 100, this.plane.add(c);
      let p = new ne(s.min.x, s.min.y, 0),
        d = new ne(s.max.x, s.max.y, 0);
      if ("function" == typeof this.outdoorContextProvider.fetchAttribution) {
        null == this.attributionEl && this.createAttributionEl();
        let e = w(this, Oi).convert3DMapPositionToCoordinate(p),
          n = w(this, Oi).convert3DMapPositionToCoordinate(d);
        this.outdoorContextProvider.fetchAttribution(t, [n.lon, n.lat, e.lon, e.lat]).then(t => t.json()).then(({
          copyrights: t
        }) => {
          this.attributionEl.innerHTML = t[0];
        }).catch(t => ke.error(t));
      }
      let f = s.getCenter(new ne()),
        m = w(this, Oi).convert3DMapPositionToCoordinate(f, i),
        g = ea.GroundResolution(m.lat, t, this.tileSize),
        v = this.tileSize * g,
        y = new E_(m, t, this, w(this, Oi), this.currentAbortController);
      y.render(v, i), this.plane.add(y.mesh), this.tiles.push(y);
      let _ = Pz(s.max.x - s.min.x),
        x = v / i.scale,
        E = Math.ceil(_ / x);
      for (let e = 1; e <= E; e++) this.populateLayer(e, m, t, v, i);
      w(this, Oi).scene.add(this.plane);
    }
    populateLayer(t = 1, e, n, i, r) {
      let o = Hw(e, i * t, Ac.NORTH, r);
      o = Hw(o, i * t, Ac.WEST, r);
      let s = 2 * t + 1,
        a = o,
        l = [Ac.EAST, Ac.SOUTH, Ac.WEST, Ac.NORTH];
      for (let t of l) for (let e = 0; e < s - 1; e++) {
        let e = new E_(a, n, this, w(this, Oi), this.currentAbortController);
        e.render(i, r), this.checkIfTileIsInBoundingBox(e) && (this.plane.add(e.mesh), this.tiles.push(e)), a = Hw(a, i, t, r);
      }
    }
    checkIfTileIsInBoundingBox(t) {
      let e = new $t().setFromObject(t.mesh);
      return this.maskMeshBoundingBox.intersectsBox(e) || this.maskMeshBoundingBox.containsBox(e);
    }
  },
  _l = Ic;
u(_l, "TileManager"), Oi = new WeakMap(), A(_l, "ENABLED", !1), A(_l, "OPTIONS"), E(), E(), "object" != typeof globalThis && (Object.defineProperty(Object.prototype, "__magic__", {
  get: function () {
    return this;
  },
  configurable: !0
}), __magic__.globalThis = __magic__, delete Object.prototype.__magic__);
var Cz = Rt(il());
E(), jn.prototype.destroy = function () {
  for (let t = this.children.length - 1; t >= 0; t--) this.children[t].destroy();
  this.geometry && (this.geometry.dispose(), this.geometry = void 0), this.parent && this.parent.remove(this), this.texture && (this.texture.dispose(), this.texture = void 0), Array.isArray(this.material) ? this.material.forEach(function (t) {
    ih(t);
  }) : void 0 !== this.material && ih(this.material), this.material = void 0;
};
var Do = new nh(),
  Az = {},
  Ime = {},
  Ia = {
    BEFORE_CAMERA: 5,
    CAMERA: 4,
    AFTER_CAMERA: 3,
    RENDER: 2,
    AFTER_RENDER: 1,
    AFTER_ALL_UPDATES: 0
  };
Ime.CameraControls = Rw, Az.CompositeVertexShader = qw, Az.CompositeFragmentShader = kw;
var yp,
  fg,
  pg,
  dg,
  Fh,
  Lc,
  Bh,
  qo,
  Ww,
  _p,
  mg,
  Uh,
  S_,
  T_,
  xp,
  P_,
  C_,
  A_,
  I_,
  L_,
  O_,
  zh,
  R_,
  Oc,
  fu,
  gg,
  N_,
  D_,
  q_,
  vg,
  bp,
  k_,
  Mp,
  Ep,
  xl,
  bl,
  Xw,
  yg,
  wp,
  Yw,
  Zw,
  Jw,
  Kw,
  F_,
  B_,
  L6 = class extends Ks {
    constructor(t, e, n = {}, i) {
      var r, o, s, a, l, h, c, p, d;
      super(), A(this, "eventSystem"), A(this, "floatingLabels"), A(this, "flatLabels"), A(this, "paths"), A(this, "polygonColors"), A(this, "polygonInteraction"), A(this, "polygonStates"), A(this, "polygonImages"), A(this, "markers"), A(this, "tooltips"), A(this, "threeDMarkers"), A(this, "blueDot"), A(this, "camera"), A(this, "options"), A(this, "currentPath"), A(this, "state", xo.EXPLORE), A(this, "imageFlippingCache", {}), A(this, "imageFlippingEnabled", !1), A(this, "MapView"), A(this, "type"), A(this, "container"), A(this, "venue"), A(this, "colors"), A(this, "loadOptions"), A(this, "smartCollisionEngine"), A(this, "taskScheduler"), A(this, "renderer"), A(this, "highlightedPolygons", {}), A(this, "scene"), A(this, "focusZoomFactor"), A(this, "cameraObject"), A(this, "polygonMeshesById"), A(this, "textLabelsByPolygonId"), A(this, "labelOrientationDelay"), A(this, "interactivePolygons"), A(this, "mapManager"), A(this, "sceneManager"), A(this, "mapObjects"), A(this, "referenceMap"), A(this, "currentInteractionEvent"), A(this, "resolution"), A(this, "cameraParameters"), A(this, "controls"), A(this, "cameraPlane"), A(this, "canvasWidth"), A(this, "canvasHeight"), A(this, "cachedPadding", {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }), A(this, "currentScale", 0), A(this, "rendererDomElement"), A(this, "resolutionScale"), re(this, yp, void 0), re(this, fg, void 0), re(this, pg, void 0), re(this, dg, void 0), re(this, Fh, void 0), re(this, Lc, void 0), re(this, Bh, void 0), re(this, qo, null), re(this, Ww, ["top", "bottom", "left", "right"]), re(this, _p, {
        PIXELS: "pixels",
        PORTIONS: "portions"
      }), re(this, mg, void 0), re(this, Uh, void 0), re(this, S_, void 0), re(this, T_, void 0), re(this, xp, void 0), re(this, P_, void 0), re(this, C_, void 0), re(this, A_, void 0), re(this, I_, void 0), re(this, L_, void 0), re(this, O_, void 0), re(this, zh, void 0), re(this, R_, void 0), re(this, Oc, !1), re(this, fu, void 0), re(this, gg, void 0), A(this, "outdoorGeometryLayers", []), A(this, "billboardManager"), A(this, "stackedMaps"), A(this, "tileManager"), re(this, N_, u((t = !0) => {
        he(this, Oc, t);
      }, "#setFlippablesNeedUpdating")), re(this, D_, u(() => {
        this.smartCollisionEngine.init(this.container, w(this, Xw));
      }, "#initializeCollisionEngine")), re(this, q_, u(t => Math.trunc(100 * t) / 100, "#round100")), re(this, vg, u(() => {
        var t, e;
        this.canvasWidth = this.rendererDomElement.clientWidth, this.canvasHeight = this.rendererDomElement.clientHeight, w(this, wp).call(this), w(this, bp).call(this), this.smartCollisionEngine.resize(this.container), "function" == typeof (null == (e = null == (t = this.sceneManager) ? void 0 : t.currentScene) ? void 0 : e.resize) && this.sceneManager.currentScene.resize();
      }, "#onWindowResize")), re(this, bp, u(() => {
        this.renderer.render(hi.ALL, null, this.scene, this.cameraObject);
      }, "#renderFull")), re(this, k_, u((t, e) => {
        t.style.transform = "rotate(" + (e + t._mRotationOffset) + "rad)";
      }, "#rotateNode")), re(this, Mp, u(() => {
        he(this, Fh, !0), he(this, Oc, !0);
      }, "#cameraRotationStarted")), re(this, Ep, u(() => {
        he(this, Fh, !1), he(this, Oc, !0);
      }, "#cameraRotationStopped")), re(this, xl, u(() => {}, "#cameraMovementStart")), re(this, bl, u(() => {}, "#cameraMovementEnd")), re(this, Xw, u((t, e) => {
        this.cameraObject.updateProjectionMatrix(), this.cameraObject.updateMatrixWorld(!0);
        let n = this.mapObjects.get(e);
        if (null == n) return {
          x: 0,
          y: 0
        };
        let i = this.convertTo3DMapPosition(t.nodeOrCoordinate);
        void 0 !== t.height && (i.z += t.height * n.object.scale.x);
        let r = i.project(this.cameraObject),
          o = (r.x + 1) / 2 * this.canvasWidth - 0,
          s = (1 - r.y) / 2 * this.canvasHeight - 0;
        return {
          x: w(this, q_).call(this, o),
          y: w(this, q_).call(this, s)
        };
      }, "#project")), re(this, yg, u((t, e) => {
        this.renderer.setBufferSize(t, e), this.cameraObject.aspect = t / e, this.cameraObject.updateProjectionMatrix(), this.cameraObject.updateMatrixWorld(!0), this.resolution.x = t, this.resolution.y = e;
      }, "#setBufferSize")), re(this, wp, u(() => {
        let t = this.canvasWidth = this.rendererDomElement.clientWidth,
          e = this.canvasHeight = this.rendererDomElement.clientHeight,
          n = Math.floor(t * this.resolutionScale),
          i = Math.floor(e * this.resolutionScale);
        if (this.rendererDomElement.width !== n || this.rendererDomElement.height !== i) {
          if (this.rendererDomElement.width * this.rendererDomElement.height * n * i != 0) {
            let t = this.rendererDomElement.width !== n ? this.rendererDomElement.width / n : this.rendererDomElement.height / i;
            this.controls.setZoom(t * this.controls.getZoom());
          }
          w(this, yg).call(this, n, i);
        }
        he(this, zh, !1);
      }, "#measureCanvas")), re(this, Yw, u(() => {
        var t;
        let e = w(this, fu).rotation.z;
        if (w(this, Fh) || w(this, Oc)) {
          let n = null == (t = this.sceneManager) ? void 0 : t.currentScene.mapObjects;
          null == n || n.forEach(t => {
            let n = e - t.object.rotation.z;
            t.imagesToFlip.forEach(t => t.flipIfNeeded(n));
          });
        }
      }, "#rotateTextLabels")), re(this, Zw, u(() => {
        var t;
        let e = w(this, fu).rotation.z;
        if (w(this, Fh) || w(this, Oc)) {
          let n = null == (t = this.sceneManager) ? void 0 : t.currentScene.mapObjects;
          null == n || n.forEach(t => {
            let n = e - t.object.rotation.z;
            t.imagesToFlip.forEach(t => t.flipIfNeeded(n));
          });
        }
      }, "#rotateImages")), re(this, Jw, u(t => {
        t.addDebugControls({
          MapView3D: [{
            name: "Background Color",
            description: "The color of the mapview background. Will be obscured if there is a fully-opaque outdoor context.",
            control: new m_({
              current: new yt("#ffffff"),
              onValueChanged: t => {
                this.renderer.setBackgroundColor(t, this.renderer.backgroundAlpha), this.tryRendering();
              }
            })
          }, {
            name: "Background Opacity",
            description: "The opacity of the mapview background. Will be obscured if there is a fully-opaque outdoor context.",
            control: new d_({
              minimum: 0,
              maximum: 1,
              step: .01,
              current: this.renderer.backgroundAlpha,
              onValueChanged: t => {
                this.renderer.setBackgroundColor(this.renderer.backgroundColor, t), this.tryRendering();
              }
            })
          }]
        });
      }, "#addDebugControls")), re(this, Kw, u(t => {
        t.removeDebugControls({
          MapView3D: ["Background Color", "Background Opacity"]
        });
      }, "#removeDebugControls")), re(this, F_, u((t, e) => Do.intersectObjects(t, !0).filter(t => !!t.object.name && (e && this.venue._polygonsById ? t.object.name in this.venue._polygonsById : t.object.name in this.interactivePolygons)).map(t => this.venue._polygonsById[t.object.name]) || [], "#getPolygonsFromRaycaster")), re(this, B_, u(() => {
        this.tryRendering();
      }, "#onCameraChange")), A(this, "getPolygon", u(t => rl(t, this.venue.polygons), "getPolygon")), A(this, "showEntireMap", u(t => {
        if (null == this.currentMap) return;
        t || (t = {});
        let e,
          n = this.mapObjects.get(this.currentMap);
        return t.interactiveOnly ? e = Object.keys(this.interactivePolygons) : (e = null == n ? void 0 : n.hoverableMeshChildren.map(function (t) {
          return t.name;
        }), !e.length && (null == n ? void 0 : n.elements) && (e = Object.keys(n.elements))), t.polygons = e, this.focusOn(t);
      }, "showEntireMap")), A(this, "resetPanBounds", u(() => {
        var t;
        if (null == this.currentMap) return;
        let e = this.mapObjects.get(this.currentMap);
        this.controls.panBounds.min = this.controls.getPosition(), this.controls.panBounds.max = this.controls.getPosition();
        let n = null == e ? void 0 : e.boundingBox;
        n || (n = new $t().setFromObject(null == e ? void 0 : e.object), this.mapObjects.get(this.currentMap).boundingBox = n), null == (t = this.mapManager) || t.expandPanBounds(n);
      }, "resetPanBounds")), A(this, "focusOn", u(t => {
        var e;
        if (null == this.currentMap || null == t) return;
        let n,
          i = void 0 === t.changeZoom || t.changeZoom;
        n = void 0 !== t.duration ? t.duration : "true" === D.env.TESTING ? 0 : 200;
        let r = void 0 !== t.focusZoomFactor ? t.focusZoomFactor : this.focusZoomFactor,
          o = t.curve,
          s = void 0 !== t.horizontalFovFactor ? t.horizontalFovFactor : 1,
          a = void 0 !== t.verticalFovFactor ? t.verticalFovFactor : 1,
          l = t.callback,
          u = t.cancelledCallback,
          h = void 0 !== t.minZoom ? t.minZoom : this.controls.minZoom,
          c = t.updateZoomLimits || !0,
          p = !1,
          d = [],
          f = null != (e = t.doNotEmitFocusOnEvent) && e;
        if (t.nodes) {
          let e = t.nodes;
          for (var m = 0, g = e.length; m < g; m++) {
            let t = e[m];
            "string" == typeof t && (t = rl(t, this.venue.nodes)), (null == t.map || t.map.id == this.currentMap) && (d.push(this.convertTo3DMapPosition(t)), p = !0);
          }
        }
        if (t.debug) {
          w(this, Bh) && w(this, Bh).destroy(), he(this, Bh, new jn()), this.scene.add(w(this, Bh));
          var v = new Ka(100, 100, 100),
            y = new Sr({
              color: 65280
            });
        }
        t.points && (t.points.forEach(t => d.push(t)), p = !0);
        let _ = this.controls.getRotation(),
          x = this.controls.getTilt();
        if (this.controls.setRotation(t.rotation, !0), this.controls.setTilt(t.tilt, !0), t.boundingBox) {
          let {
            min: e,
            max: n
          } = t.boundingBox;
          [new ne(e.x, e.y, e.z), new ne(e.x, n.y, e.z), new ne(n.x, e.y, e.z), new ne(n.x, n.y, e.z), new ne(e.x, e.y, n.z), new ne(e.x, n.y, n.z), new ne(n.x, e.y, n.z), new ne(n.x, n.y, n.z)].forEach(e => {
            if (t.debug) {
              let t = new Ft(v, y);
              t.position.set(e.x, e.y, e.z), w(this, Bh).add(t);
            }
            d.push(e);
          }), p = !0;
        }
        if (t.polygons) {
          let e = t.polygons,
            n = this.mapObjects.get(this.currentMap),
            i = 0;
          for (m = 0, g = e.length; m < g; m++) {
            let t = Vr(e[m]),
              r = null == n ? void 0 : n.objectsDictionary[t];
            if (r) if (i++, r.geometry.attributes) {
              let t = r.geometry.attributes.position;
              for (let e = 0, i = t.count; e < i; e++) {
                let i = new ne();
                i.set(t.getX(e), t.getY(e), t.getZ(e)).applyMatrix4(null == n ? void 0 : n.object.matrix), d.push(i);
              }
              p = !0;
            } else {
              for (let t = 0, e = r.geometry.vertices.length; t < e; t++) d.push(r.geometry.vertices[t].clone().applyMatrix4(null == n ? void 0 : n.object.matrix));
              p = !0;
            }
          }
          1 === i && (r = this.loadOptions && this.loadOptions.zoomOverrides && this.loadOptions.zoomOverrides.focusZoomFactorPolygon || r);
        }
        if (p) {
          this.tryRendering();
          let e = t.padding || this.cachedPadding || {
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            },
            p = this.getZoomLevelForCurrentMap(),
            m = this.getCameraFrameForPoints(d, s, a, e, !0),
            g = m.zoom;
          c && (this.controls.restrictZoomLimits(p), this.controls.expandZoomLimits(g * r));
          let v = {
            position: m.position,
            tilt: t.tilt,
            rotation: t.rotation
          };
          return i && (v.zoom = Math.max(m.zoom * r, h)), f || this.publish(Xe.FOCUSON_BEGIN), this.controls.setRotation(_, !0), this.controls.setTilt(x, !0), this.controls.animateCamera(v, n, o, l, u);
        }
        return f || this.publish(Xe.FOCUSON_BEGIN), this.controls.setRotation(_, !0), this.controls.setTilt(x, !0), this.controls.animateCamera({}, n, o, l, u);
      }, "focusOn")), A(this, "focusOnPolygon", u((t, e, n, i) => this.focusOn({
        polygons: [t],
        changeZoom: e,
        duration: n,
        curve: i
      }), "focusOnPolygon")), A(this, "focusOnPath", u((t, e, n, i, r) => this.focusOn({
        nodes: t,
        polygons: e,
        changeZoom: n,
        duration: i,
        curve: r
      }), "focusOnPath")), A(this, "getCameraFrameForPoints", u((t, e, n, i, r) => {
        (!n || isNaN(n)) && (n = 1), (!e || isNaN(e)) && (e = 1);
        let o = {
          position: this.controls.getPosition(),
          zoom: this.controls.minZoom
        };
        if (null == t || 0 === t.length) return o;
        i || (i = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          type: w(this, _p).PIXELS
        });
        for (let t of w(this, Ww)) "number" != typeof i[t] && (i[t] = 0);
        if (i.type || (i.type = w(this, _p).PIXELS), i.type === w(this, _p).PORTIONS && (i = {
          top: i.top * this.canvasHeight,
          bottom: i.bottom * this.canvasHeight,
          left: i.left * this.canvasWidth,
          right: i.right * this.canvasWidth,
          type: w(this, _p).PIXELS
        }), i.left + i.right >= this.canvasWidth || i.top + i.bottom >= this.canvasHeight) return o;
        w(this, fu).updateMatrixWorld();
        let s = this.cameraObject.matrixWorldInverse,
          a = this.cameraObject.fov * (Math.PI / 180) / 2,
          l = a * n,
          u = Math.atan(Math.tan(a) * (this.canvasWidth / this.canvasHeight)) * e;
        if (1 === t.length) {
          let e = t[0].clone();
          e.applyMatrix4(s);
          let n = this.controls.minZoom * Math.tan(u) * 2,
            r = this.controls.minZoom * Math.tan(l) * 2,
            a = (i.left - i.right) / 2 / this.canvasWidth,
            h = (i.top - i.bottom) / 2 / this.canvasHeight,
            c = new ne(-a * n, h * r, 0);
          return e.add(c), e.applyMatrix4(this.cameraObject.matrixWorld), o.position.x = e.x, o.position.y = e.y, o;
        }
        let h,
          c = new ne(1 / 0, 1 / 0, 1 / 0),
          p = new ne(-1 / 0, -1 / 0, -1 / 0),
          d = new $t().setFromPoints(t);
        for (let e = 0, n = t.length; e < n; e++) h = t[e], h.applyMatrix4(s), c.min(h), p.max(h);
        let f = p.x - c.x,
          m = p.y - c.y,
          g = this.canvasWidth - i.left - i.right,
          v = this.canvasHeight - i.top - i.bottom,
          y = (p.x + c.x) / 2,
          _ = (p.y + c.y) / 2,
          x = f / g,
          E = m / v,
          b = this.controls.getZoomScaledMin(),
          S = this.controls.getZoomScaledMax(),
          M = b * Math.tan(u) * 2,
          T = S * Math.tan(u) * 2,
          A = M / this.canvasWidth,
          P = T / this.canvasWidth,
          C = Math.max(x, E);
        r || (C = Math.min(Math.max(C, A), P));
        let I = g * C,
          N = v * C,
          L = {
            x: y - I / 2 - i.left * C,
            y: _ - N / 2 - i.bottom * C
          },
          R = {
            x: y + I / 2 + i.right * C,
            y: _ + N / 2 + i.top * C
          },
          O = (L.x + R.x) / 2,
          q = (L.y + R.y) / 2,
          D = d.getCenter(new ne()),
          k = Math.abs(O - L.x),
          F = Math.abs(q - L.y),
          U = k / Math.tan(u),
          B = F / Math.tan(l),
          z = new ne();
        z.set(O, q, p.z + Math.max(U, B)), z.applyMatrix4(this.cameraObject.matrixWorld);
        let V = new ne();
        if (V.set(O, q, p.z), V.applyMatrix4(this.cameraObject.matrixWorld), this.state === xo.STACKED) {
          let t = new ne().subVectors(V, z),
            e = (D.z - z.z) / t.z,
            n = new ne().copy(z).add(t.clone().multiplyScalar(e));
          o.position = n, V.set(o.position.x, o.position.y, o.position.z);
        } else {
          V.sub(z);
          let t = z.z / V.z;
          o.position.x = z.x - V.x * t, o.position.y = z.y - V.y * t, V.set(o.position.x, o.position.y, 0);
        }
        return z.sub(V), o.zoom = z.length(), o;
      }, "getCameraFrameForPoints")), A(this, "setPadding", u(t => {
        this.cachedPadding = t || {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };
      }, "setPadding")), A(this, "getZoomLevelForPolygon", u(t => {
        var e;
        if (null == this.currentMap) return;
        let n = Vr(t),
          i = [],
          r = null == (e = this.mapObjects.get(this.currentMap)) ? void 0 : e.objectsDictionary[n];
        if (r) {
          let t = r.geometry.attributes ? r.geometry.attributes.position : [];
          for (let e = 0, n = t.count; e < n; e++) {
            let n = new ne();
            n.set(t.getX(e), t.getY(e), t.getZ(e)), i.push(n);
          }
          return this.getCameraFrameForPoints(i, 1, 1, this.cachedPadding, !0).zoom;
        }
        return this.controls.getZoom();
      }, "getZoomLevelForPolygon")), A(this, "getZoomLevelForCurrentMap", u(() => {
        var t;
        if (null == this.currentMap) return;
        let e = null == (t = this.mapObjects.get(this.currentMap)) ? void 0 : t.object;
        if (e) {
          let t = this.mapObjects.get(this.currentMap).boundingBox;
          t || (t = new $t().setFromObject(e), this.mapObjects.get(this.currentMap).boundingBox = t);
          let n = [t.min.clone(), t.max.clone()];
          return this.getCameraFrameForPoints(n, 1, 1, this.cachedPadding, !0).zoom;
        }
        return this.controls.getZoom();
      }, "getZoomLevelForCurrentMap")), A(this, "getZoomLevelForObject", u(t => {
        let e;
        e || (e = new $t().setFromObject(t));
        let n = [e.min.clone(), e.max.clone()];
        return this.getCameraFrameForPoints(n, 1, 1, 0, !0).zoom;
      }, "getZoomLevelForObject")), A(this, "resetCamera", u((t = !1) => {
        var e;
        if (null == this.currentMap) return;
        let n = {
          x: 0,
          y: 0
        };
        if (!t) {
          let t = null == (e = this.mapObjects.get(this.currentMap)) ? void 0 : e.boundingBox;
          t && (n = {
            x: (t.max.x - t.min.x) / 2 + t.min.x,
            y: (t.max.y - t.min.y) / 2 + t.min.y
          });
        }
        let i = this.getZoomLevelForCurrentMap();
        this.controls.expandZoomLimits(i);
        this.controls.setMulti(n, i, 0, .6);
      }, "resetCamera")), A(this, "getPositionLatLon", u((t, e, n) => {
        let i;
        if (i = "string" == typeof n ? n : null == n ? this.currentMap : n.id, null == i) return;
        let r = this.mapObjects.get(i);
        if (null == r) throw new Error("Invalid map: " + i);
        return r.getPositionLatLon(t, e);
      }, "getPositionLatLon")), A(this, "lockNorth", u((t, e = 0) => {
        w(this, Lc).push(t), t._mRotationOffset = e, w(this, k_).call(this, t, this.getNorth() + this.controls.getRotation());
      }, "lockNorth")), A(this, "unlockNorth", u(t => {
        delete t._mRotationOffset, he(this, Lc, w(this, Lc).filter(function (e) {
          return e != t;
        }));
      }, "unlockNorth")), A(this, "convertTo3DMapPosition", u(t => {
        var e;
        let n = (null == (e = t.map) ? void 0 : e.id) || this.currentMap;
        if (null == n) return;
        let i = this.venue.getCollectionItemById(ii.MAP, n);
        return new ne(t.x - i.width / 2, -t.y + i.height / 2, 1).applyMatrix4(this.mapObjects.get(n).object.matrix);
      }, "convertTo3DMapPosition")), A(this, "convertScreenCoordinateToMapCoordinate", u((t, e, n) => {
        var i;
        let r = null != (i = null == n ? void 0 : n.id) ? i : this.currentMap;
        if (null == r) return;
        let o = this.mapObjects.get(r);
        this.cameraObject.updateMatrixWorld(!0), this.cameraObject.updateMatrix();
        let s = t / this.canvasWidth * 2 - 1,
          a = -e / this.canvasHeight * 2 + 1,
          l = new ne(s, a, 0);
        Do.setFromCamera(l, this.cameraObject.clone());
        let u = Do.intersectObject(this.cameraPlane, !1)[0].point.applyMatrix4(o.object.matrix);
        return o.mapClass.createCoordinateByXY(u.x + o.mapClass.width / 2, -u.y + o.mapClass.height / 2);
      }, "convertScreenCoordinateToMapCoordinate")), A(this, "convert3DMapPositionToCoordinate", u((t, e) => {
        var n;
        let i = null != (n = null == e ? void 0 : e.id) ? n : this.currentMap;
        if (null == i) return;
        let r = this.mapObjects.get(i),
          o = r.mapClass,
          s = new ne(t.x, t.y, t.z || 0);
        s.applyMatrix4(new Bt().copy(r.object.matrix).invert());
        let a = s.x + o.width / 2,
          l = -s.y + o.height / 2;
        return o.createCoordinateByXY(a, l);
      }, "convert3DMapPositionToCoordinate")), A(this, "getPositionPolygon", u(t => {
        var e;
        let n = Vr(t),
          i = t;
        null == t.map && (i = this.getPolygon(n));
        let r = null == (e = this.mapObjects.get(i.map.id)) ? void 0 : e.objectsDictionary[n];
        if (r) {
          r.geometry.computeBoundingBox();
          let t = r.geometry.boundingBox;
          return new ne(t.min.x + (t.max.x - t.min.x) / 2, t.min.y + (t.max.y - t.min.y) / 2, t.max.z);
        }
        return null;
      }, "getPositionPolygon")), A(this, "getPositionNode", u(t => {
        let e = t;
        return "string" == typeof e && (e = rl(t, this.venue.nodes)), this.convertTo3DMapPosition(e);
      }, "getPositionNode")), A(this, "hideAllLabels", u(() => {
        this.mapObjects.forEach(t => {
          t.textObjects.forEach(t => t.hide()), t.colliders.forEach(t => {
            t.disable();
          });
        });
      }, "hideAllLabels")), A(this, "setBackgroundColor", u((t, e) => {
        this.renderer.setBackgroundColor(t, e);
      }, "setBackgroundColor")), A(this, "setSize", u((t, e) => {
        this.canvasWidth = this.rendererDomElement.clientWidth, this.canvasHeight = this.rendererDomElement.clientHeight;
        let n = Math.floor(t * this.resolutionScale),
          i = Math.floor(e * this.resolutionScale);
        if (!w(this, fg) && this.rendererDomElement.width * this.rendererDomElement.height * n * i != 0) {
          let t = this.rendererDomElement.width !== n ? this.rendererDomElement.width / n : this.rendererDomElement.height / i;
          this.controls.setZoom(t * this.controls.getZoom());
        }
        w(this, yg).call(this, n, i);
      }, "setSize")), A(this, "getMapScale", u(() => null == this.currentMap ? 0 : this.mapObjects.get(this.currentMap).getMapScale(), "getMapScale")), A(this, "getNorth", u(() => null == this.currentMap ? 0 : this.mapObjects.get(this.currentMap).getNorth(), "getNorth")), A(this, "tryRendering", u((t = hi.ALL) => {
        if (null != this.renderer) if (null != w(this, qo) && this.taskScheduler.scheduleUpdate(w(this, L_)), t === hi.ALL) this.taskScheduler.scheduleUpdate(w(this, Uh)), null != w(this, O_) && this.taskScheduler.scheduleUpdate(w(this, O_)), this.taskScheduler.scheduleUpdate(w(this, mg)), this.taskScheduler.scheduleUpdate(w(this, S_)), this.taskScheduler.scheduleUpdate(w(this, T_)), this.taskScheduler.scheduleUpdate(w(this, xp)), this.taskScheduler.scheduleUpdate(w(this, A_)), this.taskScheduler.scheduleUpdate(w(this, I_));else if (t === hi.ANIMATED) this.taskScheduler.scheduleUpdate(w(this, mg)), this.taskScheduler.scheduleUpdate(w(this, Uh)), this.taskScheduler.scheduleUpdate(w(this, P_));else if (t === hi.ALWAYS_ON_TOP) this.taskScheduler.scheduleUpdate(w(this, Uh)), this.taskScheduler.scheduleUpdate(w(this, C_));else {
          if (t !== hi.TWEEN) throw new Error("invalid render task passed to tryRendering");
          this.taskScheduler.scheduleUpdate(w(this, Uh));
        }
      }, "tryRendering")), A(this, "showDebugUI", u(() => {
        null == w(this, qo) && (he(this, qo, new cg()), this.container.appendChild(w(this, qo).element), w(this, Jw).call(this, w(this, qo)), this.controls.addDebugControls(w(this, qo)), this.tryRendering());
      }, "showDebugUI")), A(this, "hideDebugUI", u(() => {
        null != w(this, qo) && (this.container.removeChild(w(this, qo).element), w(this, Kw).call(this, w(this, qo)), this.controls.removeDebugControls(w(this, qo)), w(this, qo).destroy(), he(this, qo, null));
      }, "hideDebugUI")), A(this, "determineNewLabelSize", u(() => {
        let t = this.controls.getZoom(),
          e = this.controls.getZoomScaledMin(),
          n = (t - e) / (this.controls.getZoomScaledMax() - e);
        this.currentScale = n;
      }, "determineNewLabelSize")), A(this, "setMap", u(t => {
        let e = "string" == typeof t ? this.venue.getCollectionItemById(ii.MAP, t) : t;
        if (null == e) return Promise.reject(null);
        let {
          currentScene: n
        } = this.sceneManager;
        return null == n ? Promise.reject(null) : this.state === xo.STACKED ? this.stackedMaps.mapsInJourney.includes(e) ? this.stackedMaps.zoomInToMap(e).then(() => Promise.resolve(null)) : (ke.warn("Can't set map outside of current scene"), Promise.reject(null)) : this.sceneManager.transitionTo(new bc([e], this), {
          activeMap: e
        }).then(() => Promise.resolve(null));
      }, "setMap")), A(this, "getPolygonsAtScreenCoordinate", u((t, e, n) => {
        if (null == this.currentMap) return [];
        let i = this.mapObjects.get(this.currentMap);
        if (!i || !i.hoverableMeshChildren) return [];
        let r = new je(t, e),
          o = r.x / this.canvasWidth * 2 - 1,
          s = -r.y / this.canvasHeight * 2 + 1,
          a = new ne(o, s, 0);
        return Do.setFromCamera(a, this.cameraObject), w(this, F_).call(this, i.hoverableMeshChildren, null == n ? void 0 : n.includeNonInteractive);
      }, "getPolygonsAtScreenCoordinate")), A(this, "getPolygonsAtCoordinate", u((t, e) => {
        let n = this.mapObjects.get(t.map.id);
        if (!n || !n.hoverableMeshChildren) return [];
        let i = this.convertTo3DMapPosition(t);
        return i.setZ(this.controls.maxZoom), Do.set(i, new ne(0, 0, -1)), w(this, F_).call(this, n.hoverableMeshChildren, null == e ? void 0 : e.includeNonInteractive);
      }, "getPolygonsAtCoordinate")), A(this, "destroy", u(() => {
        var t;
        this.flatLabels.removeAllLabels(), this.floatingLabels.removeAllLabels(), this.paths.removeAllPaths(), this.polygonInteraction.removeAllInteractivePolygons(), this.polygonColors.clearAllPolygonColors(), this.polygonStates.destroy(), this.markers.removeAll(), this.tooltips.removeAllTooltips(), this.smartCollisionEngine.destroy(), Sy.imagesLoadingInProgress.clear(), this.controls.dispose(), this.off(Xe.RENDER, this.tryRendering), this.off(Xe.RENDER_NOW, w(this, bp)), this.off(Xe.UPDATE_FLIPPABLES, w(this, N_)), this.off(Xe.ON_FIRST_MAP_LOADED, w(this, D_)), window.removeEventListener("resize", w(this, vg), !1), w(this, yp) && w(this, yp).disconnect(), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.CHANGE_EVENT.type, this.determineNewLabelSize), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.CHANGE_EVENT.type, w(this, B_)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.ZOOM_START_EVENT.type, w(this, xl)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.ROTATE_START_EVENT.type, w(this, xl)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.ROTATE_START_EVENT.type, w(this, Mp)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.MULTI_START_EVENT.type, w(this, xl)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.MULTI_START_EVENT.type, this.publish(Xe.CLEAR_MOUSE)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.MULTI_START_EVENT.type, w(this, Mp)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.PAN_START_EVENT.type, w(this, xl)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.PAN_START_EVENT.type, this.publish(Xe.CLEAR_MOUSE)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.ZOOM_END_EVENT.type, w(this, bl)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.ROTATE_END_EVENT.type, w(this, bl)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.ROTATE_END_EVENT.type, w(this, Ep)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.MULTI_END_EVENT.type, w(this, bl)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.MULTI_END_EVENT.type, w(this, Ep)), this.controls.dispatcher.removeEventListener(this.controls.CAMERA_EVENTS.PAN_END_EVENT.type, w(this, bl));
        for (let t in this.polygonMeshesById) this.polygonMeshesById[t].destroy();
        this.polygonMeshesById = {}, this.interactivePolygons = {}, this._subscribers = {}, null == (t = this.mapManager) || t.destroy(), this.scene.destroy(), this.interactivePolygons = {}, w(this, gg).dispose(), this.taskScheduler.destroy(), this.renderer.destroy(), this.container.removeChild(this.rendererDomElement), null != w(this, qo) && this.hideDebugUI(), this.renderer = void 0;
      }, "destroy")), this.MapView = i, this.options = n, this.type = "MapView3D", this.container = t, this.venue = e, window.MappedinDebug || (window.MappedinDebug = {}), "test" === D.env.NODE_ENV && (window.MappedinDebug.mapViewCoreInstance = this), he(this, fg, !1), he(this, pg, _l.ENABLED ? jw : n.backgroundColor || "#ffffff"), he(this, dg, null != (r = n.backgroundAlpha) ? r : 1), this.colors = {
        defaultHover2D: "#cccccc",
        select: "#4ca1fc",
        text: "#000000",
        path: "#ff834c",
        pathPulse: "#ffffff",
        textSelect: "#ffffff"
      }, n.disableZoomOnMapSizeChange && he(this, fg, !0), this.loadOptions = {
        mapRenderStrategy: Or.SINGLE_GEOMETRY,
        ...n.loadOptions
      }, !0 === this.loadOptions.loadAsync && this.loadOptions.mapRenderStrategy === Or.SINGLE_GEOMETRY && (ke.warn("Async loading does not work with the single geometry map render strategy. Reverting to non-async loading."), this.loadOptions.loadAsync = !1), this.taskScheduler = new Qf({
        performance: !0
      }), he(this, gg, new ap()), this.renderer = new ug({
        aoEnabled: null != (o = n.aoEnabled) && o,
        aoQuality: n.aoQuality,
        aoResolution: null != (s = n.aoResolution) ? s : "half",
        multiBufferRendering: "boolean" == typeof n.multiBufferRendering && n.multiBufferRendering,
        xRayPath: "boolean" != typeof n.xRayPath || n.xRayPath,
        alpha: !0,
        antialias: "boolean" != typeof n.antialias || n.antialias,
        onWebGLContextCreationError: n.onWebGLContextCreationError,
        onWebGLContextLost: n.onWebGLContextLost,
        onWebGLContextRestored: () => {
          n.onWebGLContextRestored && n.onWebGLContextRestored(), w(this, gg).onWebGLContextRestored(), this.tryRendering();
        },
        onWebGLRendererError: n.onWebGLRendererError,
        backgroundColor: w(this, pg),
        backgroundAlpha: w(this, dg)
      }), this.scene = new _d(), this.outdoorGeometryLayers = null != (l = null == (a = n.loadOptions) ? void 0 : a.outdoorGeometryLayers) ? l : [];
      let f = window.__THREE_DEVTOOLS__;
      "dev" === D.env.NODE_ENV && void 0 !== f && (f.dispatchEvent(new CustomEvent("observe", {
        detail: this.scene
      })), f.dispatchEvent(new CustomEvent("observe", {
        detail: this.renderer
      }))), this.resolutionScale = window.devicePixelRatio, this.cameraObject = new as(40, this.container.clientWidth / this.container.clientHeight, 50, 1e5);
      let m = new jn();
      m.add(this.cameraObject), he(this, fu, new jn()), w(this, fu).add(m), this.billboardManager = new l6(w(this, fu)), this.scene.add(w(this, fu)), this.cameraObject.updateProjectionMatrix(), this.cameraObject.updateMatrixWorld(!0), this.focusZoomFactor = 1.1, he(this, Fh, !1), he(this, Lc, []), this.polygonMeshesById = {}, this.textLabelsByPolygonId = {}, this.labelOrientationDelay = 650, this.interactivePolygons = {};
      let g = new Map();
      this.mapObjects = g, e.maps.forEach(t => {
        let e = new FE(t, this.polygonMeshesById, 0, this, {
          taskScheduler: this.taskScheduler
        });
        this.mapObjects.set(t.id, e);
      }), this.referenceMap = e.getCollectionItemById(ii.MAP, e.venue.defaultMap), this.rendererDomElement = this.renderer.domElement(), this.resolution = new je(), he(this, mg, new _o({
        name: "updateBillboards",
        ordering: Ia.BEFORE_CAMERA,
        callback: () => {
          this.billboardManager.update();
        }
      })), he(this, Uh, new _o({
        name: "updateTweens",
        ordering: Ia.BEFORE_CAMERA,
        callback: () => {
          Cz.default.update();
        }
      })), this.cameraParameters = new je(), he(this, S_, new _o({
        name: "camera",
        ordering: Ia.CAMERA,
        callback: () => {
          this.controls.update(), this.cameraParameters.x = this.controls.getZoom(), this.cameraParameters.y = this.controls.getTilt(), this.controls.isCameraMoving() && this.publish(Xe.CAMERA_MOVING, this.cameraParameters), this.publish(Xe.SET_BLUE_DOT_SIZE_FROM_ZOOM, this.cameraParameters.x);
        }
      })), he(this, T_, new _o({
        name: "rotateObjects",
        ordering: Ia.AFTER_CAMERA,
        callback: () => {
          let t = this.getNorth() + this.controls.getRotation();
          for (let e = 0, n = w(this, Lc).length; e < n; ++e) w(this, k_).call(this, w(this, Lc)[e], t);
          w(this, Yw).call(this), w(this, Zw).call(this), he(this, Oc, !1);
        }
      })), he(this, xp, new _o({
        name: "renderAll",
        ordering: Ia.RENDER,
        callback: () => {
          null != this.currentMap && (!this.renderer.isAvailable() || (w(this, zh) && w(this, wp).call(this), this.renderer.render(hi.ALL, null, this.scene, this.cameraObject), this.controls.postRender && this.controls.postRender()));
        }
      })), he(this, P_, new _o({
        name: "renderAnimated",
        ordering: Ia.RENDER,
        supersededBy: new Set([w(this, xp)]),
        callback: () => {
          null != this.currentMap && (!this.renderer.isAvailable() || (w(this, zh) && w(this, wp).call(this), this.renderer.render(hi.ANIMATED, null, this.scene, this.cameraObject), this.controls.postRender && this.controls.postRender()));
        }
      })), he(this, C_, new _o({
        name: "renderAlwaysOnTop",
        ordering: Ia.RENDER,
        supersededBy: new Set([w(this, xp)]),
        callback: () => {
          null != this.currentMap && (!this.renderer.isAvailable() || (w(this, zh) && w(this, wp).call(this), this.renderer.render(hi.ALWAYS_ON_TOP, null, this.scene, this.cameraObject), this.controls.postRender && this.controls.postRender()));
        }
      })), he(this, A_, new _o({
        name: "updateBlueDotPosition",
        ordering: Ia.AFTER_RENDER,
        callback: () => {
          this.publish(Xe.PUBLISH_BLUE_DOT);
        }
      })), he(this, I_, new _o({
        name: "updateColliders",
        ordering: Ia.AFTER_RENDER,
        frameCount: 32,
        callback: () => {
          this.smartCollisionEngine.reposition();
        }
      })), he(this, L_, new _o({
        name: "updateDebugUI",
        ordering: Ia.AFTER_ALL_UPDATES,
        frameCount: 1,
        callback: () => {
          var t;
          let e = {};
          for (let t of this.taskScheduler.getUpdatesRunLastFrame().values()) e[t.name] = t.getLastFrameTime();
          null == (t = w(this, qo)) || t.reportFramePerformance(e);
        }
      }));
      let v = new co(1e6, 1e6),
        y = new Sr({
          color: 0,
          visible: !1
        });
      this.cameraPlane = new Ft(v, y), this.scene.add(this.cameraPlane), t.appendChild(this.rendererDomElement), window.addEventListener("resize", w(this, vg), !1), "function" == typeof ResizeObserver && "test" !== (null == (h = D.env) ? void 0 : h.NODE_ENV) && (he(this, yp, new ResizeObserver(() => {
        window.requestAnimationFrame(w(this, vg));
      })), null == (c = w(this, yp)) || c.observe(t)), t.style.overflow = "hidden", this.rendererDomElement.style.width = (null == (p = globalThis.MappedinDebug) ? void 0 : p.TEST_IOS) ? "1080px" : "100%", this.rendererDomElement.style.height = (null == (d = globalThis.MappedinDebug) ? void 0 : d.TEST_IOS) ? "1920px" : "100%", this.rendererDomElement.style.cursor = "grab", this.canvasWidth = this.rendererDomElement.clientWidth, this.canvasHeight = this.rendererDomElement.clientHeight, this.rendererDomElement.style.touchAction = "manipulation";
      let _ = this.canvasWidth,
        x = this.canvasHeight;
      he(this, zh, !0), this.setBackgroundColor(w(this, pg), w(this, dg)), w(this, yg).call(this, Math.floor(_ * this.resolutionScale), Math.floor(x * this.resolutionScale)), w(this, bp).call(this);
      let E = new jx(16777215, .3);
      E.position.set(-150, -150, 350), this.scene.add(E);
      let b = new Wx(16777215, .741);
      this.scene.add(b), this.controls = new Rw(this.cameraObject, this.rendererDomElement, this.scene, this), this.controls.enableZoom = !0, this.smartCollisionEngine = new s6(this), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.CHANGE_EVENT.type, this.determineNewLabelSize), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.CHANGE_EVENT.type, w(this, B_)), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.ZOOM_START_EVENT.type, () => {
        this.publish(Xe.USER_ZOOM_BEGIN), w(this, xl).call(this);
      }), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.ROTATE_START_EVENT.type, () => {
        this.publish(Xe.USER_ROTATE_BEGIN), w(this, xl).call(this), w(this, Mp).call(this);
      }), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.MULTI_START_EVENT.type, () => {
        this.publish(Xe.USER_MULTI_BEGIN), this.publish(Xe.CLEAR_MOUSE), w(this, xl).call(this), w(this, Mp).call(this);
      }), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.PAN_START_EVENT.type, () => {
        this.publish(Xe.USER_PAN_BEGIN), w(this, xl).call(this), this.publish(Xe.CLEAR_MOUSE);
      }), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.ZOOM_END_EVENT.type, () => {
        this.publish(Xe.USER_ZOOM), this.publish(Xe.USER_ZOOM_BEGIN), w(this, bl).call(this);
      }), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.ROTATE_END_EVENT.type, () => {
        this.publish(Xe.USER_ROTATE), w(this, bl).call(this), w(this, Ep).call(this);
      }), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.MULTI_END_EVENT.type, () => {
        this.publish(Xe.USER_MULTI_END), w(this, bl).call(this), w(this, Ep).call(this);
      }), this.controls.dispatcher.addEventListener(this.controls.CAMERA_EVENTS.PAN_END_EVENT.type, w(this, bl)), this.controls.dispatcher.addEventListener(this.controls.INTERACTION_EVENTS.USER_PAN_START_EVENT.type, () => {
        this.currentInteractionEvent = Xe.USER_PAN;
      }), this.controls.dispatcher.addEventListener(this.controls.INTERACTION_EVENTS.USER_ROTATE_START_EVENT.type, () => {
        this.currentInteractionEvent = Xe.USER_ROTATE;
      }), this.controls.dispatcher.addEventListener(this.controls.INTERACTION_EVENTS.USER_DOLLY_START_EVENT.type, () => {
        this.currentInteractionEvent = Xe.USER_ZOOM;
      }), this.controls.dispatcher.addEventListener(this.controls.INTERACTION_EVENTS.USER_TILT_START_EVENT.type, () => {
        this.currentInteractionEvent = Xe.USER_TILT;
      }), this.controls.dispatcher.addEventListener(this.controls.INTERACTION_EVENTS.USER_ZOOM_START_EVENT.type, () => {
        this.publish(Xe.USER_ZOOM), this.currentInteractionEvent = Xe.USER_ZOOM;
      }), he(this, R_, t0(e, n)), this.sceneManager = new gC(this, new bc([w(this, R_)], this)), this.on(Xe.RENDER, this.tryRendering), this.on(Xe.RENDER_NOW, w(this, bp)), this.on(Xe.UPDATE_FLIPPABLES, w(this, N_)), this.on(Xe.TEXTURE_LOADED, t => {
        this.tryRendering(), this.renderer.preloadTexture(t);
      }), this.on(Xe.ON_FIRST_MAP_LOADED, () => {
        w(this, D_).call(this), "function" == typeof this.options.onFirstMapLoaded && this.options.onFirstMapLoaded(e);
      }), e.imageBinaries && O6(new ig(e.imageBinaries)), "function" == typeof n.onDataLoaded && n.onDataLoaded(e), this.setPadding(), this.eventSystem = new e6(this), this.floatingLabels = new mA(this), this.flatLabels = new vA(this), this.paths = new cA(this), this.polygonColors = new _A(this), this.polygonInteraction = new bA(this), this.polygonStates = new SA(this), this.polygonImages = new CA(this), this.markers = new KC(this), this.tooltips = new EA(this), this.threeDMarkers = new l_(this), this.blueDot = new LA(this), this.camera = new YA(this), this.stackedMaps = new c6(this), this.tileManager = new _l(this);
    }
    get visibleMapsInCurrentScene() {
      return Array.from(this.sceneManager.currentScene.mapObjects.values()).filter(t => t.visible).map(t => t.mapClass);
    }
    get currentMap() {
      var t, e;
      return (null == (e = null == (t = this.sceneManager) ? void 0 : t.currentMap) ? void 0 : e.id) ? this.sceneManager.currentMap.id : (ke.error("No maps loaded."), null);
    }
    async setState(t) {
      if (t !== this.state) {
        if (t === xo.EXPLORE) this.publish(Xe.BLUE_DOT_SET_FOLLOWING, !1), this.state = t;else if (t === xo.STACKED) this.publish(Xe.BLUE_DOT_SET_FOLLOWING, !1), this.state = t;else {
          if (t !== xo.FOLLOW) throw new Error("Unsupported State");
          this.publish(Xe.BLUE_DOT_SET_FOLLOWING, !0), this.state = t;
        }
        return this.publish(Xe.SET_STATE_SILENT, {
          state: this.state
        }), Promise.resolve();
      }
    }
    getNearestNodeByScreenCoordinate(t, e, n) {
      let i = "string" == typeof n ? n : (null == n ? void 0 : n.id) || this.currentMap,
        r = this.mapObjects.get(i);
      if (null == r) throw new Error("getNodeByScreenCoordinates failed: map not found");
      this.cameraObject.updateMatrixWorld(!0), this.cameraObject.updateMatrix();
      let o = t / this.canvasWidth * 2 - 1,
        s = -e / this.canvasHeight * 2 + 1,
        a = new ne(o, s, 0);
      Do.setFromCamera(a, this.cameraObject.clone());
      let l = Do.intersectObject(this.cameraPlane, !1)[0].point.applyMatrix4(r.object.matrix);
      return this.venue._mapsById[i].createCoordinateByXY(l.x + r.mapClass.width / 2, -l.y + r.mapClass.height / 2).nearestNode;
    }
  };
u(L6, "Core"), yp = new WeakMap(), fg = new WeakMap(), pg = new WeakMap(), dg = new WeakMap(), Fh = new WeakMap(), Lc = new WeakMap(), Bh = new WeakMap(), qo = new WeakMap(), Ww = new WeakMap(), _p = new WeakMap(), mg = new WeakMap(), Uh = new WeakMap(), S_ = new WeakMap(), T_ = new WeakMap(), xp = new WeakMap(), P_ = new WeakMap(), C_ = new WeakMap(), A_ = new WeakMap(), I_ = new WeakMap(), L_ = new WeakMap(), O_ = new WeakMap(), zh = new WeakMap(), R_ = new WeakMap(), Oc = new WeakMap(), fu = new WeakMap(), gg = new WeakMap(), N_ = new WeakMap(), D_ = new WeakMap(), q_ = new WeakMap(), vg = new WeakMap(), bp = new WeakMap(), k_ = new WeakMap(), Mp = new WeakMap(), Ep = new WeakMap(), xl = new WeakMap(), bl = new WeakMap(), Xw = new WeakMap(), yg = new WeakMap(), wp = new WeakMap(), Yw = new WeakMap(), Zw = new WeakMap(), Jw = new WeakMap(), Kw = new WeakMap(), F_ = new WeakMap(), B_ = new WeakMap();
var Xe,
  Iz = L6;
!function (t) {
  t[t.ON_FIRST_MAP_LOADED = 0] = "ON_FIRST_MAP_LOADED", t[t.TEXTURE_LOADED = 1] = "TEXTURE_LOADED", t[t.RENDER = 2] = "RENDER", t[t.RENDER_NOW = 3] = "RENDER_NOW", t[t.UPDATE_FLIPPABLES = 4] = "UPDATE_FLIPPABLES", t[t.SET_SCENE_MAP = 5] = "SET_SCENE_MAP", t[t.SET_SCENE_START = 6] = "SET_SCENE_START", t[t.SET_SCENE = 7] = "SET_SCENE", t[t.CAMERA_MOVING = 8] = "CAMERA_MOVING", t[t.SET_BLUE_DOT_SIZE_FROM_ZOOM = 9] = "SET_BLUE_DOT_SIZE_FROM_ZOOM", t[t.PUBLISH_BLUE_DOT = 10] = "PUBLISH_BLUE_DOT", t[t.SET_STATE_SILENT = 11] = "SET_STATE_SILENT", t[t.BLUE_DOT_UPDATE_POSITION = 12] = "BLUE_DOT_UPDATE_POSITION", t[t.BLUE_DOT_SET_FOLLOWING = 13] = "BLUE_DOT_SET_FOLLOWING", t[t.CLEAR_MOUSE = 14] = "CLEAR_MOUSE", t[t.MAP_CLICK = 15] = "MAP_CLICK", t[t.USER_ZOOM = 16] = "USER_ZOOM", t[t.USER_ZOOM_BEGIN = 17] = "USER_ZOOM_BEGIN", t[t.USER_ROTATE = 18] = "USER_ROTATE", t[t.USER_ROTATE_BEGIN = 19] = "USER_ROTATE_BEGIN", t[t.USER_PAN = 20] = "USER_PAN", t[t.USER_PAN_BEGIN = 21] = "USER_PAN_BEGIN", t[t.USER_TILT = 22] = "USER_TILT", t[t.USER_MULTI_BEGIN = 23] = "USER_MULTI_BEGIN", t[t.USER_MULTI_END = 24] = "USER_MULTI_END", t[t.FOCUSON_BEGIN = 25] = "FOCUSON_BEGIN", t[t.USER_HANDS_ON = 26] = "USER_HANDS_ON", t[t.USER_HANDS_OFF = 27] = "USER_HANDS_OFF";
}(Xe || (Xe = {}));
var Sp,
  Lme = "white",
  Lz = u((t = 1) => `<div style="width: ${32 * t}px; height: ${32 * t}px;">${np.get("journey-departure")}<div>`, "generateDepartureMarker"),
  Oz = u((t = 1) => `<div style="width: ${32 * t}px; height: ${32 * t}px;">${np.get("journey-destination")}</div>`, "generateDestinationMarker"),
  Ome = u(t => {
    let e = null == t.direction ? t.type : `${t.type}-${t.direction}`;
    return `<div style="width: 40px;\n            height: 40px;\n\t\t\tcursor: pointer;\n            border-radius: 50%;\n\t\t\tbackground: green;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;">\n          <svg\n            height="16"\n            viewBox="0 0 36 36"\n            width="16"\n          >\n            <g fill="${Lme}">\n              ${np.get(e)}\n            </g>\n          </svg><div>`;
  }, "defaultConnectionFn"),
  R6 = class {
    constructor(t, e = Ome, n) {
      var i, r;
      A(this, "tooltip"), A(this, "mapId"), A(this, "toMapId"), re(this, Sp, void 0), A(this, "handleClick", u(() => {
        w(this, Sp).setMap(this.toMapId);
      }, "handleClick")), A(this, "determineDirection", u(() => {
        var t, e;
        let {
            mapObjects: n
          } = w(this, Sp),
          i = null == (t = n.get(this.mapId)) ? void 0 : t.mapClass.elevation,
          r = null == (e = n.get(this.toMapId)) ? void 0 : e.mapClass.elevation;
        if (i !== r) return i < r ? "up" : "down";
      }, "determineDirection")), this.mapId = t.node.map.id, this.toMapId = (null == (i = t.action) ? void 0 : i.type) === Ai.TAKEVORTEX ? t.action.toMap.id : t.action.fromMap.id, he(this, Sp, n);
      let o = t.atLocation.type,
        s = this.determineDirection(),
        a = e({
          type: o,
          direction: s,
          toMapName: t.action.toMap.name,
          icon: np.get(null == s ? o : `${o}-${s}`),
          isEntering: (null == (r = t.action) ? void 0 : r.type) === Ai.TAKEVORTEX
        });
      this.tooltip = n.tooltips.createTooltip(t.node, a, {
        collisionRank: No.ALWAYS_VISIBLE,
        padding: 0,
        defaultAnchorType: "top"
      }), this.tooltip.contentEl.addEventListener("click", this.handleClick), this.tooltip.updateDimensions();
    }
    destroy() {
      var t;
      null == (t = this.tooltip) || t.containerEl.removeEventListener("click", this.handleClick), w(this, Sp).tooltips.removeTooltip(this.tooltip), this.tooltip = null;
    }
  };
u(R6, "Connection"), Sp = new WeakMap();
var Qw,
  ta,
  _g,
  Ui,
  Vh,
  Tp,
  Rc,
  Gh,
  z_,
  $w,
  Pp,
  V_,
  G_,
  Rme = {
    displayArrowsOnPath: !0,
    nearRadius: 1.8,
    farRadius: 5.4,
    color: "#ff834c",
    flattenPath: !0
  },
  Nme = {
    color: "#f5c7b3",
    displayArrowsOnPath: !1,
    flattenPath: !0,
    nearRadius: 1.6,
    farRadius: 4.8,
    showPulse: !1,
    animateDrawing: !1
  },
  Dme = {
    displayArrowsOnPath: !0,
    nearRadius: 1.8,
    farRadius: 5.4,
    color: "#ff834c",
    flattenPath: !0
  },
  Rz = 3,
  Hh = class {
    constructor(t, e = {}, n) {
      var i, r;
      A(this, "distance", 0), A(this, "accessible", !1), re(this, Qw, {}), A(this, "core"), A(this, "activeDirections"), re(this, ta, void 0), re(this, _g, void 0), re(this, Ui, {}), re(this, Vh, []), re(this, Tp, void 0), re(this, Rc, []), re(this, Gh, new Map()), A(this, "setStep", u(t => {
        t !== w(this, _g) && (w(this, ta).length < 2 || t < 0 || t > w(this, ta).length || (w(this, G_).call(this), w(this, V_).call(this), he(this, _g, t), this.activeDirections = w(this, ta)[t], this.core.currentPath = this.activeDirections.path, w(this, Pp).call(this), w(this, z_).call(this)));
      }, "setStep")), A(this, "setStepByPath", u(t => {
        let e = w(this, Gh).get(t);
        if (null == e) return void ke.warn("Cannot set step. Path is not part of journey.");
        let n = w(this, ta).indexOf(e);
        n < 0 ? ke.warn("There was a problem setting this step of the journey.") : this.setStep(n);
      }, "setStepByPath")), re(this, z_, u(() => {
        let t = this.activeDirections.path[this.activeDirections.path.length - 1],
          e = this.activeDirections.path[0];
        "string" == typeof w(this, Ui).polygonHighlightColor && (e.locations.forEach(t => {
          t.polygons.forEach(t => {
            this.core.polygonColors.setPolygonColor(t, w(this, Ui).polygonHighlightColor);
          });
        }), t.locations.forEach(t => {
          t.polygons.forEach(t => {
            this.core.polygonColors.setPolygonColor(t, w(this, Ui).polygonHighlightColor);
          });
        }));
        let n = (w(this, ta) || [this.activeDirections]).map(t => t.path[t.path.length - 1]);
        null == n || n.forEach(t => {
          let e = Oz(w(this, Ui).scale);
          "function" == typeof w(this, Ui).destinationMarkerTemplate && (w(this, Rc) || he(this, Rc, []), w(this, Rc).push(this.core.markers.add(t, w(this, Ui).destinationMarkerTemplate({
            icon: e,
            location: t.locations[0]
          }), {
            rank: No.ALWAYS_VISIBLE,
            anchor: zm.TOP
          })));
        });
        let i = Lz(w(this, Ui).scale);
        "function" == typeof w(this, Ui).departureMarkerTemplate && he(this, Tp, this.core.markers.add(e, w(this, Ui).departureMarkerTemplate({
          icon: i
        }), {
          rank: No.ALWAYS_VISIBLE,
          anchor: zm.TOP
        })), this.core.tryRendering();
      }, "#updateForJourneyStartOrStepChange")), re(this, $w, u(() => {
        if (0 === w(this, Gh).size) {
          w(this, ta).forEach(t => {
            if (t !== this.activeDirections) {
              let e = this.core.paths.drawPath(t.path, {
                ...w(this, Ui).inactivePathOptions
              });
              w(this, Gh).set(e, t);
            }
          });
          let t = this.core.paths.drawPath(this.activeDirections.path, {
            ...w(this, Ui).pathOptions
          });
          w(this, Gh).set(t, this.activeDirections);
        } else {
          let t = this.isMultiFloor;
          w(this, Gh).forEach((e, n) => {
            this.core.paths.redrawPath(n, e === this.activeDirections ? {
              ...w(this, Ui).pathOptions,
              drawConnectionSegments: t,
              connectionPathOptions: w(this, Ui).connectionPathOptions
            } : {
              ...w(this, Ui).inactivePathOptions,
              drawConnectionSegments: t,
              connectionPathOptions: w(this, Ui).connectionPathOptions
            });
          });
        }
      }, "#redrawAllPaths")), re(this, Pp, u(() => {
        this.isMultiFloor && (w(this, Vh).forEach(t => t.destroy()), he(this, Vh, []), he(this, Vh, this.activeDirections.instructions.filter(t => {
          var e, n;
          return (null == (e = t.action) ? void 0 : e.type) === Ai.TAKEVORTEX || (null == (n = t.action) ? void 0 : n.type) === Ai.EXITVORTEX;
        }).map(t => new R6(t, w(this, Ui).connectionTemplate, this.core)).filter(t => t))), w(this, $w).call(this), this.core.tryRendering();
      }, "#updateForMapChange")), re(this, V_, u(() => {
        if (!1 !== w(this, Ui).polygonHighlightColor) {
          let t = this.activeDirections.path[this.activeDirections.path.length - 1];
          this.activeDirections.path[0].locations.forEach(t => {
            t.polygons.forEach(t => {
              this.core.polygonColors.clearPolygonColor(t.id);
            });
          }), t.locations.forEach(t => {
            t.polygons.forEach(t => {
              this.core.polygonColors.clearPolygonColor(t.id);
            });
          });
        }
      }, "#unhighlightPolygons")), re(this, G_, u(() => {
        w(this, Rc).length && w(this, Rc).forEach(t => {
          this.core.markers.remove(t);
        }), he(this, Rc, []), null != w(this, Tp) && this.core.markers.remove(w(this, Tp)), he(this, Tp, void 0), w(this, Vh).forEach(t => t.destroy()), he(this, Vh, []);
      }, "#removeAllMarkers")), this.core = n, he(this, Ui, {
        scale: 1,
        polygonHighlightColor: "#7babc8",
        destinationMarkerTemplate: () => Oz(),
        departureMarkerTemplate: () => Lz(),
        ...e,
        pathOptions: {
          ...Rme,
          ...(null == e ? void 0 : e.pathOptions)
        },
        inactivePathOptions: {
          ...Nme,
          ...(null == e ? void 0 : e.inactivePathOptions)
        },
        connectionPathOptions: {
          ...Dme,
          ...(null == e ? void 0 : e.connectionPathOptions)
        }
      }), (null == (i = null == e ? void 0 : e.pathOptions) ? void 0 : i.farRadius) || (w(this, Ui).pathOptions.farRadius = w(this, Ui).pathOptions.nearRadius * Rz), (null == (r = null == e ? void 0 : e.inactivePathOptions) ? void 0 : r.farRadius) || (w(this, Ui).inactivePathOptions.farRadius = w(this, Ui).inactivePathOptions.nearRadius * Rz), Array.isArray(t) ? (he(this, ta, t), this.activeDirections = w(this, ta)[0], he(this, _g, 0), this.core.currentPath = t[0].path) : (he(this, ta, [t]), this.activeDirections = t, this.core.currentPath = t.path), this.core = n, this.core.on(Xe.SET_SCENE, w(this, Pp)), w(this, Pp).call(this), w(this, z_).call(this);
    }
    get isMultiFloor() {
      return this.mapIdsInvolvedInJourney.length > 1;
    }
    get mapsInJourney() {
      return this.mapIdsInvolvedInJourney.map(t => {
        var e;
        return null == (e = this.core.mapObjects.get(t)) ? void 0 : e.mapClass;
      });
    }
    get mapIdsInvolvedInJourney() {
      let t = {};
      w(this, ta).forEach(e => {
        e.path.forEach(e => t[e.map.id] = !0);
      });
      let e = Object.keys(t);
      return w(this, Qw).mapsInvolvedInJourney = e, e;
    }
    static create(t, e, n) {
      return null != Hh.instance && Hh.instance.destroy(), Hh.instance = new Hh(t, e, n), Hh.instance;
    }
    destroy() {
      w(this, V_).call(this), w(this, G_).call(this), this.core.paths.removeAllPaths(), this.core.currentPath = void 0, this.core.off(Xe.SET_SCENE, w(this, Pp)), Hh.instance = null;
    }
  },
  xs = Hh;
u(xs, "JourneyController"), Qw = new WeakMap(), ta = new WeakMap(), _g = new WeakMap(), Ui = new WeakMap(), Vh = new WeakMap(), Tp = new WeakMap(), Rc = new WeakMap(), Gh = new WeakMap(), z_ = new WeakMap(), $w = new WeakMap(), Pp = new WeakMap(), V_ = new WeakMap(), G_ = new WeakMap(), A(xs, "instance", null);
var pu,
  N6 = class {
    constructor(t) {
      re(this, pu, void 0), he(this, pu, t);
    }
    draw(t, e) {
      var n, i, r, o;
      let s = w(this, pu).venue.venue.slug;
      return at.addPendingEvent(new Z0({
        animate_drawing: null == (n = null == e ? void 0 : e.pathOptions) ? void 0 : n.animateDrawing,
        display_arrows_on_path: null == (i = null == e ? void 0 : e.pathOptions) ? void 0 : i.displayArrowsOnPath,
        flatten_path: null == (r = null == e ? void 0 : e.pathOptions) ? void 0 : r.flattenPath,
        show_pulse: null == (o = null == e ? void 0 : e.pathOptions) ? void 0 : o.showPulse,
        venue: s
      })), xs.create(t, e, w(this, pu));
    }
    setStep(t) {
      if (null != xs.instance) {
        let e = w(this, pu).venue.venue.slug;
        at.addPendingEvent(new J0({
          venue: e
        })), xs.instance.setStep(t);
      }
    }
    setStepByPath(t) {
      null != xs.instance && xs.instance.setStepByPath(t);
    }
    clear() {
      if (w(this, pu).stackedMaps.enabled && w(this, pu).stackedMaps.disable(), null != xs.instance) {
        let t = w(this, pu).venue.venue.slug;
        at.addPendingEvent(new Y0({
          venue: t
        })), xs.instance.destroy();
      }
    }
  };
u(N6, "Journey"), pu = new WeakMap();
var Nz = N6;
E();
var Rs,
  e3 = class {
    constructor(t) {
      re(this, Rs, void 0), he(this, Rs, t);
    }
    labelAllLocations(t) {
      var e, n;
      let i = w(this, Rs).core.venue.venue.slug;
      at.addPendingEvent(new q0({
        exclude_type: Boolean(null == (e = null == t ? void 0 : t.excludeTypes) ? void 0 : e.length) || void 0,
        include_locations: Boolean(null == (n = null == t ? void 0 : t.locations) ? void 0 : n.length) || void 0,
        venue: i
      })), w(this, Rs).labelAllLocations(t);
    }
    add(t, e, n) {
      let i = w(this, Rs).core.venue.venue.slug;
      at.addPendingEvent(new D0({
        venue: i
      })), w(this, Rs).labelPolygon(t, e, n);
    }
    remove(t) {
      let e = w(this, Rs).core.venue.venue.slug;
      at.addPendingEvent(new k0({
        venue: e
      })), w(this, Rs).removeLabel(t);
    }
    removeAll() {
      w(this, Rs).removeAllLabels();
    }
    setAppearance(t, e) {
      let n = w(this, Rs).core.venue.venue.slug;
      at.addPendingEvent(new F0({
        venue: n
      })), w(this, Rs).setAppearance(t, e);
    }
    setHoverColorForAll(t) {
      w(this, Rs).setHoverColorForAll(t);
    }
  };
u(e3, "FlatLabels"), Rs = new WeakMap(), E();
var ko,
  t3 = class {
    constructor(t) {
      re(this, ko, void 0), he(this, ko, t);
    }
    labelAllLocations(t) {
      var e, n, i, r;
      let o = w(this, ko).core.venue.venue.slug;
      at.addPendingEvent(new U0({
        exclude_type: Boolean(null == (e = null == t ? void 0 : t.excludeTypes) ? void 0 : e.length) || void 0,
        include_locations: Boolean(null == (n = null == t ? void 0 : t.locations) ? void 0 : n.length) || void 0,
        with_icon: Boolean(null == (r = null == (i = null == t ? void 0 : t.appearance) ? void 0 : i.marker) ? void 0 : r.icon) || void 0,
        venue: o
      })), w(this, ko).labelAllLocations(t);
    }
    add(t, e, n) {
      var i, r;
      let o = w(this, ko).core.venue.venue.slug;
      at.addPendingEvent(new B0({
        with_icon: Boolean(null == (r = null == (i = null == n ? void 0 : n.appearance) ? void 0 : i.marker) ? void 0 : r.icon) || void 0,
        venue: o
      })), w(this, ko).addLabel(t, e, n);
    }
    setAppearance(t, e) {
      let n = w(this, ko).core.venue.venue.slug;
      at.addPendingEvent(new G0({
        venue: n
      })), w(this, ko).setAppearance(t, e);
    }
    remove(t) {
      let e = w(this, ko).core.venue.venue.slug;
      at.addPendingEvent(new z0({
        venue: e
      })), w(this, ko).removeLabel(t, !1);
    }
    removeAll() {
      w(this, ko).removeAllLabels();
    }
    setPriority(t, e) {
      let n = w(this, ko).core.venue.venue.slug;
      at.addPendingEvent(new H0({
        venue: n
      })), w(this, ko).setPriority(t, e);
    }
    resetPriority(t) {
      let e = w(this, ko).core.venue.venue.slug;
      at.addPendingEvent(new V0({
        venue: e
      })), w(this, ko).resetPriority(t);
    }
  };
u(t3, "FloatingLabels"), ko = new WeakMap(), E();
var du,
  n3 = class {
    constructor(t) {
      re(this, du, void 0), he(this, du, t);
    }
    get markers() {
      return Array.from(w(this, du).markersMap.entries()).map(t => t[1].marker);
    }
    add(t, e, n) {
      return w(this, du).add(t, e, n);
    }
    setPosition(t, e) {
      w(this, du).setPosition(t, e);
    }
    animate(t, e, n) {
      return w(this, du).animate(t, e, n);
    }
    remove(t) {
      w(this, du).remove(t);
    }
    removeAll() {
      w(this, du).removeAll();
    }
  };
u(n3, "Markers"), du = new WeakMap(), E();
var jh,
  i3 = class {
    constructor(t) {
      re(this, jh, void 0), he(this, jh, t);
    }
    get paths() {
      let t = [];
      return w(this, jh).pathsById.forEach(({
        path: e
      }) => {
        t.push(e);
      }), t;
    }
    add(t, e) {
      return w(this, jh).drawPath(t, e);
    }
    remove(t) {
      w(this, jh).removePath(null == t ? void 0 : t.id);
    }
    removeAll() {
      w(this, jh).removeAllPaths();
    }
  };
u(i3, "Paths"), jh = new WeakMap(), E();
var Ra,
  r3 = class {
    constructor(t) {
      re(this, Ra, void 0), A(this, "on", u((...t) => {
        let e = w(this, Ra).core.venue.venue.slug;
        return at.addPendingEvent(new S0({
          venue: e
        })), w(this, Ra).on(...t);
      }, "on")), A(this, "off", u((...t) => {
        let e = w(this, Ra).core.venue.venue.slug;
        return at.addPendingEvent(new w0({
          venue: e
        })), w(this, Ra).off(...t);
      }, "off")), he(this, Ra, t);
    }
    enable(t) {
      let e = w(this, Ra).core.venue.venue.slug;
      return at.addPendingEvent(new E0({
        allow_implicit_floor_level: null == t ? void 0 : t.allowImplicitFloorLevel,
        use_rotation_mode: null == t ? void 0 : t.useRotationMode,
        smoothing: null == t ? void 0 : t.smoothing,
        show_bearing: null == t ? void 0 : t.showBearing,
        venue: e
      })), w(this, Ra).enable(t);
    }
    disable() {
      let t = w(this, Ra).core.venue.venue.slug;
      at.addPendingEvent(new M0({
        venue: t
      })), w(this, Ra).disable();
    }
  };
u(r3, "BlueDot"), Ra = new WeakMap(), E();
var Jn,
  o3 = class {
    constructor(t) {
      re(this, Jn, void 0), A(this, "on", u((...t) => w(this, Jn).on(...t), "on")), A(this, "off", u((...t) => w(this, Jn).off(...t), "off")), A(this, "interactions", {
        enable: () => {
          let t = w(this, Jn).core.venue.venue.slug;
          return at.addPendingEvent(new L0({
            venue: t
          })), w(this, Jn).interactions.enable();
        },
        disable: () => {
          let t = w(this, Jn).core.venue.venue.slug;
          return at.addPendingEvent(new I0({
            venue: t
          })), w(this, Jn).interactions.disable();
        }
      }), he(this, Jn, t);
    }
    get currentAnimation() {
      return w(this, Jn).currentAnimation;
    }
    get zoom() {
      return w(this, Jn).zoom;
    }
    get rotation() {
      return w(this, Jn).rotation;
    }
    get tilt() {
      return w(this, Jn).tilt;
    }
    get minZoom() {
      return w(this, Jn).minZoom;
    }
    set minZoom(t) {
      w(this, Jn).minZoom = t;
    }
    get maxZoom() {
      return w(this, Jn).maxZoom;
    }
    set maxZoom(t) {
      w(this, Jn).maxZoom = t;
    }
    get maxTilt() {
      return w(this, Jn).maxTilt;
    }
    set maxTilt(t) {
      w(this, Jn).maxTilt = t;
    }
    get position() {
      return w(this, Jn).position;
    }
    setSafeAreaInsets(t) {
      let e = w(this, Jn).core.venue.venue.slug;
      return at.addPendingEvent(new R0({
        venue: e
      })), w(this, Jn).setSafeAreaInsets(t);
    }
    getSafeAreaInsets() {
      let t = w(this, Jn).core.venue.venue.slug;
      return at.addPendingEvent(new A0({
        venue: t
      })), w(this, Jn).getSafeAreaInsets();
    }
    async focusOn(t, e) {
      let n = w(this, Jn).core.venue.venue.slug;
      return at.addPendingEvent(new C0({
        venue: n
      })), w(this, Jn).focusOn(t, e);
    }
    set(t) {
      let e = w(this, Jn).core.venue.venue.slug;
      return at.addPendingEvent(new O0({
        venue: e
      })), w(this, Jn).set(t);
    }
    async animate(t, e) {
      let n = w(this, Jn).core.venue.venue.slug;
      return at.addPendingEvent(new T0({
        venue: n
      })), w(this, Jn).animate(t, e);
    }
    async translate(t, e, n) {
      let i = w(this, Jn).core.venue.venue.slug;
      return at.addPendingEvent(new N0({
        venue: i
      })), w(this, Jn).translate(t, e, n);
    }
    cancelAnimation() {
      let t = w(this, Jn).core.venue.venue.slug;
      return at.addPendingEvent(new P0({
        venue: t
      })), w(this, Jn).cancelAnimation();
    }
  };
u(o3, "Camera"), Jn = new WeakMap(), E();
var mu,
  s3 = class {
    constructor(t) {
      re(this, mu, void 0), A(this, "enable", u(t => w(this, mu).enable(t), "enable")), A(this, "disable", u(() => w(this, mu).disable(), "disable")), A(this, "showOverview", u(async () => w(this, mu).showOverview(), "showOverview")), A(this, "scrollToMap", u(t => w(this, mu).scrollToMap(t), "scrollToMap")), A(this, "zoomInToMap", u((t, e) => w(this, mu).zoomInToMap(t, e), "zoomInToMap")), he(this, mu, t);
    }
    get state() {
      return w(this, mu).currentState;
    }
  };
u(s3, "StackedMaps"), mu = new WeakMap();
var dt,
  U_ = class extends Ks {
    constructor(t, e, n) {
      super(), re(this, dt, void 0), A(this, "Journey"), A(this, "Camera"), A(this, "FlatLabels"), A(this, "FloatingLabels"), A(this, "Markers"), A(this, "Paths"), A(this, "BlueDot"), A(this, "options", {}), A(this, "StackedMaps"), A(this, "on", u((...t) => {
        super.on(...t);
      }, "on")), A(this, "off", u((...t) => {
        super.off(...t);
      }, "off")), this.options = n || {}, he(this, dt, new Iz(t, e, n, this)), w(this, dt).on(Xe.MAP_CLICK, ({
        position: t,
        polygons: e,
        maps: n,
        floatingLabels: i,
        nearBlueDot: r,
        paths: o
      }) => {
        this.publish(ml.CLICK, {
          position: t,
          polygons: e,
          maps: n,
          floatingLabels: i,
          nearBlueDot: r,
          paths: o
        });
      }), w(this, dt).on(Xe.SET_SCENE, () => {
        this.publish(ml.MAP_CHANGED, this.currentMap);
      }), w(this, dt).on(Xe.SET_SCENE_MAP, () => {
        this.publish(ml.MAP_CHANGED, this.currentMap);
      }), w(this, dt).on(Xe.SET_STATE_SILENT, ({
        state: t
      }) => {
        this.publish(ml.STATE_CHANGE, t);
      }), w(this, dt).onPolygonClicked = t => {
        this.publish(ml.POLYGON_CLICKED, e.polygons.find(e => e.id === t));
      }, w(this, dt).onNothingClicked = () => {
        this.publish(ml.NOTHING_CLICKED);
      }, this.Journey = new Nz(w(this, dt)), this.BlueDot = new r3(w(this, dt).blueDot), this.FlatLabels = new e3(w(this, dt).flatLabels), this.FloatingLabels = new t3(w(this, dt).floatingLabels), this.Markers = new n3(w(this, dt).markers), this.Paths = new i3(w(this, dt).paths), this.Camera = new o3(w(this, dt).camera), this.StackedMaps = new s3(w(this, dt).stackedMaps);
    }
    labelAllLocations(t) {
      let e = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new y1({
        venue: e
      })), (null == t ? void 0 : t.flatLabels) ? this.FlatLabels.labelAllLocations(t) : this.FloatingLabels.labelAllLocations(t), [];
    }
    getNearestNodeByScreenCoordinates(t, e, n) {
      let i = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new m1({
        venue: i
      })), w(this, dt).getNearestNodeByScreenCoordinate(t, e, n);
    }
    async setState(t) {
      let e = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new I1({
        venue: e
      })), w(this, dt).setState(t);
    }
    get state() {
      return w(this, dt).state;
    }
    get venue() {
      return w(this, dt).venue;
    }
    get container() {
      return w(this, dt).container;
    }
    get currentMap() {
      return w(this, dt).venue.maps.find(t => w(this, dt).currentMap === t.id);
    }
    removeAllInteractivePolygons() {
      let t = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new _1({
        venue: t
      })), w(this, dt).polygonInteraction.removeAllInteractivePolygons();
    }
    setMap(t) {
      let e = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new C1({
        venue: e
      })), w(this, dt).setMap(t);
    }
    setPolygonColor(t, e) {
      let n = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new A1({
        venue: n
      })), w(this, dt).polygonColors.setPolygonColor(t, e);
    }
    clearPolygonColor(t) {
      let e = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new a1({
        venue: e
      })), w(this, dt).polygonColors.clearPolygonColor(t);
    }
    clearAllPolygonColors() {
      w(this, dt).polygonColors.clearAllPolygonColors();
    }
    addInteractivePolygon(t) {
      let e = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new o1({
        venue: e
      })), w(this, dt).polygonInteraction.addInteractivePolygon(t);
    }
    addInteractivePolygonsForAllLocations(t) {
      var e, n;
      let i = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new s1({
        exclude_type: Boolean(null == (e = null == t ? void 0 : t.excludeTypes) ? void 0 : e.length) || void 0,
        include_locations: Boolean(null == (n = null == t ? void 0 : t.locations) ? void 0 : n.length) || void 0,
        venue: i
      })), w(this, dt).polygonInteraction.addInteractivePolygonsForAllLocations(t);
    }
    removeInteractivePolygon(t) {
      let e = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new E1({
        venue: e
      })), w(this, dt).polygonInteraction.removeInteractivePolygon(t);
    }
    createMarker(t, e, n) {
      return this.Markers.add(t, e, n);
    }
    removeMarker(t) {
      this.Markers.remove(t);
    }
    removeAllMarkers() {
      let t = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new x1({
        venue: t
      })), this.Markers.removeAll();
    }
    removeAllTooltips() {
      let t = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new M1({
        venue: t
      })), w(this, dt).tooltips.removeAllTooltips();
    }
    createTooltip(t, e, n) {
      let i = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new u1({
        venue: i
      })), w(this, dt).tooltips.createTooltip(t, e, n);
    }
    createCustomTooltip(t, e, n, i) {
      let r = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new l1({
        venue: r
      })), w(this, dt).tooltips.createCustomTooltip(t, e, n, i);
    }
    removeTooltip(t) {
      let e = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new S1({
        venue: e
      })), w(this, dt).tooltips.removeTooltip(t);
    }
    enableImageFlippingForAllLocations(t) {
      var e, n;
      let i = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new p1({
        exclude_type: Boolean(null == (e = null == t ? void 0 : t.excludeTypes) ? void 0 : e.length) || void 0,
        include_locations: Boolean(null == (n = null == t ? void 0 : t.locations) ? void 0 : n.length) || void 0,
        venue: i
      })), w(this, dt).polygonImages.enableImageFlippingForAllLocations(t);
    }
    enableImageFlippingForPolygon(t) {
      let e = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new d1({
        venue: e
      })), w(this, dt).polygonImages.enableImageFlippingForPolygon(t);
    }
    disableImageFlippingForAllPolygons() {
      let t = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new h1({
        venue: t
      })), w(this, dt).polygonImages.disableImageFlippingForAllPolygons();
    }
    drawPath(t, e) {
      let n = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new f1({
        ...(void 0 !== (null == e ? void 0 : e.animateDrawing) && {
          animate_drawing: e.animateDrawing
        }),
        ...(void 0 !== (null == e ? void 0 : e.displayArrowsOnPath) && {
          display_arrows_on_path: e.displayArrowsOnPath
        }),
        ...(void 0 !== (null == e ? void 0 : e.flattenPath) && {
          flatten_path: e.flattenPath
        }),
        ...(void 0 !== (null == e ? void 0 : e.showPulse) && {
          show_pulse: e.showPulse
        }),
        venue: n
      })), w(this, dt).paths.drawPath(t, e).id;
    }
    removePath(t) {
      let e = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new w1({
        venue: e
      })), w(this, dt).paths.removePath(t);
    }
    removeAllPaths() {
      let t = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new b1({
        venue: t
      })), w(this, dt).paths.removeAllPaths();
    }
    setBackgroundColor(t, e) {
      let n = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new T1({
        venue: n
      })), w(this, dt).setBackgroundColor(t, e);
    }
    setHoverColor(t) {
      let e = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new P1({
        venue: e
      })), w(this, dt).eventSystem.setHoverColor(t);
    }
    tryRendering(t) {}
    getPrimaryLocationForPolygon(t) {
      let e = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new v1({
        venue: e
      })), Td(t, this.venue);
    }
    getPolygonsAtCoordinate(t, e) {
      let n = w(this, dt).venue.venue.slug;
      return at.addPendingEvent(new g1({
        venue: n
      })), w(this, dt).getPolygonsAtCoordinate(t, e);
    }
    getPolygonsAtScreenCoordinate(t, e, n) {
      return w(this, dt).getPolygonsAtScreenCoordinate(t, e, n);
    }
    destroy() {
      let t = w(this, dt).venue.venue.slug;
      at.addPendingEvent(new c1({
        venue: t
      })), w(this, dt).destroy();
    }
  };
u(U_, "MapView"), dt = new WeakMap(), E();
var D6 = class {
  constructor(t = "en-US", e = 256, n, i) {
    A(this, "lang"), A(this, "apiKey"), A(this, "token"), A(this, "tileSize"), A(this, "tilesetId", "microsoft.base.road"), this.lang = t, this.tileSize = e, this.apiKey = n, this.token = i;
  }
  makeURL(t, e, n) {
    return `https://atlas.microsoft.com/map/tile?api-version=2.0&tilesetId=${this.tilesetId}&zoom=${n}&x=${t}&y=${e}&tileSize=${this.tileSize}&language=${this.lang}&view=Auto${this.apiKey ? `&subscription-key=${this.apiKey}` : ""}`;
  }
  fetchAttribution(t, e) {
    return fetch(`https://atlas.microsoft.com/map/attribution?api-version=2022-08-01&tilesetId=${this.tilesetId}&zoom=${t}&bounds=${e[0] + "," + e[1] + "," + e[2] + "," + e[3]}${this.apiKey ? `&subscription-key=${this.apiKey}` : ""}`, {
      headers: {
        Authorization: `jwt-sas ${this.token}`
      }
    });
  }
  fetchTile(t, e, n, i) {
    return fetch(this.makeURL(t, e, n), {
      signal: i,
      headers: {
        Authorization: `jwt-sas ${this.token}`
      }
    });
  }
};
u(D6, "AzureOutdoorContextProvider");
var q6 = class {
  makeURL(t, e, n, i) {
    return null == i ? `https://tile.openstreetmap.org/${n}/${t}/${e}.png` : `https://${i}/${n}/${t}/${e}.png`;
  }
  async fetchTile(t, e, n, i, r) {
    return fetch(this.makeURL(t, e, n, r), {
      signal: i
    });
  }
};
function KXe(t, e, n) {
  return new Promise((i, r) => {
    var o, s, a;
    try {
      let {
          slug: r
        } = e.venue,
        l = new U_(t, e, {
          ...n,
          onFirstMapLoaded() {
            at.sendEventNow(new L1({
              venue: r
            })), i(l);
          }
        });
      new Ea({
        ...(null == (o = null == l ? void 0 : l.venue) ? void 0 : o.options),
        testMode: !(null == (a = null == (s = null == l ? void 0 : l.venue) ? void 0 : s.options) ? void 0 : a.emitAnalyticsEvents)
      }).mapViewLoaded("3d", !1, -1, ""), at.addPendingEvent(new X0({
        venue: r
      }));
    } catch (t) {
      r(t);
    }
  });
}
u(q6, "OpenStreetMapOutdoorContext"), u(KXe, "showVenue");
var O6 = Ty.setAssetManager.bind(Ty);
function nYe(t) {
  _l.ENABLED = !0, null != t && (_l.OPTIONS = t);
}
u(nYe, "__enableTileManager");
export { Ai as ACTION_TYPE, Os as ANIMATION_TWEENS, pc as AssetManager, D6 as AzureOutdoorContextProvider, us as BEARING_TYPE, BE as BundleAssetManager, cc as CAMERA_EASING_MODE, No as COLLISION_RANKING_TIERS, Ea as CustomerAnalytics, tp as E_BLUEDOT_EVENT, iu as E_BLUEDOT_MARKER_STATE, Kt as E_BLUEDOT_STATE, ep as E_BLUEDOT_STATE_REASON, uc as E_CAMERA_DIRECTION, Ls as E_CAMERA_EVENT, ml as E_SDK_EVENT, Rl as E_SDK_LOG_LEVEL, Or as MAP_RENDER_MODE, Aa as MARKER_ANCHOR, tu as Mappedin, mh as MappedinCategory, ii as MappedinCollectionType, gh as MappedinCoordinate, va as MappedinDestinationSet, Mf as MappedinDirections, zd as MappedinEvent, zl as MappedinLocation, Nf as MappedinMap, Gd as MappedinMapGroup, kl as MappedinNavigatable, hl as MappedinNode, ec as MappedinPolygon, Df as MappedinVenue, Xd as MappedinVortex, bE as OfflineSearch, q6 as OpenStreetMapOutdoorContext, vw as PositionUpdater, CE as SAFE_AREA_INSET_TYPE, Wi as STACKED_MAPS_STATE, xo as STATE, nYe as __enableTileManager, Sle as downloadBundle, Qk as downloadVenueBundleMVF, Ele as getVenue, wle as getVenueBundle, Kk as getVenueBundleURL, Mle as getVenueMVF, pC as labelThemes, O6 as setAssetManager, _le as setFetchFn, s7 as setLoggerLevel, KXe as showVenue };